/* tslint:disable */
/* eslint-disable */
/**
 * Web API v1
 * NexusFleet SaaS
 *
 * The version of the OpenAPI document: 1
 * Contact: info@nexusops.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccessoryChangedDto
 */
export interface AccessoryChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessoryChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof AccessoryChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof AccessoryChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof AccessoryChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {AccessoryDto}
     * @memberof AccessoryChangedDto
     */
    'entity': AccessoryDto;
    /**
     * 
     * @type {string}
     * @memberof AccessoryChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface AccessoryCheckChangedDto
 */
export interface AccessoryCheckChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessoryCheckChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof AccessoryCheckChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof AccessoryCheckChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {AccessoryCheckDto}
     * @memberof AccessoryCheckChangedDto
     */
    'entity': AccessoryCheckDto;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface AccessoryCheckContentDto
 */
export interface AccessoryCheckContentDto {
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckContentDto
     */
    'vehicleId'?: string;
}
/**
 * 
 * @export
 * @interface AccessoryCheckContentInputDto
 */
export interface AccessoryCheckContentInputDto {
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckContentInputDto
     */
    'vehicleId'?: string;
}
/**
 * 
 * @export
 * @interface AccessoryCheckCountersDto
 */
export interface AccessoryCheckCountersDto {
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckCountersDto
     */
    'version'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccessoryCheckCountersDto
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface AccessoryCheckCreatedInAppDataDto
 */
export interface AccessoryCheckCreatedInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof AccessoryCheckCreatedInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof AccessoryCheckCreatedInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof AccessoryCheckCreatedInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckCreatedInAppDataDto
     */
    'accessoryCheckId'?: string;
}


/**
 * 
 * @export
 * @interface AccessoryCheckDataDto
 */
export interface AccessoryCheckDataDto {
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckDataDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckDataDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckDataDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckDataDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof AccessoryCheckDataDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof AccessoryCheckDataDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckDataDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {AssignmentReferenceDto}
     * @memberof AccessoryCheckDataDto
     */
    'assignment'?: AssignmentReferenceDto;
    /**
     * 
     * @type {FrontEndAppType}
     * @memberof AccessoryCheckDataDto
     */
    'appType'?: FrontEndAppType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AccessoryCheckDataDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorDto}
     * @memberof AccessoryCheckDataDto
     */
    'inspector'?: GeneralInspectorDto;
    /**
     * 
     * @type {Array<AccessoryCheckItemDataDto>}
     * @memberof AccessoryCheckDataDto
     */
    'items'?: Array<AccessoryCheckItemDataDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof AccessoryCheckDataDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckDataDto
     */
    'notes'?: string | null;
}


/**
 * 
 * @export
 * @interface AccessoryCheckDto
 */
export interface AccessoryCheckDto {
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof AccessoryCheckDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AccessoryCheckDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AccessoryCheckDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessoryCheckDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessoryCheckDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof AccessoryCheckDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof AccessoryCheckDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {FrontEndAppType}
     * @memberof AccessoryCheckDto
     */
    'appType'?: FrontEndAppType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AccessoryCheckDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorDto}
     * @memberof AccessoryCheckDto
     */
    'inspector'?: GeneralInspectorDto;
    /**
     * 
     * @type {boolean}
     * @memberof AccessoryCheckDto
     */
    'isUseSupplierBranding'?: boolean;
    /**
     * 
     * @type {AssignmentReferenceDto}
     * @memberof AccessoryCheckDto
     */
    'assignment'?: AssignmentReferenceDto;
    /**
     * 
     * @type {Array<AccessoryCheckItemDto>}
     * @memberof AccessoryCheckDto
     */
    'items'?: Array<AccessoryCheckItemDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof AccessoryCheckDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof AccessoryCheckDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof AccessoryCheckDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
    /**
     * 
     * @type {TenantRequestsMetaDto}
     * @memberof AccessoryCheckDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof AccessoryCheckDto
     */
    'tags'?: GeneralAttachedTagsDto;
}


/**
 * 
 * @export
 * @interface AccessoryCheckGetPaginatedDto
 */
export interface AccessoryCheckGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'assignmentId'?: string | null;
    /**
     * 
     * @type {TenantRequestsMetaQueryDto}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof AccessoryCheckGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}
/**
 * 
 * @export
 * @interface AccessoryCheckItemDataDto
 */
export interface AccessoryCheckItemDataDto {
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckItemDataDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckItemDataDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckItemDataDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {AccessoryReferenceDto}
     * @memberof AccessoryCheckItemDataDto
     */
    'accessory'?: AccessoryReferenceDto;
    /**
     * 
     * @type {AccessoryStatus}
     * @memberof AccessoryCheckItemDataDto
     */
    'status'?: AccessoryStatus;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof AccessoryCheckItemDataDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckItemDataDto
     */
    'notes'?: string | null;
}


/**
 * 
 * @export
 * @interface AccessoryCheckItemDto
 */
export interface AccessoryCheckItemDto {
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckItemDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckItemDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {AccessoryReferenceDto}
     * @memberof AccessoryCheckItemDto
     */
    'accessory'?: AccessoryReferenceDto;
    /**
     * 
     * @type {AccessoryStatus}
     * @memberof AccessoryCheckItemDto
     */
    'status'?: AccessoryStatus;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof AccessoryCheckItemDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckItemDto
     */
    'notes'?: string | null;
}


/**
 * 
 * @export
 * @interface AccessoryCheckItemReferenceDto
 */
export interface AccessoryCheckItemReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckItemReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckItemReferenceDto
     */
    'accessoryCheckId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckItemReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface AccessoryCheckReferenceDto
 */
export interface AccessoryCheckReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckReferenceDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface AccessoryCheckResultDto
 */
export interface AccessoryCheckResultDto {
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckResultDto
     */
    'accessoryCheckId'?: string;
}
/**
 * 
 * @export
 * @interface AccessoryCheckResultInputDto
 */
export interface AccessoryCheckResultInputDto {
    /**
     * 
     * @type {string}
     * @memberof AccessoryCheckResultInputDto
     */
    'accessoryCheckId'?: string;
}
/**
 * 
 * @export
 * @interface AccessoryDto
 */
export interface AccessoryDto {
    /**
     * 
     * @type {string}
     * @memberof AccessoryDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof AccessoryDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AccessoryDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AccessoryDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessoryDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessoryDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {AccessoryType}
     * @memberof AccessoryDto
     */
    'type'?: AccessoryType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof AccessoryDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {ImportMetaDto}
     * @memberof AccessoryDto
     */
    'importMeta'?: ImportMetaDto;
    /**
     * 
     * @type {PoolsMetaDto}
     * @memberof AccessoryDto
     */
    'poolsMeta'?: PoolsMetaDto;
    /**
     * 
     * @type {AssetMetaDto}
     * @memberof AccessoryDto
     */
    'assetMeta'?: AssetMetaDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof AccessoryDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof AccessoryDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {boolean}
     * @memberof AccessoryDto
     */
    'isForAllVehicles'?: boolean;
}


/**
 * 
 * @export
 * @interface AccessoryFullReferenceDto
 */
export interface AccessoryFullReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof AccessoryFullReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryFullReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryFullReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryFullReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {AccessoryType}
     * @memberof AccessoryFullReferenceDto
     */
    'type'?: AccessoryType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof AccessoryFullReferenceDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryFullReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryFullReferenceDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {ImportMetaDto}
     * @memberof AccessoryFullReferenceDto
     */
    'importMeta'?: ImportMetaDto;
    /**
     * 
     * @type {PoolsMetaDto}
     * @memberof AccessoryFullReferenceDto
     */
    'poolsMeta'?: PoolsMetaDto;
    /**
     * 
     * @type {AssetMetaDto}
     * @memberof AccessoryFullReferenceDto
     */
    'assetMeta'?: AssetMetaDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof AccessoryFullReferenceDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AccessoryFullReferenceDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AccessoryFullReferenceDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryFullReferenceDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoryFullReferenceDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccessoryFullReferenceDto
     */
    'isForAllVehicles'?: boolean;
}


/**
 * 
 * @export
 * @interface AccessoryGetPaginatedDto
 */
export interface AccessoryGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AccessoryGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccessoryGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccessoryGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessoryGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessoryGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessoryGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AccessoryGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AccessoryGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AccessoryGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {AccessoryType}
     * @memberof AccessoryGetPaginatedDto
     */
    'type'?: AccessoryType;
    /**
     * 
     * @type {VehicleType}
     * @memberof AccessoryGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {PoolsMetaQueryDto}
     * @memberof AccessoryGetPaginatedDto
     */
    'poolsMeta'?: PoolsMetaQueryDto;
    /**
     * 
     * @type {AssetMetaQueryDto}
     * @memberof AccessoryGetPaginatedDto
     */
    'assetMeta'?: AssetMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof AccessoryGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * 
 * @export
 * @interface AccessoryReferenceDto
 */
export interface AccessoryReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof AccessoryReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {AccessoryType}
     * @memberof AccessoryReferenceDto
     */
    'type'?: AccessoryType;
    /**
     * 
     * @type {string}
     * @memberof AccessoryReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessoryReferenceDto
     */
    'description'?: string | null;
}


/**
 * Deprecated: Use AccessoryGetPaginatedDto.
 * @export
 * @interface AccessorySearchPaginatedDto
 */
export interface AccessorySearchPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AccessorySearchPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccessorySearchPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccessorySearchPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessorySearchPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessorySearchPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessorySearchPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AccessorySearchPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AccessorySearchPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AccessorySearchPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {AccessoryType}
     * @memberof AccessorySearchPaginatedDto
     */
    'type'?: AccessoryType;
    /**
     * 
     * @type {VehicleType}
     * @memberof AccessorySearchPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {PoolsMetaQueryDto}
     * @memberof AccessorySearchPaginatedDto
     */
    'poolsMeta'?: PoolsMetaQueryDto;
    /**
     * 
     * @type {AssetMetaQueryDto}
     * @memberof AccessorySearchPaginatedDto
     */
    'assetMeta'?: AssetMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof AccessorySearchPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AccessoryStatus = {
    None: 'None',
    InOrder: 'InOrder',
    Missing: 'Missing',
    Damaged: 'Damaged'
} as const;

export type AccessoryStatus = typeof AccessoryStatus[keyof typeof AccessoryStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const AccessoryType = {
    None: 'None',
    SpareKey: 'SpareKey',
    ChargerCable: 'ChargerCable',
    TrunkCover: 'TrunkCover',
    AutopassUnit: 'AutopassUnit',
    PortableTireInflator: 'PortableTireInflator',
    ChildSeat: 'ChildSeat',
    DashCam: 'DashCam',
    PhoneHolder: 'PhoneHolder',
    PhoneCharger: 'PhoneCharger'
} as const;

export type AccessoryType = typeof AccessoryType[keyof typeof AccessoryType];


/**
 * 
 * @export
 * @interface AddAccessoryCheckToContractDto
 */
export interface AddAccessoryCheckToContractDto {
    /**
     * 
     * @type {string}
     * @memberof AddAccessoryCheckToContractDto
     */
    'contractId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddAccessoryCheckToContractDto
     */
    'isSendToCustomer'?: boolean;
}
/**
 * 
 * @export
 * @interface AddAssetSubscriptionPlanProductLocationsDto
 */
export interface AddAssetSubscriptionPlanProductLocationsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddAssetSubscriptionPlanProductLocationsDto
     */
    'productLocationIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AddChatParticipantsDto
 */
export interface AddChatParticipantsDto {
    /**
     * 
     * @type {Array<ChatParticipantCandidateInputDto>}
     * @memberof AddChatParticipantsDto
     */
    'candidates'?: Array<ChatParticipantCandidateInputDto>;
}
/**
 * 
 * @export
 * @interface AddDamageCostEvaluationToContractDto
 */
export interface AddDamageCostEvaluationToContractDto {
    /**
     * 
     * @type {string}
     * @memberof AddDamageCostEvaluationToContractDto
     */
    'contractId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddDamageCostEvaluationToContractDto
     */
    'isSendToCustomer'?: boolean;
}
/**
 * 
 * @export
 * @interface AddDamageDetectionToContractDto
 */
export interface AddDamageDetectionToContractDto {
    /**
     * 
     * @type {string}
     * @memberof AddDamageDetectionToContractDto
     */
    'contractId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddDamageDetectionToContractDto
     */
    'isSendToCustomer'?: boolean;
}
/**
 * 
 * @export
 * @interface AddDepartmentLocationsDto
 */
export interface AddDepartmentLocationsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddDepartmentLocationsDto
     */
    'locationIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AddDocumentAttachmentsDto
 */
export interface AddDocumentAttachmentsDto {
    /**
     * 
     * @type {Array<FileUploadedDto>}
     * @memberof AddDocumentAttachmentsDto
     */
    'attachments'?: Array<FileUploadedDto>;
}
/**
 * 
 * @export
 * @interface AddDocumentItemAttachmentsDto
 */
export interface AddDocumentItemAttachmentsDto {
    /**
     * 
     * @type {Array<FileUploadedDto>}
     * @memberof AddDocumentItemAttachmentsDto
     */
    'attachments'?: Array<FileUploadedDto>;
}
/**
 * 
 * @export
 * @interface AddLocationSpotsDto
 */
export interface AddLocationSpotsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddLocationSpotsDto
     */
    'spotIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AddProductLocationSpotsDto
 */
export interface AddProductLocationSpotsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddProductLocationSpotsDto
     */
    'spotIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AddUsersToDepartmentDto
 */
export interface AddUsersToDepartmentDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddUsersToDepartmentDto
     */
    'userIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AddUsersToLocationDto
 */
export interface AddUsersToLocationDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddUsersToLocationDto
     */
    'userIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AdminAddUserToTenantDto
 */
export interface AdminAddUserToTenantDto {
    /**
     * 
     * @type {string}
     * @memberof AdminAddUserToTenantDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAddUserToTenantDto
     */
    'userId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminAddUserToTenantDto
     */
    'roleIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AdminClearCacheDto
 */
export interface AdminClearCacheDto {
    /**
     * 
     * @type {boolean}
     * @memberof AdminClearCacheDto
     */
    'isClearAll'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminCreateAnonymousInviteDto
 */
export interface AdminCreateAnonymousInviteDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateAnonymousInviteDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateAnonymousInviteDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateAnonymousInviteDto
     */
    'locationId'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof AdminCreateAnonymousInviteDto
     */
    'lifetime'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCreateAnonymousInviteDto
     */
    'roleIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AdminCreateCustomSessionDto
 */
export interface AdminCreateCustomSessionDto {
    /**
     * 
     * @type {UserMembershipType}
     * @memberof AdminCreateCustomSessionDto
     */
    'membershipType'?: UserMembershipType;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateCustomSessionDto
     */
    'tenantId'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminCreateCustomSessionDto
     */
    'expiresAt'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof AdminCreateCustomSessionDto
     */
    'lifetime'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCreateCustomSessionDto
     */
    'roleIds'?: Array<string>;
    /**
     * 
     * @type {ForAccountDtoInAdminCreateCustomSessionDto}
     * @memberof AdminCreateCustomSessionDto
     */
    'forAccount'?: ForAccountDtoInAdminCreateCustomSessionDto;
    /**
     * 
     * @type {object}
     * @memberof AdminCreateCustomSessionDto
     */
    'forNoAccount'?: object;
    /**
     * 
     * @type {object}
     * @memberof AdminCreateCustomSessionDto
     */
    'forAnonymous'?: object;
}


/**
 * 
 * @export
 * @interface AdminCreateDamageTypeDto
 */
export interface AdminCreateDamageTypeDto {
    /**
     * 
     * @type {DamageTypeCategory}
     * @memberof AdminCreateDamageTypeDto
     */
    'category'?: DamageTypeCategory;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateDamageTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateDamageTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateDamageTypeDto
     */
    'isCategoryRoot'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateDamageTypeDto
     */
    'isEnabledForDamageDetection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateDamageTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateDamageTypeDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminCreateGlobalRoleDto
 */
export interface AdminCreateGlobalRoleDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateGlobalRoleDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateGlobalRoleDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<AppPermission>}
     * @memberof AdminCreateGlobalRoleDto
     */
    'permissions'?: Array<AppPermission>;
}
/**
 * 
 * @export
 * @interface AdminCreateInviteDto
 */
export interface AdminCreateInviteDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateInviteDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateInviteDto
     */
    'email'?: string;
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof AdminCreateInviteDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateInviteDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateInviteDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateInviteDto
     */
    'locationId'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof AdminCreateInviteDto
     */
    'lifetime'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCreateInviteDto
     */
    'roleIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateInviteDto
     */
    'isInviteExistingUser'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminCreateNotificationDto
 */
export interface AdminCreateNotificationDto {
    /**
     * 
     * @type {NotificationChannel}
     * @memberof AdminCreateNotificationDto
     */
    'channel'?: NotificationChannel;
    /**
     * 
     * @type {AdminInAppChannelInfoDto}
     * @memberof AdminCreateNotificationDto
     */
    'inApp'?: AdminInAppChannelInfoDto;
    /**
     * 
     * @type {AdminEmailChannelInfoDto}
     * @memberof AdminCreateNotificationDto
     */
    'email'?: AdminEmailChannelInfoDto;
    /**
     * 
     * @type {AdminSmsChannelInfoDto}
     * @memberof AdminCreateNotificationDto
     */
    'sms'?: AdminSmsChannelInfoDto;
    /**
     * 
     * @type {AdminPushChannelInfoDto}
     * @memberof AdminCreateNotificationDto
     */
    'push'?: AdminPushChannelInfoDto;
    /**
     * 
     * @type {AdminWebPushChannelInfoDto}
     * @memberof AdminCreateNotificationDto
     */
    'webPush'?: AdminWebPushChannelInfoDto;
}


/**
 * 
 * @export
 * @interface AdminCreateSubscriptionPlanDto
 */
export interface AdminCreateSubscriptionPlanDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateSubscriptionPlanDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateSubscriptionPlanDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateSubscriptionPlanDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateSubscriptionPlanDto
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {Array<AdminCreateUpdateSubscriptionPlanPriceDto>}
     * @memberof AdminCreateSubscriptionPlanDto
     */
    'prices'?: Array<AdminCreateUpdateSubscriptionPlanPriceDto>;
}
/**
 * 
 * @export
 * @interface AdminCreateUpdateSubscriptionPlanPriceDto
 */
export interface AdminCreateUpdateSubscriptionPlanPriceDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateUpdateSubscriptionPlanPriceDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {BillingPeriod}
     * @memberof AdminCreateUpdateSubscriptionPlanPriceDto
     */
    'period'?: BillingPeriod;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateUpdateSubscriptionPlanPriceDto
     */
    'price'?: number;
}


/**
 * 
 * @export
 * @interface AdminCreateVehicleBodyTypeDto
 */
export interface AdminCreateVehicleBodyTypeDto {
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminCreateVehicleBodyTypeDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof AdminCreateVehicleBodyTypeDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleBodyTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleBodyTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateVehicleBodyTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateVehicleBodyTypeDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminCreateVehicleFuelTypeDto
 */
export interface AdminCreateVehicleFuelTypeDto {
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminCreateVehicleFuelTypeDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof AdminCreateVehicleFuelTypeDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleFuelTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleFuelTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateVehicleFuelTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateVehicleFuelTypeDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminCreateVehicleGenerationDto
 */
export interface AdminCreateVehicleGenerationDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleGenerationDto
     */
    'makeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleGenerationDto
     */
    'modelId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleGenerationDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateVehicleGenerationDto
     */
    'startYear'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateVehicleGenerationDto
     */
    'endYear'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateVehicleGenerationDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateVehicleGenerationDto
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface AdminCreateVehicleMakeDto
 */
export interface AdminCreateVehicleMakeDto {
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminCreateVehicleMakeDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleMakeDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateVehicleMakeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateVehicleMakeDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminCreateVehicleModelDto
 */
export interface AdminCreateVehicleModelDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleModelDto
     */
    'makeId'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminCreateVehicleModelDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleModelDto
     */
    'name'?: string;
    /**
     * 
     * @type {VehicleSize}
     * @memberof AdminCreateVehicleModelDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateVehicleModelDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateVehicleModelDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminCreateVehicleModificationDto
 */
export interface AdminCreateVehicleModificationDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleModificationDto
     */
    'makeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleModificationDto
     */
    'modelId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleModificationDto
     */
    'generationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleModificationDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleModificationDto
     */
    'fuelTypeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleModificationDto
     */
    'bodyTypeId'?: string | null;
    /**
     * 
     * @type {VehicleSize}
     * @memberof AdminCreateVehicleModificationDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateVehicleModificationDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateVehicleModificationDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminCreateVehiclePartTypeDto
 */
export interface AdminCreateVehiclePartTypeDto {
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminCreateVehiclePartTypeDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehiclePartCategory}
     * @memberof AdminCreateVehiclePartTypeDto
     */
    'category'?: VehiclePartCategory;
    /**
     * 
     * @type {VehiclePartType}
     * @memberof AdminCreateVehiclePartTypeDto
     */
    'type'?: VehiclePartType;
    /**
     * 
     * @type {Array<VehicleArea>}
     * @memberof AdminCreateVehiclePartTypeDto
     */
    'areas'?: Array<VehicleArea>;
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof AdminCreateVehiclePartTypeDto
     */
    'projections'?: Array<VehicleProjection> | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehiclePartTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehiclePartTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateVehiclePartTypeDto
     */
    'isCategoryRoot'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateVehiclePartTypeDto
     */
    'isTypeRoot'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateVehiclePartTypeDto
     */
    'isEnabledForDamageDetection'?: boolean;
    /**
     * 
     * @type {Array<DamageTypeCategory>}
     * @memberof AdminCreateVehiclePartTypeDto
     */
    'damageCategories'?: Array<DamageTypeCategory> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCreateVehiclePartTypeDto
     */
    'damageTypeIds'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateVehiclePartTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateVehiclePartTypeDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminCreateVehicleTypeDto
 */
export interface AdminCreateVehicleTypeDto {
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminCreateVehicleTypeDto
     */
    'type'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateVehicleTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateVehicleTypeDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminCreateVehicleVisualModelDto
 */
export interface AdminCreateVehicleVisualModelDto {
    /**
     * 
     * @type {VehicleVisualModelType}
     * @memberof AdminCreateVehicleVisualModelDto
     */
    'type'?: VehicleVisualModelType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof AdminCreateVehicleVisualModelDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {Array<VehicleBodyType>}
     * @memberof AdminCreateVehicleVisualModelDto
     */
    'bodyTypes'?: Array<VehicleBodyType> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCreateVehicleVisualModelDto
     */
    'makeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCreateVehicleVisualModelDto
     */
    'modelIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCreateVehicleVisualModelDto
     */
    'generationIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCreateVehicleVisualModelDto
     */
    'modificationIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<AdminCreateVehicleVisualModelImageDto>}
     * @memberof AdminCreateVehicleVisualModelDto
     */
    'images'?: Array<AdminCreateVehicleVisualModelImageDto>;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateVehicleVisualModelDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateVehicleVisualModelDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateVehicleVisualModelDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateVehicleVisualModelDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminCreateVehicleVisualModelImageDto
 */
export interface AdminCreateVehicleVisualModelImageDto {
    /**
     * 
     * @type {VehicleArea}
     * @memberof AdminCreateVehicleVisualModelImageDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof AdminCreateVehicleVisualModelImageDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {FileUploadedDto}
     * @memberof AdminCreateVehicleVisualModelImageDto
     */
    'file'?: FileUploadedDto;
}


/**
 * 
 * @export
 * @interface AdminCustomSessionGetPaginatedDto
 */
export interface AdminCustomSessionGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminCustomSessionGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomSessionGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomSessionGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCustomSessionGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCustomSessionGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCustomSessionGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminCustomSessionGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminCustomSessionGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminCustomSessionGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomSessionGetPaginatedDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomSessionGetPaginatedDto
     */
    'customIdentityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomSessionGetPaginatedDto
     */
    'userId'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminDamageDetectionGetPaginatedDto
 */
export interface AdminDamageDetectionGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'assignmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'vehicleDamageId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'vehicleDamageIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'anyVehicleDamageIds'?: Array<string> | null;
    /**
     * 
     * @type {TenantRequestsMetaQueryDto}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageDetectionGetPaginatedDto
     */
    'tenantId'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminDamageTypeDto
 */
export interface AdminDamageTypeDto {
    /**
     * 
     * @type {string}
     * @memberof AdminDamageTypeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageTypeDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {DamageTypeCategory}
     * @memberof AdminDamageTypeDto
     */
    'category'?: DamageTypeCategory;
    /**
     * 
     * @type {VehiclePartType}
     * @memberof AdminDamageTypeDto
     */
    'partType'?: VehiclePartType;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDamageTypeDto
     */
    'isCategoryRoot'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDamageTypeDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDamageTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminDamageTypeDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDamageTypeDto
     */
    'isEnabledForDamageDetection'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminDamageTypeDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminDamageTypeDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageTypeDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageTypeDto
     */
    'updatedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface AdminDamageTypeGetPaginatedDto
 */
export interface AdminDamageTypeGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {DamageTypeCategory}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'category'?: DamageTypeCategory;
    /**
     * 
     * @type {Array<DamageTypeCategory>}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'categories'?: Array<DamageTypeCategory> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'isCategoryRoot'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'isEnabledForDamageDetection'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'vehiclePartTypeId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'isBuiltIn'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDamageTypeGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface AdminEmailChannelInfoDto
 */
export interface AdminEmailChannelInfoDto {
    /**
     * 
     * @type {Array<AdminSendToAnonymousUserDto>}
     * @memberof AdminEmailChannelInfoDto
     */
    'users'?: Array<AdminSendToAnonymousUserDto>;
    /**
     * 
     * @type {string}
     * @memberof AdminEmailChannelInfoDto
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEmailChannelInfoDto
     */
    'templateId'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AdminEmailChannelInfoDto
     */
    'templateData'?: any | null;
    /**
     * 
     * @type {DefaultEmailTemplateDataV2}
     * @memberof AdminEmailChannelInfoDto
     */
    'defaultTemplateData'?: DefaultEmailTemplateDataV2;
}
/**
 * 
 * @export
 * @interface AdminFileDeleteDto
 */
export interface AdminFileDeleteDto {
    /**
     * 
     * @type {boolean}
     * @memberof AdminFileDeleteDto
     */
    'isForce'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminFileDto
 */
export interface AdminFileDto {
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof AdminFileDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminFileDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminFileDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminFileDto
     */
    'isDeleted'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminFileDto
     */
    'deletedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminFileDto
     */
    'restoredAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'deletedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'restoredBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'parentFileId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'copiedFromFileId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'storageAccountIdentifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'containerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'blobName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'originalFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'displayFileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'contentType'?: string;
    /**
     * 
     * @type {GeneralFileSizeDto}
     * @memberof AdminFileDto
     */
    'originalSize'?: GeneralFileSizeDto;
    /**
     * 
     * @type {GeneralFileSizeDto}
     * @memberof AdminFileDto
     */
    'size'?: GeneralFileSizeDto;
    /**
     * 
     * @type {FileAccessLevel}
     * @memberof AdminFileDto
     */
    'accessLevel'?: FileAccessLevel;
    /**
     * 
     * @type {boolean}
     * @memberof AdminFileDto
     */
    'isThumbnail'?: boolean;
    /**
     * 
     * @type {Array<FileThumbnailDto>}
     * @memberof AdminFileDto
     */
    'thumbnails'?: Array<FileThumbnailDto>;
    /**
     * 
     * @type {FileImageInfoDto}
     * @memberof AdminFileDto
     */
    'image'?: FileImageInfoDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminFileDto
     */
    'uploadedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'uploadedBy'?: string | null;
    /**
     * 
     * @type {FileHashDto}
     * @memberof AdminFileDto
     */
    'originalHash'?: FileHashDto;
    /**
     * 
     * @type {FileHashDto}
     * @memberof AdminFileDto
     */
    'hash'?: FileHashDto;
    /**
     * 
     * @type {FileUsageVersion}
     * @memberof AdminFileDto
     */
    'usageVersion'?: FileUsageVersion;
    /**
     * 
     * @type {Array<FileUsageLockDto>}
     * @memberof AdminFileDto
     */
    'usageLocks'?: Array<FileUsageLockDto> | null;
    /**
     * 
     * @type {Array<FileUsageLockDto>}
     * @memberof AdminFileDto
     */
    'usageLockHistory'?: Array<FileUsageLockDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminFileDto
     */
    'isBlobSoftDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminFileDto
     */
    'isBlobHardDeleted'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminFileDto
     */
    'blobSoftDeletedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminFileDto
     */
    'blobHardDeletedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminFileDto
     */
    'blobUndeletedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminFileDto
     */
    'isUsed'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminFileDto
     */
    'obsoleteAt'?: string | null;
    /**
     * Relative file size reduction expressed as a ratio, like 5:1. Higher values indicate better compression.    1 means no reduction.    (1, +∞) means size reduction.    (-∞, 1) means size increase.
     * @type {number}
     * @memberof AdminFileDto
     */
    'compressionRatio'?: number;
    /**
     * The percentage reduction in file size from the original to the compressed form, like 50%.    Expressed as normalized percentage in range [0, 1].  0 means no reduction.    [0, 1) means size reduction.    (-∞, 0) means size increase.
     * @type {number}
     * @memberof AdminFileDto
     */
    'compressionRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'originalExtension'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'extension'?: string | null;
    /**
     * 
     * @type {MimeBaseType}
     * @memberof AdminFileDto
     */
    'mimeBaseType'?: MimeBaseType;
    /**
     * 
     * @type {boolean}
     * @memberof AdminFileDto
     */
    'isBlobDeleted'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminFileDto
     */
    'blobDeletedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminFileDto
     */
    'estBlobSoftDeleteAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminFileDto
     */
    'estBlobHardDeleteAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminFileDto
     */
    'url'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof AdminFileDto
     */
    'urlLifetime'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminFileDto
     */
    'urlExpiresAt'?: string | null;
}


/**
 * 
 * @export
 * @interface AdminFileGetPaginatedDto
 */
export interface AdminFileGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminFileGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminFileGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminFileGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminFileGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminFileGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminFileGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminFileGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminFileGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminFileGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof AdminFileGetPaginatedDto
     */
    'id'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof AdminFileGetPaginatedDto
     */
    'createdAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof AdminFileGetPaginatedDto
     */
    'updatedAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof AdminFileGetPaginatedDto
     */
    'createdBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof AdminFileGetPaginatedDto
     */
    'updatedBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {boolean}
     * @memberof AdminFileGetPaginatedDto
     */
    'isDeleted'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminFileGetPaginatedDto
     */
    'isIncludeDeleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AdminFileGetPaginatedDto
     */
    'tenantId'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminFileUndeleteDto
 */
export interface AdminFileUndeleteDto {
    /**
     * 
     * @type {boolean}
     * @memberof AdminFileUndeleteDto
     */
    'isForce'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminFrontEndAppUpdateInfoCreateDto
 */
export interface AdminFrontEndAppUpdateInfoCreateDto {
    /**
     * 
     * @type {FrontEndAppType}
     * @memberof AdminFrontEndAppUpdateInfoCreateDto
     */
    'appType'?: FrontEndAppType;
    /**
     * 
     * @type {OperatingSystemType}
     * @memberof AdminFrontEndAppUpdateInfoCreateDto
     */
    'operatingSystem'?: OperatingSystemType;
    /**
     * 
     * @type {Array<FrontEndAppUpdateInfoItem>}
     * @memberof AdminFrontEndAppUpdateInfoCreateDto
     */
    'items'?: Array<FrontEndAppUpdateInfoItem>;
}


/**
 * 
 * @export
 * @interface AdminFrontEndAppUpdateInfoDeleteDto
 */
export interface AdminFrontEndAppUpdateInfoDeleteDto {
    /**
     * 
     * @type {FrontEndAppType}
     * @memberof AdminFrontEndAppUpdateInfoDeleteDto
     */
    'appType'?: FrontEndAppType;
    /**
     * 
     * @type {OperatingSystemType}
     * @memberof AdminFrontEndAppUpdateInfoDeleteDto
     */
    'operatingSystem'?: OperatingSystemType;
    /**
     * 
     * @type {string}
     * @memberof AdminFrontEndAppUpdateInfoDeleteDto
     */
    'version'?: string;
}


/**
 * 
 * @export
 * @interface AdminFrontEndAppUpdateInfoUpdateDto
 */
export interface AdminFrontEndAppUpdateInfoUpdateDto {
    /**
     * 
     * @type {FrontEndAppType}
     * @memberof AdminFrontEndAppUpdateInfoUpdateDto
     */
    'appType'?: FrontEndAppType;
    /**
     * 
     * @type {OperatingSystemType}
     * @memberof AdminFrontEndAppUpdateInfoUpdateDto
     */
    'operatingSystem'?: OperatingSystemType;
    /**
     * 
     * @type {Array<FrontEndAppUpdateInfoItem>}
     * @memberof AdminFrontEndAppUpdateInfoUpdateDto
     */
    'items'?: Array<FrontEndAppUpdateInfoItem>;
}


/**
 * 
 * @export
 * @interface AdminInAppChannelInfoDto
 */
export interface AdminInAppChannelInfoDto {
    /**
     * 
     * @type {Array<AdminSendToUserDto>}
     * @memberof AdminInAppChannelInfoDto
     */
    'users'?: Array<AdminSendToUserDto>;
    /**
     * 
     * @type {string}
     * @memberof AdminInAppChannelInfoDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInAppChannelInfoDto
     */
    'body'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminIntegrationApiClientGetPaginatedDto
 */
export interface AdminIntegrationApiClientGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminIntegrationApiClientGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminIntegrationApiClientGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminIntegrationApiClientGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminIntegrationApiClientGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminIntegrationApiClientGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminIntegrationApiClientGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminIntegrationApiClientGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminIntegrationApiClientGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminIntegrationApiClientGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof AdminIntegrationApiClientGetPaginatedDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {IntegrationApiScopeType}
     * @memberof AdminIntegrationApiClientGetPaginatedDto
     */
    'scopeType'?: IntegrationApiScopeType;
}


/**
 * 
 * @export
 * @interface AdminInviteAnonymousResultDto
 */
export interface AdminInviteAnonymousResultDto {
    /**
     * 
     * @type {string}
     * @memberof AdminInviteAnonymousResultDto
     */
    'inviteUrl'?: string;
}
/**
 * 
 * @export
 * @interface AdminInviteDto
 */
export interface AdminInviteDto {
    /**
     * 
     * @type {string}
     * @memberof AdminInviteDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof AdminInviteDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminInviteDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminInviteDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {InviteType}
     * @memberof AdminInviteDto
     */
    'type'?: InviteType;
    /**
     * 
     * @type {InviteUserType}
     * @memberof AdminInviteDto
     */
    'userType'?: InviteUserType;
    /**
     * 
     * @type {InviteUserInfo}
     * @memberof AdminInviteDto
     */
    'userInfo'?: InviteUserInfo;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminInviteDto
     */
    'sentAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminInviteDto
     */
    'expiresAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteDto
     */
    'inviteUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteDto
     */
    'redirectUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminInviteDto
     */
    'maxUsers'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminInviteDto
     */
    'currentUsers'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminInviteDto
     */
    'registeredUserIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminInviteDto
     */
    'acceptedUserIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminInviteDto
     */
    'rejectedUserIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminInviteDto
     */
    'roleIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminInviteDto
     */
    'isExpired'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminInviteDto
     */
    'isAnyRegistered'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminInviteDto
     */
    'isAnyAccepted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminInviteDto
     */
    'isAnyRejected'?: boolean;
}


/**
 * 
 * @export
 * @interface AdminInviteGetPaginatedDto
 */
export interface AdminInviteGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminInviteGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminInviteGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminInviteGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminInviteGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminInviteGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminInviteGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminInviteGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminInviteGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteGetPaginatedDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteGetPaginatedDto
     */
    'inviteId'?: string | null;
    /**
     * 
     * @type {InviteType}
     * @memberof AdminInviteGetPaginatedDto
     */
    'type'?: InviteType;
    /**
     * 
     * @type {InviteUserType}
     * @memberof AdminInviteGetPaginatedDto
     */
    'userType'?: InviteUserType;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminInviteGetPaginatedDto
     */
    'allRoleIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminInviteGetPaginatedDto
     */
    'anyRoleIds'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface AdminInvitePersonalResultDto
 */
export interface AdminInvitePersonalResultDto {
    /**
     * 
     * @type {string}
     * @memberof AdminInvitePersonalResultDto
     */
    'inviteUrl'?: string;
}
/**
 * 
 * @export
 * @interface AdminInvoiceDto
 */
export interface AdminInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'subscriptionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {InvoiceStatus}
     * @memberof AdminInvoiceDto
     */
    'status'?: InvoiceStatus;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof AdminInvoiceDto
     */
    'paymentMethod'?: PaymentMethod;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof AdminInvoiceDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {InvoiceBusinessInfoDto}
     * @memberof AdminInvoiceDto
     */
    'businessInfo'?: InvoiceBusinessInfoDto;
    /**
     * 
     * @type {InvoiceCustomerBusinessInfoDto}
     * @memberof AdminInvoiceDto
     */
    'customerBusinessInfo'?: InvoiceCustomerBusinessInfoDto;
    /**
     * 
     * @type {Array<AdminInvoiceLineItemDto>}
     * @memberof AdminInvoiceDto
     */
    'lineItems'?: Array<AdminInvoiceLineItemDto>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'date'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'dueAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'sentAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'pendingAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'paidAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'cancelledAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminInvoiceDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof AdminInvoiceDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof AdminInvoiceDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof AdminInvoiceDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminInvoiceDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminInvoiceDto
     */
    'total'?: number;
    /**
     * 
     * @type {AdminTenantDto}
     * @memberof AdminInvoiceDto
     */
    'company'?: AdminTenantDto;
    /**
     * 
     * @type {AdminSubscriptionDto}
     * @memberof AdminInvoiceDto
     */
    'subscription'?: AdminSubscriptionDto;
}


/**
 * 
 * @export
 * @interface AdminInvoiceGetPaginatedDto
 */
export interface AdminInvoiceGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminInvoiceGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminInvoiceGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminInvoiceGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminInvoiceGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminInvoiceGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminInvoiceGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminInvoiceGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminInvoiceGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminInvoiceGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof AdminInvoiceGetPaginatedDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminInvoiceGetPaginatedDto
     */
    'subscriptionId'?: string | null;
    /**
     * 
     * @type {InvoiceStatus}
     * @memberof AdminInvoiceGetPaginatedDto
     */
    'status'?: InvoiceStatus;
}


/**
 * 
 * @export
 * @interface AdminInvoiceLineItemDto
 */
export interface AdminInvoiceLineItemDto {
    /**
     * 
     * @type {string}
     * @memberof AdminInvoiceLineItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInvoiceLineItemDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminInvoiceLineItemDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminInvoiceLineItemDto
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminInvoiceLineItemDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof AdminInvoiceLineItemDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof AdminInvoiceLineItemDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof AdminInvoiceLineItemDto
     */
    'subtotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminInvoiceLineItemDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface AdminNotificationDto
 */
export interface AdminNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof AdminNotificationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNotificationDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminNotificationDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {NotificationChannel}
     * @memberof AdminNotificationDto
     */
    'channel'?: NotificationChannel;
    /**
     * 
     * @type {NotificationImportance}
     * @memberof AdminNotificationDto
     */
    'importance'?: NotificationImportance;
    /**
     * 
     * @type {NotificationDeliveryStatus}
     * @memberof AdminNotificationDto
     */
    'deliveryStatus'?: NotificationDeliveryStatus;
    /**
     * 
     * @type {NotificationDeliveryError}
     * @memberof AdminNotificationDto
     */
    'deliveryError'?: NotificationDeliveryError;
    /**
     * 
     * @type {InAppChannelInfoDto}
     * @memberof AdminNotificationDto
     */
    'inApp'?: InAppChannelInfoDto;
    /**
     * 
     * @type {EmailChannelInfoDto}
     * @memberof AdminNotificationDto
     */
    'email'?: EmailChannelInfoDto;
    /**
     * 
     * @type {SmsChannelInfoDto}
     * @memberof AdminNotificationDto
     */
    'sms'?: SmsChannelInfoDto;
    /**
     * 
     * @type {PushChannelInfoDto}
     * @memberof AdminNotificationDto
     */
    'push'?: PushChannelInfoDto;
    /**
     * 
     * @type {WebPushChannelInfoDto}
     * @memberof AdminNotificationDto
     */
    'webPush'?: WebPushChannelInfoDto;
    /**
     * 
     * @type {boolean}
     * @memberof AdminNotificationDto
     */
    'isSent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminNotificationDto
     */
    'isRead'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminNotificationDto
     */
    'readAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminNotificationDto
     */
    'sentAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminNotificationDto
     */
    'createdAt'?: string;
}


/**
 * 
 * @export
 * @interface AdminNotificationGetPaginatedDto
 */
export interface AdminNotificationGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminNotificationGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminNotificationGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminNotificationGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminNotificationGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminNotificationGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminNotificationGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminNotificationGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminNotificationGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminNotificationGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof AdminNotificationGetPaginatedDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {NotificationChannel}
     * @memberof AdminNotificationGetPaginatedDto
     */
    'channel'?: NotificationChannel;
    /**
     * 
     * @type {NotificationDeliveryStatus}
     * @memberof AdminNotificationGetPaginatedDto
     */
    'deliveryStatus'?: NotificationDeliveryStatus;
}


/**
 * 
 * @export
 * @interface AdminPushChannelInfoDto
 */
export interface AdminPushChannelInfoDto {
    /**
     * 
     * @type {Array<AdminSendToUserDto>}
     * @memberof AdminPushChannelInfoDto
     */
    'users'?: Array<AdminSendToUserDto>;
    /**
     * 
     * @type {string}
     * @memberof AdminPushChannelInfoDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPushChannelInfoDto
     */
    'body'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPushChannelInfoDto
     */
    'imageUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPushChannelInfoDto
     */
    'channel'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminSendToAnonymousUserDto
 */
export interface AdminSendToAnonymousUserDto {
    /**
     * 
     * @type {string}
     * @memberof AdminSendToAnonymousUserDto
     */
    'to'?: string;
}
/**
 * 
 * @export
 * @interface AdminSendToUserDto
 */
export interface AdminSendToUserDto {
    /**
     * 
     * @type {string}
     * @memberof AdminSendToUserDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSendToUserDto
     */
    'tenantId'?: string;
}
/**
 * 
 * @export
 * @interface AdminSmsChannelInfoDto
 */
export interface AdminSmsChannelInfoDto {
    /**
     * 
     * @type {Array<AdminSendToAnonymousUserDto>}
     * @memberof AdminSmsChannelInfoDto
     */
    'users'?: Array<AdminSendToAnonymousUserDto>;
    /**
     * 
     * @type {string}
     * @memberof AdminSmsChannelInfoDto
     */
    'body'?: string;
}
/**
 * 
 * @export
 * @interface AdminSubscriptionDto
 */
export interface AdminSubscriptionDto {
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {AdminSubscriptionSelectedPlanDto}
     * @memberof AdminSubscriptionDto
     */
    'plan'?: AdminSubscriptionSelectedPlanDto;
    /**
     * 
     * @type {SubscriptionStatus}
     * @memberof AdminSubscriptionDto
     */
    'status'?: SubscriptionStatus;
    /**
     * 
     * @type {BillingPeriod}
     * @memberof AdminSubscriptionDto
     */
    'period'?: BillingPeriod;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminSubscriptionDto
     */
    'startsAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminSubscriptionDto
     */
    'currentPeriodStartsAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminSubscriptionDto
     */
    'currentPeriodEndsAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminSubscriptionDto
     */
    'cancelAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminSubscriptionDto
     */
    'canceledAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminSubscriptionDto
     */
    'endsAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminSubscriptionDto
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDto
     */
    'lastInvoiceId'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminSubscriptionDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminSubscriptionDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionDto
     */
    'updatedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface AdminSubscriptionGetPaginatedDto
 */
export interface AdminSubscriptionGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminSubscriptionGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminSubscriptionGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminSubscriptionGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminSubscriptionGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminSubscriptionGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminSubscriptionGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminSubscriptionGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminSubscriptionGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionGetPaginatedDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {SubscriptionStatus}
     * @memberof AdminSubscriptionGetPaginatedDto
     */
    'status'?: SubscriptionStatus;
}


/**
 * 
 * @export
 * @interface AdminSubscriptionPlanDto
 */
export interface AdminSubscriptionPlanDto {
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionPlanDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionPlanDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionPlanDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminSubscriptionPlanDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSubscriptionPlanDto
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSubscriptionPlanDto
     */
    'isFree'?: boolean;
    /**
     * 
     * @type {Array<SubscriptionPlanPriceDto>}
     * @memberof AdminSubscriptionPlanDto
     */
    'prices'?: Array<SubscriptionPlanPriceDto>;
    /**
     * 
     * @type {Array<AppModule>}
     * @memberof AdminSubscriptionPlanDto
     */
    'modules'?: Array<AppModule>;
    /**
     * 
     * @type {object}
     * @memberof AdminSubscriptionPlanDto
     */
    'limits'?: object;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminSubscriptionPlanDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminSubscriptionPlanDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionPlanDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionPlanDto
     */
    'updatedBy'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminSubscriptionSelectedPlanDto
 */
export interface AdminSubscriptionSelectedPlanDto {
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionSelectedPlanDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionSelectedPlanDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSubscriptionSelectedPlanDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {SubscriptionPlanPriceDto}
     * @memberof AdminSubscriptionSelectedPlanDto
     */
    'price'?: SubscriptionPlanPriceDto;
    /**
     * 
     * @type {Array<AppModule>}
     * @memberof AdminSubscriptionSelectedPlanDto
     */
    'modules'?: Array<AppModule>;
    /**
     * 
     * @type {object}
     * @memberof AdminSubscriptionSelectedPlanDto
     */
    'limits'?: object;
}
/**
 * 
 * @export
 * @interface AdminTenantDto
 */
export interface AdminTenantDto {
    /**
     * 
     * @type {string}
     * @memberof AdminTenantDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminTenantDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminTenantDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminTenantDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {TenantStatus}
     * @memberof AdminTenantDto
     */
    'status'?: TenantStatus;
    /**
     * 
     * @type {TenantMode}
     * @memberof AdminTenantDto
     */
    'mode'?: TenantMode;
    /**
     * 
     * @type {TenantContactPersonDto}
     * @memberof AdminTenantDto
     */
    'contactPerson'?: TenantContactPersonDto;
    /**
     * 
     * @type {TenantSettingsDto}
     * @memberof AdminTenantDto
     */
    'settings'?: TenantSettingsDto;
    /**
     * 
     * @type {GeneralBrandingDto}
     * @memberof AdminTenantDto
     */
    'branding'?: GeneralBrandingDto;
    /**
     * 
     * @type {TenantSuspensionInfoDto}
     * @memberof AdminTenantDto
     */
    'suspension'?: TenantSuspensionInfoDto;
    /**
     * 
     * @type {string}
     * @memberof AdminTenantDto
     */
    'companyNumberPrefix'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminTenantDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminTenantDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminTenantDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminTenantDto
     */
    'updatedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface AdminTenantGetPaginatedDto
 */
export interface AdminTenantGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminTenantGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminTenantGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminTenantGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminTenantGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminTenantGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminTenantGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminTenantGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminTenantGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminTenantGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof AdminTenantGetPaginatedDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {Array<TenantMode>}
     * @memberof AdminTenantGetPaginatedDto
     */
    'modesAny'?: Array<TenantMode> | null;
}
/**
 * 
 * @export
 * @interface AdminTenantUpdateModeDto
 */
export interface AdminTenantUpdateModeDto {
    /**
     * 
     * @type {TenantMode}
     * @memberof AdminTenantUpdateModeDto
     */
    'mode'?: TenantMode;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AdminTestDomainEventType = {
    None: 'None',
    TestEvent: 'TestEvent',
    TestEvent2: 'TestEvent2',
    TestEvent3: 'TestEvent3'
} as const;

export type AdminTestDomainEventType = typeof AdminTestDomainEventType[keyof typeof AdminTestDomainEventType];


/**
 * 
 * @export
 * @interface AdminUpdateDamageTypeDto
 */
export interface AdminUpdateDamageTypeDto {
    /**
     * 
     * @type {DamageTypeCategory}
     * @memberof AdminUpdateDamageTypeDto
     */
    'category'?: DamageTypeCategory;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateDamageTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateDamageTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateDamageTypeDto
     */
    'isCategoryRoot'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateDamageTypeDto
     */
    'isEnabledForDamageDetection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateDamageTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateDamageTypeDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminUpdateGlobalRoleDto
 */
export interface AdminUpdateGlobalRoleDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateGlobalRoleDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateGlobalRoleDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<AppPermission>}
     * @memberof AdminUpdateGlobalRoleDto
     */
    'permissions'?: Array<AppPermission>;
}
/**
 * 
 * @export
 * @interface AdminUpdateSubscriptionPlanDto
 */
export interface AdminUpdateSubscriptionPlanDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSubscriptionPlanDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSubscriptionPlanDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateSubscriptionPlanDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateSubscriptionPlanDto
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {Array<AdminCreateUpdateSubscriptionPlanPriceDto>}
     * @memberof AdminUpdateSubscriptionPlanDto
     */
    'prices'?: Array<AdminCreateUpdateSubscriptionPlanPriceDto>;
}
/**
 * 
 * @export
 * @interface AdminUpdateVehicleBodyTypeDto
 */
export interface AdminUpdateVehicleBodyTypeDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateVehicleBodyTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateVehicleBodyTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateVehicleBodyTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateVehicleBodyTypeDto
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface AdminUpdateVehicleFuelTypeDto
 */
export interface AdminUpdateVehicleFuelTypeDto {
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof AdminUpdateVehicleFuelTypeDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateVehicleFuelTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateVehicleFuelTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateVehicleFuelTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateVehicleFuelTypeDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminUpdateVehicleGenerationDto
 */
export interface AdminUpdateVehicleGenerationDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateVehicleGenerationDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateVehicleGenerationDto
     */
    'startYear'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateVehicleGenerationDto
     */
    'endYear'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateVehicleGenerationDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateVehicleGenerationDto
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface AdminUpdateVehicleMakeDto
 */
export interface AdminUpdateVehicleMakeDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateVehicleMakeDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateVehicleMakeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateVehicleMakeDto
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface AdminUpdateVehicleModelDto
 */
export interface AdminUpdateVehicleModelDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateVehicleModelDto
     */
    'name'?: string;
    /**
     * 
     * @type {VehicleSize}
     * @memberof AdminUpdateVehicleModelDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateVehicleModelDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateVehicleModelDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminUpdateVehicleModificationDto
 */
export interface AdminUpdateVehicleModificationDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateVehicleModificationDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateVehicleModificationDto
     */
    'fuelTypeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateVehicleModificationDto
     */
    'bodyTypeId'?: string | null;
    /**
     * 
     * @type {VehicleSize}
     * @memberof AdminUpdateVehicleModificationDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateVehicleModificationDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateVehicleModificationDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminUpdateVehiclePartTypeDto
 */
export interface AdminUpdateVehiclePartTypeDto {
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminUpdateVehiclePartTypeDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehiclePartCategory}
     * @memberof AdminUpdateVehiclePartTypeDto
     */
    'category'?: VehiclePartCategory;
    /**
     * 
     * @type {VehiclePartType}
     * @memberof AdminUpdateVehiclePartTypeDto
     */
    'type'?: VehiclePartType;
    /**
     * 
     * @type {Array<VehicleArea>}
     * @memberof AdminUpdateVehiclePartTypeDto
     */
    'areas'?: Array<VehicleArea>;
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof AdminUpdateVehiclePartTypeDto
     */
    'projections'?: Array<VehicleProjection> | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateVehiclePartTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateVehiclePartTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateVehiclePartTypeDto
     */
    'isCategoryRoot'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateVehiclePartTypeDto
     */
    'isTypeRoot'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateVehiclePartTypeDto
     */
    'isEnabledForDamageDetection'?: boolean;
    /**
     * 
     * @type {Array<DamageTypeCategory>}
     * @memberof AdminUpdateVehiclePartTypeDto
     */
    'damageCategories'?: Array<DamageTypeCategory> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUpdateVehiclePartTypeDto
     */
    'damageTypeIds'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateVehiclePartTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateVehiclePartTypeDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminUpdateVehicleTypeDto
 */
export interface AdminUpdateVehicleTypeDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateVehicleTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateVehicleTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateVehicleTypeDto
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface AdminUpdateVehicleVisualModelDto
 */
export interface AdminUpdateVehicleVisualModelDto {
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateVehicleVisualModelDto
     */
    'isForceUpdate'?: boolean;
    /**
     * 
     * @type {VehicleVisualModelType}
     * @memberof AdminUpdateVehicleVisualModelDto
     */
    'type'?: VehicleVisualModelType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof AdminUpdateVehicleVisualModelDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {Array<VehicleBodyType>}
     * @memberof AdminUpdateVehicleVisualModelDto
     */
    'bodyTypes'?: Array<VehicleBodyType> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUpdateVehicleVisualModelDto
     */
    'makeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUpdateVehicleVisualModelDto
     */
    'modelIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUpdateVehicleVisualModelDto
     */
    'generationIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUpdateVehicleVisualModelDto
     */
    'modificationIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<AdminUpdateVehicleVisualModelImageDto>}
     * @memberof AdminUpdateVehicleVisualModelDto
     */
    'images'?: Array<AdminUpdateVehicleVisualModelImageDto>;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateVehicleVisualModelDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateVehicleVisualModelDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateVehicleVisualModelDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateVehicleVisualModelDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface AdminUpdateVehicleVisualModelImageDto
 */
export interface AdminUpdateVehicleVisualModelImageDto {
    /**
     * 
     * @type {VehicleArea}
     * @memberof AdminUpdateVehicleVisualModelImageDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof AdminUpdateVehicleVisualModelImageDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {FileUploadedDto}
     * @memberof AdminUpdateVehicleVisualModelImageDto
     */
    'file'?: FileUploadedDto;
}


/**
 * 
 * @export
 * @interface AdminUserActivateDto
 */
export interface AdminUserActivateDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUserActivateDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserActivateDto
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminUserDto
 */
export interface AdminUserDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUserDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserDto
     */
    'auth0UserId'?: string;
    /**
     * 
     * @type {UserStatus}
     * @memberof AdminUserDto
     */
    'status'?: UserStatus;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof AdminUserDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof AdminUserDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {UserSettingsDto}
     * @memberof AdminUserDto
     */
    'settings'?: UserSettingsDto;
    /**
     * 
     * @type {GeneralAvatarDto}
     * @memberof AdminUserDto
     */
    'avatar'?: GeneralAvatarDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUserDto
     */
    'roleIds'?: Array<string>;
    /**
     * 
     * @type {Array<UserRoleDto>}
     * @memberof AdminUserDto
     */
    'roles'?: Array<UserRoleDto>;
    /**
     * 
     * @type {Array<AdminUserTenantDto>}
     * @memberof AdminUserDto
     */
    'companies'?: Array<AdminUserTenantDto>;
    /**
     * 
     * @type {UserSuspensionInfoDto}
     * @memberof AdminUserDto
     */
    'suspension'?: UserSuspensionInfoDto;
    /**
     * 
     * @type {OnboardingRefDto}
     * @memberof AdminUserDto
     */
    'onboarding'?: OnboardingRefDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminUserDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminUserDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserDto
     */
    'isPersonalInfoComplete'?: boolean;
}


/**
 * 
 * @export
 * @interface AdminUserGetPaginatedDto
 */
export interface AdminUserGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminUserGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminUserGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminUserGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUserGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUserGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUserGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminUserGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminUserGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminUserGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof AdminUserGetPaginatedDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserGetPaginatedDto
     */
    'notForTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserGetPaginatedDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof AdminUserGetPaginatedDto
     */
    'status'?: UserStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUserGetPaginatedDto
     */
    'allRoleIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUserGetPaginatedDto
     */
    'anyRoleIds'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface AdminUserRolesUpdateDto
 */
export interface AdminUserRolesUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUserRolesUpdateDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUserRolesUpdateDto
     */
    'roleIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AdminUserSuspendDto
 */
export interface AdminUserSuspendDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUserSuspendDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserSuspendDto
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminUserTenantDto
 */
export interface AdminUserTenantDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUserTenantDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserTenantDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserTenantDto
     */
    'customerContactId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserTenantDto
     */
    'isCustomerUser'?: boolean;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof AdminUserTenantDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof AdminUserTenantDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {UserStatus}
     * @memberof AdminUserTenantDto
     */
    'status'?: UserStatus;
    /**
     * 
     * @type {UserSettingsDto}
     * @memberof AdminUserTenantDto
     */
    'settings'?: UserSettingsDto;
    /**
     * 
     * @type {GeneralAvatarDto}
     * @memberof AdminUserTenantDto
     */
    'avatar'?: GeneralAvatarDto;
    /**
     * 
     * @type {Array<UserRoleDto>}
     * @memberof AdminUserTenantDto
     */
    'roles'?: Array<UserRoleDto>;
    /**
     * 
     * @type {UserSuspensionInfoDto}
     * @memberof AdminUserTenantDto
     */
    'suspension'?: UserSuspensionInfoDto;
    /**
     * 
     * @type {OnboardingRefDto}
     * @memberof AdminUserTenantDto
     */
    'onboarding'?: OnboardingRefDto;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserTenantDto
     */
    'isPersonalInfoComplete'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUserTenantDto
     */
    'roleIds'?: Array<string>;
}


/**
 * 
 * @export
 * @interface AdminUserUnsuspendDto
 */
export interface AdminUserUnsuspendDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUserUnsuspendDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserUnsuspendDto
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminVehicleBodyTypeDto
 */
export interface AdminVehicleBodyTypeDto {
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleBodyTypeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleBodyTypeDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehicleBodyTypeDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof AdminVehicleBodyTypeDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleBodyTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleBodyTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleBodyTypeDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleBodyTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleBodyTypeDto
     */
    'sortOrder'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleBodyTypeDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleBodyTypeDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleBodyTypeDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleBodyTypeDto
     */
    'updatedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface AdminVehicleBodyTypeGetPaginatedDto
 */
export interface AdminVehicleBodyTypeGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleBodyTypeGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleBodyTypeGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleBodyTypeGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleBodyTypeGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleBodyTypeGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleBodyTypeGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminVehicleBodyTypeGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminVehicleBodyTypeGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminVehicleBodyTypeGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehicleBodyTypeGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleBodyTypeGetPaginatedDto
     */
    'vehicleTypeId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleBodyTypeGetPaginatedDto
     */
    'isBuiltIn'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleBodyTypeGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface AdminVehicleFuelTypeDto
 */
export interface AdminVehicleFuelTypeDto {
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleFuelTypeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleFuelTypeDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehicleFuelTypeDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof AdminVehicleFuelTypeDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleFuelTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleFuelTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleFuelTypeDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleFuelTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleFuelTypeDto
     */
    'sortOrder'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleFuelTypeDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleFuelTypeDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleFuelTypeDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleFuelTypeDto
     */
    'updatedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface AdminVehicleFuelTypeGetPaginatedDto
 */
export interface AdminVehicleFuelTypeGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleFuelTypeGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleFuelTypeGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleFuelTypeGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleFuelTypeGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleFuelTypeGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleFuelTypeGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminVehicleFuelTypeGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminVehicleFuelTypeGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminVehicleFuelTypeGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehicleFuelTypeGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleFuelTypeGetPaginatedDto
     */
    'vehicleTypeId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleFuelTypeGetPaginatedDto
     */
    'isBuiltIn'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleFuelTypeGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface AdminVehicleGenerationDto
 */
export interface AdminVehicleGenerationDto {
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleGenerationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleGenerationDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleGenerationDto
     */
    'car2DbId'?: string | null;
    /**
     * 
     * @type {VehicleMakeReferenceDto}
     * @memberof AdminVehicleGenerationDto
     */
    'make'?: VehicleMakeReferenceDto;
    /**
     * 
     * @type {VehicleModelReferenceDto}
     * @memberof AdminVehicleGenerationDto
     */
    'model'?: VehicleModelReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleGenerationDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleGenerationDto
     */
    'startYear'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleGenerationDto
     */
    'endYear'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleGenerationDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleGenerationDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleGenerationDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehicleGenerationDto
     */
    'vehicleType'?: VehicleType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleGenerationDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleGenerationDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleGenerationDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleGenerationDto
     */
    'updatedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface AdminVehicleGenerationGetPaginatedDto
 */
export interface AdminVehicleGenerationGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'makeId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'makeIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'modelId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'modelIds'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'isBuiltIn'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleGenerationGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface AdminVehicleMakeDto
 */
export interface AdminVehicleMakeDto {
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleMakeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleMakeDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehicleMakeDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleMakeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleMakeDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleMakeDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleMakeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleMakeDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleMakeDto
     */
    'car2DbId'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleMakeDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleMakeDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleMakeDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleMakeDto
     */
    'updatedBy'?: string | null;
    /**
     * Whether to sync this entity with the source entity from Car2DB.  Sync stops when entity is updated manually.
     * @type {boolean}
     * @memberof AdminVehicleMakeDto
     */
    'isSyncWithCar2Db'?: boolean;
}


/**
 * 
 * @export
 * @interface AdminVehicleMakeGetPaginatedDto
 */
export interface AdminVehicleMakeGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleMakeGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleMakeGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleMakeGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleMakeGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleMakeGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleMakeGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminVehicleMakeGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminVehicleMakeGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminVehicleMakeGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehicleMakeGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof AdminVehicleMakeGetPaginatedDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleMakeGetPaginatedDto
     */
    'isBuiltIn'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleMakeGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface AdminVehicleModelDto
 */
export interface AdminVehicleModelDto {
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModelDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModelDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehicleModelDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModelDto
     */
    'name'?: string;
    /**
     * 
     * @type {VehicleSize}
     * @memberof AdminVehicleModelDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof AdminVehicleModelDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleModelDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {VehicleMakeReferenceDto}
     * @memberof AdminVehicleModelDto
     */
    'make'?: VehicleMakeReferenceDto;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleModelDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleModelDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModelDto
     */
    'car2DbId'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleModelDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleModelDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModelDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModelDto
     */
    'updatedBy'?: string | null;
    /**
     * Whether to sync this entity with the source entity from Car2DB.  Sync stops when entity is updated manually.
     * @type {boolean}
     * @memberof AdminVehicleModelDto
     */
    'isSyncWithCar2Db'?: boolean;
}


/**
 * 
 * @export
 * @interface AdminVehicleModelGetPaginatedDto
 */
export interface AdminVehicleModelGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'vehicleTypeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'makeId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'makeIds'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'isBuiltIn'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleModelGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface AdminVehicleModificationDto
 */
export interface AdminVehicleModificationDto {
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModificationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModificationDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleMakeReferenceDto}
     * @memberof AdminVehicleModificationDto
     */
    'make'?: VehicleMakeReferenceDto;
    /**
     * 
     * @type {VehicleModelReferenceDto}
     * @memberof AdminVehicleModificationDto
     */
    'model'?: VehicleModelReferenceDto;
    /**
     * 
     * @type {VehicleGenerationReferenceDto}
     * @memberof AdminVehicleModificationDto
     */
    'generation'?: VehicleGenerationReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModificationDto
     */
    'name'?: string;
    /**
     * 
     * @type {VehicleFuelTypeReferenceDto}
     * @memberof AdminVehicleModificationDto
     */
    'fuelType'?: VehicleFuelTypeReferenceDto;
    /**
     * 
     * @type {VehicleBodyTypeReferenceDto}
     * @memberof AdminVehicleModificationDto
     */
    'bodyType'?: VehicleBodyTypeReferenceDto;
    /**
     * 
     * @type {VehicleSize}
     * @memberof AdminVehicleModificationDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleModificationDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleModificationDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleModificationDto
     */
    'sortOrder'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleModificationDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleModificationDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModificationDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModificationDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehicleModificationDto
     */
    'vehicleType'?: VehicleType;
}


/**
 * 
 * @export
 * @interface AdminVehicleModificationGetPaginatedDto
 */
export interface AdminVehicleModificationGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'makeId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'makeIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'modelId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'modelIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'generationId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'generationIds'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'isBuiltIn'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleModificationGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface AdminVehiclePartTypeDto
 */
export interface AdminVehiclePartTypeDto {
    /**
     * 
     * @type {string}
     * @memberof AdminVehiclePartTypeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehiclePartTypeDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehiclePartTypeDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehiclePartCategory}
     * @memberof AdminVehiclePartTypeDto
     */
    'category'?: VehiclePartCategory;
    /**
     * 
     * @type {VehiclePartType}
     * @memberof AdminVehiclePartTypeDto
     */
    'type'?: VehiclePartType;
    /**
     * 
     * @type {Array<VehicleArea>}
     * @memberof AdminVehiclePartTypeDto
     */
    'areas'?: Array<VehicleArea>;
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof AdminVehiclePartTypeDto
     */
    'projections'?: Array<VehicleProjection>;
    /**
     * 
     * @type {AdminVehiclePartTypeDtoProjectionsPerArea}
     * @memberof AdminVehiclePartTypeDto
     */
    'projectionsPerArea'?: AdminVehiclePartTypeDtoProjectionsPerArea;
    /**
     * 
     * @type {string}
     * @memberof AdminVehiclePartTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehiclePartTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehiclePartTypeDto
     */
    'isCategoryRoot'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehiclePartTypeDto
     */
    'isTypeRoot'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehiclePartTypeDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehiclePartTypeDto
     */
    'isEnabledForDamageDetection'?: boolean;
    /**
     * 
     * @type {Array<DamageTypeCategory>}
     * @memberof AdminVehiclePartTypeDto
     */
    'damageCategories'?: Array<DamageTypeCategory> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehiclePartTypeDto
     */
    'damageTypeIds'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehiclePartTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminVehiclePartTypeDto
     */
    'sortOrder'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehiclePartTypeDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehiclePartTypeDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehiclePartTypeDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehiclePartTypeDto
     */
    'updatedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface AdminVehiclePartTypeDtoProjectionsPerArea
 */
export interface AdminVehiclePartTypeDtoProjectionsPerArea {
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof AdminVehiclePartTypeDtoProjectionsPerArea
     */
    'None'?: Array<VehicleProjection>;
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof AdminVehiclePartTypeDtoProjectionsPerArea
     */
    'Exterior'?: Array<VehicleProjection>;
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof AdminVehiclePartTypeDtoProjectionsPerArea
     */
    'Interior'?: Array<VehicleProjection>;
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof AdminVehiclePartTypeDtoProjectionsPerArea
     */
    'Internal'?: Array<VehicleProjection>;
}
/**
 * 
 * @export
 * @interface AdminVehiclePartTypeGetPaginatedDto
 */
export interface AdminVehiclePartTypeGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehiclePartCategory}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'category'?: VehiclePartCategory;
    /**
     * 
     * @type {VehiclePartType}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'type'?: VehiclePartType;
    /**
     * 
     * @type {Array<VehiclePartType>}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'types'?: Array<VehiclePartType> | null;
    /**
     * 
     * @type {VehiclePartDescriptor}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'descriptor'?: VehiclePartDescriptor;
    /**
     * 
     * @type {Array<VehiclePartDescriptor>}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'descriptors'?: Array<VehiclePartDescriptor> | null;
    /**
     * 
     * @type {VehicleArea}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'projections'?: Array<VehicleProjection> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'isCategoryRoot'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'isTypeRoot'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'isEnabledForDamageDetection'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'isBuiltIn'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehiclePartTypeGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface AdminVehicleTypeDto
 */
export interface AdminVehicleTypeDto {
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleTypeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleTypeDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehicleTypeDto
     */
    'type'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleTypeDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleTypeDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleTypeDto
     */
    'car2DbId'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleTypeDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleTypeDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleTypeDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleTypeDto
     */
    'updatedBy'?: string | null;
    /**
     * Whether to sync this entity with the source entity from Car2DB.  Sync stops when entity is updated manually.
     * @type {boolean}
     * @memberof AdminVehicleTypeDto
     */
    'isSyncWithCar2Db'?: boolean;
}


/**
 * 
 * @export
 * @interface AdminVehicleTypeGetPaginatedDto
 */
export interface AdminVehicleTypeGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleTypeGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleTypeGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleTypeGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleTypeGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleTypeGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleTypeGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminVehicleTypeGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminVehicleTypeGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminVehicleTypeGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof AdminVehicleTypeGetPaginatedDto
     */
    'type'?: VehicleType;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleTypeGetPaginatedDto
     */
    'isBuiltIn'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleTypeGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface AdminVehicleVisualModelDto
 */
export interface AdminVehicleVisualModelDto {
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleVisualModelDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleVisualModelDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleVisualModelDto
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleVisualModelDto
     */
    'versionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDto
     */
    'isLatestVersion'?: boolean;
    /**
     * 
     * @type {VehicleVisualModelType}
     * @memberof AdminVehicleVisualModelDto
     */
    'type'?: VehicleVisualModelType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof AdminVehicleVisualModelDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {Array<VehicleBodyType>}
     * @memberof AdminVehicleVisualModelDto
     */
    'bodyTypes'?: Array<VehicleBodyType> | null;
    /**
     * 
     * @type {Array<VehicleMakeReferenceDto>}
     * @memberof AdminVehicleVisualModelDto
     */
    'makes'?: Array<VehicleMakeReferenceDto> | null;
    /**
     * 
     * @type {Array<VehicleModelReferenceDto>}
     * @memberof AdminVehicleVisualModelDto
     */
    'models'?: Array<VehicleModelReferenceDto> | null;
    /**
     * 
     * @type {Array<VehicleGenerationReferenceDto>}
     * @memberof AdminVehicleVisualModelDto
     */
    'generations'?: Array<VehicleGenerationReferenceDto> | null;
    /**
     * 
     * @type {Array<VehicleModificationReferenceDto>}
     * @memberof AdminVehicleVisualModelDto
     */
    'modifications'?: Array<VehicleModificationReferenceDto> | null;
    /**
     * 
     * @type {Array<AdminVehicleVisualModelImageDto>}
     * @memberof AdminVehicleVisualModelDto
     */
    'images'?: Array<AdminVehicleVisualModelImageDto>;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleVisualModelDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleVisualModelDto
     */
    'sortOrder'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleVisualModelDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AdminVehicleVisualModelDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleVisualModelDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleVisualModelDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {AdminVehicleVisualModelDtoVehicleTypesMap}
     * @memberof AdminVehicleVisualModelDto
     */
    'vehicleTypesMap'?: AdminVehicleVisualModelDtoVehicleTypesMap;
    /**
     * 
     * @type {AdminVehicleVisualModelDtoBodyTypesMap}
     * @memberof AdminVehicleVisualModelDto
     */
    'bodyTypesMap'?: AdminVehicleVisualModelDtoBodyTypesMap;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof AdminVehicleVisualModelDto
     */
    'makeIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof AdminVehicleVisualModelDto
     */
    'modelIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof AdminVehicleVisualModelDto
     */
    'generationIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof AdminVehicleVisualModelDto
     */
    'modificationIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {Array<VehicleArea>}
     * @memberof AdminVehicleVisualModelDto
     */
    'areas'?: Array<VehicleArea>;
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof AdminVehicleVisualModelDto
     */
    'projections'?: Array<VehicleProjection>;
}


/**
 * 
 * @export
 * @interface AdminVehicleVisualModelDtoBodyTypesMap
 */
export interface AdminVehicleVisualModelDtoBodyTypesMap {
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'None'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'Sedan'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'Hatchback'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'Wagon'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'Van'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'Minivan'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'CUV'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'SUV'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'Coupe'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'Convertible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'Roadster'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'Pickup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'ChassisCab'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'PlatformCab'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'PassengerVan'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'DoubleChassisCab'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'DoubleCabPickUp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'Microcar'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'MiniMPV'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'Targa'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'Other'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoBodyTypesMap
     */
    'PlatforbCab'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminVehicleVisualModelDtoVehicleTypesMap
 */
export interface AdminVehicleVisualModelDtoVehicleTypesMap {
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoVehicleTypesMap
     */
    'None'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoVehicleTypesMap
     */
    'Car'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelDtoVehicleTypesMap
     */
    'Any'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminVehicleVisualModelGetPaginatedDto
 */
export interface AdminVehicleVisualModelGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleVisualModelType}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'type'?: VehicleVisualModelType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {Array<VehicleBodyType>}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'bodyTypes'?: Array<VehicleBodyType> | null;
    /**
     * 
     * @type {Array<VehicleArea>}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'areas'?: Array<VehicleArea> | null;
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'projections'?: Array<VehicleProjection> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'isBuiltIn'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVehicleVisualModelGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface AdminVehicleVisualModelImageDto
 */
export interface AdminVehicleVisualModelImageDto {
    /**
     * 
     * @type {string}
     * @memberof AdminVehicleVisualModelImageDto
     */
    'id'?: string;
    /**
     * 
     * @type {VehicleArea}
     * @memberof AdminVehicleVisualModelImageDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof AdminVehicleVisualModelImageDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {FileReferenceDto}
     * @memberof AdminVehicleVisualModelImageDto
     */
    'file'?: FileReferenceDto;
}


/**
 * 
 * @export
 * @interface AdminWebPushChannelInfoDto
 */
export interface AdminWebPushChannelInfoDto {
    /**
     * 
     * @type {Array<AdminSendToUserDto>}
     * @memberof AdminWebPushChannelInfoDto
     */
    'users'?: Array<AdminSendToUserDto>;
    /**
     * 
     * @type {string}
     * @memberof AdminWebPushChannelInfoDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminWebPushChannelInfoDto
     */
    'body'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminWebPushChannelInfoDto
     */
    'imageUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface AgreeOrDisagreeWithNegotiationProposalResponseDto
 */
export interface AgreeOrDisagreeWithNegotiationProposalResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AgreeOrDisagreeWithNegotiationProposalResponseDto
     */
    'proposalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgreeOrDisagreeWithNegotiationProposalResponseDto
     */
    'responseId'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AllocationStatus = {
    None: 'None',
    NotAllocated: 'NotAllocated',
    Allocating: 'Allocating',
    Allocated: 'Allocated'
} as const;

export type AllocationStatus = typeof AllocationStatus[keyof typeof AllocationStatus];


/**
 * 
 * @export
 * @interface AmazonSesEmailSettingsDto
 */
export interface AmazonSesEmailSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof AmazonSesEmailSettingsDto
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof AmazonSesEmailSettingsDto
     */
    'region'?: string;
    /**
     * 
     * @type {UserSecretReferenceDto}
     * @memberof AmazonSesEmailSettingsDto
     */
    'accessKeyId'?: UserSecretReferenceDto;
    /**
     * 
     * @type {UserSecretReferenceDto}
     * @memberof AmazonSesEmailSettingsDto
     */
    'secretAccessKey'?: UserSecretReferenceDto;
}
/**
 * 
 * @export
 * @interface AmazonSesEmailSettingsInputDto
 */
export interface AmazonSesEmailSettingsInputDto {
    /**
     * 
     * @type {string}
     * @memberof AmazonSesEmailSettingsInputDto
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof AmazonSesEmailSettingsInputDto
     */
    'region'?: string;
    /**
     * 
     * @type {UserSecretInputDto}
     * @memberof AmazonSesEmailSettingsInputDto
     */
    'accessKeyId'?: UserSecretInputDto;
    /**
     * 
     * @type {UserSecretInputDto}
     * @memberof AmazonSesEmailSettingsInputDto
     */
    'secretAccessKey'?: UserSecretInputDto;
}
/**
 * Describes paid parts of the system that user can access
 * @export
 * @enum {string}
 */

export const AppModule = {
    None: 'None',
    TestFeature1: 'TestFeature1',
    TestFeature2: 'TestFeature2',
    TestPremiumFeature: 'TestPremiumFeature'
} as const;

export type AppModule = typeof AppModule[keyof typeof AppModule];


/**
 * 
 * @export
 * @enum {string}
 */

export const AppPermission = {
    None: 'None',
    AdminAppAccess: 'AdminAppAccess',
    FleetAppAccess: 'FleetAppAccess',
    FleetCustomerAppAccess: 'FleetCustomerAppAccess',
    AdminUserManage: 'AdminUserManage',
    AdminTenantManage: 'AdminTenantManage',
    AdminSubscriptionPlanManage: 'AdminSubscriptionPlanManage',
    AdminSubscriptionManage: 'AdminSubscriptionManage',
    AdminInvoiceManage: 'AdminInvoiceManage',
    AdminNotificationsManage: 'AdminNotificationsManage',
    AdminReferenceDataRead: 'AdminReferenceDataRead',
    AdminReferenceDataManage: 'AdminReferenceDataManage',
    AdminInviteRead: 'AdminInviteRead',
    AdminInviteManage: 'AdminInviteManage',
    AdminDomainEventsManage: 'AdminDomainEventsManage',
    AdminFileManage: 'AdminFileManage',
    AdminGuidanceRead: 'AdminGuidanceRead',
    AdminGuidanceManage: 'AdminGuidanceManage',
    GlobalRoleRead: 'GlobalRoleRead',
    GlobalRoleManage: 'GlobalRoleManage',
    GlobalRoleAssignmentManage: 'GlobalRoleAssignmentManage',
    RoleAssignmentManage: 'RoleAssignmentManage',
    TenantRoleRead: 'TenantRoleRead',
    TenantRoleManage: 'TenantRoleManage',
    AssignmentPerform: 'AssignmentPerform',
    TenantRead: 'TenantRead',
    TenantManage: 'TenantManage',
    TenantSubscriptionRead: 'TenantSubscriptionRead',
    TenantSubscriptionManage: 'TenantSubscriptionManage',
    TenantConnectionRead: 'TenantConnectionRead',
    TenantConnectionManage: 'TenantConnectionManage',
    TenantRequestRead: 'TenantRequestRead',
    TenantRequestManage: 'TenantRequestManage',
    DataGrantRead: 'DataGrantRead',
    DataGrantManage: 'DataGrantManage',
    ImportRead: 'ImportRead',
    ImportManage: 'ImportManage',
    ExportManage: 'ExportManage',
    InvoiceRead: 'InvoiceRead',
    TenantUserRead: 'TenantUserRead',
    TenantUserManage: 'TenantUserManage',
    TenantInviteRead: 'TenantInviteRead',
    TenantInviteManage: 'TenantInviteManage',
    DepartmentRead: 'DepartmentRead',
    DepartmentManage: 'DepartmentManage',
    LocationRead: 'LocationRead',
    LocationManage: 'LocationManage',
    SpotRead: 'SpotRead',
    SpotManage: 'SpotManage',
    ProductLocationRead: 'ProductLocationRead',
    ProductLocationManage: 'ProductLocationManage',
    AssetSubscriptionPlanRead: 'AssetSubscriptionPlanRead',
    AssetSubscriptionPlanManage: 'AssetSubscriptionPlanManage',
    AssetSubscriptionRead: 'AssetSubscriptionRead',
    AssetSubscriptionManage: 'AssetSubscriptionManage',
    CustomerRead: 'CustomerRead',
    CustomerManage: 'CustomerManage',
    ContractRead: 'ContractRead',
    ContractManage: 'ContractManage',
    VisualInspectionPerform: 'VisualInspectionPerform',
    VisualInspectionRead: 'VisualInspectionRead',
    VisualInspectionManage: 'VisualInspectionManage',
    DamageDetectionPerform: 'DamageDetectionPerform',
    DamageDetectionRead: 'DamageDetectionRead',
    DamageDetectionManage: 'DamageDetectionManage',
    DamageCostEvaluationPerform: 'DamageCostEvaluationPerform',
    DamageCostEvaluationRead: 'DamageCostEvaluationRead',
    DamageCostEvaluationManage: 'DamageCostEvaluationManage',
    AccessoryRead: 'AccessoryRead',
    AccessoryManage: 'AccessoryManage',
    VehicleRead: 'VehicleRead',
    VehicleManage: 'VehicleManage',
    VehicleDamageRead: 'VehicleDamageRead',
    VehicleDamageManage: 'VehicleDamageManage',
    VehicleDamageVerify: 'VehicleDamageVerify',
    AssessmentFlowRead: 'AssessmentFlowRead',
    AssessmentFlowManage: 'AssessmentFlowManage',
    AccessoryCheckPerform: 'AccessoryCheckPerform',
    AccessoryCheckRead: 'AccessoryCheckRead',
    AccessoryCheckManage: 'AccessoryCheckManage',
    RepairOperationPerform: 'RepairOperationPerform',
    RepairOperationRead: 'RepairOperationRead',
    RepairOperationManage: 'RepairOperationManage',
    DocumentRead: 'DocumentRead',
    DocumentManage: 'DocumentManage',
    RepairCatalogRead: 'RepairCatalogRead',
    RepairCatalogManage: 'RepairCatalogManage',
    PoolRead: 'PoolRead',
    PoolManage: 'PoolManage',
    AssetRead: 'AssetRead',
    AssetManage: 'AssetManage',
    CustomTagRead: 'CustomTagRead',
    CustomTagManage: 'CustomTagManage',
    WebhookRead: 'WebhookRead',
    WebhookManage: 'WebhookManage',
    GeneralHistoryRead: 'GeneralHistoryRead',
    GeneralHistoryManage: 'GeneralHistoryManage',
    WashPerform: 'WashPerform',
    WashRead: 'WashRead',
    WashManage: 'WashManage',
    GeneralStatusHistoryRead: 'GeneralStatusHistoryRead',
    SupplierRead: 'SupplierRead',
    SupplierManage: 'SupplierManage',
    MaintenancePerform: 'MaintenancePerform',
    MaintenanceRead: 'MaintenanceRead',
    MaintenanceManage: 'MaintenanceManage',
    WheelOperationPerform: 'WheelOperationPerform',
    WheelOperationRead: 'WheelOperationRead',
    WheelOperationManage: 'WheelOperationManage',
    DashboardRead: 'DashboardRead',
    AssignmentRead: 'AssignmentRead',
    AssignmentManage: 'AssignmentManage',
    ChargeRead: 'ChargeRead',
    ChargeManage: 'ChargeManage',
    ChatRead: 'ChatRead',
    ChatManage: 'ChatManage',
    NegotiationRead: 'NegotiationRead',
    NegotiationManage: 'NegotiationManage',
    IntegrationApiClientRead: 'IntegrationApiClientRead',
    IntegrationApiClientManage: 'IntegrationApiClientManage',
    TeslaConnectionRead: 'TeslaConnectionRead',
    TeslaConnectionManage: 'TeslaConnectionManage',
    FlowRead: 'FlowRead',
    FlowManage: 'FlowManage',
    TestRead: 'TestRead',
    TestManage: 'TestManage',
    TestFeature1Access: 'TestFeature1Access',
    TestFeature2Access: 'TestFeature2Access',
    TestPremiumFeatureAccess: 'TestPremiumFeatureAccess'
} as const;

export type AppPermission = typeof AppPermission[keyof typeof AppPermission];


/**
 * 
 * @export
 * @interface ApplyMappingToImportDto
 */
export interface ApplyMappingToImportDto {
    /**
     * 
     * @type {string}
     * @memberof ApplyMappingToImportDto
     */
    'importId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyMappingToImportDto
     */
    'templateId'?: string;
}
/**
 * Application status - defines whether operation result or any other result is applied.
 * @export
 * @enum {string}
 */

export const ApplyStatus = {
    None: 'None',
    NotApplied: 'NotApplied',
    Applied: 'Applied'
} as const;

export type ApplyStatus = typeof ApplyStatus[keyof typeof ApplyStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const ApprovalResponseType = {
    None: 'None',
    Approve: 'Approve',
    Decline: 'Decline',
    ForceApprove: 'ForceApprove',
    ForceDecline: 'ForceDecline'
} as const;

export type ApprovalResponseType = typeof ApprovalResponseType[keyof typeof ApprovalResponseType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ApprovalStatus = {
    None: 'None',
    Approved: 'Approved',
    Declined: 'Declined',
    ForceApproved: 'ForceApproved',
    ForceDeclined: 'ForceDeclined'
} as const;

export type ApprovalStatus = typeof ApprovalStatus[keyof typeof ApprovalStatus];


/**
 * 
 * @export
 * @interface ArbitraryTestSwaggerClass
 */
export interface ArbitraryTestSwaggerClass {
    /**
     * 
     * @type {number}
     * @memberof ArbitraryTestSwaggerClass
     */
    'int'?: number;
    /**
     * 
     * @type {number}
     * @memberof ArbitraryTestSwaggerClass
     */
    'intNullable'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArbitraryTestSwaggerClass
     */
    'bool'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ArbitraryTestSwaggerClass
     */
    'boolNullable'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ArbitraryTestSwaggerClass
     */
    'string'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArbitraryTestSwaggerClass
     */
    'stringNullable'?: string | null;
    /**
     * 
     * @type {TestSwaggerEnum}
     * @memberof ArbitraryTestSwaggerClass
     */
    'enum'?: TestSwaggerEnum;
    /**
     * 
     * @type {TestSwaggerEnum}
     * @memberof ArbitraryTestSwaggerClass
     */
    'enumNullable'?: TestSwaggerEnum;
    /**
     * 
     * @type {TestSwaggerStruct}
     * @memberof ArbitraryTestSwaggerClass
     */
    'struct'?: TestSwaggerStruct;
    /**
     * 
     * @type {TestSwaggerStruct}
     * @memberof ArbitraryTestSwaggerClass
     */
    'structNullable'?: TestSwaggerStruct;
    /**
     * Deprecated: It\'s obsolete.
     * @type {number}
     * @memberof ArbitraryTestSwaggerClass
     * @deprecated
     */
    'obsoleteProp'?: number;
    /**
     * 
     * @type {number}
     * @memberof ArbitraryTestSwaggerClass
     */
    'notObsoleteProp'?: number;
}


/**
 * 
 * @export
 * @interface AssessmentFlowBriefDto
 */
export interface AssessmentFlowBriefDto {
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowBriefDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowBriefDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentFlowBriefDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentFlowBriefDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowBriefDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowBriefDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof AssessmentFlowBriefDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof AssessmentFlowBriefDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {CustomerReferenceDto}
     * @memberof AssessmentFlowBriefDto
     */
    'customer'?: CustomerReferenceDto;
    /**
     * 
     * @type {AssessmentFlowStateDto}
     * @memberof AssessmentFlowBriefDto
     */
    'state'?: AssessmentFlowStateDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof AssessmentFlowBriefDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof AssessmentFlowBriefDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowBriefDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentFlowBriefDto
     */
    'damageNegotiationIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentFlowBriefDto
     */
    'damageCostNegotiationIds'?: Array<string>;
    /**
     * 
     * @type {Array<NegotiationReferenceDto>}
     * @memberof AssessmentFlowBriefDto
     */
    'negotiationRefs'?: Array<NegotiationReferenceDto>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssessmentFlowBriefDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssessmentFlowBriefDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowBriefDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowBriefDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof AssessmentFlowBriefDto
     */
    'damageNegotiationIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof AssessmentFlowBriefDto
     */
    'damageCostNegotiationIdsMap'?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface AssessmentFlowChangedDto
 */
export interface AssessmentFlowChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentFlowChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof AssessmentFlowChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof AssessmentFlowChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {AssessmentFlowDto}
     * @memberof AssessmentFlowChangedDto
     */
    'entity': AssessmentFlowDto;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface AssessmentFlowCountersDto
 */
export interface AssessmentFlowCountersDto {
    /**
     * 
     * @type {number}
     * @memberof AssessmentFlowCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {AssessmentFlowCountersDtoCountByFilterTypeMap}
     * @memberof AssessmentFlowCountersDto
     */
    'countByFilterTypeMap': AssessmentFlowCountersDtoCountByFilterTypeMap;
}
/**
 * 
 * @export
 * @interface AssessmentFlowCountersDtoCountByFilterTypeMap
 */
export interface AssessmentFlowCountersDtoCountByFilterTypeMap {
    /**
     * 
     * @type {number}
     * @memberof AssessmentFlowCountersDtoCountByFilterTypeMap
     */
    'None'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssessmentFlowCountersDtoCountByFilterTypeMap
     */
    'All'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssessmentFlowCountersDtoCountByFilterTypeMap
     */
    'Pending'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssessmentFlowCountersDtoCountByFilterTypeMap
     */
    'ActionRequired'?: number;
}
/**
 * 
 * @export
 * @interface AssessmentFlowDto
 */
export interface AssessmentFlowDto {
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentFlowDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentFlowDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof AssessmentFlowDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof AssessmentFlowDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {AssignmentReferenceDto}
     * @memberof AssessmentFlowDto
     */
    'assignment'?: AssignmentReferenceDto;
    /**
     * 
     * @type {CustomerReferenceDto}
     * @memberof AssessmentFlowDto
     */
    'customer'?: CustomerReferenceDto;
    /**
     * 
     * @type {AssessmentFlowStateDto}
     * @memberof AssessmentFlowDto
     */
    'state'?: AssessmentFlowStateDto;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof AssessmentFlowDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof AssessmentFlowDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowDto
     */
    'damageDetectionAggregateId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowDto
     */
    'damageCostEvaluationAggregateId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentFlowDto
     */
    'accessoryCheckIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentFlowDto
     */
    'damageNegotiationIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentFlowDto
     */
    'damageCostNegotiationIds'?: Array<string>;
    /**
     * 
     * @type {Array<NegotiationReferenceDto>}
     * @memberof AssessmentFlowDto
     */
    'negotiationRefs'?: Array<NegotiationReferenceDto>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssessmentFlowDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssessmentFlowDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof AssessmentFlowDto
     */
    'damageNegotiationIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof AssessmentFlowDto
     */
    'damageCostNegotiationIdsMap'?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface AssessmentFlowGetCountersDto
 */
export interface AssessmentFlowGetCountersDto {
    /**
     * 
     * @type {DateRangeInputDto}
     * @memberof AssessmentFlowGetCountersDto
     */
    'range'?: DateRangeInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentFlowGetCountersDto
     */
    'isEmptyDamagesAndCosts'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AssessmentFlowGetPaginatedDto
 */
export interface AssessmentFlowGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'assignmentId'?: string | null;
    /**
     * 
     * @type {ContractAssessmentFlowStateFilterType}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'filterType'?: ContractAssessmentFlowStateFilterType;
    /**
     * 
     * @type {Array<ContractAssessmentFlowStateFilterType>}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'filterTypes'?: Array<ContractAssessmentFlowStateFilterType> | null;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentFlowGetPaginatedDto
     */
    'isEmptyDamagesAndCosts'?: boolean | null;
}


/**
 * 
 * @export
 * @interface AssessmentFlowReferenceDto
 */
export interface AssessmentFlowReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowReferenceDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowReferenceDto
     */
    'contractId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowReferenceDto
     */
    'customerId'?: string;
}
/**
 * 
 * @export
 * @interface AssessmentFlowStateDto
 */
export interface AssessmentFlowStateDto {
    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowStateDto
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentFlowStateDto
     */
    'isProcessingDamages'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentFlowStateDto
     */
    'isProcessingDamageCosts'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentFlowStateDto
     */
    'isDamageCostEvaluating'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentFlowStateDto
     */
    'isDamageCostEvaluated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentFlowStateDto
     */
    'isEmptyDamagesAndCosts'?: boolean | null;
    /**
     * 
     * @type {DamageDetectionStatusInContract}
     * @memberof AssessmentFlowStateDto
     */
    'damageDetectionStatus'?: DamageDetectionStatusInContract;
    /**
     * 
     * @type {DamageCostEvaluationStatusInContract}
     * @memberof AssessmentFlowStateDto
     */
    'damageCostEvaluationStatus'?: DamageCostEvaluationStatusInContract;
    /**
     * 
     * @type {ContractAssessmentFlowStateFilterType}
     * @memberof AssessmentFlowStateDto
     */
    'filterState'?: ContractAssessmentFlowStateFilterType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssessmentFlowStateDto
     */
    'lastActivityAt'?: string;
}


/**
 * 
 * @export
 * @interface AssetCandidateEntityDto
 */
export interface AssetCandidateEntityDto {
    /**
     * 
     * @type {AssetEntityType}
     * @memberof AssetCandidateEntityDto
     */
    'entityType'?: AssetEntityType;
    /**
     * 
     * @type {VehicleDto}
     * @memberof AssetCandidateEntityDto
     */
    'vehicle'?: VehicleDto;
    /**
     * 
     * @type {AccessoryDto}
     * @memberof AssetCandidateEntityDto
     */
    'accessory'?: AccessoryDto;
    /**
     * 
     * @type {string}
     * @memberof AssetCandidateEntityDto
     */
    'entityId'?: string;
}


/**
 * 
 * @export
 * @interface AssetCandidateEntityInputDto
 */
export interface AssetCandidateEntityInputDto {
    /**
     * 
     * @type {AssetEntityType}
     * @memberof AssetCandidateEntityInputDto
     */
    'entityType'?: AssetEntityType;
    /**
     * 
     * @type {string}
     * @memberof AssetCandidateEntityInputDto
     */
    'entityId'?: string;
}


/**
 * 
 * @export
 * @interface AssetChangedDto
 */
export interface AssetChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AssetChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof AssetChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof AssetChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof AssetChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {AssetDto}
     * @memberof AssetChangedDto
     */
    'entity': AssetDto;
    /**
     * 
     * @type {string}
     * @memberof AssetChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface AssetCreateDto
 */
export interface AssetCreateDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetCreateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetCreateDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {AssetCandidateEntityInputDto}
     * @memberof AssetCreateDto
     */
    'entity'?: AssetCandidateEntityInputDto;
    /**
     * 
     * @type {string}
     * @memberof AssetCreateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetCreateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {AssetSpecInputDto}
     * @memberof AssetCreateDto
     */
    'spec'?: AssetSpecInputDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetCreateDto
     */
    'accessoryIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof AssetCreateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {AssetSettingsInputDto}
     * @memberof AssetCreateDto
     */
    'settings'?: AssetSettingsInputDto;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof AssetCreateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}
/**
 * 
 * @export
 * @interface AssetDto
 */
export interface AssetDto {
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof AssetDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'ownerTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {AssetEntityType}
     * @memberof AssetDto
     */
    'entityType'?: AssetEntityType;
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof AssetDto
     */
    'entity'?: GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {AssetSpecDto}
     * @memberof AssetDto
     */
    'spec'?: AssetSpecDto;
    /**
     * 
     * @type {Array<AccessoryReferenceDto>}
     * @memberof AssetDto
     */
    'accessories'?: Array<AccessoryReferenceDto> | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof AssetDto
     */
    'attachments'?: Array<GeneralAttachmentDto> | null;
    /**
     * 
     * @type {AssetSettingsDto}
     * @memberof AssetDto
     */
    'settings'?: AssetSettingsDto;
    /**
     * 
     * @type {PoolsMetaDto}
     * @memberof AssetDto
     */
    'poolsMeta'?: PoolsMetaDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof AssetDto
     */
    'tags'?: GeneralAttachedTagsDto;
}


/**
 * Must contain only values from EntityType.
 * @export
 * @enum {string}
 */

export const AssetEntityType = {
    None: 'None',
    Vehicle: 'Vehicle',
    Accessory: 'Accessory'
} as const;

export type AssetEntityType = typeof AssetEntityType[keyof typeof AssetEntityType];


/**
 * 
 * @export
 * @interface AssetFullReferenceDto
 */
export interface AssetFullReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof AssetFullReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetFullReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFullReferenceDto
     */
    'ownerTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFullReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetFullReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {AssetEntityType}
     * @memberof AssetFullReferenceDto
     */
    'entityType'?: AssetEntityType;
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof AssetFullReferenceDto
     */
    'entity'?: GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {string}
     * @memberof AssetFullReferenceDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFullReferenceDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {AssetSpecDto}
     * @memberof AssetFullReferenceDto
     */
    'spec'?: AssetSpecDto;
    /**
     * 
     * @type {Array<AccessoryReferenceDto>}
     * @memberof AssetFullReferenceDto
     */
    'accessories'?: Array<AccessoryReferenceDto> | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof AssetFullReferenceDto
     */
    'attachments'?: Array<GeneralAttachmentDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetFullReferenceDto
     */
    'poolIds'?: Array<string>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetFullReferenceDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetFullReferenceDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetFullReferenceDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetFullReferenceDto
     */
    'updatedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface AssetGetPaginatedDto
 */
export interface AssetGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AssetGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AssetGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AssetGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AssetGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {AssetEntityType}
     * @memberof AssetGetPaginatedDto
     */
    'assetEntityType'?: AssetEntityType;
    /**
     * 
     * @type {PoolsMetaQueryDto}
     * @memberof AssetGetPaginatedDto
     */
    'poolsMeta'?: PoolsMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof AssetGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * 
 * @export
 * @interface AssetMetaDto
 */
export interface AssetMetaDto {
    /**
     * 
     * @type {string}
     * @memberof AssetMetaDto
     */
    'assetId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetMetaDto
     */
    'hasAsset'?: boolean;
}
/**
 * 
 * @export
 * @interface AssetMetaQueryDto
 */
export interface AssetMetaQueryDto {
    /**
     * 
     * @type {string}
     * @memberof AssetMetaQueryDto
     */
    'assetId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetMetaQueryDto
     */
    'hasAsset'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AssetReferenceDto
 */
export interface AssetReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof AssetReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {AssetEntityType}
     * @memberof AssetReferenceDto
     */
    'entityType'?: AssetEntityType;
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof AssetReferenceDto
     */
    'entity'?: GeneralStrictEntityRelationDto;
}


/**
 * 
 * @export
 * @interface AssetSearchPaginatedDto
 */
export interface AssetSearchPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AssetSearchPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetSearchPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetSearchPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSearchPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSearchPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSearchPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AssetSearchPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AssetSearchPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AssetSearchPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {AssetEntityType}
     * @memberof AssetSearchPaginatedDto
     */
    'assetEntityType'?: AssetEntityType;
    /**
     * 
     * @type {PoolsMetaQueryDto}
     * @memberof AssetSearchPaginatedDto
     */
    'poolsMeta'?: PoolsMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof AssetSearchPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * 
 * @export
 * @interface AssetSettingsDto
 */
export interface AssetSettingsDto {
    /**
     * Whether asset spec should be synced with the source entity spec when it updates.
     * @type {boolean}
     * @memberof AssetSettingsDto
     */
    'isSyncSpec'?: boolean;
}
/**
 * 
 * @export
 * @interface AssetSettingsInputDto
 */
export interface AssetSettingsInputDto {
    /**
     * Whether asset spec should be synced with the source entity spec when it updates.
     * @type {boolean}
     * @memberof AssetSettingsInputDto
     */
    'isSyncSpec'?: boolean;
}
/**
 * 
 * @export
 * @interface AssetSpecDto
 */
export interface AssetSpecDto {
    /**
     * 
     * @type {string}
     * @memberof AssetSpecDto
     */
    'id'?: string;
    /**
     * 
     * @type {AssetEntityType}
     * @memberof AssetSpecDto
     */
    'entityType'?: AssetEntityType;
    /**
     * 
     * @type {VehicleSpecDto}
     * @memberof AssetSpecDto
     */
    'vehicle'?: VehicleSpecDto;
}


/**
 * 
 * @export
 * @interface AssetSpecInputDto
 */
export interface AssetSpecInputDto {
    /**
     * 
     * @type {string}
     * @memberof AssetSpecInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {AssetEntityType}
     * @memberof AssetSpecInputDto
     */
    'entityType'?: AssetEntityType;
    /**
     * 
     * @type {VehicleSpecInputDto}
     * @memberof AssetSpecInputDto
     */
    'vehicle'?: VehicleSpecInputDto;
}


/**
 * 
 * @export
 * @interface AssetSpecQueryDto
 */
export interface AssetSpecQueryDto {
    /**
     * 
     * @type {AssetEntityType}
     * @memberof AssetSpecQueryDto
     */
    'entityType'?: AssetEntityType;
    /**
     * 
     * @type {VehicleSpecQueryDto}
     * @memberof AssetSpecQueryDto
     */
    'vehicle'?: VehicleSpecQueryDto;
}


/**
 * 
 * @export
 * @interface AssetSubscriptionChangedDto
 */
export interface AssetSubscriptionChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof AssetSubscriptionChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof AssetSubscriptionChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {AssetSubscriptionDto}
     * @memberof AssetSubscriptionChangedDto
     */
    'entity': AssetSubscriptionDto;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface AssetSubscriptionCountersDto
 */
export interface AssetSubscriptionCountersDto {
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {AssetSubscriptionCountersDtoCountByStatusMap}
     * @memberof AssetSubscriptionCountersDto
     */
    'countByStatusMap': AssetSubscriptionCountersDtoCountByStatusMap;
    /**
     * 
     * @type {AssetSubscriptionCountersDtoCountByAllocationStatusMap}
     * @memberof AssetSubscriptionCountersDto
     */
    'countByAllocationStatusMap': AssetSubscriptionCountersDtoCountByAllocationStatusMap;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionCountersDtoCountByAllocationStatusMap
 */
export interface AssetSubscriptionCountersDtoCountByAllocationStatusMap {
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionCountersDtoCountByAllocationStatusMap
     */
    'None'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionCountersDtoCountByAllocationStatusMap
     */
    'NotAllocated'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionCountersDtoCountByAllocationStatusMap
     */
    'Allocating'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionCountersDtoCountByAllocationStatusMap
     */
    'Allocated'?: number;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionCountersDtoCountByStatusMap
 */
export interface AssetSubscriptionCountersDtoCountByStatusMap {
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionCountersDtoCountByStatusMap
     */
    'None'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionCountersDtoCountByStatusMap
     */
    'Draft'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionCountersDtoCountByStatusMap
     */
    'Pending'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionCountersDtoCountByStatusMap
     */
    'Unpaid'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionCountersDtoCountByStatusMap
     */
    'Active'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionCountersDtoCountByStatusMap
     */
    'PastDue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionCountersDtoCountByStatusMap
     */
    'Ended'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionCountersDtoCountByStatusMap
     */
    'Paused'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionCountersDtoCountByStatusMap
     */
    'Canceled'?: number;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionCreateDto
 */
export interface AssetSubscriptionCreateDto {
    /**
     * Number of external contract, agreement, etc.
     * @type {string}
     * @memberof AssetSubscriptionCreateDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionCreateDto
     */
    'customerId'?: string;
    /**
     * 
     * @type {AssetSubscriptionPlanInputDto}
     * @memberof AssetSubscriptionCreateDto
     */
    'plan'?: AssetSubscriptionPlanInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionCreateDto
     */
    'isConfirmAssetAllocation'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionCreateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionCreateDto
     */
    'locationIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionDto
 */
export interface AssetSubscriptionDto {
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof AssetSubscriptionDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {CustomerReferenceDto}
     * @memberof AssetSubscriptionDto
     */
    'customer'?: CustomerReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof AssetSubscriptionDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {AssetSubscriptionPlanReferenceDto}
     * @memberof AssetSubscriptionDto
     */
    'plan'?: AssetSubscriptionPlanReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'productLocationId'?: string | null;
    /**
     * 
     * @type {AssetSubscriptionSpotInfoDto}
     * @memberof AssetSubscriptionDto
     */
    'checkOutSpotInfo'?: AssetSubscriptionSpotInfoDto;
    /**
     * 
     * @type {AssetSubscriptionSpotInfoDto}
     * @memberof AssetSubscriptionDto
     */
    'checkInSpotInfo'?: AssetSubscriptionSpotInfoDto;
    /**
     * 
     * @type {SubscriptionAssetDto}
     * @memberof AssetSubscriptionDto
     */
    'asset'?: SubscriptionAssetDto;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof AssetSubscriptionDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {SubscriptionPlanPriceDto}
     * @memberof AssetSubscriptionDto
     */
    'basePrice'?: SubscriptionPlanPriceDto;
    /**
     * 
     * @type {SubscriptionPlanPriceDto}
     * @memberof AssetSubscriptionDto
     */
    'price'?: SubscriptionPlanPriceDto;
    /**
     * 
     * @type {SubscriptionPlanDurationDto}
     * @memberof AssetSubscriptionDto
     */
    'duration'?: SubscriptionPlanDurationDto;
    /**
     * 
     * @type {Array<SubscriptionPlanExtraOptionDto>}
     * @memberof AssetSubscriptionDto
     */
    'extraOptions'?: Array<SubscriptionPlanExtraOptionDto> | null;
    /**
     * 
     * @type {SubscriptionStatus}
     * @memberof AssetSubscriptionDto
     */
    'status'?: SubscriptionStatus;
    /**
     * 
     * @type {SubscriptionStatus}
     * @memberof AssetSubscriptionDto
     */
    'prevStatus'?: SubscriptionStatus;
    /**
     * 
     * @type {AllocationStatus}
     * @memberof AssetSubscriptionDto
     */
    'allocationStatus'?: AllocationStatus;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'startsAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'endsAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'draftAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'pendingAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'unpaidAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'activeAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'pastDueAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'endedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'pausedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionDto
     */
    'canceledAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionDto
     */
    'canReallocate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionDto
     */
    'mustConfirmAllocation'?: boolean;
}


/**
 * 
 * @export
 * @interface AssetSubscriptionGetCountersDto
 */
export interface AssetSubscriptionGetCountersDto {
    /**
     * 
     * @type {DateRangeInputDto}
     * @memberof AssetSubscriptionGetCountersDto
     */
    'range'?: DateRangeInputDto;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionGetPaginatedDto
 */
export interface AssetSubscriptionGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'planId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'assetId'?: string | null;
    /**
     * 
     * @type {ContractProductsSubscriptionsStateFilterType}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'filterType'?: ContractProductsSubscriptionsStateFilterType;
    /**
     * 
     * @type {AssetEntityType}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'assetEntityType'?: AssetEntityType;
    /**
     * 
     * @type {Array<AssetEntityType>}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'assetEntityTypes'?: Array<AssetEntityType> | null;
    /**
     * 
     * @type {SubscriptionStatus}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'status'?: SubscriptionStatus;
    /**
     * 
     * @type {Array<SubscriptionStatus>}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'statuses'?: Array<SubscriptionStatus> | null;
    /**
     * 
     * @type {AllocationStatus}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'allocationStatus'?: AllocationStatus;
    /**
     * 
     * @type {Array<AllocationStatus>}
     * @memberof AssetSubscriptionGetPaginatedDto
     */
    'allocationStatuses'?: Array<AllocationStatus> | null;
}


/**
 * 
 * @export
 * @interface AssetSubscriptionPlanAvailabilityDto
 */
export interface AssetSubscriptionPlanAvailabilityDto {
    /**
     * 
     * @type {ProductLocationDto}
     * @memberof AssetSubscriptionPlanAvailabilityDto
     */
    'productLocation'?: ProductLocationDto;
    /**
     * Availability separately for each of requested pool.
     * @type {Array<PoolAvailabilityDto>}
     * @memberof AssetSubscriptionPlanAvailabilityDto
     */
    'perPool': Array<PoolAvailabilityDto>;
    /**
     * Total count of all items.
     * @type {number}
     * @memberof AssetSubscriptionPlanAvailabilityDto
     */
    'totalCount'?: number;
    /**
     * Count of items satisfying the request.
     * @type {number}
     * @memberof AssetSubscriptionPlanAvailabilityDto
     */
    'requestedCount'?: number;
    /**
     * Count of all other items except those satisfying the request.
     * @type {number}
     * @memberof AssetSubscriptionPlanAvailabilityDto
     */
    'otherCount'?: number;
    /**
     * Try if there is at least available item satisfying the request.
     * @type {boolean}
     * @memberof AssetSubscriptionPlanAvailabilityDto
     */
    'isAnyAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionPlanChangedDto
 */
export interface AssetSubscriptionPlanChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionPlanChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof AssetSubscriptionPlanChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof AssetSubscriptionPlanChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {AssetSubscriptionPlanDto}
     * @memberof AssetSubscriptionPlanChangedDto
     */
    'entity': AssetSubscriptionPlanDto;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface AssetSubscriptionPlanCreateDto
 */
export interface AssetSubscriptionPlanCreateDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<AssetSubscriptionPlanProductLocationInputDto>}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'productLocations'?: Array<AssetSubscriptionPlanProductLocationInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'poolId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'isPropagateToEntitiesFromPools'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'isForcePropagate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'isFree'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {AssetSpecInputDto}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'assetSpec'?: AssetSpecInputDto;
    /**
     * 
     * @type {SubscriptionPlanSettingsInputDto}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'settings'?: SubscriptionPlanSettingsInputDto;
    /**
     * 
     * @type {AssetSubscriptionPlanSettingsInputDto}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'settings2'?: AssetSubscriptionPlanSettingsInputDto;
    /**
     * 
     * @type {GeneralAttachmentInputDto}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'image'?: GeneralAttachmentInputDto;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'images'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {GeneralCountryInputDto}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'country'?: GeneralCountryInputDto;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {SubscriptionPlanPriceInputDto}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'basePrice'?: SubscriptionPlanPriceInputDto;
    /**
     * 
     * @type {Array<SubscriptionPlanPriceInputDto>}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'alternativePrices'?: Array<SubscriptionPlanPriceInputDto> | null;
    /**
     * 
     * @type {Array<SubscriptionPlanDurationInputDto>}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'durations'?: Array<SubscriptionPlanDurationInputDto> | null;
    /**
     * 
     * @type {Array<SubscriptionPlanIncludedOptionInputDto>}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'includedOptions'?: Array<SubscriptionPlanIncludedOptionInputDto> | null;
    /**
     * 
     * @type {Array<SubscriptionPlanExtraOptionInputDto>}
     * @memberof AssetSubscriptionPlanCreateDto
     */
    'extraOptions'?: Array<SubscriptionPlanExtraOptionInputDto> | null;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionPlanDto
 */
export interface AssetSubscriptionPlanDto {
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof AssetSubscriptionPlanDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionPlanDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionPlanDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionPlanDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionPlanDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {Array<AssetSubscriptionPlanProductLocationDto>}
     * @memberof AssetSubscriptionPlanDto
     */
    'productLocations'?: Array<AssetSubscriptionPlanProductLocationDto> | null;
    /**
     * 
     * @type {PoolReferenceDto}
     * @memberof AssetSubscriptionPlanDto
     */
    'pool'?: PoolReferenceDto;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanDto
     */
    'isFree'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {AssetSpecDto}
     * @memberof AssetSubscriptionPlanDto
     */
    'assetSpec'?: AssetSpecDto;
    /**
     * 
     * @type {SubscriptionPlanSettingsDto}
     * @memberof AssetSubscriptionPlanDto
     */
    'settings'?: SubscriptionPlanSettingsDto;
    /**
     * 
     * @type {AssetSubscriptionPlanSettingsDto}
     * @memberof AssetSubscriptionPlanDto
     */
    'settings2'?: AssetSubscriptionPlanSettingsDto;
    /**
     * 
     * @type {GeneralAttachmentDto}
     * @memberof AssetSubscriptionPlanDto
     */
    'image'?: GeneralAttachmentDto;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof AssetSubscriptionPlanDto
     */
    'images'?: Array<GeneralAttachmentDto> | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof AssetSubscriptionPlanDto
     */
    'attachments'?: Array<GeneralAttachmentDto> | null;
    /**
     * 
     * @type {GeneralCountryDto}
     * @memberof AssetSubscriptionPlanDto
     */
    'country'?: GeneralCountryDto;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof AssetSubscriptionPlanDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {SubscriptionPlanPriceDto}
     * @memberof AssetSubscriptionPlanDto
     */
    'basePrice'?: SubscriptionPlanPriceDto;
    /**
     * 
     * @type {Array<SubscriptionPlanPriceDto>}
     * @memberof AssetSubscriptionPlanDto
     */
    'alternativePrices'?: Array<SubscriptionPlanPriceDto> | null;
    /**
     * 
     * @type {Array<SubscriptionPlanDurationDto>}
     * @memberof AssetSubscriptionPlanDto
     */
    'durations'?: Array<SubscriptionPlanDurationDto> | null;
    /**
     * 
     * @type {Array<SubscriptionPlanIncludedOptionDto>}
     * @memberof AssetSubscriptionPlanDto
     */
    'includedOptions'?: Array<SubscriptionPlanIncludedOptionDto> | null;
    /**
     * 
     * @type {Array<SubscriptionPlanExtraOptionDto>}
     * @memberof AssetSubscriptionPlanDto
     */
    'extraOptions'?: Array<SubscriptionPlanExtraOptionDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionPlanDto
     */
    'poolIds'?: Array<string>;
    /**
     * 
     * @type {Array<SubscriptionPlanPriceDto>}
     * @memberof AssetSubscriptionPlanDto
     */
    'prices'?: Array<SubscriptionPlanPriceDto>;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanDto
     */
    'canAddPools'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanDto
     */
    'canRemovePools'?: boolean;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof AssetSubscriptionPlanDto
     */
    'allAttachments'?: Array<GeneralAttachmentDto>;
}


/**
 * 
 * @export
 * @interface AssetSubscriptionPlanGetPaginatedDto
 */
export interface AssetSubscriptionPlanGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionPlanGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetSubscriptionPlanGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionPlanGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionPlanGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionPlanGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AssetSubscriptionPlanGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AssetSubscriptionPlanGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AssetSubscriptionPlanGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanGetPaginatedDto
     */
    'productLocationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanGetPaginatedDto
     */
    'notForProductLocationId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanGetPaginatedDto
     */
    'isWithAnyProductLocation'?: boolean | null;
    /**
     * 
     * @type {AssetSpecQueryDto}
     * @memberof AssetSubscriptionPlanGetPaginatedDto
     */
    'assetSpec'?: AssetSpecQueryDto;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionPlanInputDto
 */
export interface AssetSubscriptionPlanInputDto {
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanInputDto
     */
    'planId'?: string;
    /**
     * Selected ProductLocation.  Pass null only if user haven\'t selected any ProductLocation.
     * @type {string}
     * @memberof AssetSubscriptionPlanInputDto
     */
    'productLocationId'?: string | null;
    /**
     * 
     * @type {AssetSubscriptionSpotInfoInputDto}
     * @memberof AssetSubscriptionPlanInputDto
     */
    'checkOutSpotInfo'?: AssetSubscriptionSpotInfoInputDto;
    /**
     * 
     * @type {AssetSubscriptionSpotInfoInputDto}
     * @memberof AssetSubscriptionPlanInputDto
     */
    'checkInSpotInfo'?: AssetSubscriptionSpotInfoInputDto;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanInputDto
     */
    'priceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanInputDto
     */
    'durationId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionPlanInputDto
     */
    'extraOptionIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionPlanProductLocationDto
 */
export interface AssetSubscriptionPlanProductLocationDto {
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanProductLocationDto
     */
    'id'?: string;
    /**
     * 
     * @type {ProductLocationReferenceDto}
     * @memberof AssetSubscriptionPlanProductLocationDto
     */
    'productLocation'?: ProductLocationReferenceDto;
    /**
     * 
     * @type {PoolReferenceDto}
     * @memberof AssetSubscriptionPlanProductLocationDto
     */
    'pool'?: PoolReferenceDto;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionPlanProductLocationInputDto
 */
export interface AssetSubscriptionPlanProductLocationInputDto {
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanProductLocationInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanProductLocationInputDto
     */
    'productLocationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanProductLocationInputDto
     */
    'poolId'?: string | null;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionPlanReferenceDto
 */
export interface AssetSubscriptionPlanReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanReferenceDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionPlanSettingsDto
 */
export interface AssetSubscriptionPlanSettingsDto {
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanSettingsDto
     */
    'isEnsurePoolBelongToSinglePlan'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanSettingsDto
     */
    'isPropagateProductProfile'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanSettingsDto
     */
    'isForcePropagateProductProfile'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionPlanSettingsInputDto
 */
export interface AssetSubscriptionPlanSettingsInputDto {
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanSettingsInputDto
     */
    'isEnsurePoolBelongToSinglePlan'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanSettingsInputDto
     */
    'isPropagateProductProfile'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanSettingsInputDto
     */
    'isForcePropagateProductProfile'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionPlanUpdateDto
 */
export interface AssetSubscriptionPlanUpdateDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<AssetSubscriptionPlanProductLocationInputDto>}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'productLocations'?: Array<AssetSubscriptionPlanProductLocationInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'poolId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'isPropagateToEntitiesFromPools'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'isForcePropagate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'isFree'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {AssetSpecInputDto}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'assetSpec'?: AssetSpecInputDto;
    /**
     * 
     * @type {SubscriptionPlanSettingsInputDto}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'settings'?: SubscriptionPlanSettingsInputDto;
    /**
     * 
     * @type {AssetSubscriptionPlanSettingsInputDto}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'settings2'?: AssetSubscriptionPlanSettingsInputDto;
    /**
     * 
     * @type {GeneralAttachmentInputDto}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'image'?: GeneralAttachmentInputDto;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'images'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {GeneralCountryInputDto}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'country'?: GeneralCountryInputDto;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {SubscriptionPlanPriceInputDto}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'basePrice'?: SubscriptionPlanPriceInputDto;
    /**
     * 
     * @type {Array<SubscriptionPlanPriceInputDto>}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'alternativePrices'?: Array<SubscriptionPlanPriceInputDto> | null;
    /**
     * 
     * @type {Array<SubscriptionPlanDurationInputDto>}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'durations'?: Array<SubscriptionPlanDurationInputDto> | null;
    /**
     * 
     * @type {Array<SubscriptionPlanIncludedOptionInputDto>}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'includedOptions'?: Array<SubscriptionPlanIncludedOptionInputDto> | null;
    /**
     * 
     * @type {Array<SubscriptionPlanExtraOptionInputDto>}
     * @memberof AssetSubscriptionPlanUpdateDto
     */
    'extraOptions'?: Array<SubscriptionPlanExtraOptionInputDto> | null;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionReallocateAssetDto
 */
export interface AssetSubscriptionReallocateAssetDto {
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionReallocateAssetDto
     */
    'newPoolId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionReallocateAssetDto
     */
    'newPoolItemId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionReallocateAssetDto
     */
    'isConfirmed'?: boolean;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionReferenceDto
 */
export interface AssetSubscriptionReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionSpotInfoDto
 */
export interface AssetSubscriptionSpotInfoDto {
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionSpotInfoDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionSpotInfoDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionSpotInfoDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionSpotInfoDto
     */
    'productLocationId'?: string | null;
    /**
     * 
     * @type {SpotFullReferenceDto}
     * @memberof AssetSubscriptionSpotInfoDto
     */
    'spot'?: SpotFullReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionSpotInfoDto
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionSpotInfoInputDto
 */
export interface AssetSubscriptionSpotInfoInputDto {
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssetSubscriptionSpotInfoInputDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionSpotInfoInputDto
     */
    'spotId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionSpotInfoInputDto
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionUpdateDto
 */
export interface AssetSubscriptionUpdateDto {
    /**
     * Number of external contract, agreement, etc.
     * @type {string}
     * @memberof AssetSubscriptionUpdateDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionUpdateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetSubscriptionUpdateDto
     */
    'locationIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface AssetSubscriptionUpdateStatusDto
 */
export interface AssetSubscriptionUpdateStatusDto {
    /**
     * 
     * @type {SubscriptionStatus}
     * @memberof AssetSubscriptionUpdateStatusDto
     */
    'newStatus'?: SubscriptionStatus;
}


/**
 * 
 * @export
 * @interface AssetUpdateDto
 */
export interface AssetUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof AssetUpdateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetUpdateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {AssetSpecInputDto}
     * @memberof AssetUpdateDto
     */
    'spec'?: AssetSpecInputDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetUpdateDto
     */
    'accessoryIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof AssetUpdateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {AssetSettingsInputDto}
     * @memberof AssetUpdateDto
     */
    'settings'?: AssetSettingsInputDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetUpdateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetUpdateDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof AssetUpdateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}
/**
 * 
 * @export
 * @interface AssignmentAddEntityDto
 */
export interface AssignmentAddEntityDto {
    /**
     * 
     * @type {string}
     * @memberof AssignmentAddEntityDto
     */
    'assignmentId'?: string;
}
/**
 * 
 * @export
 * @interface AssignmentChangedDto
 */
export interface AssignmentChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignmentChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof AssignmentChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof AssignmentChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof AssignmentChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {AssignmentDto}
     * @memberof AssignmentChangedDto
     */
    'entity': AssignmentDto;
    /**
     * 
     * @type {string}
     * @memberof AssignmentChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface AssignmentContractDto
 */
export interface AssignmentContractDto {
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof AssignmentContractDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof AssignmentContractDto
     */
    'externalNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface AssignmentContractInputDto
 */
export interface AssignmentContractInputDto {
    /**
     * 
     * @type {string}
     * @memberof AssignmentContractInputDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentContractInputDto
     */
    'externalNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface AssignmentCountersDto
 */
export interface AssignmentCountersDto {
    /**
     * 
     * @type {number}
     * @memberof AssignmentCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof AssignmentCountersDto
     */
    'draftCount': number;
    /**
     * 
     * @type {number}
     * @memberof AssignmentCountersDto
     */
    'pendingCount': number;
    /**
     * 
     * @type {number}
     * @memberof AssignmentCountersDto
     */
    'inProgressCount': number;
    /**
     * 
     * @type {number}
     * @memberof AssignmentCountersDto
     */
    'completedCount': number;
}
/**
 * 
 * @export
 * @interface AssignmentCreateDto
 */
export interface AssignmentCreateDto {
    /**
     * 
     * @type {AssignmentType}
     * @memberof AssignmentCreateDto
     */
    'type'?: AssignmentType;
    /**
     * 
     * @type {string}
     * @memberof AssignmentCreateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentCreateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {AssignmentPartyInputDto}
     * @memberof AssignmentCreateDto
     */
    'assigner'?: AssignmentPartyInputDto;
    /**
     * 
     * @type {AssignmentPartyInputDto}
     * @memberof AssignmentCreateDto
     */
    'assignee'?: AssignmentPartyInputDto;
    /**
     * 
     * @type {AssignmentPartyInputDto}
     * @memberof AssignmentCreateDto
     */
    'origin'?: AssignmentPartyInputDto;
    /**
     * 
     * @type {AssignmentPartyInputDto}
     * @memberof AssignmentCreateDto
     */
    'destination'?: AssignmentPartyInputDto;
    /**
     * 
     * @type {AssignmentPartyInputDto}
     * @memberof AssignmentCreateDto
     */
    'driver'?: AssignmentPartyInputDto;
    /**
     * 
     * @type {AssignmentTimePeriodInputDto}
     * @memberof AssignmentCreateDto
     */
    'period'?: AssignmentTimePeriodInputDto;
    /**
     * 
     * @type {string}
     * @memberof AssignmentCreateDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {AssignmentContractInputDto}
     * @memberof AssignmentCreateDto
     */
    'contract'?: AssignmentContractInputDto;
    /**
     * 
     * @type {string}
     * @memberof AssignmentCreateDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof AssignmentCreateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {AssignmentTransportationInputDto}
     * @memberof AssignmentCreateDto
     */
    'transportation'?: AssignmentTransportationInputDto;
    /**
     * 
     * @type {GeneralStageUpdateDtoOfAssignmentStage}
     * @memberof AssignmentCreateDto
     */
    'newStage'?: GeneralStageUpdateDtoOfAssignmentStage;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof AssignmentCreateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}


/**
 * 
 * @export
 * @interface AssignmentDto
 */
export interface AssignmentDto {
    /**
     * 
     * @type {string}
     * @memberof AssignmentDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {AssignmentType}
     * @memberof AssignmentDto
     */
    'type'?: AssignmentType;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {AssignmentPartyDto}
     * @memberof AssignmentDto
     */
    'assigner'?: AssignmentPartyDto;
    /**
     * 
     * @type {AssignmentPartyDto}
     * @memberof AssignmentDto
     */
    'assignee'?: AssignmentPartyDto;
    /**
     * 
     * @type {AssignmentPartyDto}
     * @memberof AssignmentDto
     */
    'origin'?: AssignmentPartyDto;
    /**
     * 
     * @type {AssignmentPartyDto}
     * @memberof AssignmentDto
     */
    'destination'?: AssignmentPartyDto;
    /**
     * 
     * @type {AssignmentPartyDto}
     * @memberof AssignmentDto
     */
    'driver'?: AssignmentPartyDto;
    /**
     * 
     * @type {AssignmentTimePeriodDto}
     * @memberof AssignmentDto
     */
    'period'?: AssignmentTimePeriodDto;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof AssignmentDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {AssignmentContractDto}
     * @memberof AssignmentDto
     */
    'contract'?: AssignmentContractDto;
    /**
     * 
     * @type {GeneralStageHistoryDtoOfAssignmentStage}
     * @memberof AssignmentDto
     */
    'stageHistory'?: GeneralStageHistoryDtoOfAssignmentStage;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof AssignmentDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof AssignmentDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof AssignmentDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {Array<AssignmentOperationDto>}
     * @memberof AssignmentDto
     */
    'operations'?: Array<AssignmentOperationDto>;
    /**
     * 
     * @type {AssignmentTransportationDto}
     * @memberof AssignmentDto
     */
    'transportation'?: AssignmentTransportationDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssignmentDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssignmentDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDto
     */
    'updatedBy'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssignmentDto
     */
    'draftAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssignmentDto
     */
    'pendingAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssignmentDto
     */
    'inProgressAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssignmentDto
     */
    'completedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssignmentDto
     */
    'mustPerformVisualInspectionBeforePickUp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssignmentDto
     */
    'mustPerformVisualInspectionBeforeDropOff'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssignmentDto
     */
    'canPickUp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssignmentDto
     */
    'canDropOff'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssignmentDto
     */
    'isPickedUp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssignmentDto
     */
    'isDroppedOff'?: boolean;
}


/**
 * 
 * @export
 * @interface AssignmentGetCreateMetaDto
 */
export interface AssignmentGetCreateMetaDto {
    /**
     * 
     * @type {boolean}
     * @memberof AssignmentGetCreateMetaDto
     */
    'isVehicleRequired'?: boolean;
}
/**
 * 
 * @export
 * @interface AssignmentGetPaginatedDto
 */
export interface AssignmentGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof AssignmentGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssignmentGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssignmentGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignmentGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignmentGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignmentGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof AssignmentGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof AssignmentGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof AssignmentGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof AssignmentGetPaginatedDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {AssignmentStage}
     * @memberof AssignmentGetPaginatedDto
     */
    'stage'?: AssignmentStage;
    /**
     * 
     * @type {Array<AssignmentStage>}
     * @memberof AssignmentGetPaginatedDto
     */
    'stages'?: Array<AssignmentStage> | null;
    /**
     * 
     * @type {AssignmentStage}
     * @memberof AssignmentGetPaginatedDto
     */
    'excludeStage'?: AssignmentStage;
    /**
     * 
     * @type {Array<AssignmentStage>}
     * @memberof AssignmentGetPaginatedDto
     */
    'excludeStages'?: Array<AssignmentStage> | null;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof AssignmentGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * 
 * @export
 * @interface AssignmentOperationDto
 */
export interface AssignmentOperationDto {
    /**
     * 
     * @type {AssignmentOperationType}
     * @memberof AssignmentOperationDto
     */
    'type'?: AssignmentOperationType;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationDto
     */
    'visualInspectionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationDto
     */
    'damageDetectionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationDto
     */
    'damageCostEvaluationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationDto
     */
    'repairOperationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationDto
     */
    'maintenanceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationDto
     */
    'washId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationDto
     */
    'wheelOperationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationDto
     */
    'assessmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationDto
     */
    'accessoryCheckId'?: string | null;
}


/**
 * 
 * @export
 * @interface AssignmentOperationInputDto
 */
export interface AssignmentOperationInputDto {
    /**
     * 
     * @type {AssignmentOperationType}
     * @memberof AssignmentOperationInputDto
     */
    'type'?: AssignmentOperationType;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationInputDto
     */
    'visualInspectionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationInputDto
     */
    'damageDetectionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationInputDto
     */
    'damageCostEvaluationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationInputDto
     */
    'repairOperationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationInputDto
     */
    'maintenanceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationInputDto
     */
    'washId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationInputDto
     */
    'wheelOperationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationInputDto
     */
    'assessmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentOperationInputDto
     */
    'accessoryCheckId'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AssignmentOperationType = {
    None: 'None',
    VisualInspection: 'VisualInspection',
    DamageDetection: 'DamageDetection',
    DamageCostEvaluation: 'DamageCostEvaluation',
    RepairOperation: 'RepairOperation',
    Maintenance: 'Maintenance',
    Wash: 'Wash',
    WheelOperation: 'WheelOperation',
    Assessment: 'Assessment',
    AccessoryCheck: 'AccessoryCheck'
} as const;

export type AssignmentOperationType = typeof AssignmentOperationType[keyof typeof AssignmentOperationType];


/**
 * 
 * @export
 * @interface AssignmentPartyCustomDto
 */
export interface AssignmentPartyCustomDto {
    /**
     * 
     * @type {string}
     * @memberof AssignmentPartyCustomDto
     */
    'name'?: string;
    /**
     * 
     * @type {GeneralContactDto}
     * @memberof AssignmentPartyCustomDto
     */
    'contact'?: GeneralContactDto;
}
/**
 * 
 * @export
 * @interface AssignmentPartyCustomInputDto
 */
export interface AssignmentPartyCustomInputDto {
    /**
     * 
     * @type {string}
     * @memberof AssignmentPartyCustomInputDto
     */
    'name'?: string;
    /**
     * 
     * @type {GeneralContactInputDto}
     * @memberof AssignmentPartyCustomInputDto
     */
    'contact'?: GeneralContactInputDto;
}
/**
 * 
 * @export
 * @interface AssignmentPartyDto
 */
export interface AssignmentPartyDto {
    /**
     * 
     * @type {AssignmentPartyType}
     * @memberof AssignmentPartyDto
     */
    'type'?: AssignmentPartyType;
    /**
     * 
     * @type {AssignmentPartyRoleType}
     * @memberof AssignmentPartyDto
     */
    'roleType'?: AssignmentPartyRoleType;
    /**
     * 
     * @type {UserReferenceDto}
     * @memberof AssignmentPartyDto
     */
    'user'?: UserReferenceDto;
    /**
     * 
     * @type {TenantReferenceDto}
     * @memberof AssignmentPartyDto
     */
    'tenant'?: TenantReferenceDto;
    /**
     * 
     * @type {DepartmentReferenceDto}
     * @memberof AssignmentPartyDto
     */
    'department'?: DepartmentReferenceDto;
    /**
     * 
     * @type {LocationReferenceDto}
     * @memberof AssignmentPartyDto
     */
    'location'?: LocationReferenceDto;
    /**
     * 
     * @type {SupplierReferenceDto}
     * @memberof AssignmentPartyDto
     */
    'supplier'?: SupplierReferenceDto;
    /**
     * 
     * @type {CustomerReferenceDto}
     * @memberof AssignmentPartyDto
     */
    'customer'?: CustomerReferenceDto;
    /**
     * 
     * @type {AssignmentPartyCustomDto}
     * @memberof AssignmentPartyDto
     */
    'custom'?: AssignmentPartyCustomDto;
    /**
     * 
     * @type {string}
     * @memberof AssignmentPartyDto
     */
    'name'?: string;
    /**
     * 
     * @type {GeneralContact}
     * @memberof AssignmentPartyDto
     */
    'contact'?: GeneralContact;
}


/**
 * 
 * @export
 * @interface AssignmentPartyInputDto
 */
export interface AssignmentPartyInputDto {
    /**
     * 
     * @type {AssignmentPartyType}
     * @memberof AssignmentPartyInputDto
     */
    'type'?: AssignmentPartyType;
    /**
     * 
     * @type {AssignmentPartyRoleType}
     * @memberof AssignmentPartyInputDto
     */
    'roleType'?: AssignmentPartyRoleType;
    /**
     * 
     * @type {string}
     * @memberof AssignmentPartyInputDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentPartyInputDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentPartyInputDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentPartyInputDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentPartyInputDto
     */
    'supplierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentPartyInputDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {AssignmentPartyCustomInputDto}
     * @memberof AssignmentPartyInputDto
     */
    'custom'?: AssignmentPartyCustomInputDto;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AssignmentPartyRoleType = {
    None: 'None',
    Assigner: 'Assigner',
    Assignee: 'Assignee',
    Origin: 'Origin',
    Destination: 'Destination',
    Driver: 'Driver'
} as const;

export type AssignmentPartyRoleType = typeof AssignmentPartyRoleType[keyof typeof AssignmentPartyRoleType];


/**
 * 
 * @export
 * @enum {string}
 */

export const AssignmentPartyType = {
    None: 'None',
    User: 'User',
    Company: 'Company',
    Department: 'Department',
    Location: 'Location',
    Supplier: 'Supplier',
    Customer: 'Customer',
    Custom: 'Custom'
} as const;

export type AssignmentPartyType = typeof AssignmentPartyType[keyof typeof AssignmentPartyType];


/**
 * 
 * @export
 * @interface AssignmentReferenceDto
 */
export interface AssignmentReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof AssignmentReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentReferenceDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentReferenceDto
     */
    'localNumber'?: string;
}
/**
 * NB: use SortOrderAttribute to specify the order in which stages can be activated.
 * @export
 * @enum {string}
 */

export const AssignmentStage = {
    None: 'None',
    Draft: 'Draft',
    Pending: 'Pending',
    InProgress: 'InProgress',
    Completed: 'Completed'
} as const;

export type AssignmentStage = typeof AssignmentStage[keyof typeof AssignmentStage];


/**
 * 
 * @export
 * @interface AssignmentStepDto
 */
export interface AssignmentStepDto {
    /**
     * 
     * @type {AssignmentStepType}
     * @memberof AssignmentStepDto
     */
    'type'?: AssignmentStepType;
    /**
     * 
     * @type {string}
     * @memberof AssignmentStepDto
     */
    'name'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssignmentStepDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {AssignmentStepLocationDto}
     * @memberof AssignmentStepDto
     */
    'location'?: AssignmentStepLocationDto;
    /**
     * 
     * @type {string}
     * @memberof AssignmentStepDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof AssignmentStepDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {Array<AssignmentOperationDto>}
     * @memberof AssignmentStepDto
     */
    'operations'?: Array<AssignmentOperationDto>;
    /**
     * 
     * @type {AssignmentStepSettings}
     * @memberof AssignmentStepDto
     */
    'settings'?: AssignmentStepSettings;
    /**
     * 
     * @type {boolean}
     * @memberof AssignmentStepDto
     */
    'isCompleted'?: boolean;
}


/**
 * 
 * @export
 * @interface AssignmentStepInputDto
 */
export interface AssignmentStepInputDto {
    /**
     * 
     * @type {AssignmentStepType}
     * @memberof AssignmentStepInputDto
     */
    'type'?: AssignmentStepType;
    /**
     * 
     * @type {string}
     * @memberof AssignmentStepInputDto
     */
    'name'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssignmentStepInputDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {AssignmentStepLocationInputDto}
     * @memberof AssignmentStepInputDto
     */
    'location'?: AssignmentStepLocationInputDto;
    /**
     * 
     * @type {string}
     * @memberof AssignmentStepInputDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof AssignmentStepInputDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {Array<AssignmentOperationInputDto>}
     * @memberof AssignmentStepInputDto
     */
    'operations'?: Array<AssignmentOperationInputDto> | null;
    /**
     * 
     * @type {AssignmentStepSettingsInputDto}
     * @memberof AssignmentStepInputDto
     */
    'settings'?: AssignmentStepSettingsInputDto;
}


/**
 * 
 * @export
 * @interface AssignmentStepLocationDto
 */
export interface AssignmentStepLocationDto {
    /**
     * 
     * @type {AssignmentStepLocationType}
     * @memberof AssignmentStepLocationDto
     */
    'type'?: AssignmentStepLocationType;
    /**
     * 
     * @type {SpotFullReferenceDto}
     * @memberof AssignmentStepLocationDto
     */
    'spot'?: SpotFullReferenceDto;
    /**
     * 
     * @type {GeneralAddressDto}
     * @memberof AssignmentStepLocationDto
     */
    'address'?: GeneralAddressDto;
}


/**
 * 
 * @export
 * @interface AssignmentStepLocationInputDto
 */
export interface AssignmentStepLocationInputDto {
    /**
     * 
     * @type {AssignmentStepLocationType}
     * @memberof AssignmentStepLocationInputDto
     */
    'type'?: AssignmentStepLocationType;
    /**
     * 
     * @type {string}
     * @memberof AssignmentStepLocationInputDto
     */
    'spotId'?: string | null;
    /**
     * 
     * @type {GeneralAddressInputDto}
     * @memberof AssignmentStepLocationInputDto
     */
    'address'?: GeneralAddressInputDto;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AssignmentStepLocationType = {
    None: 'None',
    Spot: 'Spot',
    Address: 'Address'
} as const;

export type AssignmentStepLocationType = typeof AssignmentStepLocationType[keyof typeof AssignmentStepLocationType];


/**
 * 
 * @export
 * @interface AssignmentStepSettings
 */
export interface AssignmentStepSettings {
    /**
     * 
     * @type {boolean}
     * @memberof AssignmentStepSettings
     */
    'isRequireVisualInspection'?: boolean;
}
/**
 * 
 * @export
 * @interface AssignmentStepSettingsInputDto
 */
export interface AssignmentStepSettingsInputDto {
    /**
     * 
     * @type {boolean}
     * @memberof AssignmentStepSettingsInputDto
     */
    'isRequireVisualInspection'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AssignmentStepType = {
    None: 'None',
    PickUp: 'PickUp',
    DropOff: 'DropOff'
} as const;

export type AssignmentStepType = typeof AssignmentStepType[keyof typeof AssignmentStepType];


/**
 * 
 * @export
 * @interface AssignmentStepVisualInspectionInputDto
 */
export interface AssignmentStepVisualInspectionInputDto {
    /**
     * 
     * @type {string}
     * @memberof AssignmentStepVisualInspectionInputDto
     */
    'visualInspectionId'?: string | null;
}
/**
 * 
 * @export
 * @interface AssignmentTimePeriodDto
 */
export interface AssignmentTimePeriodDto {
    /**
     * 
     * @type {AssignmentTimePeriodType}
     * @memberof AssignmentTimePeriodDto
     */
    'type'?: AssignmentTimePeriodType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssignmentTimePeriodDto
     */
    'startsAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssignmentTimePeriodDto
     */
    'endsAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssignmentTimePeriodDto
     */
    'dueAt'?: string | null;
}


/**
 * 
 * @export
 * @interface AssignmentTimePeriodInputDto
 */
export interface AssignmentTimePeriodInputDto {
    /**
     * 
     * @type {AssignmentTimePeriodType}
     * @memberof AssignmentTimePeriodInputDto
     */
    'type'?: AssignmentTimePeriodType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssignmentTimePeriodInputDto
     */
    'startsAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssignmentTimePeriodInputDto
     */
    'endsAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AssignmentTimePeriodInputDto
     */
    'dueAt'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AssignmentTimePeriodType = {
    None: 'None',
    Range: 'Range',
    Deadline: 'Deadline'
} as const;

export type AssignmentTimePeriodType = typeof AssignmentTimePeriodType[keyof typeof AssignmentTimePeriodType];


/**
 * 
 * @export
 * @interface AssignmentTransportationDto
 */
export interface AssignmentTransportationDto {
    /**
     * 
     * @type {AssignmentStepDto}
     * @memberof AssignmentTransportationDto
     */
    'pickUp'?: AssignmentStepDto;
    /**
     * 
     * @type {AssignmentStepDto}
     * @memberof AssignmentTransportationDto
     */
    'dropOff'?: AssignmentStepDto;
}
/**
 * 
 * @export
 * @interface AssignmentTransportationInputDto
 */
export interface AssignmentTransportationInputDto {
    /**
     * 
     * @type {AssignmentStepInputDto}
     * @memberof AssignmentTransportationInputDto
     */
    'pickUp'?: AssignmentStepInputDto;
    /**
     * 
     * @type {AssignmentStepInputDto}
     * @memberof AssignmentTransportationInputDto
     */
    'dropOff'?: AssignmentStepInputDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AssignmentType = {
    None: 'None',
    Transportation: 'Transportation'
} as const;

export type AssignmentType = typeof AssignmentType[keyof typeof AssignmentType];


/**
 * 
 * @export
 * @interface AssignmentUpdateDto
 */
export interface AssignmentUpdateDto {
    /**
     * 
     * @type {AssignmentType}
     * @memberof AssignmentUpdateDto
     */
    'type'?: AssignmentType;
    /**
     * 
     * @type {string}
     * @memberof AssignmentUpdateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentUpdateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {AssignmentPartyInputDto}
     * @memberof AssignmentUpdateDto
     */
    'assigner'?: AssignmentPartyInputDto;
    /**
     * 
     * @type {AssignmentPartyInputDto}
     * @memberof AssignmentUpdateDto
     */
    'assignee'?: AssignmentPartyInputDto;
    /**
     * 
     * @type {AssignmentPartyInputDto}
     * @memberof AssignmentUpdateDto
     */
    'origin'?: AssignmentPartyInputDto;
    /**
     * 
     * @type {AssignmentPartyInputDto}
     * @memberof AssignmentUpdateDto
     */
    'destination'?: AssignmentPartyInputDto;
    /**
     * 
     * @type {AssignmentPartyInputDto}
     * @memberof AssignmentUpdateDto
     */
    'driver'?: AssignmentPartyInputDto;
    /**
     * 
     * @type {AssignmentTimePeriodInputDto}
     * @memberof AssignmentUpdateDto
     */
    'period'?: AssignmentTimePeriodInputDto;
    /**
     * 
     * @type {AssignmentContractInputDto}
     * @memberof AssignmentUpdateDto
     */
    'contract'?: AssignmentContractInputDto;
    /**
     * 
     * @type {string}
     * @memberof AssignmentUpdateDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof AssignmentUpdateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {AssignmentTransportationInputDto}
     * @memberof AssignmentUpdateDto
     */
    'transportation'?: AssignmentTransportationInputDto;
    /**
     * 
     * @type {GeneralStageUpdateDtoOfAssignmentStage}
     * @memberof AssignmentUpdateDto
     */
    'newStage'?: GeneralStageUpdateDtoOfAssignmentStage;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof AssignmentUpdateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}


/**
 * 
 * @export
 * @interface AssistantChatSettingsDto
 */
export interface AssistantChatSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof AssistantChatSettingsDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantChatSettingsDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantChatSettingsDto
     */
    'assistantParticipantId'?: string;
}
/**
 * 
 * @export
 * @interface AssistantTipDto
 */
export interface AssistantTipDto {
    /**
     * 
     * @type {string}
     * @memberof AssistantTipDto
     */
    'contextThreadId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssistantTipDto
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface AttachmentsUpdateDto
 */
export interface AttachmentsUpdateDto {
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof AttachmentsUpdateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
}
/**
 * 
 * @export
 * @interface AuthorizationProfileDto
 */
export interface AuthorizationProfileDto {
    /**
     * String value that changes when authorization data changes.
     * @type {string}
     * @memberof AuthorizationProfileDto
     */
    'authorizationState': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizationProfileDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizationProfileDto
     */
    'tenantId': string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorizationProfileDto
     */
    'tenantIdentifier': string | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof AuthorizationProfileDto
     */
    'status': UserStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuthorizationProfileDto
     */
    'tenantIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuthorizationProfileDto
     */
    'tenantIdentifiers': Array<string>;
    /**
     * 
     * @type {Array<AppPermission>}
     * @memberof AuthorizationProfileDto
     */
    'permissions': Array<AppPermission>;
    /**
     * 
     * @type {Array<ProfileDepartmentDto>}
     * @memberof AuthorizationProfileDto
     */
    'departments': Array<ProfileDepartmentDto> | null;
    /**
     * 
     * @type {UserSuspensionInfoDto}
     * @memberof AuthorizationProfileDto
     */
    'suspension': UserSuspensionInfoDto;
}


/**
 * Describes a way of creating something in terms of automation.
 * @export
 * @enum {string}
 */

export const AutomationCreateMode = {
    None: 'None',
    Manual: 'Manual',
    Automatic: 'Automatic'
} as const;

export type AutomationCreateMode = typeof AutomationCreateMode[keyof typeof AutomationCreateMode];


/**
 * Indicates whether the entity is currently available for primary business activity.
 * @export
 * @enum {string}
 */

export const AvailabilityStatus = {
    None: 'None',
    Available: 'Available',
    Unavailable: 'Unavailable'
} as const;

export type AvailabilityStatus = typeof AvailabilityStatus[keyof typeof AvailabilityStatus];


/**
 * 
 * @export
 * @interface AzureCsEmailSettingsDto
 */
export interface AzureCsEmailSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof AzureCsEmailSettingsDto
     */
    'from'?: string;
    /**
     * 
     * @type {UserSecretReferenceDto}
     * @memberof AzureCsEmailSettingsDto
     */
    'connectionString'?: UserSecretReferenceDto;
}
/**
 * 
 * @export
 * @interface AzureCsEmailSettingsInputDto
 */
export interface AzureCsEmailSettingsInputDto {
    /**
     * 
     * @type {string}
     * @memberof AzureCsEmailSettingsInputDto
     */
    'from'?: string;
    /**
     * 
     * @type {UserSecretInputDto}
     * @memberof AzureCsEmailSettingsInputDto
     */
    'connectionString'?: UserSecretInputDto;
}
/**
 * 
 * @export
 * @interface AzureMapsAccessTokenDto
 */
export interface AzureMapsAccessTokenDto {
    /**
     * 
     * @type {string}
     * @memberof AzureMapsAccessTokenDto
     */
    'accessToken': string;
}
/**
 * 
 * @export
 * @interface AzureMapsSasTokenDto
 */
export interface AzureMapsSasTokenDto {
    /**
     * 
     * @type {string}
     * @memberof AzureMapsSasTokenDto
     */
    'sasToken': string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AzureMapsSasTokenDto
     */
    'issuedAt': string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof AzureMapsSasTokenDto
     */
    'expiresAt': string;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof AzureMapsSasTokenDto
     */
    'lifetime': string;
}
/**
 * 
 * @export
 * @interface BaseEntityChangedDto
 */
export interface BaseEntityChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseEntityChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof BaseEntityChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof BaseEntityChangedDto
     */
    'changeType'?: EntityChangeType;
    /**
     * 
     * @type {string}
     * @memberof BaseEntityChangedDto
     */
    'entityId'?: string;
}


/**
 * BaseEntityData
 * @export
 * @interface BaseEntityDataDto
 */
export interface BaseEntityDataDto {
    /**
     * 
     * @type {EntityDataOriginMode}
     * @memberof BaseEntityDataDto
     */
    'dataOriginMode'?: EntityDataOriginMode;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.Id\" />/>
     * @type {string}
     * @memberof BaseEntityDataDto
     */
    'id'?: string | null;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.OriginalId\" />/>
     * @type {string}
     * @memberof BaseEntityDataDto
     */
    'originalId'?: string | null;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.OriginalIds\" />/>
     * @type {Array<string>}
     * @memberof BaseEntityDataDto
     */
    'originalIds'?: Array<string> | null;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.OriginalTenantId\" />/>
     * @type {string}
     * @memberof BaseEntityDataDto
     */
    'originalTenantId'?: string | null;
    /**
     * 
     * @type {EntityFormType}
     * @memberof BaseEntityDataDto
     */
    'formType'?: EntityFormType;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.OriginalIdsAll\" />/>
     * @type {Array<string>}
     * @memberof BaseEntityDataDto
     */
    'originalIdsAll'?: Array<string> | null;
}


/**
 * Id is non-null - load snapshot of the original entity by id, other properties aren\'t required and not validated.    Id is null - store input data, other properties are required and validated.  BaseEntityData.
 * @export
 * @interface BaseEntityDataInputDto
 */
export interface BaseEntityDataInputDto {
    /**
     * 
     * @type {EntityDataOriginMode}
     * @memberof BaseEntityDataInputDto
     */
    'dataOriginMode'?: EntityDataOriginMode;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.Id\" />/>
     * @type {string}
     * @memberof BaseEntityDataInputDto
     */
    'id'?: string | null;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.OriginalId\" />/>
     * @type {string}
     * @memberof BaseEntityDataInputDto
     */
    'originalId'?: string | null;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.OriginalIds\" />/>
     * @type {Array<string>}
     * @memberof BaseEntityDataInputDto
     */
    'originalIds'?: Array<string> | null;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.OriginalTenantId\" />/>
     * @type {string}
     * @memberof BaseEntityDataInputDto
     */
    'originalTenantId'?: string | null;
    /**
     * 
     * @type {EntityFormType}
     * @memberof BaseEntityDataInputDto
     */
    'formType'?: EntityFormType;
}


/**
 * BaseEntity
 * @export
 * @interface BaseEntityDto
 */
export interface BaseEntityDto {
    /**
     * 
     * @type {string}
     * @memberof BaseEntityDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof BaseEntityDto
     */
    'formType'?: EntityFormType;
}


/**
 * BaseEntityFullRef
 * @export
 * @interface BaseEntityFullRefDto
 */
export interface BaseEntityFullRefDto {
    /**
     * 
     * @type {string}
     * @memberof BaseEntityFullRefDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof BaseEntityFullRefDto
     */
    'formType'?: EntityFormType;
}


/**
 * BaseEntityRef
 * @export
 * @interface BaseEntityRefDto
 */
export interface BaseEntityRefDto {
    /**
     * 
     * @type {string}
     * @memberof BaseEntityRefDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof BaseEntityRefDto
     */
    'formType'?: EntityFormType;
}


/**
 * 
 * @export
 * @interface BaseInAppNotificationDataDto
 */
export interface BaseInAppNotificationDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof BaseInAppNotificationDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof BaseInAppNotificationDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof BaseInAppNotificationDataDto
     */
    'ctaEntityId'?: string | null;
}


/**
 * 
 * @export
 * @interface BaseSignalRServerDto
 */
export interface BaseSignalRServerDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseSignalRServerDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof BaseSignalRServerDto
     */
    'groupName'?: string | null;
}
/**
 * Source types for bill to information.
 * @export
 * @enum {string}
 */

export const BillToSourceType = {
    None: 'None',
    Tenant: 'Tenant',
    Department: 'Department',
    Location: 'Location',
    Custom: 'Custom'
} as const;

export type BillToSourceType = typeof BillToSourceType[keyof typeof BillToSourceType];


/**
 * Describes time period of billing for goods.  In the end of every billing period, customer should pay.
 * @export
 * @enum {string}
 */

export const BillingPeriod = {
    None: 'None',
    Day: 'Day',
    Month: 'Month',
    Year: 'Year'
} as const;

export type BillingPeriod = typeof BillingPeriod[keyof typeof BillingPeriod];


/**
 * CTA only data.
 * @export
 * @interface CallToActionInAppDataDto
 */
export interface CallToActionInAppDataDto {
    /**
     * 
     * @type {EntityType}
     * @memberof CallToActionInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof CallToActionInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof CallToActionInAppDataDto
     */
    'type'?: InAppNotificationType;
}


/**
 * 
 * @export
 * @interface CascadeActionInputDto
 */
export interface CascadeActionInputDto {
    /**
     * 
     * @type {EntityTypeEntityIdPairInputDto}
     * @memberof CascadeActionInputDto
     */
    'baseEntity'?: EntityTypeEntityIdPairInputDto;
    /**
     * 
     * @type {Array<EntityType>}
     * @memberof CascadeActionInputDto
     */
    'relatedEntitiesTypes'?: Array<EntityType> | null;
    /**
     * 
     * @type {CascadeActionParametersInputDto}
     * @memberof CascadeActionInputDto
     */
    'parameters'?: CascadeActionParametersInputDto;
}
/**
 * 
 * @export
 * @interface CascadeActionParametersInputDto
 */
export interface CascadeActionParametersInputDto {
    /**
     * 
     * @type {UpdateEntityAffiliationParametersInputDto}
     * @memberof CascadeActionParametersInputDto
     */
    'updateEntityAffiliation'?: UpdateEntityAffiliationParametersInputDto;
}
/**
 * 
 * @export
 * @interface CascadeActionSpecDto
 */
export interface CascadeActionSpecDto {
    /**
     * 
     * @type {CascadeActionType}
     * @memberof CascadeActionSpecDto
     */
    'type'?: CascadeActionType;
    /**
     * 
     * @type {EntityType}
     * @memberof CascadeActionSpecDto
     */
    'baseEntityType'?: EntityType;
    /**
     * 
     * @type {Array<EntityType>}
     * @memberof CascadeActionSpecDto
     */
    'relatedEntitiesTypes'?: Array<EntityType>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CascadeActionType = {
    None: 'None',
    UpdateEntityAffiliation: 'UpdateEntityAffiliation',
    DeleteEntity: 'DeleteEntity'
} as const;

export type CascadeActionType = typeof CascadeActionType[keyof typeof CascadeActionType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ChargeCategory = {
    None: 'None',
    Toll: 'Toll',
    Penalty: 'Penalty',
    Other: 'Other'
} as const;

export type ChargeCategory = typeof ChargeCategory[keyof typeof ChargeCategory];


/**
 * 
 * @export
 * @interface ChargeCreateDto
 */
export interface ChargeCreateDto {
    /**
     * 
     * @type {string}
     * @memberof ChargeCreateDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChargeCreateDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChargeCreateDto
     */
    'customerId'?: string | null;
    /**
     * Reference to any external document.
     * @type {string}
     * @memberof ChargeCreateDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChargeCreateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {ChargeType}
     * @memberof ChargeCreateDto
     */
    'type'?: ChargeType;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof ChargeCreateDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * The final billed total.
     * @type {number}
     * @memberof ChargeCreateDto
     */
    'total'?: number;
    /**
     * When the underlying event related to the charge took place (e.g., toll, traffic violation, service rendered).
     * @type {string}
     * @memberof ChargeCreateDto
     */
    'occurredAt'?: string | null;
    /**
     * The date and time when the charge is due for payment or settlement.
     * @type {string}
     * @memberof ChargeCreateDto
     */
    'dueAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChargeCreateDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof ChargeCreateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof ChargeCreateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}


/**
 * 
 * @export
 * @interface ChargeDto
 */
export interface ChargeDto {
    /**
     * 
     * @type {string}
     * @memberof ChargeDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof ChargeDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChargeDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChargeDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChargeDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChargeDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChargeDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChargeDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChargeDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof ChargeDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof ChargeDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {CustomerReferenceDto}
     * @memberof ChargeDto
     */
    'customer'?: CustomerReferenceDto;
    /**
     * Reference to any external document.
     * @type {string}
     * @memberof ChargeDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChargeDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {ChargeType}
     * @memberof ChargeDto
     */
    'type'?: ChargeType;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof ChargeDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * The final billed total.
     * @type {number}
     * @memberof ChargeDto
     */
    'total'?: number;
    /**
     * When the underlying event related to the charge took place (e.g., toll, traffic violation, service rendered).
     * @type {string}
     * @memberof ChargeDto
     */
    'occurredAt'?: string | null;
    /**
     * The date and time when the charge is due for payment or settlement.
     * @type {string}
     * @memberof ChargeDto
     */
    'dueAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChargeDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof ChargeDto
     */
    'attachments'?: Array<GeneralAttachmentDto> | null;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof ChargeDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {ChargeCategory}
     * @memberof ChargeDto
     */
    'category'?: ChargeCategory;
}


/**
 * 
 * @export
 * @interface ChargeGetPaginatedDto
 */
export interface ChargeGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof ChargeGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChargeGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChargeGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChargeGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChargeGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChargeGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof ChargeGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof ChargeGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof ChargeGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ChargeGetPaginatedDto
     */
    'id'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof ChargeGetPaginatedDto
     */
    'createdAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof ChargeGetPaginatedDto
     */
    'updatedAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ChargeGetPaginatedDto
     */
    'createdBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ChargeGetPaginatedDto
     */
    'updatedBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ChargeGetPaginatedDto
     */
    'vehicleId'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ChargeGetPaginatedDto
     */
    'contractId'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ChargeGetPaginatedDto
     */
    'customerId'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfChargeType}
     * @memberof ChargeGetPaginatedDto
     */
    'type'?: FieldFilterOfPrimitiveDtoOfNullableOfChargeType;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfChargeCategory}
     * @memberof ChargeGetPaginatedDto
     */
    'category'?: FieldFilterOfPrimitiveDtoOfNullableOfChargeCategory;
    /**
     * 
     * @type {GeneralCurrencyQueryDto}
     * @memberof ChargeGetPaginatedDto
     */
    'currency'?: GeneralCurrencyQueryDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDecimal}
     * @memberof ChargeGetPaginatedDto
     */
    'total'?: FieldFilterOfPrimitiveDtoOfNullableOfDecimal;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof ChargeGetPaginatedDto
     */
    'occurredAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof ChargeGetPaginatedDto
     */
    'dueAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof ChargeGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}
/**
 * 
 * @export
 * @interface ChargeReferenceDto
 */
export interface ChargeReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof ChargeReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChargeReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChargeReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChargeReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChargeType = {
    None: 'None',
    Toll: 'Toll',
    Fine: 'Fine',
    Fee: 'Fee',
    Other: 'Other'
} as const;

export type ChargeType = typeof ChargeType[keyof typeof ChargeType];


/**
 * 
 * @export
 * @interface ChargeUpdateDto
 */
export interface ChargeUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof ChargeUpdateDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChargeUpdateDto
     */
    'customerId'?: string | null;
    /**
     * Reference to any external document.
     * @type {string}
     * @memberof ChargeUpdateDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChargeUpdateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {ChargeType}
     * @memberof ChargeUpdateDto
     */
    'type'?: ChargeType;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof ChargeUpdateDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * The final billed total.
     * @type {number}
     * @memberof ChargeUpdateDto
     */
    'total'?: number;
    /**
     * When the underlying event related to the charge took place (e.g., toll, traffic violation, service rendered).
     * @type {string}
     * @memberof ChargeUpdateDto
     */
    'occurredAt'?: string | null;
    /**
     * The date and time when the charge is due for payment or settlement.
     * @type {string}
     * @memberof ChargeUpdateDto
     */
    'dueAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChargeUpdateDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof ChargeUpdateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof ChargeUpdateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}


/**
 * 
 * @export
 * @interface ChatAcknowledgeResultDto
 */
export interface ChatAcknowledgeResultDto {
    /**
     * 
     * @type {ChatDto}
     * @memberof ChatAcknowledgeResultDto
     */
    'chat'?: ChatDto;
    /**
     * 
     * @type {ChatParticipantDto}
     * @memberof ChatAcknowledgeResultDto
     */
    'acknowledgedByParticipant'?: ChatParticipantDto;
}
/**
 * 
 * @export
 * @interface ChatAcknowledgedDto
 */
export interface ChatAcknowledgedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatAcknowledgedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatAcknowledgedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatAcknowledgedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatAcknowledgedDto
     */
    'participantId'?: string;
    /**
     * 
     * @type {ChatMessageAcknowledgementDto}
     * @memberof ChatAcknowledgedDto
     */
    'acknowledgement'?: ChatMessageAcknowledgementDto;
}
/**
 * 
 * @export
 * @interface ChatAcknowledgedInAppDataDto
 */
export interface ChatAcknowledgedInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof ChatAcknowledgedInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatAcknowledgedInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof ChatAcknowledgedInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatAcknowledgedInAppDataDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatType}
     * @memberof ChatAcknowledgedInAppDataDto
     */
    'chatType'?: ChatType;
    /**
     * 
     * @type {string}
     * @memberof ChatAcknowledgedInAppDataDto
     */
    'acknowledgedByParticipantId'?: string;
}


/**
 * 
 * @export
 * @interface ChatActiveAnyActivityAnyPerformedMinimalDto
 */
export interface ChatActiveAnyActivityAnyPerformedMinimalDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatActiveAnyActivityAnyPerformedMinimalDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatActiveAnyActivityAnyPerformedMinimalDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatActiveAnyActivityAnyPerformedMinimalDto
     */
    'chatId': string;
    /**
     * 
     * @type {ChatActivityCategory}
     * @memberof ChatActiveAnyActivityAnyPerformedMinimalDto
     */
    'category': ChatActivityCategory;
    /**
     * 
     * @type {ChatActivityType}
     * @memberof ChatActiveAnyActivityAnyPerformedMinimalDto
     */
    'type': ChatActivityType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ChatActivityCategory = {
    None: 'None',
    Chat: 'Chat',
    Message: 'Message',
    Negotiation: 'Negotiation'
} as const;

export type ChatActivityCategory = typeof ChatActivityCategory[keyof typeof ChatActivityCategory];


/**
 * 
 * @export
 * @interface ChatActivityChangedDto
 */
export interface ChatActivityChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatActivityChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatActivityChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof ChatActivityChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatActivityChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof ChatActivityChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {ChatActivityDto}
     * @memberof ChatActivityChangedDto
     */
    'entity': ChatActivityDto;
    /**
     * 
     * @type {string}
     * @memberof ChatActivityChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface ChatActivityDto
 */
export interface ChatActivityDto {
    /**
     * 
     * @type {string}
     * @memberof ChatActivityDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatActivityDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatActivityDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatEventReferenceDto}
     * @memberof ChatActivityDto
     */
    'createdFromEvent'?: ChatEventReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof ChatActivityDto
     */
    'messageId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatActivityDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatActivityDto
     */
    'participantId'?: string | null;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof ChatActivityDto
     */
    'performedBy'?: GeneralByWhoDto;
    /**
     * 
     * @type {ChatActivityCategory}
     * @memberof ChatActivityDto
     */
    'category'?: ChatActivityCategory;
    /**
     * 
     * @type {ChatActivityType}
     * @memberof ChatActivityDto
     */
    'type'?: ChatActivityType;
    /**
     * 
     * @type {boolean}
     * @memberof ChatActivityDto
     */
    'isSystem'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatActivityDto
     */
    'performedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatActivityDto
     */
    'createdAt'?: string;
}


/**
 * 
 * @export
 * @interface ChatActivityGetPaginatedDto
 */
export interface ChatActivityGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof ChatActivityGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatActivityGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatActivityGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatActivityGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatActivityGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatActivityGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof ChatActivityGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof ChatActivityGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof ChatActivityGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {ChatActivityCategory}
     * @memberof ChatActivityGetPaginatedDto
     */
    'category'?: ChatActivityCategory;
    /**
     * 
     * @type {Array<ChatActivityCategory>}
     * @memberof ChatActivityGetPaginatedDto
     */
    'categories'?: Array<ChatActivityCategory> | null;
    /**
     * 
     * @type {ChatActivityType}
     * @memberof ChatActivityGetPaginatedDto
     */
    'type'?: ChatActivityType;
    /**
     * 
     * @type {Array<ChatActivityType>}
     * @memberof ChatActivityGetPaginatedDto
     */
    'types'?: Array<ChatActivityType> | null;
}


/**
 * 
 * @export
 * @interface ChatActivityOverviewDto
 */
export interface ChatActivityOverviewDto {
    /**
     * 
     * @type {string}
     * @memberof ChatActivityOverviewDto
     */
    'chatId'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatActivityOverviewDto
     */
    'lastActivityAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatActivityOverviewDto
     */
    'lastEventAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatActivityOverviewDto
     */
    'lastMessageAt'?: string | null;
    /**
     * 
     * @type {Array<ChatActivityOverviewParticipantInfoDto>}
     * @memberof ChatActivityOverviewDto
     */
    'participants'?: Array<ChatActivityOverviewParticipantInfoDto>;
    /**
     * 
     * @type {ChatActivityOverviewParticipantInfoDto}
     * @memberof ChatActivityOverviewDto
     */
    'currentParticipant'?: ChatActivityOverviewParticipantInfoDto;
}
/**
 * 
 * @export
 * @interface ChatActivityOverviewParticipantInfoDto
 */
export interface ChatActivityOverviewParticipantInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ChatActivityOverviewParticipantInfoDto
     */
    'participantId'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatActivityOverviewParticipantInfoDto
     */
    'lastActivityAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatActivityOverviewParticipantInfoDto
     */
    'lastEventAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatActivityOverviewParticipantInfoDto
     */
    'lastMessageAt'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatActivityPerformedDto
 */
export interface ChatActivityPerformedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatActivityPerformedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatActivityPerformedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatActivityPerformedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatActivityPerformedDto
     */
    'participantId'?: string | null;
    /**
     * 
     * @type {ChatActivityDto}
     * @memberof ChatActivityPerformedDto
     */
    'activity'?: ChatActivityDto;
    /**
     * 
     * @type {ChatActivityOverviewDto}
     * @memberof ChatActivityPerformedDto
     */
    'activityOverview'?: ChatActivityOverviewDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChatActivityType = {
    None: 'None',
    ChatAcknowledged: 'ChatAcknowledged',
    MessageSent: 'MessageSent',
    MessageUpdated: 'MessageUpdated',
    MessageDeleted: 'MessageDeleted',
    MessageAcknowledged: 'MessageAcknowledged',
    NegotiationProposalResponseGiven: 'NegotiationProposalResponseGiven'
} as const;

export type ChatActivityType = typeof ChatActivityType[keyof typeof ChatActivityType];


/**
 * 
 * @export
 * @interface ChatAnyActivityReadAnyPerformedMinimalDto
 */
export interface ChatAnyActivityReadAnyPerformedMinimalDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatAnyActivityReadAnyPerformedMinimalDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatAnyActivityReadAnyPerformedMinimalDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatAnyActivityReadAnyPerformedMinimalDto
     */
    'chatId': string;
}
/**
 * 
 * @export
 * @interface ChatChangedDto
 */
export interface ChatChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof ChatChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof ChatChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {ChatDto}
     * @memberof ChatChangedDto
     */
    'entity': ChatDto;
    /**
     * 
     * @type {string}
     * @memberof ChatChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface ChatCountersDto
 */
export interface ChatCountersDto {
    /**
     * 
     * @type {string}
     * @memberof ChatCountersDto
     */
    'version'?: string;
    /**
     * Count of chats with unread messages.
     * @type {number}
     * @memberof ChatCountersDto
     */
    'unreadCount': number;
}
/**
 * 
 * @export
 * @interface ChatDto
 */
export interface ChatDto {
    /**
     * 
     * @type {string}
     * @memberof ChatDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof ChatDto
     */
    'formType'?: EntityFormType;
    /**
     * 
     * @type {string}
     * @memberof ChatDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatDto
     */
    'localNumber'?: string | null;
    /**
     * 
     * @type {GeneralScopeDto}
     * @memberof ChatDto
     */
    'scope'?: GeneralScopeDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof ChatDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {Array<NegotiationReferenceDto>}
     * @memberof ChatDto
     */
    'negotiations'?: Array<NegotiationReferenceDto>;
    /**
     * 
     * @type {ChatType}
     * @memberof ChatDto
     */
    'type'?: ChatType;
    /**
     * 
     * @type {string}
     * @memberof ChatDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {ChatSettingsDto}
     * @memberof ChatDto
     */
    'settings'?: ChatSettingsDto;
    /**
     * 
     * @type {ChatMessageReferenceDto}
     * @memberof ChatDto
     */
    'lastMessage'?: ChatMessageReferenceDto;
    /**
     * 
     * @type {boolean}
     * @memberof ChatDto
     */
    'isResolved'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatDto
     */
    'resolvedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatDto
     */
    'resolvedByParticipantId'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatDto
     */
    'reopenedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatDto
     */
    'reopenedByParticipantId'?: string | null;
    /**
     * 
     * @type {Array<ChatParticipantReferenceDto>}
     * @memberof ChatDto
     */
    'participants'?: Array<ChatParticipantReferenceDto>;
    /**
     * 
     * @type {number}
     * @memberof ChatDto
     */
    'pinnedItemCount'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatDto
     */
    'updatedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatDto
     */
    'lastActivityAt'?: string;
    /**
     * 
     * @type {ChatParticipantReferenceDto}
     * @memberof ChatDto
     */
    'currentParticipant'?: ChatParticipantReferenceDto;
    /**
     * 
     * @type {ChatUserUnreadInfoDto}
     * @memberof ChatDto
     */
    'unread'?: ChatUserUnreadInfoDto;
    /**
     * 
     * @type {boolean}
     * @memberof ChatDto
     */
    'isScoped'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatDto
     */
    'isTenantToTenant'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatDto
     */
    'isRestrictedParticipants'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ChatEventCategory = {
    None: 'None',
    Chat: 'Chat',
    Participant: 'Participant',
    Message: 'Message',
    Negotiation: 'Negotiation'
} as const;

export type ChatEventCategory = typeof ChatEventCategory[keyof typeof ChatEventCategory];


/**
 * 
 * @export
 * @interface ChatEventChangedDto
 */
export interface ChatEventChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatEventChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatEventChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof ChatEventChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatEventChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof ChatEventChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {ChatEventDto}
     * @memberof ChatEventChangedDto
     */
    'entity': ChatEventDto;
    /**
     * 
     * @type {string}
     * @memberof ChatEventChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface ChatEventDto
 */
export interface ChatEventDto {
    /**
     * 
     * @type {string}
     * @memberof ChatEventDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatEventDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatEventDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatEventDto
     */
    'messageId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatEventDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatEventDto
     */
    'participantId'?: string | null;
    /**
     * 
     * @type {ChatEventCategory}
     * @memberof ChatEventDto
     */
    'category'?: ChatEventCategory;
    /**
     * 
     * @type {ChatEventType}
     * @memberof ChatEventDto
     */
    'type'?: ChatEventType;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof ChatEventDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {string}
     * @memberof ChatEventDto
     */
    'body'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatEventDto
     */
    'raisedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatEventDto
     */
    'createdAt'?: string;
}


/**
 * 
 * @export
 * @interface ChatEventGetPaginatedDto
 */
export interface ChatEventGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof ChatEventGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatEventGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatEventGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatEventGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatEventGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatEventGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof ChatEventGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof ChatEventGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof ChatEventGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {ChatEventCategory}
     * @memberof ChatEventGetPaginatedDto
     */
    'category'?: ChatEventCategory;
    /**
     * 
     * @type {Array<ChatEventCategory>}
     * @memberof ChatEventGetPaginatedDto
     */
    'categories'?: Array<ChatEventCategory> | null;
    /**
     * 
     * @type {Array<ChatEventCategory>}
     * @memberof ChatEventGetPaginatedDto
     */
    'includeCategories'?: Array<ChatEventCategory> | null;
    /**
     * 
     * @type {Array<ChatEventCategory>}
     * @memberof ChatEventGetPaginatedDto
     */
    'excludeCategories'?: Array<ChatEventCategory> | null;
    /**
     * 
     * @type {ChatEventType}
     * @memberof ChatEventGetPaginatedDto
     */
    'type'?: ChatEventType;
    /**
     * 
     * @type {Array<ChatEventType>}
     * @memberof ChatEventGetPaginatedDto
     */
    'types'?: Array<ChatEventType> | null;
    /**
     * 
     * @type {Array<ChatEventType>}
     * @memberof ChatEventGetPaginatedDto
     */
    'includeTypes'?: Array<ChatEventType> | null;
    /**
     * 
     * @type {Array<ChatEventType>}
     * @memberof ChatEventGetPaginatedDto
     */
    'excludeTypes'?: Array<ChatEventType> | null;
}


/**
 * 
 * @export
 * @interface ChatEventReceivedDto
 */
export interface ChatEventReceivedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatEventReceivedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatEventReceivedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatEventReceivedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatEventDto}
     * @memberof ChatEventReceivedDto
     */
    'event'?: ChatEventDto;
}
/**
 * 
 * @export
 * @interface ChatEventReferenceDto
 */
export interface ChatEventReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof ChatEventReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatEventReferenceDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatEventCategory}
     * @memberof ChatEventReferenceDto
     */
    'category'?: ChatEventCategory;
    /**
     * 
     * @type {ChatEventType}
     * @memberof ChatEventReferenceDto
     */
    'type'?: ChatEventType;
    /**
     * 
     * @type {string}
     * @memberof ChatEventReferenceDto
     */
    'body'?: string;
}


/**
 * NB: Web FE reads  EnumLinkedToOneAttribute`1 and  EnumLinkedToManyAttribute`1.
 * @export
 * @enum {string}
 */

export const ChatEventType = {
    None: 'None',
    ChatCreated: 'ChatCreated',
    ChatUpdated: 'ChatUpdated',
    ChatDeleted: 'ChatDeleted',
    ChatResolved: 'ChatResolved',
    ChatReopened: 'ChatReopened',
    ChatAcknowledged: 'ChatAcknowledged',
    ChatHistoryItemPinned: 'ChatHistoryItemPinned',
    ChatHistoryItemUnpinned: 'ChatHistoryItemUnpinned',
    ParticipantJoined: 'ParticipantJoined',
    ParticipantLeft: 'ParticipantLeft',
    ParticipantAdded: 'ParticipantAdded',
    ParticipantRemoved: 'ParticipantRemoved',
    MessageSent: 'MessageSent',
    MessageUpdated: 'MessageUpdated',
    MessageDeleted: 'MessageDeleted',
    MessageAcknowledged: 'MessageAcknowledged',
    NegotiationCreated: 'NegotiationCreated',
    NegotiationUpdated: 'NegotiationUpdated',
    NegotiationDeleted: 'NegotiationDeleted',
    NegotiationOpened: 'NegotiationOpened',
    NegotiationReopened: 'NegotiationReopened',
    NegotiationProposalCreated: 'NegotiationProposalCreated',
    NegotiationProposalUpdated: 'NegotiationProposalUpdated',
    NegotiationProposalResponseGiven: 'NegotiationProposalResponseGiven',
    NegotiationProposalClosed: 'NegotiationProposalClosed',
    NegotiationResolved: 'NegotiationResolved'
} as const;

export type ChatEventType = typeof ChatEventType[keyof typeof ChatEventType];


/**
 * 
 * @export
 * @interface ChatGetOrCreateNegotiationDto
 */
export interface ChatGetOrCreateNegotiationDto {
    /**
     * 
     * @type {boolean}
     * @memberof ChatGetOrCreateNegotiationDto
     */
    'isOnBehalfOfUser'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatGetOrCreateNegotiationDto
     */
    'isAutoJoin'?: boolean | null;
    /**
     * 
     * @type {GeneralScopeRequestDto}
     * @memberof ChatGetOrCreateNegotiationDto
     */
    'scope'?: GeneralScopeRequestDto;
}
/**
 * 
 * @export
 * @interface ChatGetPaginatedDto
 */
export interface ChatGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof ChatGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof ChatGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof ChatGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof ChatGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ChatGetPaginatedDto
     */
    'id'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof ChatGetPaginatedDto
     */
    'createdAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof ChatGetPaginatedDto
     */
    'updatedAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ChatGetPaginatedDto
     */
    'createdBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ChatGetPaginatedDto
     */
    'updatedBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {ChatType}
     * @memberof ChatGetPaginatedDto
     */
    'type'?: ChatType;
    /**
     * 
     * @type {Array<ChatType>}
     * @memberof ChatGetPaginatedDto
     */
    'types'?: Array<ChatType> | null;
    /**
     * 
     * @type {Array<GeneralScopeType>}
     * @memberof ChatGetPaginatedDto
     */
    'scopes'?: Array<GeneralScopeType>;
    /**
     * Return only chats where the requesting user is an active participant.
     * @type {boolean}
     * @memberof ChatGetPaginatedDto
     */
    'isActiveParticipant'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatGetPaginatedDto
     */
    'isResolved'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatGetPaginatedDto
     */
    'hasMessages'?: boolean | null;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof ChatGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
    /**
     * 
     * @type {string}
     * @memberof ChatGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatGetPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatGetPaginatedDto
     */
    'assignmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatGetPaginatedDto
     */
    'damageDetectionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatGetPaginatedDto
     */
    'damageCostEvaluationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatGetPaginatedDto
     */
    'repairId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatGetPaginatedDto
     */
    'washId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatGetPaginatedDto
     */
    'maintenanceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatGetPaginatedDto
     */
    'wheelOperationId'?: string | null;
    /**
     * Sort by unread count for current tenant user.
     * @type {boolean}
     * @memberof ChatGetPaginatedDto
     */
    'isSortByUnreadCountDesc'?: boolean | null;
}


/**
 * 
 * @export
 * @interface ChatHistoryGetPaginatedDto
 */
export interface ChatHistoryGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof ChatHistoryGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatHistoryGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatHistoryGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatHistoryGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatHistoryGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof ChatHistoryGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof ChatHistoryGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof ChatHistoryGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {Array<ChatHistoryItemType>}
     * @memberof ChatHistoryGetPaginatedDto
     */
    'types'?: Array<ChatHistoryItemType> | null;
    /**
     * 
     * @type {Array<ChatHistoryItemType>}
     * @memberof ChatHistoryGetPaginatedDto
     */
    'includeTypes'?: Array<ChatHistoryItemType> | null;
    /**
     * 
     * @type {Array<ChatHistoryItemType>}
     * @memberof ChatHistoryGetPaginatedDto
     */
    'excludeTypes'?: Array<ChatHistoryItemType> | null;
}
/**
 * 
 * @export
 * @interface ChatHistoryItemChangedDto
 */
export interface ChatHistoryItemChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatHistoryItemChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof ChatHistoryItemChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatHistoryItemChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {ChatHistoryItemDto}
     * @memberof ChatHistoryItemChangedDto
     */
    'entity': ChatHistoryItemDto;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface ChatHistoryItemCreatedDto
 */
export interface ChatHistoryItemCreatedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatHistoryItemCreatedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemCreatedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemCreatedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatHistoryItemDto}
     * @memberof ChatHistoryItemCreatedDto
     */
    'item'?: ChatHistoryItemDto;
}
/**
 * 
 * @export
 * @interface ChatHistoryItemDeletedDto
 */
export interface ChatHistoryItemDeletedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatHistoryItemDeletedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemDeletedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemDeletedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemDeletedDto
     */
    'itemId'?: string;
}
/**
 * 
 * @export
 * @interface ChatHistoryItemDto
 */
export interface ChatHistoryItemDto {
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemDto
     */
    'participantId'?: string | null;
    /**
     * 
     * @type {ChatHistoryItemType}
     * @memberof ChatHistoryItemDto
     */
    'type'?: ChatHistoryItemType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatHistoryItemDto
     */
    'date'?: string;
    /**
     * 
     * @type {ChatMessageDto}
     * @memberof ChatHistoryItemDto
     */
    'message'?: ChatMessageDto;
    /**
     * 
     * @type {ChatEventDto}
     * @memberof ChatHistoryItemDto
     */
    'event'?: ChatEventDto;
    /**
     * 
     * @type {NegotiationProposalDto}
     * @memberof ChatHistoryItemDto
     */
    'negotiationProposal'?: NegotiationProposalDto;
    /**
     * 
     * @type {boolean}
     * @memberof ChatHistoryItemDto
     */
    'isPinned'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatHistoryItemDto
     */
    'pinnedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemDto
     */
    'pinnedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemDto
     */
    'pinnedByParticipant'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatHistoryItemDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatHistoryItemDto
     */
    'updatedAt'?: string;
}


/**
 * 
 * @export
 * @interface ChatHistoryItemPinStatusChangedDto
 */
export interface ChatHistoryItemPinStatusChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatHistoryItemPinStatusChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemPinStatusChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemPinStatusChangedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatHistoryItemDto}
     * @memberof ChatHistoryItemPinStatusChangedDto
     */
    'item'?: ChatHistoryItemDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChatHistoryItemType = {
    None: 'None',
    ChatMessage: 'ChatMessage',
    ChatEvent: 'ChatEvent',
    NegotiationProposal: 'NegotiationProposal'
} as const;

export type ChatHistoryItemType = typeof ChatHistoryItemType[keyof typeof ChatHistoryItemType];


/**
 * 
 * @export
 * @interface ChatHistoryItemUpdatedDto
 */
export interface ChatHistoryItemUpdatedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatHistoryItemUpdatedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemUpdatedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryItemUpdatedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatHistoryItemDto}
     * @memberof ChatHistoryItemUpdatedDto
     */
    'item'?: ChatHistoryItemDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChatHubClientMethodName = {
    TestNotify: 'TestNotify',
    Broadcast: 'Broadcast',
    Echo: 'Echo',
    ServerErrorOccurred: 'ServerErrorOccurred',
    ChatActivityPerformed: 'ChatActivityPerformed',
    ChatActiveAnyActivityAnyPerformedMinimal: 'ChatActiveAnyActivityAnyPerformedMinimal',
    ChatSemiActiveAnyActivityAnyPerformedMinimal: 'ChatSemiActiveAnyActivityAnyPerformedMinimal',
    ChatAnyActivityReadAnyPerformedMinimal: 'ChatAnyActivityReadAnyPerformedMinimal',
    ChatUpdated: 'ChatUpdated',
    ChatResolved: 'ChatResolved',
    ChatReopened: 'ChatReopened',
    ChatAcknowledged: 'ChatAcknowledged',
    ChatUserAdded: 'ChatUserAdded',
    ParticipantConnected: 'ParticipantConnected',
    ParticipantDisconnected: 'ParticipantDisconnected',
    ParticipantStatusUpdated: 'ParticipantStatusUpdated',
    ParticipantJoined: 'ParticipantJoined',
    ParticipantLeft: 'ParticipantLeft',
    ParticipantsAdded: 'ParticipantsAdded',
    ParticipantRemoved: 'ParticipantRemoved',
    MessageSent: 'MessageSent',
    MessageUpdated: 'MessageUpdated',
    MessageDeleted: 'MessageDeleted',
    MessageAcknowledged: 'MessageAcknowledged',
    MessagesRead: 'MessagesRead',
    ChatEventReceived: 'ChatEventReceived',
    ChatHistoryItemCreated: 'ChatHistoryItemCreated',
    ChatHistoryItemUpdated: 'ChatHistoryItemUpdated',
    ChatHistoryItemDeleted: 'ChatHistoryItemDeleted',
    ChatHistoryItemPinStatusChanged: 'ChatHistoryItemPinStatusChanged'
} as const;

export type ChatHubClientMethodName = typeof ChatHubClientMethodName[keyof typeof ChatHubClientMethodName];


/**
 * 
 * @export
 * @enum {string}
 */

export const ChatHubServerMethodName = {
    Broadcast: 'Broadcast',
    Echo: 'Echo',
    ConnectToChat: 'ConnectToChat',
    DisconnectFromChat: 'DisconnectFromChat',
    ReportMyChatParticipantStatus: 'ReportMyChatParticipantStatus',
    SubscribeToChatActivityUpdates: 'SubscribeToChatActivityUpdates',
    UnsubscribeFromChatActivityUpdates: 'UnsubscribeFromChatActivityUpdates',
    SubscribeToChatActiveAnyActivityAnyMinimal: 'SubscribeToChatActiveAnyActivityAnyMinimal',
    UnsubscribeFromChatActiveAnyActivityAnyMinimal: 'UnsubscribeFromChatActiveAnyActivityAnyMinimal',
    SubscribeToChatSemiActiveAnyActivityAnyMinimal: 'SubscribeToChatSemiActiveAnyActivityAnyMinimal',
    UnsubscribeFromChatSemiActiveAnyActivityAnyMinimal: 'UnsubscribeFromChatSemiActiveAnyActivityAnyMinimal',
    SubscribeToChatAnyActivityReadAnyMinimal: 'SubscribeToChatAnyActivityReadAnyMinimal',
    UnsubscribeFromChatAnyActivityReadAnyMinimal: 'UnsubscribeFromChatAnyActivityReadAnyMinimal'
} as const;

export type ChatHubServerMethodName = typeof ChatHubServerMethodName[keyof typeof ChatHubServerMethodName];


/**
 * 
 * @export
 * @interface ChatMessageAcknowledgedDto
 */
export interface ChatMessageAcknowledgedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatMessageAcknowledgedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAcknowledgedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAcknowledgedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAcknowledgedDto
     */
    'messageId'?: string;
    /**
     * 
     * @type {ChatMessageAcknowledgementDto}
     * @memberof ChatMessageAcknowledgedDto
     */
    'acknowledgement'?: ChatMessageAcknowledgementDto;
}
/**
 * 
 * @export
 * @interface ChatMessageAcknowledgedInAppDataDto
 */
export interface ChatMessageAcknowledgedInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof ChatMessageAcknowledgedInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatMessageAcknowledgedInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof ChatMessageAcknowledgedInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAcknowledgedInAppDataDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatType}
     * @memberof ChatMessageAcknowledgedInAppDataDto
     */
    'chatType'?: ChatType;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAcknowledgedInAppDataDto
     */
    'acknowledgedByParticipantId'?: string;
}


/**
 * 
 * @export
 * @interface ChatMessageAcknowledgementDto
 */
export interface ChatMessageAcknowledgementDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAcknowledgementDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageAcknowledgementDto
     */
    'participantId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessageAcknowledgementDto
     */
    'isAcknowledged'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatMessageAcknowledgementDto
     */
    'acknowledgedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatMessageChangedDto
 */
export interface ChatMessageChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatMessageChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof ChatMessageChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatMessageChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {ChatMessageDto}
     * @memberof ChatMessageChangedDto
     */
    'entity': ChatMessageDto;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface ChatMessageCountersDto
 */
export interface ChatMessageCountersDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageCountersDto
     */
    'version'?: string;
    /**
     * Count of unread messages in all chats in the tenant.
     * @type {number}
     * @memberof ChatMessageCountersDto
     */
    'unreadCount': number;
}
/**
 * 
 * @export
 * @interface ChatMessageDeletedDto
 */
export interface ChatMessageDeletedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatMessageDeletedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDeletedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDeletedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDeletedDto
     */
    'messageId'?: string;
}
/**
 * 
 * @export
 * @interface ChatMessageDto
 */
export interface ChatMessageDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof ChatMessageDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    'participantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    'body'?: string | null;
    /**
     * 
     * @type {ChatMessageRootNodeDto}
     * @memberof ChatMessageDto
     */
    'rootNode'?: ChatMessageRootNodeDto;
    /**
     * 
     * @type {Array<ChatMessageAcknowledgementDto>}
     * @memberof ChatMessageDto
     */
    'acknowledgements'?: Array<ChatMessageAcknowledgementDto>;
    /**
     * 
     * @type {Array<ChatMessageReadByInfoDto>}
     * @memberof ChatMessageDto
     */
    'readByInfo'?: Array<ChatMessageReadByInfoDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof ChatMessageDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * User edited the message.
     * @type {boolean}
     * @memberof ChatMessageDto
     */
    'isEdited'?: boolean | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatMessageDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof ChatMessageDto
     */
    'bodyTags'?: GeneralAttachedTagsDto;
}
/**
 * 
 * @export
 * @interface ChatMessageGetPaginatedDto
 */
export interface ChatMessageGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof ChatMessageGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatMessageGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatMessageGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatMessageGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof ChatMessageGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof ChatMessageGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof ChatMessageGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
}
/**
 * 
 * @export
 * @interface ChatMessageMarkdownTextNodeDataDto
 */
export interface ChatMessageMarkdownTextNodeDataDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageMarkdownTextNodeDataDto
     */
    'markdown'?: string;
}
/**
 * 
 * @export
 * @interface ChatMessageMarkdownTextNodeDataInputDto
 */
export interface ChatMessageMarkdownTextNodeDataInputDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageMarkdownTextNodeDataInputDto
     */
    'markdown'?: string;
}
/**
 * 
 * @export
 * @interface ChatMessageMentionNodeDataInputDto
 */
export interface ChatMessageMentionNodeDataInputDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageMentionNodeDataInputDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageMentionNodeDataInputDto
     */
    'participantId'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatMessageNodeDto
 */
export interface ChatMessageNodeDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageNodeDto
     */
    'id'?: string;
    /**
     * 
     * @type {ChatMessageNodeType}
     * @memberof ChatMessageNodeDto
     */
    'type'?: ChatMessageNodeType;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageNodeDto
     */
    'startIndex'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageNodeDto
     */
    'endIndex'?: number;
    /**
     * 
     * @type {ChatMessageTextNodeDataDto}
     * @memberof ChatMessageNodeDto
     */
    'text'?: ChatMessageTextNodeDataDto;
    /**
     * 
     * @type {ChatMessageWebLinkNodeDataDto}
     * @memberof ChatMessageNodeDto
     */
    'webLink'?: ChatMessageWebLinkNodeDataDto;
    /**
     * 
     * @type {ChatMessageTagNodeDataDto}
     * @memberof ChatMessageNodeDto
     */
    'tag'?: ChatMessageTagNodeDataDto;
    /**
     * 
     * @type {ChatMessageMarkdownTextNodeDataDto}
     * @memberof ChatMessageNodeDto
     */
    'markdown'?: ChatMessageMarkdownTextNodeDataDto;
}


/**
 * 
 * @export
 * @interface ChatMessageNodeInputDto
 */
export interface ChatMessageNodeInputDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageNodeInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {ChatMessageNodeType}
     * @memberof ChatMessageNodeInputDto
     */
    'type'?: ChatMessageNodeType;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageNodeInputDto
     */
    'startIndex'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageNodeInputDto
     */
    'endIndex'?: number;
    /**
     * 
     * @type {ChatMessageTextNodeDataInputDto}
     * @memberof ChatMessageNodeInputDto
     */
    'text'?: ChatMessageTextNodeDataInputDto;
    /**
     * 
     * @type {ChatMessageMentionNodeDataInputDto}
     * @memberof ChatMessageNodeInputDto
     */
    'mention'?: ChatMessageMentionNodeDataInputDto;
    /**
     * 
     * @type {ChatMessageWebLinkNodeDataInputDto}
     * @memberof ChatMessageNodeInputDto
     */
    'webLink'?: ChatMessageWebLinkNodeDataInputDto;
    /**
     * 
     * @type {ChatMessageTagNodeDataInputDto}
     * @memberof ChatMessageNodeInputDto
     */
    'tag'?: ChatMessageTagNodeDataInputDto;
    /**
     * 
     * @type {ChatMessageMarkdownTextNodeDataInputDto}
     * @memberof ChatMessageNodeInputDto
     */
    'markdown'?: ChatMessageMarkdownTextNodeDataInputDto;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ChatMessageNodeType = {
    None: 'None',
    Root: 'Root',
    Text: 'Text',
    WebLink: 'WebLink',
    Tag: 'Tag',
    MarkdownText: 'MarkdownText'
} as const;

export type ChatMessageNodeType = typeof ChatMessageNodeType[keyof typeof ChatMessageNodeType];


/**
 * 
 * @export
 * @interface ChatMessageReadByInfoDto
 */
export interface ChatMessageReadByInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageReadByInfoDto
     */
    'participantId'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatMessageReadByInfoDto
     */
    'readAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageReadByInfoDto
     */
    'computedId'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatMessageReferenceDto
 */
export interface ChatMessageReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageReferenceDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageReferenceDto
     */
    'body'?: string;
}
/**
 * 
 * @export
 * @interface ChatMessageRootNodeDto
 */
export interface ChatMessageRootNodeDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageRootNodeDto
     */
    'id'?: string;
    /**
     * 
     * @type {Array<ChatMessageNodeDto>}
     * @memberof ChatMessageRootNodeDto
     */
    'nodes'?: Array<ChatMessageNodeDto>;
}
/**
 * 
 * @export
 * @interface ChatMessageRootNodeInputDto
 */
export interface ChatMessageRootNodeInputDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageRootNodeInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {Array<ChatMessageNodeInputDto>}
     * @memberof ChatMessageRootNodeInputDto
     */
    'nodes'?: Array<ChatMessageNodeInputDto>;
}
/**
 * 
 * @export
 * @interface ChatMessageSentDto
 */
export interface ChatMessageSentDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatMessageSentDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageSentDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageSentDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatMessageDto}
     * @memberof ChatMessageSentDto
     */
    'message'?: ChatMessageDto;
}
/**
 * 
 * @export
 * @interface ChatMessageTagNodeDataDto
 */
export interface ChatMessageTagNodeDataDto {
    /**
     * 
     * @type {GeneralTagDto}
     * @memberof ChatMessageTagNodeDataDto
     */
    'tag'?: GeneralTagDto;
}
/**
 * 
 * @export
 * @interface ChatMessageTagNodeDataInputDto
 */
export interface ChatMessageTagNodeDataInputDto {
    /**
     * 
     * @type {GeneralTagInputDto}
     * @memberof ChatMessageTagNodeDataInputDto
     */
    'tag'?: GeneralTagInputDto;
}
/**
 * 
 * @export
 * @interface ChatMessageTextNodeDataDto
 */
export interface ChatMessageTextNodeDataDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageTextNodeDataDto
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface ChatMessageTextNodeDataInputDto
 */
export interface ChatMessageTextNodeDataInputDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageTextNodeDataInputDto
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface ChatMessageUpdatedDto
 */
export interface ChatMessageUpdatedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatMessageUpdatedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUpdatedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUpdatedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatMessageDto}
     * @memberof ChatMessageUpdatedDto
     */
    'message'?: ChatMessageDto;
}
/**
 * 
 * @export
 * @interface ChatMessageWebLinkNodeDataDto
 */
export interface ChatMessageWebLinkNodeDataDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageWebLinkNodeDataDto
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface ChatMessageWebLinkNodeDataInputDto
 */
export interface ChatMessageWebLinkNodeDataInputDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageWebLinkNodeDataInputDto
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface ChatMessagesReadDto
 */
export interface ChatMessagesReadDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatMessagesReadDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessagesReadDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessagesReadDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatMessagesReadDto
     */
    'messageIds'?: Array<string>;
    /**
     * 
     * @type {ChatMessageReadByInfoDto}
     * @memberof ChatMessagesReadDto
     */
    'readByInfo'?: ChatMessageReadByInfoDto;
}
/**
 * 
 * @export
 * @interface ChatNegotiationProposalCreatedInAppDataDto
 */
export interface ChatNegotiationProposalCreatedInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof ChatNegotiationProposalCreatedInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatNegotiationProposalCreatedInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof ChatNegotiationProposalCreatedInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatNegotiationProposalCreatedInAppDataDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatType}
     * @memberof ChatNegotiationProposalCreatedInAppDataDto
     */
    'chatType'?: ChatType;
    /**
     * 
     * @type {string}
     * @memberof ChatNegotiationProposalCreatedInAppDataDto
     */
    'createdByParticipantId'?: string | null;
}


/**
 * 
 * @export
 * @interface ChatNegotiationProposalResponseGivenInAppDataDto
 */
export interface ChatNegotiationProposalResponseGivenInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof ChatNegotiationProposalResponseGivenInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatNegotiationProposalResponseGivenInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof ChatNegotiationProposalResponseGivenInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatNegotiationProposalResponseGivenInAppDataDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatType}
     * @memberof ChatNegotiationProposalResponseGivenInAppDataDto
     */
    'chatType'?: ChatType;
    /**
     * 
     * @type {string}
     * @memberof ChatNegotiationProposalResponseGivenInAppDataDto
     */
    'respondedParticipantId'?: string | null;
}


/**
 * 
 * @export
 * @interface ChatParticipantAddManyResultDto
 */
export interface ChatParticipantAddManyResultDto {
    /**
     * 
     * @type {ChatDto}
     * @memberof ChatParticipantAddManyResultDto
     */
    'chat'?: ChatDto;
    /**
     * 
     * @type {Array<ChatParticipantDto>}
     * @memberof ChatParticipantAddManyResultDto
     */
    'participants'?: Array<ChatParticipantDto>;
}
/**
 * 
 * @export
 * @interface ChatParticipantAddedInAppDataDto
 */
export interface ChatParticipantAddedInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof ChatParticipantAddedInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatParticipantAddedInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof ChatParticipantAddedInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantAddedInAppDataDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatType}
     * @memberof ChatParticipantAddedInAppDataDto
     */
    'chatType'?: ChatType;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantAddedInAppDataDto
     */
    'addedByParticipantId'?: string;
}


/**
 * 
 * @export
 * @interface ChatParticipantCandidateDto
 */
export interface ChatParticipantCandidateDto {
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantCandidateDto
     */
    'randomId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantCandidateDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof ChatParticipantCandidateDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantCandidateDto
     */
    'email'?: string;
    /**
     * 
     * @type {GeneralAvatarDto}
     * @memberof ChatParticipantCandidateDto
     */
    'avatar'?: GeneralAvatarDto;
}
/**
 * 
 * @export
 * @interface ChatParticipantCandidateInputDto
 */
export interface ChatParticipantCandidateInputDto {
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantCandidateInputDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantCandidateInputDto
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface ChatParticipantChangedDto
 */
export interface ChatParticipantChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatParticipantChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof ChatParticipantChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatParticipantChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {ChatParticipantDto}
     * @memberof ChatParticipantChangedDto
     */
    'entity': ChatParticipantDto;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface ChatParticipantConnectedDto
 */
export interface ChatParticipantConnectedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatParticipantConnectedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantConnectedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantConnectedDto
     */
    'connectionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantConnectedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantConnectedDto
     */
    'participantId'?: string;
}
/**
 * 
 * @export
 * @interface ChatParticipantDisconnectedDto
 */
export interface ChatParticipantDisconnectedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatParticipantDisconnectedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantDisconnectedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantDisconnectedDto
     */
    'connectionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantDisconnectedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantDisconnectedDto
     */
    'participantId'?: string;
}
/**
 * 
 * @export
 * @interface ChatParticipantDto
 */
export interface ChatParticipantDto {
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof ChatParticipantDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {Array<PartyAndMemberReferenceDto>}
     * @memberof ChatParticipantDto
     */
    'parties'?: Array<PartyAndMemberReferenceDto> | null;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof ChatParticipantDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'email'?: string;
    /**
     * 
     * @type {ChatParticipantJoinType}
     * @memberof ChatParticipantDto
     */
    'joinType'?: ChatParticipantJoinType;
    /**
     * 
     * @type {ChatParticipantStatus}
     * @memberof ChatParticipantDto
     */
    'status'?: ChatParticipantStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ChatParticipantDto
     */
    'isAcknowledged'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'acknowledgedAt'?: string | null;
    /**
     * 
     * @type {GeneralAvatarDto}
     * @memberof ChatParticipantDto
     */
    'avatar'?: GeneralAvatarDto;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'addedByParticipantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'removedByParticipantId'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'joinedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'leftAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'addedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'removedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ChatParticipantDto
     */
    'lastConnectedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatParticipantDto
     */
    'isSystem'?: boolean;
}


/**
 * 
 * @export
 * @interface ChatParticipantGetPaginatedDto
 */
export interface ChatParticipantGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof ChatParticipantGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatParticipantGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatParticipantGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatParticipantGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatParticipantGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof ChatParticipantGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof ChatParticipantGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof ChatParticipantGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {ChatParticipantStatus}
     * @memberof ChatParticipantGetPaginatedDto
     */
    'status'?: ChatParticipantStatus;
}


/**
 * 
 * @export
 * @interface ChatParticipantJoinResultDto
 */
export interface ChatParticipantJoinResultDto {
    /**
     * 
     * @type {ChatDto}
     * @memberof ChatParticipantJoinResultDto
     */
    'chat'?: ChatDto;
    /**
     * 
     * @type {ChatParticipantDto}
     * @memberof ChatParticipantJoinResultDto
     */
    'participant'?: ChatParticipantDto;
}
/**
 * Defines how a participant joined the chat.
 * @export
 * @enum {string}
 */

export const ChatParticipantJoinType = {
    None: 'None',
    Joined: 'Joined',
    Added: 'Added'
} as const;

export type ChatParticipantJoinType = typeof ChatParticipantJoinType[keyof typeof ChatParticipantJoinType];


/**
 * 
 * @export
 * @interface ChatParticipantJoinedDto
 */
export interface ChatParticipantJoinedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatParticipantJoinedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantJoinedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantJoinedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatParticipantDto}
     * @memberof ChatParticipantJoinedDto
     */
    'participant'?: ChatParticipantDto;
}
/**
 * 
 * @export
 * @interface ChatParticipantLeaveResultDto
 */
export interface ChatParticipantLeaveResultDto {
    /**
     * 
     * @type {ChatDto}
     * @memberof ChatParticipantLeaveResultDto
     */
    'chat'?: ChatDto;
    /**
     * 
     * @type {ChatParticipantDto}
     * @memberof ChatParticipantLeaveResultDto
     */
    'participant'?: ChatParticipantDto;
}
/**
 * 
 * @export
 * @interface ChatParticipantLeftDto
 */
export interface ChatParticipantLeftDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatParticipantLeftDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantLeftDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantLeftDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatParticipantDto}
     * @memberof ChatParticipantLeftDto
     */
    'participant'?: ChatParticipantDto;
}
/**
 * 
 * @export
 * @interface ChatParticipantMentionedInAppDataDto
 */
export interface ChatParticipantMentionedInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof ChatParticipantMentionedInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatParticipantMentionedInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof ChatParticipantMentionedInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantMentionedInAppDataDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatType}
     * @memberof ChatParticipantMentionedInAppDataDto
     */
    'chatType'?: ChatType;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantMentionedInAppDataDto
     */
    'mentionedByParticipantId'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ChatParticipantOnlineStatus = {
    None: 'None',
    Offline: 'Offline',
    Online: 'Online'
} as const;

export type ChatParticipantOnlineStatus = typeof ChatParticipantOnlineStatus[keyof typeof ChatParticipantOnlineStatus];


/**
 * 
 * @export
 * @interface ChatParticipantReferenceDto
 */
export interface ChatParticipantReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof ChatParticipantReferenceDto
     */
    'formType'?: EntityFormType;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantReferenceDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantReferenceDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantReferenceDto
     */
    'email'?: string;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof ChatParticipantReferenceDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {ChatParticipantStatus}
     * @memberof ChatParticipantReferenceDto
     */
    'status'?: ChatParticipantStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ChatParticipantReferenceDto
     */
    'isSystem'?: boolean;
}


/**
 * 
 * @export
 * @interface ChatParticipantRemoveResultDto
 */
export interface ChatParticipantRemoveResultDto {
    /**
     * 
     * @type {ChatDto}
     * @memberof ChatParticipantRemoveResultDto
     */
    'chat'?: ChatDto;
    /**
     * 
     * @type {ChatParticipantDto}
     * @memberof ChatParticipantRemoveResultDto
     */
    'participant'?: ChatParticipantDto;
}
/**
 * 
 * @export
 * @interface ChatParticipantRemovedDto
 */
export interface ChatParticipantRemovedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatParticipantRemovedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantRemovedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantRemovedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatParticipantDto}
     * @memberof ChatParticipantRemovedDto
     */
    'participant'?: ChatParticipantDto;
}
/**
 * 
 * @export
 * @interface ChatParticipantRemovedInAppDataDto
 */
export interface ChatParticipantRemovedInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof ChatParticipantRemovedInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatParticipantRemovedInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof ChatParticipantRemovedInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantRemovedInAppDataDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatType}
     * @memberof ChatParticipantRemovedInAppDataDto
     */
    'chatType'?: ChatType;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantRemovedInAppDataDto
     */
    'removedByParticipantId'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ChatParticipantStatus = {
    None: 'None',
    Active: 'Active',
    Left: 'Left',
    Removed: 'Removed'
} as const;

export type ChatParticipantStatus = typeof ChatParticipantStatus[keyof typeof ChatParticipantStatus];


/**
 * 
 * @export
 * @interface ChatParticipantStatusUpdatedDto
 */
export interface ChatParticipantStatusUpdatedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatParticipantStatusUpdatedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantStatusUpdatedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantStatusUpdatedDto
     */
    'connectionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantStatusUpdatedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantStatusUpdatedDto
     */
    'participantId'?: string;
    /**
     * 
     * @type {ChatParticipantOnlineStatus}
     * @memberof ChatParticipantStatusUpdatedDto
     */
    'onlineStatus'?: ChatParticipantOnlineStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ChatParticipantStatusUpdatedDto
     */
    'isReportBack'?: boolean | null;
}


/**
 * 
 * @export
 * @interface ChatParticipantsAddedDto
 */
export interface ChatParticipantsAddedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatParticipantsAddedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantsAddedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantsAddedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {Array<ChatParticipantDto>}
     * @memberof ChatParticipantsAddedDto
     */
    'participants'?: Array<ChatParticipantDto>;
}
/**
 * 
 * @export
 * @interface ChatPartyLimitDto
 */
export interface ChatPartyLimitDto {
    /**
     * 
     * @type {number}
     * @memberof ChatPartyLimitDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {PartyReferenceDto}
     * @memberof ChatPartyLimitDto
     */
    'party'?: PartyReferenceDto;
}
/**
 * 
 * @export
 * @interface ChatReferenceDto
 */
export interface ChatReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof ChatReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatReferenceDto
     */
    'localNumber'?: string | null;
    /**
     * 
     * @type {ChatType}
     * @memberof ChatReferenceDto
     */
    'type'?: ChatType;
}


/**
 * 
 * @export
 * @interface ChatReopenedDto
 */
export interface ChatReopenedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatReopenedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatReopenedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {ChatDto}
     * @memberof ChatReopenedDto
     */
    'chat'?: ChatDto;
    /**
     * 
     * @type {string}
     * @memberof ChatReopenedDto
     */
    'reopenedByParticipantId'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatReopenedInAppDataDto
 */
export interface ChatReopenedInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof ChatReopenedInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatReopenedInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof ChatReopenedInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatReopenedInAppDataDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatType}
     * @memberof ChatReopenedInAppDataDto
     */
    'chatType'?: ChatType;
    /**
     * 
     * @type {string}
     * @memberof ChatReopenedInAppDataDto
     */
    'reopenedByParticipantId'?: string;
}


/**
 * 
 * @export
 * @interface ChatResolvedDto
 */
export interface ChatResolvedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatResolvedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatResolvedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {ChatDto}
     * @memberof ChatResolvedDto
     */
    'chat'?: ChatDto;
}
/**
 * 
 * @export
 * @interface ChatResolvedInAppDataDto
 */
export interface ChatResolvedInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof ChatResolvedInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatResolvedInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof ChatResolvedInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatResolvedInAppDataDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatType}
     * @memberof ChatResolvedInAppDataDto
     */
    'chatType'?: ChatType;
    /**
     * 
     * @type {string}
     * @memberof ChatResolvedInAppDataDto
     */
    'resolvedByParticipantId'?: string;
}


/**
 * 
 * @export
 * @interface ChatSemiActiveAnyActivityAnyPerformedMinimalDto
 */
export interface ChatSemiActiveAnyActivityAnyPerformedMinimalDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatSemiActiveAnyActivityAnyPerformedMinimalDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatSemiActiveAnyActivityAnyPerformedMinimalDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatSemiActiveAnyActivityAnyPerformedMinimalDto
     */
    'chatId': string;
    /**
     * 
     * @type {ChatActivityCategory}
     * @memberof ChatSemiActiveAnyActivityAnyPerformedMinimalDto
     */
    'category': ChatActivityCategory;
    /**
     * 
     * @type {ChatActivityType}
     * @memberof ChatSemiActiveAnyActivityAnyPerformedMinimalDto
     */
    'type': ChatActivityType;
}


/**
 * 
 * @export
 * @interface ChatSettingsDto
 */
export interface ChatSettingsDto {
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'allowJoin'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'allowLeave'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'allowPartyMemberJoin'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'allowParticipantManagement'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'allowResolution'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'allowAcknowledgement'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'allowMessageAcknowledgement'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'allowEdit'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'allowPinnedItems'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChatSettingsDto
     */
    'maxPinnedItems'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'isPinNegotiations'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'allowSendMessages'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'allowMessageAttachments'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'allowEditMessages'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'allowDeleteMessages'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'allowNegotiations'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsDto
     */
    'isNotifyAboutNewMessageViaEmail'?: boolean;
    /**
     * 
     * @type {Array<ChatPartyLimitDto>}
     * @memberof ChatSettingsDto
     */
    'limitedToParties'?: Array<ChatPartyLimitDto>;
}
/**
 * 
 * @export
 * @interface ChatSettingsInputDto
 */
export interface ChatSettingsInputDto {
    /**
     * 
     * @type {boolean}
     * @memberof ChatSettingsInputDto
     */
    'isNotifyAboutNewMessageViaEmail'?: boolean;
}
/**
 * 
 * @export
 * @interface ChatTipDto
 */
export interface ChatTipDto {
    /**
     * 
     * @type {string}
     * @memberof ChatTipDto
     */
    'body'?: string;
}
/**
 * 
 * @export
 * @interface ChatTipsDto
 */
export interface ChatTipsDto {
    /**
     * 
     * @type {string}
     * @memberof ChatTipsDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {Array<ChatTipDto>}
     * @memberof ChatTipsDto
     */
    'tips'?: Array<ChatTipDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChatType = {
    None: 'None',
    Personal: 'Personal',
    Group: 'Group',
    Comment: 'Comment',
    Negotiation: 'Negotiation',
    Assistant: 'Assistant'
} as const;

export type ChatType = typeof ChatType[keyof typeof ChatType];


/**
 * 
 * @export
 * @interface ChatUpdatedDto
 */
export interface ChatUpdatedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatUpdatedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatUpdatedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatUpdatedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatDto}
     * @memberof ChatUpdatedDto
     */
    'chat'?: ChatDto;
    /**
     * 
     * @type {string}
     * @memberof ChatUpdatedDto
     */
    'participantId'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatUserAddedDto
 */
export interface ChatUserAddedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatUserAddedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatUserAddedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatUserAddedDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {ChatParticipantDto}
     * @memberof ChatUserAddedDto
     */
    'participant'?: ChatParticipantDto;
}
/**
 * 
 * @export
 * @interface ChatUserSettingsChangedDto
 */
export interface ChatUserSettingsChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatUserSettingsChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatUserSettingsChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof ChatUserSettingsChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof ChatUserSettingsChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof ChatUserSettingsChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {ChatUserSettingsDto}
     * @memberof ChatUserSettingsChangedDto
     */
    'entity': ChatUserSettingsDto;
    /**
     * 
     * @type {string}
     * @memberof ChatUserSettingsChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface ChatUserSettingsDto
 */
export interface ChatUserSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof ChatUserSettingsDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatUserSettingsDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatUserSettingsDto
     */
    'chatId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatUserSettingsDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatUserSettingsDto
     */
    'participantId'?: string | null;
    /**
     * 
     * @type {ChatUserSettingsEvent}
     * @memberof ChatUserSettingsDto
     */
    'event'?: ChatUserSettingsEvent;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsDto
     */
    'isGlobal'?: boolean;
}
/**
 * 
 * @export
 * @interface ChatUserSettingsEvent
 */
export interface ChatUserSettingsEvent {
    /**
     * 
     * @type {ChatUserSettingsEventDisabledCategoriesMap}
     * @memberof ChatUserSettingsEvent
     */
    'disabledCategoriesMap'?: ChatUserSettingsEventDisabledCategoriesMap;
    /**
     * 
     * @type {ChatUserSettingsEventDisabledTypesMap}
     * @memberof ChatUserSettingsEvent
     */
    'disabledTypesMap'?: ChatUserSettingsEventDisabledTypesMap;
}
/**
 * 
 * @export
 * @interface ChatUserSettingsEventDisabledCategoriesMap
 */
export interface ChatUserSettingsEventDisabledCategoriesMap {
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledCategoriesMap
     */
    'None'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledCategoriesMap
     */
    'Chat'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledCategoriesMap
     */
    'Participant'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledCategoriesMap
     */
    'Message'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledCategoriesMap
     */
    'Negotiation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledCategoriesMap
     */
    'Unknown'?: boolean;
}
/**
 * 
 * @export
 * @interface ChatUserSettingsEventDisabledTypesMap
 */
export interface ChatUserSettingsEventDisabledTypesMap {
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'None'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'ChatCreated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'ChatUpdated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'ChatDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'ChatResolved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'ChatReopened'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'ChatAcknowledged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'ChatHistoryItemPinned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'ChatHistoryItemUnpinned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'ParticipantJoined'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'ParticipantLeft'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'ParticipantAdded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'ParticipantRemoved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'MessageSent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'MessageUpdated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'MessageDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'MessageAcknowledged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'NegotiationCreated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'NegotiationUpdated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'NegotiationDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'NegotiationOpened'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'NegotiationReopened'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'NegotiationProposalCreated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'NegotiationProposalUpdated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'NegotiationProposalResponseGiven'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'NegotiationProposalClosed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'NegotiationResolved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'Unknown'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUserSettingsEventDisabledTypesMap
     */
    'UserAddedToChat'?: boolean;
}
/**
 * 
 * @export
 * @interface ChatUserUnreadInfoDto
 */
export interface ChatUserUnreadInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ChatUserUnreadInfoDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatUserUnreadInfoDto
     */
    'participantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatUserUnreadInfoDto
     */
    'userId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatUserUnreadInfoDto
     */
    'unreadCount'?: number;
}
/**
 * 
 * @export
 * @interface CheckoutManualDto
 */
export interface CheckoutManualDto {
    /**
     * 
     * @type {string}
     * @memberof CheckoutManualDto
     */
    'subscriptionPlanId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckoutManualDto
     */
    'priceId'?: string;
}
/**
 * 
 * @export
 * @interface ClaimTestDto
 */
export interface ClaimTestDto {
    /**
     * 
     * @type {string}
     * @memberof ClaimTestDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimTestDto
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface CommunicationCountersDto
 */
export interface CommunicationCountersDto {
    /**
     * 
     * @type {string}
     * @memberof CommunicationCountersDto
     */
    'version'?: string;
    /**
     * 
     * @type {ChatCountersDto}
     * @memberof CommunicationCountersDto
     */
    'chats': ChatCountersDto;
    /**
     * 
     * @type {ChatMessageCountersDto}
     * @memberof CommunicationCountersDto
     */
    'chatMessages': ChatMessageCountersDto;
}
/**
 * 
 * @export
 * @interface CompanyIdentifierValidateResultDto
 */
export interface CompanyIdentifierValidateResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof CompanyIdentifierValidateResultDto
     */
    'isFree'?: boolean;
}
/**
 * 
 * @export
 * @interface CompanyIncompleteRegistrationCompanyInfoDto
 */
export interface CompanyIncompleteRegistrationCompanyInfoDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyIncompleteRegistrationCompanyInfoDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyIncompleteRegistrationCompanyInfoDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyIncompleteRegistrationCompanyInfoDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyIncompleteRegistrationCompanyInfoDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {TenantContactPersonDto}
     * @memberof CompanyIncompleteRegistrationCompanyInfoDto
     */
    'contactPerson'?: TenantContactPersonDto;
}
/**
 * Info needed to display incomplete company registration.
 * @export
 * @interface CompanyIncompleteRegistrationDto
 */
export interface CompanyIncompleteRegistrationDto {
    /**
     * 
     * @type {boolean}
     * @memberof CompanyIncompleteRegistrationDto
     */
    'isFoundIncompleteRegistration'?: boolean;
    /**
     * 
     * @type {CompanyIncompleteRegistrationCompanyInfoDto}
     * @memberof CompanyIncompleteRegistrationDto
     */
    'company'?: CompanyIncompleteRegistrationCompanyInfoDto;
}
/**
 * 
 * @export
 * @interface ConnectToChatDto
 */
export interface ConnectToChatDto {
    /**
     * 
     * @type {string}
     * @memberof ConnectToChatDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectToChatDto
     */
    'participantId'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ConsensusType = {
    None: 'None',
    Consensus: 'Consensus',
    ForcedConsensus: 'ForcedConsensus',
    NoConsensus: 'NoConsensus'
} as const;

export type ConsensusType = typeof ConsensusType[keyof typeof ConsensusType];


/**
 * Describes types of communication channels between company and customer.
 * @export
 * @enum {string}
 */

export const ContactChannel = {
    None: 'None',
    InPerson: 'InPerson',
    Email: 'Email',
    VoiceCall: 'VoiceCall',
    Sms: 'Sms',
    Chat: 'Chat'
} as const;

export type ContactChannel = typeof ContactChannel[keyof typeof ContactChannel];


/**
 * 
 * @export
 * @interface ContextItemDto
 */
export interface ContextItemDto {
    /**
     * 
     * @type {string}
     * @memberof ContextItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContextItemDto
     */
    'chatMessageId'?: string | null;
    /**
     * 
     * @type {ContextItemKind}
     * @memberof ContextItemDto
     */
    'kind'?: ContextItemKind;
    /**
     * 
     * @type {string}
     * @memberof ContextItemDto
     */
    'textBody'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContextItemDto
     */
    'authorName'?: string | null;
    /**
     * 
     * @type {Array<ContextItemImage>}
     * @memberof ContextItemDto
     */
    'images'?: Array<ContextItemImage>;
}


/**
 * 
 * @export
 * @interface ContextItemImage
 */
export interface ContextItemImage {
    /**
     * 
     * @type {string}
     * @memberof ContextItemImage
     */
    'url'?: string;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof ContextItemImage
     */
    'urlLifetime'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContextItemImage
     */
    'urlExpiresAt'?: string | null;
    /**
     * 
     * @type {ContextItemImageMeta}
     * @memberof ContextItemImage
     */
    'meta'?: ContextItemImageMeta;
    /**
     * 
     * @type {boolean}
     * @memberof ContextItemImage
     */
    'isExpired'?: boolean;
}
/**
 * 
 * @export
 * @interface ContextItemImageMeta
 */
export interface ContextItemImageMeta {
    /**
     * 
     * @type {string}
     * @memberof ContextItemImageMeta
     */
    'mimeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContextItemImageMeta
     */
    'extension'?: string | null;
    /**
     * 
     * @type {ImageQuality}
     * @memberof ContextItemImageMeta
     */
    'quality'?: ImageQuality;
    /**
     * 
     * @type {GeneralFileSize}
     * @memberof ContextItemImageMeta
     */
    'fileSize'?: GeneralFileSize;
    /**
     * 
     * @type {GeneralImageSize}
     * @memberof ContextItemImageMeta
     */
    'size'?: GeneralImageSize;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ContextItemKind = {
    None: 'None',
    System: 'System',
    User: 'User',
    Assistant: 'Assistant',
    ToolCall: 'ToolCall'
} as const;

export type ContextItemKind = typeof ContextItemKind[keyof typeof ContextItemKind];


/**
 * 
 * @export
 * @interface ContextThreadDto
 */
export interface ContextThreadDto {
    /**
     * 
     * @type {string}
     * @memberof ContextThreadDto
     */
    'id'?: string;
    /**
     * 
     * @type {ContextThreadSubject}
     * @memberof ContextThreadDto
     */
    'subject'?: ContextThreadSubject;
    /**
     * 
     * @type {Array<ContextItemDto>}
     * @memberof ContextThreadDto
     */
    'items'?: Array<ContextItemDto>;
    /**
     * 
     * @type {AssistantChatSettingsDto}
     * @memberof ContextThreadDto
     */
    'assistantChat'?: AssistantChatSettingsDto;
}


/**
 * Represents the type of the assistance.  Different subjects means different ways of providing assistance.
 * @export
 * @enum {string}
 */

export const ContextThreadSubject = {
    None: 'None',
    AssistantChat: 'AssistantChat'
} as const;

export type ContextThreadSubject = typeof ContextThreadSubject[keyof typeof ContextThreadSubject];


/**
 * 
 * @export
 * @enum {string}
 */

export const ContractAssessmentFlowStateFilterType = {
    None: 'None',
    All: 'All',
    Pending: 'Pending',
    ActionRequired: 'ActionRequired'
} as const;

export type ContractAssessmentFlowStateFilterType = typeof ContractAssessmentFlowStateFilterType[keyof typeof ContractAssessmentFlowStateFilterType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ContractB2CStatus = {
    None: 'None',
    Active: 'Active',
    Completed: 'Completed',
    Upcoming: 'Upcoming'
} as const;

export type ContractB2CStatus = typeof ContractB2CStatus[keyof typeof ContractB2CStatus];


/**
 * 
 * @export
 * @interface ContractBulkDeleteDto
 */
export interface ContractBulkDeleteDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractBulkDeleteDto
     */
    'ids'?: Array<string>;
    /**
     * 
     * @type {Array<EntityType>}
     * @memberof ContractBulkDeleteDto
     */
    'relatedEntitiesTypes'?: Array<EntityType>;
    /**
     * 
     * @type {boolean}
     * @memberof ContractBulkDeleteDto
     */
    'isDeleteAllRelatedData'?: boolean;
}
/**
 * 
 * @export
 * @interface ContractChangedDto
 */
export interface ContractChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ContractChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof ContractChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof ContractChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof ContractChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {ContractDto}
     * @memberof ContractChangedDto
     */
    'entity': ContractDto;
    /**
     * 
     * @type {string}
     * @memberof ContractChangedDto
     */
    'tenantId': string | null;
}


/**
 * ContractCheckInfoExtractedData.
 * @export
 * @interface ContractCheckInfoExtractedDataDto
 */
export interface ContractCheckInfoExtractedDataDto {
    /**
     * Auto-generated ID for this extracted data record.    Used for caching, logging, or referencing this specific extraction.
     * @type {string}
     * @memberof ContractCheckInfoExtractedDataDto
     */
    'extractedDataId'?: string;
    /**
     * 
     * @type {ExtractedDocumentType}
     * @memberof ContractCheckInfoExtractedDataDto
     */
    'documentType'?: ExtractedDocumentType;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Common.DocumentIntelligence.Base.BaseExtractedData.DocumentConfidence\" />
     * @type {number}
     * @memberof ContractCheckInfoExtractedDataDto
     */
    'documentConfidence'?: number;
    /**
     * 
     * @type {ExtractedDocumentConfidenceLevel}
     * @memberof ContractCheckInfoExtractedDataDto
     */
    'documentConfidenceLevel'?: ExtractedDocumentConfidenceLevel;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractCheckInfoExtractedDataDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {SpotExtractedDataDto}
     * @memberof ContractCheckInfoExtractedDataDto
     */
    'spot'?: SpotExtractedDataDto;
}


/**
 * Describes subject in communication (in scope of a contract) between company and customer.
 * @export
 * @enum {string}
 */

export const ContractCommunicationSubjectType = {
    None: 'None',
    DamageDetection: 'DamageDetection',
    DamageCostEvaluation: 'DamageCostEvaluation',
    Other: 'Other'
} as const;

export type ContractCommunicationSubjectType = typeof ContractCommunicationSubjectType[keyof typeof ContractCommunicationSubjectType];


/**
 * 
 * @export
 * @interface ContractCountersDto
 */
export interface ContractCountersDto {
    /**
     * 
     * @type {number}
     * @memberof ContractCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {ContractCountersDtoCountByFilterTypeMap}
     * @memberof ContractCountersDto
     */
    'countByFilterTypeMap': ContractCountersDtoCountByFilterTypeMap;
    /**
     * 
     * @type {AssetSubscriptionCountersDtoCountByAllocationStatusMap}
     * @memberof ContractCountersDto
     */
    'countByAllocationStatusMap': AssetSubscriptionCountersDtoCountByAllocationStatusMap;
    /**
     * Check-outs count according to the request.
     * @type {number}
     * @memberof ContractCountersDto
     */
    'checkOutCount'?: number;
    /**
     * Check-outs count according to the request.
     * @type {number}
     * @memberof ContractCountersDto
     */
    'checkInCount'?: number;
}
/**
 * 
 * @export
 * @interface ContractCountersDtoCountByFilterTypeMap
 */
export interface ContractCountersDtoCountByFilterTypeMap {
    /**
     * 
     * @type {number}
     * @memberof ContractCountersDtoCountByFilterTypeMap
     */
    'None'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractCountersDtoCountByFilterTypeMap
     */
    'All'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractCountersDtoCountByFilterTypeMap
     */
    'CheckOut'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractCountersDtoCountByFilterTypeMap
     */
    'CheckIn'?: number;
}
/**
 * 
 * @export
 * @interface ContractCreateDto
 */
export interface ContractCreateDto {
    /**
     * 
     * @type {string}
     * @memberof ContractCreateDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractCreateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractCreateDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ContractCreateDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractCreateDto
     */
    'customerId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractCreateDto
     */
    'accessoryIds'?: Array<string> | null;
    /**
     * 
     * @type {ContractType}
     * @memberof ContractCreateDto
     */
    'type'?: ContractType;
    /**
     * Start of contract Active stage. Inclusive date.  NB: Contracts with both empty StartsAt and EndsAt are treated as having zero duration.
     * @type {string}
     * @memberof ContractCreateDto
     */
    'startsAt'?: string | null;
    /**
     * End of contract Active stage. Exclusive date.
     * @type {string}
     * @memberof ContractCreateDto
     */
    'endsAt'?: string | null;
    /**
     * Additional time before the start, added to the overall duration, ensuring a gap before the vehicle is available for the next contract.
     * @type {string}
     * @memberof ContractCreateDto
     */
    'bufferBefore'?: string | null;
    /**
     * Additional time after the end, added to the overall duration, ensuring a gap after the vehicle is available for the next contract.
     * @type {string}
     * @memberof ContractCreateDto
     */
    'bufferAfter'?: string | null;
    /**
     * Date when the stage is automatically updated to ReservationExpired.    Applies only to Reserved stage.
     * @type {string}
     * @memberof ContractCreateDto
     */
    'reservationExpiresAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractCreateDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof ContractCreateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {ContractSettingsInputDto}
     * @memberof ContractCreateDto
     */
    'settings'?: ContractSettingsInputDto;
    /**
     * 
     * @type {ContractSpotInfoInputDto}
     * @memberof ContractCreateDto
     */
    'checkOutSpotInfo'?: ContractSpotInfoInputDto;
    /**
     * 
     * @type {ContractSpotInfoInputDto}
     * @memberof ContractCreateDto
     */
    'checkInSpotInfo'?: ContractSpotInfoInputDto;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof ContractCreateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof ContractCreateDto
     */
    'isConfirmVehicleAllocation'?: boolean;
    /**
     * If true, creates a contract in Reserved stage, otherwise in Draft.
     * @type {boolean}
     * @memberof ContractCreateDto
     */
    'isReserved'?: boolean;
    /**
     * Extracted data used to create this contract.
     * @type {string}
     * @memberof ContractCreateDto
     */
    'extractedDataId'?: string | null;
}


/**
 * 
 * @export
 * @interface ContractCustomerCommunicationDto
 */
export interface ContractCustomerCommunicationDto {
    /**
     * 
     * @type {Array<ContractCustomerCommunicationEntryDto>}
     * @memberof ContractCustomerCommunicationDto
     */
    'entries'?: Array<ContractCustomerCommunicationEntryDto>;
    /**
     * 
     * @type {boolean}
     * @memberof ContractCustomerCommunicationDto
     */
    'isContacted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractCustomerCommunicationDto
     */
    'isContactedOnDamageDetection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractCustomerCommunicationDto
     */
    'isContactedOnDamageCostEvaluation'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractCustomerCommunicationDto
     */
    'contactedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractCustomerCommunicationDto
     */
    'contactedOnDamageDetectionAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractCustomerCommunicationDto
     */
    'contactedOnDamageCostEvaluationAt'?: string | null;
}
/**
 * 
 * @export
 * @interface ContractCustomerCommunicationEntryDto
 */
export interface ContractCustomerCommunicationEntryDto {
    /**
     * 
     * @type {string}
     * @memberof ContractCustomerCommunicationEntryDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractCustomerCommunicationEntryDto
     */
    'customerContactId'?: string;
    /**
     * 
     * @type {ContactChannel}
     * @memberof ContractCustomerCommunicationEntryDto
     */
    'contactChannel'?: ContactChannel;
    /**
     * 
     * @type {Array<ContractCommunicationSubjectType>}
     * @memberof ContractCustomerCommunicationEntryDto
     */
    'subjectTypes'?: Array<ContractCommunicationSubjectType>;
    /**
     * 
     * @type {string}
     * @memberof ContractCustomerCommunicationEntryDto
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractCustomerCommunicationEntryDto
     */
    'notes'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractCustomerCommunicationEntryDto
     */
    'contactedAt'?: string;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof ContractCustomerCommunicationEntryDto
     */
    'handledBy'?: GeneralByWhoDto;
    /**
     * 
     * @type {boolean}
     * @memberof ContractCustomerCommunicationEntryDto
     */
    'isAuto'?: boolean;
}


/**
 * 
 * @export
 * @interface ContractDto
 */
export interface ContractDto {
    /**
     * 
     * @type {string}
     * @memberof ContractDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof ContractDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof ContractDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {CustomerReferenceDto}
     * @memberof ContractDto
     */
    'customer'?: CustomerReferenceDto;
    /**
     * 
     * @type {AssetSubscriptionReferenceDto}
     * @memberof ContractDto
     */
    'assetSubscription'?: AssetSubscriptionReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof ContractDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {ContractType}
     * @memberof ContractDto
     */
    'type'?: ContractType;
    /**
     * 
     * @type {GeneralStageHistoryDtoOfContractStage}
     * @memberof ContractDto
     */
    'stageHistory'?: GeneralStageHistoryDtoOfContractStage;
    /**
     * 
     * @type {AllocationStatus}
     * @memberof ContractDto
     */
    'allocationStatus'?: AllocationStatus;
    /**
     * Start of contract Active stage. Inclusive date.  NB: Contracts with both empty StartsAt and EndsAt are treated as having zero duration.
     * @type {string}
     * @memberof ContractDto
     */
    'startsAt'?: string | null;
    /**
     * End of contract Active stage. Exclusive date.
     * @type {string}
     * @memberof ContractDto
     */
    'endsAt'?: string | null;
    /**
     * Additional time before the start, added to the overall duration, ensuring a gap before the vehicle is available for the next contract.
     * @type {string}
     * @memberof ContractDto
     */
    'bufferBefore'?: string | null;
    /**
     * Additional time after the end, added to the overall duration, ensuring a gap after the vehicle is available for the next contract.
     * @type {string}
     * @memberof ContractDto
     */
    'bufferAfter'?: string | null;
    /**
     * Date when the stage is automatically updated to ReservationExpired.    Applies only to Reserved stage.
     * @type {string}
     * @memberof ContractDto
     */
    'reservationExpiresAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof ContractDto
     */
    'attachments'?: Array<GeneralAttachmentDto> | null;
    /**
     * 
     * @type {Array<AccessoryReferenceDto>}
     * @memberof ContractDto
     */
    'accessories'?: Array<AccessoryReferenceDto>;
    /**
     * 
     * @type {ContractSettingsDto}
     * @memberof ContractDto
     */
    'settings'?: ContractSettingsDto;
    /**
     * 
     * @type {ContractReminderSettingsDto}
     * @memberof ContractDto
     */
    'reminderSettings'?: ContractReminderSettingsDto;
    /**
     * 
     * @type {ContractCustomerCommunicationDto}
     * @memberof ContractDto
     */
    'customerCommunication'?: ContractCustomerCommunicationDto;
    /**
     * 
     * @type {ContractSpotInfoDto}
     * @memberof ContractDto
     */
    'checkOutSpotInfo'?: ContractSpotInfoDto;
    /**
     * 
     * @type {ContractSpotInfoDto}
     * @memberof ContractDto
     */
    'checkInSpotInfo'?: ContractSpotInfoDto;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof ContractDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof ContractDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {OneflowContractRefDto}
     * @memberof ContractDto
     */
    'oneflowContract'?: OneflowContractRefDto;
    /**
     * 
     * @type {boolean}
     * @memberof ContractDto
     */
    'isExternal'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractDto
     */
    'draftAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractDto
     */
    'activatedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractDto
     */
    'completedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractDto
     */
    'closedAt'?: string | null;
    /**
     * Overall start of the contract including before buffer. Inclusive date.
     * @type {string}
     * @memberof ContractDto
     */
    'startsAtEffective'?: string | null;
    /**
     * Overall end of the contract including after buffer. Exclusive date.
     * @type {string}
     * @memberof ContractDto
     */
    'endsAtEffective'?: string | null;
    /**
     * Indicates if any buffer is applied, i.e., effective dates are different from the original ones.
     * @type {boolean}
     * @memberof ContractDto
     */
    'isBuffered'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractDto
     */
    'canReallocate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractDto
     */
    'mustConfirmAllocation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractDto
     */
    'mustPerformVisualInspectionBeforeCheckOut'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractDto
     */
    'mustPerformVisualInspectionBeforeCheckIn'?: boolean;
    /**
     * Whether check out is possible at the moment.
     * @type {boolean}
     * @memberof ContractDto
     */
    'canCheckOut'?: boolean;
    /**
     * Whether check in is possible at the moment.
     * @type {boolean}
     * @memberof ContractDto
     */
    'canCheckIn'?: boolean;
    /**
     * Whether check out is possible and everything is prepared for it.  This flag is designed for fleet users who don\'t know all the info about checkout.
     * @type {boolean}
     * @memberof ContractDto
     */
    'isPreparedForCheckOut'?: boolean;
    /**
     * Whether check in is possible and everything is prepared for it.  This flag is designed for fleet users who don\'t know all the info about check in.
     * @type {boolean}
     * @memberof ContractDto
     */
    'isPreparedForCheckIn'?: boolean;
    /**
     * Whether check out is completed.
     * @type {boolean}
     * @memberof ContractDto
     */
    'isCheckedOut'?: boolean;
    /**
     * Whether check in is completed.
     * @type {boolean}
     * @memberof ContractDto
     */
    'isCheckedIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractDto
     */
    'canPerformAnyOperation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractDto
     */
    'canPerformVisualInspection'?: boolean;
    /**
     * 
     * @type {ContractFilterType}
     * @memberof ContractDto
     */
    'filterType'?: ContractFilterType;
    /**
     * 
     * @type {ContractB2CStatus}
     * @memberof ContractDto
     */
    'b2CStatus'?: ContractB2CStatus;
}


/**
 * ContractExtractedData.
 * @export
 * @interface ContractExtractedDataDto
 */
export interface ContractExtractedDataDto {
    /**
     * Auto-generated ID for this extracted data record.    Used for caching, logging, or referencing this specific extraction.
     * @type {string}
     * @memberof ContractExtractedDataDto
     */
    'extractedDataId'?: string;
    /**
     * 
     * @type {ExtractedDocumentType}
     * @memberof ContractExtractedDataDto
     */
    'documentType'?: ExtractedDocumentType;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Common.DocumentIntelligence.Base.BaseExtractedData.DocumentConfidence\" />
     * @type {number}
     * @memberof ContractExtractedDataDto
     */
    'documentConfidence'?: number;
    /**
     * 
     * @type {ExtractedDocumentConfidenceLevel}
     * @memberof ContractExtractedDataDto
     */
    'documentConfidenceLevel'?: ExtractedDocumentConfidenceLevel;
    /**
     * Entity ID matched using extracted data after extraction in post-processing.
     * @type {string}
     * @memberof ContractExtractedDataDto
     */
    'matchedId'?: string | null;
    /**
     * 
     * @type {ContractType}
     * @memberof ContractExtractedDataDto
     */
    'type'?: ContractType;
    /**
     * 
     * @type {string}
     * @memberof ContractExtractedDataDto
     */
    'externalNumber'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractExtractedDataDto
     */
    'startDate'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractExtractedDataDto
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractExtractedDataDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {VehicleExtractedDataDto}
     * @memberof ContractExtractedDataDto
     */
    'vehicle'?: VehicleExtractedDataDto;
    /**
     * 
     * @type {CustomerExtractedDataDto}
     * @memberof ContractExtractedDataDto
     */
    'customer'?: CustomerExtractedDataDto;
    /**
     * 
     * @type {ContractCheckInfoExtractedDataDto}
     * @memberof ContractExtractedDataDto
     */
    'checkOutInfo'?: ContractCheckInfoExtractedDataDto;
    /**
     * 
     * @type {ContractCheckInfoExtractedDataDto}
     * @memberof ContractExtractedDataDto
     */
    'checkInInfo'?: ContractCheckInfoExtractedDataDto;
    /**
     * 
     * @type {CountryCode}
     * @memberof ContractExtractedDataDto
     */
    'detectedCountryCode'?: CountryCode;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ContractFilterType = {
    None: 'None',
    All: 'All',
    CheckOut: 'CheckOut',
    CheckIn: 'CheckIn'
} as const;

export type ContractFilterType = typeof ContractFilterType[keyof typeof ContractFilterType];


/**
 * 
 * @export
 * @interface ContractFullReferenceDto
 */
export interface ContractFullReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof ContractFullReferenceDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {CustomerReferenceDto}
     * @memberof ContractFullReferenceDto
     */
    'customer'?: CustomerReferenceDto;
    /**
     * 
     * @type {AssetSubscriptionReferenceDto}
     * @memberof ContractFullReferenceDto
     */
    'assetSubscription'?: AssetSubscriptionReferenceDto;
    /**
     * 
     * @type {VisualInspectionReferenceDto}
     * @memberof ContractFullReferenceDto
     */
    'visualInspectionBeforeCheckOut'?: VisualInspectionReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {ContractType}
     * @memberof ContractFullReferenceDto
     */
    'type'?: ContractType;
    /**
     * 
     * @type {GeneralStageHistoryDtoOfContractStage}
     * @memberof ContractFullReferenceDto
     */
    'stageHistory'?: GeneralStageHistoryDtoOfContractStage;
    /**
     * Start of contract Active stage. Inclusive date.  NB: Contracts with both empty StartsAt and EndsAt are treated as having zero duration.
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'startsAt'?: string | null;
    /**
     * End of contract Active stage. Exclusive date.
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'endsAt'?: string | null;
    /**
     * Additional time before the start, added to the overall duration, ensuring a gap before the vehicle is available for the next contract.
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'bufferBefore'?: string | null;
    /**
     * Additional time after the end, added to the overall duration, ensuring a gap after the vehicle is available for the next contract.
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'bufferAfter'?: string | null;
    /**
     * Date when the stage is automatically updated to ReservationExpired.    Applies only to Reserved stage.
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'reservationExpiresAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof ContractFullReferenceDto
     */
    'attachments'?: Array<GeneralAttachmentDto> | null;
    /**
     * 
     * @type {Array<AccessoryReferenceDto>}
     * @memberof ContractFullReferenceDto
     */
    'accessories'?: Array<AccessoryReferenceDto>;
    /**
     * 
     * @type {ContractSettingsDto}
     * @memberof ContractFullReferenceDto
     */
    'settings'?: ContractSettingsDto;
    /**
     * 
     * @type {ContractReminderSettingsDto}
     * @memberof ContractFullReferenceDto
     */
    'reminderSettings'?: ContractReminderSettingsDto;
    /**
     * 
     * @type {ContractCustomerCommunicationDto}
     * @memberof ContractFullReferenceDto
     */
    'customerCommunication'?: ContractCustomerCommunicationDto;
    /**
     * 
     * @type {ContractSpotInfoDto}
     * @memberof ContractFullReferenceDto
     */
    'checkOutSpotInfo'?: ContractSpotInfoDto;
    /**
     * 
     * @type {ContractSpotInfoDto}
     * @memberof ContractFullReferenceDto
     */
    'checkInSpotInfo'?: ContractSpotInfoDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFullReferenceDto
     */
    'isExternal'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'draftAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'activatedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'completedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'closedAt'?: string | null;
    /**
     * Overall start of the contract including before buffer. Inclusive date.
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'startsAtEffective'?: string | null;
    /**
     * Overall end of the contract including after buffer. Exclusive date.
     * @type {string}
     * @memberof ContractFullReferenceDto
     */
    'endsAtEffective'?: string | null;
    /**
     * Indicates if any buffer is applied, i.e., effective dates are different from the original ones.
     * @type {boolean}
     * @memberof ContractFullReferenceDto
     */
    'isBuffered'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFullReferenceDto
     */
    'canReallocate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFullReferenceDto
     */
    'mustConfirmAllocation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFullReferenceDto
     */
    'mustPerformVisualInspectionBeforeCheckOut'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFullReferenceDto
     */
    'mustPerformVisualInspectionBeforeCheckIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFullReferenceDto
     */
    'canCheckOut'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFullReferenceDto
     */
    'canCheckIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFullReferenceDto
     */
    'isPreparedForCheckOut'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFullReferenceDto
     */
    'isPreparedForCheckIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFullReferenceDto
     */
    'isCheckedOut'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFullReferenceDto
     */
    'isCheckedIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFullReferenceDto
     */
    'canPerformAnyOperation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFullReferenceDto
     */
    'canPerformVisualInspection'?: boolean;
    /**
     * 
     * @type {ContractFilterType}
     * @memberof ContractFullReferenceDto
     */
    'filterType'?: ContractFilterType;
}


/**
 * 
 * @export
 * @interface ContractGetCountersDto
 */
export interface ContractGetCountersDto {
    /**
     * 
     * @type {DateRangeInputDto}
     * @memberof ContractGetCountersDto
     */
    'range'?: DateRangeInputDto;
    /**
     * 
     * @type {ContractGetCountersDtoRangeByFilterTypeMap}
     * @memberof ContractGetCountersDto
     */
    'rangeByFilterTypeMap'?: ContractGetCountersDtoRangeByFilterTypeMap | null;
}
/**
 * 
 * @export
 * @interface ContractGetCountersDtoRangeByFilterTypeMap
 */
export interface ContractGetCountersDtoRangeByFilterTypeMap {
    /**
     * 
     * @type {DateRangeInputDto}
     * @memberof ContractGetCountersDtoRangeByFilterTypeMap
     */
    'None'?: DateRangeInputDto;
    /**
     * 
     * @type {DateRangeInputDto}
     * @memberof ContractGetCountersDtoRangeByFilterTypeMap
     */
    'All'?: DateRangeInputDto;
    /**
     * 
     * @type {DateRangeInputDto}
     * @memberof ContractGetCountersDtoRangeByFilterTypeMap
     */
    'CheckOut'?: DateRangeInputDto;
    /**
     * 
     * @type {DateRangeInputDto}
     * @memberof ContractGetCountersDtoRangeByFilterTypeMap
     */
    'CheckIn'?: DateRangeInputDto;
}
/**
 * 
 * @export
 * @interface ContractGetCreateMetaDto
 */
export interface ContractGetCreateMetaDto {
    /**
     * 
     * @type {ContractSettingsDto}
     * @memberof ContractGetCreateMetaDto
     */
    'settings'?: ContractSettingsDto;
}
/**
 * 
 * @export
 * @interface ContractGetPaginatedDto
 */
export interface ContractGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof ContractGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof ContractGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof ContractGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof ContractGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ContractGetPaginatedDto
     */
    'id'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof ContractGetPaginatedDto
     */
    'createdAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof ContractGetPaginatedDto
     */
    'updatedAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ContractGetPaginatedDto
     */
    'createdBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ContractGetPaginatedDto
     */
    'updatedBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {string}
     * @memberof ContractGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractGetPaginatedDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractGetPaginatedDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {Array<ContractType>}
     * @memberof ContractGetPaginatedDto
     */
    'types'?: Array<ContractType> | null;
    /**
     * 
     * @type {ContractStage}
     * @memberof ContractGetPaginatedDto
     */
    'stage'?: ContractStage;
    /**
     * 
     * @type {Array<ContractStage>}
     * @memberof ContractGetPaginatedDto
     */
    'stages'?: Array<ContractStage> | null;
    /**
     * 
     * @type {ContractStage}
     * @memberof ContractGetPaginatedDto
     */
    'excludeStage'?: ContractStage;
    /**
     * 
     * @type {Array<ContractStage>}
     * @memberof ContractGetPaginatedDto
     */
    'excludeStages'?: Array<ContractStage> | null;
    /**
     * 
     * @type {AllocationStatus}
     * @memberof ContractGetPaginatedDto
     */
    'allocationStatus'?: AllocationStatus;
    /**
     * 
     * @type {ContractFilterType}
     * @memberof ContractGetPaginatedDto
     */
    'filterType'?: ContractFilterType;
    /**
     * 
     * @type {ContractB2CStatus}
     * @memberof ContractGetPaginatedDto
     */
    'b2CStatus'?: ContractB2CStatus;
    /**
     * 
     * @type {ContractGetCountersDtoRangeByFilterTypeMap}
     * @memberof ContractGetPaginatedDto
     */
    'rangeByFilterTypeMap'?: ContractGetCountersDtoRangeByFilterTypeMap | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractGetPaginatedDto
     */
    'isPreparedForCheckOut'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractGetPaginatedDto
     */
    'isPreparedForCheckIn'?: boolean | null;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof ContractGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * 
 * @export
 * @interface ContractOneflowContractCreateDto
 */
export interface ContractOneflowContractCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ContractOneflowContractCreateDto
     */
    'oneflowTemplateId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractOneflowContractCreateDto
     */
    'isIncludeCounterparty'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractOneflowContractCreateDto
     */
    'isIncludeExpandedPdf'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractOneflowContractCreateDto
     */
    'isIncludeDataFields'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractOneflowContractCreateDto
     */
    'isIncludeCheckOutLocationDataField'?: boolean | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ContractProductsSubscriptionsStateFilterType = {
    None: 'None',
    All: 'All',
    Reservations: 'Reservations',
    Active: 'Active',
    Completed: 'Completed'
} as const;

export type ContractProductsSubscriptionsStateFilterType = typeof ContractProductsSubscriptionsStateFilterType[keyof typeof ContractProductsSubscriptionsStateFilterType];


/**
 * 
 * @export
 * @interface ContractReallocateVehicleDto
 */
export interface ContractReallocateVehicleDto {
    /**
     * 
     * @type {string}
     * @memberof ContractReallocateVehicleDto
     */
    'newVehicleId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContractReallocateVehicleDto
     */
    'isConfirmed'?: boolean;
}
/**
 * 
 * @export
 * @interface ContractReferenceDto
 */
export interface ContractReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof ContractReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractReferenceDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractReferenceDto
     */
    'customerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractReferenceDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {ContractType}
     * @memberof ContractReferenceDto
     */
    'type'?: ContractType;
}


/**
 * 
 * @export
 * @interface ContractReminderDto
 */
export interface ContractReminderDto {
    /**
     * 
     * @type {string}
     * @memberof ContractReminderDto
     */
    'id'?: string;
    /**
     * 
     * @type {ContractReminderType}
     * @memberof ContractReminderDto
     */
    'type'?: ContractReminderType;
    /**
     * 
     * @type {boolean}
     * @memberof ContractReminderDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContractReminderDto
     */
    'jobId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractReminderDto
     */
    'isFired'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractReminderDto
     */
    'nextFireAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractReminderDto
     */
    'previousFireAt'?: string | null;
}


/**
 * 
 * @export
 * @interface ContractReminderSettingsDto
 */
export interface ContractReminderSettingsDto {
    /**
     * 
     * @type {ContractReminderDto}
     * @memberof ContractReminderSettingsDto
     */
    'ofDamageDetectionToCustomer'?: ContractReminderDto;
    /**
     * 
     * @type {ContractReminderDto}
     * @memberof ContractReminderSettingsDto
     */
    'ofDamageCostEvaluationToCustomer'?: ContractReminderDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ContractReminderType = {
    None: 'None',
    DamageDetectionToCustomer: 'DamageDetectionToCustomer',
    DamageCostEvaluationToCustomer: 'DamageCostEvaluationToCustomer'
} as const;

export type ContractReminderType = typeof ContractReminderType[keyof typeof ContractReminderType];


/**
 * 
 * @export
 * @interface ContractReminderUpdateDto
 */
export interface ContractReminderUpdateDto {
    /**
     * 
     * @type {boolean}
     * @memberof ContractReminderUpdateDto
     */
    'isEnabled'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractReminderUpdateDto
     */
    'nextFireAt'?: string;
}
/**
 * 
 * @export
 * @interface ContractReminderUpdatedDto
 */
export interface ContractReminderUpdatedDto {
    /**
     * 
     * @type {ContractDto}
     * @memberof ContractReminderUpdatedDto
     */
    'contract'?: ContractDto;
    /**
     * 
     * @type {ContractReminderDto}
     * @memberof ContractReminderUpdatedDto
     */
    'reminder'?: ContractReminderDto;
}
/**
 * 
 * @export
 * @interface ContractSearchPaginatedDto
 */
export interface ContractSearchPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof ContractSearchPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractSearchPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractSearchPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractSearchPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractSearchPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractSearchPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof ContractSearchPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof ContractSearchPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof ContractSearchPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ContractSearchPaginatedDto
     */
    'id'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof ContractSearchPaginatedDto
     */
    'createdAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof ContractSearchPaginatedDto
     */
    'updatedAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ContractSearchPaginatedDto
     */
    'createdBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof ContractSearchPaginatedDto
     */
    'updatedBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {string}
     * @memberof ContractSearchPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractSearchPaginatedDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractSearchPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractSearchPaginatedDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {Array<ContractType>}
     * @memberof ContractSearchPaginatedDto
     */
    'types'?: Array<ContractType> | null;
    /**
     * 
     * @type {ContractStage}
     * @memberof ContractSearchPaginatedDto
     */
    'stage'?: ContractStage;
    /**
     * 
     * @type {Array<ContractStage>}
     * @memberof ContractSearchPaginatedDto
     */
    'stages'?: Array<ContractStage> | null;
    /**
     * 
     * @type {ContractStage}
     * @memberof ContractSearchPaginatedDto
     */
    'excludeStage'?: ContractStage;
    /**
     * 
     * @type {Array<ContractStage>}
     * @memberof ContractSearchPaginatedDto
     */
    'excludeStages'?: Array<ContractStage> | null;
    /**
     * 
     * @type {AllocationStatus}
     * @memberof ContractSearchPaginatedDto
     */
    'allocationStatus'?: AllocationStatus;
    /**
     * 
     * @type {ContractFilterType}
     * @memberof ContractSearchPaginatedDto
     */
    'filterType'?: ContractFilterType;
    /**
     * 
     * @type {ContractB2CStatus}
     * @memberof ContractSearchPaginatedDto
     */
    'b2CStatus'?: ContractB2CStatus;
    /**
     * 
     * @type {ContractGetCountersDtoRangeByFilterTypeMap}
     * @memberof ContractSearchPaginatedDto
     */
    'rangeByFilterTypeMap'?: ContractGetCountersDtoRangeByFilterTypeMap | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractSearchPaginatedDto
     */
    'isPreparedForCheckOut'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractSearchPaginatedDto
     */
    'isPreparedForCheckIn'?: boolean | null;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof ContractSearchPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * <inheritdoc cref=\"T:Domain.Entities.Contract.Common.ContractSettings\" />
 * @export
 * @interface ContractSettingsDto
 */
export interface ContractSettingsDto {
    /**
     * 
     * @type {boolean}
     * @memberof ContractSettingsDto
     */
    'isRequireStartDate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractSettingsDto
     */
    'isRequireEndDate'?: boolean;
    /**
     * Enable/disable vehicle checkin/checkout.
     * @type {boolean}
     * @memberof ContractSettingsDto
     */
    'isCheckEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractSettingsDto
     */
    'isRequireVisualInspectionBeforeCheckOut'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractSettingsDto
     */
    'isRequireVisualInspectionBeforeCheckIn'?: boolean;
    /**
     * 
     * @type {CustomerAcknowledgementSettingsDto}
     * @memberof ContractSettingsDto
     */
    'vehicleStateAckOnCheckOut'?: CustomerAcknowledgementSettingsDto;
    /**
     * 
     * @type {string}
     * @memberof ContractSettingsDto
     */
    'defaultVehicleStateAckShortText'?: string;
}
/**
 * <inheritdoc cref=\"T:Domain.Entities.Contract.Common.ContractSettings\" />
 * @export
 * @interface ContractSettingsInputDto
 */
export interface ContractSettingsInputDto {
    /**
     * 
     * @type {boolean}
     * @memberof ContractSettingsInputDto
     */
    'isRequireStartDate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractSettingsInputDto
     */
    'isRequireEndDate'?: boolean;
    /**
     * Enable/disable vehicle checkin/checkout.
     * @type {boolean}
     * @memberof ContractSettingsInputDto
     */
    'isCheckEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractSettingsInputDto
     */
    'isRequireVisualInspectionBeforeCheckOut'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractSettingsInputDto
     */
    'isRequireVisualInspectionBeforeCheckIn'?: boolean;
    /**
     * 
     * @type {CustomerAcknowledgementSettingsInputDto}
     * @memberof ContractSettingsInputDto
     */
    'vehicleStateAckOnCheckOut'?: CustomerAcknowledgementSettingsInputDto;
}
/**
 * 
 * @export
 * @interface ContractSpotInfoDto
 */
export interface ContractSpotInfoDto {
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractSpotInfoDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractSpotInfoDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractSpotInfoDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractSpotInfoDto
     */
    'productLocationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractSpotInfoDto
     */
    'visualInspectionId'?: string | null;
    /**
     * 
     * @type {SpotFullReferenceDto}
     * @memberof ContractSpotInfoDto
     */
    'spot'?: SpotFullReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof ContractSpotInfoDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {FileReferenceDto}
     * @memberof ContractSpotInfoDto
     */
    'vehicleActualStatePdf'?: FileReferenceDto;
    /**
     * 
     * @type {CustomerAcknowledgementDto}
     * @memberof ContractSpotInfoDto
     */
    'vehicleStateAck'?: CustomerAcknowledgementDto;
    /**
     * Whether check out, check in (or other related activity) is completed.
     * @type {boolean}
     * @memberof ContractSpotInfoDto
     */
    'isCompleted'?: boolean;
}
/**
 * 
 * @export
 * @interface ContractSpotInfoInputDto
 */
export interface ContractSpotInfoInputDto {
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ContractSpotInfoInputDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractSpotInfoInputDto
     */
    'visualInspectionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractSpotInfoInputDto
     */
    'spotId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractSpotInfoInputDto
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface ContractSpotInfoVisualInspectionInputDto
 */
export interface ContractSpotInfoVisualInspectionInputDto {
    /**
     * 
     * @type {string}
     * @memberof ContractSpotInfoVisualInspectionInputDto
     */
    'visualInspectionId'?: string | null;
}
/**
 * NB: use SortOrderAttribute to specify the order in which stages can be activated.
 * @export
 * @enum {string}
 */

export const ContractStage = {
    None: 'None',
    Draft: 'Draft',
    Reserved: 'Reserved',
    Pending: 'Pending',
    Active: 'Active',
    Completed: 'Completed',
    Closed: 'Closed',
    Cancelled: 'Cancelled',
    ReservationExpired: 'ReservationExpired'
} as const;

export type ContractStage = typeof ContractStage[keyof typeof ContractStage];


/**
 * 
 * @export
 * @interface ContractStageUpdateDto
 */
export interface ContractStageUpdateDto {
    /**
     * 
     * @type {ContractStage}
     * @memberof ContractStageUpdateDto
     */
    'newStage'?: ContractStage;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ContractType = {
    None: 'None',
    Rental: 'Rental',
    Leasing: 'Leasing',
    Carsharing: 'Carsharing',
    Subscription: 'Subscription'
} as const;

export type ContractType = typeof ContractType[keyof typeof ContractType];


/**
 * 
 * @export
 * @interface ContractUpdateDto
 */
export interface ContractUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof ContractUpdateDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractUpdateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractUpdateDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractUpdateDto
     */
    'accessoryIds'?: Array<string> | null;
    /**
     * 
     * @type {ContractType}
     * @memberof ContractUpdateDto
     */
    'type'?: ContractType;
    /**
     * Start of contract Active stage. Inclusive date.  NB: Contracts with both empty StartsAt and EndsAt are treated as having zero duration.
     * @type {string}
     * @memberof ContractUpdateDto
     */
    'startsAt'?: string | null;
    /**
     * End of contract Active stage. Exclusive date.
     * @type {string}
     * @memberof ContractUpdateDto
     */
    'endsAt'?: string | null;
    /**
     * Additional time before the start, added to the overall duration, ensuring a gap before the vehicle is available for the next contract.
     * @type {string}
     * @memberof ContractUpdateDto
     */
    'bufferBefore'?: string | null;
    /**
     * Additional time after the end, added to the overall duration, ensuring a gap after the vehicle is available for the next contract.
     * @type {string}
     * @memberof ContractUpdateDto
     */
    'bufferAfter'?: string | null;
    /**
     * Date when the stage is automatically updated to ReservationExpired.    Applies only to Reserved stage.
     * @type {string}
     * @memberof ContractUpdateDto
     */
    'reservationExpiresAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractUpdateDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof ContractUpdateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {ContractSettingsInputDto}
     * @memberof ContractUpdateDto
     */
    'settings'?: ContractSettingsInputDto;
    /**
     * 
     * @type {ContractSpotInfoInputDto}
     * @memberof ContractUpdateDto
     */
    'checkOutSpotInfo'?: ContractSpotInfoInputDto;
    /**
     * 
     * @type {ContractSpotInfoInputDto}
     * @memberof ContractUpdateDto
     */
    'checkInSpotInfo'?: ContractSpotInfoInputDto;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof ContractUpdateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}


/**
 * 
 * @export
 * @interface ContractVehicleCheckInDto
 */
export interface ContractVehicleCheckInDto {
    /**
     * 
     * @type {ContractSpotInfoInputDto}
     * @memberof ContractVehicleCheckInDto
     */
    'spotInfo'?: ContractSpotInfoInputDto;
}
/**
 * 
 * @export
 * @interface ContractVehicleCheckOutDto
 */
export interface ContractVehicleCheckOutDto {
    /**
     * 
     * @type {ContractSpotInfoInputDto}
     * @memberof ContractVehicleCheckOutDto
     */
    'spotInfo'?: ContractSpotInfoInputDto;
    /**
     * 
     * @type {CustomerAcknowledgementInputDto}
     * @memberof ContractVehicleCheckOutDto
     */
    'vehicleStateAck'?: CustomerAcknowledgementInputDto;
}
/**
 * 
 * @export
 * @interface CountDtoInWidgetDataOfDamageAndIssueSummaryDto
 */
export interface CountDtoInWidgetDataOfDamageAndIssueSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof CountDtoInWidgetDataOfDamageAndIssueSummaryDto
     */
    'count': number;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof CountDtoInWidgetDataOfDamageAndIssueSummaryDto
     */
    'filterDefinition': FilterDefinitionDto;
}
/**
 * 
 * @export
 * @interface CountDtoInWidgetDataOfTenantStatsAdminDto
 */
export interface CountDtoInWidgetDataOfTenantStatsAdminDto {
    /**
     * 
     * @type {number}
     * @memberof CountDtoInWidgetDataOfTenantStatsAdminDto
     */
    'count': number;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof CountDtoInWidgetDataOfTenantStatsAdminDto
     */
    'filterDefinition': FilterDefinitionDto;
}
/**
 * 
 * @export
 * @interface CountDtoInWidgetDataOfVehicleInFlowSummaryDto
 */
export interface CountDtoInWidgetDataOfVehicleInFlowSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof CountDtoInWidgetDataOfVehicleInFlowSummaryDto
     */
    'count': number;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof CountDtoInWidgetDataOfVehicleInFlowSummaryDto
     */
    'filterDefinition': FilterDefinitionDto;
}
/**
 * 
 * @export
 * @interface CountDtoOfDamageCostEvaluationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
 */
export interface CountDtoOfDamageCostEvaluationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof CountDtoOfDamageCostEvaluationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
     */
    'count': number;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof CountDtoOfDamageCostEvaluationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
     */
    'filterDefinition': FilterDefinitionDto;
}
/**
 * 
 * @export
 * @interface CountDtoOfMaintenanceGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
 */
export interface CountDtoOfMaintenanceGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof CountDtoOfMaintenanceGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
     */
    'count': number;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof CountDtoOfMaintenanceGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
     */
    'filterDefinition': FilterDefinitionDto;
}
/**
 * 
 * @export
 * @interface CountDtoOfRepairOperationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
 */
export interface CountDtoOfRepairOperationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof CountDtoOfRepairOperationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
     */
    'count': number;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof CountDtoOfRepairOperationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
     */
    'filterDefinition': FilterDefinitionDto;
}
/**
 * 
 * @export
 * @interface CountDtoOfTenantRequestGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
 */
export interface CountDtoOfTenantRequestGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof CountDtoOfTenantRequestGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
     */
    'count': number;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof CountDtoOfTenantRequestGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
     */
    'filterDefinition': FilterDefinitionDto;
}
/**
 * 
 * @export
 * @interface CountDtoOfWashGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
 */
export interface CountDtoOfWashGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof CountDtoOfWashGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
     */
    'count': number;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof CountDtoOfWashGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
     */
    'filterDefinition': FilterDefinitionDto;
}
/**
 * 
 * @export
 * @interface CountDtoOfWheelOperationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
 */
export interface CountDtoOfWheelOperationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof CountDtoOfWheelOperationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
     */
    'count': number;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof CountDtoOfWheelOperationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto
     */
    'filterDefinition': FilterDefinitionDto;
}
/**
 * ISO 3166 two-letter code (alpha-2).
 * @export
 * @enum {string}
 */

export const CountryCode = {
    None: 'None',
    Af: 'AF',
    Ax: 'AX',
    Al: 'AL',
    Dz: 'DZ',
    As: 'AS',
    Ad: 'AD',
    Ao: 'AO',
    Ai: 'AI',
    Aq: 'AQ',
    Ag: 'AG',
    Ar: 'AR',
    Am: 'AM',
    Aw: 'AW',
    Au: 'AU',
    At: 'AT',
    Az: 'AZ',
    Bs: 'BS',
    Bh: 'BH',
    Bd: 'BD',
    Bb: 'BB',
    By: 'BY',
    Be: 'BE',
    Bz: 'BZ',
    Bj: 'BJ',
    Bm: 'BM',
    Bt: 'BT',
    Bo: 'BO',
    Bq: 'BQ',
    Ba: 'BA',
    Bw: 'BW',
    Bv: 'BV',
    Br: 'BR',
    Io: 'IO',
    Bn: 'BN',
    Bg: 'BG',
    Bf: 'BF',
    Bi: 'BI',
    Cv: 'CV',
    Kh: 'KH',
    Cm: 'CM',
    Ca: 'CA',
    Ky: 'KY',
    Cf: 'CF',
    Td: 'TD',
    Cl: 'CL',
    Cn: 'CN',
    Cx: 'CX',
    Cc: 'CC',
    Co: 'CO',
    Km: 'KM',
    Cd: 'CD',
    Cg: 'CG',
    Ck: 'CK',
    Cr: 'CR',
    Ci: 'CI',
    Hr: 'HR',
    Cu: 'CU',
    Cw: 'CW',
    Cy: 'CY',
    Cz: 'CZ',
    Dk: 'DK',
    Dj: 'DJ',
    Dm: 'DM',
    Do: 'DO',
    Ec: 'EC',
    Eg: 'EG',
    Sv: 'SV',
    Gq: 'GQ',
    Er: 'ER',
    Ee: 'EE',
    Sz: 'SZ',
    Et: 'ET',
    Fk: 'FK',
    Fo: 'FO',
    Fj: 'FJ',
    Fi: 'FI',
    Fr: 'FR',
    Gf: 'GF',
    Pf: 'PF',
    Tf: 'TF',
    Ga: 'GA',
    Gm: 'GM',
    Ge: 'GE',
    De: 'DE',
    Gh: 'GH',
    Gi: 'GI',
    Gr: 'GR',
    Gl: 'GL',
    Gd: 'GD',
    Gp: 'GP',
    Gu: 'GU',
    Gt: 'GT',
    Gg: 'GG',
    Gn: 'GN',
    Gw: 'GW',
    Gy: 'GY',
    Ht: 'HT',
    Hm: 'HM',
    Va: 'VA',
    Hn: 'HN',
    Hk: 'HK',
    Hu: 'HU',
    Is: 'IS',
    In: 'IN',
    Id: 'ID',
    Ir: 'IR',
    Iq: 'IQ',
    Ie: 'IE',
    Im: 'IM',
    Il: 'IL',
    It: 'IT',
    Jm: 'JM',
    Jp: 'JP',
    Je: 'JE',
    Jo: 'JO',
    Kz: 'KZ',
    Ke: 'KE',
    Ki: 'KI',
    Kp: 'KP',
    Kr: 'KR',
    Kw: 'KW',
    Kg: 'KG',
    La: 'LA',
    Lv: 'LV',
    Lb: 'LB',
    Ls: 'LS',
    Lr: 'LR',
    Ly: 'LY',
    Li: 'LI',
    Lt: 'LT',
    Lu: 'LU',
    Mo: 'MO',
    Mk: 'MK',
    Mg: 'MG',
    Mw: 'MW',
    My: 'MY',
    Mv: 'MV',
    Ml: 'ML',
    Mt: 'MT',
    Mh: 'MH',
    Mq: 'MQ',
    Mr: 'MR',
    Mu: 'MU',
    Yt: 'YT',
    Mx: 'MX',
    Fm: 'FM',
    Md: 'MD',
    Mc: 'MC',
    Mn: 'MN',
    Me: 'ME',
    Ms: 'MS',
    Ma: 'MA',
    Mz: 'MZ',
    Mm: 'MM',
    Na: 'NA',
    Nr: 'NR',
    Np: 'NP',
    Nl: 'NL',
    Nc: 'NC',
    Nz: 'NZ',
    Ni: 'NI',
    Ne: 'NE',
    Ng: 'NG',
    Nu: 'NU',
    Nf: 'NF',
    Mp: 'MP',
    No: 'NO',
    Om: 'OM',
    Pk: 'PK',
    Pw: 'PW',
    Ps: 'PS',
    Pa: 'PA',
    Pg: 'PG',
    Py: 'PY',
    Pe: 'PE',
    Ph: 'PH',
    Pn: 'PN',
    Pl: 'PL',
    Pt: 'PT',
    Pr: 'PR',
    Qa: 'QA',
    Re: 'RE',
    Ro: 'RO',
    Ru: 'RU',
    Rw: 'RW',
    Bl: 'BL',
    Sh: 'SH',
    Kn: 'KN',
    Lc: 'LC',
    Mf: 'MF',
    Pm: 'PM',
    Vc: 'VC',
    Ws: 'WS',
    Sm: 'SM',
    St: 'ST',
    Sa: 'SA',
    Sn: 'SN',
    Rs: 'RS',
    Sc: 'SC',
    Sl: 'SL',
    Sg: 'SG',
    Sx: 'SX',
    Sk: 'SK',
    Si: 'SI',
    Sb: 'SB',
    So: 'SO',
    Za: 'ZA',
    Gs: 'GS',
    Ss: 'SS',
    Es: 'ES',
    Lk: 'LK',
    Sd: 'SD',
    Sr: 'SR',
    Sj: 'SJ',
    Se: 'SE',
    Ch: 'CH',
    Sy: 'SY',
    Tw: 'TW',
    Tj: 'TJ',
    Tz: 'TZ',
    Th: 'TH',
    Tl: 'TL',
    Tg: 'TG',
    Tk: 'TK',
    To: 'TO',
    Tt: 'TT',
    Tn: 'TN',
    Tr: 'TR',
    Tm: 'TM',
    Tc: 'TC',
    Tv: 'TV',
    Ug: 'UG',
    Ua: 'UA',
    Ae: 'AE',
    Gb: 'GB',
    Um: 'UM',
    Us: 'US',
    Uy: 'UY',
    Uz: 'UZ',
    Vu: 'VU',
    Ve: 'VE',
    Vn: 'VN',
    Vg: 'VG',
    Vi: 'VI',
    Wf: 'WF',
    Eh: 'EH',
    Ye: 'YE',
    Zm: 'ZM',
    Zw: 'ZW'
} as const;

export type CountryCode = typeof CountryCode[keyof typeof CountryCode];


/**
 * 
 * @export
 * @interface CreateAccessoryCheckDto
 */
export interface CreateAccessoryCheckDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAccessoryCheckDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAccessoryCheckDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessoryCheckDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessoryCheckDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessoryCheckDto
     */
    'externalNumber'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CreateAccessoryCheckDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorInputDto}
     * @memberof CreateAccessoryCheckDto
     */
    'inspector'?: GeneralInspectorInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAccessoryCheckDto
     */
    'isUseSupplierBranding'?: boolean;
    /**
     * 
     * @type {Array<CreateAccessoryCheckItemDto>}
     * @memberof CreateAccessoryCheckDto
     */
    'items'?: Array<CreateAccessoryCheckItemDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof CreateAccessoryCheckDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessoryCheckDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {TenantRequestsMetaInputDto}
     * @memberof CreateAccessoryCheckDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaInputDto;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof CreateAccessoryCheckDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}
/**
 * 
 * @export
 * @interface CreateAccessoryCheckItemDto
 */
export interface CreateAccessoryCheckItemDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAccessoryCheckItemDto
     */
    'accessoryId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessoryCheckItemDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {AccessoryStatus}
     * @memberof CreateAccessoryCheckItemDto
     */
    'status'?: AccessoryStatus;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessoryCheckItemDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof CreateAccessoryCheckItemDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
}


/**
 * 
 * @export
 * @interface CreateAccessoryDto
 */
export interface CreateAccessoryDto {
    /**
     * 
     * @type {AccessoryType}
     * @memberof CreateAccessoryDto
     */
    'type'?: AccessoryType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof CreateAccessoryDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessoryDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessoryDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof CreateAccessoryDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}


/**
 * 
 * @export
 * @interface CreateCompanyDto
 */
export interface CreateCompanyDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {TenantType}
     * @memberof CreateCompanyDto
     */
    'type'?: TenantType;
    /**
     * 
     * @type {CreateDepartmentDto}
     * @memberof CreateCompanyDto
     */
    'department'?: CreateDepartmentDto;
}


/**
 * 
 * @export
 * @interface CreateContractCustomerCommunicationEntryDto
 */
export interface CreateContractCustomerCommunicationEntryDto {
    /**
     * 
     * @type {string}
     * @memberof CreateContractCustomerCommunicationEntryDto
     */
    'customerContactId'?: string;
    /**
     * 
     * @type {ContactChannel}
     * @memberof CreateContractCustomerCommunicationEntryDto
     */
    'contactChannel'?: ContactChannel;
    /**
     * 
     * @type {Array<ContractCommunicationSubjectType>}
     * @memberof CreateContractCustomerCommunicationEntryDto
     */
    'subjectTypes'?: Array<ContractCommunicationSubjectType>;
    /**
     * 
     * @type {string}
     * @memberof CreateContractCustomerCommunicationEntryDto
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateContractCustomerCommunicationEntryDto
     */
    'notes'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CreateContractCustomerCommunicationEntryDto
     */
    'contactedAt'?: string | null;
}


/**
 * 
 * @export
 * @interface CreateDamageDetectionDto
 */
export interface CreateDamageDetectionDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDamageDetectionDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDamageDetectionDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDamageDetectionDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDamageDetectionDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDamageDetectionDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDamageDetectionDto
     */
    'vehicleVisualModelId'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CreateDamageDetectionDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorInputDto}
     * @memberof CreateDamageDetectionDto
     */
    'inspector'?: GeneralInspectorInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDamageDetectionDto
     */
    'isUseSupplierBranding'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateDamageDetectionDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {VehicleMileageInputDto}
     * @memberof CreateDamageDetectionDto
     */
    'mileage'?: VehicleMileageInputDto;
    /**
     * 
     * @type {string}
     * @memberof CreateDamageDetectionDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDamageDetectionDto
     */
    'isNoDamagesDetected'?: boolean;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof CreateDamageDetectionDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof CreateDamageDetectionDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {Array<CreateDamageDetectionItemDto>}
     * @memberof CreateDamageDetectionDto
     */
    'items'?: Array<CreateDamageDetectionItemDto>;
    /**
     * 
     * @type {TenantRequestsMetaInputDto}
     * @memberof CreateDamageDetectionDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaInputDto;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof CreateDamageDetectionDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {DamageDetectionSendToExternalDamageCostEvaluationInlineDto}
     * @memberof CreateDamageDetectionDto
     */
    'sendToExternalCostEvaluation'?: DamageDetectionSendToExternalDamageCostEvaluationInlineDto;
}
/**
 * 
 * @export
 * @interface CreateDamageDetectionItemDto
 */
export interface CreateDamageDetectionItemDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDamageDetectionItemDto
     */
    'partTypeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDamageDetectionItemDto
     */
    'damageTypeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDamageDetectionItemDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof CreateDamageDetectionItemDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {VehicleArea}
     * @memberof CreateDamageDetectionItemDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof CreateDamageDetectionItemDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {GeneralSvgPointDto}
     * @memberof CreateDamageDetectionItemDto
     */
    'point'?: GeneralSvgPointDto;
}


/**
 * 
 * @export
 * @interface CreateDepartmentDto
 */
export interface CreateDepartmentDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDepartmentDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDepartmentDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAddressInputDto}
     * @memberof CreateDepartmentDto
     */
    'address'?: GeneralAddressInputDto;
    /**
     * 
     * @type {GeneralContactInputDto}
     * @memberof CreateDepartmentDto
     */
    'contact'?: GeneralContactInputDto;
    /**
     * 
     * @type {GeneralBrandingInputDto}
     * @memberof CreateDepartmentDto
     */
    'branding'?: GeneralBrandingInputDto;
}
/**
 * 
 * @export
 * @interface CreateGroupChatDto
 */
export interface CreateGroupChatDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateGroupChatDto
     */
    'isOnBehalfOfUser'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateGroupChatDto
     */
    'isAutoJoin'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupChatDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CreateLocationDto
 */
export interface CreateLocationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAddressInputDto}
     * @memberof CreateLocationDto
     */
    'address'?: GeneralAddressInputDto;
    /**
     * 
     * @type {GeneralContactInputDto}
     * @memberof CreateLocationDto
     */
    'contact'?: GeneralContactInputDto;
}
/**
 * 
 * @export
 * @interface CreateMaintenanceDto
 */
export interface CreateMaintenanceDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateMaintenanceDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateMaintenanceDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceDto
     */
    'supplierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {MaintenanceScheduleType}
     * @memberof CreateMaintenanceDto
     */
    'scheduleType'?: MaintenanceScheduleType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CreateMaintenanceDto
     */
    'scheduledAt'?: string | null;
    /**
     * 
     * @type {GeneralByWhoInputDto}
     * @memberof CreateMaintenanceDto
     */
    'responsibleUser'?: GeneralByWhoInputDto;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof CreateMaintenanceDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {VehicleMileageInputDto}
     * @memberof CreateMaintenanceDto
     */
    'mileage'?: VehicleMileageInputDto;
    /**
     * 
     * @type {number}
     * @memberof CreateMaintenanceDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMaintenanceDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof CreateMaintenanceDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof CreateMaintenanceDto
     */
    'tax'?: GeneralTaxInputDto;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof CreateMaintenanceDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof CreateMaintenanceDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {TenantRequestsMetaInputDto}
     * @memberof CreateMaintenanceDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaInputDto;
    /**
     * 
     * @type {GeneralStageUpdateDtoOfMaintenanceStage}
     * @memberof CreateMaintenanceDto
     */
    'newStage'?: GeneralStageUpdateDtoOfMaintenanceStage;
}


/**
 * 
 * @export
 * @interface CreateNegotiationProposalDto
 */
export interface CreateNegotiationProposalDto {
    /**
     * 
     * @type {string}
     * @memberof CreateNegotiationProposalDto
     */
    'createFromProposalId'?: string | null;
    /**
     * 
     * @type {NegotiationType}
     * @memberof CreateNegotiationProposalDto
     */
    'type'?: NegotiationType;
    /**
     * 
     * @type {string}
     * @memberof CreateNegotiationProposalDto
     */
    'statement'?: string;
    /**
     * 
     * @type {NegotiationProposalSettingsDto}
     * @memberof CreateNegotiationProposalDto
     */
    'settings'?: NegotiationProposalSettingsDto;
    /**
     * 
     * @type {CreateNegotiationProposalValueDto}
     * @memberof CreateNegotiationProposalDto
     */
    'value'?: CreateNegotiationProposalValueDto;
}


/**
 * 
 * @export
 * @interface CreateNegotiationProposalValueDto
 */
export interface CreateNegotiationProposalValueDto {
    /**
     * 
     * @type {NegotiationValueType}
     * @memberof CreateNegotiationProposalValueDto
     */
    'valueType'?: NegotiationValueType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateNegotiationProposalValueDto
     */
    'bool'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateNegotiationProposalValueDto
     */
    'string'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNegotiationProposalValueDto
     */
    'int32'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNegotiationProposalValueDto
     */
    'double'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNegotiationProposalValueDto
     */
    'decimal'?: number | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CreateNegotiationProposalValueDto
     */
    'dateTime'?: string | null;
    /**
     * 
     * @type {CreateNegotiationProposalValuePriceDto}
     * @memberof CreateNegotiationProposalValueDto
     */
    'price'?: CreateNegotiationProposalValuePriceDto;
}


/**
 * 
 * @export
 * @interface CreateNegotiationProposalValuePriceDto
 */
export interface CreateNegotiationProposalValuePriceDto {
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof CreateNegotiationProposalValuePriceDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {GeneralPriceInputDto}
     * @memberof CreateNegotiationProposalValuePriceDto
     */
    'price'?: GeneralPriceInputDto;
    /**
     * 
     * @type {GeneralPriceInputDto}
     * @memberof CreateNegotiationProposalValuePriceDto
     */
    'minPrice'?: GeneralPriceInputDto;
    /**
     * 
     * @type {GeneralPriceInputDto}
     * @memberof CreateNegotiationProposalValuePriceDto
     */
    'maxPrice'?: GeneralPriceInputDto;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof CreateNegotiationProposalValuePriceDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof CreateNegotiationProposalValuePriceDto
     */
    'tax'?: GeneralTaxInputDto;
}
/**
 * 
 * @export
 * @interface CreatePersonalChatDto
 */
export interface CreatePersonalChatDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreatePersonalChatDto
     */
    'isOnBehalfOfUser'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePersonalChatDto
     */
    'isAutoJoin'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonalChatDto
     */
    'interlocutorUserId'?: string;
}
/**
 * 
 * @export
 * @interface CreateProductLocationDto
 */
export interface CreateProductLocationDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductLocationDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductLocationDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProductLocationDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductLocationDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAddressInputDto}
     * @memberof CreateProductLocationDto
     */
    'address'?: GeneralAddressInputDto;
}
/**
 * 
 * @export
 * @interface CreateRepairMaterialDto
 */
export interface CreateRepairMaterialDto {
    /**
     * 
     * @type {string}
     * @memberof CreateRepairMaterialDto
     */
    'repairCatalogId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairMaterialDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairMaterialDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof CreateRepairMaterialDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairMaterialDto
     */
    'brandName'?: string | null;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof CreateRepairMaterialDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {number}
     * @memberof CreateRepairMaterialDto
     */
    'price'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRepairMaterialDto
     */
    'isDividable'?: boolean;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof CreateRepairMaterialDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof CreateRepairMaterialDto
     */
    'tax'?: GeneralTaxInputDto;
}


/**
 * 
 * @export
 * @interface CreateRepairOperationDto
 */
export interface CreateRepairOperationDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRepairOperationDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRepairOperationDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairOperationDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairOperationDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairOperationDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairOperationDto
     */
    'supplierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairOperationDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairOperationDto
     */
    'description'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CreateRepairOperationDto
     */
    'date'?: string;
    /**
     * 
     * @type {GeneralByWhoInputDto}
     * @memberof CreateRepairOperationDto
     */
    'responsibleUser'?: GeneralByWhoInputDto;
    /**
     * 
     * @type {VehicleMileageInputDto}
     * @memberof CreateRepairOperationDto
     */
    'mileage'?: VehicleMileageInputDto;
    /**
     * 
     * @type {number}
     * @memberof CreateRepairOperationDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof CreateRepairOperationDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {Array<RepairOperationItemInputDto>}
     * @memberof CreateRepairOperationDto
     */
    'items'?: Array<RepairOperationItemInputDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairOperationDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof CreateRepairOperationDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {TenantRequestsMetaInputDto}
     * @memberof CreateRepairOperationDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaInputDto;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof CreateRepairOperationDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {GeneralStageUpdateDtoOfRepairOperationStage}
     * @memberof CreateRepairOperationDto
     */
    'newStage'?: GeneralStageUpdateDtoOfRepairOperationStage;
}
/**
 * 
 * @export
 * @interface CreateRepairSparePartDto
 */
export interface CreateRepairSparePartDto {
    /**
     * 
     * @type {string}
     * @memberof CreateRepairSparePartDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairSparePartDto
     */
    'partNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairSparePartDto
     */
    'brandName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairSparePartDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof CreateRepairSparePartDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {VehicleType}
     * @memberof CreateRepairSparePartDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairSparePartDto
     */
    'partTypeId'?: string | null;
    /**
     * 
     * @type {Array<RepairSparePartDetalizationInputDto>}
     * @memberof CreateRepairSparePartDto
     */
    'detalizations'?: Array<RepairSparePartDetalizationInputDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof CreateRepairSparePartDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof CreateRepairSparePartDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {number}
     * @memberof CreateRepairSparePartDto
     */
    'price'?: number | null;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof CreateRepairSparePartDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof CreateRepairSparePartDto
     */
    'tax'?: GeneralTaxInputDto;
}


/**
 * 
 * @export
 * @interface CreateRepairSpecDto
 */
export interface CreateRepairSpecDto {
    /**
     * 
     * @type {string}
     * @memberof CreateRepairSpecDto
     */
    'sourceTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairSpecDto
     */
    'repairCatalogId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairSpecDto
     */
    'sourceSpecId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairSpecDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairSpecDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof CreateRepairSpecDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof CreateRepairSpecDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairSpecDto
     */
    'damageTypeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairSpecDto
     */
    'partTypeId'?: string;
    /**
     * 
     * @type {RepairSpecDetalizationInputDto}
     * @memberof CreateRepairSpecDto
     */
    'detalization'?: RepairSpecDetalizationInputDto;
    /**
     * 
     * @type {number}
     * @memberof CreateRepairSpecDto
     */
    'spotFactor'?: number;
    /**
     * 
     * @type {Array<RepairSpecItemInputDto>}
     * @memberof CreateRepairSpecDto
     */
    'items'?: Array<RepairSpecItemInputDto>;
}


/**
 * 
 * @export
 * @interface CreateRepairWorkDto
 */
export interface CreateRepairWorkDto {
    /**
     * 
     * @type {string}
     * @memberof CreateRepairWorkDto
     */
    'repairCatalogId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairWorkDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRepairWorkDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof CreateRepairWorkDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof CreateRepairWorkDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {number}
     * @memberof CreateRepairWorkDto
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRepairWorkDto
     */
    'expendablesPercent'?: number;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof CreateRepairWorkDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof CreateRepairWorkDto
     */
    'tax'?: GeneralTaxInputDto;
}


/**
 * 
 * @export
 * @interface CreateSpotDto
 */
export interface CreateSpotDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSpotDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSpotDto
     */
    'productLocationId'?: string | null;
    /**
     * 
     * @type {Array<SpotType>}
     * @memberof CreateSpotDto
     */
    'types'?: Array<SpotType>;
    /**
     * 
     * @type {string}
     * @memberof CreateSpotDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSpotDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAddressInputDto}
     * @memberof CreateSpotDto
     */
    'address'?: GeneralAddressInputDto;
    /**
     * 
     * @type {GeneralGeolocationInputDto}
     * @memberof CreateSpotDto
     */
    'geolocation'?: GeneralGeolocationInputDto;
}
/**
 * 
 * @export
 * @interface CreateSupplierContactDto
 */
export interface CreateSupplierContactDto {
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof CreateSupplierContactDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof CreateSupplierContactDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSupplierContactDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {GeneralNationalIdentityNumberInputDto}
     * @memberof CreateSupplierContactDto
     */
    'nationalIdentityNumber'?: GeneralNationalIdentityNumberInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSupplierContactDto
     */
    'isPrimary'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateSupplierDto
 */
export interface CreateSupplierDto {
    /**
     * 
     * @type {Array<SupplierType>}
     * @memberof CreateSupplierDto
     */
    'types'?: Array<SupplierType>;
    /**
     * 
     * @type {string}
     * @memberof CreateSupplierDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSupplierDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {GeneralAddressInputDto}
     * @memberof CreateSupplierDto
     */
    'address'?: GeneralAddressInputDto;
    /**
     * 
     * @type {Array<CreateSupplierContactDto>}
     * @memberof CreateSupplierDto
     */
    'contacts'?: Array<CreateSupplierContactDto>;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof CreateSupplierDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSupplierDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSupplierDto
     */
    'locationIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CreateTenantRoleDto
 */
export interface CreateTenantRoleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRoleDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRoleDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<AppPermission>}
     * @memberof CreateTenantRoleDto
     */
    'permissions'?: Array<AppPermission> | null;
}
/**
 * 
 * @export
 * @interface CreateVehicleDto
 */
export interface CreateVehicleDto {
    /**
     * 
     * @type {VehicleSpecInputDto}
     * @memberof CreateVehicleDto
     */
    'spec'?: VehicleSpecInputDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateVehicleDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateVehicleDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'identificationNumber'?: string | null;
    /**
     * 
     * @type {GeneralPlateNoInputDto}
     * @memberof CreateVehicleDto
     */
    'plateNo'?: GeneralPlateNoInputDto;
    /**
     * 
     * @type {VehicleMileageInputDto}
     * @memberof CreateVehicleDto
     */
    'mileage'?: VehicleMileageInputDto;
    /**
     * 
     * @type {VehicleBatteryStateInputDto}
     * @memberof CreateVehicleDto
     */
    'batteryState'?: VehicleBatteryStateInputDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateVehicleDto
     */
    'accessoryIds'?: Array<string> | null;
    /**
     * 
     * @type {object}
     * @memberof CreateVehicleDto
     */
    'car'?: object;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof CreateVehicleDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'defaultVisualModelId'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof CreateVehicleDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {GeneralStatusInputTypedDtoOfVehicleStatus}
     * @memberof CreateVehicleDto
     */
    'status'?: GeneralStatusInputTypedDtoOfVehicleStatus;
}
/**
 * 
 * @export
 * @interface CreateWashDto
 */
export interface CreateWashDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateWashDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateWashDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWashDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWashDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWashDto
     */
    'supplierId'?: string | null;
    /**
     * 
     * @type {Array<WashType>}
     * @memberof CreateWashDto
     */
    'types'?: Array<WashType> | null;
    /**
     * 
     * @type {WashScheduleType}
     * @memberof CreateWashDto
     */
    'scheduleType'?: WashScheduleType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CreateWashDto
     */
    'scheduledAt'?: string | null;
    /**
     * 
     * @type {GeneralByWhoInputDto}
     * @memberof CreateWashDto
     */
    'responsibleUser'?: GeneralByWhoInputDto;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof CreateWashDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {VehicleMileageInputDto}
     * @memberof CreateWashDto
     */
    'mileage'?: VehicleMileageInputDto;
    /**
     * 
     * @type {number}
     * @memberof CreateWashDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateWashDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof CreateWashDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof CreateWashDto
     */
    'tax'?: GeneralTaxInputDto;
    /**
     * 
     * @type {string}
     * @memberof CreateWashDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof CreateWashDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof CreateWashDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {TenantRequestsMetaInputDto}
     * @memberof CreateWashDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaInputDto;
    /**
     * 
     * @type {GeneralStageUpdateDtoOfWashStage}
     * @memberof CreateWashDto
     */
    'newStage'?: GeneralStageUpdateDtoOfWashStage;
}


/**
 * 
 * @export
 * @interface CreateWebhookDto
 */
export interface CreateWebhookDto {
    /**
     * 
     * @type {string}
     * @memberof CreateWebhookDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWebhookDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<WebhookEventType>}
     * @memberof CreateWebhookDto
     */
    'eventTypes'?: Array<WebhookEventType>;
    /**
     * 
     * @type {string}
     * @memberof CreateWebhookDto
     */
    'url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWebhookDto
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateWheelOperationDto
 */
export interface CreateWheelOperationDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateWheelOperationDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateWheelOperationDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWheelOperationDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWheelOperationDto
     */
    'supplierId'?: string | null;
    /**
     * 
     * @type {GeneralByWhoInputDto}
     * @memberof CreateWheelOperationDto
     */
    'responsibleUser'?: GeneralByWhoInputDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CreateWheelOperationDto
     */
    'scheduledAt'?: string | null;
    /**
     * 
     * @type {WheelOperationScheduleType}
     * @memberof CreateWheelOperationDto
     */
    'scheduleType'?: WheelOperationScheduleType;
    /**
     * 
     * @type {Array<WheelServiceType>}
     * @memberof CreateWheelOperationDto
     */
    'serviceTypes'?: Array<WheelServiceType>;
    /**
     * 
     * @type {number}
     * @memberof CreateWheelOperationDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateWheelOperationDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof CreateWheelOperationDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof CreateWheelOperationDto
     */
    'tax'?: GeneralTaxInputDto;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof CreateWheelOperationDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof CreateWheelOperationDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWheelOperationDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {TenantRequestsMetaInputDto}
     * @memberof CreateWheelOperationDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaInputDto;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof CreateWheelOperationDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {GeneralStageUpdateDtoOfWheelOperationStage}
     * @memberof CreateWheelOperationDto
     */
    'newStage'?: GeneralStageUpdateDtoOfWheelOperationStage;
    /**
     * 
     * @type {string}
     * @memberof CreateWheelOperationDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {VehicleMileageInputDto}
     * @memberof CreateWheelOperationDto
     */
    'mileage'?: VehicleMileageInputDto;
}


/**
 * ISO 4217 currency code.
 * @export
 * @enum {string}
 */

export const CurrencyCode = {
    None: 'None',
    Usd: 'USD',
    Eur: 'EUR',
    Nok: 'NOK',
    Sek: 'SEK',
    Dkk: 'DKK'
} as const;

export type CurrencyCode = typeof CurrencyCode[keyof typeof CurrencyCode];


/**
 * 
 * @export
 * @interface CurrentIdentityTestDto
 */
export interface CurrentIdentityTestDto {
    /**
     * 
     * @type {string}
     * @memberof CurrentIdentityTestDto
     */
    'auth0UserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentIdentityTestDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentIdentityTestDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {Array<ClaimTestDto>}
     * @memberof CurrentIdentityTestDto
     */
    'claims'?: Array<ClaimTestDto>;
    /**
     * 
     * @type {UserIdentityTestDto}
     * @memberof CurrentIdentityTestDto
     */
    'userIdentity'?: UserIdentityTestDto;
}
/**
 * Additional object to be added under \"debug\" key to ProblemDetails.
 * @export
 * @interface CustomProblemDetailsDebugInfoDto
 */
export interface CustomProblemDetailsDebugInfoDto {
    /**
     * 
     * @type {string}
     * @memberof CustomProblemDetailsDebugInfoDto
     */
    'exceptionMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomProblemDetailsDebugInfoDto
     */
    'stackTrace'?: string | null;
}
/**
 * 
 * @export
 * @interface CustomSessionDto
 */
export interface CustomSessionDto {
    /**
     * 
     * @type {string}
     * @memberof CustomSessionDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomSessionDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSessionDto
     */
    'userIdentityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomSessionDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSessionDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {UserMembershipType}
     * @memberof CustomSessionDto
     */
    'membershipType'?: UserMembershipType;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof CustomSessionDto
     */
    'issuedBy'?: GeneralByWhoDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomSessionDto
     */
    'issuedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomSessionDto
     */
    'expiresAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomSessionDto
     */
    'allowRefresh'?: boolean;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof CustomSessionDto
     */
    'lifetimeAfterRefresh'?: string | null;
    /**
     * 
     * @type {Array<RoleReferenceDto>}
     * @memberof CustomSessionDto
     */
    'roles'?: Array<RoleReferenceDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomSessionDto
     */
    'permissions'?: Array<string>;
    /**
     * 
     * @type {Array<AppModule>}
     * @memberof CustomSessionDto
     */
    'modules'?: Array<AppModule>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomSessionDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomSessionDto
     */
    'updatedAt'?: string;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof CustomSessionDto
     */
    'lifetime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomSessionDto
     */
    'isExpired'?: boolean;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof CustomSessionDto
     */
    'lifetimeLeft'?: string | null;
}


/**
 * 
 * @export
 * @interface CustomTagChangedDto
 */
export interface CustomTagChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomTagChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CustomTagChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof CustomTagChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof CustomTagChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof CustomTagChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {CustomTagDto}
     * @memberof CustomTagChangedDto
     */
    'entity': CustomTagDto;
    /**
     * 
     * @type {string}
     * @memberof CustomTagChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface CustomTagCreateDto
 */
export interface CustomTagCreateDto {
    /**
     * 
     * @type {string}
     * @memberof CustomTagCreateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomTagCreateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {TagStylesInputDto}
     * @memberof CustomTagCreateDto
     */
    'styles'?: TagStylesInputDto;
}
/**
 * 
 * @export
 * @interface CustomTagDto
 */
export interface CustomTagDto {
    /**
     * 
     * @type {string}
     * @memberof CustomTagDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof CustomTagDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomTagDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomTagDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomTagDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomTagDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomTagDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomTagDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomTagDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {TagStylesDto}
     * @memberof CustomTagDto
     */
    'styles'?: TagStylesDto;
}


/**
 * 
 * @export
 * @interface CustomTagFullReferenceDto
 */
export interface CustomTagFullReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof CustomTagFullReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomTagFullReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomTagFullReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomTagFullReferenceDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {TagStylesDto}
     * @memberof CustomTagFullReferenceDto
     */
    'styles'?: TagStylesDto;
}
/**
 * 
 * @export
 * @interface CustomTagGetPaginatedDto
 */
export interface CustomTagGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof CustomTagGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomTagGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomTagGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomTagGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomTagGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomTagGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof CustomTagGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof CustomTagGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof CustomTagGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
}
/**
 * 
 * @export
 * @interface CustomTagReferenceDto
 */
export interface CustomTagReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof CustomTagReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomTagReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomTagReferenceDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CustomTagSearchPaginatedDto
 */
export interface CustomTagSearchPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof CustomTagSearchPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomTagSearchPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomTagSearchPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomTagSearchPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomTagSearchPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomTagSearchPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof CustomTagSearchPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof CustomTagSearchPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof CustomTagSearchPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
}
/**
 * 
 * @export
 * @interface CustomTagUpdateDto
 */
export interface CustomTagUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof CustomTagUpdateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomTagUpdateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {TagStylesInputDto}
     * @memberof CustomTagUpdateDto
     */
    'styles'?: TagStylesInputDto;
}
/**
 * Customer\'s acknowledgement of vehicle state captured in contract context (checkout or other stages if needed).
 * @export
 * @interface CustomerAcknowledgementDto
 */
export interface CustomerAcknowledgementDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerAcknowledgementDto
     */
    'id'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomerAcknowledgementDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomerAcknowledgementDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAcknowledgementDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerAcknowledgementDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {CustomerAcknowledgementType}
     * @memberof CustomerAcknowledgementDto
     */
    'type'?: CustomerAcknowledgementType;
    /**
     * 
     * @type {CustomerVerificationMethod}
     * @memberof CustomerAcknowledgementDto
     */
    'method'?: CustomerVerificationMethod;
    /**
     * 
     * @type {CustomerAcknowledgementStatus}
     * @memberof CustomerAcknowledgementDto
     */
    'status'?: CustomerAcknowledgementStatus;
    /**
     * Snapshot of acknowledgement short text shown to the customer (e.g., footer text).
     * @type {string}
     * @memberof CustomerAcknowledgementDto
     */
    'ackShortText'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerAcknowledgementDto
     */
    'isPrivacyPolicyAccepted'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomerAcknowledgementDto
     */
    'privacyPolicyAcceptedAt'?: string;
    /**
     * When customer has viewed the damage book.
     * @type {string}
     * @memberof CustomerAcknowledgementDto
     */
    'damageBookViewedAt'?: string;
    /**
     * When the signature itself is captured..
     * @type {string}
     * @memberof CustomerAcknowledgementDto
     */
    'signedAt'?: string | null;
    /**
     * When the entire acknowledgement was captured and submitted.
     * @type {string}
     * @memberof CustomerAcknowledgementDto
     */
    'capturedAt'?: string;
    /**
     * Employee user who captured the acknowledgement from the customer.
     * @type {string}
     * @memberof CustomerAcknowledgementDto
     */
    'capturedBy'?: string | null;
    /**
     * Whether email with the PDF is sent to the customer.
     * @type {boolean}
     * @memberof CustomerAcknowledgementDto
     */
    'isSentToCustomer'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomerAcknowledgementDto
     */
    'sentToCustomerAt'?: string | null;
    /**
     * 
     * @type {CustomerContactDataDto}
     * @memberof CustomerAcknowledgementDto
     */
    'contact'?: CustomerContactDataDto;
    /**
     * 
     * @type {FileReferenceDto}
     * @memberof CustomerAcknowledgementDto
     */
    'signatureImage'?: FileReferenceDto;
    /**
     * Customer\'s document photos/scans: driver’s license, ID card, passport, etc.
     * @type {Array<FileReferenceDto>}
     * @memberof CustomerAcknowledgementDto
     */
    'personalDocumentImages'?: Array<FileReferenceDto> | null;
    /**
     * 
     * @type {FileReferenceDto}
     * @memberof CustomerAcknowledgementDto
     */
    'vehicleActualStatePdf'?: FileReferenceDto;
    /**
     * 
     * @type {PersonalDataDeletionDto}
     * @memberof CustomerAcknowledgementDto
     */
    'personalDataDeletion'?: PersonalDataDeletionDto;
}


/**
 * Customer\'s acknowledgement of vehicle state captured in contract context (checkout or other stages if needed).
 * @export
 * @interface CustomerAcknowledgementInputDto
 */
export interface CustomerAcknowledgementInputDto {
    /**
     * 
     * @type {CustomerVerificationMethod}
     * @memberof CustomerAcknowledgementInputDto
     */
    'method': CustomerVerificationMethod;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerAcknowledgementInputDto
     */
    'isPrivacyPolicyAccepted': boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomerAcknowledgementInputDto
     */
    'privacyPolicyAcceptedAt': string;
    /**
     * When customer has viewed the damage book.
     * @type {string}
     * @memberof CustomerAcknowledgementInputDto
     */
    'damageBookViewedAt': string;
    /**
     * When the signature itself is captured..
     * @type {string}
     * @memberof CustomerAcknowledgementInputDto
     */
    'signedAt'?: string | null;
    /**
     * When the entire acknowledgement was captured and submitted.
     * @type {string}
     * @memberof CustomerAcknowledgementInputDto
     */
    'capturedAt': string;
    /**
     * 
     * @type {CustomerContactDataInputDto}
     * @memberof CustomerAcknowledgementInputDto
     */
    'contact': CustomerContactDataInputDto;
    /**
     * 
     * @type {FileUploadedDto}
     * @memberof CustomerAcknowledgementInputDto
     */
    'signatureImage'?: FileUploadedDto;
    /**
     * Customer\'s document photos/scans: driver’s license, ID card, passport, etc.
     * @type {Array<FileUploadedDto>}
     * @memberof CustomerAcknowledgementInputDto
     */
    'personalDocumentImages'?: Array<FileUploadedDto> | null;
}


/**
 * <inheritdoc cref=\"T:Domain.Entities.Customer.Common.CustomerAcknowledgementSettings\" />
 * @export
 * @interface CustomerAcknowledgementSettingsDto
 */
export interface CustomerAcknowledgementSettingsDto {
    /**
     * Whether customer acknowledgement flow is enabled.
     * @type {boolean}
     * @memberof CustomerAcknowledgementSettingsDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {SubmissionRequirement}
     * @memberof CustomerAcknowledgementSettingsDto
     */
    'signatureReq'?: SubmissionRequirement;
    /**
     * 
     * @type {SubmissionRequirement}
     * @memberof CustomerAcknowledgementSettingsDto
     */
    'personalDocumentImageReq'?: SubmissionRequirement;
    /**
     * Acknowledgement short text shown to the customer (e.g., footer text).
     * @type {string}
     * @memberof CustomerAcknowledgementSettingsDto
     */
    'ackShortText'?: string | null;
}


/**
 * <inheritdoc cref=\"T:Domain.Entities.Customer.Common.CustomerAcknowledgementSettings\" />
 * @export
 * @interface CustomerAcknowledgementSettingsInputDto
 */
export interface CustomerAcknowledgementSettingsInputDto {
    /**
     * Whether customer acknowledgement flow is enabled.
     * @type {boolean}
     * @memberof CustomerAcknowledgementSettingsInputDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {SubmissionRequirement}
     * @memberof CustomerAcknowledgementSettingsInputDto
     */
    'signatureReq'?: SubmissionRequirement;
    /**
     * 
     * @type {SubmissionRequirement}
     * @memberof CustomerAcknowledgementSettingsInputDto
     */
    'personalDocumentImageReq'?: SubmissionRequirement;
    /**
     * Acknowledgement short text shown to the customer (e.g., footer text).
     * @type {string}
     * @memberof CustomerAcknowledgementSettingsInputDto
     */
    'ackShortText'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CustomerAcknowledgementStatus = {
    None: 'None',
    Pending: 'Pending',
    Completed: 'Completed',
    PersonalDataDeleted: 'PersonalDataDeleted'
} as const;

export type CustomerAcknowledgementStatus = typeof CustomerAcknowledgementStatus[keyof typeof CustomerAcknowledgementStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const CustomerAcknowledgementType = {
    None: 'None',
    VehicleState: 'VehicleState'
} as const;

export type CustomerAcknowledgementType = typeof CustomerAcknowledgementType[keyof typeof CustomerAcknowledgementType];


/**
 * 
 * @export
 * @interface CustomerChangedDto
 */
export interface CustomerChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof CustomerChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof CustomerChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof CustomerChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {CustomerDto}
     * @memberof CustomerChangedDto
     */
    'entity': CustomerDto;
    /**
     * 
     * @type {string}
     * @memberof CustomerChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface CustomerContactCreateDto
 */
export interface CustomerContactCreateDto {
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof CustomerContactCreateDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactCreateDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactCreateDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {GeneralNationalIdentityNumberInputDto}
     * @memberof CustomerContactCreateDto
     */
    'nationalIdentityNumber'?: GeneralNationalIdentityNumberInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerContactCreateDto
     */
    'isPrimary'?: boolean;
}
/**
 * 
 * @export
 * @interface CustomerContactDataDto
 */
export interface CustomerContactDataDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDataDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDataDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDataDto
     */
    'contactId'?: string | null;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof CustomerContactDataDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDataDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDataDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {GeneralNationalIdentityNumberDto}
     * @memberof CustomerContactDataDto
     */
    'nationalIdentityNumber'?: GeneralNationalIdentityNumberDto;
}
/**
 * 
 * @export
 * @interface CustomerContactDataInputDto
 */
export interface CustomerContactDataInputDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDataInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDataInputDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDataInputDto
     */
    'contactId'?: string | null;
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof CustomerContactDataInputDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDataInputDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDataInputDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {GeneralNationalIdentityNumberInputDto}
     * @memberof CustomerContactDataInputDto
     */
    'nationalIdentityNumber'?: GeneralNationalIdentityNumberInputDto;
}
/**
 * 
 * @export
 * @interface CustomerContactDto
 */
export interface CustomerContactDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof CustomerContactDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {GeneralNationalIdentityNumberDto}
     * @memberof CustomerContactDto
     */
    'nationalIdentityNumber'?: GeneralNationalIdentityNumberDto;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerContactDto
     */
    'isPrimary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerContactDto
     */
    'isLinkedToExternalUser'?: boolean;
}
/**
 * 
 * @export
 * @interface CustomerContactUpdateDto
 */
export interface CustomerContactUpdateDto {
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof CustomerContactUpdateDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactUpdateDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactUpdateDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {GeneralNationalIdentityNumberInputDto}
     * @memberof CustomerContactUpdateDto
     */
    'nationalIdentityNumber'?: GeneralNationalIdentityNumberInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerContactUpdateDto
     */
    'isPrimary'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactUpdateDto
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface CustomerCreateDto
 */
export interface CustomerCreateDto {
    /**
     * 
     * @type {CustomerType}
     * @memberof CustomerCreateDto
     */
    'type'?: CustomerType;
    /**
     * 
     * @type {string}
     * @memberof CustomerCreateDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerCreateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerCreateDto
     */
    'isDriver'?: boolean | null;
    /**
     * 
     * @type {GeneralAddressInputDto}
     * @memberof CustomerCreateDto
     */
    'address'?: GeneralAddressInputDto;
    /**
     * 
     * @type {Array<CustomerContactCreateDto>}
     * @memberof CustomerCreateDto
     */
    'contacts'?: Array<CustomerContactCreateDto>;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof CustomerCreateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerCreateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerCreateDto
     */
    'locationIds'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface CustomerDto
 */
export interface CustomerDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof CustomerDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomerDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomerDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {CustomerType}
     * @memberof CustomerDto
     */
    'type'?: CustomerType;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<CustomerContactDto>}
     * @memberof CustomerDto
     */
    'contacts'?: Array<CustomerContactDto>;
    /**
     * 
     * @type {GeneralAddressDto}
     * @memberof CustomerDto
     */
    'address'?: GeneralAddressDto;
    /**
     * 
     * @type {Array<CustomerExternalUserLinkDto>}
     * @memberof CustomerDto
     */
    'externalUserLinks'?: Array<CustomerExternalUserLinkDto> | null;
    /**
     * 
     * @type {Array<CustomerExternalUserLinkDto>}
     * @memberof CustomerDto
     */
    'externalUserLinkHistory'?: Array<CustomerExternalUserLinkDto> | null;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof CustomerDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {CustomerContactDto}
     * @memberof CustomerDto
     */
    'contact'?: CustomerContactDto;
}


/**
 * 
 * @export
 * @interface CustomerExternalUserLinkDto
 */
export interface CustomerExternalUserLinkDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerExternalUserLinkDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerExternalUserLinkDto
     */
    'externalUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerExternalUserLinkDto
     */
    'contactId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerExternalUserLinkDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerExternalUserLinkDto
     */
    'integrationApiClientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerExternalUserLinkDto
     */
    'integrationApiClientKeyId'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomerExternalUserLinkDto
     */
    'linkedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof CustomerExternalUserLinkDto
     */
    'unlinkedAt'?: string | null;
}
/**
 * CustomerExtractedData.
 * @export
 * @interface CustomerExtractedDataDto
 */
export interface CustomerExtractedDataDto {
    /**
     * Auto-generated ID for this extracted data record.    Used for caching, logging, or referencing this specific extraction.
     * @type {string}
     * @memberof CustomerExtractedDataDto
     */
    'extractedDataId'?: string;
    /**
     * 
     * @type {ExtractedDocumentType}
     * @memberof CustomerExtractedDataDto
     */
    'documentType'?: ExtractedDocumentType;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Common.DocumentIntelligence.Base.BaseExtractedData.DocumentConfidence\" />
     * @type {number}
     * @memberof CustomerExtractedDataDto
     */
    'documentConfidence'?: number;
    /**
     * 
     * @type {ExtractedDocumentConfidenceLevel}
     * @memberof CustomerExtractedDataDto
     */
    'documentConfidenceLevel'?: ExtractedDocumentConfidenceLevel;
    /**
     * Entity ID matched using extracted data after extraction in post-processing.
     * @type {string}
     * @memberof CustomerExtractedDataDto
     */
    'matchedId'?: string | null;
    /**
     * 
     * @type {CustomerType}
     * @memberof CustomerExtractedDataDto
     */
    'type'?: CustomerType;
    /**
     * 
     * @type {string}
     * @memberof CustomerExtractedDataDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerExtractedDataDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerExtractedDataDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerExtractedDataDto
     */
    'middleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerExtractedDataDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerExtractedDataDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerExtractedDataDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerExtractedDataDto
     */
    'driverLicenseNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerExtractedDataDto
     */
    'passportNumber'?: string | null;
    /**
     * 
     * @type {GeneralAddressDto}
     * @memberof CustomerExtractedDataDto
     */
    'address'?: GeneralAddressDto;
    /**
     * 
     * @type {CountryCode}
     * @memberof CustomerExtractedDataDto
     */
    'detectedCountryCode'?: CountryCode;
}


/**
 * 
 * @export
 * @interface CustomerGetPaginatedDto
 */
export interface CustomerGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof CustomerGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof CustomerGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof CustomerGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof CustomerGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {CustomerType}
     * @memberof CustomerGetPaginatedDto
     */
    'type'?: CustomerType;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof CustomerGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * 
 * @export
 * @interface CustomerInviteAsUserDto
 */
export interface CustomerInviteAsUserDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerInviteAsUserDto
     */
    'contactIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CustomerReferenceDto
 */
export interface CustomerReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {CustomerType}
     * @memberof CustomerReferenceDto
     */
    'type'?: CustomerType;
    /**
     * 
     * @type {string}
     * @memberof CustomerReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {CustomerContactDto}
     * @memberof CustomerReferenceDto
     */
    'contact'?: CustomerContactDto;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CustomerType = {
    None: 'None',
    B2C: 'B2C',
    B2B: 'B2B'
} as const;

export type CustomerType = typeof CustomerType[keyof typeof CustomerType];


/**
 * 
 * @export
 * @interface CustomerUpdateDto
 */
export interface CustomerUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerUpdateDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerUpdateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerUpdateDto
     */
    'isDriver'?: boolean | null;
    /**
     * 
     * @type {GeneralAddressInputDto}
     * @memberof CustomerUpdateDto
     */
    'address'?: GeneralAddressInputDto;
    /**
     * 
     * @type {Array<CustomerContactUpdateDto>}
     * @memberof CustomerUpdateDto
     */
    'contacts'?: Array<CustomerContactUpdateDto>;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof CustomerUpdateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerUpdateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerUpdateDto
     */
    'locationIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CustomerVerificationMethod = {
    None: 'None',
    ManualSignature: 'ManualSignature'
} as const;

export type CustomerVerificationMethod = typeof CustomerVerificationMethod[keyof typeof CustomerVerificationMethod];


/**
 * 
 * @export
 * @interface CustomersInviteGetPaginatedDto
 */
export interface CustomersInviteGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof CustomersInviteGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomersInviteGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomersInviteGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomersInviteGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomersInviteGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomersInviteGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof CustomersInviteGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof CustomersInviteGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof CustomersInviteGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
}
/**
 * Defines how damages are related to each other in a correction.  DamageCorrectionType.
 * @export
 * @enum {string}
 */

export const DamageCorrectionRole = {
    None: 'None',
    Source: 'Source',
    Target: 'Target'
} as const;

export type DamageCorrectionRole = typeof DamageCorrectionRole[keyof typeof DamageCorrectionRole];


/**
 * Whether the damage has been modified (corrected/adjusted) by assessor, professional or normal user.
 * @export
 * @enum {string}
 */

export const DamageCorrectionStatus = {
    None: 'None',
    NotCorrected: 'NotCorrected',
    Corrected: 'Corrected'
} as const;

export type DamageCorrectionStatus = typeof DamageCorrectionStatus[keyof typeof DamageCorrectionStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const DamageCorrectionType = {
    None: 'None',
    Replacement: 'Replacement',
    Split: 'Split',
    Merge: 'Merge'
} as const;

export type DamageCorrectionType = typeof DamageCorrectionType[keyof typeof DamageCorrectionType];


/**
 * 
 * @export
 * @interface DamageCostEvaluationAggregateChangedDto
 */
export interface DamageCostEvaluationAggregateChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationAggregateChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof DamageCostEvaluationAggregateChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof DamageCostEvaluationAggregateChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {DamageCostEvaluationAggregateDto}
     * @memberof DamageCostEvaluationAggregateChangedDto
     */
    'entity': DamageCostEvaluationAggregateDto;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface DamageCostEvaluationAggregateDataDto
 */
export interface DamageCostEvaluationAggregateDataDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {Array<DamageCostEvaluationReferenceDto>}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'sourceDamageCostEvaluations'?: Array<DamageCostEvaluationReferenceDto>;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<DamageCostEvaluationAggregateItemDataDto>}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'items'?: Array<DamageCostEvaluationAggregateItemDataDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'total'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'lastInspectedAt'?: string | null;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * Whether already sent to the contract customer.
     * @type {boolean}
     * @memberof DamageCostEvaluationAggregateDataDto
     */
    'isSentToCustomer'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationAggregateDto
 */
export interface DamageCostEvaluationAggregateDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {Array<DamageCostEvaluationReferenceDto>}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'sourceDamageCostEvaluations'?: Array<DamageCostEvaluationReferenceDto>;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<DamageCostEvaluationAggregateItemDto>}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'items'?: Array<DamageCostEvaluationAggregateItemDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'total'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'lastInspectedAt'?: string | null;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * Whether already sent to the contract customer.
     * @type {boolean}
     * @memberof DamageCostEvaluationAggregateDto
     */
    'isSentToCustomer'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationAggregateGetPaginatedDto
 */
export interface DamageCostEvaluationAggregateGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationAggregateGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationAggregateGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationAggregateGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationAggregateGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationAggregateGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof DamageCostEvaluationAggregateGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof DamageCostEvaluationAggregateGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof DamageCostEvaluationAggregateGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateGetPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof DamageCostEvaluationAggregateGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationAggregateItemDataDto
 */
export interface DamageCostEvaluationAggregateItemDataDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateItemDataDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateItemDataDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {GeneralApprovalStatusInfoDto}
     * @memberof DamageCostEvaluationAggregateItemDataDto
     */
    'approval'?: GeneralApprovalStatusInfoDto;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof DamageCostEvaluationAggregateItemDataDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * Whether already sent to the contract customer.
     * @type {boolean}
     * @memberof DamageCostEvaluationAggregateItemDataDto
     */
    'isSentToCustomer'?: boolean | null;
    /**
     * 
     * @type {DamageCostEvaluationDataDto}
     * @memberof DamageCostEvaluationAggregateItemDataDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationDataDto;
    /**
     * 
     * @type {DamageCostEvaluationItemDataDto}
     * @memberof DamageCostEvaluationAggregateItemDataDto
     */
    'item'?: DamageCostEvaluationItemDataDto;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationAggregateItemDto
 */
export interface DamageCostEvaluationAggregateItemDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateItemDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {GeneralApprovalStatusInfoDto}
     * @memberof DamageCostEvaluationAggregateItemDto
     */
    'approval'?: GeneralApprovalStatusInfoDto;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof DamageCostEvaluationAggregateItemDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * Whether already sent to the contract customer.
     * @type {boolean}
     * @memberof DamageCostEvaluationAggregateItemDto
     */
    'isSentToCustomer'?: boolean | null;
    /**
     * 
     * @type {DamageCostEvaluationDataDto}
     * @memberof DamageCostEvaluationAggregateItemDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationDataDto;
    /**
     * 
     * @type {DamageCostEvaluationItemDataDto}
     * @memberof DamageCostEvaluationAggregateItemDto
     */
    'item'?: DamageCostEvaluationItemDataDto;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationAggregateItemReferenceDto
 */
export interface DamageCostEvaluationAggregateItemReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateItemReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateItemReferenceDto
     */
    'damageCostEvaluationAggregateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateItemReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationAggregateReferenceDto
 */
export interface DamageCostEvaluationAggregateReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateReferenceDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationAggregateSearchPaginatedDto
 */
export interface DamageCostEvaluationAggregateSearchPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationAggregateSearchPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationAggregateSearchPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateSearchPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationAggregateSearchPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationAggregateSearchPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationAggregateSearchPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof DamageCostEvaluationAggregateSearchPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof DamageCostEvaluationAggregateSearchPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof DamageCostEvaluationAggregateSearchPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateSearchPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateSearchPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof DamageCostEvaluationAggregateSearchPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationAggregateUpdatedInAppDataDto
 */
export interface DamageCostEvaluationAggregateUpdatedInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof DamageCostEvaluationAggregateUpdatedInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof DamageCostEvaluationAggregateUpdatedInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof DamageCostEvaluationAggregateUpdatedInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregateUpdatedInAppDataDto
     */
    'damageCostEvaluationAggregateId'?: string;
}


/**
 * 
 * @export
 * @interface DamageCostEvaluationChangedDto
 */
export interface DamageCostEvaluationChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof DamageCostEvaluationChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof DamageCostEvaluationChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {DamageCostEvaluationDto}
     * @memberof DamageCostEvaluationChangedDto
     */
    'entity': DamageCostEvaluationDto;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface DamageCostEvaluationCompleteDto
 */
export interface DamageCostEvaluationCompleteDto {
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationCompleteDto
     */
    'isSendToCustomer'?: boolean;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationCompletedInAppDataDto
 */
export interface DamageCostEvaluationCompletedInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof DamageCostEvaluationCompletedInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof DamageCostEvaluationCompletedInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof DamageCostEvaluationCompletedInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationCompletedInAppDataDto
     */
    'damageCostEvaluationId'?: string;
}


/**
 * 
 * @export
 * @interface DamageCostEvaluationContentDto
 */
export interface DamageCostEvaluationContentDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationContentDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationContentDto
     */
    'vehicleDamageIds'?: Array<string>;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof DamageCostEvaluationContentDto
     */
    'currency'?: GeneralCurrencyDto;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationContentInputDto
 */
export interface DamageCostEvaluationContentInputDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationContentInputDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationContentInputDto
     */
    'vehicleDamageIds'?: Array<string>;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof DamageCostEvaluationContentInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationCountersDto
 */
export interface DamageCostEvaluationCountersDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationCountersDto
     */
    'version'?: string;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationCountersDto
     */
    'draftCount': number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationCountersDto
     */
    'inProgressCount': number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationCountersDto
     */
    'completedCount': number;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationCreateDto
 */
export interface DamageCostEvaluationCreateDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationCreateDto
     */
    'originalId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationCreateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationCreateDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationCreateDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationCreateDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationCreateDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationCreateDto
     */
    'customerId'?: string | null;
    /**
     * Explicit source DD.
     * @type {string}
     * @memberof DamageCostEvaluationCreateDto
     */
    'damageDetectionId'?: string | null;
    /**
     * Initial damages specified when creating this DCE (from DD, T2T request, etc.). Never updated after creation.  \"/>
     * @type {Array<string>}
     * @memberof DamageCostEvaluationCreateDto
     */
    'initialVehicleDamageIds'?: Array<string> | null;
    /**
     * 
     * @type {GeneralEntitySourceInputDto}
     * @memberof DamageCostEvaluationCreateDto
     */
    'source'?: GeneralEntitySourceInputDto;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof DamageCostEvaluationCreateDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageCostEvaluationCreateDto
     */
    'inspectedAt'?: string | null;
    /**
     * 
     * @type {GeneralInspectorInputDto}
     * @memberof DamageCostEvaluationCreateDto
     */
    'inspector'?: GeneralInspectorInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationCreateDto
     */
    'isUseSupplierBranding'?: boolean;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof DamageCostEvaluationCreateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationCreateDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<DamageCostEvaluationItemCreateDto>}
     * @memberof DamageCostEvaluationCreateDto
     */
    'items'?: Array<DamageCostEvaluationItemCreateDto>;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof DamageCostEvaluationCreateDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * 
     * @type {TenantRequestsMetaInputDto}
     * @memberof DamageCostEvaluationCreateDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaInputDto;
    /**
     * 
     * @type {GeneralStageUpdateDtoOfDamageCostEvaluationStage}
     * @memberof DamageCostEvaluationCreateDto
     */
    'newStage'?: GeneralStageUpdateDtoOfDamageCostEvaluationStage;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof DamageCostEvaluationCreateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {GeneralBillToInfoInputDto}
     * @memberof DamageCostEvaluationCreateDto
     */
    'billTo'?: GeneralBillToInfoInputDto;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationDamageCorrectionsDto
 */
export interface DamageCostEvaluationDamageCorrectionsDto {
    /**
     * 
     * @type {ApplyStatus}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'applyStatus'?: ApplyStatus;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'appliedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'appliedBy'?: string | null;
    /**
     * Initial and/or original damages before the correction that are marked as inactive after correction is applied.
     * @type {Array<string>}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'vehicleDamageIdsDeactivated'?: Array<string> | null;
    /**
     * New damages created after the correction.
     * @type {Array<string>}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'vehicleDamageIdsCreated'?: Array<string> | null;
    /**
     * Initial damages specified when creating this DCE (from DD, T2T request, etc.). Never updated after creation.  .    Copy for easier access.
     * @type {Array<string>}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'initialVehicleDamageIds'?: Array<string>;
    /**
     * Original damages (including all extra damages that were added later after operation was created).
     * @type {Array<string>}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'originalVehicleDamageIds'?: Array<string>;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.DamageCostEvaluation.DamageCostEvaluationDamageCorrections.InitialAndOriginalVehicleDamageIds\" />
     * @type {Array<string>}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'initialAndOriginalVehicleDamageIds'?: Array<string>;
    /**
     * 
     * @type {DamageCorrectionStatus}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'correctionStatus'?: DamageCorrectionStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'canApply'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'initialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'originalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'initialAndOriginalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'currentCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'notCorrectedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'correctedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'addedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'updatedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDamageCorrectionsDto
     */
    'removedCount'?: number;
}


/**
 * 
 * @export
 * @interface DamageCostEvaluationDataDto
 */
export interface DamageCostEvaluationDataDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDataDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDataDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDataDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDataDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof DamageCostEvaluationDataDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof DamageCostEvaluationDataDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDataDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {AssignmentReferenceDto}
     * @memberof DamageCostEvaluationDataDto
     */
    'assignment'?: AssignmentReferenceDto;
    /**
     * 
     * @type {CustomerReferenceDto}
     * @memberof DamageCostEvaluationDataDto
     */
    'customer'?: CustomerReferenceDto;
    /**
     * 
     * @type {GeneralStageHistoryDtoOfDamageCostEvaluationStage}
     * @memberof DamageCostEvaluationDataDto
     */
    'stageHistory'?: GeneralStageHistoryDtoOfDamageCostEvaluationStage;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof DamageCostEvaluationDataDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageCostEvaluationDataDto
     */
    'inspectedAt'?: string | null;
    /**
     * 
     * @type {GeneralInspectorDto}
     * @memberof DamageCostEvaluationDataDto
     */
    'inspector'?: GeneralInspectorDto;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDataDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<DamageCostEvaluationItemDataDto>}
     * @memberof DamageCostEvaluationDataDto
     */
    'items'?: Array<DamageCostEvaluationItemDataDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DamageCostEvaluationDataDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof DamageCostEvaluationDataDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * Whether already sent to the contract customer.
     * @type {boolean}
     * @memberof DamageCostEvaluationDataDto
     */
    'isSentToCustomer'?: boolean | null;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof DamageCostEvaluationDataDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof DamageCostEvaluationDataDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDataDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDataDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDataDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationDto
 */
export interface DamageCostEvaluationDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof DamageCostEvaluationDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'originalTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'originalId'?: string | null;
    /**
     * 
     * @type {EntityOriginType}
     * @memberof DamageCostEvaluationDto
     */
    'originType'?: EntityOriginType;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof DamageCostEvaluationDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof DamageCostEvaluationDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {AssignmentReferenceDto}
     * @memberof DamageCostEvaluationDto
     */
    'assignment'?: AssignmentReferenceDto;
    /**
     * 
     * @type {CustomerReferenceDto}
     * @memberof DamageCostEvaluationDto
     */
    'customer'?: CustomerReferenceDto;
    /**
     * Initial damages specified when creating this DCE (from DD, T2T request, etc.). Never updated after creation.
     * @type {Array<string>}
     * @memberof DamageCostEvaluationDto
     */
    'initialVehicleDamageIds'?: Array<string> | null;
    /**
     * 
     * @type {GeneralEntitySourceDto}
     * @memberof DamageCostEvaluationDto
     */
    'source'?: GeneralEntitySourceDto;
    /**
     * 
     * @type {GeneralStageHistoryDtoOfDamageCostEvaluationStage}
     * @memberof DamageCostEvaluationDto
     */
    'stageHistory'?: GeneralStageHistoryDtoOfDamageCostEvaluationStage;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof DamageCostEvaluationDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {FrontEndAppType}
     * @memberof DamageCostEvaluationDto
     */
    'appType'?: FrontEndAppType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'inspectedAt'?: string | null;
    /**
     * 
     * @type {GeneralInspector}
     * @memberof DamageCostEvaluationDto
     */
    'inspector'?: GeneralInspector;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationDto
     */
    'isUseSupplierBranding'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<DamageCostEvaluationItemDto>}
     * @memberof DamageCostEvaluationDto
     */
    'items'?: Array<DamageCostEvaluationItemDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DamageCostEvaluationDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof DamageCostEvaluationDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * Whether already sent to the contract customer.
     * @type {boolean}
     * @memberof DamageCostEvaluationDto
     */
    'isSentToCustomer'?: boolean | null;
    /**
     * 
     * @type {DamageCostEvaluationDamageCorrectionsDto}
     * @memberof DamageCostEvaluationDto
     */
    'corrections'?: DamageCostEvaluationDamageCorrectionsDto;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof DamageCostEvaluationDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof DamageCostEvaluationDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
    /**
     * 
     * @type {TenantRequestsMetaDto}
     * @memberof DamageCostEvaluationDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof DamageCostEvaluationDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {GeneralBillToInfoDto}
     * @memberof DamageCostEvaluationDto
     */
    'billTo'?: GeneralBillToInfoDto;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'damageDetectionId'?: string | null;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof DamageCostEvaluationDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof DamageCostEvaluationDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationDto
     */
    'total'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'draftAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'inProgressAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageCostEvaluationDto
     */
    'completedAt'?: string | null;
}


/**
 * 
 * @export
 * @interface DamageCostEvaluationGetPaginatedDto
 */
export interface DamageCostEvaluationGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'vehicleDamageId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'assignmentId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'vehicleDamageIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'anyVehicleDamageIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'damageDetectionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'damageDetectionAggregateId'?: string | null;
    /**
     * 
     * @type {DamageCostEvaluationStage}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'stage'?: DamageCostEvaluationStage;
    /**
     * 
     * @type {TenantRequestsMetaQueryDto}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
    /**
     * 
     * @type {GeneralEntitySourceQueryDto}
     * @memberof DamageCostEvaluationGetPaginatedDto
     */
    'source'?: GeneralEntitySourceQueryDto;
}


/**
 * 
 * @export
 * @interface DamageCostEvaluationItemCreateDto
 */
export interface DamageCostEvaluationItemCreateDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemCreateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<DamageCostEvaluationItemDamageInputDto>}
     * @memberof DamageCostEvaluationItemCreateDto
     */
    'damages'?: Array<DamageCostEvaluationItemDamageInputDto>;
    /**
     * 
     * @type {RepairSpecDataInputDto}
     * @memberof DamageCostEvaluationItemCreateDto
     */
    'repairSpec'?: RepairSpecDataInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationItemCreateDto
     */
    'isRepairSpecChanged'?: boolean;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof DamageCostEvaluationItemCreateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemCreateDto
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationItemDamageDto
 */
export interface DamageCostEvaluationItemDamageDto {
    /**
     * 
     * @type {VehicleDamageDataDto}
     * @memberof DamageCostEvaluationItemDamageDto
     */
    'damage'?: VehicleDamageDataDto;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationItemDamageInputDto
 */
export interface DamageCostEvaluationItemDamageInputDto {
    /**
     * 
     * @type {VehicleDamageDataInputDto}
     * @memberof DamageCostEvaluationItemDamageInputDto
     */
    'damage'?: VehicleDamageDataInputDto;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationItemDataDto
 */
export interface DamageCostEvaluationItemDataDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'name'?: string | null;
    /**
     * v2.
     * @type {Array<DamageCostEvaluationItemDamageDto>}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'damages'?: Array<DamageCostEvaluationItemDamageDto>;
    /**
     * 
     * @type {RepairSpecDataDto}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'repairSpec'?: RepairSpecDataDto;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'isRepairSpecChanged'?: boolean;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {GeneralPriceDto}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'negotiatedPrice'?: GeneralPriceDto;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'negotiatedDiscount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'negotiatedTax'?: GeneralTaxDto;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'initialDiscount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'initialTax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'initialSubTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'initialSubTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'initialTotal'?: number;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'total'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'isNegotiatedNewSubTotal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'isNegotiatedNewDiscount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'isNegotiatedNewTax'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationItemDataDto
     */
    'isNegotiatedAnyNew'?: boolean;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationItemDto
 */
export interface DamageCostEvaluationItemDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<DamageCostEvaluationItemDamageDto>}
     * @memberof DamageCostEvaluationItemDto
     */
    'damages'?: Array<DamageCostEvaluationItemDamageDto>;
    /**
     * 
     * @type {RepairSpecDataDto}
     * @memberof DamageCostEvaluationItemDto
     */
    'repairSpec'?: RepairSpecDataDto;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationItemDto
     */
    'isRepairSpecChanged'?: boolean;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DamageCostEvaluationItemDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {GeneralPriceDto}
     * @memberof DamageCostEvaluationItemDto
     */
    'negotiatedPrice'?: GeneralPriceDto;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof DamageCostEvaluationItemDto
     */
    'negotiatedDiscount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof DamageCostEvaluationItemDto
     */
    'negotiatedTax'?: GeneralTaxDto;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof DamageCostEvaluationItemDto
     */
    'initialDiscount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof DamageCostEvaluationItemDto
     */
    'initialTax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationItemDto
     */
    'initialSubTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationItemDto
     */
    'initialSubTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationItemDto
     */
    'initialTotal'?: number;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof DamageCostEvaluationItemDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof DamageCostEvaluationItemDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationItemDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationItemDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCostEvaluationItemDto
     */
    'total'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationItemDto
     */
    'isNegotiatedNewSubTotal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationItemDto
     */
    'isNegotiatedNewDiscount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationItemDto
     */
    'isNegotiatedNewTax'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationItemDto
     */
    'isNegotiatedAnyNew'?: boolean;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationItemReferenceDto
 */
export interface DamageCostEvaluationItemReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemReferenceDto
     */
    'damageCostEvaluationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationItemUpdateDto
 */
export interface DamageCostEvaluationItemUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemUpdateDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemUpdateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<DamageCostEvaluationItemDamageInputDto>}
     * @memberof DamageCostEvaluationItemUpdateDto
     */
    'damages'?: Array<DamageCostEvaluationItemDamageInputDto>;
    /**
     * 
     * @type {RepairSpecDataInputDto}
     * @memberof DamageCostEvaluationItemUpdateDto
     */
    'repairSpec'?: RepairSpecDataInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationItemUpdateDto
     */
    'isRepairSpecChanged'?: boolean;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof DamageCostEvaluationItemUpdateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationItemUpdateDto
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationReferenceDto
 */
export interface DamageCostEvaluationReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof DamageCostEvaluationReferenceDto
     */
    'formType'?: EntityFormType;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationReferenceDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationReferenceDto
     */
    'localNumber'?: string;
}


/**
 * 
 * @export
 * @interface DamageCostEvaluationResultDto
 */
export interface DamageCostEvaluationResultDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationResultDto
     */
    'damageCostEvaluationId'?: string;
}
/**
 * 
 * @export
 * @interface DamageCostEvaluationResultInputDto
 */
export interface DamageCostEvaluationResultInputDto {
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationResultInputDto
     */
    'damageCostEvaluationId'?: string;
}
/**
 * NB: use SortOrderAttribute to specify the order in which stages can be activated.
 * @export
 * @enum {string}
 */

export const DamageCostEvaluationStage = {
    None: 'None',
    Draft: 'Draft',
    InProgress: 'InProgress',
    Completed: 'Completed'
} as const;

export type DamageCostEvaluationStage = typeof DamageCostEvaluationStage[keyof typeof DamageCostEvaluationStage];


/**
 * 
 * @export
 * @interface DamageCostEvaluationStartedInAppDataDto
 */
export interface DamageCostEvaluationStartedInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof DamageCostEvaluationStartedInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof DamageCostEvaluationStartedInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof DamageCostEvaluationStartedInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationStartedInAppDataDto
     */
    'damageCostEvaluationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationStartedInAppDataDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationStartedInAppDataDto
     */
    'localNumber'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DamageCostEvaluationStatusInContract = {
    None: 'None',
    NoDamageCost: 'NoDamageCost',
    EvaluatingDamageCost: 'EvaluatingDamageCost',
    DamageCostEvaluated: 'DamageCostEvaluated',
    NegotiatingDamageCost: 'NegotiatingDamageCost',
    DamageCostChanged: 'DamageCostChanged',
    DamageCostAgreed: 'DamageCostAgreed',
    DamageCostForceApproved: 'DamageCostForceApproved'
} as const;

export type DamageCostEvaluationStatusInContract = typeof DamageCostEvaluationStatusInContract[keyof typeof DamageCostEvaluationStatusInContract];


/**
 * 
 * @export
 * @interface DamageCostEvaluationUpdateDto
 */
export interface DamageCostEvaluationUpdateDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorInputDto}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'inspector'?: GeneralInspectorInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'isUseSupplierBranding'?: boolean;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<DamageCostEvaluationItemUpdateDto>}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'items'?: Array<DamageCostEvaluationItemUpdateDto>;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * 
     * @type {GeneralStageUpdateDtoOfDamageCostEvaluationStage}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'newStage'?: GeneralStageUpdateDtoOfDamageCostEvaluationStage;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {GeneralBillToInfoInputDto}
     * @memberof DamageCostEvaluationUpdateDto
     */
    'billTo'?: GeneralBillToInfoInputDto;
}
/**
 * 
 * @export
 * @interface DamageDetectedDataDto
 */
export interface DamageDetectedDataDto {
    /**
     * 
     * @type {VehicleDamageReferenceDto}
     * @memberof DamageDetectedDataDto
     */
    'damage'?: VehicleDamageReferenceDto;
}
/**
 * 
 * @export
 * @interface DamageDetectionAggregateChangedDto
 */
export interface DamageDetectionAggregateChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionAggregateChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof DamageDetectionAggregateChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof DamageDetectionAggregateChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {DamageDetectionAggregateDto}
     * @memberof DamageDetectionAggregateChangedDto
     */
    'entity': DamageDetectionAggregateDto;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface DamageDetectionAggregateDataDto
 */
export interface DamageDetectionAggregateDataDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateDataDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateDataDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateDataDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateDataDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof DamageDetectionAggregateDataDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof DamageDetectionAggregateDataDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {Array<DamageDetectionReferenceDto>}
     * @memberof DamageDetectionAggregateDataDto
     */
    'sourceDamageDetections'?: Array<DamageDetectionReferenceDto>;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateDataDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<DamageDetectionAggregateItemDataDto>}
     * @memberof DamageDetectionAggregateDataDto
     */
    'items'?: Array<DamageDetectionAggregateItemDataDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DamageDetectionAggregateDataDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageDetectionAggregateDataDto
     */
    'lastInspectedAt'?: string | null;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof DamageDetectionAggregateDataDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * Whether already sent to the contract customer.
     * @type {boolean}
     * @memberof DamageDetectionAggregateDataDto
     */
    'isSentToCustomer'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DamageDetectionAggregateDto
 */
export interface DamageDetectionAggregateDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionAggregateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionAggregateDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof DamageDetectionAggregateDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof DamageDetectionAggregateDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {Array<DamageDetectionReferenceDto>}
     * @memberof DamageDetectionAggregateDto
     */
    'sourceDamageDetections'?: Array<DamageDetectionReferenceDto>;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<DamageDetectionAggregateItemDto>}
     * @memberof DamageDetectionAggregateDto
     */
    'items'?: Array<DamageDetectionAggregateItemDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DamageDetectionAggregateDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof DamageDetectionAggregateDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof DamageDetectionAggregateDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof DamageDetectionAggregateDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageDetectionAggregateDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageDetectionAggregateDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateDto
     */
    'updatedBy'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageDetectionAggregateDto
     */
    'lastInspectedAt'?: string | null;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof DamageDetectionAggregateDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * Whether already sent to the contract customer.
     * @type {boolean}
     * @memberof DamageDetectionAggregateDto
     */
    'isSentToCustomer'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DamageDetectionAggregateGetPaginatedDto
 */
export interface DamageDetectionAggregateGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof DamageDetectionAggregateGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageDetectionAggregateGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionAggregateGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionAggregateGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionAggregateGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof DamageDetectionAggregateGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof DamageDetectionAggregateGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof DamageDetectionAggregateGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateGetPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof DamageDetectionAggregateGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}
/**
 * 
 * @export
 * @interface DamageDetectionAggregateItemDataDto
 */
export interface DamageDetectionAggregateItemDataDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateItemDataDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateItemDataDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DamageDetectionAggregateItemDataDto
     */
    'isCostEvaluationStarted'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageDetectionAggregateItemDataDto
     */
    'costEvaluationStartedAt'?: string | null;
    /**
     * 
     * @type {GeneralApprovalStatusInfoDto}
     * @memberof DamageDetectionAggregateItemDataDto
     */
    'approval'?: GeneralApprovalStatusInfoDto;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof DamageDetectionAggregateItemDataDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * Whether already sent to the contract customer.
     * @type {boolean}
     * @memberof DamageDetectionAggregateItemDataDto
     */
    'isSentToCustomer'?: boolean | null;
    /**
     * 
     * @type {DamageDetectionDataDto}
     * @memberof DamageDetectionAggregateItemDataDto
     */
    'damageDetection'?: DamageDetectionDataDto;
    /**
     * 
     * @type {DamageDetectionItemDataDto}
     * @memberof DamageDetectionAggregateItemDataDto
     */
    'item'?: DamageDetectionItemDataDto;
}
/**
 * 
 * @export
 * @interface DamageDetectionAggregateItemDto
 */
export interface DamageDetectionAggregateItemDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateItemDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DamageDetectionAggregateItemDto
     */
    'isCostEvaluationStarted'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageDetectionAggregateItemDto
     */
    'costEvaluationStartedAt'?: string | null;
    /**
     * 
     * @type {GeneralApprovalStatusInfoDto}
     * @memberof DamageDetectionAggregateItemDto
     */
    'approval'?: GeneralApprovalStatusInfoDto;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof DamageDetectionAggregateItemDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * Whether already sent to the contract customer.
     * @type {boolean}
     * @memberof DamageDetectionAggregateItemDto
     */
    'isSentToCustomer'?: boolean | null;
    /**
     * 
     * @type {DamageDetectionDataDto}
     * @memberof DamageDetectionAggregateItemDto
     */
    'damageDetection'?: DamageDetectionDataDto;
    /**
     * 
     * @type {DamageDetectionItemDataDto}
     * @memberof DamageDetectionAggregateItemDto
     */
    'item'?: DamageDetectionItemDataDto;
}
/**
 * 
 * @export
 * @interface DamageDetectionAggregateItemReferenceDto
 */
export interface DamageDetectionAggregateItemReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateItemReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateItemReferenceDto
     */
    'damageDetectionAggregateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateItemReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface DamageDetectionAggregateReferenceDto
 */
export interface DamageDetectionAggregateReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateReferenceDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface DamageDetectionAggregateSearchPaginatedDto
 */
export interface DamageDetectionAggregateSearchPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof DamageDetectionAggregateSearchPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageDetectionAggregateSearchPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateSearchPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionAggregateSearchPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionAggregateSearchPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionAggregateSearchPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof DamageDetectionAggregateSearchPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof DamageDetectionAggregateSearchPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof DamageDetectionAggregateSearchPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateSearchPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregateSearchPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof DamageDetectionAggregateSearchPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}
/**
 * 
 * @export
 * @interface DamageDetectionBulkDeleteDto
 */
export interface DamageDetectionBulkDeleteDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionBulkDeleteDto
     */
    'ids'?: Array<string>;
    /**
     * 
     * @type {Array<EntityType>}
     * @memberof DamageDetectionBulkDeleteDto
     */
    'relatedEntitiesTypes'?: Array<EntityType>;
    /**
     * 
     * @type {boolean}
     * @memberof DamageDetectionBulkDeleteDto
     */
    'isDeleteVehicleDamages'?: boolean;
}
/**
 * 
 * @export
 * @interface DamageDetectionChangedDto
 */
export interface DamageDetectionChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof DamageDetectionChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof DamageDetectionChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {DamageDetectionDto}
     * @memberof DamageDetectionChangedDto
     */
    'entity': DamageDetectionDto;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface DamageDetectionContentDto
 */
export interface DamageDetectionContentDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionContentDto
     */
    'vehicleId'?: string;
}
/**
 * 
 * @export
 * @interface DamageDetectionContentInputDto
 */
export interface DamageDetectionContentInputDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionContentInputDto
     */
    'vehicleId'?: string;
}
/**
 * 
 * @export
 * @interface DamageDetectionCostEvaluationLinkDto
 */
export interface DamageDetectionCostEvaluationLinkDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionCostEvaluationLinkDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityOriginType}
     * @memberof DamageDetectionCostEvaluationLinkDto
     */
    'originType': EntityOriginType;
    /**
     * Whether DCE is local or external via T2T request.
     * @type {string}
     * @memberof DamageDetectionCostEvaluationLinkDto
     */
    'damageCostEvaluationId'?: string | null;
    /**
     * 
     * @type {DamageCostEvaluationStage}
     * @memberof DamageDetectionCostEvaluationLinkDto
     */
    'damageCostEvaluationStage'?: DamageCostEvaluationStage;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionCostEvaluationLinkDto
     */
    'tenantRequestId'?: string | null;
    /**
     * Receiver tenant of the T2T request (assessor).
     * @type {string}
     * @memberof DamageDetectionCostEvaluationLinkDto
     */
    'assessorTenantId'?: string | null;
    /**
     * 
     * @type {TenantRequestStage}
     * @memberof DamageDetectionCostEvaluationLinkDto
     */
    'tenantRequestStage'?: TenantRequestStage;
    /**
     * Whether all damages from the DD are included in DCE (full evaluation).
     * @type {boolean}
     * @memberof DamageDetectionCostEvaluationLinkDto
     */
    'isAllDamages'?: boolean;
    /**
     * Damage ids from DD included in DCE (full or partial evaluation).
     * @type {Array<string>}
     * @memberof DamageDetectionCostEvaluationLinkDto
     */
    'vehicleDamageIds'?: Array<string>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageDetectionCostEvaluationLinkDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageDetectionCostEvaluationLinkDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {DamageDetectionCostEvaluationStatus}
     * @memberof DamageDetectionCostEvaluationLinkDto
     */
    'status'?: DamageDetectionCostEvaluationStatus;
}


/**
 * 
 * @export
 * @interface DamageDetectionCostEvaluationOverviewDto
 */
export interface DamageDetectionCostEvaluationOverviewDto {
    /**
     * 
     * @type {Array<DamageDetectionCostEvaluationLinkDto>}
     * @memberof DamageDetectionCostEvaluationOverviewDto
     */
    'links'?: Array<DamageDetectionCostEvaluationLinkDto>;
    /**
     * 
     * @type {number}
     * @memberof DamageDetectionCostEvaluationOverviewDto
     */
    'localCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageDetectionCostEvaluationOverviewDto
     */
    'externalCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DamageDetectionCostEvaluationOverviewDto
     */
    'isAnyLocal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DamageDetectionCostEvaluationOverviewDto
     */
    'isAnyExternal'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageDetectionCostEvaluationOverviewDto
     */
    'updatedAt'?: string | null;
}
/**
 * Derived status of linked DCE for this DD.
 * @export
 * @enum {string}
 */

export const DamageDetectionCostEvaluationStatus = {
    None: 'None',
    Unknown: 'Unknown',
    Pending: 'Pending',
    Sent: 'Sent',
    Declined: 'Declined',
    InProgress: 'InProgress',
    Completed: 'Completed',
    Applied: 'Applied'
} as const;

export type DamageDetectionCostEvaluationStatus = typeof DamageDetectionCostEvaluationStatus[keyof typeof DamageDetectionCostEvaluationStatus];


/**
 * 
 * @export
 * @interface DamageDetectionCountersDto
 */
export interface DamageDetectionCountersDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionCountersDto
     */
    'version'?: string;
    /**
     * 
     * @type {number}
     * @memberof DamageDetectionCountersDto
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface DamageDetectionCreatedInAppDataDto
 */
export interface DamageDetectionCreatedInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof DamageDetectionCreatedInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof DamageDetectionCreatedInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof DamageDetectionCreatedInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionCreatedInAppDataDto
     */
    'damageDetectionId'?: string;
}


/**
 * 
 * @export
 * @interface DamageDetectionDataDto
 */
export interface DamageDetectionDataDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionDataDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionDataDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionDataDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionDataDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof DamageDetectionDataDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof DamageDetectionDataDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionDataDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {AssignmentReferenceDto}
     * @memberof DamageDetectionDataDto
     */
    'assignment'?: AssignmentReferenceDto;
    /**
     * 
     * @type {VehicleVisualModelReferenceDto}
     * @memberof DamageDetectionDataDto
     */
    'vehicleVisualModel'?: VehicleVisualModelReferenceDto;
    /**
     * 
     * @type {FrontEndAppType}
     * @memberof DamageDetectionDataDto
     */
    'appType'?: FrontEndAppType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageDetectionDataDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorDto}
     * @memberof DamageDetectionDataDto
     */
    'inspector'?: GeneralInspectorDto;
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof DamageDetectionDataDto
     */
    'mileage'?: VehicleMileageDto;
    /**
     * 
     * @type {number}
     * @memberof DamageDetectionDataDto
     */
    'fuelLevel'?: number;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionDataDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DamageDetectionDataDto
     */
    'isNoDamagesDetected'?: boolean;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof DamageDetectionDataDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * Whether already sent to the contract customer.
     * @type {boolean}
     * @memberof DamageDetectionDataDto
     */
    'isSentToCustomer'?: boolean | null;
    /**
     * 
     * @type {Array<DamageDetectionItemDataDto>}
     * @memberof DamageDetectionDataDto
     */
    'items'?: Array<DamageDetectionItemDataDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DamageDetectionDataDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
}


/**
 * 
 * @export
 * @interface DamageDetectionDeleteDto
 */
export interface DamageDetectionDeleteDto {
    /**
     * 
     * @type {boolean}
     * @memberof DamageDetectionDeleteDto
     */
    'isDeleteVehicleDamages'?: boolean;
}
/**
 * 
 * @export
 * @interface DamageDetectionDto
 */
export interface DamageDetectionDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof DamageDetectionDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageDetectionDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageDetectionDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof DamageDetectionDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof DamageDetectionDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {AssignmentReferenceDto}
     * @memberof DamageDetectionDto
     */
    'assignment'?: AssignmentReferenceDto;
    /**
     * 
     * @type {VehicleVisualModelReferenceDto}
     * @memberof DamageDetectionDto
     */
    'vehicleVisualModel'?: VehicleVisualModelReferenceDto;
    /**
     * 
     * @type {VehicleVisualModelReferenceDto}
     * @memberof DamageDetectionDto
     */
    'oldVehicleVisualModel'?: VehicleVisualModelReferenceDto;
    /**
     * 
     * @type {FrontEndAppType}
     * @memberof DamageDetectionDto
     */
    'appType'?: FrontEndAppType;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionDto
     */
    'localNumber'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DamageDetectionDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorDto}
     * @memberof DamageDetectionDto
     */
    'inspector'?: GeneralInspectorDto;
    /**
     * 
     * @type {boolean}
     * @memberof DamageDetectionDto
     */
    'isUseSupplierBranding'?: boolean;
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof DamageDetectionDto
     */
    'mileage'?: VehicleMileageDto;
    /**
     * 
     * @type {number}
     * @memberof DamageDetectionDto
     */
    'fuelLevel'?: number;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionDto
     */
    'notes'?: string | null;
    /**
     * User confirmed that vehicle has no damages.
     * @type {boolean}
     * @memberof DamageDetectionDto
     */
    'isNoDamagesDetected'?: boolean;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof DamageDetectionDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * Whether already sent to the contract customer.
     * @type {boolean}
     * @memberof DamageDetectionDto
     */
    'isSentToCustomer'?: boolean | null;
    /**
     * 
     * @type {Array<DamageDetectionItemDto>}
     * @memberof DamageDetectionDto
     */
    'items'?: Array<DamageDetectionItemDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DamageDetectionDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof DamageDetectionDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof DamageDetectionDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
    /**
     * 
     * @type {TenantRequestsMetaDto}
     * @memberof DamageDetectionDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof DamageDetectionDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {DamageDetectionCostEvaluationOverviewDto}
     * @memberof DamageDetectionDto
     */
    'costEvaluationOverview'?: DamageDetectionCostEvaluationOverviewDto;
}


/**
 * 
 * @export
 * @interface DamageDetectionGetPaginatedDto
 */
export interface DamageDetectionGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'assignmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'vehicleDamageId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'vehicleDamageIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'anyVehicleDamageIds'?: Array<string> | null;
    /**
     * 
     * @type {TenantRequestsMetaQueryDto}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof DamageDetectionGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}
/**
 * 
 * @export
 * @interface DamageDetectionItemDataDto
 */
export interface DamageDetectionItemDataDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionItemDataDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionItemDataDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehiclePartTypeReferenceDto}
     * @memberof DamageDetectionItemDataDto
     */
    'partType'?: VehiclePartTypeReferenceDto;
    /**
     * 
     * @type {DamageTypeReferenceDto}
     * @memberof DamageDetectionItemDataDto
     */
    'damageType'?: DamageTypeReferenceDto;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DamageDetectionItemDataDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionItemDataDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {VehicleArea}
     * @memberof DamageDetectionItemDataDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof DamageDetectionItemDataDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {GeneralSvgPointDto}
     * @memberof DamageDetectionItemDataDto
     */
    'point'?: GeneralSvgPointDto;
    /**
     * 
     * @type {VehicleDamageFullReferenceDto}
     * @memberof DamageDetectionItemDataDto
     */
    'damage'?: VehicleDamageFullReferenceDto;
}


/**
 * 
 * @export
 * @interface DamageDetectionItemDto
 */
export interface DamageDetectionItemDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionItemDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehiclePartTypeReferenceDto}
     * @memberof DamageDetectionItemDto
     */
    'partType'?: VehiclePartTypeReferenceDto;
    /**
     * 
     * @type {DamageTypeReferenceDto}
     * @memberof DamageDetectionItemDto
     */
    'damageType'?: DamageTypeReferenceDto;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DamageDetectionItemDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionItemDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {VehicleArea}
     * @memberof DamageDetectionItemDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof DamageDetectionItemDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {GeneralSvgPointDto}
     * @memberof DamageDetectionItemDto
     */
    'point'?: GeneralSvgPointDto;
    /**
     * 
     * @type {GeneralSvgPointDto}
     * @memberof DamageDetectionItemDto
     */
    'oldPoint'?: GeneralSvgPointDto;
    /**
     * 
     * @type {VehicleDamageFullReferenceDto}
     * @memberof DamageDetectionItemDto
     */
    'damage'?: VehicleDamageFullReferenceDto;
}


/**
 * 
 * @export
 * @interface DamageDetectionItemReferenceDto
 */
export interface DamageDetectionItemReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionItemReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionItemReferenceDto
     */
    'damageDetectionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionItemReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface DamageDetectionMigrateToNewVisualModelDto
 */
export interface DamageDetectionMigrateToNewVisualModelDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionMigrateToNewVisualModelDto
     */
    'oldVehicleVisualModelId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionMigrateToNewVisualModelDto
     */
    'newVehicleVisualModelId'?: string;
    /**
     * 
     * @type {Array<ItemDtoInDamageDetectionMigrateToNewVisualModelDto>}
     * @memberof DamageDetectionMigrateToNewVisualModelDto
     */
    'items'?: Array<ItemDtoInDamageDetectionMigrateToNewVisualModelDto>;
    /**
     * 
     * @type {boolean}
     * @memberof DamageDetectionMigrateToNewVisualModelDto
     */
    'isMigrateVehicleDamages'?: boolean;
}
/**
 * 
 * @export
 * @interface DamageDetectionReferenceDto
 */
export interface DamageDetectionReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionReferenceDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface DamageDetectionResultDto
 */
export interface DamageDetectionResultDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionResultDto
     */
    'damageDetectionId'?: string;
}
/**
 * 
 * @export
 * @interface DamageDetectionResultInputDto
 */
export interface DamageDetectionResultInputDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionResultInputDto
     */
    'damageDetectionId'?: string;
}
/**
 * 
 * @export
 * @interface DamageDetectionSendToExternalDamageCostEvaluationDto
 */
export interface DamageDetectionSendToExternalDamageCostEvaluationDto {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionSendToExternalDamageCostEvaluationDto
     */
    'assessorTenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionSendToExternalDamageCostEvaluationDto
     */
    'vehicleDamageIds'?: Array<string> | null;
    /**
     * 
     * @type {GeneralBillToInfoInputDto}
     * @memberof DamageDetectionSendToExternalDamageCostEvaluationDto
     */
    'billTo'?: GeneralBillToInfoInputDto;
}
/**
 * 
 * @export
 * @interface DamageDetectionSendToExternalDamageCostEvaluationInlineDto
 */
export interface DamageDetectionSendToExternalDamageCostEvaluationInlineDto {
    /**
     * 
     * @type {boolean}
     * @memberof DamageDetectionSendToExternalDamageCostEvaluationInlineDto
     */
    'isSend'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionSendToExternalDamageCostEvaluationInlineDto
     */
    'assessorTenantId'?: string | null;
}
/**
 * 
 * @export
 * @interface DamageDetectionSendToExternalDamageCostEvaluationResultDto
 */
export interface DamageDetectionSendToExternalDamageCostEvaluationResultDto {
    /**
     * 
     * @type {DamageDetectionDto}
     * @memberof DamageDetectionSendToExternalDamageCostEvaluationResultDto
     */
    'damageDetection': DamageDetectionDto;
    /**
     * 
     * @type {TenantRequestDto}
     * @memberof DamageDetectionSendToExternalDamageCostEvaluationResultDto
     */
    'tenantRequest': TenantRequestDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DamageDetectionStatusInContract = {
    None: 'None',
    NoDamage: 'NoDamage',
    NewDamageDetected: 'NewDamageDetected',
    NegotiatingDamage: 'NegotiatingDamage',
    DamageAgreed: 'DamageAgreed',
    DamageForceApproved: 'DamageForceApproved'
} as const;

export type DamageDetectionStatusInContract = typeof DamageDetectionStatusInContract[keyof typeof DamageDetectionStatusInContract];


/**
 * 
 * @export
 * @interface DamageRepairedDataDto
 */
export interface DamageRepairedDataDto {
    /**
     * 
     * @type {VehicleDamageReferenceDto}
     * @memberof DamageRepairedDataDto
     */
    'damage'?: VehicleDamageReferenceDto;
    /**
     * 
     * @type {RepairOperationReferenceDto}
     * @memberof DamageRepairedDataDto
     */
    'repairOperation'?: RepairOperationReferenceDto;
}
/**
 * General category of a damage.  Damage should belong to one of these categories for correct mapping to appropriate vehicle parts, for instance.
 * @export
 * @enum {string}
 */

export const DamageTypeCategory = {
    None: 'None',
    Damaged: 'Damaged',
    Scratch: 'Scratch',
    StoneChip: 'StoneChip',
    GlassCrack: 'GlassCrack',
    Dent: 'Dent',
    Paint: 'Paint',
    Smell: 'Smell',
    AbnormalSound: 'AbnormalSound',
    Torn: 'Torn',
    Malfunction: 'Malfunction',
    Stain: 'Stain',
    Missing: 'Missing'
} as const;

export type DamageTypeCategory = typeof DamageTypeCategory[keyof typeof DamageTypeCategory];


/**
 * 
 * @export
 * @interface DamageTypeChangedDto
 */
export interface DamageTypeChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageTypeChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DamageTypeChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof DamageTypeChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof DamageTypeChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof DamageTypeChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {DamageTypeDto}
     * @memberof DamageTypeChangedDto
     */
    'entity': DamageTypeDto;
    /**
     * 
     * @type {string}
     * @memberof DamageTypeChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface DamageTypeDto
 */
export interface DamageTypeDto {
    /**
     * 
     * @type {string}
     * @memberof DamageTypeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageTypeDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {DamageTypeCategory}
     * @memberof DamageTypeDto
     */
    'category'?: DamageTypeCategory;
    /**
     * 
     * @type {VehiclePartType}
     * @memberof DamageTypeDto
     */
    'partType'?: VehiclePartType;
    /**
     * 
     * @type {string}
     * @memberof DamageTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DamageTypeDto
     */
    'isCategoryRoot'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DamageTypeDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DamageTypeDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DamageTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DamageTypeDto
     */
    'isEnabledForDamageDetection'?: boolean;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DamageTypeDto
     */
    'examplePictures'?: Array<GeneralAttachmentDto>;
}


/**
 * 
 * @export
 * @interface DamageTypeGetPaginatedDto
 */
export interface DamageTypeGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof DamageTypeGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageTypeGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof DamageTypeGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageTypeGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageTypeGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DamageTypeGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof DamageTypeGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof DamageTypeGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof DamageTypeGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {DamageTypeCategory}
     * @memberof DamageTypeGetPaginatedDto
     */
    'category'?: DamageTypeCategory;
    /**
     * 
     * @type {Array<DamageTypeCategory>}
     * @memberof DamageTypeGetPaginatedDto
     */
    'categories'?: Array<DamageTypeCategory> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DamageTypeGetPaginatedDto
     */
    'isCategoryRoot'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DamageTypeGetPaginatedDto
     */
    'isEnabledForDamageDetection'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DamageTypeGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DamageTypeGetPaginatedDto
     */
    'vehiclePartTypeId'?: string | null;
}


/**
 * 
 * @export
 * @interface DamageTypeReferenceDto
 */
export interface DamageTypeReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof DamageTypeReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageTypeReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {DamageTypeCategory}
     * @memberof DamageTypeReferenceDto
     */
    'category'?: DamageTypeCategory;
    /**
     * 
     * @type {string}
     * @memberof DamageTypeReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageTypeReferenceDto
     */
    'description'?: string | null;
}


/**
 * 
 * @export
 * @interface DataExportConfigCreateDto
 */
export interface DataExportConfigCreateDto {
    /**
     * 
     * @type {ExportType}
     * @memberof DataExportConfigCreateDto
     */
    'type'?: ExportType;
    /**
     * 
     * @type {GeneralStrictEntityRelationInputDto}
     * @memberof DataExportConfigCreateDto
     */
    'primaryEntity'?: GeneralStrictEntityRelationInputDto;
    /**
     * 
     * @type {string}
     * @memberof DataExportConfigCreateDto
     */
    'mimeType'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataExportConfigCreateDto
     */
    'properties'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DataExportConfigCreateDto
     */
    'identifier'?: string;
}


/**
 * 
 * @export
 * @interface DataExportConfigDto
 */
export interface DataExportConfigDto {
    /**
     * 
     * @type {string}
     * @memberof DataExportConfigDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataExportConfigDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataExportConfigDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {ExportType}
     * @memberof DataExportConfigDto
     */
    'type'?: ExportType;
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof DataExportConfigDto
     */
    'primaryEntity'?: GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {string}
     * @memberof DataExportConfigDto
     */
    'mimeType'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataExportConfigDto
     */
    'properties'?: Array<string>;
}


/**
 * 
 * @export
 * @interface DataExportConfigGetPaginatedDto
 */
export interface DataExportConfigGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof DataExportConfigGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataExportConfigGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataExportConfigGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataExportConfigGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataExportConfigGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataExportConfigGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof DataExportConfigGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof DataExportConfigGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof DataExportConfigGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {ExportType}
     * @memberof DataExportConfigGetPaginatedDto
     */
    'type'?: ExportType;
    /**
     * 
     * @type {GeneralStrictEntityRelationInputDto}
     * @memberof DataExportConfigGetPaginatedDto
     */
    'primaryEntity'?: GeneralStrictEntityRelationInputDto;
}


/**
 * 
 * @export
 * @interface DataExportConfigUpdateDto
 */
export interface DataExportConfigUpdateDto {
    /**
     * 
     * @type {ExportType}
     * @memberof DataExportConfigUpdateDto
     */
    'type'?: ExportType;
    /**
     * 
     * @type {GeneralStrictEntityRelationInputDto}
     * @memberof DataExportConfigUpdateDto
     */
    'primaryEntity'?: GeneralStrictEntityRelationInputDto;
    /**
     * 
     * @type {string}
     * @memberof DataExportConfigUpdateDto
     */
    'mimeType'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataExportConfigUpdateDto
     */
    'properties'?: Array<string>;
}


/**
 * 
 * @export
 * @interface DataExportRequestAllFilteredScopeDto
 */
export interface DataExportRequestAllFilteredScopeDto {
    /**
     * 
     * @type {VehicleGetPaginatedDto}
     * @memberof DataExportRequestAllFilteredScopeDto
     */
    'vehicle'?: VehicleGetPaginatedDto;
    /**
     * 
     * @type {ContractGetPaginatedDto}
     * @memberof DataExportRequestAllFilteredScopeDto
     */
    'contract'?: ContractGetPaginatedDto;
    /**
     * 
     * @type {VisualInspectionGetPaginatedDto}
     * @memberof DataExportRequestAllFilteredScopeDto
     */
    'visualInspection'?: VisualInspectionGetPaginatedDto;
    /**
     * 
     * @type {DamageDetectionGetPaginatedDto}
     * @memberof DataExportRequestAllFilteredScopeDto
     */
    'damageDetection'?: DamageDetectionGetPaginatedDto;
    /**
     * 
     * @type {DamageCostEvaluationGetPaginatedDto}
     * @memberof DataExportRequestAllFilteredScopeDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationGetPaginatedDto;
    /**
     * 
     * @type {TenantRequestGetPaginatedDto}
     * @memberof DataExportRequestAllFilteredScopeDto
     */
    'tenantRequest'?: TenantRequestGetPaginatedDto;
    /**
     * 
     * @type {RepairMaterialGetPaginatedDto}
     * @memberof DataExportRequestAllFilteredScopeDto
     */
    'repairMaterial'?: RepairMaterialGetPaginatedDto;
    /**
     * 
     * @type {RepairWorkGetPaginatedDto}
     * @memberof DataExportRequestAllFilteredScopeDto
     */
    'repairWork'?: RepairWorkGetPaginatedDto;
    /**
     * 
     * @type {RepairSparePartGetPaginatedDto}
     * @memberof DataExportRequestAllFilteredScopeDto
     */
    'repairSparePart'?: RepairSparePartGetPaginatedDto;
    /**
     * 
     * @type {RepairSpecGetPaginatedDto}
     * @memberof DataExportRequestAllFilteredScopeDto
     */
    'repairSpec'?: RepairSpecGetPaginatedDto;
}
/**
 * 
 * @export
 * @interface DataExportRequestCurrentPageScopeDto
 */
export interface DataExportRequestCurrentPageScopeDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DataExportRequestCurrentPageScopeDto
     */
    'ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DataExportRequestDto
 */
export interface DataExportRequestDto {
    /**
     * 
     * @type {ExportType}
     * @memberof DataExportRequestDto
     */
    'type'?: ExportType;
    /**
     * 
     * @type {ExportScope}
     * @memberof DataExportRequestDto
     */
    'scope'?: ExportScope;
    /**
     * 
     * @type {GeneralStrictEntityRelationInputDto}
     * @memberof DataExportRequestDto
     */
    'primaryEntity'?: GeneralStrictEntityRelationInputDto;
    /**
     * The mime type of the export file (xlsx, csv, etc.).  />
     * @type {string}
     * @memberof DataExportRequestDto
     */
    'mimeType'?: string;
    /**
     * The properties to export.  />
     * @type {Array<string>}
     * @memberof DataExportRequestDto
     */
    'properties'?: Array<string>;
    /**
     * 
     * @type {DataExportRequestCurrentPageScopeDto}
     * @memberof DataExportRequestDto
     */
    'currentPageScope'?: DataExportRequestCurrentPageScopeDto;
    /**
     * 
     * @type {DataExportRequestAllFilteredScopeDto}
     * @memberof DataExportRequestDto
     */
    'allFilteredScope'?: DataExportRequestAllFilteredScopeDto;
    /**
     * 
     * @type {object}
     * @memberof DataExportRequestDto
     */
    'allScope'?: object;
}


/**
 * 
 * @export
 * @interface DataGrantChangedDto
 */
export interface DataGrantChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DataGrantChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DataGrantChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof DataGrantChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof DataGrantChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof DataGrantChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {DataGrantDto}
     * @memberof DataGrantChangedDto
     */
    'entity': DataGrantDto;
    /**
     * 
     * @type {string}
     * @memberof DataGrantChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface DataGrantCountersDto
 */
export interface DataGrantCountersDto {
    /**
     * 
     * @type {number}
     * @memberof DataGrantCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {IncomingCountersDtoInDataGrantCountersDto}
     * @memberof DataGrantCountersDto
     */
    'incoming': IncomingCountersDtoInDataGrantCountersDto;
    /**
     * 
     * @type {OutcomingCountersDtoInDataGrantCountersDto}
     * @memberof DataGrantCountersDto
     */
    'outcoming': OutcomingCountersDtoInDataGrantCountersDto;
}
/**
 * 
 * @export
 * @interface DataGrantCreateDto
 */
export interface DataGrantCreateDto {
    /**
     * 
     * @type {string}
     * @memberof DataGrantCreateDto
     */
    'consumerTenantId'?: string;
    /**
     * 
     * @type {DataGrantEntityType}
     * @memberof DataGrantCreateDto
     */
    'grantEntityType'?: DataGrantEntityType;
    /**
     * 
     * @type {string}
     * @memberof DataGrantCreateDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {Array<DataGrantPermission>}
     * @memberof DataGrantCreateDto
     */
    'permissions'?: Array<DataGrantPermission>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DataGrantCreateDto
     */
    'expiresAt'?: string | null;
    /**
     * 
     * @type {TenantRequestsMetaInputDto}
     * @memberof DataGrantCreateDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaInputDto;
}


/**
 * 
 * @export
 * @interface DataGrantDto
 */
export interface DataGrantDto {
    /**
     * 
     * @type {string}
     * @memberof DataGrantDto
     */
    'id'?: string;
    /**
     * 
     * @type {DataGrantType}
     * @memberof DataGrantDto
     */
    'type'?: DataGrantType;
    /**
     * 
     * @type {boolean}
     * @memberof DataGrantDto
     */
    'isAuto'?: boolean;
    /**
     * 
     * @type {TenantReferenceDto}
     * @memberof DataGrantDto
     */
    'issuerTenant'?: TenantReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof DataGrantDto
     */
    'issuerUserId'?: string | null;
    /**
     * 
     * @type {TenantReferenceDto}
     * @memberof DataGrantDto
     */
    'consumerTenant'?: TenantReferenceDto;
    /**
     * 
     * @type {DataGrantEntityType}
     * @memberof DataGrantDto
     */
    'grantEntityType'?: DataGrantEntityType;
    /**
     * 
     * @type {string}
     * @memberof DataGrantDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {Array<DataGrantPermission>}
     * @memberof DataGrantDto
     */
    'permissions'?: Array<DataGrantPermission>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DataGrantDto
     */
    'expiresAt'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof DataGrantDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {TenantRequestsMetaDto}
     * @memberof DataGrantDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DataGrantDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DataGrantDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataGrantDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataGrantDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {EntityType}
     * @memberof DataGrantDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof DataGrantDto
     */
    'tenantIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof DataGrantDto
     */
    'userIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {DataGrantDtoPermissionsMap}
     * @memberof DataGrantDto
     */
    'permissionsMap'?: DataGrantDtoPermissionsMap;
}


/**
 * 
 * @export
 * @interface DataGrantDtoPermissionsMap
 */
export interface DataGrantDtoPermissionsMap {
    /**
     * 
     * @type {boolean}
     * @memberof DataGrantDtoPermissionsMap
     */
    'None'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataGrantDtoPermissionsMap
     */
    'Read'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataGrantDtoPermissionsMap
     */
    'Write'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataGrantDtoPermissionsMap
     */
    'Delete'?: boolean;
}
/**
 * Must contain only values from EntityType.
 * @export
 * @enum {string}
 */

export const DataGrantEntityType = {
    None: 'None',
    Vehicle: 'Vehicle',
    VehicleHistory: 'VehicleHistory',
    VehicleDamage: 'VehicleDamage',
    Accessory: 'Accessory',
    AccessoryCheck: 'AccessoryCheck',
    VisualInspection: 'VisualInspection',
    DamageDetection: 'DamageDetection',
    DamageDetectionAggregate: 'DamageDetectionAggregate',
    DamageCostEvaluation: 'DamageCostEvaluation',
    DamageCostEvaluationAggregate: 'DamageCostEvaluationAggregate',
    RepairOperation: 'RepairOperation',
    Wash: 'Wash',
    Maintenance: 'Maintenance'
} as const;

export type DataGrantEntityType = typeof DataGrantEntityType[keyof typeof DataGrantEntityType];


/**
 * 
 * @export
 * @interface DataGrantGetPaginatedDto
 */
export interface DataGrantGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof DataGrantGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataGrantGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataGrantGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataGrantGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataGrantGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataGrantGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof DataGrantGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof DataGrantGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof DataGrantGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {DataGrantType}
     * @memberof DataGrantGetPaginatedDto
     */
    'type'?: DataGrantType;
    /**
     * 
     * @type {string}
     * @memberof DataGrantGetPaginatedDto
     */
    'issuerTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataGrantGetPaginatedDto
     */
    'consumerTenantId'?: string | null;
    /**
     * 
     * @type {DataGrantEntityType}
     * @memberof DataGrantGetPaginatedDto
     */
    'grantEntityType'?: DataGrantEntityType;
    /**
     * 
     * @type {EntityType}
     * @memberof DataGrantGetPaginatedDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {string}
     * @memberof DataGrantGetPaginatedDto
     */
    'entityId'?: string | null;
    /**
     * 
     * @type {TenantRequestsMetaQueryDto}
     * @memberof DataGrantGetPaginatedDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaQueryDto;
}


/**
 * Brief info about DataGrants stored in shared entity.
 * @export
 * @interface DataGrantMeta
 */
export interface DataGrantMeta {
    /**
     * 
     * @type {string}
     * @memberof DataGrantMeta
     */
    'id'?: string;
    /**
     * 
     * @type {DataGrantType}
     * @memberof DataGrantMeta
     */
    'type': DataGrantType;
    /**
     * 
     * @type {TenantReference}
     * @memberof DataGrantMeta
     */
    'issuerTenant'?: TenantReference;
    /**
     * 
     * @type {TenantReference}
     * @memberof DataGrantMeta
     */
    'consumerTenant'?: TenantReference;
    /**
     * 
     * @type {DataGrantEntityType}
     * @memberof DataGrantMeta
     */
    'grantEntityType': DataGrantEntityType;
    /**
     * 
     * @type {string}
     * @memberof DataGrantMeta
     */
    'entityId': string;
    /**
     * 
     * @type {Array<DataGrantPermission>}
     * @memberof DataGrantMeta
     */
    'permissions': Array<DataGrantPermission>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DataGrantMeta
     */
    'expiresAt': string | null;
    /**
     * 
     * @type {EntityType}
     * @memberof DataGrantMeta
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {EntityTypeEntityIdPair}
     * @memberof DataGrantMeta
     */
    'entityTypeEntityId'?: EntityTypeEntityIdPair;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataGrantPermission = {
    None: 'None',
    Read: 'Read',
    Write: 'Write',
    Delete: 'Delete'
} as const;

export type DataGrantPermission = typeof DataGrantPermission[keyof typeof DataGrantPermission];


/**
 * 
 * @export
 * @interface DataGrantReferenceDto
 */
export interface DataGrantReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof DataGrantReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {DataGrantType}
     * @memberof DataGrantReferenceDto
     */
    'type'?: DataGrantType;
    /**
     * 
     * @type {string}
     * @memberof DataGrantReferenceDto
     */
    'issuerTenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataGrantReferenceDto
     */
    'consumerTenantId'?: string;
    /**
     * 
     * @type {DataGrantEntityType}
     * @memberof DataGrantReferenceDto
     */
    'grantEntityType'?: DataGrantEntityType;
    /**
     * 
     * @type {string}
     * @memberof DataGrantReferenceDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {EntityType}
     * @memberof DataGrantReferenceDto
     */
    'entityType'?: EntityType;
}


/**
 * 
 * @export
 * @interface DataGrantSearchPaginatedDto
 */
export interface DataGrantSearchPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof DataGrantSearchPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataGrantSearchPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataGrantSearchPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataGrantSearchPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataGrantSearchPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataGrantSearchPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof DataGrantSearchPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof DataGrantSearchPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof DataGrantSearchPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {DataGrantType}
     * @memberof DataGrantSearchPaginatedDto
     */
    'type'?: DataGrantType;
    /**
     * 
     * @type {string}
     * @memberof DataGrantSearchPaginatedDto
     */
    'issuerTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataGrantSearchPaginatedDto
     */
    'consumerTenantId'?: string | null;
    /**
     * 
     * @type {DataGrantEntityType}
     * @memberof DataGrantSearchPaginatedDto
     */
    'grantEntityType'?: DataGrantEntityType;
    /**
     * 
     * @type {EntityType}
     * @memberof DataGrantSearchPaginatedDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {string}
     * @memberof DataGrantSearchPaginatedDto
     */
    'entityId'?: string | null;
    /**
     * 
     * @type {TenantRequestsMetaQueryDto}
     * @memberof DataGrantSearchPaginatedDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaQueryDto;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataGrantType = {
    None: 'None',
    TenantToTenant: 'TenantToTenant'
} as const;

export type DataGrantType = typeof DataGrantType[keyof typeof DataGrantType];


/**
 * 
 * @export
 * @interface DataGrantUpdateDto
 */
export interface DataGrantUpdateDto {
    /**
     * 
     * @type {Array<DataGrantPermission>}
     * @memberof DataGrantUpdateDto
     */
    'permissions': Array<DataGrantPermission>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DataGrantUpdateDto
     */
    'expiresAt'?: string | null;
    /**
     * 
     * @type {TenantRequestsMetaInputDto}
     * @memberof DataGrantUpdateDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaInputDto;
}
/**
 * 
 * @export
 * @interface DataGrantsMetaBriefDto
 */
export interface DataGrantsMetaBriefDto {
    /**
     * 
     * @type {string}
     * @memberof DataGrantsMetaBriefDto
     */
    'issuerTenantId'?: string;
    /**
     * 
     * @type {DataGrantEntityType}
     * @memberof DataGrantsMetaBriefDto
     */
    'grantEntityType'?: DataGrantEntityType;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof DataGrantsMetaBriefDto
     */
    'grantIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof DataGrantsMetaBriefDto
     */
    'consumerTenantIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: Array<DataGrantPermission>; }}
     * @memberof DataGrantsMetaBriefDto
     */
    'tenantPermissions'?: { [key: string]: Array<DataGrantPermission>; };
    /**
     * 
     * @type {{ [key: string]: DataGrantDtoPermissionsMap; }}
     * @memberof DataGrantsMetaBriefDto
     */
    'tenantPermissionsMap'?: { [key: string]: DataGrantDtoPermissionsMap; };
}


/**
 * 
 * @export
 * @interface DataGrantsMetaDto
 */
export interface DataGrantsMetaDto {
    /**
     * 
     * @type {Array<DataGrantMeta>}
     * @memberof DataGrantsMetaDto
     */
    'grants': Array<DataGrantMeta>;
    /**
     * 
     * @type {string}
     * @memberof DataGrantsMetaDto
     */
    'issuerTenantId'?: string;
    /**
     * 
     * @type {DataGrantEntityType}
     * @memberof DataGrantsMetaDto
     */
    'grantEntityType'?: DataGrantEntityType;
    /**
     * 
     * @type {EntityType}
     * @memberof DataGrantsMetaDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {string}
     * @memberof DataGrantsMetaDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof DataGrantsMetaDto
     */
    'grantIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof DataGrantsMetaDto
     */
    'consumerTenantIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: Array<DataGrantPermission>; }}
     * @memberof DataGrantsMetaDto
     */
    'tenantPermissions'?: { [key: string]: Array<DataGrantPermission>; };
    /**
     * 
     * @type {{ [key: string]: DataGrantDtoPermissionsMap; }}
     * @memberof DataGrantsMetaDto
     */
    'tenantPermissionsMap'?: { [key: string]: DataGrantDtoPermissionsMap; };
}


/**
 * 
 * @export
 * @interface DataPointDtoOfDateTimeOffsetAndDecimal
 */
export interface DataPointDtoOfDateTimeOffsetAndDecimal {
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DataPointDtoOfDateTimeOffsetAndDecimal
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof DataPointDtoOfDateTimeOffsetAndDecimal
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface DataPointDtoOfVehicleStatusAndInt64
 */
export interface DataPointDtoOfVehicleStatusAndInt64 {
    /**
     * 
     * @type {VehicleStatus}
     * @memberof DataPointDtoOfVehicleStatusAndInt64
     */
    'label': VehicleStatus;
    /**
     * 
     * @type {number}
     * @memberof DataPointDtoOfVehicleStatusAndInt64
     */
    'value': number;
}


/**
 * SignalR client methods that can be called by the server.
 * @export
 * @enum {string}
 */

export const DataUpdatesHubClientMethodName = {
    Echo: 'Echo',
    ServerErrorOccurred: 'ServerErrorOccurred',
    EntityChanged: 'EntityChanged'
} as const;

export type DataUpdatesHubClientMethodName = typeof DataUpdatesHubClientMethodName[keyof typeof DataUpdatesHubClientMethodName];


/**
 * SignalR server methods that can be called by clients.
 * @export
 * @enum {string}
 */

export const DataUpdatesHubServerMethodName = {
    Echo: 'Echo',
    SubscribeOnDataUpdates: 'SubscribeOnDataUpdates',
    UnsubscribeFromDataUpdates: 'UnsubscribeFromDataUpdates'
} as const;

export type DataUpdatesHubServerMethodName = typeof DataUpdatesHubServerMethodName[keyof typeof DataUpdatesHubServerMethodName];


/**
 * 
 * @export
 * @interface DateRangeDto
 */
export interface DateRangeDto {
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DateRangeDto
     */
    'from'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DateRangeDto
     */
    'to'?: string | null;
}
/**
 * 
 * @export
 * @interface DateRangeInputDto
 */
export interface DateRangeInputDto {
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DateRangeInputDto
     */
    'from'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DateRangeInputDto
     */
    'to'?: string | null;
}
/**
 * 
 * @export
 * @interface DateRangeRequiredDto
 */
export interface DateRangeRequiredDto {
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DateRangeRequiredDto
     */
    'from': string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DateRangeRequiredDto
     */
    'to': string;
}
/**
 * 
 * @export
 * @interface DateRangeRequiredInputDto
 */
export interface DateRangeRequiredInputDto {
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DateRangeRequiredInputDto
     */
    'from': string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DateRangeRequiredInputDto
     */
    'to': string;
}
/**
 * 
 * @export
 * @interface DefaultEmailTemplateDataV2
 */
export interface DefaultEmailTemplateDataV2 {
    /**
     * 
     * @type {EmailLogo}
     * @memberof DefaultEmailTemplateDataV2
     */
    'logo'?: EmailLogo;
    /**
     * 
     * @type {string}
     * @memberof DefaultEmailTemplateDataV2
     */
    'title'?: string;
    /**
     * 
     * @type {Array<EmailSection>}
     * @memberof DefaultEmailTemplateDataV2
     */
    'sections'?: Array<EmailSection>;
    /**
     * 
     * @type {Array<EmailLink>}
     * @memberof DefaultEmailTemplateDataV2
     */
    'links'?: Array<EmailLink>;
    /**
     * 
     * @type {Array<EmailButton>}
     * @memberof DefaultEmailTemplateDataV2
     */
    'buttons'?: Array<EmailButton>;
}
/**
 * 
 * @export
 * @interface DeleteRepairMaterialInfoDto
 */
export interface DeleteRepairMaterialInfoDto {
    /**
     * 
     * @type {Array<RepairSpecDto>}
     * @memberof DeleteRepairMaterialInfoDto
     */
    'affectedRepairSpecs'?: Array<RepairSpecDto>;
}
/**
 * 
 * @export
 * @interface DeleteRepairSparePartInfoDto
 */
export interface DeleteRepairSparePartInfoDto {
    /**
     * 
     * @type {Array<RepairSpecDto>}
     * @memberof DeleteRepairSparePartInfoDto
     */
    'affectedRepairSpecs'?: Array<RepairSpecDto>;
}
/**
 * 
 * @export
 * @interface DeleteRepairWorkInfoDto
 */
export interface DeleteRepairWorkInfoDto {
    /**
     * 
     * @type {Array<RepairSpecDto>}
     * @memberof DeleteRepairWorkInfoDto
     */
    'affectedRepairSpecs'?: Array<RepairSpecDto>;
}
/**
 * 
 * @export
 * @interface DepartmentChangedDto
 */
export interface DepartmentChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DepartmentChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DepartmentChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof DepartmentChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof DepartmentChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof DepartmentChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {DepartmentDto}
     * @memberof DepartmentChangedDto
     */
    'entity': DepartmentDto;
    /**
     * 
     * @type {string}
     * @memberof DepartmentChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface DepartmentDto
 */
export interface DepartmentDto {
    /**
     * 
     * @type {string}
     * @memberof DepartmentDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof DepartmentDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DepartmentDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DepartmentDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DepartmentDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DepartmentDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DepartmentDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DepartmentDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DepartmentDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DepartmentDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DepartmentDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAddressDto}
     * @memberof DepartmentDto
     */
    'address'?: GeneralAddressDto;
    /**
     * 
     * @type {GeneralContactDto}
     * @memberof DepartmentDto
     */
    'contact'?: GeneralContactDto;
    /**
     * 
     * @type {GeneralBrandingDto}
     * @memberof DepartmentDto
     */
    'branding'?: GeneralBrandingDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof DepartmentDto
     */
    'locationIds'?: Array<string>;
}


/**
 * 
 * @export
 * @interface DepartmentGetPaginatedDto
 */
export interface DepartmentGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof DepartmentGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof DepartmentGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof DepartmentGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DepartmentGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DepartmentGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DepartmentGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof DepartmentGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof DepartmentGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof DepartmentGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
}
/**
 * 
 * @export
 * @interface DepartmentReferenceDto
 */
export interface DepartmentReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof DepartmentReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DepartmentReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DepartmentReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DepartmentReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DepartmentReferenceDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface DisconnectFromChatDto
 */
export interface DisconnectFromChatDto {
    /**
     * 
     * @type {string}
     * @memberof DisconnectFromChatDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisconnectFromChatDto
     */
    'participantId'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DiscountType = {
    None: 'None',
    Trade: 'Trade',
    Bulk: 'Bulk',
    PromptPayment: 'PromptPayment'
} as const;

export type DiscountType = typeof DiscountType[keyof typeof DiscountType];


/**
 * 
 * @export
 * @enum {string}
 */

export const DiscountValueType = {
    None: 'None',
    Percent: 'Percent',
    Value: 'Value'
} as const;

export type DiscountValueType = typeof DiscountValueType[keyof typeof DiscountValueType];


/**
 * 
 * @export
 * @interface DocumentChangedDto
 */
export interface DocumentChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof DocumentChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof DocumentChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof DocumentChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {DocumentDto}
     * @memberof DocumentChangedDto
     */
    'entity': DocumentDto;
    /**
     * 
     * @type {string}
     * @memberof DocumentChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface DocumentDataExtractionResultDto
 */
export interface DocumentDataExtractionResultDto {
    /**
     * Data extraction input files.
     * @type {Array<FileReferenceDto>}
     * @memberof DocumentDataExtractionResultDto
     */
    'inputFiles': Array<FileReferenceDto>;
    /**
     * Input files as attachments.
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DocumentDataExtractionResultDto
     */
    'inputAttachments': Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {ExtractedDocumentType}
     * @memberof DocumentDataExtractionResultDto
     */
    'requestedDocumentType'?: ExtractedDocumentType;
    /**
     * 
     * @type {ExtractedDocumentType}
     * @memberof DocumentDataExtractionResultDto
     */
    'documentType'?: ExtractedDocumentType;
    /**
     * 
     * @type {ContractExtractedDataDto}
     * @memberof DocumentDataExtractionResultDto
     */
    'contract'?: ContractExtractedDataDto;
    /**
     * 
     * @type {EntityType}
     * @memberof DocumentDataExtractionResultDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {ExtractedDocumentConfidenceLevel}
     * @memberof DocumentDataExtractionResultDto
     */
    'documentConfidenceLevel'?: ExtractedDocumentConfidenceLevel;
}


/**
 * 
 * @export
 * @interface DocumentDto
 */
export interface DocumentDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'prevDocumentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof DocumentDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {DocumentType}
     * @memberof DocumentDto
     */
    'type'?: DocumentType;
    /**
     * 
     * @type {GeneralEntitySourceDto}
     * @memberof DocumentDto
     */
    'source'?: GeneralEntitySourceDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DocumentDto
     */
    'sourceLastUpdatedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentDto
     */
    'isLatestForSource'?: boolean;
    /**
     * 
     * @type {Array<DocumentSourcingStrategy>}
     * @memberof DocumentDto
     */
    'sourcingStrategies'?: Array<DocumentSourcingStrategy>;
    /**
     * 
     * @type {GeneralStageHistoryDtoOfDocumentStage}
     * @memberof DocumentDto
     */
    'stageHistory'?: GeneralStageHistoryDtoOfDocumentStage;
    /**
     * 
     * @type {DocumentStatus}
     * @memberof DocumentDto
     */
    'status'?: DocumentStatus;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DocumentDto
     */
    'date'?: string;
    /**
     * 
     * @type {Array<DocumentSectionDto>}
     * @memberof DocumentDto
     */
    'sections'?: Array<DocumentSectionDto>;
    /**
     * 
     * @type {Array<DocumentItemDto>}
     * @memberof DocumentDto
     */
    'items'?: Array<DocumentItemDto>;
    /**
     * 
     * @type {DocumentGeneralDataDto}
     * @memberof DocumentDto
     */
    'generalData'?: DocumentGeneralDataDto;
    /**
     * 
     * @type {DamageDetectionDataDto}
     * @memberof DocumentDto
     */
    'damageDetection'?: DamageDetectionDataDto;
    /**
     * 
     * @type {DamageDetectionAggregateDataDto}
     * @memberof DocumentDto
     */
    'damageDetectionAggregate'?: DamageDetectionAggregateDataDto;
    /**
     * 
     * @type {DamageCostEvaluationDataDto}
     * @memberof DocumentDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationDataDto;
    /**
     * 
     * @type {DamageCostEvaluationAggregateDataDto}
     * @memberof DocumentDto
     */
    'damageCostEvaluationAggregate'?: DamageCostEvaluationAggregateDataDto;
    /**
     * 
     * @type {AccessoryCheckDataDto}
     * @memberof DocumentDto
     */
    'accessoryCheck'?: AccessoryCheckDataDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DocumentDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DocumentDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {GeneralScopeInfoDto}
     * @memberof DocumentDto
     */
    'scopeInfo'?: GeneralScopeInfoDto;
    /**
     * 
     * @type {Array<GeneralScopeInfoDto>}
     * @memberof DocumentDto
     */
    'allScopeInfo'?: Array<GeneralScopeInfoDto>;
}


/**
 * 
 * @export
 * @interface DocumentGeneralDataDto
 */
export interface DocumentGeneralDataDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentGeneralDataDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentGeneralDataDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentGeneralDataDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DocumentGeneralDataDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
}
/**
 * 
 * @export
 * @interface DocumentGetPaginatedDto
 */
export interface DocumentGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof DocumentGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof DocumentGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof DocumentGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof DocumentGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {DocumentType}
     * @memberof DocumentGetPaginatedDto
     */
    'type'?: DocumentType;
    /**
     * 
     * @type {DocumentStage}
     * @memberof DocumentGetPaginatedDto
     */
    'stage'?: DocumentStage;
    /**
     * 
     * @type {EntitySourceType}
     * @memberof DocumentGetPaginatedDto
     */
    'sourceType'?: EntitySourceType;
    /**
     * 
     * @type {string}
     * @memberof DocumentGetPaginatedDto
     */
    'sourceId'?: string | null;
}


/**
 * 
 * @export
 * @interface DocumentItemDto
 */
export interface DocumentItemDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentItemDto
     */
    'sectionId'?: string | null;
    /**
     * 
     * @type {GeneralEntitySourceDto}
     * @memberof DocumentItemDto
     */
    'source'?: GeneralEntitySourceDto;
    /**
     * 
     * @type {DocumentType}
     * @memberof DocumentItemDto
     */
    'type'?: DocumentType;
    /**
     * 
     * @type {DocumentStatus}
     * @memberof DocumentItemDto
     */
    'status'?: DocumentStatus;
    /**
     * 
     * @type {DocumentItemGeneralDataDto}
     * @memberof DocumentItemDto
     */
    'generalData'?: DocumentItemGeneralDataDto;
    /**
     * 
     * @type {DamageDetectionItemDataDto}
     * @memberof DocumentItemDto
     */
    'damageDetectionItem'?: DamageDetectionItemDataDto;
    /**
     * 
     * @type {DamageDetectionAggregateItemDataDto}
     * @memberof DocumentItemDto
     */
    'damageDetectionAggregateItem'?: DamageDetectionAggregateItemDataDto;
    /**
     * 
     * @type {DamageCostEvaluationItemDataDto}
     * @memberof DocumentItemDto
     */
    'damageCostEvaluationItem'?: DamageCostEvaluationItemDataDto;
    /**
     * 
     * @type {DamageCostEvaluationAggregateItemDataDto}
     * @memberof DocumentItemDto
     */
    'damageCostEvaluationAggregateItem'?: DamageCostEvaluationAggregateItemDataDto;
    /**
     * 
     * @type {AccessoryCheckItemDataDto}
     * @memberof DocumentItemDto
     */
    'accessoryCheckItem'?: AccessoryCheckItemDataDto;
    /**
     * 
     * @type {GeneralScopeInfoDto}
     * @memberof DocumentItemDto
     */
    'scopeInfo'?: GeneralScopeInfoDto;
}


/**
 * 
 * @export
 * @interface DocumentItemGeneralDataDto
 */
export interface DocumentItemGeneralDataDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentItemGeneralDataDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentItemGeneralDataDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentItemGeneralDataDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof DocumentItemGeneralDataDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
}
/**
 * 
 * @export
 * @interface DocumentReferenceDto
 */
export interface DocumentReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {DocumentType}
     * @memberof DocumentReferenceDto
     */
    'type'?: DocumentType;
    /**
     * 
     * @type {GeneralEntitySourceDto}
     * @memberof DocumentReferenceDto
     */
    'source'?: GeneralEntitySourceDto;
}


/**
 * 
 * @export
 * @interface DocumentSectionDto
 */
export interface DocumentSectionDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentSectionDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSectionDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentSectionDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentSectionDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentSectionDto
     */
    'itemIds'?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DocumentSourcingStrategy = {
    None: 'None',
    CreateOnCreate: 'CreateOnCreate',
    UpdateOnUpdate: 'UpdateOnUpdate',
    CreateOnUpdate: 'CreateOnUpdate',
    DeleteOnDelete: 'DeleteOnDelete',
    UpdateOnDelete: 'UpdateOnDelete'
} as const;

export type DocumentSourcingStrategy = typeof DocumentSourcingStrategy[keyof typeof DocumentSourcingStrategy];


/**
 * NB: use SortOrderAttribute to specify the order in which stages can be activated.
 * @export
 * @enum {string}
 */

export const DocumentStage = {
    None: 'None',
    Draft: 'Draft',
    Negotiating: 'Negotiating',
    Processed: 'Processed',
    Signed: 'Signed',
    Archived: 'Archived'
} as const;

export type DocumentStage = typeof DocumentStage[keyof typeof DocumentStage];


/**
 * 
 * @export
 * @enum {string}
 */

export const DocumentStatus = {
    None: 'None'
} as const;

export type DocumentStatus = typeof DocumentStatus[keyof typeof DocumentStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const DocumentType = {
    None: 'None',
    General: 'General',
    Typed: 'Typed'
} as const;

export type DocumentType = typeof DocumentType[keyof typeof DocumentType];


/**
 * 
 * @export
 * @interface EmailButton
 */
export interface EmailButton {
    /**
     * 
     * @type {string}
     * @memberof EmailButton
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailButton
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailButton
     */
    'backgroundColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailButton
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailButton
     */
    'fontSize'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailButton
     */
    'lineHeight'?: string;
}
/**
 * 
 * @export
 * @interface EmailChannelInfoDto
 */
export interface EmailChannelInfoDto {
    /**
     * 
     * @type {string}
     * @memberof EmailChannelInfoDto
     */
    'to'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailChannelInfoDto
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailChannelInfoDto
     */
    'templateId'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof EmailChannelInfoDto
     */
    'templateData'?: any | null;
    /**
     * 
     * @type {DefaultEmailTemplateDataV2}
     * @memberof EmailChannelInfoDto
     */
    'defaultTemplateData'?: DefaultEmailTemplateDataV2;
}
/**
 * 
 * @export
 * @interface EmailLink
 */
export interface EmailLink {
    /**
     * 
     * @type {string}
     * @memberof EmailLink
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailLink
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailLink
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailLink
     */
    'fontWeight'?: string | null;
}
/**
 * 
 * @export
 * @interface EmailLogo
 */
export interface EmailLogo {
    /**
     * 
     * @type {string}
     * @memberof EmailLogo
     */
    'imageSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailLogo
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EmailProviderType = {
    None: 'None',
    Default: 'Default',
    SendGrid: 'SendGrid',
    Mailgun: 'Mailgun',
    AmazonSes: 'AmazonSes',
    Mailchimp: 'Mailchimp',
    Microsoft365: 'Microsoft365',
    AzureCs: 'AzureCs',
    Smtp: 'Smtp'
} as const;

export type EmailProviderType = typeof EmailProviderType[keyof typeof EmailProviderType];


/**
 * 
 * @export
 * @interface EmailSection
 */
export interface EmailSection {
    /**
     * 
     * @type {string}
     * @memberof EmailSection
     */
    'text'?: string;
    /**
     * 
     * @type {Array<EmailLink>}
     * @memberof EmailSection
     */
    'sectionLinks'?: Array<EmailLink> | null;
    /**
     * 
     * @type {Array<EmailButton>}
     * @memberof EmailSection
     */
    'sectionButtons'?: Array<EmailButton> | null;
}
/**
 * 
 * @export
 * @interface EntitiesPoolsGetRequestDto
 */
export interface EntitiesPoolsGetRequestDto {
    /**
     * 
     * @type {Array<EntityPoolsGetDto>}
     * @memberof EntitiesPoolsGetRequestDto
     */
    'entities'?: Array<EntityPoolsGetDto> | null;
}
/**
 * 
 * @export
 * @interface EntityAffiliationInfoDto
 */
export interface EntityAffiliationInfoDto {
    /**
     * 
     * @type {string}
     * @memberof EntityAffiliationInfoDto
     */
    'tenantId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EntityAffiliationInfoDto
     */
    'departmentIds': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EntityAffiliationInfoDto
     */
    'locationIds': Array<string> | null;
}
/**
 * 
 * @export
 * @interface EntityAffiliationInfoInputDto
 */
export interface EntityAffiliationInfoInputDto {
    /**
     * 
     * @type {string}
     * @memberof EntityAffiliationInfoInputDto
     */
    'tenantId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EntityAffiliationInfoInputDto
     */
    'departmentIds': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EntityAffiliationInfoInputDto
     */
    'locationIds': Array<string> | null;
}
/**
 * 
 * @export
 * @interface EntityBulkDeleteDto
 */
export interface EntityBulkDeleteDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof EntityBulkDeleteDto
     */
    'ids'?: Array<string>;
    /**
     * 
     * @type {Array<EntityType>}
     * @memberof EntityBulkDeleteDto
     */
    'relatedEntitiesTypes'?: Array<EntityType>;
}
/**
 * Describes type of already applied change.
 * @export
 * @enum {string}
 */

export const EntityChangeType = {
    None: 'None',
    Created: 'Created',
    Updated: 'Updated',
    Deleted: 'Deleted'
} as const;

export type EntityChangeType = typeof EntityChangeType[keyof typeof EntityChangeType];


/**
 * 
 * @export
 * @interface EntityChangedDtoOfTEntityDto
 */
export interface EntityChangedDtoOfTEntityDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof EntityChangedDtoOfTEntityDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof EntityChangedDtoOfTEntityDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof EntityChangedDtoOfTEntityDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof EntityChangedDtoOfTEntityDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof EntityChangedDtoOfTEntityDto
     */
    'entityId': string;
    /**
     * 
     * @type {object}
     * @memberof EntityChangedDtoOfTEntityDto
     */
    'entity': object;
    /**
     * 
     * @type {string}
     * @memberof EntityChangedDtoOfTEntityDto
     */
    'tenantId': string | null;
}


/**
 * Specifies whether entity data is referenced or defined inline.
 * @export
 * @enum {string}
 */

export const EntityDataOriginMode = {
    None: 'None',
    Ref: 'Ref',
    Inline: 'Inline'
} as const;

export type EntityDataOriginMode = typeof EntityDataOriginMode[keyof typeof EntityDataOriginMode];


/**
 * Describes the form of an entity object instance.  Used as a discriminator to distinguish between different forms of entity object in code or storage.
 * @export
 * @enum {string}
 */

export const EntityFormType = {
    None: 'None',
    Entity: 'Entity',
    Ref: 'Ref',
    FullRef: 'FullRef',
    Data: 'Data'
} as const;

export type EntityFormType = typeof EntityFormType[keyof typeof EntityFormType];


/**
 * Contains Info related to results of matching/searching an entity by some criteria.
 * @export
 * @interface EntityMatchMetaDto
 */
export interface EntityMatchMetaDto {
    /**
     * Match score [0, 100]. The higher value the better match.
     * @type {number}
     * @memberof EntityMatchMetaDto
     */
    'score'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EntityMatchMetaDto
     */
    'isPerfect'?: boolean;
}
/**
 * Defines the origin of an entity in terms of tenant boundaries.    I.e. where the entity conceptually comes from, not just where it resides.
 * @export
 * @enum {string}
 */

export const EntityOriginType = {
    None: 'None',
    Local: 'Local',
    External: 'External'
} as const;

export type EntityOriginType = typeof EntityOriginType[keyof typeof EntityOriginType];


/**
 * 
 * @export
 * @interface EntityPoolsDto
 */
export interface EntityPoolsDto {
    /**
     * 
     * @type {EntityPoolsGetRequest}
     * @memberof EntityPoolsDto
     */
    'request'?: EntityPoolsGetRequest;
    /**
     * 
     * @type {Array<PoolEntity>}
     * @memberof EntityPoolsDto
     */
    'pools'?: Array<PoolEntity>;
    /**
     * 
     * @type {Array<PoolEntity>}
     * @memberof EntityPoolsDto
     */
    'assetPools'?: Array<PoolEntity> | null;
}
/**
 * 
 * @export
 * @interface EntityPoolsGetDto
 */
export interface EntityPoolsGetDto {
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof EntityPoolsGetDto
     */
    'entityType'?: PoolItemEntityType;
    /**
     * 
     * @type {string}
     * @memberof EntityPoolsGetDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EntityPoolsGetDto
     */
    'isIncludeAssetPools'?: boolean;
}


/**
 * 
 * @export
 * @interface EntityPoolsGetRequest
 */
export interface EntityPoolsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EntityPoolsGetRequest
     */
    'tenantId': string;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof EntityPoolsGetRequest
     */
    'entityType': PoolItemEntityType;
    /**
     * 
     * @type {string}
     * @memberof EntityPoolsGetRequest
     */
    'entityId': string;
    /**
     * 
     * @type {boolean}
     * @memberof EntityPoolsGetRequest
     */
    'isIncludeAssetPools'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const EntitySourceSubType = {
    None: 'None',
    DamageDetection: 'DamageDetection',
    DamageDetectionItem: 'DamageDetectionItem',
    DamageDetectionAggregate: 'DamageDetectionAggregate',
    DamageDetectionAggregateItem: 'DamageDetectionAggregateItem',
    DamageCostEvaluationItem: 'DamageCostEvaluationItem',
    DamageCostEvaluationAggregateItem: 'DamageCostEvaluationAggregateItem',
    AccessoryCheckItem: 'AccessoryCheckItem'
} as const;

export type EntitySourceSubType = typeof EntitySourceSubType[keyof typeof EntitySourceSubType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EntitySourceType = {
    None: 'None',
    VisualInspection: 'VisualInspection',
    DamageDetection: 'DamageDetection',
    DamageDetectionAggregate: 'DamageDetectionAggregate',
    DamageCostEvaluation: 'DamageCostEvaluation',
    DamageCostEvaluationAggregate: 'DamageCostEvaluationAggregate',
    AccessoryCheck: 'AccessoryCheck',
    RepairOperation: 'RepairOperation',
    WheelOperation: 'WheelOperation',
    Document: 'Document',
    Wash: 'Wash',
    Maintenance: 'Maintenance'
} as const;

export type EntitySourceType = typeof EntitySourceType[keyof typeof EntitySourceType];


/**
 * 
 * @export
 * @interface EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
 */
export interface EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto {
    /**
     * 
     * @type {number}
     * @memberof EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EntityType = {
    None: 'None',
    User: 'User',
    Role: 'Role',
    Company: 'Company',
    Department: 'Department',
    Location: 'Location',
    Spot: 'Spot',
    Vehicle: 'Vehicle',
    VehicleHistory: 'VehicleHistory',
    VehicleDamage: 'VehicleDamage',
    Contract: 'Contract',
    Customer: 'Customer',
    Accessory: 'Accessory',
    VisualInspection: 'VisualInspection',
    DamageDetection: 'DamageDetection',
    DamageDetectionAggregate: 'DamageDetectionAggregate',
    DamageCostEvaluation: 'DamageCostEvaluation',
    DamageCostEvaluationAggregate: 'DamageCostEvaluationAggregate',
    AccessoryCheck: 'AccessoryCheck',
    RepairOperation: 'RepairOperation',
    Maintenance: 'Maintenance',
    Document: 'Document',
    DocumentItem: 'DocumentItem',
    Chat: 'Chat',
    ChatParticipant: 'ChatParticipant',
    ChatMessage: 'ChatMessage',
    ChatHistoryItem: 'ChatHistoryItem',
    ChatEvent: 'ChatEvent',
    ChatActivity: 'ChatActivity',
    ChatUserSettings: 'ChatUserSettings',
    Negotiation: 'Negotiation',
    NegotiationProposal: 'NegotiationProposal',
    File: 'File',
    Invoice: 'Invoice',
    Invite: 'Invite',
    VehicleType: 'VehicleType',
    VehicleMake: 'VehicleMake',
    VehicleModel: 'VehicleModel',
    VehicleGeneration: 'VehicleGeneration',
    VehicleModification: 'VehicleModification',
    VehicleBodyType: 'VehicleBodyType',
    VehicleFuelType: 'VehicleFuelType',
    VehiclePartType: 'VehiclePartType',
    VehicleVisualModel: 'VehicleVisualModel',
    DamageType: 'DamageType',
    RepairCatalog: 'RepairCatalog',
    RepairWork: 'RepairWork',
    RepairMaterial: 'RepairMaterial',
    RepairSpec: 'RepairSpec',
    RepairSparePart: 'RepairSparePart',
    SubscriptionPlan: 'SubscriptionPlan',
    Subscription: 'Subscription',
    AssetSubscriptionPlan: 'AssetSubscriptionPlan',
    AssetSubscription: 'AssetSubscription',
    ProductLocation: 'ProductLocation',
    Pool: 'Pool',
    PoolItem: 'PoolItem',
    Asset: 'Asset',
    IntegrationApiClient: 'IntegrationApiClient',
    TenantConnectionRequest: 'TenantConnectionRequest',
    TenantConnection: 'TenantConnection',
    TenantRequest: 'TenantRequest',
    DataGrant: 'DataGrant',
    AssessmentFlow: 'AssessmentFlow',
    UserSecret: 'UserSecret',
    CustomIdentity: 'CustomIdentity',
    CustomSession: 'CustomSession',
    FlowInstance: 'FlowInstance',
    FlowSpec: 'FlowSpec',
    FlowStepSpec: 'FlowStepSpec',
    GeneralEventLog: 'GeneralEventLog',
    Import: 'Import',
    ImportTemplate: 'ImportTemplate',
    NumberRegistryItem: 'NumberRegistryItem',
    Party: 'Party',
    PartyMember: 'PartyMember',
    TestDamageAssessmentReport: 'TestDamageAssessmentReport',
    Test: 'Test',
    UserVerificationRequest: 'UserVerificationRequest',
    DeviceToken: 'DeviceToken',
    Notification: 'Notification',
    NotificationGroup: 'NotificationGroup',
    NotificationGroupMember: 'NotificationGroupMember',
    NotificationProfile: 'NotificationProfile',
    CustomTag: 'CustomTag',
    Wash: 'Wash',
    Webhook: 'Webhook',
    WebhookActivation: 'WebhookActivation',
    GeneralHistory: 'GeneralHistory',
    TeslaConnection: 'TeslaConnection',
    GeneralStatusHistory: 'GeneralStatusHistory',
    WheelOperation: 'WheelOperation',
    Supplier: 'Supplier',
    Assignment: 'Assignment',
    ContextThread: 'ContextThread',
    KeyValue: 'KeyValue',
    AnnotationTriple: 'AnnotationTriple',
    Charge: 'Charge',
    DataExportConfig: 'DataExportConfig',
    OnboardingDefinition: 'OnboardingDefinition',
    Onboarding: 'Onboarding'
} as const;

export type EntityType = typeof EntityType[keyof typeof EntityType];


/**
 * 
 * @export
 * @interface EntityTypeEntityIdPair
 */
export interface EntityTypeEntityIdPair {
    /**
     * 
     * @type {EntityType}
     * @memberof EntityTypeEntityIdPair
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof EntityTypeEntityIdPair
     */
    'entityId': string;
}


/**
 * 
 * @export
 * @interface EntityTypeEntityIdPairInputDto
 */
export interface EntityTypeEntityIdPairInputDto {
    /**
     * 
     * @type {EntityType}
     * @memberof EntityTypeEntityIdPairInputDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {string}
     * @memberof EntityTypeEntityIdPairInputDto
     */
    'entityId'?: string;
}


/**
 * 
 * @export
 * @interface EnumCatalogDto
 */
export interface EnumCatalogDto {
    /**
     * {{EnumTypeName}: Dto}
     * @type {{ [key: string]: Array<EnumDto>; }}
     * @memberof EnumCatalogDto
     */
    'enumsMap': { [key: string]: Array<EnumDto>; };
}
/**
 * Represents enum data retrieved from DisplayAttribute
 * @export
 * @interface EnumDto
 */
export interface EnumDto {
    /**
     * 
     * @type {string}
     * @memberof EnumDto
     */
    'enumTypeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnumDto
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnumDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnumDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnumDto
     */
    'shortName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnumDto
     */
    'description'?: string | null;
    /**
     * List enum values to which this enum value is linked.
     * @type {Array<EnumLinkDto>}
     * @memberof EnumDto
     */
    'enumLinks'?: Array<EnumLinkDto>;
}
/**
 * 
 * @export
 * @interface EnumLinkDto
 */
export interface EnumLinkDto {
    /**
     * 
     * @type {string}
     * @memberof EnumLinkDto
     */
    'enumTypeName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnumLinkDto
     */
    'enumValues'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof EnumLinkDto
     */
    'enumValuesMap'?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface EnumTransitionSpecDto
 */
export interface EnumTransitionSpecDto {
    /**
     * 
     * @type {string}
     * @memberof EnumTransitionSpecDto
     */
    'enumTypeName': string;
    /**
     * 
     * @type {{ [key: string]: EnumTransitionSpecEntryDto; }}
     * @memberof EnumTransitionSpecDto
     */
    'entriesMap': { [key: string]: EnumTransitionSpecEntryDto; };
    /**
     * 
     * @type {Array<string>}
     * @memberof EnumTransitionSpecDto
     */
    'ignoredValues': Array<string> | null;
}
/**
 * 
 * @export
 * @interface EnumTransitionSpecEntryDto
 */
export interface EnumTransitionSpecEntryDto {
    /**
     * 
     * @type {string}
     * @memberof EnumTransitionSpecEntryDto
     */
    'source': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnumTransitionSpecEntryDto
     */
    'exactTargets': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnumTransitionSpecEntryDto
     */
    'exceptTargets': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnumTransitionSpecEntryDto
     */
    'ignoredTargets': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnumTransitionSpecEntryDto
     */
    'targets': Array<string>;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof EnumTransitionSpecEntryDto
     */
    'targetsMap': { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ExportScope = {
    None: 'None',
    CurrentPage: 'CurrentPage',
    AllFiltered: 'AllFiltered',
    All: 'All'
} as const;

export type ExportScope = typeof ExportScope[keyof typeof ExportScope];


/**
 * 
 * @export
 * @enum {string}
 */

export const ExportType = {
    None: 'None',
    Vehicle: 'Vehicle',
    Contract: 'Contract',
    AssessmentFlow: 'AssessmentFlow',
    Accessory: 'Accessory',
    Customer: 'Customer',
    Supplier: 'Supplier',
    DamageDetection: 'DamageDetection',
    DamageDetectionAggregate: 'DamageDetectionAggregate',
    DamageCostEvaluation: 'DamageCostEvaluation',
    DamageCostEvaluationAggregate: 'DamageCostEvaluationAggregate',
    AccessoryCheck: 'AccessoryCheck',
    VisualInspection: 'VisualInspection',
    GeneralHistory: 'GeneralHistory',
    GeneralStatusHistory: 'GeneralStatusHistory',
    TenantRequest: 'TenantRequest',
    RepairMaterial: 'RepairMaterial',
    RepairWork: 'RepairWork',
    RepairSparePart: 'RepairSparePart',
    RepairSpec: 'RepairSpec'
} as const;

export type ExportType = typeof ExportType[keyof typeof ExportType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ExtractedDocumentConfidenceLevel = {
    None: 'None',
    Low: 'Low',
    Medium: 'Medium',
    High: 'High'
} as const;

export type ExtractedDocumentConfidenceLevel = typeof ExtractedDocumentConfidenceLevel[keyof typeof ExtractedDocumentConfidenceLevel];


/**
 * 
 * @export
 * @enum {string}
 */

export const ExtractedDocumentType = {
    None: 'None',
    Make: 'Make',
    Model: 'Model',
    Vehicle: 'Vehicle',
    Customer: 'Customer',
    Contract: 'Contract',
    Location: 'Location',
    Spot: 'Spot',
    MakeModel: 'MakeModel'
} as const;

export type ExtractedDocumentType = typeof ExtractedDocumentType[keyof typeof ExtractedDocumentType];


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfAvailabilityStatus
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfAvailabilityStatus {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfAvailabilityStatus
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfAvailabilityStatus
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {AvailabilityStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfAvailabilityStatus
     */
    'equal'?: AvailabilityStatus;
    /**
     * 
     * @type {AvailabilityStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfAvailabilityStatus
     */
    'notEqual'?: AvailabilityStatus;
    /**
     * 
     * @type {AvailabilityStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfAvailabilityStatus
     */
    'lessThan'?: AvailabilityStatus;
    /**
     * 
     * @type {AvailabilityStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfAvailabilityStatus
     */
    'lessThanOrEqual'?: AvailabilityStatus;
    /**
     * 
     * @type {AvailabilityStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfAvailabilityStatus
     */
    'greaterThan'?: AvailabilityStatus;
    /**
     * 
     * @type {AvailabilityStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfAvailabilityStatus
     */
    'greaterThanOrEqual'?: AvailabilityStatus;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<AvailabilityStatus>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfAvailabilityStatus
     */
    'anyOf'?: Array<AvailabilityStatus> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<AvailabilityStatus>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfAvailabilityStatus
     */
    'noneOf'?: Array<AvailabilityStatus> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfBillingPeriod
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfBillingPeriod {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfBillingPeriod
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfBillingPeriod
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {BillingPeriod}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfBillingPeriod
     */
    'equal'?: BillingPeriod;
    /**
     * 
     * @type {BillingPeriod}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfBillingPeriod
     */
    'notEqual'?: BillingPeriod;
    /**
     * 
     * @type {BillingPeriod}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfBillingPeriod
     */
    'lessThan'?: BillingPeriod;
    /**
     * 
     * @type {BillingPeriod}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfBillingPeriod
     */
    'lessThanOrEqual'?: BillingPeriod;
    /**
     * 
     * @type {BillingPeriod}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfBillingPeriod
     */
    'greaterThan'?: BillingPeriod;
    /**
     * 
     * @type {BillingPeriod}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfBillingPeriod
     */
    'greaterThanOrEqual'?: BillingPeriod;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<BillingPeriod>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfBillingPeriod
     */
    'anyOf'?: Array<BillingPeriod> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<BillingPeriod>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfBillingPeriod
     */
    'noneOf'?: Array<BillingPeriod> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfChargeCategory
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfChargeCategory {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeCategory
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeCategory
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {ChargeCategory}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeCategory
     */
    'equal'?: ChargeCategory;
    /**
     * 
     * @type {ChargeCategory}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeCategory
     */
    'notEqual'?: ChargeCategory;
    /**
     * 
     * @type {ChargeCategory}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeCategory
     */
    'lessThan'?: ChargeCategory;
    /**
     * 
     * @type {ChargeCategory}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeCategory
     */
    'lessThanOrEqual'?: ChargeCategory;
    /**
     * 
     * @type {ChargeCategory}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeCategory
     */
    'greaterThan'?: ChargeCategory;
    /**
     * 
     * @type {ChargeCategory}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeCategory
     */
    'greaterThanOrEqual'?: ChargeCategory;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<ChargeCategory>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeCategory
     */
    'anyOf'?: Array<ChargeCategory> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<ChargeCategory>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeCategory
     */
    'noneOf'?: Array<ChargeCategory> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfChargeType
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfChargeType {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeType
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeType
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {ChargeType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeType
     */
    'equal'?: ChargeType;
    /**
     * 
     * @type {ChargeType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeType
     */
    'notEqual'?: ChargeType;
    /**
     * 
     * @type {ChargeType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeType
     */
    'lessThan'?: ChargeType;
    /**
     * 
     * @type {ChargeType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeType
     */
    'lessThanOrEqual'?: ChargeType;
    /**
     * 
     * @type {ChargeType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeType
     */
    'greaterThan'?: ChargeType;
    /**
     * 
     * @type {ChargeType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeType
     */
    'greaterThanOrEqual'?: ChargeType;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<ChargeType>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeType
     */
    'anyOf'?: Array<ChargeType> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<ChargeType>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfChargeType
     */
    'noneOf'?: Array<ChargeType> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfCurrencyCode
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfCurrencyCode {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfCurrencyCode
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfCurrencyCode
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfCurrencyCode
     */
    'equal'?: CurrencyCode;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfCurrencyCode
     */
    'notEqual'?: CurrencyCode;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfCurrencyCode
     */
    'lessThan'?: CurrencyCode;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfCurrencyCode
     */
    'lessThanOrEqual'?: CurrencyCode;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfCurrencyCode
     */
    'greaterThan'?: CurrencyCode;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfCurrencyCode
     */
    'greaterThanOrEqual'?: CurrencyCode;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<CurrencyCode>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfCurrencyCode
     */
    'anyOf'?: Array<CurrencyCode> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<CurrencyCode>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfCurrencyCode
     */
    'noneOf'?: Array<CurrencyCode> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfDamageCorrectionStatus
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfDamageCorrectionStatus {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDamageCorrectionStatus
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDamageCorrectionStatus
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {DamageCorrectionStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDamageCorrectionStatus
     */
    'equal'?: DamageCorrectionStatus;
    /**
     * 
     * @type {DamageCorrectionStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDamageCorrectionStatus
     */
    'notEqual'?: DamageCorrectionStatus;
    /**
     * 
     * @type {DamageCorrectionStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDamageCorrectionStatus
     */
    'lessThan'?: DamageCorrectionStatus;
    /**
     * 
     * @type {DamageCorrectionStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDamageCorrectionStatus
     */
    'lessThanOrEqual'?: DamageCorrectionStatus;
    /**
     * 
     * @type {DamageCorrectionStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDamageCorrectionStatus
     */
    'greaterThan'?: DamageCorrectionStatus;
    /**
     * 
     * @type {DamageCorrectionStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDamageCorrectionStatus
     */
    'greaterThanOrEqual'?: DamageCorrectionStatus;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<DamageCorrectionStatus>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDamageCorrectionStatus
     */
    'anyOf'?: Array<DamageCorrectionStatus> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<DamageCorrectionStatus>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDamageCorrectionStatus
     */
    'noneOf'?: Array<DamageCorrectionStatus> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset
     */
    'isNull'?: boolean | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset
     */
    'equal'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset
     */
    'notEqual'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset
     */
    'lessThan'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset
     */
    'lessThanOrEqual'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset
     */
    'greaterThan'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset
     */
    'greaterThanOrEqual'?: string | null;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<string>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset
     */
    'anyOf'?: Array<string> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<string>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset
     */
    'noneOf'?: Array<string> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfDecimal
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfDecimal {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDecimal
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDecimal
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDecimal
     */
    'equal'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDecimal
     */
    'notEqual'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDecimal
     */
    'lessThan'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDecimal
     */
    'lessThanOrEqual'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDecimal
     */
    'greaterThan'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDecimal
     */
    'greaterThanOrEqual'?: number | null;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<number>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDecimal
     */
    'anyOf'?: Array<number> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<number>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfDecimal
     */
    'noneOf'?: Array<number> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceSubType
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceSubType {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceSubType
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceSubType
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {EntitySourceSubType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceSubType
     */
    'equal'?: EntitySourceSubType;
    /**
     * 
     * @type {EntitySourceSubType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceSubType
     */
    'notEqual'?: EntitySourceSubType;
    /**
     * 
     * @type {EntitySourceSubType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceSubType
     */
    'lessThan'?: EntitySourceSubType;
    /**
     * 
     * @type {EntitySourceSubType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceSubType
     */
    'lessThanOrEqual'?: EntitySourceSubType;
    /**
     * 
     * @type {EntitySourceSubType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceSubType
     */
    'greaterThan'?: EntitySourceSubType;
    /**
     * 
     * @type {EntitySourceSubType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceSubType
     */
    'greaterThanOrEqual'?: EntitySourceSubType;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<EntitySourceSubType>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceSubType
     */
    'anyOf'?: Array<EntitySourceSubType> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<EntitySourceSubType>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceSubType
     */
    'noneOf'?: Array<EntitySourceSubType> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceType
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceType {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceType
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceType
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {EntitySourceType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceType
     */
    'equal'?: EntitySourceType;
    /**
     * 
     * @type {EntitySourceType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceType
     */
    'notEqual'?: EntitySourceType;
    /**
     * 
     * @type {EntitySourceType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceType
     */
    'lessThan'?: EntitySourceType;
    /**
     * 
     * @type {EntitySourceType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceType
     */
    'lessThanOrEqual'?: EntitySourceType;
    /**
     * 
     * @type {EntitySourceType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceType
     */
    'greaterThan'?: EntitySourceType;
    /**
     * 
     * @type {EntitySourceType}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceType
     */
    'greaterThanOrEqual'?: EntitySourceType;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<EntitySourceType>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceType
     */
    'anyOf'?: Array<EntitySourceType> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<EntitySourceType>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceType
     */
    'noneOf'?: Array<EntitySourceType> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfOperabilityStatus
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfOperabilityStatus {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfOperabilityStatus
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfOperabilityStatus
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {OperabilityStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfOperabilityStatus
     */
    'equal'?: OperabilityStatus;
    /**
     * 
     * @type {OperabilityStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfOperabilityStatus
     */
    'notEqual'?: OperabilityStatus;
    /**
     * 
     * @type {OperabilityStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfOperabilityStatus
     */
    'lessThan'?: OperabilityStatus;
    /**
     * 
     * @type {OperabilityStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfOperabilityStatus
     */
    'lessThanOrEqual'?: OperabilityStatus;
    /**
     * 
     * @type {OperabilityStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfOperabilityStatus
     */
    'greaterThan'?: OperabilityStatus;
    /**
     * 
     * @type {OperabilityStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfOperabilityStatus
     */
    'greaterThanOrEqual'?: OperabilityStatus;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<OperabilityStatus>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfOperabilityStatus
     */
    'anyOf'?: Array<OperabilityStatus> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<OperabilityStatus>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfOperabilityStatus
     */
    'noneOf'?: Array<OperabilityStatus> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfUtilizationStatus
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfUtilizationStatus {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfUtilizationStatus
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfUtilizationStatus
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {UtilizationStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfUtilizationStatus
     */
    'equal'?: UtilizationStatus;
    /**
     * 
     * @type {UtilizationStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfUtilizationStatus
     */
    'notEqual'?: UtilizationStatus;
    /**
     * 
     * @type {UtilizationStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfUtilizationStatus
     */
    'lessThan'?: UtilizationStatus;
    /**
     * 
     * @type {UtilizationStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfUtilizationStatus
     */
    'lessThanOrEqual'?: UtilizationStatus;
    /**
     * 
     * @type {UtilizationStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfUtilizationStatus
     */
    'greaterThan'?: UtilizationStatus;
    /**
     * 
     * @type {UtilizationStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfUtilizationStatus
     */
    'greaterThanOrEqual'?: UtilizationStatus;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<UtilizationStatus>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfUtilizationStatus
     */
    'anyOf'?: Array<UtilizationStatus> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<UtilizationStatus>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfUtilizationStatus
     */
    'noneOf'?: Array<UtilizationStatus> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfVehicleArea
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfVehicleArea {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleArea
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleArea
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {VehicleArea}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleArea
     */
    'equal'?: VehicleArea;
    /**
     * 
     * @type {VehicleArea}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleArea
     */
    'notEqual'?: VehicleArea;
    /**
     * 
     * @type {VehicleArea}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleArea
     */
    'lessThan'?: VehicleArea;
    /**
     * 
     * @type {VehicleArea}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleArea
     */
    'lessThanOrEqual'?: VehicleArea;
    /**
     * 
     * @type {VehicleArea}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleArea
     */
    'greaterThan'?: VehicleArea;
    /**
     * 
     * @type {VehicleArea}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleArea
     */
    'greaterThanOrEqual'?: VehicleArea;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<VehicleArea>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleArea
     */
    'anyOf'?: Array<VehicleArea> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<VehicleArea>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleArea
     */
    'noneOf'?: Array<VehicleArea> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfVehicleDamageState
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfVehicleDamageState {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleDamageState
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleDamageState
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {VehicleDamageState}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleDamageState
     */
    'equal'?: VehicleDamageState;
    /**
     * 
     * @type {VehicleDamageState}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleDamageState
     */
    'notEqual'?: VehicleDamageState;
    /**
     * 
     * @type {VehicleDamageState}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleDamageState
     */
    'lessThan'?: VehicleDamageState;
    /**
     * 
     * @type {VehicleDamageState}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleDamageState
     */
    'lessThanOrEqual'?: VehicleDamageState;
    /**
     * 
     * @type {VehicleDamageState}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleDamageState
     */
    'greaterThan'?: VehicleDamageState;
    /**
     * 
     * @type {VehicleDamageState}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleDamageState
     */
    'greaterThanOrEqual'?: VehicleDamageState;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<VehicleDamageState>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleDamageState
     */
    'anyOf'?: Array<VehicleDamageState> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<VehicleDamageState>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleDamageState
     */
    'noneOf'?: Array<VehicleDamageState> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfVehicleProjection
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfVehicleProjection {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleProjection
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleProjection
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleProjection
     */
    'equal'?: VehicleProjection;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleProjection
     */
    'notEqual'?: VehicleProjection;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleProjection
     */
    'lessThan'?: VehicleProjection;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleProjection
     */
    'lessThanOrEqual'?: VehicleProjection;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleProjection
     */
    'greaterThan'?: VehicleProjection;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleProjection
     */
    'greaterThanOrEqual'?: VehicleProjection;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<VehicleProjection>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleProjection
     */
    'anyOf'?: Array<VehicleProjection> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<VehicleProjection>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleProjection
     */
    'noneOf'?: Array<VehicleProjection> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfNullableOfVehicleStatus
 */
export interface FieldFilterOfPrimitiveDtoOfNullableOfVehicleStatus {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleStatus
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleStatus
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {VehicleStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleStatus
     */
    'equal'?: VehicleStatus;
    /**
     * 
     * @type {VehicleStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleStatus
     */
    'notEqual'?: VehicleStatus;
    /**
     * 
     * @type {VehicleStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleStatus
     */
    'lessThan'?: VehicleStatus;
    /**
     * 
     * @type {VehicleStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleStatus
     */
    'lessThanOrEqual'?: VehicleStatus;
    /**
     * 
     * @type {VehicleStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleStatus
     */
    'greaterThan'?: VehicleStatus;
    /**
     * 
     * @type {VehicleStatus}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleStatus
     */
    'greaterThanOrEqual'?: VehicleStatus;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<VehicleStatus>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleStatus
     */
    'anyOf'?: Array<VehicleStatus> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<VehicleStatus>}
     * @memberof FieldFilterOfPrimitiveDtoOfNullableOfVehicleStatus
     */
    'noneOf'?: Array<VehicleStatus> | null;
}


/**
 * Defines filters for a field of a primitive type.
 * @export
 * @interface FieldFilterOfPrimitiveDtoOfString
 */
export interface FieldFilterOfPrimitiveDtoOfString {
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof FieldFilterOfPrimitiveDtoOfString
     */
    'operator'?: FilterLogicalOperator;
    /**
     * null - ignore.    false - the field exists and is null.    true - the field doesn\'t exist or is null.
     * @type {boolean}
     * @memberof FieldFilterOfPrimitiveDtoOfString
     */
    'isNull'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FieldFilterOfPrimitiveDtoOfString
     */
    'equal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldFilterOfPrimitiveDtoOfString
     */
    'notEqual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldFilterOfPrimitiveDtoOfString
     */
    'lessThan'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldFilterOfPrimitiveDtoOfString
     */
    'lessThanOrEqual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldFilterOfPrimitiveDtoOfString
     */
    'greaterThan'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldFilterOfPrimitiveDtoOfString
     */
    'greaterThanOrEqual'?: string | null;
    /**
     * The field is equal to any of the values (is in the list).
     * @type {Array<string>}
     * @memberof FieldFilterOfPrimitiveDtoOfString
     */
    'anyOf'?: Array<string> | null;
    /**
     * The field is not equal to any of the values (is not in the list).
     * @type {Array<string>}
     * @memberof FieldFilterOfPrimitiveDtoOfString
     */
    'noneOf'?: Array<string> | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FileAccessLevel = {
    None: 'None',
    Private: 'Private',
    Public: 'Public'
} as const;

export type FileAccessLevel = typeof FileAccessLevel[keyof typeof FileAccessLevel];


/**
 * 
 * @export
 * @interface FileChangedDto
 */
export interface FileChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof FileChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof FileChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof FileChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof FileChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof FileChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {FileDto}
     * @memberof FileChangedDto
     */
    'entity': FileDto;
    /**
     * 
     * @type {string}
     * @memberof FileChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface FileDto
 */
export interface FileDto {
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'originalFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'displayFileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'contentType'?: string;
    /**
     * 
     * @type {number}
     * @memberof FileDto
     */
    'sizeBytes'?: number;
    /**
     * 
     * @type {GeneralFileSizeDto}
     * @memberof FileDto
     */
    'size'?: GeneralFileSizeDto;
    /**
     * 
     * @type {Array<FileThumbnailDto>}
     * @memberof FileDto
     */
    'thumbnails'?: Array<FileThumbnailDto>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FileDto
     */
    'uploadedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FileDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'originalExtension'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'extension'?: string | null;
    /**
     * 
     * @type {MimeBaseType}
     * @memberof FileDto
     */
    'mimeBaseType'?: MimeBaseType;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'url'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof FileDto
     */
    'urlLifetime'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FileDto
     */
    'urlExpiresAt'?: string | null;
}


/**
 * 
 * @export
 * @interface FileHashDto
 */
export interface FileHashDto {
    /**
     * 
     * @type {string}
     * @memberof FileHashDto
     */
    'hash'?: string;
    /**
     * 
     * @type {HashAlgorithmType}
     * @memberof FileHashDto
     */
    'algorithmType'?: HashAlgorithmType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FileHashDto
     */
    'createdAt'?: string;
}


/**
 * 
 * @export
 * @interface FileImageInfoDto
 */
export interface FileImageInfoDto {
    /**
     * 
     * @type {GeneralImageSizeDto}
     * @memberof FileImageInfoDto
     */
    'size'?: GeneralImageSizeDto;
    /**
     * 
     * @type {ImageQuality}
     * @memberof FileImageInfoDto
     */
    'quality'?: ImageQuality;
}


/**
 * 
 * @export
 * @interface FileReferenceDto
 */
export interface FileReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof FileReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileReferenceDto
     */
    'originalFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileReferenceDto
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileReferenceDto
     */
    'displayFileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileReferenceDto
     */
    'contentType'?: string;
    /**
     * 
     * @type {number}
     * @memberof FileReferenceDto
     */
    'sizeBytes'?: number;
    /**
     * 
     * @type {GeneralFileSizeDto}
     * @memberof FileReferenceDto
     */
    'size'?: GeneralFileSizeDto;
    /**
     * 
     * @type {Array<FileThumbnailDto>}
     * @memberof FileReferenceDto
     */
    'thumbnails'?: Array<FileThumbnailDto>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FileReferenceDto
     */
    'uploadedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileReferenceDto
     */
    'extension'?: string | null;
    /**
     * 
     * @type {MimeBaseType}
     * @memberof FileReferenceDto
     */
    'mimeBaseType'?: MimeBaseType;
    /**
     * 
     * @type {string}
     * @memberof FileReferenceDto
     */
    'url'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof FileReferenceDto
     */
    'urlLifetime'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FileReferenceDto
     */
    'urlExpiresAt'?: string | null;
}


/**
 * 
 * @export
 * @interface FileStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
 */
export interface FileStatsDtoInWidgetDataOfTenantStatsTabularAdminDto {
    /**
     * 
     * @type {number}
     * @memberof FileStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'totalSizeBytes'?: number;
}
/**
 * 
 * @export
 * @interface FileThumbnailDto
 */
export interface FileThumbnailDto {
    /**
     * 
     * @type {ThumbnailSizeType}
     * @memberof FileThumbnailDto
     */
    'sizeType'?: ThumbnailSizeType;
    /**
     * 
     * @type {GeneralImageSizeDto}
     * @memberof FileThumbnailDto
     */
    'size'?: GeneralImageSizeDto;
    /**
     * 
     * @type {string}
     * @memberof FileThumbnailDto
     */
    'url'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof FileThumbnailDto
     */
    'urlLifetime'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FileThumbnailDto
     */
    'urlExpiresAt'?: string | null;
}


/**
 * 
 * @export
 * @interface FileUploadManyResultDto
 */
export interface FileUploadManyResultDto {
    /**
     * 
     * @type {Array<FileDto>}
     * @memberof FileUploadManyResultDto
     */
    'files': Array<FileDto>;
}
/**
 * 
 * @export
 * @interface FileUploadResultDto
 */
export interface FileUploadResultDto {
    /**
     * 
     * @type {FileDto}
     * @memberof FileUploadResultDto
     */
    'file': FileDto;
}
/**
 * Options for configuring the response details of a file upload,   including file URL expiration settings.
 * @export
 * @interface FileUploadResultOptionsDto
 */
export interface FileUploadResultOptionsDto {
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof FileUploadResultOptionsDto
     */
    'fileUrlLifetime'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FileUploadResultOptionsDto
     */
    'fileUrlExpiresAt'?: string | null;
}
/**
 * 
 * @export
 * @interface FileUploadSpecDto
 */
export interface FileUploadSpecDto {
    /**
     * Max number of files that is allowed to be uploaded simultaneously via one request.
     * @type {number}
     * @memberof FileUploadSpecDto
     */
    'uploadSimultaneousFilesLimit': number;
    /**
     * Max allowed file size in bytes.
     * @type {number}
     * @memberof FileUploadSpecDto
     */
    'uploadFileSizeLimitBytes': number;
    /**
     * Max lifetime of SAS URL that can be requested by a client via the API.
     * @type {string}
     * @memberof FileUploadSpecDto
     */
    'sasUrlLifetimeLimit': string;
    /**
     * Default lifetime of SAS URL for files returned via the API.
     * @type {string}
     * @memberof FileUploadSpecDto
     */
    'sasUrlDefaultLifetimeInDto': string;
    /**
     * List of allowed file extensions.
     * @type {Array<string>}
     * @memberof FileUploadSpecDto
     */
    'uploadPermittedExtensions': Array<string>;
    /**
     * List of allowed file content types.
     * @type {Array<string>}
     * @memberof FileUploadSpecDto
     */
    'uploadPermittedContentTypes': Array<string>;
    /**
     * Max allowed file size in bytes per file extension.
     * @type {{ [key: string]: number; }}
     * @memberof FileUploadSpecDto
     */
    'uploadFileSizeLimitBytesPerExtensionMap': { [key: string]: number; };
    /**
     * Max allowed file size in bytes per file content type.
     * @type {{ [key: string]: number; }}
     * @memberof FileUploadSpecDto
     */
    'uploadFileSizeLimitBytesPerContentTypeMap': { [key: string]: number; };
}
/**
 * File that has been successfully uploaded and used as input for other operations that reference an uploaded file.
 * @export
 * @interface FileUploadedDto
 */
export interface FileUploadedDto {
    /**
     * File id.
     * @type {string}
     * @memberof FileUploadedDto
     */
    'id'?: string;
    /**
     * Auto-computed helper prop for front-end/client.
     * @type {boolean}
     * @memberof FileUploadedDto
     */
    'isUploadedFile'?: boolean;
}
/**
 * 
 * @export
 * @interface FileUsageLockDto
 */
export interface FileUsageLockDto {
    /**
     * 
     * @type {string}
     * @memberof FileUsageLockDto
     */
    'id'?: string;
    /**
     * 
     * @type {FileUsageLockSubjectDto}
     * @memberof FileUsageLockDto
     */
    'subject'?: FileUsageLockSubjectDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FileUsageLockDto
     */
    'lockedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof FileUsageLockDto
     */
    'unlockedAt'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof FileUsageLockDto
     */
    'lockDuration'?: string | null;
}
/**
 * 
 * @export
 * @interface FileUsageLockSubjectDto
 */
export interface FileUsageLockSubjectDto {
    /**
     * 
     * @type {FileUsageLockSubjectType}
     * @memberof FileUsageLockSubjectDto
     */
    'type'?: FileUsageLockSubjectType;
    /**
     * 
     * @type {string}
     * @memberof FileUsageLockSubjectDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {EntityType}
     * @memberof FileUsageLockSubjectDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {string}
     * @memberof FileUsageLockSubjectDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileUsageLockSubjectDto
     */
    'computedIdentifier'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FileUsageLockSubjectType = {
    None: 'None',
    Entity: 'Entity'
} as const;

export type FileUsageLockSubjectType = typeof FileUsageLockSubjectType[keyof typeof FileUsageLockSubjectType];


/**
 * 
 * @export
 * @enum {string}
 */

export const FileUsageVersion = {
    None: 'None',
    V1: 'V1',
    V2: 'V2'
} as const;

export type FileUsageVersion = typeof FileUsageVersion[keyof typeof FileUsageVersion];


/**
 * 
 * @export
 * @interface FilterDefinitionDto
 */
export interface FilterDefinitionDto {
    /**
     * 
     * @type {Array<FilterDefinitionItemDto>}
     * @memberof FilterDefinitionDto
     */
    'items'?: Array<FilterDefinitionItemDto> | null;
}
/**
 * 
 * @export
 * @interface FilterDefinitionItemDto
 */
export interface FilterDefinitionItemDto {
    /**
     * 
     * @type {FilterType}
     * @memberof FilterDefinitionItemDto
     */
    'type'?: FilterType;
    /**
     * 
     * @type {string}
     * @memberof FilterDefinitionItemDto
     */
    'field'?: string;
    /**
     * 
     * @type {FilterOperator}
     * @memberof FilterDefinitionItemDto
     */
    'operator'?: FilterOperator;
    /**
     * 
     * @type {FilterValueType}
     * @memberof FilterDefinitionItemDto
     */
    'valueType'?: FilterValueType;
    /**
     * 
     * @type {any}
     * @memberof FilterDefinitionItemDto
     */
    'value'?: any | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FilterLogicalOperator = {
    None: 'None',
    And: 'And',
    Or: 'Or'
} as const;

export type FilterLogicalOperator = typeof FilterLogicalOperator[keyof typeof FilterLogicalOperator];


/**
 * 
 * @export
 * @enum {string}
 */

export const FilterOperator = {
    None: 'None',
    Equal: 'Equal',
    NotEqual: 'NotEqual',
    Contain: 'Contain',
    NotContain: 'NotContain',
    LessThan: 'LessThan',
    LessThanOrEqual: 'LessThanOrEqual',
    GreaterThan: 'GreaterThan',
    GreaterThanOrEqual: 'GreaterThanOrEqual',
    AnyOf: 'AnyOf',
    NoneOf: 'NoneOf',
    Empty: 'Empty',
    NotEmpty: 'NotEmpty'
} as const;

export type FilterOperator = typeof FilterOperator[keyof typeof FilterOperator];


/**
 * 
 * @export
 * @enum {string}
 */

export const FilterType = {
    None: 'None',
    Static: 'Static',
    Dynamic: 'Dynamic'
} as const;

export type FilterType = typeof FilterType[keyof typeof FilterType];


/**
 * 
 * @export
 * @enum {string}
 */

export const FilterValueType = {
    None: 'None',
    Arbitrary: 'Arbitrary',
    String: 'String',
    Number: 'Number',
    Boolean: 'Boolean',
    Date: 'Date',
    Enum: 'Enum',
    Id: 'Id',
    ArrayOfString: 'ArrayOfString',
    ArrayOfEnum: 'ArrayOfEnum',
    ArrayOfId: 'ArrayOfId'
} as const;

export type FilterValueType = typeof FilterValueType[keyof typeof FilterValueType];


/**
 * 
 * @export
 * @interface ForAccountDtoInAdminCreateCustomSessionDto
 */
export interface ForAccountDtoInAdminCreateCustomSessionDto {
    /**
     * 
     * @type {string}
     * @memberof ForAccountDtoInAdminCreateCustomSessionDto
     */
    'userId'?: string | null;
}
/**
 * Describes params of the action to be automatically performed on the FE page when user opens it.
 * @export
 * @interface FrontEndActionParamsInQueryStringDto
 */
export interface FrontEndActionParamsInQueryStringDto {
    /**
     * 
     * @type {FrontEndActionTypeInQueryString}
     * @memberof FrontEndActionParamsInQueryStringDto
     */
    'actionType'?: FrontEndActionTypeInQueryString;
}


/**
 * Describes type of action to be automatically performed on the FE page when user opens it.
 * @export
 * @enum {string}
 */

export const FrontEndActionTypeInQueryString = {
    None: 'None',
    ApproveAllDamageNegotiationProposals: 'ApproveAllDamageNegotiationProposals',
    DeclineAllDamageNegotiationProposals: 'DeclineAllDamageNegotiationProposals',
    ApproveAllDamageCostNegotiationProposals: 'ApproveAllDamageCostNegotiationProposals',
    DeclineAllDamageCostNegotiationProposals: 'DeclineAllDamageCostNegotiationProposals'
} as const;

export type FrontEndActionTypeInQueryString = typeof FrontEndActionTypeInQueryString[keyof typeof FrontEndActionTypeInQueryString];


/**
 * 
 * @export
 * @enum {string}
 */

export const FrontEndAppType = {
    None: 'None',
    Web: 'Web',
    Mobile: 'Mobile'
} as const;

export type FrontEndAppType = typeof FrontEndAppType[keyof typeof FrontEndAppType];


/**
 * 
 * @export
 * @interface FrontEndAppUpdateInfoDto
 */
export interface FrontEndAppUpdateInfoDto {
    /**
     * 
     * @type {FrontEndAppType}
     * @memberof FrontEndAppUpdateInfoDto
     */
    'appType'?: FrontEndAppType;
    /**
     * 
     * @type {OperatingSystemType}
     * @memberof FrontEndAppUpdateInfoDto
     */
    'operatingSystem'?: OperatingSystemType;
    /**
     * 
     * @type {Array<FrontEndAppUpdateInfoItemDto>}
     * @memberof FrontEndAppUpdateInfoDto
     */
    'items'?: Array<FrontEndAppUpdateInfoItemDto>;
}


/**
 * 
 * @export
 * @interface FrontEndAppUpdateInfoItem
 */
export interface FrontEndAppUpdateInfoItem {
    /**
     * 
     * @type {FrontEndAppUpdateType}
     * @memberof FrontEndAppUpdateInfoItem
     */
    'updateType'?: FrontEndAppUpdateType;
    /**
     * 
     * @type {string}
     * @memberof FrontEndAppUpdateInfoItem
     */
    'minVersion': string;
    /**
     * Flag to indicate is there a need to check if the app is available for download from the App Store or Google Play
     * @type {boolean}
     * @memberof FrontEndAppUpdateInfoItem
     */
    'isCheckAvailability'?: boolean;
}


/**
 * 
 * @export
 * @interface FrontEndAppUpdateInfoItemDto
 */
export interface FrontEndAppUpdateInfoItemDto {
    /**
     * 
     * @type {FrontEndAppUpdateType}
     * @memberof FrontEndAppUpdateInfoItemDto
     */
    'updateType'?: FrontEndAppUpdateType;
    /**
     * 
     * @type {string}
     * @memberof FrontEndAppUpdateInfoItemDto
     */
    'minVersion': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FrontEndAppUpdateType = {
    None: 'None',
    Optional: 'Optional',
    Recommended: 'Recommended',
    Mandatory: 'Mandatory'
} as const;

export type FrontEndAppUpdateType = typeof FrontEndAppUpdateType[keyof typeof FrontEndAppUpdateType];


/**
 * Describes auth params that FE app should apply when loaded.
 * @export
 * @interface FrontEndAuthParamsInQueryStringDto
 */
export interface FrontEndAuthParamsInQueryStringDto {
    /**
     * Auth0 connection to be used when logging in.
     * @type {string}
     * @memberof FrontEndAuthParamsInQueryStringDto
     */
    'preferredAuth0Connection'?: string | null;
    /**
     * The user\'s email address or other identifier.  Used during login to prefill inputs.
     * @type {string}
     * @memberof FrontEndAuthParamsInQueryStringDto
     */
    'auth0LoginHint'?: string | null;
    /**
     * Whether to prefer quick login - skip SPA auth pages (like login, logged out, etc) and redirect  directly to Auth0 login page if user is not authenticated.
     * @type {boolean}
     * @memberof FrontEndAuthParamsInQueryStringDto
     */
    'isPreferQuickLogin'?: boolean | null;
}
/**
 * 
 * @export
 * @interface FrontEndMultiAppUpdateInfoDto
 */
export interface FrontEndMultiAppUpdateInfoDto {
    /**
     * 
     * @type {Array<FrontEndAppUpdateInfoDto>}
     * @memberof FrontEndMultiAppUpdateInfoDto
     */
    'apps'?: Array<FrontEndAppUpdateInfoDto>;
}
/**
 * Contains minimal telemetry data sent from FE to BE in each API request.
 * @export
 * @interface FrontEndTelemetryDataInputDto
 */
export interface FrontEndTelemetryDataInputDto {
    /**
     * Correlation ID generated by FE for tracking telemetry across different services.
     * @type {string}
     * @memberof FrontEndTelemetryDataInputDto
     */
    'correlationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FrontEndTelemetryDataInputDto
     */
    'pageUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralAddressDto
 */
export interface GeneralAddressDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralAddressDto
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralAddressDto
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralAddressDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralAddressDto
     */
    'line1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralAddressDto
     */
    'line2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralAddressDto
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralAddressDto
     */
    'isEmpty'?: boolean;
}
/**
 * 
 * @export
 * @interface GeneralAddressInputDto
 */
export interface GeneralAddressInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralAddressInputDto
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralAddressInputDto
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralAddressInputDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralAddressInputDto
     */
    'line1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralAddressInputDto
     */
    'line2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralAddressInputDto
     */
    'postalCode'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralApprovalStatusInfoDto
 */
export interface GeneralApprovalStatusInfoDto {
    /**
     * 
     * @type {ApprovalStatus}
     * @memberof GeneralApprovalStatusInfoDto
     */
    'status'?: ApprovalStatus;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralApprovalStatusInfoDto
     */
    'updatedAt'?: string;
}


/**
 * 
 * @export
 * @interface GeneralAttachedTagsDto
 */
export interface GeneralAttachedTagsDto {
    /**
     * 
     * @type {Array<GeneralTagDto>}
     * @memberof GeneralAttachedTagsDto
     */
    'tags'?: Array<GeneralTagDto> | null;
}
/**
 * 
 * @export
 * @interface GeneralAttachedTagsInputDto
 */
export interface GeneralAttachedTagsInputDto {
    /**
     * 
     * @type {Array<GeneralTagInputDto>}
     * @memberof GeneralAttachedTagsInputDto
     */
    'tags'?: Array<GeneralTagInputDto> | null;
}
/**
 * 
 * @export
 * @interface GeneralAttachedTagsOfEntitiesDeleteDto
 */
export interface GeneralAttachedTagsOfEntitiesDeleteDto {
    /**
     * 
     * @type {TagEntityType}
     * @memberof GeneralAttachedTagsOfEntitiesDeleteDto
     */
    'tagEntityType'?: TagEntityType;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralAttachedTagsOfEntitiesDeleteDto
     */
    'entityIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralAttachedTagsOfEntitiesDeleteDto
     */
    'tagIds'?: Array<string>;
}


/**
 * 
 * @export
 * @interface GeneralAttachedTagsOfEntitiesUpdateDto
 */
export interface GeneralAttachedTagsOfEntitiesUpdateDto {
    /**
     * 
     * @type {TagEntityType}
     * @memberof GeneralAttachedTagsOfEntitiesUpdateDto
     */
    'tagEntityType'?: TagEntityType;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralAttachedTagsOfEntitiesUpdateDto
     */
    'entityIds'?: Array<string>;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof GeneralAttachedTagsOfEntitiesUpdateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralAttachedTagsOfEntitiesUpdateDto
     */
    'isReplace'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralAttachedTagsOfEntityDeleteDto
 */
export interface GeneralAttachedTagsOfEntityDeleteDto {
    /**
     * 
     * @type {TagEntityType}
     * @memberof GeneralAttachedTagsOfEntityDeleteDto
     */
    'entityType'?: TagEntityType;
    /**
     * 
     * @type {string}
     * @memberof GeneralAttachedTagsOfEntityDeleteDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralAttachedTagsOfEntityDeleteDto
     */
    'tagIds'?: Array<string>;
}


/**
 * 
 * @export
 * @interface GeneralAttachedTagsOfEntityUpdateDto
 */
export interface GeneralAttachedTagsOfEntityUpdateDto {
    /**
     * 
     * @type {TagEntityType}
     * @memberof GeneralAttachedTagsOfEntityUpdateDto
     */
    'entityType'?: TagEntityType;
    /**
     * 
     * @type {string}
     * @memberof GeneralAttachedTagsOfEntityUpdateDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof GeneralAttachedTagsOfEntityUpdateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}


/**
 * 
 * @export
 * @interface GeneralAttachedTagsQueryDto
 */
export interface GeneralAttachedTagsQueryDto {
    /**
     * 
     * @type {Array<TagTargetType>}
     * @memberof GeneralAttachedTagsQueryDto
     */
    'targetTypes'?: Array<TagTargetType> | null;
    /**
     * 
     * @type {Array<TagSubTargetType>}
     * @memberof GeneralAttachedTagsQueryDto
     */
    'subTargetTypes'?: Array<TagSubTargetType> | null;
    /**
     * 
     * @type {Array<VisibilityStatus>}
     * @memberof GeneralAttachedTagsQueryDto
     */
    'visibilityStatuses'?: Array<VisibilityStatus> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralAttachedTagsQueryDto
     */
    'targetIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralAttachedTagsQueryDto
     */
    'subTargetIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralAttachedTagsQueryDto
     */
    'search'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralAttachmentDto
 */
export interface GeneralAttachmentDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralAttachmentDto
     */
    'id'?: string;
    /**
     * 
     * @type {FileReferenceDto}
     * @memberof GeneralAttachmentDto
     */
    'file'?: FileReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralAttachmentDto
     */
    'caption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralAttachmentDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {GeneralDeferredValueDtoOfVehicleImageInsightsDto}
     * @memberof GeneralAttachmentDto
     */
    'vehicleInsights'?: GeneralDeferredValueDtoOfVehicleImageInsightsDto;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralAttachmentDto
     */
    'isAttachment'?: boolean;
}
/**
 * Describes adding already uploaded file as attachment to something.
 * @export
 * @interface GeneralAttachmentInputDto
 */
export interface GeneralAttachmentInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralAttachmentInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {FileUploadedDto}
     * @memberof GeneralAttachmentInputDto
     */
    'file'?: FileUploadedDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralAttachmentInputDto
     */
    'caption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralAttachmentInputDto
     */
    'notes'?: string | null;
    /**
     * The file in the attachment must be copied before saving.    When set to true it means that provided file was not uploaded as a new file, but rather was taken from attachments of other entity,    and therefor must be copied before saving to avoid multiple entities reference the same file (each entity must have own file copy).    NB: use only when really needed, copying files is costly operation.
     * @type {boolean}
     * @memberof GeneralAttachmentInputDto
     */
    'mustBeCopied'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralAttachmentInputDto
     */
    'isAttachmentInput'?: boolean;
}
/**
 * 
 * @export
 * @interface GeneralAvatarAddDto
 */
export interface GeneralAvatarAddDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralAvatarAddDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {FileUploadedDto}
     * @memberof GeneralAvatarAddDto
     */
    'file'?: FileUploadedDto;
}
/**
 * 
 * @export
 * @interface GeneralAvatarDto
 */
export interface GeneralAvatarDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralAvatarDto
     */
    'id'?: string;
    /**
     * 
     * @type {FileReferenceDto}
     * @memberof GeneralAvatarDto
     */
    'file'?: FileReferenceDto;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralAvatarDto
     */
    'isAvatar'?: boolean;
}
/**
 * 
 * @export
 * @interface GeneralBillToInfoDto
 */
export interface GeneralBillToInfoDto {
    /**
     * true = manually entered text or selected department/location, false = inferred.    Visibility: sender.
     * @type {boolean}
     * @memberof GeneralBillToInfoDto
     */
    'isCustom'?: boolean;
    /**
     * Bill to name (inferred/custom).    Visibility: sender, receiver.  
     * @type {string}
     * @memberof GeneralBillToInfoDto
     */
    'name'?: string;
    /**
     * 
     * @type {BillToSourceType}
     * @memberof GeneralBillToInfoDto
     */
    'sourceType'?: BillToSourceType;
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof GeneralBillToInfoDto
     */
    'billToEntity'?: GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof GeneralBillToInfoDto
     */
    'inferredFromEntity'?: GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {EntityAffiliationInfoDto}
     * @memberof GeneralBillToInfoDto
     */
    'inferredAffiliationInfo'?: EntityAffiliationInfoDto;
}


/**
 * 
 * @export
 * @interface GeneralBillToInfoInputDto
 */
export interface GeneralBillToInfoInputDto {
    /**
     * true = manually entered text or selected department/location, false = inferred.    Visibility: sender.
     * @type {boolean}
     * @memberof GeneralBillToInfoInputDto
     */
    'isCustom'?: boolean;
    /**
     * Bill to name (inferred/custom).    Visibility: sender, receiver.  
     * @type {string}
     * @memberof GeneralBillToInfoInputDto
     */
    'name'?: string;
    /**
     * 
     * @type {BillToSourceType}
     * @memberof GeneralBillToInfoInputDto
     */
    'sourceType'?: BillToSourceType;
    /**
     * 
     * @type {GeneralStrictEntityRelationInputDto}
     * @memberof GeneralBillToInfoInputDto
     */
    'billToEntity'?: GeneralStrictEntityRelationInputDto;
    /**
     * 
     * @type {GeneralStrictEntityRelationInputDto}
     * @memberof GeneralBillToInfoInputDto
     */
    'inferredFromEntity'?: GeneralStrictEntityRelationInputDto;
    /**
     * 
     * @type {EntityAffiliationInfoInputDto}
     * @memberof GeneralBillToInfoInputDto
     */
    'inferredAffiliationInfo'?: EntityAffiliationInfoInputDto;
}


/**
 * 
 * @export
 * @interface GeneralBillToInfoOfEntityUpdateDto
 */
export interface GeneralBillToInfoOfEntityUpdateDto {
    /**
     * 
     * @type {GeneralBillToInfoInputDto}
     * @memberof GeneralBillToInfoOfEntityUpdateDto
     */
    'billTo'?: GeneralBillToInfoInputDto;
}
/**
 * 
 * @export
 * @interface GeneralBrandingDto
 */
export interface GeneralBrandingDto {
    /**
     * 
     * @type {GeneralLogoResizedDto}
     * @memberof GeneralBrandingDto
     */
    'logo'?: GeneralLogoResizedDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralBrandingDto
     */
    'fullLegalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralBrandingDto
     */
    'shortName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralBrandingDto
     */
    'disclaimer'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralBrandingInputDto
 */
export interface GeneralBrandingInputDto {
    /**
     * 
     * @type {GeneralLogoInputDto}
     * @memberof GeneralBrandingInputDto
     */
    'logo'?: GeneralLogoInputDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralBrandingInputDto
     */
    'fullLegalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralBrandingInputDto
     */
    'shortName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralBrandingInputDto
     */
    'disclaimer'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralBrandingInputMetaDto
 */
export interface GeneralBrandingInputMetaDto {
    /**
     * 
     * @type {GeneralBrandingInputMetaForLogoDto}
     * @memberof GeneralBrandingInputMetaDto
     */
    'logo': GeneralBrandingInputMetaForLogoDto;
}
/**
 * 
 * @export
 * @interface GeneralBrandingInputMetaForLogoDto
 */
export interface GeneralBrandingInputMetaForLogoDto {
    /**
     * 
     * @type {GeneralImageSizeDto}
     * @memberof GeneralBrandingInputMetaForLogoDto
     */
    'minSize': GeneralImageSizeDto;
    /**
     * 
     * @type {GeneralImageSizeDto}
     * @memberof GeneralBrandingInputMetaForLogoDto
     */
    'maxSize': GeneralImageSizeDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralBrandingInputMetaForLogoDto
     */
    'allowedContentTypes': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralBrandingInputMetaForLogoDto
     */
    'allowedFileExtensions': Array<string>;
}
/**
 * 
 * @export
 * @interface GeneralByWhoDto
 */
export interface GeneralByWhoDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralByWhoDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralByWhoDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralByWhoDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralByWhoDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {WhoType}
     * @memberof GeneralByWhoDto
     */
    'type'?: WhoType;
    /**
     * 
     * @type {string}
     * @memberof GeneralByWhoDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof GeneralByWhoDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralByWhoDto
     */
    'phone'?: string | null;
}


/**
 * 
 * @export
 * @interface GeneralByWhoInputDto
 */
export interface GeneralByWhoInputDto {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralByWhoInputDto
     */
    'isCurrentUser'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralByWhoInputDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralByWhoInputDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralByWhoInputDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralByWhoInputDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof GeneralByWhoInputDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralByWhoInputDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralByWhoInputDto
     */
    'phone'?: string | null;
}
/**
 * General contact with optional fields.
 * @export
 * @interface GeneralContact
 */
export interface GeneralContact {
    /**
     * 
     * @type {GeneralPersonName}
     * @memberof GeneralContact
     */
    'personName'?: GeneralPersonName;
    /**
     * 
     * @type {string}
     * @memberof GeneralContact
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralContact
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralContact
     */
    'isEmpty'?: boolean;
}
/**
 * General contact with optional fields.
 * @export
 * @interface GeneralContactDto
 */
export interface GeneralContactDto {
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof GeneralContactDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralContactDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralContactDto
     */
    'phoneNumber'?: string | null;
}
/**
 * General contact with optional fields.
 * @export
 * @interface GeneralContactInputDto
 */
export interface GeneralContactInputDto {
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof GeneralContactInputDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralContactInputDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralContactInputDto
     */
    'phoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralCountryDto
 */
export interface GeneralCountryDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralCountryDto
     */
    'alpha2Code'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralCountryDto
     */
    'alpha3Code'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralCountryDto
     */
    'numericCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralCountryDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralCountryDto
     */
    'officialName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralCountryDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface GeneralCountryInputDto
 */
export interface GeneralCountryInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralCountryInputDto
     */
    'alpha2Code'?: string;
}
/**
 * 
 * @export
 * @interface GeneralCountryQueryDto
 */
export interface GeneralCountryQueryDto {
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof GeneralCountryQueryDto
     */
    'alpha2Code'?: FieldFilterOfPrimitiveDtoOfString;
}
/**
 * 
 * @export
 * @interface GeneralCultureDto
 */
export interface GeneralCultureDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralCultureDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralCultureDto
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralCultureDto
     */
    'nativeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralCultureDto
     */
    'englishName'?: string;
    /**
     * The same as name.
     * @type {string}
     * @memberof GeneralCultureDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface GeneralCultureInputDto
 */
export interface GeneralCultureInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralCultureInputDto
     */
    'name'?: string;
}
/**
 * Represents ISO 4217 currency.  https://en.wikipedia.org/wiki/ISO_4217
 * @export
 * @interface GeneralCurrency
 */
export interface GeneralCurrency {
    /**
     * 
     * @type {CurrencyCode}
     * @memberof GeneralCurrency
     */
    'code'?: CurrencyCode;
    /**
     * 
     * @type {string}
     * @memberof GeneralCurrency
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @interface GeneralCurrencyDto
 */
export interface GeneralCurrencyDto {
    /**
     * 
     * @type {CurrencyCode}
     * @memberof GeneralCurrencyDto
     */
    'code'?: CurrencyCode;
    /**
     * 
     * @type {string}
     * @memberof GeneralCurrencyDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralCurrencyDto
     */
    'id'?: string;
}


/**
 * 
 * @export
 * @interface GeneralCurrencyInputDto
 */
export interface GeneralCurrencyInputDto {
    /**
     * 
     * @type {CurrencyCode}
     * @memberof GeneralCurrencyInputDto
     */
    'code'?: CurrencyCode;
}


/**
 * 
 * @export
 * @interface GeneralCurrencyQueryDto
 */
export interface GeneralCurrencyQueryDto {
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfCurrencyCode}
     * @memberof GeneralCurrencyQueryDto
     */
    'code'?: FieldFilterOfPrimitiveDtoOfNullableOfCurrencyCode;
}
/**
 * 
 * @export
 * @interface GeneralDeferredValueDtoOfVehicleImageInsightsDto
 */
export interface GeneralDeferredValueDtoOfVehicleImageInsightsDto {
    /**
     * 
     * @type {VehicleImageInsightsDto}
     * @memberof GeneralDeferredValueDtoOfVehicleImageInsightsDto
     */
    'value'?: VehicleImageInsightsDto;
    /**
     * 
     * @type {GeneralDeferredValueStatus}
     * @memberof GeneralDeferredValueDtoOfVehicleImageInsightsDto
     */
    'status'?: GeneralDeferredValueStatus;
    /**
     * 
     * @type {string}
     * @memberof GeneralDeferredValueDtoOfVehicleImageInsightsDto
     */
    'displayError'?: string | null;
}


/**
 * 
 * @export
 * @interface GeneralDeferredValueDtoOfVehicleInsightsDto
 */
export interface GeneralDeferredValueDtoOfVehicleInsightsDto {
    /**
     * 
     * @type {VehicleInsightsDto}
     * @memberof GeneralDeferredValueDtoOfVehicleInsightsDto
     */
    'value'?: VehicleInsightsDto;
    /**
     * 
     * @type {GeneralDeferredValueStatus}
     * @memberof GeneralDeferredValueDtoOfVehicleInsightsDto
     */
    'status'?: GeneralDeferredValueStatus;
    /**
     * 
     * @type {string}
     * @memberof GeneralDeferredValueDtoOfVehicleInsightsDto
     */
    'displayError'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const GeneralDeferredValueStatus = {
    None: 'None',
    Pending: 'Pending',
    Success: 'Success',
    Failed: 'Failed'
} as const;

export type GeneralDeferredValueStatus = typeof GeneralDeferredValueStatus[keyof typeof GeneralDeferredValueStatus];


/**
 * 
 * @export
 * @interface GeneralDeleteEntityDto
 */
export interface GeneralDeleteEntityDto {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralDeleteEntityDto
     */
    'isDeleteAllRelatedData'?: boolean;
}
/**
 * Represents a percentage/amount from goods price that is deducted from the final price.  Stored as positive number and is always deducted from SubTotal (adding discount to SubTotal is not allowed).
 * @export
 * @interface GeneralDiscount
 */
export interface GeneralDiscount {
    /**
     * 
     * @type {DiscountType}
     * @memberof GeneralDiscount
     */
    'type'?: DiscountType;
    /**
     * 
     * @type {DiscountValueType}
     * @memberof GeneralDiscount
     */
    'valueType'?: DiscountValueType;
    /**
     * Percents [0; 1].
     * @type {number}
     * @memberof GeneralDiscount
     */
    'percent'?: number | null;
    /**
     * Amount in some currency representation.
     * @type {number}
     * @memberof GeneralDiscount
     */
    'value'?: number | null;
    /**
     * 
     * @type {GeneralCurrency}
     * @memberof GeneralDiscount
     */
    'currency'?: GeneralCurrency;
    /**
     * Discount that is a result of merging N discounts into one.
     * @type {boolean}
     * @memberof GeneralDiscount
     */
    'isCompound'?: boolean;
}


/**
 * Represents a percentage/amount from goods price that is deducted from the final price.  Stored as positive number and is always deducted from SubTotal (adding discount to SubTotal is not allowed).
 * @export
 * @interface GeneralDiscountDto
 */
export interface GeneralDiscountDto {
    /**
     * 
     * @type {DiscountType}
     * @memberof GeneralDiscountDto
     */
    'type'?: DiscountType;
    /**
     * 
     * @type {DiscountValueType}
     * @memberof GeneralDiscountDto
     */
    'valueType'?: DiscountValueType;
    /**
     * Percents [0; 1].
     * @type {number}
     * @memberof GeneralDiscountDto
     */
    'percent'?: number | null;
    /**
     * Amount in some currency representation.
     * @type {number}
     * @memberof GeneralDiscountDto
     */
    'value'?: number | null;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof GeneralDiscountDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * Discount that is a result of merging N discounts into one.
     * @type {boolean}
     * @memberof GeneralDiscountDto
     */
    'isCompound'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralDiscountInputDto
 */
export interface GeneralDiscountInputDto {
    /**
     * 
     * @type {DiscountType}
     * @memberof GeneralDiscountInputDto
     */
    'type'?: DiscountType;
    /**
     * 
     * @type {DiscountValueType}
     * @memberof GeneralDiscountInputDto
     */
    'valueType'?: DiscountValueType;
    /**
     * 
     * @type {number}
     * @memberof GeneralDiscountInputDto
     */
    'percent'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GeneralDiscountInputDto
     */
    'value'?: number | null;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof GeneralDiscountInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralDiscountInputDto
     */
    'isCompound'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralEntitySourceDto
 */
export interface GeneralEntitySourceDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralEntitySourceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralEntitySourceDto
     */
    'sourceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralEntitySourceDto
     */
    'sourceSubId'?: string | null;
    /**
     * 
     * @type {EntitySourceType}
     * @memberof GeneralEntitySourceDto
     */
    'type'?: EntitySourceType;
    /**
     * 
     * @type {EntitySourceSubType}
     * @memberof GeneralEntitySourceDto
     */
    'subType'?: EntitySourceSubType;
    /**
     * 
     * @type {VisualInspectionReferenceDto}
     * @memberof GeneralEntitySourceDto
     */
    'visualInspection'?: VisualInspectionReferenceDto;
    /**
     * 
     * @type {DamageDetectionReferenceDto}
     * @memberof GeneralEntitySourceDto
     */
    'damageDetection'?: DamageDetectionReferenceDto;
    /**
     * 
     * @type {DamageDetectionAggregateReferenceDto}
     * @memberof GeneralEntitySourceDto
     */
    'damageDetectionAggregate'?: DamageDetectionAggregateReferenceDto;
    /**
     * 
     * @type {DamageCostEvaluationReferenceDto}
     * @memberof GeneralEntitySourceDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationReferenceDto;
    /**
     * 
     * @type {DamageCostEvaluationAggregateReferenceDto}
     * @memberof GeneralEntitySourceDto
     */
    'damageCostEvaluationAggregate'?: DamageCostEvaluationAggregateReferenceDto;
    /**
     * 
     * @type {AccessoryCheckReferenceDto}
     * @memberof GeneralEntitySourceDto
     */
    'accessoryCheck'?: AccessoryCheckReferenceDto;
    /**
     * 
     * @type {DocumentReferenceDto}
     * @memberof GeneralEntitySourceDto
     */
    'document'?: DocumentReferenceDto;
    /**
     * 
     * @type {DamageDetectionItemReferenceDto}
     * @memberof GeneralEntitySourceDto
     */
    'damageDetectionItem'?: DamageDetectionItemReferenceDto;
    /**
     * 
     * @type {DamageDetectionAggregateItemReferenceDto}
     * @memberof GeneralEntitySourceDto
     */
    'damageDetectionAggregateItem'?: DamageDetectionAggregateItemReferenceDto;
    /**
     * 
     * @type {DamageCostEvaluationItemReferenceDto}
     * @memberof GeneralEntitySourceDto
     */
    'damageCostEvaluationItem'?: DamageCostEvaluationItemReferenceDto;
    /**
     * 
     * @type {DamageCostEvaluationAggregateItemReferenceDto}
     * @memberof GeneralEntitySourceDto
     */
    'damageCostEvaluationAggregateItem'?: DamageCostEvaluationAggregateItemReferenceDto;
    /**
     * 
     * @type {AccessoryCheckItemReferenceDto}
     * @memberof GeneralEntitySourceDto
     */
    'accessoryCheckItem'?: AccessoryCheckItemReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralEntitySourceDto
     */
    'compoundId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralEntitySourceDto
     */
    'globalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralEntitySourceDto
     */
    'localNumber'?: string | null;
}


/**
 * 
 * @export
 * @interface GeneralEntitySourceInputDto
 */
export interface GeneralEntitySourceInputDto {
    /**
     * 
     * @type {EntitySourceType}
     * @memberof GeneralEntitySourceInputDto
     */
    'type'?: EntitySourceType;
    /**
     * 
     * @type {string}
     * @memberof GeneralEntitySourceInputDto
     */
    'sourceId'?: string;
}


/**
 * 
 * @export
 * @interface GeneralEntitySourceQueryDto
 */
export interface GeneralEntitySourceQueryDto {
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof GeneralEntitySourceQueryDto
     */
    'sourceId'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof GeneralEntitySourceQueryDto
     */
    'sourceSubId'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceType}
     * @memberof GeneralEntitySourceQueryDto
     */
    'type'?: FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceType;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceSubType}
     * @memberof GeneralEntitySourceQueryDto
     */
    'subType'?: FieldFilterOfPrimitiveDtoOfNullableOfEntitySourceSubType;
}
/**
 * Describes sub type of entity described by EntityType.  E.g. EntityType=Asset and Asset has own underlying entity types like Vehicle, Accessory, etc.
 * @export
 * @interface GeneralEntitySubType
 */
export interface GeneralEntitySubType {
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralEntitySubType
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralEntitySubType
     */
    'entitySubType'?: EntityType;
    /**
     * 
     * @type {AssetEntityType}
     * @memberof GeneralEntitySubType
     */
    'assetEntityType'?: AssetEntityType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof GeneralEntitySubType
     */
    'poolItemEntityType'?: PoolItemEntityType;
}


/**
 * 
 * @export
 * @interface GeneralEntitySubTypeDto
 */
export interface GeneralEntitySubTypeDto {
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralEntitySubTypeDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralEntitySubTypeDto
     */
    'entitySubType'?: EntityType;
    /**
     * 
     * @type {AssetEntityType}
     * @memberof GeneralEntitySubTypeDto
     */
    'assetEntityType'?: AssetEntityType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof GeneralEntitySubTypeDto
     */
    'poolItemEntityType'?: PoolItemEntityType;
}


/**
 * 
 * @export
 * @interface GeneralEntitySubTypeInputDto
 */
export interface GeneralEntitySubTypeInputDto {
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralEntitySubTypeInputDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralEntitySubTypeInputDto
     */
    'entitySubType'?: EntityType;
    /**
     * 
     * @type {AssetEntityType}
     * @memberof GeneralEntitySubTypeInputDto
     */
    'assetEntityType'?: AssetEntityType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof GeneralEntitySubTypeInputDto
     */
    'poolItemEntityType'?: PoolItemEntityType;
}


/**
 * 
 * @export
 * @interface GeneralEventLogChangedDto
 */
export interface GeneralEventLogChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralEventLogChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralEventLogChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof GeneralEventLogChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralEventLogChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof GeneralEventLogChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {GeneralEventLogDto}
     * @memberof GeneralEventLogChangedDto
     */
    'entity': GeneralEventLogDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralEventLogChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface GeneralEventLogDto
 */
export interface GeneralEventLogDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralEventLogDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralEventLogDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof GeneralEventLogDto
     */
    'entity'?: GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {GeneralEventLogType}
     * @memberof GeneralEventLogDto
     */
    'type'?: GeneralEventLogType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralEventLogDto
     */
    'date'?: string;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof GeneralEventLogDto
     */
    'raisedBy'?: GeneralByWhoDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof GeneralEventLogDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralEventLogDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralEventLogDto
     */
    'body'?: string | null;
}


/**
 * 
 * @export
 * @interface GeneralEventLogGetPaginatedDto
 */
export interface GeneralEventLogGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof GeneralEventLogGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralEventLogGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeneralEventLogGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralEventLogGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralEventLogGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralEventLogGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof GeneralEventLogGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof GeneralEventLogGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof GeneralEventLogGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GeneralEventLogType = {
    None: 'None',
    NegotiationCreated: 'NegotiationCreated',
    NegotiationUpdated: 'NegotiationUpdated',
    NegotiationOpened: 'NegotiationOpened',
    NegotiationReopened: 'NegotiationReopened',
    NegotiationResolved: 'NegotiationResolved',
    NegotiationProposalCreated: 'NegotiationProposalCreated',
    NegotiationProposalUpdated: 'NegotiationProposalUpdated',
    NegotiationProposalResponseGiven: 'NegotiationProposalResponseGiven',
    NegotiationProposalAutoClosed: 'NegotiationProposalAutoClosed',
    NegotiationProposalClosed: 'NegotiationProposalClosed'
} as const;

export type GeneralEventLogType = typeof GeneralEventLogType[keyof typeof GeneralEventLogType];


/**
 * 
 * @export
 * @interface GeneralExternalNumberInputDto
 */
export interface GeneralExternalNumberInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralExternalNumberInputDto
     */
    'externalNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralFileSize
 */
export interface GeneralFileSize {
    /**
     * 
     * @type {number}
     * @memberof GeneralFileSize
     */
    'bytes': number;
    /**
     * 
     * @type {number}
     * @memberof GeneralFileSize
     */
    'asKiB'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralFileSize
     */
    'asMiB'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralFileSize
     */
    'asGiB'?: number;
}
/**
 * 
 * @export
 * @interface GeneralFileSizeDto
 */
export interface GeneralFileSizeDto {
    /**
     * 
     * @type {number}
     * @memberof GeneralFileSizeDto
     */
    'bytes'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralFileSizeDto
     */
    'asKiB'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralFileSizeDto
     */
    'asMiB'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralFileSizeDto
     */
    'asGiB'?: number;
}
/**
 * 
 * @export
 * @interface GeneralGeolocationDto
 */
export interface GeneralGeolocationDto {
    /**
     * 
     * @type {GeoJsonPointDto}
     * @memberof GeneralGeolocationDto
     */
    'point': GeoJsonPointDto;
    /**
     * The exact moment when the geolocation was captured by the end device (e.g., GPS timestamp).
     * @type {string}
     * @memberof GeneralGeolocationDto
     */
    'capturedAt': string;
    /**
     * The last time the geolocation was updated in the DB.
     * @type {string}
     * @memberof GeneralGeolocationDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralGeolocationDto
     */
    'updatedBy'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralGeolocationInputDto
 */
export interface GeneralGeolocationInputDto {
    /**
     * 
     * @type {GeoJsonPointInputDto}
     * @memberof GeneralGeolocationInputDto
     */
    'point'?: GeoJsonPointInputDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralGeolocationInputDto
     */
    'capturedAt'?: string | null;
}
/**
 * Specifies a point for which a geospatial query returns documents that are within the max distance.    Documents are sorted by proximity (from nearest to farthest).    Documents without geolocation are ignored.    Custom sorting is ignored.  
 * @export
 * @interface GeneralGeolocationNearPointQueryDto
 */
export interface GeneralGeolocationNearPointQueryDto {
    /**
     * 
     * @type {GeoJsonPointInputDto}
     * @memberof GeneralGeolocationNearPointQueryDto
     */
    'point'?: GeoJsonPointInputDto;
    /**
     * The maximum distance from the point, in meters.
     * @type {number}
     * @memberof GeneralGeolocationNearPointQueryDto
     */
    'maxDistanceM'?: number;
}
/**
 * 
 * @export
 * @interface GeneralGeolocationOfEntityUpdateDto
 */
export interface GeneralGeolocationOfEntityUpdateDto {
    /**
     * 
     * @type {GeneralGeolocationInputDto}
     * @memberof GeneralGeolocationOfEntityUpdateDto
     */
    'geolocation'?: GeneralGeolocationInputDto;
}
/**
 * 
 * @export
 * @interface GeneralGeolocationOfEntityUpdateResultDto
 */
export interface GeneralGeolocationOfEntityUpdateResultDto {
    /**
     * 
     * @type {GeneralGeolocationDto}
     * @memberof GeneralGeolocationOfEntityUpdateResultDto
     */
    'geolocation'?: GeneralGeolocationDto;
}
/**
 * 
 * @export
 * @interface GeneralGeolocationQueryDto
 */
export interface GeneralGeolocationQueryDto {
    /**
     * 
     * @type {GeneralGeolocationNearPointQueryDto}
     * @memberof GeneralGeolocationQueryDto
     */
    'nearPoint'?: GeneralGeolocationNearPointQueryDto;
    /**
     * 
     * @type {GeneralGeolocationWithinRadiusQueryDto}
     * @memberof GeneralGeolocationQueryDto
     */
    'withinRadius'?: GeneralGeolocationWithinRadiusQueryDto;
}
/**
 * Specifies a circle for which a geospatial query returns documents that are within the bounds of the circle.    Documents are unsorted.    Documents without geolocation are ignored.    Custom sorting is not ignored.  
 * @export
 * @interface GeneralGeolocationWithinRadiusQueryDto
 */
export interface GeneralGeolocationWithinRadiusQueryDto {
    /**
     * 
     * @type {GeoJsonPointInputDto}
     * @memberof GeneralGeolocationWithinRadiusQueryDto
     */
    'point'?: GeoJsonPointInputDto;
    /**
     * Radius in meters.
     * @type {number}
     * @memberof GeneralGeolocationWithinRadiusQueryDto
     */
    'radiusM'?: number;
}
/**
 * 
 * @export
 * @interface GeneralHistoryChangedDto
 */
export interface GeneralHistoryChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralHistoryChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof GeneralHistoryChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralHistoryChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {GeneralHistoryDto}
     * @memberof GeneralHistoryChangedDto
     */
    'entity': GeneralHistoryDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface GeneralHistoryCreateDto
 */
export interface GeneralHistoryCreateDto {
    /**
     * 
     * @type {GeneralHistoryType}
     * @memberof GeneralHistoryCreateDto
     */
    'type'?: GeneralHistoryType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralHistoryCreateDto
     */
    'raisedAt'?: string;
    /**
     * 
     * @type {GeneralHistorySubjectInputDto}
     * @memberof GeneralHistoryCreateDto
     */
    'subject'?: GeneralHistorySubjectInputDto;
    /**
     * 
     * @type {GeneralHistoryEventInputDto}
     * @memberof GeneralHistoryCreateDto
     */
    'event'?: GeneralHistoryEventInputDto;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof GeneralHistoryCreateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof GeneralHistoryCreateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}


/**
 * 
 * @export
 * @interface GeneralHistoryDto
 */
export interface GeneralHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof GeneralHistoryDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralHistoryDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralHistoryDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {GeneralHistoryType}
     * @memberof GeneralHistoryDto
     */
    'type'?: GeneralHistoryType;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralHistoryDto
     */
    'autoCreateMode'?: AutomationCreateMode;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralHistoryDto
     */
    'raisedAt'?: string;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof GeneralHistoryDto
     */
    'raisedBy'?: GeneralByWhoDto;
    /**
     * 
     * @type {GeneralHistorySubjectDto}
     * @memberof GeneralHistoryDto
     */
    'subject'?: GeneralHistorySubjectDto;
    /**
     * 
     * @type {GeneralHistoryLogDto}
     * @memberof GeneralHistoryDto
     */
    'log'?: GeneralHistoryLogDto;
    /**
     * 
     * @type {GeneralHistoryEventDto}
     * @memberof GeneralHistoryDto
     */
    'event'?: GeneralHistoryEventDto;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof GeneralHistoryDto
     */
    'attachments'?: Array<GeneralAttachmentDto> | null;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof GeneralHistoryDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {DataGrantsMetaDto}
     * @memberof GeneralHistoryDto
     */
    'grantsMeta'?: DataGrantsMetaDto;
}


/**
 * 
 * @export
 * @interface GeneralHistoryEventDto
 */
export interface GeneralHistoryEventDto {
    /**
     * 
     * @type {GeneralHistoryEventType}
     * @memberof GeneralHistoryEventDto
     */
    'type'?: GeneralHistoryEventType;
    /**
     * 
     * @type {GeneralHistoryEventOfArbitraryDto}
     * @memberof GeneralHistoryEventDto
     */
    'arbitrary'?: GeneralHistoryEventOfArbitraryDto;
    /**
     * 
     * @type {GeneralHistoryEventOfVehicleDto}
     * @memberof GeneralHistoryEventDto
     */
    'vehicle'?: GeneralHistoryEventOfVehicleDto;
    /**
     * 
     * @type {GeneralHistoryEventOfVehicleDamageDto}
     * @memberof GeneralHistoryEventDto
     */
    'vehicleDamage'?: GeneralHistoryEventOfVehicleDamageDto;
}


/**
 * 
 * @export
 * @interface GeneralHistoryEventInputDto
 */
export interface GeneralHistoryEventInputDto {
    /**
     * 
     * @type {GeneralHistoryEventType}
     * @memberof GeneralHistoryEventInputDto
     */
    'type'?: GeneralHistoryEventType;
    /**
     * 
     * @type {GeneralHistoryEventOfArbitraryInputDto}
     * @memberof GeneralHistoryEventInputDto
     */
    'arbitrary'?: GeneralHistoryEventOfArbitraryInputDto;
}


/**
 * 
 * @export
 * @interface GeneralHistoryEventOfArbitraryDto
 */
export interface GeneralHistoryEventOfArbitraryDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryEventOfArbitraryDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryEventOfArbitraryDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralHistoryEventOfArbitraryInputDto
 */
export interface GeneralHistoryEventOfArbitraryInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryEventOfArbitraryInputDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryEventOfArbitraryInputDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralHistoryEventOfVehicleDamageDto
 */
export interface GeneralHistoryEventOfVehicleDamageDto {
    /**
     * 
     * @type {GeneralHistoryEventTypeOfVehicleDamage}
     * @memberof GeneralHistoryEventOfVehicleDamageDto
     */
    'type'?: GeneralHistoryEventTypeOfVehicleDamage;
    /**
     * 
     * @type {VehicleDamageDetectedEventDataDto}
     * @memberof GeneralHistoryEventOfVehicleDamageDto
     */
    'damageDetected'?: VehicleDamageDetectedEventDataDto;
    /**
     * 
     * @type {VehicleDamageRepairedEventDataDto}
     * @memberof GeneralHistoryEventOfVehicleDamageDto
     */
    'damageRepaired'?: VehicleDamageRepairedEventDataDto;
}


/**
 * 
 * @export
 * @interface GeneralHistoryEventOfVehicleDto
 */
export interface GeneralHistoryEventOfVehicleDto {
    /**
     * 
     * @type {GeneralHistoryEventTypeOfVehicle}
     * @memberof GeneralHistoryEventOfVehicleDto
     */
    'type'?: GeneralHistoryEventTypeOfVehicle;
    /**
     * 
     * @type {VehicleMileageChangedEventDataDto}
     * @memberof GeneralHistoryEventOfVehicleDto
     */
    'mileageChanged'?: VehicleMileageChangedEventDataDto;
    /**
     * 
     * @type {VehicleMileageCorrectedEventDataDto}
     * @memberof GeneralHistoryEventOfVehicleDto
     */
    'mileageCorrected'?: VehicleMileageCorrectedEventDataDto;
    /**
     * 
     * @type {VehicleDamageDetectedEventDataDto}
     * @memberof GeneralHistoryEventOfVehicleDto
     */
    'damageDetected'?: VehicleDamageDetectedEventDataDto;
    /**
     * 
     * @type {VehicleDamageRepairedEventDataDto}
     * @memberof GeneralHistoryEventOfVehicleDto
     */
    'damageRepaired'?: VehicleDamageRepairedEventDataDto;
    /**
     * 
     * @type {VehicleDamageDeletedEventDataDto}
     * @memberof GeneralHistoryEventOfVehicleDto
     */
    'damageDeleted'?: VehicleDamageDeletedEventDataDto;
    /**
     * 
     * @type {VehicleCheckedOutEventDataDto}
     * @memberof GeneralHistoryEventOfVehicleDto
     */
    'checkedOut'?: VehicleCheckedOutEventDataDto;
    /**
     * 
     * @type {VehicleCheckedInEventDataDto}
     * @memberof GeneralHistoryEventOfVehicleDto
     */
    'checkedIn'?: VehicleCheckedInEventDataDto;
    /**
     * 
     * @type {VehicleAllocatedEventDataDto}
     * @memberof GeneralHistoryEventOfVehicleDto
     */
    'allocated'?: VehicleAllocatedEventDataDto;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const GeneralHistoryEventType = {
    None: 'None',
    Arbitrary: 'Arbitrary',
    Vehicle: 'Vehicle',
    VehicleDamage: 'VehicleDamage'
} as const;

export type GeneralHistoryEventType = typeof GeneralHistoryEventType[keyof typeof GeneralHistoryEventType];


/**
 * 
 * @export
 * @enum {string}
 */

export const GeneralHistoryEventTypeOfVehicle = {
    None: 'None',
    MileageChanged: 'MileageChanged',
    MileageCorrected: 'MileageCorrected',
    DamageDetected: 'DamageDetected',
    DamageRepaired: 'DamageRepaired',
    DamageDeleted: 'DamageDeleted',
    CheckedOut: 'CheckedOut',
    CheckedIn: 'CheckedIn',
    Allocated: 'Allocated',
    WheelOperationCompleted: 'WheelOperationCompleted'
} as const;

export type GeneralHistoryEventTypeOfVehicle = typeof GeneralHistoryEventTypeOfVehicle[keyof typeof GeneralHistoryEventTypeOfVehicle];


/**
 * 
 * @export
 * @enum {string}
 */

export const GeneralHistoryEventTypeOfVehicleDamage = {
    None: 'None',
    DamageDetected: 'DamageDetected',
    DamageRepaired: 'DamageRepaired'
} as const;

export type GeneralHistoryEventTypeOfVehicleDamage = typeof GeneralHistoryEventTypeOfVehicleDamage[keyof typeof GeneralHistoryEventTypeOfVehicleDamage];


/**
 * 
 * @export
 * @interface GeneralHistoryGetPaginatedDto
 */
export interface GeneralHistoryGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'id'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'createdAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'updatedAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'createdBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'updatedBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {GeneralHistoryType}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'type'?: GeneralHistoryType;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'autoCreateMode'?: AutomationCreateMode;
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'subjectEntityType'?: EntityType;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'subjectEntityId'?: string | null;
    /**
     * 
     * @type {GeneralHistoryEventType}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'eventType'?: GeneralHistoryEventType;
    /**
     * 
     * @type {GeneralHistoryEventTypeOfVehicle}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'eventTypeOfVehicle'?: GeneralHistoryEventTypeOfVehicle;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof GeneralHistoryGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * 
 * @export
 * @interface GeneralHistoryLogDto
 */
export interface GeneralHistoryLogDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryLogDto
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface GeneralHistorySubjectDto
 */
export interface GeneralHistorySubjectDto {
    /**
     * 
     * @type {GeneralHistorySubjectType}
     * @memberof GeneralHistorySubjectDto
     */
    'type': GeneralHistorySubjectType;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistorySubjectDto
     */
    'identifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistorySubjectDto
     */
    'parentIdentifier'?: string | null;
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralHistorySubjectDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistorySubjectDto
     */
    'entityId'?: string | null;
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralHistorySubjectDto
     */
    'parentEntityType'?: EntityType;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistorySubjectDto
     */
    'parentEntityId'?: string | null;
}


/**
 * 
 * @export
 * @interface GeneralHistorySubjectInputDto
 */
export interface GeneralHistorySubjectInputDto {
    /**
     * 
     * @type {GeneralHistorySubjectType}
     * @memberof GeneralHistorySubjectInputDto
     */
    'type'?: GeneralHistorySubjectType;
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralHistorySubjectInputDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {string}
     * @memberof GeneralHistorySubjectInputDto
     */
    'entityId'?: string | null;
}


/**
 * Describes object types to which history can be linked.
 * @export
 * @enum {string}
 */

export const GeneralHistorySubjectType = {
    None: 'None',
    Arbitrary: 'Arbitrary',
    Entity: 'Entity'
} as const;

export type GeneralHistorySubjectType = typeof GeneralHistorySubjectType[keyof typeof GeneralHistorySubjectType];


/**
 * 
 * @export
 * @enum {string}
 */

export const GeneralHistoryType = {
    None: 'None',
    Log: 'Log',
    Event: 'Event'
} as const;

export type GeneralHistoryType = typeof GeneralHistoryType[keyof typeof GeneralHistoryType];


/**
 * 
 * @export
 * @interface GeneralHistoryUpdateDto
 */
export interface GeneralHistoryUpdateDto {
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralHistoryUpdateDto
     */
    'raisedAt'?: string;
    /**
     * 
     * @type {GeneralHistoryEventInputDto}
     * @memberof GeneralHistoryUpdateDto
     */
    'event'?: GeneralHistoryEventInputDto;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof GeneralHistoryUpdateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof GeneralHistoryUpdateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}
/**
 * Enumerates client method names that should support all hubs.
 * @export
 * @enum {string}
 */

export const GeneralHubClientMethodName = {
    Echo: 'Echo',
    ServerErrorOccurred: 'ServerErrorOccurred'
} as const;

export type GeneralHubClientMethodName = typeof GeneralHubClientMethodName[keyof typeof GeneralHubClientMethodName];


/**
 * Describes size of an image.
 * @export
 * @interface GeneralImageSize
 */
export interface GeneralImageSize {
    /**
     * 
     * @type {number}
     * @memberof GeneralImageSize
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralImageSize
     */
    'height'?: number;
}
/**
 * 
 * @export
 * @interface GeneralImageSizeDto
 */
export interface GeneralImageSizeDto {
    /**
     * 
     * @type {number}
     * @memberof GeneralImageSizeDto
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralImageSizeDto
     */
    'height'?: number;
}
/**
 * Represents a person who inspected something.
 * @export
 * @interface GeneralInspector
 */
export interface GeneralInspector {
    /**
     * 
     * @type {string}
     * @memberof GeneralInspector
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralInspector
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralInspector
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralInspector
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralInspector
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {GeneralPersonName}
     * @memberof GeneralInspector
     */
    'personName'?: GeneralPersonName;
    /**
     * 
     * @type {string}
     * @memberof GeneralInspector
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralInspector
     */
    'phoneNumber'?: string | null;
    /**
     * Deprecated: Use PersonName.
     * @type {string}
     * @memberof GeneralInspector
     * @deprecated
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface GeneralInspectorDto
 */
export interface GeneralInspectorDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralInspectorDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralInspectorDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralInspectorDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralInspectorDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralInspectorDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof GeneralInspectorDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralInspectorDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralInspectorDto
     */
    'phoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralInspectorInputDto
 */
export interface GeneralInspectorInputDto {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralInspectorInputDto
     */
    'isCurrentUser'?: boolean;
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof GeneralInspectorInputDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralInspectorInputDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralInspectorInputDto
     */
    'phoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralInsuranceDto
 */
export interface GeneralInsuranceDto {
    /**
     * 
     * @type {number}
     * @memberof GeneralInsuranceDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof GeneralInsuranceDto
     */
    'currency'?: GeneralCurrencyDto;
}
/**
 * 
 * @export
 * @interface GeneralInsuranceInputDto
 */
export interface GeneralInsuranceInputDto {
    /**
     * 
     * @type {number}
     * @memberof GeneralInsuranceInputDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof GeneralInsuranceInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
}
/**
 * 
 * @export
 * @interface GeneralLogoInputDto
 */
export interface GeneralLogoInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralLogoInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {FileUploadedDto}
     * @memberof GeneralLogoInputDto
     */
    'file'?: FileUploadedDto;
}
/**
 * 
 * @export
 * @interface GeneralLogoResizedDto
 */
export interface GeneralLogoResizedDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralLogoResizedDto
     */
    'id'?: string;
    /**
     * 
     * @type {FileReferenceDto}
     * @memberof GeneralLogoResizedDto
     */
    'file'?: FileReferenceDto;
    /**
     * 
     * @type {Array<GeneralLogoResizedImageDto>}
     * @memberof GeneralLogoResizedDto
     */
    'logos'?: Array<GeneralLogoResizedImageDto>;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralLogoResizedDto
     */
    'isLogo'?: boolean;
}
/**
 * 
 * @export
 * @interface GeneralLogoResizedImageDto
 */
export interface GeneralLogoResizedImageDto {
    /**
     * 
     * @type {LogoSizeType}
     * @memberof GeneralLogoResizedImageDto
     */
    'sizeType'?: LogoSizeType;
    /**
     * 
     * @type {GeneralImageSizeDto}
     * @memberof GeneralLogoResizedImageDto
     */
    'size'?: GeneralImageSizeDto;
    /**
     * 
     * @type {FileReferenceDto}
     * @memberof GeneralLogoResizedImageDto
     */
    'file'?: FileReferenceDto;
}


/**
 * 
 * @export
 * @interface GeneralNationalIdentityNumberDto
 */
export interface GeneralNationalIdentityNumberDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralNationalIdentityNumberDto
     */
    'number'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralNationalIdentityNumberDto
     */
    'countryCode'?: string;
    /**
     * 
     * @type {GeneralCountryDto}
     * @memberof GeneralNationalIdentityNumberDto
     */
    'country'?: GeneralCountryDto;
}
/**
 * 
 * @export
 * @interface GeneralNationalIdentityNumberInputDto
 */
export interface GeneralNationalIdentityNumberInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralNationalIdentityNumberInputDto
     */
    'number'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralNationalIdentityNumberInputDto
     */
    'countryCode'?: string;
}
/**
 * 
 * @export
 * @interface GeneralNotesInputDto
 */
export interface GeneralNotesInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralNotesInputDto
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralPersonName
 */
export interface GeneralPersonName {
    /**
     * 
     * @type {string}
     * @memberof GeneralPersonName
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralPersonName
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralPersonName
     */
    'middleName'?: string | null;
    /**
     * Full name.
     * @type {string}
     * @memberof GeneralPersonName
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralPersonName
     */
    'isEmpty'?: boolean;
}
/**
 * 
 * @export
 * @interface GeneralPersonNameDto
 */
export interface GeneralPersonNameDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralPersonNameDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralPersonNameDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralPersonNameDto
     */
    'middleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralPersonNameDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface GeneralPersonNameInputDto
 */
export interface GeneralPersonNameInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralPersonNameInputDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralPersonNameInputDto
     */
    'lastName'?: string;
}
/**
 * 
 * @export
 * @interface GeneralPlateNoDto
 */
export interface GeneralPlateNoDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralPlateNoDto
     */
    'countryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralPlateNoDto
     */
    'plateNo'?: string;
}
/**
 * 
 * @export
 * @interface GeneralPlateNoInputDto
 */
export interface GeneralPlateNoInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralPlateNoInputDto
     */
    'countryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralPlateNoInputDto
     */
    'plateNo'?: string;
}
/**
 * 
 * @export
 * @interface GeneralPriceDto
 */
export interface GeneralPriceDto {
    /**
     * 
     * @type {number}
     * @memberof GeneralPriceDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof GeneralPriceDto
     */
    'currency'?: GeneralCurrencyDto;
}
/**
 * 
 * @export
 * @interface GeneralPriceInputDto
 */
export interface GeneralPriceInputDto {
    /**
     * 
     * @type {number}
     * @memberof GeneralPriceInputDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof GeneralPriceInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
}
/**
 * 
 * @export
 * @interface GeneralPriceSummaryDto
 */
export interface GeneralPriceSummaryDto {
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof GeneralPriceSummaryDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * Price before any discount or tax is applied.
     * @type {number}
     * @memberof GeneralPriceSummaryDto
     */
    'subTotal'?: number;
    /**
     * Price after discount is applied, but before any tax is applied.
     * @type {number}
     * @memberof GeneralPriceSummaryDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof GeneralPriceSummaryDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof GeneralPriceSummaryDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {GeneralInsuranceDto}
     * @memberof GeneralPriceSummaryDto
     */
    'insurance'?: GeneralInsuranceDto;
    /**
     * SubTotal after discounts, taxes, etc.
     * @type {number}
     * @memberof GeneralPriceSummaryDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface GeneralPriceSummaryInputDto
 */
export interface GeneralPriceSummaryInputDto {
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof GeneralPriceSummaryInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * Price before any discount or tax is applied.
     * @type {number}
     * @memberof GeneralPriceSummaryInputDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof GeneralPriceSummaryInputDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof GeneralPriceSummaryInputDto
     */
    'tax'?: GeneralTaxInputDto;
    /**
     * 
     * @type {GeneralInsuranceInputDto}
     * @memberof GeneralPriceSummaryInputDto
     */
    'insurance'?: GeneralInsuranceInputDto;
    /**
     * SubTotal after discounts, taxes, etc.
     * @type {number}
     * @memberof GeneralPriceSummaryInputDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface GeneralProductProfileDto
 */
export interface GeneralProductProfileDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralProductProfileDto
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralProductProfileDto
     */
    'isAllowPropagation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralProductProfileDto
     */
    'isPropagated'?: boolean;
    /**
     * 
     * @type {GeneralProductProfileSourceDto}
     * @memberof GeneralProductProfileDto
     */
    'source'?: GeneralProductProfileSourceDto;
    /**
     * 
     * @type {GeneralCountryDto}
     * @memberof GeneralProductProfileDto
     */
    'country'?: GeneralCountryDto;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof GeneralProductProfileDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {SubscriptionPlanPriceDto}
     * @memberof GeneralProductProfileDto
     */
    'basePrice'?: SubscriptionPlanPriceDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralProductProfileDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralProductProfileDto
     */
    'updatedBy'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralProductProfileInputDto
 */
export interface GeneralProductProfileInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralProductProfileInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralProductProfileInputDto
     */
    'isAllowPropagation'?: boolean;
    /**
     * 
     * @type {GeneralCountryInputDto}
     * @memberof GeneralProductProfileInputDto
     */
    'country'?: GeneralCountryInputDto;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof GeneralProductProfileInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {SubscriptionPlanPriceInputDto}
     * @memberof GeneralProductProfileInputDto
     */
    'basePrice'?: SubscriptionPlanPriceInputDto;
}
/**
 * 
 * @export
 * @interface GeneralProductProfileOfEntityUpdateDto
 */
export interface GeneralProductProfileOfEntityUpdateDto {
    /**
     * 
     * @type {GeneralProductProfileInputDto}
     * @memberof GeneralProductProfileOfEntityUpdateDto
     */
    'productProfile'?: GeneralProductProfileInputDto;
}
/**
 * 
 * @export
 * @interface GeneralProductProfileOfEntityUpdateResultDto
 */
export interface GeneralProductProfileOfEntityUpdateResultDto {
    /**
     * 
     * @type {GeneralProductProfileDto}
     * @memberof GeneralProductProfileOfEntityUpdateResultDto
     */
    'productProfile'?: GeneralProductProfileDto;
}
/**
 * 
 * @export
 * @interface GeneralProductProfileQueryDto
 */
export interface GeneralProductProfileQueryDto {
    /**
     * 
     * @type {GeneralCountryQueryDto}
     * @memberof GeneralProductProfileQueryDto
     */
    'country'?: GeneralCountryQueryDto;
    /**
     * 
     * @type {GeneralCurrencyQueryDto}
     * @memberof GeneralProductProfileQueryDto
     */
    'currency'?: GeneralCurrencyQueryDto;
    /**
     * 
     * @type {SubscriptionPlanPriceQueryDto}
     * @memberof GeneralProductProfileQueryDto
     */
    'basePrice'?: SubscriptionPlanPriceQueryDto;
}
/**
 * 
 * @export
 * @interface GeneralProductProfileSourceDto
 */
export interface GeneralProductProfileSourceDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralProductProfileSourceDto
     */
    'assetSubscriptionPlanId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralProductProfileSourceDto
     */
    'poolId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralProductProfileSourceDto
     */
    'assetId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralProductProfileSourceDto
     */
    'computedId'?: string;
}
/**
 * 
 * @export
 * @interface GeneralScopeDto
 */
export interface GeneralScopeDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralScopeDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralScopeDto
     */
    'subIdentifier'?: string | null;
    /**
     * 
     * @type {GeneralScopeType}
     * @memberof GeneralScopeDto
     */
    'type'?: GeneralScopeType;
    /**
     * 
     * @type {string}
     * @memberof GeneralScopeDto
     */
    'parentIdentifier'?: string | null;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof GeneralScopeDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof GeneralScopeDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {AssessmentFlowReferenceDto}
     * @memberof GeneralScopeDto
     */
    'assessmentFlow'?: AssessmentFlowReferenceDto;
    /**
     * 
     * @type {DamageDetectionReferenceDto}
     * @memberof GeneralScopeDto
     */
    'damageDetection'?: DamageDetectionReferenceDto;
    /**
     * 
     * @type {DamageDetectionAggregateReferenceDto}
     * @memberof GeneralScopeDto
     */
    'damageDetectionAggregate'?: DamageDetectionAggregateReferenceDto;
    /**
     * 
     * @type {DamageDetectionAggregateItemReferenceDto}
     * @memberof GeneralScopeDto
     */
    'damageDetectionAggregateItem'?: DamageDetectionAggregateItemReferenceDto;
    /**
     * 
     * @type {DamageCostEvaluationReferenceDto}
     * @memberof GeneralScopeDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationReferenceDto;
    /**
     * 
     * @type {DamageCostEvaluationAggregateReferenceDto}
     * @memberof GeneralScopeDto
     */
    'damageCostEvaluationAggregate'?: DamageCostEvaluationAggregateReferenceDto;
    /**
     * 
     * @type {DamageCostEvaluationAggregateItemReferenceDto}
     * @memberof GeneralScopeDto
     */
    'damageCostEvaluationAggregateItem'?: DamageCostEvaluationAggregateItemReferenceDto;
    /**
     * 
     * @type {VisualInspectionReferenceDto}
     * @memberof GeneralScopeDto
     */
    'visualInspection'?: VisualInspectionReferenceDto;
    /**
     * 
     * @type {AccessoryCheckReferenceDto}
     * @memberof GeneralScopeDto
     */
    'accessoryCheck'?: AccessoryCheckReferenceDto;
    /**
     * 
     * @type {AccessoryCheckItemReferenceDto}
     * @memberof GeneralScopeDto
     */
    'accessoryCheckItem'?: AccessoryCheckItemReferenceDto;
    /**
     * 
     * @type {RepairOperationReferenceDto}
     * @memberof GeneralScopeDto
     */
    'repairOperation'?: RepairOperationReferenceDto;
    /**
     * 
     * @type {WheelOperationReferenceDto}
     * @memberof GeneralScopeDto
     */
    'wheelOperation'?: WheelOperationReferenceDto;
    /**
     * 
     * @type {WashReferenceDto}
     * @memberof GeneralScopeDto
     */
    'wash'?: WashReferenceDto;
    /**
     * 
     * @type {MaintenanceReferenceDto}
     * @memberof GeneralScopeDto
     */
    'maintenance'?: MaintenanceReferenceDto;
    /**
     * 
     * @type {AssignmentReferenceDto}
     * @memberof GeneralScopeDto
     */
    'assignment'?: AssignmentReferenceDto;
    /**
     * 
     * @type {TenantConnectionRequestReferenceDto}
     * @memberof GeneralScopeDto
     */
    'tenantConnectionRequest'?: TenantConnectionRequestReferenceDto;
    /**
     * 
     * @type {TenantConnectionReferenceDto}
     * @memberof GeneralScopeDto
     */
    'tenantConnection'?: TenantConnectionReferenceDto;
    /**
     * 
     * @type {TenantRequestReferenceDto}
     * @memberof GeneralScopeDto
     */
    'tenantRequest'?: TenantRequestReferenceDto;
}


/**
 * 
 * @export
 * @interface GeneralScopeInfoDto
 */
export interface GeneralScopeInfoDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralScopeInfoDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralScopeInfoDto
     */
    'subIdentifier'?: string | null;
    /**
     * 
     * @type {GeneralScopeType}
     * @memberof GeneralScopeInfoDto
     */
    'type'?: GeneralScopeType;
}


/**
 * 
 * @export
 * @interface GeneralScopeRequestDto
 */
export interface GeneralScopeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralScopeRequestDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralScopeRequestDto
     */
    'subIdentifier'?: string | null;
    /**
     * 
     * @type {GeneralScopeType}
     * @memberof GeneralScopeRequestDto
     */
    'type'?: GeneralScopeType;
}


/**
 * Helps link chat to its scope.  For instance, link comments chat to report entity to be able to update report based on chat events or actions.
 * @export
 * @enum {string}
 */

export const GeneralScopeType = {
    None: 'None',
    Dynamic: 'Dynamic',
    Vehicle: 'Vehicle',
    Contract: 'Contract',
    AssessmentFlow: 'AssessmentFlow',
    VisualInspection: 'VisualInspection',
    DamageDetection: 'DamageDetection',
    DamageDetectionItem: 'DamageDetectionItem',
    DamageDetectionAggregate: 'DamageDetectionAggregate',
    DamageDetectionAggregateItem: 'DamageDetectionAggregateItem',
    DamageCostEvaluation: 'DamageCostEvaluation',
    DamageCostEvaluationItem: 'DamageCostEvaluationItem',
    DamageCostEvaluationAggregate: 'DamageCostEvaluationAggregate',
    DamageCostEvaluationAggregateItem: 'DamageCostEvaluationAggregateItem',
    AccessoryCheck: 'AccessoryCheck',
    AccessoryCheckItem: 'AccessoryCheckItem',
    RepairOperation: 'RepairOperation',
    WheelOperation: 'WheelOperation',
    Wash: 'Wash',
    Maintenance: 'Maintenance',
    Document: 'Document',
    Assignment: 'Assignment',
    DocumentItem: 'DocumentItem',
    TenantConnectionRequest: 'TenantConnectionRequest',
    TenantConnection: 'TenantConnection',
    TenantRequest: 'TenantRequest'
} as const;

export type GeneralScopeType = typeof GeneralScopeType[keyof typeof GeneralScopeType];


/**
 * 
 * @export
 * @interface GeneralScopeUnwoundDto
 */
export interface GeneralScopeUnwoundDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralScopeUnwoundDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralScopeUnwoundDto
     */
    'subIdentifier'?: string | null;
    /**
     * 
     * @type {GeneralScopeType}
     * @memberof GeneralScopeUnwoundDto
     */
    'type'?: GeneralScopeType;
    /**
     * 
     * @type {string}
     * @memberof GeneralScopeUnwoundDto
     */
    'parentIdentifier'?: string | null;
    /**
     * 
     * @type {ContractDto}
     * @memberof GeneralScopeUnwoundDto
     */
    'contract'?: ContractDto;
    /**
     * 
     * @type {DamageDetectionAggregateDto}
     * @memberof GeneralScopeUnwoundDto
     */
    'damageDetectionAggregate'?: DamageDetectionAggregateDto;
    /**
     * 
     * @type {DamageDetectionAggregateItemDto}
     * @memberof GeneralScopeUnwoundDto
     */
    'damageDetectionAggregateItem'?: DamageDetectionAggregateItemDto;
    /**
     * 
     * @type {DamageCostEvaluationAggregateDto}
     * @memberof GeneralScopeUnwoundDto
     */
    'damageCostEvaluationAggregate'?: DamageCostEvaluationAggregateDto;
    /**
     * 
     * @type {DamageCostEvaluationAggregateItemDto}
     * @memberof GeneralScopeUnwoundDto
     */
    'damageCostEvaluationAggregateItem'?: DamageCostEvaluationAggregateItemDto;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryDtoOfAssignmentStage
 */
export interface GeneralStageHistoryDtoOfAssignmentStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryDtoOfAssignmentStage
     */
    'id'?: string;
    /**
     * 
     * @type {AssignmentStage}
     * @memberof GeneralStageHistoryDtoOfAssignmentStage
     */
    'stage'?: AssignmentStage;
    /**
     * 
     * @type {Array<GeneralStageHistoryItemDtoOfAssignmentStage>}
     * @memberof GeneralStageHistoryDtoOfAssignmentStage
     */
    'items'?: Array<GeneralStageHistoryItemDtoOfAssignmentStage>;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryDtoOfAssignmentStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {Array<GeneralStageInfoDtoOfAssignmentStage>}
     * @memberof GeneralStageHistoryDtoOfAssignmentStage
     */
    'allStagesInfo'?: Array<GeneralStageInfoDtoOfAssignmentStage>;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryDtoOfContractStage
 */
export interface GeneralStageHistoryDtoOfContractStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryDtoOfContractStage
     */
    'id'?: string;
    /**
     * 
     * @type {ContractStage}
     * @memberof GeneralStageHistoryDtoOfContractStage
     */
    'stage'?: ContractStage;
    /**
     * 
     * @type {Array<GeneralStageHistoryItemDtoOfContractStage>}
     * @memberof GeneralStageHistoryDtoOfContractStage
     */
    'items'?: Array<GeneralStageHistoryItemDtoOfContractStage>;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryDtoOfContractStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {Array<GeneralStageInfoDtoOfContractStage>}
     * @memberof GeneralStageHistoryDtoOfContractStage
     */
    'allStagesInfo'?: Array<GeneralStageInfoDtoOfContractStage>;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryDtoOfDamageCostEvaluationStage
 */
export interface GeneralStageHistoryDtoOfDamageCostEvaluationStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryDtoOfDamageCostEvaluationStage
     */
    'id'?: string;
    /**
     * 
     * @type {DamageCostEvaluationStage}
     * @memberof GeneralStageHistoryDtoOfDamageCostEvaluationStage
     */
    'stage'?: DamageCostEvaluationStage;
    /**
     * 
     * @type {Array<GeneralStageHistoryItemDtoOfDamageCostEvaluationStage>}
     * @memberof GeneralStageHistoryDtoOfDamageCostEvaluationStage
     */
    'items'?: Array<GeneralStageHistoryItemDtoOfDamageCostEvaluationStage>;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryDtoOfDamageCostEvaluationStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {Array<GeneralStageInfoDtoOfDamageCostEvaluationStage>}
     * @memberof GeneralStageHistoryDtoOfDamageCostEvaluationStage
     */
    'allStagesInfo'?: Array<GeneralStageInfoDtoOfDamageCostEvaluationStage>;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryDtoOfDocumentStage
 */
export interface GeneralStageHistoryDtoOfDocumentStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryDtoOfDocumentStage
     */
    'id'?: string;
    /**
     * 
     * @type {DocumentStage}
     * @memberof GeneralStageHistoryDtoOfDocumentStage
     */
    'stage'?: DocumentStage;
    /**
     * 
     * @type {Array<GeneralStageHistoryItemDtoOfDocumentStage>}
     * @memberof GeneralStageHistoryDtoOfDocumentStage
     */
    'items'?: Array<GeneralStageHistoryItemDtoOfDocumentStage>;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryDtoOfDocumentStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {Array<GeneralStageInfoDtoOfDocumentStage>}
     * @memberof GeneralStageHistoryDtoOfDocumentStage
     */
    'allStagesInfo'?: Array<GeneralStageInfoDtoOfDocumentStage>;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryDtoOfMaintenanceStage
 */
export interface GeneralStageHistoryDtoOfMaintenanceStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryDtoOfMaintenanceStage
     */
    'id'?: string;
    /**
     * 
     * @type {MaintenanceStage}
     * @memberof GeneralStageHistoryDtoOfMaintenanceStage
     */
    'stage'?: MaintenanceStage;
    /**
     * 
     * @type {Array<GeneralStageHistoryItemDtoOfMaintenanceStage>}
     * @memberof GeneralStageHistoryDtoOfMaintenanceStage
     */
    'items'?: Array<GeneralStageHistoryItemDtoOfMaintenanceStage>;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryDtoOfMaintenanceStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {Array<GeneralStageInfoDtoOfMaintenanceStage>}
     * @memberof GeneralStageHistoryDtoOfMaintenanceStage
     */
    'allStagesInfo'?: Array<GeneralStageInfoDtoOfMaintenanceStage>;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryDtoOfRepairOperationStage
 */
export interface GeneralStageHistoryDtoOfRepairOperationStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryDtoOfRepairOperationStage
     */
    'id'?: string;
    /**
     * 
     * @type {RepairOperationStage}
     * @memberof GeneralStageHistoryDtoOfRepairOperationStage
     */
    'stage'?: RepairOperationStage;
    /**
     * 
     * @type {Array<GeneralStageHistoryItemDtoOfRepairOperationStage>}
     * @memberof GeneralStageHistoryDtoOfRepairOperationStage
     */
    'items'?: Array<GeneralStageHistoryItemDtoOfRepairOperationStage>;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryDtoOfRepairOperationStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {Array<GeneralStageInfoDtoOfRepairOperationStage>}
     * @memberof GeneralStageHistoryDtoOfRepairOperationStage
     */
    'allStagesInfo'?: Array<GeneralStageInfoDtoOfRepairOperationStage>;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryDtoOfTenantRequestStage
 */
export interface GeneralStageHistoryDtoOfTenantRequestStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryDtoOfTenantRequestStage
     */
    'id'?: string;
    /**
     * 
     * @type {TenantRequestStage}
     * @memberof GeneralStageHistoryDtoOfTenantRequestStage
     */
    'stage'?: TenantRequestStage;
    /**
     * 
     * @type {Array<GeneralStageHistoryItemDtoOfTenantRequestStage>}
     * @memberof GeneralStageHistoryDtoOfTenantRequestStage
     */
    'items'?: Array<GeneralStageHistoryItemDtoOfTenantRequestStage>;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryDtoOfTenantRequestStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {Array<GeneralStageInfoDtoOfTenantRequestStage>}
     * @memberof GeneralStageHistoryDtoOfTenantRequestStage
     */
    'allStagesInfo'?: Array<GeneralStageInfoDtoOfTenantRequestStage>;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryDtoOfWashStage
 */
export interface GeneralStageHistoryDtoOfWashStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryDtoOfWashStage
     */
    'id'?: string;
    /**
     * 
     * @type {WashStage}
     * @memberof GeneralStageHistoryDtoOfWashStage
     */
    'stage'?: WashStage;
    /**
     * 
     * @type {Array<GeneralStageHistoryItemDtoOfWashStage>}
     * @memberof GeneralStageHistoryDtoOfWashStage
     */
    'items'?: Array<GeneralStageHistoryItemDtoOfWashStage>;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryDtoOfWashStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {Array<GeneralStageInfoDtoOfWashStage>}
     * @memberof GeneralStageHistoryDtoOfWashStage
     */
    'allStagesInfo'?: Array<GeneralStageInfoDtoOfWashStage>;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryDtoOfWheelOperationStage
 */
export interface GeneralStageHistoryDtoOfWheelOperationStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryDtoOfWheelOperationStage
     */
    'id'?: string;
    /**
     * 
     * @type {WheelOperationStage}
     * @memberof GeneralStageHistoryDtoOfWheelOperationStage
     */
    'stage'?: WheelOperationStage;
    /**
     * 
     * @type {Array<GeneralStageHistoryItemDtoOfWheelOperationStage>}
     * @memberof GeneralStageHistoryDtoOfWheelOperationStage
     */
    'items'?: Array<GeneralStageHistoryItemDtoOfWheelOperationStage>;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryDtoOfWheelOperationStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {Array<GeneralStageInfoDtoOfWheelOperationStage>}
     * @memberof GeneralStageHistoryDtoOfWheelOperationStage
     */
    'allStagesInfo'?: Array<GeneralStageInfoDtoOfWheelOperationStage>;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryItemDtoOfAssignmentStage
 */
export interface GeneralStageHistoryItemDtoOfAssignmentStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'id'?: string;
    /**
     * 
     * @type {AssignmentStage}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'stage'?: AssignmentStage;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'isCurrent'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'firstStartedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'startedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'firstEndedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'startedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'endedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'endReason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'startCount'?: number | null;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'startMode'?: AutomationCreateMode;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'endMode'?: AutomationCreateMode;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'isEnded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfAssignmentStage
     */
    'isLast'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryItemDtoOfContractStage
 */
export interface GeneralStageHistoryItemDtoOfContractStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'id'?: string;
    /**
     * 
     * @type {ContractStage}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'stage'?: ContractStage;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'isCurrent'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'firstStartedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'startedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'firstEndedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'startedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'endedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'endReason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'startCount'?: number | null;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'startMode'?: AutomationCreateMode;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'endMode'?: AutomationCreateMode;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'isEnded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfContractStage
     */
    'isLast'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
 */
export interface GeneralStageHistoryItemDtoOfDamageCostEvaluationStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'id'?: string;
    /**
     * 
     * @type {DamageCostEvaluationStage}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'stage'?: DamageCostEvaluationStage;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'isCurrent'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'firstStartedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'startedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'firstEndedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'startedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'endedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'endReason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'startCount'?: number | null;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'startMode'?: AutomationCreateMode;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'endMode'?: AutomationCreateMode;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'isEnded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfDamageCostEvaluationStage
     */
    'isLast'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryItemDtoOfDocumentStage
 */
export interface GeneralStageHistoryItemDtoOfDocumentStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'id'?: string;
    /**
     * 
     * @type {DocumentStage}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'stage'?: DocumentStage;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'isCurrent'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'firstStartedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'startedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'firstEndedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'startedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'endedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'endReason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'startCount'?: number | null;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'startMode'?: AutomationCreateMode;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'endMode'?: AutomationCreateMode;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'isEnded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfDocumentStage
     */
    'isLast'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryItemDtoOfMaintenanceStage
 */
export interface GeneralStageHistoryItemDtoOfMaintenanceStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'id'?: string;
    /**
     * 
     * @type {MaintenanceStage}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'stage'?: MaintenanceStage;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'isCurrent'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'firstStartedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'startedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'firstEndedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'startedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'endedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'endReason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'startCount'?: number | null;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'startMode'?: AutomationCreateMode;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'endMode'?: AutomationCreateMode;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'isEnded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfMaintenanceStage
     */
    'isLast'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryItemDtoOfRepairOperationStage
 */
export interface GeneralStageHistoryItemDtoOfRepairOperationStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'id'?: string;
    /**
     * 
     * @type {RepairOperationStage}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'stage'?: RepairOperationStage;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'isCurrent'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'firstStartedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'startedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'firstEndedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'startedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'endedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'endReason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'startCount'?: number | null;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'startMode'?: AutomationCreateMode;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'endMode'?: AutomationCreateMode;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'isEnded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfRepairOperationStage
     */
    'isLast'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryItemDtoOfTenantRequestStage
 */
export interface GeneralStageHistoryItemDtoOfTenantRequestStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'id'?: string;
    /**
     * 
     * @type {TenantRequestStage}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'stage'?: TenantRequestStage;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'isCurrent'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'firstStartedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'startedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'firstEndedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'startedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'endedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'endReason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'startCount'?: number | null;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'startMode'?: AutomationCreateMode;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'endMode'?: AutomationCreateMode;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'isEnded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfTenantRequestStage
     */
    'isLast'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryItemDtoOfWashStage
 */
export interface GeneralStageHistoryItemDtoOfWashStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'id'?: string;
    /**
     * 
     * @type {WashStage}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'stage'?: WashStage;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'isCurrent'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'firstStartedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'startedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'firstEndedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'startedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'endedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'endReason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'startCount'?: number | null;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'startMode'?: AutomationCreateMode;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'endMode'?: AutomationCreateMode;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'isEnded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfWashStage
     */
    'isLast'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageHistoryItemDtoOfWheelOperationStage
 */
export interface GeneralStageHistoryItemDtoOfWheelOperationStage {
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'id'?: string;
    /**
     * 
     * @type {WheelOperationStage}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'stage'?: WheelOperationStage;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'isCurrent'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'firstStartedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'startedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'firstEndedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'startedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'endedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'endReason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'startCount'?: number | null;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'startMode'?: AutomationCreateMode;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'endMode'?: AutomationCreateMode;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'isEnded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageHistoryItemDtoOfWheelOperationStage
     */
    'isLast'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageInfoDtoOfAssignmentStage
 */
export interface GeneralStageInfoDtoOfAssignmentStage {
    /**
     * 
     * @type {AssignmentStage}
     * @memberof GeneralStageInfoDtoOfAssignmentStage
     */
    'stage'?: AssignmentStage;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageInfoDtoOfAssignmentStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageInfoDtoOfAssignmentStage
     */
    'isFinal'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageInfoDtoOfContractStage
 */
export interface GeneralStageInfoDtoOfContractStage {
    /**
     * 
     * @type {ContractStage}
     * @memberof GeneralStageInfoDtoOfContractStage
     */
    'stage'?: ContractStage;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageInfoDtoOfContractStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageInfoDtoOfContractStage
     */
    'isFinal'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageInfoDtoOfDamageCostEvaluationStage
 */
export interface GeneralStageInfoDtoOfDamageCostEvaluationStage {
    /**
     * 
     * @type {DamageCostEvaluationStage}
     * @memberof GeneralStageInfoDtoOfDamageCostEvaluationStage
     */
    'stage'?: DamageCostEvaluationStage;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageInfoDtoOfDamageCostEvaluationStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageInfoDtoOfDamageCostEvaluationStage
     */
    'isFinal'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageInfoDtoOfDocumentStage
 */
export interface GeneralStageInfoDtoOfDocumentStage {
    /**
     * 
     * @type {DocumentStage}
     * @memberof GeneralStageInfoDtoOfDocumentStage
     */
    'stage'?: DocumentStage;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageInfoDtoOfDocumentStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageInfoDtoOfDocumentStage
     */
    'isFinal'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageInfoDtoOfMaintenanceStage
 */
export interface GeneralStageInfoDtoOfMaintenanceStage {
    /**
     * 
     * @type {MaintenanceStage}
     * @memberof GeneralStageInfoDtoOfMaintenanceStage
     */
    'stage'?: MaintenanceStage;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageInfoDtoOfMaintenanceStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageInfoDtoOfMaintenanceStage
     */
    'isFinal'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageInfoDtoOfRepairOperationStage
 */
export interface GeneralStageInfoDtoOfRepairOperationStage {
    /**
     * 
     * @type {RepairOperationStage}
     * @memberof GeneralStageInfoDtoOfRepairOperationStage
     */
    'stage'?: RepairOperationStage;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageInfoDtoOfRepairOperationStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageInfoDtoOfRepairOperationStage
     */
    'isFinal'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageInfoDtoOfTenantRequestStage
 */
export interface GeneralStageInfoDtoOfTenantRequestStage {
    /**
     * 
     * @type {TenantRequestStage}
     * @memberof GeneralStageInfoDtoOfTenantRequestStage
     */
    'stage'?: TenantRequestStage;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageInfoDtoOfTenantRequestStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageInfoDtoOfTenantRequestStage
     */
    'isFinal'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageInfoDtoOfWashStage
 */
export interface GeneralStageInfoDtoOfWashStage {
    /**
     * 
     * @type {WashStage}
     * @memberof GeneralStageInfoDtoOfWashStage
     */
    'stage'?: WashStage;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageInfoDtoOfWashStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageInfoDtoOfWashStage
     */
    'isFinal'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageInfoDtoOfWheelOperationStage
 */
export interface GeneralStageInfoDtoOfWheelOperationStage {
    /**
     * 
     * @type {WheelOperationStage}
     * @memberof GeneralStageInfoDtoOfWheelOperationStage
     */
    'stage'?: WheelOperationStage;
    /**
     * 
     * @type {number}
     * @memberof GeneralStageInfoDtoOfWheelOperationStage
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStageInfoDtoOfWheelOperationStage
     */
    'isFinal'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralStageUpdateDtoOfAssignmentStage
 */
export interface GeneralStageUpdateDtoOfAssignmentStage {
    /**
     * 
     * @type {AssignmentStage}
     * @memberof GeneralStageUpdateDtoOfAssignmentStage
     */
    'newStage'?: AssignmentStage;
}


/**
 * 
 * @export
 * @interface GeneralStageUpdateDtoOfDamageCostEvaluationStage
 */
export interface GeneralStageUpdateDtoOfDamageCostEvaluationStage {
    /**
     * 
     * @type {DamageCostEvaluationStage}
     * @memberof GeneralStageUpdateDtoOfDamageCostEvaluationStage
     */
    'newStage'?: DamageCostEvaluationStage;
}


/**
 * 
 * @export
 * @interface GeneralStageUpdateDtoOfMaintenanceStage
 */
export interface GeneralStageUpdateDtoOfMaintenanceStage {
    /**
     * 
     * @type {MaintenanceStage}
     * @memberof GeneralStageUpdateDtoOfMaintenanceStage
     */
    'newStage'?: MaintenanceStage;
}


/**
 * 
 * @export
 * @interface GeneralStageUpdateDtoOfRepairOperationStage
 */
export interface GeneralStageUpdateDtoOfRepairOperationStage {
    /**
     * 
     * @type {RepairOperationStage}
     * @memberof GeneralStageUpdateDtoOfRepairOperationStage
     */
    'newStage'?: RepairOperationStage;
}


/**
 * 
 * @export
 * @interface GeneralStageUpdateDtoOfTenantRequestStage
 */
export interface GeneralStageUpdateDtoOfTenantRequestStage {
    /**
     * 
     * @type {TenantRequestStage}
     * @memberof GeneralStageUpdateDtoOfTenantRequestStage
     */
    'newStage'?: TenantRequestStage;
}


/**
 * 
 * @export
 * @interface GeneralStageUpdateDtoOfWashStage
 */
export interface GeneralStageUpdateDtoOfWashStage {
    /**
     * 
     * @type {WashStage}
     * @memberof GeneralStageUpdateDtoOfWashStage
     */
    'newStage'?: WashStage;
}


/**
 * 
 * @export
 * @interface GeneralStageUpdateDtoOfWheelOperationStage
 */
export interface GeneralStageUpdateDtoOfWheelOperationStage {
    /**
     * 
     * @type {WheelOperationStage}
     * @memberof GeneralStageUpdateDtoOfWheelOperationStage
     */
    'newStage'?: WheelOperationStage;
}


/**
 * 
 * @export
 * @interface GeneralStatusHistoryDto
 */
export interface GeneralStatusHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof GeneralStatusHistoryDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'prevStatusHistoryId'?: string | null;
    /**
     * 
     * @type {GeneralStatusSubjectDto}
     * @memberof GeneralStatusHistoryDto
     */
    'subject'?: GeneralStatusSubjectDto;
    /**
     * 
     * @type {GeneralStatusIdentifier}
     * @memberof GeneralStatusHistoryDto
     */
    'statusIdentifier'?: GeneralStatusIdentifier;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'prevStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'status'?: string;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStatusHistoryDto
     */
    'startAutoMode'?: AutomationCreateMode;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStatusHistoryDto
     */
    'endAutoMode'?: AutomationCreateMode;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'startedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof GeneralStatusHistoryDto
     */
    'startedBy'?: GeneralByWhoDto;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof GeneralStatusHistoryDto
     */
    'endedBy'?: GeneralByWhoDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'endReason'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof GeneralStatusHistoryDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'statusEnumTypeName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStatusHistoryDto
     */
    'isCurrent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStatusHistoryDto
     */
    'isEnded'?: boolean;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof GeneralStatusHistoryDto
     */
    'duration'?: string | null;
}


/**
 * 
 * @export
 * @interface GeneralStatusHistoryGetPaginatedDto
 */
export interface GeneralStatusHistoryGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'id'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'createdAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'updatedAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'createdBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'updatedBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'subjectEntityType'?: EntityType;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'subjectEntityId'?: string | null;
    /**
     * 
     * @type {GeneralStatusIdentifier}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'statusIdentifier'?: GeneralStatusIdentifier;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof GeneralStatusHistoryGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * Describes unique types of statues that must correspond to single enum type (and enum name).  It allows to link status identifiers with their corresponding status enum types  and avoid storing enum type names in the DB.
 * @export
 * @enum {string}
 */

export const GeneralStatusIdentifier = {
    None: 'None',
    VehicleStatus: 'VehicleStatus',
    AvailabilityStatus: 'AvailabilityStatus',
    UtilizationStatus: 'UtilizationStatus',
    OperabilityStatus: 'OperabilityStatus'
} as const;

export type GeneralStatusIdentifier = typeof GeneralStatusIdentifier[keyof typeof GeneralStatusIdentifier];


/**
 * 
 * @export
 * @interface GeneralStatusInputDto
 */
export interface GeneralStatusInputDto {
    /**
     * 
     * @type {GeneralStatusIdentifier}
     * @memberof GeneralStatusInputDto
     */
    'statusIdentifier'?: GeneralStatusIdentifier;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusInputDto
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof GeneralStatusInputDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusInputDto
     */
    'status'?: string;
}


/**
 * 
 * @export
 * @interface GeneralStatusInputTypedDtoOfVehicleStatus
 */
export interface GeneralStatusInputTypedDtoOfVehicleStatus {
    /**
     * 
     * @type {GeneralStatusIdentifier}
     * @memberof GeneralStatusInputTypedDtoOfVehicleStatus
     */
    'statusIdentifier'?: GeneralStatusIdentifier;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusInputTypedDtoOfVehicleStatus
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof GeneralStatusInputTypedDtoOfVehicleStatus
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {VehicleStatus}
     * @memberof GeneralStatusInputTypedDtoOfVehicleStatus
     */
    'status'?: VehicleStatus;
}


/**
 * 
 * @export
 * @interface GeneralStatusMetaDto
 */
export interface GeneralStatusMetaDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaDto
     */
    'prevStatusHistoryId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaDto
     */
    'statusHistoryId'?: string;
    /**
     * 
     * @type {GeneralStatusSubjectDto}
     * @memberof GeneralStatusMetaDto
     */
    'subject'?: GeneralStatusSubjectDto;
    /**
     * 
     * @type {GeneralStatusIdentifier}
     * @memberof GeneralStatusMetaDto
     */
    'statusIdentifier'?: GeneralStatusIdentifier;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaDto
     */
    'prevStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaDto
     */
    'status'?: string;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStatusMetaDto
     */
    'startAutoMode'?: AutomationCreateMode;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStatusMetaDto
     */
    'startedAt'?: string;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof GeneralStatusMetaDto
     */
    'startedBy'?: GeneralByWhoDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaDto
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof GeneralStatusMetaDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaDto
     */
    'statusEnumTypeName'?: string;
}


/**
 * 
 * @export
 * @interface GeneralStatusMetaTypedDtoOfAvailabilityStatus
 */
export interface GeneralStatusMetaTypedDtoOfAvailabilityStatus {
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'prevStatusHistoryId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'statusHistoryId'?: string;
    /**
     * 
     * @type {GeneralStatusSubjectDto}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'subject'?: GeneralStatusSubjectDto;
    /**
     * 
     * @type {GeneralStatusIdentifier}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'statusIdentifier'?: GeneralStatusIdentifier;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'prevStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'status'?: string;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'startAutoMode'?: AutomationCreateMode;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'startedAt'?: string;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'startedBy'?: GeneralByWhoDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'statusEnumTypeName'?: string;
    /**
     * 
     * @type {AvailabilityStatus}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'prevStatusTyped'?: AvailabilityStatus;
    /**
     * 
     * @type {AvailabilityStatus}
     * @memberof GeneralStatusMetaTypedDtoOfAvailabilityStatus
     */
    'statusTyped'?: AvailabilityStatus;
}


/**
 * 
 * @export
 * @interface GeneralStatusMetaTypedDtoOfOperabilityStatus
 */
export interface GeneralStatusMetaTypedDtoOfOperabilityStatus {
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'prevStatusHistoryId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'statusHistoryId'?: string;
    /**
     * 
     * @type {GeneralStatusSubjectDto}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'subject'?: GeneralStatusSubjectDto;
    /**
     * 
     * @type {GeneralStatusIdentifier}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'statusIdentifier'?: GeneralStatusIdentifier;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'prevStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'status'?: string;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'startAutoMode'?: AutomationCreateMode;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'startedAt'?: string;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'startedBy'?: GeneralByWhoDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'statusEnumTypeName'?: string;
    /**
     * 
     * @type {OperabilityStatus}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'prevStatusTyped'?: OperabilityStatus;
    /**
     * 
     * @type {OperabilityStatus}
     * @memberof GeneralStatusMetaTypedDtoOfOperabilityStatus
     */
    'statusTyped'?: OperabilityStatus;
}


/**
 * 
 * @export
 * @interface GeneralStatusMetaTypedDtoOfUtilizationStatus
 */
export interface GeneralStatusMetaTypedDtoOfUtilizationStatus {
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'prevStatusHistoryId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'statusHistoryId'?: string;
    /**
     * 
     * @type {GeneralStatusSubjectDto}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'subject'?: GeneralStatusSubjectDto;
    /**
     * 
     * @type {GeneralStatusIdentifier}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'statusIdentifier'?: GeneralStatusIdentifier;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'prevStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'status'?: string;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'startAutoMode'?: AutomationCreateMode;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'startedAt'?: string;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'startedBy'?: GeneralByWhoDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'statusEnumTypeName'?: string;
    /**
     * 
     * @type {UtilizationStatus}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'prevStatusTyped'?: UtilizationStatus;
    /**
     * 
     * @type {UtilizationStatus}
     * @memberof GeneralStatusMetaTypedDtoOfUtilizationStatus
     */
    'statusTyped'?: UtilizationStatus;
}


/**
 * 
 * @export
 * @interface GeneralStatusMetaTypedDtoOfVehicleStatus
 */
export interface GeneralStatusMetaTypedDtoOfVehicleStatus {
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'prevStatusHistoryId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'statusHistoryId'?: string;
    /**
     * 
     * @type {GeneralStatusSubjectDto}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'subject'?: GeneralStatusSubjectDto;
    /**
     * 
     * @type {GeneralStatusIdentifier}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'statusIdentifier'?: GeneralStatusIdentifier;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'prevStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'status'?: string;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'startAutoMode'?: AutomationCreateMode;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'startedAt'?: string;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'startedBy'?: GeneralByWhoDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'startReason'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'statusEnumTypeName'?: string;
    /**
     * 
     * @type {VehicleStatus}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'prevStatusTyped'?: VehicleStatus;
    /**
     * 
     * @type {VehicleStatus}
     * @memberof GeneralStatusMetaTypedDtoOfVehicleStatus
     */
    'statusTyped'?: VehicleStatus;
}


/**
 * 
 * @export
 * @interface GeneralStatusSubjectDto
 */
export interface GeneralStatusSubjectDto {
    /**
     * 
     * @type {GeneralStatusSubjectType}
     * @memberof GeneralStatusSubjectDto
     */
    'type': GeneralStatusSubjectType;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusSubjectDto
     */
    'identifier'?: string | null;
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralStatusSubjectDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusSubjectDto
     */
    'entityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralStatusSubjectDto
     */
    'computedIdentifier'?: string;
}


/**
 * Describes object types to which history can be linked.
 * @export
 * @enum {string}
 */

export const GeneralStatusSubjectType = {
    None: 'None',
    Arbitrary: 'Arbitrary',
    Entity: 'Entity'
} as const;

export type GeneralStatusSubjectType = typeof GeneralStatusSubjectType[keyof typeof GeneralStatusSubjectType];


/**
 * 
 * @export
 * @interface GeneralStrictEntityRelationDto
 */
export interface GeneralStrictEntityRelationDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralStrictEntityRelationDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralStrictEntityRelationDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof GeneralStrictEntityRelationDto
     */
    'parentEntityIdMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {GeneralStrictEntityRelationDtoParentEntityTypeMap}
     * @memberof GeneralStrictEntityRelationDto
     */
    'parentEntityTypeMap'?: GeneralStrictEntityRelationDtoParentEntityTypeMap;
    /**
     * 
     * @type {TenantReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'tenant'?: TenantReferenceDto;
    /**
     * 
     * @type {DepartmentReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'department'?: DepartmentReferenceDto;
    /**
     * 
     * @type {LocationReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'location'?: LocationReferenceDto;
    /**
     * 
     * @type {SpotReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'spot'?: SpotReferenceDto;
    /**
     * 
     * @type {ProductLocationReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'productLocation'?: ProductLocationReferenceDto;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {VehicleFullReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'vehicleFullRef'?: VehicleFullReferenceDto;
    /**
     * 
     * @type {VehicleHistoryItemReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'vehicleHistory'?: VehicleHistoryItemReferenceDto;
    /**
     * 
     * @type {VehicleDamageReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'vehicleDamage'?: VehicleDamageReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {ContractFullReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'contractFullRef'?: ContractFullReferenceDto;
    /**
     * 
     * @type {CustomerReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'customer'?: CustomerReferenceDto;
    /**
     * 
     * @type {SupplierReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'supplier'?: SupplierReferenceDto;
    /**
     * 
     * @type {AssessmentFlowReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'assessmentFlow'?: AssessmentFlowReferenceDto;
    /**
     * 
     * @type {AccessoryReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'accessory'?: AccessoryReferenceDto;
    /**
     * 
     * @type {AccessoryFullReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'accessoryFullRef'?: AccessoryFullReferenceDto;
    /**
     * 
     * @type {VisualInspectionReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'visualInspection'?: VisualInspectionReferenceDto;
    /**
     * 
     * @type {DamageDetectionReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'damageDetection'?: DamageDetectionReferenceDto;
    /**
     * 
     * @type {DamageDetectionAggregateReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'damageDetectionAggregate'?: DamageDetectionAggregateReferenceDto;
    /**
     * 
     * @type {DamageCostEvaluationReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationReferenceDto;
    /**
     * 
     * @type {DamageCostEvaluationAggregateReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'damageCostEvaluationAggregate'?: DamageCostEvaluationAggregateReferenceDto;
    /**
     * 
     * @type {AccessoryCheckReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'accessoryCheck'?: AccessoryCheckReferenceDto;
    /**
     * 
     * @type {RepairOperationReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'repairOperation'?: RepairOperationReferenceDto;
    /**
     * 
     * @type {WheelOperationReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'wheelOperation'?: WheelOperationReferenceDto;
    /**
     * 
     * @type {WashReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'wash'?: WashReferenceDto;
    /**
     * 
     * @type {MaintenanceReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'maintenance'?: MaintenanceReferenceDto;
    /**
     * 
     * @type {ChatReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'chat'?: ChatReferenceDto;
    /**
     * 
     * @type {NegotiationReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'negotiation'?: NegotiationReferenceDto;
    /**
     * 
     * @type {NegotiationProposalReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'proposal'?: NegotiationProposalReferenceDto;
    /**
     * 
     * @type {DocumentReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'document'?: DocumentReferenceDto;
    /**
     * 
     * @type {InvoiceReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'invoice'?: InvoiceReferenceDto;
    /**
     * 
     * @type {VehicleTypeReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'vehicleType'?: VehicleTypeReferenceDto;
    /**
     * 
     * @type {VehicleMakeReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'vehicleMake'?: VehicleMakeReferenceDto;
    /**
     * 
     * @type {VehicleModelReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'vehicleModel'?: VehicleModelReferenceDto;
    /**
     * 
     * @type {VehicleGenerationReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'vehicleGeneration'?: VehicleGenerationReferenceDto;
    /**
     * 
     * @type {VehicleModificationReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'vehicleModification'?: VehicleModificationReferenceDto;
    /**
     * 
     * @type {VehicleBodyTypeReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'vehicleBodyType'?: VehicleBodyTypeReferenceDto;
    /**
     * 
     * @type {VehicleFuelTypeReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'vehicleFuelType'?: VehicleFuelTypeReferenceDto;
    /**
     * 
     * @type {VehiclePartTypeReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'vehiclePartType'?: VehiclePartTypeReferenceDto;
    /**
     * 
     * @type {VehicleVisualModelReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'vehicleVisualModel'?: VehicleVisualModelReferenceDto;
    /**
     * 
     * @type {DamageTypeReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'damageType'?: DamageTypeReferenceDto;
    /**
     * 
     * @type {RepairCatalogReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'repairCatalog'?: RepairCatalogReferenceDto;
    /**
     * 
     * @type {RepairWorkReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'repairWork'?: RepairWorkReferenceDto;
    /**
     * 
     * @type {RepairMaterialReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'repairMaterial'?: RepairMaterialReferenceDto;
    /**
     * 
     * @type {RepairSpecReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'repairSpec'?: RepairSpecReferenceDto;
    /**
     * 
     * @type {SubscriptionPlanReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'subscriptionPlan'?: SubscriptionPlanReferenceDto;
    /**
     * 
     * @type {SubscriptionReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'subscription'?: SubscriptionReferenceDto;
    /**
     * 
     * @type {AssetSubscriptionPlanReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'assetSubscriptionPlan'?: AssetSubscriptionPlanReferenceDto;
    /**
     * 
     * @type {AssetSubscriptionReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'assetSubscription'?: AssetSubscriptionReferenceDto;
    /**
     * 
     * @type {AssetReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'asset'?: AssetReferenceDto;
    /**
     * 
     * @type {AssetFullReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'assetFullRef'?: AssetFullReferenceDto;
    /**
     * 
     * @type {PoolReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'pool'?: PoolReferenceDto;
    /**
     * 
     * @type {PoolItemReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'poolItem'?: PoolItemReferenceDto;
    /**
     * 
     * @type {PoolItemFullReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'poolItemFullRef'?: PoolItemFullReferenceDto;
    /**
     * 
     * @type {IntegrationApiClientReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'integrationApiClient'?: IntegrationApiClientReferenceDto;
    /**
     * 
     * @type {TenantConnectionRequestReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'tenantConnectionRequest'?: TenantConnectionRequestReferenceDto;
    /**
     * 
     * @type {TenantConnectionReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'tenantConnection'?: TenantConnectionReferenceDto;
    /**
     * 
     * @type {TenantRequestReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'tenantRequest'?: TenantRequestReferenceDto;
    /**
     * 
     * @type {ChargeReferenceDto}
     * @memberof GeneralStrictEntityRelationDto
     */
    'charge'?: ChargeReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralStrictEntityRelationDto
     */
    'nameComputed'?: string | null;
}


/**
 * 
 * @export
 * @interface GeneralStrictEntityRelationDtoParentEntityTypeMap
 */
export interface GeneralStrictEntityRelationDtoParentEntityTypeMap {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'None'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'User'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Role'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Company'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Department'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Location'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Spot'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Vehicle'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'VehicleHistory'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'VehicleDamage'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Contract'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Customer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Accessory'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'VisualInspection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'DamageDetection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'DamageDetectionAggregate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'DamageCostEvaluation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'DamageCostEvaluationAggregate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'AccessoryCheck'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'RepairOperation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Maintenance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Document'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'DocumentItem'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Chat'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'ChatParticipant'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'ChatMessage'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'ChatHistoryItem'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'ChatEvent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'ChatActivity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'ChatUserSettings'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Negotiation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'NegotiationProposal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'File'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Invoice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Invite'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'VehicleType'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'VehicleMake'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'VehicleModel'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'VehicleGeneration'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'VehicleModification'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'VehicleBodyType'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'VehicleFuelType'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'VehiclePartType'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'VehicleVisualModel'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'DamageType'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'RepairCatalog'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'RepairWork'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'RepairMaterial'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'RepairSpec'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'RepairSparePart'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'SubscriptionPlan'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Subscription'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'AssetSubscriptionPlan'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'AssetSubscription'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'ProductLocation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Pool'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'PoolItem'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Asset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'IntegrationApiClient'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'TenantConnectionRequest'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'TenantConnection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'TenantRequest'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'DataGrant'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'AssessmentFlow'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'UserSecret'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'CustomIdentity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'CustomSession'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'FlowInstance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'FlowSpec'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'FlowStepSpec'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'GeneralEventLog'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Import'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'ImportTemplate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'NumberRegistryItem'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Party'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'PartyMember'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'TestDamageAssessmentReport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Test'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'UserVerificationRequest'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'DeviceToken'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Notification'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'NotificationGroup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'NotificationGroupMember'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'NotificationProfile'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'CustomTag'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Wash'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Webhook'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'WebhookActivation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'GeneralHistory'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'TeslaConnection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'GeneralStatusHistory'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'WheelOperation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Supplier'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Assignment'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'ContextThread'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'KeyValue'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'AnnotationTriple'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Charge'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'DataExportConfig'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'OnboardingDefinition'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'Onboarding'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'SecretValueKey'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralStrictEntityRelationDtoParentEntityTypeMap
     */
    'CompanyRequest'?: boolean;
}
/**
 * 
 * @export
 * @interface GeneralStrictEntityRelationInputDto
 */
export interface GeneralStrictEntityRelationInputDto {
    /**
     * 
     * @type {EntityType}
     * @memberof GeneralStrictEntityRelationInputDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {string}
     * @memberof GeneralStrictEntityRelationInputDto
     */
    'entityId'?: string;
}


/**
 * 
 * @export
 * @interface GeneralSvgPointDto
 */
export interface GeneralSvgPointDto {
    /**
     * SVG absolute/native coordinates.
     * @type {number}
     * @memberof GeneralSvgPointDto
     */
    'x'?: number;
    /**
     * SVG absolute/native coordinates.
     * @type {number}
     * @memberof GeneralSvgPointDto
     */
    'y'?: number;
    /**
     * SVG relative/normalized coordinates. Percents [0; 1].
     * @type {number}
     * @memberof GeneralSvgPointDto
     */
    'xp'?: number;
    /**
     * SVG relative/normalized coordinates. Percents [0; 1].
     * @type {number}
     * @memberof GeneralSvgPointDto
     */
    'yp'?: number;
    /**
     * SVG viewBox width used to calc relative coordinates.
     * @type {number}
     * @memberof GeneralSvgPointDto
     */
    'width'?: number;
    /**
     * SVG viewBox height used to calc relative coordinates.
     * @type {number}
     * @memberof GeneralSvgPointDto
     */
    'height'?: number;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidateDto
 */
export interface GeneralTagCandidateDto {
    /**
     * 
     * @type {GeneralTagDto}
     * @memberof GeneralTagCandidateDto
     */
    'tag'?: GeneralTagDto;
    /**
     * 
     * @type {Array<GeneralTagCandidateDto>}
     * @memberof GeneralTagCandidateDto
     */
    'subCandidates'?: Array<GeneralTagCandidateDto> | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidateDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidatesAccessoryCheckRequestDto
 */
export interface GeneralTagCandidatesAccessoryCheckRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesAccessoryCheckRequestDto
     */
    'vehicleId'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidatesAssignmentRequestDto
 */
export interface GeneralTagCandidatesAssignmentRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesAssignmentRequestDto
     */
    'vehicleId'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidatesByScopeRequestDto
 */
export interface GeneralTagCandidatesByScopeRequestDto {
    /**
     * 
     * @type {number}
     * @memberof GeneralTagCandidatesByScopeRequestDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralTagCandidatesByScopeRequestDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesByScopeRequestDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {GeneralScopeDto}
     * @memberof GeneralTagCandidatesByScopeRequestDto
     */
    'scope'?: GeneralScopeDto;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidatesChatParticipantRequestDto
 */
export interface GeneralTagCandidatesChatParticipantRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesChatParticipantRequestDto
     */
    'chatId'?: string;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidatesDamageCostEvaluationAggregateRequestDto
 */
export interface GeneralTagCandidatesDamageCostEvaluationAggregateRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesDamageCostEvaluationAggregateRequestDto
     */
    'vehicleId'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidatesDamageCostEvaluationRequestDto
 */
export interface GeneralTagCandidatesDamageCostEvaluationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesDamageCostEvaluationRequestDto
     */
    'vehicleId'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidatesDamageDetectionAggregateRequestDto
 */
export interface GeneralTagCandidatesDamageDetectionAggregateRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesDamageDetectionAggregateRequestDto
     */
    'vehicleId'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidatesDamageDetectionRequestDto
 */
export interface GeneralTagCandidatesDamageDetectionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesDamageDetectionRequestDto
     */
    'vehicleId'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidatesMaintenanceRequestDto
 */
export interface GeneralTagCandidatesMaintenanceRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesMaintenanceRequestDto
     */
    'vehicleId'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidatesRepairOperationRequestDto
 */
export interface GeneralTagCandidatesRepairOperationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesRepairOperationRequestDto
     */
    'vehicleId'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidatesRequestDto
 */
export interface GeneralTagCandidatesRequestDto {
    /**
     * 
     * @type {number}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'targetId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'targetSubId'?: string | null;
    /**
     * 
     * @type {TagTargetType}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'targetType'?: TagTargetType;
    /**
     * 
     * @type {TagSubTargetType}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'targetSubType'?: TagSubTargetType;
    /**
     * 
     * @type {GeneralTagCandidatesUserRequestDto}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'user'?: GeneralTagCandidatesUserRequestDto;
    /**
     * 
     * @type {GeneralTagCandidatesChatParticipantRequestDto}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'chatParticipant'?: GeneralTagCandidatesChatParticipantRequestDto;
    /**
     * 
     * @type {GeneralTagCandidatesVehicleDamageRequestDto}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'vehicleDamage'?: GeneralTagCandidatesVehicleDamageRequestDto;
    /**
     * 
     * @type {GeneralTagCandidatesVisualInspectionRequestDto}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'visualInspection'?: GeneralTagCandidatesVisualInspectionRequestDto;
    /**
     * 
     * @type {GeneralTagCandidatesDamageDetectionRequestDto}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'damageDetection'?: GeneralTagCandidatesDamageDetectionRequestDto;
    /**
     * 
     * @type {GeneralTagCandidatesDamageDetectionAggregateRequestDto}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'damageDetectionAggregate'?: GeneralTagCandidatesDamageDetectionAggregateRequestDto;
    /**
     * 
     * @type {GeneralTagCandidatesDamageCostEvaluationRequestDto}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'damageCostEvaluation'?: GeneralTagCandidatesDamageCostEvaluationRequestDto;
    /**
     * 
     * @type {GeneralTagCandidatesDamageCostEvaluationAggregateRequestDto}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'damageCostEvaluationAggregate'?: GeneralTagCandidatesDamageCostEvaluationAggregateRequestDto;
    /**
     * 
     * @type {GeneralTagCandidatesAccessoryCheckRequestDto}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'accessoryCheck'?: GeneralTagCandidatesAccessoryCheckRequestDto;
    /**
     * 
     * @type {GeneralTagCandidatesRepairOperationRequestDto}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'repairOperation'?: GeneralTagCandidatesRepairOperationRequestDto;
    /**
     * 
     * @type {GeneralTagCandidatesWashRequestDto}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'wash'?: GeneralTagCandidatesWashRequestDto;
    /**
     * 
     * @type {GeneralTagCandidatesMaintenanceRequestDto}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'maintenance'?: GeneralTagCandidatesMaintenanceRequestDto;
    /**
     * 
     * @type {GeneralTagCandidatesAssignmentRequestDto}
     * @memberof GeneralTagCandidatesRequestDto
     */
    'assignment'?: GeneralTagCandidatesAssignmentRequestDto;
}


/**
 * 
 * @export
 * @interface GeneralTagCandidatesUserRequestDto
 */
export interface GeneralTagCandidatesUserRequestDto {
    /**
     * true - query external users from the connected tenant.
     * @type {boolean}
     * @memberof GeneralTagCandidatesUserRequestDto
     */
    'isExternalUsers'?: boolean;
    /**
     * Connected tenant to query external users from.
     * @type {string}
     * @memberof GeneralTagCandidatesUserRequestDto
     */
    'connectedTenantId'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidatesVehicleDamageRequestDto
 */
export interface GeneralTagCandidatesVehicleDamageRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesVehicleDamageRequestDto
     */
    'vehicleId'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidatesVisualInspectionRequestDto
 */
export interface GeneralTagCandidatesVisualInspectionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesVisualInspectionRequestDto
     */
    'vehicleId'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralTagCandidatesWashRequestDto
 */
export interface GeneralTagCandidatesWashRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagCandidatesWashRequestDto
     */
    'vehicleId'?: string | null;
}
/**
 * Tag is a mention of user or some entity at some place.    NB: For some use cases, tag can be created in tenant A, but point to an entity in tenant B (external target).  
 * @export
 * @interface GeneralTagDto
 */
export interface GeneralTagDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagDto
     */
    'id'?: string;
    /**
     * Tenant where tag is created and stored.
     * @type {string}
     * @memberof GeneralTagDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {TagTargetType}
     * @memberof GeneralTagDto
     */
    'targetType'?: TagTargetType;
    /**
     * 
     * @type {TagSubTargetType}
     * @memberof GeneralTagDto
     */
    'subTargetType'?: TagSubTargetType;
    /**
     * 
     * @type {VisibilityStatus}
     * @memberof GeneralTagDto
     */
    'visibilityStatus'?: VisibilityStatus;
    /**
     * 
     * @type {GeneralTagTargetDto}
     * @memberof GeneralTagDto
     */
    'target'?: GeneralTagTargetDto;
    /**
     * 
     * @type {GeneralTagSubTargetDto}
     * @memberof GeneralTagDto
     */
    'subTarget'?: GeneralTagSubTargetDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof GeneralTagDto
     */
    'taggedAt'?: string;
    /**
     * 
     * @type {GeneralTagTaggedByDto}
     * @memberof GeneralTagDto
     */
    'taggedBy'?: GeneralTagTaggedByDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagDto
     */
    'computedId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagDto
     */
    'targetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagDto
     */
    'subTargetId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagDto
     */
    'targetTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralTagDto
     */
    'isExternalTarget'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralTagDto
     */
    'isPersonTagged'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagDto
     */
    'title'?: string;
}


/**
 * 
 * @export
 * @interface GeneralTagInputDto
 */
export interface GeneralTagInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {TagTargetType}
     * @memberof GeneralTagInputDto
     */
    'targetType'?: TagTargetType;
    /**
     * 
     * @type {TagSubTargetType}
     * @memberof GeneralTagInputDto
     */
    'subTargetType'?: TagSubTargetType;
    /**
     * 
     * @type {VisibilityStatus}
     * @memberof GeneralTagInputDto
     */
    'visibilityStatus'?: VisibilityStatus;
    /**
     * 
     * @type {GeneralTagTargetInputDto}
     * @memberof GeneralTagInputDto
     */
    'target'?: GeneralTagTargetInputDto;
    /**
     * 
     * @type {GeneralTagSubTargetInputDto}
     * @memberof GeneralTagInputDto
     */
    'subTarget'?: GeneralTagSubTargetInputDto;
}


/**
 * 
 * @export
 * @interface GeneralTagSubTargetDto
 */
export interface GeneralTagSubTargetDto {
    /**
     * 
     * @type {DamageDetectionItemReferenceDto}
     * @memberof GeneralTagSubTargetDto
     */
    'damageDetectionItem'?: DamageDetectionItemReferenceDto;
    /**
     * 
     * @type {DamageDetectionAggregateItemReferenceDto}
     * @memberof GeneralTagSubTargetDto
     */
    'damageDetectionAggregateItem'?: DamageDetectionAggregateItemReferenceDto;
    /**
     * 
     * @type {DamageCostEvaluationItemReferenceDto}
     * @memberof GeneralTagSubTargetDto
     */
    'damageCostEvaluationItem'?: DamageCostEvaluationItemReferenceDto;
    /**
     * 
     * @type {DamageCostEvaluationAggregateItemReferenceDto}
     * @memberof GeneralTagSubTargetDto
     */
    'damageCostEvaluationAggregateItem'?: DamageCostEvaluationAggregateItemReferenceDto;
    /**
     * 
     * @type {AccessoryCheckItemReferenceDto}
     * @memberof GeneralTagSubTargetDto
     */
    'accessoryCheckItem'?: AccessoryCheckItemReferenceDto;
    /**
     * 
     * @type {NegotiationProposalReferenceDto}
     * @memberof GeneralTagSubTargetDto
     */
    'proposal'?: NegotiationProposalReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagSubTargetDto
     */
    'subTargetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagSubTargetDto
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface GeneralTagSubTargetInputDto
 */
export interface GeneralTagSubTargetInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagSubTargetInputDto
     */
    'subTargetId'?: string;
}
/**
 * 
 * @export
 * @interface GeneralTagTaggedByDto
 */
export interface GeneralTagTaggedByDto {
    /**
     * 
     * @type {UserReferenceDto}
     * @memberof GeneralTagTaggedByDto
     */
    'user'?: UserReferenceDto;
    /**
     * 
     * @type {ChatParticipantReferenceDto}
     * @memberof GeneralTagTaggedByDto
     */
    'chatParticipant'?: ChatParticipantReferenceDto;
}
/**
 * 
 * @export
 * @interface GeneralTagTargetDto
 */
export interface GeneralTagTargetDto {
    /**
     * 
     * @type {CustomTagFullReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'customTag'?: CustomTagFullReferenceDto;
    /**
     * 
     * @type {UserReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'user'?: UserReferenceDto;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {AssetReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'asset'?: AssetReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {AssessmentFlowReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'assessmentFlow'?: AssessmentFlowReferenceDto;
    /**
     * 
     * @type {CustomerReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'customer'?: CustomerReferenceDto;
    /**
     * 
     * @type {VehicleDamageReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'vehicleDamage'?: VehicleDamageReferenceDto;
    /**
     * 
     * @type {AccessoryReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'accessory'?: AccessoryReferenceDto;
    /**
     * 
     * @type {VisualInspectionReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'visualInspection'?: VisualInspectionReferenceDto;
    /**
     * 
     * @type {DamageDetectionReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'damageDetection'?: DamageDetectionReferenceDto;
    /**
     * 
     * @type {DamageDetectionAggregateReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'damageDetectionAggregate'?: DamageDetectionAggregateReferenceDto;
    /**
     * 
     * @type {DamageCostEvaluationReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationReferenceDto;
    /**
     * 
     * @type {DamageCostEvaluationAggregateReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'damageCostEvaluationAggregate'?: DamageCostEvaluationAggregateReferenceDto;
    /**
     * 
     * @type {AccessoryCheckReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'accessoryCheck'?: AccessoryCheckReferenceDto;
    /**
     * 
     * @type {RepairOperationReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'repairOperation'?: RepairOperationReferenceDto;
    /**
     * 
     * @type {WheelOperationReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'wheelOperation'?: WheelOperationReferenceDto;
    /**
     * 
     * @type {WashReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'wash'?: WashReferenceDto;
    /**
     * 
     * @type {MaintenanceReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'maintenance'?: MaintenanceReferenceDto;
    /**
     * 
     * @type {ChatReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'chat'?: ChatReferenceDto;
    /**
     * 
     * @type {ChatParticipantReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'chatParticipant'?: ChatParticipantReferenceDto;
    /**
     * 
     * @type {NegotiationReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'negotiation'?: NegotiationReferenceDto;
    /**
     * 
     * @type {AssetSubscriptionPlanReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'assetSubscriptionPlan'?: AssetSubscriptionPlanReferenceDto;
    /**
     * 
     * @type {AssetSubscriptionReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'assetSubscription'?: AssetSubscriptionReferenceDto;
    /**
     * 
     * @type {TenantConnectionRequestReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'tenantConnectionRequest'?: TenantConnectionRequestReferenceDto;
    /**
     * 
     * @type {TenantConnectionReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'tenantConnection'?: TenantConnectionReferenceDto;
    /**
     * 
     * @type {TenantRequestReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'tenantRequest'?: TenantRequestReferenceDto;
    /**
     * 
     * @type {DataGrantReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'dataGrant'?: DataGrantReferenceDto;
    /**
     * 
     * @type {PoolReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'pool'?: PoolReferenceDto;
    /**
     * 
     * @type {DepartmentReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'department'?: DepartmentReferenceDto;
    /**
     * 
     * @type {LocationReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'location'?: LocationReferenceDto;
    /**
     * 
     * @type {SpotReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'spot'?: SpotReferenceDto;
    /**
     * 
     * @type {AssignmentReferenceDto}
     * @memberof GeneralTagTargetDto
     */
    'assignment'?: AssignmentReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagTargetDto
     */
    'targetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagTargetDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagTargetDto
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface GeneralTagTargetInputDto
 */
export interface GeneralTagTargetInputDto {
    /**
     * 
     * @type {string}
     * @memberof GeneralTagTargetInputDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralTagTargetInputDto
     */
    'targetId'?: string;
}
/**
 * Represents a percentage/amount from goods price that should be paid as tax.  Stored as positive number and is always added to SubTotal.
 * @export
 * @interface GeneralTax
 */
export interface GeneralTax {
    /**
     * 
     * @type {TaxType}
     * @memberof GeneralTax
     */
    'type'?: TaxType;
    /**
     * 
     * @type {TaxValueType}
     * @memberof GeneralTax
     */
    'valueType'?: TaxValueType;
    /**
     * Percents [0; N].
     * @type {number}
     * @memberof GeneralTax
     */
    'percent'?: number | null;
    /**
     * Amount in some currency representation.
     * @type {number}
     * @memberof GeneralTax
     */
    'value'?: number | null;
    /**
     * 
     * @type {GeneralCurrency}
     * @memberof GeneralTax
     */
    'currency'?: GeneralCurrency;
    /**
     * Tax that is a result of merging N taxes into one.
     * @type {boolean}
     * @memberof GeneralTax
     */
    'isCompound'?: boolean;
    /**
     * 
     * @type {GeneralTax}
     * @memberof GeneralTax
     */
    'original'?: GeneralTax;
}


/**
 * 
 * @export
 * @interface GeneralTaxDto
 */
export interface GeneralTaxDto {
    /**
     * 
     * @type {TaxType}
     * @memberof GeneralTaxDto
     */
    'type'?: TaxType;
    /**
     * 
     * @type {TaxValueType}
     * @memberof GeneralTaxDto
     */
    'valueType'?: TaxValueType;
    /**
     * Percents [0, 1]
     * @type {number}
     * @memberof GeneralTaxDto
     */
    'percent'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GeneralTaxDto
     */
    'value'?: number | null;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof GeneralTaxDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralTaxDto
     */
    'isCompound'?: boolean;
}


/**
 * 
 * @export
 * @interface GeneralTaxInputDto
 */
export interface GeneralTaxInputDto {
    /**
     * 
     * @type {TaxType}
     * @memberof GeneralTaxInputDto
     */
    'type'?: TaxType;
    /**
     * 
     * @type {TaxValueType}
     * @memberof GeneralTaxInputDto
     */
    'valueType'?: TaxValueType;
    /**
     * Percents [0, 1]
     * @type {number}
     * @memberof GeneralTaxInputDto
     */
    'percent'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GeneralTaxInputDto
     */
    'value'?: number | null;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof GeneralTaxInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
}


/**
 * 
 * @export
 * @interface GeneralTimeZoneDto
 */
export interface GeneralTimeZoneDto {
    /**
     * IANA time zone id.
     * @type {string}
     * @memberof GeneralTimeZoneDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralTimeZoneDto
     */
    'displayName'?: string;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof GeneralTimeZoneDto
     */
    'minOffset'?: string;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof GeneralTimeZoneDto
     */
    'maxOffset'?: string;
}
/**
 * 
 * @export
 * @interface GeoJsonPointDto
 */
export interface GeoJsonPointDto {
    /**
     * 
     * @type {GeoJsonType}
     * @memberof GeoJsonPointDto
     */
    'type'?: GeoJsonType;
    /**
     * 
     * @type {number}
     * @memberof GeoJsonPointDto
     */
    'longitude': number;
    /**
     * 
     * @type {number}
     * @memberof GeoJsonPointDto
     */
    'latitude': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof GeoJsonPointDto
     */
    'coordinates'?: Array<number>;
}


/**
 * 
 * @export
 * @interface GeoJsonPointInputDto
 */
export interface GeoJsonPointInputDto {
    /**
     * 
     * @type {number}
     * @memberof GeoJsonPointInputDto
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoJsonPointInputDto
     */
    'latitude'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GeoJsonType = {
    None: 'None',
    Point: 'Point',
    LineString: 'LineString',
    Polygon: 'Polygon',
    MultiPoint: 'MultiPoint',
    MultiLineString: 'MultiLineString',
    MultiPolygon: 'MultiPolygon',
    Feature: 'Feature'
} as const;

export type GeoJsonType = typeof GeoJsonType[keyof typeof GeoJsonType];


/**
 * 
 * @export
 * @interface GetChatActivityOverviewByScopeDto
 */
export interface GetChatActivityOverviewByScopeDto {
    /**
     * 
     * @type {GeneralScopeRequestDto}
     * @memberof GetChatActivityOverviewByScopeDto
     */
    'scope'?: GeneralScopeRequestDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetChatActivityOverviewByScopeDto
     */
    'isResolved'?: boolean | null;
}
/**
 * 
 * @export
 * @interface GetChatActivityOverviewByScopesDto
 */
export interface GetChatActivityOverviewByScopesDto {
    /**
     * 
     * @type {Array<GeneralScopeRequestDto>}
     * @memberof GetChatActivityOverviewByScopesDto
     */
    'scopes'?: Array<GeneralScopeRequestDto>;
    /**
     * 
     * @type {boolean}
     * @memberof GetChatActivityOverviewByScopesDto
     */
    'isResolved'?: boolean | null;
}
/**
 * 
 * @export
 * @interface GetChatUserSettingsResultDto
 */
export interface GetChatUserSettingsResultDto {
    /**
     * 
     * @type {string}
     * @memberof GetChatUserSettingsResultDto
     */
    'requestedForChatId'?: string;
    /**
     * 
     * @type {ChatUserSettingsDto}
     * @memberof GetChatUserSettingsResultDto
     */
    'global'?: ChatUserSettingsDto;
    /**
     * 
     * @type {ChatUserSettingsDto}
     * @memberof GetChatUserSettingsResultDto
     */
    'chat'?: ChatUserSettingsDto;
}
/**
 * 
 * @export
 * @interface GetOrCreateCommentChatDto
 */
export interface GetOrCreateCommentChatDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetOrCreateCommentChatDto
     */
    'isOnBehalfOfUser'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrCreateCommentChatDto
     */
    'isAutoJoin'?: boolean | null;
    /**
     * 
     * @type {GeneralScopeRequestDto}
     * @memberof GetOrCreateCommentChatDto
     */
    'scope'?: GeneralScopeRequestDto;
    /**
     * 
     * @type {string}
     * @memberof GetOrCreateCommentChatDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrCreateCommentChatDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GlobalSearchCategory = {
    All: 'All',
    Vehicles: 'Vehicles',
    Contracts: 'Contracts',
    Documents: 'Documents',
    VisualInspections: 'VisualInspections',
    DamageDetections: 'DamageDetections',
    DamageDetectionAggregates: 'DamageDetectionAggregates',
    AccessoryChecks: 'AccessoryChecks',
    Invoices: 'Invoices',
    Assets: 'Assets',
    Customers: 'Customers',
    AssessmentFlows: 'AssessmentFlows',
    DamageCostEvaluations: 'DamageCostEvaluations',
    DamageCostEvaluationAggregates: 'DamageCostEvaluationAggregates',
    RepairOperations: 'RepairOperations',
    Departments: 'Departments',
    Locations: 'Locations',
    Spots: 'Spots',
    ProductLocations: 'ProductLocations',
    Pools: 'Pools',
    AssetSubscriptionPlans: 'AssetSubscriptionPlans',
    AssetSubscriptions: 'AssetSubscriptions',
    TenantRequests: 'TenantRequests'
} as const;

export type GlobalSearchCategory = typeof GlobalSearchCategory[keyof typeof GlobalSearchCategory];


/**
 * 
 * @export
 * @interface GlobalSearchResultDto
 */
export interface GlobalSearchResultDto {
    /**
     * 
     * @type {GlobalSearchCategory}
     * @memberof GlobalSearchResultDto
     */
    'category'?: GlobalSearchCategory;
    /**
     * 
     * @type {PaginationDtoOfVehicleDto}
     * @memberof GlobalSearchResultDto
     */
    'vehicles'?: PaginationDtoOfVehicleDto;
    /**
     * 
     * @type {PaginationDtoOfContractDto}
     * @memberof GlobalSearchResultDto
     */
    'contracts'?: PaginationDtoOfContractDto;
    /**
     * 
     * @type {PaginationDtoOfDocumentDto}
     * @memberof GlobalSearchResultDto
     */
    'documents'?: PaginationDtoOfDocumentDto;
    /**
     * 
     * @type {PaginationDtoOfVisualInspectionDto}
     * @memberof GlobalSearchResultDto
     */
    'visualInspections'?: PaginationDtoOfVisualInspectionDto;
    /**
     * 
     * @type {PaginationDtoOfDamageDetectionDto}
     * @memberof GlobalSearchResultDto
     */
    'damageDetections'?: PaginationDtoOfDamageDetectionDto;
    /**
     * 
     * @type {PaginationDtoOfDamageDetectionAggregateDto}
     * @memberof GlobalSearchResultDto
     */
    'damageDetectionAggregates'?: PaginationDtoOfDamageDetectionAggregateDto;
    /**
     * 
     * @type {PaginationDtoOfAccessoryCheckDto}
     * @memberof GlobalSearchResultDto
     */
    'accessoryChecks'?: PaginationDtoOfAccessoryCheckDto;
    /**
     * 
     * @type {PaginationDtoOfInvoiceDto}
     * @memberof GlobalSearchResultDto
     */
    'invoices'?: PaginationDtoOfInvoiceDto;
    /**
     * 
     * @type {PaginationDtoOfAssetDto}
     * @memberof GlobalSearchResultDto
     */
    'assets'?: PaginationDtoOfAssetDto;
    /**
     * 
     * @type {PaginationDtoOfCustomerDto}
     * @memberof GlobalSearchResultDto
     */
    'customers'?: PaginationDtoOfCustomerDto;
    /**
     * 
     * @type {PaginationDtoOfAssessmentFlowDto}
     * @memberof GlobalSearchResultDto
     */
    'assessmentFlows'?: PaginationDtoOfAssessmentFlowDto;
    /**
     * 
     * @type {PaginationDtoOfDamageCostEvaluationDto}
     * @memberof GlobalSearchResultDto
     */
    'damageCostEvaluations'?: PaginationDtoOfDamageCostEvaluationDto;
    /**
     * 
     * @type {PaginationDtoOfDamageCostEvaluationAggregateDto}
     * @memberof GlobalSearchResultDto
     */
    'damageCostEvaluationAggregates'?: PaginationDtoOfDamageCostEvaluationAggregateDto;
    /**
     * 
     * @type {PaginationDtoOfRepairOperationDto}
     * @memberof GlobalSearchResultDto
     */
    'repairOperations'?: PaginationDtoOfRepairOperationDto;
    /**
     * 
     * @type {PaginationDtoOfDepartmentDto}
     * @memberof GlobalSearchResultDto
     */
    'departments'?: PaginationDtoOfDepartmentDto;
    /**
     * 
     * @type {PaginationDtoOfLocationDto}
     * @memberof GlobalSearchResultDto
     */
    'locations'?: PaginationDtoOfLocationDto;
    /**
     * 
     * @type {PaginationDtoOfSpotDto}
     * @memberof GlobalSearchResultDto
     */
    'spots'?: PaginationDtoOfSpotDto;
    /**
     * 
     * @type {PaginationDtoOfProductLocationDto}
     * @memberof GlobalSearchResultDto
     */
    'productLocations'?: PaginationDtoOfProductLocationDto;
    /**
     * 
     * @type {PaginationDtoOfPoolDto}
     * @memberof GlobalSearchResultDto
     */
    'pools'?: PaginationDtoOfPoolDto;
    /**
     * 
     * @type {PaginationDtoOfAssetSubscriptionPlanDto}
     * @memberof GlobalSearchResultDto
     */
    'assetSubscriptionPlans'?: PaginationDtoOfAssetSubscriptionPlanDto;
    /**
     * 
     * @type {PaginationDtoOfAssetSubscriptionDto}
     * @memberof GlobalSearchResultDto
     */
    'assetSubscriptions'?: PaginationDtoOfAssetSubscriptionDto;
    /**
     * 
     * @type {PaginationDtoOfTenantRequestDto}
     * @memberof GlobalSearchResultDto
     */
    'tenantRequests'?: PaginationDtoOfTenantRequestDto;
    /**
     * 
     * @type {number}
     * @memberof GlobalSearchResultDto
     */
    'totalReturnedCount'?: number;
}


/**
 * See:  - HashAlgorithmType  - HashAlgorithmName
 * @export
 * @enum {string}
 */

export const HashAlgorithmType = {
    None: 'None',
    Md5: 'MD5',
    Sha1: 'SHA1',
    Sha256: 'SHA256',
    Sha384: 'SHA384',
    Sha512: 'SHA512'
} as const;

export type HashAlgorithmType = typeof HashAlgorithmType[keyof typeof HashAlgorithmType];


/**
 * Denotes entity from which Asset can be created.  NB: Mongo Entity mappings must be configured manually for each entity.
 * @export
 * @interface IAssetSourceEntityDto
 */
export interface IAssetSourceEntityDto {
    /**
     * 
     * @type {AssetMetaDto}
     * @memberof IAssetSourceEntityDto
     */
    'assetMeta'?: AssetMetaDto;
}
/**
 * 
 * @export
 * @interface IEntityChangedDto
 */
export interface IEntityChangedDto {
    /**
     * Optional list of connection ids of client/clients that initiated this server to client SignalR method call.
     * @type {Array<string>}
     * @memberof IEntityChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * SignalR group name to which server sends the message.
     * @type {string}
     * @memberof IEntityChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof IEntityChangedDto
     */
    'changeType'?: EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof IEntityChangedDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {string}
     * @memberof IEntityChangedDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof IEntityChangedDto
     */
    'tenantId'?: string | null;
}


/**
 * 
 * @export
 * @interface IGeneralDeferredValueDto
 */
export interface IGeneralDeferredValueDto {
    /**
     * 
     * @type {GeneralDeferredValueStatus}
     * @memberof IGeneralDeferredValueDto
     */
    'status'?: GeneralDeferredValueStatus;
    /**
     * 
     * @type {string}
     * @memberof IGeneralDeferredValueDto
     */
    'displayError'?: string | null;
}


/**
 * <inheritdoc cref=\"T:Domain.Interfaces.IHasGlobalNumber\" />
 * @export
 * @interface IHasGlobalNumberDto
 */
export interface IHasGlobalNumberDto {
    /**
     * Number unique across the whole system.
     * @type {string}
     * @memberof IHasGlobalNumberDto
     */
    'globalNumber'?: string;
}
/**
 * <inheritdoc cref=\"T:Domain.Interfaces.IHasLocalNumber\" />
 * @export
 * @interface IHasLocalNumberDto
 */
export interface IHasLocalNumberDto {
    /**
     * Number unique across a tenant.
     * @type {string}
     * @memberof IHasLocalNumberDto
     */
    'localNumber'?: string;
}
/**
 * Describes entity which might have DataGrants.
 * @export
 * @interface IMightHaveDataGrantsBriefDto
 */
export interface IMightHaveDataGrantsBriefDto {
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof IMightHaveDataGrantsBriefDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
}
/**
 * Describes entity which might have DataGrants.
 * @export
 * @interface IMightHaveDataGrantsDto
 */
export interface IMightHaveDataGrantsDto {
    /**
     * 
     * @type {DataGrantsMetaDto}
     * @memberof IMightHaveDataGrantsDto
     */
    'grantsMeta'?: DataGrantsMetaDto;
}
/**
 * Entity with department affiliation.  NB: Mongo Entity mappings must be configured manually for each entity.
 * @export
 * @interface IMightHaveDepartmentsDto
 */
export interface IMightHaveDepartmentsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof IMightHaveDepartmentsDto
     */
    'departmentIds'?: Array<string> | null;
}
/**
 * Describes entity which was imported.
 * @export
 * @interface IMightHaveImportMetaDto
 */
export interface IMightHaveImportMetaDto {
    /**
     * 
     * @type {ImportMetaDto}
     * @memberof IMightHaveImportMetaDto
     */
    'importMeta'?: ImportMetaDto;
}
/**
 * Entity with location affiliation.  NB: Mongo Entity mappings must be configured manually for each entity.
 * @export
 * @interface IMightHaveLocationsDto
 */
export interface IMightHaveLocationsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof IMightHaveLocationsDto
     */
    'locationIds'?: Array<string> | null;
}
/**
 * <inheritdoc cref=\"T:Domain.Interfaces.IMightHaveOrigin\" />
 * @export
 * @interface IMightHaveOriginDto
 */
export interface IMightHaveOriginDto {
    /**
     * 
     * @type {EntityOriginType}
     * @memberof IMightHaveOriginDto
     */
    'originType'?: EntityOriginType;
}


/**
 * Denotes entity that can belong to pools.  NB: Mongo Entity mappings must be configured manually for each entity.
 * @export
 * @interface IMightHavePoolsDto
 */
export interface IMightHavePoolsDto {
    /**
     * 
     * @type {PoolsMetaDto}
     * @memberof IMightHavePoolsDto
     */
    'poolsMeta'?: PoolsMetaDto;
}
/**
 * Describes entity with attached tags.
 * @export
 * @interface IMightHaveTagsDto
 */
export interface IMightHaveTagsDto {
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof IMightHaveTagsDto
     */
    'tags'?: GeneralAttachedTagsDto;
}
/**
 * NB: Mongo Entity mappings must be configured manually for each entity.
 * @export
 * @interface IMightHaveTenantDto
 */
export interface IMightHaveTenantDto {
    /**
     * 
     * @type {string}
     * @memberof IMightHaveTenantDto
     */
    'tenantId'?: string | null;
}
/**
 * Denotes entity that can belong to many TenantRequests.  NB: Mongo Entity mappings must be configured manually for each entity.
 * @export
 * @interface IMightHaveTenantRequestsDto
 */
export interface IMightHaveTenantRequestsDto {
    /**
     * 
     * @type {TenantRequestsMetaDto}
     * @memberof IMightHaveTenantRequestsDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaDto;
}
/**
 * 
 * @export
 * @interface IMightHaveUnseenInfoDto
 */
export interface IMightHaveUnseenInfoDto {
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof IMightHaveUnseenInfoDto
     */
    'myUnseen'?: UserUnseenInfoDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ImageQuality = {
    None: 'None',
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    VeryHigh: 'VeryHigh',
    Original: 'Original'
} as const;

export type ImageQuality = typeof ImageQuality[keyof typeof ImageQuality];


/**
 * 
 * @export
 * @interface ImportDto
 */
export interface ImportDto {
    /**
     * 
     * @type {string}
     * @memberof ImportDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {ImportStage}
     * @memberof ImportDto
     */
    'stage'?: ImportStage;
    /**
     * 
     * @type {ImportType}
     * @memberof ImportDto
     */
    'type'?: ImportType;
    /**
     * 
     * @type {GeneralAttachmentDto}
     * @memberof ImportDto
     */
    'attachment'?: GeneralAttachmentDto;
    /**
     * 
     * @type {TabularFileMetadataDto}
     * @memberof ImportDto
     */
    'fileMetadata'?: TabularFileMetadataDto;
    /**
     * 
     * @type {ImportMappingDto}
     * @memberof ImportDto
     */
    'mapping'?: ImportMappingDto;
    /**
     * 
     * @type {ImportResultDto}
     * @memberof ImportDto
     */
    'result'?: ImportResultDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ImportDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ImportDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportDto
     */
    'updatedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface ImportFieldFailureDto
 */
export interface ImportFieldFailureDto {
    /**
     * 
     * @type {string}
     * @memberof ImportFieldFailureDto
     */
    'field'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportFieldFailureDto
     */
    'column'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportFieldFailureDto
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ImportFromCatalogDto
 */
export interface ImportFromCatalogDto {
    /**
     * 
     * @type {string}
     * @memberof ImportFromCatalogDto
     */
    'sourceCatalogId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportFromCatalogDto
     */
    'targetCatalogId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportFromCatalogDto
     */
    'isImportAll'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportFromCatalogDto
     */
    'isImportAllMaterials'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportFromCatalogDto
     */
    'isImportAllWork'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportFromCatalogDto
     */
    'isImportAllSpecs'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportFromCatalogDto
     */
    'materialIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportFromCatalogDto
     */
    'workIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportFromCatalogDto
     */
    'specIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ImportFromCatalogInfoDto
 */
export interface ImportFromCatalogInfoDto {
    /**
     * 
     * @type {RepairCatalogDto}
     * @memberof ImportFromCatalogInfoDto
     */
    'sourceCatalog'?: RepairCatalogDto;
    /**
     * 
     * @type {RepairCatalogDto}
     * @memberof ImportFromCatalogInfoDto
     */
    'targetCatalog'?: RepairCatalogDto;
    /**
     * 
     * @type {Array<RepairMaterialDto>}
     * @memberof ImportFromCatalogInfoDto
     */
    'materials'?: Array<RepairMaterialDto>;
    /**
     * 
     * @type {Array<RepairWorkDto>}
     * @memberof ImportFromCatalogInfoDto
     */
    'work'?: Array<RepairWorkDto>;
    /**
     * 
     * @type {Array<RepairSpecDto>}
     * @memberof ImportFromCatalogInfoDto
     */
    'specs'?: Array<RepairSpecDto>;
}
/**
 * 
 * @export
 * @interface ImportGetPaginatedDto
 */
export interface ImportGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof ImportGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof ImportGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof ImportGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof ImportGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
}
/**
 * 
 * @export
 * @interface ImportMappingDto
 */
export interface ImportMappingDto {
    /**
     * Definition of mapping
     * @type {Array<ImportMappingItemDto>}
     * @memberof ImportMappingDto
     */
    'items'?: Array<ImportMappingItemDto>;
}
/**
 * 
 * @export
 * @interface ImportMappingItemDto
 */
export interface ImportMappingItemDto {
    /**
     * 
     * @type {string}
     * @memberof ImportMappingItemDto
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportMappingItemDto
     */
    'target'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportMappingItemDto
     */
    'defaultValue'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ImportMappingItemDto
     */
    'isIgnored'?: boolean;
}
/**
 * 
 * @export
 * @interface ImportMappingItemInputDto
 */
export interface ImportMappingItemInputDto {
    /**
     * 
     * @type {string}
     * @memberof ImportMappingItemInputDto
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportMappingItemInputDto
     */
    'target'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportMappingItemInputDto
     */
    'defaultValue'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ImportMappingItemInputDto
     */
    'isIgnored'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportMappingItemInputDto
     */
    'isConfirmed'?: boolean;
}
/**
 * 
 * @export
 * @interface ImportMetaDto
 */
export interface ImportMetaDto {
    /**
     * 
     * @type {string}
     * @memberof ImportMetaDto
     */
    'importId'?: string;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof ImportMetaDto
     */
    'changeType'?: EntityChangeType;
}


/**
 * 
 * @export
 * @interface ImportModelFieldSpecDto
 */
export interface ImportModelFieldSpecDto {
    /**
     * 
     * @type {string}
     * @memberof ImportModelFieldSpecDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportModelFieldSpecDto
     */
    'isRequired'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportModelFieldSpecDto
     */
    'allowUserEnteredDefaultValue'?: boolean;
}
/**
 * 
 * @export
 * @interface ImportModelResultDto
 */
export interface ImportModelResultDto {
    /**
     * 
     * @type {number}
     * @memberof ImportModelResultDto
     */
    'index': number;
    /**
     * 
     * @type {ImportModelResultStatus}
     * @memberof ImportModelResultDto
     */
    'status'?: ImportModelResultStatus;
    /**
     * 
     * @type {ImportModelResultPayloadDto}
     * @memberof ImportModelResultDto
     */
    'payload'?: ImportModelResultPayloadDto;
    /**
     * 
     * @type {Array<ImportModelResultDto>}
     * @memberof ImportModelResultDto
     */
    'subResults'?: Array<ImportModelResultDto>;
    /**
     * 
     * @type {string}
     * @memberof ImportModelResultDto
     */
    'failure'?: string | null;
    /**
     * 
     * @type {Array<ImportFieldFailureDto>}
     * @memberof ImportModelResultDto
     */
    'fieldsFailures'?: Array<ImportFieldFailureDto>;
}


/**
 * 
 * @export
 * @interface ImportModelResultPayloadDto
 */
export interface ImportModelResultPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof ImportModelResultPayloadDto
     */
    'failure'?: string | null;
    /**
     * 
     * @type {Array<ImportFieldFailureDto>}
     * @memberof ImportModelResultPayloadDto
     */
    'fieldsFailures'?: Array<ImportFieldFailureDto>;
    /**
     * 
     * @type {AccessoryReferenceDto}
     * @memberof ImportModelResultPayloadDto
     */
    'accessory'?: AccessoryReferenceDto;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof ImportModelResultPayloadDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof ImportModelResultPayloadDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {CustomerReferenceDto}
     * @memberof ImportModelResultPayloadDto
     */
    'customer'?: CustomerReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof ImportModelResultPayloadDto
     */
    'entityId'?: string | null;
    /**
     * 
     * @type {EntityType}
     * @memberof ImportModelResultPayloadDto
     */
    'type'?: EntityType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ImportModelResultStatus = {
    None: 'None',
    Created: 'Created',
    Updated: 'Updated',
    Skipped: 'Skipped',
    Failed: 'Failed'
} as const;

export type ImportModelResultStatus = typeof ImportModelResultStatus[keyof typeof ImportModelResultStatus];


/**
 * 
 * @export
 * @interface ImportModelSpecDto
 */
export interface ImportModelSpecDto {
    /**
     * 
     * @type {ImportType}
     * @memberof ImportModelSpecDto
     */
    'type'?: ImportType;
    /**
     * 
     * @type {Array<ImportModelFieldSpecDto>}
     * @memberof ImportModelSpecDto
     */
    'fields'?: Array<ImportModelFieldSpecDto>;
}


/**
 * 
 * @export
 * @interface ImportResultDto
 */
export interface ImportResultDto {
    /**
     * 
     * @type {string}
     * @memberof ImportResultDto
     */
    'failure'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ImportResultDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {Array<ImportModelResultDto>}
     * @memberof ImportResultDto
     */
    'models'?: Array<ImportModelResultDto>;
    /**
     * 
     * @type {boolean}
     * @memberof ImportResultDto
     */
    'isSuccess'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ImportStage = {
    None: 'None',
    DataUploading: 'DataUploading',
    MappingConfiguration: 'MappingConfiguration',
    PreLaunchConfiguration: 'PreLaunchConfiguration',
    Processing: 'Processing',
    Completed: 'Completed',
    Failed: 'Failed'
} as const;

export type ImportStage = typeof ImportStage[keyof typeof ImportStage];


/**
 * 
 * @export
 * @interface ImportTemplateDto
 */
export interface ImportTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof ImportTemplateDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportTemplateDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportTemplateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportTemplateDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ImportTemplateDto
     */
    'name'?: string;
    /**
     * 
     * @type {ImportType}
     * @memberof ImportTemplateDto
     */
    'type'?: ImportType;
    /**
     * 
     * @type {Array<ImportMappingItemDto>}
     * @memberof ImportTemplateDto
     */
    'items'?: Array<ImportMappingItemDto>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ImportType = {
    None: 'None',
    Accessory: 'Accessory',
    Vehicle: 'Vehicle',
    Contract: 'Contract',
    Customer: 'Customer',
    GeneralAddress: 'GeneralAddress',
    CustomerContact: 'CustomerContact',
    ReadyForCheckInVehicles: 'ReadyForCheckInVehicles'
} as const;

export type ImportType = typeof ImportType[keyof typeof ImportType];


/**
 * 
 * @export
 * @interface InAppChannelInfoDto
 */
export interface InAppChannelInfoDto {
    /**
     * 
     * @type {string}
     * @memberof InAppChannelInfoDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof InAppChannelInfoDto
     */
    'body'?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof InAppChannelInfoDto
     */
    'data'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface InAppNotificationReceivedDto
 */
export interface InAppNotificationReceivedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof InAppNotificationReceivedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof InAppNotificationReceivedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {NotificationDto}
     * @memberof InAppNotificationReceivedDto
     */
    'notification'?: NotificationDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const InAppNotificationType = {
    None: 'None',
    CallToAction: 'CallToAction',
    DamageDetectionCreated: 'DamageDetectionCreated',
    DamageCostEvaluationStarted: 'DamageCostEvaluationStarted',
    DamageCostEvaluationCompleted: 'DamageCostEvaluationCompleted',
    DamageCostEvaluationAggregateUpdated: 'DamageCostEvaluationAggregateUpdated',
    AccessoryCheckCreated: 'AccessoryCheckCreated',
    ChatResolved: 'ChatResolved',
    ChatReopened: 'ChatReopened',
    ChatAcknowledged: 'ChatAcknowledged',
    ChatParticipantAdded: 'ChatParticipantAdded',
    ChatParticipantRemoved: 'ChatParticipantRemoved',
    ChatParticipantMentioned: 'ChatParticipantMentioned',
    ChatMessageAcknowledged: 'ChatMessageAcknowledged',
    ChatNegotiationProposalCreated: 'ChatNegotiationProposalCreated',
    ChatNegotiationProposalResponseGiven: 'ChatNegotiationProposalResponseGiven',
    UserTaggedInEntity: 'UserTaggedInEntity'
} as const;

export type InAppNotificationType = typeof InAppNotificationType[keyof typeof InAppNotificationType];


/**
 * 
 * @export
 * @interface IncomingCountersDtoInDataGrantCountersDto
 */
export interface IncomingCountersDtoInDataGrantCountersDto {
    /**
     * 
     * @type {number}
     * @memberof IncomingCountersDtoInDataGrantCountersDto
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface IncomingCountersDtoInTenantConnectionRequestCountersDto
 */
export interface IncomingCountersDtoInTenantConnectionRequestCountersDto {
    /**
     * 
     * @type {number}
     * @memberof IncomingCountersDtoInTenantConnectionRequestCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof IncomingCountersDtoInTenantConnectionRequestCountersDto
     */
    'pendingCount': number;
    /**
     * 
     * @type {number}
     * @memberof IncomingCountersDtoInTenantConnectionRequestCountersDto
     */
    'acceptedCount': number;
    /**
     * 
     * @type {number}
     * @memberof IncomingCountersDtoInTenantConnectionRequestCountersDto
     */
    'declinedCount': number;
    /**
     * 
     * @type {number}
     * @memberof IncomingCountersDtoInTenantConnectionRequestCountersDto
     */
    'notRespondedCount': number;
    /**
     * 
     * @type {number}
     * @memberof IncomingCountersDtoInTenantConnectionRequestCountersDto
     */
    'revokedCount': number;
}
/**
 * 
 * @export
 * @interface IntegrationApiClientChangedDto
 */
export interface IntegrationApiClientChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof IntegrationApiClientChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof IntegrationApiClientChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof IntegrationApiClientChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {IntegrationApiClientDto}
     * @memberof IntegrationApiClientChangedDto
     */
    'entity': IntegrationApiClientDto;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface IntegrationApiClientCreateDto
 */
export interface IntegrationApiClientCreateDto {
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientCreateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientCreateDto
     */
    'description'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof IntegrationApiClientCreateDto
     */
    'expiresAt'?: string | null;
}
/**
 * 
 * @export
 * @interface IntegrationApiClientDto
 */
export interface IntegrationApiClientDto {
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientDto
     */
    'localNumber'?: string | null;
    /**
     * 
     * @type {IntegrationApiScopeDto}
     * @memberof IntegrationApiClientDto
     */
    'scope'?: IntegrationApiScopeDto;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientDto
     */
    'description'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof IntegrationApiClientDto
     */
    'expiresAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof IntegrationApiClientDto
     */
    'expiredAt'?: string | null;
    /**
     * 
     * @type {Array<IntegrationApiClientKeyDto>}
     * @memberof IntegrationApiClientDto
     */
    'keys'?: Array<IntegrationApiClientKeyDto>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof IntegrationApiClientDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof IntegrationApiClientDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientDto
     */
    'updatedBy'?: string | null;
}
/**
 * 
 * @export
 * @interface IntegrationApiClientGetPaginatedDto
 */
export interface IntegrationApiClientGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof IntegrationApiClientGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationApiClientGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof IntegrationApiClientGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof IntegrationApiClientGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof IntegrationApiClientGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof IntegrationApiClientGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof IntegrationApiClientGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof IntegrationApiClientGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {IntegrationApiScopeType}
     * @memberof IntegrationApiClientGetPaginatedDto
     */
    'scopeType'?: IntegrationApiScopeType;
}


/**
 * 
 * @export
 * @interface IntegrationApiClientKeyDto
 */
export interface IntegrationApiClientKeyDto {
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientKeyDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientKeyDto
     */
    'name'?: string;
    /**
     * 
     * @type {IntegrationApiKeyStatus}
     * @memberof IntegrationApiClientKeyDto
     */
    'status'?: IntegrationApiKeyStatus;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof IntegrationApiClientKeyDto
     */
    'expiresAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof IntegrationApiClientKeyDto
     */
    'activeAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof IntegrationApiClientKeyDto
     */
    'revokedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof IntegrationApiClientKeyDto
     */
    'expiredAt'?: string | null;
}


/**
 * 
 * @export
 * @interface IntegrationApiClientKeyInputDto
 */
export interface IntegrationApiClientKeyInputDto {
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientKeyInputDto
     */
    'name'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof IntegrationApiClientKeyInputDto
     */
    'expiresAt'?: string | null;
}
/**
 * 
 * @export
 * @interface IntegrationApiClientKeyValueDto
 */
export interface IntegrationApiClientKeyValueDto {
    /**
     * 
     * @type {IntegrationApiClientKeyDto}
     * @memberof IntegrationApiClientKeyValueDto
     */
    'key'?: IntegrationApiClientKeyDto;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientKeyValueDto
     */
    'keyValue'?: string;
}
/**
 * 
 * @export
 * @interface IntegrationApiClientReferenceDto
 */
export interface IntegrationApiClientReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientReferenceDto
     */
    'localNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface IntegrationApiClientSearchPaginatedDto
 */
export interface IntegrationApiClientSearchPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof IntegrationApiClientSearchPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationApiClientSearchPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientSearchPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof IntegrationApiClientSearchPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof IntegrationApiClientSearchPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof IntegrationApiClientSearchPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof IntegrationApiClientSearchPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof IntegrationApiClientSearchPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof IntegrationApiClientSearchPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {IntegrationApiScopeType}
     * @memberof IntegrationApiClientSearchPaginatedDto
     */
    'scopeType'?: IntegrationApiScopeType;
}


/**
 * 
 * @export
 * @interface IntegrationApiClientUpdateDto
 */
export interface IntegrationApiClientUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientUpdateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientUpdateDto
     */
    'description'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof IntegrationApiClientUpdateDto
     */
    'expiresAt'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IntegrationApiKeyStatus = {
    None: 'None',
    Active: 'Active',
    Revoked: 'Revoked',
    Expired: 'Expired'
} as const;

export type IntegrationApiKeyStatus = typeof IntegrationApiKeyStatus[keyof typeof IntegrationApiKeyStatus];


/**
 * 
 * @export
 * @interface IntegrationApiScopeDto
 */
export interface IntegrationApiScopeDto {
    /**
     * 
     * @type {IntegrationApiScopeType}
     * @memberof IntegrationApiScopeDto
     */
    'type'?: IntegrationApiScopeType;
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiScopeDto
     */
    'tenantId'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IntegrationApiScopeType = {
    None: 'None',
    Global: 'Global',
    Tenant: 'Tenant',
    Combined: 'Combined'
} as const;

export type IntegrationApiScopeType = typeof IntegrationApiScopeType[keyof typeof IntegrationApiScopeType];


/**
 * 
 * @export
 * @interface InviteAnonymousUserDto
 */
export interface InviteAnonymousUserDto {
    /**
     * 
     * @type {string}
     * @memberof InviteAnonymousUserDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InviteAnonymousUserDto
     */
    'locationId'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof InviteAnonymousUserDto
     */
    'lifetime'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InviteAnonymousUserDto
     */
    'roleIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface InviteAnonymousUserResultDto
 */
export interface InviteAnonymousUserResultDto {
    /**
     * 
     * @type {string}
     * @memberof InviteAnonymousUserResultDto
     */
    'inviteUrl'?: string;
}
/**
 * 
 * @export
 * @interface InviteChangedDto
 */
export interface InviteChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof InviteChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof InviteChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof InviteChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof InviteChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof InviteChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {InviteDto}
     * @memberof InviteChangedDto
     */
    'entity': InviteDto;
    /**
     * 
     * @type {string}
     * @memberof InviteChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface InviteCheckUserExistsDto
 */
export interface InviteCheckUserExistsDto {
    /**
     * 
     * @type {string}
     * @memberof InviteCheckUserExistsDto
     */
    'inviteId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteCheckUserExistsDto
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface InviteDto
 */
export interface InviteDto {
    /**
     * 
     * @type {string}
     * @memberof InviteDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {InviteType}
     * @memberof InviteDto
     */
    'type'?: InviteType;
    /**
     * 
     * @type {InviteUserType}
     * @memberof InviteDto
     */
    'userType'?: InviteUserType;
    /**
     * 
     * @type {InviteUserInfo}
     * @memberof InviteDto
     */
    'userInfo'?: InviteUserInfo;
    /**
     * 
     * @type {string}
     * @memberof InviteDto
     */
    'redirectUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InviteDto
     */
    'isExpired'?: boolean;
    /**
     * 
     * @type {InviteTenantDto}
     * @memberof InviteDto
     */
    'tenant'?: InviteTenantDto;
    /**
     * 
     * @type {boolean}
     * @memberof InviteDto
     */
    'isIAlreadyAnswered'?: boolean | null;
}


/**
 * 
 * @export
 * @interface InviteTenantDto
 */
export interface InviteTenantDto {
    /**
     * 
     * @type {string}
     * @memberof InviteTenantDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteTenantDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteTenantDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const InviteType = {
    None: 'None',
    Personal: 'Personal',
    Anonymous: 'Anonymous'
} as const;

export type InviteType = typeof InviteType[keyof typeof InviteType];


/**
 * 
 * @export
 * @interface InviteUserDto
 */
export interface InviteUserDto {
    /**
     * 
     * @type {string}
     * @memberof InviteUserDto
     */
    'email'?: string;
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof InviteUserDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof InviteUserDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteUserDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InviteUserDto
     */
    'locationId'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof InviteUserDto
     */
    'lifetime'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InviteUserDto
     */
    'roleIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof InviteUserDto
     */
    'isInviteExistingUser'?: boolean;
}
/**
 * 
 * @export
 * @interface InviteUserExistsDto
 */
export interface InviteUserExistsDto {
    /**
     * 
     * @type {boolean}
     * @memberof InviteUserExistsDto
     */
    'exists'?: boolean;
}
/**
 * 
 * @export
 * @interface InviteUserInfo
 */
export interface InviteUserInfo {
    /**
     * 
     * @type {GeneralPersonName}
     * @memberof InviteUserInfo
     */
    'personName'?: GeneralPersonName;
    /**
     * 
     * @type {string}
     * @memberof InviteUserInfo
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteUserInfo
     */
    'phoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface InviteUserInfoDto
 */
export interface InviteUserInfoDto {
    /**
     * 
     * @type {string}
     * @memberof InviteUserInfoDto
     */
    'email'?: string;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof InviteUserInfoDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof InviteUserInfoDto
     */
    'phoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const InviteUserType = {
    None: 'None',
    Tenant: 'Tenant',
    Customer: 'Customer'
} as const;

export type InviteUserType = typeof InviteUserType[keyof typeof InviteUserType];


/**
 * 
 * @export
 * @interface InvoiceBusinessInfoDto
 */
export interface InvoiceBusinessInfoDto {
    /**
     * 
     * @type {string}
     * @memberof InvoiceBusinessInfoDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceBusinessInfoDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceBusinessInfoDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceBusinessInfoDto
     */
    'webSiteUrl'?: string | null;
    /**
     * 
     * @type {GeneralAddressDto}
     * @memberof InvoiceBusinessInfoDto
     */
    'address'?: GeneralAddressDto;
}
/**
 * 
 * @export
 * @interface InvoiceChangedDto
 */
export interface InvoiceChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof InvoiceChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof InvoiceChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof InvoiceChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof InvoiceChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {InvoiceDto}
     * @memberof InvoiceChangedDto
     */
    'entity': InvoiceDto;
    /**
     * 
     * @type {string}
     * @memberof InvoiceChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface InvoiceCustomerBusinessInfoDto
 */
export interface InvoiceCustomerBusinessInfoDto {
    /**
     * 
     * @type {string}
     * @memberof InvoiceCustomerBusinessInfoDto
     */
    'businessName'?: string;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof InvoiceCustomerBusinessInfoDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof InvoiceCustomerBusinessInfoDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceCustomerBusinessInfoDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {GeneralAddressDto}
     * @memberof InvoiceCustomerBusinessInfoDto
     */
    'address'?: GeneralAddressDto;
}
/**
 * 
 * @export
 * @interface InvoiceDto
 */
export interface InvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    'subscriptionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {InvoiceStatus}
     * @memberof InvoiceDto
     */
    'status'?: InvoiceStatus;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof InvoiceDto
     */
    'paymentMethod'?: PaymentMethod;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof InvoiceDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {InvoiceBusinessInfoDto}
     * @memberof InvoiceDto
     */
    'businessInfo'?: InvoiceBusinessInfoDto;
    /**
     * 
     * @type {InvoiceCustomerBusinessInfoDto}
     * @memberof InvoiceDto
     */
    'customerBusinessInfo'?: InvoiceCustomerBusinessInfoDto;
    /**
     * 
     * @type {Array<InvoiceLineItemDto>}
     * @memberof InvoiceDto
     */
    'lineItems'?: Array<InvoiceLineItemDto>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof InvoiceDto
     */
    'date'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof InvoiceDto
     */
    'dueAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof InvoiceDto
     */
    'sentAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof InvoiceDto
     */
    'pendingAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof InvoiceDto
     */
    'paidAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof InvoiceDto
     */
    'cancelledAt'?: string | null;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof InvoiceDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof InvoiceDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDto
     */
    'total'?: number;
}


/**
 * 
 * @export
 * @interface InvoiceGetPaginatedDto
 */
export interface InvoiceGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof InvoiceGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvoiceGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvoiceGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvoiceGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof InvoiceGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof InvoiceGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof InvoiceGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof InvoiceGetPaginatedDto
     */
    'subscriptionId'?: string | null;
    /**
     * 
     * @type {InvoiceStatus}
     * @memberof InvoiceGetPaginatedDto
     */
    'status'?: InvoiceStatus;
}


/**
 * 
 * @export
 * @interface InvoiceLineItemDto
 */
export interface InvoiceLineItemDto {
    /**
     * 
     * @type {string}
     * @memberof InvoiceLineItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLineItemDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceLineItemDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceLineItemDto
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLineItemDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof InvoiceLineItemDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof InvoiceLineItemDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof InvoiceLineItemDto
     */
    'subtotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceLineItemDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface InvoiceReferenceDto
 */
export interface InvoiceReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof InvoiceReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceReferenceDto
     */
    'subscriptionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const InvoiceStatus = {
    None: 'None',
    Draft: 'Draft',
    Pending: 'Pending',
    Paid: 'Paid',
    Overdue: 'Overdue',
    Cancelled: 'Cancelled'
} as const;

export type InvoiceStatus = typeof InvoiceStatus[keyof typeof InvoiceStatus];


/**
 * 
 * @export
 * @interface ItemDtoInDamageDetectionMigrateToNewVisualModelDto
 */
export interface ItemDtoInDamageDetectionMigrateToNewVisualModelDto {
    /**
     * 
     * @type {string}
     * @memberof ItemDtoInDamageDetectionMigrateToNewVisualModelDto
     */
    'id'?: string;
    /**
     * 
     * @type {GeneralSvgPointDto}
     * @memberof ItemDtoInDamageDetectionMigrateToNewVisualModelDto
     */
    'oldPoint'?: GeneralSvgPointDto;
    /**
     * 
     * @type {GeneralSvgPointDto}
     * @memberof ItemDtoInDamageDetectionMigrateToNewVisualModelDto
     */
    'newPoint'?: GeneralSvgPointDto;
}
/**
 * 
 * @export
 * @interface JoinChatDto
 */
export interface JoinChatDto {
    /**
     * 
     * @type {string}
     * @memberof JoinChatDto
     */
    'chatId'?: string;
}
/**
 * 
 * @export
 * @interface LaunchImportDto
 */
export interface LaunchImportDto {
    /**
     * Flag that indicates whether we should update entity it already exists
     * @type {boolean}
     * @memberof LaunchImportDto
     */
    'shouldUpdateEntityIfExists'?: boolean;
}
/**
 * 
 * @export
 * @interface LeaveChatDto
 */
export interface LeaveChatDto {
    /**
     * 
     * @type {string}
     * @memberof LeaveChatDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaveChatDto
     */
    'participantId'?: string;
}
/**
 * 
 * @export
 * @interface LocationChangedDto
 */
export interface LocationChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof LocationChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof LocationChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof LocationChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof LocationChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof LocationChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {LocationDto}
     * @memberof LocationChangedDto
     */
    'entity': LocationDto;
    /**
     * 
     * @type {string}
     * @memberof LocationChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface LocationDto
 */
export interface LocationDto {
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof LocationDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof LocationDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof LocationDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {DepartmentReferenceDto}
     * @memberof LocationDto
     */
    'department'?: DepartmentReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAddressDto}
     * @memberof LocationDto
     */
    'address'?: GeneralAddressDto;
    /**
     * 
     * @type {GeneralContactDto}
     * @memberof LocationDto
     */
    'contact'?: GeneralContactDto;
}


/**
 * 
 * @export
 * @interface LocationGetPaginatedDto
 */
export interface LocationGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof LocationGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof LocationGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LocationGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LocationGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LocationGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof LocationGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof LocationGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof LocationGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof LocationGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LocationGetPaginatedDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof LocationGetPaginatedDto
     */
    'notForDepartmentId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LocationGetPaginatedDto
     */
    'isWithDepartment'?: boolean | null;
}
/**
 * 
 * @export
 * @interface LocationReferenceDto
 */
export interface LocationReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof LocationReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LogoSizeType = {
    None: 'None',
    Logo32: 'Logo32',
    Logo48: 'Logo48',
    Logo128: 'Logo128',
    Logo250x50: 'Logo250x50'
} as const;

export type LogoSizeType = typeof LogoSizeType[keyof typeof LogoSizeType];


/**
 * 
 * @export
 * @interface MailchimpEmailSettingsDto
 */
export interface MailchimpEmailSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof MailchimpEmailSettingsDto
     */
    'from'?: string;
    /**
     * 
     * @type {UserSecretReferenceDto}
     * @memberof MailchimpEmailSettingsDto
     */
    'apiKey'?: UserSecretReferenceDto;
}
/**
 * 
 * @export
 * @interface MailchimpEmailSettingsInputDto
 */
export interface MailchimpEmailSettingsInputDto {
    /**
     * 
     * @type {string}
     * @memberof MailchimpEmailSettingsInputDto
     */
    'from'?: string;
    /**
     * 
     * @type {UserSecretInputDto}
     * @memberof MailchimpEmailSettingsInputDto
     */
    'apiKey'?: UserSecretInputDto;
}
/**
 * 
 * @export
 * @interface MailgunEmailSettingsDto
 */
export interface MailgunEmailSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof MailgunEmailSettingsDto
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailgunEmailSettingsDto
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailgunEmailSettingsDto
     */
    'region'?: string;
    /**
     * 
     * @type {UserSecretReferenceDto}
     * @memberof MailgunEmailSettingsDto
     */
    'apiKey'?: UserSecretReferenceDto;
}
/**
 * 
 * @export
 * @interface MailgunEmailSettingsInputDto
 */
export interface MailgunEmailSettingsInputDto {
    /**
     * 
     * @type {string}
     * @memberof MailgunEmailSettingsInputDto
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailgunEmailSettingsInputDto
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailgunEmailSettingsInputDto
     */
    'region'?: string;
    /**
     * 
     * @type {UserSecretInputDto}
     * @memberof MailgunEmailSettingsInputDto
     */
    'apiKey'?: UserSecretInputDto;
}
/**
 * 
 * @export
 * @interface MaintenanceChangedDto
 */
export interface MaintenanceChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof MaintenanceChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof MaintenanceChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof MaintenanceChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {MaintenanceDto}
     * @memberof MaintenanceChangedDto
     */
    'entity': MaintenanceDto;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface MaintenanceContentDto
 */
export interface MaintenanceContentDto {
    /**
     * 
     * @type {string}
     * @memberof MaintenanceContentDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof MaintenanceContentDto
     */
    'currency'?: GeneralCurrencyDto;
}
/**
 * 
 * @export
 * @interface MaintenanceContentInputDto
 */
export interface MaintenanceContentInputDto {
    /**
     * 
     * @type {string}
     * @memberof MaintenanceContentInputDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof MaintenanceContentInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
}
/**
 * 
 * @export
 * @interface MaintenanceCountersDto
 */
export interface MaintenanceCountersDto {
    /**
     * 
     * @type {string}
     * @memberof MaintenanceCountersDto
     */
    'version'?: string;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceCountersDto
     */
    'draftCount': number;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceCountersDto
     */
    'scheduledCount': number;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceCountersDto
     */
    'inProgressCount': number;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceCountersDto
     */
    'completedCount': number;
}
/**
 * 
 * @export
 * @interface MaintenanceDto
 */
export interface MaintenanceDto {
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof MaintenanceDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof MaintenanceDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof MaintenanceDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MaintenanceDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MaintenanceDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof MaintenanceDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {AssignmentReferenceDto}
     * @memberof MaintenanceDto
     */
    'assignment'?: AssignmentReferenceDto;
    /**
     * 
     * @type {SupplierReferenceDto}
     * @memberof MaintenanceDto
     */
    'supplier'?: SupplierReferenceDto;
    /**
     * 
     * @type {GeneralEntitySourceDto}
     * @memberof MaintenanceDto
     */
    'source'?: GeneralEntitySourceDto;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof MaintenanceDto
     */
    'mileage'?: VehicleMileageDto;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {MaintenanceScheduleType}
     * @memberof MaintenanceDto
     */
    'scheduleType'?: MaintenanceScheduleType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof MaintenanceDto
     */
    'scheduledAt'?: string | null;
    /**
     * 
     * @type {GeneralStageHistoryDtoOfMaintenanceStage}
     * @memberof MaintenanceDto
     */
    'stageHistory'?: GeneralStageHistoryDtoOfMaintenanceStage;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof MaintenanceDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof MaintenanceDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof MaintenanceDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof MaintenanceDto
     */
    'responsibleUser'?: GeneralByWhoDto;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof MaintenanceDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof MaintenanceDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof MaintenanceDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
    /**
     * 
     * @type {TenantRequestsMetaDto}
     * @memberof MaintenanceDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof MaintenanceDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDto
     */
    'total'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof MaintenanceDto
     */
    'draftAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof MaintenanceDto
     */
    'scheduledStageAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof MaintenanceDto
     */
    'inProgressAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof MaintenanceDto
     */
    'completedAt'?: string | null;
}


/**
 * 
 * @export
 * @interface MaintenanceGetPaginatedDto
 */
export interface MaintenanceGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof MaintenanceGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MaintenanceGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MaintenanceGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MaintenanceGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof MaintenanceGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof MaintenanceGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof MaintenanceGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof MaintenanceGetPaginatedDto
     */
    'id'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof MaintenanceGetPaginatedDto
     */
    'createdAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof MaintenanceGetPaginatedDto
     */
    'updatedAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof MaintenanceGetPaginatedDto
     */
    'createdBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof MaintenanceGetPaginatedDto
     */
    'updatedBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceGetPaginatedDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceGetPaginatedDto
     */
    'supplierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceGetPaginatedDto
     */
    'assignmentId'?: string | null;
    /**
     * 
     * @type {MaintenanceStage}
     * @memberof MaintenanceGetPaginatedDto
     */
    'stage'?: MaintenanceStage;
    /**
     * 
     * @type {MaintenanceScheduleType}
     * @memberof MaintenanceGetPaginatedDto
     */
    'scheduleType'?: MaintenanceScheduleType;
    /**
     * 
     * @type {TenantRequestsMetaQueryDto}
     * @memberof MaintenanceGetPaginatedDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof MaintenanceGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * 
 * @export
 * @interface MaintenanceReferenceDto
 */
export interface MaintenanceReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof MaintenanceReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceReferenceDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceReferenceDto
     */
    'supplierId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface MaintenanceResultDto
 */
export interface MaintenanceResultDto {
    /**
     * 
     * @type {string}
     * @memberof MaintenanceResultDto
     */
    'maintenanceId'?: string;
}
/**
 * 
 * @export
 * @interface MaintenanceResultInputDto
 */
export interface MaintenanceResultInputDto {
    /**
     * 
     * @type {string}
     * @memberof MaintenanceResultInputDto
     */
    'maintenanceId'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MaintenanceScheduleType = {
    None: 'None',
    Scheduled: 'Scheduled',
    Preventive: 'Preventive',
    Unscheduled: 'Unscheduled'
} as const;

export type MaintenanceScheduleType = typeof MaintenanceScheduleType[keyof typeof MaintenanceScheduleType];


/**
 * NB: use SortOrderAttribute to specify the order in which stages can be activated.
 * @export
 * @enum {string}
 */

export const MaintenanceStage = {
    None: 'None',
    Draft: 'Draft',
    Scheduled: 'Scheduled',
    InProgress: 'InProgress',
    Completed: 'Completed'
} as const;

export type MaintenanceStage = typeof MaintenanceStage[keyof typeof MaintenanceStage];


/**
 * 
 * @export
 * @interface MarkChatMessagesAsReadDto
 */
export interface MarkChatMessagesAsReadDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof MarkChatMessagesAsReadDto
     */
    'messageIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface MarkChatMessagesAsReadResultDto
 */
export interface MarkChatMessagesAsReadResultDto {
    /**
     * 
     * @type {string}
     * @memberof MarkChatMessagesAsReadResultDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MarkChatMessagesAsReadResultDto
     */
    'messageIds'?: Array<string>;
    /**
     * 
     * @type {ChatMessageReadByInfoDto}
     * @memberof MarkChatMessagesAsReadResultDto
     */
    'readByInfo'?: ChatMessageReadByInfoDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MeasurementSystemType = {
    None: 'None',
    Metric: 'Metric',
    Imperial: 'Imperial',
    UsCustomary: 'USCustomary'
} as const;

export type MeasurementSystemType = typeof MeasurementSystemType[keyof typeof MeasurementSystemType];


/**
 * 
 * @export
 * @enum {string}
 */

export const MeasurementUnit = {
    None: 'None',
    Hour: 'Hour',
    Period: 'Period',
    Liter: 'Liter',
    Piece: 'Piece',
    Gram: 'Gram',
    Millimeter: 'Millimeter'
} as const;

export type MeasurementUnit = typeof MeasurementUnit[keyof typeof MeasurementUnit];


/**
 * 
 * @export
 * @interface MileageChangedDataDto
 */
export interface MileageChangedDataDto {
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof MileageChangedDataDto
     */
    'oldMileage'?: VehicleMileageDto;
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof MileageChangedDataDto
     */
    'newMileage'?: VehicleMileageDto;
    /**
     * 
     * @type {string}
     * @memberof MileageChangedDataDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof MileageChangedDataDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MileageUnit = {
    None: 'None',
    Km: 'Km'
} as const;

export type MileageUnit = typeof MileageUnit[keyof typeof MileageUnit];


/**
 * Describes base type (or just type) of some MIME type.  Base type is a first part that goes before first slash:  \"type \"/\" [tree \".\"] subtype [\"+\" suffix]* [\";\" parameter]\".
 * @export
 * @enum {string}
 */

export const MimeBaseType = {
    None: 'None',
    Unknown: 'Unknown',
    Application: 'Application',
    Audio: 'Audio',
    Image: 'Image',
    Message: 'Message',
    Model: 'Model',
    Multipart: 'Multipart',
    Text: 'Text',
    Video: 'Video'
} as const;

export type MimeBaseType = typeof MimeBaseType[keyof typeof MimeBaseType];


/**
 * 
 * @export
 * @interface Ms365EmailSettingsDto
 */
export interface Ms365EmailSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof Ms365EmailSettingsDto
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ms365EmailSettingsDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ms365EmailSettingsDto
     */
    'clientId'?: string;
    /**
     * 
     * @type {UserSecretReferenceDto}
     * @memberof Ms365EmailSettingsDto
     */
    'clientSecret'?: UserSecretReferenceDto;
}
/**
 * 
 * @export
 * @interface Ms365EmailSettingsInputDto
 */
export interface Ms365EmailSettingsInputDto {
    /**
     * 
     * @type {string}
     * @memberof Ms365EmailSettingsInputDto
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ms365EmailSettingsInputDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ms365EmailSettingsInputDto
     */
    'clientId'?: string;
    /**
     * 
     * @type {UserSecretInputDto}
     * @memberof Ms365EmailSettingsInputDto
     */
    'clientSecret'?: UserSecretInputDto;
}
/**
 * 
 * @export
 * @interface NameSuggestionDtoInRepairSpecNameSuggestionsDto
 */
export interface NameSuggestionDtoInRepairSpecNameSuggestionsDto {
    /**
     * 
     * @type {string}
     * @memberof NameSuggestionDtoInRepairSpecNameSuggestionsDto
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NameSuggestionDtoInRepairSpecNameSuggestionsDto
     */
    'ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface NegotiationAllowedActionsDto
 */
export interface NegotiationAllowedActionsDto {
    /**
     * 
     * @type {string}
     * @memberof NegotiationAllowedActionsDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NegotiationAllowedActionsDto
     */
    'negotiationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationAllowedActionsDto
     */
    'canManageNegotiation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationAllowedActionsDto
     */
    'canManageProposal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationAllowedActionsDto
     */
    'canCreateNewProposal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationAllowedActionsDto
     */
    'canRespondOnProposal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationAllowedActionsDto
     */
    'canForceRespondOnProposal'?: boolean;
    /**
     * 
     * @type {Array<ApprovalResponseType>}
     * @memberof NegotiationAllowedActionsDto
     */
    'allowedProposalResponseTypes'?: Array<ApprovalResponseType>;
}
/**
 * 
 * @export
 * @interface NegotiationChangedDto
 */
export interface NegotiationChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof NegotiationChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof NegotiationChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof NegotiationChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof NegotiationChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof NegotiationChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {NegotiationDto}
     * @memberof NegotiationChangedDto
     */
    'entity': NegotiationDto;
    /**
     * 
     * @type {string}
     * @memberof NegotiationChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface NegotiationDto
 */
export interface NegotiationDto {
    /**
     * 
     * @type {string}
     * @memberof NegotiationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NegotiationDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NegotiationDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof NegotiationDto
     */
    'localNumber'?: string | null;
    /**
     * 
     * @type {Array<ChatReferenceDto>}
     * @memberof NegotiationDto
     */
    'chats'?: Array<ChatReferenceDto>;
    /**
     * 
     * @type {GeneralScopeDto}
     * @memberof NegotiationDto
     */
    'scope'?: GeneralScopeDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof NegotiationDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {string}
     * @memberof NegotiationDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NegotiationDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {NegotiationType}
     * @memberof NegotiationDto
     */
    'type'?: NegotiationType;
    /**
     * 
     * @type {NegotiationValueType}
     * @memberof NegotiationDto
     */
    'valueType'?: NegotiationValueType;
    /**
     * 
     * @type {NegotiationStatus}
     * @memberof NegotiationDto
     */
    'status'?: NegotiationStatus;
    /**
     * 
     * @type {Array<PartyReferenceDto>}
     * @memberof NegotiationDto
     */
    'moderatorParties'?: Array<PartyReferenceDto>;
    /**
     * 
     * @type {PartyReferenceDto}
     * @memberof NegotiationDto
     */
    'initiatorParty'?: PartyReferenceDto;
    /**
     * 
     * @type {PartyReferenceDto}
     * @memberof NegotiationDto
     */
    'targetParty'?: PartyReferenceDto;
    /**
     * 
     * @type {NegotiationSettingsDto}
     * @memberof NegotiationDto
     */
    'settings'?: NegotiationSettingsDto;
    /**
     * 
     * @type {Array<NegotiationProposalDto>}
     * @memberof NegotiationDto
     */
    'proposals'?: Array<NegotiationProposalDto>;
    /**
     * 
     * @type {NegotiationResultDto}
     * @memberof NegotiationDto
     */
    'result'?: NegotiationResultDto;
}


/**
 * 
 * @export
 * @interface NegotiationGetPaginatedDto
 */
export interface NegotiationGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof NegotiationGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof NegotiationGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof NegotiationGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NegotiationGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NegotiationGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NegotiationGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof NegotiationGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof NegotiationGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof NegotiationGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof NegotiationGetPaginatedDto
     */
    'chatId'?: string | null;
    /**
     * 
     * @type {NegotiationType}
     * @memberof NegotiationGetPaginatedDto
     */
    'type'?: NegotiationType;
    /**
     * 
     * @type {NegotiationStatus}
     * @memberof NegotiationGetPaginatedDto
     */
    'status'?: NegotiationStatus;
}


/**
 * 
 * @export
 * @interface NegotiationProposalDto
 */
export interface NegotiationProposalDto {
    /**
     * 
     * @type {string}
     * @memberof NegotiationProposalDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NegotiationProposalDto
     */
    'negotiationId'?: string;
    /**
     * 
     * @type {GeneralScopeDto}
     * @memberof NegotiationProposalDto
     */
    'scope'?: GeneralScopeDto;
    /**
     * 
     * @type {PartyReferenceDto}
     * @memberof NegotiationProposalDto
     */
    'party'?: PartyReferenceDto;
    /**
     * 
     * @type {PartyMemberReferenceDto}
     * @memberof NegotiationProposalDto
     */
    'partyMember'?: PartyMemberReferenceDto;
    /**
     * 
     * @type {ChatParticipantReferenceDto}
     * @memberof NegotiationProposalDto
     */
    'participant'?: ChatParticipantReferenceDto;
    /**
     * 
     * @type {NegotiationProposalSettingsDto}
     * @memberof NegotiationProposalDto
     */
    'settings'?: NegotiationProposalSettingsDto;
    /**
     * 
     * @type {ProposalStatus}
     * @memberof NegotiationProposalDto
     */
    'status'?: ProposalStatus;
    /**
     * 
     * @type {ConsensusType}
     * @memberof NegotiationProposalDto
     */
    'consensusType'?: ConsensusType;
    /**
     * 
     * @type {ApprovalStatus}
     * @memberof NegotiationProposalDto
     */
    'approvalStatus'?: ApprovalStatus;
    /**
     * 
     * @type {string}
     * @memberof NegotiationProposalDto
     */
    'statement'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationProposalDto
     */
    'isInitial'?: boolean;
    /**
     * 
     * @type {NegotiationProposalValueDto}
     * @memberof NegotiationProposalDto
     */
    'value'?: NegotiationProposalValueDto;
    /**
     * 
     * @type {Array<NegotiationProposalResponseDto>}
     * @memberof NegotiationProposalDto
     */
    'responses'?: Array<NegotiationProposalResponseDto>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof NegotiationProposalDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof NegotiationProposalDto
     */
    'openedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof NegotiationProposalDto
     */
    'closedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationProposalDto
     */
    'isAnyOpenStatus'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationProposalDto
     */
    'isAnyClosedStatus'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationProposalDto
     */
    'isAnyConsensusType'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NegotiationProposalDto
     */
    'participantId'?: string | null;
}


/**
 * 
 * @export
 * @interface NegotiationProposalReferenceDto
 */
export interface NegotiationProposalReferenceDto {
    /**
     * 
     * @type {NegotiationReferenceDto}
     * @memberof NegotiationProposalReferenceDto
     */
    'negotiation'?: NegotiationReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof NegotiationProposalReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NegotiationProposalReferenceDto
     */
    'partyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NegotiationProposalReferenceDto
     */
    'statement'?: string;
}
/**
 * 
 * @export
 * @interface NegotiationProposalResponseDto
 */
export interface NegotiationProposalResponseDto {
    /**
     * 
     * @type {string}
     * @memberof NegotiationProposalResponseDto
     */
    'id'?: string;
    /**
     * 
     * @type {PartyReferenceDto}
     * @memberof NegotiationProposalResponseDto
     */
    'party'?: PartyReferenceDto;
    /**
     * 
     * @type {PartyMemberReferenceDto}
     * @memberof NegotiationProposalResponseDto
     */
    'partyMember'?: PartyMemberReferenceDto;
    /**
     * 
     * @type {ApprovalResponseType}
     * @memberof NegotiationProposalResponseDto
     */
    'responseType'?: ApprovalResponseType;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationProposalResponseDto
     */
    'isAuto'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof NegotiationProposalResponseDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof NegotiationProposalResponseDto
     */
    'updatedAt'?: string;
}


/**
 * 
 * @export
 * @interface NegotiationProposalSettingsDto
 */
export interface NegotiationProposalSettingsDto {
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationProposalSettingsDto
     */
    'allowChangeProposalResponse'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationProposalSettingsDto
     */
    'requireProposalConsensus'?: boolean;
}
/**
 * 
 * @export
 * @interface NegotiationProposalValueDto
 */
export interface NegotiationProposalValueDto {
    /**
     * 
     * @type {NegotiationValueType}
     * @memberof NegotiationProposalValueDto
     */
    'valueType'?: NegotiationValueType;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationProposalValueDto
     */
    'bool'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof NegotiationProposalValueDto
     */
    'string'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NegotiationProposalValueDto
     */
    'int32'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NegotiationProposalValueDto
     */
    'double'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NegotiationProposalValueDto
     */
    'decimal'?: number | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof NegotiationProposalValueDto
     */
    'dateTime'?: string | null;
    /**
     * 
     * @type {NegotiationProposalValuePriceDto}
     * @memberof NegotiationProposalValueDto
     */
    'price'?: NegotiationProposalValuePriceDto;
}


/**
 * 
 * @export
 * @interface NegotiationProposalValuePriceDto
 */
export interface NegotiationProposalValuePriceDto {
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof NegotiationProposalValuePriceDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {GeneralPriceDto}
     * @memberof NegotiationProposalValuePriceDto
     */
    'price'?: GeneralPriceDto;
    /**
     * 
     * @type {GeneralPriceDto}
     * @memberof NegotiationProposalValuePriceDto
     */
    'minPrice'?: GeneralPriceDto;
    /**
     * 
     * @type {GeneralPriceDto}
     * @memberof NegotiationProposalValuePriceDto
     */
    'maxPrice'?: GeneralPriceDto;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof NegotiationProposalValuePriceDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof NegotiationProposalValuePriceDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {NegotiationProposalValuePriceDto}
     * @memberof NegotiationProposalValuePriceDto
     */
    'initial'?: NegotiationProposalValuePriceDto;
    /**
     * 
     * @type {NegotiationProposalValuePriceDto}
     * @memberof NegotiationProposalValuePriceDto
     */
    'prev'?: NegotiationProposalValuePriceDto;
    /**
     * 
     * @type {number}
     * @memberof NegotiationProposalValuePriceDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof NegotiationProposalValuePriceDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof NegotiationProposalValuePriceDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface NegotiationReferenceDto
 */
export interface NegotiationReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof NegotiationReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {NegotiationType}
     * @memberof NegotiationReferenceDto
     */
    'type'?: NegotiationType;
    /**
     * 
     * @type {string}
     * @memberof NegotiationReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof NegotiationReferenceDto
     */
    'localNumber'?: string | null;
}


/**
 * 
 * @export
 * @interface NegotiationResultDto
 */
export interface NegotiationResultDto {
    /**
     * 
     * @type {ConsensusType}
     * @memberof NegotiationResultDto
     */
    'consensusType'?: ConsensusType;
    /**
     * 
     * @type {ApprovalStatus}
     * @memberof NegotiationResultDto
     */
    'approvalStatus'?: ApprovalStatus;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationResultDto
     */
    'isForced'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationResultDto
     */
    'isAuto'?: boolean;
    /**
     * 
     * @type {NegotiationProposalValueDto}
     * @memberof NegotiationResultDto
     */
    'value'?: NegotiationProposalValueDto;
}


/**
 * 
 * @export
 * @interface NegotiationSettingsDto
 */
export interface NegotiationSettingsDto {
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationSettingsDto
     */
    'allowCreateNewProposal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationSettingsDto
     */
    'requireProposalResolution'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationSettingsDto
     */
    'allowReopen'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationSettingsDto
     */
    'allowChangeProposalResponse'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NegotiationSettingsDto
     */
    'requireProposalConsensus'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof NegotiationSettingsDto
     */
    'deadlineAt'?: string | null;
    /**
     * 
     * @type {ApprovalResponseType}
     * @memberof NegotiationSettingsDto
     */
    'autoResponseTypeOnDeadline'?: ApprovalResponseType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof NegotiationSettingsDto
     */
    'deadlineHandledAt'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const NegotiationStatus = {
    None: 'None',
    Open: 'Open',
    Escalated: 'Escalated',
    Reopened: 'Reopened',
    Resolved: 'Resolved'
} as const;

export type NegotiationStatus = typeof NegotiationStatus[keyof typeof NegotiationStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const NegotiationType = {
    None: 'None',
    Approval: 'Approval',
    Value: 'Value'
} as const;

export type NegotiationType = typeof NegotiationType[keyof typeof NegotiationType];


/**
 * 
 * @export
 * @enum {string}
 */

export const NegotiationValueType = {
    None: 'None',
    Bool: 'Bool',
    String: 'String',
    Int32: 'Int32',
    Double: 'Double',
    Decimal: 'Decimal',
    DateTime: 'DateTime',
    Price: 'Price'
} as const;

export type NegotiationValueType = typeof NegotiationValueType[keyof typeof NegotiationValueType];


/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationChannel = {
    None: 'None',
    InApp: 'InApp',
    Email: 'Email',
    Sms: 'Sms',
    Push: 'Push',
    WebPush: 'WebPush'
} as const;

export type NotificationChannel = typeof NotificationChannel[keyof typeof NotificationChannel];


/**
 * Source: NotificationCountersModel
 * @export
 * @interface NotificationCountersDto
 */
export interface NotificationCountersDto {
    /**
     * 
     * @type {number}
     * @memberof NotificationCountersDto
     */
    'readCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NotificationCountersDto
     */
    'unreadCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NotificationCountersDto
     */
    'totalFilteredCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NotificationCountersDto
     */
    'totalCount'?: number | null;
}
/**
 * 
 * @export
 * @interface NotificationDeliveryError
 */
export interface NotificationDeliveryError {
    /**
     * 
     * @type {string}
     * @memberof NotificationDeliveryError
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDeliveryError
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationDeliveryStatus = {
    None: 'None',
    Pending: 'Pending',
    Sent: 'Sent',
    Delivered: 'Delivered',
    Failed: 'Failed'
} as const;

export type NotificationDeliveryStatus = typeof NotificationDeliveryStatus[keyof typeof NotificationDeliveryStatus];


/**
 * 
 * @export
 * @interface NotificationDto
 */
export interface NotificationDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {NotificationChannel}
     * @memberof NotificationDto
     */
    'channel'?: NotificationChannel;
    /**
     * 
     * @type {NotificationImportance}
     * @memberof NotificationDto
     */
    'importance'?: NotificationImportance;
    /**
     * 
     * @type {InAppChannelInfoDto}
     * @memberof NotificationDto
     */
    'inApp'?: InAppChannelInfoDto;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationDto
     */
    'isSent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationDto
     */
    'isRead'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof NotificationDto
     */
    'readAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof NotificationDto
     */
    'sentAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof NotificationDto
     */
    'createdAt'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationHubClientMethodName = {
    TestNotify: 'TestNotify',
    Broadcast: 'Broadcast',
    Echo: 'Echo',
    ServerErrorOccurred: 'ServerErrorOccurred',
    InAppNotificationReceived: 'InAppNotificationReceived'
} as const;

export type NotificationHubClientMethodName = typeof NotificationHubClientMethodName[keyof typeof NotificationHubClientMethodName];


/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationHubServerMethodName = {
    Broadcast: 'Broadcast',
    Echo: 'Echo'
} as const;

export type NotificationHubServerMethodName = typeof NotificationHubServerMethodName[keyof typeof NotificationHubServerMethodName];


/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationImportance = {
    None: 'None',
    Low: 'Low',
    Medium: 'Medium',
    High: 'High'
} as const;

export type NotificationImportance = typeof NotificationImportance[keyof typeof NotificationImportance];


/**
 * 
 * @export
 * @interface NotificationSendTestDto
 */
export interface NotificationSendTestDto {
    /**
     * 
     * @type {NotificationChannel}
     * @memberof NotificationSendTestDto
     */
    'channel'?: NotificationChannel;
    /**
     * 
     * @type {NotificationSendTestEmailChannelInfoDto}
     * @memberof NotificationSendTestDto
     */
    'email'?: NotificationSendTestEmailChannelInfoDto;
}


/**
 * 
 * @export
 * @interface NotificationSendTestEmailChannelInfoDto
 */
export interface NotificationSendTestEmailChannelInfoDto {
    /**
     * Specify either email or user.
     * @type {string}
     * @memberof NotificationSendTestEmailChannelInfoDto
     */
    'toEmail'?: string | null;
    /**
     * Specify either email or user.
     * @type {string}
     * @memberof NotificationSendTestEmailChannelInfoDto
     */
    'toUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationSendTestEmailChannelInfoDto
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationSendTestEmailChannelInfoDto
     */
    'body'?: string | null;
}
/**
 * 
 * @export
 * @interface NuclinoContentRefDto
 */
export interface NuclinoContentRefDto {
    /**
     * 
     * @type {NuclinoItemRefDto}
     * @memberof NuclinoContentRefDto
     */
    'item'?: NuclinoItemRefDto;
}
/**
 * 
 * @export
 * @interface NuclinoContentRefInputAdminDto
 */
export interface NuclinoContentRefInputAdminDto {
    /**
     * 
     * @type {NuclinoItemRefInputAdminDto}
     * @memberof NuclinoContentRefInputAdminDto
     */
    'item'?: NuclinoItemRefInputAdminDto;
}
/**
 * 
 * @export
 * @interface NuclinoItemRefDto
 */
export interface NuclinoItemRefDto {
    /**
     * 
     * @type {string}
     * @memberof NuclinoItemRefDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NuclinoItemRefDto
     */
    'teamId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NuclinoItemRefDto
     */
    'workspaceId'?: string;
    /**
     * URL returned by Nuclino API (contains only item ID):  https://app.nuclino.com/t/b/561dc946-088d-444a-9061-f4a38a2543f3
     * @type {string}
     * @memberof NuclinoItemRefDto
     */
    'canonicalUrl'?: string;
    /**
     * User-friendly URL displayed in browser (contains team name, workspace name, item name and item ID):  https://app.nuclino.com/Pixel-and-Bytes/NexusFleet-Help-Center/0-NexusFleet-Interface-b0653116-2a9a-48df-a6c0-f25a16e3bdb1
     * @type {string}
     * @memberof NuclinoItemRefDto
     */
    'friendlyUrl'?: string | null;
}
/**
 * Either ID or URL must be set.
 * @export
 * @interface NuclinoItemRefInputAdminDto
 */
export interface NuclinoItemRefInputAdminDto {
    /**
     * 
     * @type {string}
     * @memberof NuclinoItemRefInputAdminDto
     */
    'id'?: string | null;
    /**
     * URL returned by Nuclino API (contains only item ID):  https://app.nuclino.com/t/b/561dc946-088d-444a-9061-f4a38a2543f3
     * @type {string}
     * @memberof NuclinoItemRefInputAdminDto
     */
    'canonicalUrl'?: string | null;
    /**
     * User-friendly URL displayed in browser (contains team name, workspace name, item name and item ID):  https://app.nuclino.com/Pixel-and-Bytes/NexusFleet-Help-Center/0-NexusFleet-Interface-b0653116-2a9a-48df-a6c0-f25a16e3bdb1
     * @type {string}
     * @memberof NuclinoItemRefInputAdminDto
     */
    'friendlyUrl'?: string | null;
    /**
     * Either canonical or friendly URL.
     * @type {string}
     * @memberof NuclinoItemRefInputAdminDto
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface NullableTestSwaggerClass
 */
export interface NullableTestSwaggerClass {
    /**
     * 
     * @type {number}
     * @memberof NullableTestSwaggerClass
     */
    'int'?: number;
    /**
     * 
     * @type {number}
     * @memberof NullableTestSwaggerClass
     */
    'intRequired': number;
    /**
     * 
     * @type {number}
     * @memberof NullableTestSwaggerClass
     */
    'intNullable'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NullableTestSwaggerClass
     */
    'intRequiredNullable': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof NullableTestSwaggerClass
     */
    'bool'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NullableTestSwaggerClass
     */
    'boolRequired': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NullableTestSwaggerClass
     */
    'boolNullable'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof NullableTestSwaggerClass
     */
    'boolRequiredNullable': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof NullableTestSwaggerClass
     */
    'string'?: string;
    /**
     * 
     * @type {string}
     * @memberof NullableTestSwaggerClass
     */
    'stringRequired': string;
    /**
     * 
     * @type {string}
     * @memberof NullableTestSwaggerClass
     */
    'stringNullable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NullableTestSwaggerClass
     */
    'stringRequiredNullable': string | null;
    /**
     * 
     * @type {VehicleType}
     * @memberof NullableTestSwaggerClass
     */
    'enum'?: VehicleType;
    /**
     * 
     * @type {VehicleType}
     * @memberof NullableTestSwaggerClass
     */
    'enumRequired': VehicleType;
    /**
     * 
     * @type {VehicleType}
     * @memberof NullableTestSwaggerClass
     */
    'enumNullable'?: VehicleType;
    /**
     * 
     * @type {VehicleType}
     * @memberof NullableTestSwaggerClass
     */
    'enumRequiredNullable': VehicleType;
    /**
     * 
     * @type {Size}
     * @memberof NullableTestSwaggerClass
     */
    'struct'?: Size;
    /**
     * 
     * @type {Size}
     * @memberof NullableTestSwaggerClass
     */
    'structRequired': Size;
    /**
     * 
     * @type {Size}
     * @memberof NullableTestSwaggerClass
     */
    'structNullable'?: Size;
    /**
     * 
     * @type {Size}
     * @memberof NullableTestSwaggerClass
     */
    'structRequiredNullable': Size;
    /**
     * 
     * @type {ArbitraryTestSwaggerClass}
     * @memberof NullableTestSwaggerClass
     */
    'class'?: ArbitraryTestSwaggerClass;
    /**
     * 
     * @type {ArbitraryTestSwaggerClass}
     * @memberof NullableTestSwaggerClass
     */
    'classRequired': ArbitraryTestSwaggerClass;
    /**
     * 
     * @type {ArbitraryTestSwaggerClass}
     * @memberof NullableTestSwaggerClass
     */
    'classNullable'?: ArbitraryTestSwaggerClass;
    /**
     * 
     * @type {ArbitraryTestSwaggerClass}
     * @memberof NullableTestSwaggerClass
     */
    'classRequiredNullable': ArbitraryTestSwaggerClass;
}


/**
 * Deprecated: This test class is obsolete.
 * @export
 * @interface ObsoleteTestSwaggerClass
 */
export interface ObsoleteTestSwaggerClass {
    /**
     * Deprecated: It\'s obsolete.
     * @type {number}
     * @memberof ObsoleteTestSwaggerClass
     * @deprecated
     */
    'obsoleteProp'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObsoleteTestSwaggerClass
     */
    'notObsoleteProp'?: number;
}
/**
 * 
 * @export
 * @interface OnboardingAdminDto
 */
export interface OnboardingAdminDto {
    /**
     * 
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof OnboardingAdminDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingAdminDto
     */
    'isDeleted'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'deletedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'restoredAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'deletedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'restoredBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'definitionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {OnboardingStatus}
     * @memberof OnboardingAdminDto
     */
    'status'?: OnboardingStatus;
    /**
     * Show onboarding on next app launch (login, app load, etc.).
     * @type {boolean}
     * @memberof OnboardingAdminDto
     */
    'isShowOnLaunch'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'inProgressAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'completedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'skippedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'inProgressBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'completedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingAdminDto
     */
    'skippedBy'?: string | null;
    /**
     * Tracks progress of steps that user interacted with.    Might not contain all steps from the definition.    Might contain steps that were deleted in the definition.    Unique by DefinitionId.
     * @type {Array<OnboardingStepAdminDto>}
     * @memberof OnboardingAdminDto
     */
    'steps'?: Array<OnboardingStepAdminDto>;
}


/**
 * Matches TenantType.
 * @export
 * @enum {string}
 */

export const OnboardingBuiltInType = {
    None: 'None',
    AllPurpose: 'AllPurpose',
    Rental: 'Rental',
    Leasing: 'Leasing',
    Carsharing: 'Carsharing',
    Utility: 'Utility',
    DamageAssessor: 'DamageAssessor'
} as const;

export type OnboardingBuiltInType = typeof OnboardingBuiltInType[keyof typeof OnboardingBuiltInType];


/**
 * Blueprint.
 * @export
 * @interface OnboardingDefinitionAdminDto
 */
export interface OnboardingDefinitionAdminDto {
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof OnboardingDefinitionAdminDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingDefinitionAdminDto
     */
    'isDeleted'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'deletedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'restoredAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'deletedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'restoredBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {OnboardingBuiltInType}
     * @memberof OnboardingDefinitionAdminDto
     */
    'builtInType'?: OnboardingBuiltInType;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'name'?: string;
    /**
     * For end users.
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'title'?: string;
    /**
     * For end users.
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'subtitle'?: string | null;
    /**
     * Whether available for end users.
     * @type {boolean}
     * @memberof OnboardingDefinitionAdminDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingDefinitionAdminDto
     */
    'isSkippable'?: boolean;
    /**
     * 
     * @type {OnboardingScopeType}
     * @memberof OnboardingDefinitionAdminDto
     */
    'scopeType'?: OnboardingScopeType;
    /**
     * Matching criteria.
     * @type {Array<TenantType>}
     * @memberof OnboardingDefinitionAdminDto
     */
    'tenantTypes'?: Array<TenantType> | null;
    /**
     * 
     * @type {Array<OnboardingStepDefinitionAdminDto>}
     * @memberof OnboardingDefinitionAdminDto
     */
    'steps'?: Array<OnboardingStepDefinitionAdminDto>;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof OnboardingDefinitionAdminDto
     */
    'estimatedDuration'?: string | null;
}


/**
 * Blueprint.
 * @export
 * @interface OnboardingDefinitionDto
 */
export interface OnboardingDefinitionDto {
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof OnboardingDefinitionDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingDefinitionDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingDefinitionDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {OnboardingBuiltInType}
     * @memberof OnboardingDefinitionDto
     */
    'builtInType'?: OnboardingBuiltInType;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionDto
     */
    'version'?: string;
    /**
     * For end users.
     * @type {string}
     * @memberof OnboardingDefinitionDto
     */
    'title'?: string;
    /**
     * For end users.
     * @type {string}
     * @memberof OnboardingDefinitionDto
     */
    'subtitle'?: string | null;
    /**
     * Whether available for end users.
     * @type {boolean}
     * @memberof OnboardingDefinitionDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingDefinitionDto
     */
    'isSkippable'?: boolean;
    /**
     * 
     * @type {OnboardingScopeType}
     * @memberof OnboardingDefinitionDto
     */
    'scopeType'?: OnboardingScopeType;
    /**
     * Matching criteria.
     * @type {Array<TenantType>}
     * @memberof OnboardingDefinitionDto
     */
    'tenantTypes'?: Array<TenantType> | null;
    /**
     * 
     * @type {Array<OnboardingStepDefinitionDto>}
     * @memberof OnboardingDefinitionDto
     */
    'steps'?: Array<OnboardingStepDefinitionDto>;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof OnboardingDefinitionDto
     */
    'estimatedDuration'?: string | null;
}


/**
 * 
 * @export
 * @interface OnboardingDefinitionGetPaginatedAdminDto
 */
export interface OnboardingDefinitionGetPaginatedAdminDto {
    /**
     * 
     * @type {number}
     * @memberof OnboardingDefinitionGetPaginatedAdminDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof OnboardingDefinitionGetPaginatedAdminDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionGetPaginatedAdminDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnboardingDefinitionGetPaginatedAdminDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnboardingDefinitionGetPaginatedAdminDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnboardingDefinitionGetPaginatedAdminDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof OnboardingDefinitionGetPaginatedAdminDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof OnboardingDefinitionGetPaginatedAdminDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof OnboardingDefinitionGetPaginatedAdminDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof OnboardingDefinitionGetPaginatedAdminDto
     */
    'id'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof OnboardingDefinitionGetPaginatedAdminDto
     */
    'createdAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof OnboardingDefinitionGetPaginatedAdminDto
     */
    'updatedAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof OnboardingDefinitionGetPaginatedAdminDto
     */
    'createdBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof OnboardingDefinitionGetPaginatedAdminDto
     */
    'updatedBy'?: FieldFilterOfPrimitiveDtoOfString;
}
/**
 * 
 * @export
 * @interface OnboardingDefinitionUpdateAdminDto
 */
export interface OnboardingDefinitionUpdateAdminDto {
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionUpdateAdminDto
     */
    'name'?: string;
    /**
     * For end users.
     * @type {string}
     * @memberof OnboardingDefinitionUpdateAdminDto
     */
    'title'?: string;
    /**
     * For end users.
     * @type {string}
     * @memberof OnboardingDefinitionUpdateAdminDto
     */
    'subtitle'?: string | null;
    /**
     * Whether available for end users.
     * @type {boolean}
     * @memberof OnboardingDefinitionUpdateAdminDto
     */
    'isEnabled'?: boolean;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Guidance.OnboardingDefinition.OnboardingDefinitionEntity.IsSkippable\" />
     * @type {boolean}
     * @memberof OnboardingDefinitionUpdateAdminDto
     */
    'isSkippable'?: boolean;
    /**
     * 
     * @type {Array<OnboardingStepDefinitionInputAdminDto>}
     * @memberof OnboardingDefinitionUpdateAdminDto
     */
    'steps'?: Array<OnboardingStepDefinitionInputAdminDto>;
}
/**
 * Specific instance for progress tracking.
 * @export
 * @interface OnboardingDto
 */
export interface OnboardingDto {
    /**
     * 
     * @type {string}
     * @memberof OnboardingDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof OnboardingDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDto
     */
    'definitionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {OnboardingStatus}
     * @memberof OnboardingDto
     */
    'status'?: OnboardingStatus;
    /**
     * Show onboarding on next app launch (login, app load, etc.).
     * @type {boolean}
     * @memberof OnboardingDto
     */
    'isShowOnLaunch'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingDto
     */
    'inProgressAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingDto
     */
    'completedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingDto
     */
    'skippedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDto
     */
    'inProgressBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDto
     */
    'completedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDto
     */
    'skippedBy'?: string | null;
    /**
     * Tracks progress of steps that user interacted with.    Might not contain all steps from the definition.    Might contain steps that were deleted in the definition.    Unique by DefinitionId.
     * @type {Array<OnboardingStepDto>}
     * @memberof OnboardingDto
     */
    'steps'?: Array<OnboardingStepDto>;
    /**
     * 
     * @type {OnboardingDefinitionDto}
     * @memberof OnboardingDto
     */
    'definition'?: OnboardingDefinitionDto;
}


/**
 * 
 * @export
 * @interface OnboardingGetPaginatedAdminDto
 */
export interface OnboardingGetPaginatedAdminDto {
    /**
     * 
     * @type {number}
     * @memberof OnboardingGetPaginatedAdminDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof OnboardingGetPaginatedAdminDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof OnboardingGetPaginatedAdminDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnboardingGetPaginatedAdminDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnboardingGetPaginatedAdminDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnboardingGetPaginatedAdminDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof OnboardingGetPaginatedAdminDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof OnboardingGetPaginatedAdminDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof OnboardingGetPaginatedAdminDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof OnboardingGetPaginatedAdminDto
     */
    'id'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof OnboardingGetPaginatedAdminDto
     */
    'createdAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof OnboardingGetPaginatedAdminDto
     */
    'updatedAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof OnboardingGetPaginatedAdminDto
     */
    'createdBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof OnboardingGetPaginatedAdminDto
     */
    'updatedBy'?: FieldFilterOfPrimitiveDtoOfString;
}
/**
 * <inheritdoc cref=\"T:Domain.Entities.Guidance.Onboarding.OnboardingRef\" />
 * @export
 * @interface OnboardingRefDto
 */
export interface OnboardingRefDto {
    /**
     * 
     * @type {string}
     * @memberof OnboardingRefDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof OnboardingRefDto
     */
    'formType'?: EntityFormType;
    /**
     * 
     * @type {string}
     * @memberof OnboardingRefDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingRefDto
     */
    'definitionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingRefDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingRefDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {OnboardingStatus}
     * @memberof OnboardingRefDto
     */
    'status'?: OnboardingStatus;
    /**
     * Show onboarding on next app launch (login, app load, etc.).
     * @type {boolean}
     * @memberof OnboardingRefDto
     */
    'isShowOnLaunch'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OnboardingScopeType = {
    None: 'None',
    User: 'User',
    Tenant: 'Tenant',
    TenantUser: 'TenantUser'
} as const;

export type OnboardingScopeType = typeof OnboardingScopeType[keyof typeof OnboardingScopeType];


/**
 * 
 * @export
 * @enum {string}
 */

export const OnboardingStatus = {
    None: 'None',
    NotStarted: 'NotStarted',
    InProgress: 'InProgress',
    Completed: 'Completed',
    Skipped: 'Skipped'
} as const;

export type OnboardingStatus = typeof OnboardingStatus[keyof typeof OnboardingStatus];


/**
 * Progress of concrete step.
 * @export
 * @interface OnboardingStepAdminDto
 */
export interface OnboardingStepAdminDto {
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepAdminDto
     */
    'id'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingStepAdminDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingStepAdminDto
     */
    'updatedAt'?: string;
    /**
     * UserId.
     * @type {string}
     * @memberof OnboardingStepAdminDto
     */
    'createdBy'?: string | null;
    /**
     * UserId.
     * @type {string}
     * @memberof OnboardingStepAdminDto
     */
    'updatedBy'?: string | null;
    /**
     * Step definition ID.    Must be unique withing the onboarding instance.
     * @type {string}
     * @memberof OnboardingStepAdminDto
     */
    'definitionId'?: string;
    /**
     * 
     * @type {OnboardingStatus}
     * @memberof OnboardingStepAdminDto
     */
    'status'?: OnboardingStatus;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingStepAdminDto
     */
    'inProgressAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingStepAdminDto
     */
    'completedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingStepAdminDto
     */
    'skippedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepAdminDto
     */
    'inProgressBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepAdminDto
     */
    'completedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepAdminDto
     */
    'skippedBy'?: string | null;
}


/**
 * <inheritdoc cref=\"T:Domain.Entities.Guidance.OnboardingDefinition.OnboardingStepDefinition\" />
 * @export
 * @interface OnboardingStepDefinitionAdminDto
 */
export interface OnboardingStepDefinitionAdminDto {
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepDefinitionAdminDto
     */
    'id'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingStepDefinitionAdminDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingStepDefinitionAdminDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepDefinitionAdminDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepDefinitionAdminDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {OnboardingStepType}
     * @memberof OnboardingStepDefinitionAdminDto
     */
    'type'?: OnboardingStepType;
    /**
     * For end users.
     * @type {string}
     * @memberof OnboardingStepDefinitionAdminDto
     */
    'title'?: string;
    /**
     * For end users.
     * @type {string}
     * @memberof OnboardingStepDefinitionAdminDto
     */
    'subtitle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStepDefinitionAdminDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStepDefinitionAdminDto
     */
    'isSkippable'?: boolean;
    /**
     * Lesser values go first.
     * @type {number}
     * @memberof OnboardingStepDefinitionAdminDto
     */
    'sortOrder'?: number;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof OnboardingStepDefinitionAdminDto
     */
    'estimatedDuration'?: string | null;
    /**
     * 
     * @type {NuclinoContentRefDto}
     * @memberof OnboardingStepDefinitionAdminDto
     */
    'nuclinoContent'?: NuclinoContentRefDto;
}


/**
 * 
 * @export
 * @interface OnboardingStepDefinitionContentDto
 */
export interface OnboardingStepDefinitionContentDto {
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepDefinitionContentDto
     */
    'markdown'?: string | null;
}
/**
 * <inheritdoc cref=\"T:Domain.Entities.Guidance.OnboardingDefinition.OnboardingStepDefinition\" />
 * @export
 * @interface OnboardingStepDefinitionDto
 */
export interface OnboardingStepDefinitionDto {
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepDefinitionDto
     */
    'id'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingStepDefinitionDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OnboardingStepDefinitionDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepDefinitionDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepDefinitionDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {OnboardingStepType}
     * @memberof OnboardingStepDefinitionDto
     */
    'type'?: OnboardingStepType;
    /**
     * For end users.
     * @type {string}
     * @memberof OnboardingStepDefinitionDto
     */
    'title'?: string;
    /**
     * For end users.
     * @type {string}
     * @memberof OnboardingStepDefinitionDto
     */
    'subtitle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStepDefinitionDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStepDefinitionDto
     */
    'isSkippable'?: boolean;
    /**
     * Lesser values go first.
     * @type {number}
     * @memberof OnboardingStepDefinitionDto
     */
    'sortOrder'?: number;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof OnboardingStepDefinitionDto
     */
    'estimatedDuration'?: string | null;
    /**
     * 
     * @type {NuclinoContentRefDto}
     * @memberof OnboardingStepDefinitionDto
     */
    'nuclinoContent'?: NuclinoContentRefDto;
}


/**
 * <inheritdoc cref=\"T:Domain.Entities.Guidance.OnboardingDefinition.OnboardingStepDefinition\" />
 * @export
 * @interface OnboardingStepDefinitionInputAdminDto
 */
export interface OnboardingStepDefinitionInputAdminDto {
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepDefinitionInputAdminDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {OnboardingStepType}
     * @memberof OnboardingStepDefinitionInputAdminDto
     */
    'type'?: OnboardingStepType;
    /**
     * For end users.
     * @type {string}
     * @memberof OnboardingStepDefinitionInputAdminDto
     */
    'title'?: string;
    /**
     * For end users.
     * @type {string}
     * @memberof OnboardingStepDefinitionInputAdminDto
     */
    'subtitle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStepDefinitionInputAdminDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStepDefinitionInputAdminDto
     */
    'isSkippable'?: boolean;
    /**
     * Lesser values go first.
     * @type {number}
     * @memberof OnboardingStepDefinitionInputAdminDto
     */
    'sortOrder'?: number;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof OnboardingStepDefinitionInputAdminDto
     */
    'estimatedDuration'?: string | null;
    /**
     * 
     * @type {NuclinoContentRefInputAdminDto}
     * @memberof OnboardingStepDefinitionInputAdminDto
     */
    'nuclinoContent'?: NuclinoContentRefInputAdminDto;
}


/**
 * Progress of concrete step.
 * @export
 * @interface OnboardingStepDto
 */
export interface OnboardingStepDto {
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepDto
     */
    'id'?: string;
    /**
     * Step definition ID.    Must be unique withing the onboarding instance.
     * @type {string}
     * @memberof OnboardingStepDto
     */
    'definitionId'?: string;
    /**
     * 
     * @type {OnboardingStatus}
     * @memberof OnboardingStepDto
     */
    'status'?: OnboardingStatus;
}


/**
 * Defines step type and relevant CTAs.
 * @export
 * @enum {string}
 */

export const OnboardingStepType = {
    None: 'None',
    TenantSettingsUpdate: 'TenantSettingsUpdate',
    DepartmentCreate: 'DepartmentCreate',
    LocationCreate: 'LocationCreate',
    SpotCreate: 'SpotCreate',
    RoleCreate: 'RoleCreate',
    InviteCreatePersonal: 'InviteCreatePersonal',
    InviteCreateAnonymous: 'InviteCreateAnonymous',
    InviteAccept: 'InviteAccept',
    VehicleCreate: 'VehicleCreate',
    VehicleCreateMany: 'VehicleCreateMany',
    VehicleImport: 'VehicleImport',
    VehicleUpdateAffiliation: 'VehicleUpdateAffiliation',
    CustomerCreate: 'CustomerCreate',
    ContractCreate: 'ContractCreate',
    VisualInspectionCreate: 'VisualInspectionCreate',
    VisualInspectionCreateOnMobile: 'VisualInspectionCreateOnMobile',
    DamageDetectionCreate: 'DamageDetectionCreate',
    DamageDetectionCreateOnMobile: 'DamageDetectionCreateOnMobile',
    DamageCostEvaluationCreate: 'DamageCostEvaluationCreate',
    PoolCreate: 'PoolCreate',
    PoolAddItems: 'PoolAddItems',
    ProductLocationCreate: 'ProductLocationCreate',
    AssetSubscriptionPlanCreate: 'AssetSubscriptionPlanCreate',
    AssetSubscriptionCreate: 'AssetSubscriptionCreate',
    RepairSpecCreate: 'RepairSpecCreate'
} as const;

export type OnboardingStepType = typeof OnboardingStepType[keyof typeof OnboardingStepType];


/**
 * References Oneflow content with additional info.
 * @export
 * @interface OneflowContractRefDto
 */
export interface OneflowContractRefDto {
    /**
     * 
     * @type {string}
     * @memberof OneflowContractRefDto
     */
    'id'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OneflowContractRefDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof OneflowContractRefDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OneflowContractRefDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OneflowContractRefDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {OneflowEnvironmentType}
     * @memberof OneflowContractRefDto
     */
    'environmentType'?: OneflowEnvironmentType;
    /**
     * 
     * @type {number}
     * @memberof OneflowContractRefDto
     */
    'contractId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OneflowContractRefDto
     */
    'workspaceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OneflowContractRefDto
     */
    'templateId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OneflowContractRefDto
     */
    'templateTypeId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OneflowContractRefDto
     */
    'playbookId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OneflowContractRefDto
     */
    'integrationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OneflowContractRefDto
     */
    'integrationBlueprintId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OneflowContractRefDto
     */
    'userEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof OneflowContractRefDto
     */
    'contractUrl'?: string;
}


/**
 * 
 * @export
 * @interface OneflowDefaultsDto
 */
export interface OneflowDefaultsDto {
    /**
     * 
     * @type {number}
     * @memberof OneflowDefaultsDto
     */
    'defaultTemplateId'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OneflowEnvironmentType = {
    None: 'None',
    Production: 'Production',
    Testing: 'Testing'
} as const;

export type OneflowEnvironmentType = typeof OneflowEnvironmentType[keyof typeof OneflowEnvironmentType];


/**
 * OneflowTemplateExtDto
 * @export
 * @interface OneflowTemplateDto
 */
export interface OneflowTemplateDto {
    /**
     * 
     * @type {number}
     * @memberof OneflowTemplateDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof OneflowTemplateDto
     */
    'name'?: string;
}
/**
 * Indicates whether the entity is in a functional state and fit for use.
 * @export
 * @enum {string}
 */

export const OperabilityStatus = {
    None: 'None',
    Operable: 'Operable',
    Inoperable: 'Inoperable'
} as const;

export type OperabilityStatus = typeof OperabilityStatus[keyof typeof OperabilityStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const OperatingSystemType = {
    None: 'None',
    Windows: 'Windows',
    MacOs: 'macOS',
    Linux: 'Linux',
    IOs: 'iOS',
    Android: 'Android'
} as const;

export type OperatingSystemType = typeof OperatingSystemType[keyof typeof OperatingSystemType];


/**
 * 
 * @export
 * @interface OperationCountersDto
 */
export interface OperationCountersDto {
    /**
     * 
     * @type {string}
     * @memberof OperationCountersDto
     */
    'version'?: string;
    /**
     * 
     * @type {AccessoryCheckCountersDto}
     * @memberof OperationCountersDto
     */
    'accessoryChecks': AccessoryCheckCountersDto;
    /**
     * 
     * @type {VisualInspectionCountersDto}
     * @memberof OperationCountersDto
     */
    'visualInspections': VisualInspectionCountersDto;
    /**
     * 
     * @type {DamageDetectionCountersDto}
     * @memberof OperationCountersDto
     */
    'damageDetections': DamageDetectionCountersDto;
    /**
     * 
     * @type {DamageCostEvaluationCountersDto}
     * @memberof OperationCountersDto
     */
    'damageCostEvaluations': DamageCostEvaluationCountersDto;
    /**
     * 
     * @type {RepairOperationCountersDto}
     * @memberof OperationCountersDto
     */
    'repairOperations': RepairOperationCountersDto;
    /**
     * 
     * @type {WheelOperationCountersDto}
     * @memberof OperationCountersDto
     */
    'wheelOperations': WheelOperationCountersDto;
    /**
     * 
     * @type {WashCountersDto}
     * @memberof OperationCountersDto
     */
    'washes': WashCountersDto;
    /**
     * 
     * @type {MaintenanceCountersDto}
     * @memberof OperationCountersDto
     */
    'maintenances': MaintenanceCountersDto;
}
/**
 * 
 * @export
 * @interface OptionalClosedIntervalDtoOfDouble
 */
export interface OptionalClosedIntervalDtoOfDouble {
    /**
     * 
     * @type {number}
     * @memberof OptionalClosedIntervalDtoOfDouble
     */
    'start'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OptionalClosedIntervalDtoOfDouble
     */
    'end'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof OptionalClosedIntervalDtoOfDouble
     */
    'isNull'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OptionalClosedIntervalDtoOfDouble
     */
    'isNotNull'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OptionalClosedIntervalDtoOfDouble
     */
    'isAnyNotNull'?: boolean;
}
/**
 * 
 * @export
 * @interface OptionalClosedIntervalDtoOfInt32
 */
export interface OptionalClosedIntervalDtoOfInt32 {
    /**
     * 
     * @type {number}
     * @memberof OptionalClosedIntervalDtoOfInt32
     */
    'start'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OptionalClosedIntervalDtoOfInt32
     */
    'end'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof OptionalClosedIntervalDtoOfInt32
     */
    'isNull'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OptionalClosedIntervalDtoOfInt32
     */
    'isNotNull'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OptionalClosedIntervalDtoOfInt32
     */
    'isAnyNotNull'?: boolean;
}
/**
 * 
 * @export
 * @interface OutcomingCountersDtoInDataGrantCountersDto
 */
export interface OutcomingCountersDtoInDataGrantCountersDto {
    /**
     * 
     * @type {number}
     * @memberof OutcomingCountersDtoInDataGrantCountersDto
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface OutcomingCountersDtoInTenantConnectionRequestCountersDto
 */
export interface OutcomingCountersDtoInTenantConnectionRequestCountersDto {
    /**
     * 
     * @type {number}
     * @memberof OutcomingCountersDtoInTenantConnectionRequestCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof OutcomingCountersDtoInTenantConnectionRequestCountersDto
     */
    'pendingCount': number;
    /**
     * 
     * @type {number}
     * @memberof OutcomingCountersDtoInTenantConnectionRequestCountersDto
     */
    'acceptedCount': number;
    /**
     * 
     * @type {number}
     * @memberof OutcomingCountersDtoInTenantConnectionRequestCountersDto
     */
    'declinedCount': number;
    /**
     * 
     * @type {number}
     * @memberof OutcomingCountersDtoInTenantConnectionRequestCountersDto
     */
    'notRespondedCount': number;
    /**
     * 
     * @type {number}
     * @memberof OutcomingCountersDtoInTenantConnectionRequestCountersDto
     */
    'revokedCount': number;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAccessoryCheckDto
 */
export interface PaginationDtoOfAccessoryCheckDto {
    /**
     * 
     * @type {Array<AccessoryCheckDto>}
     * @memberof PaginationDtoOfAccessoryCheckDto
     */
    'items'?: Array<AccessoryCheckDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAccessoryCheckDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAccessoryDto
 */
export interface PaginationDtoOfAccessoryDto {
    /**
     * 
     * @type {Array<AccessoryDto>}
     * @memberof PaginationDtoOfAccessoryDto
     */
    'items'?: Array<AccessoryDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAccessoryDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminDamageTypeDto
 */
export interface PaginationDtoOfAdminDamageTypeDto {
    /**
     * 
     * @type {Array<AdminDamageTypeDto>}
     * @memberof PaginationDtoOfAdminDamageTypeDto
     */
    'items'?: Array<AdminDamageTypeDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminDamageTypeDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminFileDto
 */
export interface PaginationDtoOfAdminFileDto {
    /**
     * 
     * @type {Array<AdminFileDto>}
     * @memberof PaginationDtoOfAdminFileDto
     */
    'items'?: Array<AdminFileDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminFileDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminInviteDto
 */
export interface PaginationDtoOfAdminInviteDto {
    /**
     * 
     * @type {Array<AdminInviteDto>}
     * @memberof PaginationDtoOfAdminInviteDto
     */
    'items'?: Array<AdminInviteDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminInviteDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminInvoiceDto
 */
export interface PaginationDtoOfAdminInvoiceDto {
    /**
     * 
     * @type {Array<AdminInvoiceDto>}
     * @memberof PaginationDtoOfAdminInvoiceDto
     */
    'items'?: Array<AdminInvoiceDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminInvoiceDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminNotificationDto
 */
export interface PaginationDtoOfAdminNotificationDto {
    /**
     * 
     * @type {Array<AdminNotificationDto>}
     * @memberof PaginationDtoOfAdminNotificationDto
     */
    'items'?: Array<AdminNotificationDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminNotificationDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminSubscriptionDto
 */
export interface PaginationDtoOfAdminSubscriptionDto {
    /**
     * 
     * @type {Array<AdminSubscriptionDto>}
     * @memberof PaginationDtoOfAdminSubscriptionDto
     */
    'items'?: Array<AdminSubscriptionDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminSubscriptionDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminTenantDto
 */
export interface PaginationDtoOfAdminTenantDto {
    /**
     * 
     * @type {Array<AdminTenantDto>}
     * @memberof PaginationDtoOfAdminTenantDto
     */
    'items'?: Array<AdminTenantDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminTenantDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminUserDto
 */
export interface PaginationDtoOfAdminUserDto {
    /**
     * 
     * @type {Array<AdminUserDto>}
     * @memberof PaginationDtoOfAdminUserDto
     */
    'items'?: Array<AdminUserDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminUserDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminVehicleBodyTypeDto
 */
export interface PaginationDtoOfAdminVehicleBodyTypeDto {
    /**
     * 
     * @type {Array<AdminVehicleBodyTypeDto>}
     * @memberof PaginationDtoOfAdminVehicleBodyTypeDto
     */
    'items'?: Array<AdminVehicleBodyTypeDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminVehicleBodyTypeDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminVehicleFuelTypeDto
 */
export interface PaginationDtoOfAdminVehicleFuelTypeDto {
    /**
     * 
     * @type {Array<AdminVehicleFuelTypeDto>}
     * @memberof PaginationDtoOfAdminVehicleFuelTypeDto
     */
    'items'?: Array<AdminVehicleFuelTypeDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminVehicleFuelTypeDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminVehicleGenerationDto
 */
export interface PaginationDtoOfAdminVehicleGenerationDto {
    /**
     * 
     * @type {Array<AdminVehicleGenerationDto>}
     * @memberof PaginationDtoOfAdminVehicleGenerationDto
     */
    'items'?: Array<AdminVehicleGenerationDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminVehicleGenerationDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminVehicleMakeDto
 */
export interface PaginationDtoOfAdminVehicleMakeDto {
    /**
     * 
     * @type {Array<AdminVehicleMakeDto>}
     * @memberof PaginationDtoOfAdminVehicleMakeDto
     */
    'items'?: Array<AdminVehicleMakeDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminVehicleMakeDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminVehicleModelDto
 */
export interface PaginationDtoOfAdminVehicleModelDto {
    /**
     * 
     * @type {Array<AdminVehicleModelDto>}
     * @memberof PaginationDtoOfAdminVehicleModelDto
     */
    'items'?: Array<AdminVehicleModelDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminVehicleModelDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminVehicleModificationDto
 */
export interface PaginationDtoOfAdminVehicleModificationDto {
    /**
     * 
     * @type {Array<AdminVehicleModificationDto>}
     * @memberof PaginationDtoOfAdminVehicleModificationDto
     */
    'items'?: Array<AdminVehicleModificationDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminVehicleModificationDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminVehiclePartTypeDto
 */
export interface PaginationDtoOfAdminVehiclePartTypeDto {
    /**
     * 
     * @type {Array<AdminVehiclePartTypeDto>}
     * @memberof PaginationDtoOfAdminVehiclePartTypeDto
     */
    'items'?: Array<AdminVehiclePartTypeDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminVehiclePartTypeDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminVehicleTypeDto
 */
export interface PaginationDtoOfAdminVehicleTypeDto {
    /**
     * 
     * @type {Array<AdminVehicleTypeDto>}
     * @memberof PaginationDtoOfAdminVehicleTypeDto
     */
    'items'?: Array<AdminVehicleTypeDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminVehicleTypeDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAdminVehicleVisualModelDto
 */
export interface PaginationDtoOfAdminVehicleVisualModelDto {
    /**
     * 
     * @type {Array<AdminVehicleVisualModelDto>}
     * @memberof PaginationDtoOfAdminVehicleVisualModelDto
     */
    'items'?: Array<AdminVehicleVisualModelDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAdminVehicleVisualModelDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAssessmentFlowBriefDto
 */
export interface PaginationDtoOfAssessmentFlowBriefDto {
    /**
     * 
     * @type {Array<AssessmentFlowBriefDto>}
     * @memberof PaginationDtoOfAssessmentFlowBriefDto
     */
    'items'?: Array<AssessmentFlowBriefDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAssessmentFlowBriefDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAssessmentFlowDto
 */
export interface PaginationDtoOfAssessmentFlowDto {
    /**
     * 
     * @type {Array<AssessmentFlowDto>}
     * @memberof PaginationDtoOfAssessmentFlowDto
     */
    'items'?: Array<AssessmentFlowDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAssessmentFlowDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAssetCandidateEntityDto
 */
export interface PaginationDtoOfAssetCandidateEntityDto {
    /**
     * 
     * @type {Array<AssetCandidateEntityDto>}
     * @memberof PaginationDtoOfAssetCandidateEntityDto
     */
    'items'?: Array<AssetCandidateEntityDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAssetCandidateEntityDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAssetDto
 */
export interface PaginationDtoOfAssetDto {
    /**
     * 
     * @type {Array<AssetDto>}
     * @memberof PaginationDtoOfAssetDto
     */
    'items'?: Array<AssetDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAssetDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAssetSubscriptionDto
 */
export interface PaginationDtoOfAssetSubscriptionDto {
    /**
     * 
     * @type {Array<AssetSubscriptionDto>}
     * @memberof PaginationDtoOfAssetSubscriptionDto
     */
    'items'?: Array<AssetSubscriptionDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAssetSubscriptionDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAssetSubscriptionPlanDto
 */
export interface PaginationDtoOfAssetSubscriptionPlanDto {
    /**
     * 
     * @type {Array<AssetSubscriptionPlanDto>}
     * @memberof PaginationDtoOfAssetSubscriptionPlanDto
     */
    'items'?: Array<AssetSubscriptionPlanDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAssetSubscriptionPlanDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfAssignmentDto
 */
export interface PaginationDtoOfAssignmentDto {
    /**
     * 
     * @type {Array<AssignmentDto>}
     * @memberof PaginationDtoOfAssignmentDto
     */
    'items'?: Array<AssignmentDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfAssignmentDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfChargeDto
 */
export interface PaginationDtoOfChargeDto {
    /**
     * 
     * @type {Array<ChargeDto>}
     * @memberof PaginationDtoOfChargeDto
     */
    'items'?: Array<ChargeDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfChargeDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfChatActivityDto
 */
export interface PaginationDtoOfChatActivityDto {
    /**
     * 
     * @type {Array<ChatActivityDto>}
     * @memberof PaginationDtoOfChatActivityDto
     */
    'items'?: Array<ChatActivityDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfChatActivityDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfChatDto
 */
export interface PaginationDtoOfChatDto {
    /**
     * 
     * @type {Array<ChatDto>}
     * @memberof PaginationDtoOfChatDto
     */
    'items'?: Array<ChatDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfChatDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfChatEventDto
 */
export interface PaginationDtoOfChatEventDto {
    /**
     * 
     * @type {Array<ChatEventDto>}
     * @memberof PaginationDtoOfChatEventDto
     */
    'items'?: Array<ChatEventDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfChatEventDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfChatHistoryItemDto
 */
export interface PaginationDtoOfChatHistoryItemDto {
    /**
     * 
     * @type {Array<ChatHistoryItemDto>}
     * @memberof PaginationDtoOfChatHistoryItemDto
     */
    'items'?: Array<ChatHistoryItemDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfChatHistoryItemDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfChatMessageDto
 */
export interface PaginationDtoOfChatMessageDto {
    /**
     * 
     * @type {Array<ChatMessageDto>}
     * @memberof PaginationDtoOfChatMessageDto
     */
    'items'?: Array<ChatMessageDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfChatMessageDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfChatParticipantCandidateDto
 */
export interface PaginationDtoOfChatParticipantCandidateDto {
    /**
     * 
     * @type {Array<ChatParticipantCandidateDto>}
     * @memberof PaginationDtoOfChatParticipantCandidateDto
     */
    'items'?: Array<ChatParticipantCandidateDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfChatParticipantCandidateDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfChatParticipantDto
 */
export interface PaginationDtoOfChatParticipantDto {
    /**
     * 
     * @type {Array<ChatParticipantDto>}
     * @memberof PaginationDtoOfChatParticipantDto
     */
    'items'?: Array<ChatParticipantDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfChatParticipantDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfContractDto
 */
export interface PaginationDtoOfContractDto {
    /**
     * 
     * @type {Array<ContractDto>}
     * @memberof PaginationDtoOfContractDto
     */
    'items'?: Array<ContractDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfContractDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfCustomSessionDto
 */
export interface PaginationDtoOfCustomSessionDto {
    /**
     * 
     * @type {Array<CustomSessionDto>}
     * @memberof PaginationDtoOfCustomSessionDto
     */
    'items'?: Array<CustomSessionDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfCustomSessionDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfCustomTagDto
 */
export interface PaginationDtoOfCustomTagDto {
    /**
     * 
     * @type {Array<CustomTagDto>}
     * @memberof PaginationDtoOfCustomTagDto
     */
    'items'?: Array<CustomTagDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfCustomTagDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfCustomerDto
 */
export interface PaginationDtoOfCustomerDto {
    /**
     * 
     * @type {Array<CustomerDto>}
     * @memberof PaginationDtoOfCustomerDto
     */
    'items'?: Array<CustomerDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfCustomerDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfDamageCostEvaluationAggregateDto
 */
export interface PaginationDtoOfDamageCostEvaluationAggregateDto {
    /**
     * 
     * @type {Array<DamageCostEvaluationAggregateDto>}
     * @memberof PaginationDtoOfDamageCostEvaluationAggregateDto
     */
    'items'?: Array<DamageCostEvaluationAggregateDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfDamageCostEvaluationAggregateDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfDamageCostEvaluationDto
 */
export interface PaginationDtoOfDamageCostEvaluationDto {
    /**
     * 
     * @type {Array<DamageCostEvaluationDto>}
     * @memberof PaginationDtoOfDamageCostEvaluationDto
     */
    'items'?: Array<DamageCostEvaluationDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfDamageCostEvaluationDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfDamageDetectionAggregateDto
 */
export interface PaginationDtoOfDamageDetectionAggregateDto {
    /**
     * 
     * @type {Array<DamageDetectionAggregateDto>}
     * @memberof PaginationDtoOfDamageDetectionAggregateDto
     */
    'items'?: Array<DamageDetectionAggregateDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfDamageDetectionAggregateDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfDamageDetectionDto
 */
export interface PaginationDtoOfDamageDetectionDto {
    /**
     * 
     * @type {Array<DamageDetectionDto>}
     * @memberof PaginationDtoOfDamageDetectionDto
     */
    'items'?: Array<DamageDetectionDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfDamageDetectionDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfDamageTypeDto
 */
export interface PaginationDtoOfDamageTypeDto {
    /**
     * 
     * @type {Array<DamageTypeDto>}
     * @memberof PaginationDtoOfDamageTypeDto
     */
    'items'?: Array<DamageTypeDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfDamageTypeDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfDataExportConfigDto
 */
export interface PaginationDtoOfDataExportConfigDto {
    /**
     * 
     * @type {Array<DataExportConfigDto>}
     * @memberof PaginationDtoOfDataExportConfigDto
     */
    'items'?: Array<DataExportConfigDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfDataExportConfigDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfDataGrantDto
 */
export interface PaginationDtoOfDataGrantDto {
    /**
     * 
     * @type {Array<DataGrantDto>}
     * @memberof PaginationDtoOfDataGrantDto
     */
    'items'?: Array<DataGrantDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfDataGrantDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfDepartmentDto
 */
export interface PaginationDtoOfDepartmentDto {
    /**
     * 
     * @type {Array<DepartmentDto>}
     * @memberof PaginationDtoOfDepartmentDto
     */
    'items'?: Array<DepartmentDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfDepartmentDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfDocumentDto
 */
export interface PaginationDtoOfDocumentDto {
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof PaginationDtoOfDocumentDto
     */
    'items'?: Array<DocumentDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfDocumentDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfGeneralEventLogDto
 */
export interface PaginationDtoOfGeneralEventLogDto {
    /**
     * 
     * @type {Array<GeneralEventLogDto>}
     * @memberof PaginationDtoOfGeneralEventLogDto
     */
    'items'?: Array<GeneralEventLogDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfGeneralEventLogDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfGeneralHistoryDto
 */
export interface PaginationDtoOfGeneralHistoryDto {
    /**
     * 
     * @type {Array<GeneralHistoryDto>}
     * @memberof PaginationDtoOfGeneralHistoryDto
     */
    'items'?: Array<GeneralHistoryDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfGeneralHistoryDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfGeneralStatusHistoryDto
 */
export interface PaginationDtoOfGeneralStatusHistoryDto {
    /**
     * 
     * @type {Array<GeneralStatusHistoryDto>}
     * @memberof PaginationDtoOfGeneralStatusHistoryDto
     */
    'items'?: Array<GeneralStatusHistoryDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfGeneralStatusHistoryDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfGeneralTagCandidateDto
 */
export interface PaginationDtoOfGeneralTagCandidateDto {
    /**
     * 
     * @type {Array<GeneralTagCandidateDto>}
     * @memberof PaginationDtoOfGeneralTagCandidateDto
     */
    'items'?: Array<GeneralTagCandidateDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfGeneralTagCandidateDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfImportDto
 */
export interface PaginationDtoOfImportDto {
    /**
     * 
     * @type {Array<ImportDto>}
     * @memberof PaginationDtoOfImportDto
     */
    'items'?: Array<ImportDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfImportDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfIntegrationApiClientDto
 */
export interface PaginationDtoOfIntegrationApiClientDto {
    /**
     * 
     * @type {Array<IntegrationApiClientDto>}
     * @memberof PaginationDtoOfIntegrationApiClientDto
     */
    'items'?: Array<IntegrationApiClientDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfIntegrationApiClientDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfInvoiceDto
 */
export interface PaginationDtoOfInvoiceDto {
    /**
     * 
     * @type {Array<InvoiceDto>}
     * @memberof PaginationDtoOfInvoiceDto
     */
    'items'?: Array<InvoiceDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfInvoiceDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfLocationDto
 */
export interface PaginationDtoOfLocationDto {
    /**
     * 
     * @type {Array<LocationDto>}
     * @memberof PaginationDtoOfLocationDto
     */
    'items'?: Array<LocationDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfLocationDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfMaintenanceDto
 */
export interface PaginationDtoOfMaintenanceDto {
    /**
     * 
     * @type {Array<MaintenanceDto>}
     * @memberof PaginationDtoOfMaintenanceDto
     */
    'items'?: Array<MaintenanceDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfMaintenanceDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfNegotiationDto
 */
export interface PaginationDtoOfNegotiationDto {
    /**
     * 
     * @type {Array<NegotiationDto>}
     * @memberof PaginationDtoOfNegotiationDto
     */
    'items'?: Array<NegotiationDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfNegotiationDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfNotificationDto
 */
export interface PaginationDtoOfNotificationDto {
    /**
     * 
     * @type {Array<NotificationDto>}
     * @memberof PaginationDtoOfNotificationDto
     */
    'items'?: Array<NotificationDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfNotificationDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfOnboardingAdminDto
 */
export interface PaginationDtoOfOnboardingAdminDto {
    /**
     * 
     * @type {Array<OnboardingAdminDto>}
     * @memberof PaginationDtoOfOnboardingAdminDto
     */
    'items'?: Array<OnboardingAdminDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfOnboardingAdminDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfOnboardingDefinitionAdminDto
 */
export interface PaginationDtoOfOnboardingDefinitionAdminDto {
    /**
     * 
     * @type {Array<OnboardingDefinitionAdminDto>}
     * @memberof PaginationDtoOfOnboardingDefinitionAdminDto
     */
    'items'?: Array<OnboardingDefinitionAdminDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfOnboardingDefinitionAdminDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfPoolDto
 */
export interface PaginationDtoOfPoolDto {
    /**
     * 
     * @type {Array<PoolDto>}
     * @memberof PaginationDtoOfPoolDto
     */
    'items'?: Array<PoolDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfPoolDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfPoolItemCandidateEntityDto
 */
export interface PaginationDtoOfPoolItemCandidateEntityDto {
    /**
     * 
     * @type {Array<PoolItemCandidateEntityDto>}
     * @memberof PaginationDtoOfPoolItemCandidateEntityDto
     */
    'items'?: Array<PoolItemCandidateEntityDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfPoolItemCandidateEntityDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfPoolItemDto
 */
export interface PaginationDtoOfPoolItemDto {
    /**
     * 
     * @type {Array<PoolItemDto>}
     * @memberof PaginationDtoOfPoolItemDto
     */
    'items'?: Array<PoolItemDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfPoolItemDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfProductLocationDto
 */
export interface PaginationDtoOfProductLocationDto {
    /**
     * 
     * @type {Array<ProductLocationDto>}
     * @memberof PaginationDtoOfProductLocationDto
     */
    'items'?: Array<ProductLocationDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfProductLocationDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfRepairCatalogDto
 */
export interface PaginationDtoOfRepairCatalogDto {
    /**
     * 
     * @type {Array<RepairCatalogDto>}
     * @memberof PaginationDtoOfRepairCatalogDto
     */
    'items'?: Array<RepairCatalogDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfRepairCatalogDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfRepairMaterialDto
 */
export interface PaginationDtoOfRepairMaterialDto {
    /**
     * 
     * @type {Array<RepairMaterialDto>}
     * @memberof PaginationDtoOfRepairMaterialDto
     */
    'items'?: Array<RepairMaterialDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfRepairMaterialDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfRepairOperationDto
 */
export interface PaginationDtoOfRepairOperationDto {
    /**
     * 
     * @type {Array<RepairOperationDto>}
     * @memberof PaginationDtoOfRepairOperationDto
     */
    'items'?: Array<RepairOperationDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfRepairOperationDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfRepairSparePartDto
 */
export interface PaginationDtoOfRepairSparePartDto {
    /**
     * 
     * @type {Array<RepairSparePartDto>}
     * @memberof PaginationDtoOfRepairSparePartDto
     */
    'items'?: Array<RepairSparePartDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfRepairSparePartDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfRepairSpecDto
 */
export interface PaginationDtoOfRepairSpecDto {
    /**
     * 
     * @type {Array<RepairSpecDto>}
     * @memberof PaginationDtoOfRepairSpecDto
     */
    'items'?: Array<RepairSpecDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfRepairSpecDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfRepairWorkDto
 */
export interface PaginationDtoOfRepairWorkDto {
    /**
     * 
     * @type {Array<RepairWorkDto>}
     * @memberof PaginationDtoOfRepairWorkDto
     */
    'items'?: Array<RepairWorkDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfRepairWorkDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfSpotDto
 */
export interface PaginationDtoOfSpotDto {
    /**
     * 
     * @type {Array<SpotDto>}
     * @memberof PaginationDtoOfSpotDto
     */
    'items'?: Array<SpotDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfSpotDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfSubscriptionDto
 */
export interface PaginationDtoOfSubscriptionDto {
    /**
     * 
     * @type {Array<SubscriptionDto>}
     * @memberof PaginationDtoOfSubscriptionDto
     */
    'items'?: Array<SubscriptionDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfSubscriptionDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfSupplierDto
 */
export interface PaginationDtoOfSupplierDto {
    /**
     * 
     * @type {Array<SupplierDto>}
     * @memberof PaginationDtoOfSupplierDto
     */
    'items'?: Array<SupplierDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfSupplierDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfTItem
 */
export interface PaginationDtoOfTItem {
    /**
     * 
     * @type {Array<object>}
     * @memberof PaginationDtoOfTItem
     */
    'items'?: Array<object>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfTItem
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfTenantConnectionDto
 */
export interface PaginationDtoOfTenantConnectionDto {
    /**
     * 
     * @type {Array<TenantConnectionDto>}
     * @memberof PaginationDtoOfTenantConnectionDto
     */
    'items'?: Array<TenantConnectionDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfTenantConnectionDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfTenantConnectionRequestDto
 */
export interface PaginationDtoOfTenantConnectionRequestDto {
    /**
     * 
     * @type {Array<TenantConnectionRequestDto>}
     * @memberof PaginationDtoOfTenantConnectionRequestDto
     */
    'items'?: Array<TenantConnectionRequestDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfTenantConnectionRequestDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfTenantDto
 */
export interface PaginationDtoOfTenantDto {
    /**
     * 
     * @type {Array<TenantDto>}
     * @memberof PaginationDtoOfTenantDto
     */
    'items'?: Array<TenantDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfTenantDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfTenantInviteDto
 */
export interface PaginationDtoOfTenantInviteDto {
    /**
     * 
     * @type {Array<TenantInviteDto>}
     * @memberof PaginationDtoOfTenantInviteDto
     */
    'items'?: Array<TenantInviteDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfTenantInviteDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfTenantRequestDto
 */
export interface PaginationDtoOfTenantRequestDto {
    /**
     * 
     * @type {Array<TenantRequestDto>}
     * @memberof PaginationDtoOfTenantRequestDto
     */
    'items'?: Array<TenantRequestDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfTenantRequestDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfTenantWithStatsDto
 */
export interface PaginationDtoOfTenantWithStatsDto {
    /**
     * 
     * @type {Array<TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto>}
     * @memberof PaginationDtoOfTenantWithStatsDto
     */
    'items'?: Array<TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfTenantWithStatsDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfUserDto
 */
export interface PaginationDtoOfUserDto {
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof PaginationDtoOfUserDto
     */
    'items'?: Array<UserDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfUserDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfVehicleBodyTypeDto
 */
export interface PaginationDtoOfVehicleBodyTypeDto {
    /**
     * 
     * @type {Array<VehicleBodyTypeDto>}
     * @memberof PaginationDtoOfVehicleBodyTypeDto
     */
    'items'?: Array<VehicleBodyTypeDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfVehicleBodyTypeDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfVehicleDamageDto
 */
export interface PaginationDtoOfVehicleDamageDto {
    /**
     * 
     * @type {Array<VehicleDamageDto>}
     * @memberof PaginationDtoOfVehicleDamageDto
     */
    'items'?: Array<VehicleDamageDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfVehicleDamageDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfVehicleDto
 */
export interface PaginationDtoOfVehicleDto {
    /**
     * 
     * @type {Array<VehicleDto>}
     * @memberof PaginationDtoOfVehicleDto
     */
    'items'?: Array<VehicleDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfVehicleDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfVehicleFuelTypeDto
 */
export interface PaginationDtoOfVehicleFuelTypeDto {
    /**
     * 
     * @type {Array<VehicleFuelTypeDto>}
     * @memberof PaginationDtoOfVehicleFuelTypeDto
     */
    'items'?: Array<VehicleFuelTypeDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfVehicleFuelTypeDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfVehicleGenerationDto
 */
export interface PaginationDtoOfVehicleGenerationDto {
    /**
     * 
     * @type {Array<VehicleGenerationDto>}
     * @memberof PaginationDtoOfVehicleGenerationDto
     */
    'items'?: Array<VehicleGenerationDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfVehicleGenerationDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfVehicleHistoryItemDto
 */
export interface PaginationDtoOfVehicleHistoryItemDto {
    /**
     * 
     * @type {Array<VehicleHistoryItemDto>}
     * @memberof PaginationDtoOfVehicleHistoryItemDto
     */
    'items'?: Array<VehicleHistoryItemDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfVehicleHistoryItemDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfVehicleMakeDto
 */
export interface PaginationDtoOfVehicleMakeDto {
    /**
     * 
     * @type {Array<VehicleMakeDto>}
     * @memberof PaginationDtoOfVehicleMakeDto
     */
    'items'?: Array<VehicleMakeDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfVehicleMakeDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfVehicleModelDto
 */
export interface PaginationDtoOfVehicleModelDto {
    /**
     * 
     * @type {Array<VehicleModelDto>}
     * @memberof PaginationDtoOfVehicleModelDto
     */
    'items'?: Array<VehicleModelDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfVehicleModelDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfVehicleModificationDto
 */
export interface PaginationDtoOfVehicleModificationDto {
    /**
     * 
     * @type {Array<VehicleModificationDto>}
     * @memberof PaginationDtoOfVehicleModificationDto
     */
    'items'?: Array<VehicleModificationDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfVehicleModificationDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfVehiclePartTypeDto
 */
export interface PaginationDtoOfVehiclePartTypeDto {
    /**
     * 
     * @type {Array<VehiclePartTypeDto>}
     * @memberof PaginationDtoOfVehiclePartTypeDto
     */
    'items'?: Array<VehiclePartTypeDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfVehiclePartTypeDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfVehicleTypeDto
 */
export interface PaginationDtoOfVehicleTypeDto {
    /**
     * 
     * @type {Array<VehicleTypeDto>}
     * @memberof PaginationDtoOfVehicleTypeDto
     */
    'items'?: Array<VehicleTypeDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfVehicleTypeDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfVehicleVisualModelDto
 */
export interface PaginationDtoOfVehicleVisualModelDto {
    /**
     * 
     * @type {Array<VehicleVisualModelDto>}
     * @memberof PaginationDtoOfVehicleVisualModelDto
     */
    'items'?: Array<VehicleVisualModelDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfVehicleVisualModelDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfVisualInspectionDto
 */
export interface PaginationDtoOfVisualInspectionDto {
    /**
     * 
     * @type {Array<VisualInspectionDto>}
     * @memberof PaginationDtoOfVisualInspectionDto
     */
    'items'?: Array<VisualInspectionDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfVisualInspectionDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfWashDto
 */
export interface PaginationDtoOfWashDto {
    /**
     * 
     * @type {Array<WashDto>}
     * @memberof PaginationDtoOfWashDto
     */
    'items'?: Array<WashDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfWashDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfWebhookActivationDto
 */
export interface PaginationDtoOfWebhookActivationDto {
    /**
     * 
     * @type {Array<WebhookActivationDto>}
     * @memberof PaginationDtoOfWebhookActivationDto
     */
    'items'?: Array<WebhookActivationDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfWebhookActivationDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfWebhookDto
 */
export interface PaginationDtoOfWebhookDto {
    /**
     * 
     * @type {Array<WebhookDto>}
     * @memberof PaginationDtoOfWebhookDto
     */
    'items'?: Array<WebhookDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfWebhookDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfWheelOperationDto
 */
export interface PaginationDtoOfWheelOperationDto {
    /**
     * 
     * @type {Array<WheelOperationDto>}
     * @memberof PaginationDtoOfWheelOperationDto
     */
    'items'?: Array<WheelOperationDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfWheelOperationDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationInfoDto
 */
export interface PaginationInfoDto {
    /**
     * Total number of records in the requested dataset.
     * @type {number}
     * @memberof PaginationInfoDto
     */
    'totalCount'?: number;
    /**
     * Zero-based offset.
     * @type {number}
     * @memberof PaginationInfoDto
     */
    'offset'?: number;
    /**
     * The same as page size.
     * @type {number}
     * @memberof PaginationInfoDto
     */
    'limit'?: number;
    /**
     * Current page zero-based index.
     * @type {number}
     * @memberof PaginationInfoDto
     */
    'currentPage'?: number;
    /**
     * Total number of pages.
     * @type {number}
     * @memberof PaginationInfoDto
     */
    'totalPages'?: number;
}
/**
 * 
 * @export
 * @interface PairDtoOfStringAndString
 */
export interface PairDtoOfStringAndString {
    /**
     * 
     * @type {string}
     * @memberof PairDtoOfStringAndString
     */
    'first'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PairDtoOfStringAndString
     */
    'second'?: string | null;
}
/**
 * 
 * @export
 * @interface ParentTestSwaggerClass
 */
export interface ParentTestSwaggerClass {
    /**
     * 
     * @type {object}
     * @memberof ParentTestSwaggerClass
     */
    'generic1'?: object;
    /**
     * 
     * @type {object}
     * @memberof ParentTestSwaggerClass
     */
    'generic2'?: object;
}
/**
 * 
 * @export
 * @interface PartyAndMemberDto
 */
export interface PartyAndMemberDto {
    /**
     * 
     * @type {PartyDto}
     * @memberof PartyAndMemberDto
     */
    'party'?: PartyDto;
    /**
     * 
     * @type {PartyMemberReferenceDto}
     * @memberof PartyAndMemberDto
     */
    'member'?: PartyMemberReferenceDto;
}
/**
 * 
 * @export
 * @interface PartyAndMemberReferenceDto
 */
export interface PartyAndMemberReferenceDto {
    /**
     * 
     * @type {PartyReferenceDto}
     * @memberof PartyAndMemberReferenceDto
     */
    'party'?: PartyReferenceDto;
    /**
     * 
     * @type {PartyMemberReferenceDto}
     * @memberof PartyAndMemberReferenceDto
     */
    'member'?: PartyMemberReferenceDto;
}
/**
 * 
 * @export
 * @interface PartyChangedDto
 */
export interface PartyChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof PartyChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof PartyChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof PartyChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof PartyChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof PartyChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {PartyDto}
     * @memberof PartyChangedDto
     */
    'entity': PartyDto;
    /**
     * 
     * @type {string}
     * @memberof PartyChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface PartyDto
 */
export interface PartyDto {
    /**
     * 
     * @type {string}
     * @memberof PartyDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {PartyReferenceDto}
     * @memberof PartyDto
     */
    'parentParty'?: PartyReferenceDto;
    /**
     * 
     * @type {PartySourceDto}
     * @memberof PartyDto
     */
    'source'?: PartySourceDto;
    /**
     * 
     * @type {PartyType}
     * @memberof PartyDto
     */
    'type'?: PartyType;
    /**
     * 
     * @type {string}
     * @memberof PartyDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartyDto
     */
    'memberCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PartyDto
     */
    'isSystem'?: boolean;
}


/**
 * 
 * @export
 * @interface PartyEntity
 */
export interface PartyEntity {
    /**
     * 
     * @type {string}
     * @memberof PartyEntity
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof PartyEntity
     */
    'formTypeOrDefault'?: EntityFormType;
    /**
     * 
     * @type {EntityFormType}
     * @memberof PartyEntity
     */
    'formType'?: EntityFormType;
    /**
     * When the entity was created.
     * @type {string}
     * @memberof PartyEntity
     */
    'createdAt'?: string;
    /**
     * When the entity was updated last time.
     * @type {string}
     * @memberof PartyEntity
     */
    'updatedAt'?: string;
    /**
     * Id of user who created the entity.
     * @type {string}
     * @memberof PartyEntity
     */
    'createdBy'?: string | null;
    /**
     * Id of user who updated the entity last time.
     * @type {string}
     * @memberof PartyEntity
     */
    'updatedBy'?: string | null;
    /**
     * Is updated manually by user.
     * @type {boolean}
     * @memberof PartyEntity
     */
    'isUpdatedManually'?: boolean;
    /**
     * Is updated by the system or manually by unknown user.
     * @type {boolean}
     * @memberof PartyEntity
     */
    'isUpdatedBySystemOrUnknown'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartyEntity
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {PartyReference}
     * @memberof PartyEntity
     */
    'parentParty'?: PartyReference;
    /**
     * 
     * @type {PartySource}
     * @memberof PartyEntity
     */
    'source'?: PartySource;
    /**
     * 
     * @type {PartyType}
     * @memberof PartyEntity
     */
    'type'?: PartyType;
    /**
     * 
     * @type {string}
     * @memberof PartyEntity
     */
    'name'?: string;
    /**
     * Whether to infer members based on party type or use stored member list.  E.g. members can be inferred from tenant or department.
     * @type {boolean}
     * @memberof PartyEntity
     */
    'isInferMembers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartyEntity
     */
    'allowAddMembers'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PartyEntity
     */
    'memberCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PartyEntity
     */
    'isSystem'?: boolean;
}


/**
 * 
 * @export
 * @interface PartyMemberChangedDto
 */
export interface PartyMemberChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof PartyMemberChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof PartyMemberChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof PartyMemberChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {PartyMemberDto}
     * @memberof PartyMemberChangedDto
     */
    'entity': PartyMemberDto;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface PartyMemberDto
 */
export interface PartyMemberDto {
    /**
     * 
     * @type {string}
     * @memberof PartyMemberDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {PartyReferenceDto}
     * @memberof PartyMemberDto
     */
    'party'?: PartyReferenceDto;
    /**
     * 
     * @type {PartyMemberSourceDto}
     * @memberof PartyMemberDto
     */
    'source'?: PartyMemberSourceDto;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {UserMembershipType}
     * @memberof PartyMemberDto
     */
    'membershipType'?: UserMembershipType;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PartyMemberDto
     */
    'isSystem'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberDto
     */
    'comparisonId'?: string;
}


/**
 * 
 * @export
 * @interface PartyMemberReferenceDto
 */
export interface PartyMemberReferenceDto {
    /**
     * 
     * @type {PartyReferenceDto}
     * @memberof PartyMemberReferenceDto
     */
    'party'?: PartyReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberReferenceDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PartyMemberReferenceDto
     */
    'isInferred'?: boolean;
    /**
     * 
     * @type {PartyMemberSourceDto}
     * @memberof PartyMemberReferenceDto
     */
    'source'?: PartyMemberSourceDto;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberReferenceDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberReferenceDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberReferenceDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PartyMemberReferenceDto
     */
    'isSystem'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberReferenceDto
     */
    'comparisonId'?: string;
}
/**
 * 
 * @export
 * @interface PartyMemberSourceDto
 */
export interface PartyMemberSourceDto {
    /**
     * 
     * @type {PartyMemberSourceType}
     * @memberof PartyMemberSourceDto
     */
    'sourceType'?: PartyMemberSourceType;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberSourceDto
     */
    'sourceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberSourceDto
     */
    'systemIdentifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberSourceDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberSourceDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberSourceDto
     */
    'customerContactId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartyMemberSourceDto
     */
    'customerUserId'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PartyMemberSourceType = {
    None: 'None',
    System: 'System',
    TenantUser: 'TenantUser',
    DepartmentUser: 'DepartmentUser',
    User: 'User',
    UserGroupUser: 'UserGroupUser',
    CustomerContact: 'CustomerContact',
    CustomerContactUser: 'CustomerContactUser'
} as const;

export type PartyMemberSourceType = typeof PartyMemberSourceType[keyof typeof PartyMemberSourceType];


/**
 * 
 * @export
 * @interface PartyReference
 */
export interface PartyReference {
    /**
     * 
     * @type {string}
     * @memberof PartyReference
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof PartyReference
     */
    'formTypeOrDefault'?: EntityFormType;
    /**
     * 
     * @type {EntityFormType}
     * @memberof PartyReference
     */
    'formType'?: EntityFormType;
    /**
     * 
     * @type {string}
     * @memberof PartyReference
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {PartyType}
     * @memberof PartyReference
     */
    'type'?: PartyType;
    /**
     * 
     * @type {string}
     * @memberof PartyReference
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartyReference
     */
    'isSystem'?: boolean;
}


/**
 * 
 * @export
 * @interface PartyReferenceDto
 */
export interface PartyReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof PartyReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {PartyType}
     * @memberof PartyReferenceDto
     */
    'type'?: PartyType;
    /**
     * 
     * @type {string}
     * @memberof PartyReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartyReferenceDto
     */
    'isSystem'?: boolean;
}


/**
 * 
 * @export
 * @interface PartySource
 */
export interface PartySource {
    /**
     * 
     * @type {PartySourceType}
     * @memberof PartySource
     */
    'sourceType'?: PartySourceType;
    /**
     * Id of source object/entity the party is associated with. Can be any unique string.
     * @type {string}
     * @memberof PartySource
     */
    'sourceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartySource
     */
    'systemIdentifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartySource
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartySource
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartySource
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartySource
     */
    'userGroupIdentifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartySource
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PartySource
     */
    'sourceIdIsObjectId'?: boolean;
}


/**
 * 
 * @export
 * @interface PartySourceDto
 */
export interface PartySourceDto {
    /**
     * 
     * @type {PartySourceType}
     * @memberof PartySourceDto
     */
    'sourceType'?: PartySourceType;
    /**
     * 
     * @type {string}
     * @memberof PartySourceDto
     */
    'sourceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartySourceDto
     */
    'systemIdentifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartySourceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartySourceDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartySourceDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartySourceDto
     */
    'userGroupIdentifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartySourceDto
     */
    'customerId'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PartySourceType = {
    None: 'None',
    System: 'System',
    Tenant: 'Tenant',
    Department: 'Department',
    User: 'User',
    UserGroup: 'UserGroup',
    Customer: 'Customer'
} as const;

export type PartySourceType = typeof PartySourceType[keyof typeof PartySourceType];


/**
 * 
 * @export
 * @enum {string}
 */

export const PartyType = {
    None: 'None',
    System: 'System',
    Tenant: 'Tenant',
    Department: 'Department',
    User: 'User',
    UserGroup: 'UserGroup',
    Customer: 'Customer'
} as const;

export type PartyType = typeof PartyType[keyof typeof PartyType];


/**
 * 
 * @export
 * @interface PasswordPolicyDto
 */
export interface PasswordPolicyDto {
    /**
     * 
     * @type {number}
     * @memberof PasswordPolicyDto
     */
    'minLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof PasswordPolicyDto
     */
    'maxLength'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordPolicyDto
     */
    'withNumbers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordPolicyDto
     */
    'withUpperCase'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordPolicyDto
     */
    'withLowerCase'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordPolicyDto
     */
    'withSpecialChars'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PasswordPolicyDto
     */
    'allowedSpecialChars'?: string;
}
/**
 * 
 * @export
 * @interface PasswordValidateResultDto
 */
export interface PasswordValidateResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof PasswordValidateResultDto
     */
    'isValid'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordValidateResultDto
     */
    'minLength'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordValidateResultDto
     */
    'maxLength'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordValidateResultDto
     */
    'withNumbers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordValidateResultDto
     */
    'withUpperCase'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordValidateResultDto
     */
    'withLowerCase'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordValidateResultDto
     */
    'withSpecialChars'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PasswordValidateResultDto
     */
    'allowedSpecialChars'?: string;
}
/**
 * 
 * @export
 * @interface PaymentBusinessInfoDto
 */
export interface PaymentBusinessInfoDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentBusinessInfoDto
     */
    'businessName'?: string;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof PaymentBusinessInfoDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof PaymentBusinessInfoDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentBusinessInfoDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {GeneralAddressDto}
     * @memberof PaymentBusinessInfoDto
     */
    'address'?: GeneralAddressDto;
}
/**
 * 
 * @export
 * @interface PaymentBusinessInfoInputDto
 */
export interface PaymentBusinessInfoInputDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentBusinessInfoInputDto
     */
    'businessName'?: string;
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof PaymentBusinessInfoInputDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof PaymentBusinessInfoInputDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentBusinessInfoInputDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {GeneralAddressInputDto}
     * @memberof PaymentBusinessInfoInputDto
     */
    'address'?: GeneralAddressInputDto;
}
/**
 * 
 * @export
 * @interface PaymentContactDto
 */
export interface PaymentContactDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentContactDto
     */
    'id'?: string;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof PaymentContactDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof PaymentContactDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentContactDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentContactDto
     */
    'isPrimary'?: boolean;
}
/**
 * 
 * @export
 * @interface PaymentContactInputDto
 */
export interface PaymentContactInputDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentContactInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof PaymentContactInputDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof PaymentContactInputDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentContactInputDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentContactInputDto
     */
    'isPrimary'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentMethod = {
    None: 'None',
    Manual: 'Manual',
    Stripe: 'Stripe'
} as const;

export type PaymentMethod = typeof PaymentMethod[keyof typeof PaymentMethod];


/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentRegularityType = {
    None: 'None',
    OneTime: 'OneTime',
    Recurring: 'Recurring'
} as const;

export type PaymentRegularityType = typeof PaymentRegularityType[keyof typeof PaymentRegularityType];


/**
 * Represents common types of actions we’d assign permissions for.  Base detailed actions: Read, Create, Update, Delete.  Base simplified actions: Read, Manage.
 * @export
 * @enum {string}
 */

export const PermissionAction = {
    None: 'None',
    Read: 'Read',
    Manage: 'Manage',
    Create: 'Create',
    Update: 'Update',
    Delete: 'Delete',
    Access: 'Access',
    Verify: 'Verify',
    Perform: 'Perform'
} as const;

export type PermissionAction = typeof PermissionAction[keyof typeof PermissionAction];


/**
 * Functional groups of permissions for better UX.
 * @export
 * @enum {string}
 */

export const PermissionFunctionalGroup = {
    None: 'None',
    AccessControl: 'AccessControl',
    FleetManagement: 'FleetManagement',
    Operations: 'Operations',
    Repair: 'Repair',
    Communication: 'Communication',
    Product: 'Product',
    TenantManagement: 'TenantManagement',
    TenantToTenant: 'TenantToTenant',
    ImportExport: 'ImportExport',
    Integration: 'Integration',
    Admin: 'Admin',
    Other: 'Other',
    Test: 'Test'
} as const;

export type PermissionFunctionalGroup = typeof PermissionFunctionalGroup[keyof typeof PermissionFunctionalGroup];


/**
 * 
 * @export
 * @interface PermissionFunctionalGroupMetaDto
 */
export interface PermissionFunctionalGroupMetaDto {
    /**
     * 
     * @type {PermissionFunctionalGroup}
     * @memberof PermissionFunctionalGroupMetaDto
     */
    'value': PermissionFunctionalGroup;
    /**
     * 
     * @type {number}
     * @memberof PermissionFunctionalGroupMetaDto
     */
    'sortOrder': number;
}


/**
 * Small logical groups of permissions for better UX.
 * @export
 * @enum {string}
 */

export const PermissionGroup = {
    None: 'None',
    AppAccess: 'AppAccess',
    Role: 'Role',
    Invite: 'Invite',
    Dashboard: 'Dashboard',
    Vehicle: 'Vehicle',
    VehicleDamage: 'VehicleDamage',
    Customer: 'Customer',
    Contract: 'Contract',
    Accessory: 'Accessory',
    Supplier: 'Supplier',
    CustomTag: 'CustomTag',
    GeneralHistory: 'GeneralHistory',
    GeneralStatusHistory: 'GeneralStatusHistory',
    AssessmentFlow: 'AssessmentFlow',
    Flow: 'Flow',
    Assignment: 'Assignment',
    Charge: 'Charge',
    Document: 'Document',
    VisualInspection: 'VisualInspection',
    DamageDetection: 'DamageDetection',
    DamageCostEvaluation: 'DamageCostEvaluation',
    AccessoryCheck: 'AccessoryCheck',
    RepairOperation: 'RepairOperation',
    Wash: 'Wash',
    Maintenance: 'Maintenance',
    WheelOperation: 'WheelOperation',
    RepairCatalog: 'RepairCatalog',
    ProductLocation: 'ProductLocation',
    AssetSubscriptionPlan: 'AssetSubscriptionPlan',
    AssetSubscription: 'AssetSubscription',
    Pool: 'Pool',
    Asset: 'Asset',
    Tenant: 'Tenant',
    User: 'User',
    Department: 'Department',
    Location: 'Location',
    Spot: 'Spot',
    TenantSubscription: 'TenantSubscription',
    Invoice: 'Invoice',
    Chat: 'Chat',
    Negotiation: 'Negotiation',
    TenantConnection: 'TenantConnection',
    TenantRequest: 'TenantRequest',
    DataGrant: 'DataGrant',
    Import: 'Import',
    Export: 'Export',
    Webhook: 'Webhook',
    IntegrationApiClient: 'IntegrationApiClient',
    TeslaConnection: 'TeslaConnection',
    Admin: 'Admin',
    Other: 'Other',
    Test: 'Test',
    TestModule: 'TestModule'
} as const;

export type PermissionGroup = typeof PermissionGroup[keyof typeof PermissionGroup];


/**
 * 
 * @export
 * @interface PermissionGroupMetaDto
 */
export interface PermissionGroupMetaDto {
    /**
     * 
     * @type {PermissionGroup}
     * @memberof PermissionGroupMetaDto
     */
    'value': PermissionGroup;
    /**
     * 
     * @type {number}
     * @memberof PermissionGroupMetaDto
     */
    'sortOrder': number;
}


/**
 * 
 * @export
 * @interface PermissionMetaDto
 */
export interface PermissionMetaDto {
    /**
     * 
     * @type {AppPermission}
     * @memberof PermissionMetaDto
     */
    'value': AppPermission;
    /**
     * 
     * @type {string}
     * @memberof PermissionMetaDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PermissionMetaDto
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof PermissionMetaDto
     */
    'sortOrder': number | null;
    /**
     * 
     * @type {PermissionGroupMetaDto}
     * @memberof PermissionMetaDto
     */
    'groupMeta': PermissionGroupMetaDto;
    /**
     * 
     * @type {PermissionFunctionalGroupMetaDto}
     * @memberof PermissionMetaDto
     */
    'funcGroupMeta': PermissionFunctionalGroupMetaDto;
    /**
     * 
     * @type {PermissionAction}
     * @memberof PermissionMetaDto
     */
    'action': PermissionAction;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionMetaDto
     */
    'isObsolete': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionMetaDto
     */
    'isTest': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionMetaDto
     */
    'isAppAccess': boolean;
}


/**
 * Represents info about deleting user/customer personal data initiated by an user (employee), potentially in response to a user/customer inquiry.
 * @export
 * @interface PersonalDataDeleteDto
 */
export interface PersonalDataDeleteDto {
    /**
     * 
     * @type {PersonalDataDeletionReasonType}
     * @memberof PersonalDataDeleteDto
     */
    'reasonType'?: PersonalDataDeletionReasonType;
    /**
     * Required if Other.
     * @type {string}
     * @memberof PersonalDataDeleteDto
     */
    'reason'?: string | null;
    /**
     * Date when the inquiry was received.
     * @type {string}
     * @memberof PersonalDataDeleteDto
     */
    'inquiryDate'?: string | null;
    /**
     * Attachments related to the deletion inquiry, such as screenshots or PDFs.
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof PersonalDataDeleteDto
     */
    'inquiryAttachments'?: Array<GeneralAttachmentInputDto> | null;
}


/**
 * Represents info about deleting user/customer personal data initiated by an user (employee), potentially in response to a user/customer inquiry.
 * @export
 * @interface PersonalDataDeletionDto
 */
export interface PersonalDataDeletionDto {
    /**
     * 
     * @type {string}
     * @memberof PersonalDataDeletionDto
     */
    'id'?: string;
    /**
     * 
     * @type {PersonalDataDeletionReasonType}
     * @memberof PersonalDataDeletionDto
     */
    'reasonType'?: PersonalDataDeletionReasonType;
    /**
     * Required if Other.
     * @type {string}
     * @memberof PersonalDataDeletionDto
     */
    'reason'?: string | null;
    /**
     * Date when the inquiry was received.
     * @type {string}
     * @memberof PersonalDataDeletionDto
     */
    'inquiryDate'?: string | null;
    /**
     * Attachments related to the deletion inquiry, such as screenshots or PDFs.
     * @type {Array<GeneralAttachmentDto>}
     * @memberof PersonalDataDeletionDto
     */
    'inquiryAttachments'?: Array<GeneralAttachmentDto> | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof PersonalDataDeletionDto
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDataDeletionDto
     */
    'deletedBy'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PersonalDataDeletionReasonType = {
    None: 'None',
    CustomerInquiry: 'CustomerInquiry',
    Other: 'Other'
} as const;

export type PersonalDataDeletionReasonType = typeof PersonalDataDeletionReasonType[keyof typeof PersonalDataDeletionReasonType];


/**
 * 
 * @export
 * @interface PoolAvailabilityDto
 */
export interface PoolAvailabilityDto {
    /**
     * 
     * @type {PoolStateDto}
     * @memberof PoolAvailabilityDto
     */
    'state'?: PoolStateDto;
    /**
     * 
     * @type {number}
     * @memberof PoolAvailabilityDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolAvailabilityDto
     */
    'requestedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolAvailabilityDto
     */
    'otherCount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolAvailabilityDto
     */
    'requestedItemIds'?: Array<string> | null;
    /**
     * 
     * @type {PoolDto}
     * @memberof PoolAvailabilityDto
     */
    'pool'?: PoolDto;
}
/**
 * 
 * @export
 * @interface PoolChangedDto
 */
export interface PoolChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof PoolChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof PoolChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof PoolChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof PoolChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {PoolDto}
     * @memberof PoolChangedDto
     */
    'entity': PoolDto;
    /**
     * 
     * @type {string}
     * @memberof PoolChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface PoolCreateDto
 */
export interface PoolCreateDto {
    /**
     * 
     * @type {string}
     * @memberof PoolCreateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolCreateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {PoolStructureType}
     * @memberof PoolCreateDto
     */
    'structureType'?: PoolStructureType;
    /**
     * 
     * @type {PoolItemType}
     * @memberof PoolCreateDto
     */
    'itemType'?: PoolItemType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof PoolCreateDto
     */
    'itemEntityType'?: PoolItemEntityType;
    /**
     * 
     * @type {Array<PoolItemEntityType>}
     * @memberof PoolCreateDto
     */
    'itemEntityTypes'?: Array<PoolItemEntityType> | null;
    /**
     * 
     * @type {GeneralEntitySubTypeInputDto}
     * @memberof PoolCreateDto
     */
    'itemEntitySubType'?: GeneralEntitySubTypeInputDto;
    /**
     * 
     * @type {PoolSettingsInputDto}
     * @memberof PoolCreateDto
     */
    'settings'?: PoolSettingsInputDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolCreateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolCreateDto
     */
    'locationIds'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface PoolDto
 */
export interface PoolDto {
    /**
     * 
     * @type {string}
     * @memberof PoolDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof PoolDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof PoolDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof PoolDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof PoolDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {PoolStructureType}
     * @memberof PoolDto
     */
    'structureType'?: PoolStructureType;
    /**
     * 
     * @type {PoolItemType}
     * @memberof PoolDto
     */
    'itemType'?: PoolItemType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof PoolDto
     */
    'itemEntityType'?: PoolItemEntityType;
    /**
     * 
     * @type {Array<PoolItemEntityType>}
     * @memberof PoolDto
     */
    'itemEntityTypes'?: Array<PoolItemEntityType> | null;
    /**
     * 
     * @type {GeneralEntitySubTypeDto}
     * @memberof PoolDto
     */
    'itemEntitySubType'?: GeneralEntitySubTypeDto;
    /**
     * 
     * @type {PoolSettingsDto}
     * @memberof PoolDto
     */
    'settings'?: PoolSettingsDto;
    /**
     * 
     * @type {PoolStateDto}
     * @memberof PoolDto
     */
    'state'?: PoolStateDto;
}


/**
 * Entity pool.  Pool serves as a medium for accounting for elements that belong to it.
 * @export
 * @interface PoolEntity
 */
export interface PoolEntity {
    /**
     * 
     * @type {string}
     * @memberof PoolEntity
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof PoolEntity
     */
    'formTypeOrDefault'?: EntityFormType;
    /**
     * 
     * @type {EntityFormType}
     * @memberof PoolEntity
     */
    'formType'?: EntityFormType;
    /**
     * When the entity was created.
     * @type {string}
     * @memberof PoolEntity
     */
    'createdAt'?: string;
    /**
     * When the entity was updated last time.
     * @type {string}
     * @memberof PoolEntity
     */
    'updatedAt'?: string;
    /**
     * Id of user who created the entity.
     * @type {string}
     * @memberof PoolEntity
     */
    'createdBy'?: string | null;
    /**
     * Id of user who updated the entity last time.
     * @type {string}
     * @memberof PoolEntity
     */
    'updatedBy'?: string | null;
    /**
     * Is updated manually by user.
     * @type {boolean}
     * @memberof PoolEntity
     */
    'isUpdatedManually'?: boolean;
    /**
     * Is updated by the system or manually by unknown user.
     * @type {boolean}
     * @memberof PoolEntity
     */
    'isUpdatedBySystemOrUnknown'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PoolEntity
     */
    'isDeleted'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof PoolEntity
     */
    'deletedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof PoolEntity
     */
    'restoredAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolEntity
     */
    'deletedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolEntity
     */
    'restoredBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolEntity
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolEntity
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolEntity
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof PoolEntity
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolEntity
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolEntity
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolEntity
     */
    'description'?: string | null;
    /**
     * 
     * @type {PoolStructureType}
     * @memberof PoolEntity
     */
    'structureType'?: PoolStructureType;
    /**
     * 
     * @type {PoolItemType}
     * @memberof PoolEntity
     */
    'itemType'?: PoolItemType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof PoolEntity
     */
    'itemEntityType'?: PoolItemEntityType;
    /**
     * Must be set if Diverse.
     * @type {Array<PoolItemEntityType>}
     * @memberof PoolEntity
     */
    'itemEntityTypes'?: Array<PoolItemEntityType> | null;
    /**
     * 
     * @type {GeneralEntitySubType}
     * @memberof PoolEntity
     */
    'itemEntitySubType'?: GeneralEntitySubType;
    /**
     * 
     * @type {PoolSettings}
     * @memberof PoolEntity
     */
    'settings'?: PoolSettings;
    /**
     * 
     * @type {PoolSettings}
     * @memberof PoolEntity
     */
    'prevSettings'?: PoolSettings;
    /**
     * 
     * @type {PoolState}
     * @memberof PoolEntity
     */
    'state'?: PoolState;
    /**
     * General spec of assets in the pool.  Specific assets might have different specs.
     * @type {Array<PoolItemEntityType>}
     * @memberof PoolEntity
     */
    'allItemEntityTypes'?: Array<PoolItemEntityType>;
    /**
     * 
     * @type {PoolEntityItemEntityTypesMap}
     * @memberof PoolEntity
     */
    'itemEntityTypesMap'?: PoolEntityItemEntityTypesMap;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof PoolEntity
     */
    'departmentIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof PoolEntity
     */
    'locationIdsMap'?: { [key: string]: boolean; };
}


/**
 * 
 * @export
 * @interface PoolEntityItemEntityTypesMap
 */
export interface PoolEntityItemEntityTypesMap {
    /**
     * 
     * @type {boolean}
     * @memberof PoolEntityItemEntityTypesMap
     */
    'None'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PoolEntityItemEntityTypesMap
     */
    'Asset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PoolEntityItemEntityTypesMap
     */
    'Vehicle'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PoolEntityItemEntityTypesMap
     */
    'Accessory'?: boolean;
}
/**
 * 
 * @export
 * @interface PoolGetPaginatedDto
 */
export interface PoolGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof PoolGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof PoolGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof PoolGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof PoolGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof PoolGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {PoolStructureType}
     * @memberof PoolGetPaginatedDto
     */
    'structureType'?: PoolStructureType;
    /**
     * 
     * @type {PoolItemType}
     * @memberof PoolGetPaginatedDto
     */
    'itemType'?: PoolItemType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof PoolGetPaginatedDto
     */
    'itemEntityType'?: PoolItemEntityType;
    /**
     * 
     * @type {Array<PoolItemEntityType>}
     * @memberof PoolGetPaginatedDto
     */
    'itemEntityTypes'?: Array<PoolItemEntityType> | null;
    /**
     * 
     * @type {Array<PoolItemEntityType>}
     * @memberof PoolGetPaginatedDto
     */
    'anyItemEntityTypes'?: Array<PoolItemEntityType> | null;
    /**
     * 
     * @type {EntityType}
     * @memberof PoolGetPaginatedDto
     */
    'itemEntitySubType'?: EntityType;
    /**
     * 
     * @type {Array<EntityType>}
     * @memberof PoolGetPaginatedDto
     */
    'anyItemEntitySubTypes'?: Array<EntityType> | null;
}


/**
 * 
 * @export
 * @interface PoolItemCandidateEntityDto
 */
export interface PoolItemCandidateEntityDto {
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof PoolItemCandidateEntityDto
     */
    'entityType'?: PoolItemEntityType;
    /**
     * 
     * @type {VehicleDto}
     * @memberof PoolItemCandidateEntityDto
     */
    'vehicle'?: VehicleDto;
    /**
     * 
     * @type {AccessoryDto}
     * @memberof PoolItemCandidateEntityDto
     */
    'accessory'?: AccessoryDto;
    /**
     * 
     * @type {AssetDto}
     * @memberof PoolItemCandidateEntityDto
     */
    'asset'?: AssetDto;
    /**
     * 
     * @type {string}
     * @memberof PoolItemCandidateEntityDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolItemCandidateEntityDto
     */
    'id'?: string;
}


/**
 * 
 * @export
 * @interface PoolItemCandidateEntityInputDto
 */
export interface PoolItemCandidateEntityInputDto {
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof PoolItemCandidateEntityInputDto
     */
    'entityType'?: PoolItemEntityType;
    /**
     * 
     * @type {string}
     * @memberof PoolItemCandidateEntityInputDto
     */
    'entityId'?: string;
}


/**
 * 
 * @export
 * @interface PoolItemChangedDto
 */
export interface PoolItemChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolItemChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof PoolItemChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof PoolItemChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof PoolItemChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof PoolItemChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {PoolItemDto}
     * @memberof PoolItemChangedDto
     */
    'entity': PoolItemDto;
    /**
     * 
     * @type {string}
     * @memberof PoolItemChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface PoolItemCreateDto
 */
export interface PoolItemCreateDto {
    /**
     * 
     * @type {PoolItemType}
     * @memberof PoolItemCreateDto
     */
    'type'?: PoolItemType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof PoolItemCreateDto
     */
    'entityType'?: PoolItemEntityType;
    /**
     * 
     * @type {GeneralEntitySubTypeInputDto}
     * @memberof PoolItemCreateDto
     */
    'entitySubType'?: GeneralEntitySubTypeInputDto;
    /**
     * 
     * @type {PoolItemStatus}
     * @memberof PoolItemCreateDto
     */
    'status'?: PoolItemStatus;
    /**
     * 
     * @type {string}
     * @memberof PoolItemCreateDto
     */
    'statusReason'?: string | null;
    /**
     * 
     * @type {PoolItemCandidateEntityInputDto}
     * @memberof PoolItemCreateDto
     */
    'entity'?: PoolItemCandidateEntityInputDto;
    /**
     * 
     * @type {PoolItemSettingsInputDto}
     * @memberof PoolItemCreateDto
     */
    'settings'?: PoolItemSettingsInputDto;
}


/**
 * 
 * @export
 * @interface PoolItemCreateManyDto
 */
export interface PoolItemCreateManyDto {
    /**
     * 
     * @type {Array<PoolItemCreateDto>}
     * @memberof PoolItemCreateManyDto
     */
    'items'?: Array<PoolItemCreateDto>;
}
/**
 * 
 * @export
 * @interface PoolItemDto
 */
export interface PoolItemDto {
    /**
     * 
     * @type {string}
     * @memberof PoolItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof PoolItemDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof PoolItemDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof PoolItemDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolItemDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolItemDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolItemDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolItemDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolItemDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof PoolItemDto
     */
    'poolId'?: string;
    /**
     * 
     * @type {PoolItemType}
     * @memberof PoolItemDto
     */
    'type'?: PoolItemType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof PoolItemDto
     */
    'entityType'?: PoolItemEntityType;
    /**
     * 
     * @type {GeneralEntitySubTypeDto}
     * @memberof PoolItemDto
     */
    'entitySubType'?: GeneralEntitySubTypeDto;
    /**
     * 
     * @type {PoolItemStatus}
     * @memberof PoolItemDto
     */
    'status'?: PoolItemStatus;
    /**
     * 
     * @type {string}
     * @memberof PoolItemDto
     */
    'statusReason'?: string | null;
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof PoolItemDto
     */
    'entity'?: GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof PoolItemDto
     */
    'usedByEntity'?: GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {PoolItemSettingsDto}
     * @memberof PoolItemDto
     */
    'settings'?: PoolItemSettingsDto;
    /**
     * 
     * @type {string}
     * @memberof PoolItemDto
     */
    'itemId'?: string;
}


/**
 * Describes entity types that are suitable for pools.  Must contain only values from EntityType.
 * @export
 * @enum {string}
 */

export const PoolItemEntityType = {
    None: 'None',
    Asset: 'Asset',
    Vehicle: 'Vehicle',
    Accessory: 'Accessory'
} as const;

export type PoolItemEntityType = typeof PoolItemEntityType[keyof typeof PoolItemEntityType];


/**
 * 
 * @export
 * @interface PoolItemFullReferenceDto
 */
export interface PoolItemFullReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof PoolItemFullReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolItemFullReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolItemFullReferenceDto
     */
    'poolId'?: string;
    /**
     * 
     * @type {PoolItemType}
     * @memberof PoolItemFullReferenceDto
     */
    'type'?: PoolItemType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof PoolItemFullReferenceDto
     */
    'entityType'?: PoolItemEntityType;
    /**
     * 
     * @type {GeneralEntitySubTypeDto}
     * @memberof PoolItemFullReferenceDto
     */
    'entitySubType'?: GeneralEntitySubTypeDto;
    /**
     * 
     * @type {PoolItemStatus}
     * @memberof PoolItemFullReferenceDto
     */
    'status'?: PoolItemStatus;
    /**
     * 
     * @type {string}
     * @memberof PoolItemFullReferenceDto
     */
    'statusReason'?: string | null;
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof PoolItemFullReferenceDto
     */
    'entity'?: GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof PoolItemFullReferenceDto
     */
    'usedByEntity'?: GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {PoolItemSettingsDto}
     * @memberof PoolItemFullReferenceDto
     */
    'settings'?: PoolItemSettingsDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof PoolItemFullReferenceDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof PoolItemFullReferenceDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolItemFullReferenceDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolItemFullReferenceDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolItemFullReferenceDto
     */
    'itemId'?: string;
}


/**
 * 
 * @export
 * @interface PoolItemGetPaginatedDto
 */
export interface PoolItemGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof PoolItemGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolItemGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof PoolItemGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolItemGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolItemGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolItemGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof PoolItemGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof PoolItemGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof PoolItemGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {PoolItemType}
     * @memberof PoolItemGetPaginatedDto
     */
    'type'?: PoolItemType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof PoolItemGetPaginatedDto
     */
    'entityType'?: PoolItemEntityType;
    /**
     * 
     * @type {EntityType}
     * @memberof PoolItemGetPaginatedDto
     */
    'entitySubType'?: EntityType;
    /**
     * 
     * @type {PoolItemStatus}
     * @memberof PoolItemGetPaginatedDto
     */
    'status'?: PoolItemStatus;
}


/**
 * 
 * @export
 * @interface PoolItemMeta
 */
export interface PoolItemMeta {
    /**
     * 
     * @type {string}
     * @memberof PoolItemMeta
     */
    'poolId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolItemMeta
     */
    'poolItemId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PoolItemMeta
     */
    'isEnsureEntityBelongToSinglePool'?: boolean;
}
/**
 * 
 * @export
 * @interface PoolItemReferenceDto
 */
export interface PoolItemReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof PoolItemReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolItemReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolItemReferenceDto
     */
    'poolId'?: string;
    /**
     * 
     * @type {PoolItemType}
     * @memberof PoolItemReferenceDto
     */
    'type'?: PoolItemType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof PoolItemReferenceDto
     */
    'entityType'?: PoolItemEntityType;
}


/**
 * 
 * @export
 * @interface PoolItemSearchPaginatedDto
 */
export interface PoolItemSearchPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof PoolItemSearchPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolItemSearchPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof PoolItemSearchPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolItemSearchPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolItemSearchPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolItemSearchPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof PoolItemSearchPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof PoolItemSearchPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof PoolItemSearchPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {PoolItemType}
     * @memberof PoolItemSearchPaginatedDto
     */
    'type'?: PoolItemType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof PoolItemSearchPaginatedDto
     */
    'entityType'?: PoolItemEntityType;
    /**
     * 
     * @type {EntityType}
     * @memberof PoolItemSearchPaginatedDto
     */
    'entitySubType'?: EntityType;
    /**
     * 
     * @type {PoolItemStatus}
     * @memberof PoolItemSearchPaginatedDto
     */
    'status'?: PoolItemStatus;
}


/**
 * 
 * @export
 * @interface PoolItemSettingsDto
 */
export interface PoolItemSettingsDto {
    /**
     * 
     * @type {boolean}
     * @memberof PoolItemSettingsDto
     */
    'isEnsureEntityBelongToSinglePool'?: boolean;
}
/**
 * 
 * @export
 * @interface PoolItemSettingsInputDto
 */
export interface PoolItemSettingsInputDto {
    /**
     * 
     * @type {boolean}
     * @memberof PoolItemSettingsInputDto
     */
    'isEnsureEntityBelongToSinglePool'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PoolItemStatus = {
    None: 'None',
    Pending: 'Pending',
    Available: 'Available',
    Locked: 'Locked',
    Reserved: 'Reserved',
    Unavailable: 'Unavailable'
} as const;

export type PoolItemStatus = typeof PoolItemStatus[keyof typeof PoolItemStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const PoolItemType = {
    None: 'None',
    Specific: 'Specific',
    Abstract: 'Abstract'
} as const;

export type PoolItemType = typeof PoolItemType[keyof typeof PoolItemType];


/**
 * 
 * @export
 * @interface PoolItemUpdateDto
 */
export interface PoolItemUpdateDto {
    /**
     * 
     * @type {PoolItemStatus}
     * @memberof PoolItemUpdateDto
     */
    'status'?: PoolItemStatus;
    /**
     * 
     * @type {string}
     * @memberof PoolItemUpdateDto
     */
    'statusReason'?: string | null;
    /**
     * 
     * @type {PoolItemSettingsInputDto}
     * @memberof PoolItemUpdateDto
     */
    'settings'?: PoolItemSettingsInputDto;
}


/**
 * 
 * @export
 * @interface PoolItemUpdateStatusDto
 */
export interface PoolItemUpdateStatusDto {
    /**
     * 
     * @type {PoolItemStatus}
     * @memberof PoolItemUpdateStatusDto
     */
    'status'?: PoolItemStatus;
    /**
     * 
     * @type {string}
     * @memberof PoolItemUpdateStatusDto
     */
    'statusReason'?: string | null;
}


/**
 * 
 * @export
 * @interface PoolReferenceDto
 */
export interface PoolReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof PoolReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {PoolStructureType}
     * @memberof PoolReferenceDto
     */
    'structureType'?: PoolStructureType;
    /**
     * 
     * @type {PoolItemType}
     * @memberof PoolReferenceDto
     */
    'itemType'?: PoolItemType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof PoolReferenceDto
     */
    'itemEntityType'?: PoolItemEntityType;
}


/**
 * 
 * @export
 * @interface PoolSearchPaginatedDto
 */
export interface PoolSearchPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof PoolSearchPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolSearchPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof PoolSearchPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolSearchPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolSearchPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolSearchPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof PoolSearchPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof PoolSearchPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof PoolSearchPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {PoolStructureType}
     * @memberof PoolSearchPaginatedDto
     */
    'structureType'?: PoolStructureType;
    /**
     * 
     * @type {PoolItemType}
     * @memberof PoolSearchPaginatedDto
     */
    'itemType'?: PoolItemType;
    /**
     * 
     * @type {PoolItemEntityType}
     * @memberof PoolSearchPaginatedDto
     */
    'itemEntityType'?: PoolItemEntityType;
    /**
     * 
     * @type {Array<PoolItemEntityType>}
     * @memberof PoolSearchPaginatedDto
     */
    'itemEntityTypes'?: Array<PoolItemEntityType> | null;
    /**
     * 
     * @type {Array<PoolItemEntityType>}
     * @memberof PoolSearchPaginatedDto
     */
    'anyItemEntityTypes'?: Array<PoolItemEntityType> | null;
    /**
     * 
     * @type {EntityType}
     * @memberof PoolSearchPaginatedDto
     */
    'itemEntitySubType'?: EntityType;
    /**
     * 
     * @type {Array<EntityType>}
     * @memberof PoolSearchPaginatedDto
     */
    'anyItemEntitySubTypes'?: Array<EntityType> | null;
}


/**
 * 
 * @export
 * @interface PoolSettings
 */
export interface PoolSettings {
    /**
     * 
     * @type {number}
     * @memberof PoolSettings
     */
    'minItems'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolSettings
     */
    'maxItems'?: number;
    /**
     * If true, ensures that single identifiable entity belongs max to 1 pool.
     * @type {boolean}
     * @memberof PoolSettings
     */
    'isEnsureEntityBelongToSinglePool'?: boolean;
    /**
     * Entity types that can be added to the pool.
     * @type {Array<PoolItemEntityType>}
     * @memberof PoolSettings
     */
    'allowedEntityTypes'?: Array<PoolItemEntityType> | null;
}
/**
 * 
 * @export
 * @interface PoolSettingsDto
 */
export interface PoolSettingsDto {
    /**
     * 
     * @type {number}
     * @memberof PoolSettingsDto
     */
    'minItems'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolSettingsDto
     */
    'maxItems'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PoolSettingsDto
     */
    'isEnsureEntityBelongToSinglePool'?: boolean;
    /**
     * 
     * @type {Array<PoolItemEntityType>}
     * @memberof PoolSettingsDto
     */
    'allowedEntityTypes'?: Array<PoolItemEntityType> | null;
}
/**
 * 
 * @export
 * @interface PoolSettingsInputDto
 */
export interface PoolSettingsInputDto {
    /**
     * 
     * @type {number}
     * @memberof PoolSettingsInputDto
     */
    'minItems'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PoolSettingsInputDto
     */
    'maxItems'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PoolSettingsInputDto
     */
    'isEnsureEntityBelongToSinglePool'?: boolean;
}
/**
 * Computed Pool state.
 * @export
 * @interface PoolState
 */
export interface PoolState {
    /**
     * 
     * @type {number}
     * @memberof PoolState
     */
    'totalCount'?: number;
    /**
     * 
     * @type {PoolStateCountByStatusMap}
     * @memberof PoolState
     */
    'countByStatusMap'?: PoolStateCountByStatusMap;
    /**
     * 
     * @type {PoolStateCountByEntityTypeMap}
     * @memberof PoolState
     */
    'countByEntityTypeMap'?: PoolStateCountByEntityTypeMap;
    /**
     * Actual distinct entity types in the pool.
     * @type {Array<PoolItemEntityType>}
     * @memberof PoolState
     */
    'entityTypes'?: Array<PoolItemEntityType>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof PoolState
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PoolState
     */
    'hasAny'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PoolState
     */
    'hasUniformItems'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PoolState
     */
    'hasDiverseItems'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PoolState
     */
    'pendingCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolState
     */
    'availableCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolState
     */
    'lockedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolState
     */
    'unavailableCount'?: number;
}
/**
 * 
 * @export
 * @interface PoolStateCountByEntityTypeMap
 */
export interface PoolStateCountByEntityTypeMap {
    /**
     * 
     * @type {number}
     * @memberof PoolStateCountByEntityTypeMap
     */
    'None'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolStateCountByEntityTypeMap
     */
    'Asset'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolStateCountByEntityTypeMap
     */
    'Vehicle'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolStateCountByEntityTypeMap
     */
    'Accessory'?: number;
}
/**
 * 
 * @export
 * @interface PoolStateCountByStatusMap
 */
export interface PoolStateCountByStatusMap {
    /**
     * 
     * @type {number}
     * @memberof PoolStateCountByStatusMap
     */
    'None'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolStateCountByStatusMap
     */
    'Pending'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolStateCountByStatusMap
     */
    'Available'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolStateCountByStatusMap
     */
    'Locked'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolStateCountByStatusMap
     */
    'Reserved'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolStateCountByStatusMap
     */
    'Unavailable'?: number;
}
/**
 * 
 * @export
 * @interface PoolStateDto
 */
export interface PoolStateDto {
    /**
     * 
     * @type {number}
     * @memberof PoolStateDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {PoolStateCountByStatusMap}
     * @memberof PoolStateDto
     */
    'countByStatusMap'?: PoolStateCountByStatusMap;
    /**
     * 
     * @type {PoolStateCountByEntityTypeMap}
     * @memberof PoolStateDto
     */
    'countByEntityTypeMap'?: PoolStateCountByEntityTypeMap;
    /**
     * 
     * @type {Array<PoolItemEntityType>}
     * @memberof PoolStateDto
     */
    'entityTypes'?: Array<PoolItemEntityType>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof PoolStateDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PoolStateDto
     */
    'hasAny'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PoolStateDto
     */
    'hasUniformItems'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PoolStateDto
     */
    'hasDiverseItems'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PoolStateDto
     */
    'pendingCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolStateDto
     */
    'availableCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolStateDto
     */
    'lockedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolStateDto
     */
    'unavailableCount'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PoolStructureType = {
    None: 'None',
    Uniform: 'Uniform',
    Diverse: 'Diverse'
} as const;

export type PoolStructureType = typeof PoolStructureType[keyof typeof PoolStructureType];


/**
 * 
 * @export
 * @interface PoolUpdateDto
 */
export interface PoolUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof PoolUpdateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoolUpdateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralEntitySubTypeInputDto}
     * @memberof PoolUpdateDto
     */
    'itemEntitySubType'?: GeneralEntitySubTypeInputDto;
    /**
     * 
     * @type {PoolSettingsInputDto}
     * @memberof PoolUpdateDto
     */
    'settings'?: PoolSettingsInputDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolUpdateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolUpdateDto
     */
    'locationIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface PoolsIntersectionDto
 */
export interface PoolsIntersectionDto {
    /**
     * 
     * @type {Array<PoolDto>}
     * @memberof PoolsIntersectionDto
     */
    'pools'?: Array<PoolDto>;
    /**
     * 
     * @type {Array<PoolsIntersectionEntryDto>}
     * @memberof PoolsIntersectionDto
     */
    'entries'?: Array<PoolsIntersectionEntryDto>;
}
/**
 * 
 * @export
 * @interface PoolsIntersectionEntryDto
 */
export interface PoolsIntersectionEntryDto {
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof PoolsIntersectionEntryDto
     */
    'entity'?: GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {Array<PoolItemDto>}
     * @memberof PoolsIntersectionEntryDto
     */
    'poolItems'?: Array<PoolItemDto>;
}
/**
 * 
 * @export
 * @interface PoolsIntersectionResultDto
 */
export interface PoolsIntersectionResultDto {
    /**
     * 
     * @type {Array<PoolsIntersectionDto>}
     * @memberof PoolsIntersectionResultDto
     */
    'intersections'?: Array<PoolsIntersectionDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PoolsIntersectionResultDto
     */
    'isAnyIntersection'?: boolean;
}
/**
 * 
 * @export
 * @interface PoolsMetaDto
 */
export interface PoolsMetaDto {
    /**
     * 
     * @type {Array<PoolItemMeta>}
     * @memberof PoolsMetaDto
     */
    'pools'?: Array<PoolItemMeta> | null;
    /**
     * 
     * @type {boolean}
     * @memberof PoolsMetaDto
     */
    'hasPool'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolsMetaDto
     */
    'poolIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolsMetaDto
     */
    'poolItemIds'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof PoolsMetaDto
     */
    'poolIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof PoolsMetaDto
     */
    'poolItemIdsMap'?: { [key: string]: boolean; };
    /**
     * Set to true if for any Pool or Pools item corresponding settings is true.  This is needed to properly filter out Pool candidate entities.  E.g. entity A is added to Pool A with  IsEnsureEntityBelongToSinglePool = true,  then when adding items to Pool B entity A should be excluded from candidates list.
     * @type {boolean}
     * @memberof PoolsMetaDto
     */
    'isEnsureEntityBelongToSinglePoolSetForAny'?: boolean;
}
/**
 * 
 * @export
 * @interface PoolsMetaQueryDto
 */
export interface PoolsMetaQueryDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolsMetaQueryDto
     */
    'poolIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolsMetaQueryDto
     */
    'notForPoolIds'?: Array<string> | null;
    /**
     * If set, returns entities that are suitable candidates to be added to the Pool (for new PoolItem).
     * @type {string}
     * @memberof PoolsMetaQueryDto
     */
    'onlySuitableCandidatesForPoolId'?: string | null;
}
/**
 * Describes how price summary is entered/calculated.
 * @export
 * @enum {string}
 */

export const PriceSummaryCalcType = {
    None: 'None',
    BasedOnSubTotal: 'BasedOnSubTotal',
    BasedOnTotal: 'BasedOnTotal'
} as const;

export type PriceSummaryCalcType = typeof PriceSummaryCalcType[keyof typeof PriceSummaryCalcType];


/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'instance'?: string | null;
}
/**
 * 
 * @export
 * @interface ProductLocationChangedDto
 */
export interface ProductLocationChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductLocationChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof ProductLocationChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof ProductLocationChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {ProductLocationDto}
     * @memberof ProductLocationChangedDto
     */
    'entity': ProductLocationDto;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface ProductLocationDto
 */
export interface ProductLocationDto {
    /**
     * 
     * @type {string}
     * @memberof ProductLocationDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof ProductLocationDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ProductLocationDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof ProductLocationDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductLocationDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductLocationDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAddressDto}
     * @memberof ProductLocationDto
     */
    'address'?: GeneralAddressDto;
}


/**
 * 
 * @export
 * @interface ProductLocationGetPaginatedDto
 */
export interface ProductLocationGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof ProductLocationGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductLocationGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductLocationGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductLocationGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductLocationGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof ProductLocationGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof ProductLocationGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof ProductLocationGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationGetPaginatedDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationGetPaginatedDto
     */
    'assetSubscriptionPlanId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationGetPaginatedDto
     */
    'notForDepartmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationGetPaginatedDto
     */
    'notForLocationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationGetPaginatedDto
     */
    'notForAssetSubscriptionPlanId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductLocationGetPaginatedDto
     */
    'isWithDepartment'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductLocationGetPaginatedDto
     */
    'isWithLocation'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductLocationGetPaginatedDto
     */
    'isWithAnyAssetSubscriptionPlan'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ProductLocationReferenceDto
 */
export interface ProductLocationReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof ProductLocationReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductLocationReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface ProfileDepartmentDto
 */
export interface ProfileDepartmentDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileDepartmentDto
     */
    'id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileDepartmentDto
     */
    'locationIds'?: Array<string> | null;
}
/**
 * User profile.
 * @export
 * @interface ProfileDto
 */
export interface ProfileDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'id'?: string;
    /**
     * Current user tenant.
     * @type {string}
     * @memberof ProfileDto
     */
    'tenantId'?: string | null;
    /**
     * All user\'s tenants.
     * @type {Array<string>}
     * @memberof ProfileDto
     */
    'tenantIds'?: Array<string> | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof ProfileDto
     */
    'status'?: UserStatus;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'email'?: string;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof ProfileDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {UserSettingsDto}
     * @memberof ProfileDto
     */
    'settings'?: UserSettingsDto;
    /**
     * 
     * @type {GeneralAvatarDto}
     * @memberof ProfileDto
     */
    'avatar'?: GeneralAvatarDto;
    /**
     * 
     * @type {UserSuspensionInfoDto}
     * @memberof ProfileDto
     */
    'suspension'?: UserSuspensionInfoDto;
    /**
     * 
     * @type {UserAssistantInfoDto}
     * @memberof ProfileDto
     */
    'assistant'?: UserAssistantInfoDto;
    /**
     * 
     * @type {Array<UserDepartmentDto>}
     * @memberof ProfileDto
     */
    'departments'?: Array<UserDepartmentDto>;
    /**
     * 
     * @type {Array<ProfileUserLocationDto>}
     * @memberof ProfileDto
     */
    'locations'?: Array<ProfileUserLocationDto>;
    /**
     * 
     * @type {OnboardingRefDto}
     * @memberof ProfileDto
     */
    'onboarding'?: OnboardingRefDto;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileDto
     */
    'isPersonalInfoComplete'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileDto
     */
    'isCustomerUser'?: boolean;
    /**
     * Temp solution: features enabled for the current tenant user.
     * @type {{ [key: string]: boolean; }}
     * @memberof ProfileDto
     */
    'features'?: { [key: string]: boolean; };
}


/**
 * Permissions to be displayed to users.
 * @export
 * @interface ProfilePermissionsDto
 */
export interface ProfilePermissionsDto {
    /**
     * 
     * @type {string}
     * @memberof ProfilePermissionsDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {Array<PermissionMetaDto>}
     * @memberof ProfilePermissionsDto
     */
    'globalPermissions'?: Array<PermissionMetaDto>;
    /**
     * 
     * @type {Array<PermissionMetaDto>}
     * @memberof ProfilePermissionsDto
     */
    'tenantPermissions'?: Array<PermissionMetaDto>;
    /**
     * 
     * @type {Array<PermissionMetaDto>}
     * @memberof ProfilePermissionsDto
     */
    'allPermissions'?: Array<PermissionMetaDto>;
}
/**
 * 
 * @export
 * @interface ProfilePersonalInfoUpdateDto
 */
export interface ProfilePersonalInfoUpdateDto {
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof ProfilePersonalInfoUpdateDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof ProfilePersonalInfoUpdateDto
     */
    'phoneNumber'?: string;
}
/**
 * Roles to be displayed to users.
 * @export
 * @interface ProfileRolesDto
 */
export interface ProfileRolesDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileRolesDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {Array<RoleDto>}
     * @memberof ProfileRolesDto
     */
    'globalRoles'?: Array<RoleDto>;
    /**
     * 
     * @type {Array<RoleDto>}
     * @memberof ProfileRolesDto
     */
    'tenantRoles'?: Array<RoleDto>;
    /**
     * 
     * @type {Array<RoleDto>}
     * @memberof ProfileRolesDto
     */
    'allRoles'?: Array<RoleDto>;
}
/**
 * 
 * @export
 * @interface ProfileUserLocationDto
 */
export interface ProfileUserLocationDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileUserLocationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileUserLocationDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ProposalStatus = {
    None: 'None',
    Open: 'Open',
    Closed: 'Closed',
    AutoClosed: 'AutoClosed'
} as const;

export type ProposalStatus = typeof ProposalStatus[keyof typeof ProposalStatus];


/**
 * 
 * @export
 * @interface PushChannelInfoDto
 */
export interface PushChannelInfoDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof PushChannelInfoDto
     */
    'deviceTokens'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PushChannelInfoDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PushChannelInfoDto
     */
    'body'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PushChannelInfoDto
     */
    'imageUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PushChannelInfoDto
     */
    'channel'?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PushChannelInfoDto
     */
    'data'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface RegisterCompleteDto
 */
export interface RegisterCompleteDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterCompleteDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterCompleteDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterCompleteDto
     */
    'confirmPassword'?: string;
}
/**
 * 
 * @export
 * @interface RegisterDeviceTokenDto
 */
export interface RegisterDeviceTokenDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceTokenDto
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface RegisterDto
 */
export interface RegisterDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'companyIdentifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'companyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'companyDescription'?: string | null;
    /**
     * 
     * @type {TenantType}
     * @memberof RegisterDto
     */
    'tenantType'?: TenantType;
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof RegisterDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'email'?: string;
}


/**
 * 
 * @export
 * @interface RegisterInvitedUserDto
 */
export interface RegisterInvitedUserDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterInvitedUserDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterInvitedUserDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterInvitedUserDto
     */
    'confirmPassword'?: string;
}
/**
 * 
 * @export
 * @interface RegisterResultDto
 */
export interface RegisterResultDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterResultDto
     */
    'companyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterResultDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterResultDto
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface RemoveDocumentAttachmentsDto
 */
export interface RemoveDocumentAttachmentsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof RemoveDocumentAttachmentsDto
     */
    'attachmentIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface RemoveDocumentItemAttachmentsDto
 */
export interface RemoveDocumentItemAttachmentsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof RemoveDocumentItemAttachmentsDto
     */
    'attachmentIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface RepairCatalogChangedDto
 */
export interface RepairCatalogChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairCatalogChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof RepairCatalogChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof RepairCatalogChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {RepairCatalogDto}
     * @memberof RepairCatalogChangedDto
     */
    'entity': RepairCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface RepairCatalogDto
 */
export interface RepairCatalogDto {
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof RepairCatalogDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairCatalogDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairCatalogDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RepairCatalogDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RepairCatalogDto
     */
    'isGlobal'?: boolean;
}


/**
 * 
 * @export
 * @interface RepairCatalogGetPaginatedDto
 */
export interface RepairCatalogGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof RepairCatalogGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairCatalogGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairCatalogGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairCatalogGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairCatalogGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof RepairCatalogGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof RepairCatalogGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof RepairCatalogGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {boolean}
     * @memberof RepairCatalogGetPaginatedDto
     */
    'isGlobal'?: boolean;
}
/**
 * 
 * @export
 * @interface RepairCatalogReferenceDto
 */
export interface RepairCatalogReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface RepairCatalogSearchPaginatedDto
 */
export interface RepairCatalogSearchPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof RepairCatalogSearchPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairCatalogSearchPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairCatalogSearchPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairCatalogSearchPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairCatalogSearchPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairCatalogSearchPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof RepairCatalogSearchPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof RepairCatalogSearchPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof RepairCatalogSearchPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {boolean}
     * @memberof RepairCatalogSearchPaginatedDto
     */
    'isGlobal'?: boolean;
}
/**
 * 
 * @export
 * @interface RepairMaterialChangedDto
 */
export interface RepairMaterialChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairMaterialChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof RepairMaterialChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof RepairMaterialChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {RepairMaterialDto}
     * @memberof RepairMaterialChangedDto
     */
    'entity': RepairMaterialDto;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface RepairMaterialDto
 */
export interface RepairMaterialDto {
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof RepairMaterialDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairMaterialDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairMaterialDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialDto
     */
    'repairCatalogId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialDto
     */
    'sourceMaterialId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof RepairMaterialDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialDto
     */
    'brandName'?: string | null;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof RepairMaterialDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {number}
     * @memberof RepairMaterialDto
     */
    'price'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RepairMaterialDto
     */
    'isDividable'?: boolean;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof RepairMaterialDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof RepairMaterialDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {boolean}
     * @memberof RepairMaterialDto
     */
    'isGlobal'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RepairMaterialDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairMaterialDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairMaterialDto
     */
    'total'?: number;
}


/**
 * 
 * @export
 * @interface RepairMaterialFullReferenceDto
 */
export interface RepairMaterialFullReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialFullReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialFullReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialFullReferenceDto
     */
    'repairCatalogId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialFullReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialFullReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialFullReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialFullReferenceDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof RepairMaterialFullReferenceDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialFullReferenceDto
     */
    'brandName'?: string | null;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof RepairMaterialFullReferenceDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {number}
     * @memberof RepairMaterialFullReferenceDto
     */
    'price'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RepairMaterialFullReferenceDto
     */
    'isDividable'?: boolean;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof RepairMaterialFullReferenceDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof RepairMaterialFullReferenceDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {boolean}
     * @memberof RepairMaterialFullReferenceDto
     */
    'isGlobal'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RepairMaterialFullReferenceDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairMaterialFullReferenceDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairMaterialFullReferenceDto
     */
    'total'?: number;
}


/**
 * 
 * @export
 * @interface RepairMaterialGetPaginatedDto
 */
export interface RepairMaterialGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof RepairMaterialGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairMaterialGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairMaterialGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairMaterialGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairMaterialGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof RepairMaterialGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof RepairMaterialGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof RepairMaterialGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * ID of the target tenant from which to query data.  Allows to query from any of user\'s tenant.
     * @type {string}
     * @memberof RepairMaterialGetPaginatedDto
     */
    'myTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RepairMaterialGetPaginatedDto
     */
    'isGlobal'?: boolean | null;
}
/**
 * 
 * @export
 * @interface RepairMaterialReferenceDto
 */
export interface RepairMaterialReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialReferenceDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface RepairOperationAddVehicleDamageDto
 */
export interface RepairOperationAddVehicleDamageDto {
    /**
     * 
     * @type {string}
     * @memberof RepairOperationAddVehicleDamageDto
     */
    'vehicleDamageId'?: string;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationAddVehicleDamageDto
     */
    'cost'?: number | null;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof RepairOperationAddVehicleDamageDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof RepairOperationAddVehicleDamageDto
     */
    'tax'?: GeneralTaxInputDto;
}
/**
 * 
 * @export
 * @interface RepairOperationAddVehicleDamagesDto
 */
export interface RepairOperationAddVehicleDamagesDto {
    /**
     * 
     * @type {Array<RepairOperationAddVehicleDamageDto>}
     * @memberof RepairOperationAddVehicleDamagesDto
     */
    'vehicleDamages'?: Array<RepairOperationAddVehicleDamageDto>;
}
/**
 * 
 * @export
 * @interface RepairOperationChangedDto
 */
export interface RepairOperationChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof RepairOperationChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof RepairOperationChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {RepairOperationDto}
     * @memberof RepairOperationChangedDto
     */
    'entity': RepairOperationDto;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface RepairOperationContentDto
 */
export interface RepairOperationContentDto {
    /**
     * 
     * @type {string}
     * @memberof RepairOperationContentDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationContentDto
     */
    'vehicleDamageIds'?: Array<string>;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof RepairOperationContentDto
     */
    'currency'?: GeneralCurrencyDto;
}
/**
 * 
 * @export
 * @interface RepairOperationContentInputDto
 */
export interface RepairOperationContentInputDto {
    /**
     * 
     * @type {string}
     * @memberof RepairOperationContentInputDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationContentInputDto
     */
    'vehicleDamageIds'?: Array<string>;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof RepairOperationContentInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
}
/**
 * 
 * @export
 * @interface RepairOperationCountersDto
 */
export interface RepairOperationCountersDto {
    /**
     * 
     * @type {string}
     * @memberof RepairOperationCountersDto
     */
    'version'?: string;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationCountersDto
     */
    'draftCount': number;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationCountersDto
     */
    'inProgressCount': number;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationCountersDto
     */
    'completedCount': number;
}
/**
 * 
 * @export
 * @interface RepairOperationDto
 */
export interface RepairOperationDto {
    /**
     * 
     * @type {string}
     * @memberof RepairOperationDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof RepairOperationDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairOperationDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairOperationDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof RepairOperationDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof RepairOperationDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {SupplierReferenceDto}
     * @memberof RepairOperationDto
     */
    'supplier'?: SupplierReferenceDto;
    /**
     * 
     * @type {AssignmentReferenceDto}
     * @memberof RepairOperationDto
     */
    'assignment'?: AssignmentReferenceDto;
    /**
     * 
     * @type {GeneralStageHistoryDtoOfRepairOperationStage}
     * @memberof RepairOperationDto
     */
    'stageHistory'?: GeneralStageHistoryDtoOfRepairOperationStage;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationDto
     */
    'description'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairOperationDto
     */
    'date'?: string;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof RepairOperationDto
     */
    'responsibleUser'?: GeneralByWhoDto;
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof RepairOperationDto
     */
    'mileage'?: VehicleMileageDto;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof RepairOperationDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {Array<RepairOperationItemDto>}
     * @memberof RepairOperationDto
     */
    'items'?: Array<RepairOperationItemDto>;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof RepairOperationDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof RepairOperationDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof RepairOperationDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
    /**
     * 
     * @type {TenantRequestsMetaDto}
     * @memberof RepairOperationDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof RepairOperationDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {boolean}
     * @memberof RepairOperationDto
     */
    'canBeUpdated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RepairOperationDto
     */
    'canBeDeleted'?: boolean;
    /**
     * 
     * @type {GeneralDiscount}
     * @memberof RepairOperationDto
     */
    'discount'?: GeneralDiscount;
    /**
     * 
     * @type {GeneralTax}
     * @memberof RepairOperationDto
     */
    'tax'?: GeneralTax;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationDto
     */
    'total'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairOperationDto
     */
    'draftAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairOperationDto
     */
    'inProgressAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairOperationDto
     */
    'completedAt'?: string | null;
}


/**
 * 
 * @export
 * @interface RepairOperationGetPaginatedDto
 */
export interface RepairOperationGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof RepairOperationGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof RepairOperationGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof RepairOperationGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof RepairOperationGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationGetPaginatedDto
     */
    'vehicleDamageId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationGetPaginatedDto
     */
    'vehicleDamageIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationGetPaginatedDto
     */
    'anyVehicleDamageIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationGetPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationGetPaginatedDto
     */
    'damageId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationGetPaginatedDto
     */
    'assignmentId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationGetPaginatedDto
     */
    'damageIds'?: Array<string> | null;
    /**
     * 
     * @type {RepairOperationStage}
     * @memberof RepairOperationGetPaginatedDto
     */
    'stage'?: RepairOperationStage;
    /**
     * 
     * @type {RepairOperationStage}
     * @memberof RepairOperationGetPaginatedDto
     */
    'excludeStage'?: RepairOperationStage;
    /**
     * 
     * @type {Array<RepairOperationStage>}
     * @memberof RepairOperationGetPaginatedDto
     */
    'excludeStages'?: Array<RepairOperationStage> | null;
    /**
     * 
     * @type {TenantRequestsMetaQueryDto}
     * @memberof RepairOperationGetPaginatedDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof RepairOperationGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * 
 * @export
 * @interface RepairOperationItemDto
 */
export interface RepairOperationItemDto {
    /**
     * 
     * @type {string}
     * @memberof RepairOperationItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationItemDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleDamageFullReferenceDto}
     * @memberof RepairOperationItemDto
     */
    'damage'?: VehicleDamageFullReferenceDto;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationItemDto
     */
    'cost'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationItemDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof RepairOperationItemDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof RepairOperationItemDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof RepairOperationItemDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationItemDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationItemDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationItemDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface RepairOperationItemInputDto
 */
export interface RepairOperationItemInputDto {
    /**
     * 
     * @type {string}
     * @memberof RepairOperationItemInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationItemInputDto
     */
    'damageId'?: string;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationItemInputDto
     */
    'cost'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationItemInputDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof RepairOperationItemInputDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof RepairOperationItemInputDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof RepairOperationItemInputDto
     */
    'tax'?: GeneralTaxInputDto;
}
/**
 * 
 * @export
 * @interface RepairOperationReferenceDto
 */
export interface RepairOperationReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof RepairOperationReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationReferenceDto
     */
    'vehicleId'?: string;
}
/**
 * 
 * @export
 * @interface RepairOperationResultDto
 */
export interface RepairOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof RepairOperationResultDto
     */
    'repairOperationId'?: string;
}
/**
 * 
 * @export
 * @interface RepairOperationResultInputDto
 */
export interface RepairOperationResultInputDto {
    /**
     * 
     * @type {string}
     * @memberof RepairOperationResultInputDto
     */
    'repairOperationId'?: string;
}
/**
 * 
 * @export
 * @interface RepairOperationSearchPaginatedDto
 */
export interface RepairOperationSearchPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'damageId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'assignmentId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'damageIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'vehicleDamageId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'vehicleDamageIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'anyVehicleDamageIds'?: Array<string> | null;
    /**
     * 
     * @type {RepairOperationStage}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'stage'?: RepairOperationStage;
    /**
     * 
     * @type {RepairOperationStage}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'excludeStage'?: RepairOperationStage;
    /**
     * 
     * @type {Array<RepairOperationStage>}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'excludeStages'?: Array<RepairOperationStage> | null;
    /**
     * 
     * @type {TenantRequestsMetaQueryDto}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof RepairOperationSearchPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * NB: use SortOrderAttribute to specify the order in which stages can be activated.
 * @export
 * @enum {string}
 */

export const RepairOperationStage = {
    None: 'None',
    Draft: 'Draft',
    InProgress: 'InProgress',
    Completed: 'Completed'
} as const;

export type RepairOperationStage = typeof RepairOperationStage[keyof typeof RepairOperationStage];


/**
 * 
 * @export
 * @interface RepairSparePartChangedDto
 */
export interface RepairSparePartChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairSparePartChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof RepairSparePartChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof RepairSparePartChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {RepairSparePartDto}
     * @memberof RepairSparePartChangedDto
     */
    'entity': RepairSparePartDto;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface RepairSparePartDetalizationDto
 */
export interface RepairSparePartDetalizationDto {
    /**
     * 
     * @type {RepairSparePartDetalizationType}
     * @memberof RepairSparePartDetalizationDto
     */
    'type'?: RepairSparePartDetalizationType;
    /**
     * 
     * @type {VehicleSize}
     * @memberof RepairSparePartDetalizationDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof RepairSparePartDetalizationDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof RepairSparePartDetalizationDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {VehicleMakeReferenceDto}
     * @memberof RepairSparePartDetalizationDto
     */
    'make'?: VehicleMakeReferenceDto;
    /**
     * 
     * @type {VehicleModelReferenceDto}
     * @memberof RepairSparePartDetalizationDto
     */
    'model'?: VehicleModelReferenceDto;
    /**
     * 
     * @type {VehicleGenerationReferenceDto}
     * @memberof RepairSparePartDetalizationDto
     */
    'generation'?: VehicleGenerationReferenceDto;
    /**
     * 
     * @type {VehicleModificationReferenceDto}
     * @memberof RepairSparePartDetalizationDto
     */
    'modification'?: VehicleModificationReferenceDto;
}


/**
 * 
 * @export
 * @interface RepairSparePartDetalizationInputDto
 */
export interface RepairSparePartDetalizationInputDto {
    /**
     * 
     * @type {RepairSparePartDetalizationType}
     * @memberof RepairSparePartDetalizationInputDto
     */
    'type'?: RepairSparePartDetalizationType;
    /**
     * 
     * @type {VehicleSize}
     * @memberof RepairSparePartDetalizationInputDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof RepairSparePartDetalizationInputDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof RepairSparePartDetalizationInputDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartDetalizationInputDto
     */
    'makeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartDetalizationInputDto
     */
    'modelId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartDetalizationInputDto
     */
    'generationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartDetalizationInputDto
     */
    'modificationId'?: string | null;
}


/**
 * Detalizations go from more general to more specific.  Priority: lower = more general, higher = more specific. Specific has priority.
 * @export
 * @enum {string}
 */

export const RepairSparePartDetalizationType = {
    None: 'None',
    General: 'General',
    VehicleSize: 'VehicleSize',
    BodyType: 'BodyType',
    Make: 'Make',
    Model: 'Model',
    Generation: 'Generation',
    Modification: 'Modification'
} as const;

export type RepairSparePartDetalizationType = typeof RepairSparePartDetalizationType[keyof typeof RepairSparePartDetalizationType];


/**
 * 
 * @export
 * @interface RepairSparePartDto
 */
export interface RepairSparePartDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof RepairSparePartDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairSparePartDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairSparePartDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartDto
     */
    'partNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartDto
     */
    'brandName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof RepairSparePartDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {VehicleType}
     * @memberof RepairSparePartDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehiclePartTypeReferenceDto}
     * @memberof RepairSparePartDto
     */
    'partType'?: VehiclePartTypeReferenceDto;
    /**
     * 
     * @type {Array<RepairSparePartDetalizationDto>}
     * @memberof RepairSparePartDto
     */
    'detalizations'?: Array<RepairSparePartDetalizationDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof RepairSparePartDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof RepairSparePartDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {number}
     * @memberof RepairSparePartDto
     */
    'price'?: number | null;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof RepairSparePartDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof RepairSparePartDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {boolean}
     * @memberof RepairSparePartDto
     */
    'isGlobal'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RepairSparePartDto
     */
    'subTotal'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RepairSparePartDto
     */
    'subTotalIncDiscount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RepairSparePartDto
     */
    'total'?: number | null;
    /**
     * 
     * @type {EntityMatchMetaDto}
     * @memberof RepairSparePartDto
     */
    'matchMeta'?: EntityMatchMetaDto;
}


/**
 * 
 * @export
 * @interface RepairSparePartFullReferenceDto
 */
export interface RepairSparePartFullReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartFullReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartFullReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartFullReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartFullReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartFullReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartFullReferenceDto
     */
    'partNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartFullReferenceDto
     */
    'brandName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartFullReferenceDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof RepairSparePartFullReferenceDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {VehicleType}
     * @memberof RepairSparePartFullReferenceDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehiclePartTypeReferenceDto}
     * @memberof RepairSparePartFullReferenceDto
     */
    'partType'?: VehiclePartTypeReferenceDto;
    /**
     * 
     * @type {Array<RepairSparePartDetalizationDto>}
     * @memberof RepairSparePartFullReferenceDto
     */
    'detalizations'?: Array<RepairSparePartDetalizationDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof RepairSparePartFullReferenceDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof RepairSparePartFullReferenceDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {number}
     * @memberof RepairSparePartFullReferenceDto
     */
    'price'?: number | null;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof RepairSparePartFullReferenceDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof RepairSparePartFullReferenceDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {boolean}
     * @memberof RepairSparePartFullReferenceDto
     */
    'isGlobal'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RepairSparePartFullReferenceDto
     */
    'subTotal'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RepairSparePartFullReferenceDto
     */
    'subTotalIncDiscount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RepairSparePartFullReferenceDto
     */
    'total'?: number | null;
}


/**
 * 
 * @export
 * @interface RepairSparePartGetPaginatedDto
 */
export interface RepairSparePartGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * ID of the target tenant from which to query data.  Allows to query from any of user\'s tenant.
     * @type {string}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'myTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'isGlobal'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'partTypeId'?: string | null;
    /**
     * 
     * @type {VehicleType}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehicleSize}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'makeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'modelId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'generationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'modificationId'?: string | null;
    /**
     * 
     * @type {RepairSparePartMatchQueryDto}
     * @memberof RepairSparePartGetPaginatedDto
     */
    'match'?: RepairSparePartMatchQueryDto;
}


/**
 * 
 * @export
 * @interface RepairSparePartMatchQueryDto
 */
export interface RepairSparePartMatchQueryDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartMatchQueryDto
     */
    'partTypeId'?: string | null;
    /**
     * 
     * @type {VehicleSize}
     * @memberof RepairSparePartMatchQueryDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof RepairSparePartMatchQueryDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof RepairSparePartMatchQueryDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartMatchQueryDto
     */
    'makeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartMatchQueryDto
     */
    'modelId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartMatchQueryDto
     */
    'generationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartMatchQueryDto
     */
    'modificationId'?: string | null;
}


/**
 * 
 * @export
 * @interface RepairSparePartReferenceDto
 */
export interface RepairSparePartReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartReferenceDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface RepairSpecChangedDto
 */
export interface RepairSpecChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairSpecChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof RepairSpecChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof RepairSpecChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {RepairSpecDto}
     * @memberof RepairSpecChangedDto
     */
    'entity': RepairSpecDto;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecChangedDto
     */
    'tenantId': string | null;
}


/**
 * Data that can be changed and stored in other entities.  Data sync from the source entity is not expected by default.
 * @export
 * @interface RepairSpecDataDto
 */
export interface RepairSpecDataDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataDto
     */
    'sourceTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataDto
     */
    'sourceSpecId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof RepairSpecDataDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof RepairSpecDataDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehiclePartTypeReferenceDto}
     * @memberof RepairSpecDataDto
     */
    'partType'?: VehiclePartTypeReferenceDto;
    /**
     * 
     * @type {DamageTypeReferenceDto}
     * @memberof RepairSpecDataDto
     */
    'damageType'?: DamageTypeReferenceDto;
    /**
     * 
     * @type {RepairSpecDetalizationDto}
     * @memberof RepairSpecDataDto
     */
    'detalization'?: RepairSpecDetalizationDto;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecDataDto
     */
    'spotFactor'?: number;
    /**
     * 
     * @type {Array<RepairSpecItemDataDto>}
     * @memberof RepairSpecDataDto
     */
    'items'?: Array<RepairSpecItemDataDto>;
    /**
     * 
     * @type {boolean}
     * @memberof RepairSpecDataDto
     */
    'isDetailsHidden'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RepairSpecDataDto
     */
    'isCreatedOnTheSpot'?: boolean;
    /**
     * 
     * @type {RepairType}
     * @memberof RepairSpecDataDto
     */
    'repairType'?: RepairType;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof RepairSpecDataDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof RepairSpecDataDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecDataDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecDataDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecDataDto
     */
    'total'?: number;
}


/**
 * 
 * @export
 * @interface RepairSpecDataInputDto
 */
export interface RepairSpecDataInputDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataInputDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataInputDto
     */
    'sourceTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataInputDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataInputDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof RepairSpecDataInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof RepairSpecDataInputDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataInputDto
     */
    'partTypeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDataInputDto
     */
    'damageTypeId'?: string;
    /**
     * 
     * @type {RepairSpecDetalizationInputDto}
     * @memberof RepairSpecDataInputDto
     */
    'detalization'?: RepairSpecDetalizationInputDto;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecDataInputDto
     */
    'spotFactor'?: number;
    /**
     * 
     * @type {Array<RepairSpecItemDataInputDto>}
     * @memberof RepairSpecDataInputDto
     */
    'items'?: Array<RepairSpecItemDataInputDto>;
}


/**
 * 
 * @export
 * @interface RepairSpecDetalizationDto
 */
export interface RepairSpecDetalizationDto {
    /**
     * 
     * @type {RepairSpecDetalizationType}
     * @memberof RepairSpecDetalizationDto
     */
    'type'?: RepairSpecDetalizationType;
    /**
     * 
     * @type {VehicleSize}
     * @memberof RepairSpecDetalizationDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof RepairSpecDetalizationDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof RepairSpecDetalizationDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {VehicleMakeReferenceDto}
     * @memberof RepairSpecDetalizationDto
     */
    'make'?: VehicleMakeReferenceDto;
    /**
     * 
     * @type {VehicleModelReferenceDto}
     * @memberof RepairSpecDetalizationDto
     */
    'model'?: VehicleModelReferenceDto;
    /**
     * 
     * @type {VehicleGenerationReferenceDto}
     * @memberof RepairSpecDetalizationDto
     */
    'generation'?: VehicleGenerationReferenceDto;
    /**
     * 
     * @type {VehicleModificationReferenceDto}
     * @memberof RepairSpecDetalizationDto
     */
    'modification'?: VehicleModificationReferenceDto;
}


/**
 * 
 * @export
 * @interface RepairSpecDetalizationInputDto
 */
export interface RepairSpecDetalizationInputDto {
    /**
     * 
     * @type {RepairSpecDetalizationType}
     * @memberof RepairSpecDetalizationInputDto
     */
    'type'?: RepairSpecDetalizationType;
    /**
     * 
     * @type {VehicleSize}
     * @memberof RepairSpecDetalizationInputDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof RepairSpecDetalizationInputDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof RepairSpecDetalizationInputDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDetalizationInputDto
     */
    'makeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDetalizationInputDto
     */
    'modelId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDetalizationInputDto
     */
    'generationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDetalizationInputDto
     */
    'modificationId'?: string | null;
}


/**
 * Detalizations go from more general to more specific.  Priority: lower = more general, higher = more specific. Specific has priority.
 * @export
 * @enum {string}
 */

export const RepairSpecDetalizationType = {
    None: 'None',
    General: 'General',
    VehicleSize: 'VehicleSize',
    BodyType: 'BodyType',
    Make: 'Make',
    Model: 'Model',
    Generation: 'Generation',
    Modification: 'Modification'
} as const;

export type RepairSpecDetalizationType = typeof RepairSpecDetalizationType[keyof typeof RepairSpecDetalizationType];


/**
 * 
 * @export
 * @interface RepairSpecDto
 */
export interface RepairSpecDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof RepairSpecDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairSpecDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairSpecDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDto
     */
    'sourceTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDto
     */
    'repairCatalogId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDto
     */
    'sourceSpecId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof RepairSpecDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof RepairSpecDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehiclePartTypeReferenceDto}
     * @memberof RepairSpecDto
     */
    'partType'?: VehiclePartTypeReferenceDto;
    /**
     * 
     * @type {DamageTypeReferenceDto}
     * @memberof RepairSpecDto
     */
    'damageType'?: DamageTypeReferenceDto;
    /**
     * 
     * @type {RepairSpecDetalizationDto}
     * @memberof RepairSpecDto
     */
    'detalization'?: RepairSpecDetalizationDto;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecDto
     */
    'spotFactor'?: number;
    /**
     * 
     * @type {Array<RepairSpecItemDto>}
     * @memberof RepairSpecDto
     */
    'items'?: Array<RepairSpecItemDto>;
    /**
     * The last time when references (material, work, etc) were synced with the source entities.
     * @type {string}
     * @memberof RepairSpecDto
     */
    'lastReferenceSyncAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RepairSpecDto
     */
    'isDetailsHidden'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RepairSpecDto
     */
    'isGlobal'?: boolean;
    /**
     * 
     * @type {RepairType}
     * @memberof RepairSpecDto
     */
    'repairType'?: RepairType;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof RepairSpecDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof RepairSpecDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecDto
     */
    'total'?: number;
    /**
     * 
     * @type {EntityMatchMetaDto}
     * @memberof RepairSpecDto
     */
    'matchMeta'?: EntityMatchMetaDto;
}


/**
 * 
 * @export
 * @interface RepairSpecGetPaginatedDto
 */
export interface RepairSpecGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof RepairSpecGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairSpecGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairSpecGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairSpecGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof RepairSpecGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof RepairSpecGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof RepairSpecGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * ID of the target tenant from which to query data.  Allows to query from any of user\'s tenant.
     * @type {string}
     * @memberof RepairSpecGetPaginatedDto
     */
    'myTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RepairSpecGetPaginatedDto
     */
    'isGlobal'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecGetPaginatedDto
     */
    'damageTypeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecGetPaginatedDto
     */
    'partTypeId'?: string | null;
    /**
     * 
     * @type {VehicleType}
     * @memberof RepairSpecGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehicleSize}
     * @memberof RepairSpecGetPaginatedDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof RepairSpecGetPaginatedDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof RepairSpecGetPaginatedDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecGetPaginatedDto
     */
    'makeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecGetPaginatedDto
     */
    'modelId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecGetPaginatedDto
     */
    'generationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecGetPaginatedDto
     */
    'modificationId'?: string | null;
    /**
     * 
     * @type {RepairSpecMatchQueryDto}
     * @memberof RepairSpecGetPaginatedDto
     */
    'match'?: RepairSpecMatchQueryDto;
}


/**
 * 
 * @export
 * @interface RepairSpecItemCustomItemDto
 */
export interface RepairSpecItemCustomItemDto {
    /**
     * 
     * @type {boolean}
     * @memberof RepairSpecItemCustomItemDto
     */
    'isDetailsHidden'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemCustomItemDto
     */
    'name'?: string;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof RepairSpecItemCustomItemDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemCustomItemDto
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemCustomItemDto
     */
    'expendablesPercent'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof RepairSpecItemCustomItemDto
     */
    'isDividable'?: boolean;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof RepairSpecItemCustomItemDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof RepairSpecItemCustomItemDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemCustomItemDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemCustomItemDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemCustomItemDto
     */
    'total'?: number;
}


/**
 * 
 * @export
 * @interface RepairSpecItemCustomItemInputDto
 */
export interface RepairSpecItemCustomItemInputDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemCustomItemInputDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof RepairSpecItemCustomItemInputDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemCustomItemInputDto
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemCustomItemInputDto
     */
    'expendablesPercent'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof RepairSpecItemCustomItemInputDto
     */
    'isDividable'?: boolean;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof RepairSpecItemCustomItemInputDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof RepairSpecItemCustomItemInputDto
     */
    'tax'?: GeneralTaxInputDto;
}


/**
 * Data that can be changed and stored in other entities.  Data sync from the source entity is not expected by default.
 * @export
 * @interface RepairSpecItemDataDto
 */
export interface RepairSpecItemDataDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemDataDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemDataDto
     */
    'sourceTenantId'?: string | null;
    /**
     * 
     * @type {RepairSpecItemType}
     * @memberof RepairSpecItemDataDto
     */
    'type'?: RepairSpecItemType;
    /**
     * 
     * @type {RepairSpecItemType}
     * @memberof RepairSpecItemDataDto
     */
    'sourceType'?: RepairSpecItemType;
    /**
     * 
     * @type {RepairMaterialFullReferenceDto}
     * @memberof RepairSpecItemDataDto
     */
    'material'?: RepairMaterialFullReferenceDto;
    /**
     * 
     * @type {RepairWorkFullReferenceDto}
     * @memberof RepairSpecItemDataDto
     */
    'work'?: RepairWorkFullReferenceDto;
    /**
     * 
     * @type {RepairSpecSparePartDto}
     * @memberof RepairSpecItemDataDto
     */
    'sparePart'?: RepairSpecSparePartDto;
    /**
     * 
     * @type {RepairSpecItemCustomItemDto}
     * @memberof RepairSpecItemDataDto
     */
    'custom'?: RepairSpecItemCustomItemDto;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemDataDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDataDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDataDto
     */
    'spotFactor'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RepairSpecItemDataDto
     */
    'isDetailsHidden'?: boolean;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof RepairSpecItemDataDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDataDto
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDataDto
     */
    'expendablesPercent'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RepairSpecItemDataDto
     */
    'isDividable'?: boolean;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof RepairSpecItemDataDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof RepairSpecItemDataDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDataDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDataDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDataDto
     */
    'total'?: number;
}


/**
 * 
 * @export
 * @interface RepairSpecItemDataInputDto
 */
export interface RepairSpecItemDataInputDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemDataInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {RepairSpecItemType}
     * @memberof RepairSpecItemDataInputDto
     */
    'type'?: RepairSpecItemType;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemDataInputDto
     */
    'materialId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemDataInputDto
     */
    'workId'?: string | null;
    /**
     * 
     * @type {RepairSpecSparePartInputDto}
     * @memberof RepairSpecItemDataInputDto
     */
    'sparePart'?: RepairSpecSparePartInputDto;
    /**
     * 
     * @type {RepairSpecItemCustomItemInputDto}
     * @memberof RepairSpecItemDataInputDto
     */
    'custom'?: RepairSpecItemCustomItemInputDto;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDataInputDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDataInputDto
     */
    'spotFactor'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemDataInputDto
     */
    'notes'?: string | null;
}


/**
 * 
 * @export
 * @interface RepairSpecItemDto
 */
export interface RepairSpecItemDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemDto
     */
    'sourceTenantId'?: string | null;
    /**
     * 
     * @type {RepairSpecItemType}
     * @memberof RepairSpecItemDto
     */
    'type'?: RepairSpecItemType;
    /**
     * 
     * @type {RepairSpecItemType}
     * @memberof RepairSpecItemDto
     */
    'sourceType'?: RepairSpecItemType;
    /**
     * 
     * @type {RepairMaterialFullReferenceDto}
     * @memberof RepairSpecItemDto
     */
    'material'?: RepairMaterialFullReferenceDto;
    /**
     * 
     * @type {RepairWorkFullReferenceDto}
     * @memberof RepairSpecItemDto
     */
    'work'?: RepairWorkFullReferenceDto;
    /**
     * 
     * @type {RepairSpecSparePartDto}
     * @memberof RepairSpecItemDto
     */
    'sparePart'?: RepairSpecSparePartDto;
    /**
     * 
     * @type {RepairSpecItemCustomItemDto}
     * @memberof RepairSpecItemDto
     */
    'custom'?: RepairSpecItemCustomItemDto;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDto
     */
    'spotFactor'?: number;
    /**
     * The last time material, work, etc reference was synced with the source entity.
     * @type {string}
     * @memberof RepairSpecItemDto
     */
    'lastReferenceSyncAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RepairSpecItemDto
     */
    'isDetailsHidden'?: boolean;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof RepairSpecItemDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDto
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDto
     */
    'expendablesPercent'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RepairSpecItemDto
     */
    'isDividable'?: boolean;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof RepairSpecItemDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof RepairSpecItemDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemDto
     */
    'total'?: number;
}


/**
 * 
 * @export
 * @interface RepairSpecItemInputDto
 */
export interface RepairSpecItemInputDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {RepairSpecItemType}
     * @memberof RepairSpecItemInputDto
     */
    'type'?: RepairSpecItemType;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemInputDto
     */
    'materialId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemInputDto
     */
    'workId'?: string | null;
    /**
     * 
     * @type {RepairSpecSparePartInputDto}
     * @memberof RepairSpecItemInputDto
     */
    'sparePart'?: RepairSpecSparePartInputDto;
    /**
     * 
     * @type {RepairSpecItemCustomItemInputDto}
     * @memberof RepairSpecItemInputDto
     */
    'custom'?: RepairSpecItemCustomItemInputDto;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecItemInputDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemInputDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecItemInputDto
     */
    'spotFactor'?: number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const RepairSpecItemType = {
    None: 'None',
    Material: 'Material',
    SparePart: 'SparePart',
    Work: 'Work',
    Custom: 'Custom'
} as const;

export type RepairSpecItemType = typeof RepairSpecItemType[keyof typeof RepairSpecItemType];


/**
 * Describes props used for RepairSpec matching for vehicle part type, damage type, vehicle spec.    These props might be combined in DB query via AND, OR operators, meaning they are not just all AND-ed or OR-ed.
 * @export
 * @interface RepairSpecMatchQueryDto
 */
export interface RepairSpecMatchQueryDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSpecMatchQueryDto
     */
    'partTypeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecMatchQueryDto
     */
    'damageTypeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecMatchQueryDto
     */
    'vehicleId'?: string | null;
}
/**
 * 
 * @export
 * @interface RepairSpecNameSuggestionsDto
 */
export interface RepairSpecNameSuggestionsDto {
    /**
     * 
     * @type {Array<NameSuggestionDtoInRepairSpecNameSuggestionsDto>}
     * @memberof RepairSpecNameSuggestionsDto
     */
    'suggestions'?: Array<NameSuggestionDtoInRepairSpecNameSuggestionsDto>;
}
/**
 * 
 * @export
 * @interface RepairSpecReferenceDto
 */
export interface RepairSpecReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSpecReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof RepairSpecReferenceDto
     */
    'formType'?: EntityFormType;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairSpecReferenceDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {RepairSpecDetalizationType}
     * @memberof RepairSpecReferenceDto
     */
    'detalizationType'?: RepairSpecDetalizationType;
}


/**
 * 
 * @export
 * @interface RepairSpecSparePartDto
 */
export interface RepairSpecSparePartDto {
    /**
     * 
     * @type {RepairSparePartFullReferenceDto}
     * @memberof RepairSpecSparePartDto
     */
    'sparePart'?: RepairSparePartFullReferenceDto;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof RepairSpecSparePartDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecSparePartDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof RepairSpecSparePartDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof RepairSpecSparePartDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecSparePartDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecSparePartDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecSparePartDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface RepairSpecSparePartInputDto
 */
export interface RepairSpecSparePartInputDto {
    /**
     * 
     * @type {string}
     * @memberof RepairSpecSparePartInputDto
     */
    'sparePartId'?: string;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof RepairSpecSparePartInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {number}
     * @memberof RepairSpecSparePartInputDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof RepairSpecSparePartInputDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof RepairSpecSparePartInputDto
     */
    'tax'?: GeneralTaxInputDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RepairType = {
    None: 'None',
    Spot: 'Spot',
    Full: 'Full'
} as const;

export type RepairType = typeof RepairType[keyof typeof RepairType];


/**
 * 
 * @export
 * @interface RepairWorkChangedDto
 */
export interface RepairWorkChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairWorkChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof RepairWorkChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof RepairWorkChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {RepairWorkDto}
     * @memberof RepairWorkChangedDto
     */
    'entity': RepairWorkDto;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface RepairWorkDto
 */
export interface RepairWorkDto {
    /**
     * 
     * @type {string}
     * @memberof RepairWorkDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof RepairWorkDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairWorkDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RepairWorkDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkDto
     */
    'repairCatalogId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkDto
     */
    'sourceWorkId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof RepairWorkDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof RepairWorkDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {number}
     * @memberof RepairWorkDto
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairWorkDto
     */
    'expendablesPercent'?: number;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof RepairWorkDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof RepairWorkDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {boolean}
     * @memberof RepairWorkDto
     */
    'isGlobal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RepairWorkDto
     */
    'isDividable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RepairWorkDto
     */
    'isExpendablesIncluded'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RepairWorkDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairWorkDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairWorkDto
     */
    'total'?: number;
}


/**
 * 
 * @export
 * @interface RepairWorkFullReferenceDto
 */
export interface RepairWorkFullReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof RepairWorkFullReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkFullReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkFullReferenceDto
     */
    'repairCatalogId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkFullReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkFullReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkFullReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkFullReferenceDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof RepairWorkFullReferenceDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof RepairWorkFullReferenceDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {number}
     * @memberof RepairWorkFullReferenceDto
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairWorkFullReferenceDto
     */
    'expendablesPercent'?: number;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof RepairWorkFullReferenceDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof RepairWorkFullReferenceDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {boolean}
     * @memberof RepairWorkFullReferenceDto
     */
    'isGlobal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RepairWorkFullReferenceDto
     */
    'isDividable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RepairWorkFullReferenceDto
     */
    'isExpendablesIncluded'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RepairWorkFullReferenceDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairWorkFullReferenceDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairWorkFullReferenceDto
     */
    'total'?: number;
}


/**
 * 
 * @export
 * @interface RepairWorkGetPaginatedDto
 */
export interface RepairWorkGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof RepairWorkGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairWorkGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairWorkGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairWorkGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepairWorkGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof RepairWorkGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof RepairWorkGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof RepairWorkGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * ID of the target tenant from which to query data.  Allows to query from any of user\'s tenant.
     * @type {string}
     * @memberof RepairWorkGetPaginatedDto
     */
    'myTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RepairWorkGetPaginatedDto
     */
    'isGlobal'?: boolean | null;
}
/**
 * 
 * @export
 * @interface RepairWorkReferenceDto
 */
export interface RepairWorkReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof RepairWorkReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairWorkReferenceDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ReportMyChatParticipantStatusDto
 */
export interface ReportMyChatParticipantStatusDto {
    /**
     * 
     * @type {string}
     * @memberof ReportMyChatParticipantStatusDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportMyChatParticipantStatusDto
     */
    'participantId'?: string;
    /**
     * 
     * @type {ChatParticipantOnlineStatus}
     * @memberof ReportMyChatParticipantStatusDto
     */
    'onlineStatus'?: ChatParticipantOnlineStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportMyChatParticipantStatusDto
     */
    'onlyToConnectionIds'?: Array<string> | null;
    /**
     * If true, receiving participant should report own status to the sender.
     * @type {boolean}
     * @memberof ReportMyChatParticipantStatusDto
     */
    'isReportBack'?: boolean | null;
}


/**
 * 
 * @export
 * @interface RespondOnManyProposalsDto
 */
export interface RespondOnManyProposalsDto {
    /**
     * 
     * @type {Array<PairDtoOfStringAndString>}
     * @memberof RespondOnManyProposalsDto
     */
    'byNegotiationAndProposalId'?: Array<PairDtoOfStringAndString> | null;
    /**
     * 
     * @type {GeneralScopeInfoDto}
     * @memberof RespondOnManyProposalsDto
     */
    'byParentScope'?: GeneralScopeInfoDto;
    /**
     * 
     * @type {Array<GeneralScopeInfoDto>}
     * @memberof RespondOnManyProposalsDto
     */
    'byScopes'?: Array<GeneralScopeInfoDto> | null;
    /**
     * 
     * @type {ApprovalResponseType}
     * @memberof RespondOnManyProposalsDto
     */
    'responseType'?: ApprovalResponseType;
    /**
     * 
     * @type {boolean}
     * @memberof RespondOnManyProposalsDto
     */
    'onlyForProposalsWithoutPartyMemberResponse'?: boolean | null;
    /**
     * 
     * @type {Array<ProposalStatus>}
     * @memberof RespondOnManyProposalsDto
     */
    'onlyForProposalsWithStatuses'?: Array<ProposalStatus> | null;
}


/**
 * 
 * @export
 * @interface RespondOnManyProposalsInfoDto
 */
export interface RespondOnManyProposalsInfoDto {
    /**
     * 
     * @type {Array<ChatReferenceDto>}
     * @memberof RespondOnManyProposalsInfoDto
     */
    'chats'?: Array<ChatReferenceDto>;
    /**
     * 
     * @type {Array<NegotiationReferenceDto>}
     * @memberof RespondOnManyProposalsInfoDto
     */
    'negotiations'?: Array<NegotiationReferenceDto>;
    /**
     * 
     * @type {Array<NegotiationProposalDto>}
     * @memberof RespondOnManyProposalsInfoDto
     */
    'proposals'?: Array<NegotiationProposalDto>;
    /**
     * 
     * @type {number}
     * @memberof RespondOnManyProposalsInfoDto
     */
    'chatCount'?: number;
    /**
     * Chats where requesting user is a participant.
     * @type {number}
     * @memberof RespondOnManyProposalsInfoDto
     */
    'chatWhereIsParticipantCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RespondOnManyProposalsInfoDto
     */
    'isParticipantOfAllChats'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RespondOnManyProposalsInfoDto
     */
    'negotiationCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RespondOnManyProposalsInfoDto
     */
    'proposalCount'?: number;
    /**
     * Proposals on which requesting used have responded.
     * @type {number}
     * @memberof RespondOnManyProposalsInfoDto
     */
    'respondedProposalCount'?: number;
    /**
     * Proposals on which requesting used haven\'t responded.
     * @type {number}
     * @memberof RespondOnManyProposalsInfoDto
     */
    'notRespondedProposalCount'?: number;
}
/**
 * 
 * @export
 * @interface RespondOnManyProposalsInfoRequestDto
 */
export interface RespondOnManyProposalsInfoRequestDto {
    /**
     * 
     * @type {Array<PairDtoOfStringAndString>}
     * @memberof RespondOnManyProposalsInfoRequestDto
     */
    'byNegotiationAndProposalId'?: Array<PairDtoOfStringAndString> | null;
    /**
     * 
     * @type {GeneralScopeInfoDto}
     * @memberof RespondOnManyProposalsInfoRequestDto
     */
    'byParentScope'?: GeneralScopeInfoDto;
    /**
     * 
     * @type {Array<GeneralScopeInfoDto>}
     * @memberof RespondOnManyProposalsInfoRequestDto
     */
    'byScopes'?: Array<GeneralScopeInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RespondOnManyProposalsInfoRequestDto
     */
    'onlyForProposalsWithoutPartyMemberResponse'?: boolean | null;
    /**
     * 
     * @type {Array<ProposalStatus>}
     * @memberof RespondOnManyProposalsInfoRequestDto
     */
    'onlyForProposalsWithStatuses'?: Array<ProposalStatus> | null;
}
/**
 * 
 * @export
 * @interface RespondOnNegotiationProposalDto
 */
export interface RespondOnNegotiationProposalDto {
    /**
     * 
     * @type {string}
     * @memberof RespondOnNegotiationProposalDto
     */
    'proposalId'?: string;
    /**
     * 
     * @type {ApprovalResponseType}
     * @memberof RespondOnNegotiationProposalDto
     */
    'responseType'?: ApprovalResponseType;
}


/**
 * 
 * @export
 * @interface ResultDtoInVehicleStatusBulkUpdateResultDto
 */
export interface ResultDtoInVehicleStatusBulkUpdateResultDto {
    /**
     * 
     * @type {VehicleDto}
     * @memberof ResultDtoInVehicleStatusBulkUpdateResultDto
     */
    'vehicle': VehicleDto;
    /**
     * 
     * @type {boolean}
     * @memberof ResultDtoInVehicleStatusBulkUpdateResultDto
     */
    'isUpdated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResultDtoInVehicleStatusBulkUpdateResultDto
     */
    'isError'?: boolean;
    /**
     * 
     * @type {ValidationProblemDetails}
     * @memberof ResultDtoInVehicleStatusBulkUpdateResultDto
     */
    'problemDetails'?: ValidationProblemDetails;
}
/**
 * 
 * @export
 * @interface RoleAssignmentRestrictionsDto
 */
export interface RoleAssignmentRestrictionsDto {
    /**
     * User which is going to apply role assignment.
     * @type {string}
     * @memberof RoleAssignmentRestrictionsDto
     */
    'byUserId'?: string;
    /**
     * User for which role assignment is applied.
     * @type {string}
     * @memberof RoleAssignmentRestrictionsDto
     */
    'targetUserId'?: string;
    /**
     * Context of an assignment. Global if null.
     * @type {string}
     * @memberof RoleAssignmentRestrictionsDto
     */
    'tenantId'?: string | null;
    /**
     * Roles that can be assigned by the user to target user.
     * @type {Array<RoleDto>}
     * @memberof RoleAssignmentRestrictionsDto
     */
    'allowedRoles'?: Array<RoleDto>;
    /**
     * Roles that can\'t be assigned by the user to target user.
     * @type {Array<RoleDto>}
     * @memberof RoleAssignmentRestrictionsDto
     */
    'disallowedRoles'?: Array<RoleDto>;
    /**
     * Roles that can be unassigned by the user from target user.
     * @type {Array<RoleDto>}
     * @memberof RoleAssignmentRestrictionsDto
     */
    'unassignAllowedRoles'?: Array<RoleDto>;
    /**
     * Roles that can\'t be unassigned by the user from target user.
     * @type {Array<RoleDto>}
     * @memberof RoleAssignmentRestrictionsDto
     */
    'unassignDisallowedRoles'?: Array<RoleDto>;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof RoleAssignmentRestrictionsDto
     */
    'allowedRoleIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof RoleAssignmentRestrictionsDto
     */
    'disallowedRoleIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof RoleAssignmentRestrictionsDto
     */
    'unassignAllowedRoleIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof RoleAssignmentRestrictionsDto
     */
    'unassignDisallowedRoleIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {Array<AppPermission>}
     * @memberof RoleAssignmentRestrictionsDto
     */
    'allowedPermissions'?: Array<AppPermission>;
    /**
     * 
     * @type {Array<AppPermission>}
     * @memberof RoleAssignmentRestrictionsDto
     */
    'disallowedPermissions'?: Array<AppPermission>;
}
/**
 * 
 * @export
 * @interface RoleChangedDto
 */
export interface RoleChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof RoleChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof RoleChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof RoleChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof RoleChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof RoleChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {RoleDto}
     * @memberof RoleChangedDto
     */
    'entity': RoleDto;
    /**
     * 
     * @type {string}
     * @memberof RoleChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'builtInRole'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'isScoped'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'isTest'?: boolean;
    /**
     * 
     * @type {Array<AppPermission>}
     * @memberof RoleDto
     */
    'permissions'?: Array<AppPermission>;
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    'sortOrder'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RoleDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof RoleDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'canBeEdited'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'canBeDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface RoleReferenceDto
 */
export interface RoleReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof RoleReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof RoleReferenceDto
     */
    'formType'?: EntityFormType;
    /**
     * 
     * @type {string}
     * @memberof RoleReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RoleReferenceDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleReferenceDto
     */
    'builtInRole'?: string | null;
}


/**
 * 
 * @export
 * @interface ScheduleEntriesGetDto
 */
export interface ScheduleEntriesGetDto {
    /**
     * 
     * @type {DateRangeRequiredInputDto}
     * @memberof ScheduleEntriesGetDto
     */
    'range'?: DateRangeRequiredInputDto;
    /**
     * 
     * @type {Array<ScheduleEntryEntityType>}
     * @memberof ScheduleEntriesGetDto
     */
    'entityTypes'?: Array<ScheduleEntryEntityType> | null;
}
/**
 * 
 * @export
 * @interface ScheduleEntriesResultDto
 */
export interface ScheduleEntriesResultDto {
    /**
     * 
     * @type {Array<ScheduleEntryDto>}
     * @memberof ScheduleEntriesResultDto
     */
    'entries'?: Array<ScheduleEntryDto>;
}
/**
 * Canonical schedule entry that represents a timeline of events across all time periods.    Can be rendered by calendar, timeline, agenda, etc. views.
 * @export
 * @interface ScheduleEntryDto
 */
export interface ScheduleEntryDto {
    /**
     * <inheritdoc cref=\"P:Application.Features.Schedule.Models.ScheduleEntry.Id\" />
     * @type {string}
     * @memberof ScheduleEntryDto
     */
    'id'?: string;
    /**
     * 
     * @type {ScheduleEntryKind}
     * @memberof ScheduleEntryDto
     */
    'kind': ScheduleEntryKind;
    /**
     * 
     * @type {ScheduleEntryDurationType}
     * @memberof ScheduleEntryDto
     */
    'durationType': ScheduleEntryDurationType;
    /**
     * Point in time. Mutually exclusive with StartAt/EndAt.
     * @type {string}
     * @memberof ScheduleEntryDto
     */
    'pointAt': string | null;
    /**
     * Range start. Used when entry represents a time span.
     * @type {string}
     * @memberof ScheduleEntryDto
     */
    'startsAt': string | null;
    /**
     * Range end. Used when entry represents a time span.
     * @type {string}
     * @memberof ScheduleEntryDto
     */
    'endsAt': string | null;
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof ScheduleEntryDto
     */
    'resourceEntity': GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {ScheduleEntrySourceEntityDto}
     * @memberof ScheduleEntryDto
     */
    'sourceEntity': ScheduleEntrySourceEntityDto;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ScheduleEntryDurationType = {
    None: 'None',
    Point: 'Point',
    Range: 'Range'
} as const;

export type ScheduleEntryDurationType = typeof ScheduleEntryDurationType[keyof typeof ScheduleEntryDurationType];


/**
 * Entity types that can be mapped to schedule entry.  Must contain only values from EntityType.
 * @export
 * @enum {string}
 */

export const ScheduleEntryEntityType = {
    None: 'None',
    Contract: 'Contract',
    AssetSubscription: 'AssetSubscription',
    AccessoryCheck: 'AccessoryCheck',
    VisualInspection: 'VisualInspection',
    DamageDetection: 'DamageDetection',
    DamageCostEvaluation: 'DamageCostEvaluation',
    RepairOperation: 'RepairOperation',
    Wash: 'Wash',
    WheelOperation: 'WheelOperation',
    Maintenance: 'Maintenance',
    GeneralStatusHistory: 'GeneralStatusHistory'
} as const;

export type ScheduleEntryEntityType = typeof ScheduleEntryEntityType[keyof typeof ScheduleEntryEntityType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ScheduleEntryKind = {
    None: 'None',
    Activity: 'Activity',
    Status: 'Status'
} as const;

export type ScheduleEntryKind = typeof ScheduleEntryKind[keyof typeof ScheduleEntryKind];


/**
 * Source entity from which this entry was derived.
 * @export
 * @interface ScheduleEntrySourceEntityDto
 */
export interface ScheduleEntrySourceEntityDto {
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof ScheduleEntrySourceEntityDto
     */
    'entity'?: GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {ContractDto}
     * @memberof ScheduleEntrySourceEntityDto
     */
    'contract'?: ContractDto;
    /**
     * 
     * @type {AssetSubscriptionDto}
     * @memberof ScheduleEntrySourceEntityDto
     */
    'assetSubscription'?: AssetSubscriptionDto;
    /**
     * 
     * @type {AccessoryCheckDto}
     * @memberof ScheduleEntrySourceEntityDto
     */
    'accessoryCheck'?: AccessoryCheckDto;
    /**
     * 
     * @type {VisualInspectionDto}
     * @memberof ScheduleEntrySourceEntityDto
     */
    'visualInspection'?: VisualInspectionDto;
    /**
     * 
     * @type {DamageDetectionDto}
     * @memberof ScheduleEntrySourceEntityDto
     */
    'damageDetection'?: DamageDetectionDto;
    /**
     * 
     * @type {DamageCostEvaluationDto}
     * @memberof ScheduleEntrySourceEntityDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationDto;
    /**
     * 
     * @type {RepairOperationDto}
     * @memberof ScheduleEntrySourceEntityDto
     */
    'repairOperation'?: RepairOperationDto;
    /**
     * 
     * @type {WashDto}
     * @memberof ScheduleEntrySourceEntityDto
     */
    'wash'?: WashDto;
    /**
     * 
     * @type {WheelOperationDto}
     * @memberof ScheduleEntrySourceEntityDto
     */
    'wheelOperation'?: WheelOperationDto;
    /**
     * 
     * @type {MaintenanceDto}
     * @memberof ScheduleEntrySourceEntityDto
     */
    'maintenance'?: MaintenanceDto;
    /**
     * 
     * @type {GeneralStatusHistoryDto}
     * @memberof ScheduleEntrySourceEntityDto
     */
    'generalStatusHistory'?: GeneralStatusHistoryDto;
    /**
     * 
     * @type {ScheduleEntryEntityType}
     * @memberof ScheduleEntrySourceEntityDto
     */
    'entityType'?: ScheduleEntryEntityType;
}


/**
 * 
 * @export
 * @interface ScheduleStatusEntriesGetDto
 */
export interface ScheduleStatusEntriesGetDto {
    /**
     * 
     * @type {DateRangeRequiredInputDto}
     * @memberof ScheduleStatusEntriesGetDto
     */
    'range'?: DateRangeRequiredInputDto;
    /**
     * Which status timelines to return.
     * @type {Array<GeneralStatusIdentifier>}
     * @memberof ScheduleStatusEntriesGetDto
     */
    'statusIdentifiers'?: Array<GeneralStatusIdentifier> | null;
}
/**
 * 
 * @export
 * @interface SendChatMessageDto
 */
export interface SendChatMessageDto {
    /**
     * 
     * @type {string}
     * @memberof SendChatMessageDto
     */
    'participantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessageDto
     */
    'body'?: string | null;
    /**
     * 
     * @type {ChatMessageRootNodeInputDto}
     * @memberof SendChatMessageDto
     */
    'rootNode'?: ChatMessageRootNodeInputDto;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof SendChatMessageDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
}
/**
 * 
 * @export
 * @interface SendEmailVerificationTokenDto
 */
export interface SendEmailVerificationTokenDto {
    /**
     * 
     * @type {string}
     * @memberof SendEmailVerificationTokenDto
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface SendGridEmailSettingsDto
 */
export interface SendGridEmailSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof SendGridEmailSettingsDto
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof SendGridEmailSettingsDto
     */
    'fromName'?: string;
    /**
     * 
     * @type {UserSecretReferenceDto}
     * @memberof SendGridEmailSettingsDto
     */
    'apiKey'?: UserSecretReferenceDto;
}
/**
 * 
 * @export
 * @interface SendGridEmailSettingsInputDto
 */
export interface SendGridEmailSettingsInputDto {
    /**
     * 
     * @type {string}
     * @memberof SendGridEmailSettingsInputDto
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof SendGridEmailSettingsInputDto
     */
    'fromName'?: string;
    /**
     * 
     * @type {UserSecretInputDto}
     * @memberof SendGridEmailSettingsInputDto
     */
    'apiKey'?: UserSecretInputDto;
}
/**
 * 
 * @export
 * @interface SendTestEventsDto
 */
export interface SendTestEventsDto {
    /**
     * 
     * @type {Array<TestEventDto>}
     * @memberof SendTestEventsDto
     */
    'testEvents'?: Array<TestEventDto>;
}
/**
 * 
 * @export
 * @interface Size
 */
export interface Size {
    /**
     * 
     * @type {boolean}
     * @memberof Size
     */
    'isEmpty'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Size
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof Size
     */
    'height'?: number;
}
/**
 * 
 * @export
 * @interface SmsChannelInfoDto
 */
export interface SmsChannelInfoDto {
    /**
     * 
     * @type {string}
     * @memberof SmsChannelInfoDto
     */
    'to'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmsChannelInfoDto
     */
    'body'?: string;
}
/**
 * 
 * @export
 * @interface SmtpEmailSettingsDto
 */
export interface SmtpEmailSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof SmtpEmailSettingsDto
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmtpEmailSettingsDto
     */
    'fromName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmtpEmailSettingsDto
     */
    'replyTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmtpEmailSettingsDto
     */
    'host'?: string;
    /**
     * 
     * @type {number}
     * @memberof SmtpEmailSettingsDto
     */
    'port'?: number;
    /**
     * 
     * @type {string}
     * @memberof SmtpEmailSettingsDto
     */
    'username'?: string;
    /**
     * 
     * @type {UserSecretReferenceDto}
     * @memberof SmtpEmailSettingsDto
     */
    'password'?: UserSecretReferenceDto;
}
/**
 * 
 * @export
 * @interface SmtpEmailSettingsInputDto
 */
export interface SmtpEmailSettingsInputDto {
    /**
     * 
     * @type {string}
     * @memberof SmtpEmailSettingsInputDto
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmtpEmailSettingsInputDto
     */
    'fromName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SmtpEmailSettingsInputDto
     */
    'replyTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmtpEmailSettingsInputDto
     */
    'host'?: string;
    /**
     * 
     * @type {number}
     * @memberof SmtpEmailSettingsInputDto
     */
    'port'?: number;
    /**
     * 
     * @type {string}
     * @memberof SmtpEmailSettingsInputDto
     */
    'username'?: string;
    /**
     * 
     * @type {UserSecretInputDto}
     * @memberof SmtpEmailSettingsInputDto
     */
    'password'?: UserSecretInputDto;
}
/**
 * Defines sorting on one or multiple fields.
 * @export
 * @interface SortDefinitionDto
 */
export interface SortDefinitionDto {
    /**
     * Comma-separated list of fields to sort by.
     * @type {string}
     * @memberof SortDefinitionDto
     */
    'sortBy'?: string | null;
    /**
     * Comma-separated list of sort orders, with indexes corresponding to fields.  See values in SortOrder enum.
     * @type {string}
     * @memberof SortDefinitionDto
     */
    'sortOrder'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SortOrder = {
    None: 'None',
    Asc: 'Asc',
    Desc: 'Desc'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];


/**
 * 
 * @export
 * @interface SpotChangedDto
 */
export interface SpotChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SpotChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SpotChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof SpotChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof SpotChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof SpotChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {SpotDto}
     * @memberof SpotChangedDto
     */
    'entity': SpotDto;
    /**
     * 
     * @type {string}
     * @memberof SpotChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface SpotDto
 */
export interface SpotDto {
    /**
     * 
     * @type {string}
     * @memberof SpotDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof SpotDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SpotDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SpotDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpotDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpotDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpotDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpotDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {LocationReferenceDto}
     * @memberof SpotDto
     */
    'location'?: LocationReferenceDto;
    /**
     * 
     * @type {ProductLocationReferenceDto}
     * @memberof SpotDto
     */
    'productLocation'?: ProductLocationReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof SpotDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpotDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {Array<SpotType>}
     * @memberof SpotDto
     */
    'types'?: Array<SpotType>;
    /**
     * 
     * @type {string}
     * @memberof SpotDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpotDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAddressDto}
     * @memberof SpotDto
     */
    'address'?: GeneralAddressDto;
    /**
     * 
     * @type {GeneralGeolocationDto}
     * @memberof SpotDto
     */
    'geolocation'?: GeneralGeolocationDto;
}


/**
 * SpotExtractedData.
 * @export
 * @interface SpotExtractedDataDto
 */
export interface SpotExtractedDataDto {
    /**
     * Auto-generated ID for this extracted data record.    Used for caching, logging, or referencing this specific extraction.
     * @type {string}
     * @memberof SpotExtractedDataDto
     */
    'extractedDataId'?: string;
    /**
     * 
     * @type {ExtractedDocumentType}
     * @memberof SpotExtractedDataDto
     */
    'documentType'?: ExtractedDocumentType;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Common.DocumentIntelligence.Base.BaseExtractedData.DocumentConfidence\" />
     * @type {number}
     * @memberof SpotExtractedDataDto
     */
    'documentConfidence'?: number;
    /**
     * 
     * @type {ExtractedDocumentConfidenceLevel}
     * @memberof SpotExtractedDataDto
     */
    'documentConfidenceLevel'?: ExtractedDocumentConfidenceLevel;
    /**
     * Entity ID matched using extracted data after extraction in post-processing.
     * @type {string}
     * @memberof SpotExtractedDataDto
     */
    'matchedId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpotExtractedDataDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {GeneralAddressDto}
     * @memberof SpotExtractedDataDto
     */
    'address'?: GeneralAddressDto;
}


/**
 * 
 * @export
 * @interface SpotFullReferenceDto
 */
export interface SpotFullReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof SpotFullReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpotFullReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {LocationReferenceDto}
     * @memberof SpotFullReferenceDto
     */
    'location'?: LocationReferenceDto;
    /**
     * 
     * @type {ProductLocationReferenceDto}
     * @memberof SpotFullReferenceDto
     */
    'productLocation'?: ProductLocationReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof SpotFullReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpotFullReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {Array<SpotType>}
     * @memberof SpotFullReferenceDto
     */
    'types'?: Array<SpotType>;
    /**
     * 
     * @type {string}
     * @memberof SpotFullReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpotFullReferenceDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAddressDto}
     * @memberof SpotFullReferenceDto
     */
    'address'?: GeneralAddressDto;
}
/**
 * 
 * @export
 * @interface SpotGetPaginatedDto
 */
export interface SpotGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof SpotGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof SpotGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof SpotGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpotGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpotGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpotGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof SpotGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof SpotGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof SpotGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof SpotGetPaginatedDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpotGetPaginatedDto
     */
    'productLocationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpotGetPaginatedDto
     */
    'notForLocationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpotGetPaginatedDto
     */
    'notForProductLocationId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SpotGetPaginatedDto
     */
    'isWithLocation'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SpotGetPaginatedDto
     */
    'isWithProductLocation'?: boolean | null;
    /**
     * 
     * @type {SpotType}
     * @memberof SpotGetPaginatedDto
     */
    'type'?: SpotType;
    /**
     * 
     * @type {Array<SpotType>}
     * @memberof SpotGetPaginatedDto
     */
    'types'?: Array<SpotType> | null;
    /**
     * 
     * @type {GeneralGeolocationQueryDto}
     * @memberof SpotGetPaginatedDto
     */
    'geolocation'?: GeneralGeolocationQueryDto;
}


/**
 * 
 * @export
 * @interface SpotReferenceDto
 */
export interface SpotReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof SpotReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpotReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {LocationReferenceDto}
     * @memberof SpotReferenceDto
     */
    'location'?: LocationReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof SpotReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpotReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SpotType = {
    None: 'None',
    Delivery: 'Delivery',
    CheckOut: 'CheckOut',
    CheckIn: 'CheckIn',
    Pickup: 'Pickup',
    Return: 'Return',
    Service: 'Service'
} as const;

export type SpotType = typeof SpotType[keyof typeof SpotType];


/**
 * 
 * @export
 * @interface StartCostEvaluationDto
 */
export interface StartCostEvaluationDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof StartCostEvaluationDto
     */
    'aggregateItemIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface StartCostEvaluationResponseDto
 */
export interface StartCostEvaluationResponseDto {
    /**
     * 
     * @type {DamageDetectionAggregateDto}
     * @memberof StartCostEvaluationResponseDto
     */
    'damageDetectionAggregate'?: DamageDetectionAggregateDto;
    /**
     * 
     * @type {DamageCostEvaluationDto}
     * @memberof StartCostEvaluationResponseDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationDto;
}
/**
 * 
 * @export
 * @interface StatusCountSummaryDtoOfVehicleStatus
 */
export interface StatusCountSummaryDtoOfVehicleStatus {
    /**
     * 
     * @type {string}
     * @memberof StatusCountSummaryDtoOfVehicleStatus
     */
    'dataSeriesId': string;
    /**
     * 
     * @type {Array<DataPointDtoOfVehicleStatusAndInt64>}
     * @memberof StatusCountSummaryDtoOfVehicleStatus
     */
    'points': Array<DataPointDtoOfVehicleStatusAndInt64>;
}
/**
 * Generic enum for requirements related to submissions (e.g., forms, uploads, or verifications).    Specific requirement types should be defined in more specialized enums.
 * @export
 * @enum {string}
 */

export const SubmissionRequirement = {
    None: 'None',
    NotRequired: 'NotRequired',
    Optional: 'Optional',
    Required: 'Required'
} as const;

export type SubmissionRequirement = typeof SubmissionRequirement[keyof typeof SubmissionRequirement];


/**
 * 
 * @export
 * @interface SubmitMappingDto
 */
export interface SubmitMappingDto {
    /**
     * 
     * @type {ImportType}
     * @memberof SubmitMappingDto
     */
    'type'?: ImportType;
    /**
     * Flag that indicates whether we should save template of this import for future
     * @type {boolean}
     * @memberof SubmitMappingDto
     */
    'isSaveTemplate'?: boolean;
    /**
     * Name for this mapping if we want to save him
     * @type {string}
     * @memberof SubmitMappingDto
     */
    'name'?: string | null;
    /**
     * Mapping definition
     * @type {Array<ImportMappingItemInputDto>}
     * @memberof SubmitMappingDto
     */
    'items'?: Array<ImportMappingItemInputDto>;
}


/**
 * 
 * @export
 * @interface SubmitUploadDto
 */
export interface SubmitUploadDto {
    /**
     * 
     * @type {ImportType}
     * @memberof SubmitUploadDto
     */
    'type'?: ImportType;
    /**
     * 
     * @type {GeneralAttachmentInputDto}
     * @memberof SubmitUploadDto
     */
    'attachment'?: GeneralAttachmentInputDto;
}


/**
 * 
 * @export
 * @interface SubscribeOnDataUpdatesDto
 */
export interface SubscribeOnDataUpdatesDto {
    /**
     * 
     * @type {string}
     * @memberof SubscribeOnDataUpdatesDto
     */
    'channelName'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscribeOnDataUpdatesDto
     */
    'channelNames'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscribeOnDataUpdatesDto
     */
    'allChannelNames'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SubscribeToChatActivityUpdatesDto
 */
export interface SubscribeToChatActivityUpdatesDto {
    /**
     * 
     * @type {string}
     * @memberof SubscribeToChatActivityUpdatesDto
     */
    'chatId'?: string;
}
/**
 * 
 * @export
 * @interface SubscriptionAssetDto
 */
export interface SubscriptionAssetDto {
    /**
     * 
     * @type {AssetReferenceDto}
     * @memberof SubscriptionAssetDto
     */
    'asset'?: AssetReferenceDto;
    /**
     * 
     * @type {AssetEntityType}
     * @memberof SubscriptionAssetDto
     */
    'entityType'?: AssetEntityType;
    /**
     * 
     * @type {PoolItemReferenceDto}
     * @memberof SubscriptionAssetDto
     */
    'poolItem'?: PoolItemReferenceDto;
}


/**
 * 
 * @export
 * @interface SubscriptionChangedDto
 */
export interface SubscriptionChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof SubscriptionChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof SubscriptionChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {SubscriptionDto}
     * @memberof SubscriptionChangedDto
     */
    'entity': SubscriptionDto;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface SubscriptionDto
 */
export interface SubscriptionDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDto
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionDto
     */
    'isCurrent'?: boolean;
    /**
     * 
     * @type {SubscriptionSelectedPlanDto}
     * @memberof SubscriptionDto
     */
    'plan'?: SubscriptionSelectedPlanDto;
    /**
     * 
     * @type {SubscriptionStatus}
     * @memberof SubscriptionDto
     */
    'status'?: SubscriptionStatus;
    /**
     * 
     * @type {BillingPeriod}
     * @memberof SubscriptionDto
     */
    'period'?: BillingPeriod;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SubscriptionDto
     */
    'currentPeriodStartsAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SubscriptionDto
     */
    'currentPeriodEndsAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SubscriptionDto
     */
    'startsAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SubscriptionDto
     */
    'endsAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SubscriptionDto
     */
    'endedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SubscriptionDto
     */
    'activatedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SubscriptionDto
     */
    'pastDueAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDto
     */
    'activatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDto
     */
    'lastInvoiceId'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SubscriptionDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SubscriptionDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDto
     */
    'updatedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface SubscriptionGetPaginatedDto
 */
export interface SubscriptionGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof SubscriptionGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof SubscriptionGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof SubscriptionGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
}
/**
 * 
 * @export
 * @interface SubscriptionPlanChangedDto
 */
export interface SubscriptionPlanChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionPlanChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof SubscriptionPlanChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof SubscriptionPlanChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {SubscriptionPlanDto}
     * @memberof SubscriptionPlanChangedDto
     */
    'entity': SubscriptionPlanDto;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface SubscriptionPlanDto
 */
export interface SubscriptionPlanDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPlanDto
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPlanDto
     */
    'isFree'?: boolean;
    /**
     * 
     * @type {Array<SubscriptionPlanPriceDto>}
     * @memberof SubscriptionPlanDto
     */
    'prices'?: Array<SubscriptionPlanPriceDto>;
    /**
     * 
     * @type {Array<AppModule>}
     * @memberof SubscriptionPlanDto
     */
    'modules'?: Array<AppModule>;
    /**
     * 
     * @type {object}
     * @memberof SubscriptionPlanDto
     */
    'limits'?: object;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SubscriptionPlanDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SubscriptionPlanDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDto
     */
    'updatedBy'?: string | null;
}
/**
 * 
 * @export
 * @interface SubscriptionPlanDurationDto
 */
export interface SubscriptionPlanDurationDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDurationDto
     */
    'id'?: string;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof SubscriptionPlanDurationDto
     */
    'minDuration'?: string | null;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof SubscriptionPlanDurationDto
     */
    'discount'?: GeneralDiscountDto;
}
/**
 * 
 * @export
 * @interface SubscriptionPlanDurationInputDto
 */
export interface SubscriptionPlanDurationInputDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDurationInputDto
     */
    'id'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof SubscriptionPlanDurationInputDto
     */
    'minDuration'?: string | null;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof SubscriptionPlanDurationInputDto
     */
    'discount'?: GeneralDiscountInputDto;
}
/**
 * 
 * @export
 * @interface SubscriptionPlanExtraOptionDto
 */
export interface SubscriptionPlanExtraOptionDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanExtraOptionDto
     */
    'id'?: string;
    /**
     * 
     * @type {SubscriptionPlanOptionDto}
     * @memberof SubscriptionPlanExtraOptionDto
     */
    'option'?: SubscriptionPlanOptionDto;
    /**
     * 
     * @type {PaymentRegularityType}
     * @memberof SubscriptionPlanExtraOptionDto
     */
    'regularityType'?: PaymentRegularityType;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanExtraOptionDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof SubscriptionPlanExtraOptionDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanExtraOptionDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanExtraOptionDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanExtraOptionDto
     */
    'total'?: number;
}


/**
 * 
 * @export
 * @interface SubscriptionPlanExtraOptionInputDto
 */
export interface SubscriptionPlanExtraOptionInputDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanExtraOptionInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {SubscriptionPlanOptionInputDto}
     * @memberof SubscriptionPlanExtraOptionInputDto
     */
    'option'?: SubscriptionPlanOptionInputDto;
    /**
     * 
     * @type {PaymentRegularityType}
     * @memberof SubscriptionPlanExtraOptionInputDto
     */
    'regularityType'?: PaymentRegularityType;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanExtraOptionInputDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof SubscriptionPlanExtraOptionInputDto
     */
    'discount'?: GeneralDiscountInputDto;
}


/**
 * 
 * @export
 * @interface SubscriptionPlanIncludedOptionDto
 */
export interface SubscriptionPlanIncludedOptionDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanIncludedOptionDto
     */
    'id'?: string;
    /**
     * 
     * @type {SubscriptionPlanOptionDto}
     * @memberof SubscriptionPlanIncludedOptionDto
     */
    'option'?: SubscriptionPlanOptionDto;
}
/**
 * 
 * @export
 * @interface SubscriptionPlanIncludedOptionInputDto
 */
export interface SubscriptionPlanIncludedOptionInputDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanIncludedOptionInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {SubscriptionPlanOptionInputDto}
     * @memberof SubscriptionPlanIncludedOptionInputDto
     */
    'option'?: SubscriptionPlanOptionInputDto;
}
/**
 * 
 * @export
 * @interface SubscriptionPlanOptionDto
 */
export interface SubscriptionPlanOptionDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanOptionDto
     */
    'id'?: string;
    /**
     * 
     * @type {SubscriptionPlanOptionType}
     * @memberof SubscriptionPlanOptionDto
     */
    'type'?: SubscriptionPlanOptionType;
    /**
     * 
     * @type {AccessoryReferenceDto}
     * @memberof SubscriptionPlanOptionDto
     */
    'accessory'?: AccessoryReferenceDto;
    /**
     * 
     * @type {SubscriptionPlanOptionForVehicleDto}
     * @memberof SubscriptionPlanOptionDto
     */
    'forVehicle'?: SubscriptionPlanOptionForVehicleDto;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanOptionDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanOptionDto
     */
    'description'?: string | null;
}


/**
 * 
 * @export
 * @interface SubscriptionPlanOptionForVehicleDto
 */
export interface SubscriptionPlanOptionForVehicleDto {
    /**
     * 
     * @type {SubscriptionPlanOptionForVehicleType}
     * @memberof SubscriptionPlanOptionForVehicleDto
     */
    'type'?: SubscriptionPlanOptionForVehicleType;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanOptionForVehicleDto
     */
    'mileage'?: number | null;
}


/**
 * 
 * @export
 * @interface SubscriptionPlanOptionForVehicleInputDto
 */
export interface SubscriptionPlanOptionForVehicleInputDto {
    /**
     * 
     * @type {SubscriptionPlanOptionForVehicleType}
     * @memberof SubscriptionPlanOptionForVehicleInputDto
     */
    'type'?: SubscriptionPlanOptionForVehicleType;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanOptionForVehicleInputDto
     */
    'mileage'?: number | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SubscriptionPlanOptionForVehicleType = {
    None: 'None',
    Mileage: 'Mileage',
    FullTankAtReceive: 'FullTankAtReceive',
    FullTankAtReturn: 'FullTankAtReturn',
    DeliverToHome: 'DeliverToHome'
} as const;

export type SubscriptionPlanOptionForVehicleType = typeof SubscriptionPlanOptionForVehicleType[keyof typeof SubscriptionPlanOptionForVehicleType];


/**
 * 
 * @export
 * @interface SubscriptionPlanOptionInputDto
 */
export interface SubscriptionPlanOptionInputDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanOptionInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {SubscriptionPlanOptionType}
     * @memberof SubscriptionPlanOptionInputDto
     */
    'type'?: SubscriptionPlanOptionType;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanOptionInputDto
     */
    'accessoryId'?: string | null;
    /**
     * 
     * @type {SubscriptionPlanOptionForVehicleInputDto}
     * @memberof SubscriptionPlanOptionInputDto
     */
    'forVehicle'?: SubscriptionPlanOptionForVehicleInputDto;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanOptionInputDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanOptionInputDto
     */
    'description'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SubscriptionPlanOptionType = {
    None: 'None',
    Accessory: 'Accessory',
    ForVehicle: 'ForVehicle'
} as const;

export type SubscriptionPlanOptionType = typeof SubscriptionPlanOptionType[keyof typeof SubscriptionPlanOptionType];


/**
 * 
 * @export
 * @interface SubscriptionPlanPriceDto
 */
export interface SubscriptionPlanPriceDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanPriceDto
     */
    'id'?: string;
    /**
     * 
     * @type {BillingPeriod}
     * @memberof SubscriptionPlanPriceDto
     */
    'period'?: BillingPeriod;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanPriceDto
     */
    'price'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPlanPriceDto
     */
    'isBase'?: boolean;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof SubscriptionPlanPriceDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof SubscriptionPlanPriceDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {GeneralInsuranceDto}
     * @memberof SubscriptionPlanPriceDto
     */
    'insurance'?: GeneralInsuranceDto;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanPriceDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanPriceDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanPriceDto
     */
    'total'?: number;
}


/**
 * 
 * @export
 * @interface SubscriptionPlanPriceInputDto
 */
export interface SubscriptionPlanPriceInputDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanPriceInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {BillingPeriod}
     * @memberof SubscriptionPlanPriceInputDto
     */
    'period'?: BillingPeriod;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanPriceInputDto
     */
    'price'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPlanPriceInputDto
     */
    'isBase'?: boolean;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof SubscriptionPlanPriceInputDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof SubscriptionPlanPriceInputDto
     */
    'tax'?: GeneralTaxInputDto;
    /**
     * 
     * @type {GeneralInsuranceInputDto}
     * @memberof SubscriptionPlanPriceInputDto
     */
    'insurance'?: GeneralInsuranceInputDto;
}


/**
 * 
 * @export
 * @interface SubscriptionPlanPriceQueryDto
 */
export interface SubscriptionPlanPriceQueryDto {
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfBillingPeriod}
     * @memberof SubscriptionPlanPriceQueryDto
     */
    'period'?: FieldFilterOfPrimitiveDtoOfNullableOfBillingPeriod;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDecimal}
     * @memberof SubscriptionPlanPriceQueryDto
     */
    'subTotal'?: FieldFilterOfPrimitiveDtoOfNullableOfDecimal;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDecimal}
     * @memberof SubscriptionPlanPriceQueryDto
     */
    'total'?: FieldFilterOfPrimitiveDtoOfNullableOfDecimal;
}
/**
 * 
 * @export
 * @interface SubscriptionPlanReferenceDto
 */
export interface SubscriptionPlanReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanReferenceDto
     */
    'globalNumber'?: string;
}
/**
 * 
 * @export
 * @interface SubscriptionPlanSettingsDto
 */
export interface SubscriptionPlanSettingsDto {
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof SubscriptionPlanSettingsDto
     */
    'minDuration'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof SubscriptionPlanSettingsDto
     */
    'maxDuration'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof SubscriptionPlanSettingsDto
     */
    'exactDuration'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof SubscriptionPlanSettingsDto
     */
    'defaultDuration'?: string | null;
}
/**
 * 
 * @export
 * @interface SubscriptionPlanSettingsInputDto
 */
export interface SubscriptionPlanSettingsInputDto {
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof SubscriptionPlanSettingsInputDto
     */
    'minDuration'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof SubscriptionPlanSettingsInputDto
     */
    'maxDuration'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof SubscriptionPlanSettingsInputDto
     */
    'exactDuration'?: string | null;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof SubscriptionPlanSettingsInputDto
     */
    'defaultDuration'?: string | null;
}
/**
 * 
 * @export
 * @interface SubscriptionReferenceDto
 */
export interface SubscriptionReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionReferenceDto
     */
    'globalNumber'?: string;
}
/**
 * 
 * @export
 * @interface SubscriptionSelectedPlanDto
 */
export interface SubscriptionSelectedPlanDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionSelectedPlanDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionSelectedPlanDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionSelectedPlanDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionSelectedPlanDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionSelectedPlanDto
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {SubscriptionPlanPriceDto}
     * @memberof SubscriptionSelectedPlanDto
     */
    'price'?: SubscriptionPlanPriceDto;
    /**
     * 
     * @type {Array<AppModule>}
     * @memberof SubscriptionSelectedPlanDto
     */
    'modules'?: Array<AppModule>;
    /**
     * 
     * @type {object}
     * @memberof SubscriptionSelectedPlanDto
     */
    'limits'?: object;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SubscriptionStatus = {
    None: 'None',
    Draft: 'Draft',
    Pending: 'Pending',
    Unpaid: 'Unpaid',
    Active: 'Active',
    PastDue: 'PastDue',
    Ended: 'Ended',
    Paused: 'Paused',
    Canceled: 'Canceled'
} as const;

export type SubscriptionStatus = typeof SubscriptionStatus[keyof typeof SubscriptionStatus];


/**
 * 
 * @export
 * @interface SupplierChangedDto
 */
export interface SupplierChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SupplierChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SupplierChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof SupplierChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof SupplierChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof SupplierChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {SupplierDto}
     * @memberof SupplierChangedDto
     */
    'entity': SupplierDto;
    /**
     * 
     * @type {string}
     * @memberof SupplierChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface SupplierContactDto
 */
export interface SupplierContactDto {
    /**
     * 
     * @type {string}
     * @memberof SupplierContactDto
     */
    'id'?: string;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof SupplierContactDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof SupplierContactDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierContactDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {GeneralNationalIdentityNumberDto}
     * @memberof SupplierContactDto
     */
    'nationalIdentityNumber'?: GeneralNationalIdentityNumberDto;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierContactDto
     */
    'isPrimary'?: boolean;
}
/**
 * 
 * @export
 * @interface SupplierDto
 */
export interface SupplierDto {
    /**
     * 
     * @type {string}
     * @memberof SupplierDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof SupplierDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SupplierDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof SupplierDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplierDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplierDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SupplierDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SupplierDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SupplierDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {Array<SupplierType>}
     * @memberof SupplierDto
     */
    'types'?: Array<SupplierType>;
    /**
     * 
     * @type {string}
     * @memberof SupplierDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<SupplierContactDto>}
     * @memberof SupplierDto
     */
    'contacts'?: Array<SupplierContactDto>;
    /**
     * 
     * @type {GeneralAddressDto}
     * @memberof SupplierDto
     */
    'address'?: GeneralAddressDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof SupplierDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {SupplierContactDto}
     * @memberof SupplierDto
     */
    'contact'?: SupplierContactDto;
    /**
     * 
     * @type {string}
     * @memberof SupplierDto
     */
    'name'?: string;
}


/**
 * 
 * @export
 * @interface SupplierGetPaginatedDto
 */
export interface SupplierGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof SupplierGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SupplierGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SupplierGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SupplierGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof SupplierGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof SupplierGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof SupplierGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof SupplierGetPaginatedDto
     */
    'id'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof SupplierGetPaginatedDto
     */
    'createdAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof SupplierGetPaginatedDto
     */
    'updatedAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof SupplierGetPaginatedDto
     */
    'createdBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof SupplierGetPaginatedDto
     */
    'updatedBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {Array<SupplierType>}
     * @memberof SupplierGetPaginatedDto
     */
    'types'?: Array<SupplierType> | null;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof SupplierGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}
/**
 * 
 * @export
 * @interface SupplierReferenceDto
 */
export interface SupplierReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof SupplierReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {Array<SupplierType>}
     * @memberof SupplierReferenceDto
     */
    'types'?: Array<SupplierType>;
    /**
     * 
     * @type {string}
     * @memberof SupplierReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {SupplierContactDto}
     * @memberof SupplierReferenceDto
     */
    'contact'?: SupplierContactDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SupplierType = {
    None: 'None',
    Workshop: 'Workshop',
    Wash: 'Wash',
    Detailing: 'Detailing',
    TireService: 'TireService',
    WheelService: 'WheelService',
    Assessment: 'Assessment',
    Other: 'Other'
} as const;

export type SupplierType = typeof SupplierType[keyof typeof SupplierType];


/**
 * 
 * @export
 * @interface TabularDtoOfString
 */
export interface TabularDtoOfString {
    /**
     * 
     * @type {Array<string>}
     * @memberof TabularDtoOfString
     */
    'columns'?: Array<string>;
    /**
     * 
     * @type {Array<TabularRowDtoOfString>}
     * @memberof TabularDtoOfString
     */
    'rows'?: Array<TabularRowDtoOfString>;
}
/**
 * 
 * @export
 * @interface TabularFileColumnInfoDto
 */
export interface TabularFileColumnInfoDto {
    /**
     * 
     * @type {string}
     * @memberof TabularFileColumnInfoDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof TabularFileColumnInfoDto
     */
    'index'?: number;
}
/**
 * 
 * @export
 * @interface TabularFileMetadataDto
 */
export interface TabularFileMetadataDto {
    /**
     * 
     * @type {Array<TabularFileColumnInfoDto>}
     * @memberof TabularFileMetadataDto
     */
    'columns'?: Array<TabularFileColumnInfoDto>;
    /**
     * 
     * @type {number}
     * @memberof TabularFileMetadataDto
     */
    'rowCapacity'?: number;
}
/**
 * 
 * @export
 * @interface TabularRowDtoOfString
 */
export interface TabularRowDtoOfString {
    /**
     * 
     * @type {Array<string>}
     * @memberof TabularRowDtoOfString
     */
    'items'?: Array<string>;
}
/**
 * Entity where tag can be placed.  Must contain only values from EntityType.
 * @export
 * @enum {string}
 */

export const TagEntityType = {
    None: 'None',
    Arbitrary: 'Arbitrary',
    Chat: 'Chat',
    ChatMessage: 'ChatMessage',
    ChatEvent: 'ChatEvent',
    Negotiation: 'Negotiation',
    GeneralEventLog: 'GeneralEventLog',
    VehicleHistory: 'VehicleHistory',
    Document: 'Document',
    DataGrant: 'DataGrant',
    TenantRequest: 'TenantRequest',
    Contract: 'Contract',
    AssessmentFlow: 'AssessmentFlow',
    Customer: 'Customer',
    Supplier: 'Supplier',
    Vehicle: 'Vehicle',
    Asset: 'Asset',
    Accessory: 'Accessory',
    AccessoryCheck: 'AccessoryCheck',
    VisualInspection: 'VisualInspection',
    DamageDetection: 'DamageDetection',
    DamageDetectionAggregate: 'DamageDetectionAggregate',
    DamageCostEvaluation: 'DamageCostEvaluation',
    DamageCostEvaluationAggregate: 'DamageCostEvaluationAggregate',
    RepairOperation: 'RepairOperation',
    WheelOperation: 'WheelOperation',
    Wash: 'Wash',
    Maintenance: 'Maintenance',
    GeneralHistory: 'GeneralHistory',
    GeneralStatusHistory: 'GeneralStatusHistory',
    Assignment: 'Assignment',
    Charge: 'Charge'
} as const;

export type TagEntityType = typeof TagEntityType[keyof typeof TagEntityType];


/**
 * 
 * @export
 * @interface TagStaticFilterDto
 */
export interface TagStaticFilterDto {
    /**
     * 
     * @type {FilterOperator}
     * @memberof TagStaticFilterDto
     */
    'operator'?: FilterOperator;
    /**
     * 
     * @type {GeneralAttachedTagsQueryDto}
     * @memberof TagStaticFilterDto
     */
    'query'?: GeneralAttachedTagsQueryDto;
}


/**
 * 
 * @export
 * @interface TagStylesDto
 */
export interface TagStylesDto {
    /**
     * 
     * @type {string}
     * @memberof TagStylesDto
     */
    'backgroundColor'?: string | null;
}
/**
 * 
 * @export
 * @interface TagStylesInputDto
 */
export interface TagStylesInputDto {
    /**
     * 
     * @type {string}
     * @memberof TagStylesInputDto
     */
    'backgroundColor'?: string | null;
}
/**
 * What/who can be tagged.
 * @export
 * @enum {string}
 */

export const TagSubTargetType = {
    None: 'None',
    DamageDetectionItem: 'DamageDetectionItem',
    DamageDetectionAggregateItem: 'DamageDetectionAggregateItem',
    DamageCostEvaluationItem: 'DamageCostEvaluationItem',
    DamageCostEvaluationAggregateItem: 'DamageCostEvaluationAggregateItem',
    AccessoryCheckItem: 'AccessoryCheckItem',
    NegotiationProposal: 'NegotiationProposal'
} as const;

export type TagSubTargetType = typeof TagSubTargetType[keyof typeof TagSubTargetType];


/**
 * What/who can be tagged.  Must contain only values from EntityType.
 * @export
 * @enum {string}
 */

export const TagTargetType = {
    None: 'None',
    CustomTag: 'CustomTag',
    User: 'User',
    Vehicle: 'Vehicle',
    Asset: 'Asset',
    Contract: 'Contract',
    AssessmentFlow: 'AssessmentFlow',
    Customer: 'Customer',
    Supplier: 'Supplier',
    VehicleDamage: 'VehicleDamage',
    Accessory: 'Accessory',
    VisualInspection: 'VisualInspection',
    DamageDetection: 'DamageDetection',
    DamageDetectionAggregate: 'DamageDetectionAggregate',
    DamageCostEvaluation: 'DamageCostEvaluation',
    DamageCostEvaluationAggregate: 'DamageCostEvaluationAggregate',
    AccessoryCheck: 'AccessoryCheck',
    RepairOperation: 'RepairOperation',
    Wash: 'Wash',
    WheelOperation: 'WheelOperation',
    Chat: 'Chat',
    ChatParticipant: 'ChatParticipant',
    Negotiation: 'Negotiation',
    AssetSubscriptionPlan: 'AssetSubscriptionPlan',
    AssetSubscription: 'AssetSubscription',
    TenantConnectionRequest: 'TenantConnectionRequest',
    TenantConnection: 'TenantConnection',
    TenantRequest: 'TenantRequest',
    DataGrant: 'DataGrant',
    Pool: 'Pool',
    Department: 'Department',
    Location: 'Location',
    Spot: 'Spot',
    Maintenance: 'Maintenance',
    Assignment: 'Assignment'
} as const;

export type TagTargetType = typeof TagTargetType[keyof typeof TagTargetType];


/**
 * 
 * @export
 * @enum {string}
 */

export const TaxType = {
    None: 'None',
    Custom: 'Custom',
    Vat: 'Vat'
} as const;

export type TaxType = typeof TaxType[keyof typeof TaxType];


/**
 * 
 * @export
 * @enum {string}
 */

export const TaxValueType = {
    None: 'None',
    Percent: 'Percent',
    Value: 'Value'
} as const;

export type TaxValueType = typeof TaxValueType[keyof typeof TaxValueType];


/**
 * 
 * @export
 * @interface TenantChangedDto
 */
export interface TenantChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof TenantChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof TenantChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof TenantChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof TenantChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {TenantDto}
     * @memberof TenantChangedDto
     */
    'entity': TenantDto;
    /**
     * 
     * @type {string}
     * @memberof TenantChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface TenantConnectionChangedDto
 */
export interface TenantConnectionChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantConnectionChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof TenantConnectionChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof TenantConnectionChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {TenantConnectionDto}
     * @memberof TenantConnectionChangedDto
     */
    'entity': TenantConnectionDto;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface TenantConnectionCountersDto
 */
export interface TenantConnectionCountersDto {
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionCountersDto
     */
    'version'?: string;
    /**
     * 
     * @type {number}
     * @memberof TenantConnectionCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof TenantConnectionCountersDto
     */
    'activeCount': number;
    /**
     * 
     * @type {number}
     * @memberof TenantConnectionCountersDto
     */
    'endedCount': number;
}
/**
 * 
 * @export
 * @interface TenantConnectionDto
 */
export interface TenantConnectionDto {
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof TenantConnectionDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantConnectionDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantConnectionDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionDto
     */
    'requestId'?: string;
    /**
     * 
     * @type {TenantReferenceDto}
     * @memberof TenantConnectionDto
     */
    'connectedTenant1'?: TenantReferenceDto;
    /**
     * 
     * @type {TenantReferenceDto}
     * @memberof TenantConnectionDto
     */
    'connectedTenant2'?: TenantReferenceDto;
    /**
     * 
     * @type {ChatReferenceDto}
     * @memberof TenantConnectionDto
     */
    'chat'?: ChatReferenceDto;
    /**
     * 
     * @type {TenantConnectionStatus}
     * @memberof TenantConnectionDto
     */
    'status'?: TenantConnectionStatus;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof TenantConnectionDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantConnectionDto
     */
    'statusUpdatedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantConnectionDto
     */
    'activeAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantConnectionDto
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {TenantConnectionLocalDataDto}
     * @memberof TenantConnectionDto
     */
    'tenantLocalData'?: TenantConnectionLocalDataDto;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof TenantConnectionDto
     */
    'tenantIdsMap'?: { [key: string]: boolean; };
}


/**
 * 
 * @export
 * @interface TenantConnectionGetPaginatedDto
 */
export interface TenantConnectionGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof TenantConnectionGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantConnectionGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantConnectionGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantConnectionGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantConnectionGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof TenantConnectionGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof TenantConnectionGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof TenantConnectionGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionGetPaginatedDto
     */
    'requestId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionGetPaginatedDto
     */
    'connectedTenantId'?: string | null;
    /**
     * 
     * @type {TenantConnectionStatus}
     * @memberof TenantConnectionGetPaginatedDto
     */
    'status'?: TenantConnectionStatus;
}


/**
 * Tenant-specific/local data and state, visible and editable only by that tenant.
 * @export
 * @interface TenantConnectionLocalDataDto
 */
export interface TenantConnectionLocalDataDto {
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionLocalDataDto
     */
    'tenantId': string;
    /**
     * Explicit contacts for this connection, that this tenant has approved to share with the other connected tenant.
     * @type {Array<TenantContactDto>}
     * @memberof TenantConnectionLocalDataDto
     */
    'contacts'?: Array<TenantContactDto> | null;
}
/**
 * 
 * @export
 * @interface TenantConnectionLocalDataInputDto
 */
export interface TenantConnectionLocalDataInputDto {
    /**
     * Explicit contacts for this connection, that this tenant has approved to share with the other connected tenant.
     * @type {Array<TenantContactInputDto>}
     * @memberof TenantConnectionLocalDataInputDto
     */
    'contacts'?: Array<TenantContactInputDto> | null;
}
/**
 * 
 * @export
 * @interface TenantConnectionReferenceDto
 */
export interface TenantConnectionReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionReferenceDto
     */
    'globalNumber'?: string;
}
/**
 * 
 * @export
 * @interface TenantConnectionRequestChangedDto
 */
export interface TenantConnectionRequestChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantConnectionRequestChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof TenantConnectionRequestChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof TenantConnectionRequestChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {TenantConnectionRequestDto}
     * @memberof TenantConnectionRequestChangedDto
     */
    'entity': TenantConnectionRequestDto;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface TenantConnectionRequestCountersDto
 */
export interface TenantConnectionRequestCountersDto {
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestCountersDto
     */
    'version'?: string;
    /**
     * 
     * @type {number}
     * @memberof TenantConnectionRequestCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {IncomingCountersDtoInTenantConnectionRequestCountersDto}
     * @memberof TenantConnectionRequestCountersDto
     */
    'incoming': IncomingCountersDtoInTenantConnectionRequestCountersDto;
    /**
     * 
     * @type {OutcomingCountersDtoInTenantConnectionRequestCountersDto}
     * @memberof TenantConnectionRequestCountersDto
     */
    'outcoming': OutcomingCountersDtoInTenantConnectionRequestCountersDto;
}
/**
 * 
 * @export
 * @interface TenantConnectionRequestCreateDto
 */
export interface TenantConnectionRequestCreateDto {
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestCreateDto
     */
    'receiverTenantId'?: string;
}
/**
 * 
 * @export
 * @interface TenantConnectionRequestDto
 */
export interface TenantConnectionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof TenantConnectionRequestDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantConnectionRequestDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantConnectionRequestDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {TenantReferenceDto}
     * @memberof TenantConnectionRequestDto
     */
    'senderTenant'?: TenantReferenceDto;
    /**
     * 
     * @type {TenantReferenceDto}
     * @memberof TenantConnectionRequestDto
     */
    'receiverTenant'?: TenantReferenceDto;
    /**
     * 
     * @type {ChatReferenceDto}
     * @memberof TenantConnectionRequestDto
     */
    'chat'?: ChatReferenceDto;
    /**
     * 
     * @type {TenantConnectionRequestStatus}
     * @memberof TenantConnectionRequestDto
     */
    'status'?: TenantConnectionRequestStatus;
    /**
     * 
     * @type {TenantConnectionRequestResponseType}
     * @memberof TenantConnectionRequestDto
     */
    'responseType'?: TenantConnectionRequestResponseType;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof TenantConnectionRequestDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantConnectionRequestDto
     */
    'respondedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantConnectionRequestDto
     */
    'statusUpdatedAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantConnectionRequestDto
     */
    'pendingAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantConnectionRequestDto
     */
    'acceptedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantConnectionRequestDto
     */
    'declinedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantConnectionRequestDto
     */
    'notRespondedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantConnectionRequestDto
     */
    'revokedAt'?: string | null;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof TenantConnectionRequestDto
     */
    'tenantIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {boolean}
     * @memberof TenantConnectionRequestDto
     */
    'isResponded'?: boolean;
}


/**
 * 
 * @export
 * @interface TenantConnectionRequestGetPaginatedDto
 */
export interface TenantConnectionRequestGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof TenantConnectionRequestGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantConnectionRequestGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantConnectionRequestGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantConnectionRequestGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantConnectionRequestGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof TenantConnectionRequestGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof TenantConnectionRequestGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof TenantConnectionRequestGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestGetPaginatedDto
     */
    'senderTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestGetPaginatedDto
     */
    'receiverTenantId'?: string | null;
    /**
     * 
     * @type {TenantConnectionRequestStatus}
     * @memberof TenantConnectionRequestGetPaginatedDto
     */
    'status'?: TenantConnectionRequestStatus;
}


/**
 * 
 * @export
 * @interface TenantConnectionRequestReferenceDto
 */
export interface TenantConnectionRequestReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestReferenceDto
     */
    'globalNumber'?: string;
}
/**
 * 
 * @export
 * @interface TenantConnectionRequestRespondDto
 */
export interface TenantConnectionRequestRespondDto {
    /**
     * 
     * @type {TenantConnectionRequestResponseType}
     * @memberof TenantConnectionRequestRespondDto
     */
    'responseType'?: TenantConnectionRequestResponseType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TenantConnectionRequestResponseType = {
    None: 'None',
    Accept: 'Accept',
    Decline: 'Decline'
} as const;

export type TenantConnectionRequestResponseType = typeof TenantConnectionRequestResponseType[keyof typeof TenantConnectionRequestResponseType];


/**
 * 
 * @export
 * @enum {string}
 */

export const TenantConnectionRequestStatus = {
    None: 'None',
    Pending: 'Pending',
    Accepted: 'Accepted',
    Declined: 'Declined',
    NotResponded: 'NotResponded',
    Revoked: 'Revoked'
} as const;

export type TenantConnectionRequestStatus = typeof TenantConnectionRequestStatus[keyof typeof TenantConnectionRequestStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const TenantConnectionStatus = {
    None: 'None',
    Active: 'Active',
    Ended: 'Ended'
} as const;

export type TenantConnectionStatus = typeof TenantConnectionStatus[keyof typeof TenantConnectionStatus];


/**
 * 
 * @export
 * @interface TenantConnectionUpdateDto
 */
export interface TenantConnectionUpdateDto {
    /**
     * 
     * @type {TenantConnectionLocalDataInputDto}
     * @memberof TenantConnectionUpdateDto
     */
    'tenantLocalData'?: TenantConnectionLocalDataInputDto;
}
/**
 * General-purpose contact of a tenant.
 * @export
 * @interface TenantContactDto
 */
export interface TenantContactDto {
    /**
     * 
     * @type {string}
     * @memberof TenantContactDto
     */
    'id'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantContactDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantContactDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContactDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantContactDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantContactDto
     */
    'tenantId': string;
    /**
     * 
     * @type {TenantContactType}
     * @memberof TenantContactDto
     */
    'type': TenantContactType;
    /**
     * 
     * @type {UserReferenceDto}
     * @memberof TenantContactDto
     */
    'user': UserReferenceDto;
}


/**
 * 
 * @export
 * @interface TenantContactInputDto
 */
export interface TenantContactInputDto {
    /**
     * 
     * @type {string}
     * @memberof TenantContactInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantContactInputDto
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface TenantContactPersonDto
 */
export interface TenantContactPersonDto {
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof TenantContactPersonDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof TenantContactPersonDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContactPersonDto
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface TenantContactPersonInputDto
 */
export interface TenantContactPersonInputDto {
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof TenantContactPersonInputDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof TenantContactPersonInputDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContactPersonInputDto
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TenantContactType = {
    None: 'None',
    User: 'User'
} as const;

export type TenantContactType = typeof TenantContactType[keyof typeof TenantContactType];


/**
 * 
 * @export
 * @interface TenantDto
 */
export interface TenantDto {
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof TenantDto
     */
    'formType'?: EntityFormType;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {TenantType}
     * @memberof TenantDto
     */
    'type'?: TenantType;
    /**
     * 
     * @type {TenantStatus}
     * @memberof TenantDto
     */
    'status'?: TenantStatus;
    /**
     * 
     * @type {TenantMode}
     * @memberof TenantDto
     */
    'mode'?: TenantMode;
    /**
     * 
     * @type {GeneralBrandingDto}
     * @memberof TenantDto
     */
    'branding'?: GeneralBrandingDto;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof TenantDto
     */
    'myUnseen'?: UserUnseenInfoDto;
}


/**
 * 
 * @export
 * @interface TenantEmailSettingsDto
 */
export interface TenantEmailSettingsDto {
    /**
     * 
     * @type {EmailProviderType}
     * @memberof TenantEmailSettingsDto
     */
    'providerType'?: EmailProviderType;
    /**
     * 
     * @type {SendGridEmailSettingsDto}
     * @memberof TenantEmailSettingsDto
     */
    'sendGrid'?: SendGridEmailSettingsDto;
    /**
     * 
     * @type {MailgunEmailSettingsDto}
     * @memberof TenantEmailSettingsDto
     */
    'mailgun'?: MailgunEmailSettingsDto;
    /**
     * 
     * @type {AmazonSesEmailSettingsDto}
     * @memberof TenantEmailSettingsDto
     */
    'amazonSes'?: AmazonSesEmailSettingsDto;
    /**
     * 
     * @type {MailchimpEmailSettingsDto}
     * @memberof TenantEmailSettingsDto
     */
    'mailchimp'?: MailchimpEmailSettingsDto;
    /**
     * 
     * @type {Ms365EmailSettingsDto}
     * @memberof TenantEmailSettingsDto
     */
    'microsoft365'?: Ms365EmailSettingsDto;
    /**
     * 
     * @type {AzureCsEmailSettingsDto}
     * @memberof TenantEmailSettingsDto
     */
    'azureCs'?: AzureCsEmailSettingsDto;
    /**
     * 
     * @type {SmtpEmailSettingsDto}
     * @memberof TenantEmailSettingsDto
     */
    'smtp'?: SmtpEmailSettingsDto;
}


/**
 * 
 * @export
 * @interface TenantEmailSettingsInputDto
 */
export interface TenantEmailSettingsInputDto {
    /**
     * 
     * @type {EmailProviderType}
     * @memberof TenantEmailSettingsInputDto
     */
    'providerType'?: EmailProviderType;
    /**
     * 
     * @type {SendGridEmailSettingsInputDto}
     * @memberof TenantEmailSettingsInputDto
     */
    'sendGrid'?: SendGridEmailSettingsInputDto;
    /**
     * 
     * @type {MailgunEmailSettingsInputDto}
     * @memberof TenantEmailSettingsInputDto
     */
    'mailgun'?: MailgunEmailSettingsInputDto;
    /**
     * 
     * @type {AmazonSesEmailSettingsInputDto}
     * @memberof TenantEmailSettingsInputDto
     */
    'amazonSes'?: AmazonSesEmailSettingsInputDto;
    /**
     * 
     * @type {MailchimpEmailSettingsInputDto}
     * @memberof TenantEmailSettingsInputDto
     */
    'mailchimp'?: MailchimpEmailSettingsInputDto;
    /**
     * 
     * @type {Ms365EmailSettingsInputDto}
     * @memberof TenantEmailSettingsInputDto
     */
    'microsoft365'?: Ms365EmailSettingsInputDto;
    /**
     * 
     * @type {AzureCsEmailSettingsInputDto}
     * @memberof TenantEmailSettingsInputDto
     */
    'azureCs'?: AzureCsEmailSettingsInputDto;
    /**
     * 
     * @type {SmtpEmailSettingsInputDto}
     * @memberof TenantEmailSettingsInputDto
     */
    'smtp'?: SmtpEmailSettingsInputDto;
}


/**
 * 
 * @export
 * @interface TenantGetPaginatedDto
 */
export interface TenantGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof TenantGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof TenantGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof TenantGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof TenantGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * Companies where I belong.
     * @type {boolean}
     * @memberof TenantGetPaginatedDto
     */
    'isMy'?: boolean | null;
    /**
     * Companies that are in my connections.
     * @type {boolean}
     * @memberof TenantGetPaginatedDto
     */
    'isInMyConnections'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantGetPaginatedDto
     */
    'isEnableTenantToTenantConnections'?: boolean | null;
    /**
     * 
     * @type {Array<TenantMode>}
     * @memberof TenantGetPaginatedDto
     */
    'modesAny'?: Array<TenantMode> | null;
}
/**
 * 
 * @export
 * @interface TenantInviteDto
 */
export interface TenantInviteDto {
    /**
     * 
     * @type {string}
     * @memberof TenantInviteDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof TenantInviteDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantInviteDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantInviteDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantInviteDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantInviteDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantInviteDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantInviteDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantInviteDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantInviteDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {InviteType}
     * @memberof TenantInviteDto
     */
    'type'?: InviteType;
    /**
     * 
     * @type {InviteUserType}
     * @memberof TenantInviteDto
     */
    'userType'?: InviteUserType;
    /**
     * 
     * @type {InviteUserInfoDto}
     * @memberof TenantInviteDto
     */
    'userInfo'?: InviteUserInfoDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantInviteDto
     */
    'sentAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantInviteDto
     */
    'expiresAt'?: string;
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof TenantInviteDto
     */
    'lifetime'?: string;
    /**
     * 
     * @type {number}
     * @memberof TenantInviteDto
     */
    'maxUsers'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantInviteDto
     */
    'currentUsers'?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantInviteDto
     */
    'inviteUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantInviteDto
     */
    'redirectUrl'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantInviteDto
     */
    'registeredUserIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantInviteDto
     */
    'acceptedUserIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantInviteDto
     */
    'rejectedUserIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantInviteDto
     */
    'roleIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TenantInviteDto
     */
    'isExpired'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantInviteDto
     */
    'isAnyRegistered'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantInviteDto
     */
    'isAnyAccepted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantInviteDto
     */
    'isAnyRejected'?: boolean;
}


/**
 * 
 * @export
 * @interface TenantInviteGetPaginatedDto
 */
export interface TenantInviteGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof TenantInviteGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantInviteGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantInviteGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantInviteGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantInviteGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantInviteGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof TenantInviteGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof TenantInviteGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof TenantInviteGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof TenantInviteGetPaginatedDto
     */
    'inviteId'?: string | null;
    /**
     * 
     * @type {InviteType}
     * @memberof TenantInviteGetPaginatedDto
     */
    'type'?: InviteType;
    /**
     * 
     * @type {InviteUserType}
     * @memberof TenantInviteGetPaginatedDto
     */
    'userType'?: InviteUserType;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantInviteGetPaginatedDto
     */
    'allRoleIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantInviteGetPaginatedDto
     */
    'anyRoleIds'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface TenantMediaSettingDto
 */
export interface TenantMediaSettingDto {
    /**
     * 
     * @type {ImageQuality}
     * @memberof TenantMediaSettingDto
     */
    'imageQuality'?: ImageQuality;
}


/**
 * 
 * @export
 * @interface TenantMediaSettingInputDto
 */
export interface TenantMediaSettingInputDto {
    /**
     * 
     * @type {ImageQuality}
     * @memberof TenantMediaSettingInputDto
     */
    'imageQuality'?: ImageQuality;
}


/**
 * 
 * @export
 * @interface TenantMembershipOfEntityUpdateDto
 */
export interface TenantMembershipOfEntityUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof TenantMembershipOfEntityUpdateDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantMembershipOfEntityUpdateDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantMembershipOfEntityUpdateDto
     */
    'entitiesIds'?: Array<string>;
    /**
     * 
     * @type {EntityType}
     * @memberof TenantMembershipOfEntityUpdateDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {Array<EntityType>}
     * @memberof TenantMembershipOfEntityUpdateDto
     */
    'relatedEntitiesTypes'?: Array<EntityType> | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TenantMode = {
    None: 'None',
    Live: 'Live',
    Test: 'Test',
    Demo: 'Demo'
} as const;

export type TenantMode = typeof TenantMode[keyof typeof TenantMode];


/**
 * 
 * @export
 * @interface TenantPaymentProfileDto
 */
export interface TenantPaymentProfileDto {
    /**
     * 
     * @type {PaymentBusinessInfoDto}
     * @memberof TenantPaymentProfileDto
     */
    'businessInfo'?: PaymentBusinessInfoDto;
    /**
     * 
     * @type {Array<PaymentContactDto>}
     * @memberof TenantPaymentProfileDto
     */
    'contacts'?: Array<PaymentContactDto>;
}
/**
 * 
 * @export
 * @interface TenantPaymentProfileInputDto
 */
export interface TenantPaymentProfileInputDto {
    /**
     * 
     * @type {PaymentBusinessInfoInputDto}
     * @memberof TenantPaymentProfileInputDto
     */
    'businessInfo'?: PaymentBusinessInfoInputDto;
    /**
     * 
     * @type {Array<PaymentContactInputDto>}
     * @memberof TenantPaymentProfileInputDto
     */
    'contacts'?: Array<PaymentContactInputDto>;
}
/**
 * 
 * @export
 * @interface TenantProfileDto
 */
export interface TenantProfileDto {
    /**
     * 
     * @type {string}
     * @memberof TenantProfileDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantProfileDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantProfileDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantProfileDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {TenantType}
     * @memberof TenantProfileDto
     */
    'type'?: TenantType;
    /**
     * 
     * @type {TenantStatus}
     * @memberof TenantProfileDto
     */
    'status'?: TenantStatus;
    /**
     * 
     * @type {TenantMode}
     * @memberof TenantProfileDto
     */
    'mode'?: TenantMode;
    /**
     * 
     * @type {TenantContactPersonDto}
     * @memberof TenantProfileDto
     */
    'contactPerson'?: TenantContactPersonDto;
    /**
     * 
     * @type {TenantSettingsDto}
     * @memberof TenantProfileDto
     */
    'settings'?: TenantSettingsDto;
    /**
     * 
     * @type {GeneralBrandingDto}
     * @memberof TenantProfileDto
     */
    'branding'?: GeneralBrandingDto;
    /**
     * 
     * @type {TenantSuspensionInfoDto}
     * @memberof TenantProfileDto
     */
    'suspension'?: TenantSuspensionInfoDto;
}


/**
 * 
 * @export
 * @interface TenantProfileUpdateDto
 */
export interface TenantProfileUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof TenantProfileUpdateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantProfileUpdateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {TenantContactPersonInputDto}
     * @memberof TenantProfileUpdateDto
     */
    'contactPerson'?: TenantContactPersonInputDto;
    /**
     * 
     * @type {GeneralBrandingInputDto}
     * @memberof TenantProfileUpdateDto
     */
    'branding'?: GeneralBrandingInputDto;
}
/**
 * 
 * @export
 * @interface TenantReference
 */
export interface TenantReference {
    /**
     * 
     * @type {string}
     * @memberof TenantReference
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof TenantReference
     */
    'formTypeOrDefault'?: EntityFormType;
    /**
     * 
     * @type {EntityFormType}
     * @memberof TenantReference
     */
    'formType'?: EntityFormType;
    /**
     * 
     * @type {string}
     * @memberof TenantReference
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantReference
     */
    'name'?: string;
}


/**
 * 
 * @export
 * @interface TenantReferenceDto
 */
export interface TenantReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof TenantReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantReferenceDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantReferenceDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface TenantRequestAppliedResultDto
 */
export interface TenantRequestAppliedResultDto {
    /**
     * 
     * @type {ApplyStatus}
     * @memberof TenantRequestAppliedResultDto
     */
    'status'?: ApplyStatus;
    /**
     * 
     * @type {number}
     * @memberof TenantRequestAppliedResultDto
     */
    'applyCount'?: number;
    /**
     * When result was applied to sender tenant.
     * @type {string}
     * @memberof TenantRequestAppliedResultDto
     */
    'appliedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestAppliedResultDto
     */
    'appliedBy'?: string | null;
    /**
     * 
     * @type {AutomationCreateMode}
     * @memberof TenantRequestAppliedResultDto
     */
    'applyMode'?: AutomationCreateMode;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof TenantRequestAppliedResultDto
     */
    'createdEntityTags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRequestAppliedResultDto
     */
    'isApplied'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRequestAppliedResultDto
     */
    'isReapplied'?: boolean;
}


/**
 * 
 * @export
 * @interface TenantRequestApplyResultDto
 */
export interface TenantRequestApplyResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof TenantRequestApplyResultDto
     */
    'isReapply'?: boolean;
}
/**
 * 
 * @export
 * @interface TenantRequestChangedDto
 */
export interface TenantRequestChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantRequestChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof TenantRequestChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof TenantRequestChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {TenantRequestDto}
     * @memberof TenantRequestChangedDto
     */
    'entity': TenantRequestDto;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface TenantRequestCloseDto
 */
export interface TenantRequestCloseDto {
    /**
     * 
     * @type {string}
     * @memberof TenantRequestCloseDto
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface TenantRequestContentDto
 */
export interface TenantRequestContentDto {
    /**
     * 
     * @type {TenantRequestType}
     * @memberof TenantRequestContentDto
     */
    'type'?: TenantRequestType;
    /**
     * 
     * @type {object}
     * @memberof TenantRequestContentDto
     */
    'arbitrary'?: object;
    /**
     * 
     * @type {TenantRequestOperationContentDto}
     * @memberof TenantRequestContentDto
     */
    'operation'?: TenantRequestOperationContentDto;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestContentDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof TenantRequestContentDto
     */
    'attachments'?: Array<GeneralAttachmentDto> | null;
}


/**
 * 
 * @export
 * @interface TenantRequestContentInputDto
 */
export interface TenantRequestContentInputDto {
    /**
     * 
     * @type {TenantRequestType}
     * @memberof TenantRequestContentInputDto
     */
    'type'?: TenantRequestType;
    /**
     * 
     * @type {object}
     * @memberof TenantRequestContentInputDto
     */
    'arbitrary'?: object;
    /**
     * 
     * @type {TenantRequestOperationContentInputDto}
     * @memberof TenantRequestContentInputDto
     */
    'operation'?: TenantRequestOperationContentInputDto;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestContentInputDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof TenantRequestContentInputDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
}


/**
 * 
 * @export
 * @interface TenantRequestCountersDto
 */
export interface TenantRequestCountersDto {
    /**
     * 
     * @type {string}
     * @memberof TenantRequestCountersDto
     */
    'version'?: string;
    /**
     * 
     * @type {number}
     * @memberof TenantRequestCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {TenantRequestCountersDtoCountByStageMap}
     * @memberof TenantRequestCountersDto
     */
    'countByStageMap': TenantRequestCountersDtoCountByStageMap;
}
/**
 * 
 * @export
 * @interface TenantRequestCountersDtoCountByStageMap
 */
export interface TenantRequestCountersDtoCountByStageMap {
    /**
     * 
     * @type {number}
     * @memberof TenantRequestCountersDtoCountByStageMap
     */
    'None'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantRequestCountersDtoCountByStageMap
     */
    'Draft'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantRequestCountersDtoCountByStageMap
     */
    'Pending'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantRequestCountersDtoCountByStageMap
     */
    'Accepted'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantRequestCountersDtoCountByStageMap
     */
    'Declined'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantRequestCountersDtoCountByStageMap
     */
    'InProgress'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantRequestCountersDtoCountByStageMap
     */
    'Completed'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantRequestCountersDtoCountByStageMap
     */
    'Reporting'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantRequestCountersDtoCountByStageMap
     */
    'Returned'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantRequestCountersDtoCountByStageMap
     */
    'Closed'?: number;
}
/**
 * 
 * @export
 * @interface TenantRequestCreateDto
 */
export interface TenantRequestCreateDto {
    /**
     * 
     * @type {string}
     * @memberof TenantRequestCreateDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestCreateDto
     */
    'receiverTenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestCreateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestCreateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {TenantRequestContentInputDto}
     * @memberof TenantRequestCreateDto
     */
    'content'?: TenantRequestContentInputDto;
    /**
     * 
     * @type {TenantRequestDataGrantSettingsInputDto}
     * @memberof TenantRequestCreateDto
     */
    'dataGrantSettings'?: TenantRequestDataGrantSettingsInputDto;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof TenantRequestCreateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestCreateDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestCreateDto
     */
    'assessmentFlowId'?: string | null;
    /**
     * DD for which DCE or other operation is requested.
     * @type {string}
     * @memberof TenantRequestCreateDto
     */
    'damageDetectionId'?: string | null;
    /**
     * 
     * @type {GeneralStageUpdateDtoOfTenantRequestStage}
     * @memberof TenantRequestCreateDto
     */
    'newStage'?: GeneralStageUpdateDtoOfTenantRequestStage;
    /**
     * 
     * @type {GeneralBillToInfoInputDto}
     * @memberof TenantRequestCreateDto
     */
    'billTo'?: GeneralBillToInfoInputDto;
}
/**
 * 
 * @export
 * @interface TenantRequestDataGrantSettingsDto
 */
export interface TenantRequestDataGrantSettingsDto {
    /**
     * 
     * @type {Array<DataGrantPermission>}
     * @memberof TenantRequestDataGrantSettingsDto
     */
    'permissions'?: Array<DataGrantPermission>;
}
/**
 * 
 * @export
 * @interface TenantRequestDataGrantSettingsInputDto
 */
export interface TenantRequestDataGrantSettingsInputDto {
    /**
     * 
     * @type {Array<DataGrantPermission>}
     * @memberof TenantRequestDataGrantSettingsInputDto
     */
    'permissions'?: Array<DataGrantPermission>;
}
/**
 * 
 * @export
 * @interface TenantRequestDto
 */
export interface TenantRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TenantRequestDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof TenantRequestDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantRequestDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantRequestDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {TenantReferenceDto}
     * @memberof TenantRequestDto
     */
    'senderTenant'?: TenantReferenceDto;
    /**
     * 
     * @type {TenantReferenceDto}
     * @memberof TenantRequestDto
     */
    'receiverTenant'?: TenantReferenceDto;
    /**
     * 
     * @type {ChatReferenceDto}
     * @memberof TenantRequestDto
     */
    'chat'?: ChatReferenceDto;
    /**
     * 
     * @type {GeneralStageHistoryDtoOfTenantRequestStage}
     * @memberof TenantRequestDto
     */
    'stageHistory'?: GeneralStageHistoryDtoOfTenantRequestStage;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {TenantRequestContentDto}
     * @memberof TenantRequestDto
     */
    'content'?: TenantRequestContentDto;
    /**
     * 
     * @type {TenantRequestDataGrantSettingsDto}
     * @memberof TenantRequestDto
     */
    'dataGrantSettings'?: TenantRequestDataGrantSettingsDto;
    /**
     * 
     * @type {TenantRequestResponseType}
     * @memberof TenantRequestDto
     */
    'responseType'?: TenantRequestResponseType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantRequestDto
     */
    'respondedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestDto
     */
    'responseReason'?: string | null;
    /**
     * 
     * @type {TenantRequestResultDto}
     * @memberof TenantRequestDto
     */
    'result'?: TenantRequestResultDto;
    /**
     * 
     * @type {TenantRequestAppliedResultDto}
     * @memberof TenantRequestDto
     */
    'appliedResult'?: TenantRequestAppliedResultDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof TenantRequestDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof TenantRequestDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {AssessmentFlowReferenceDto}
     * @memberof TenantRequestDto
     */
    'assessmentFlow'?: AssessmentFlowReferenceDto;
    /**
     * 
     * @type {DamageDetectionReferenceDto}
     * @memberof TenantRequestDto
     */
    'damageDetection'?: DamageDetectionReferenceDto;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof TenantRequestDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {GeneralEntitySourceDto}
     * @memberof TenantRequestDto
     */
    'source'?: GeneralEntitySourceDto;
    /**
     * 
     * @type {GeneralBillToInfoDto}
     * @memberof TenantRequestDto
     */
    'billTo'?: GeneralBillToInfoDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantRequestDto
     */
    'lastChatActivityAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRequestDto
     */
    'isResponded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRequestDto
     */
    'isOpen'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantRequestDto
     */
    'lastActivityAt'?: string;
}


/**
 * 
 * @export
 * @interface TenantRequestGetPaginatedDto
 */
export interface TenantRequestGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof TenantRequestGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantRequestGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantRequestGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantRequestGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantRequestGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof TenantRequestGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof TenantRequestGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof TenantRequestGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestGetPaginatedDto
     */
    'senderTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestGetPaginatedDto
     */
    'receiverTenantId'?: string | null;
    /**
     * 
     * @type {TenantRequestStage}
     * @memberof TenantRequestGetPaginatedDto
     */
    'stage'?: TenantRequestStage;
    /**
     * 
     * @type {TenantRequestType}
     * @memberof TenantRequestGetPaginatedDto
     */
    'type'?: TenantRequestType;
    /**
     * 
     * @type {TenantRequestOperationType}
     * @memberof TenantRequestGetPaginatedDto
     */
    'operationType'?: TenantRequestOperationType;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestGetPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestGetPaginatedDto
     */
    'assessmentFlowId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRequestGetPaginatedDto
     */
    'isOpen'?: boolean | null;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof TenantRequestGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
    /**
     * 
     * @type {GeneralEntitySourceQueryDto}
     * @memberof TenantRequestGetPaginatedDto
     */
    'source'?: GeneralEntitySourceQueryDto;
}


/**
 * 
 * @export
 * @interface TenantRequestInferBillToInfoInputDto
 */
export interface TenantRequestInferBillToInfoInputDto {
    /**
     * 
     * @type {Array<GeneralStrictEntityRelationInputDto>}
     * @memberof TenantRequestInferBillToInfoInputDto
     */
    'fromEntities'?: Array<GeneralStrictEntityRelationInputDto>;
    /**
     * 
     * @type {BillToSourceType}
     * @memberof TenantRequestInferBillToInfoInputDto
     */
    'sourceType'?: BillToSourceType;
    /**
     * True by default.
     * @type {boolean}
     * @memberof TenantRequestInferBillToInfoInputDto
     */
    'isFallback'?: boolean | null;
}


/**
 * 
 * @export
 * @interface TenantRequestOperationContentDto
 */
export interface TenantRequestOperationContentDto {
    /**
     * 
     * @type {TenantRequestOperationType}
     * @memberof TenantRequestOperationContentDto
     */
    'operationType'?: TenantRequestOperationType;
    /**
     * 
     * @type {VisualInspectionContentDto}
     * @memberof TenantRequestOperationContentDto
     */
    'visualInspection'?: VisualInspectionContentDto;
    /**
     * 
     * @type {DamageDetectionContentDto}
     * @memberof TenantRequestOperationContentDto
     */
    'damageDetection'?: DamageDetectionContentDto;
    /**
     * 
     * @type {DamageCostEvaluationContentDto}
     * @memberof TenantRequestOperationContentDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationContentDto;
    /**
     * 
     * @type {AccessoryCheckContentDto}
     * @memberof TenantRequestOperationContentDto
     */
    'accessoryCheck'?: AccessoryCheckContentDto;
    /**
     * 
     * @type {RepairOperationContentDto}
     * @memberof TenantRequestOperationContentDto
     */
    'repairOperation'?: RepairOperationContentDto;
    /**
     * 
     * @type {WheelOperationContentDto}
     * @memberof TenantRequestOperationContentDto
     */
    'wheelOperation'?: WheelOperationContentDto;
    /**
     * 
     * @type {WashContentDto}
     * @memberof TenantRequestOperationContentDto
     */
    'wash'?: WashContentDto;
    /**
     * 
     * @type {MaintenanceContentDto}
     * @memberof TenantRequestOperationContentDto
     */
    'maintenance'?: MaintenanceContentDto;
}


/**
 * 
 * @export
 * @interface TenantRequestOperationContentInputDto
 */
export interface TenantRequestOperationContentInputDto {
    /**
     * 
     * @type {TenantRequestOperationType}
     * @memberof TenantRequestOperationContentInputDto
     */
    'operationType'?: TenantRequestOperationType;
    /**
     * 
     * @type {VisualInspectionContentInputDto}
     * @memberof TenantRequestOperationContentInputDto
     */
    'visualInspection'?: VisualInspectionContentInputDto;
    /**
     * 
     * @type {DamageDetectionContentInputDto}
     * @memberof TenantRequestOperationContentInputDto
     */
    'damageDetection'?: DamageDetectionContentInputDto;
    /**
     * 
     * @type {DamageCostEvaluationContentInputDto}
     * @memberof TenantRequestOperationContentInputDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationContentInputDto;
    /**
     * 
     * @type {AccessoryCheckContentInputDto}
     * @memberof TenantRequestOperationContentInputDto
     */
    'accessoryCheck'?: AccessoryCheckContentInputDto;
    /**
     * 
     * @type {RepairOperationContentInputDto}
     * @memberof TenantRequestOperationContentInputDto
     */
    'repairOperation'?: RepairOperationContentInputDto;
    /**
     * 
     * @type {WheelOperationContentInputDto}
     * @memberof TenantRequestOperationContentInputDto
     */
    'wheelOperation'?: WheelOperationContentInputDto;
    /**
     * 
     * @type {WashContentInputDto}
     * @memberof TenantRequestOperationContentInputDto
     */
    'wash'?: WashContentInputDto;
    /**
     * 
     * @type {MaintenanceContentInputDto}
     * @memberof TenantRequestOperationContentInputDto
     */
    'maintenance'?: MaintenanceContentInputDto;
}


/**
 * 
 * @export
 * @interface TenantRequestOperationResultDto
 */
export interface TenantRequestOperationResultDto {
    /**
     * 
     * @type {TenantRequestOperationType}
     * @memberof TenantRequestOperationResultDto
     */
    'operationType'?: TenantRequestOperationType;
    /**
     * 
     * @type {VisualInspectionResultDto}
     * @memberof TenantRequestOperationResultDto
     */
    'visualInspection'?: VisualInspectionResultDto;
    /**
     * 
     * @type {DamageDetectionResultDto}
     * @memberof TenantRequestOperationResultDto
     */
    'damageDetection'?: DamageDetectionResultDto;
    /**
     * 
     * @type {DamageCostEvaluationResultDto}
     * @memberof TenantRequestOperationResultDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationResultDto;
    /**
     * 
     * @type {AccessoryCheckResultDto}
     * @memberof TenantRequestOperationResultDto
     */
    'accessoryCheck'?: AccessoryCheckResultDto;
    /**
     * 
     * @type {RepairOperationResultDto}
     * @memberof TenantRequestOperationResultDto
     */
    'repairOperation'?: RepairOperationResultDto;
    /**
     * 
     * @type {WheelOperationResultDto}
     * @memberof TenantRequestOperationResultDto
     */
    'wheelOperation'?: WheelOperationResultDto;
    /**
     * 
     * @type {WashResultDto}
     * @memberof TenantRequestOperationResultDto
     */
    'wash'?: WashResultDto;
    /**
     * 
     * @type {MaintenanceResultDto}
     * @memberof TenantRequestOperationResultDto
     */
    'maintenance'?: MaintenanceResultDto;
}


/**
 * 
 * @export
 * @interface TenantRequestOperationResultInputDto
 */
export interface TenantRequestOperationResultInputDto {
    /**
     * 
     * @type {TenantRequestOperationType}
     * @memberof TenantRequestOperationResultInputDto
     */
    'operationType'?: TenantRequestOperationType;
    /**
     * 
     * @type {VisualInspectionResultInputDto}
     * @memberof TenantRequestOperationResultInputDto
     */
    'visualInspection'?: VisualInspectionResultInputDto;
    /**
     * 
     * @type {DamageDetectionResultInputDto}
     * @memberof TenantRequestOperationResultInputDto
     */
    'damageDetection'?: DamageDetectionResultInputDto;
    /**
     * 
     * @type {DamageCostEvaluationResultInputDto}
     * @memberof TenantRequestOperationResultInputDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationResultInputDto;
    /**
     * 
     * @type {AccessoryCheckResultInputDto}
     * @memberof TenantRequestOperationResultInputDto
     */
    'accessoryCheck'?: AccessoryCheckResultInputDto;
    /**
     * 
     * @type {RepairOperationResultInputDto}
     * @memberof TenantRequestOperationResultInputDto
     */
    'repairOperation'?: RepairOperationResultInputDto;
    /**
     * 
     * @type {WashResultInputDto}
     * @memberof TenantRequestOperationResultInputDto
     */
    'wash'?: WashResultInputDto;
    /**
     * 
     * @type {MaintenanceResultInputDto}
     * @memberof TenantRequestOperationResultInputDto
     */
    'maintenance'?: MaintenanceResultInputDto;
    /**
     * 
     * @type {WheelOperationResultInputDto}
     * @memberof TenantRequestOperationResultInputDto
     */
    'wheelOperation'?: WheelOperationResultInputDto;
}


/**
 * Describes types of operations (from business logic perspective) that can be performed by tenants.
 * @export
 * @enum {string}
 */

export const TenantRequestOperationType = {
    None: 'None',
    VisualInspection: 'VisualInspection',
    DamageDetection: 'DamageDetection',
    DamageCostEvaluation: 'DamageCostEvaluation',
    AccessoryCheck: 'AccessoryCheck',
    RepairOperation: 'RepairOperation',
    WheelOperation: 'WheelOperation',
    Wash: 'Wash',
    Maintenance: 'Maintenance'
} as const;

export type TenantRequestOperationType = typeof TenantRequestOperationType[keyof typeof TenantRequestOperationType];


/**
 * 
 * @export
 * @interface TenantRequestReferenceDto
 */
export interface TenantRequestReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof TenantRequestReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestReferenceDto
     */
    'globalNumber'?: string;
}
/**
 * 
 * @export
 * @interface TenantRequestRespondDto
 */
export interface TenantRequestRespondDto {
    /**
     * 
     * @type {TenantRequestResponseType}
     * @memberof TenantRequestRespondDto
     */
    'responseType'?: TenantRequestResponseType;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestRespondDto
     */
    'reason'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TenantRequestResponseType = {
    None: 'None',
    Accept: 'Accept',
    Decline: 'Decline'
} as const;

export type TenantRequestResponseType = typeof TenantRequestResponseType[keyof typeof TenantRequestResponseType];


/**
 * 
 * @export
 * @interface TenantRequestResultDto
 */
export interface TenantRequestResultDto {
    /**
     * 
     * @type {TenantRequestType}
     * @memberof TenantRequestResultDto
     */
    'type'?: TenantRequestType;
    /**
     * 
     * @type {TenantRequestOperationResultDto}
     * @memberof TenantRequestResultDto
     */
    'operation'?: TenantRequestOperationResultDto;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestResultDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof TenantRequestResultDto
     */
    'attachments'?: Array<GeneralAttachmentDto> | null;
}


/**
 * 
 * @export
 * @interface TenantRequestResultInputDto
 */
export interface TenantRequestResultInputDto {
    /**
     * 
     * @type {TenantRequestType}
     * @memberof TenantRequestResultInputDto
     */
    'type'?: TenantRequestType;
    /**
     * 
     * @type {TenantRequestOperationResultInputDto}
     * @memberof TenantRequestResultInputDto
     */
    'operation'?: TenantRequestOperationResultInputDto;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestResultInputDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof TenantRequestResultInputDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
}


/**
 * 
 * @export
 * @interface TenantRequestReturnDto
 */
export interface TenantRequestReturnDto {
    /**
     * 
     * @type {string}
     * @memberof TenantRequestReturnDto
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface TenantRequestReworkDto
 */
export interface TenantRequestReworkDto {
    /**
     * 
     * @type {string}
     * @memberof TenantRequestReworkDto
     */
    'reason'?: string | null;
}
/**
 * NB: use SortOrderAttribute to specify the order in which stages can be activated.
 * @export
 * @enum {string}
 */

export const TenantRequestStage = {
    None: 'None',
    Draft: 'Draft',
    Pending: 'Pending',
    Accepted: 'Accepted',
    Declined: 'Declined',
    InProgress: 'InProgress',
    Completed: 'Completed',
    Reporting: 'Reporting',
    Returned: 'Returned',
    Closed: 'Closed'
} as const;

export type TenantRequestStage = typeof TenantRequestStage[keyof typeof TenantRequestStage];


/**
 * 
 * @export
 * @enum {string}
 */

export const TenantRequestType = {
    None: 'None',
    Arbitrary: 'Arbitrary',
    Operation: 'Operation'
} as const;

export type TenantRequestType = typeof TenantRequestType[keyof typeof TenantRequestType];


/**
 * 
 * @export
 * @interface TenantRequestUpdateDto
 */
export interface TenantRequestUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof TenantRequestUpdateDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestUpdateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestUpdateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {TenantRequestContentInputDto}
     * @memberof TenantRequestUpdateDto
     */
    'content'?: TenantRequestContentInputDto;
    /**
     * 
     * @type {TenantRequestDataGrantSettingsInputDto}
     * @memberof TenantRequestUpdateDto
     */
    'dataGrantSettings'?: TenantRequestDataGrantSettingsInputDto;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof TenantRequestUpdateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestUpdateDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestUpdateDto
     */
    'assessmentFlowId'?: string | null;
    /**
     * 
     * @type {GeneralBillToInfoInputDto}
     * @memberof TenantRequestUpdateDto
     */
    'billTo'?: GeneralBillToInfoInputDto;
}
/**
 * 
 * @export
 * @interface TenantRequestsMetaDto
 */
export interface TenantRequestsMetaDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantRequestsMetaDto
     */
    'tenantRequestIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestsMetaDto
     */
    'appliedResultOfTenantRequestId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRequestsMetaDto
     */
    'hasTenantRequest'?: boolean;
}
/**
 * 
 * @export
 * @interface TenantRequestsMetaInputDto
 */
export interface TenantRequestsMetaInputDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantRequestsMetaInputDto
     */
    'tenantRequestIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface TenantRequestsMetaQueryDto
 */
export interface TenantRequestsMetaQueryDto {
    /**
     * 
     * @type {string}
     * @memberof TenantRequestsMetaQueryDto
     */
    'tenantRequestId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantRequestsMetaQueryDto
     */
    'tenantRequestIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantRequestsMetaQueryDto
     */
    'notTenantRequestIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRequestsMetaQueryDto
     */
    'appliedResultOfTenantRequestId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRequestsMetaQueryDto
     */
    'hasTenantRequest'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TenantSettingsDto
 */
export interface TenantSettingsDto {
    /**
     * 
     * @type {GeneralCountryDto}
     * @memberof TenantSettingsDto
     */
    'country'?: GeneralCountryDto;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof TenantSettingsDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof TenantSettingsDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {string}
     * @memberof TenantSettingsDto
     */
    'tzId'?: string;
    /**
     * Deprecated: Use TenantToTenant.IsEnableConnections instead.
     * @type {boolean}
     * @memberof TenantSettingsDto
     * @deprecated
     */
    'isEnableTenantToTenantConnections'?: boolean;
    /**
     * 
     * @type {VisualInspectionSettingsDto}
     * @memberof TenantSettingsDto
     */
    'visualInspection'?: VisualInspectionSettingsDto;
    /**
     * 
     * @type {TenantVehicleTaxSettingsDto}
     * @memberof TenantSettingsDto
     */
    'vehicleTax'?: TenantVehicleTaxSettingsDto;
    /**
     * 
     * @type {ContractSettingsDto}
     * @memberof TenantSettingsDto
     */
    'contract'?: ContractSettingsDto;
    /**
     * 
     * @type {TenantMediaSettingDto}
     * @memberof TenantSettingsDto
     */
    'media'?: TenantMediaSettingDto;
    /**
     * 
     * @type {TenantTenantToTenantSettingsDto}
     * @memberof TenantSettingsDto
     */
    'tenantToTenant'?: TenantTenantToTenantSettingsDto;
}
/**
 * 
 * @export
 * @interface TenantSettingsInputDto
 */
export interface TenantSettingsInputDto {
    /**
     * 
     * @type {GeneralCountryInputDto}
     * @memberof TenantSettingsInputDto
     */
    'country'?: GeneralCountryInputDto;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof TenantSettingsInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof TenantSettingsInputDto
     */
    'tax'?: GeneralTaxInputDto;
    /**
     * 
     * @type {string}
     * @memberof TenantSettingsInputDto
     */
    'tzId'?: string;
    /**
     * 
     * @type {VisualInspectionSettingsInputDto}
     * @memberof TenantSettingsInputDto
     */
    'visualInspection'?: VisualInspectionSettingsInputDto;
    /**
     * 
     * @type {TenantVehicleTaxSettingsInputDto}
     * @memberof TenantSettingsInputDto
     */
    'vehicleTax'?: TenantVehicleTaxSettingsInputDto;
    /**
     * 
     * @type {ContractSettingsInputDto}
     * @memberof TenantSettingsInputDto
     */
    'contract'?: ContractSettingsInputDto;
    /**
     * 
     * @type {TenantMediaSettingInputDto}
     * @memberof TenantSettingsInputDto
     */
    'media'?: TenantMediaSettingInputDto;
    /**
     * 
     * @type {TenantTenantToTenantSettingsInputDto}
     * @memberof TenantSettingsInputDto
     */
    'tenantToTenant'?: TenantTenantToTenantSettingsInputDto;
}
/**
 * 
 * @export
 * @interface TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
 */
export interface TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto {
    /**
     * 
     * @type {UserStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'user': UserStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'vehicle': EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'customer': EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'contract': EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'assetSubscription': EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'assessmentFlow': EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'damageDetection': EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'damageCostEvaluation': EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'repairOperation': EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'visualInspection': EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'maintenance': EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'wheelOperation': EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'wash': EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'tenantConnection': EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'tenantRequest': EntityStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {FileStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'file': FileStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {FileStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'fileOfPrevRange': FileStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
    /**
     * 
     * @type {number}
     * @memberof TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'fileTotalSizeBytesDiffComparedToPrevPeriod': number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TenantStatus = {
    None: 'None',
    RegistrationIncomplete: 'RegistrationIncomplete',
    InfoIncomplete: 'InfoIncomplete',
    Active: 'Active',
    Suspended: 'Suspended'
} as const;

export type TenantStatus = typeof TenantStatus[keyof typeof TenantStatus];


/**
 * 
 * @export
 * @interface TenantSuspendAdminDto
 */
export interface TenantSuspendAdminDto {
    /**
     * 
     * @type {TenantSuspensionReasonType}
     * @memberof TenantSuspendAdminDto
     */
    'reasonType'?: TenantSuspensionReasonType;
    /**
     * 
     * @type {string}
     * @memberof TenantSuspendAdminDto
     */
    'reason'?: string | null;
}


/**
 * 
 * @export
 * @interface TenantSuspensionInfoDto
 */
export interface TenantSuspensionInfoDto {
    /**
     * 
     * @type {TenantStatus}
     * @memberof TenantSuspensionInfoDto
     */
    'statusBeforeSuspension'?: TenantStatus;
    /**
     * 
     * @type {TenantStatus}
     * @memberof TenantSuspensionInfoDto
     */
    'statusAfterUnsuspension'?: TenantStatus;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantSuspensionInfoDto
     */
    'suspendedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantSuspensionInfoDto
     */
    'unsuspendedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantSuspensionInfoDto
     */
    'suspendedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantSuspensionInfoDto
     */
    'unsuspendedBy'?: string | null;
    /**
     * 
     * @type {TenantSuspensionReasonType}
     * @memberof TenantSuspensionInfoDto
     */
    'suspensionReasonType'?: TenantSuspensionReasonType;
    /**
     * 
     * @type {string}
     * @memberof TenantSuspensionInfoDto
     */
    'suspensionReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantSuspensionInfoDto
     */
    'unsuspensionReason'?: string | null;
}


/**
 * Detailed reason for tenant suspension.
 * @export
 * @enum {string}
 */

export const TenantSuspensionReasonType = {
    None: 'None',
    NonPayment: 'NonPayment',
    LegalIssues: 'LegalIssues',
    Other: 'Other'
} as const;

export type TenantSuspensionReasonType = typeof TenantSuspensionReasonType[keyof typeof TenantSuspensionReasonType];


/**
 * 
 * @export
 * @interface TenantTenantToTenantSettingsDto
 */
export interface TenantTenantToTenantSettingsDto {
    /**
     * Whether can connect with other tenants and/or receive connection requests from other tenants.
     * @type {boolean}
     * @memberof TenantTenantToTenantSettingsDto
     */
    'isEnableConnections'?: boolean;
    /**
     * Default assessor tenant where to send assessments by default via T2T.
     * @type {string}
     * @memberof TenantTenantToTenantSettingsDto
     */
    'defaultAssessorTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantTenantToTenantSettingsDto
     */
    'isAutoAcceptTenantRequestResultFromDefaultAssessor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantTenantToTenantSettingsDto
     */
    'isAutoApplyTenantRequestResultFromDefaultAssessor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantTenantToTenantSettingsDto
     */
    'isEnableBillTo'?: boolean;
    /**
     * 
     * @type {BillToSourceType}
     * @memberof TenantTenantToTenantSettingsDto
     */
    'defaultBillToSourceType'?: BillToSourceType;
    /**
     * Default contacts for all T2T communications.    Contacts this tenant has approved to share with the other connected tenants.
     * @type {Array<TenantContactDto>}
     * @memberof TenantTenantToTenantSettingsDto
     */
    'contacts'?: Array<TenantContactDto> | null;
}


/**
 * 
 * @export
 * @interface TenantTenantToTenantSettingsInputDto
 */
export interface TenantTenantToTenantSettingsInputDto {
    /**
     * 
     * @type {boolean}
     * @memberof TenantTenantToTenantSettingsInputDto
     */
    'isEnableConnections'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TenantTenantToTenantSettingsInputDto
     */
    'defaultAssessorTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantTenantToTenantSettingsInputDto
     */
    'isAutoAcceptTenantRequestResultFromDefaultAssessor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantTenantToTenantSettingsInputDto
     */
    'isAutoApplyTenantRequestResultFromDefaultAssessor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantTenantToTenantSettingsInputDto
     */
    'isEnableBillTo'?: boolean;
    /**
     * 
     * @type {BillToSourceType}
     * @memberof TenantTenantToTenantSettingsInputDto
     */
    'defaultBillToSourceType'?: BillToSourceType;
    /**
     * 
     * @type {Array<TenantContactInputDto>}
     * @memberof TenantTenantToTenantSettingsInputDto
     */
    'contacts'?: Array<TenantContactInputDto> | null;
}


/**
 * 
 * @export
 * @interface TenantToTenantCountersDto
 */
export interface TenantToTenantCountersDto {
    /**
     * 
     * @type {string}
     * @memberof TenantToTenantCountersDto
     */
    'version'?: string;
    /**
     * 
     * @type {TenantConnectionRequestCountersDto}
     * @memberof TenantToTenantCountersDto
     */
    'connectionRequests': TenantConnectionRequestCountersDto;
    /**
     * 
     * @type {TenantConnectionCountersDto}
     * @memberof TenantToTenantCountersDto
     */
    'connections': TenantConnectionCountersDto;
    /**
     * 
     * @type {TenantRequestCountersDto}
     * @memberof TenantToTenantCountersDto
     */
    'requests': TenantRequestCountersDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TenantType = {
    None: 'None',
    AllPurpose: 'AllPurpose',
    Rental: 'Rental',
    Leasing: 'Leasing',
    Carsharing: 'Carsharing',
    Utility: 'Utility',
    DamageAssessor: 'DamageAssessor'
} as const;

export type TenantType = typeof TenantType[keyof typeof TenantType];


/**
 * 
 * @export
 * @interface TenantUnsuspendAdminDto
 */
export interface TenantUnsuspendAdminDto {
    /**
     * 
     * @type {string}
     * @memberof TenantUnsuspendAdminDto
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface TenantVehicleTaxSettingsDto
 */
export interface TenantVehicleTaxSettingsDto {
    /**
     * 
     * @type {Array<VehicleTaxDto>}
     * @memberof TenantVehicleTaxSettingsDto
     */
    'vehicleTaxes'?: Array<VehicleTaxDto> | null;
}
/**
 * 
 * @export
 * @interface TenantVehicleTaxSettingsInputDto
 */
export interface TenantVehicleTaxSettingsInputDto {
    /**
     * 
     * @type {Array<VehicleTaxInputDto>}
     * @memberof TenantVehicleTaxSettingsInputDto
     */
    'vehicleTaxes'?: Array<VehicleTaxInputDto> | null;
}
/**
 * 
 * @export
 * @interface TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
 */
export interface TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto {
    /**
     * 
     * @type {string}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {TenantStatus}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'status'?: TenantStatus;
    /**
     * 
     * @type {TenantMode}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'mode'?: TenantMode;
    /**
     * 
     * @type {TenantContactPersonDto}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'contactPerson'?: TenantContactPersonDto;
    /**
     * 
     * @type {TenantSettingsDto}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'settings'?: TenantSettingsDto;
    /**
     * 
     * @type {GeneralBrandingDto}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'branding'?: GeneralBrandingDto;
    /**
     * 
     * @type {TenantSuspensionInfoDto}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'suspension'?: TenantSuspensionInfoDto;
    /**
     * 
     * @type {string}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'companyNumberPrefix'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto}
     * @memberof TenantWithStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'stats'?: TenantStatsDtoInWidgetDataOfTenantStatsTabularAdminDto;
}


/**
 * 
 * @export
 * @interface TestEventDto
 */
export interface TestEventDto {
    /**
     * 
     * @type {number}
     * @memberof TestEventDto
     */
    'numberOfEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof TestEventDto
     */
    'proccessDurationMs'?: number | null;
    /**
     * 
     * @type {AdminTestDomainEventType}
     * @memberof TestEventDto
     */
    'eventType'?: AdminTestDomainEventType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TestSwaggerEnum = {
    None: 'None',
    Test1: 'Test1',
    Test2: 'Test2',
    Other: 'Other'
} as const;

export type TestSwaggerEnum = typeof TestSwaggerEnum[keyof typeof TestSwaggerEnum];


/**
 * 
 * @export
 * @interface TestSwaggerStruct
 */
export interface TestSwaggerStruct {
    /**
     * 
     * @type {number}
     * @memberof TestSwaggerStruct
     */
    'int'?: number;
    /**
     * 
     * @type {number}
     * @memberof TestSwaggerStruct
     */
    'intNullable'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ThumbnailSizeType = {
    None: 'None',
    ExtraSmall: 'ExtraSmall',
    Small: 'Small',
    Medium: 'Medium',
    Large: 'Large',
    ExtraLarge: 'ExtraLarge'
} as const;

export type ThumbnailSizeType = typeof ThumbnailSizeType[keyof typeof ThumbnailSizeType];


/**
 * 
 * @export
 * @interface TotalPerMonthSummaryDto
 */
export interface TotalPerMonthSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof TotalPerMonthSummaryDto
     */
    'dataSeriesId': string;
    /**
     * 
     * @type {Array<DataPointDtoOfDateTimeOffsetAndDecimal>}
     * @memberof TotalPerMonthSummaryDto
     */
    'points': Array<DataPointDtoOfDateTimeOffsetAndDecimal>;
    /**
     * 
     * @type {number}
     * @memberof TotalPerMonthSummaryDto
     */
    'sum'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UnitOfTime = {
    None: 'None',
    Year: 'Year',
    Month: 'Month',
    Week: 'Week',
    Day: 'Day',
    Hour: 'Hour',
    Minute: 'Minute',
    Second: 'Second',
    Millisecond: 'Millisecond'
} as const;

export type UnitOfTime = typeof UnitOfTime[keyof typeof UnitOfTime];


/**
 * 
 * @export
 * @interface UnsubscribeFromChatActivityUpdatesDto
 */
export interface UnsubscribeFromChatActivityUpdatesDto {
    /**
     * 
     * @type {string}
     * @memberof UnsubscribeFromChatActivityUpdatesDto
     */
    'chatId'?: string;
}
/**
 * 
 * @export
 * @interface UnsubscribeFromDataUpdatesDto
 */
export interface UnsubscribeFromDataUpdatesDto {
    /**
     * 
     * @type {string}
     * @memberof UnsubscribeFromDataUpdatesDto
     */
    'channelName'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UnsubscribeFromDataUpdatesDto
     */
    'channelNames'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UnsubscribeFromDataUpdatesDto
     */
    'allChannelNames'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateAccessoryCheckDto
 */
export interface UpdateAccessoryCheckDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAccessoryCheckDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAccessoryCheckDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccessoryCheckDto
     */
    'externalNumber'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof UpdateAccessoryCheckDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorInputDto}
     * @memberof UpdateAccessoryCheckDto
     */
    'inspector'?: GeneralInspectorInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAccessoryCheckDto
     */
    'isUseSupplierBranding'?: boolean;
    /**
     * 
     * @type {Array<UpdateAccessoryCheckItemDto>}
     * @memberof UpdateAccessoryCheckDto
     */
    'items'?: Array<UpdateAccessoryCheckItemDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof UpdateAccessoryCheckDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccessoryCheckDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof UpdateAccessoryCheckDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}
/**
 * 
 * @export
 * @interface UpdateAccessoryCheckItemDto
 */
export interface UpdateAccessoryCheckItemDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAccessoryCheckItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {AccessoryStatus}
     * @memberof UpdateAccessoryCheckItemDto
     */
    'status'?: AccessoryStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccessoryCheckItemDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof UpdateAccessoryCheckItemDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
}


/**
 * 
 * @export
 * @interface UpdateAccessoryDto
 */
export interface UpdateAccessoryDto {
    /**
     * 
     * @type {AccessoryType}
     * @memberof UpdateAccessoryDto
     */
    'type'?: AccessoryType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof UpdateAccessoryDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccessoryDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccessoryDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof UpdateAccessoryDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}


/**
 * 
 * @export
 * @interface UpdateAdminUserDto
 */
export interface UpdateAdminUserDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAdminUserDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof UpdateAdminUserDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdminUserDto
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface UpdateChatDto
 */
export interface UpdateChatDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateChatDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateChatDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {ChatSettingsInputDto}
     * @memberof UpdateChatDto
     */
    'settings'?: ChatSettingsInputDto;
}
/**
 * 
 * @export
 * @interface UpdateChatMessageDto
 */
export interface UpdateChatMessageDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateChatMessageDto
     */
    'body'?: string | null;
    /**
     * 
     * @type {ChatMessageRootNodeInputDto}
     * @memberof UpdateChatMessageDto
     */
    'rootNode'?: ChatMessageRootNodeInputDto;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof UpdateChatMessageDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
}
/**
 * 
 * @export
 * @interface UpdateChatUserSettingsDto
 */
export interface UpdateChatUserSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateChatUserSettingsDto
     */
    'chatId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateChatUserSettingsDto
     */
    'settingsId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateChatUserSettingsDto
     */
    'isGlobal'?: boolean;
    /**
     * 
     * @type {UpdateChatUserSettingsEventDto}
     * @memberof UpdateChatUserSettingsDto
     */
    'event'?: UpdateChatUserSettingsEventDto;
}
/**
 * 
 * @export
 * @interface UpdateChatUserSettingsEventDto
 */
export interface UpdateChatUserSettingsEventDto {
    /**
     * 
     * @type {ChatUserSettingsEventDisabledCategoriesMap}
     * @memberof UpdateChatUserSettingsEventDto
     */
    'disabledCategoriesMap'?: ChatUserSettingsEventDisabledCategoriesMap;
    /**
     * 
     * @type {ChatUserSettingsEventDisabledTypesMap}
     * @memberof UpdateChatUserSettingsEventDto
     */
    'disabledTypesMap'?: ChatUserSettingsEventDisabledTypesMap;
}
/**
 * 
 * @export
 * @interface UpdateDamageDetectionDto
 */
export interface UpdateDamageDetectionDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDamageDetectionDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDamageDetectionDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDamageDetectionDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDamageDetectionDto
     */
    'vehicleVisualModelId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDamageDetectionDto
     */
    'externalNumber'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof UpdateDamageDetectionDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorInputDto}
     * @memberof UpdateDamageDetectionDto
     */
    'inspector'?: GeneralInspectorInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDamageDetectionDto
     */
    'isUseSupplierBranding'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateDamageDetectionDto
     */
    'fuelLevel'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDamageDetectionDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDamageDetectionDto
     */
    'isNoDamagesDetected'?: boolean;
    /**
     * Whether to send to the contract customer.
     * @type {boolean}
     * @memberof UpdateDamageDetectionDto
     */
    'isSendToCustomer'?: boolean | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof UpdateDamageDetectionDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {Array<UpdateDamageDetectionItemDto>}
     * @memberof UpdateDamageDetectionDto
     */
    'items'?: Array<UpdateDamageDetectionItemDto>;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof UpdateDamageDetectionDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}
/**
 * 
 * @export
 * @interface UpdateDamageDetectionItemDto
 */
export interface UpdateDamageDetectionItemDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDamageDetectionItemDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDamageDetectionItemDto
     */
    'partTypeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDamageDetectionItemDto
     */
    'damageTypeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDamageDetectionItemDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof UpdateDamageDetectionItemDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {VehicleArea}
     * @memberof UpdateDamageDetectionItemDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof UpdateDamageDetectionItemDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {GeneralSvgPointDto}
     * @memberof UpdateDamageDetectionItemDto
     */
    'point'?: GeneralSvgPointDto;
}


/**
 * 
 * @export
 * @interface UpdateDepartmentDto
 */
export interface UpdateDepartmentDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDepartmentDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDepartmentDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAddressInputDto}
     * @memberof UpdateDepartmentDto
     */
    'address'?: GeneralAddressInputDto;
    /**
     * 
     * @type {GeneralContactInputDto}
     * @memberof UpdateDepartmentDto
     */
    'contact'?: GeneralContactInputDto;
    /**
     * 
     * @type {GeneralBrandingInputDto}
     * @memberof UpdateDepartmentDto
     */
    'branding'?: GeneralBrandingInputDto;
}
/**
 * 
 * @export
 * @interface UpdateDocumentStageDto
 */
export interface UpdateDocumentStageDto {
    /**
     * 
     * @type {DocumentStage}
     * @memberof UpdateDocumentStageDto
     */
    'newStage'?: DocumentStage;
}


/**
 * 
 * @export
 * @interface UpdateEntityAffiliationParametersInputDto
 */
export interface UpdateEntityAffiliationParametersInputDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateEntityAffiliationParametersInputDto
     */
    'departmentIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateEntityAffiliationParametersInputDto
     */
    'locationIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateLocationDto
 */
export interface UpdateLocationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAddressInputDto}
     * @memberof UpdateLocationDto
     */
    'address'?: GeneralAddressInputDto;
    /**
     * 
     * @type {GeneralContactInputDto}
     * @memberof UpdateLocationDto
     */
    'contact'?: GeneralContactInputDto;
}
/**
 * 
 * @export
 * @interface UpdateMaintenanceDto
 */
export interface UpdateMaintenanceDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateMaintenanceDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateMaintenanceDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaintenanceDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaintenanceDto
     */
    'supplierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaintenanceDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaintenanceDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {MaintenanceScheduleType}
     * @memberof UpdateMaintenanceDto
     */
    'scheduleType'?: MaintenanceScheduleType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof UpdateMaintenanceDto
     */
    'scheduledAt'?: string | null;
    /**
     * 
     * @type {GeneralByWhoInputDto}
     * @memberof UpdateMaintenanceDto
     */
    'responsibleUser'?: GeneralByWhoInputDto;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof UpdateMaintenanceDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {number}
     * @memberof UpdateMaintenanceDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMaintenanceDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof UpdateMaintenanceDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof UpdateMaintenanceDto
     */
    'tax'?: GeneralTaxInputDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaintenanceDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof UpdateMaintenanceDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof UpdateMaintenanceDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}


/**
 * 
 * @export
 * @interface UpdateNegotiationDto
 */
export interface UpdateNegotiationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateNegotiationDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateNegotiationDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {NegotiationSettingsDto}
     * @memberof UpdateNegotiationDto
     */
    'settings'?: NegotiationSettingsDto;
}
/**
 * 
 * @export
 * @interface UpdateNegotiationProposalDto
 */
export interface UpdateNegotiationProposalDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateNegotiationProposalDto
     */
    'statement'?: string;
    /**
     * 
     * @type {NegotiationProposalSettingsDto}
     * @memberof UpdateNegotiationProposalDto
     */
    'settings'?: NegotiationProposalSettingsDto;
}
/**
 * 
 * @export
 * @interface UpdateProductLocationDto
 */
export interface UpdateProductLocationDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProductLocationDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProductLocationDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductLocationDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductLocationDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAddressInputDto}
     * @memberof UpdateProductLocationDto
     */
    'address'?: GeneralAddressInputDto;
}
/**
 * 
 * @export
 * @interface UpdateRepairMaterialDto
 */
export interface UpdateRepairMaterialDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairMaterialDto
     */
    'repairCatalogId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairMaterialDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairMaterialDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof UpdateRepairMaterialDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairMaterialDto
     */
    'brandName'?: string | null;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof UpdateRepairMaterialDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {number}
     * @memberof UpdateRepairMaterialDto
     */
    'price'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRepairMaterialDto
     */
    'isDividable'?: boolean;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof UpdateRepairMaterialDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof UpdateRepairMaterialDto
     */
    'tax'?: GeneralTaxInputDto;
}


/**
 * 
 * @export
 * @interface UpdateRepairOperationDto
 */
export interface UpdateRepairOperationDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRepairOperationDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRepairOperationDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairOperationDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairOperationDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairOperationDto
     */
    'supplierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairOperationDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairOperationDto
     */
    'description'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof UpdateRepairOperationDto
     */
    'date'?: string;
    /**
     * 
     * @type {GeneralByWhoInputDto}
     * @memberof UpdateRepairOperationDto
     */
    'responsibleUser'?: GeneralByWhoInputDto;
    /**
     * 
     * @type {number}
     * @memberof UpdateRepairOperationDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof UpdateRepairOperationDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {Array<RepairOperationItemInputDto>}
     * @memberof UpdateRepairOperationDto
     */
    'items'?: Array<RepairOperationItemInputDto>;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairOperationDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof UpdateRepairOperationDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof UpdateRepairOperationDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {GeneralStageUpdateDtoOfRepairOperationStage}
     * @memberof UpdateRepairOperationDto
     */
    'newStage'?: GeneralStageUpdateDtoOfRepairOperationStage;
}
/**
 * 
 * @export
 * @interface UpdateRepairSparePartDto
 */
export interface UpdateRepairSparePartDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairSparePartDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairSparePartDto
     */
    'partNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairSparePartDto
     */
    'brandName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairSparePartDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof UpdateRepairSparePartDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {VehicleType}
     * @memberof UpdateRepairSparePartDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairSparePartDto
     */
    'partTypeId'?: string | null;
    /**
     * 
     * @type {Array<RepairSparePartDetalizationInputDto>}
     * @memberof UpdateRepairSparePartDto
     */
    'detalizations'?: Array<RepairSparePartDetalizationInputDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof UpdateRepairSparePartDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof UpdateRepairSparePartDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {number}
     * @memberof UpdateRepairSparePartDto
     */
    'price'?: number | null;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof UpdateRepairSparePartDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof UpdateRepairSparePartDto
     */
    'tax'?: GeneralTaxInputDto;
}


/**
 * 
 * @export
 * @interface UpdateRepairSpecDto
 */
export interface UpdateRepairSpecDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairSpecDto
     */
    'repairCatalogId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairSpecDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairSpecDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof UpdateRepairSpecDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof UpdateRepairSpecDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairSpecDto
     */
    'damageTypeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairSpecDto
     */
    'partTypeId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRepairSpecDto
     */
    'isSpot'?: boolean;
    /**
     * 
     * @type {RepairSpecDetalizationInputDto}
     * @memberof UpdateRepairSpecDto
     */
    'detalization'?: RepairSpecDetalizationInputDto;
    /**
     * 
     * @type {number}
     * @memberof UpdateRepairSpecDto
     */
    'spotFactor'?: number;
    /**
     * 
     * @type {Array<RepairSpecItemInputDto>}
     * @memberof UpdateRepairSpecDto
     */
    'items'?: Array<RepairSpecItemInputDto>;
}


/**
 * 
 * @export
 * @interface UpdateRepairWorkDto
 */
export interface UpdateRepairWorkDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairWorkDto
     */
    'repairCatalogId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairWorkDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRepairWorkDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof UpdateRepairWorkDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof UpdateRepairWorkDto
     */
    'unit'?: MeasurementUnit;
    /**
     * 
     * @type {number}
     * @memberof UpdateRepairWorkDto
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRepairWorkDto
     */
    'expendablesPercent'?: number;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof UpdateRepairWorkDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof UpdateRepairWorkDto
     */
    'tax'?: GeneralTaxInputDto;
}


/**
 * 
 * @export
 * @interface UpdateSpotDto
 */
export interface UpdateSpotDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSpotDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpotDto
     */
    'productLocationId'?: string | null;
    /**
     * 
     * @type {Array<SpotType>}
     * @memberof UpdateSpotDto
     */
    'types'?: Array<SpotType>;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpotDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpotDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {GeneralAddressInputDto}
     * @memberof UpdateSpotDto
     */
    'address'?: GeneralAddressInputDto;
    /**
     * 
     * @type {GeneralGeolocationInputDto}
     * @memberof UpdateSpotDto
     */
    'geolocation'?: GeneralGeolocationInputDto;
}
/**
 * 
 * @export
 * @interface UpdateSupplierContactDto
 */
export interface UpdateSupplierContactDto {
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof UpdateSupplierContactDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateSupplierContactDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSupplierContactDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {GeneralNationalIdentityNumberInputDto}
     * @memberof UpdateSupplierContactDto
     */
    'nationalIdentityNumber'?: GeneralNationalIdentityNumberInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSupplierContactDto
     */
    'isPrimary'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateSupplierContactDto
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateSupplierDto
 */
export interface UpdateSupplierDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSupplierDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSupplierDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {GeneralAddressInputDto}
     * @memberof UpdateSupplierDto
     */
    'address'?: GeneralAddressInputDto;
    /**
     * 
     * @type {Array<SupplierType>}
     * @memberof UpdateSupplierDto
     */
    'types'?: Array<SupplierType>;
    /**
     * 
     * @type {Array<UpdateSupplierContactDto>}
     * @memberof UpdateSupplierDto
     */
    'contacts'?: Array<UpdateSupplierContactDto>;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof UpdateSupplierDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSupplierDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSupplierDto
     */
    'locationIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface UpdateTenantRoleDto
 */
export interface UpdateTenantRoleDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRoleDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRoleDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<AppPermission>}
     * @memberof UpdateTenantRoleDto
     */
    'permissions'?: Array<AppPermission> | null;
}
/**
 * 
 * @export
 * @interface UpdateTenantUserDto
 */
export interface UpdateTenantUserDto {
    /**
     * 
     * @type {GeneralPersonNameInputDto}
     * @memberof UpdateTenantUserDto
     */
    'personName'?: GeneralPersonNameInputDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantUserDto
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface UpdateUserRolesDto
 */
export interface UpdateUserRolesDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserRolesDto
     */
    'roleIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateVehicleDto
 */
export interface UpdateVehicleDto {
    /**
     * 
     * @type {VehicleSpecInputDto}
     * @memberof UpdateVehicleDto
     */
    'spec'?: VehicleSpecInputDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateVehicleDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateVehicleDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'identificationNumber'?: string | null;
    /**
     * 
     * @type {GeneralPlateNoInputDto}
     * @memberof UpdateVehicleDto
     */
    'plateNo'?: GeneralPlateNoInputDto;
    /**
     * 
     * @type {VehicleMileageInputDto}
     * @memberof UpdateVehicleDto
     */
    'mileage'?: VehicleMileageInputDto;
    /**
     * 
     * @type {VehicleBatteryStateInputDto}
     * @memberof UpdateVehicleDto
     */
    'batteryState'?: VehicleBatteryStateInputDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateVehicleDto
     */
    'accessoryIds'?: Array<string> | null;
    /**
     * 
     * @type {object}
     * @memberof UpdateVehicleDto
     */
    'car'?: object;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof UpdateVehicleDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'defaultVisualModelId'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof UpdateVehicleDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {GeneralStatusInputTypedDtoOfVehicleStatus}
     * @memberof UpdateVehicleDto
     */
    'status'?: GeneralStatusInputTypedDtoOfVehicleStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'vehicleId'?: string;
}
/**
 * 
 * @export
 * @interface UpdateVehicleMileageDto
 */
export interface UpdateVehicleMileageDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleMileageDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {VehicleMileageInputDto}
     * @memberof UpdateVehicleMileageDto
     */
    'mileage'?: VehicleMileageInputDto;
}
/**
 * 
 * @export
 * @interface UpdateWashDto
 */
export interface UpdateWashDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateWashDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateWashDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWashDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWashDto
     */
    'supplierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWashDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {Array<WashType>}
     * @memberof UpdateWashDto
     */
    'types'?: Array<WashType> | null;
    /**
     * 
     * @type {WashScheduleType}
     * @memberof UpdateWashDto
     */
    'scheduleType'?: WashScheduleType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof UpdateWashDto
     */
    'scheduledAt'?: string | null;
    /**
     * 
     * @type {GeneralByWhoInputDto}
     * @memberof UpdateWashDto
     */
    'responsibleUser'?: GeneralByWhoInputDto;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof UpdateWashDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {number}
     * @memberof UpdateWashDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWashDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof UpdateWashDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof UpdateWashDto
     */
    'tax'?: GeneralTaxInputDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateWashDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof UpdateWashDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof UpdateWashDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}


/**
 * 
 * @export
 * @interface UpdateWebhookDto
 */
export interface UpdateWebhookDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateWebhookDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWebhookDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<WebhookEventType>}
     * @memberof UpdateWebhookDto
     */
    'eventTypes'?: Array<WebhookEventType>;
    /**
     * 
     * @type {string}
     * @memberof UpdateWebhookDto
     */
    'url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWebhookDto
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateWheelOperationDto
 */
export interface UpdateWheelOperationDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateWheelOperationDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateWheelOperationDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWheelOperationDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWheelOperationDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWheelOperationDto
     */
    'supplierId'?: string | null;
    /**
     * 
     * @type {GeneralByWhoInputDto}
     * @memberof UpdateWheelOperationDto
     */
    'responsibleUser'?: GeneralByWhoInputDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof UpdateWheelOperationDto
     */
    'scheduledAt'?: string | null;
    /**
     * 
     * @type {WheelOperationScheduleType}
     * @memberof UpdateWheelOperationDto
     */
    'scheduleType'?: WheelOperationScheduleType;
    /**
     * 
     * @type {Array<WheelServiceType>}
     * @memberof UpdateWheelOperationDto
     */
    'serviceTypes'?: Array<WheelServiceType>;
    /**
     * 
     * @type {number}
     * @memberof UpdateWheelOperationDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWheelOperationDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof UpdateWheelOperationDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof UpdateWheelOperationDto
     */
    'tax'?: GeneralTaxInputDto;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof UpdateWheelOperationDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof UpdateWheelOperationDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWheelOperationDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {TenantRequestsMetaInputDto}
     * @memberof UpdateWheelOperationDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaInputDto;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof UpdateWheelOperationDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {GeneralStageUpdateDtoOfWheelOperationStage}
     * @memberof UpdateWheelOperationDto
     */
    'newStage'?: GeneralStageUpdateDtoOfWheelOperationStage;
}


/**
 * Deprecated: Use FileUploadManyDto instead.
 * @export
 * @interface UploadFilesDto
 */
export interface UploadFilesDto {
    /**
     * 
     * @type {Array<File>}
     * @memberof UploadFilesDto
     */
    'files'?: Array<File>;
    /**
     * 
     * @type {FileUploadResultOptionsDto}
     * @memberof UploadFilesDto
     */
    'responseOptions'?: FileUploadResultOptionsDto;
}
/**
 * Deprecated: Use FileUploadResultOptionsDto instead.
 * @export
 * @interface UploadFilesResponseOptionsDto
 */
export interface UploadFilesResponseOptionsDto {
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof UploadFilesResponseOptionsDto
     */
    'fileUrlLifetime'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof UploadFilesResponseOptionsDto
     */
    'fileUrlExpiresAt'?: string | null;
}
/**
 * Deprecated: Use FileUploadManyResultDto instead.
 * @export
 * @interface UploadFilesResultDto
 */
export interface UploadFilesResultDto {
    /**
     * 
     * @type {Array<FileDto>}
     * @memberof UploadFilesResultDto
     */
    'files': Array<FileDto>;
}
/**
 * Deprecated: Use FileUploadedDto instead.
 * @export
 * @interface UploadedFileDto
 */
export interface UploadedFileDto {
    /**
     * File id.
     * @type {string}
     * @memberof UploadedFileDto
     */
    'id'?: string;
    /**
     * Auto-computed helper prop for front-end/client.
     * @type {boolean}
     * @memberof UploadedFileDto
     */
    'isUploadedFile'?: boolean;
}
/**
 * 
 * @export
 * @interface UserActivateDto
 */
export interface UserActivateDto {
    /**
     * 
     * @type {string}
     * @memberof UserActivateDto
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface UserAssistantInfoDto
 */
export interface UserAssistantInfoDto {
    /**
     * 
     * @type {string}
     * @memberof UserAssistantInfoDto
     */
    'threadId'?: string;
}
/**
 * 
 * @export
 * @interface UserChangedDto
 */
export interface UserChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof UserChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof UserChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof UserChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {UserDto}
     * @memberof UserChangedDto
     */
    'entity': UserDto;
    /**
     * 
     * @type {string}
     * @memberof UserChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface UserDepartmentDto
 */
export interface UserDepartmentDto {
    /**
     * 
     * @type {string}
     * @memberof UserDepartmentDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDepartmentDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof UserDto
     */
    'formType'?: EntityFormType;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof UserDto
     */
    'status'?: UserStatus;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof UserDto
     */
    'personName'?: GeneralPersonNameDto;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {UserSettingsDto}
     * @memberof UserDto
     */
    'settings'?: UserSettingsDto;
    /**
     * 
     * @type {Array<UserDepartmentDto>}
     * @memberof UserDto
     */
    'departments'?: Array<UserDepartmentDto>;
    /**
     * 
     * @type {GeneralAvatarDto}
     * @memberof UserDto
     */
    'avatar'?: GeneralAvatarDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDto
     */
    'roleIds'?: Array<string>;
    /**
     * 
     * @type {Array<UserRoleDto>}
     * @memberof UserDto
     */
    'roles'?: Array<UserRoleDto>;
    /**
     * 
     * @type {UserSuspensionInfoDto}
     * @memberof UserDto
     */
    'suspension'?: UserSuspensionInfoDto;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'isPersonalInfoComplete'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'isCustomerUser'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'customerContactId'?: string | null;
}


/**
 * 
 * @export
 * @interface UserGetPaginatedDto
 */
export interface UserGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof UserGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof UserGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof UserGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof UserGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof UserGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGetPaginatedDto
     */
    'isCustomer'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserGetPaginatedDto
     */
    'customerId'?: string | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof UserGetPaginatedDto
     */
    'status'?: UserStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserGetPaginatedDto
     */
    'allRoleIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserGetPaginatedDto
     */
    'anyRoleIds'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface UserIdentityRoleDto
 */
export interface UserIdentityRoleDto {
    /**
     * 
     * @type {string}
     * @memberof UserIdentityRoleDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserIdentityRoleDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserIdentityRoleDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {Array<AppPermission>}
     * @memberof UserIdentityRoleDto
     */
    'permissions'?: Array<AppPermission>;
}
/**
 * 
 * @export
 * @interface UserIdentityTestDto
 */
export interface UserIdentityTestDto {
    /**
     * 
     * @type {VersionDto}
     * @memberof UserIdentityTestDto
     */
    'version'?: VersionDto;
    /**
     * 
     * @type {string}
     * @memberof UserIdentityTestDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserIdentityTestDto
     */
    'auth0UserId'?: string;
    /**
     * Current tenant.
     * @type {string}
     * @memberof UserIdentityTestDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserIdentityTestDto
     */
    'email'?: string;
    /**
     * 
     * @type {UserStatus}
     * @memberof UserIdentityTestDto
     */
    'status'?: UserStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserIdentityTestDto
     */
    'tenantIds'?: Array<string>;
    /**
     * 
     * @type {Array<UserIdentityRoleDto>}
     * @memberof UserIdentityTestDto
     */
    'roles'?: Array<UserIdentityRoleDto>;
    /**
     * 
     * @type {Array<AppModule>}
     * @memberof UserIdentityTestDto
     */
    'modules'?: Array<AppModule>;
    /**
     * 
     * @type {Array<AppPermission>}
     * @memberof UserIdentityTestDto
     */
    'permissions'?: Array<AppPermission>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof UserIdentityTestDto
     */
    'createdAt'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const UserMembershipType = {
    None: 'None',
    Account: 'Account',
    NoAccount: 'NoAccount',
    Anonymous: 'Anonymous'
} as const;

export type UserMembershipType = typeof UserMembershipType[keyof typeof UserMembershipType];


/**
 * 
 * @export
 * @interface UserPartiesMembershipDto
 */
export interface UserPartiesMembershipDto {
    /**
     * 
     * @type {string}
     * @memberof UserPartiesMembershipDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPartiesMembershipDto
     */
    'userId'?: string;
    /**
     * 
     * @type {Array<PartyAndMemberDto>}
     * @memberof UserPartiesMembershipDto
     */
    'membership'?: Array<PartyAndMemberDto>;
    /**
     * 
     * @type {Array<PartyEntity>}
     * @memberof UserPartiesMembershipDto
     */
    'parties'?: Array<PartyEntity>;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof UserPartiesMembershipDto
     */
    'membershipByPartyMap'?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface UserReferenceDto
 */
export interface UserReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof UserReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReferenceDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReferenceDto
     */
    'email'?: string;
    /**
     * 
     * @type {GeneralPersonNameDto}
     * @memberof UserReferenceDto
     */
    'personName'?: GeneralPersonNameDto;
}
/**
 * 
 * @export
 * @interface UserRoleDto
 */
export interface UserRoleDto {
    /**
     * 
     * @type {RoleReferenceDto}
     * @memberof UserRoleDto
     */
    'role'?: RoleReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof UserRoleDto
     */
    'assignedBy'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof UserRoleDto
     */
    'assignedAt'?: string;
}
/**
 * 
 * @export
 * @interface UserSecretDto
 */
export interface UserSecretDto {
    /**
     * 
     * @type {string}
     * @memberof UserSecretDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSecretDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSecretDto
     */
    'hash'?: string;
    /**
     * 
     * @type {HashAlgorithmType}
     * @memberof UserSecretDto
     */
    'hashAlgorithmType'?: HashAlgorithmType;
}


/**
 * 
 * @export
 * @interface UserSecretInputDto
 */
export interface UserSecretInputDto {
    /**
     * 
     * @type {string}
     * @memberof UserSecretInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSecretInputDto
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface UserSecretReferenceDto
 */
export interface UserSecretReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof UserSecretReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSecretReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSecretReferenceDto
     */
    'hash'?: string;
}
/**
 * 
 * @export
 * @interface UserSecretValueDto
 */
export interface UserSecretValueDto {
    /**
     * 
     * @type {UserSecretDto}
     * @memberof UserSecretValueDto
     */
    'key'?: UserSecretDto;
    /**
     * 
     * @type {string}
     * @memberof UserSecretValueDto
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface UserSettingsDto
 */
export interface UserSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof UserSettingsDto
     */
    'tzId'?: string;
    /**
     * 
     * @type {GeneralCultureDto}
     * @memberof UserSettingsDto
     */
    'culture'?: GeneralCultureDto;
}
/**
 * 
 * @export
 * @interface UserSettingsInputDto
 */
export interface UserSettingsInputDto {
    /**
     * 
     * @type {string}
     * @memberof UserSettingsInputDto
     */
    'tzId'?: string | null;
    /**
     * 
     * @type {GeneralCultureInputDto}
     * @memberof UserSettingsInputDto
     */
    'culture'?: GeneralCultureInputDto;
}
/**
 * 
 * @export
 * @interface UserStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
 */
export interface UserStatsDtoInWidgetDataOfTenantStatsTabularAdminDto {
    /**
     * 
     * @type {number}
     * @memberof UserStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'tenantUserCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatsDtoInWidgetDataOfTenantStatsTabularAdminDto
     */
    'customerUserCount'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UserStatus = {
    None: 'None',
    InviteIncomplete: 'InviteIncomplete',
    InfoIncomplete: 'InfoIncomplete',
    Active: 'Active',
    Suspended: 'Suspended'
} as const;

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];


/**
 * 
 * @export
 * @interface UserSuspendDto
 */
export interface UserSuspendDto {
    /**
     * 
     * @type {string}
     * @memberof UserSuspendDto
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface UserSuspensionInfoDto
 */
export interface UserSuspensionInfoDto {
    /**
     * 
     * @type {UserStatus}
     * @memberof UserSuspensionInfoDto
     */
    'statusBeforeSuspension'?: UserStatus;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof UserSuspensionInfoDto
     */
    'suspendedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof UserSuspensionInfoDto
     */
    'unsuspendedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSuspensionInfoDto
     */
    'suspendedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSuspensionInfoDto
     */
    'unsuspendedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSuspensionInfoDto
     */
    'suspendReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSuspensionInfoDto
     */
    'unsuspendReason'?: string | null;
}


/**
 * 
 * @export
 * @interface UserTaggedInEntityInAppDataDto
 */
export interface UserTaggedInEntityInAppDataDto {
    /**
     * 
     * @type {InAppNotificationType}
     * @memberof UserTaggedInEntityInAppDataDto
     */
    'type'?: InAppNotificationType;
    /**
     * 
     * @type {EntityType}
     * @memberof UserTaggedInEntityInAppDataDto
     */
    'ctaEntityType'?: EntityType;
    /**
     * Entity ID for Call To Action (CTA).
     * @type {string}
     * @memberof UserTaggedInEntityInAppDataDto
     */
    'ctaEntityId'?: string | null;
    /**
     * 
     * @type {EntityType}
     * @memberof UserTaggedInEntityInAppDataDto
     */
    'entityType'?: EntityType;
    /**
     * 
     * @type {string}
     * @memberof UserTaggedInEntityInAppDataDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTaggedInEntityInAppDataDto
     */
    'taggedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface UserUnseenInfoDto
 */
export interface UserUnseenInfoDto {
    /**
     * 
     * @type {number}
     * @memberof UserUnseenInfoDto
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface UserUnsuspendDto
 */
export interface UserUnsuspendDto {
    /**
     * 
     * @type {string}
     * @memberof UserUnsuspendDto
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface UserValidateResultDto
 */
export interface UserValidateResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof UserValidateResultDto
     */
    'isValid'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserValidateResultDto
     */
    'attemptsLeft'?: number;
}
/**
 * Indicates whether the entity is currently being used in a primary business activity.
 * @export
 * @enum {string}
 */

export const UtilizationStatus = {
    None: 'None',
    Utilized: 'Utilized',
    Unutilized: 'Unutilized'
} as const;

export type UtilizationStatus = typeof UtilizationStatus[keyof typeof UtilizationStatus];


/**
 * 
 * @export
 * @interface ValidateCompanyIdentifierDto
 */
export interface ValidateCompanyIdentifierDto {
    /**
     * 
     * @type {string}
     * @memberof ValidateCompanyIdentifierDto
     */
    'identifier'?: string;
}
/**
 * 
 * @export
 * @interface ValidateEmailVerificationTokenDto
 */
export interface ValidateEmailVerificationTokenDto {
    /**
     * 
     * @type {string}
     * @memberof ValidateEmailVerificationTokenDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateEmailVerificationTokenDto
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface ValidatePasswordDto
 */
export interface ValidatePasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ValidatePasswordDto
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface ValidationProblemDetails
 */
export interface ValidationProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ValidationProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ValidationProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationProblemDetails
     */
    'instance'?: string | null;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ValidationProblemDetails
     */
    'errors'?: { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface VehicleAccessoriesDto
 */
export interface VehicleAccessoriesDto {
    /**
     * 
     * @type {Array<AccessoryReferenceDto>}
     * @memberof VehicleAccessoriesDto
     */
    'accessories'?: Array<AccessoryReferenceDto>;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof VehicleAccessoriesDto
     */
    'contract'?: ContractReferenceDto;
}
/**
 * 
 * @export
 * @interface VehicleActualStateDto
 */
export interface VehicleActualStateDto {
    /**
     * 
     * @type {VehicleDto}
     * @memberof VehicleActualStateDto
     */
    'vehicle'?: VehicleDto;
    /**
     * 
     * @type {Array<VehicleDamageDto>}
     * @memberof VehicleActualStateDto
     */
    'damages'?: Array<VehicleDamageDto>;
}
/**
 * 
 * @export
 * @interface VehicleAllocatedEventDataDto
 */
export interface VehicleAllocatedEventDataDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleAllocatedEventDataDto
     */
    'vehicleId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleAllocatedEventDataDto
     */
    'contractId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleAllocatedEventDataDto
     */
    'customerId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleAllocatedEventDataDto
     */
    'assetSubscriptionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleAllocatedEventDataDto
     */
    'assetId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleAllocatedEventDataDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleAllocatedEventDataDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleAllocatedEventDataDto
     */
    'spotId'?: string | null;
}
/**
 * Describes basic vehicle areas.
 * @export
 * @enum {string}
 */

export const VehicleArea = {
    None: 'None',
    Exterior: 'Exterior',
    Interior: 'Interior',
    Internal: 'Internal'
} as const;

export type VehicleArea = typeof VehicleArea[keyof typeof VehicleArea];


/**
 * 
 * @export
 * @interface VehicleAvailabilityDto
 */
export interface VehicleAvailabilityDto {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleAvailabilityDto
     */
    'isAvailable'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleAvailabilityDto
     */
    'occupiedByContractIds'?: Array<string> | null;
}
/**
 * Query vehicle availability base on contract date range.
 * @export
 * @interface VehicleAvailabilityQueryDto
 */
export interface VehicleAvailabilityQueryDto {
    /**
     * 
     * @type {DateRangeRequiredInputDto}
     * @memberof VehicleAvailabilityQueryDto
     */
    'range'?: DateRangeRequiredInputDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleBatteryHealthRating = {
    None: 'None',
    Excellent: 'Excellent',
    Good: 'Good',
    Fair: 'Fair',
    Poor: 'Poor'
} as const;

export type VehicleBatteryHealthRating = typeof VehicleBatteryHealthRating[keyof typeof VehicleBatteryHealthRating];


/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleBatteryHealthStatus = {
    None: 'None',
    Normal: 'Normal',
    NeedsService: 'NeedsService',
    NeedsReplacement: 'NeedsReplacement'
} as const;

export type VehicleBatteryHealthStatus = typeof VehicleBatteryHealthStatus[keyof typeof VehicleBatteryHealthStatus];


/**
 * 
 * @export
 * @interface VehicleBatteryStateDto
 */
export interface VehicleBatteryStateDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleBatteryStateDto
     */
    'currentCapacityPct'?: number | null;
    /**
     * 
     * @type {VehicleBatteryHealthStatus}
     * @memberof VehicleBatteryStateDto
     */
    'healthStatus'?: VehicleBatteryHealthStatus;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleBatteryStateDto
     */
    'lastServiceAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleBatteryStateDto
     */
    'lastReplacementAt'?: string | null;
    /**
     * 
     * @type {VehicleBatteryHealthRating}
     * @memberof VehicleBatteryStateDto
     */
    'healthRating'?: VehicleBatteryHealthRating;
}


/**
 * 
 * @export
 * @interface VehicleBatteryStateInputDto
 */
export interface VehicleBatteryStateInputDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleBatteryStateInputDto
     */
    'currentCapacityPct'?: number | null;
    /**
     * 
     * @type {VehicleBatteryHealthStatus}
     * @memberof VehicleBatteryStateInputDto
     */
    'healthStatus'?: VehicleBatteryHealthStatus;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleBatteryStateInputDto
     */
    'lastServiceAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleBatteryStateInputDto
     */
    'lastReplacementAt'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleBodyType = {
    None: 'None',
    Sedan: 'Sedan',
    Hatchback: 'Hatchback',
    Wagon: 'Wagon',
    Van: 'Van',
    Minivan: 'Minivan',
    Cuv: 'CUV',
    Suv: 'SUV',
    Coupe: 'Coupe',
    Convertible: 'Convertible',
    Roadster: 'Roadster',
    Pickup: 'Pickup',
    ChassisCab: 'ChassisCab',
    PlatformCab: 'PlatformCab',
    PassengerVan: 'PassengerVan',
    DoubleChassisCab: 'DoubleChassisCab',
    DoubleCabPickUp: 'DoubleCabPickUp',
    Microcar: 'Microcar',
    MiniMpv: 'MiniMPV',
    Targa: 'Targa',
    Other: 'Other',
    PlatforbCab: 'PlatforbCab'
} as const;

export type VehicleBodyType = typeof VehicleBodyType[keyof typeof VehicleBodyType];


/**
 * 
 * @export
 * @interface VehicleBodyTypeChangedDto
 */
export interface VehicleBodyTypeChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleBodyTypeChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypeChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof VehicleBodyTypeChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof VehicleBodyTypeChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypeChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {VehicleBodyTypeDto}
     * @memberof VehicleBodyTypeChangedDto
     */
    'entity': VehicleBodyTypeDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypeChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface VehicleBodyTypeDto
 */
export interface VehicleBodyTypeDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypeDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleBodyTypeDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof VehicleBodyTypeDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleBodyTypeDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleBodyTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleBodyTypeDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface VehicleBodyTypeGetPaginatedDto
 */
export interface VehicleBodyTypeGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleBodyTypeGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleBodyTypeGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypeGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleBodyTypeGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleBodyTypeGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleBodyTypeGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof VehicleBodyTypeGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof VehicleBodyTypeGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof VehicleBodyTypeGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleBodyTypeGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypeGetPaginatedDto
     */
    'vehicleTypeId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleBodyTypeGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface VehicleBodyTypeReferenceDto
 */
export interface VehicleBodyTypeReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypeReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleBodyTypeReferenceDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof VehicleBodyTypeReferenceDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypeReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleBodyTypeReferenceDto
     */
    'isBuiltIn'?: boolean;
}


/**
 * 
 * @export
 * @interface VehicleChangedDto
 */
export interface VehicleChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof VehicleChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof VehicleChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof VehicleChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {VehicleDto}
     * @memberof VehicleChangedDto
     */
    'entity': VehicleDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface VehicleCheckedInEventDataDto
 */
export interface VehicleCheckedInEventDataDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleCheckedInEventDataDto
     */
    'vehicleId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleCheckedInEventDataDto
     */
    'contractId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleCheckedInEventDataDto
     */
    'customerId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleCheckedInEventDataDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleCheckedInEventDataDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleCheckedInEventDataDto
     */
    'spotId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleCheckedInEventDataDto
     */
    'mileage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleCheckedInEventDataDto
     */
    'totalMileage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleCheckedInEventDataDto
     */
    'fuelLevel'?: number | null;
}
/**
 * 
 * @export
 * @interface VehicleCheckedOutEventDataDto
 */
export interface VehicleCheckedOutEventDataDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleCheckedOutEventDataDto
     */
    'vehicleId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleCheckedOutEventDataDto
     */
    'contractId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleCheckedOutEventDataDto
     */
    'customerId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleCheckedOutEventDataDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleCheckedOutEventDataDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleCheckedOutEventDataDto
     */
    'spotId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleCheckedOutEventDataDto
     */
    'mileage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleCheckedOutEventDataDto
     */
    'fuelLevel'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleCleanlinessExtent = {
    None: 'None',
    Spotless: 'Spotless',
    VeryClean: 'VeryClean',
    Clean: 'Clean',
    SlightlyDirty: 'SlightlyDirty',
    ModerateDirty: 'ModerateDirty',
    VeryDirty: 'VeryDirty',
    ExtremelyDirty: 'ExtremelyDirty'
} as const;

export type VehicleCleanlinessExtent = typeof VehicleCleanlinessExtent[keyof typeof VehicleCleanlinessExtent];


/**
 * 
 * @export
 * @interface VehicleCreateManySimilarDto
 */
export interface VehicleCreateManySimilarDto {
    /**
     * 
     * @type {Array<VehicleCreateManySimilarVehicleDto>}
     * @memberof VehicleCreateManySimilarDto
     */
    'vehicles'?: Array<VehicleCreateManySimilarVehicleDto>;
    /**
     * 
     * @type {VehicleCreateManySimilarSharedDataDto}
     * @memberof VehicleCreateManySimilarDto
     */
    'shared'?: VehicleCreateManySimilarSharedDataDto;
    /**
     * 
     * @type {Array<CreateVehicleDto>}
     * @memberof VehicleCreateManySimilarDto
     */
    'createDtos'?: Array<CreateVehicleDto>;
}
/**
 * 
 * @export
 * @interface VehicleCreateManySimilarSharedDataDto
 */
export interface VehicleCreateManySimilarSharedDataDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleCreateManySimilarSharedDataDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleCreateManySimilarSharedDataDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {VehicleSpecInputDto}
     * @memberof VehicleCreateManySimilarSharedDataDto
     */
    'spec'?: VehicleSpecInputDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleCreateManySimilarSharedDataDto
     */
    'accessoryIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof VehicleCreateManySimilarSharedDataDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleCreateManySimilarSharedDataDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleCreateManySimilarSharedDataDto
     */
    'defaultVisualModelId'?: string | null;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof VehicleCreateManySimilarSharedDataDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
    /**
     * 
     * @type {GeneralStatusInputTypedDtoOfVehicleStatus}
     * @memberof VehicleCreateManySimilarSharedDataDto
     */
    'status'?: GeneralStatusInputTypedDtoOfVehicleStatus;
}
/**
 * 
 * @export
 * @interface VehicleCreateManySimilarVehicleDto
 */
export interface VehicleCreateManySimilarVehicleDto {
    /**
     * 
     * @type {GeneralPlateNoInputDto}
     * @memberof VehicleCreateManySimilarVehicleDto
     */
    'plateNo'?: GeneralPlateNoInputDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleCreateManySimilarVehicleDto
     */
    'identificationNumber'?: string | null;
    /**
     * 
     * @type {VehicleMileageInputDto}
     * @memberof VehicleCreateManySimilarVehicleDto
     */
    'mileage'?: VehicleMileageInputDto;
}
/**
 * 
 * @export
 * @interface VehicleDamageChangedDto
 */
export interface VehicleDamageChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleDamageChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof VehicleDamageChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof VehicleDamageChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {VehicleDamageDto}
     * @memberof VehicleDamageChangedDto
     */
    'entity': VehicleDamageDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface VehicleDamageCorrectionDto
 */
export interface VehicleDamageCorrectionDto {
    /**
     * 
     * @type {DamageCorrectionType}
     * @memberof VehicleDamageCorrectionDto
     */
    'type'?: DamageCorrectionType;
    /**
     * 
     * @type {DamageCorrectionRole}
     * @memberof VehicleDamageCorrectionDto
     */
    'role'?: DamageCorrectionRole;
    /**
     * Original damages before correction, resulted in this damage after the correction.    Set for source corrections and target role, otherwise null.
     * @type {Array<string>}
     * @memberof VehicleDamageCorrectionDto
     */
    'sourceDamageIds'?: Array<string> | null;
    /**
     * Result damages after correction, created from this damage.    Set for target corrections and source role, otherwise null.
     * @type {Array<string>}
     * @memberof VehicleDamageCorrectionDto
     */
    'targetDamageIds'?: Array<string> | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDamageCorrectionDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageCorrectionDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleDamageCorrectionDto
     */
    'damageIds'?: Array<string>;
}


/**
 * 
 * @export
 * @interface VehicleDamageCountersDto
 */
export interface VehicleDamageCountersDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleDamageCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {VehicleDamageCountersDtoCountByStateMap}
     * @memberof VehicleDamageCountersDto
     */
    'countByStateMap': VehicleDamageCountersDtoCountByStateMap;
    /**
     * 
     * @type {VehicleDamageCountersDtoCountByAreaMap}
     * @memberof VehicleDamageCountersDto
     */
    'countByAreaMap': VehicleDamageCountersDtoCountByAreaMap;
}
/**
 * 
 * @export
 * @interface VehicleDamageCountersDtoCountByAreaMap
 */
export interface VehicleDamageCountersDtoCountByAreaMap {
    /**
     * 
     * @type {number}
     * @memberof VehicleDamageCountersDtoCountByAreaMap
     */
    'None'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDamageCountersDtoCountByAreaMap
     */
    'Exterior'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDamageCountersDtoCountByAreaMap
     */
    'Interior'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDamageCountersDtoCountByAreaMap
     */
    'Internal'?: number;
}
/**
 * 
 * @export
 * @interface VehicleDamageCountersDtoCountByStateMap
 */
export interface VehicleDamageCountersDtoCountByStateMap {
    /**
     * 
     * @type {number}
     * @memberof VehicleDamageCountersDtoCountByStateMap
     */
    'None'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDamageCountersDtoCountByStateMap
     */
    'Actual'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDamageCountersDtoCountByStateMap
     */
    'Repaired'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDamageCountersDtoCountByStateMap
     */
    'Inactive'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDamageCountersDtoCountByStateMap
     */
    'Fixed'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDamageCountersDtoCountByStateMap
     */
    'Superseded'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDamageCountersDtoCountByStateMap
     */
    'Replaced'?: number;
}
/**
 * 
 * @export
 * @interface VehicleDamageDataDto
 */
export interface VehicleDamageDataDto {
    /**
     * 
     * @type {EntityDataOriginMode}
     * @memberof VehicleDamageDataDto
     */
    'dataOriginMode'?: EntityDataOriginMode;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.Id\" />/>
     * @type {string}
     * @memberof VehicleDamageDataDto
     */
    'id'?: string | null;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.OriginalId\" />/>
     * @type {string}
     * @memberof VehicleDamageDataDto
     */
    'originalId'?: string | null;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.OriginalIds\" />/>
     * @type {Array<string>}
     * @memberof VehicleDamageDataDto
     */
    'originalIds'?: Array<string> | null;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.OriginalTenantId\" />/>
     * @type {string}
     * @memberof VehicleDamageDataDto
     */
    'originalTenantId'?: string | null;
    /**
     * 
     * @type {EntityFormType}
     * @memberof VehicleDamageDataDto
     */
    'formType'?: EntityFormType;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.OriginalIdsAll\" />/>
     * @type {Array<string>}
     * @memberof VehicleDamageDataDto
     */
    'originalIdsAll'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDataDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDataDto
     */
    'globalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDataDto
     */
    'localNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDataDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDataDto
     */
    'visualModelId'?: string;
    /**
     * 
     * @type {VehicleDamageState}
     * @memberof VehicleDamageDataDto
     */
    'state'?: VehicleDamageState;
    /**
     * 
     * @type {DamageCorrectionStatus}
     * @memberof VehicleDamageDataDto
     */
    'correctionStatus'?: DamageCorrectionStatus;
    /**
     * 
     * @type {FrontEndAppType}
     * @memberof VehicleDamageDataDto
     */
    'appType'?: FrontEndAppType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDamageDataDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorDto}
     * @memberof VehicleDamageDataDto
     */
    'inspector'?: GeneralInspectorDto;
    /**
     * 
     * @type {VehiclePartTypeReferenceDto}
     * @memberof VehicleDamageDataDto
     */
    'partType'?: VehiclePartTypeReferenceDto;
    /**
     * 
     * @type {DamageTypeReferenceDto}
     * @memberof VehicleDamageDataDto
     */
    'damageType'?: DamageTypeReferenceDto;
    /**
     * 
     * @type {VehicleArea}
     * @memberof VehicleDamageDataDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof VehicleDamageDataDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {GeneralSvgPointDto}
     * @memberof VehicleDamageDataDto
     */
    'point'?: GeneralSvgPointDto;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof VehicleDamageDataDto
     */
    'attachments'?: Array<GeneralAttachmentDto> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDataDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {DamageCorrectionStatus}
     * @memberof VehicleDamageDataDto
     */
    'dataCorrectionStatusComputed'?: DamageCorrectionStatus;
}


/**
 * 
 * @export
 * @interface VehicleDamageDataInputDto
 */
export interface VehicleDamageDataInputDto {
    /**
     * 
     * @type {EntityDataOriginMode}
     * @memberof VehicleDamageDataInputDto
     */
    'dataOriginMode'?: EntityDataOriginMode;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.Id\" />/>
     * @type {string}
     * @memberof VehicleDamageDataInputDto
     */
    'id'?: string | null;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.OriginalId\" />/>
     * @type {string}
     * @memberof VehicleDamageDataInputDto
     */
    'originalId'?: string | null;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.OriginalIds\" />/>
     * @type {Array<string>}
     * @memberof VehicleDamageDataInputDto
     */
    'originalIds'?: Array<string> | null;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Base.BaseEntityData.OriginalTenantId\" />/>
     * @type {string}
     * @memberof VehicleDamageDataInputDto
     */
    'originalTenantId'?: string | null;
    /**
     * 
     * @type {EntityFormType}
     * @memberof VehicleDamageDataInputDto
     */
    'formType'?: EntityFormType;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDataInputDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDataInputDto
     */
    'globalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDataInputDto
     */
    'localNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDataInputDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDataInputDto
     */
    'visualModelId'?: string;
    /**
     * 
     * @type {VehicleDamageState}
     * @memberof VehicleDamageDataInputDto
     */
    'state'?: VehicleDamageState;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDamageDataInputDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDataInputDto
     */
    'partTypeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDataInputDto
     */
    'damageTypeId'?: string;
    /**
     * 
     * @type {VehicleArea}
     * @memberof VehicleDamageDataInputDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof VehicleDamageDataInputDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {GeneralSvgPointDto}
     * @memberof VehicleDamageDataInputDto
     */
    'point'?: GeneralSvgPointDto;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof VehicleDamageDataInputDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDataInputDto
     */
    'notes'?: string | null;
}


/**
 * 
 * @export
 * @interface VehicleDamageDeletedEventDataDto
 */
export interface VehicleDamageDeletedEventDataDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDeletedEventDataDto
     */
    'vehicleId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDeletedEventDataDto
     */
    'vehicleDamageId': string;
}
/**
 * 
 * @export
 * @interface VehicleDamageDetectedEventDataDto
 */
export interface VehicleDamageDetectedEventDataDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDetectedEventDataDto
     */
    'vehicleId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDetectedEventDataDto
     */
    'vehicleDamageId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDetectedEventDataDto
     */
    'damageDetectionId': string | null;
}
/**
 * 
 * @export
 * @interface VehicleDamageDto
 */
export interface VehicleDamageDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof VehicleDamageDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'tenantId'?: string | null;
    /**
     * Original damage from which this damage is derived (e.g., replacement, split, merge (explicit origin) correction).
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'originalId'?: string | null;
    /**
     * Original damages from which this damage is derived  (e.g., merge correction).
     * @type {Array<string>}
     * @memberof VehicleDamageDto
     */
    'originalIds'?: Array<string> | null;
    /**
     * DD of the original damage.
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'originalDamageDetectionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof VehicleDamageDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof VehicleDamageDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {VehicleVisualModelReferenceDto}
     * @memberof VehicleDamageDto
     */
    'visualModel'?: VehicleVisualModelReferenceDto;
    /**
     * 
     * @type {VehicleVisualModelReferenceDto}
     * @memberof VehicleDamageDto
     */
    'oldVisualModel'?: VehicleVisualModelReferenceDto;
    /**
     * 
     * @type {GeneralEntitySourceDto}
     * @memberof VehicleDamageDto
     */
    'source'?: GeneralEntitySourceDto;
    /**
     * 
     * @type {DamageDetectionReferenceDto}
     * @memberof VehicleDamageDto
     */
    'damageDetection'?: DamageDetectionReferenceDto;
    /**
     * 
     * @type {DamageCostEvaluationReferenceDto}
     * @memberof VehicleDamageDto
     */
    'damageCostEvaluation'?: DamageCostEvaluationReferenceDto;
    /**
     * 
     * @type {RepairOperationReferenceDto}
     * @memberof VehicleDamageDto
     */
    'repairOperation'?: RepairOperationReferenceDto;
    /**
     * 
     * @type {VehicleDamageState}
     * @memberof VehicleDamageDto
     */
    'state'?: VehicleDamageState;
    /**
     * 
     * @type {VehicleDamageInactiveReasonType}
     * @memberof VehicleDamageDto
     */
    'inactiveReasonType'?: VehicleDamageInactiveReasonType;
    /**
     * 
     * @type {DamageCorrectionStatus}
     * @memberof VehicleDamageDto
     */
    'correctionStatus'?: DamageCorrectionStatus;
    /**
     * 
     * @type {FrontEndAppType}
     * @memberof VehicleDamageDto
     */
    'appType'?: FrontEndAppType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorDto}
     * @memberof VehicleDamageDto
     */
    'inspector'?: GeneralInspectorDto;
    /**
     * 
     * @type {VehiclePartTypeReferenceDto}
     * @memberof VehicleDamageDto
     */
    'partType'?: VehiclePartTypeReferenceDto;
    /**
     * 
     * @type {DamageTypeReferenceDto}
     * @memberof VehicleDamageDto
     */
    'damageType'?: DamageTypeReferenceDto;
    /**
     * 
     * @type {VehicleArea}
     * @memberof VehicleDamageDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof VehicleDamageDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {GeneralSvgPointDto}
     * @memberof VehicleDamageDto
     */
    'point'?: GeneralSvgPointDto;
    /**
     * 
     * @type {GeneralSvgPointDto}
     * @memberof VehicleDamageDto
     */
    'oldPoint'?: GeneralSvgPointDto;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof VehicleDamageDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'notes'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'repairedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'inactiveAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDamageDto
     */
    'correctedAt'?: string | null;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof VehicleDamageDto
     */
    'repairedBy'?: GeneralByWhoDto;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof VehicleDamageDto
     */
    'inactiveBy'?: GeneralByWhoDto;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof VehicleDamageDto
     */
    'correctedBy'?: GeneralByWhoDto;
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof VehicleDamageDto
     */
    'inactiveIn'?: GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {GeneralStrictEntityRelationDto}
     * @memberof VehicleDamageDto
     */
    'correctedIn'?: GeneralStrictEntityRelationDto;
    /**
     * 
     * @type {VehicleDamageCorrectionDto}
     * @memberof VehicleDamageDto
     */
    'sourceCorrection'?: VehicleDamageCorrectionDto;
    /**
     * 
     * @type {VehicleDamageCorrectionDto}
     * @memberof VehicleDamageDto
     */
    'targetCorrection'?: VehicleDamageCorrectionDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof VehicleDamageDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
    /**
     * 
     * @type {TenantRequestsMetaDto}
     * @memberof VehicleDamageDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleDamageDto
     */
    'originalIdsAll'?: Array<string> | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleDamageExtent = {
    None: 'None',
    NoDamage: 'NoDamage',
    VeryMinor: 'VeryMinor',
    Minor: 'Minor',
    Moderate: 'Moderate',
    Severe: 'Severe',
    VerySevere: 'VerySevere',
    Total: 'Total'
} as const;

export type VehicleDamageExtent = typeof VehicleDamageExtent[keyof typeof VehicleDamageExtent];


/**
 * 
 * @export
 * @interface VehicleDamageFullReferenceDto
 */
export interface VehicleDamageFullReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageFullReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof VehicleDamageFullReferenceDto
     */
    'formType'?: EntityFormType;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageFullReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageFullReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageFullReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageFullReferenceDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageFullReferenceDto
     */
    'visualModelId'?: string;
    /**
     * 
     * @type {VehicleDamageState}
     * @memberof VehicleDamageFullReferenceDto
     */
    'state'?: VehicleDamageState;
    /**
     * 
     * @type {FrontEndAppType}
     * @memberof VehicleDamageFullReferenceDto
     */
    'appType'?: FrontEndAppType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDamageFullReferenceDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorDto}
     * @memberof VehicleDamageFullReferenceDto
     */
    'inspector'?: GeneralInspectorDto;
    /**
     * 
     * @type {VehiclePartTypeReferenceDto}
     * @memberof VehicleDamageFullReferenceDto
     */
    'partType'?: VehiclePartTypeReferenceDto;
    /**
     * 
     * @type {DamageTypeReferenceDto}
     * @memberof VehicleDamageFullReferenceDto
     */
    'damageType'?: DamageTypeReferenceDto;
    /**
     * 
     * @type {VehicleArea}
     * @memberof VehicleDamageFullReferenceDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof VehicleDamageFullReferenceDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {GeneralSvgPointDto}
     * @memberof VehicleDamageFullReferenceDto
     */
    'point'?: GeneralSvgPointDto;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof VehicleDamageFullReferenceDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageFullReferenceDto
     */
    'notes'?: string | null;
}


/**
 * 
 * @export
 * @interface VehicleDamageGetCountersDto
 */
export interface VehicleDamageGetCountersDto {
    /**
     * 
     * @type {DateRangeInputDto}
     * @memberof VehicleDamageGetCountersDto
     */
    'range'?: DateRangeInputDto;
}
/**
 * 
 * @export
 * @interface VehicleDamageGetPaginatedDto
 */
export interface VehicleDamageGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * This param is ignored if vehicle id is specified in endpoint URI.
     * @type {string}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'partTypeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'damageTypeId'?: string | null;
    /**
     * 
     * @type {VehicleDamageState}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'state'?: VehicleDamageState;
    /**
     * 
     * @type {Array<VehicleDamageState>}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'states'?: Array<VehicleDamageState> | null;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfVehicleDamageState}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'stateV2'?: FieldFilterOfPrimitiveDtoOfNullableOfVehicleDamageState;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDamageCorrectionStatus}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'correctionStatus'?: FieldFilterOfPrimitiveDtoOfNullableOfDamageCorrectionStatus;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfVehicleArea}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'area'?: FieldFilterOfPrimitiveDtoOfNullableOfVehicleArea;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfVehicleProjection}
     * @memberof VehicleDamageGetPaginatedDto
     */
    'projection'?: FieldFilterOfPrimitiveDtoOfNullableOfVehicleProjection;
}


/**
 * Defines reason types for Inactive state.
 * @export
 * @enum {string}
 */

export const VehicleDamageInactiveReasonType = {
    None: 'None',
    Unknown: 'Unknown',
    Corrected: 'Corrected'
} as const;

export type VehicleDamageInactiveReasonType = typeof VehicleDamageInactiveReasonType[keyof typeof VehicleDamageInactiveReasonType];


/**
 * 
 * @export
 * @interface VehicleDamageInsightDto
 */
export interface VehicleDamageInsightDto {
    /**
     * 
     * @type {DamageTypeCategory}
     * @memberof VehicleDamageInsightDto
     */
    'damageType'?: DamageTypeCategory;
    /**
     * 
     * @type {VehiclePartCategory}
     * @memberof VehicleDamageInsightDto
     */
    'partCategory'?: VehiclePartCategory;
    /**
     * 
     * @type {VehiclePartType}
     * @memberof VehicleDamageInsightDto
     */
    'partType'?: VehiclePartType;
}


/**
 * 
 * @export
 * @interface VehicleDamageMigrateToNewVisualModelDto
 */
export interface VehicleDamageMigrateToNewVisualModelDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageMigrateToNewVisualModelDto
     */
    'oldVehicleVisualModelId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageMigrateToNewVisualModelDto
     */
    'newVehicleVisualModelId'?: string;
    /**
     * 
     * @type {GeneralSvgPointDto}
     * @memberof VehicleDamageMigrateToNewVisualModelDto
     */
    'oldPoint'?: GeneralSvgPointDto;
    /**
     * 
     * @type {GeneralSvgPointDto}
     * @memberof VehicleDamageMigrateToNewVisualModelDto
     */
    'newPoint'?: GeneralSvgPointDto;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDamageMigrateToNewVisualModelDto
     */
    'isMigrateDamageDetection'?: boolean;
}
/**
 * 
 * @export
 * @interface VehicleDamageReferenceDto
 */
export interface VehicleDamageReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof VehicleDamageReferenceDto
     */
    'formType'?: EntityFormType;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageReferenceDto
     */
    'vehicleId'?: string;
}


/**
 * 
 * @export
 * @interface VehicleDamageRepairedEventDataDto
 */
export interface VehicleDamageRepairedEventDataDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageRepairedEventDataDto
     */
    'vehicleId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageRepairedEventDataDto
     */
    'vehicleDamageId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDamageRepairedEventDataDto
     */
    'repairOperationId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleDamageState = {
    None: 'None',
    Actual: 'Actual',
    Repaired: 'Repaired',
    Inactive: 'Inactive'
} as const;

export type VehicleDamageState = typeof VehicleDamageState[keyof typeof VehicleDamageState];


/**
 * 
 * @export
 * @interface VehicleDataPrefillDto
 */
export interface VehicleDataPrefillDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleDataPrefillDto
     */
    'identificationNumber'?: string | null;
    /**
     * 
     * @type {GeneralPlateNoDto}
     * @memberof VehicleDataPrefillDto
     */
    'plateNo'?: GeneralPlateNoDto;
    /**
     * 
     * @type {VehicleMakeReferenceDto}
     * @memberof VehicleDataPrefillDto
     */
    'make'?: VehicleMakeReferenceDto;
    /**
     * 
     * @type {VehicleModelReferenceDto}
     * @memberof VehicleDataPrefillDto
     */
    'model'?: VehicleModelReferenceDto;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof VehicleDataPrefillDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataPrefillDto
     */
    'vegvesenMakeModelName'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleDrivetrainType = {
    None: 'None',
    Fwd: 'FWD',
    Rwd: 'RWD',
    Awd: 'AWD',
    FourWd: 'FourWD'
} as const;

export type VehicleDrivetrainType = typeof VehicleDrivetrainType[keyof typeof VehicleDrivetrainType];


/**
 * 
 * @export
 * @interface VehicleDto
 */
export interface VehicleDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof VehicleDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'ownerTenantId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {ContractFullReferenceDto}
     * @memberof VehicleDto
     */
    'lastContract'?: ContractFullReferenceDto;
    /**
     * 
     * @type {VehicleSpecDto}
     * @memberof VehicleDto
     */
    'spec'?: VehicleSpecDto;
    /**
     * 
     * @type {Array<AccessoryReferenceDto>}
     * @memberof VehicleDto
     */
    'accessories'?: Array<AccessoryReferenceDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof VehicleDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof VehicleDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {VehicleVisualModelReferenceDto}
     * @memberof VehicleDto
     */
    'defaultVisualModel'?: VehicleVisualModelReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'identificationNumber'?: string | null;
    /**
     * 
     * @type {GeneralPlateNoDto}
     * @memberof VehicleDto
     */
    'plateNo'?: GeneralPlateNoDto;
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof VehicleDto
     */
    'mileage'?: VehicleMileageDto;
    /**
     * 
     * @type {VehicleBatteryStateDto}
     * @memberof VehicleDto
     */
    'batteryState'?: VehicleBatteryStateDto;
    /**
     * 
     * @type {object}
     * @memberof VehicleDto
     */
    'car'?: object;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'totalDamagesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'actualDamagesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'repairedDamagesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'inactiveDamagesCount'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDto
     */
    'lastVisualInspectionAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDto
     */
    'lastDamageDetectionAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDto
     */
    'lastAccessoryCheckAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleDto
     */
    'lastMileageUpdatedAt'?: string | null;
    /**
     * 
     * @type {PoolsMetaDto}
     * @memberof VehicleDto
     */
    'poolsMeta'?: PoolsMetaDto;
    /**
     * 
     * @type {AssetMetaDto}
     * @memberof VehicleDto
     */
    'assetMeta'?: AssetMetaDto;
    /**
     * 
     * @type {ImportMetaDto}
     * @memberof VehicleDto
     */
    'importMeta'?: ImportMetaDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof VehicleDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
    /**
     * 
     * @type {TenantRequestsMetaDto}
     * @memberof VehicleDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof VehicleDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {GeneralStatusMetaTypedDtoOfVehicleStatus}
     * @memberof VehicleDto
     */
    'status'?: GeneralStatusMetaTypedDtoOfVehicleStatus;
    /**
     * 
     * @type {GeneralStatusMetaTypedDtoOfAvailabilityStatus}
     * @memberof VehicleDto
     */
    'availabilityStatus'?: GeneralStatusMetaTypedDtoOfAvailabilityStatus;
    /**
     * 
     * @type {GeneralStatusMetaTypedDtoOfUtilizationStatus}
     * @memberof VehicleDto
     */
    'utilizationStatus'?: GeneralStatusMetaTypedDtoOfUtilizationStatus;
    /**
     * 
     * @type {GeneralStatusMetaTypedDtoOfOperabilityStatus}
     * @memberof VehicleDto
     */
    'operabilityStatus'?: GeneralStatusMetaTypedDtoOfOperabilityStatus;
    /**
     * 
     * @type {GeneralGeolocationDto}
     * @memberof VehicleDto
     */
    'geolocation'?: GeneralGeolocationDto;
    /**
     * 
     * @type {GeneralProductProfileDto}
     * @memberof VehicleDto
     */
    'productProfile'?: GeneralProductProfileDto;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof VehicleDto
     */
    'departmentIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof VehicleDto
     */
    'locationIdsMap'?: { [key: string]: boolean; };
}


/**
 * VehicleExtractedData.
 * @export
 * @interface VehicleExtractedDataDto
 */
export interface VehicleExtractedDataDto {
    /**
     * Auto-generated ID for this extracted data record.    Used for caching, logging, or referencing this specific extraction.
     * @type {string}
     * @memberof VehicleExtractedDataDto
     */
    'extractedDataId'?: string;
    /**
     * 
     * @type {ExtractedDocumentType}
     * @memberof VehicleExtractedDataDto
     */
    'documentType'?: ExtractedDocumentType;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Common.DocumentIntelligence.Base.BaseExtractedData.DocumentConfidence\" />
     * @type {number}
     * @memberof VehicleExtractedDataDto
     */
    'documentConfidence'?: number;
    /**
     * 
     * @type {ExtractedDocumentConfidenceLevel}
     * @memberof VehicleExtractedDataDto
     */
    'documentConfidenceLevel'?: ExtractedDocumentConfidenceLevel;
    /**
     * Entity ID matched using extracted data after extraction in post-processing.
     * @type {string}
     * @memberof VehicleExtractedDataDto
     */
    'matchedId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleExtractedDataDto
     */
    'plateNo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleExtractedDataDto
     */
    'identificationNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleExtractedDataDto
     */
    'mileageKm'?: number | null;
    /**
     * 
     * @type {VehicleMakeModelExtractedDataDto}
     * @memberof VehicleExtractedDataDto
     */
    'makeModel'?: VehicleMakeModelExtractedDataDto;
    /**
     * 
     * @type {VehicleMakeExtractedDataDto}
     * @memberof VehicleExtractedDataDto
     */
    'make'?: VehicleMakeExtractedDataDto;
    /**
     * 
     * @type {VehicleModelExtractedDataDto}
     * @memberof VehicleExtractedDataDto
     */
    'model'?: VehicleModelExtractedDataDto;
}


/**
 * 
 * @export
 * @interface VehicleFuelConsumptionDto
 */
export interface VehicleFuelConsumptionDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleFuelConsumptionDto
     */
    'lPer100Km'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleFuelConsumptionDto
     */
    'lPerKm'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleFuelConsumptionDto
     */
    'lPer10Km'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleFuelConsumptionDto
     */
    'kmPerL'?: number;
    /**
     * 
     * @type {VehicleFuelConsumptionImperial}
     * @memberof VehicleFuelConsumptionDto
     */
    'uk'?: VehicleFuelConsumptionImperial;
    /**
     * 
     * @type {VehicleFuelConsumptionImperial}
     * @memberof VehicleFuelConsumptionDto
     */
    'us'?: VehicleFuelConsumptionImperial;
}
/**
 * For UK and US in imperial units.  NB: UK gallon differs from US gallon.
 * @export
 * @interface VehicleFuelConsumptionImperial
 */
export interface VehicleFuelConsumptionImperial {
    /**
     * 
     * @type {MeasurementSystemType}
     * @memberof VehicleFuelConsumptionImperial
     */
    'type'?: MeasurementSystemType;
    /**
     * Aka MPG (Miles per gallon).
     * @type {number}
     * @memberof VehicleFuelConsumptionImperial
     */
    'miPerGal'?: number;
    /**
     * The opposite of MGP.
     * @type {number}
     * @memberof VehicleFuelConsumptionImperial
     */
    'galPerMi'?: number;
}


/**
 * 
 * @export
 * @interface VehicleFuelConsumptionInputDto
 */
export interface VehicleFuelConsumptionInputDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleFuelConsumptionInputDto
     */
    'lPer100Km'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleFuelType = {
    None: 'None',
    Gasoline: 'Gasoline',
    Diesel: 'Diesel',
    Biodiesel: 'Biodiesel',
    Cng: 'CNG',
    Lpg: 'LPG',
    Alcohol: 'Alcohol',
    Ethanol: 'Ethanol',
    Methanol: 'Methanol',
    E85: 'E85',
    Mhev: 'MHEV',
    Hev: 'HEV',
    Phev: 'PHEV',
    Bev: 'BEV',
    Reev: 'REEV',
    Fcev: 'FCEV',
    Hydrogen: 'Hydrogen',
    Other: 'Other'
} as const;

export type VehicleFuelType = typeof VehicleFuelType[keyof typeof VehicleFuelType];


/**
 * 
 * @export
 * @interface VehicleFuelTypeChangedDto
 */
export interface VehicleFuelTypeChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleFuelTypeChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypeChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof VehicleFuelTypeChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof VehicleFuelTypeChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypeChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {VehicleFuelTypeDto}
     * @memberof VehicleFuelTypeChangedDto
     */
    'entity': VehicleFuelTypeDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypeChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface VehicleFuelTypeDto
 */
export interface VehicleFuelTypeDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypeDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleFuelTypeDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof VehicleFuelTypeDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleFuelTypeDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleFuelTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleFuelTypeDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface VehicleFuelTypeGetPaginatedDto
 */
export interface VehicleFuelTypeGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleFuelTypeGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleFuelTypeGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypeGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleFuelTypeGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleFuelTypeGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleFuelTypeGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof VehicleFuelTypeGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof VehicleFuelTypeGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof VehicleFuelTypeGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleFuelTypeGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypeGetPaginatedDto
     */
    'vehicleTypeId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleFuelTypeGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface VehicleFuelTypeReferenceDto
 */
export interface VehicleFuelTypeReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypeReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleFuelTypeReferenceDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof VehicleFuelTypeReferenceDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypeReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleFuelTypeReferenceDto
     */
    'isBuiltIn'?: boolean;
}


/**
 * 
 * @export
 * @interface VehicleFullReferenceDto
 */
export interface VehicleFullReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleFullReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleFullReferenceDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleFullReferenceDto
     */
    'ownerTenantId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleFullReferenceDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleFullReferenceDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleFullReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleFullReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {ContractFullReferenceDto}
     * @memberof VehicleFullReferenceDto
     */
    'lastContract'?: ContractFullReferenceDto;
    /**
     * 
     * @type {VehicleSpecDto}
     * @memberof VehicleFullReferenceDto
     */
    'spec'?: VehicleSpecDto;
    /**
     * 
     * @type {DepartmentReferenceDto}
     * @memberof VehicleFullReferenceDto
     */
    'department'?: DepartmentReferenceDto;
    /**
     * 
     * @type {LocationReferenceDto}
     * @memberof VehicleFullReferenceDto
     */
    'location'?: LocationReferenceDto;
    /**
     * 
     * @type {Array<AccessoryReferenceDto>}
     * @memberof VehicleFullReferenceDto
     */
    'accessories'?: Array<AccessoryReferenceDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof VehicleFullReferenceDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof VehicleFullReferenceDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {VehicleVisualModelReferenceDto}
     * @memberof VehicleFullReferenceDto
     */
    'defaultVisualModel'?: VehicleVisualModelReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleFullReferenceDto
     */
    'identificationNumber'?: string | null;
    /**
     * 
     * @type {GeneralPlateNoDto}
     * @memberof VehicleFullReferenceDto
     */
    'plateNo'?: GeneralPlateNoDto;
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof VehicleFullReferenceDto
     */
    'mileage'?: VehicleMileageDto;
    /**
     * 
     * @type {number}
     * @memberof VehicleFullReferenceDto
     */
    'manufactureYear'?: number | null;
    /**
     * 
     * @type {object}
     * @memberof VehicleFullReferenceDto
     */
    'car'?: object;
    /**
     * 
     * @type {number}
     * @memberof VehicleFullReferenceDto
     */
    'actualDamagesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleFullReferenceDto
     */
    'repairedDamagesCount'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleFullReferenceDto
     */
    'lastDamageDetectionAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleFullReferenceDto
     */
    'lastAccessoryCheckAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleFullReferenceDto
     */
    'lastMileageUpdatedAt'?: string | null;
    /**
     * 
     * @type {PoolsMetaDto}
     * @memberof VehicleFullReferenceDto
     */
    'poolsMeta'?: PoolsMetaDto;
    /**
     * 
     * @type {AssetMetaDto}
     * @memberof VehicleFullReferenceDto
     */
    'assetMeta'?: AssetMetaDto;
    /**
     * 
     * @type {ImportMetaDto}
     * @memberof VehicleFullReferenceDto
     */
    'importMeta'?: ImportMetaDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof VehicleFullReferenceDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
    /**
     * 
     * @type {TenantRequestsMetaDto}
     * @memberof VehicleFullReferenceDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof VehicleFullReferenceDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {GeneralStatusMetaTypedDtoOfVehicleStatus}
     * @memberof VehicleFullReferenceDto
     */
    'status'?: GeneralStatusMetaTypedDtoOfVehicleStatus;
    /**
     * 
     * @type {GeneralStatusMetaTypedDtoOfAvailabilityStatus}
     * @memberof VehicleFullReferenceDto
     */
    'availabilityStatus'?: GeneralStatusMetaTypedDtoOfAvailabilityStatus;
    /**
     * 
     * @type {GeneralStatusMetaTypedDtoOfUtilizationStatus}
     * @memberof VehicleFullReferenceDto
     */
    'utilizationStatus'?: GeneralStatusMetaTypedDtoOfUtilizationStatus;
    /**
     * 
     * @type {GeneralStatusMetaTypedDtoOfOperabilityStatus}
     * @memberof VehicleFullReferenceDto
     */
    'operabilityStatus'?: GeneralStatusMetaTypedDtoOfOperabilityStatus;
    /**
     * 
     * @type {GeneralGeolocationDto}
     * @memberof VehicleFullReferenceDto
     */
    'geolocation'?: GeneralGeolocationDto;
    /**
     * 
     * @type {GeneralProductProfileDto}
     * @memberof VehicleFullReferenceDto
     */
    'productProfile'?: GeneralProductProfileDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleFullReferenceDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleFullReferenceDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleFullReferenceDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleFullReferenceDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof VehicleFullReferenceDto
     */
    'departmentIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof VehicleFullReferenceDto
     */
    'locationIdsMap'?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleGearboxType = {
    None: 'None',
    Manual: 'Manual',
    Automatic: 'Automatic',
    Amt: 'AMT',
    DualClutch: 'DualClutch',
    TorqueConverter: 'TorqueConverter',
    Cvt: 'CVT'
} as const;

export type VehicleGearboxType = typeof VehicleGearboxType[keyof typeof VehicleGearboxType];


/**
 * 
 * @export
 * @interface VehicleGenerationChangedDto
 */
export interface VehicleGenerationChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleGenerationChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof VehicleGenerationChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof VehicleGenerationChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {VehicleGenerationDto}
     * @memberof VehicleGenerationChangedDto
     */
    'entity': VehicleGenerationDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface VehicleGenerationDto
 */
export interface VehicleGenerationDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleGenerationDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {VehicleMakeReferenceDto}
     * @memberof VehicleGenerationDto
     */
    'make'?: VehicleMakeReferenceDto;
    /**
     * 
     * @type {VehicleModelReferenceDto}
     * @memberof VehicleGenerationDto
     */
    'model'?: VehicleModelReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleGenerationDto
     */
    'startYear'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleGenerationDto
     */
    'endYear'?: number | null;
    /**
     * 
     * @type {VehicleSize}
     * @memberof VehicleGenerationDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof VehicleGenerationDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleGenerationDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleGenerationDto
     */
    'vehicleType'?: VehicleType;
}


/**
 * 
 * @export
 * @interface VehicleGenerationGetPaginatedDto
 */
export interface VehicleGenerationGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'makeId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'makeIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'modelId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'modelIds'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleGenerationGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface VehicleGenerationReferenceDto
 */
export interface VehicleGenerationReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleGenerationReferenceDto
     */
    'isBuiltIn'?: boolean;
}
/**
 * 
 * @export
 * @interface VehicleGetPaginatedDto
 */
export interface VehicleGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof VehicleGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof VehicleGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof VehicleGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof VehicleGetPaginatedDto
     */
    'id'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof VehicleGetPaginatedDto
     */
    'createdAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof VehicleGetPaginatedDto
     */
    'updatedAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof VehicleGetPaginatedDto
     */
    'createdBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof VehicleGetPaginatedDto
     */
    'updatedBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {string}
     * @memberof VehicleGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleGetPaginatedDto
     */
    'makeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleGetPaginatedDto
     */
    'modelId'?: string | null;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleGetPaginatedDto
     */
    'type'?: VehicleType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof VehicleGetPaginatedDto
     */
    'types'?: Array<VehicleType> | null;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof VehicleGetPaginatedDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof VehicleGetPaginatedDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {OptionalClosedIntervalDtoOfDouble}
     * @memberof VehicleGetPaginatedDto
     */
    'mileageRange'?: OptionalClosedIntervalDtoOfDouble;
    /**
     * 
     * @type {number}
     * @memberof VehicleGetPaginatedDto
     */
    'manufactureYear'?: number | null;
    /**
     * 
     * @type {OptionalClosedIntervalDtoOfInt32}
     * @memberof VehicleGetPaginatedDto
     */
    'manufactureYearRange'?: OptionalClosedIntervalDtoOfInt32;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleGetPaginatedDto
     */
    'isPreparedForCheckOut'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleGetPaginatedDto
     */
    'isPreparedForCheckIn'?: boolean | null;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfVehicleStatus}
     * @memberof VehicleGetPaginatedDto
     */
    'status'?: FieldFilterOfPrimitiveDtoOfNullableOfVehicleStatus;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfAvailabilityStatus}
     * @memberof VehicleGetPaginatedDto
     */
    'availabilityStatus'?: FieldFilterOfPrimitiveDtoOfNullableOfAvailabilityStatus;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfUtilizationStatus}
     * @memberof VehicleGetPaginatedDto
     */
    'utilizationStatus'?: FieldFilterOfPrimitiveDtoOfNullableOfUtilizationStatus;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfOperabilityStatus}
     * @memberof VehicleGetPaginatedDto
     */
    'operabilityStatus'?: FieldFilterOfPrimitiveDtoOfNullableOfOperabilityStatus;
    /**
     * 
     * @type {GeneralGeolocationQueryDto}
     * @memberof VehicleGetPaginatedDto
     */
    'geolocation'?: GeneralGeolocationQueryDto;
    /**
     * 
     * @type {GeneralProductProfileQueryDto}
     * @memberof VehicleGetPaginatedDto
     */
    'productProfile'?: GeneralProductProfileQueryDto;
    /**
     * 
     * @type {PoolsMetaQueryDto}
     * @memberof VehicleGetPaginatedDto
     */
    'poolsMeta'?: PoolsMetaQueryDto;
    /**
     * 
     * @type {AssetMetaQueryDto}
     * @memberof VehicleGetPaginatedDto
     */
    'assetMeta'?: AssetMetaQueryDto;
    /**
     * 
     * @type {TenantRequestsMetaQueryDto}
     * @memberof VehicleGetPaginatedDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof VehicleGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
    /**
     * 
     * @type {VehicleAvailabilityQueryDto}
     * @memberof VehicleGetPaginatedDto
     */
    'availability'?: VehicleAvailabilityQueryDto;
}


/**
 * 
 * @export
 * @interface VehicleHistoryGetPaginatedDto
 */
export interface VehicleHistoryGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleHistoryGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleHistoryGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleHistoryGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleHistoryGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleHistoryGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleHistoryGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof VehicleHistoryGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof VehicleHistoryGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof VehicleHistoryGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {Array<VehicleHistoryItemType>}
     * @memberof VehicleHistoryGetPaginatedDto
     */
    'types'?: Array<VehicleHistoryItemType> | null;
}
/**
 * 
 * @export
 * @interface VehicleHistoryItemChangedDto
 */
export interface VehicleHistoryItemChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleHistoryItemChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleHistoryItemChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof VehicleHistoryItemChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof VehicleHistoryItemChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof VehicleHistoryItemChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {VehicleHistoryItemDto}
     * @memberof VehicleHistoryItemChangedDto
     */
    'entity': VehicleHistoryItemDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleHistoryItemChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface VehicleHistoryItemDto
 */
export interface VehicleHistoryItemDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleHistoryItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleHistoryItemDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleHistoryItemDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof VehicleHistoryItemDto
     */
    'who'?: GeneralByWhoDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleHistoryItemDto
     */
    'date'?: string;
    /**
     * 
     * @type {VehicleHistoryItemType}
     * @memberof VehicleHistoryItemDto
     */
    'type'?: VehicleHistoryItemType;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof VehicleHistoryItemDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {MileageChangedDataDto}
     * @memberof VehicleHistoryItemDto
     */
    'mileageChanged'?: MileageChangedDataDto;
    /**
     * 
     * @type {DamageDetectedDataDto}
     * @memberof VehicleHistoryItemDto
     */
    'damageDetected'?: DamageDetectedDataDto;
    /**
     * 
     * @type {DamageRepairedDataDto}
     * @memberof VehicleHistoryItemDto
     */
    'damageRepaired'?: DamageRepairedDataDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof VehicleHistoryItemDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
}


/**
 * 
 * @export
 * @interface VehicleHistoryItemReferenceDto
 */
export interface VehicleHistoryItemReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleHistoryItemReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleHistoryItemReferenceDto
     */
    'vehicleId'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VehicleHistoryItemReferenceDto
     */
    'date'?: string;
    /**
     * 
     * @type {VehicleHistoryItemType}
     * @memberof VehicleHistoryItemReferenceDto
     */
    'type'?: VehicleHistoryItemType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleHistoryItemType = {
    None: 'None',
    MileageChanged: 'MileageChanged',
    MileageCorrected: 'MileageCorrected',
    DamageDetected: 'DamageDetected',
    DamageRepaired: 'DamageRepaired',
    DamageDeleted: 'DamageDeleted'
} as const;

export type VehicleHistoryItemType = typeof VehicleHistoryItemType[keyof typeof VehicleHistoryItemType];


/**
 * 
 * @export
 * @interface VehicleImageInsightsDto
 */
export interface VehicleImageInsightsDto {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleImageInsightsDto
     */
    'isVehicle'?: boolean;
    /**
     * 
     * @type {VehicleArea}
     * @memberof VehicleImageInsightsDto
     */
    'vehicleArea'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof VehicleImageInsightsDto
     */
    'vehicleProjection'?: VehicleProjection;
    /**
     * 
     * @type {VehicleDamageExtent}
     * @memberof VehicleImageInsightsDto
     */
    'vehicleDamageExtent'?: VehicleDamageExtent;
    /**
     * 
     * @type {Array<VehicleDamageInsightDto>}
     * @memberof VehicleImageInsightsDto
     */
    'vehiclePotentialDamages'?: Array<VehicleDamageInsightDto>;
    /**
     * 
     * @type {VehicleCleanlinessExtent}
     * @memberof VehicleImageInsightsDto
     */
    'vehicleCleanlinessExtent'?: VehicleCleanlinessExtent;
}


/**
 * 
 * @export
 * @interface VehicleInsightsDto
 */
export interface VehicleInsightsDto {
    /**
     * 
     * @type {VehicleDamageExtent}
     * @memberof VehicleInsightsDto
     */
    'damageExtent'?: VehicleDamageExtent;
    /**
     * 
     * @type {VehicleCleanlinessExtent}
     * @memberof VehicleInsightsDto
     */
    'cleanlinessExtent'?: VehicleCleanlinessExtent;
}


/**
 * 
 * @export
 * @interface VehicleMakeChangedDto
 */
export interface VehicleMakeChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleMakeChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof VehicleMakeChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof VehicleMakeChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {VehicleMakeDto}
     * @memberof VehicleMakeChangedDto
     */
    'entity': VehicleMakeDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface VehicleMakeDto
 */
export interface VehicleMakeDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleMakeDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMakeDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMakeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleMakeDto
     */
    'sortOrder'?: number;
}


/**
 * VehicleMakeExtractedData.
 * @export
 * @interface VehicleMakeExtractedDataDto
 */
export interface VehicleMakeExtractedDataDto {
    /**
     * Auto-generated ID for this extracted data record.    Used for caching, logging, or referencing this specific extraction.
     * @type {string}
     * @memberof VehicleMakeExtractedDataDto
     */
    'extractedDataId'?: string;
    /**
     * 
     * @type {ExtractedDocumentType}
     * @memberof VehicleMakeExtractedDataDto
     */
    'documentType'?: ExtractedDocumentType;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Common.DocumentIntelligence.Base.BaseExtractedData.DocumentConfidence\" />
     * @type {number}
     * @memberof VehicleMakeExtractedDataDto
     */
    'documentConfidence'?: number;
    /**
     * 
     * @type {ExtractedDocumentConfidenceLevel}
     * @memberof VehicleMakeExtractedDataDto
     */
    'documentConfidenceLevel'?: ExtractedDocumentConfidenceLevel;
    /**
     * Entity ID matched using extracted data after extraction in post-processing.
     * @type {string}
     * @memberof VehicleMakeExtractedDataDto
     */
    'matchedId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeExtractedDataDto
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @interface VehicleMakeGetPaginatedDto
 */
export interface VehicleMakeGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMakeGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleMakeGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleMakeGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleMakeGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleMakeGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof VehicleMakeGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof VehicleMakeGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof VehicleMakeGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleMakeGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof VehicleMakeGetPaginatedDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMakeGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * VehicleMakeModelExtractedData.
 * @export
 * @interface VehicleMakeModelExtractedDataDto
 */
export interface VehicleMakeModelExtractedDataDto {
    /**
     * Auto-generated ID for this extracted data record.    Used for caching, logging, or referencing this specific extraction.
     * @type {string}
     * @memberof VehicleMakeModelExtractedDataDto
     */
    'extractedDataId'?: string;
    /**
     * 
     * @type {ExtractedDocumentType}
     * @memberof VehicleMakeModelExtractedDataDto
     */
    'documentType'?: ExtractedDocumentType;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Common.DocumentIntelligence.Base.BaseExtractedData.DocumentConfidence\" />
     * @type {number}
     * @memberof VehicleMakeModelExtractedDataDto
     */
    'documentConfidence'?: number;
    /**
     * 
     * @type {ExtractedDocumentConfidenceLevel}
     * @memberof VehicleMakeModelExtractedDataDto
     */
    'documentConfidenceLevel'?: ExtractedDocumentConfidenceLevel;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeModelExtractedDataDto
     */
    'fullModelName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeModelExtractedDataDto
     */
    'makeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeModelExtractedDataDto
     */
    'modelName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeModelExtractedDataDto
     */
    'makeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeModelExtractedDataDto
     */
    'modelId'?: string | null;
}


/**
 * 
 * @export
 * @interface VehicleMakeReferenceDto
 */
export interface VehicleMakeReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleMakeReferenceDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMakeReferenceDto
     */
    'identifier'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMakeReferenceDto
     */
    'isBuiltIn'?: boolean;
}


/**
 * 
 * @export
 * @interface VehicleMileageChangedEventDataDto
 */
export interface VehicleMileageChangedEventDataDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageChangedEventDataDto
     */
    'vehicleId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageChangedEventDataDto
     */
    'visualInspectionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageChangedEventDataDto
     */
    'damageDetectionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageChangedEventDataDto
     */
    'repairOperationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageChangedEventDataDto
     */
    'wheelOperationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageChangedEventDataDto
     */
    'washId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageChangedEventDataDto
     */
    'maintenanceId'?: string | null;
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof VehicleMileageChangedEventDataDto
     */
    'oldMileage'?: VehicleMileageDto;
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof VehicleMileageChangedEventDataDto
     */
    'newMileage'?: VehicleMileageDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageChangedEventDataDto
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageCorrectedEventDataDto
 */
export interface VehicleMileageCorrectedEventDataDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageCorrectedEventDataDto
     */
    'vehicleId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageCorrectedEventDataDto
     */
    'visualInspectionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageCorrectedEventDataDto
     */
    'damageDetectionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageCorrectedEventDataDto
     */
    'repairOperationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageCorrectedEventDataDto
     */
    'wheelOperationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageCorrectedEventDataDto
     */
    'washId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageCorrectedEventDataDto
     */
    'maintenanceId'?: string | null;
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof VehicleMileageCorrectedEventDataDto
     */
    'oldMileage': VehicleMileageDto;
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof VehicleMileageCorrectedEventDataDto
     */
    'newMileage': VehicleMileageDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageCorrectedEventDataDto
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageDto
 */
export interface VehicleMileageDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageDto
     */
    'mileage'?: number;
    /**
     * 
     * @type {MileageUnit}
     * @memberof VehicleMileageDto
     */
    'unit'?: MileageUnit;
}


/**
 * 
 * @export
 * @interface VehicleMileageInputDto
 */
export interface VehicleMileageInputDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageInputDto
     */
    'mileage'?: number;
    /**
     * Should be at least 1 attachment (photo of the odometer)  when provided mileage is less than the current mileage the vehicle.
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof VehicleMileageInputDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageInputDto
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleModelChangedDto
 */
export interface VehicleModelChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleModelChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleModelChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof VehicleModelChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof VehicleModelChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof VehicleModelChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {VehicleModelDto}
     * @memberof VehicleModelChangedDto
     */
    'entity': VehicleModelDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleModelChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface VehicleModelDto
 */
export interface VehicleModelDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleModelDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleModelDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleModelDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof VehicleModelDto
     */
    'name'?: string;
    /**
     * 
     * @type {VehicleSize}
     * @memberof VehicleModelDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof VehicleModelDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleModelDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {VehicleMakeReferenceDto}
     * @memberof VehicleModelDto
     */
    'make'?: VehicleMakeReferenceDto;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleModelDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleModelDto
     */
    'sortOrder'?: number;
}


/**
 * VehicleModelExtractedData.
 * @export
 * @interface VehicleModelExtractedDataDto
 */
export interface VehicleModelExtractedDataDto {
    /**
     * Auto-generated ID for this extracted data record.    Used for caching, logging, or referencing this specific extraction.
     * @type {string}
     * @memberof VehicleModelExtractedDataDto
     */
    'extractedDataId'?: string;
    /**
     * 
     * @type {ExtractedDocumentType}
     * @memberof VehicleModelExtractedDataDto
     */
    'documentType'?: ExtractedDocumentType;
    /**
     * <inheritdoc cref=\"P:Domain.Entities.Common.DocumentIntelligence.Base.BaseExtractedData.DocumentConfidence\" />
     * @type {number}
     * @memberof VehicleModelExtractedDataDto
     */
    'documentConfidence'?: number;
    /**
     * 
     * @type {ExtractedDocumentConfidenceLevel}
     * @memberof VehicleModelExtractedDataDto
     */
    'documentConfidenceLevel'?: ExtractedDocumentConfidenceLevel;
    /**
     * Entity ID matched using extracted data after extraction in post-processing.
     * @type {string}
     * @memberof VehicleModelExtractedDataDto
     */
    'matchedId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleModelExtractedDataDto
     */
    'name'?: string | null;
}


/**
 * 
 * @export
 * @interface VehicleModelGetPaginatedDto
 */
export interface VehicleModelGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleModelGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleModelGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleModelGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleModelGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleModelGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleModelGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof VehicleModelGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof VehicleModelGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof VehicleModelGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleModelGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof VehicleModelGetPaginatedDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleModelGetPaginatedDto
     */
    'vehicleTypeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleModelGetPaginatedDto
     */
    'makeId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleModelGetPaginatedDto
     */
    'makeIds'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleModelGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface VehicleModelReferenceDto
 */
export interface VehicleModelReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleModelReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleModelReferenceDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleModelReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {VehicleSize}
     * @memberof VehicleModelReferenceDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {VehicleMakeReferenceDto}
     * @memberof VehicleModelReferenceDto
     */
    'make'?: VehicleMakeReferenceDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleModelReferenceDto
     */
    'vehicleType'?: VehicleType;
}


/**
 * 
 * @export
 * @interface VehicleModificationChangedDto
 */
export interface VehicleModificationChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleModificationChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof VehicleModificationChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof VehicleModificationChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {VehicleModificationDto}
     * @memberof VehicleModificationChangedDto
     */
    'entity': VehicleModificationDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface VehicleModificationDto
 */
export interface VehicleModificationDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleMakeReferenceDto}
     * @memberof VehicleModificationDto
     */
    'make'?: VehicleMakeReferenceDto;
    /**
     * 
     * @type {VehicleModelReferenceDto}
     * @memberof VehicleModificationDto
     */
    'model'?: VehicleModelReferenceDto;
    /**
     * 
     * @type {VehicleGenerationReferenceDto}
     * @memberof VehicleModificationDto
     */
    'generation'?: VehicleGenerationReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationDto
     */
    'name'?: string;
    /**
     * 
     * @type {VehicleFuelTypeReferenceDto}
     * @memberof VehicleModificationDto
     */
    'fuelType'?: VehicleFuelTypeReferenceDto;
    /**
     * 
     * @type {VehicleBodyTypeReferenceDto}
     * @memberof VehicleModificationDto
     */
    'bodyType'?: VehicleBodyTypeReferenceDto;
    /**
     * 
     * @type {VehicleSize}
     * @memberof VehicleModificationDto
     */
    'vehicleSize'?: VehicleSize;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleModificationDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleModificationDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleModificationDto
     */
    'vehicleType'?: VehicleType;
}


/**
 * 
 * @export
 * @interface VehicleModificationGetPaginatedDto
 */
export interface VehicleModificationGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'makeId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'makeIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'modelId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'modelIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'generationId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'generationIds'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleModificationGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface VehicleModificationReferenceDto
 */
export interface VehicleModificationReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleModificationReferenceDto
     */
    'isBuiltIn'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleOperationType = {
    None: 'None',
    VisualInspection: 'VisualInspection',
    DamageDetection: 'DamageDetection',
    DamageCostEvaluation: 'DamageCostEvaluation',
    AccessoryCheck: 'AccessoryCheck',
    RepairOperation: 'RepairOperation',
    Maintenance: 'Maintenance',
    Wash: 'Wash',
    WheelOperation: 'WheelOperation'
} as const;

export type VehicleOperationType = typeof VehicleOperationType[keyof typeof VehicleOperationType];


/**
 * Describes general/basic categories of vehicle parts.  Vehicle part should belong to one of these categories for correct mapping and suggestions.  For instance, when mapping parts to damages and repair methods.
 * @export
 * @enum {string}
 */

export const VehiclePartCategory = {
    None: 'None',
    Body: 'Body',
    Wheels: 'Wheels',
    Glass: 'Glass',
    Lighting: 'Lighting',
    ExteriorAccessories: 'ExteriorAccessories',
    Seats: 'Seats',
    AirVentilation: 'AirVentilation',
    Dashboard: 'Dashboard',
    Upholstery: 'Upholstery',
    SteeringWheel: 'SteeringWheel',
    InteriorLighting: 'InteriorLighting',
    InteriorControls: 'InteriorControls',
    AudioSystem: 'AudioSystem',
    InteriorAccessories: 'InteriorAccessories'
} as const;

export type VehiclePartCategory = typeof VehiclePartCategory[keyof typeof VehiclePartCategory];


/**
 * Describes the final vehicle part.  It\'s not an identifier as multiple parts may have the same descriptor.
 * @export
 * @enum {string}
 */

export const VehiclePartDescriptor = {
    None: 'None',
    LicencePlateFront: 'LicencePlate_Front',
    LicencePlateRear: 'LicencePlate_Rear',
    LicencePlateLightFront: 'LicencePlateLight_Front',
    LicencePlateLightRear: 'LicencePlateLight_Rear',
    BumperFront: 'Bumper_Front',
    BumperRear: 'Bumper_Rear',
    HeadlightLeft: 'Headlight_Left',
    HeadlightRight: 'Headlight_Right',
    TailLightLeft: 'TailLight_Left',
    TailLightRight: 'TailLight_Right',
    FogLightFrontLeft: 'FogLight_Front_Left',
    FogLightFrontRight: 'FogLight_Front_Right',
    FogLightRearLeft: 'FogLight_Rear_Left',
    FogLightRearRight: 'FogLight_Rear_Right',
    TurnSignalFrontLeft: 'TurnSignal_Front_Left',
    TurnSignalFrontRight: 'TurnSignal_Front_Right',
    TurnSignalRearLeft: 'TurnSignal_Rear_Left',
    TurnSignalRearRight: 'TurnSignal_Rear_Right',
    TurnSignalSideLeft: 'TurnSignal_Side_Left',
    TurnSignalSideRight: 'TurnSignal_Side_Right',
    FenderFront: 'Fender_Front',
    FenderRear: 'Fender_Rear',
    FenderFrontLeft: 'Fender_Front_Left',
    FenderFrontRight: 'Fender_Front_Right',
    FenderRearLeft: 'Fender_Rear_Left',
    FenderRearRight: 'Fender_Rear_Right',
    FenderLinerFront: 'FenderLiner_Front',
    FenderLinerRear: 'FenderLiner_Rear',
    FenderLinerFrontLeft: 'FenderLiner_Front_Left',
    FenderLinerFrontRight: 'FenderLiner_Front_Right',
    FenderLinerRearLeft: 'FenderLiner_Rear_Left',
    FenderLinerRearRight: 'FenderLiner_Rear_Right',
    SideMirrorLeft: 'SideMirror_Left',
    SideMirrorRight: 'SideMirror_Right',
    DoorFront: 'Door_Front',
    DoorRear: 'Door_Rear',
    DoorFrontLeft: 'Door_Front_Left',
    DoorFrontRight: 'Door_Front_Right',
    DoorRearLeft: 'Door_Rear_Left',
    DoorRearRight: 'Door_Rear_Right',
    DoorHandleFront: 'DoorHandle_Front',
    DoorHandleRear: 'DoorHandle_Rear',
    DoorHandleFrontLeft: 'DoorHandle_Front_Left',
    DoorHandleFrontRight: 'DoorHandle_Front_Right',
    DoorHandleRearLeft: 'DoorHandle_Rear_Left',
    DoorHandleRearRight: 'DoorHandle_Rear_Right',
    DoorGlassFront: 'DoorGlass_Front',
    DoorGlassRear: 'DoorGlass_Rear',
    DoorGlassFrontLeft: 'DoorGlass_Front_Left',
    DoorGlassFrontRight: 'DoorGlass_Front_Right',
    DoorGlassRearLeft: 'DoorGlass_Rear_Left',
    DoorGlassRearRight: 'DoorGlass_Rear_Right',
    QuarterGlassFront: 'QuarterGlass_Front',
    QuarterGlassRear: 'QuarterGlass_Rear',
    QuarterGlassFrontLeft: 'QuarterGlass_Front_Left',
    QuarterGlassFrontRight: 'QuarterGlass_Front_Right',
    QuarterGlassRearLeft: 'QuarterGlass_Rear_Left',
    QuarterGlassRearRight: 'QuarterGlass_Rear_Right',
    DoorLockFront: 'DoorLock_Front',
    DoorLockRear: 'DoorLock_Rear',
    DoorLockFrontLeft: 'DoorLock_Front_Left',
    DoorLockFrontRight: 'DoorLock_Front_Right',
    DoorLockRearLeft: 'DoorLock_Rear_Left',
    DoorLockRearRight: 'DoorLock_Rear_Right',
    SeatFrontLeft: 'Seat_Front_Left',
    SeatFrontRight: 'Seat_Front_Right',
    SeatRearLeft: 'Seat_Rear_Left',
    SeatRearRight: 'Seat_Rear_Right',
    SeatRearMiddle: 'Seat_Rear_Middle',
    SeatThirdRowLeft: 'Seat_ThirdRow_Left',
    SeatThirdRowMiddle: 'Seat_ThirdRow_Middle',
    SeatThirdRowRight: 'Seat_ThirdRow_Right',
    HeadrestFrontLeft: 'Headrest_Front_Left',
    HeadrestFrontRight: 'Headrest_Front_Right',
    HeadrestRearLeft: 'Headrest_Rear_Left',
    HeadrestRearRight: 'Headrest_Rear_Right',
    HeadrestRearMiddle: 'Headrest_Rear_Middle',
    SeatAdjustmentControlsFrontLeft: 'SeatAdjustmentControls_Front_Left',
    SeatAdjustmentControlsFrontRight: 'SeatAdjustmentControls_Front_Right',
    SeatFoldingMechanismRear: 'SeatFoldingMechanism_Rear',
    SeatBeltFrontLeft: 'SeatBelt_Front_Left',
    SeatBeltFrontRight: 'SeatBelt_Front_Right',
    SeatBeltRearLeft: 'SeatBelt_Rear_Left',
    SeatBeltRearRight: 'SeatBelt_Rear_Right',
    SeatBeltRearMiddle: 'SeatBelt_Rear_Middle',
    SeatBeltBuckleFrontLeft: 'SeatBeltBuckle_Front_Left',
    SeatBeltBuckleFrontRight: 'SeatBeltBuckle_Front_Right',
    SeatBeltBuckleRearLeft: 'SeatBeltBuckle_Rear_Left',
    SeatBeltBuckleRearRight: 'SeatBeltBuckle_Rear_Right',
    SeatBeltBuckleRearMiddle: 'SeatBeltBuckle_Rear_Middle',
    SeatBeltBuckleThirdRowLeft: 'SeatBeltBuckle_ThirdRow_Left',
    SeatBeltBuckleThirdRowMiddle: 'SeatBeltBuckle_ThirdRow_Middle',
    SeatBeltBuckleThirdRowRight: 'SeatBeltBuckle_ThirdRow_Right',
    FloorMatFrontLeft: 'FloorMat_Front_Left',
    FloorMatFrontRight: 'FloorMat_Front_Right',
    FloorMatRearLeft: 'FloorMat_Rear_Left',
    FloorMatRearRight: 'FloorMat_Rear_Right',
    FloorMatRearMiddle: 'FloorMat_Rear_Middle',
    FloorMatTrunk: 'FloorMat_Trunk',
    MatCoverTrunk: 'MatCover_Trunk',
    DoorPanelFrontLeft: 'DoorPanel_Front_Left',
    DoorPanelFrontRight: 'DoorPanel_Front_Right',
    DoorPanelRearLeft: 'DoorPanel_Rear_Left',
    DoorPanelRearRight: 'DoorPanel_Rear_Right',
    DoorSwitchPanelFrontLeft: 'DoorSwitchPanel_Front_Left',
    DoorSwitchPanelFrontRight: 'DoorSwitchPanel_Front_Right',
    DoorSwitchPanelRearLeft: 'DoorSwitchPanel_Rear_Left',
    DoorSwitchPanelRearRight: 'DoorSwitchPanel_Rear_Right',
    AirVentilationFrontLeft: 'AirVentilation_Front_Left',
    AirVentilationFrontRight: 'AirVentilation_Front_Right',
    AirVentilationFrontMiddle: 'AirVentilation_Front_Middle',
    AirVentilationRearMiddle: 'AirVentilation_Rear_Middle',
    ArmrestFront: 'Armrest_Front',
    ArmrestRear: 'Armrest_Rear',
    SunVisorLeft: 'SunVisor_Left',
    SunVisorRight: 'SunVisor_Right',
    SunVisorLightingLeft: 'SunVisorLighting_Left',
    SunVisorLightingRight: 'SunVisorLighting_Right',
    InteriorDoorHandleLightingFrontLeft: 'InteriorDoorHandleLighting_Front_Left',
    InteriorDoorHandleLightingFrontRight: 'InteriorDoorHandleLighting_Front_Right',
    InteriorDoorHandleLightingRearLeft: 'InteriorDoorHandleLighting_Rear_Left',
    InteriorDoorHandleLightingRearRight: 'InteriorDoorHandleLighting_Rear_Right',
    DoorPanelLightingFrontLeft: 'DoorPanelLighting_Front_Left',
    DoorPanelLightingFrontRight: 'DoorPanelLighting_Front_Right',
    DoorPanelLightingRearLeft: 'DoorPanelLighting_Rear_Left',
    DoorPanelLightingRearRight: 'DoorPanelLighting_Rear_Right',
    SpeakerFront: 'Speaker_Front',
    SpeakerRear: 'Speaker_Rear',
    SpeakerTrunk: 'Speaker_Trunk'
} as const;

export type VehiclePartDescriptor = typeof VehiclePartDescriptor[keyof typeof VehiclePartDescriptor];


/**
 * Further detalization of VehiclePartCategory.  Describes general types of vehicle parts.
 * @export
 * @enum {string}
 */

export const VehiclePartType = {
    None: 'None',
    LicencePlate: 'LicencePlate',
    LicencePlateLight: 'LicencePlateLight',
    MarkerLight: 'MarkerLight',
    WindowFrame: 'WindowFrame',
    Bumper: 'Bumper',
    Grille: 'Grille',
    Headlight: 'Headlight',
    TailLight: 'TailLight',
    FogLight: 'FogLight',
    TurnSignal: 'TurnSignal',
    Hood: 'Hood',
    CowlPanel: 'CowlPanel',
    Windshield: 'Windshield',
    WindshieldWiper: 'WindshieldWiper',
    RearWindshield: 'RearWindshield',
    RearWindshieldWiper: 'RearWindshieldWiper',
    Wheel: 'Wheel',
    Tire: 'Tire',
    Rim: 'Rim',
    Hubcap: 'Hubcap',
    Fender: 'Fender',
    FenderLiner: 'FenderLiner',
    SideMirror: 'SideMirror',
    Door: 'Door',
    TrunkLid: 'TrunkLid',
    DoorHandle: 'DoorHandle',
    DoorGlass: 'DoorGlass',
    QuarterGlass: 'QuarterGlass',
    DoorLock: 'DoorLock',
    FuelTankLid: 'FuelTankLid',
    FuelTankCap: 'FuelTankCap',
    SideSkirt: 'SideSkirt',
    RockerPanel: 'RockerPanel',
    RockerPanelCover: 'RockerPanelCover',
    ExhaustPipeTip: 'ExhaustPipeTip',
    Spoiler: 'Spoiler',
    Roof: 'Roof',
    RoofMarkerLight: 'RoofMarkerLight',
    RoofHatch: 'RoofHatch',
    GlassRoofHatch: 'GlassRoofHatch',
    RoofHatchGlass: 'RoofHatchGlass',
    RoofRack: 'RoofRack',
    RoofRail: 'RoofRail',
    Seat: 'Seat',
    Headrest: 'Headrest',
    SeatAdjustmentControls: 'SeatAdjustmentControls',
    SeatFoldingMechanism: 'SeatFoldingMechanism',
    SeatBelt: 'SeatBelt',
    SeatBeltBuckle: 'SeatBeltBuckle',
    DoorPanel: 'DoorPanel',
    DoorSwitchPanel: 'DoorSwitchPanel',
    AirVentilation: 'AirVentilation',
    ClimateControl: 'ClimateControl',
    GloveCompartment: 'GloveCompartment',
    CentralDisplay: 'CentralDisplay',
    LighterSocket: 'LighterSocket',
    Speedometer: 'Speedometer',
    Tachometer: 'Tachometer',
    FuelGauge: 'FuelGauge',
    TemperatureGauge: 'TemperatureGauge',
    SteeringWheel: 'SteeringWheel',
    SteeringWheelControls: 'SteeringWheelControls',
    Horn: 'Horn',
    InteriorLightingControls: 'InteriorLightingControls',
    OverheadLighting: 'OverheadLighting',
    SunVisorLighting: 'SunVisorLighting',
    AmbientLighting: 'AmbientLighting',
    FootwellLighting: 'FootwellLighting',
    InteriorDoorHandleLighting: 'InteriorDoorHandleLighting',
    DoorPanelLighting: 'DoorPanelLighting',
    CupHolderLighting: 'CupHolderLighting',
    DashboardLighting: 'DashboardLighting',
    InteriorRoofLighting: 'InteriorRoofLighting',
    InteriorTrunkLighting: 'InteriorTrunkLighting',
    RoofLiner: 'RoofLiner',
    IgnitionSwitch: 'IgnitionSwitch',
    IgnitionKey: 'IgnitionKey',
    ParkingBrake: 'ParkingBrake',
    ElectronicParkingBrake: 'ElectronicParkingBrake',
    GearStick: 'GearStick',
    GearSelector: 'GearSelector',
    AcceleratorPedal: 'AcceleratorPedal',
    BreakPedal: 'BreakPedal',
    ClutchPedal: 'ClutchPedal',
    WindshieldWiperControl: 'WindshieldWiperControl',
    FloorMat: 'FloorMat',
    MatCover: 'MatCover',
    Armrest: 'Armrest',
    SunVisor: 'SunVisor',
    RearViewMirror: 'RearViewMirror',
    Navigator: 'Navigator',
    ProjectionNavigator: 'ProjectionNavigator',
    VideoRecorder: 'VideoRecorder',
    AudioSystem: 'AudioSystem',
    Speaker: 'Speaker',
    TrunkOrganizer: 'TrunkOrganizer',
    TrunkDivider: 'TrunkDivider',
    TrunkHiddenStorage: 'TrunkHiddenStorage',
    TrunkNet: 'TrunkNet',
    TrunkLiner: 'TrunkLiner',
    TireRepairKit: 'TireRepairKit',
    TireInflator: 'TireInflator',
    SpareWheel: 'SpareWheel',
    Jack: 'Jack'
} as const;

export type VehiclePartType = typeof VehiclePartType[keyof typeof VehiclePartType];


/**
 * 
 * @export
 * @interface VehiclePartTypeChangedDto
 */
export interface VehiclePartTypeChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehiclePartTypeChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypeChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof VehiclePartTypeChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof VehiclePartTypeChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypeChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {VehiclePartTypeDto}
     * @memberof VehiclePartTypeChangedDto
     */
    'entity': VehiclePartTypeDto;
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypeChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface VehiclePartTypeDto
 */
export interface VehiclePartTypeDto {
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypeDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehiclePartTypeDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehiclePartCategory}
     * @memberof VehiclePartTypeDto
     */
    'category'?: VehiclePartCategory;
    /**
     * 
     * @type {VehiclePartType}
     * @memberof VehiclePartTypeDto
     */
    'type'?: VehiclePartType;
    /**
     * 
     * @type {VehiclePartDescriptor}
     * @memberof VehiclePartTypeDto
     */
    'descriptor'?: VehiclePartDescriptor;
    /**
     * 
     * @type {Array<VehicleArea>}
     * @memberof VehiclePartTypeDto
     */
    'areas'?: Array<VehicleArea>;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof VehiclePartTypeDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof VehiclePartTypeDto
     */
    'projections'?: Array<VehicleProjection>;
    /**
     * 
     * @type {AdminVehiclePartTypeDtoProjectionsPerArea}
     * @memberof VehiclePartTypeDto
     */
    'projectionsPerArea'?: AdminVehiclePartTypeDtoProjectionsPerArea;
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypeDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehiclePartTypeDto
     */
    'isCategoryRoot'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehiclePartTypeDto
     */
    'isTypeRoot'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehiclePartTypeDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehiclePartTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehiclePartTypeDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehiclePartTypeDto
     */
    'isEnabledForDamageDetection'?: boolean;
    /**
     * 
     * @type {Array<DamageTypeCategory>}
     * @memberof VehiclePartTypeDto
     */
    'damageCategories'?: Array<DamageTypeCategory> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehiclePartTypeDto
     */
    'damageTypeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof VehiclePartTypeDto
     */
    'examplePictures'?: Array<GeneralAttachmentDto>;
}


/**
 * 
 * @export
 * @interface VehiclePartTypeGetPaginatedDto
 */
export interface VehiclePartTypeGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehiclePartCategory}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'category'?: VehiclePartCategory;
    /**
     * 
     * @type {VehiclePartType}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'type'?: VehiclePartType;
    /**
     * 
     * @type {Array<VehiclePartType>}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'types'?: Array<VehiclePartType> | null;
    /**
     * 
     * @type {VehiclePartDescriptor}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'descriptor'?: VehiclePartDescriptor;
    /**
     * 
     * @type {Array<VehiclePartDescriptor>}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'descriptors'?: Array<VehiclePartDescriptor> | null;
    /**
     * 
     * @type {VehicleArea}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'projections'?: Array<VehicleProjection> | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'isCategoryRoot'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'isTypeRoot'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'isEnabledForDamageDetection'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehiclePartTypeGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface VehiclePartTypeReferenceDto
 */
export interface VehiclePartTypeReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypeReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypeReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehiclePartTypeReferenceDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehiclePartCategory}
     * @memberof VehiclePartTypeReferenceDto
     */
    'category'?: VehiclePartCategory;
    /**
     * 
     * @type {VehiclePartType}
     * @memberof VehiclePartTypeReferenceDto
     */
    'type'?: VehiclePartType;
    /**
     * 
     * @type {Array<VehicleArea>}
     * @memberof VehiclePartTypeReferenceDto
     */
    'areas'?: Array<VehicleArea>;
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof VehiclePartTypeReferenceDto
     */
    'projections'?: Array<VehicleProjection>;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof VehiclePartTypeReferenceDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypeReferenceDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypeReferenceDto
     */
    'description'?: string | null;
}


/**
 * 
 * @export
 * @interface VehiclePriceApplySettingsInputDto
 */
export interface VehiclePriceApplySettingsInputDto {
    /**
     * Indicates whether the cost must be applied to all vehicles with the same vehicle spec
     * @type {boolean}
     * @memberof VehiclePriceApplySettingsInputDto
     */
    'isForAllSimilarVehicles'?: boolean;
    /**
     * Indicates whether the cost must be applied to all vehicles with the same make
     * @type {boolean}
     * @memberof VehiclePriceApplySettingsInputDto
     */
    'isForAllWithSameMake'?: boolean;
    /**
     * Indicates whether the cost must be applied to all vehicles with the same model
     * @type {boolean}
     * @memberof VehiclePriceApplySettingsInputDto
     */
    'isForAllWithSameModel'?: boolean;
    /**
     * Indicates whether the cost must be applied to all vehicles with the same generation
     * @type {boolean}
     * @memberof VehiclePriceApplySettingsInputDto
     */
    'isForAllWithSameGeneration'?: boolean;
    /**
     * Indicates whether the cost must be applied to all vehicles with the same modification
     * @type {boolean}
     * @memberof VehiclePriceApplySettingsInputDto
     */
    'isForAllWithSameModification'?: boolean;
}
/**
 * 
 * @export
 * @interface VehiclePriceDto
 */
export interface VehiclePriceDto {
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof VehiclePriceDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {number}
     * @memberof VehiclePriceDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof VehiclePriceDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof VehiclePriceDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * Total before any discount or tax is applied
     * @type {number}
     * @memberof VehiclePriceDto
     */
    'subTotal'?: number;
    /**
     * Total after discount is applied, but before any tax is applied.
     * @type {number}
     * @memberof VehiclePriceDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * Total after discounts and taxes.
     * @type {number}
     * @memberof VehiclePriceDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface VehiclePriceInputDto
 */
export interface VehiclePriceInputDto {
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof VehiclePriceInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
    /**
     * 
     * @type {number}
     * @memberof VehiclePriceInputDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralDiscountInputDto}
     * @memberof VehiclePriceInputDto
     */
    'discount'?: GeneralDiscountInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof VehiclePriceInputDto
     */
    'tax'?: GeneralTaxInputDto;
}
/**
 * 
 * @export
 * @interface VehiclePriceWithSettingsInputDto
 */
export interface VehiclePriceWithSettingsInputDto {
    /**
     * 
     * @type {VehiclePriceInputDto}
     * @memberof VehiclePriceWithSettingsInputDto
     */
    'price'?: VehiclePriceInputDto;
    /**
     * 
     * @type {VehiclePriceApplySettingsInputDto}
     * @memberof VehiclePriceWithSettingsInputDto
     */
    'settings'?: VehiclePriceApplySettingsInputDto;
}
/**
 * Describes side of a vehicle in 3D space.
 * @export
 * @enum {string}
 */

export const VehicleProjection = {
    None: 'None',
    Any: 'Any',
    Front: 'Front',
    Back: 'Back',
    Top: 'Top',
    Bottom: 'Bottom',
    Left: 'Left',
    Right: 'Right'
} as const;

export type VehicleProjection = typeof VehicleProjection[keyof typeof VehicleProjection];


/**
 * Describes the component of powertrain which generates power and propels a vehicle.  I.e. engine or motor.
 * @export
 * @enum {string}
 */

export const VehiclePropulsionType = {
    None: 'None',
    InternalCombustionEngine: 'InternalCombustionEngine',
    ElectricMotor: 'ElectricMotor'
} as const;

export type VehiclePropulsionType = typeof VehiclePropulsionType[keyof typeof VehiclePropulsionType];


/**
 * 
 * @export
 * @interface VehicleReferenceDto
 */
export interface VehicleReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleSpecReferenceDto}
     * @memberof VehicleReferenceDto
     */
    'spec'?: VehicleSpecReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleReferenceDto
     */
    'identificationNumber'?: string | null;
    /**
     * 
     * @type {GeneralPlateNoDto}
     * @memberof VehicleReferenceDto
     */
    'plateNo'?: GeneralPlateNoDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleSize = {
    None: 'None',
    Small: 'Small',
    Medium: 'Medium',
    Large: 'Large',
    ExtraLarge: 'ExtraLarge'
} as const;

export type VehicleSize = typeof VehicleSize[keyof typeof VehicleSize];


/**
 * 
 * @export
 * @interface VehicleSpecDto
 */
export interface VehicleSpecDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleSpecDto
     */
    'id'?: string;
    /**
     * 
     * @type {VehicleMakeReferenceDto}
     * @memberof VehicleSpecDto
     */
    'make'?: VehicleMakeReferenceDto;
    /**
     * 
     * @type {VehicleModelReferenceDto}
     * @memberof VehicleSpecDto
     */
    'model'?: VehicleModelReferenceDto;
    /**
     * 
     * @type {VehicleGenerationReferenceDto}
     * @memberof VehicleSpecDto
     */
    'generation'?: VehicleGenerationReferenceDto;
    /**
     * 
     * @type {VehicleModificationReferenceDto}
     * @memberof VehicleSpecDto
     */
    'modification'?: VehicleModificationReferenceDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleSpecDto
     */
    'type'?: VehicleType;
    /**
     * 
     * @type {VehicleSize}
     * @memberof VehicleSpecDto
     */
    'size'?: VehicleSize;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof VehicleSpecDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof VehicleSpecDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {VehicleGearboxType}
     * @memberof VehicleSpecDto
     */
    'gearboxType'?: VehicleGearboxType;
    /**
     * 
     * @type {VehicleDrivetrainType}
     * @memberof VehicleSpecDto
     */
    'drivetrainType'?: VehicleDrivetrainType;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecDto
     */
    'manufactureYear'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecDto
     */
    'numberOfSeats'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecDto
     */
    'numberOfDoors'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecDto
     */
    'bootCapacityL'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecDto
     */
    'cO2EmissionsGKm'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecDto
     */
    'horsepower'?: number | null;
    /**
     * 
     * @type {VehicleFuelConsumptionDto}
     * @memberof VehicleSpecDto
     */
    'fuelConsumption'?: VehicleFuelConsumptionDto;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecDto
     */
    'batteryCapacityKWh'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecDto
     */
    'electricRangeKm'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSpecDto
     */
    'hasAirConditioner'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSpecDto
     */
    'hasTowHook'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSpecDto
     */
    'hasTowBar'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSpecDto
     */
    'hasTowRope'?: boolean | null;
    /**
     * v1. Preserved for backward compatibility.
     * @type {number}
     * @memberof VehicleSpecDto
     */
    'purchasingCost'?: number | null;
    /**
     * 
     * @type {VehiclePriceDto}
     * @memberof VehicleSpecDto
     */
    'purchasePrice'?: VehiclePriceDto;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSpecDto
     */
    'hasBattery'?: boolean | null;
    /**
     * 
     * @type {VehiclePropulsionType}
     * @memberof VehicleSpecDto
     */
    'primaryPropulsionType'?: VehiclePropulsionType;
    /**
     * 
     * @type {VehiclePropulsionType}
     * @memberof VehicleSpecDto
     */
    'secondaryPropulsionType'?: VehiclePropulsionType;
}


/**
 * 
 * @export
 * @interface VehicleSpecInputDto
 */
export interface VehicleSpecInputDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleSpecInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleSpecInputDto
     */
    'type'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof VehicleSpecInputDto
     */
    'makeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleSpecInputDto
     */
    'modelId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleSpecInputDto
     */
    'generationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSpecInputDto
     */
    'modificationId'?: string | null;
    /**
     * 
     * @type {VehicleSize}
     * @memberof VehicleSpecInputDto
     */
    'size'?: VehicleSize;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof VehicleSpecInputDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof VehicleSpecInputDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {VehicleGearboxType}
     * @memberof VehicleSpecInputDto
     */
    'gearboxType'?: VehicleGearboxType;
    /**
     * 
     * @type {VehicleDrivetrainType}
     * @memberof VehicleSpecInputDto
     */
    'drivetrainType'?: VehicleDrivetrainType;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecInputDto
     */
    'manufactureYear'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecInputDto
     */
    'numberOfSeats'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecInputDto
     */
    'numberOfDoors'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecInputDto
     */
    'bootCapacityL'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecInputDto
     */
    'cO2EmissionsGKm'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecInputDto
     */
    'horsepower'?: number | null;
    /**
     * 
     * @type {VehicleFuelConsumptionInputDto}
     * @memberof VehicleSpecInputDto
     */
    'fuelConsumption'?: VehicleFuelConsumptionInputDto;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecInputDto
     */
    'batteryCapacityKWh'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecInputDto
     */
    'electricRangeKm'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSpecInputDto
     */
    'hasAirConditioner'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSpecInputDto
     */
    'hasTowHook'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSpecInputDto
     */
    'hasTowBar'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSpecInputDto
     */
    'hasTowRope'?: boolean | null;
    /**
     * 
     * @type {VehiclePriceWithSettingsInputDto}
     * @memberof VehicleSpecInputDto
     */
    'purchasePrice'?: VehiclePriceWithSettingsInputDto;
}


/**
 * 
 * @export
 * @interface VehicleSpecQueryDto
 */
export interface VehicleSpecQueryDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleSpecQueryDto
     */
    'makeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSpecQueryDto
     */
    'modelId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSpecQueryDto
     */
    'generationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSpecQueryDto
     */
    'modificationId'?: string | null;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleSpecQueryDto
     */
    'type'?: VehicleType;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof VehicleSpecQueryDto
     */
    'bodyType'?: VehicleBodyType;
    /**
     * 
     * @type {VehicleFuelType}
     * @memberof VehicleSpecQueryDto
     */
    'fuelType'?: VehicleFuelType;
    /**
     * 
     * @type {VehicleGearboxType}
     * @memberof VehicleSpecQueryDto
     */
    'gearboxType'?: VehicleGearboxType;
    /**
     * 
     * @type {VehicleDrivetrainType}
     * @memberof VehicleSpecQueryDto
     */
    'drivetrainType'?: VehicleDrivetrainType;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecQueryDto
     */
    'manufactureYear'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecQueryDto
     */
    'numberOfSeats'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleSpecQueryDto
     */
    'numberOfDoors'?: number | null;
}


/**
 * 
 * @export
 * @interface VehicleSpecReferenceDto
 */
export interface VehicleSpecReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleSpecReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {VehicleMakeReferenceDto}
     * @memberof VehicleSpecReferenceDto
     */
    'make'?: VehicleMakeReferenceDto;
    /**
     * 
     * @type {VehicleModelReferenceDto}
     * @memberof VehicleSpecReferenceDto
     */
    'model'?: VehicleModelReferenceDto;
    /**
     * 
     * @type {VehicleGenerationReferenceDto}
     * @memberof VehicleSpecReferenceDto
     */
    'generation'?: VehicleGenerationReferenceDto;
    /**
     * 
     * @type {VehicleModificationReferenceDto}
     * @memberof VehicleSpecReferenceDto
     */
    'modification'?: VehicleModificationReferenceDto;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleSpecReferenceDto
     */
    'type'?: VehicleType;
    /**
     * 
     * @type {VehicleBodyType}
     * @memberof VehicleSpecReferenceDto
     */
    'bodyType'?: VehicleBodyType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleStatus = {
    None: 'None',
    Unknown: 'Unknown',
    Available: 'Available',
    Reserved: 'Reserved',
    InUse: 'InUse',
    OnRent: 'OnRent',
    InLease: 'InLease',
    InSubscription: 'InSubscription',
    Returning: 'Returning',
    InWash: 'InWash',
    ChangingTires: 'ChangingTires',
    InWheelService: 'InWheelService',
    UnderMaintenance: 'UnderMaintenance',
    InRepair: 'InRepair',
    InTransit: 'InTransit',
    Disposed: 'Disposed',
    Sold: 'Sold',
    PermanentlyLost: 'PermanentlyLost',
    LeaseEnded: 'LeaseEnded',
    Locked: 'Locked'
} as const;

export type VehicleStatus = typeof VehicleStatus[keyof typeof VehicleStatus];


/**
 * 
 * @export
 * @interface VehicleStatusBulkUpdateDto
 */
export interface VehicleStatusBulkUpdateDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleStatusBulkUpdateDto
     */
    'vehicleIds'?: Array<string>;
    /**
     * 
     * @type {GeneralStatusInputTypedDtoOfVehicleStatus}
     * @memberof VehicleStatusBulkUpdateDto
     */
    'status'?: GeneralStatusInputTypedDtoOfVehicleStatus;
}
/**
 * 
 * @export
 * @interface VehicleStatusBulkUpdateResultDto
 */
export interface VehicleStatusBulkUpdateResultDto {
    /**
     * 
     * @type {Array<ResultDtoInVehicleStatusBulkUpdateResultDto>}
     * @memberof VehicleStatusBulkUpdateResultDto
     */
    'results': Array<ResultDtoInVehicleStatusBulkUpdateResultDto>;
}
/**
 * 
 * @export
 * @interface VehicleTaxCalcRequestDto
 */
export interface VehicleTaxCalcRequestDto {
    /**
     * 
     * @type {VehicleTaxType}
     * @memberof VehicleTaxCalcRequestDto
     */
    'type'?: VehicleTaxType;
    /**
     * 
     * @type {VehicleSpecInputDto}
     * @memberof VehicleTaxCalcRequestDto
     */
    'spec'?: VehicleSpecInputDto;
    /**
     * 
     * @type {GeneralPriceInputDto}
     * @memberof VehicleTaxCalcRequestDto
     */
    'price'?: GeneralPriceInputDto;
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof VehicleTaxCalcRequestDto
     */
    'tax'?: GeneralTaxInputDto;
    /**
     * 
     * @type {GeneralCountryInputDto}
     * @memberof VehicleTaxCalcRequestDto
     */
    'country'?: GeneralCountryInputDto;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof VehicleTaxCalcRequestDto
     */
    'currency': GeneralCurrencyInputDto;
}


/**
 * 
 * @export
 * @interface VehicleTaxCalcResponseDto
 */
export interface VehicleTaxCalcResponseDto {
    /**
     * 
     * @type {VehicleTaxCalcRequestDto}
     * @memberof VehicleTaxCalcResponseDto
     */
    'request': VehicleTaxCalcRequestDto;
    /**
     * 
     * @type {VehicleTaxDto}
     * @memberof VehicleTaxCalcResponseDto
     */
    'vehicleTax': VehicleTaxDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof VehicleTaxCalcResponseDto
     */
    'newTax': GeneralTaxDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleTaxCalcResponseDto
     */
    'newTaxCalcExplanationText': string | null;
}
/**
 * 
 * @export
 * @interface VehicleTaxDto
 */
export interface VehicleTaxDto {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleTaxDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {VehicleTaxType}
     * @memberof VehicleTaxDto
     */
    'type'?: VehicleTaxType;
    /**
     * 
     * @type {Array<GeneralCountryDto>}
     * @memberof VehicleTaxDto
     */
    'countries'?: Array<GeneralCountryDto> | null;
    /**
     * 
     * @type {Array<TaxType>}
     * @memberof VehicleTaxDto
     */
    'taxTypes'?: Array<TaxType> | null;
    /**
     * 
     * @type {Array<VehicleFuelType>}
     * @memberof VehicleTaxDto
     */
    'fuelTypes'?: Array<VehicleFuelType> | null;
    /**
     * 
     * @type {VehicleTaxReducedDto}
     * @memberof VehicleTaxDto
     */
    'reducedForPurchase'?: VehicleTaxReducedDto;
    /**
     * 
     * @type {VehicleTaxReducedDto}
     * @memberof VehicleTaxDto
     */
    'reducedForRental'?: VehicleTaxReducedDto;
    /**
     * 
     * @type {VehicleTaxFixedFreeValueDto}
     * @memberof VehicleTaxDto
     */
    'fixedFreeValueForPurchase'?: VehicleTaxFixedFreeValueDto;
    /**
     * 
     * @type {VehicleTaxFixedFreeValueDto}
     * @memberof VehicleTaxDto
     */
    'fixedFreeValueForRental'?: VehicleTaxFixedFreeValueDto;
}


/**
 * 
 * @export
 * @interface VehicleTaxFixedFreeValueDto
 */
export interface VehicleTaxFixedFreeValueDto {
    /**
     * 
     * @type {GeneralPriceDto}
     * @memberof VehicleTaxFixedFreeValueDto
     */
    'fixedFreeValue'?: GeneralPriceDto;
}
/**
 * 
 * @export
 * @interface VehicleTaxFixedFreeValueInputDto
 */
export interface VehicleTaxFixedFreeValueInputDto {
    /**
     * 
     * @type {GeneralPriceInputDto}
     * @memberof VehicleTaxFixedFreeValueInputDto
     */
    'fixedFreeValue'?: GeneralPriceInputDto;
}
/**
 * 
 * @export
 * @interface VehicleTaxInputDto
 */
export interface VehicleTaxInputDto {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleTaxInputDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {VehicleTaxType}
     * @memberof VehicleTaxInputDto
     */
    'type'?: VehicleTaxType;
    /**
     * 
     * @type {Array<GeneralCountryInputDto>}
     * @memberof VehicleTaxInputDto
     */
    'countries'?: Array<GeneralCountryInputDto> | null;
    /**
     * 
     * @type {Array<TaxType>}
     * @memberof VehicleTaxInputDto
     */
    'taxTypes'?: Array<TaxType> | null;
    /**
     * 
     * @type {Array<VehicleFuelType>}
     * @memberof VehicleTaxInputDto
     */
    'fuelTypes'?: Array<VehicleFuelType> | null;
    /**
     * 
     * @type {VehicleTaxReducedInputDto}
     * @memberof VehicleTaxInputDto
     */
    'reducedForPurchase'?: VehicleTaxReducedInputDto;
    /**
     * 
     * @type {VehicleTaxReducedInputDto}
     * @memberof VehicleTaxInputDto
     */
    'reducedForRental'?: VehicleTaxReducedInputDto;
    /**
     * 
     * @type {VehicleTaxFixedFreeValueInputDto}
     * @memberof VehicleTaxInputDto
     */
    'fixedFreeValueForPurchase'?: VehicleTaxFixedFreeValueInputDto;
    /**
     * 
     * @type {VehicleTaxFixedFreeValueInputDto}
     * @memberof VehicleTaxInputDto
     */
    'fixedFreeValueForRental'?: VehicleTaxFixedFreeValueInputDto;
}


/**
 * 
 * @export
 * @interface VehicleTaxReducedDto
 */
export interface VehicleTaxReducedDto {
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof VehicleTaxReducedDto
     */
    'reducedTax'?: GeneralTaxDto;
}
/**
 * 
 * @export
 * @interface VehicleTaxReducedInputDto
 */
export interface VehicleTaxReducedInputDto {
    /**
     * 
     * @type {GeneralTaxInputDto}
     * @memberof VehicleTaxReducedInputDto
     */
    'reducedTax'?: GeneralTaxInputDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleTaxType = {
    None: 'None',
    ReducedForPurchase: 'ReducedForPurchase',
    ReducedForRental: 'ReducedForRental',
    FixedFreeValueForPurchase: 'FixedFreeValueForPurchase',
    FixedFreeValueForRental: 'FixedFreeValueForRental'
} as const;

export type VehicleTaxType = typeof VehicleTaxType[keyof typeof VehicleTaxType];


/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleType = {
    None: 'None',
    Car: 'Car'
} as const;

export type VehicleType = typeof VehicleType[keyof typeof VehicleType];


/**
 * 
 * @export
 * @interface VehicleTypeChangedDto
 */
export interface VehicleTypeChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleTypeChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleTypeChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof VehicleTypeChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof VehicleTypeChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof VehicleTypeChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {VehicleTypeDto}
     * @memberof VehicleTypeChangedDto
     */
    'entity': VehicleTypeDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleTypeChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface VehicleTypeDto
 */
export interface VehicleTypeDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleTypeDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleTypeDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleTypeDto
     */
    'type'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof VehicleTypeDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleTypeDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleTypeDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleTypeDto
     */
    'sortOrder'?: number;
}


/**
 * 
 * @export
 * @interface VehicleTypeGetPaginatedDto
 */
export interface VehicleTypeGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleTypeGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleTypeGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleTypeGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleTypeGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleTypeGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleTypeGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof VehicleTypeGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof VehicleTypeGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof VehicleTypeGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleTypeGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}
/**
 * 
 * @export
 * @interface VehicleTypeReferenceDto
 */
export interface VehicleTypeReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleTypeReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleTypeReferenceDto
     */
    'type'?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof VehicleTypeReferenceDto
     */
    'name'?: string;
}


/**
 * 
 * @export
 * @interface VehicleVisualModelChangedDto
 */
export interface VehicleVisualModelChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleVisualModelChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof VehicleVisualModelChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof VehicleVisualModelChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {VehicleVisualModelDto}
     * @memberof VehicleVisualModelChangedDto
     */
    'entity': VehicleVisualModelDto;
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface VehicleVisualModelDto
 */
export interface VehicleVisualModelDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelDto
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelDto
     */
    'versionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleVisualModelDto
     */
    'isLatestVersion'?: boolean;
    /**
     * 
     * @type {VehicleVisualModelType}
     * @memberof VehicleVisualModelDto
     */
    'type'?: VehicleVisualModelType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof VehicleVisualModelDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {Array<VehicleBodyType>}
     * @memberof VehicleVisualModelDto
     */
    'bodyTypes'?: Array<VehicleBodyType> | null;
    /**
     * 
     * @type {Array<VehicleMakeReferenceDto>}
     * @memberof VehicleVisualModelDto
     */
    'makes'?: Array<VehicleMakeReferenceDto> | null;
    /**
     * 
     * @type {Array<VehicleModelReferenceDto>}
     * @memberof VehicleVisualModelDto
     */
    'models'?: Array<VehicleModelReferenceDto> | null;
    /**
     * 
     * @type {Array<VehicleGenerationReferenceDto>}
     * @memberof VehicleVisualModelDto
     */
    'generations'?: Array<VehicleGenerationReferenceDto> | null;
    /**
     * 
     * @type {Array<VehicleModificationReferenceDto>}
     * @memberof VehicleVisualModelDto
     */
    'modifications'?: Array<VehicleModificationReferenceDto> | null;
    /**
     * 
     * @type {Array<VehicleVisualModelImageDto>}
     * @memberof VehicleVisualModelDto
     */
    'images'?: Array<VehicleVisualModelImageDto>;
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleVisualModelDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleVisualModelDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleVisualModelDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {AdminVehicleVisualModelDtoVehicleTypesMap}
     * @memberof VehicleVisualModelDto
     */
    'vehicleTypesMap'?: AdminVehicleVisualModelDtoVehicleTypesMap;
    /**
     * 
     * @type {AdminVehicleVisualModelDtoBodyTypesMap}
     * @memberof VehicleVisualModelDto
     */
    'bodyTypesMap'?: AdminVehicleVisualModelDtoBodyTypesMap;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof VehicleVisualModelDto
     */
    'makeIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof VehicleVisualModelDto
     */
    'modelIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof VehicleVisualModelDto
     */
    'generationIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof VehicleVisualModelDto
     */
    'modificationIdsMap'?: { [key: string]: boolean; };
    /**
     * 
     * @type {Array<VehicleArea>}
     * @memberof VehicleVisualModelDto
     */
    'areas'?: Array<VehicleArea>;
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof VehicleVisualModelDto
     */
    'projections'?: Array<VehicleProjection>;
}


/**
 * 
 * @export
 * @interface VehicleVisualModelGetPaginatedDto
 */
export interface VehicleVisualModelGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {VehicleVisualModelType}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'type'?: VehicleVisualModelType;
    /**
     * 
     * @type {Array<VehicleType>}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'vehicleTypes'?: Array<VehicleType> | null;
    /**
     * 
     * @type {Array<VehicleBodyType>}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'bodyTypes'?: Array<VehicleBodyType> | null;
    /**
     * 
     * @type {Array<VehicleArea>}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'areas'?: Array<VehicleArea> | null;
    /**
     * 
     * @type {Array<VehicleProjection>}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'projections'?: Array<VehicleProjection> | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleVisualModelGetPaginatedDto
     */
    'isEnabled'?: boolean | null;
}


/**
 * 
 * @export
 * @interface VehicleVisualModelImageDto
 */
export interface VehicleVisualModelImageDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelImageDto
     */
    'id'?: string;
    /**
     * 
     * @type {VehicleArea}
     * @memberof VehicleVisualModelImageDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof VehicleVisualModelImageDto
     */
    'projection'?: VehicleProjection;
    /**
     * 
     * @type {FileReferenceDto}
     * @memberof VehicleVisualModelImageDto
     */
    'file'?: FileReferenceDto;
}


/**
 * 
 * @export
 * @interface VehicleVisualModelReferenceDto
 */
export interface VehicleVisualModelReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {VehicleVisualModelType}
     * @memberof VehicleVisualModelReferenceDto
     */
    'type'?: VehicleVisualModelType;
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelReferenceDto
     */
    'name'?: string;
}


/**
 * Describes data object that is stored in VehicleVisualModel SVG file -> \"<path />\" -> \"<desc />\" metadata node.
 * @export
 * @interface VehicleVisualModelSvgPathMetadataDto
 */
export interface VehicleVisualModelSvgPathMetadataDto {
    /**
     * 
     * @type {VehicleVisualModelSvgPathType}
     * @memberof VehicleVisualModelSvgPathMetadataDto
     */
    'pathType'?: VehicleVisualModelSvgPathType;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleVisualModelSvgPathMetadataDto
     */
    'vehicleType'?: VehicleType;
    /**
     * 
     * @type {VehicleArea}
     * @memberof VehicleVisualModelSvgPathMetadataDto
     */
    'vehicleArea'?: VehicleArea;
    /**
     * 
     * @type {VehicleProjection}
     * @memberof VehicleVisualModelSvgPathMetadataDto
     */
    'vehicleProjection'?: VehicleProjection;
    /**
     * 
     * @type {VehiclePartCategory}
     * @memberof VehicleVisualModelSvgPathMetadataDto
     */
    'vehiclePartCategory'?: VehiclePartCategory;
    /**
     * 
     * @type {Array<VehiclePartType>}
     * @memberof VehicleVisualModelSvgPathMetadataDto
     */
    'vehiclePartTypes'?: Array<VehiclePartType> | null;
    /**
     * 
     * @type {Array<VehiclePartDescriptor>}
     * @memberof VehicleVisualModelSvgPathMetadataDto
     */
    'vehiclePartDescriptors'?: Array<VehiclePartDescriptor> | null;
}


/**
 * Describes SVG path types in VehicleVisualModel SVG file.
 * @export
 * @enum {string}
 */

export const VehicleVisualModelSvgPathType = {
    None: 'None',
    VehiclePart: 'VehiclePart'
} as const;

export type VehicleVisualModelSvgPathType = typeof VehicleVisualModelSvgPathType[keyof typeof VehicleVisualModelSvgPathType];


/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleVisualModelType = {
    None: 'None',
    TwoDimensionalDivided: 'TwoDimensionalDivided'
} as const;

export type VehicleVisualModelType = typeof VehicleVisualModelType[keyof typeof VehicleVisualModelType];


/**
 * 
 * @export
 * @interface VersionDto
 */
export interface VersionDto {
    /**
     * 
     * @type {string}
     * @memberof VersionDto
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VisibilityStatus = {
    None: 'None',
    Visible: 'Visible',
    Hidden: 'Hidden'
} as const;

export type VisibilityStatus = typeof VisibilityStatus[keyof typeof VisibilityStatus];


/**
 * 
 * @export
 * @interface VisualInspectionAddToContractDto
 */
export interface VisualInspectionAddToContractDto {
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionAddToContractDto
     */
    'contractId'?: string;
}
/**
 * 
 * @export
 * @interface VisualInspectionAreaSettingsDto
 */
export interface VisualInspectionAreaSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionAreaSettingsDto
     */
    'id'?: string;
    /**
     * 
     * @type {VehicleArea}
     * @memberof VisualInspectionAreaSettingsDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {boolean}
     * @memberof VisualInspectionAreaSettingsDto
     */
    'isRequired'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionAreaSettingsDto
     */
    'minAttachmentCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionAreaSettingsDto
     */
    'minPhotoCount'?: number | null;
}


/**
 * 
 * @export
 * @interface VisualInspectionAreaSettingsInputDto
 */
export interface VisualInspectionAreaSettingsInputDto {
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionAreaSettingsInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {VehicleArea}
     * @memberof VisualInspectionAreaSettingsInputDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {boolean}
     * @memberof VisualInspectionAreaSettingsInputDto
     */
    'isRequired'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionAreaSettingsInputDto
     */
    'minAttachmentCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionAreaSettingsInputDto
     */
    'minPhotoCount'?: number | null;
}


/**
 * 
 * @export
 * @interface VisualInspectionChangedDto
 */
export interface VisualInspectionChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VisualInspectionChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof VisualInspectionChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof VisualInspectionChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {VisualInspectionDto}
     * @memberof VisualInspectionChangedDto
     */
    'entity': VisualInspectionDto;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface VisualInspectionContentDto
 */
export interface VisualInspectionContentDto {
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionContentDto
     */
    'vehicleId'?: string;
}
/**
 * 
 * @export
 * @interface VisualInspectionContentInputDto
 */
export interface VisualInspectionContentInputDto {
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionContentInputDto
     */
    'vehicleId'?: string;
}
/**
 * 
 * @export
 * @interface VisualInspectionCountersDto
 */
export interface VisualInspectionCountersDto {
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionCountersDto
     */
    'version'?: string;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionCountersDto
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface VisualInspectionCreateDto
 */
export interface VisualInspectionCreateDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VisualInspectionCreateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VisualInspectionCreateDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionCreateDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionCreateDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionCreateDto
     */
    'externalNumber'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VisualInspectionCreateDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorInputDto}
     * @memberof VisualInspectionCreateDto
     */
    'inspector'?: GeneralInspectorInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof VisualInspectionCreateDto
     */
    'isUseSupplierBranding'?: boolean;
    /**
     * 
     * @type {VehicleMileageInputDto}
     * @memberof VisualInspectionCreateDto
     */
    'mileage'?: VehicleMileageInputDto;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionCreateDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionCreateDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<VisualInspectionItemInputDto>}
     * @memberof VisualInspectionCreateDto
     */
    'items'?: Array<VisualInspectionItemInputDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof VisualInspectionCreateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {VisualInspectionSettingsInputDto}
     * @memberof VisualInspectionCreateDto
     */
    'settings'?: VisualInspectionSettingsInputDto;
    /**
     * 
     * @type {TenantRequestsMetaInputDto}
     * @memberof VisualInspectionCreateDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaInputDto;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof VisualInspectionCreateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}
/**
 * 
 * @export
 * @interface VisualInspectionDto
 */
export interface VisualInspectionDto {
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof VisualInspectionDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VisualInspectionDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VisualInspectionDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VisualInspectionDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VisualInspectionDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof VisualInspectionDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {ContractReferenceDto}
     * @memberof VisualInspectionDto
     */
    'contract'?: ContractReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {AssignmentReferenceDto}
     * @memberof VisualInspectionDto
     */
    'assignment'?: AssignmentReferenceDto;
    /**
     * 
     * @type {FrontEndAppType}
     * @memberof VisualInspectionDto
     */
    'appType'?: FrontEndAppType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VisualInspectionDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorDto}
     * @memberof VisualInspectionDto
     */
    'inspector'?: GeneralInspectorDto;
    /**
     * 
     * @type {boolean}
     * @memberof VisualInspectionDto
     */
    'isUseSupplierBranding'?: boolean;
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof VisualInspectionDto
     */
    'mileage'?: VehicleMileageDto;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<VisualInspectionItemDto>}
     * @memberof VisualInspectionDto
     */
    'items'?: Array<VisualInspectionItemDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof VisualInspectionDto
     */
    'attachments'?: Array<GeneralAttachmentDto> | null;
    /**
     * 
     * @type {VisualInspectionSettingsDto}
     * @memberof VisualInspectionDto
     */
    'settings'?: VisualInspectionSettingsDto;
    /**
     * 
     * @type {GeneralDeferredValueDtoOfVehicleInsightsDto}
     * @memberof VisualInspectionDto
     */
    'vehicleInsights'?: GeneralDeferredValueDtoOfVehicleInsightsDto;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof VisualInspectionDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {DataGrantsMetaDto}
     * @memberof VisualInspectionDto
     */
    'grantsMeta'?: DataGrantsMetaDto;
    /**
     * 
     * @type {TenantRequestsMetaDto}
     * @memberof VisualInspectionDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof VisualInspectionDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {Array<VehicleArea>}
     * @memberof VisualInspectionDto
     */
    'areas'?: Array<VehicleArea>;
    /**
     * 
     * @type {VisualInspectionDtoAreasMap}
     * @memberof VisualInspectionDto
     */
    'areasMap'?: VisualInspectionDtoAreasMap;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof VisualInspectionDto
     */
    'tenantRequestIdsMap'?: { [key: string]: boolean; } | null;
}


/**
 * 
 * @export
 * @interface VisualInspectionDtoAreasMap
 */
export interface VisualInspectionDtoAreasMap {
    /**
     * 
     * @type {boolean}
     * @memberof VisualInspectionDtoAreasMap
     */
    'None'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VisualInspectionDtoAreasMap
     */
    'Exterior'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VisualInspectionDtoAreasMap
     */
    'Interior'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VisualInspectionDtoAreasMap
     */
    'Internal'?: boolean;
}
/**
 * 
 * @export
 * @interface VisualInspectionGetCreateMetaDto
 */
export interface VisualInspectionGetCreateMetaDto {
    /**
     * 
     * @type {VisualInspectionSettingsDto}
     * @memberof VisualInspectionGetCreateMetaDto
     */
    'settings'?: VisualInspectionSettingsDto;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionGetCreateMetaDto
     */
    'attachmentMaxCount'?: number;
}
/**
 * 
 * @export
 * @interface VisualInspectionGetPaginatedDto
 */
export interface VisualInspectionGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'assignmentId'?: string | null;
    /**
     * 
     * @type {VehicleArea}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {Array<VehicleArea>}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'areas'?: Array<VehicleArea> | null;
    /**
     * 
     * @type {TenantRequestsMetaQueryDto}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof VisualInspectionGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * 
 * @export
 * @interface VisualInspectionItemDto
 */
export interface VisualInspectionItemDto {
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {VehicleArea}
     * @memberof VisualInspectionItemDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionItemDto
     */
    'minPhotos'?: number;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof VisualInspectionItemDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
}


/**
 * 
 * @export
 * @interface VisualInspectionItemInputDto
 */
export interface VisualInspectionItemInputDto {
    /**
     * 
     * @type {VehicleArea}
     * @memberof VisualInspectionItemInputDto
     */
    'area'?: VehicleArea;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof VisualInspectionItemInputDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto>;
}


/**
 * 
 * @export
 * @interface VisualInspectionReferenceDto
 */
export interface VisualInspectionReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionReferenceDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionReferenceDto
     */
    'vehicleId'?: string;
}
/**
 * 
 * @export
 * @interface VisualInspectionResultDto
 */
export interface VisualInspectionResultDto {
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionResultDto
     */
    'visualInspectionId'?: string;
}
/**
 * 
 * @export
 * @interface VisualInspectionResultInputDto
 */
export interface VisualInspectionResultInputDto {
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionResultInputDto
     */
    'visualInspectionId'?: string;
}
/**
 * 
 * @export
 * @interface VisualInspectionSettingsDto
 */
export interface VisualInspectionSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionSettingsDto
     */
    'id'?: string;
    /**
     * 
     * @type {Array<VisualInspectionAreaSettingsDto>}
     * @memberof VisualInspectionSettingsDto
     */
    'perArea'?: Array<VisualInspectionAreaSettingsDto> | null;
}
/**
 * 
 * @export
 * @interface VisualInspectionSettingsInputDto
 */
export interface VisualInspectionSettingsInputDto {
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionSettingsInputDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {Array<VisualInspectionAreaSettingsInputDto>}
     * @memberof VisualInspectionSettingsInputDto
     */
    'perArea'?: Array<VisualInspectionAreaSettingsInputDto> | null;
}
/**
 * 
 * @export
 * @interface VisualInspectionUpdateDto
 */
export interface VisualInspectionUpdateDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VisualInspectionUpdateDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VisualInspectionUpdateDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionUpdateDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionUpdateDto
     */
    'externalNumber'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof VisualInspectionUpdateDto
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {GeneralInspectorInputDto}
     * @memberof VisualInspectionUpdateDto
     */
    'inspector'?: GeneralInspectorInputDto;
    /**
     * 
     * @type {boolean}
     * @memberof VisualInspectionUpdateDto
     */
    'isUseSupplierBranding'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VisualInspectionUpdateDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VisualInspectionUpdateDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<VisualInspectionItemInputDto>}
     * @memberof VisualInspectionUpdateDto
     */
    'items'?: Array<VisualInspectionItemInputDto>;
    /**
     * 
     * @type {Array<GeneralAttachmentInputDto>}
     * @memberof VisualInspectionUpdateDto
     */
    'attachments'?: Array<GeneralAttachmentInputDto> | null;
    /**
     * 
     * @type {VisualInspectionSettingsInputDto}
     * @memberof VisualInspectionUpdateDto
     */
    'settings'?: VisualInspectionSettingsInputDto;
    /**
     * 
     * @type {GeneralAttachedTagsInputDto}
     * @memberof VisualInspectionUpdateDto
     */
    'tags'?: GeneralAttachedTagsInputDto;
}
/**
 * 
 * @export
 * @interface WashChangedDto
 */
export interface WashChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof WashChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof WashChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof WashChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof WashChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof WashChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {WashDto}
     * @memberof WashChangedDto
     */
    'entity': WashDto;
    /**
     * 
     * @type {string}
     * @memberof WashChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface WashContentDto
 */
export interface WashContentDto {
    /**
     * 
     * @type {string}
     * @memberof WashContentDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof WashContentDto
     */
    'currency'?: GeneralCurrencyDto;
}
/**
 * 
 * @export
 * @interface WashContentInputDto
 */
export interface WashContentInputDto {
    /**
     * 
     * @type {string}
     * @memberof WashContentInputDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof WashContentInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
}
/**
 * 
 * @export
 * @interface WashCountersDto
 */
export interface WashCountersDto {
    /**
     * 
     * @type {string}
     * @memberof WashCountersDto
     */
    'version'?: string;
    /**
     * 
     * @type {number}
     * @memberof WashCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof WashCountersDto
     */
    'draftCount': number;
    /**
     * 
     * @type {number}
     * @memberof WashCountersDto
     */
    'inProgressCount': number;
    /**
     * 
     * @type {number}
     * @memberof WashCountersDto
     */
    'completedCount': number;
}
/**
 * 
 * @export
 * @interface WashDto
 */
export interface WashDto {
    /**
     * 
     * @type {string}
     * @memberof WashDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof WashDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WashDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WashDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof WashDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WashDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WashDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WashDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WashDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof WashDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof WashDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof WashDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof WashDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {SupplierReferenceDto}
     * @memberof WashDto
     */
    'supplier'?: SupplierReferenceDto;
    /**
     * 
     * @type {AssignmentReferenceDto}
     * @memberof WashDto
     */
    'assignment'?: AssignmentReferenceDto;
    /**
     * 
     * @type {GeneralEntitySourceDto}
     * @memberof WashDto
     */
    'source'?: GeneralEntitySourceDto;
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof WashDto
     */
    'mileage'?: VehicleMileageDto;
    /**
     * 
     * @type {number}
     * @memberof WashDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {Array<WashType>}
     * @memberof WashDto
     */
    'types'?: Array<WashType> | null;
    /**
     * 
     * @type {WashScheduleType}
     * @memberof WashDto
     */
    'scheduleType'?: WashScheduleType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WashDto
     */
    'scheduledAt'?: string | null;
    /**
     * 
     * @type {GeneralStageHistoryDtoOfWashStage}
     * @memberof WashDto
     */
    'stageHistory'?: GeneralStageHistoryDtoOfWashStage;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof WashDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {number}
     * @memberof WashDto
     */
    'price'?: number;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof WashDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof WashDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof WashDto
     */
    'responsibleUser'?: GeneralByWhoDto;
    /**
     * 
     * @type {string}
     * @memberof WashDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof WashDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof WashDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof WashDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
    /**
     * 
     * @type {TenantRequestsMetaDto}
     * @memberof WashDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof WashDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {number}
     * @memberof WashDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof WashDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof WashDto
     */
    'total'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WashDto
     */
    'draftAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WashDto
     */
    'inProgressAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WashDto
     */
    'completedAt'?: string | null;
}


/**
 * 
 * @export
 * @interface WashGetPaginatedDto
 */
export interface WashGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof WashGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof WashGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof WashGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WashGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WashGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WashGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof WashGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof WashGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof WashGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof WashGetPaginatedDto
     */
    'id'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof WashGetPaginatedDto
     */
    'createdAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof WashGetPaginatedDto
     */
    'updatedAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof WashGetPaginatedDto
     */
    'createdBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof WashGetPaginatedDto
     */
    'updatedBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {string}
     * @memberof WashGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WashGetPaginatedDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WashGetPaginatedDto
     */
    'contractId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WashGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WashGetPaginatedDto
     */
    'supplierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WashGetPaginatedDto
     */
    'assignmentId'?: string | null;
    /**
     * 
     * @type {WashStage}
     * @memberof WashGetPaginatedDto
     */
    'stage'?: WashStage;
    /**
     * 
     * @type {Array<WashType>}
     * @memberof WashGetPaginatedDto
     */
    'types'?: Array<WashType> | null;
    /**
     * 
     * @type {WashScheduleType}
     * @memberof WashGetPaginatedDto
     */
    'scheduleType'?: WashScheduleType;
    /**
     * 
     * @type {TenantRequestsMetaQueryDto}
     * @memberof WashGetPaginatedDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof WashGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * 
 * @export
 * @interface WashReferenceDto
 */
export interface WashReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof WashReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof WashReferenceDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WashReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof WashReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface WashResultDto
 */
export interface WashResultDto {
    /**
     * 
     * @type {string}
     * @memberof WashResultDto
     */
    'washId'?: string;
}
/**
 * 
 * @export
 * @interface WashResultInputDto
 */
export interface WashResultInputDto {
    /**
     * 
     * @type {string}
     * @memberof WashResultInputDto
     */
    'washId'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WashScheduleType = {
    None: 'None',
    Scheduled: 'Scheduled',
    Unscheduled: 'Unscheduled'
} as const;

export type WashScheduleType = typeof WashScheduleType[keyof typeof WashScheduleType];


/**
 * NB: use SortOrderAttribute to specify the order in which stages can be activated.
 * @export
 * @enum {string}
 */

export const WashStage = {
    None: 'None',
    Draft: 'Draft',
    InProgress: 'InProgress',
    Completed: 'Completed'
} as const;

export type WashStage = typeof WashStage[keyof typeof WashStage];


/**
 * 
 * @export
 * @enum {string}
 */

export const WashType = {
    None: 'None',
    External: 'External',
    Internal: 'Internal',
    DryCleaning: 'DryCleaning',
    Detailing: 'Detailing',
    Polishing: 'Polishing',
    Other: 'Other'
} as const;

export type WashType = typeof WashType[keyof typeof WashType];


/**
 * 
 * @export
 * @interface WebPushChannelInfoDto
 */
export interface WebPushChannelInfoDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof WebPushChannelInfoDto
     */
    'deviceTokens'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WebPushChannelInfoDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebPushChannelInfoDto
     */
    'body'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebPushChannelInfoDto
     */
    'imageUrl'?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof WebPushChannelInfoDto
     */
    'data'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface WebPushWebhookDto
 */
export interface WebPushWebhookDto {
    /**
     * 
     * @type {string}
     * @memberof WebPushWebhookDto
     */
    'messageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebPushWebhookDto
     */
    'messageStatus'?: string;
}
/**
 * 
 * @export
 * @interface WebhookActivationDto
 */
export interface WebhookActivationDto {
    /**
     * 
     * @type {string}
     * @memberof WebhookActivationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookActivationDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {WebhookReference}
     * @memberof WebhookActivationDto
     */
    'webhook'?: WebhookReference;
    /**
     * 
     * @type {WebhookEventType}
     * @memberof WebhookActivationDto
     */
    'eventType'?: WebhookEventType;
    /**
     * 
     * @type {WebhookActivationStatus}
     * @memberof WebhookActivationDto
     */
    'status'?: WebhookActivationStatus;
    /**
     * 
     * @type {string}
     * @memberof WebhookActivationDto
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebhookActivationDto
     */
    'jsonPayload'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WebhookActivationDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WebhookActivationDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookActivationDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebhookActivationDto
     */
    'updatedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface WebhookActivationGetPaginatedDto
 */
export interface WebhookActivationGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof WebhookActivationGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof WebhookActivationGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof WebhookActivationGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebhookActivationGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebhookActivationGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebhookActivationGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof WebhookActivationGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof WebhookActivationGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof WebhookActivationGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof WebhookActivationGetPaginatedDto
     */
    'webhookId'?: string | null;
    /**
     * 
     * @type {WebhookEventType}
     * @memberof WebhookActivationGetPaginatedDto
     */
    'eventType'?: WebhookEventType;
    /**
     * 
     * @type {WebhookActivationStatus}
     * @memberof WebhookActivationGetPaginatedDto
     */
    'status'?: WebhookActivationStatus;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const WebhookActivationStatus = {
    None: 'None',
    New: 'New',
    Processing: 'Processing',
    Success: 'Success',
    Failed: 'Failed',
    Cancelled: 'Cancelled'
} as const;

export type WebhookActivationStatus = typeof WebhookActivationStatus[keyof typeof WebhookActivationStatus];


/**
 * 
 * @export
 * @interface WebhookDto
 */
export interface WebhookDto {
    /**
     * 
     * @type {string}
     * @memberof WebhookDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<WebhookEventType>}
     * @memberof WebhookDto
     */
    'eventTypes'?: Array<WebhookEventType>;
    /**
     * 
     * @type {string}
     * @memberof WebhookDto
     */
    'url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WebhookDto
     */
    'isEnabled'?: boolean;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WebhookDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WebhookDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebhookDto
     */
    'updatedBy'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WebhookEventType = {
    None: 'None',
    ContractVehicleAllocated: 'ContractVehicleAllocated',
    ContractCheckIn: 'ContractCheckIn',
    ContractCheckOut: 'ContractCheckOut',
    Test: 'Test'
} as const;

export type WebhookEventType = typeof WebhookEventType[keyof typeof WebhookEventType];


/**
 * 
 * @export
 * @interface WebhookGetPaginatedDto
 */
export interface WebhookGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof WebhookGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof WebhookGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof WebhookGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebhookGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebhookGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebhookGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof WebhookGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof WebhookGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof WebhookGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {Array<WebhookEventType>}
     * @memberof WebhookGetPaginatedDto
     */
    'eventTypes'?: Array<WebhookEventType> | null;
}
/**
 * 
 * @export
 * @interface WebhookReference
 */
export interface WebhookReference {
    /**
     * 
     * @type {string}
     * @memberof WebhookReference
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof WebhookReference
     */
    'formTypeOrDefault'?: EntityFormType;
    /**
     * 
     * @type {EntityFormType}
     * @memberof WebhookReference
     */
    'formType'?: EntityFormType;
    /**
     * 
     * @type {string}
     * @memberof WebhookReference
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookReference
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookReference
     */
    'localNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookReference
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookReference
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<WebhookEventType>}
     * @memberof WebhookReference
     */
    'eventTypes'?: Array<WebhookEventType>;
}


/**
 * 
 * @export
 * @interface WheelOperationChangedDto
 */
export interface WheelOperationChangedDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof WheelOperationChangedDto
     */
    'connectionIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationChangedDto
     */
    'groupName'?: string | null;
    /**
     * 
     * @type {EntityChangeType}
     * @memberof WheelOperationChangedDto
     */
    'changeType': EntityChangeType;
    /**
     * 
     * @type {EntityType}
     * @memberof WheelOperationChangedDto
     */
    'entityType': EntityType;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationChangedDto
     */
    'entityId': string;
    /**
     * 
     * @type {WheelOperationDto}
     * @memberof WheelOperationChangedDto
     */
    'entity': WheelOperationDto;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationChangedDto
     */
    'tenantId': string | null;
}


/**
 * 
 * @export
 * @interface WheelOperationContentDto
 */
export interface WheelOperationContentDto {
    /**
     * 
     * @type {string}
     * @memberof WheelOperationContentDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof WheelOperationContentDto
     */
    'currency'?: GeneralCurrencyDto;
}
/**
 * 
 * @export
 * @interface WheelOperationContentInputDto
 */
export interface WheelOperationContentInputDto {
    /**
     * 
     * @type {string}
     * @memberof WheelOperationContentInputDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {GeneralCurrencyInputDto}
     * @memberof WheelOperationContentInputDto
     */
    'currency'?: GeneralCurrencyInputDto;
}
/**
 * 
 * @export
 * @interface WheelOperationCountersDto
 */
export interface WheelOperationCountersDto {
    /**
     * 
     * @type {string}
     * @memberof WheelOperationCountersDto
     */
    'version'?: string;
    /**
     * 
     * @type {number}
     * @memberof WheelOperationCountersDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof WheelOperationCountersDto
     */
    'draftCount': number;
    /**
     * 
     * @type {number}
     * @memberof WheelOperationCountersDto
     */
    'inProgressCount': number;
    /**
     * 
     * @type {number}
     * @memberof WheelOperationCountersDto
     */
    'completedCount': number;
}
/**
 * 
 * @export
 * @interface WheelOperationDto
 */
export interface WheelOperationDto {
    /**
     * 
     * @type {string}
     * @memberof WheelOperationDto
     */
    'id'?: string;
    /**
     * 
     * @type {EntityFormType}
     * @memberof WheelOperationDto
     */
    'formType'?: EntityFormType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WheelOperationDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WheelOperationDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WheelOperationDto
     */
    'departmentIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WheelOperationDto
     */
    'locationIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationDto
     */
    'localNumber'?: string;
    /**
     * 
     * @type {VehicleReferenceDto}
     * @memberof WheelOperationDto
     */
    'vehicle'?: VehicleReferenceDto;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationDto
     */
    'externalNumber'?: string | null;
    /**
     * 
     * @type {SupplierReferenceDto}
     * @memberof WheelOperationDto
     */
    'supplier'?: SupplierReferenceDto;
    /**
     * 
     * @type {AssignmentReferenceDto}
     * @memberof WheelOperationDto
     */
    'assignment'?: AssignmentReferenceDto;
    /**
     * 
     * @type {GeneralByWhoDto}
     * @memberof WheelOperationDto
     */
    'responsibleUser'?: GeneralByWhoDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WheelOperationDto
     */
    'scheduledAt'?: string | null;
    /**
     * 
     * @type {WheelOperationScheduleType}
     * @memberof WheelOperationDto
     */
    'scheduleType'?: WheelOperationScheduleType;
    /**
     * 
     * @type {Array<WheelServiceType>}
     * @memberof WheelOperationDto
     */
    'serviceTypes'?: Array<WheelServiceType>;
    /**
     * 
     * @type {GeneralStageHistoryDtoOfWheelOperationStage}
     * @memberof WheelOperationDto
     */
    'stageHistory'?: GeneralStageHistoryDtoOfWheelOperationStage;
    /**
     * 
     * @type {VehicleMileageDto}
     * @memberof WheelOperationDto
     */
    'mileage'?: VehicleMileageDto;
    /**
     * 
     * @type {number}
     * @memberof WheelOperationDto
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WheelOperationDto
     */
    'price'?: number | null;
    /**
     * 
     * @type {GeneralDiscountDto}
     * @memberof WheelOperationDto
     */
    'discount'?: GeneralDiscountDto;
    /**
     * 
     * @type {GeneralTaxDto}
     * @memberof WheelOperationDto
     */
    'tax'?: GeneralTaxDto;
    /**
     * 
     * @type {GeneralCurrencyDto}
     * @memberof WheelOperationDto
     */
    'currency'?: GeneralCurrencyDto;
    /**
     * 
     * @type {Array<GeneralAttachmentDto>}
     * @memberof WheelOperationDto
     */
    'attachments'?: Array<GeneralAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {UserUnseenInfoDto}
     * @memberof WheelOperationDto
     */
    'myUnseen'?: UserUnseenInfoDto;
    /**
     * 
     * @type {DataGrantsMetaBriefDto}
     * @memberof WheelOperationDto
     */
    'grantsMeta'?: DataGrantsMetaBriefDto;
    /**
     * 
     * @type {TenantRequestsMetaDto}
     * @memberof WheelOperationDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaDto;
    /**
     * 
     * @type {GeneralAttachedTagsDto}
     * @memberof WheelOperationDto
     */
    'tags'?: GeneralAttachedTagsDto;
    /**
     * 
     * @type {number}
     * @memberof WheelOperationDto
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof WheelOperationDto
     */
    'subTotalIncDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof WheelOperationDto
     */
    'total'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WheelOperationDto
     */
    'draftAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WheelOperationDto
     */
    'inProgressAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WheelOperationDto
     */
    'completedAt'?: string | null;
}


/**
 * 
 * @export
 * @interface WheelOperationGetPaginatedDto
 */
export interface WheelOperationGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof WheelOperationGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof WheelOperationGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WheelOperationGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WheelOperationGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WheelOperationGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof WheelOperationGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof WheelOperationGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof WheelOperationGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof WheelOperationGetPaginatedDto
     */
    'id'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof WheelOperationGetPaginatedDto
     */
    'createdAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset}
     * @memberof WheelOperationGetPaginatedDto
     */
    'updatedAt'?: FieldFilterOfPrimitiveDtoOfNullableOfDateTimeOffset;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof WheelOperationGetPaginatedDto
     */
    'createdBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {FieldFilterOfPrimitiveDtoOfString}
     * @memberof WheelOperationGetPaginatedDto
     */
    'updatedBy'?: FieldFilterOfPrimitiveDtoOfString;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationGetPaginatedDto
     */
    'departmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationGetPaginatedDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationGetPaginatedDto
     */
    'supplierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationGetPaginatedDto
     */
    'assignmentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationGetPaginatedDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {WheelOperationStage}
     * @memberof WheelOperationGetPaginatedDto
     */
    'stage'?: WheelOperationStage;
    /**
     * 
     * @type {WheelOperationScheduleType}
     * @memberof WheelOperationGetPaginatedDto
     */
    'scheduleType'?: WheelOperationScheduleType;
    /**
     * 
     * @type {Array<WheelServiceType>}
     * @memberof WheelOperationGetPaginatedDto
     */
    'serviceTypes'?: Array<WheelServiceType> | null;
    /**
     * 
     * @type {TenantRequestsMetaQueryDto}
     * @memberof WheelOperationGetPaginatedDto
     */
    'tenantRequestsMeta'?: TenantRequestsMetaQueryDto;
    /**
     * 
     * @type {TagStaticFilterDto}
     * @memberof WheelOperationGetPaginatedDto
     */
    'tags'?: TagStaticFilterDto;
}


/**
 * 
 * @export
 * @interface WheelOperationReferenceDto
 */
export interface WheelOperationReferenceDto {
    /**
     * 
     * @type {string}
     * @memberof WheelOperationReferenceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationReferenceDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationReferenceDto
     */
    'vehicleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationReferenceDto
     */
    'globalNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof WheelOperationReferenceDto
     */
    'localNumber'?: string;
}
/**
 * 
 * @export
 * @interface WheelOperationResultDto
 */
export interface WheelOperationResultDto {
    /**
     * 
     * @type {string}
     * @memberof WheelOperationResultDto
     */
    'wheelOperationId'?: string;
}
/**
 * 
 * @export
 * @interface WheelOperationResultInputDto
 */
export interface WheelOperationResultInputDto {
    /**
     * 
     * @type {string}
     * @memberof WheelOperationResultInputDto
     */
    'wheelOperationId'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WheelOperationScheduleType = {
    None: 'None',
    Scheduled: 'Scheduled',
    Preventive: 'Preventive',
    Unscheduled: 'Unscheduled'
} as const;

export type WheelOperationScheduleType = typeof WheelOperationScheduleType[keyof typeof WheelOperationScheduleType];


/**
 * 
 * @export
 * @enum {string}
 */

export const WheelOperationStage = {
    None: 'None',
    Draft: 'Draft',
    InProgress: 'InProgress',
    Completed: 'Completed'
} as const;

export type WheelOperationStage = typeof WheelOperationStage[keyof typeof WheelOperationStage];


/**
 * 
 * @export
 * @enum {string}
 */

export const WheelServiceType = {
    None: 'None',
    SeasonalChange: 'SeasonalChange',
    TireChange: 'TireChange',
    TireRepair: 'TireRepair',
    DiskRepair: 'DiskRepair',
    Balancing: 'Balancing',
    Other: 'Other'
} as const;

export type WheelServiceType = typeof WheelServiceType[keyof typeof WheelServiceType];


/**
 * 
 * @export
 * @enum {string}
 */

export const WhoType = {
    None: 'None',
    System: 'System',
    User: 'User'
} as const;

export type WhoType = typeof WhoType[keyof typeof WhoType];


/**
 * 
 * @export
 * @interface WidgetDataBaseDto
 */
export interface WidgetDataBaseDto {
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof WidgetDataBaseDto
     */
    'recomputeFrequency': string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WidgetDataBaseDto
     */
    'computedAt'?: string;
}
/**
 * 
 * @export
 * @interface WidgetDataGetBaseDto
 */
export interface WidgetDataGetBaseDto {
    /**
     * 
     * @type {boolean}
     * @memberof WidgetDataGetBaseDto
     */
    'isRecompute'?: boolean;
}
/**
 * 
 * @export
 * @interface WidgetDataOfActiveOperationSummaryDto
 */
export interface WidgetDataOfActiveOperationSummaryDto {
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof WidgetDataOfActiveOperationSummaryDto
     */
    'recomputeFrequency': string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WidgetDataOfActiveOperationSummaryDto
     */
    'computedAt'?: string;
    /**
     * 
     * @type {CountDtoOfDamageCostEvaluationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto}
     * @memberof WidgetDataOfActiveOperationSummaryDto
     */
    'damageCostEvaluation': CountDtoOfDamageCostEvaluationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto;
    /**
     * 
     * @type {CountDtoOfRepairOperationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto}
     * @memberof WidgetDataOfActiveOperationSummaryDto
     */
    'repairOperation': CountDtoOfRepairOperationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto;
    /**
     * 
     * @type {CountDtoOfMaintenanceGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto}
     * @memberof WidgetDataOfActiveOperationSummaryDto
     */
    'maintenance': CountDtoOfMaintenanceGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto;
    /**
     * 
     * @type {CountDtoOfWashGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto}
     * @memberof WidgetDataOfActiveOperationSummaryDto
     */
    'wash': CountDtoOfWashGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto;
    /**
     * 
     * @type {CountDtoOfWheelOperationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto}
     * @memberof WidgetDataOfActiveOperationSummaryDto
     */
    'wheelOperation': CountDtoOfWheelOperationGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto;
    /**
     * 
     * @type {CountDtoOfTenantRequestGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto}
     * @memberof WidgetDataOfActiveOperationSummaryDto
     */
    'tenantRequest': CountDtoOfTenantRequestGetPaginatedDtoInWidgetDataOfActiveOperationSummaryDto;
}
/**
 * 
 * @export
 * @interface WidgetDataOfCostPerMonthSummaryDto
 */
export interface WidgetDataOfCostPerMonthSummaryDto {
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof WidgetDataOfCostPerMonthSummaryDto
     */
    'recomputeFrequency': string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WidgetDataOfCostPerMonthSummaryDto
     */
    'computedAt'?: string;
    /**
     * 
     * @type {DateRangeRequiredDto}
     * @memberof WidgetDataOfCostPerMonthSummaryDto
     */
    'range': DateRangeRequiredDto;
    /**
     * 
     * @type {string}
     * @memberof WidgetDataOfCostPerMonthSummaryDto
     */
    'tzId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WidgetDataOfCostPerMonthSummaryDto
     */
    'dataLabels': Array<string>;
    /**
     * 
     * @type {TotalPerMonthSummaryDto}
     * @memberof WidgetDataOfCostPerMonthSummaryDto
     */
    'damageCostEvaluation': TotalPerMonthSummaryDto;
    /**
     * 
     * @type {TotalPerMonthSummaryDto}
     * @memberof WidgetDataOfCostPerMonthSummaryDto
     */
    'repairOperation': TotalPerMonthSummaryDto;
    /**
     * 
     * @type {TotalPerMonthSummaryDto}
     * @memberof WidgetDataOfCostPerMonthSummaryDto
     */
    'maintenance': TotalPerMonthSummaryDto;
    /**
     * 
     * @type {TotalPerMonthSummaryDto}
     * @memberof WidgetDataOfCostPerMonthSummaryDto
     */
    'wash': TotalPerMonthSummaryDto;
    /**
     * 
     * @type {TotalPerMonthSummaryDto}
     * @memberof WidgetDataOfCostPerMonthSummaryDto
     */
    'wheelOperation': TotalPerMonthSummaryDto;
    /**
     * 
     * @type {TotalPerMonthSummaryDto}
     * @memberof WidgetDataOfCostPerMonthSummaryDto
     */
    'tenantToTenantOperationTotal': TotalPerMonthSummaryDto;
    /**
     * 
     * @type {TotalPerMonthSummaryDto}
     * @memberof WidgetDataOfCostPerMonthSummaryDto
     */
    'total': TotalPerMonthSummaryDto;
    /**
     * 
     * @type {number}
     * @memberof WidgetDataOfCostPerMonthSummaryDto
     */
    'totalSum'?: number;
}
/**
 * 
 * @export
 * @interface WidgetDataOfCostPerMonthSummaryGetDto
 */
export interface WidgetDataOfCostPerMonthSummaryGetDto {
    /**
     * 
     * @type {boolean}
     * @memberof WidgetDataOfCostPerMonthSummaryGetDto
     */
    'isRecompute'?: boolean;
    /**
     * 
     * @type {DateRangeRequiredInputDto}
     * @memberof WidgetDataOfCostPerMonthSummaryGetDto
     */
    'range': DateRangeRequiredInputDto;
}
/**
 * 
 * @export
 * @interface WidgetDataOfDamageAndIssueSummaryDto
 */
export interface WidgetDataOfDamageAndIssueSummaryDto {
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof WidgetDataOfDamageAndIssueSummaryDto
     */
    'recomputeFrequency': string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WidgetDataOfDamageAndIssueSummaryDto
     */
    'computedAt'?: string;
    /**
     * 
     * @type {CountDtoInWidgetDataOfDamageAndIssueSummaryDto}
     * @memberof WidgetDataOfDamageAndIssueSummaryDto
     */
    'vehicleWithDamageActual': CountDtoInWidgetDataOfDamageAndIssueSummaryDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfDamageAndIssueSummaryDto}
     * @memberof WidgetDataOfDamageAndIssueSummaryDto
     */
    'damageActual': CountDtoInWidgetDataOfDamageAndIssueSummaryDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfDamageAndIssueSummaryDto}
     * @memberof WidgetDataOfDamageAndIssueSummaryDto
     */
    'assessmentPending': CountDtoInWidgetDataOfDamageAndIssueSummaryDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfDamageAndIssueSummaryDto}
     * @memberof WidgetDataOfDamageAndIssueSummaryDto
     */
    'assessmentActionRequired': CountDtoInWidgetDataOfDamageAndIssueSummaryDto;
    /**
     * 
     * @type {number}
     * @memberof WidgetDataOfDamageAndIssueSummaryDto
     */
    'totalCount'?: number;
}
/**
 * 
 * @export
 * @interface WidgetDataOfTenantStatsAdminDto
 */
export interface WidgetDataOfTenantStatsAdminDto {
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'recomputeFrequency': string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'computedAt'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'tenantIds'?: Array<string>;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'vehicle': CountDtoInWidgetDataOfTenantStatsAdminDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'contract': CountDtoInWidgetDataOfTenantStatsAdminDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'assetSubscription': CountDtoInWidgetDataOfTenantStatsAdminDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'assessment': CountDtoInWidgetDataOfTenantStatsAdminDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'damageDetection': CountDtoInWidgetDataOfTenantStatsAdminDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'damageCostEvaluation': CountDtoInWidgetDataOfTenantStatsAdminDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'repair': CountDtoInWidgetDataOfTenantStatsAdminDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'visualInspection': CountDtoInWidgetDataOfTenantStatsAdminDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'maintenance': CountDtoInWidgetDataOfTenantStatsAdminDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'wheelOperation': CountDtoInWidgetDataOfTenantStatsAdminDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'wash': CountDtoInWidgetDataOfTenantStatsAdminDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'assignment': CountDtoInWidgetDataOfTenantStatsAdminDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'tenantConnection': CountDtoInWidgetDataOfTenantStatsAdminDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'tenantRequest': CountDtoInWidgetDataOfTenantStatsAdminDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfTenantStatsAdminDto}
     * @memberof WidgetDataOfTenantStatsAdminDto
     */
    'user': CountDtoInWidgetDataOfTenantStatsAdminDto;
}
/**
 * 
 * @export
 * @interface WidgetDataOfTenantStatsGetAdminDto
 */
export interface WidgetDataOfTenantStatsGetAdminDto {
    /**
     * 
     * @type {boolean}
     * @memberof WidgetDataOfTenantStatsGetAdminDto
     */
    'isRecompute'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WidgetDataOfTenantStatsGetAdminDto
     */
    'tenantId'?: string | null;
}
/**
 * 
 * @export
 * @interface WidgetDataOfTenantStatsTabularAdminDto
 */
export interface WidgetDataOfTenantStatsTabularAdminDto {
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof WidgetDataOfTenantStatsTabularAdminDto
     */
    'recomputeFrequency': string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WidgetDataOfTenantStatsTabularAdminDto
     */
    'computedAt'?: string;
    /**
     * 
     * @type {PaginationDtoOfTenantWithStatsDto}
     * @memberof WidgetDataOfTenantStatsTabularAdminDto
     */
    'paginated': PaginationDtoOfTenantWithStatsDto;
}
/**
 * 
 * @export
 * @interface WidgetDataOfTenantStatsTabularGetAdminDto
 */
export interface WidgetDataOfTenantStatsTabularGetAdminDto {
    /**
     * 
     * @type {boolean}
     * @memberof WidgetDataOfTenantStatsTabularGetAdminDto
     */
    'isRecompute'?: boolean;
    /**
     * 
     * @type {TenantGetPaginatedDto}
     * @memberof WidgetDataOfTenantStatsTabularGetAdminDto
     */
    'paginated'?: TenantGetPaginatedDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof WidgetDataOfTenantStatsTabularGetAdminDto
     */
    'tenantIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof WidgetDataOfTenantStatsTabularGetAdminDto
     */
    'range'?: DateRangeDto;
}
/**
 * 
 * @export
 * @interface WidgetDataOfVehicleInFlowSummaryDto
 */
export interface WidgetDataOfVehicleInFlowSummaryDto {
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof WidgetDataOfVehicleInFlowSummaryDto
     */
    'recomputeFrequency': string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WidgetDataOfVehicleInFlowSummaryDto
     */
    'computedAt'?: string;
    /**
     * 
     * @type {CountDtoInWidgetDataOfVehicleInFlowSummaryDto}
     * @memberof WidgetDataOfVehicleInFlowSummaryDto
     */
    'assetSubscriptionAwaitingAllocation': CountDtoInWidgetDataOfVehicleInFlowSummaryDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfVehicleInFlowSummaryDto}
     * @memberof WidgetDataOfVehicleInFlowSummaryDto
     */
    'vehicleReturning': CountDtoInWidgetDataOfVehicleInFlowSummaryDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfVehicleInFlowSummaryDto}
     * @memberof WidgetDataOfVehicleInFlowSummaryDto
     */
    'contractCanCheckOut': CountDtoInWidgetDataOfVehicleInFlowSummaryDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfVehicleInFlowSummaryDto}
     * @memberof WidgetDataOfVehicleInFlowSummaryDto
     */
    'contractCanCheckIn': CountDtoInWidgetDataOfVehicleInFlowSummaryDto;
    /**
     * 
     * @type {CountDtoInWidgetDataOfVehicleInFlowSummaryDto}
     * @memberof WidgetDataOfVehicleInFlowSummaryDto
     */
    'assessmentWithIssues': CountDtoInWidgetDataOfVehicleInFlowSummaryDto;
}
/**
 * 
 * @export
 * @interface WidgetDataOfVehicleStatusSummaryDto
 */
export interface WidgetDataOfVehicleStatusSummaryDto {
    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof WidgetDataOfVehicleStatusSummaryDto
     */
    'recomputeFrequency': string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof WidgetDataOfVehicleStatusSummaryDto
     */
    'computedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof WidgetDataOfVehicleStatusSummaryDto
     */
    'vehicleTotalCount': number;
    /**
     * 
     * @type {StatusCountSummaryDtoOfVehicleStatus}
     * @memberof WidgetDataOfVehicleStatusSummaryDto
     */
    'vehicleStatus': StatusCountSummaryDtoOfVehicleStatus;
}

/**
 * AccessoriesApi - axios parameter creator
 * @export
 */
export const AccessoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoriesAccessoryIdDelete: async (nexusOpsTenant: string, accessoryId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoriesAccessoryIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'accessoryId' is not null or undefined
            assertParamExists('apiV1AccessoriesAccessoryIdDelete', 'accessoryId', accessoryId)
            const localVarPath = `/api/v1/accessories/{accessoryId}`
                .replace(`{${"accessoryId"}}`, encodeURIComponent(String(accessoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoriesAccessoryIdGet: async (nexusOpsTenant: string, accessoryId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoriesAccessoryIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'accessoryId' is not null or undefined
            assertParamExists('apiV1AccessoriesAccessoryIdGet', 'accessoryId', accessoryId)
            const localVarPath = `/api/v1/accessories/{accessoryId}`
                .replace(`{${"accessoryId"}}`, encodeURIComponent(String(accessoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateAccessoryDto} [updateAccessoryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoriesAccessoryIdPut: async (nexusOpsTenant: string, accessoryId: string, nexusOpsAppVersion?: string, updateAccessoryDto?: UpdateAccessoryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoriesAccessoryIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'accessoryId' is not null or undefined
            assertParamExists('apiV1AccessoriesAccessoryIdPut', 'accessoryId', accessoryId)
            const localVarPath = `/api/v1/accessories/{accessoryId}`
                .replace(`{${"accessoryId"}}`, encodeURIComponent(String(accessoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccessoryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoriesBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoriesBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/accessories/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AccessoryGetPaginatedDto} [accessoryGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoriesGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, accessoryGetPaginatedDto?: AccessoryGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoriesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/accessories/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accessoryGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateAccessoryDto} [createAccessoryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoriesPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createAccessoryDto?: CreateAccessoryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoriesPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/accessories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAccessoryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated: Use /get.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AccessorySearchPaginatedDto} [accessorySearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1AccessoriesSearchPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, accessorySearchPaginatedDto?: AccessorySearchPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoriesSearchPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/accessories/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accessorySearchPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccessoriesApi - functional programming interface
 * @export
 */
export const AccessoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccessoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoriesAccessoryIdDelete(nexusOpsTenant: string, accessoryId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoriesAccessoryIdDelete(nexusOpsTenant, accessoryId, nexusOpsAppVersion, isDeleteCascade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoriesApi.apiV1AccessoriesAccessoryIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoriesAccessoryIdGet(nexusOpsTenant: string, accessoryId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoriesAccessoryIdGet(nexusOpsTenant, accessoryId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoriesApi.apiV1AccessoriesAccessoryIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateAccessoryDto} [updateAccessoryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoriesAccessoryIdPut(nexusOpsTenant: string, accessoryId: string, nexusOpsAppVersion?: string, updateAccessoryDto?: UpdateAccessoryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoriesAccessoryIdPut(nexusOpsTenant, accessoryId, nexusOpsAppVersion, updateAccessoryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoriesApi.apiV1AccessoriesAccessoryIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoriesBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoriesBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoriesApi.apiV1AccessoriesBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AccessoryGetPaginatedDto} [accessoryGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoriesGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, accessoryGetPaginatedDto?: AccessoryGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAccessoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoriesGetPost(nexusOpsTenant, nexusOpsAppVersion, accessoryGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoriesApi.apiV1AccessoriesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateAccessoryDto} [createAccessoryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoriesPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createAccessoryDto?: CreateAccessoryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoriesPost(nexusOpsTenant, nexusOpsAppVersion, createAccessoryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoriesApi.apiV1AccessoriesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deprecated: Use /get.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AccessorySearchPaginatedDto} [accessorySearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async apiV1AccessoriesSearchPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, accessorySearchPaginatedDto?: AccessorySearchPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAccessoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoriesSearchPost(nexusOpsTenant, nexusOpsAppVersion, accessorySearchPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoriesApi.apiV1AccessoriesSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccessoriesApi - factory interface
 * @export
 */
export const AccessoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccessoriesApiFp(configuration)
    return {
        /**
         * 
         * @param {AccessoriesApiApiV1AccessoriesAccessoryIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoriesAccessoryIdDelete(requestParameters: AccessoriesApiApiV1AccessoriesAccessoryIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AccessoriesAccessoryIdDelete(requestParameters.nexusOpsTenant, requestParameters.accessoryId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoriesApiApiV1AccessoriesAccessoryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoriesAccessoryIdGet(requestParameters: AccessoriesApiApiV1AccessoriesAccessoryIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccessoryDto> {
            return localVarFp.apiV1AccessoriesAccessoryIdGet(requestParameters.nexusOpsTenant, requestParameters.accessoryId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoriesApiApiV1AccessoriesAccessoryIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoriesAccessoryIdPut(requestParameters: AccessoriesApiApiV1AccessoriesAccessoryIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccessoryDto> {
            return localVarFp.apiV1AccessoriesAccessoryIdPut(requestParameters.nexusOpsTenant, requestParameters.accessoryId, requestParameters.nexusOpsAppVersion, requestParameters.updateAccessoryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoriesApiApiV1AccessoriesBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoriesBulkDeleteDelete(requestParameters: AccessoriesApiApiV1AccessoriesBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AccessoriesBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoriesApiApiV1AccessoriesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoriesGetPost(requestParameters: AccessoriesApiApiV1AccessoriesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAccessoryDto> {
            return localVarFp.apiV1AccessoriesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.accessoryGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoriesApiApiV1AccessoriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoriesPost(requestParameters: AccessoriesApiApiV1AccessoriesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccessoryDto> {
            return localVarFp.apiV1AccessoriesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createAccessoryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated: Use /get.
         * @param {AccessoriesApiApiV1AccessoriesSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1AccessoriesSearchPost(requestParameters: AccessoriesApiApiV1AccessoriesSearchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAccessoryDto> {
            return localVarFp.apiV1AccessoriesSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.accessorySearchPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AccessoriesAccessoryIdDelete operation in AccessoriesApi.
 * @export
 * @interface AccessoriesApiApiV1AccessoriesAccessoryIdDeleteRequest
 */
export interface AccessoriesApiApiV1AccessoriesAccessoryIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesAccessoryIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesAccessoryIdDelete
     */
    readonly accessoryId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesAccessoryIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof AccessoriesApiApiV1AccessoriesAccessoryIdDelete
     */
    readonly isDeleteCascade?: boolean
}

/**
 * Request parameters for apiV1AccessoriesAccessoryIdGet operation in AccessoriesApi.
 * @export
 * @interface AccessoriesApiApiV1AccessoriesAccessoryIdGetRequest
 */
export interface AccessoriesApiApiV1AccessoriesAccessoryIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesAccessoryIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesAccessoryIdGet
     */
    readonly accessoryId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesAccessoryIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AccessoriesAccessoryIdPut operation in AccessoriesApi.
 * @export
 * @interface AccessoriesApiApiV1AccessoriesAccessoryIdPutRequest
 */
export interface AccessoriesApiApiV1AccessoriesAccessoryIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesAccessoryIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesAccessoryIdPut
     */
    readonly accessoryId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesAccessoryIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateAccessoryDto}
     * @memberof AccessoriesApiApiV1AccessoriesAccessoryIdPut
     */
    readonly updateAccessoryDto?: UpdateAccessoryDto
}

/**
 * Request parameters for apiV1AccessoriesBulkDeleteDelete operation in AccessoriesApi.
 * @export
 * @interface AccessoriesApiApiV1AccessoriesBulkDeleteDeleteRequest
 */
export interface AccessoriesApiApiV1AccessoriesBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof AccessoriesApiApiV1AccessoriesBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1AccessoriesGetPost operation in AccessoriesApi.
 * @export
 * @interface AccessoriesApiApiV1AccessoriesGetPostRequest
 */
export interface AccessoriesApiApiV1AccessoriesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AccessoryGetPaginatedDto}
     * @memberof AccessoriesApiApiV1AccessoriesGetPost
     */
    readonly accessoryGetPaginatedDto?: AccessoryGetPaginatedDto
}

/**
 * Request parameters for apiV1AccessoriesPost operation in AccessoriesApi.
 * @export
 * @interface AccessoriesApiApiV1AccessoriesPostRequest
 */
export interface AccessoriesApiApiV1AccessoriesPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateAccessoryDto}
     * @memberof AccessoriesApiApiV1AccessoriesPost
     */
    readonly createAccessoryDto?: CreateAccessoryDto
}

/**
 * Request parameters for apiV1AccessoriesSearchPost operation in AccessoriesApi.
 * @export
 * @interface AccessoriesApiApiV1AccessoriesSearchPostRequest
 */
export interface AccessoriesApiApiV1AccessoriesSearchPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesSearchPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoriesApiApiV1AccessoriesSearchPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AccessorySearchPaginatedDto}
     * @memberof AccessoriesApiApiV1AccessoriesSearchPost
     */
    readonly accessorySearchPaginatedDto?: AccessorySearchPaginatedDto
}

/**
 * AccessoriesApi - object-oriented interface
 * @export
 * @class AccessoriesApi
 * @extends {BaseAPI}
 */
export class AccessoriesApi extends BaseAPI {
    /**
     * 
     * @param {AccessoriesApiApiV1AccessoriesAccessoryIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoriesApi
     */
    public apiV1AccessoriesAccessoryIdDelete(requestParameters: AccessoriesApiApiV1AccessoriesAccessoryIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AccessoriesApiFp(this.configuration).apiV1AccessoriesAccessoryIdDelete(requestParameters.nexusOpsTenant, requestParameters.accessoryId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoriesApiApiV1AccessoriesAccessoryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoriesApi
     */
    public apiV1AccessoriesAccessoryIdGet(requestParameters: AccessoriesApiApiV1AccessoriesAccessoryIdGetRequest, options?: RawAxiosRequestConfig) {
        return AccessoriesApiFp(this.configuration).apiV1AccessoriesAccessoryIdGet(requestParameters.nexusOpsTenant, requestParameters.accessoryId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoriesApiApiV1AccessoriesAccessoryIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoriesApi
     */
    public apiV1AccessoriesAccessoryIdPut(requestParameters: AccessoriesApiApiV1AccessoriesAccessoryIdPutRequest, options?: RawAxiosRequestConfig) {
        return AccessoriesApiFp(this.configuration).apiV1AccessoriesAccessoryIdPut(requestParameters.nexusOpsTenant, requestParameters.accessoryId, requestParameters.nexusOpsAppVersion, requestParameters.updateAccessoryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoriesApiApiV1AccessoriesBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoriesApi
     */
    public apiV1AccessoriesBulkDeleteDelete(requestParameters: AccessoriesApiApiV1AccessoriesBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return AccessoriesApiFp(this.configuration).apiV1AccessoriesBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoriesApiApiV1AccessoriesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoriesApi
     */
    public apiV1AccessoriesGetPost(requestParameters: AccessoriesApiApiV1AccessoriesGetPostRequest, options?: RawAxiosRequestConfig) {
        return AccessoriesApiFp(this.configuration).apiV1AccessoriesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.accessoryGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoriesApiApiV1AccessoriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoriesApi
     */
    public apiV1AccessoriesPost(requestParameters: AccessoriesApiApiV1AccessoriesPostRequest, options?: RawAxiosRequestConfig) {
        return AccessoriesApiFp(this.configuration).apiV1AccessoriesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createAccessoryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated: Use /get.
     * @param {AccessoriesApiApiV1AccessoriesSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AccessoriesApi
     */
    public apiV1AccessoriesSearchPost(requestParameters: AccessoriesApiApiV1AccessoriesSearchPostRequest, options?: RawAxiosRequestConfig) {
        return AccessoriesApiFp(this.configuration).apiV1AccessoriesSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.accessorySearchPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AccessoryChecksApi - axios parameter creator
 * @export
 */
export const AccessoryChecksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut: async (nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'accessoryCheckId' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut', 'accessoryCheckId', accessoryCheckId)
            const localVarPath = `/api/v1/accessory-checks/{accessoryCheckId}/add-assignment`
                .replace(`{${"accessoryCheckId"}}`, encodeURIComponent(String(accessoryCheckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentAddEntityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddAccessoryCheckToContractDto} [addAccessoryCheckToContractDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdAddContractPut: async (nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, addAccessoryCheckToContractDto?: AddAccessoryCheckToContractDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdAddContractPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'accessoryCheckId' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdAddContractPut', 'accessoryCheckId', accessoryCheckId)
            const localVarPath = `/api/v1/accessory-checks/{accessoryCheckId}/add-contract`
                .replace(`{${"accessoryCheckId"}}`, encodeURIComponent(String(accessoryCheckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAccessoryCheckToContractDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdDelete: async (nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'accessoryCheckId' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdDelete', 'accessoryCheckId', accessoryCheckId)
            const localVarPath = `/api/v1/accessory-checks/{accessoryCheckId}`
                .replace(`{${"accessoryCheckId"}}`, encodeURIComponent(String(accessoryCheckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdDownloadPdfGet: async (nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdDownloadPdfGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'accessoryCheckId' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdDownloadPdfGet', 'accessoryCheckId', accessoryCheckId)
            const localVarPath = `/api/v1/accessory-checks/{accessoryCheckId}/download/pdf`
                .replace(`{${"accessoryCheckId"}}`, encodeURIComponent(String(accessoryCheckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdExternalNumberPut: async (nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdExternalNumberPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'accessoryCheckId' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdExternalNumberPut', 'accessoryCheckId', accessoryCheckId)
            const localVarPath = `/api/v1/accessory-checks/{accessoryCheckId}/external-number`
                .replace(`{${"accessoryCheckId"}}`, encodeURIComponent(String(accessoryCheckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalExternalNumberInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdGet: async (nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'accessoryCheckId' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdGet', 'accessoryCheckId', accessoryCheckId)
            const localVarPath = `/api/v1/accessory-checks/{accessoryCheckId}`
                .replace(`{${"accessoryCheckId"}}`, encodeURIComponent(String(accessoryCheckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdNotesPut: async (nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdNotesPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'accessoryCheckId' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdNotesPut', 'accessoryCheckId', accessoryCheckId)
            const localVarPath = `/api/v1/accessory-checks/{accessoryCheckId}/notes`
                .replace(`{${"accessoryCheckId"}}`, encodeURIComponent(String(accessoryCheckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalNotesInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateAccessoryCheckDto} [updateAccessoryCheckDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdPut: async (nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, updateAccessoryCheckDto?: UpdateAccessoryCheckDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'accessoryCheckId' is not null or undefined
            assertParamExists('apiV1AccessoryChecksAccessoryCheckIdPut', 'accessoryCheckId', accessoryCheckId)
            const localVarPath = `/api/v1/accessory-checks/{accessoryCheckId}`
                .replace(`{${"accessoryCheckId"}}`, encodeURIComponent(String(accessoryCheckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccessoryCheckDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoryChecksBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/accessory-checks/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksByIdsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoryChecksByIdsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/accessory-checks/by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoryChecksCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/accessory-checks/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AccessoryCheckGetPaginatedDto} [accessoryCheckGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, accessoryCheckGetPaginatedDto?: AccessoryCheckGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoryChecksGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/accessory-checks/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accessoryCheckGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateAccessoryCheckDto} [createAccessoryCheckDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createAccessoryCheckDto?: CreateAccessoryCheckDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccessoryChecksPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/accessory-checks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAccessoryCheckDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccessoryChecksApi - functional programming interface
 * @export
 */
export const AccessoryChecksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccessoryChecksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut(nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessoryCheckDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut(nexusOpsTenant, accessoryCheckId, nexusOpsAppVersion, assignmentAddEntityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoryChecksApi.apiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddAccessoryCheckToContractDto} [addAccessoryCheckToContractDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoryChecksAccessoryCheckIdAddContractPut(nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, addAccessoryCheckToContractDto?: AddAccessoryCheckToContractDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessoryCheckDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoryChecksAccessoryCheckIdAddContractPut(nexusOpsTenant, accessoryCheckId, nexusOpsAppVersion, addAccessoryCheckToContractDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoryChecksApi.apiV1AccessoryChecksAccessoryCheckIdAddContractPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoryChecksAccessoryCheckIdDelete(nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoryChecksAccessoryCheckIdDelete(nexusOpsTenant, accessoryCheckId, nexusOpsAppVersion, isDeleteCascade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoryChecksApi.apiV1AccessoryChecksAccessoryCheckIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoryChecksAccessoryCheckIdDownloadPdfGet(nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoryChecksAccessoryCheckIdDownloadPdfGet(nexusOpsTenant, accessoryCheckId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoryChecksApi.apiV1AccessoryChecksAccessoryCheckIdDownloadPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoryChecksAccessoryCheckIdExternalNumberPut(nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessoryCheckDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoryChecksAccessoryCheckIdExternalNumberPut(nexusOpsTenant, accessoryCheckId, nexusOpsAppVersion, generalExternalNumberInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoryChecksApi.apiV1AccessoryChecksAccessoryCheckIdExternalNumberPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoryChecksAccessoryCheckIdGet(nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessoryCheckDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoryChecksAccessoryCheckIdGet(nexusOpsTenant, accessoryCheckId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoryChecksApi.apiV1AccessoryChecksAccessoryCheckIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoryChecksAccessoryCheckIdNotesPut(nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessoryCheckDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoryChecksAccessoryCheckIdNotesPut(nexusOpsTenant, accessoryCheckId, nexusOpsAppVersion, generalNotesInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoryChecksApi.apiV1AccessoryChecksAccessoryCheckIdNotesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} accessoryCheckId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateAccessoryCheckDto} [updateAccessoryCheckDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoryChecksAccessoryCheckIdPut(nexusOpsTenant: string, accessoryCheckId: string, nexusOpsAppVersion?: string, updateAccessoryCheckDto?: UpdateAccessoryCheckDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessoryCheckDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoryChecksAccessoryCheckIdPut(nexusOpsTenant, accessoryCheckId, nexusOpsAppVersion, updateAccessoryCheckDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoryChecksApi.apiV1AccessoryChecksAccessoryCheckIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoryChecksBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoryChecksBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoryChecksApi.apiV1AccessoryChecksBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoryChecksByIdsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccessoryCheckDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoryChecksByIdsGet(nexusOpsTenant, nexusOpsAppVersion, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoryChecksApi.apiV1AccessoryChecksByIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoryChecksCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessoryCheckCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoryChecksCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoryChecksApi.apiV1AccessoryChecksCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AccessoryCheckGetPaginatedDto} [accessoryCheckGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoryChecksGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, accessoryCheckGetPaginatedDto?: AccessoryCheckGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAccessoryCheckDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoryChecksGetPost(nexusOpsTenant, nexusOpsAppVersion, accessoryCheckGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoryChecksApi.apiV1AccessoryChecksGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateAccessoryCheckDto} [createAccessoryCheckDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccessoryChecksPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createAccessoryCheckDto?: CreateAccessoryCheckDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessoryCheckDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccessoryChecksPost(nexusOpsTenant, nexusOpsAppVersion, createAccessoryCheckDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessoryChecksApi.apiV1AccessoryChecksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccessoryChecksApi - factory interface
 * @export
 */
export const AccessoryChecksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccessoryChecksApiFp(configuration)
    return {
        /**
         * 
         * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddAssignmentPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddAssignmentPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccessoryCheckDto> {
            return localVarFp.apiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddContractPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdAddContractPut(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddContractPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccessoryCheckDto> {
            return localVarFp.apiV1AccessoryChecksAccessoryCheckIdAddContractPut(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, requestParameters.addAccessoryCheckToContractDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdDelete(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AccessoryChecksAccessoryCheckIdDelete(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDownloadPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdDownloadPdfGet(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1AccessoryChecksAccessoryCheckIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdExternalNumberPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdExternalNumberPut(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdExternalNumberPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccessoryCheckDto> {
            return localVarFp.apiV1AccessoryChecksAccessoryCheckIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdGet(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccessoryCheckDto> {
            return localVarFp.apiV1AccessoryChecksAccessoryCheckIdGet(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdNotesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdNotesPut(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdNotesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccessoryCheckDto> {
            return localVarFp.apiV1AccessoryChecksAccessoryCheckIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksAccessoryCheckIdPut(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccessoryCheckDto> {
            return localVarFp.apiV1AccessoryChecksAccessoryCheckIdPut(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, requestParameters.updateAccessoryCheckDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoryChecksApiApiV1AccessoryChecksBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksBulkDeleteDelete(requestParameters: AccessoryChecksApiApiV1AccessoryChecksBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AccessoryChecksBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoryChecksApiApiV1AccessoryChecksByIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksByIdsGet(requestParameters: AccessoryChecksApiApiV1AccessoryChecksByIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AccessoryCheckDto>> {
            return localVarFp.apiV1AccessoryChecksByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoryChecksApiApiV1AccessoryChecksCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksCountersGet(requestParameters: AccessoryChecksApiApiV1AccessoryChecksCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccessoryCheckCountersDto> {
            return localVarFp.apiV1AccessoryChecksCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoryChecksApiApiV1AccessoryChecksGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksGetPost(requestParameters: AccessoryChecksApiApiV1AccessoryChecksGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAccessoryCheckDto> {
            return localVarFp.apiV1AccessoryChecksGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.accessoryCheckGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessoryChecksApiApiV1AccessoryChecksPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccessoryChecksPost(requestParameters: AccessoryChecksApiApiV1AccessoryChecksPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccessoryCheckDto> {
            return localVarFp.apiV1AccessoryChecksPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createAccessoryCheckDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut operation in AccessoryChecksApi.
 * @export
 * @interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddAssignmentPutRequest
 */
export interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddAssignmentPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut
     */
    readonly accessoryCheckId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentAddEntityDto}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut
     */
    readonly assignmentAddEntityDto?: AssignmentAddEntityDto
}

/**
 * Request parameters for apiV1AccessoryChecksAccessoryCheckIdAddContractPut operation in AccessoryChecksApi.
 * @export
 * @interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddContractPutRequest
 */
export interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddContractPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddContractPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddContractPut
     */
    readonly accessoryCheckId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddContractPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AddAccessoryCheckToContractDto}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddContractPut
     */
    readonly addAccessoryCheckToContractDto?: AddAccessoryCheckToContractDto
}

/**
 * Request parameters for apiV1AccessoryChecksAccessoryCheckIdDelete operation in AccessoryChecksApi.
 * @export
 * @interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDeleteRequest
 */
export interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDelete
     */
    readonly accessoryCheckId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDelete
     */
    readonly isDeleteCascade?: boolean
}

/**
 * Request parameters for apiV1AccessoryChecksAccessoryCheckIdDownloadPdfGet operation in AccessoryChecksApi.
 * @export
 * @interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDownloadPdfGetRequest
 */
export interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDownloadPdfGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDownloadPdfGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDownloadPdfGet
     */
    readonly accessoryCheckId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDownloadPdfGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AccessoryChecksAccessoryCheckIdExternalNumberPut operation in AccessoryChecksApi.
 * @export
 * @interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdExternalNumberPutRequest
 */
export interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdExternalNumberPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdExternalNumberPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdExternalNumberPut
     */
    readonly accessoryCheckId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdExternalNumberPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralExternalNumberInputDto}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdExternalNumberPut
     */
    readonly generalExternalNumberInputDto?: GeneralExternalNumberInputDto
}

/**
 * Request parameters for apiV1AccessoryChecksAccessoryCheckIdGet operation in AccessoryChecksApi.
 * @export
 * @interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdGetRequest
 */
export interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdGet
     */
    readonly accessoryCheckId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AccessoryChecksAccessoryCheckIdNotesPut operation in AccessoryChecksApi.
 * @export
 * @interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdNotesPutRequest
 */
export interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdNotesPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdNotesPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdNotesPut
     */
    readonly accessoryCheckId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdNotesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralNotesInputDto}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdNotesPut
     */
    readonly generalNotesInputDto?: GeneralNotesInputDto
}

/**
 * Request parameters for apiV1AccessoryChecksAccessoryCheckIdPut operation in AccessoryChecksApi.
 * @export
 * @interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdPutRequest
 */
export interface AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdPut
     */
    readonly accessoryCheckId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateAccessoryCheckDto}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdPut
     */
    readonly updateAccessoryCheckDto?: UpdateAccessoryCheckDto
}

/**
 * Request parameters for apiV1AccessoryChecksBulkDeleteDelete operation in AccessoryChecksApi.
 * @export
 * @interface AccessoryChecksApiApiV1AccessoryChecksBulkDeleteDeleteRequest
 */
export interface AccessoryChecksApiApiV1AccessoryChecksBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1AccessoryChecksByIdsGet operation in AccessoryChecksApi.
 * @export
 * @interface AccessoryChecksApiApiV1AccessoryChecksByIdsGetRequest
 */
export interface AccessoryChecksApiApiV1AccessoryChecksByIdsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksByIdsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksByIdsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksByIdsGet
     */
    readonly ids?: Array<string>
}

/**
 * Request parameters for apiV1AccessoryChecksCountersGet operation in AccessoryChecksApi.
 * @export
 * @interface AccessoryChecksApiApiV1AccessoryChecksCountersGetRequest
 */
export interface AccessoryChecksApiApiV1AccessoryChecksCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AccessoryChecksGetPost operation in AccessoryChecksApi.
 * @export
 * @interface AccessoryChecksApiApiV1AccessoryChecksGetPostRequest
 */
export interface AccessoryChecksApiApiV1AccessoryChecksGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AccessoryCheckGetPaginatedDto}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksGetPost
     */
    readonly accessoryCheckGetPaginatedDto?: AccessoryCheckGetPaginatedDto
}

/**
 * Request parameters for apiV1AccessoryChecksPost operation in AccessoryChecksApi.
 * @export
 * @interface AccessoryChecksApiApiV1AccessoryChecksPostRequest
 */
export interface AccessoryChecksApiApiV1AccessoryChecksPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateAccessoryCheckDto}
     * @memberof AccessoryChecksApiApiV1AccessoryChecksPost
     */
    readonly createAccessoryCheckDto?: CreateAccessoryCheckDto
}

/**
 * AccessoryChecksApi - object-oriented interface
 * @export
 * @class AccessoryChecksApi
 * @extends {BaseAPI}
 */
export class AccessoryChecksApi extends BaseAPI {
    /**
     * 
     * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddAssignmentPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoryChecksApi
     */
    public apiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddAssignmentPutRequest, options?: RawAxiosRequestConfig) {
        return AccessoryChecksApiFp(this.configuration).apiV1AccessoryChecksAccessoryCheckIdAddAssignmentPut(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddContractPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoryChecksApi
     */
    public apiV1AccessoryChecksAccessoryCheckIdAddContractPut(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdAddContractPutRequest, options?: RawAxiosRequestConfig) {
        return AccessoryChecksApiFp(this.configuration).apiV1AccessoryChecksAccessoryCheckIdAddContractPut(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, requestParameters.addAccessoryCheckToContractDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoryChecksApi
     */
    public apiV1AccessoryChecksAccessoryCheckIdDelete(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AccessoryChecksApiFp(this.configuration).apiV1AccessoryChecksAccessoryCheckIdDelete(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDownloadPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoryChecksApi
     */
    public apiV1AccessoryChecksAccessoryCheckIdDownloadPdfGet(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig) {
        return AccessoryChecksApiFp(this.configuration).apiV1AccessoryChecksAccessoryCheckIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdExternalNumberPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoryChecksApi
     */
    public apiV1AccessoryChecksAccessoryCheckIdExternalNumberPut(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdExternalNumberPutRequest, options?: RawAxiosRequestConfig) {
        return AccessoryChecksApiFp(this.configuration).apiV1AccessoryChecksAccessoryCheckIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoryChecksApi
     */
    public apiV1AccessoryChecksAccessoryCheckIdGet(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdGetRequest, options?: RawAxiosRequestConfig) {
        return AccessoryChecksApiFp(this.configuration).apiV1AccessoryChecksAccessoryCheckIdGet(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdNotesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoryChecksApi
     */
    public apiV1AccessoryChecksAccessoryCheckIdNotesPut(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdNotesPutRequest, options?: RawAxiosRequestConfig) {
        return AccessoryChecksApiFp(this.configuration).apiV1AccessoryChecksAccessoryCheckIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoryChecksApi
     */
    public apiV1AccessoryChecksAccessoryCheckIdPut(requestParameters: AccessoryChecksApiApiV1AccessoryChecksAccessoryCheckIdPutRequest, options?: RawAxiosRequestConfig) {
        return AccessoryChecksApiFp(this.configuration).apiV1AccessoryChecksAccessoryCheckIdPut(requestParameters.nexusOpsTenant, requestParameters.accessoryCheckId, requestParameters.nexusOpsAppVersion, requestParameters.updateAccessoryCheckDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoryChecksApiApiV1AccessoryChecksBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoryChecksApi
     */
    public apiV1AccessoryChecksBulkDeleteDelete(requestParameters: AccessoryChecksApiApiV1AccessoryChecksBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return AccessoryChecksApiFp(this.configuration).apiV1AccessoryChecksBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoryChecksApiApiV1AccessoryChecksByIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoryChecksApi
     */
    public apiV1AccessoryChecksByIdsGet(requestParameters: AccessoryChecksApiApiV1AccessoryChecksByIdsGetRequest, options?: RawAxiosRequestConfig) {
        return AccessoryChecksApiFp(this.configuration).apiV1AccessoryChecksByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoryChecksApiApiV1AccessoryChecksCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoryChecksApi
     */
    public apiV1AccessoryChecksCountersGet(requestParameters: AccessoryChecksApiApiV1AccessoryChecksCountersGetRequest, options?: RawAxiosRequestConfig) {
        return AccessoryChecksApiFp(this.configuration).apiV1AccessoryChecksCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoryChecksApiApiV1AccessoryChecksGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoryChecksApi
     */
    public apiV1AccessoryChecksGetPost(requestParameters: AccessoryChecksApiApiV1AccessoryChecksGetPostRequest, options?: RawAxiosRequestConfig) {
        return AccessoryChecksApiFp(this.configuration).apiV1AccessoryChecksGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.accessoryCheckGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessoryChecksApiApiV1AccessoryChecksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessoryChecksApi
     */
    public apiV1AccessoryChecksPost(requestParameters: AccessoryChecksApiApiV1AccessoryChecksPostRequest, options?: RawAxiosRequestConfig) {
        return AccessoryChecksApiFp(this.configuration).apiV1AccessoryChecksPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createAccessoryCheckDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountPasswordPolicyGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/password/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ValidatePasswordDto} [validatePasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountPasswordValidatePost: async (nexusOpsAppVersion?: string, validatePasswordDto?: ValidatePasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/password/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validatePasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RegisterCompleteDto} [registerCompleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountRegisterCompanyCompletePost: async (nexusOpsAppVersion?: string, registerCompleteDto?: RegisterCompleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/register/company/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerCompleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [email] 
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountRegisterCompanyGetIncompleteRegistrationGet: async (nexusOpsAppVersion?: string, email?: string, companyId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/register/company/get-incomplete-registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ValidateCompanyIdentifierDto} [validateCompanyIdentifierDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountRegisterCompanyIdentifierValidatePost: async (nexusOpsAppVersion?: string, validateCompanyIdentifierDto?: ValidateCompanyIdentifierDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/register/company/identifier/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateCompanyIdentifierDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RegisterDto} [registerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountRegisterCompanyInfoPost: async (nexusOpsAppVersion?: string, registerDto?: RegisterDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/register/company/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateCompanyDto} [createCompanyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountRegisterCompanyNewPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createCompanyDto?: CreateCompanyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AccountRegisterCompanyNewPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/account/register/company/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SendEmailVerificationTokenDto} [sendEmailVerificationTokenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountVerificationEmailTokenSendPost: async (nexusOpsAppVersion?: string, sendEmailVerificationTokenDto?: SendEmailVerificationTokenDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/verification/email/token/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendEmailVerificationTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ValidateEmailVerificationTokenDto} [validateEmailVerificationTokenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountVerificationEmailTokenValidatePost: async (nexusOpsAppVersion?: string, validateEmailVerificationTokenDto?: ValidateEmailVerificationTokenDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/verification/email/token/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateEmailVerificationTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountPasswordPolicyGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordPolicyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountPasswordPolicyGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.apiV1AccountPasswordPolicyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ValidatePasswordDto} [validatePasswordDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountPasswordValidatePost(nexusOpsAppVersion?: string, validatePasswordDto?: ValidatePasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PasswordValidateResultDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountPasswordValidatePost(nexusOpsAppVersion, validatePasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.apiV1AccountPasswordValidatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RegisterCompleteDto} [registerCompleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountRegisterCompanyCompletePost(nexusOpsAppVersion?: string, registerCompleteDto?: RegisterCompleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountRegisterCompanyCompletePost(nexusOpsAppVersion, registerCompleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.apiV1AccountRegisterCompanyCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [email] 
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountRegisterCompanyGetIncompleteRegistrationGet(nexusOpsAppVersion?: string, email?: string, companyId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyIncompleteRegistrationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountRegisterCompanyGetIncompleteRegistrationGet(nexusOpsAppVersion, email, companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.apiV1AccountRegisterCompanyGetIncompleteRegistrationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ValidateCompanyIdentifierDto} [validateCompanyIdentifierDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountRegisterCompanyIdentifierValidatePost(nexusOpsAppVersion?: string, validateCompanyIdentifierDto?: ValidateCompanyIdentifierDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyIdentifierValidateResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountRegisterCompanyIdentifierValidatePost(nexusOpsAppVersion, validateCompanyIdentifierDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.apiV1AccountRegisterCompanyIdentifierValidatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RegisterDto} [registerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountRegisterCompanyInfoPost(nexusOpsAppVersion?: string, registerDto?: RegisterDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountRegisterCompanyInfoPost(nexusOpsAppVersion, registerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.apiV1AccountRegisterCompanyInfoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateCompanyDto} [createCompanyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountRegisterCompanyNewPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createCompanyDto?: CreateCompanyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountRegisterCompanyNewPost(nexusOpsTenant, nexusOpsAppVersion, createCompanyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.apiV1AccountRegisterCompanyNewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SendEmailVerificationTokenDto} [sendEmailVerificationTokenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountVerificationEmailTokenSendPost(nexusOpsAppVersion?: string, sendEmailVerificationTokenDto?: SendEmailVerificationTokenDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountVerificationEmailTokenSendPost(nexusOpsAppVersion, sendEmailVerificationTokenDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.apiV1AccountVerificationEmailTokenSendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ValidateEmailVerificationTokenDto} [validateEmailVerificationTokenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountVerificationEmailTokenValidatePost(nexusOpsAppVersion?: string, validateEmailVerificationTokenDto?: ValidateEmailVerificationTokenDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserValidateResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountVerificationEmailTokenValidatePost(nexusOpsAppVersion, validateEmailVerificationTokenDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.apiV1AccountVerificationEmailTokenValidatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @param {AccountApiApiV1AccountPasswordPolicyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountPasswordPolicyGet(requestParameters: AccountApiApiV1AccountPasswordPolicyGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PasswordPolicyDto> {
            return localVarFp.apiV1AccountPasswordPolicyGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiApiV1AccountPasswordValidatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountPasswordValidatePost(requestParameters: AccountApiApiV1AccountPasswordValidatePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<PasswordValidateResultDto>> {
            return localVarFp.apiV1AccountPasswordValidatePost(requestParameters.nexusOpsAppVersion, requestParameters.validatePasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiApiV1AccountRegisterCompanyCompletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountRegisterCompanyCompletePost(requestParameters: AccountApiApiV1AccountRegisterCompanyCompletePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AccountRegisterCompanyCompletePost(requestParameters.nexusOpsAppVersion, requestParameters.registerCompleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiApiV1AccountRegisterCompanyGetIncompleteRegistrationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountRegisterCompanyGetIncompleteRegistrationGet(requestParameters: AccountApiApiV1AccountRegisterCompanyGetIncompleteRegistrationGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CompanyIncompleteRegistrationDto> {
            return localVarFp.apiV1AccountRegisterCompanyGetIncompleteRegistrationGet(requestParameters.nexusOpsAppVersion, requestParameters.email, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiApiV1AccountRegisterCompanyIdentifierValidatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountRegisterCompanyIdentifierValidatePost(requestParameters: AccountApiApiV1AccountRegisterCompanyIdentifierValidatePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CompanyIdentifierValidateResultDto> {
            return localVarFp.apiV1AccountRegisterCompanyIdentifierValidatePost(requestParameters.nexusOpsAppVersion, requestParameters.validateCompanyIdentifierDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiApiV1AccountRegisterCompanyInfoPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountRegisterCompanyInfoPost(requestParameters: AccountApiApiV1AccountRegisterCompanyInfoPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RegisterResultDto> {
            return localVarFp.apiV1AccountRegisterCompanyInfoPost(requestParameters.nexusOpsAppVersion, requestParameters.registerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiApiV1AccountRegisterCompanyNewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountRegisterCompanyNewPost(requestParameters: AccountApiApiV1AccountRegisterCompanyNewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterResultDto> {
            return localVarFp.apiV1AccountRegisterCompanyNewPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createCompanyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiApiV1AccountVerificationEmailTokenSendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountVerificationEmailTokenSendPost(requestParameters: AccountApiApiV1AccountVerificationEmailTokenSendPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AccountVerificationEmailTokenSendPost(requestParameters.nexusOpsAppVersion, requestParameters.sendEmailVerificationTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiApiV1AccountVerificationEmailTokenValidatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountVerificationEmailTokenValidatePost(requestParameters: AccountApiApiV1AccountVerificationEmailTokenValidatePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserValidateResultDto> {
            return localVarFp.apiV1AccountVerificationEmailTokenValidatePost(requestParameters.nexusOpsAppVersion, requestParameters.validateEmailVerificationTokenDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AccountPasswordPolicyGet operation in AccountApi.
 * @export
 * @interface AccountApiApiV1AccountPasswordPolicyGetRequest
 */
export interface AccountApiApiV1AccountPasswordPolicyGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountApiApiV1AccountPasswordPolicyGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AccountPasswordValidatePost operation in AccountApi.
 * @export
 * @interface AccountApiApiV1AccountPasswordValidatePostRequest
 */
export interface AccountApiApiV1AccountPasswordValidatePostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountApiApiV1AccountPasswordValidatePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ValidatePasswordDto}
     * @memberof AccountApiApiV1AccountPasswordValidatePost
     */
    readonly validatePasswordDto?: ValidatePasswordDto
}

/**
 * Request parameters for apiV1AccountRegisterCompanyCompletePost operation in AccountApi.
 * @export
 * @interface AccountApiApiV1AccountRegisterCompanyCompletePostRequest
 */
export interface AccountApiApiV1AccountRegisterCompanyCompletePostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountApiApiV1AccountRegisterCompanyCompletePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RegisterCompleteDto}
     * @memberof AccountApiApiV1AccountRegisterCompanyCompletePost
     */
    readonly registerCompleteDto?: RegisterCompleteDto
}

/**
 * Request parameters for apiV1AccountRegisterCompanyGetIncompleteRegistrationGet operation in AccountApi.
 * @export
 * @interface AccountApiApiV1AccountRegisterCompanyGetIncompleteRegistrationGetRequest
 */
export interface AccountApiApiV1AccountRegisterCompanyGetIncompleteRegistrationGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountApiApiV1AccountRegisterCompanyGetIncompleteRegistrationGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof AccountApiApiV1AccountRegisterCompanyGetIncompleteRegistrationGet
     */
    readonly email?: string

    /**
     * 
     * @type {string}
     * @memberof AccountApiApiV1AccountRegisterCompanyGetIncompleteRegistrationGet
     */
    readonly companyId?: string
}

/**
 * Request parameters for apiV1AccountRegisterCompanyIdentifierValidatePost operation in AccountApi.
 * @export
 * @interface AccountApiApiV1AccountRegisterCompanyIdentifierValidatePostRequest
 */
export interface AccountApiApiV1AccountRegisterCompanyIdentifierValidatePostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountApiApiV1AccountRegisterCompanyIdentifierValidatePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ValidateCompanyIdentifierDto}
     * @memberof AccountApiApiV1AccountRegisterCompanyIdentifierValidatePost
     */
    readonly validateCompanyIdentifierDto?: ValidateCompanyIdentifierDto
}

/**
 * Request parameters for apiV1AccountRegisterCompanyInfoPost operation in AccountApi.
 * @export
 * @interface AccountApiApiV1AccountRegisterCompanyInfoPostRequest
 */
export interface AccountApiApiV1AccountRegisterCompanyInfoPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountApiApiV1AccountRegisterCompanyInfoPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RegisterDto}
     * @memberof AccountApiApiV1AccountRegisterCompanyInfoPost
     */
    readonly registerDto?: RegisterDto
}

/**
 * Request parameters for apiV1AccountRegisterCompanyNewPost operation in AccountApi.
 * @export
 * @interface AccountApiApiV1AccountRegisterCompanyNewPostRequest
 */
export interface AccountApiApiV1AccountRegisterCompanyNewPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AccountApiApiV1AccountRegisterCompanyNewPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountApiApiV1AccountRegisterCompanyNewPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateCompanyDto}
     * @memberof AccountApiApiV1AccountRegisterCompanyNewPost
     */
    readonly createCompanyDto?: CreateCompanyDto
}

/**
 * Request parameters for apiV1AccountVerificationEmailTokenSendPost operation in AccountApi.
 * @export
 * @interface AccountApiApiV1AccountVerificationEmailTokenSendPostRequest
 */
export interface AccountApiApiV1AccountVerificationEmailTokenSendPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountApiApiV1AccountVerificationEmailTokenSendPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {SendEmailVerificationTokenDto}
     * @memberof AccountApiApiV1AccountVerificationEmailTokenSendPost
     */
    readonly sendEmailVerificationTokenDto?: SendEmailVerificationTokenDto
}

/**
 * Request parameters for apiV1AccountVerificationEmailTokenValidatePost operation in AccountApi.
 * @export
 * @interface AccountApiApiV1AccountVerificationEmailTokenValidatePostRequest
 */
export interface AccountApiApiV1AccountVerificationEmailTokenValidatePostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountApiApiV1AccountVerificationEmailTokenValidatePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ValidateEmailVerificationTokenDto}
     * @memberof AccountApiApiV1AccountVerificationEmailTokenValidatePost
     */
    readonly validateEmailVerificationTokenDto?: ValidateEmailVerificationTokenDto
}

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @param {AccountApiApiV1AccountPasswordPolicyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV1AccountPasswordPolicyGet(requestParameters: AccountApiApiV1AccountPasswordPolicyGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiV1AccountPasswordPolicyGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiApiV1AccountPasswordValidatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV1AccountPasswordValidatePost(requestParameters: AccountApiApiV1AccountPasswordValidatePostRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiV1AccountPasswordValidatePost(requestParameters.nexusOpsAppVersion, requestParameters.validatePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiApiV1AccountRegisterCompanyCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV1AccountRegisterCompanyCompletePost(requestParameters: AccountApiApiV1AccountRegisterCompanyCompletePostRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiV1AccountRegisterCompanyCompletePost(requestParameters.nexusOpsAppVersion, requestParameters.registerCompleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiApiV1AccountRegisterCompanyGetIncompleteRegistrationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV1AccountRegisterCompanyGetIncompleteRegistrationGet(requestParameters: AccountApiApiV1AccountRegisterCompanyGetIncompleteRegistrationGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiV1AccountRegisterCompanyGetIncompleteRegistrationGet(requestParameters.nexusOpsAppVersion, requestParameters.email, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiApiV1AccountRegisterCompanyIdentifierValidatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV1AccountRegisterCompanyIdentifierValidatePost(requestParameters: AccountApiApiV1AccountRegisterCompanyIdentifierValidatePostRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiV1AccountRegisterCompanyIdentifierValidatePost(requestParameters.nexusOpsAppVersion, requestParameters.validateCompanyIdentifierDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiApiV1AccountRegisterCompanyInfoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV1AccountRegisterCompanyInfoPost(requestParameters: AccountApiApiV1AccountRegisterCompanyInfoPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiV1AccountRegisterCompanyInfoPost(requestParameters.nexusOpsAppVersion, requestParameters.registerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiApiV1AccountRegisterCompanyNewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV1AccountRegisterCompanyNewPost(requestParameters: AccountApiApiV1AccountRegisterCompanyNewPostRequest, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiV1AccountRegisterCompanyNewPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createCompanyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiApiV1AccountVerificationEmailTokenSendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV1AccountVerificationEmailTokenSendPost(requestParameters: AccountApiApiV1AccountVerificationEmailTokenSendPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiV1AccountVerificationEmailTokenSendPost(requestParameters.nexusOpsAppVersion, requestParameters.sendEmailVerificationTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiApiV1AccountVerificationEmailTokenValidatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV1AccountVerificationEmailTokenValidatePost(requestParameters: AccountApiApiV1AccountVerificationEmailTokenValidatePostRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiV1AccountVerificationEmailTokenValidatePost(requestParameters.nexusOpsAppVersion, requestParameters.validateEmailVerificationTokenDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AccountAdminApi - axios parameter creator
 * @export
 */
export const AccountAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountAllPermissionsGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/account/all/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalPermissionsGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/account/global/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [targetUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRoleAssignmentsRestrictionsGet: async (nexusOpsAppVersion?: string, targetUserId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/account/global/role-assignments/restrictions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (targetUserId !== undefined) {
                localVarQueryParameter['targetUserId'] = targetUserId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [roleIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRolesByIdsGet: async (nexusOpsAppVersion?: string, roleIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/account/global/roles/by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (roleIds) {
                localVarQueryParameter['roleIds'] = roleIds;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [sortBy] Comma-separated list of fields to sort by.
         * @param {string} [sortOrder] Comma-separated list of sort orders, with indexes corresponding to fields.  See values in SortOrder enum.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRolesGet: async (nexusOpsAppVersion?: string, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/account/global/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateGlobalRoleDto} [adminCreateGlobalRoleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRolesPost: async (nexusOpsAppVersion?: string, adminCreateGlobalRoleDto?: AdminCreateGlobalRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/account/global/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateGlobalRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRolesRoleIdDelete: async (roleId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiV1AdminAccountGlobalRolesRoleIdDelete', 'roleId', roleId)
            const localVarPath = `/api/v1/admin/account/global/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRolesRoleIdGet: async (roleId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiV1AdminAccountGlobalRolesRoleIdGet', 'roleId', roleId)
            const localVarPath = `/api/v1/admin/account/global/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRolesRoleIdPermissionsGet: async (roleId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiV1AdminAccountGlobalRolesRoleIdPermissionsGet', 'roleId', roleId)
            const localVarPath = `/api/v1/admin/account/global/roles/{roleId}/permissions`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateGlobalRoleDto} [adminUpdateGlobalRoleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRolesRoleIdPut: async (roleId: string, nexusOpsAppVersion?: string, adminUpdateGlobalRoleDto?: AdminUpdateGlobalRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiV1AdminAccountGlobalRolesRoleIdPut', 'roleId', roleId)
            const localVarPath = `/api/v1/admin/account/global/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateGlobalRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateUserRolesDto} [updateUserRolesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalUsersUserIdRolesPut: async (userId: string, nexusOpsAppVersion?: string, updateUserRolesDto?: UpdateUserRolesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1AdminAccountGlobalUsersUserIdRolesPut', 'userId', userId)
            const localVarPath = `/api/v1/admin/account/global/users/{userId}/roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRolesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountTenantsPermissionsGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/account/tenants/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [targetUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGet: async (tenantId: string, nexusOpsAppVersion?: string, targetUserId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGet', 'tenantId', tenantId)
            const localVarPath = `/api/v1/admin/account/tenants/{tenantId}/role-assignments/restrictions`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (targetUserId !== undefined) {
                localVarQueryParameter['targetUserId'] = targetUserId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountTenantsTenantIdRolesGet: async (tenantId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiV1AdminAccountTenantsTenantIdRolesGet', 'tenantId', tenantId)
            const localVarPath = `/api/v1/admin/account/tenants/{tenantId}/roles`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountTenantsTenantIdRolesRoleIdGet: async (tenantId: string, roleId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiV1AdminAccountTenantsTenantIdRolesRoleIdGet', 'tenantId', tenantId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiV1AdminAccountTenantsTenantIdRolesRoleIdGet', 'roleId', roleId)
            const localVarPath = `/api/v1/admin/account/tenants/{tenantId}/roles/{roleId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGet: async (tenantId: string, roleId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGet', 'tenantId', tenantId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGet', 'roleId', roleId)
            const localVarPath = `/api/v1/admin/account/tenants/{tenantId}/roles/{roleId}/permissions`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUserRolesUpdateDto} [adminUserRolesUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut: async (tenantId: string, userId: string, nexusOpsAppVersion?: string, adminUserRolesUpdateDto?: AdminUserRolesUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut', 'tenantId', tenantId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut', 'userId', userId)
            const localVarPath = `/api/v1/admin/account/tenants/{tenantId}/users/{userId}/roles`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUserRolesUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [roleIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountTenantsTenantIdrolesByIdsGet: async (tenantId: string, nexusOpsAppVersion?: string, roleIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiV1AdminAccountTenantsTenantIdrolesByIdsGet', 'tenantId', tenantId)
            const localVarPath = `/api/v1/admin/account/tenants/{tenantId}roles/by-ids`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (roleIds) {
                localVarQueryParameter['roleIds'] = roleIds;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountAdminApi - functional programming interface
 * @export
 */
export const AccountAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountAllPermissionsGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionMetaDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountAllPermissionsGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountAllPermissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountGlobalPermissionsGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionMetaDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountGlobalPermissionsGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountGlobalPermissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [targetUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountGlobalRoleAssignmentsRestrictionsGet(nexusOpsAppVersion?: string, targetUserId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleAssignmentRestrictionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountGlobalRoleAssignmentsRestrictionsGet(nexusOpsAppVersion, targetUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountGlobalRoleAssignmentsRestrictionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [roleIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountGlobalRolesByIdsGet(nexusOpsAppVersion?: string, roleIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountGlobalRolesByIdsGet(nexusOpsAppVersion, roleIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountGlobalRolesByIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [sortBy] Comma-separated list of fields to sort by.
         * @param {string} [sortOrder] Comma-separated list of sort orders, with indexes corresponding to fields.  See values in SortOrder enum.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountGlobalRolesGet(nexusOpsAppVersion?: string, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountGlobalRolesGet(nexusOpsAppVersion, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountGlobalRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateGlobalRoleDto} [adminCreateGlobalRoleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountGlobalRolesPost(nexusOpsAppVersion?: string, adminCreateGlobalRoleDto?: AdminCreateGlobalRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountGlobalRolesPost(nexusOpsAppVersion, adminCreateGlobalRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountGlobalRolesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountGlobalRolesRoleIdDelete(roleId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountGlobalRolesRoleIdDelete(roleId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountGlobalRolesRoleIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountGlobalRolesRoleIdGet(roleId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountGlobalRolesRoleIdGet(roleId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountGlobalRolesRoleIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountGlobalRolesRoleIdPermissionsGet(roleId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionMetaDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountGlobalRolesRoleIdPermissionsGet(roleId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountGlobalRolesRoleIdPermissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateGlobalRoleDto} [adminUpdateGlobalRoleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountGlobalRolesRoleIdPut(roleId: string, nexusOpsAppVersion?: string, adminUpdateGlobalRoleDto?: AdminUpdateGlobalRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountGlobalRolesRoleIdPut(roleId, nexusOpsAppVersion, adminUpdateGlobalRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountGlobalRolesRoleIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateUserRolesDto} [updateUserRolesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountGlobalUsersUserIdRolesPut(userId: string, nexusOpsAppVersion?: string, updateUserRolesDto?: UpdateUserRolesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountGlobalUsersUserIdRolesPut(userId, nexusOpsAppVersion, updateUserRolesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountGlobalUsersUserIdRolesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountTenantsPermissionsGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionMetaDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountTenantsPermissionsGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountTenantsPermissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [targetUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGet(tenantId: string, nexusOpsAppVersion?: string, targetUserId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleAssignmentRestrictionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGet(tenantId, nexusOpsAppVersion, targetUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountTenantsTenantIdRolesGet(tenantId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountTenantsTenantIdRolesGet(tenantId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountTenantsTenantIdRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountTenantsTenantIdRolesRoleIdGet(tenantId: string, roleId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountTenantsTenantIdRolesRoleIdGet(tenantId, roleId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountTenantsTenantIdRolesRoleIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGet(tenantId: string, roleId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionMetaDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGet(tenantId, roleId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUserRolesUpdateDto} [adminUserRolesUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut(tenantId: string, userId: string, nexusOpsAppVersion?: string, adminUserRolesUpdateDto?: AdminUserRolesUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut(tenantId, userId, nexusOpsAppVersion, adminUserRolesUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [roleIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAccountTenantsTenantIdrolesByIdsGet(tenantId: string, nexusOpsAppVersion?: string, roleIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAccountTenantsTenantIdrolesByIdsGet(tenantId, nexusOpsAppVersion, roleIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountAdminApi.apiV1AdminAccountTenantsTenantIdrolesByIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountAdminApi - factory interface
 * @export
 */
export const AccountAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountAllPermissionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountAllPermissionsGet(requestParameters: AccountAdminApiApiV1AdminAccountAllPermissionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<PermissionMetaDto>> {
            return localVarFp.apiV1AdminAccountAllPermissionsGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountGlobalPermissionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalPermissionsGet(requestParameters: AccountAdminApiApiV1AdminAccountGlobalPermissionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<PermissionMetaDto>> {
            return localVarFp.apiV1AdminAccountGlobalPermissionsGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountGlobalRoleAssignmentsRestrictionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRoleAssignmentsRestrictionsGet(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRoleAssignmentsRestrictionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RoleAssignmentRestrictionsDto> {
            return localVarFp.apiV1AdminAccountGlobalRoleAssignmentsRestrictionsGet(requestParameters.nexusOpsAppVersion, requestParameters.targetUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountGlobalRolesByIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRolesByIdsGet(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRolesByIdsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleDto>> {
            return localVarFp.apiV1AdminAccountGlobalRolesByIdsGet(requestParameters.nexusOpsAppVersion, requestParameters.roleIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountGlobalRolesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRolesGet(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRolesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleDto>> {
            return localVarFp.apiV1AdminAccountGlobalRolesGet(requestParameters.nexusOpsAppVersion, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountGlobalRolesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRolesPost(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRolesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RoleDto> {
            return localVarFp.apiV1AdminAccountGlobalRolesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateGlobalRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRolesRoleIdDelete(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminAccountGlobalRolesRoleIdDelete(requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRolesRoleIdGet(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RoleDto> {
            return localVarFp.apiV1AdminAccountGlobalRolesRoleIdGet(requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPermissionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRolesRoleIdPermissionsGet(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPermissionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PermissionMetaDto>> {
            return localVarFp.apiV1AdminAccountGlobalRolesRoleIdPermissionsGet(requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalRolesRoleIdPut(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RoleDto> {
            return localVarFp.apiV1AdminAccountGlobalRolesRoleIdPut(requestParameters.roleId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateGlobalRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountGlobalUsersUserIdRolesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountGlobalUsersUserIdRolesPut(requestParameters: AccountAdminApiApiV1AdminAccountGlobalUsersUserIdRolesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminAccountGlobalUsersUserIdRolesPut(requestParameters.userId, requestParameters.nexusOpsAppVersion, requestParameters.updateUserRolesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountTenantsPermissionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountTenantsPermissionsGet(requestParameters: AccountAdminApiApiV1AdminAccountTenantsPermissionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<PermissionMetaDto>> {
            return localVarFp.apiV1AdminAccountTenantsPermissionsGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGet(requestParameters: AccountAdminApiApiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RoleAssignmentRestrictionsDto> {
            return localVarFp.apiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGet(requestParameters.tenantId, requestParameters.nexusOpsAppVersion, requestParameters.targetUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountTenantsTenantIdRolesGet(requestParameters: AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleDto>> {
            return localVarFp.apiV1AdminAccountTenantsTenantIdRolesGet(requestParameters.tenantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountTenantsTenantIdRolesRoleIdGet(requestParameters: AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RoleDto> {
            return localVarFp.apiV1AdminAccountTenantsTenantIdRolesRoleIdGet(requestParameters.tenantId, requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGet(requestParameters: AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PermissionMetaDto>> {
            return localVarFp.apiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGet(requestParameters.tenantId, requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountTenantsTenantIdUsersUserIdRolesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut(requestParameters: AccountAdminApiApiV1AdminAccountTenantsTenantIdUsersUserIdRolesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut(requestParameters.tenantId, requestParameters.userId, requestParameters.nexusOpsAppVersion, requestParameters.adminUserRolesUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountAdminApiApiV1AdminAccountTenantsTenantIdrolesByIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAccountTenantsTenantIdrolesByIdsGet(requestParameters: AccountAdminApiApiV1AdminAccountTenantsTenantIdrolesByIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleDto>> {
            return localVarFp.apiV1AdminAccountTenantsTenantIdrolesByIdsGet(requestParameters.tenantId, requestParameters.nexusOpsAppVersion, requestParameters.roleIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminAccountAllPermissionsGet operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountAllPermissionsGetRequest
 */
export interface AccountAdminApiApiV1AdminAccountAllPermissionsGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountAllPermissionsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminAccountGlobalPermissionsGet operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountGlobalPermissionsGetRequest
 */
export interface AccountAdminApiApiV1AdminAccountGlobalPermissionsGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalPermissionsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminAccountGlobalRoleAssignmentsRestrictionsGet operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountGlobalRoleAssignmentsRestrictionsGetRequest
 */
export interface AccountAdminApiApiV1AdminAccountGlobalRoleAssignmentsRestrictionsGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRoleAssignmentsRestrictionsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRoleAssignmentsRestrictionsGet
     */
    readonly targetUserId?: string
}

/**
 * Request parameters for apiV1AdminAccountGlobalRolesByIdsGet operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountGlobalRolesByIdsGetRequest
 */
export interface AccountAdminApiApiV1AdminAccountGlobalRolesByIdsGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesByIdsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesByIdsGet
     */
    readonly roleIds?: Array<string>
}

/**
 * Request parameters for apiV1AdminAccountGlobalRolesGet operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountGlobalRolesGetRequest
 */
export interface AccountAdminApiApiV1AdminAccountGlobalRolesGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * Comma-separated list of fields to sort by.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesGet
     */
    readonly sortBy?: string

    /**
     * Comma-separated list of sort orders, with indexes corresponding to fields.  See values in SortOrder enum.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesGet
     */
    readonly sortOrder?: string
}

/**
 * Request parameters for apiV1AdminAccountGlobalRolesPost operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountGlobalRolesPostRequest
 */
export interface AccountAdminApiApiV1AdminAccountGlobalRolesPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateGlobalRoleDto}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesPost
     */
    readonly adminCreateGlobalRoleDto?: AdminCreateGlobalRoleDto
}

/**
 * Request parameters for apiV1AdminAccountGlobalRolesRoleIdDelete operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdDeleteRequest
 */
export interface AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdDelete
     */
    readonly roleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminAccountGlobalRolesRoleIdGet operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdGetRequest
 */
export interface AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdGet
     */
    readonly roleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminAccountGlobalRolesRoleIdPermissionsGet operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPermissionsGetRequest
 */
export interface AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPermissionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPermissionsGet
     */
    readonly roleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPermissionsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminAccountGlobalRolesRoleIdPut operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPutRequest
 */
export interface AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPut
     */
    readonly roleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUpdateGlobalRoleDto}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPut
     */
    readonly adminUpdateGlobalRoleDto?: AdminUpdateGlobalRoleDto
}

/**
 * Request parameters for apiV1AdminAccountGlobalUsersUserIdRolesPut operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountGlobalUsersUserIdRolesPutRequest
 */
export interface AccountAdminApiApiV1AdminAccountGlobalUsersUserIdRolesPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalUsersUserIdRolesPut
     */
    readonly userId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalUsersUserIdRolesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateUserRolesDto}
     * @memberof AccountAdminApiApiV1AdminAccountGlobalUsersUserIdRolesPut
     */
    readonly updateUserRolesDto?: UpdateUserRolesDto
}

/**
 * Request parameters for apiV1AdminAccountTenantsPermissionsGet operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountTenantsPermissionsGetRequest
 */
export interface AccountAdminApiApiV1AdminAccountTenantsPermissionsGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsPermissionsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGet operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGetRequest
 */
export interface AccountAdminApiApiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGet
     */
    readonly tenantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGet
     */
    readonly targetUserId?: string
}

/**
 * Request parameters for apiV1AdminAccountTenantsTenantIdRolesGet operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesGetRequest
 */
export interface AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesGet
     */
    readonly tenantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminAccountTenantsTenantIdRolesRoleIdGet operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdGetRequest
 */
export interface AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdGet
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdGet
     */
    readonly roleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGet operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGetRequest
 */
export interface AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGet
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGet
     */
    readonly roleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountTenantsTenantIdUsersUserIdRolesPutRequest
 */
export interface AccountAdminApiApiV1AdminAccountTenantsTenantIdUsersUserIdRolesPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut
     */
    readonly userId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUserRolesUpdateDto}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut
     */
    readonly adminUserRolesUpdateDto?: AdminUserRolesUpdateDto
}

/**
 * Request parameters for apiV1AdminAccountTenantsTenantIdrolesByIdsGet operation in AccountAdminApi.
 * @export
 * @interface AccountAdminApiApiV1AdminAccountTenantsTenantIdrolesByIdsGetRequest
 */
export interface AccountAdminApiApiV1AdminAccountTenantsTenantIdrolesByIdsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdrolesByIdsGet
     */
    readonly tenantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdrolesByIdsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof AccountAdminApiApiV1AdminAccountTenantsTenantIdrolesByIdsGet
     */
    readonly roleIds?: Array<string>
}

/**
 * AccountAdminApi - object-oriented interface
 * @export
 * @class AccountAdminApi
 * @extends {BaseAPI}
 */
export class AccountAdminApi extends BaseAPI {
    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountAllPermissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountAllPermissionsGet(requestParameters: AccountAdminApiApiV1AdminAccountAllPermissionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountAllPermissionsGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountGlobalPermissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountGlobalPermissionsGet(requestParameters: AccountAdminApiApiV1AdminAccountGlobalPermissionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountGlobalPermissionsGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountGlobalRoleAssignmentsRestrictionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountGlobalRoleAssignmentsRestrictionsGet(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRoleAssignmentsRestrictionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountGlobalRoleAssignmentsRestrictionsGet(requestParameters.nexusOpsAppVersion, requestParameters.targetUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountGlobalRolesByIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountGlobalRolesByIdsGet(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRolesByIdsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountGlobalRolesByIdsGet(requestParameters.nexusOpsAppVersion, requestParameters.roleIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountGlobalRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountGlobalRolesGet(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRolesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountGlobalRolesGet(requestParameters.nexusOpsAppVersion, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountGlobalRolesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountGlobalRolesPost(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRolesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountGlobalRolesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateGlobalRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountGlobalRolesRoleIdDelete(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountGlobalRolesRoleIdDelete(requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountGlobalRolesRoleIdGet(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdGetRequest, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountGlobalRolesRoleIdGet(requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPermissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountGlobalRolesRoleIdPermissionsGet(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPermissionsGetRequest, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountGlobalRolesRoleIdPermissionsGet(requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountGlobalRolesRoleIdPut(requestParameters: AccountAdminApiApiV1AdminAccountGlobalRolesRoleIdPutRequest, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountGlobalRolesRoleIdPut(requestParameters.roleId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateGlobalRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountGlobalUsersUserIdRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountGlobalUsersUserIdRolesPut(requestParameters: AccountAdminApiApiV1AdminAccountGlobalUsersUserIdRolesPutRequest, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountGlobalUsersUserIdRolesPut(requestParameters.userId, requestParameters.nexusOpsAppVersion, requestParameters.updateUserRolesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountTenantsPermissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountTenantsPermissionsGet(requestParameters: AccountAdminApiApiV1AdminAccountTenantsPermissionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountTenantsPermissionsGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGet(requestParameters: AccountAdminApiApiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGetRequest, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountTenantsTenantIdRoleAssignmentsRestrictionsGet(requestParameters.tenantId, requestParameters.nexusOpsAppVersion, requestParameters.targetUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountTenantsTenantIdRolesGet(requestParameters: AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesGetRequest, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountTenantsTenantIdRolesGet(requestParameters.tenantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountTenantsTenantIdRolesRoleIdGet(requestParameters: AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdGetRequest, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountTenantsTenantIdRolesRoleIdGet(requestParameters.tenantId, requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGet(requestParameters: AccountAdminApiApiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGetRequest, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountTenantsTenantIdRolesRoleIdPermissionsGet(requestParameters.tenantId, requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountTenantsTenantIdUsersUserIdRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut(requestParameters: AccountAdminApiApiV1AdminAccountTenantsTenantIdUsersUserIdRolesPutRequest, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountTenantsTenantIdUsersUserIdRolesPut(requestParameters.tenantId, requestParameters.userId, requestParameters.nexusOpsAppVersion, requestParameters.adminUserRolesUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountAdminApiApiV1AdminAccountTenantsTenantIdrolesByIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdminApi
     */
    public apiV1AdminAccountTenantsTenantIdrolesByIdsGet(requestParameters: AccountAdminApiApiV1AdminAccountTenantsTenantIdrolesByIdsGetRequest, options?: RawAxiosRequestConfig) {
        return AccountAdminApiFp(this.configuration).apiV1AdminAccountTenantsTenantIdrolesByIdsGet(requestParameters.tenantId, requestParameters.nexusOpsAppVersion, requestParameters.roleIds, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssessmentFlowsApi - axios parameter creator
 * @export
 */
export const AssessmentFlowsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assessmentFlowId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost: async (nexusOpsTenant: string, assessmentFlowId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assessmentFlowId' is not null or undefined
            assertParamExists('apiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost', 'assessmentFlowId', assessmentFlowId)
            const localVarPath = `/api/v1/flows/assessment-flows/{assessmentFlowId}/add-assignment`
                .replace(`{${"assessmentFlowId"}}`, encodeURIComponent(String(assessmentFlowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentAddEntityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assessmentFlowId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FlowsAssessmentFlowsAssessmentFlowIdGet: async (nexusOpsTenant: string, assessmentFlowId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1FlowsAssessmentFlowsAssessmentFlowIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assessmentFlowId' is not null or undefined
            assertParamExists('apiV1FlowsAssessmentFlowsAssessmentFlowIdGet', 'assessmentFlowId', assessmentFlowId)
            const localVarPath = `/api/v1/flows/assessment-flows/{assessmentFlowId}`
                .replace(`{${"assessmentFlowId"}}`, encodeURIComponent(String(assessmentFlowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assessmentFlowId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPost: async (nexusOpsTenant: string, assessmentFlowId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assessmentFlowId' is not null or undefined
            assertParamExists('apiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPost', 'assessmentFlowId', assessmentFlowId)
            const localVarPath = `/api/v1/flows/assessment-flows/{assessmentFlowId}/send-to-customer`
                .replace(`{${"assessmentFlowId"}}`, encodeURIComponent(String(assessmentFlowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assessmentFlowId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePost: async (nexusOpsTenant: string, assessmentFlowId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assessmentFlowId' is not null or undefined
            assertParamExists('apiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePost', 'assessmentFlowId', assessmentFlowId)
            const localVarPath = `/api/v1/flows/assessment-flows/{assessmentFlowId}/state/recompute`
                .replace(`{${"assessmentFlowId"}}`, encodeURIComponent(String(assessmentFlowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FlowsAssessmentFlowsByContractContractIdGet: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1FlowsAssessmentFlowsByContractContractIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1FlowsAssessmentFlowsByContractContractIdGet', 'contractId', contractId)
            const localVarPath = `/api/v1/flows/assessment-flows/by-contract/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssessmentFlowGetCountersDto} [assessmentFlowGetCountersDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FlowsAssessmentFlowsCountersGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, assessmentFlowGetCountersDto?: AssessmentFlowGetCountersDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1FlowsAssessmentFlowsCountersGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/flows/assessment-flows/counters/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assessmentFlowGetCountersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssessmentFlowGetPaginatedDto} [assessmentFlowGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FlowsAssessmentFlowsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, assessmentFlowGetPaginatedDto?: AssessmentFlowGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1FlowsAssessmentFlowsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/flows/assessment-flows/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assessmentFlowGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssessmentFlowsApi - functional programming interface
 * @export
 */
export const AssessmentFlowsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssessmentFlowsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assessmentFlowId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost(nexusOpsTenant: string, assessmentFlowId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentFlowDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost(nexusOpsTenant, assessmentFlowId, nexusOpsAppVersion, assignmentAddEntityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentFlowsApi.apiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assessmentFlowId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FlowsAssessmentFlowsAssessmentFlowIdGet(nexusOpsTenant: string, assessmentFlowId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentFlowDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FlowsAssessmentFlowsAssessmentFlowIdGet(nexusOpsTenant, assessmentFlowId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentFlowsApi.apiV1FlowsAssessmentFlowsAssessmentFlowIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assessmentFlowId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPost(nexusOpsTenant: string, assessmentFlowId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPost(nexusOpsTenant, assessmentFlowId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentFlowsApi.apiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assessmentFlowId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePost(nexusOpsTenant: string, assessmentFlowId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentFlowDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePost(nexusOpsTenant, assessmentFlowId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentFlowsApi.apiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FlowsAssessmentFlowsByContractContractIdGet(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentFlowDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FlowsAssessmentFlowsByContractContractIdGet(nexusOpsTenant, contractId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentFlowsApi.apiV1FlowsAssessmentFlowsByContractContractIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssessmentFlowGetCountersDto} [assessmentFlowGetCountersDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FlowsAssessmentFlowsCountersGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, assessmentFlowGetCountersDto?: AssessmentFlowGetCountersDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentFlowCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FlowsAssessmentFlowsCountersGetPost(nexusOpsTenant, nexusOpsAppVersion, assessmentFlowGetCountersDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentFlowsApi.apiV1FlowsAssessmentFlowsCountersGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssessmentFlowGetPaginatedDto} [assessmentFlowGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FlowsAssessmentFlowsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, assessmentFlowGetPaginatedDto?: AssessmentFlowGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAssessmentFlowBriefDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FlowsAssessmentFlowsGetPost(nexusOpsTenant, nexusOpsAppVersion, assessmentFlowGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentFlowsApi.apiV1FlowsAssessmentFlowsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssessmentFlowsApi - factory interface
 * @export
 */
export const AssessmentFlowsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssessmentFlowsApiFp(configuration)
    return {
        /**
         * 
         * @param {AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost(requestParameters: AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentFlowDto> {
            return localVarFp.apiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost(requestParameters.nexusOpsTenant, requestParameters.assessmentFlowId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FlowsAssessmentFlowsAssessmentFlowIdGet(requestParameters: AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentFlowDto> {
            return localVarFp.apiV1FlowsAssessmentFlowsAssessmentFlowIdGet(requestParameters.nexusOpsTenant, requestParameters.assessmentFlowId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPost(requestParameters: AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPost(requestParameters.nexusOpsTenant, requestParameters.assessmentFlowId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePost(requestParameters: AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentFlowDto> {
            return localVarFp.apiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePost(requestParameters.nexusOpsTenant, requestParameters.assessmentFlowId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssessmentFlowsApiApiV1FlowsAssessmentFlowsByContractContractIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FlowsAssessmentFlowsByContractContractIdGet(requestParameters: AssessmentFlowsApiApiV1FlowsAssessmentFlowsByContractContractIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentFlowDto> {
            return localVarFp.apiV1FlowsAssessmentFlowsByContractContractIdGet(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssessmentFlowsApiApiV1FlowsAssessmentFlowsCountersGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FlowsAssessmentFlowsCountersGetPost(requestParameters: AssessmentFlowsApiApiV1FlowsAssessmentFlowsCountersGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentFlowCountersDto> {
            return localVarFp.apiV1FlowsAssessmentFlowsCountersGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assessmentFlowGetCountersDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssessmentFlowsApiApiV1FlowsAssessmentFlowsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FlowsAssessmentFlowsGetPost(requestParameters: AssessmentFlowsApiApiV1FlowsAssessmentFlowsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAssessmentFlowBriefDto> {
            return localVarFp.apiV1FlowsAssessmentFlowsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assessmentFlowGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost operation in AssessmentFlowsApi.
 * @export
 * @interface AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPostRequest
 */
export interface AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost
     */
    readonly assessmentFlowId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentAddEntityDto}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost
     */
    readonly assignmentAddEntityDto?: AssignmentAddEntityDto
}

/**
 * Request parameters for apiV1FlowsAssessmentFlowsAssessmentFlowIdGet operation in AssessmentFlowsApi.
 * @export
 * @interface AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdGetRequest
 */
export interface AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdGet
     */
    readonly assessmentFlowId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPost operation in AssessmentFlowsApi.
 * @export
 * @interface AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPostRequest
 */
export interface AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPost
     */
    readonly assessmentFlowId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePost operation in AssessmentFlowsApi.
 * @export
 * @interface AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePostRequest
 */
export interface AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePost
     */
    readonly assessmentFlowId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1FlowsAssessmentFlowsByContractContractIdGet operation in AssessmentFlowsApi.
 * @export
 * @interface AssessmentFlowsApiApiV1FlowsAssessmentFlowsByContractContractIdGetRequest
 */
export interface AssessmentFlowsApiApiV1FlowsAssessmentFlowsByContractContractIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsByContractContractIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsByContractContractIdGet
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsByContractContractIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1FlowsAssessmentFlowsCountersGetPost operation in AssessmentFlowsApi.
 * @export
 * @interface AssessmentFlowsApiApiV1FlowsAssessmentFlowsCountersGetPostRequest
 */
export interface AssessmentFlowsApiApiV1FlowsAssessmentFlowsCountersGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsCountersGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsCountersGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssessmentFlowGetCountersDto}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsCountersGetPost
     */
    readonly assessmentFlowGetCountersDto?: AssessmentFlowGetCountersDto
}

/**
 * Request parameters for apiV1FlowsAssessmentFlowsGetPost operation in AssessmentFlowsApi.
 * @export
 * @interface AssessmentFlowsApiApiV1FlowsAssessmentFlowsGetPostRequest
 */
export interface AssessmentFlowsApiApiV1FlowsAssessmentFlowsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssessmentFlowGetPaginatedDto}
     * @memberof AssessmentFlowsApiApiV1FlowsAssessmentFlowsGetPost
     */
    readonly assessmentFlowGetPaginatedDto?: AssessmentFlowGetPaginatedDto
}

/**
 * AssessmentFlowsApi - object-oriented interface
 * @export
 * @class AssessmentFlowsApi
 * @extends {BaseAPI}
 */
export class AssessmentFlowsApi extends BaseAPI {
    /**
     * 
     * @param {AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentFlowsApi
     */
    public apiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost(requestParameters: AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPostRequest, options?: RawAxiosRequestConfig) {
        return AssessmentFlowsApiFp(this.configuration).apiV1FlowsAssessmentFlowsAssessmentFlowIdAddAssignmentPost(requestParameters.nexusOpsTenant, requestParameters.assessmentFlowId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentFlowsApi
     */
    public apiV1FlowsAssessmentFlowsAssessmentFlowIdGet(requestParameters: AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdGetRequest, options?: RawAxiosRequestConfig) {
        return AssessmentFlowsApiFp(this.configuration).apiV1FlowsAssessmentFlowsAssessmentFlowIdGet(requestParameters.nexusOpsTenant, requestParameters.assessmentFlowId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentFlowsApi
     */
    public apiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPost(requestParameters: AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPostRequest, options?: RawAxiosRequestConfig) {
        return AssessmentFlowsApiFp(this.configuration).apiV1FlowsAssessmentFlowsAssessmentFlowIdSendToCustomerPost(requestParameters.nexusOpsTenant, requestParameters.assessmentFlowId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentFlowsApi
     */
    public apiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePost(requestParameters: AssessmentFlowsApiApiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePostRequest, options?: RawAxiosRequestConfig) {
        return AssessmentFlowsApiFp(this.configuration).apiV1FlowsAssessmentFlowsAssessmentFlowIdStateRecomputePost(requestParameters.nexusOpsTenant, requestParameters.assessmentFlowId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssessmentFlowsApiApiV1FlowsAssessmentFlowsByContractContractIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentFlowsApi
     */
    public apiV1FlowsAssessmentFlowsByContractContractIdGet(requestParameters: AssessmentFlowsApiApiV1FlowsAssessmentFlowsByContractContractIdGetRequest, options?: RawAxiosRequestConfig) {
        return AssessmentFlowsApiFp(this.configuration).apiV1FlowsAssessmentFlowsByContractContractIdGet(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssessmentFlowsApiApiV1FlowsAssessmentFlowsCountersGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentFlowsApi
     */
    public apiV1FlowsAssessmentFlowsCountersGetPost(requestParameters: AssessmentFlowsApiApiV1FlowsAssessmentFlowsCountersGetPostRequest, options?: RawAxiosRequestConfig) {
        return AssessmentFlowsApiFp(this.configuration).apiV1FlowsAssessmentFlowsCountersGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assessmentFlowGetCountersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssessmentFlowsApiApiV1FlowsAssessmentFlowsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentFlowsApi
     */
    public apiV1FlowsAssessmentFlowsGetPost(requestParameters: AssessmentFlowsApiApiV1FlowsAssessmentFlowsGetPostRequest, options?: RawAxiosRequestConfig) {
        return AssessmentFlowsApiFp(this.configuration).apiV1FlowsAssessmentFlowsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assessmentFlowGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssetSubscriptionPlansApi - axios parameter creator
 * @export
 */
export const AssetSubscriptionPlansApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [productLocationId] 
         * @param {string} [dateRangeFrom] Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {string} [dateRangeTo] Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet: async (nexusOpsTenant: string, assetSubscriptionPlanId: string, nexusOpsAppVersion?: string, productLocationId?: string, dateRangeFrom?: string, dateRangeTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetSubscriptionPlanId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet', 'assetSubscriptionPlanId', assetSubscriptionPlanId)
            const localVarPath = `/api/v1/asset-subscription-plans/{assetSubscriptionPlanId}/availability`
                .replace(`{${"assetSubscriptionPlanId"}}`, encodeURIComponent(String(assetSubscriptionPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productLocationId !== undefined) {
                localVarQueryParameter['productLocationId'] = productLocationId;
            }

            if (dateRangeFrom !== undefined) {
                localVarQueryParameter['dateRange.from'] = dateRangeFrom;
            }

            if (dateRangeTo !== undefined) {
                localVarQueryParameter['dateRange.to'] = dateRangeTo;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete: async (nexusOpsTenant: string, assetSubscriptionPlanId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetSubscriptionPlanId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete', 'assetSubscriptionPlanId', assetSubscriptionPlanId)
            const localVarPath = `/api/v1/asset-subscription-plans/{assetSubscriptionPlanId}`
                .replace(`{${"assetSubscriptionPlanId"}}`, encodeURIComponent(String(assetSubscriptionPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePost: async (nexusOpsTenant: string, assetSubscriptionPlanId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetSubscriptionPlanId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePost', 'assetSubscriptionPlanId', assetSubscriptionPlanId)
            const localVarPath = `/api/v1/asset-subscription-plans/{assetSubscriptionPlanId}/enabled/toggle`
                .replace(`{${"assetSubscriptionPlanId"}}`, encodeURIComponent(String(assetSubscriptionPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGet: async (nexusOpsTenant: string, assetSubscriptionPlanId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetSubscriptionPlanId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGet', 'assetSubscriptionPlanId', assetSubscriptionPlanId)
            const localVarPath = `/api/v1/asset-subscription-plans/{assetSubscriptionPlanId}`
                .replace(`{${"assetSubscriptionPlanId"}}`, encodeURIComponent(String(assetSubscriptionPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddAssetSubscriptionPlanProductLocationsDto} [addAssetSubscriptionPlanProductLocationsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost: async (nexusOpsTenant: string, assetSubscriptionPlanId: string, nexusOpsAppVersion?: string, addAssetSubscriptionPlanProductLocationsDto?: AddAssetSubscriptionPlanProductLocationsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetSubscriptionPlanId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost', 'assetSubscriptionPlanId', assetSubscriptionPlanId)
            const localVarPath = `/api/v1/asset-subscription-plans/{assetSubscriptionPlanId}/product-locations`
                .replace(`{${"assetSubscriptionPlanId"}}`, encodeURIComponent(String(assetSubscriptionPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAssetSubscriptionPlanProductLocationsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionPlanId 
         * @param {string} productLocationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete: async (nexusOpsTenant: string, assetSubscriptionPlanId: string, productLocationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetSubscriptionPlanId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete', 'assetSubscriptionPlanId', assetSubscriptionPlanId)
            // verify required parameter 'productLocationId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete', 'productLocationId', productLocationId)
            const localVarPath = `/api/v1/asset-subscription-plans/{assetSubscriptionPlanId}/product-locations/{productLocationId}`
                .replace(`{${"assetSubscriptionPlanId"}}`, encodeURIComponent(String(assetSubscriptionPlanId)))
                .replace(`{${"productLocationId"}}`, encodeURIComponent(String(productLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionPlanUpdateDto} [assetSubscriptionPlanUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut: async (nexusOpsTenant: string, assetSubscriptionPlanId: string, nexusOpsAppVersion?: string, assetSubscriptionPlanUpdateDto?: AssetSubscriptionPlanUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetSubscriptionPlanId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut', 'assetSubscriptionPlanId', assetSubscriptionPlanId)
            const localVarPath = `/api/v1/asset-subscription-plans/{assetSubscriptionPlanId}`
                .replace(`{${"assetSubscriptionPlanId"}}`, encodeURIComponent(String(assetSubscriptionPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetSubscriptionPlanUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/asset-subscription-plans/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionPlanGetPaginatedDto} [assetSubscriptionPlanGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, assetSubscriptionPlanGetPaginatedDto?: AssetSubscriptionPlanGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/asset-subscription-plans/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetSubscriptionPlanGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionPlanCreateDto} [assetSubscriptionPlanCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, assetSubscriptionPlanCreateDto?: AssetSubscriptionPlanCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionPlansPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/asset-subscription-plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetSubscriptionPlanCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetSubscriptionPlansApi - functional programming interface
 * @export
 */
export const AssetSubscriptionPlansApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetSubscriptionPlansApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [productLocationId] 
         * @param {string} [dateRangeFrom] Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {string} [dateRangeTo] Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet(nexusOpsTenant: string, assetSubscriptionPlanId: string, nexusOpsAppVersion?: string, productLocationId?: string, dateRangeFrom?: string, dateRangeTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionPlanAvailabilityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet(nexusOpsTenant, assetSubscriptionPlanId, nexusOpsAppVersion, productLocationId, dateRangeFrom, dateRangeTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionPlansApi.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete(nexusOpsTenant: string, assetSubscriptionPlanId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete(nexusOpsTenant, assetSubscriptionPlanId, nexusOpsAppVersion, isDeleteCascade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionPlansApi.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePost(nexusOpsTenant: string, assetSubscriptionPlanId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionPlanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePost(nexusOpsTenant, assetSubscriptionPlanId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionPlansApi.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGet(nexusOpsTenant: string, assetSubscriptionPlanId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionPlanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGet(nexusOpsTenant, assetSubscriptionPlanId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionPlansApi.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddAssetSubscriptionPlanProductLocationsDto} [addAssetSubscriptionPlanProductLocationsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost(nexusOpsTenant: string, assetSubscriptionPlanId: string, nexusOpsAppVersion?: string, addAssetSubscriptionPlanProductLocationsDto?: AddAssetSubscriptionPlanProductLocationsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionPlanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost(nexusOpsTenant, assetSubscriptionPlanId, nexusOpsAppVersion, addAssetSubscriptionPlanProductLocationsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionPlansApi.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionPlanId 
         * @param {string} productLocationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete(nexusOpsTenant: string, assetSubscriptionPlanId: string, productLocationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionPlanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete(nexusOpsTenant, assetSubscriptionPlanId, productLocationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionPlansApi.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionPlanUpdateDto} [assetSubscriptionPlanUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut(nexusOpsTenant: string, assetSubscriptionPlanId: string, nexusOpsAppVersion?: string, assetSubscriptionPlanUpdateDto?: AssetSubscriptionPlanUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionPlanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut(nexusOpsTenant, assetSubscriptionPlanId, nexusOpsAppVersion, assetSubscriptionPlanUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionPlansApi.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionPlansBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionPlansBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionPlansApi.apiV1AssetSubscriptionPlansBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionPlanGetPaginatedDto} [assetSubscriptionPlanGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionPlansGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, assetSubscriptionPlanGetPaginatedDto?: AssetSubscriptionPlanGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAssetSubscriptionPlanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionPlansGetPost(nexusOpsTenant, nexusOpsAppVersion, assetSubscriptionPlanGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionPlansApi.apiV1AssetSubscriptionPlansGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionPlanCreateDto} [assetSubscriptionPlanCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionPlansPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, assetSubscriptionPlanCreateDto?: AssetSubscriptionPlanCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionPlanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionPlansPost(nexusOpsTenant, nexusOpsAppVersion, assetSubscriptionPlanCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionPlansApi.apiV1AssetSubscriptionPlansPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssetSubscriptionPlansApi - factory interface
 * @export
 */
export const AssetSubscriptionPlansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetSubscriptionPlansApiFp(configuration)
    return {
        /**
         * 
         * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionPlanAvailabilityDto> {
            return localVarFp.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionPlanId, requestParameters.nexusOpsAppVersion, requestParameters.productLocationId, requestParameters.dateRangeFrom, requestParameters.dateRangeTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionPlanId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePost(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionPlanDto> {
            return localVarFp.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePost(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionPlanId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGet(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionPlanDto> {
            return localVarFp.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGet(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionPlanId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionPlanDto> {
            return localVarFp.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionPlanId, requestParameters.nexusOpsAppVersion, requestParameters.addAssetSubscriptionPlanProductLocationsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionPlanDto> {
            return localVarFp.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionPlanId, requestParameters.productLocationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionPlanDto> {
            return localVarFp.apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionPlanId, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionPlanUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansBulkDeleteDelete(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AssetSubscriptionPlansBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansGetPost(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAssetSubscriptionPlanDto> {
            return localVarFp.apiV1AssetSubscriptionPlansGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionPlanGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionPlansPost(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionPlanDto> {
            return localVarFp.apiV1AssetSubscriptionPlansPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionPlanCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet operation in AssetSubscriptionPlansApi.
 * @export
 * @interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGetRequest
 */
export interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet
     */
    readonly assetSubscriptionPlanId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet
     */
    readonly productLocationId?: string

    /**
     * Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet
     */
    readonly dateRangeFrom?: string

    /**
     * Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet
     */
    readonly dateRangeTo?: string
}

/**
 * Request parameters for apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete operation in AssetSubscriptionPlansApi.
 * @export
 * @interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDeleteRequest
 */
export interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete
     */
    readonly assetSubscriptionPlanId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete
     */
    readonly isDeleteCascade?: boolean
}

/**
 * Request parameters for apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePost operation in AssetSubscriptionPlansApi.
 * @export
 * @interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePostRequest
 */
export interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePost
     */
    readonly assetSubscriptionPlanId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGet operation in AssetSubscriptionPlansApi.
 * @export
 * @interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGetRequest
 */
export interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGet
     */
    readonly assetSubscriptionPlanId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost operation in AssetSubscriptionPlansApi.
 * @export
 * @interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPostRequest
 */
export interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost
     */
    readonly assetSubscriptionPlanId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AddAssetSubscriptionPlanProductLocationsDto}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost
     */
    readonly addAssetSubscriptionPlanProductLocationsDto?: AddAssetSubscriptionPlanProductLocationsDto
}

/**
 * Request parameters for apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete operation in AssetSubscriptionPlansApi.
 * @export
 * @interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDeleteRequest
 */
export interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete
     */
    readonly assetSubscriptionPlanId: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete
     */
    readonly productLocationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut operation in AssetSubscriptionPlansApi.
 * @export
 * @interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPutRequest
 */
export interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut
     */
    readonly assetSubscriptionPlanId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssetSubscriptionPlanUpdateDto}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut
     */
    readonly assetSubscriptionPlanUpdateDto?: AssetSubscriptionPlanUpdateDto
}

/**
 * Request parameters for apiV1AssetSubscriptionPlansBulkDeleteDelete operation in AssetSubscriptionPlansApi.
 * @export
 * @interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansBulkDeleteDeleteRequest
 */
export interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1AssetSubscriptionPlansGetPost operation in AssetSubscriptionPlansApi.
 * @export
 * @interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansGetPostRequest
 */
export interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssetSubscriptionPlanGetPaginatedDto}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansGetPost
     */
    readonly assetSubscriptionPlanGetPaginatedDto?: AssetSubscriptionPlanGetPaginatedDto
}

/**
 * Request parameters for apiV1AssetSubscriptionPlansPost operation in AssetSubscriptionPlansApi.
 * @export
 * @interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansPostRequest
 */
export interface AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssetSubscriptionPlanCreateDto}
     * @memberof AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansPost
     */
    readonly assetSubscriptionPlanCreateDto?: AssetSubscriptionPlanCreateDto
}

/**
 * AssetSubscriptionPlansApi - object-oriented interface
 * @export
 * @class AssetSubscriptionPlansApi
 * @extends {BaseAPI}
 */
export class AssetSubscriptionPlansApi extends BaseAPI {
    /**
     * 
     * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionPlansApi
     */
    public apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGetRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionPlansApiFp(this.configuration).apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdAvailabilityGet(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionPlanId, requestParameters.nexusOpsAppVersion, requestParameters.productLocationId, requestParameters.dateRangeFrom, requestParameters.dateRangeTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionPlansApi
     */
    public apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionPlansApiFp(this.configuration).apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdDelete(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionPlanId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionPlansApi
     */
    public apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePost(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePostRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionPlansApiFp(this.configuration).apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdEnabledTogglePost(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionPlanId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionPlansApi
     */
    public apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGet(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGetRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionPlansApiFp(this.configuration).apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdGet(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionPlanId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionPlansApi
     */
    public apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPostRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionPlansApiFp(this.configuration).apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsPost(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionPlanId, requestParameters.nexusOpsAppVersion, requestParameters.addAssetSubscriptionPlanProductLocationsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionPlansApi
     */
    public apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionPlansApiFp(this.configuration).apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdProductLocationsProductLocationIdDelete(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionPlanId, requestParameters.productLocationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionPlansApi
     */
    public apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPutRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionPlansApiFp(this.configuration).apiV1AssetSubscriptionPlansAssetSubscriptionPlanIdPut(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionPlanId, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionPlanUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionPlansApi
     */
    public apiV1AssetSubscriptionPlansBulkDeleteDelete(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionPlansApiFp(this.configuration).apiV1AssetSubscriptionPlansBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionPlansApi
     */
    public apiV1AssetSubscriptionPlansGetPost(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansGetPostRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionPlansApiFp(this.configuration).apiV1AssetSubscriptionPlansGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionPlanGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionPlansApi
     */
    public apiV1AssetSubscriptionPlansPost(requestParameters: AssetSubscriptionPlansApiApiV1AssetSubscriptionPlansPostRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionPlansApiFp(this.configuration).apiV1AssetSubscriptionPlansPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionPlanCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssetSubscriptionsApi - axios parameter creator
 * @export
 */
export const AssetSubscriptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPost: async (nexusOpsTenant: string, assetSubscriptionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetSubscriptionId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPost', 'assetSubscriptionId', assetSubscriptionId)
            const localVarPath = `/api/v1/asset-subscriptions/{assetSubscriptionId}/asset/allocation/confirm`
                .replace(`{${"assetSubscriptionId"}}`, encodeURIComponent(String(assetSubscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionReallocateAssetDto} [assetSubscriptionReallocateAssetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost: async (nexusOpsTenant: string, assetSubscriptionId: string, nexusOpsAppVersion?: string, assetSubscriptionReallocateAssetDto?: AssetSubscriptionReallocateAssetDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetSubscriptionId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost', 'assetSubscriptionId', assetSubscriptionId)
            const localVarPath = `/api/v1/asset-subscriptions/{assetSubscriptionId}/asset/allocation/reallocate`
                .replace(`{${"assetSubscriptionId"}}`, encodeURIComponent(String(assetSubscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetSubscriptionReallocateAssetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePost: async (nexusOpsTenant: string, assetSubscriptionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetSubscriptionId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePost', 'assetSubscriptionId', assetSubscriptionId)
            const localVarPath = `/api/v1/asset-subscriptions/{assetSubscriptionId}/asset/release`
                .replace(`{${"assetSubscriptionId"}}`, encodeURIComponent(String(assetSubscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsAssetSubscriptionIdDelete: async (nexusOpsTenant: string, assetSubscriptionId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsAssetSubscriptionIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetSubscriptionId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsAssetSubscriptionIdDelete', 'assetSubscriptionId', assetSubscriptionId)
            const localVarPath = `/api/v1/asset-subscriptions/{assetSubscriptionId}`
                .replace(`{${"assetSubscriptionId"}}`, encodeURIComponent(String(assetSubscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsAssetSubscriptionIdGet: async (nexusOpsTenant: string, assetSubscriptionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsAssetSubscriptionIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetSubscriptionId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsAssetSubscriptionIdGet', 'assetSubscriptionId', assetSubscriptionId)
            const localVarPath = `/api/v1/asset-subscriptions/{assetSubscriptionId}`
                .replace(`{${"assetSubscriptionId"}}`, encodeURIComponent(String(assetSubscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionUpdateDto} [assetSubscriptionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsAssetSubscriptionIdPut: async (nexusOpsTenant: string, assetSubscriptionId: string, nexusOpsAppVersion?: string, assetSubscriptionUpdateDto?: AssetSubscriptionUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsAssetSubscriptionIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetSubscriptionId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsAssetSubscriptionIdPut', 'assetSubscriptionId', assetSubscriptionId)
            const localVarPath = `/api/v1/asset-subscriptions/{assetSubscriptionId}`
                .replace(`{${"assetSubscriptionId"}}`, encodeURIComponent(String(assetSubscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetSubscriptionUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionUpdateStatusDto} [assetSubscriptionUpdateStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsAssetSubscriptionIdStatusPut: async (nexusOpsTenant: string, assetSubscriptionId: string, nexusOpsAppVersion?: string, assetSubscriptionUpdateStatusDto?: AssetSubscriptionUpdateStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsAssetSubscriptionIdStatusPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetSubscriptionId' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsAssetSubscriptionIdStatusPut', 'assetSubscriptionId', assetSubscriptionId)
            const localVarPath = `/api/v1/asset-subscriptions/{assetSubscriptionId}/status`
                .replace(`{${"assetSubscriptionId"}}`, encodeURIComponent(String(assetSubscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetSubscriptionUpdateStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/asset-subscriptions/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionGetCountersDto} [assetSubscriptionGetCountersDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsCountersGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, assetSubscriptionGetCountersDto?: AssetSubscriptionGetCountersDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsCountersGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/asset-subscriptions/counters/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetSubscriptionGetCountersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionGetPaginatedDto} [assetSubscriptionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, assetSubscriptionGetPaginatedDto?: AssetSubscriptionGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/asset-subscriptions/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetSubscriptionGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionCreateDto} [assetSubscriptionCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, assetSubscriptionCreateDto?: AssetSubscriptionCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetSubscriptionsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/asset-subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetSubscriptionCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetSubscriptionsApi - functional programming interface
 * @export
 */
export const AssetSubscriptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetSubscriptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPost(nexusOpsTenant: string, assetSubscriptionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPost(nexusOpsTenant, assetSubscriptionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionsApi.apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionReallocateAssetDto} [assetSubscriptionReallocateAssetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost(nexusOpsTenant: string, assetSubscriptionId: string, nexusOpsAppVersion?: string, assetSubscriptionReallocateAssetDto?: AssetSubscriptionReallocateAssetDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost(nexusOpsTenant, assetSubscriptionId, nexusOpsAppVersion, assetSubscriptionReallocateAssetDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionsApi.apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePost(nexusOpsTenant: string, assetSubscriptionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePost(nexusOpsTenant, assetSubscriptionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionsApi.apiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionsAssetSubscriptionIdDelete(nexusOpsTenant: string, assetSubscriptionId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionsAssetSubscriptionIdDelete(nexusOpsTenant, assetSubscriptionId, nexusOpsAppVersion, isDeleteCascade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionsApi.apiV1AssetSubscriptionsAssetSubscriptionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionsAssetSubscriptionIdGet(nexusOpsTenant: string, assetSubscriptionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionsAssetSubscriptionIdGet(nexusOpsTenant, assetSubscriptionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionsApi.apiV1AssetSubscriptionsAssetSubscriptionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionUpdateDto} [assetSubscriptionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionsAssetSubscriptionIdPut(nexusOpsTenant: string, assetSubscriptionId: string, nexusOpsAppVersion?: string, assetSubscriptionUpdateDto?: AssetSubscriptionUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionsAssetSubscriptionIdPut(nexusOpsTenant, assetSubscriptionId, nexusOpsAppVersion, assetSubscriptionUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionsApi.apiV1AssetSubscriptionsAssetSubscriptionIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetSubscriptionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionUpdateStatusDto} [assetSubscriptionUpdateStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionsAssetSubscriptionIdStatusPut(nexusOpsTenant: string, assetSubscriptionId: string, nexusOpsAppVersion?: string, assetSubscriptionUpdateStatusDto?: AssetSubscriptionUpdateStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionsAssetSubscriptionIdStatusPut(nexusOpsTenant, assetSubscriptionId, nexusOpsAppVersion, assetSubscriptionUpdateStatusDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionsApi.apiV1AssetSubscriptionsAssetSubscriptionIdStatusPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionsBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionsBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionsApi.apiV1AssetSubscriptionsBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionGetCountersDto} [assetSubscriptionGetCountersDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionsCountersGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, assetSubscriptionGetCountersDto?: AssetSubscriptionGetCountersDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionsCountersGetPost(nexusOpsTenant, nexusOpsAppVersion, assetSubscriptionGetCountersDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionsApi.apiV1AssetSubscriptionsCountersGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionGetPaginatedDto} [assetSubscriptionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, assetSubscriptionGetPaginatedDto?: AssetSubscriptionGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAssetSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionsGetPost(nexusOpsTenant, nexusOpsAppVersion, assetSubscriptionGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionsApi.apiV1AssetSubscriptionsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSubscriptionCreateDto} [assetSubscriptionCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetSubscriptionsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, assetSubscriptionCreateDto?: AssetSubscriptionCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetSubscriptionsPost(nexusOpsTenant, nexusOpsAppVersion, assetSubscriptionCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetSubscriptionsApi.apiV1AssetSubscriptionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssetSubscriptionsApi - factory interface
 * @export
 */
export const AssetSubscriptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetSubscriptionsApiFp(configuration)
    return {
        /**
         * 
         * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPost(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionDto> {
            return localVarFp.apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPost(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionDto> {
            return localVarFp.apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionId, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionReallocateAssetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePost(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionDto> {
            return localVarFp.apiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePost(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsAssetSubscriptionIdDelete(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AssetSubscriptionsAssetSubscriptionIdDelete(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsAssetSubscriptionIdGet(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionDto> {
            return localVarFp.apiV1AssetSubscriptionsAssetSubscriptionIdGet(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsAssetSubscriptionIdPut(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionDto> {
            return localVarFp.apiV1AssetSubscriptionsAssetSubscriptionIdPut(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionId, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdStatusPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsAssetSubscriptionIdStatusPut(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdStatusPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionDto> {
            return localVarFp.apiV1AssetSubscriptionsAssetSubscriptionIdStatusPut(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionId, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionUpdateStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsBulkDeleteDelete(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AssetSubscriptionsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsCountersGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsCountersGetPost(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsCountersGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionCountersDto> {
            return localVarFp.apiV1AssetSubscriptionsCountersGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionGetCountersDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsGetPost(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAssetSubscriptionDto> {
            return localVarFp.apiV1AssetSubscriptionsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetSubscriptionsPost(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSubscriptionDto> {
            return localVarFp.apiV1AssetSubscriptionsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPost operation in AssetSubscriptionsApi.
 * @export
 * @interface AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPostRequest
 */
export interface AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPost
     */
    readonly assetSubscriptionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost operation in AssetSubscriptionsApi.
 * @export
 * @interface AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePostRequest
 */
export interface AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost
     */
    readonly assetSubscriptionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssetSubscriptionReallocateAssetDto}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost
     */
    readonly assetSubscriptionReallocateAssetDto?: AssetSubscriptionReallocateAssetDto
}

/**
 * Request parameters for apiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePost operation in AssetSubscriptionsApi.
 * @export
 * @interface AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePostRequest
 */
export interface AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePost
     */
    readonly assetSubscriptionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssetSubscriptionsAssetSubscriptionIdDelete operation in AssetSubscriptionsApi.
 * @export
 * @interface AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdDeleteRequest
 */
export interface AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdDelete
     */
    readonly assetSubscriptionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdDelete
     */
    readonly isDeleteCascade?: boolean
}

/**
 * Request parameters for apiV1AssetSubscriptionsAssetSubscriptionIdGet operation in AssetSubscriptionsApi.
 * @export
 * @interface AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdGetRequest
 */
export interface AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdGet
     */
    readonly assetSubscriptionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssetSubscriptionsAssetSubscriptionIdPut operation in AssetSubscriptionsApi.
 * @export
 * @interface AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdPutRequest
 */
export interface AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdPut
     */
    readonly assetSubscriptionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssetSubscriptionUpdateDto}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdPut
     */
    readonly assetSubscriptionUpdateDto?: AssetSubscriptionUpdateDto
}

/**
 * Request parameters for apiV1AssetSubscriptionsAssetSubscriptionIdStatusPut operation in AssetSubscriptionsApi.
 * @export
 * @interface AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdStatusPutRequest
 */
export interface AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdStatusPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdStatusPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdStatusPut
     */
    readonly assetSubscriptionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdStatusPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssetSubscriptionUpdateStatusDto}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdStatusPut
     */
    readonly assetSubscriptionUpdateStatusDto?: AssetSubscriptionUpdateStatusDto
}

/**
 * Request parameters for apiV1AssetSubscriptionsBulkDeleteDelete operation in AssetSubscriptionsApi.
 * @export
 * @interface AssetSubscriptionsApiApiV1AssetSubscriptionsBulkDeleteDeleteRequest
 */
export interface AssetSubscriptionsApiApiV1AssetSubscriptionsBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1AssetSubscriptionsCountersGetPost operation in AssetSubscriptionsApi.
 * @export
 * @interface AssetSubscriptionsApiApiV1AssetSubscriptionsCountersGetPostRequest
 */
export interface AssetSubscriptionsApiApiV1AssetSubscriptionsCountersGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsCountersGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsCountersGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssetSubscriptionGetCountersDto}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsCountersGetPost
     */
    readonly assetSubscriptionGetCountersDto?: AssetSubscriptionGetCountersDto
}

/**
 * Request parameters for apiV1AssetSubscriptionsGetPost operation in AssetSubscriptionsApi.
 * @export
 * @interface AssetSubscriptionsApiApiV1AssetSubscriptionsGetPostRequest
 */
export interface AssetSubscriptionsApiApiV1AssetSubscriptionsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssetSubscriptionGetPaginatedDto}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsGetPost
     */
    readonly assetSubscriptionGetPaginatedDto?: AssetSubscriptionGetPaginatedDto
}

/**
 * Request parameters for apiV1AssetSubscriptionsPost operation in AssetSubscriptionsApi.
 * @export
 * @interface AssetSubscriptionsApiApiV1AssetSubscriptionsPostRequest
 */
export interface AssetSubscriptionsApiApiV1AssetSubscriptionsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssetSubscriptionCreateDto}
     * @memberof AssetSubscriptionsApiApiV1AssetSubscriptionsPost
     */
    readonly assetSubscriptionCreateDto?: AssetSubscriptionCreateDto
}

/**
 * AssetSubscriptionsApi - object-oriented interface
 * @export
 * @class AssetSubscriptionsApi
 * @extends {BaseAPI}
 */
export class AssetSubscriptionsApi extends BaseAPI {
    /**
     * 
     * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionsApi
     */
    public apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPost(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPostRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionsApiFp(this.configuration).apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationConfirmPost(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionsApi
     */
    public apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePostRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionsApiFp(this.configuration).apiV1AssetSubscriptionsAssetSubscriptionIdAssetAllocationReallocatePost(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionId, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionReallocateAssetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionsApi
     */
    public apiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePost(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePostRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionsApiFp(this.configuration).apiV1AssetSubscriptionsAssetSubscriptionIdAssetReleasePost(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionsApi
     */
    public apiV1AssetSubscriptionsAssetSubscriptionIdDelete(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionsApiFp(this.configuration).apiV1AssetSubscriptionsAssetSubscriptionIdDelete(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionsApi
     */
    public apiV1AssetSubscriptionsAssetSubscriptionIdGet(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdGetRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionsApiFp(this.configuration).apiV1AssetSubscriptionsAssetSubscriptionIdGet(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionsApi
     */
    public apiV1AssetSubscriptionsAssetSubscriptionIdPut(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdPutRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionsApiFp(this.configuration).apiV1AssetSubscriptionsAssetSubscriptionIdPut(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionId, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdStatusPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionsApi
     */
    public apiV1AssetSubscriptionsAssetSubscriptionIdStatusPut(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsAssetSubscriptionIdStatusPutRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionsApiFp(this.configuration).apiV1AssetSubscriptionsAssetSubscriptionIdStatusPut(requestParameters.nexusOpsTenant, requestParameters.assetSubscriptionId, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionUpdateStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionsApi
     */
    public apiV1AssetSubscriptionsBulkDeleteDelete(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionsApiFp(this.configuration).apiV1AssetSubscriptionsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsCountersGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionsApi
     */
    public apiV1AssetSubscriptionsCountersGetPost(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsCountersGetPostRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionsApiFp(this.configuration).apiV1AssetSubscriptionsCountersGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionGetCountersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionsApi
     */
    public apiV1AssetSubscriptionsGetPost(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsGetPostRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionsApiFp(this.configuration).apiV1AssetSubscriptionsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetSubscriptionsApiApiV1AssetSubscriptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetSubscriptionsApi
     */
    public apiV1AssetSubscriptionsPost(requestParameters: AssetSubscriptionsApiApiV1AssetSubscriptionsPostRequest, options?: RawAxiosRequestConfig) {
        return AssetSubscriptionsApiFp(this.configuration).apiV1AssetSubscriptionsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetSubscriptionCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssetsApi - axios parameter creator
 * @export
 */
export const AssetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsAssetIdDelete: async (nexusOpsTenant: string, assetId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetsAssetIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('apiV1AssetsAssetIdDelete', 'assetId', assetId)
            const localVarPath = `/api/v1/assets/{assetId}`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsAssetIdGet: async (nexusOpsTenant: string, assetId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetsAssetIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('apiV1AssetsAssetIdGet', 'assetId', assetId)
            const localVarPath = `/api/v1/assets/{assetId}`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetUpdateDto} [assetUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsAssetIdPut: async (nexusOpsTenant: string, assetId: string, nexusOpsAppVersion?: string, assetUpdateDto?: AssetUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetsAssetIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('apiV1AssetsAssetIdPut', 'assetId', assetId)
            const localVarPath = `/api/v1/assets/{assetId}`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetsBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assets/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetEntityType} [entityType] Must contain only values from EntityType.
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsByEntityGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityType?: AssetEntityType, entityId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetsByEntityGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assets/by-entity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {number} offset 
         * @param {number} limit 
         * @param {string} search 
         * @param {AssetEntityType} entityType Must contain only values from EntityType.
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsCandidatesGet: async (nexusOpsTenant: string, offset: number, limit: number, search: string, entityType: AssetEntityType, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetsCandidatesGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('apiV1AssetsCandidatesGet', 'offset', offset)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('apiV1AssetsCandidatesGet', 'limit', limit)
            // verify required parameter 'search' is not null or undefined
            assertParamExists('apiV1AssetsCandidatesGet', 'search', search)
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('apiV1AssetsCandidatesGet', 'entityType', entityType)
            const localVarPath = `/api/v1/assets/candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetGetPaginatedDto} [assetGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, assetGetPaginatedDto?: AssetGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assets/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetCreateDto} [assetCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, assetCreateDto?: AssetCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSearchPaginatedDto} [assetSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsSearchPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, assetSearchPaginatedDto?: AssetSearchPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetsSearchPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assets/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetSearchPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetEntityType} [entityType] Must contain only values from EntityType.
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsSpecInferFromEntityGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityType?: AssetEntityType, entityId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetsSpecInferFromEntityGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assets/spec/infer/from-entity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [poolId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsSpecInferFromPoolGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, poolId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssetsSpecInferFromPoolGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assets/spec/infer/from-pool`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (poolId !== undefined) {
                localVarQueryParameter['poolId'] = poolId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetsApi - functional programming interface
 * @export
 */
export const AssetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetsAssetIdDelete(nexusOpsTenant: string, assetId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetsAssetIdDelete(nexusOpsTenant, assetId, nexusOpsAppVersion, isDeleteCascade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.apiV1AssetsAssetIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetsAssetIdGet(nexusOpsTenant: string, assetId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetsAssetIdGet(nexusOpsTenant, assetId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.apiV1AssetsAssetIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assetId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetUpdateDto} [assetUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetsAssetIdPut(nexusOpsTenant: string, assetId: string, nexusOpsAppVersion?: string, assetUpdateDto?: AssetUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetsAssetIdPut(nexusOpsTenant, assetId, nexusOpsAppVersion, assetUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.apiV1AssetsAssetIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetsBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetsBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.apiV1AssetsBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetEntityType} [entityType] Must contain only values from EntityType.
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetsByEntityGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityType?: AssetEntityType, entityId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetsByEntityGet(nexusOpsTenant, nexusOpsAppVersion, entityType, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.apiV1AssetsByEntityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {number} offset 
         * @param {number} limit 
         * @param {string} search 
         * @param {AssetEntityType} entityType Must contain only values from EntityType.
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetsCandidatesGet(nexusOpsTenant: string, offset: number, limit: number, search: string, entityType: AssetEntityType, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAssetCandidateEntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetsCandidatesGet(nexusOpsTenant, offset, limit, search, entityType, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.apiV1AssetsCandidatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetGetPaginatedDto} [assetGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, assetGetPaginatedDto?: AssetGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetsGetPost(nexusOpsTenant, nexusOpsAppVersion, assetGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.apiV1AssetsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetCreateDto} [assetCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, assetCreateDto?: AssetCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetsPost(nexusOpsTenant, nexusOpsAppVersion, assetCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.apiV1AssetsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetSearchPaginatedDto} [assetSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetsSearchPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, assetSearchPaginatedDto?: AssetSearchPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetsSearchPost(nexusOpsTenant, nexusOpsAppVersion, assetSearchPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.apiV1AssetsSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssetEntityType} [entityType] Must contain only values from EntityType.
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetsSpecInferFromEntityGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityType?: AssetEntityType, entityId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSpecDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetsSpecInferFromEntityGet(nexusOpsTenant, nexusOpsAppVersion, entityType, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.apiV1AssetsSpecInferFromEntityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [poolId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssetsSpecInferFromPoolGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, poolId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetSpecDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssetsSpecInferFromPoolGet(nexusOpsTenant, nexusOpsAppVersion, poolId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.apiV1AssetsSpecInferFromPoolGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssetsApi - factory interface
 * @export
 */
export const AssetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetsApiFp(configuration)
    return {
        /**
         * 
         * @param {AssetsApiApiV1AssetsAssetIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsAssetIdDelete(requestParameters: AssetsApiApiV1AssetsAssetIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AssetsAssetIdDelete(requestParameters.nexusOpsTenant, requestParameters.assetId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetsApiApiV1AssetsAssetIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsAssetIdGet(requestParameters: AssetsApiApiV1AssetsAssetIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetDto> {
            return localVarFp.apiV1AssetsAssetIdGet(requestParameters.nexusOpsTenant, requestParameters.assetId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetsApiApiV1AssetsAssetIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsAssetIdPut(requestParameters: AssetsApiApiV1AssetsAssetIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetDto> {
            return localVarFp.apiV1AssetsAssetIdPut(requestParameters.nexusOpsTenant, requestParameters.assetId, requestParameters.nexusOpsAppVersion, requestParameters.assetUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetsApiApiV1AssetsBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsBulkDeleteDelete(requestParameters: AssetsApiApiV1AssetsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AssetsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetsApiApiV1AssetsByEntityGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsByEntityGet(requestParameters: AssetsApiApiV1AssetsByEntityGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetDto> {
            return localVarFp.apiV1AssetsByEntityGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityType, requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetsApiApiV1AssetsCandidatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsCandidatesGet(requestParameters: AssetsApiApiV1AssetsCandidatesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAssetCandidateEntityDto> {
            return localVarFp.apiV1AssetsCandidatesGet(requestParameters.nexusOpsTenant, requestParameters.offset, requestParameters.limit, requestParameters.search, requestParameters.entityType, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetsApiApiV1AssetsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsGetPost(requestParameters: AssetsApiApiV1AssetsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAssetDto> {
            return localVarFp.apiV1AssetsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetsApiApiV1AssetsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsPost(requestParameters: AssetsApiApiV1AssetsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetDto> {
            return localVarFp.apiV1AssetsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetsApiApiV1AssetsSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsSearchPost(requestParameters: AssetsApiApiV1AssetsSearchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAssetDto> {
            return localVarFp.apiV1AssetsSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetSearchPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetsApiApiV1AssetsSpecInferFromEntityGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsSpecInferFromEntityGet(requestParameters: AssetsApiApiV1AssetsSpecInferFromEntityGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSpecDto> {
            return localVarFp.apiV1AssetsSpecInferFromEntityGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityType, requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssetsApiApiV1AssetsSpecInferFromPoolGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssetsSpecInferFromPoolGet(requestParameters: AssetsApiApiV1AssetsSpecInferFromPoolGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetSpecDto> {
            return localVarFp.apiV1AssetsSpecInferFromPoolGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.poolId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AssetsAssetIdDelete operation in AssetsApi.
 * @export
 * @interface AssetsApiApiV1AssetsAssetIdDeleteRequest
 */
export interface AssetsApiApiV1AssetsAssetIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetsApiApiV1AssetsAssetIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiApiV1AssetsAssetIdDelete
     */
    readonly assetId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetsApiApiV1AssetsAssetIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof AssetsApiApiV1AssetsAssetIdDelete
     */
    readonly isDeleteCascade?: boolean
}

/**
 * Request parameters for apiV1AssetsAssetIdGet operation in AssetsApi.
 * @export
 * @interface AssetsApiApiV1AssetsAssetIdGetRequest
 */
export interface AssetsApiApiV1AssetsAssetIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetsApiApiV1AssetsAssetIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiApiV1AssetsAssetIdGet
     */
    readonly assetId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetsApiApiV1AssetsAssetIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssetsAssetIdPut operation in AssetsApi.
 * @export
 * @interface AssetsApiApiV1AssetsAssetIdPutRequest
 */
export interface AssetsApiApiV1AssetsAssetIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetsApiApiV1AssetsAssetIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiApiV1AssetsAssetIdPut
     */
    readonly assetId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetsApiApiV1AssetsAssetIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssetUpdateDto}
     * @memberof AssetsApiApiV1AssetsAssetIdPut
     */
    readonly assetUpdateDto?: AssetUpdateDto
}

/**
 * Request parameters for apiV1AssetsBulkDeleteDelete operation in AssetsApi.
 * @export
 * @interface AssetsApiApiV1AssetsBulkDeleteDeleteRequest
 */
export interface AssetsApiApiV1AssetsBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetsApiApiV1AssetsBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetsApiApiV1AssetsBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof AssetsApiApiV1AssetsBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1AssetsByEntityGet operation in AssetsApi.
 * @export
 * @interface AssetsApiApiV1AssetsByEntityGetRequest
 */
export interface AssetsApiApiV1AssetsByEntityGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetsApiApiV1AssetsByEntityGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetsApiApiV1AssetsByEntityGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * Must contain only values from EntityType.
     * @type {AssetEntityType}
     * @memberof AssetsApiApiV1AssetsByEntityGet
     */
    readonly entityType?: AssetEntityType

    /**
     * 
     * @type {string}
     * @memberof AssetsApiApiV1AssetsByEntityGet
     */
    readonly entityId?: string
}

/**
 * Request parameters for apiV1AssetsCandidatesGet operation in AssetsApi.
 * @export
 * @interface AssetsApiApiV1AssetsCandidatesGetRequest
 */
export interface AssetsApiApiV1AssetsCandidatesGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetsApiApiV1AssetsCandidatesGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {number}
     * @memberof AssetsApiApiV1AssetsCandidatesGet
     */
    readonly offset: number

    /**
     * 
     * @type {number}
     * @memberof AssetsApiApiV1AssetsCandidatesGet
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof AssetsApiApiV1AssetsCandidatesGet
     */
    readonly search: string

    /**
     * Must contain only values from EntityType.
     * @type {AssetEntityType}
     * @memberof AssetsApiApiV1AssetsCandidatesGet
     */
    readonly entityType: AssetEntityType

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetsApiApiV1AssetsCandidatesGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssetsGetPost operation in AssetsApi.
 * @export
 * @interface AssetsApiApiV1AssetsGetPostRequest
 */
export interface AssetsApiApiV1AssetsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetsApiApiV1AssetsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetsApiApiV1AssetsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssetGetPaginatedDto}
     * @memberof AssetsApiApiV1AssetsGetPost
     */
    readonly assetGetPaginatedDto?: AssetGetPaginatedDto
}

/**
 * Request parameters for apiV1AssetsPost operation in AssetsApi.
 * @export
 * @interface AssetsApiApiV1AssetsPostRequest
 */
export interface AssetsApiApiV1AssetsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetsApiApiV1AssetsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetsApiApiV1AssetsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssetCreateDto}
     * @memberof AssetsApiApiV1AssetsPost
     */
    readonly assetCreateDto?: AssetCreateDto
}

/**
 * Request parameters for apiV1AssetsSearchPost operation in AssetsApi.
 * @export
 * @interface AssetsApiApiV1AssetsSearchPostRequest
 */
export interface AssetsApiApiV1AssetsSearchPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetsApiApiV1AssetsSearchPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetsApiApiV1AssetsSearchPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssetSearchPaginatedDto}
     * @memberof AssetsApiApiV1AssetsSearchPost
     */
    readonly assetSearchPaginatedDto?: AssetSearchPaginatedDto
}

/**
 * Request parameters for apiV1AssetsSpecInferFromEntityGet operation in AssetsApi.
 * @export
 * @interface AssetsApiApiV1AssetsSpecInferFromEntityGetRequest
 */
export interface AssetsApiApiV1AssetsSpecInferFromEntityGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetsApiApiV1AssetsSpecInferFromEntityGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetsApiApiV1AssetsSpecInferFromEntityGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * Must contain only values from EntityType.
     * @type {AssetEntityType}
     * @memberof AssetsApiApiV1AssetsSpecInferFromEntityGet
     */
    readonly entityType?: AssetEntityType

    /**
     * 
     * @type {string}
     * @memberof AssetsApiApiV1AssetsSpecInferFromEntityGet
     */
    readonly entityId?: string
}

/**
 * Request parameters for apiV1AssetsSpecInferFromPoolGet operation in AssetsApi.
 * @export
 * @interface AssetsApiApiV1AssetsSpecInferFromPoolGetRequest
 */
export interface AssetsApiApiV1AssetsSpecInferFromPoolGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssetsApiApiV1AssetsSpecInferFromPoolGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssetsApiApiV1AssetsSpecInferFromPoolGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiApiV1AssetsSpecInferFromPoolGet
     */
    readonly poolId?: string
}

/**
 * AssetsApi - object-oriented interface
 * @export
 * @class AssetsApi
 * @extends {BaseAPI}
 */
export class AssetsApi extends BaseAPI {
    /**
     * 
     * @param {AssetsApiApiV1AssetsAssetIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public apiV1AssetsAssetIdDelete(requestParameters: AssetsApiApiV1AssetsAssetIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).apiV1AssetsAssetIdDelete(requestParameters.nexusOpsTenant, requestParameters.assetId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetsApiApiV1AssetsAssetIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public apiV1AssetsAssetIdGet(requestParameters: AssetsApiApiV1AssetsAssetIdGetRequest, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).apiV1AssetsAssetIdGet(requestParameters.nexusOpsTenant, requestParameters.assetId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetsApiApiV1AssetsAssetIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public apiV1AssetsAssetIdPut(requestParameters: AssetsApiApiV1AssetsAssetIdPutRequest, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).apiV1AssetsAssetIdPut(requestParameters.nexusOpsTenant, requestParameters.assetId, requestParameters.nexusOpsAppVersion, requestParameters.assetUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetsApiApiV1AssetsBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public apiV1AssetsBulkDeleteDelete(requestParameters: AssetsApiApiV1AssetsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).apiV1AssetsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetsApiApiV1AssetsByEntityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public apiV1AssetsByEntityGet(requestParameters: AssetsApiApiV1AssetsByEntityGetRequest, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).apiV1AssetsByEntityGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityType, requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetsApiApiV1AssetsCandidatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public apiV1AssetsCandidatesGet(requestParameters: AssetsApiApiV1AssetsCandidatesGetRequest, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).apiV1AssetsCandidatesGet(requestParameters.nexusOpsTenant, requestParameters.offset, requestParameters.limit, requestParameters.search, requestParameters.entityType, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetsApiApiV1AssetsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public apiV1AssetsGetPost(requestParameters: AssetsApiApiV1AssetsGetPostRequest, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).apiV1AssetsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetsApiApiV1AssetsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public apiV1AssetsPost(requestParameters: AssetsApiApiV1AssetsPostRequest, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).apiV1AssetsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetsApiApiV1AssetsSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public apiV1AssetsSearchPost(requestParameters: AssetsApiApiV1AssetsSearchPostRequest, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).apiV1AssetsSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assetSearchPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetsApiApiV1AssetsSpecInferFromEntityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public apiV1AssetsSpecInferFromEntityGet(requestParameters: AssetsApiApiV1AssetsSpecInferFromEntityGetRequest, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).apiV1AssetsSpecInferFromEntityGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityType, requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssetsApiApiV1AssetsSpecInferFromPoolGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public apiV1AssetsSpecInferFromPoolGet(requestParameters: AssetsApiApiV1AssetsSpecInferFromPoolGetRequest, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).apiV1AssetsSpecInferFromPoolGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.poolId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssignmentsApi - axios parameter creator
 * @export
 */
export const AssignmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdDelete: async (nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdDelete', 'assignmentId', assignmentId)
            const localVarPath = `/api/v1/assignments/{assignmentId}`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdExternalNumberPut: async (nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdExternalNumberPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdExternalNumberPut', 'assignmentId', assignmentId)
            const localVarPath = `/api/v1/assignments/{assignmentId}/external-number`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalExternalNumberInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdGet: async (nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdGet', 'assignmentId', assignmentId)
            const localVarPath = `/api/v1/assignments/{assignmentId}`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdNotesPut: async (nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdNotesPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdNotesPut', 'assignmentId', assignmentId)
            const localVarPath = `/api/v1/assignments/{assignmentId}/notes`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalNotesInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentUpdateDto} [assignmentUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdPut: async (nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, assignmentUpdateDto?: AssignmentUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdPut', 'assignmentId', assignmentId)
            const localVarPath = `/api/v1/assignments/{assignmentId}`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStageUpdateDtoOfAssignmentStage} [generalStageUpdateDtoOfAssignmentStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdStagePut: async (nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, generalStageUpdateDtoOfAssignmentStage?: GeneralStageUpdateDtoOfAssignmentStage, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdStagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdStagePut', 'assignmentId', assignmentId)
            const localVarPath = `/api/v1/assignments/{assignmentId}/stage`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalStageUpdateDtoOfAssignmentStage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentStepInputDto} [assignmentStepInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdTransportationDropOffPost: async (nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, assignmentStepInputDto?: AssignmentStepInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdTransportationDropOffPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdTransportationDropOffPost', 'assignmentId', assignmentId)
            const localVarPath = `/api/v1/assignments/{assignmentId}/transportation/drop-off`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentStepInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentStepInputDto} [assignmentStepInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdTransportationDropOffPut: async (nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, assignmentStepInputDto?: AssignmentStepInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdTransportationDropOffPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdTransportationDropOffPut', 'assignmentId', assignmentId)
            const localVarPath = `/api/v1/assignments/{assignmentId}/transportation/drop-off`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentStepInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentStepVisualInspectionInputDto} [assignmentStepVisualInspectionInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut: async (nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, assignmentStepVisualInspectionInputDto?: AssignmentStepVisualInspectionInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut', 'assignmentId', assignmentId)
            const localVarPath = `/api/v1/assignments/{assignmentId}/transportation/drop-off/visual-inspection`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentStepVisualInspectionInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentStepInputDto} [assignmentStepInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdTransportationPickUpPost: async (nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, assignmentStepInputDto?: AssignmentStepInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdTransportationPickUpPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdTransportationPickUpPost', 'assignmentId', assignmentId)
            const localVarPath = `/api/v1/assignments/{assignmentId}/transportation/pick-up`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentStepInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentStepInputDto} [assignmentStepInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdTransportationPickUpPut: async (nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, assignmentStepInputDto?: AssignmentStepInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdTransportationPickUpPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdTransportationPickUpPut', 'assignmentId', assignmentId)
            const localVarPath = `/api/v1/assignments/{assignmentId}/transportation/pick-up`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentStepInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentStepVisualInspectionInputDto} [assignmentStepVisualInspectionInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut: async (nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, assignmentStepVisualInspectionInputDto?: AssignmentStepVisualInspectionInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut', 'assignmentId', assignmentId)
            const localVarPath = `/api/v1/assignments/{assignmentId}/transportation/pick-up/visual-inspection`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentStepVisualInspectionInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assignments/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsByIdsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsByIdsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assignments/by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assignments/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsCreateMetaGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, type?: AssignmentType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsCreateMetaGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assignments/create/meta`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentGetPaginatedDto} [assignmentGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, assignmentGetPaginatedDto?: AssignmentGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assignments/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentCreateDto} [assignmentCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, assignmentCreateDto?: AssignmentCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssignmentsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssignmentsApi - functional programming interface
 * @export
 */
export const AssignmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssignmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsAssignmentIdDelete(nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsAssignmentIdDelete(nexusOpsTenant, assignmentId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsAssignmentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsAssignmentIdExternalNumberPut(nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsAssignmentIdExternalNumberPut(nexusOpsTenant, assignmentId, nexusOpsAppVersion, generalExternalNumberInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsAssignmentIdExternalNumberPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsAssignmentIdGet(nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsAssignmentIdGet(nexusOpsTenant, assignmentId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsAssignmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsAssignmentIdNotesPut(nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsAssignmentIdNotesPut(nexusOpsTenant, assignmentId, nexusOpsAppVersion, generalNotesInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsAssignmentIdNotesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentUpdateDto} [assignmentUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsAssignmentIdPut(nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, assignmentUpdateDto?: AssignmentUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsAssignmentIdPut(nexusOpsTenant, assignmentId, nexusOpsAppVersion, assignmentUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsAssignmentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStageUpdateDtoOfAssignmentStage} [generalStageUpdateDtoOfAssignmentStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsAssignmentIdStagePut(nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, generalStageUpdateDtoOfAssignmentStage?: GeneralStageUpdateDtoOfAssignmentStage, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsAssignmentIdStagePut(nexusOpsTenant, assignmentId, nexusOpsAppVersion, generalStageUpdateDtoOfAssignmentStage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsAssignmentIdStagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentStepInputDto} [assignmentStepInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsAssignmentIdTransportationDropOffPost(nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, assignmentStepInputDto?: AssignmentStepInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsAssignmentIdTransportationDropOffPost(nexusOpsTenant, assignmentId, nexusOpsAppVersion, assignmentStepInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsAssignmentIdTransportationDropOffPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentStepInputDto} [assignmentStepInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsAssignmentIdTransportationDropOffPut(nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, assignmentStepInputDto?: AssignmentStepInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsAssignmentIdTransportationDropOffPut(nexusOpsTenant, assignmentId, nexusOpsAppVersion, assignmentStepInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsAssignmentIdTransportationDropOffPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentStepVisualInspectionInputDto} [assignmentStepVisualInspectionInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut(nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, assignmentStepVisualInspectionInputDto?: AssignmentStepVisualInspectionInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut(nexusOpsTenant, assignmentId, nexusOpsAppVersion, assignmentStepVisualInspectionInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentStepInputDto} [assignmentStepInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsAssignmentIdTransportationPickUpPost(nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, assignmentStepInputDto?: AssignmentStepInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsAssignmentIdTransportationPickUpPost(nexusOpsTenant, assignmentId, nexusOpsAppVersion, assignmentStepInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsAssignmentIdTransportationPickUpPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentStepInputDto} [assignmentStepInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsAssignmentIdTransportationPickUpPut(nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, assignmentStepInputDto?: AssignmentStepInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsAssignmentIdTransportationPickUpPut(nexusOpsTenant, assignmentId, nexusOpsAppVersion, assignmentStepInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsAssignmentIdTransportationPickUpPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} assignmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentStepVisualInspectionInputDto} [assignmentStepVisualInspectionInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut(nexusOpsTenant: string, assignmentId: string, nexusOpsAppVersion?: string, assignmentStepVisualInspectionInputDto?: AssignmentStepVisualInspectionInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut(nexusOpsTenant, assignmentId, nexusOpsAppVersion, assignmentStepVisualInspectionInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsByIdsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsByIdsGet(nexusOpsTenant, nexusOpsAppVersion, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsByIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsCreateMetaGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, type?: AssignmentType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentGetCreateMetaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsCreateMetaGet(nexusOpsTenant, nexusOpsAppVersion, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsCreateMetaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentGetPaginatedDto} [assignmentGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, assignmentGetPaginatedDto?: AssignmentGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsGetPost(nexusOpsTenant, nexusOpsAppVersion, assignmentGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentCreateDto} [assignmentCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssignmentsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, assignmentCreateDto?: AssignmentCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssignmentsPost(nexusOpsTenant, nexusOpsAppVersion, assignmentCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsApi.apiV1AssignmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssignmentsApi - factory interface
 * @export
 */
export const AssignmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssignmentsApiFp(configuration)
    return {
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsAssignmentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdDelete(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AssignmentsAssignmentIdDelete(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsAssignmentIdExternalNumberPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdExternalNumberPut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdExternalNumberPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentDto> {
            return localVarFp.apiV1AssignmentsAssignmentIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsAssignmentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdGet(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentDto> {
            return localVarFp.apiV1AssignmentsAssignmentIdGet(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsAssignmentIdNotesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdNotesPut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdNotesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentDto> {
            return localVarFp.apiV1AssignmentsAssignmentIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsAssignmentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdPut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentDto> {
            return localVarFp.apiV1AssignmentsAssignmentIdPut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsAssignmentIdStagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdStagePut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdStagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentDto> {
            return localVarFp.apiV1AssignmentsAssignmentIdStagePut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.generalStageUpdateDtoOfAssignmentStage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdTransportationDropOffPost(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentDto> {
            return localVarFp.apiV1AssignmentsAssignmentIdTransportationDropOffPost(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentStepInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdTransportationDropOffPut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentDto> {
            return localVarFp.apiV1AssignmentsAssignmentIdTransportationDropOffPut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentStepInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentDto> {
            return localVarFp.apiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentStepVisualInspectionInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdTransportationPickUpPost(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentDto> {
            return localVarFp.apiV1AssignmentsAssignmentIdTransportationPickUpPost(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentStepInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdTransportationPickUpPut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentDto> {
            return localVarFp.apiV1AssignmentsAssignmentIdTransportationPickUpPut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentStepInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentDto> {
            return localVarFp.apiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentStepVisualInspectionInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsBulkDeleteDelete(requestParameters: AssignmentsApiApiV1AssignmentsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AssignmentsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsByIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsByIdsGet(requestParameters: AssignmentsApiApiV1AssignmentsByIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssignmentDto>> {
            return localVarFp.apiV1AssignmentsByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsCountersGet(requestParameters: AssignmentsApiApiV1AssignmentsCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentCountersDto> {
            return localVarFp.apiV1AssignmentsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsCreateMetaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsCreateMetaGet(requestParameters: AssignmentsApiApiV1AssignmentsCreateMetaGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentGetCreateMetaDto> {
            return localVarFp.apiV1AssignmentsCreateMetaGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsGetPost(requestParameters: AssignmentsApiApiV1AssignmentsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAssignmentDto> {
            return localVarFp.apiV1AssignmentsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assignmentGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignmentsApiApiV1AssignmentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssignmentsPost(requestParameters: AssignmentsApiApiV1AssignmentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentDto> {
            return localVarFp.apiV1AssignmentsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assignmentCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AssignmentsAssignmentIdDelete operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsAssignmentIdDeleteRequest
 */
export interface AssignmentsApiApiV1AssignmentsAssignmentIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdDelete
     */
    readonly assignmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssignmentsAssignmentIdExternalNumberPut operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsAssignmentIdExternalNumberPutRequest
 */
export interface AssignmentsApiApiV1AssignmentsAssignmentIdExternalNumberPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdExternalNumberPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdExternalNumberPut
     */
    readonly assignmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdExternalNumberPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralExternalNumberInputDto}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdExternalNumberPut
     */
    readonly generalExternalNumberInputDto?: GeneralExternalNumberInputDto
}

/**
 * Request parameters for apiV1AssignmentsAssignmentIdGet operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsAssignmentIdGetRequest
 */
export interface AssignmentsApiApiV1AssignmentsAssignmentIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdGet
     */
    readonly assignmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssignmentsAssignmentIdNotesPut operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsAssignmentIdNotesPutRequest
 */
export interface AssignmentsApiApiV1AssignmentsAssignmentIdNotesPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdNotesPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdNotesPut
     */
    readonly assignmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdNotesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralNotesInputDto}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdNotesPut
     */
    readonly generalNotesInputDto?: GeneralNotesInputDto
}

/**
 * Request parameters for apiV1AssignmentsAssignmentIdPut operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsAssignmentIdPutRequest
 */
export interface AssignmentsApiApiV1AssignmentsAssignmentIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdPut
     */
    readonly assignmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentUpdateDto}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdPut
     */
    readonly assignmentUpdateDto?: AssignmentUpdateDto
}

/**
 * Request parameters for apiV1AssignmentsAssignmentIdStagePut operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsAssignmentIdStagePutRequest
 */
export interface AssignmentsApiApiV1AssignmentsAssignmentIdStagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdStagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdStagePut
     */
    readonly assignmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdStagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralStageUpdateDtoOfAssignmentStage}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdStagePut
     */
    readonly generalStageUpdateDtoOfAssignmentStage?: GeneralStageUpdateDtoOfAssignmentStage
}

/**
 * Request parameters for apiV1AssignmentsAssignmentIdTransportationDropOffPost operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPostRequest
 */
export interface AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPost
     */
    readonly assignmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentStepInputDto}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPost
     */
    readonly assignmentStepInputDto?: AssignmentStepInputDto
}

/**
 * Request parameters for apiV1AssignmentsAssignmentIdTransportationDropOffPut operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPutRequest
 */
export interface AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPut
     */
    readonly assignmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentStepInputDto}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPut
     */
    readonly assignmentStepInputDto?: AssignmentStepInputDto
}

/**
 * Request parameters for apiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPutRequest
 */
export interface AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut
     */
    readonly assignmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentStepVisualInspectionInputDto}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut
     */
    readonly assignmentStepVisualInspectionInputDto?: AssignmentStepVisualInspectionInputDto
}

/**
 * Request parameters for apiV1AssignmentsAssignmentIdTransportationPickUpPost operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPostRequest
 */
export interface AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPost
     */
    readonly assignmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentStepInputDto}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPost
     */
    readonly assignmentStepInputDto?: AssignmentStepInputDto
}

/**
 * Request parameters for apiV1AssignmentsAssignmentIdTransportationPickUpPut operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPutRequest
 */
export interface AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPut
     */
    readonly assignmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentStepInputDto}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPut
     */
    readonly assignmentStepInputDto?: AssignmentStepInputDto
}

/**
 * Request parameters for apiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPutRequest
 */
export interface AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut
     */
    readonly assignmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentStepVisualInspectionInputDto}
     * @memberof AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut
     */
    readonly assignmentStepVisualInspectionInputDto?: AssignmentStepVisualInspectionInputDto
}

/**
 * Request parameters for apiV1AssignmentsBulkDeleteDelete operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsBulkDeleteDeleteRequest
 */
export interface AssignmentsApiApiV1AssignmentsBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof AssignmentsApiApiV1AssignmentsBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1AssignmentsByIdsGet operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsByIdsGetRequest
 */
export interface AssignmentsApiApiV1AssignmentsByIdsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsByIdsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsByIdsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof AssignmentsApiApiV1AssignmentsByIdsGet
     */
    readonly ids?: Array<string>
}

/**
 * Request parameters for apiV1AssignmentsCountersGet operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsCountersGetRequest
 */
export interface AssignmentsApiApiV1AssignmentsCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssignmentsCreateMetaGet operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsCreateMetaGetRequest
 */
export interface AssignmentsApiApiV1AssignmentsCreateMetaGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsCreateMetaGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsCreateMetaGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentType}
     * @memberof AssignmentsApiApiV1AssignmentsCreateMetaGet
     */
    readonly type?: AssignmentType
}

/**
 * Request parameters for apiV1AssignmentsGetPost operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsGetPostRequest
 */
export interface AssignmentsApiApiV1AssignmentsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentGetPaginatedDto}
     * @memberof AssignmentsApiApiV1AssignmentsGetPost
     */
    readonly assignmentGetPaginatedDto?: AssignmentGetPaginatedDto
}

/**
 * Request parameters for apiV1AssignmentsPost operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiApiV1AssignmentsPostRequest
 */
export interface AssignmentsApiApiV1AssignmentsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssignmentsApiApiV1AssignmentsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentCreateDto}
     * @memberof AssignmentsApiApiV1AssignmentsPost
     */
    readonly assignmentCreateDto?: AssignmentCreateDto
}

/**
 * AssignmentsApi - object-oriented interface
 * @export
 * @class AssignmentsApi
 * @extends {BaseAPI}
 */
export class AssignmentsApi extends BaseAPI {
    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsAssignmentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsAssignmentIdDelete(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsAssignmentIdDelete(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsAssignmentIdExternalNumberPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsAssignmentIdExternalNumberPut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdExternalNumberPutRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsAssignmentIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsAssignmentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsAssignmentIdGet(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdGetRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsAssignmentIdGet(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsAssignmentIdNotesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsAssignmentIdNotesPut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdNotesPutRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsAssignmentIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsAssignmentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsAssignmentIdPut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdPutRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsAssignmentIdPut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsAssignmentIdStagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsAssignmentIdStagePut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdStagePutRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsAssignmentIdStagePut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.generalStageUpdateDtoOfAssignmentStage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsAssignmentIdTransportationDropOffPost(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPostRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsAssignmentIdTransportationDropOffPost(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentStepInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsAssignmentIdTransportationDropOffPut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffPutRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsAssignmentIdTransportationDropOffPut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentStepInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPutRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsAssignmentIdTransportationDropOffVisualInspectionPut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentStepVisualInspectionInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsAssignmentIdTransportationPickUpPost(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPostRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsAssignmentIdTransportationPickUpPost(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentStepInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsAssignmentIdTransportationPickUpPut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpPutRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsAssignmentIdTransportationPickUpPut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentStepInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut(requestParameters: AssignmentsApiApiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPutRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsAssignmentIdTransportationPickUpVisualInspectionPut(requestParameters.nexusOpsTenant, requestParameters.assignmentId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentStepVisualInspectionInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsBulkDeleteDelete(requestParameters: AssignmentsApiApiV1AssignmentsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsByIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsByIdsGet(requestParameters: AssignmentsApiApiV1AssignmentsByIdsGetRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsCountersGet(requestParameters: AssignmentsApiApiV1AssignmentsCountersGetRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsCreateMetaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsCreateMetaGet(requestParameters: AssignmentsApiApiV1AssignmentsCreateMetaGetRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsCreateMetaGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsGetPost(requestParameters: AssignmentsApiApiV1AssignmentsGetPostRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assignmentGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignmentsApiApiV1AssignmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public apiV1AssignmentsPost(requestParameters: AssignmentsApiApiV1AssignmentsPostRequest, options?: RawAxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).apiV1AssignmentsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assignmentCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssistantApi - axios parameter creator
 * @export
 */
export const AssistantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssistantThreadGetOrInitPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssistantThreadGetOrInitPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assistant/thread/get-or-init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} threadId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssistantThreadIdDelete: async (nexusOpsTenant: string, threadId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssistantThreadIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('apiV1AssistantThreadIdDelete', 'threadId', threadId)
            const localVarPath = `/api/v1/assistant/{threadId}`
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssistantThreadInitPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssistantThreadInitPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assistant/thread/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} threadId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssistantThreadThreadIdCompletionPost: async (nexusOpsTenant: string, threadId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssistantThreadThreadIdCompletionPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('apiV1AssistantThreadThreadIdCompletionPost', 'threadId', threadId)
            const localVarPath = `/api/v1/assistant/thread/{threadId}/completion`
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssistantTipGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssistantTipGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assistant/tip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssistantTipDto} [assistantTipDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssistantTipSubmitPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, assistantTipDto?: AssistantTipDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AssistantTipSubmitPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/assistant/tip/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assistantTipDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssistantApi - functional programming interface
 * @export
 */
export const AssistantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssistantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssistantThreadGetOrInitPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContextThreadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssistantThreadGetOrInitPost(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.apiV1AssistantThreadGetOrInitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} threadId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssistantThreadIdDelete(nexusOpsTenant: string, threadId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssistantThreadIdDelete(nexusOpsTenant, threadId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.apiV1AssistantThreadIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssistantThreadInitPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContextThreadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssistantThreadInitPost(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.apiV1AssistantThreadInitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} threadId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssistantThreadThreadIdCompletionPost(nexusOpsTenant: string, threadId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssistantThreadThreadIdCompletionPost(nexusOpsTenant, threadId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.apiV1AssistantThreadThreadIdCompletionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssistantTipGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssistantTipDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssistantTipGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.apiV1AssistantTipGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssistantTipDto} [assistantTipDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AssistantTipSubmitPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, assistantTipDto?: AssistantTipDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AssistantTipSubmitPost(nexusOpsTenant, nexusOpsAppVersion, assistantTipDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.apiV1AssistantTipSubmitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssistantApi - factory interface
 * @export
 */
export const AssistantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssistantApiFp(configuration)
    return {
        /**
         * 
         * @param {AssistantApiApiV1AssistantThreadGetOrInitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssistantThreadGetOrInitPost(requestParameters: AssistantApiApiV1AssistantThreadGetOrInitPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContextThreadDto> {
            return localVarFp.apiV1AssistantThreadGetOrInitPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiV1AssistantThreadIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssistantThreadIdDelete(requestParameters: AssistantApiApiV1AssistantThreadIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AssistantThreadIdDelete(requestParameters.nexusOpsTenant, requestParameters.threadId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiV1AssistantThreadInitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssistantThreadInitPost(requestParameters: AssistantApiApiV1AssistantThreadInitPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContextThreadDto> {
            return localVarFp.apiV1AssistantThreadInitPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiV1AssistantThreadThreadIdCompletionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssistantThreadThreadIdCompletionPost(requestParameters: AssistantApiApiV1AssistantThreadThreadIdCompletionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AssistantThreadThreadIdCompletionPost(requestParameters.nexusOpsTenant, requestParameters.threadId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiV1AssistantTipGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssistantTipGet(requestParameters: AssistantApiApiV1AssistantTipGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssistantTipDto> {
            return localVarFp.apiV1AssistantTipGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiV1AssistantTipSubmitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AssistantTipSubmitPost(requestParameters: AssistantApiApiV1AssistantTipSubmitPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AssistantTipSubmitPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assistantTipDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AssistantThreadGetOrInitPost operation in AssistantApi.
 * @export
 * @interface AssistantApiApiV1AssistantThreadGetOrInitPostRequest
 */
export interface AssistantApiApiV1AssistantThreadGetOrInitPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssistantApiApiV1AssistantThreadGetOrInitPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssistantApiApiV1AssistantThreadGetOrInitPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssistantThreadIdDelete operation in AssistantApi.
 * @export
 * @interface AssistantApiApiV1AssistantThreadIdDeleteRequest
 */
export interface AssistantApiApiV1AssistantThreadIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssistantApiApiV1AssistantThreadIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssistantApiApiV1AssistantThreadIdDelete
     */
    readonly threadId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssistantApiApiV1AssistantThreadIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssistantThreadInitPost operation in AssistantApi.
 * @export
 * @interface AssistantApiApiV1AssistantThreadInitPostRequest
 */
export interface AssistantApiApiV1AssistantThreadInitPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssistantApiApiV1AssistantThreadInitPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssistantApiApiV1AssistantThreadInitPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssistantThreadThreadIdCompletionPost operation in AssistantApi.
 * @export
 * @interface AssistantApiApiV1AssistantThreadThreadIdCompletionPostRequest
 */
export interface AssistantApiApiV1AssistantThreadThreadIdCompletionPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssistantApiApiV1AssistantThreadThreadIdCompletionPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof AssistantApiApiV1AssistantThreadThreadIdCompletionPost
     */
    readonly threadId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssistantApiApiV1AssistantThreadThreadIdCompletionPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssistantTipGet operation in AssistantApi.
 * @export
 * @interface AssistantApiApiV1AssistantTipGetRequest
 */
export interface AssistantApiApiV1AssistantTipGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssistantApiApiV1AssistantTipGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssistantApiApiV1AssistantTipGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AssistantTipSubmitPost operation in AssistantApi.
 * @export
 * @interface AssistantApiApiV1AssistantTipSubmitPostRequest
 */
export interface AssistantApiApiV1AssistantTipSubmitPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AssistantApiApiV1AssistantTipSubmitPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AssistantApiApiV1AssistantTipSubmitPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssistantTipDto}
     * @memberof AssistantApiApiV1AssistantTipSubmitPost
     */
    readonly assistantTipDto?: AssistantTipDto
}

/**
 * AssistantApi - object-oriented interface
 * @export
 * @class AssistantApi
 * @extends {BaseAPI}
 */
export class AssistantApi extends BaseAPI {
    /**
     * 
     * @param {AssistantApiApiV1AssistantThreadGetOrInitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public apiV1AssistantThreadGetOrInitPost(requestParameters: AssistantApiApiV1AssistantThreadGetOrInitPostRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).apiV1AssistantThreadGetOrInitPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiV1AssistantThreadIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public apiV1AssistantThreadIdDelete(requestParameters: AssistantApiApiV1AssistantThreadIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).apiV1AssistantThreadIdDelete(requestParameters.nexusOpsTenant, requestParameters.threadId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiV1AssistantThreadInitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public apiV1AssistantThreadInitPost(requestParameters: AssistantApiApiV1AssistantThreadInitPostRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).apiV1AssistantThreadInitPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiV1AssistantThreadThreadIdCompletionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public apiV1AssistantThreadThreadIdCompletionPost(requestParameters: AssistantApiApiV1AssistantThreadThreadIdCompletionPostRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).apiV1AssistantThreadThreadIdCompletionPost(requestParameters.nexusOpsTenant, requestParameters.threadId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiV1AssistantTipGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public apiV1AssistantTipGet(requestParameters: AssistantApiApiV1AssistantTipGetRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).apiV1AssistantTipGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiV1AssistantTipSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    public apiV1AssistantTipSubmitPost(requestParameters: AssistantApiApiV1AssistantTipSubmitPostRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiFp(this.configuration).apiV1AssistantTipSubmitPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.assistantTipDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AzureMapsApi - axios parameter creator
 * @export
 */
export const AzureMapsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns accessToken to be used by Azure Maps client libraries.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProvidersAzureAzureMapsAuthAccessTokenGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProvidersAzureAzureMapsAuthAccessTokenGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/providers/azure/azure-maps/auth/access-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns SAS token to be used by Azure Maps client libraries.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProvidersAzureAzureMapsAuthSasTokenGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProvidersAzureAzureMapsAuthSasTokenGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/providers/azure/azure-maps/auth/sas-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AzureMapsApi - functional programming interface
 * @export
 */
export const AzureMapsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AzureMapsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns accessToken to be used by Azure Maps client libraries.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProvidersAzureAzureMapsAuthAccessTokenGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AzureMapsAccessTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProvidersAzureAzureMapsAuthAccessTokenGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AzureMapsApi.apiV1ProvidersAzureAzureMapsAuthAccessTokenGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns SAS token to be used by Azure Maps client libraries.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProvidersAzureAzureMapsAuthSasTokenGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AzureMapsSasTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProvidersAzureAzureMapsAuthSasTokenGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AzureMapsApi.apiV1ProvidersAzureAzureMapsAuthSasTokenGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AzureMapsApi - factory interface
 * @export
 */
export const AzureMapsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AzureMapsApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns accessToken to be used by Azure Maps client libraries.
         * @param {AzureMapsApiApiV1ProvidersAzureAzureMapsAuthAccessTokenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProvidersAzureAzureMapsAuthAccessTokenGet(requestParameters: AzureMapsApiApiV1ProvidersAzureAzureMapsAuthAccessTokenGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AzureMapsAccessTokenDto> {
            return localVarFp.apiV1ProvidersAzureAzureMapsAuthAccessTokenGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns SAS token to be used by Azure Maps client libraries.
         * @param {AzureMapsApiApiV1ProvidersAzureAzureMapsAuthSasTokenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProvidersAzureAzureMapsAuthSasTokenGet(requestParameters: AzureMapsApiApiV1ProvidersAzureAzureMapsAuthSasTokenGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AzureMapsSasTokenDto> {
            return localVarFp.apiV1ProvidersAzureAzureMapsAuthSasTokenGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ProvidersAzureAzureMapsAuthAccessTokenGet operation in AzureMapsApi.
 * @export
 * @interface AzureMapsApiApiV1ProvidersAzureAzureMapsAuthAccessTokenGetRequest
 */
export interface AzureMapsApiApiV1ProvidersAzureAzureMapsAuthAccessTokenGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AzureMapsApiApiV1ProvidersAzureAzureMapsAuthAccessTokenGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AzureMapsApiApiV1ProvidersAzureAzureMapsAuthAccessTokenGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ProvidersAzureAzureMapsAuthSasTokenGet operation in AzureMapsApi.
 * @export
 * @interface AzureMapsApiApiV1ProvidersAzureAzureMapsAuthSasTokenGetRequest
 */
export interface AzureMapsApiApiV1ProvidersAzureAzureMapsAuthSasTokenGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof AzureMapsApiApiV1ProvidersAzureAzureMapsAuthSasTokenGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof AzureMapsApiApiV1ProvidersAzureAzureMapsAuthSasTokenGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * AzureMapsApi - object-oriented interface
 * @export
 * @class AzureMapsApi
 * @extends {BaseAPI}
 */
export class AzureMapsApi extends BaseAPI {
    /**
     * 
     * @summary Returns accessToken to be used by Azure Maps client libraries.
     * @param {AzureMapsApiApiV1ProvidersAzureAzureMapsAuthAccessTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AzureMapsApi
     */
    public apiV1ProvidersAzureAzureMapsAuthAccessTokenGet(requestParameters: AzureMapsApiApiV1ProvidersAzureAzureMapsAuthAccessTokenGetRequest, options?: RawAxiosRequestConfig) {
        return AzureMapsApiFp(this.configuration).apiV1ProvidersAzureAzureMapsAuthAccessTokenGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns SAS token to be used by Azure Maps client libraries.
     * @param {AzureMapsApiApiV1ProvidersAzureAzureMapsAuthSasTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AzureMapsApi
     */
    public apiV1ProvidersAzureAzureMapsAuthSasTokenGet(requestParameters: AzureMapsApiApiV1ProvidersAzureAzureMapsAuthSasTokenGetRequest, options?: RawAxiosRequestConfig) {
        return AzureMapsApiFp(this.configuration).apiV1ProvidersAzureAzureMapsAuthSasTokenGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CascadeActionsApi - axios parameter creator
 * @export
 */
export const CascadeActionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CascadeActionType} [actionType] 
         * @param {EntityType} [baseEntityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CascadeActionsSpecGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, actionType?: CascadeActionType, baseEntityType?: EntityType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CascadeActionsSpecGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/cascade-actions/spec`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (actionType !== undefined) {
                localVarQueryParameter['actionType'] = actionType;
            }

            if (baseEntityType !== undefined) {
                localVarQueryParameter['baseEntityType'] = baseEntityType;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CascadeActionInputDto} [cascadeActionInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CascadeActionsUpdateAffiliationPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, cascadeActionInputDto?: CascadeActionInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CascadeActionsUpdateAffiliationPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/cascade-actions/update-affiliation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cascadeActionInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CascadeActionsApi - functional programming interface
 * @export
 */
export const CascadeActionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CascadeActionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CascadeActionType} [actionType] 
         * @param {EntityType} [baseEntityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CascadeActionsSpecGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, actionType?: CascadeActionType, baseEntityType?: EntityType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CascadeActionSpecDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CascadeActionsSpecGet(nexusOpsTenant, nexusOpsAppVersion, actionType, baseEntityType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CascadeActionsApi.apiV1CascadeActionsSpecGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CascadeActionInputDto} [cascadeActionInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CascadeActionsUpdateAffiliationPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, cascadeActionInputDto?: CascadeActionInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CascadeActionsUpdateAffiliationPost(nexusOpsTenant, nexusOpsAppVersion, cascadeActionInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CascadeActionsApi.apiV1CascadeActionsUpdateAffiliationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CascadeActionsApi - factory interface
 * @export
 */
export const CascadeActionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CascadeActionsApiFp(configuration)
    return {
        /**
         * 
         * @param {CascadeActionsApiApiV1CascadeActionsSpecGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CascadeActionsSpecGet(requestParameters: CascadeActionsApiApiV1CascadeActionsSpecGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CascadeActionSpecDto> {
            return localVarFp.apiV1CascadeActionsSpecGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.actionType, requestParameters.baseEntityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CascadeActionsApiApiV1CascadeActionsUpdateAffiliationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CascadeActionsUpdateAffiliationPost(requestParameters: CascadeActionsApiApiV1CascadeActionsUpdateAffiliationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1CascadeActionsUpdateAffiliationPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.cascadeActionInputDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1CascadeActionsSpecGet operation in CascadeActionsApi.
 * @export
 * @interface CascadeActionsApiApiV1CascadeActionsSpecGetRequest
 */
export interface CascadeActionsApiApiV1CascadeActionsSpecGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CascadeActionsApiApiV1CascadeActionsSpecGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CascadeActionsApiApiV1CascadeActionsSpecGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CascadeActionType}
     * @memberof CascadeActionsApiApiV1CascadeActionsSpecGet
     */
    readonly actionType?: CascadeActionType

    /**
     * 
     * @type {EntityType}
     * @memberof CascadeActionsApiApiV1CascadeActionsSpecGet
     */
    readonly baseEntityType?: EntityType
}

/**
 * Request parameters for apiV1CascadeActionsUpdateAffiliationPost operation in CascadeActionsApi.
 * @export
 * @interface CascadeActionsApiApiV1CascadeActionsUpdateAffiliationPostRequest
 */
export interface CascadeActionsApiApiV1CascadeActionsUpdateAffiliationPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CascadeActionsApiApiV1CascadeActionsUpdateAffiliationPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CascadeActionsApiApiV1CascadeActionsUpdateAffiliationPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CascadeActionInputDto}
     * @memberof CascadeActionsApiApiV1CascadeActionsUpdateAffiliationPost
     */
    readonly cascadeActionInputDto?: CascadeActionInputDto
}

/**
 * CascadeActionsApi - object-oriented interface
 * @export
 * @class CascadeActionsApi
 * @extends {BaseAPI}
 */
export class CascadeActionsApi extends BaseAPI {
    /**
     * 
     * @param {CascadeActionsApiApiV1CascadeActionsSpecGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CascadeActionsApi
     */
    public apiV1CascadeActionsSpecGet(requestParameters: CascadeActionsApiApiV1CascadeActionsSpecGetRequest, options?: RawAxiosRequestConfig) {
        return CascadeActionsApiFp(this.configuration).apiV1CascadeActionsSpecGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.actionType, requestParameters.baseEntityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CascadeActionsApiApiV1CascadeActionsUpdateAffiliationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CascadeActionsApi
     */
    public apiV1CascadeActionsUpdateAffiliationPost(requestParameters: CascadeActionsApiApiV1CascadeActionsUpdateAffiliationPostRequest, options?: RawAxiosRequestConfig) {
        return CascadeActionsApiFp(this.configuration).apiV1CascadeActionsUpdateAffiliationPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.cascadeActionInputDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChargesApi - axios parameter creator
 * @export
 */
export const ChargesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChargesBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChargesBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/charges/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chargeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChargesChargeIdDelete: async (nexusOpsTenant: string, chargeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChargesChargeIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chargeId' is not null or undefined
            assertParamExists('apiV1ChargesChargeIdDelete', 'chargeId', chargeId)
            const localVarPath = `/api/v1/charges/{chargeId}`
                .replace(`{${"chargeId"}}`, encodeURIComponent(String(chargeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chargeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChargesChargeIdGet: async (nexusOpsTenant: string, chargeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChargesChargeIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chargeId' is not null or undefined
            assertParamExists('apiV1ChargesChargeIdGet', 'chargeId', chargeId)
            const localVarPath = `/api/v1/charges/{chargeId}`
                .replace(`{${"chargeId"}}`, encodeURIComponent(String(chargeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chargeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChargesChargeIdNotesPut: async (nexusOpsTenant: string, chargeId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChargesChargeIdNotesPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chargeId' is not null or undefined
            assertParamExists('apiV1ChargesChargeIdNotesPut', 'chargeId', chargeId)
            const localVarPath = `/api/v1/charges/{chargeId}/notes`
                .replace(`{${"chargeId"}}`, encodeURIComponent(String(chargeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalNotesInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chargeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChargeUpdateDto} [chargeUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChargesChargeIdPut: async (nexusOpsTenant: string, chargeId: string, nexusOpsAppVersion?: string, chargeUpdateDto?: ChargeUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChargesChargeIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chargeId' is not null or undefined
            assertParamExists('apiV1ChargesChargeIdPut', 'chargeId', chargeId)
            const localVarPath = `/api/v1/charges/{chargeId}`
                .replace(`{${"chargeId"}}`, encodeURIComponent(String(chargeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chargeUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChargeGetPaginatedDto} [chargeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChargesGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, chargeGetPaginatedDto?: ChargeGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChargesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/charges/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chargeGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChargeCreateDto} [chargeCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChargesPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, chargeCreateDto?: ChargeCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChargesPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/charges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chargeCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChargesApi - functional programming interface
 * @export
 */
export const ChargesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChargesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChargesBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChargesBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChargesApi.apiV1ChargesBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chargeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChargesChargeIdDelete(nexusOpsTenant: string, chargeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChargesChargeIdDelete(nexusOpsTenant, chargeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChargesApi.apiV1ChargesChargeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chargeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChargesChargeIdGet(nexusOpsTenant: string, chargeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChargeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChargesChargeIdGet(nexusOpsTenant, chargeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChargesApi.apiV1ChargesChargeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chargeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChargesChargeIdNotesPut(nexusOpsTenant: string, chargeId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChargeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChargesChargeIdNotesPut(nexusOpsTenant, chargeId, nexusOpsAppVersion, generalNotesInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChargesApi.apiV1ChargesChargeIdNotesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chargeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChargeUpdateDto} [chargeUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChargesChargeIdPut(nexusOpsTenant: string, chargeId: string, nexusOpsAppVersion?: string, chargeUpdateDto?: ChargeUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChargeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChargesChargeIdPut(nexusOpsTenant, chargeId, nexusOpsAppVersion, chargeUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChargesApi.apiV1ChargesChargeIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChargeGetPaginatedDto} [chargeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChargesGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, chargeGetPaginatedDto?: ChargeGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfChargeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChargesGetPost(nexusOpsTenant, nexusOpsAppVersion, chargeGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChargesApi.apiV1ChargesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChargeCreateDto} [chargeCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChargesPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, chargeCreateDto?: ChargeCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChargeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChargesPost(nexusOpsTenant, nexusOpsAppVersion, chargeCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChargesApi.apiV1ChargesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChargesApi - factory interface
 * @export
 */
export const ChargesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChargesApiFp(configuration)
    return {
        /**
         * 
         * @param {ChargesApiApiV1ChargesBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChargesBulkDeleteDelete(requestParameters: ChargesApiApiV1ChargesBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1ChargesBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChargesApiApiV1ChargesChargeIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChargesChargeIdDelete(requestParameters: ChargesApiApiV1ChargesChargeIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1ChargesChargeIdDelete(requestParameters.nexusOpsTenant, requestParameters.chargeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChargesApiApiV1ChargesChargeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChargesChargeIdGet(requestParameters: ChargesApiApiV1ChargesChargeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChargeDto> {
            return localVarFp.apiV1ChargesChargeIdGet(requestParameters.nexusOpsTenant, requestParameters.chargeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChargesApiApiV1ChargesChargeIdNotesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChargesChargeIdNotesPut(requestParameters: ChargesApiApiV1ChargesChargeIdNotesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChargeDto> {
            return localVarFp.apiV1ChargesChargeIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.chargeId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChargesApiApiV1ChargesChargeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChargesChargeIdPut(requestParameters: ChargesApiApiV1ChargesChargeIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChargeDto> {
            return localVarFp.apiV1ChargesChargeIdPut(requestParameters.nexusOpsTenant, requestParameters.chargeId, requestParameters.nexusOpsAppVersion, requestParameters.chargeUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChargesApiApiV1ChargesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChargesGetPost(requestParameters: ChargesApiApiV1ChargesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfChargeDto> {
            return localVarFp.apiV1ChargesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.chargeGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChargesApiApiV1ChargesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChargesPost(requestParameters: ChargesApiApiV1ChargesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChargeDto> {
            return localVarFp.apiV1ChargesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.chargeCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ChargesBulkDeleteDelete operation in ChargesApi.
 * @export
 * @interface ChargesApiApiV1ChargesBulkDeleteDeleteRequest
 */
export interface ChargesApiApiV1ChargesBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChargesApiApiV1ChargesBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChargesApiApiV1ChargesBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof ChargesApiApiV1ChargesBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1ChargesChargeIdDelete operation in ChargesApi.
 * @export
 * @interface ChargesApiApiV1ChargesChargeIdDeleteRequest
 */
export interface ChargesApiApiV1ChargesChargeIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChargesApiApiV1ChargesChargeIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChargesApiApiV1ChargesChargeIdDelete
     */
    readonly chargeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChargesApiApiV1ChargesChargeIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChargesChargeIdGet operation in ChargesApi.
 * @export
 * @interface ChargesApiApiV1ChargesChargeIdGetRequest
 */
export interface ChargesApiApiV1ChargesChargeIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChargesApiApiV1ChargesChargeIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChargesApiApiV1ChargesChargeIdGet
     */
    readonly chargeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChargesApiApiV1ChargesChargeIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChargesChargeIdNotesPut operation in ChargesApi.
 * @export
 * @interface ChargesApiApiV1ChargesChargeIdNotesPutRequest
 */
export interface ChargesApiApiV1ChargesChargeIdNotesPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChargesApiApiV1ChargesChargeIdNotesPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChargesApiApiV1ChargesChargeIdNotesPut
     */
    readonly chargeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChargesApiApiV1ChargesChargeIdNotesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralNotesInputDto}
     * @memberof ChargesApiApiV1ChargesChargeIdNotesPut
     */
    readonly generalNotesInputDto?: GeneralNotesInputDto
}

/**
 * Request parameters for apiV1ChargesChargeIdPut operation in ChargesApi.
 * @export
 * @interface ChargesApiApiV1ChargesChargeIdPutRequest
 */
export interface ChargesApiApiV1ChargesChargeIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChargesApiApiV1ChargesChargeIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChargesApiApiV1ChargesChargeIdPut
     */
    readonly chargeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChargesApiApiV1ChargesChargeIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ChargeUpdateDto}
     * @memberof ChargesApiApiV1ChargesChargeIdPut
     */
    readonly chargeUpdateDto?: ChargeUpdateDto
}

/**
 * Request parameters for apiV1ChargesGetPost operation in ChargesApi.
 * @export
 * @interface ChargesApiApiV1ChargesGetPostRequest
 */
export interface ChargesApiApiV1ChargesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChargesApiApiV1ChargesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChargesApiApiV1ChargesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ChargeGetPaginatedDto}
     * @memberof ChargesApiApiV1ChargesGetPost
     */
    readonly chargeGetPaginatedDto?: ChargeGetPaginatedDto
}

/**
 * Request parameters for apiV1ChargesPost operation in ChargesApi.
 * @export
 * @interface ChargesApiApiV1ChargesPostRequest
 */
export interface ChargesApiApiV1ChargesPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChargesApiApiV1ChargesPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChargesApiApiV1ChargesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ChargeCreateDto}
     * @memberof ChargesApiApiV1ChargesPost
     */
    readonly chargeCreateDto?: ChargeCreateDto
}

/**
 * ChargesApi - object-oriented interface
 * @export
 * @class ChargesApi
 * @extends {BaseAPI}
 */
export class ChargesApi extends BaseAPI {
    /**
     * 
     * @param {ChargesApiApiV1ChargesBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public apiV1ChargesBulkDeleteDelete(requestParameters: ChargesApiApiV1ChargesBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return ChargesApiFp(this.configuration).apiV1ChargesBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChargesApiApiV1ChargesChargeIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public apiV1ChargesChargeIdDelete(requestParameters: ChargesApiApiV1ChargesChargeIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ChargesApiFp(this.configuration).apiV1ChargesChargeIdDelete(requestParameters.nexusOpsTenant, requestParameters.chargeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChargesApiApiV1ChargesChargeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public apiV1ChargesChargeIdGet(requestParameters: ChargesApiApiV1ChargesChargeIdGetRequest, options?: RawAxiosRequestConfig) {
        return ChargesApiFp(this.configuration).apiV1ChargesChargeIdGet(requestParameters.nexusOpsTenant, requestParameters.chargeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChargesApiApiV1ChargesChargeIdNotesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public apiV1ChargesChargeIdNotesPut(requestParameters: ChargesApiApiV1ChargesChargeIdNotesPutRequest, options?: RawAxiosRequestConfig) {
        return ChargesApiFp(this.configuration).apiV1ChargesChargeIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.chargeId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChargesApiApiV1ChargesChargeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public apiV1ChargesChargeIdPut(requestParameters: ChargesApiApiV1ChargesChargeIdPutRequest, options?: RawAxiosRequestConfig) {
        return ChargesApiFp(this.configuration).apiV1ChargesChargeIdPut(requestParameters.nexusOpsTenant, requestParameters.chargeId, requestParameters.nexusOpsAppVersion, requestParameters.chargeUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChargesApiApiV1ChargesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public apiV1ChargesGetPost(requestParameters: ChargesApiApiV1ChargesGetPostRequest, options?: RawAxiosRequestConfig) {
        return ChargesApiFp(this.configuration).apiV1ChargesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.chargeGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChargesApiApiV1ChargesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public apiV1ChargesPost(requestParameters: ChargesApiApiV1ChargesPostRequest, options?: RawAxiosRequestConfig) {
        return ChargesApiFp(this.configuration).apiV1ChargesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.chargeCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatActivityApi - axios parameter creator
 * @export
 */
export const ChatActivityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatActivityGetPaginatedDto} [chatActivityGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatActivityByChatChatIdGetPost: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, chatActivityGetPaginatedDto?: ChatActivityGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatActivityByChatChatIdGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatActivityByChatChatIdGetPost', 'chatId', chatId)
            const localVarPath = `/api/v1/chat-activity/by-chat/{chatId}/get`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatActivityGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatActivityApi - functional programming interface
 * @export
 */
export const ChatActivityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatActivityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatActivityGetPaginatedDto} [chatActivityGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatActivityByChatChatIdGetPost(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, chatActivityGetPaginatedDto?: ChatActivityGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfChatActivityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatActivityByChatChatIdGetPost(nexusOpsTenant, chatId, nexusOpsAppVersion, chatActivityGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatActivityApi.apiV1ChatActivityByChatChatIdGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatActivityApi - factory interface
 * @export
 */
export const ChatActivityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatActivityApiFp(configuration)
    return {
        /**
         * 
         * @param {ChatActivityApiApiV1ChatActivityByChatChatIdGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatActivityByChatChatIdGetPost(requestParameters: ChatActivityApiApiV1ChatActivityByChatChatIdGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfChatActivityDto> {
            return localVarFp.apiV1ChatActivityByChatChatIdGetPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.chatActivityGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ChatActivityByChatChatIdGetPost operation in ChatActivityApi.
 * @export
 * @interface ChatActivityApiApiV1ChatActivityByChatChatIdGetPostRequest
 */
export interface ChatActivityApiApiV1ChatActivityByChatChatIdGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatActivityApiApiV1ChatActivityByChatChatIdGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatActivityApiApiV1ChatActivityByChatChatIdGetPost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatActivityApiApiV1ChatActivityByChatChatIdGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ChatActivityGetPaginatedDto}
     * @memberof ChatActivityApiApiV1ChatActivityByChatChatIdGetPost
     */
    readonly chatActivityGetPaginatedDto?: ChatActivityGetPaginatedDto
}

/**
 * ChatActivityApi - object-oriented interface
 * @export
 * @class ChatActivityApi
 * @extends {BaseAPI}
 */
export class ChatActivityApi extends BaseAPI {
    /**
     * 
     * @param {ChatActivityApiApiV1ChatActivityByChatChatIdGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatActivityApi
     */
    public apiV1ChatActivityByChatChatIdGetPost(requestParameters: ChatActivityApiApiV1ChatActivityByChatChatIdGetPostRequest, options?: RawAxiosRequestConfig) {
        return ChatActivityApiFp(this.configuration).apiV1ChatActivityByChatChatIdGetPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.chatActivityGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatActivityOverviewsApi - axios parameter creator
 * @export
 */
export const ChatActivityOverviewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatActivityOverviewsByChatChatIdGet: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatActivityOverviewsByChatChatIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatActivityOverviewsByChatChatIdGet', 'chatId', chatId)
            const localVarPath = `/api/v1/chat-activity-overviews/by-chat/{chatId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [chatIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatActivityOverviewsByChatsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, chatIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatActivityOverviewsByChatsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/chat-activity-overviews/by-chats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (chatIds) {
                localVarQueryParameter['chatIds'] = chatIds;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GetChatActivityOverviewByScopeDto} [getChatActivityOverviewByScopeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatActivityOverviewsGetByScopePost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, getChatActivityOverviewByScopeDto?: GetChatActivityOverviewByScopeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatActivityOverviewsGetByScopePost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/chat-activity-overviews/get/by-scope`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getChatActivityOverviewByScopeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GetChatActivityOverviewByScopesDto} [getChatActivityOverviewByScopesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatActivityOverviewsGetByScopesPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, getChatActivityOverviewByScopesDto?: GetChatActivityOverviewByScopesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatActivityOverviewsGetByScopesPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/chat-activity-overviews/get/by-scopes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getChatActivityOverviewByScopesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatActivityOverviewsApi - functional programming interface
 * @export
 */
export const ChatActivityOverviewsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatActivityOverviewsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatActivityOverviewsByChatChatIdGet(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatActivityOverviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatActivityOverviewsByChatChatIdGet(nexusOpsTenant, chatId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatActivityOverviewsApi.apiV1ChatActivityOverviewsByChatChatIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [chatIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatActivityOverviewsByChatsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, chatIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatActivityOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatActivityOverviewsByChatsGet(nexusOpsTenant, nexusOpsAppVersion, chatIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatActivityOverviewsApi.apiV1ChatActivityOverviewsByChatsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GetChatActivityOverviewByScopeDto} [getChatActivityOverviewByScopeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatActivityOverviewsGetByScopePost(nexusOpsTenant: string, nexusOpsAppVersion?: string, getChatActivityOverviewByScopeDto?: GetChatActivityOverviewByScopeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatActivityOverviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatActivityOverviewsGetByScopePost(nexusOpsTenant, nexusOpsAppVersion, getChatActivityOverviewByScopeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatActivityOverviewsApi.apiV1ChatActivityOverviewsGetByScopePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GetChatActivityOverviewByScopesDto} [getChatActivityOverviewByScopesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatActivityOverviewsGetByScopesPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, getChatActivityOverviewByScopesDto?: GetChatActivityOverviewByScopesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatActivityOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatActivityOverviewsGetByScopesPost(nexusOpsTenant, nexusOpsAppVersion, getChatActivityOverviewByScopesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatActivityOverviewsApi.apiV1ChatActivityOverviewsGetByScopesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatActivityOverviewsApi - factory interface
 * @export
 */
export const ChatActivityOverviewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatActivityOverviewsApiFp(configuration)
    return {
        /**
         * 
         * @param {ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatChatIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatActivityOverviewsByChatChatIdGet(requestParameters: ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatChatIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatActivityOverviewDto> {
            return localVarFp.apiV1ChatActivityOverviewsByChatChatIdGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatActivityOverviewsByChatsGet(requestParameters: ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatActivityOverviewDto>> {
            return localVarFp.apiV1ChatActivityOverviewsByChatsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.chatIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatActivityOverviewsGetByScopePost(requestParameters: ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatActivityOverviewDto> {
            return localVarFp.apiV1ChatActivityOverviewsGetByScopePost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.getChatActivityOverviewByScopeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatActivityOverviewsGetByScopesPost(requestParameters: ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatActivityOverviewDto>> {
            return localVarFp.apiV1ChatActivityOverviewsGetByScopesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.getChatActivityOverviewByScopesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ChatActivityOverviewsByChatChatIdGet operation in ChatActivityOverviewsApi.
 * @export
 * @interface ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatChatIdGetRequest
 */
export interface ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatChatIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatChatIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatChatIdGet
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatChatIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatActivityOverviewsByChatsGet operation in ChatActivityOverviewsApi.
 * @export
 * @interface ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatsGetRequest
 */
export interface ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatsGet
     */
    readonly chatIds?: Array<string>
}

/**
 * Request parameters for apiV1ChatActivityOverviewsGetByScopePost operation in ChatActivityOverviewsApi.
 * @export
 * @interface ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopePostRequest
 */
export interface ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopePost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GetChatActivityOverviewByScopeDto}
     * @memberof ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopePost
     */
    readonly getChatActivityOverviewByScopeDto?: GetChatActivityOverviewByScopeDto
}

/**
 * Request parameters for apiV1ChatActivityOverviewsGetByScopesPost operation in ChatActivityOverviewsApi.
 * @export
 * @interface ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopesPostRequest
 */
export interface ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopesPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopesPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GetChatActivityOverviewByScopesDto}
     * @memberof ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopesPost
     */
    readonly getChatActivityOverviewByScopesDto?: GetChatActivityOverviewByScopesDto
}

/**
 * ChatActivityOverviewsApi - object-oriented interface
 * @export
 * @class ChatActivityOverviewsApi
 * @extends {BaseAPI}
 */
export class ChatActivityOverviewsApi extends BaseAPI {
    /**
     * 
     * @param {ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatChatIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatActivityOverviewsApi
     */
    public apiV1ChatActivityOverviewsByChatChatIdGet(requestParameters: ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatChatIdGetRequest, options?: RawAxiosRequestConfig) {
        return ChatActivityOverviewsApiFp(this.configuration).apiV1ChatActivityOverviewsByChatChatIdGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatActivityOverviewsApi
     */
    public apiV1ChatActivityOverviewsByChatsGet(requestParameters: ChatActivityOverviewsApiApiV1ChatActivityOverviewsByChatsGetRequest, options?: RawAxiosRequestConfig) {
        return ChatActivityOverviewsApiFp(this.configuration).apiV1ChatActivityOverviewsByChatsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.chatIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatActivityOverviewsApi
     */
    public apiV1ChatActivityOverviewsGetByScopePost(requestParameters: ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopePostRequest, options?: RawAxiosRequestConfig) {
        return ChatActivityOverviewsApiFp(this.configuration).apiV1ChatActivityOverviewsGetByScopePost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.getChatActivityOverviewByScopeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatActivityOverviewsApi
     */
    public apiV1ChatActivityOverviewsGetByScopesPost(requestParameters: ChatActivityOverviewsApiApiV1ChatActivityOverviewsGetByScopesPostRequest, options?: RawAxiosRequestConfig) {
        return ChatActivityOverviewsApiFp(this.configuration).apiV1ChatActivityOverviewsGetByScopesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.getChatActivityOverviewByScopesDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatEventsApi - axios parameter creator
 * @export
 */
export const ChatEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatEventGetPaginatedDto} [chatEventGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdEventsGetPost: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, chatEventGetPaginatedDto?: ChatEventGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdEventsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdEventsGetPost', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/events/get`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatEventGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatEventsApi - functional programming interface
 * @export
 */
export const ChatEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatEventGetPaginatedDto} [chatEventGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdEventsGetPost(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, chatEventGetPaginatedDto?: ChatEventGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfChatEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdEventsGetPost(nexusOpsTenant, chatId, nexusOpsAppVersion, chatEventGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatEventsApi.apiV1ChatsChatIdEventsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatEventsApi - factory interface
 * @export
 */
export const ChatEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatEventsApiFp(configuration)
    return {
        /**
         * 
         * @param {ChatEventsApiApiV1ChatsChatIdEventsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdEventsGetPost(requestParameters: ChatEventsApiApiV1ChatsChatIdEventsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfChatEventDto> {
            return localVarFp.apiV1ChatsChatIdEventsGetPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.chatEventGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ChatsChatIdEventsGetPost operation in ChatEventsApi.
 * @export
 * @interface ChatEventsApiApiV1ChatsChatIdEventsGetPostRequest
 */
export interface ChatEventsApiApiV1ChatsChatIdEventsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatEventsApiApiV1ChatsChatIdEventsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatEventsApiApiV1ChatsChatIdEventsGetPost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatEventsApiApiV1ChatsChatIdEventsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ChatEventGetPaginatedDto}
     * @memberof ChatEventsApiApiV1ChatsChatIdEventsGetPost
     */
    readonly chatEventGetPaginatedDto?: ChatEventGetPaginatedDto
}

/**
 * ChatEventsApi - object-oriented interface
 * @export
 * @class ChatEventsApi
 * @extends {BaseAPI}
 */
export class ChatEventsApi extends BaseAPI {
    /**
     * 
     * @param {ChatEventsApiApiV1ChatsChatIdEventsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatEventsApi
     */
    public apiV1ChatsChatIdEventsGetPost(requestParameters: ChatEventsApiApiV1ChatsChatIdEventsGetPostRequest, options?: RawAxiosRequestConfig) {
        return ChatEventsApiFp(this.configuration).apiV1ChatsChatIdEventsGetPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.chatEventGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatHistoryApi - axios parameter creator
 * @export
 */
export const ChatHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatHistoryGetPaginatedDto} [chatHistoryGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdHistoryGetPinnedPost: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, chatHistoryGetPaginatedDto?: ChatHistoryGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdHistoryGetPinnedPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdHistoryGetPinnedPost', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/history/get/pinned`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatHistoryGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatHistoryGetPaginatedDto} [chatHistoryGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdHistoryGetPost: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, chatHistoryGetPaginatedDto?: ChatHistoryGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdHistoryGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdHistoryGetPost', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/history/get`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatHistoryGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} itemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdHistoryItemsItemIdPinPost: async (nexusOpsTenant: string, chatId: string, itemId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdHistoryItemsItemIdPinPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdHistoryItemsItemIdPinPost', 'chatId', chatId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdHistoryItemsItemIdPinPost', 'itemId', itemId)
            const localVarPath = `/api/v1/chats/{chatId}/history/items/{itemId}/pin`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} itemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdHistoryItemsItemIdUnpinPost: async (nexusOpsTenant: string, chatId: string, itemId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdHistoryItemsItemIdUnpinPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdHistoryItemsItemIdUnpinPost', 'chatId', chatId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdHistoryItemsItemIdUnpinPost', 'itemId', itemId)
            const localVarPath = `/api/v1/chats/{chatId}/history/items/{itemId}/unpin`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatHistoryApi - functional programming interface
 * @export
 */
export const ChatHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatHistoryGetPaginatedDto} [chatHistoryGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdHistoryGetPinnedPost(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, chatHistoryGetPaginatedDto?: ChatHistoryGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfChatHistoryItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdHistoryGetPinnedPost(nexusOpsTenant, chatId, nexusOpsAppVersion, chatHistoryGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatHistoryApi.apiV1ChatsChatIdHistoryGetPinnedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatHistoryGetPaginatedDto} [chatHistoryGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdHistoryGetPost(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, chatHistoryGetPaginatedDto?: ChatHistoryGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfChatHistoryItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdHistoryGetPost(nexusOpsTenant, chatId, nexusOpsAppVersion, chatHistoryGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatHistoryApi.apiV1ChatsChatIdHistoryGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} itemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdHistoryItemsItemIdPinPost(nexusOpsTenant: string, chatId: string, itemId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatHistoryItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdHistoryItemsItemIdPinPost(nexusOpsTenant, chatId, itemId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatHistoryApi.apiV1ChatsChatIdHistoryItemsItemIdPinPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} itemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdHistoryItemsItemIdUnpinPost(nexusOpsTenant: string, chatId: string, itemId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdHistoryItemsItemIdUnpinPost(nexusOpsTenant, chatId, itemId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatHistoryApi.apiV1ChatsChatIdHistoryItemsItemIdUnpinPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatHistoryApi - factory interface
 * @export
 */
export const ChatHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {ChatHistoryApiApiV1ChatsChatIdHistoryGetPinnedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdHistoryGetPinnedPost(requestParameters: ChatHistoryApiApiV1ChatsChatIdHistoryGetPinnedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfChatHistoryItemDto> {
            return localVarFp.apiV1ChatsChatIdHistoryGetPinnedPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.chatHistoryGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatHistoryApiApiV1ChatsChatIdHistoryGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdHistoryGetPost(requestParameters: ChatHistoryApiApiV1ChatsChatIdHistoryGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfChatHistoryItemDto> {
            return localVarFp.apiV1ChatsChatIdHistoryGetPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.chatHistoryGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdPinPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdHistoryItemsItemIdPinPost(requestParameters: ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdPinPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatHistoryItemDto> {
            return localVarFp.apiV1ChatsChatIdHistoryItemsItemIdPinPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.itemId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdUnpinPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdHistoryItemsItemIdUnpinPost(requestParameters: ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdUnpinPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1ChatsChatIdHistoryItemsItemIdUnpinPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.itemId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ChatsChatIdHistoryGetPinnedPost operation in ChatHistoryApi.
 * @export
 * @interface ChatHistoryApiApiV1ChatsChatIdHistoryGetPinnedPostRequest
 */
export interface ChatHistoryApiApiV1ChatsChatIdHistoryGetPinnedPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryGetPinnedPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryGetPinnedPost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryGetPinnedPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ChatHistoryGetPaginatedDto}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryGetPinnedPost
     */
    readonly chatHistoryGetPaginatedDto?: ChatHistoryGetPaginatedDto
}

/**
 * Request parameters for apiV1ChatsChatIdHistoryGetPost operation in ChatHistoryApi.
 * @export
 * @interface ChatHistoryApiApiV1ChatsChatIdHistoryGetPostRequest
 */
export interface ChatHistoryApiApiV1ChatsChatIdHistoryGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryGetPost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ChatHistoryGetPaginatedDto}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryGetPost
     */
    readonly chatHistoryGetPaginatedDto?: ChatHistoryGetPaginatedDto
}

/**
 * Request parameters for apiV1ChatsChatIdHistoryItemsItemIdPinPost operation in ChatHistoryApi.
 * @export
 * @interface ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdPinPostRequest
 */
export interface ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdPinPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdPinPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdPinPost
     */
    readonly chatId: string

    /**
     * 
     * @type {string}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdPinPost
     */
    readonly itemId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdPinPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsChatIdHistoryItemsItemIdUnpinPost operation in ChatHistoryApi.
 * @export
 * @interface ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdUnpinPostRequest
 */
export interface ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdUnpinPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdUnpinPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdUnpinPost
     */
    readonly chatId: string

    /**
     * 
     * @type {string}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdUnpinPost
     */
    readonly itemId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdUnpinPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * ChatHistoryApi - object-oriented interface
 * @export
 * @class ChatHistoryApi
 * @extends {BaseAPI}
 */
export class ChatHistoryApi extends BaseAPI {
    /**
     * 
     * @param {ChatHistoryApiApiV1ChatsChatIdHistoryGetPinnedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatHistoryApi
     */
    public apiV1ChatsChatIdHistoryGetPinnedPost(requestParameters: ChatHistoryApiApiV1ChatsChatIdHistoryGetPinnedPostRequest, options?: RawAxiosRequestConfig) {
        return ChatHistoryApiFp(this.configuration).apiV1ChatsChatIdHistoryGetPinnedPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.chatHistoryGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatHistoryApiApiV1ChatsChatIdHistoryGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatHistoryApi
     */
    public apiV1ChatsChatIdHistoryGetPost(requestParameters: ChatHistoryApiApiV1ChatsChatIdHistoryGetPostRequest, options?: RawAxiosRequestConfig) {
        return ChatHistoryApiFp(this.configuration).apiV1ChatsChatIdHistoryGetPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.chatHistoryGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdPinPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatHistoryApi
     */
    public apiV1ChatsChatIdHistoryItemsItemIdPinPost(requestParameters: ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdPinPostRequest, options?: RawAxiosRequestConfig) {
        return ChatHistoryApiFp(this.configuration).apiV1ChatsChatIdHistoryItemsItemIdPinPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.itemId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdUnpinPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatHistoryApi
     */
    public apiV1ChatsChatIdHistoryItemsItemIdUnpinPost(requestParameters: ChatHistoryApiApiV1ChatsChatIdHistoryItemsItemIdUnpinPostRequest, options?: RawAxiosRequestConfig) {
        return ChatHistoryApiFp(this.configuration).apiV1ChatsChatIdHistoryItemsItemIdUnpinPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.itemId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatMessagesApi - axios parameter creator
 * @export
 */
export const ChatMessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatMessageGetPaginatedDto} [chatMessageGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdMessagesGetPost: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, chatMessageGetPaginatedDto?: ChatMessageGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesGetPost', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/messages/get`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatMessageGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {MarkChatMessagesAsReadDto} [markChatMessagesAsReadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdMessagesMarkAsReadPost: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, markChatMessagesAsReadDto?: MarkChatMessagesAsReadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesMarkAsReadPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesMarkAsReadPost', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/messages/mark-as-read`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markChatMessagesAsReadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} messageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdMessagesMessageIdAcknowledgePost: async (nexusOpsTenant: string, chatId: string, messageId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesMessageIdAcknowledgePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesMessageIdAcknowledgePost', 'chatId', chatId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesMessageIdAcknowledgePost', 'messageId', messageId)
            const localVarPath = `/api/v1/chats/{chatId}/messages/{messageId}/acknowledge`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} messageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdMessagesMessageIdDelete: async (nexusOpsTenant: string, chatId: string, messageId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesMessageIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesMessageIdDelete', 'chatId', chatId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesMessageIdDelete', 'messageId', messageId)
            const localVarPath = `/api/v1/chats/{chatId}/messages/{messageId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} messageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdMessagesMessageIdGet: async (nexusOpsTenant: string, chatId: string, messageId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesMessageIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesMessageIdGet', 'chatId', chatId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesMessageIdGet', 'messageId', messageId)
            const localVarPath = `/api/v1/chats/{chatId}/messages/{messageId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} messageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateChatMessageDto} [updateChatMessageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdMessagesMessageIdPut: async (nexusOpsTenant: string, chatId: string, messageId: string, nexusOpsAppVersion?: string, updateChatMessageDto?: UpdateChatMessageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesMessageIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesMessageIdPut', 'chatId', chatId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesMessageIdPut', 'messageId', messageId)
            const localVarPath = `/api/v1/chats/{chatId}/messages/{messageId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChatMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SendChatMessageDto} [sendChatMessageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdMessagesPost: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, sendChatMessageDto?: SendChatMessageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdMessagesPost', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/messages`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendChatMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatMessagesApi - functional programming interface
 * @export
 */
export const ChatMessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatMessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatMessageGetPaginatedDto} [chatMessageGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdMessagesGetPost(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, chatMessageGetPaginatedDto?: ChatMessageGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfChatMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdMessagesGetPost(nexusOpsTenant, chatId, nexusOpsAppVersion, chatMessageGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMessagesApi.apiV1ChatsChatIdMessagesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {MarkChatMessagesAsReadDto} [markChatMessagesAsReadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdMessagesMarkAsReadPost(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, markChatMessagesAsReadDto?: MarkChatMessagesAsReadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkChatMessagesAsReadResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdMessagesMarkAsReadPost(nexusOpsTenant, chatId, nexusOpsAppVersion, markChatMessagesAsReadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMessagesApi.apiV1ChatsChatIdMessagesMarkAsReadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} messageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdMessagesMessageIdAcknowledgePost(nexusOpsTenant: string, chatId: string, messageId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdMessagesMessageIdAcknowledgePost(nexusOpsTenant, chatId, messageId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMessagesApi.apiV1ChatsChatIdMessagesMessageIdAcknowledgePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} messageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdMessagesMessageIdDelete(nexusOpsTenant: string, chatId: string, messageId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdMessagesMessageIdDelete(nexusOpsTenant, chatId, messageId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMessagesApi.apiV1ChatsChatIdMessagesMessageIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} messageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdMessagesMessageIdGet(nexusOpsTenant: string, chatId: string, messageId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdMessagesMessageIdGet(nexusOpsTenant, chatId, messageId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMessagesApi.apiV1ChatsChatIdMessagesMessageIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} messageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateChatMessageDto} [updateChatMessageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdMessagesMessageIdPut(nexusOpsTenant: string, chatId: string, messageId: string, nexusOpsAppVersion?: string, updateChatMessageDto?: UpdateChatMessageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdMessagesMessageIdPut(nexusOpsTenant, chatId, messageId, nexusOpsAppVersion, updateChatMessageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMessagesApi.apiV1ChatsChatIdMessagesMessageIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SendChatMessageDto} [sendChatMessageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdMessagesPost(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, sendChatMessageDto?: SendChatMessageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdMessagesPost(nexusOpsTenant, chatId, nexusOpsAppVersion, sendChatMessageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatMessagesApi.apiV1ChatsChatIdMessagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatMessagesApi - factory interface
 * @export
 */
export const ChatMessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatMessagesApiFp(configuration)
    return {
        /**
         * 
         * @param {ChatMessagesApiApiV1ChatsChatIdMessagesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdMessagesGetPost(requestParameters: ChatMessagesApiApiV1ChatsChatIdMessagesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfChatMessageDto> {
            return localVarFp.apiV1ChatsChatIdMessagesGetPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.chatMessageGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatMessagesApiApiV1ChatsChatIdMessagesMarkAsReadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdMessagesMarkAsReadPost(requestParameters: ChatMessagesApiApiV1ChatsChatIdMessagesMarkAsReadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<MarkChatMessagesAsReadResultDto> {
            return localVarFp.apiV1ChatsChatIdMessagesMarkAsReadPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.markChatMessagesAsReadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdAcknowledgePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdMessagesMessageIdAcknowledgePost(requestParameters: ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdAcknowledgePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageDto> {
            return localVarFp.apiV1ChatsChatIdMessagesMessageIdAcknowledgePost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.messageId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdMessagesMessageIdDelete(requestParameters: ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1ChatsChatIdMessagesMessageIdDelete(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.messageId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdMessagesMessageIdGet(requestParameters: ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageDto> {
            return localVarFp.apiV1ChatsChatIdMessagesMessageIdGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.messageId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdMessagesMessageIdPut(requestParameters: ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageDto> {
            return localVarFp.apiV1ChatsChatIdMessagesMessageIdPut(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.messageId, requestParameters.nexusOpsAppVersion, requestParameters.updateChatMessageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatMessagesApiApiV1ChatsChatIdMessagesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdMessagesPost(requestParameters: ChatMessagesApiApiV1ChatsChatIdMessagesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageDto> {
            return localVarFp.apiV1ChatsChatIdMessagesPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.sendChatMessageDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ChatsChatIdMessagesGetPost operation in ChatMessagesApi.
 * @export
 * @interface ChatMessagesApiApiV1ChatsChatIdMessagesGetPostRequest
 */
export interface ChatMessagesApiApiV1ChatsChatIdMessagesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesGetPost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ChatMessageGetPaginatedDto}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesGetPost
     */
    readonly chatMessageGetPaginatedDto?: ChatMessageGetPaginatedDto
}

/**
 * Request parameters for apiV1ChatsChatIdMessagesMarkAsReadPost operation in ChatMessagesApi.
 * @export
 * @interface ChatMessagesApiApiV1ChatsChatIdMessagesMarkAsReadPostRequest
 */
export interface ChatMessagesApiApiV1ChatsChatIdMessagesMarkAsReadPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMarkAsReadPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMarkAsReadPost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMarkAsReadPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {MarkChatMessagesAsReadDto}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMarkAsReadPost
     */
    readonly markChatMessagesAsReadDto?: MarkChatMessagesAsReadDto
}

/**
 * Request parameters for apiV1ChatsChatIdMessagesMessageIdAcknowledgePost operation in ChatMessagesApi.
 * @export
 * @interface ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdAcknowledgePostRequest
 */
export interface ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdAcknowledgePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdAcknowledgePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdAcknowledgePost
     */
    readonly chatId: string

    /**
     * 
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdAcknowledgePost
     */
    readonly messageId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdAcknowledgePost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsChatIdMessagesMessageIdDelete operation in ChatMessagesApi.
 * @export
 * @interface ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdDeleteRequest
 */
export interface ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdDelete
     */
    readonly chatId: string

    /**
     * 
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdDelete
     */
    readonly messageId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsChatIdMessagesMessageIdGet operation in ChatMessagesApi.
 * @export
 * @interface ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdGetRequest
 */
export interface ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdGet
     */
    readonly chatId: string

    /**
     * 
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdGet
     */
    readonly messageId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsChatIdMessagesMessageIdPut operation in ChatMessagesApi.
 * @export
 * @interface ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdPutRequest
 */
export interface ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdPut
     */
    readonly chatId: string

    /**
     * 
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdPut
     */
    readonly messageId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateChatMessageDto}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdPut
     */
    readonly updateChatMessageDto?: UpdateChatMessageDto
}

/**
 * Request parameters for apiV1ChatsChatIdMessagesPost operation in ChatMessagesApi.
 * @export
 * @interface ChatMessagesApiApiV1ChatsChatIdMessagesPostRequest
 */
export interface ChatMessagesApiApiV1ChatsChatIdMessagesPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesPost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {SendChatMessageDto}
     * @memberof ChatMessagesApiApiV1ChatsChatIdMessagesPost
     */
    readonly sendChatMessageDto?: SendChatMessageDto
}

/**
 * ChatMessagesApi - object-oriented interface
 * @export
 * @class ChatMessagesApi
 * @extends {BaseAPI}
 */
export class ChatMessagesApi extends BaseAPI {
    /**
     * 
     * @param {ChatMessagesApiApiV1ChatsChatIdMessagesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMessagesApi
     */
    public apiV1ChatsChatIdMessagesGetPost(requestParameters: ChatMessagesApiApiV1ChatsChatIdMessagesGetPostRequest, options?: RawAxiosRequestConfig) {
        return ChatMessagesApiFp(this.configuration).apiV1ChatsChatIdMessagesGetPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.chatMessageGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatMessagesApiApiV1ChatsChatIdMessagesMarkAsReadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMessagesApi
     */
    public apiV1ChatsChatIdMessagesMarkAsReadPost(requestParameters: ChatMessagesApiApiV1ChatsChatIdMessagesMarkAsReadPostRequest, options?: RawAxiosRequestConfig) {
        return ChatMessagesApiFp(this.configuration).apiV1ChatsChatIdMessagesMarkAsReadPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.markChatMessagesAsReadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdAcknowledgePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMessagesApi
     */
    public apiV1ChatsChatIdMessagesMessageIdAcknowledgePost(requestParameters: ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdAcknowledgePostRequest, options?: RawAxiosRequestConfig) {
        return ChatMessagesApiFp(this.configuration).apiV1ChatsChatIdMessagesMessageIdAcknowledgePost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.messageId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMessagesApi
     */
    public apiV1ChatsChatIdMessagesMessageIdDelete(requestParameters: ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ChatMessagesApiFp(this.configuration).apiV1ChatsChatIdMessagesMessageIdDelete(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.messageId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMessagesApi
     */
    public apiV1ChatsChatIdMessagesMessageIdGet(requestParameters: ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdGetRequest, options?: RawAxiosRequestConfig) {
        return ChatMessagesApiFp(this.configuration).apiV1ChatsChatIdMessagesMessageIdGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.messageId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMessagesApi
     */
    public apiV1ChatsChatIdMessagesMessageIdPut(requestParameters: ChatMessagesApiApiV1ChatsChatIdMessagesMessageIdPutRequest, options?: RawAxiosRequestConfig) {
        return ChatMessagesApiFp(this.configuration).apiV1ChatsChatIdMessagesMessageIdPut(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.messageId, requestParameters.nexusOpsAppVersion, requestParameters.updateChatMessageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatMessagesApiApiV1ChatsChatIdMessagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatMessagesApi
     */
    public apiV1ChatsChatIdMessagesPost(requestParameters: ChatMessagesApiApiV1ChatsChatIdMessagesPostRequest, options?: RawAxiosRequestConfig) {
        return ChatMessagesApiFp(this.configuration).apiV1ChatsChatIdMessagesPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.sendChatMessageDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatParticipantsApi - axios parameter creator
 * @export
 */
export const ChatParticipantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsCandidatesGet: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, offset?: number, limit?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsCandidatesGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsCandidatesGet', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/participants/candidates`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatParticipantGetPaginatedDto} [chatParticipantGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsGetPost: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, chatParticipantGetPaginatedDto?: ChatParticipantGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsGetPost', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/participants/get`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatParticipantGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsJoinPost: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsJoinPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsJoinPost', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/participants/join`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsLeavePost: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsLeavePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsLeavePost', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/participants/leave`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsMeGet: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsMeGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsMeGet', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/participants/me`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} participantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsParticipantIdDelete: async (nexusOpsTenant: string, chatId: string, participantId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsParticipantIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsParticipantIdDelete', 'chatId', chatId)
            // verify required parameter 'participantId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsParticipantIdDelete', 'participantId', participantId)
            const localVarPath = `/api/v1/chats/{chatId}/participants/{participantId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)))
                .replace(`{${"participantId"}}`, encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} participantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsParticipantIdGet: async (nexusOpsTenant: string, chatId: string, participantId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsParticipantIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsParticipantIdGet', 'chatId', chatId)
            // verify required parameter 'participantId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsParticipantIdGet', 'participantId', participantId)
            const localVarPath = `/api/v1/chats/{chatId}/participants/{participantId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)))
                .replace(`{${"participantId"}}`, encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddChatParticipantsDto} [addChatParticipantsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsPost: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, addChatParticipantsDto?: AddChatParticipantsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdParticipantsPost', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/participants`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addChatParticipantsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatParticipantsApi - functional programming interface
 * @export
 */
export const ChatParticipantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatParticipantsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdParticipantsCandidatesGet(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, offset?: number, limit?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfChatParticipantCandidateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdParticipantsCandidatesGet(nexusOpsTenant, chatId, nexusOpsAppVersion, offset, limit, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatParticipantsApi.apiV1ChatsChatIdParticipantsCandidatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatParticipantGetPaginatedDto} [chatParticipantGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdParticipantsGetPost(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, chatParticipantGetPaginatedDto?: ChatParticipantGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfChatParticipantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdParticipantsGetPost(nexusOpsTenant, chatId, nexusOpsAppVersion, chatParticipantGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatParticipantsApi.apiV1ChatsChatIdParticipantsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdParticipantsJoinPost(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatParticipantJoinResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdParticipantsJoinPost(nexusOpsTenant, chatId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatParticipantsApi.apiV1ChatsChatIdParticipantsJoinPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdParticipantsLeavePost(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatParticipantLeaveResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdParticipantsLeavePost(nexusOpsTenant, chatId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatParticipantsApi.apiV1ChatsChatIdParticipantsLeavePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdParticipantsMeGet(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfChatParticipantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdParticipantsMeGet(nexusOpsTenant, chatId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatParticipantsApi.apiV1ChatsChatIdParticipantsMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} participantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdParticipantsParticipantIdDelete(nexusOpsTenant: string, chatId: string, participantId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatParticipantRemoveResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdParticipantsParticipantIdDelete(nexusOpsTenant, chatId, participantId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatParticipantsApi.apiV1ChatsChatIdParticipantsParticipantIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} participantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdParticipantsParticipantIdGet(nexusOpsTenant: string, chatId: string, participantId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatParticipantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdParticipantsParticipantIdGet(nexusOpsTenant, chatId, participantId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatParticipantsApi.apiV1ChatsChatIdParticipantsParticipantIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddChatParticipantsDto} [addChatParticipantsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdParticipantsPost(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, addChatParticipantsDto?: AddChatParticipantsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatParticipantAddManyResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdParticipantsPost(nexusOpsTenant, chatId, nexusOpsAppVersion, addChatParticipantsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatParticipantsApi.apiV1ChatsChatIdParticipantsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatParticipantsApi - factory interface
 * @export
 */
export const ChatParticipantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatParticipantsApiFp(configuration)
    return {
        /**
         * 
         * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsCandidatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsCandidatesGet(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsCandidatesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfChatParticipantCandidateDto> {
            return localVarFp.apiV1ChatsChatIdParticipantsCandidatesGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.offset, requestParameters.limit, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsGetPost(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfChatParticipantDto> {
            return localVarFp.apiV1ChatsChatIdParticipantsGetPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.chatParticipantGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsJoinPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsJoinPost(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsJoinPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatParticipantJoinResultDto> {
            return localVarFp.apiV1ChatsChatIdParticipantsJoinPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsLeavePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsLeavePost(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsLeavePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatParticipantLeaveResultDto> {
            return localVarFp.apiV1ChatsChatIdParticipantsLeavePost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsMeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsMeGet(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsMeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfChatParticipantDto> {
            return localVarFp.apiV1ChatsChatIdParticipantsMeGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsParticipantIdDelete(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatParticipantRemoveResultDto> {
            return localVarFp.apiV1ChatsChatIdParticipantsParticipantIdDelete(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.participantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsParticipantIdGet(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatParticipantDto> {
            return localVarFp.apiV1ChatsChatIdParticipantsParticipantIdGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.participantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdParticipantsPost(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatParticipantAddManyResultDto> {
            return localVarFp.apiV1ChatsChatIdParticipantsPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.addChatParticipantsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ChatsChatIdParticipantsCandidatesGet operation in ChatParticipantsApi.
 * @export
 * @interface ChatParticipantsApiApiV1ChatsChatIdParticipantsCandidatesGetRequest
 */
export interface ChatParticipantsApiApiV1ChatsChatIdParticipantsCandidatesGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsCandidatesGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsCandidatesGet
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsCandidatesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {number}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsCandidatesGet
     */
    readonly offset?: number

    /**
     * 
     * @type {number}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsCandidatesGet
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsCandidatesGet
     */
    readonly search?: string
}

/**
 * Request parameters for apiV1ChatsChatIdParticipantsGetPost operation in ChatParticipantsApi.
 * @export
 * @interface ChatParticipantsApiApiV1ChatsChatIdParticipantsGetPostRequest
 */
export interface ChatParticipantsApiApiV1ChatsChatIdParticipantsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsGetPost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ChatParticipantGetPaginatedDto}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsGetPost
     */
    readonly chatParticipantGetPaginatedDto?: ChatParticipantGetPaginatedDto
}

/**
 * Request parameters for apiV1ChatsChatIdParticipantsJoinPost operation in ChatParticipantsApi.
 * @export
 * @interface ChatParticipantsApiApiV1ChatsChatIdParticipantsJoinPostRequest
 */
export interface ChatParticipantsApiApiV1ChatsChatIdParticipantsJoinPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsJoinPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsJoinPost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsJoinPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsChatIdParticipantsLeavePost operation in ChatParticipantsApi.
 * @export
 * @interface ChatParticipantsApiApiV1ChatsChatIdParticipantsLeavePostRequest
 */
export interface ChatParticipantsApiApiV1ChatsChatIdParticipantsLeavePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsLeavePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsLeavePost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsLeavePost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsChatIdParticipantsMeGet operation in ChatParticipantsApi.
 * @export
 * @interface ChatParticipantsApiApiV1ChatsChatIdParticipantsMeGetRequest
 */
export interface ChatParticipantsApiApiV1ChatsChatIdParticipantsMeGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsMeGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsMeGet
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsMeGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsChatIdParticipantsParticipantIdDelete operation in ChatParticipantsApi.
 * @export
 * @interface ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdDeleteRequest
 */
export interface ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdDelete
     */
    readonly chatId: string

    /**
     * 
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdDelete
     */
    readonly participantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsChatIdParticipantsParticipantIdGet operation in ChatParticipantsApi.
 * @export
 * @interface ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdGetRequest
 */
export interface ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdGet
     */
    readonly chatId: string

    /**
     * 
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdGet
     */
    readonly participantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsChatIdParticipantsPost operation in ChatParticipantsApi.
 * @export
 * @interface ChatParticipantsApiApiV1ChatsChatIdParticipantsPostRequest
 */
export interface ChatParticipantsApiApiV1ChatsChatIdParticipantsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsPost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AddChatParticipantsDto}
     * @memberof ChatParticipantsApiApiV1ChatsChatIdParticipantsPost
     */
    readonly addChatParticipantsDto?: AddChatParticipantsDto
}

/**
 * ChatParticipantsApi - object-oriented interface
 * @export
 * @class ChatParticipantsApi
 * @extends {BaseAPI}
 */
export class ChatParticipantsApi extends BaseAPI {
    /**
     * 
     * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsCandidatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatParticipantsApi
     */
    public apiV1ChatsChatIdParticipantsCandidatesGet(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsCandidatesGetRequest, options?: RawAxiosRequestConfig) {
        return ChatParticipantsApiFp(this.configuration).apiV1ChatsChatIdParticipantsCandidatesGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.offset, requestParameters.limit, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatParticipantsApi
     */
    public apiV1ChatsChatIdParticipantsGetPost(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsGetPostRequest, options?: RawAxiosRequestConfig) {
        return ChatParticipantsApiFp(this.configuration).apiV1ChatsChatIdParticipantsGetPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.chatParticipantGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsJoinPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatParticipantsApi
     */
    public apiV1ChatsChatIdParticipantsJoinPost(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsJoinPostRequest, options?: RawAxiosRequestConfig) {
        return ChatParticipantsApiFp(this.configuration).apiV1ChatsChatIdParticipantsJoinPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsLeavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatParticipantsApi
     */
    public apiV1ChatsChatIdParticipantsLeavePost(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsLeavePostRequest, options?: RawAxiosRequestConfig) {
        return ChatParticipantsApiFp(this.configuration).apiV1ChatsChatIdParticipantsLeavePost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsMeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatParticipantsApi
     */
    public apiV1ChatsChatIdParticipantsMeGet(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsMeGetRequest, options?: RawAxiosRequestConfig) {
        return ChatParticipantsApiFp(this.configuration).apiV1ChatsChatIdParticipantsMeGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatParticipantsApi
     */
    public apiV1ChatsChatIdParticipantsParticipantIdDelete(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ChatParticipantsApiFp(this.configuration).apiV1ChatsChatIdParticipantsParticipantIdDelete(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.participantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatParticipantsApi
     */
    public apiV1ChatsChatIdParticipantsParticipantIdGet(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsParticipantIdGetRequest, options?: RawAxiosRequestConfig) {
        return ChatParticipantsApiFp(this.configuration).apiV1ChatsChatIdParticipantsParticipantIdGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.participantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatParticipantsApiApiV1ChatsChatIdParticipantsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatParticipantsApi
     */
    public apiV1ChatsChatIdParticipantsPost(requestParameters: ChatParticipantsApiApiV1ChatsChatIdParticipantsPostRequest, options?: RawAxiosRequestConfig) {
        return ChatParticipantsApiFp(this.configuration).apiV1ChatsChatIdParticipantsPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.addChatParticipantsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatUserSettingsApi - axios parameter creator
 * @export
 */
export const ChatUserSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatUserSettingsChatIdGet: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatUserSettingsChatIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatUserSettingsChatIdGet', 'chatId', chatId)
            const localVarPath = `/api/v1/chat-user-settings/{chatId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateChatUserSettingsDto} [updateChatUserSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatUserSettingsPut: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, updateChatUserSettingsDto?: UpdateChatUserSettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatUserSettingsPut', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/chat-user-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChatUserSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatUserSettingsApi - functional programming interface
 * @export
 */
export const ChatUserSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatUserSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatUserSettingsChatIdGet(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatUserSettingsResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatUserSettingsChatIdGet(nexusOpsTenant, chatId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatUserSettingsApi.apiV1ChatUserSettingsChatIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateChatUserSettingsDto} [updateChatUserSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatUserSettingsPut(nexusOpsTenant: string, nexusOpsAppVersion?: string, updateChatUserSettingsDto?: UpdateChatUserSettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatUserSettingsResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatUserSettingsPut(nexusOpsTenant, nexusOpsAppVersion, updateChatUserSettingsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatUserSettingsApi.apiV1ChatUserSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatUserSettingsApi - factory interface
 * @export
 */
export const ChatUserSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatUserSettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {ChatUserSettingsApiApiV1ChatUserSettingsChatIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatUserSettingsChatIdGet(requestParameters: ChatUserSettingsApiApiV1ChatUserSettingsChatIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetChatUserSettingsResultDto> {
            return localVarFp.apiV1ChatUserSettingsChatIdGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatUserSettingsApiApiV1ChatUserSettingsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatUserSettingsPut(requestParameters: ChatUserSettingsApiApiV1ChatUserSettingsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetChatUserSettingsResultDto> {
            return localVarFp.apiV1ChatUserSettingsPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.updateChatUserSettingsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ChatUserSettingsChatIdGet operation in ChatUserSettingsApi.
 * @export
 * @interface ChatUserSettingsApiApiV1ChatUserSettingsChatIdGetRequest
 */
export interface ChatUserSettingsApiApiV1ChatUserSettingsChatIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatUserSettingsApiApiV1ChatUserSettingsChatIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatUserSettingsApiApiV1ChatUserSettingsChatIdGet
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatUserSettingsApiApiV1ChatUserSettingsChatIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatUserSettingsPut operation in ChatUserSettingsApi.
 * @export
 * @interface ChatUserSettingsApiApiV1ChatUserSettingsPutRequest
 */
export interface ChatUserSettingsApiApiV1ChatUserSettingsPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatUserSettingsApiApiV1ChatUserSettingsPut
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatUserSettingsApiApiV1ChatUserSettingsPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateChatUserSettingsDto}
     * @memberof ChatUserSettingsApiApiV1ChatUserSettingsPut
     */
    readonly updateChatUserSettingsDto?: UpdateChatUserSettingsDto
}

/**
 * ChatUserSettingsApi - object-oriented interface
 * @export
 * @class ChatUserSettingsApi
 * @extends {BaseAPI}
 */
export class ChatUserSettingsApi extends BaseAPI {
    /**
     * 
     * @param {ChatUserSettingsApiApiV1ChatUserSettingsChatIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUserSettingsApi
     */
    public apiV1ChatUserSettingsChatIdGet(requestParameters: ChatUserSettingsApiApiV1ChatUserSettingsChatIdGetRequest, options?: RawAxiosRequestConfig) {
        return ChatUserSettingsApiFp(this.configuration).apiV1ChatUserSettingsChatIdGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatUserSettingsApiApiV1ChatUserSettingsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUserSettingsApi
     */
    public apiV1ChatUserSettingsPut(requestParameters: ChatUserSettingsApiApiV1ChatUserSettingsPutRequest, options?: RawAxiosRequestConfig) {
        return ChatUserSettingsApiFp(this.configuration).apiV1ChatUserSettingsPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.updateChatUserSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatsApi - axios parameter creator
 * @export
 */
export const ChatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [identifier] 
         * @param {string} [subIdentifier] 
         * @param {GeneralScopeType} [type] Helps link chat to its scope.  For instance, link comments chat to report entity to be able to update report based on chat events or actions.
         * @param {boolean} [isResolved] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsByScopeGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, identifier?: string, subIdentifier?: string, type?: GeneralScopeType, isResolved?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsByScopeGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/chats/by-scope`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (identifier !== undefined) {
                localVarQueryParameter['identifier'] = identifier;
            }

            if (subIdentifier !== undefined) {
                localVarQueryParameter['subIdentifier'] = subIdentifier;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (isResolved !== undefined) {
                localVarQueryParameter['isResolved'] = isResolved;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdAcknowledgePost: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdAcknowledgePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdAcknowledgePost', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/acknowledge`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdDelete: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdDelete', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdGet: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdGet', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateChatDto} [updateChatDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdPut: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, updateChatDto?: UpdateChatDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdPut', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChatDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdReopenPost: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdReopenPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdReopenPost', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/reopen`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdResolvePost: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdResolvePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdResolvePost', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/resolve`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdTipsGet: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsChatIdTipsGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1ChatsChatIdTipsGet', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/tips`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GetOrCreateCommentChatDto} [getOrCreateCommentChatDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsCommentEntityGetOrCreatePost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, getOrCreateCommentChatDto?: GetOrCreateCommentChatDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsCommentEntityGetOrCreatePost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/chats/comment/entity/get-or-create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOrCreateCommentChatDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GetOrCreateCommentChatDto} [getOrCreateCommentChatDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsCommentGetOrCreatePost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, getOrCreateCommentChatDto?: GetOrCreateCommentChatDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsCommentGetOrCreatePost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/chats/comment/get-or-create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOrCreateCommentChatDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatGetPaginatedDto} [chatGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, chatGetPaginatedDto?: ChatGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/chats/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateGroupChatDto} [createGroupChatDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsGroupPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createGroupChatDto?: CreateGroupChatDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsGroupPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/chats/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupChatDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatGetOrCreateNegotiationDto} [chatGetOrCreateNegotiationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsNegotiationGetOrCreatePost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, chatGetOrCreateNegotiationDto?: ChatGetOrCreateNegotiationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsNegotiationGetOrCreatePost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/chats/negotiation/get-or-create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatGetOrCreateNegotiationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreatePersonalChatDto} [createPersonalChatDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsPersonalPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createPersonalChatDto?: CreatePersonalChatDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ChatsPersonalPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/chats/personal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPersonalChatDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatsApi - functional programming interface
 * @export
 */
export const ChatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [identifier] 
         * @param {string} [subIdentifier] 
         * @param {GeneralScopeType} [type] Helps link chat to its scope.  For instance, link comments chat to report entity to be able to update report based on chat events or actions.
         * @param {boolean} [isResolved] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsByScopeGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, identifier?: string, subIdentifier?: string, type?: GeneralScopeType, isResolved?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsByScopeGet(nexusOpsTenant, nexusOpsAppVersion, identifier, subIdentifier, type, isResolved, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.apiV1ChatsByScopeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdAcknowledgePost(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatAcknowledgeResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdAcknowledgePost(nexusOpsTenant, chatId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.apiV1ChatsChatIdAcknowledgePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdDelete(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdDelete(nexusOpsTenant, chatId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.apiV1ChatsChatIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdGet(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdGet(nexusOpsTenant, chatId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.apiV1ChatsChatIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateChatDto} [updateChatDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdPut(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, updateChatDto?: UpdateChatDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdPut(nexusOpsTenant, chatId, nexusOpsAppVersion, updateChatDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.apiV1ChatsChatIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdReopenPost(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdReopenPost(nexusOpsTenant, chatId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.apiV1ChatsChatIdReopenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdResolvePost(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdResolvePost(nexusOpsTenant, chatId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.apiV1ChatsChatIdResolvePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsChatIdTipsGet(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatTipsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsChatIdTipsGet(nexusOpsTenant, chatId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.apiV1ChatsChatIdTipsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GetOrCreateCommentChatDto} [getOrCreateCommentChatDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsCommentEntityGetOrCreatePost(nexusOpsTenant: string, nexusOpsAppVersion?: string, getOrCreateCommentChatDto?: GetOrCreateCommentChatDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsCommentEntityGetOrCreatePost(nexusOpsTenant, nexusOpsAppVersion, getOrCreateCommentChatDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.apiV1ChatsCommentEntityGetOrCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GetOrCreateCommentChatDto} [getOrCreateCommentChatDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsCommentGetOrCreatePost(nexusOpsTenant: string, nexusOpsAppVersion?: string, getOrCreateCommentChatDto?: GetOrCreateCommentChatDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsCommentGetOrCreatePost(nexusOpsTenant, nexusOpsAppVersion, getOrCreateCommentChatDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.apiV1ChatsCommentGetOrCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatGetPaginatedDto} [chatGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, chatGetPaginatedDto?: ChatGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfChatDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsGetPost(nexusOpsTenant, nexusOpsAppVersion, chatGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.apiV1ChatsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateGroupChatDto} [createGroupChatDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsGroupPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createGroupChatDto?: CreateGroupChatDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsGroupPost(nexusOpsTenant, nexusOpsAppVersion, createGroupChatDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.apiV1ChatsGroupPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ChatGetOrCreateNegotiationDto} [chatGetOrCreateNegotiationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsNegotiationGetOrCreatePost(nexusOpsTenant: string, nexusOpsAppVersion?: string, chatGetOrCreateNegotiationDto?: ChatGetOrCreateNegotiationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsNegotiationGetOrCreatePost(nexusOpsTenant, nexusOpsAppVersion, chatGetOrCreateNegotiationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.apiV1ChatsNegotiationGetOrCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreatePersonalChatDto} [createPersonalChatDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChatsPersonalPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createPersonalChatDto?: CreatePersonalChatDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChatsPersonalPost(nexusOpsTenant, nexusOpsAppVersion, createPersonalChatDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatsApi.apiV1ChatsPersonalPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatsApi - factory interface
 * @export
 */
export const ChatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatsApiFp(configuration)
    return {
        /**
         * 
         * @param {ChatsApiApiV1ChatsByScopeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsByScopeGet(requestParameters: ChatsApiApiV1ChatsByScopeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDto> {
            return localVarFp.apiV1ChatsByScopeGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.identifier, requestParameters.subIdentifier, requestParameters.type, requestParameters.isResolved, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatsApiApiV1ChatsChatIdAcknowledgePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdAcknowledgePost(requestParameters: ChatsApiApiV1ChatsChatIdAcknowledgePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatAcknowledgeResultDto> {
            return localVarFp.apiV1ChatsChatIdAcknowledgePost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatsApiApiV1ChatsChatIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdDelete(requestParameters: ChatsApiApiV1ChatsChatIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1ChatsChatIdDelete(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatsApiApiV1ChatsChatIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdGet(requestParameters: ChatsApiApiV1ChatsChatIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDto> {
            return localVarFp.apiV1ChatsChatIdGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatsApiApiV1ChatsChatIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdPut(requestParameters: ChatsApiApiV1ChatsChatIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDto> {
            return localVarFp.apiV1ChatsChatIdPut(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.updateChatDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatsApiApiV1ChatsChatIdReopenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdReopenPost(requestParameters: ChatsApiApiV1ChatsChatIdReopenPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDto> {
            return localVarFp.apiV1ChatsChatIdReopenPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatsApiApiV1ChatsChatIdResolvePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdResolvePost(requestParameters: ChatsApiApiV1ChatsChatIdResolvePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDto> {
            return localVarFp.apiV1ChatsChatIdResolvePost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatsApiApiV1ChatsChatIdTipsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsChatIdTipsGet(requestParameters: ChatsApiApiV1ChatsChatIdTipsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatTipsDto> {
            return localVarFp.apiV1ChatsChatIdTipsGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatsApiApiV1ChatsCommentEntityGetOrCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsCommentEntityGetOrCreatePost(requestParameters: ChatsApiApiV1ChatsCommentEntityGetOrCreatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDto> {
            return localVarFp.apiV1ChatsCommentEntityGetOrCreatePost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.getOrCreateCommentChatDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatsApiApiV1ChatsCommentGetOrCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsCommentGetOrCreatePost(requestParameters: ChatsApiApiV1ChatsCommentGetOrCreatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDto> {
            return localVarFp.apiV1ChatsCommentGetOrCreatePost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.getOrCreateCommentChatDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatsApiApiV1ChatsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsGetPost(requestParameters: ChatsApiApiV1ChatsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfChatDto> {
            return localVarFp.apiV1ChatsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.chatGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatsApiApiV1ChatsGroupPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsGroupPost(requestParameters: ChatsApiApiV1ChatsGroupPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDto> {
            return localVarFp.apiV1ChatsGroupPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createGroupChatDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatsApiApiV1ChatsNegotiationGetOrCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsNegotiationGetOrCreatePost(requestParameters: ChatsApiApiV1ChatsNegotiationGetOrCreatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDto> {
            return localVarFp.apiV1ChatsNegotiationGetOrCreatePost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.chatGetOrCreateNegotiationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChatsApiApiV1ChatsPersonalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChatsPersonalPost(requestParameters: ChatsApiApiV1ChatsPersonalPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatDto> {
            return localVarFp.apiV1ChatsPersonalPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createPersonalChatDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ChatsByScopeGet operation in ChatsApi.
 * @export
 * @interface ChatsApiApiV1ChatsByScopeGetRequest
 */
export interface ChatsApiApiV1ChatsByScopeGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatsApiApiV1ChatsByScopeGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatsApiApiV1ChatsByScopeGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof ChatsApiApiV1ChatsByScopeGet
     */
    readonly identifier?: string

    /**
     * 
     * @type {string}
     * @memberof ChatsApiApiV1ChatsByScopeGet
     */
    readonly subIdentifier?: string

    /**
     * Helps link chat to its scope.  For instance, link comments chat to report entity to be able to update report based on chat events or actions.
     * @type {GeneralScopeType}
     * @memberof ChatsApiApiV1ChatsByScopeGet
     */
    readonly type?: GeneralScopeType

    /**
     * 
     * @type {boolean}
     * @memberof ChatsApiApiV1ChatsByScopeGet
     */
    readonly isResolved?: boolean
}

/**
 * Request parameters for apiV1ChatsChatIdAcknowledgePost operation in ChatsApi.
 * @export
 * @interface ChatsApiApiV1ChatsChatIdAcknowledgePostRequest
 */
export interface ChatsApiApiV1ChatsChatIdAcknowledgePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdAcknowledgePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdAcknowledgePost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdAcknowledgePost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsChatIdDelete operation in ChatsApi.
 * @export
 * @interface ChatsApiApiV1ChatsChatIdDeleteRequest
 */
export interface ChatsApiApiV1ChatsChatIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdDelete
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsChatIdGet operation in ChatsApi.
 * @export
 * @interface ChatsApiApiV1ChatsChatIdGetRequest
 */
export interface ChatsApiApiV1ChatsChatIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdGet
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsChatIdPut operation in ChatsApi.
 * @export
 * @interface ChatsApiApiV1ChatsChatIdPutRequest
 */
export interface ChatsApiApiV1ChatsChatIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdPut
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateChatDto}
     * @memberof ChatsApiApiV1ChatsChatIdPut
     */
    readonly updateChatDto?: UpdateChatDto
}

/**
 * Request parameters for apiV1ChatsChatIdReopenPost operation in ChatsApi.
 * @export
 * @interface ChatsApiApiV1ChatsChatIdReopenPostRequest
 */
export interface ChatsApiApiV1ChatsChatIdReopenPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdReopenPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdReopenPost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdReopenPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsChatIdResolvePost operation in ChatsApi.
 * @export
 * @interface ChatsApiApiV1ChatsChatIdResolvePostRequest
 */
export interface ChatsApiApiV1ChatsChatIdResolvePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdResolvePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdResolvePost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdResolvePost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsChatIdTipsGet operation in ChatsApi.
 * @export
 * @interface ChatsApiApiV1ChatsChatIdTipsGetRequest
 */
export interface ChatsApiApiV1ChatsChatIdTipsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdTipsGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdTipsGet
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatsApiApiV1ChatsChatIdTipsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ChatsCommentEntityGetOrCreatePost operation in ChatsApi.
 * @export
 * @interface ChatsApiApiV1ChatsCommentEntityGetOrCreatePostRequest
 */
export interface ChatsApiApiV1ChatsCommentEntityGetOrCreatePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatsApiApiV1ChatsCommentEntityGetOrCreatePost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatsApiApiV1ChatsCommentEntityGetOrCreatePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GetOrCreateCommentChatDto}
     * @memberof ChatsApiApiV1ChatsCommentEntityGetOrCreatePost
     */
    readonly getOrCreateCommentChatDto?: GetOrCreateCommentChatDto
}

/**
 * Request parameters for apiV1ChatsCommentGetOrCreatePost operation in ChatsApi.
 * @export
 * @interface ChatsApiApiV1ChatsCommentGetOrCreatePostRequest
 */
export interface ChatsApiApiV1ChatsCommentGetOrCreatePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatsApiApiV1ChatsCommentGetOrCreatePost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatsApiApiV1ChatsCommentGetOrCreatePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GetOrCreateCommentChatDto}
     * @memberof ChatsApiApiV1ChatsCommentGetOrCreatePost
     */
    readonly getOrCreateCommentChatDto?: GetOrCreateCommentChatDto
}

/**
 * Request parameters for apiV1ChatsGetPost operation in ChatsApi.
 * @export
 * @interface ChatsApiApiV1ChatsGetPostRequest
 */
export interface ChatsApiApiV1ChatsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatsApiApiV1ChatsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatsApiApiV1ChatsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ChatGetPaginatedDto}
     * @memberof ChatsApiApiV1ChatsGetPost
     */
    readonly chatGetPaginatedDto?: ChatGetPaginatedDto
}

/**
 * Request parameters for apiV1ChatsGroupPost operation in ChatsApi.
 * @export
 * @interface ChatsApiApiV1ChatsGroupPostRequest
 */
export interface ChatsApiApiV1ChatsGroupPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatsApiApiV1ChatsGroupPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatsApiApiV1ChatsGroupPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateGroupChatDto}
     * @memberof ChatsApiApiV1ChatsGroupPost
     */
    readonly createGroupChatDto?: CreateGroupChatDto
}

/**
 * Request parameters for apiV1ChatsNegotiationGetOrCreatePost operation in ChatsApi.
 * @export
 * @interface ChatsApiApiV1ChatsNegotiationGetOrCreatePostRequest
 */
export interface ChatsApiApiV1ChatsNegotiationGetOrCreatePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatsApiApiV1ChatsNegotiationGetOrCreatePost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatsApiApiV1ChatsNegotiationGetOrCreatePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ChatGetOrCreateNegotiationDto}
     * @memberof ChatsApiApiV1ChatsNegotiationGetOrCreatePost
     */
    readonly chatGetOrCreateNegotiationDto?: ChatGetOrCreateNegotiationDto
}

/**
 * Request parameters for apiV1ChatsPersonalPost operation in ChatsApi.
 * @export
 * @interface ChatsApiApiV1ChatsPersonalPostRequest
 */
export interface ChatsApiApiV1ChatsPersonalPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ChatsApiApiV1ChatsPersonalPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ChatsApiApiV1ChatsPersonalPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreatePersonalChatDto}
     * @memberof ChatsApiApiV1ChatsPersonalPost
     */
    readonly createPersonalChatDto?: CreatePersonalChatDto
}

/**
 * ChatsApi - object-oriented interface
 * @export
 * @class ChatsApi
 * @extends {BaseAPI}
 */
export class ChatsApi extends BaseAPI {
    /**
     * 
     * @param {ChatsApiApiV1ChatsByScopeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public apiV1ChatsByScopeGet(requestParameters: ChatsApiApiV1ChatsByScopeGetRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).apiV1ChatsByScopeGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.identifier, requestParameters.subIdentifier, requestParameters.type, requestParameters.isResolved, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatsApiApiV1ChatsChatIdAcknowledgePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public apiV1ChatsChatIdAcknowledgePost(requestParameters: ChatsApiApiV1ChatsChatIdAcknowledgePostRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).apiV1ChatsChatIdAcknowledgePost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatsApiApiV1ChatsChatIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public apiV1ChatsChatIdDelete(requestParameters: ChatsApiApiV1ChatsChatIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).apiV1ChatsChatIdDelete(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatsApiApiV1ChatsChatIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public apiV1ChatsChatIdGet(requestParameters: ChatsApiApiV1ChatsChatIdGetRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).apiV1ChatsChatIdGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatsApiApiV1ChatsChatIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public apiV1ChatsChatIdPut(requestParameters: ChatsApiApiV1ChatsChatIdPutRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).apiV1ChatsChatIdPut(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.updateChatDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatsApiApiV1ChatsChatIdReopenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public apiV1ChatsChatIdReopenPost(requestParameters: ChatsApiApiV1ChatsChatIdReopenPostRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).apiV1ChatsChatIdReopenPost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatsApiApiV1ChatsChatIdResolvePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public apiV1ChatsChatIdResolvePost(requestParameters: ChatsApiApiV1ChatsChatIdResolvePostRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).apiV1ChatsChatIdResolvePost(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatsApiApiV1ChatsChatIdTipsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public apiV1ChatsChatIdTipsGet(requestParameters: ChatsApiApiV1ChatsChatIdTipsGetRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).apiV1ChatsChatIdTipsGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatsApiApiV1ChatsCommentEntityGetOrCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public apiV1ChatsCommentEntityGetOrCreatePost(requestParameters: ChatsApiApiV1ChatsCommentEntityGetOrCreatePostRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).apiV1ChatsCommentEntityGetOrCreatePost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.getOrCreateCommentChatDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatsApiApiV1ChatsCommentGetOrCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public apiV1ChatsCommentGetOrCreatePost(requestParameters: ChatsApiApiV1ChatsCommentGetOrCreatePostRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).apiV1ChatsCommentGetOrCreatePost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.getOrCreateCommentChatDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatsApiApiV1ChatsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public apiV1ChatsGetPost(requestParameters: ChatsApiApiV1ChatsGetPostRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).apiV1ChatsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.chatGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatsApiApiV1ChatsGroupPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public apiV1ChatsGroupPost(requestParameters: ChatsApiApiV1ChatsGroupPostRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).apiV1ChatsGroupPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createGroupChatDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatsApiApiV1ChatsNegotiationGetOrCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public apiV1ChatsNegotiationGetOrCreatePost(requestParameters: ChatsApiApiV1ChatsNegotiationGetOrCreatePostRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).apiV1ChatsNegotiationGetOrCreatePost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.chatGetOrCreateNegotiationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChatsApiApiV1ChatsPersonalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public apiV1ChatsPersonalPost(requestParameters: ChatsApiApiV1ChatsPersonalPostRequest, options?: RawAxiosRequestConfig) {
        return ChatsApiFp(this.configuration).apiV1ChatsPersonalPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createPersonalChatDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommunicationApi - axios parameter creator
 * @export
 */
export const CommunicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunicationCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CommunicationCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/communication/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommunicationApi - functional programming interface
 * @export
 */
export const CommunicationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommunicationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CommunicationCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunicationCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CommunicationCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunicationApi.apiV1CommunicationCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommunicationApi - factory interface
 * @export
 */
export const CommunicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommunicationApiFp(configuration)
    return {
        /**
         * 
         * @param {CommunicationApiApiV1CommunicationCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CommunicationCountersGet(requestParameters: CommunicationApiApiV1CommunicationCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunicationCountersDto> {
            return localVarFp.apiV1CommunicationCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1CommunicationCountersGet operation in CommunicationApi.
 * @export
 * @interface CommunicationApiApiV1CommunicationCountersGetRequest
 */
export interface CommunicationApiApiV1CommunicationCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CommunicationApiApiV1CommunicationCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CommunicationApiApiV1CommunicationCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * CommunicationApi - object-oriented interface
 * @export
 * @class CommunicationApi
 * @extends {BaseAPI}
 */
export class CommunicationApi extends BaseAPI {
    /**
     * 
     * @param {CommunicationApiApiV1CommunicationCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApi
     */
    public apiV1CommunicationCountersGet(requestParameters: CommunicationApiApiV1CommunicationCountersGetRequest, options?: RawAxiosRequestConfig) {
        return CommunicationApiFp(this.configuration).apiV1CommunicationCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContractsApi - axios parameter creator
 * @export
 */
export const ContractsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractBulkDeleteDto} [contractBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, contractBulkDeleteDto?: ContractBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/contracts/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateContractCustomerCommunicationEntryDto} [createContractCustomerCommunicationEntryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdCustomerCommunicationEntriesPost: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, createContractCustomerCommunicationEntryDto?: CreateContractCustomerCommunicationEntryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdCustomerCommunicationEntriesPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdCustomerCommunicationEntriesPost', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/customer-communication/entries`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContractCustomerCommunicationEntryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {GeneralDeleteEntityDto} [generalDeleteEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdDelete: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, generalDeleteEntityDto?: GeneralDeleteEntityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdDelete', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalDeleteEntityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdExternalNumberPut: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdExternalNumberPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdExternalNumberPut', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/external-number`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalExternalNumberInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accepts document images in any upload supported image format.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {File} [file] 
         * @param {string} [resultOptionsFileUrlLifetime] Check out how C# TimeSpan is serialized to string for more info.
         * @param {string} [resultOptionsFileUrlExpiresAt] Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, file?: File, resultOptionsFileUrlLifetime?: string, resultOptionsFileUrlExpiresAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/files/customer/personal-documents/image/upload`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (resultOptionsFileUrlLifetime !== undefined) { 
                localVarFormParams.append('resultOptions.fileUrlLifetime', resultOptionsFileUrlLifetime as any);
            }
    
            if (resultOptionsFileUrlExpiresAt !== undefined) { 
                localVarFormParams.append('resultOptions.fileUrlExpiresAt', resultOptionsFileUrlExpiresAt as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Requires signature image in SVG format.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {File} [file] 
         * @param {string} [resultOptionsFileUrlLifetime] Check out how C# TimeSpan is serialized to string for more info.
         * @param {string} [resultOptionsFileUrlExpiresAt] Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, file?: File, resultOptionsFileUrlLifetime?: string, resultOptionsFileUrlExpiresAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/files/customer/signatures/image/upload`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (resultOptionsFileUrlLifetime !== undefined) { 
                localVarFormParams.append('resultOptions.fileUrlLifetime', resultOptionsFileUrlLifetime as any);
            }
    
            if (resultOptionsFileUrlExpiresAt !== undefined) { 
                localVarFormParams.append('resultOptions.fileUrlExpiresAt', resultOptionsFileUrlExpiresAt as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdGet: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdGet', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractOneflowContractCreateDto} [contractOneflowContractCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdIntegrationsOneflowContractCreatePost: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractOneflowContractCreateDto?: ContractOneflowContractCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdIntegrationsOneflowContractCreatePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdIntegrationsOneflowContractCreatePost', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/integrations/oneflow/contract/create`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractOneflowContractCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdNotesPut: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdNotesPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdNotesPut', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/notes`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalNotesInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractUpdateDto} [contractUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdPut: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractUpdateDto?: ContractUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdPut', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdReferenceGet: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdReferenceGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdReferenceGet', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/reference`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} reminderId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdRemindersReminderIdEnabledTogglePut: async (nexusOpsTenant: string, contractId: string, reminderId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdRemindersReminderIdEnabledTogglePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdRemindersReminderIdEnabledTogglePut', 'contractId', contractId)
            // verify required parameter 'reminderId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdRemindersReminderIdEnabledTogglePut', 'reminderId', reminderId)
            const localVarPath = `/api/v1/contracts/{contractId}/reminders/{reminderId}/enabled/toggle`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)))
                .replace(`{${"reminderId"}}`, encodeURIComponent(String(reminderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} reminderId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractReminderUpdateDto} [contractReminderUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdRemindersReminderIdPut: async (nexusOpsTenant: string, contractId: string, reminderId: string, nexusOpsAppVersion?: string, contractReminderUpdateDto?: ContractReminderUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdRemindersReminderIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdRemindersReminderIdPut', 'contractId', contractId)
            // verify required parameter 'reminderId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdRemindersReminderIdPut', 'reminderId', reminderId)
            const localVarPath = `/api/v1/contracts/{contractId}/reminders/{reminderId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)))
                .replace(`{${"reminderId"}}`, encodeURIComponent(String(reminderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractReminderUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractStageUpdateDto} [contractStageUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdStagePut: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractStageUpdateDto?: ContractStageUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdStagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdStagePut', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/stage`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractStageUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleAllocationConfirmPost: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleAllocationConfirmPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleAllocationConfirmPost', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/vehicle/allocation/confirm`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractReallocateVehicleDto} [contractReallocateVehicleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleAllocationReallocatePost: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractReallocateVehicleDto?: ContractReallocateVehicleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleAllocationReallocatePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleAllocationReallocatePost', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/vehicle/allocation/reallocate`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractReallocateVehicleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractVehicleCheckInDto} [contractVehicleCheckInDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckInPost: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractVehicleCheckInDto?: ContractVehicleCheckInDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckInPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckInPost', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/vehicle/check-in`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractVehicleCheckInDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractSpotInfoInputDto} [contractSpotInfoInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckInSpotInfoPut: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractSpotInfoInputDto?: ContractSpotInfoInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckInSpotInfoPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckInSpotInfoPut', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/vehicle/check-in/spot-info`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractSpotInfoInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractSpotInfoVisualInspectionInputDto} [contractSpotInfoVisualInspectionInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractSpotInfoVisualInspectionInputDto?: ContractSpotInfoVisualInspectionInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/vehicle/check-in/spot-info/visual-inspection`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractSpotInfoVisualInspectionInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PersonalDataDeleteDto} [personalDataDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, personalDataDeleteDto?: PersonalDataDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/vehicle/check-out/acknowledgements/vehicle-state/customer-personal-data`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(personalDataDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomerAcknowledgementInputDto} [customerAcknowledgementInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, customerAcknowledgementInputDto?: CustomerAcknowledgementInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/vehicle/check-out/acknowledgements/vehicle-state`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerAcknowledgementInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractVehicleCheckOutDto} [contractVehicleCheckOutDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckOutPost: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractVehicleCheckOutDto?: ContractVehicleCheckOutDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckOutPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckOutPost', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/vehicle/check-out`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractVehicleCheckOutDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractSpotInfoInputDto} [contractSpotInfoInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckOutSpotInfoPut: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractSpotInfoInputDto?: ContractSpotInfoInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckOutSpotInfoPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckOutSpotInfoPut', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/vehicle/check-out/spot-info`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractSpotInfoInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractSpotInfoVisualInspectionInputDto} [contractSpotInfoVisualInspectionInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractSpotInfoVisualInspectionInputDto?: ContractSpotInfoVisualInspectionInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut', 'contractId', contractId)
            const localVarPath = `/api/v1/contracts/{contractId}/vehicle/check-out/spot-info/visual-inspection`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractSpotInfoVisualInspectionInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractGetCountersDto} [contractGetCountersDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsCountersGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, contractGetCountersDto?: ContractGetCountersDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsCountersGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/contracts/counters/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractGetCountersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsCreateMetaGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsCreateMetaGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/contracts/create/meta`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractGetPaginatedDto} [contractGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, contractGetPaginatedDto?: ContractGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/contracts/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates new contract in Draft stage.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractCreateDto} [contractCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, contractCreateDto?: ContractCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated: Use /get.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractSearchPaginatedDto} [contractSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1ContractsSearchPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, contractSearchPaginatedDto?: ContractSearchPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ContractsSearchPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/contracts/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractSearchPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractsApi - functional programming interface
 * @export
 */
export const ContractsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractBulkDeleteDto} [contractBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, contractBulkDeleteDto?: ContractBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, contractBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateContractCustomerCommunicationEntryDto} [createContractCustomerCommunicationEntryDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdCustomerCommunicationEntriesPost(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, createContractCustomerCommunicationEntryDto?: CreateContractCustomerCommunicationEntryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdCustomerCommunicationEntriesPost(nexusOpsTenant, contractId, nexusOpsAppVersion, createContractCustomerCommunicationEntryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdCustomerCommunicationEntriesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {GeneralDeleteEntityDto} [generalDeleteEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdDelete(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, generalDeleteEntityDto?: GeneralDeleteEntityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdDelete(nexusOpsTenant, contractId, nexusOpsAppVersion, isDeleteCascade, generalDeleteEntityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdExternalNumberPut(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdExternalNumberPut(nexusOpsTenant, contractId, nexusOpsAppVersion, generalExternalNumberInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdExternalNumberPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Accepts document images in any upload supported image format.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {File} [file] 
         * @param {string} [resultOptionsFileUrlLifetime] Check out how C# TimeSpan is serialized to string for more info.
         * @param {string} [resultOptionsFileUrlExpiresAt] Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, file?: File, resultOptionsFileUrlLifetime?: string, resultOptionsFileUrlExpiresAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost(nexusOpsTenant, contractId, nexusOpsAppVersion, file, resultOptionsFileUrlLifetime, resultOptionsFileUrlExpiresAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Requires signature image in SVG format.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {File} [file] 
         * @param {string} [resultOptionsFileUrlLifetime] Check out how C# TimeSpan is serialized to string for more info.
         * @param {string} [resultOptionsFileUrlExpiresAt] Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, file?: File, resultOptionsFileUrlLifetime?: string, resultOptionsFileUrlExpiresAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost(nexusOpsTenant, contractId, nexusOpsAppVersion, file, resultOptionsFileUrlLifetime, resultOptionsFileUrlExpiresAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdGet(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdGet(nexusOpsTenant, contractId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractOneflowContractCreateDto} [contractOneflowContractCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdIntegrationsOneflowContractCreatePost(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractOneflowContractCreateDto?: ContractOneflowContractCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdIntegrationsOneflowContractCreatePost(nexusOpsTenant, contractId, nexusOpsAppVersion, contractOneflowContractCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdIntegrationsOneflowContractCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdNotesPut(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdNotesPut(nexusOpsTenant, contractId, nexusOpsAppVersion, generalNotesInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdNotesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractUpdateDto} [contractUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdPut(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractUpdateDto?: ContractUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdPut(nexusOpsTenant, contractId, nexusOpsAppVersion, contractUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdReferenceGet(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractReferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdReferenceGet(nexusOpsTenant, contractId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdReferenceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} reminderId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdRemindersReminderIdEnabledTogglePut(nexusOpsTenant: string, contractId: string, reminderId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractReminderUpdatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdRemindersReminderIdEnabledTogglePut(nexusOpsTenant, contractId, reminderId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdRemindersReminderIdEnabledTogglePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} reminderId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractReminderUpdateDto} [contractReminderUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdRemindersReminderIdPut(nexusOpsTenant: string, contractId: string, reminderId: string, nexusOpsAppVersion?: string, contractReminderUpdateDto?: ContractReminderUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractReminderUpdatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdRemindersReminderIdPut(nexusOpsTenant, contractId, reminderId, nexusOpsAppVersion, contractReminderUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdRemindersReminderIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractStageUpdateDto} [contractStageUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdStagePut(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractStageUpdateDto?: ContractStageUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdStagePut(nexusOpsTenant, contractId, nexusOpsAppVersion, contractStageUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdStagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdVehicleAllocationConfirmPost(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdVehicleAllocationConfirmPost(nexusOpsTenant, contractId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdVehicleAllocationConfirmPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractReallocateVehicleDto} [contractReallocateVehicleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdVehicleAllocationReallocatePost(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractReallocateVehicleDto?: ContractReallocateVehicleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdVehicleAllocationReallocatePost(nexusOpsTenant, contractId, nexusOpsAppVersion, contractReallocateVehicleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdVehicleAllocationReallocatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractVehicleCheckInDto} [contractVehicleCheckInDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdVehicleCheckInPost(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractVehicleCheckInDto?: ContractVehicleCheckInDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdVehicleCheckInPost(nexusOpsTenant, contractId, nexusOpsAppVersion, contractVehicleCheckInDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdVehicleCheckInPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractSpotInfoInputDto} [contractSpotInfoInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdVehicleCheckInSpotInfoPut(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractSpotInfoInputDto?: ContractSpotInfoInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdVehicleCheckInSpotInfoPut(nexusOpsTenant, contractId, nexusOpsAppVersion, contractSpotInfoInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdVehicleCheckInSpotInfoPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractSpotInfoVisualInspectionInputDto} [contractSpotInfoVisualInspectionInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractSpotInfoVisualInspectionInputDto?: ContractSpotInfoVisualInspectionInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut(nexusOpsTenant, contractId, nexusOpsAppVersion, contractSpotInfoVisualInspectionInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PersonalDataDeleteDto} [personalDataDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, personalDataDeleteDto?: PersonalDataDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete(nexusOpsTenant, contractId, nexusOpsAppVersion, personalDataDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomerAcknowledgementInputDto} [customerAcknowledgementInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, customerAcknowledgementInputDto?: CustomerAcknowledgementInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut(nexusOpsTenant, contractId, nexusOpsAppVersion, customerAcknowledgementInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractVehicleCheckOutDto} [contractVehicleCheckOutDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdVehicleCheckOutPost(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractVehicleCheckOutDto?: ContractVehicleCheckOutDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdVehicleCheckOutPost(nexusOpsTenant, contractId, nexusOpsAppVersion, contractVehicleCheckOutDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdVehicleCheckOutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractSpotInfoInputDto} [contractSpotInfoInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdVehicleCheckOutSpotInfoPut(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractSpotInfoInputDto?: ContractSpotInfoInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdVehicleCheckOutSpotInfoPut(nexusOpsTenant, contractId, nexusOpsAppVersion, contractSpotInfoInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdVehicleCheckOutSpotInfoPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractSpotInfoVisualInspectionInputDto} [contractSpotInfoVisualInspectionInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, contractSpotInfoVisualInspectionInputDto?: ContractSpotInfoVisualInspectionInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut(nexusOpsTenant, contractId, nexusOpsAppVersion, contractSpotInfoVisualInspectionInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractGetCountersDto} [contractGetCountersDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsCountersGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, contractGetCountersDto?: ContractGetCountersDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsCountersGetPost(nexusOpsTenant, nexusOpsAppVersion, contractGetCountersDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsCountersGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsCreateMetaGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractGetCreateMetaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsCreateMetaGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsCreateMetaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractGetPaginatedDto} [contractGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, contractGetPaginatedDto?: ContractGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsGetPost(nexusOpsTenant, nexusOpsAppVersion, contractGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates new contract in Draft stage.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractCreateDto} [contractCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContractsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, contractCreateDto?: ContractCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsPost(nexusOpsTenant, nexusOpsAppVersion, contractCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deprecated: Use /get.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ContractSearchPaginatedDto} [contractSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async apiV1ContractsSearchPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, contractSearchPaginatedDto?: ContractSearchPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContractsSearchPost(nexusOpsTenant, nexusOpsAppVersion, contractSearchPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractsApi.apiV1ContractsSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContractsApi - factory interface
 * @export
 */
export const ContractsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractsApiFp(configuration)
    return {
        /**
         * 
         * @param {ContractsApiApiV1ContractsBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsBulkDeleteDelete(requestParameters: ContractsApiApiV1ContractsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1ContractsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.contractBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdCustomerCommunicationEntriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdCustomerCommunicationEntriesPost(requestParameters: ContractsApiApiV1ContractsContractIdCustomerCommunicationEntriesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdCustomerCommunicationEntriesPost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.createContractCustomerCommunicationEntryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdDelete(requestParameters: ContractsApiApiV1ContractsContractIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1ContractsContractIdDelete(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, requestParameters.generalDeleteEntityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdExternalNumberPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdExternalNumberPut(requestParameters: ContractsApiApiV1ContractsContractIdExternalNumberPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accepts document images in any upload supported image format.
         * @param {ContractsApiApiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost(requestParameters: ContractsApiApiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FileUploadResultDto> {
            return localVarFp.apiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.file, requestParameters.resultOptionsFileUrlLifetime, requestParameters.resultOptionsFileUrlExpiresAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Requires signature image in SVG format.
         * @param {ContractsApiApiV1ContractsContractIdFilesCustomerSignaturesImageUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost(requestParameters: ContractsApiApiV1ContractsContractIdFilesCustomerSignaturesImageUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FileUploadResultDto> {
            return localVarFp.apiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.file, requestParameters.resultOptionsFileUrlLifetime, requestParameters.resultOptionsFileUrlExpiresAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdGet(requestParameters: ContractsApiApiV1ContractsContractIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdGet(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdIntegrationsOneflowContractCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdIntegrationsOneflowContractCreatePost(requestParameters: ContractsApiApiV1ContractsContractIdIntegrationsOneflowContractCreatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdIntegrationsOneflowContractCreatePost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractOneflowContractCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdNotesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdNotesPut(requestParameters: ContractsApiApiV1ContractsContractIdNotesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdPut(requestParameters: ContractsApiApiV1ContractsContractIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdReferenceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdReferenceGet(requestParameters: ContractsApiApiV1ContractsContractIdReferenceGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractReferenceDto> {
            return localVarFp.apiV1ContractsContractIdReferenceGet(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdRemindersReminderIdEnabledTogglePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdRemindersReminderIdEnabledTogglePut(requestParameters: ContractsApiApiV1ContractsContractIdRemindersReminderIdEnabledTogglePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractReminderUpdatedDto> {
            return localVarFp.apiV1ContractsContractIdRemindersReminderIdEnabledTogglePut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.reminderId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdRemindersReminderIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdRemindersReminderIdPut(requestParameters: ContractsApiApiV1ContractsContractIdRemindersReminderIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractReminderUpdatedDto> {
            return localVarFp.apiV1ContractsContractIdRemindersReminderIdPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.reminderId, requestParameters.nexusOpsAppVersion, requestParameters.contractReminderUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdStagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdStagePut(requestParameters: ContractsApiApiV1ContractsContractIdStagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdStagePut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractStageUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdVehicleAllocationConfirmPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleAllocationConfirmPost(requestParameters: ContractsApiApiV1ContractsContractIdVehicleAllocationConfirmPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdVehicleAllocationConfirmPost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdVehicleAllocationReallocatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleAllocationReallocatePost(requestParameters: ContractsApiApiV1ContractsContractIdVehicleAllocationReallocatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdVehicleAllocationReallocatePost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractReallocateVehicleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdVehicleCheckInPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckInPost(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckInPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdVehicleCheckInPost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractVehicleCheckInDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckInSpotInfoPut(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdVehicleCheckInSpotInfoPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractSpotInfoInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractSpotInfoVisualInspectionInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.personalDataDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.customerAcknowledgementInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdVehicleCheckOutPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckOutPost(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckOutPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdVehicleCheckOutPost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractVehicleCheckOutDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckOutSpotInfoPut(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdVehicleCheckOutSpotInfoPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractSpotInfoInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractSpotInfoVisualInspectionInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsCountersGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsCountersGetPost(requestParameters: ContractsApiApiV1ContractsCountersGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractCountersDto> {
            return localVarFp.apiV1ContractsCountersGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.contractGetCountersDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsCreateMetaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsCreateMetaGet(requestParameters: ContractsApiApiV1ContractsCreateMetaGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractGetCreateMetaDto> {
            return localVarFp.apiV1ContractsCreateMetaGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractsApiApiV1ContractsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsGetPost(requestParameters: ContractsApiApiV1ContractsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfContractDto> {
            return localVarFp.apiV1ContractsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.contractGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates new contract in Draft stage.
         * @param {ContractsApiApiV1ContractsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContractsPost(requestParameters: ContractsApiApiV1ContractsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.apiV1ContractsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.contractCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated: Use /get.
         * @param {ContractsApiApiV1ContractsSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1ContractsSearchPost(requestParameters: ContractsApiApiV1ContractsSearchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfContractDto> {
            return localVarFp.apiV1ContractsSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.contractSearchPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ContractsBulkDeleteDelete operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsBulkDeleteDeleteRequest
 */
export interface ContractsApiApiV1ContractsBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractBulkDeleteDto}
     * @memberof ContractsApiApiV1ContractsBulkDeleteDelete
     */
    readonly contractBulkDeleteDto?: ContractBulkDeleteDto
}

/**
 * Request parameters for apiV1ContractsContractIdCustomerCommunicationEntriesPost operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdCustomerCommunicationEntriesPostRequest
 */
export interface ContractsApiApiV1ContractsContractIdCustomerCommunicationEntriesPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdCustomerCommunicationEntriesPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdCustomerCommunicationEntriesPost
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdCustomerCommunicationEntriesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateContractCustomerCommunicationEntryDto}
     * @memberof ContractsApiApiV1ContractsContractIdCustomerCommunicationEntriesPost
     */
    readonly createContractCustomerCommunicationEntryDto?: CreateContractCustomerCommunicationEntryDto
}

/**
 * Request parameters for apiV1ContractsContractIdDelete operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdDeleteRequest
 */
export interface ContractsApiApiV1ContractsContractIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdDelete
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof ContractsApiApiV1ContractsContractIdDelete
     */
    readonly isDeleteCascade?: boolean

    /**
     * 
     * @type {GeneralDeleteEntityDto}
     * @memberof ContractsApiApiV1ContractsContractIdDelete
     */
    readonly generalDeleteEntityDto?: GeneralDeleteEntityDto
}

/**
 * Request parameters for apiV1ContractsContractIdExternalNumberPut operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdExternalNumberPutRequest
 */
export interface ContractsApiApiV1ContractsContractIdExternalNumberPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdExternalNumberPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdExternalNumberPut
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdExternalNumberPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralExternalNumberInputDto}
     * @memberof ContractsApiApiV1ContractsContractIdExternalNumberPut
     */
    readonly generalExternalNumberInputDto?: GeneralExternalNumberInputDto
}

/**
 * Request parameters for apiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPostRequest
 */
export interface ContractsApiApiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {File}
     * @memberof ContractsApiApiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost
     */
    readonly file?: File

    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost
     */
    readonly resultOptionsFileUrlLifetime?: string

    /**
     * Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost
     */
    readonly resultOptionsFileUrlExpiresAt?: string
}

/**
 * Request parameters for apiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdFilesCustomerSignaturesImageUploadPostRequest
 */
export interface ContractsApiApiV1ContractsContractIdFilesCustomerSignaturesImageUploadPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {File}
     * @memberof ContractsApiApiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost
     */
    readonly file?: File

    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost
     */
    readonly resultOptionsFileUrlLifetime?: string

    /**
     * Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost
     */
    readonly resultOptionsFileUrlExpiresAt?: string
}

/**
 * Request parameters for apiV1ContractsContractIdGet operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdGetRequest
 */
export interface ContractsApiApiV1ContractsContractIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdGet
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ContractsContractIdIntegrationsOneflowContractCreatePost operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdIntegrationsOneflowContractCreatePostRequest
 */
export interface ContractsApiApiV1ContractsContractIdIntegrationsOneflowContractCreatePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdIntegrationsOneflowContractCreatePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdIntegrationsOneflowContractCreatePost
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdIntegrationsOneflowContractCreatePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractOneflowContractCreateDto}
     * @memberof ContractsApiApiV1ContractsContractIdIntegrationsOneflowContractCreatePost
     */
    readonly contractOneflowContractCreateDto?: ContractOneflowContractCreateDto
}

/**
 * Request parameters for apiV1ContractsContractIdNotesPut operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdNotesPutRequest
 */
export interface ContractsApiApiV1ContractsContractIdNotesPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdNotesPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdNotesPut
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdNotesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralNotesInputDto}
     * @memberof ContractsApiApiV1ContractsContractIdNotesPut
     */
    readonly generalNotesInputDto?: GeneralNotesInputDto
}

/**
 * Request parameters for apiV1ContractsContractIdPut operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdPutRequest
 */
export interface ContractsApiApiV1ContractsContractIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdPut
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractUpdateDto}
     * @memberof ContractsApiApiV1ContractsContractIdPut
     */
    readonly contractUpdateDto?: ContractUpdateDto
}

/**
 * Request parameters for apiV1ContractsContractIdReferenceGet operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdReferenceGetRequest
 */
export interface ContractsApiApiV1ContractsContractIdReferenceGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdReferenceGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdReferenceGet
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdReferenceGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ContractsContractIdRemindersReminderIdEnabledTogglePut operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdRemindersReminderIdEnabledTogglePutRequest
 */
export interface ContractsApiApiV1ContractsContractIdRemindersReminderIdEnabledTogglePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdRemindersReminderIdEnabledTogglePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdRemindersReminderIdEnabledTogglePut
     */
    readonly contractId: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdRemindersReminderIdEnabledTogglePut
     */
    readonly reminderId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdRemindersReminderIdEnabledTogglePut
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ContractsContractIdRemindersReminderIdPut operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdRemindersReminderIdPutRequest
 */
export interface ContractsApiApiV1ContractsContractIdRemindersReminderIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdRemindersReminderIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdRemindersReminderIdPut
     */
    readonly contractId: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdRemindersReminderIdPut
     */
    readonly reminderId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdRemindersReminderIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractReminderUpdateDto}
     * @memberof ContractsApiApiV1ContractsContractIdRemindersReminderIdPut
     */
    readonly contractReminderUpdateDto?: ContractReminderUpdateDto
}

/**
 * Request parameters for apiV1ContractsContractIdStagePut operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdStagePutRequest
 */
export interface ContractsApiApiV1ContractsContractIdStagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdStagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdStagePut
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdStagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractStageUpdateDto}
     * @memberof ContractsApiApiV1ContractsContractIdStagePut
     */
    readonly contractStageUpdateDto?: ContractStageUpdateDto
}

/**
 * Request parameters for apiV1ContractsContractIdVehicleAllocationConfirmPost operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdVehicleAllocationConfirmPostRequest
 */
export interface ContractsApiApiV1ContractsContractIdVehicleAllocationConfirmPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleAllocationConfirmPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleAllocationConfirmPost
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleAllocationConfirmPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ContractsContractIdVehicleAllocationReallocatePost operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdVehicleAllocationReallocatePostRequest
 */
export interface ContractsApiApiV1ContractsContractIdVehicleAllocationReallocatePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleAllocationReallocatePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleAllocationReallocatePost
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleAllocationReallocatePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractReallocateVehicleDto}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleAllocationReallocatePost
     */
    readonly contractReallocateVehicleDto?: ContractReallocateVehicleDto
}

/**
 * Request parameters for apiV1ContractsContractIdVehicleCheckInPost operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdVehicleCheckInPostRequest
 */
export interface ContractsApiApiV1ContractsContractIdVehicleCheckInPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckInPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckInPost
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckInPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractVehicleCheckInDto}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckInPost
     */
    readonly contractVehicleCheckInDto?: ContractVehicleCheckInDto
}

/**
 * Request parameters for apiV1ContractsContractIdVehicleCheckInSpotInfoPut operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoPutRequest
 */
export interface ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoPut
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractSpotInfoInputDto}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoPut
     */
    readonly contractSpotInfoInputDto?: ContractSpotInfoInputDto
}

/**
 * Request parameters for apiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPutRequest
 */
export interface ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractSpotInfoVisualInspectionInputDto}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut
     */
    readonly contractSpotInfoVisualInspectionInputDto?: ContractSpotInfoVisualInspectionInputDto
}

/**
 * Request parameters for apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDeleteRequest
 */
export interface ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {PersonalDataDeleteDto}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete
     */
    readonly personalDataDeleteDto?: PersonalDataDeleteDto
}

/**
 * Request parameters for apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePutRequest
 */
export interface ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CustomerAcknowledgementInputDto}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut
     */
    readonly customerAcknowledgementInputDto?: CustomerAcknowledgementInputDto
}

/**
 * Request parameters for apiV1ContractsContractIdVehicleCheckOutPost operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdVehicleCheckOutPostRequest
 */
export interface ContractsApiApiV1ContractsContractIdVehicleCheckOutPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutPost
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractVehicleCheckOutDto}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutPost
     */
    readonly contractVehicleCheckOutDto?: ContractVehicleCheckOutDto
}

/**
 * Request parameters for apiV1ContractsContractIdVehicleCheckOutSpotInfoPut operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoPutRequest
 */
export interface ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoPut
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractSpotInfoInputDto}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoPut
     */
    readonly contractSpotInfoInputDto?: ContractSpotInfoInputDto
}

/**
 * Request parameters for apiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPutRequest
 */
export interface ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractSpotInfoVisualInspectionInputDto}
     * @memberof ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut
     */
    readonly contractSpotInfoVisualInspectionInputDto?: ContractSpotInfoVisualInspectionInputDto
}

/**
 * Request parameters for apiV1ContractsCountersGetPost operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsCountersGetPostRequest
 */
export interface ContractsApiApiV1ContractsCountersGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsCountersGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsCountersGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractGetCountersDto}
     * @memberof ContractsApiApiV1ContractsCountersGetPost
     */
    readonly contractGetCountersDto?: ContractGetCountersDto
}

/**
 * Request parameters for apiV1ContractsCreateMetaGet operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsCreateMetaGetRequest
 */
export interface ContractsApiApiV1ContractsCreateMetaGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsCreateMetaGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsCreateMetaGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ContractsGetPost operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsGetPostRequest
 */
export interface ContractsApiApiV1ContractsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractGetPaginatedDto}
     * @memberof ContractsApiApiV1ContractsGetPost
     */
    readonly contractGetPaginatedDto?: ContractGetPaginatedDto
}

/**
 * Request parameters for apiV1ContractsPost operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsPostRequest
 */
export interface ContractsApiApiV1ContractsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractCreateDto}
     * @memberof ContractsApiApiV1ContractsPost
     */
    readonly contractCreateDto?: ContractCreateDto
}

/**
 * Request parameters for apiV1ContractsSearchPost operation in ContractsApi.
 * @export
 * @interface ContractsApiApiV1ContractsSearchPostRequest
 */
export interface ContractsApiApiV1ContractsSearchPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ContractsApiApiV1ContractsSearchPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ContractsApiApiV1ContractsSearchPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ContractSearchPaginatedDto}
     * @memberof ContractsApiApiV1ContractsSearchPost
     */
    readonly contractSearchPaginatedDto?: ContractSearchPaginatedDto
}

/**
 * ContractsApi - object-oriented interface
 * @export
 * @class ContractsApi
 * @extends {BaseAPI}
 */
export class ContractsApi extends BaseAPI {
    /**
     * 
     * @param {ContractsApiApiV1ContractsBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsBulkDeleteDelete(requestParameters: ContractsApiApiV1ContractsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.contractBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdCustomerCommunicationEntriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdCustomerCommunicationEntriesPost(requestParameters: ContractsApiApiV1ContractsContractIdCustomerCommunicationEntriesPostRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdCustomerCommunicationEntriesPost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.createContractCustomerCommunicationEntryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdDelete(requestParameters: ContractsApiApiV1ContractsContractIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdDelete(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, requestParameters.generalDeleteEntityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdExternalNumberPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdExternalNumberPut(requestParameters: ContractsApiApiV1ContractsContractIdExternalNumberPutRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accepts document images in any upload supported image format.
     * @param {ContractsApiApiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost(requestParameters: ContractsApiApiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPostRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdFilesCustomerPersonalDocumentsImageUploadPost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.file, requestParameters.resultOptionsFileUrlLifetime, requestParameters.resultOptionsFileUrlExpiresAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Requires signature image in SVG format.
     * @param {ContractsApiApiV1ContractsContractIdFilesCustomerSignaturesImageUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost(requestParameters: ContractsApiApiV1ContractsContractIdFilesCustomerSignaturesImageUploadPostRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdFilesCustomerSignaturesImageUploadPost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.file, requestParameters.resultOptionsFileUrlLifetime, requestParameters.resultOptionsFileUrlExpiresAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdGet(requestParameters: ContractsApiApiV1ContractsContractIdGetRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdGet(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdIntegrationsOneflowContractCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdIntegrationsOneflowContractCreatePost(requestParameters: ContractsApiApiV1ContractsContractIdIntegrationsOneflowContractCreatePostRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdIntegrationsOneflowContractCreatePost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractOneflowContractCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdNotesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdNotesPut(requestParameters: ContractsApiApiV1ContractsContractIdNotesPutRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdPut(requestParameters: ContractsApiApiV1ContractsContractIdPutRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdReferenceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdReferenceGet(requestParameters: ContractsApiApiV1ContractsContractIdReferenceGetRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdReferenceGet(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdRemindersReminderIdEnabledTogglePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdRemindersReminderIdEnabledTogglePut(requestParameters: ContractsApiApiV1ContractsContractIdRemindersReminderIdEnabledTogglePutRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdRemindersReminderIdEnabledTogglePut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.reminderId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdRemindersReminderIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdRemindersReminderIdPut(requestParameters: ContractsApiApiV1ContractsContractIdRemindersReminderIdPutRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdRemindersReminderIdPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.reminderId, requestParameters.nexusOpsAppVersion, requestParameters.contractReminderUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdStagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdStagePut(requestParameters: ContractsApiApiV1ContractsContractIdStagePutRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdStagePut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractStageUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdVehicleAllocationConfirmPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdVehicleAllocationConfirmPost(requestParameters: ContractsApiApiV1ContractsContractIdVehicleAllocationConfirmPostRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdVehicleAllocationConfirmPost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdVehicleAllocationReallocatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdVehicleAllocationReallocatePost(requestParameters: ContractsApiApiV1ContractsContractIdVehicleAllocationReallocatePostRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdVehicleAllocationReallocatePost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractReallocateVehicleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdVehicleCheckInPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdVehicleCheckInPost(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckInPostRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdVehicleCheckInPost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractVehicleCheckInDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdVehicleCheckInSpotInfoPut(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoPutRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdVehicleCheckInSpotInfoPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractSpotInfoInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPutRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdVehicleCheckInSpotInfoVisualInspectionPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractSpotInfoVisualInspectionInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDeleteRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStateCustomerPersonalDataDelete(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.personalDataDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePutRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdVehicleCheckOutAcknowledgementsVehicleStatePut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.customerAcknowledgementInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdVehicleCheckOutPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdVehicleCheckOutPost(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckOutPostRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdVehicleCheckOutPost(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractVehicleCheckOutDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdVehicleCheckOutSpotInfoPut(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoPutRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdVehicleCheckOutSpotInfoPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractSpotInfoInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut(requestParameters: ContractsApiApiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPutRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsContractIdVehicleCheckOutSpotInfoVisualInspectionPut(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, requestParameters.contractSpotInfoVisualInspectionInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsCountersGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsCountersGetPost(requestParameters: ContractsApiApiV1ContractsCountersGetPostRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsCountersGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.contractGetCountersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsCreateMetaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsCreateMetaGet(requestParameters: ContractsApiApiV1ContractsCreateMetaGetRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsCreateMetaGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractsApiApiV1ContractsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsGetPost(requestParameters: ContractsApiApiV1ContractsGetPostRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.contractGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates new contract in Draft stage.
     * @param {ContractsApiApiV1ContractsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsPost(requestParameters: ContractsApiApiV1ContractsPostRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.contractCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated: Use /get.
     * @param {ContractsApiApiV1ContractsSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public apiV1ContractsSearchPost(requestParameters: ContractsApiApiV1ContractsSearchPostRequest, options?: RawAxiosRequestConfig) {
        return ContractsApiFp(this.configuration).apiV1ContractsSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.contractSearchPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomSessionsApi - axios parameter creator
 * @export
 */
export const CustomSessionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} sessionIdentifier 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomSessionsByIdentifierSessionIdentifierGet: async (nexusOpsTenant: string, sessionIdentifier: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CustomSessionsByIdentifierSessionIdentifierGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'sessionIdentifier' is not null or undefined
            assertParamExists('apiV1CustomSessionsByIdentifierSessionIdentifierGet', 'sessionIdentifier', sessionIdentifier)
            const localVarPath = `/api/v1/custom-sessions/by-identifier/{sessionIdentifier}`
                .replace(`{${"sessionIdentifier"}}`, encodeURIComponent(String(sessionIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} sessionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomSessionsSessionIdGet: async (nexusOpsTenant: string, sessionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CustomSessionsSessionIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV1CustomSessionsSessionIdGet', 'sessionId', sessionId)
            const localVarPath = `/api/v1/custom-sessions/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomSessionsApi - functional programming interface
 * @export
 */
export const CustomSessionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomSessionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} sessionIdentifier 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CustomSessionsByIdentifierSessionIdentifierGet(nexusOpsTenant: string, sessionIdentifier: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomSessionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CustomSessionsByIdentifierSessionIdentifierGet(nexusOpsTenant, sessionIdentifier, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomSessionsApi.apiV1CustomSessionsByIdentifierSessionIdentifierGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} sessionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CustomSessionsSessionIdGet(nexusOpsTenant: string, sessionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomSessionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CustomSessionsSessionIdGet(nexusOpsTenant, sessionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomSessionsApi.apiV1CustomSessionsSessionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomSessionsApi - factory interface
 * @export
 */
export const CustomSessionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomSessionsApiFp(configuration)
    return {
        /**
         * 
         * @param {CustomSessionsApiApiV1CustomSessionsByIdentifierSessionIdentifierGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomSessionsByIdentifierSessionIdentifierGet(requestParameters: CustomSessionsApiApiV1CustomSessionsByIdentifierSessionIdentifierGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomSessionDto> {
            return localVarFp.apiV1CustomSessionsByIdentifierSessionIdentifierGet(requestParameters.nexusOpsTenant, requestParameters.sessionIdentifier, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomSessionsApiApiV1CustomSessionsSessionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomSessionsSessionIdGet(requestParameters: CustomSessionsApiApiV1CustomSessionsSessionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomSessionDto> {
            return localVarFp.apiV1CustomSessionsSessionIdGet(requestParameters.nexusOpsTenant, requestParameters.sessionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1CustomSessionsByIdentifierSessionIdentifierGet operation in CustomSessionsApi.
 * @export
 * @interface CustomSessionsApiApiV1CustomSessionsByIdentifierSessionIdentifierGetRequest
 */
export interface CustomSessionsApiApiV1CustomSessionsByIdentifierSessionIdentifierGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomSessionsApiApiV1CustomSessionsByIdentifierSessionIdentifierGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof CustomSessionsApiApiV1CustomSessionsByIdentifierSessionIdentifierGet
     */
    readonly sessionIdentifier: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomSessionsApiApiV1CustomSessionsByIdentifierSessionIdentifierGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1CustomSessionsSessionIdGet operation in CustomSessionsApi.
 * @export
 * @interface CustomSessionsApiApiV1CustomSessionsSessionIdGetRequest
 */
export interface CustomSessionsApiApiV1CustomSessionsSessionIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomSessionsApiApiV1CustomSessionsSessionIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof CustomSessionsApiApiV1CustomSessionsSessionIdGet
     */
    readonly sessionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomSessionsApiApiV1CustomSessionsSessionIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * CustomSessionsApi - object-oriented interface
 * @export
 * @class CustomSessionsApi
 * @extends {BaseAPI}
 */
export class CustomSessionsApi extends BaseAPI {
    /**
     * 
     * @param {CustomSessionsApiApiV1CustomSessionsByIdentifierSessionIdentifierGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomSessionsApi
     */
    public apiV1CustomSessionsByIdentifierSessionIdentifierGet(requestParameters: CustomSessionsApiApiV1CustomSessionsByIdentifierSessionIdentifierGetRequest, options?: RawAxiosRequestConfig) {
        return CustomSessionsApiFp(this.configuration).apiV1CustomSessionsByIdentifierSessionIdentifierGet(requestParameters.nexusOpsTenant, requestParameters.sessionIdentifier, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomSessionsApiApiV1CustomSessionsSessionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomSessionsApi
     */
    public apiV1CustomSessionsSessionIdGet(requestParameters: CustomSessionsApiApiV1CustomSessionsSessionIdGetRequest, options?: RawAxiosRequestConfig) {
        return CustomSessionsApiFp(this.configuration).apiV1CustomSessionsSessionIdGet(requestParameters.nexusOpsTenant, requestParameters.sessionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomSessionsAdminApi - axios parameter creator
 * @export
 */
export const CustomSessionsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} sessionIdentifier 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminCustomSessionsByIdentifierSessionIdentifierGet: async (sessionIdentifier: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionIdentifier' is not null or undefined
            assertParamExists('apiV1AdminCustomSessionsByIdentifierSessionIdentifierGet', 'sessionIdentifier', sessionIdentifier)
            const localVarPath = `/api/v1/admin/custom-sessions/by-identifier/{sessionIdentifier}`
                .replace(`{${"sessionIdentifier"}}`, encodeURIComponent(String(sessionIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCustomSessionGetPaginatedDto} [adminCustomSessionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminCustomSessionsGetPost: async (nexusOpsAppVersion?: string, adminCustomSessionGetPaginatedDto?: AdminCustomSessionGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/custom-sessions/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCustomSessionGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateCustomSessionDto} [adminCreateCustomSessionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminCustomSessionsPost: async (nexusOpsAppVersion?: string, adminCreateCustomSessionDto?: AdminCreateCustomSessionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/custom-sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateCustomSessionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminCustomSessionsSessionIdGet: async (sessionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV1AdminCustomSessionsSessionIdGet', 'sessionId', sessionId)
            const localVarPath = `/api/v1/admin/custom-sessions/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomSessionsAdminApi - functional programming interface
 * @export
 */
export const CustomSessionsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomSessionsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} sessionIdentifier 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminCustomSessionsByIdentifierSessionIdentifierGet(sessionIdentifier: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomSessionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminCustomSessionsByIdentifierSessionIdentifierGet(sessionIdentifier, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomSessionsAdminApi.apiV1AdminCustomSessionsByIdentifierSessionIdentifierGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCustomSessionGetPaginatedDto} [adminCustomSessionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminCustomSessionsGetPost(nexusOpsAppVersion?: string, adminCustomSessionGetPaginatedDto?: AdminCustomSessionGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfCustomSessionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminCustomSessionsGetPost(nexusOpsAppVersion, adminCustomSessionGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomSessionsAdminApi.apiV1AdminCustomSessionsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateCustomSessionDto} [adminCreateCustomSessionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminCustomSessionsPost(nexusOpsAppVersion?: string, adminCreateCustomSessionDto?: AdminCreateCustomSessionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomSessionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminCustomSessionsPost(nexusOpsAppVersion, adminCreateCustomSessionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomSessionsAdminApi.apiV1AdminCustomSessionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminCustomSessionsSessionIdGet(sessionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomSessionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminCustomSessionsSessionIdGet(sessionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomSessionsAdminApi.apiV1AdminCustomSessionsSessionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomSessionsAdminApi - factory interface
 * @export
 */
export const CustomSessionsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomSessionsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {CustomSessionsAdminApiApiV1AdminCustomSessionsByIdentifierSessionIdentifierGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminCustomSessionsByIdentifierSessionIdentifierGet(requestParameters: CustomSessionsAdminApiApiV1AdminCustomSessionsByIdentifierSessionIdentifierGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomSessionDto> {
            return localVarFp.apiV1AdminCustomSessionsByIdentifierSessionIdentifierGet(requestParameters.sessionIdentifier, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomSessionsAdminApiApiV1AdminCustomSessionsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminCustomSessionsGetPost(requestParameters: CustomSessionsAdminApiApiV1AdminCustomSessionsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfCustomSessionDto> {
            return localVarFp.apiV1AdminCustomSessionsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCustomSessionGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomSessionsAdminApiApiV1AdminCustomSessionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminCustomSessionsPost(requestParameters: CustomSessionsAdminApiApiV1AdminCustomSessionsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CustomSessionDto> {
            return localVarFp.apiV1AdminCustomSessionsPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateCustomSessionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomSessionsAdminApiApiV1AdminCustomSessionsSessionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminCustomSessionsSessionIdGet(requestParameters: CustomSessionsAdminApiApiV1AdminCustomSessionsSessionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomSessionDto> {
            return localVarFp.apiV1AdminCustomSessionsSessionIdGet(requestParameters.sessionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminCustomSessionsByIdentifierSessionIdentifierGet operation in CustomSessionsAdminApi.
 * @export
 * @interface CustomSessionsAdminApiApiV1AdminCustomSessionsByIdentifierSessionIdentifierGetRequest
 */
export interface CustomSessionsAdminApiApiV1AdminCustomSessionsByIdentifierSessionIdentifierGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomSessionsAdminApiApiV1AdminCustomSessionsByIdentifierSessionIdentifierGet
     */
    readonly sessionIdentifier: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomSessionsAdminApiApiV1AdminCustomSessionsByIdentifierSessionIdentifierGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminCustomSessionsGetPost operation in CustomSessionsAdminApi.
 * @export
 * @interface CustomSessionsAdminApiApiV1AdminCustomSessionsGetPostRequest
 */
export interface CustomSessionsAdminApiApiV1AdminCustomSessionsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomSessionsAdminApiApiV1AdminCustomSessionsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCustomSessionGetPaginatedDto}
     * @memberof CustomSessionsAdminApiApiV1AdminCustomSessionsGetPost
     */
    readonly adminCustomSessionGetPaginatedDto?: AdminCustomSessionGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminCustomSessionsPost operation in CustomSessionsAdminApi.
 * @export
 * @interface CustomSessionsAdminApiApiV1AdminCustomSessionsPostRequest
 */
export interface CustomSessionsAdminApiApiV1AdminCustomSessionsPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomSessionsAdminApiApiV1AdminCustomSessionsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateCustomSessionDto}
     * @memberof CustomSessionsAdminApiApiV1AdminCustomSessionsPost
     */
    readonly adminCreateCustomSessionDto?: AdminCreateCustomSessionDto
}

/**
 * Request parameters for apiV1AdminCustomSessionsSessionIdGet operation in CustomSessionsAdminApi.
 * @export
 * @interface CustomSessionsAdminApiApiV1AdminCustomSessionsSessionIdGetRequest
 */
export interface CustomSessionsAdminApiApiV1AdminCustomSessionsSessionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomSessionsAdminApiApiV1AdminCustomSessionsSessionIdGet
     */
    readonly sessionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomSessionsAdminApiApiV1AdminCustomSessionsSessionIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * CustomSessionsAdminApi - object-oriented interface
 * @export
 * @class CustomSessionsAdminApi
 * @extends {BaseAPI}
 */
export class CustomSessionsAdminApi extends BaseAPI {
    /**
     * 
     * @param {CustomSessionsAdminApiApiV1AdminCustomSessionsByIdentifierSessionIdentifierGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomSessionsAdminApi
     */
    public apiV1AdminCustomSessionsByIdentifierSessionIdentifierGet(requestParameters: CustomSessionsAdminApiApiV1AdminCustomSessionsByIdentifierSessionIdentifierGetRequest, options?: RawAxiosRequestConfig) {
        return CustomSessionsAdminApiFp(this.configuration).apiV1AdminCustomSessionsByIdentifierSessionIdentifierGet(requestParameters.sessionIdentifier, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomSessionsAdminApiApiV1AdminCustomSessionsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomSessionsAdminApi
     */
    public apiV1AdminCustomSessionsGetPost(requestParameters: CustomSessionsAdminApiApiV1AdminCustomSessionsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomSessionsAdminApiFp(this.configuration).apiV1AdminCustomSessionsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCustomSessionGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomSessionsAdminApiApiV1AdminCustomSessionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomSessionsAdminApi
     */
    public apiV1AdminCustomSessionsPost(requestParameters: CustomSessionsAdminApiApiV1AdminCustomSessionsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomSessionsAdminApiFp(this.configuration).apiV1AdminCustomSessionsPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateCustomSessionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomSessionsAdminApiApiV1AdminCustomSessionsSessionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomSessionsAdminApi
     */
    public apiV1AdminCustomSessionsSessionIdGet(requestParameters: CustomSessionsAdminApiApiV1AdminCustomSessionsSessionIdGetRequest, options?: RawAxiosRequestConfig) {
        return CustomSessionsAdminApiFp(this.configuration).apiV1AdminCustomSessionsSessionIdGet(requestParameters.sessionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomTagsApi - axios parameter creator
 * @export
 */
export const CustomTagsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsCustomBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsCustomBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tags/custom/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customTagId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsCustomCustomTagIdDelete: async (nexusOpsTenant: string, customTagId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsCustomCustomTagIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'customTagId' is not null or undefined
            assertParamExists('apiV1TagsCustomCustomTagIdDelete', 'customTagId', customTagId)
            const localVarPath = `/api/v1/tags/custom/{customTagId}`
                .replace(`{${"customTagId"}}`, encodeURIComponent(String(customTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customTagId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsCustomCustomTagIdGet: async (nexusOpsTenant: string, customTagId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsCustomCustomTagIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'customTagId' is not null or undefined
            assertParamExists('apiV1TagsCustomCustomTagIdGet', 'customTagId', customTagId)
            const localVarPath = `/api/v1/tags/custom/{customTagId}`
                .replace(`{${"customTagId"}}`, encodeURIComponent(String(customTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customTagId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomTagUpdateDto} [customTagUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsCustomCustomTagIdPut: async (nexusOpsTenant: string, customTagId: string, nexusOpsAppVersion?: string, customTagUpdateDto?: CustomTagUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsCustomCustomTagIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'customTagId' is not null or undefined
            assertParamExists('apiV1TagsCustomCustomTagIdPut', 'customTagId', customTagId)
            const localVarPath = `/api/v1/tags/custom/{customTagId}`
                .replace(`{${"customTagId"}}`, encodeURIComponent(String(customTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customTagUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomTagGetPaginatedDto} [customTagGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsCustomGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, customTagGetPaginatedDto?: CustomTagGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsCustomGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tags/custom/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customTagGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomTagCreateDto} [customTagCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsCustomPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, customTagCreateDto?: CustomTagCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsCustomPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tags/custom`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customTagCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomTagSearchPaginatedDto} [customTagSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsCustomSearchPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, customTagSearchPaginatedDto?: CustomTagSearchPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsCustomSearchPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tags/custom/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customTagSearchPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomTagsApi - functional programming interface
 * @export
 */
export const CustomTagsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomTagsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsCustomBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsCustomBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomTagsApi.apiV1TagsCustomBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customTagId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsCustomCustomTagIdDelete(nexusOpsTenant: string, customTagId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsCustomCustomTagIdDelete(nexusOpsTenant, customTagId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomTagsApi.apiV1TagsCustomCustomTagIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customTagId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsCustomCustomTagIdGet(nexusOpsTenant: string, customTagId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomTagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsCustomCustomTagIdGet(nexusOpsTenant, customTagId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomTagsApi.apiV1TagsCustomCustomTagIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customTagId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomTagUpdateDto} [customTagUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsCustomCustomTagIdPut(nexusOpsTenant: string, customTagId: string, nexusOpsAppVersion?: string, customTagUpdateDto?: CustomTagUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomTagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsCustomCustomTagIdPut(nexusOpsTenant, customTagId, nexusOpsAppVersion, customTagUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomTagsApi.apiV1TagsCustomCustomTagIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomTagGetPaginatedDto} [customTagGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsCustomGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, customTagGetPaginatedDto?: CustomTagGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfCustomTagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsCustomGetPost(nexusOpsTenant, nexusOpsAppVersion, customTagGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomTagsApi.apiV1TagsCustomGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomTagCreateDto} [customTagCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsCustomPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, customTagCreateDto?: CustomTagCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomTagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsCustomPost(nexusOpsTenant, nexusOpsAppVersion, customTagCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomTagsApi.apiV1TagsCustomPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomTagSearchPaginatedDto} [customTagSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsCustomSearchPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, customTagSearchPaginatedDto?: CustomTagSearchPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfCustomTagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsCustomSearchPost(nexusOpsTenant, nexusOpsAppVersion, customTagSearchPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomTagsApi.apiV1TagsCustomSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomTagsApi - factory interface
 * @export
 */
export const CustomTagsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomTagsApiFp(configuration)
    return {
        /**
         * 
         * @param {CustomTagsApiApiV1TagsCustomBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsCustomBulkDeleteDelete(requestParameters: CustomTagsApiApiV1TagsCustomBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1TagsCustomBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomTagsApiApiV1TagsCustomCustomTagIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsCustomCustomTagIdDelete(requestParameters: CustomTagsApiApiV1TagsCustomCustomTagIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1TagsCustomCustomTagIdDelete(requestParameters.nexusOpsTenant, requestParameters.customTagId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomTagsApiApiV1TagsCustomCustomTagIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsCustomCustomTagIdGet(requestParameters: CustomTagsApiApiV1TagsCustomCustomTagIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomTagDto> {
            return localVarFp.apiV1TagsCustomCustomTagIdGet(requestParameters.nexusOpsTenant, requestParameters.customTagId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomTagsApiApiV1TagsCustomCustomTagIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsCustomCustomTagIdPut(requestParameters: CustomTagsApiApiV1TagsCustomCustomTagIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomTagDto> {
            return localVarFp.apiV1TagsCustomCustomTagIdPut(requestParameters.nexusOpsTenant, requestParameters.customTagId, requestParameters.nexusOpsAppVersion, requestParameters.customTagUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomTagsApiApiV1TagsCustomGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsCustomGetPost(requestParameters: CustomTagsApiApiV1TagsCustomGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfCustomTagDto> {
            return localVarFp.apiV1TagsCustomGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.customTagGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomTagsApiApiV1TagsCustomPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsCustomPost(requestParameters: CustomTagsApiApiV1TagsCustomPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomTagDto> {
            return localVarFp.apiV1TagsCustomPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.customTagCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomTagsApiApiV1TagsCustomSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsCustomSearchPost(requestParameters: CustomTagsApiApiV1TagsCustomSearchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfCustomTagDto> {
            return localVarFp.apiV1TagsCustomSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.customTagSearchPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1TagsCustomBulkDeleteDelete operation in CustomTagsApi.
 * @export
 * @interface CustomTagsApiApiV1TagsCustomBulkDeleteDeleteRequest
 */
export interface CustomTagsApiApiV1TagsCustomBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof CustomTagsApiApiV1TagsCustomBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1TagsCustomCustomTagIdDelete operation in CustomTagsApi.
 * @export
 * @interface CustomTagsApiApiV1TagsCustomCustomTagIdDeleteRequest
 */
export interface CustomTagsApiApiV1TagsCustomCustomTagIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomCustomTagIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomCustomTagIdDelete
     */
    readonly customTagId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomCustomTagIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TagsCustomCustomTagIdGet operation in CustomTagsApi.
 * @export
 * @interface CustomTagsApiApiV1TagsCustomCustomTagIdGetRequest
 */
export interface CustomTagsApiApiV1TagsCustomCustomTagIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomCustomTagIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomCustomTagIdGet
     */
    readonly customTagId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomCustomTagIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TagsCustomCustomTagIdPut operation in CustomTagsApi.
 * @export
 * @interface CustomTagsApiApiV1TagsCustomCustomTagIdPutRequest
 */
export interface CustomTagsApiApiV1TagsCustomCustomTagIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomCustomTagIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomCustomTagIdPut
     */
    readonly customTagId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomCustomTagIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CustomTagUpdateDto}
     * @memberof CustomTagsApiApiV1TagsCustomCustomTagIdPut
     */
    readonly customTagUpdateDto?: CustomTagUpdateDto
}

/**
 * Request parameters for apiV1TagsCustomGetPost operation in CustomTagsApi.
 * @export
 * @interface CustomTagsApiApiV1TagsCustomGetPostRequest
 */
export interface CustomTagsApiApiV1TagsCustomGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CustomTagGetPaginatedDto}
     * @memberof CustomTagsApiApiV1TagsCustomGetPost
     */
    readonly customTagGetPaginatedDto?: CustomTagGetPaginatedDto
}

/**
 * Request parameters for apiV1TagsCustomPost operation in CustomTagsApi.
 * @export
 * @interface CustomTagsApiApiV1TagsCustomPostRequest
 */
export interface CustomTagsApiApiV1TagsCustomPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CustomTagCreateDto}
     * @memberof CustomTagsApiApiV1TagsCustomPost
     */
    readonly customTagCreateDto?: CustomTagCreateDto
}

/**
 * Request parameters for apiV1TagsCustomSearchPost operation in CustomTagsApi.
 * @export
 * @interface CustomTagsApiApiV1TagsCustomSearchPostRequest
 */
export interface CustomTagsApiApiV1TagsCustomSearchPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomSearchPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomTagsApiApiV1TagsCustomSearchPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CustomTagSearchPaginatedDto}
     * @memberof CustomTagsApiApiV1TagsCustomSearchPost
     */
    readonly customTagSearchPaginatedDto?: CustomTagSearchPaginatedDto
}

/**
 * CustomTagsApi - object-oriented interface
 * @export
 * @class CustomTagsApi
 * @extends {BaseAPI}
 */
export class CustomTagsApi extends BaseAPI {
    /**
     * 
     * @param {CustomTagsApiApiV1TagsCustomBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomTagsApi
     */
    public apiV1TagsCustomBulkDeleteDelete(requestParameters: CustomTagsApiApiV1TagsCustomBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return CustomTagsApiFp(this.configuration).apiV1TagsCustomBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomTagsApiApiV1TagsCustomCustomTagIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomTagsApi
     */
    public apiV1TagsCustomCustomTagIdDelete(requestParameters: CustomTagsApiApiV1TagsCustomCustomTagIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CustomTagsApiFp(this.configuration).apiV1TagsCustomCustomTagIdDelete(requestParameters.nexusOpsTenant, requestParameters.customTagId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomTagsApiApiV1TagsCustomCustomTagIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomTagsApi
     */
    public apiV1TagsCustomCustomTagIdGet(requestParameters: CustomTagsApiApiV1TagsCustomCustomTagIdGetRequest, options?: RawAxiosRequestConfig) {
        return CustomTagsApiFp(this.configuration).apiV1TagsCustomCustomTagIdGet(requestParameters.nexusOpsTenant, requestParameters.customTagId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomTagsApiApiV1TagsCustomCustomTagIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomTagsApi
     */
    public apiV1TagsCustomCustomTagIdPut(requestParameters: CustomTagsApiApiV1TagsCustomCustomTagIdPutRequest, options?: RawAxiosRequestConfig) {
        return CustomTagsApiFp(this.configuration).apiV1TagsCustomCustomTagIdPut(requestParameters.nexusOpsTenant, requestParameters.customTagId, requestParameters.nexusOpsAppVersion, requestParameters.customTagUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomTagsApiApiV1TagsCustomGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomTagsApi
     */
    public apiV1TagsCustomGetPost(requestParameters: CustomTagsApiApiV1TagsCustomGetPostRequest, options?: RawAxiosRequestConfig) {
        return CustomTagsApiFp(this.configuration).apiV1TagsCustomGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.customTagGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomTagsApiApiV1TagsCustomPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomTagsApi
     */
    public apiV1TagsCustomPost(requestParameters: CustomTagsApiApiV1TagsCustomPostRequest, options?: RawAxiosRequestConfig) {
        return CustomTagsApiFp(this.configuration).apiV1TagsCustomPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.customTagCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomTagsApiApiV1TagsCustomSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomTagsApi
     */
    public apiV1TagsCustomSearchPost(requestParameters: CustomTagsApiApiV1TagsCustomSearchPostRequest, options?: RawAxiosRequestConfig) {
        return CustomTagsApiFp(this.configuration).apiV1TagsCustomSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.customTagSearchPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomersApi - axios parameter creator
 * @export
 */
export const CustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CustomersBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/customers/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByContractContractIdGet: async (nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CustomersByContractContractIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiV1CustomersByContractContractIdGet', 'contractId', contractId)
            const localVarPath = `/api/v1/customers/by-contract/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdDelete: async (nexusOpsTenant: string, customerId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdDelete', 'customerId', customerId)
            const localVarPath = `/api/v1/customers/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdGet: async (nexusOpsTenant: string, customerId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdGet', 'customerId', customerId)
            const localVarPath = `/api/v1/customers/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomerUpdateDto} [customerUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdPut: async (nexusOpsTenant: string, customerId: string, nexusOpsAppVersion?: string, customerUpdateDto?: CustomerUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdPut', 'customerId', customerId)
            const localVarPath = `/api/v1/customers/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomerGetPaginatedDto} [customerGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, customerGetPaginatedDto?: CustomerGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CustomersGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/customers/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomerCreateDto} [customerCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, customerCreateDto?: CustomerCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CustomersPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersApi - functional programming interface
 * @export
 */
export const CustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CustomersBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CustomersBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.apiV1CustomersBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} contractId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CustomersByContractContractIdGet(nexusOpsTenant: string, contractId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CustomersByContractContractIdGet(nexusOpsTenant, contractId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.apiV1CustomersByContractContractIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CustomersCustomerIdDelete(nexusOpsTenant: string, customerId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CustomersCustomerIdDelete(nexusOpsTenant, customerId, nexusOpsAppVersion, isDeleteCascade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.apiV1CustomersCustomerIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CustomersCustomerIdGet(nexusOpsTenant: string, customerId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CustomersCustomerIdGet(nexusOpsTenant, customerId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.apiV1CustomersCustomerIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomerUpdateDto} [customerUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CustomersCustomerIdPut(nexusOpsTenant: string, customerId: string, nexusOpsAppVersion?: string, customerUpdateDto?: CustomerUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CustomersCustomerIdPut(nexusOpsTenant, customerId, nexusOpsAppVersion, customerUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.apiV1CustomersCustomerIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomerGetPaginatedDto} [customerGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CustomersGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, customerGetPaginatedDto?: CustomerGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfCustomerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CustomersGetPost(nexusOpsTenant, nexusOpsAppVersion, customerGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.apiV1CustomersGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomerCreateDto} [customerCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CustomersPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, customerCreateDto?: CustomerCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CustomersPost(nexusOpsTenant, nexusOpsAppVersion, customerCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.apiV1CustomersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomersApi - factory interface
 * @export
 */
export const CustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersApiFp(configuration)
    return {
        /**
         * 
         * @param {CustomersApiApiV1CustomersBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersBulkDeleteDelete(requestParameters: CustomersApiApiV1CustomersBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1CustomersBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersApiApiV1CustomersByContractContractIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByContractContractIdGet(requestParameters: CustomersApiApiV1CustomersByContractContractIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDto> {
            return localVarFp.apiV1CustomersByContractContractIdGet(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersApiApiV1CustomersCustomerIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdDelete(requestParameters: CustomersApiApiV1CustomersCustomerIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1CustomersCustomerIdDelete(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersApiApiV1CustomersCustomerIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdGet(requestParameters: CustomersApiApiV1CustomersCustomerIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDto> {
            return localVarFp.apiV1CustomersCustomerIdGet(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersApiApiV1CustomersCustomerIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdPut(requestParameters: CustomersApiApiV1CustomersCustomerIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDto> {
            return localVarFp.apiV1CustomersCustomerIdPut(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.nexusOpsAppVersion, requestParameters.customerUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersApiApiV1CustomersGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersGetPost(requestParameters: CustomersApiApiV1CustomersGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfCustomerDto> {
            return localVarFp.apiV1CustomersGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.customerGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersApiApiV1CustomersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersPost(requestParameters: CustomersApiApiV1CustomersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDto> {
            return localVarFp.apiV1CustomersPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.customerCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1CustomersBulkDeleteDelete operation in CustomersApi.
 * @export
 * @interface CustomersApiApiV1CustomersBulkDeleteDeleteRequest
 */
export interface CustomersApiApiV1CustomersBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomersApiApiV1CustomersBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomersApiApiV1CustomersBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof CustomersApiApiV1CustomersBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1CustomersByContractContractIdGet operation in CustomersApi.
 * @export
 * @interface CustomersApiApiV1CustomersByContractContractIdGetRequest
 */
export interface CustomersApiApiV1CustomersByContractContractIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomersApiApiV1CustomersByContractContractIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof CustomersApiApiV1CustomersByContractContractIdGet
     */
    readonly contractId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomersApiApiV1CustomersByContractContractIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1CustomersCustomerIdDelete operation in CustomersApi.
 * @export
 * @interface CustomersApiApiV1CustomersCustomerIdDeleteRequest
 */
export interface CustomersApiApiV1CustomersCustomerIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomersApiApiV1CustomersCustomerIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof CustomersApiApiV1CustomersCustomerIdDelete
     */
    readonly customerId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomersApiApiV1CustomersCustomerIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof CustomersApiApiV1CustomersCustomerIdDelete
     */
    readonly isDeleteCascade?: boolean
}

/**
 * Request parameters for apiV1CustomersCustomerIdGet operation in CustomersApi.
 * @export
 * @interface CustomersApiApiV1CustomersCustomerIdGetRequest
 */
export interface CustomersApiApiV1CustomersCustomerIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomersApiApiV1CustomersCustomerIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof CustomersApiApiV1CustomersCustomerIdGet
     */
    readonly customerId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomersApiApiV1CustomersCustomerIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1CustomersCustomerIdPut operation in CustomersApi.
 * @export
 * @interface CustomersApiApiV1CustomersCustomerIdPutRequest
 */
export interface CustomersApiApiV1CustomersCustomerIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomersApiApiV1CustomersCustomerIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof CustomersApiApiV1CustomersCustomerIdPut
     */
    readonly customerId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomersApiApiV1CustomersCustomerIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CustomerUpdateDto}
     * @memberof CustomersApiApiV1CustomersCustomerIdPut
     */
    readonly customerUpdateDto?: CustomerUpdateDto
}

/**
 * Request parameters for apiV1CustomersGetPost operation in CustomersApi.
 * @export
 * @interface CustomersApiApiV1CustomersGetPostRequest
 */
export interface CustomersApiApiV1CustomersGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomersApiApiV1CustomersGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomersApiApiV1CustomersGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CustomerGetPaginatedDto}
     * @memberof CustomersApiApiV1CustomersGetPost
     */
    readonly customerGetPaginatedDto?: CustomerGetPaginatedDto
}

/**
 * Request parameters for apiV1CustomersPost operation in CustomersApi.
 * @export
 * @interface CustomersApiApiV1CustomersPostRequest
 */
export interface CustomersApiApiV1CustomersPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomersApiApiV1CustomersPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomersApiApiV1CustomersPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CustomerCreateDto}
     * @memberof CustomersApiApiV1CustomersPost
     */
    readonly customerCreateDto?: CustomerCreateDto
}

/**
 * CustomersApi - object-oriented interface
 * @export
 * @class CustomersApi
 * @extends {BaseAPI}
 */
export class CustomersApi extends BaseAPI {
    /**
     * 
     * @param {CustomersApiApiV1CustomersBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public apiV1CustomersBulkDeleteDelete(requestParameters: CustomersApiApiV1CustomersBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).apiV1CustomersBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiApiV1CustomersByContractContractIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public apiV1CustomersByContractContractIdGet(requestParameters: CustomersApiApiV1CustomersByContractContractIdGetRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).apiV1CustomersByContractContractIdGet(requestParameters.nexusOpsTenant, requestParameters.contractId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiApiV1CustomersCustomerIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public apiV1CustomersCustomerIdDelete(requestParameters: CustomersApiApiV1CustomersCustomerIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).apiV1CustomersCustomerIdDelete(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiApiV1CustomersCustomerIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public apiV1CustomersCustomerIdGet(requestParameters: CustomersApiApiV1CustomersCustomerIdGetRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).apiV1CustomersCustomerIdGet(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiApiV1CustomersCustomerIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public apiV1CustomersCustomerIdPut(requestParameters: CustomersApiApiV1CustomersCustomerIdPutRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).apiV1CustomersCustomerIdPut(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.nexusOpsAppVersion, requestParameters.customerUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiApiV1CustomersGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public apiV1CustomersGetPost(requestParameters: CustomersApiApiV1CustomersGetPostRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).apiV1CustomersGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.customerGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiApiV1CustomersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public apiV1CustomersPost(requestParameters: CustomersApiApiV1CustomersPostRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).apiV1CustomersPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.customerCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomersInvitesApi - axios parameter creator
 * @export
 */
export const CustomersInvitesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} customerContactId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdInvitesCustomerContactIdPost: async (nexusOpsTenant: string, customerId: string, customerContactId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdInvitesCustomerContactIdPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdInvitesCustomerContactIdPost', 'customerId', customerId)
            // verify required parameter 'customerContactId' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdInvitesCustomerContactIdPost', 'customerContactId', customerContactId)
            const localVarPath = `/api/v1/customers/{customerId}/invites/{customerContactId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"customerContactId"}}`, encodeURIComponent(String(customerContactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomersInviteGetPaginatedDto} [customersInviteGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdInvitesGetPost: async (nexusOpsTenant: string, customerId: string, nexusOpsAppVersion?: string, customersInviteGetPaginatedDto?: CustomersInviteGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdInvitesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdInvitesGetPost', 'customerId', customerId)
            const localVarPath = `/api/v1/customers/{customerId}/invites/get`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customersInviteGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdInvitesInviteIdDelete: async (nexusOpsTenant: string, customerId: string, inviteId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdInvitesInviteIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdInvitesInviteIdDelete', 'customerId', customerId)
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdInvitesInviteIdDelete', 'inviteId', inviteId)
            const localVarPath = `/api/v1/customers/{customerId}/invites/{inviteId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdInvitesInviteIdResendPost: async (nexusOpsTenant: string, customerId: string, inviteId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdInvitesInviteIdResendPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdInvitesInviteIdResendPost', 'customerId', customerId)
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdInvitesInviteIdResendPost', 'inviteId', inviteId)
            const localVarPath = `/api/v1/customers/{customerId}/invites/{inviteId}/resend`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomerInviteAsUserDto} [customerInviteAsUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdInvitesPost: async (nexusOpsTenant: string, customerId: string, nexusOpsAppVersion?: string, customerInviteAsUserDto?: CustomerInviteAsUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdInvitesPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('apiV1CustomersCustomerIdInvitesPost', 'customerId', customerId)
            const localVarPath = `/api/v1/customers/{customerId}/invites`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerInviteAsUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersInvitesApi - functional programming interface
 * @export
 */
export const CustomersInvitesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersInvitesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} customerContactId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CustomersCustomerIdInvitesCustomerContactIdPost(nexusOpsTenant: string, customerId: string, customerContactId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CustomersCustomerIdInvitesCustomerContactIdPost(nexusOpsTenant, customerId, customerContactId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersInvitesApi.apiV1CustomersCustomerIdInvitesCustomerContactIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomersInviteGetPaginatedDto} [customersInviteGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CustomersCustomerIdInvitesGetPost(nexusOpsTenant: string, customerId: string, nexusOpsAppVersion?: string, customersInviteGetPaginatedDto?: CustomersInviteGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfTenantInviteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CustomersCustomerIdInvitesGetPost(nexusOpsTenant, customerId, nexusOpsAppVersion, customersInviteGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersInvitesApi.apiV1CustomersCustomerIdInvitesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CustomersCustomerIdInvitesInviteIdDelete(nexusOpsTenant: string, customerId: string, inviteId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CustomersCustomerIdInvitesInviteIdDelete(nexusOpsTenant, customerId, inviteId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersInvitesApi.apiV1CustomersCustomerIdInvitesInviteIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CustomersCustomerIdInvitesInviteIdResendPost(nexusOpsTenant: string, customerId: string, inviteId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CustomersCustomerIdInvitesInviteIdResendPost(nexusOpsTenant, customerId, inviteId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersInvitesApi.apiV1CustomersCustomerIdInvitesInviteIdResendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customerId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CustomerInviteAsUserDto} [customerInviteAsUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CustomersCustomerIdInvitesPost(nexusOpsTenant: string, customerId: string, nexusOpsAppVersion?: string, customerInviteAsUserDto?: CustomerInviteAsUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantInviteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CustomersCustomerIdInvitesPost(nexusOpsTenant, customerId, nexusOpsAppVersion, customerInviteAsUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersInvitesApi.apiV1CustomersCustomerIdInvitesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomersInvitesApi - factory interface
 * @export
 */
export const CustomersInvitesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersInvitesApiFp(configuration)
    return {
        /**
         * 
         * @param {CustomersInvitesApiApiV1CustomersCustomerIdInvitesCustomerContactIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdInvitesCustomerContactIdPost(requestParameters: CustomersInvitesApiApiV1CustomersCustomerIdInvitesCustomerContactIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1CustomersCustomerIdInvitesCustomerContactIdPost(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.customerContactId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersInvitesApiApiV1CustomersCustomerIdInvitesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdInvitesGetPost(requestParameters: CustomersInvitesApiApiV1CustomersCustomerIdInvitesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfTenantInviteDto> {
            return localVarFp.apiV1CustomersCustomerIdInvitesGetPost(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.nexusOpsAppVersion, requestParameters.customersInviteGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdInvitesInviteIdDelete(requestParameters: CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1CustomersCustomerIdInvitesInviteIdDelete(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdResendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdInvitesInviteIdResendPost(requestParameters: CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdResendPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1CustomersCustomerIdInvitesInviteIdResendPost(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomersInvitesApiApiV1CustomersCustomerIdInvitesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersCustomerIdInvitesPost(requestParameters: CustomersInvitesApiApiV1CustomersCustomerIdInvitesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TenantInviteDto>> {
            return localVarFp.apiV1CustomersCustomerIdInvitesPost(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.nexusOpsAppVersion, requestParameters.customerInviteAsUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1CustomersCustomerIdInvitesCustomerContactIdPost operation in CustomersInvitesApi.
 * @export
 * @interface CustomersInvitesApiApiV1CustomersCustomerIdInvitesCustomerContactIdPostRequest
 */
export interface CustomersInvitesApiApiV1CustomersCustomerIdInvitesCustomerContactIdPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesCustomerContactIdPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesCustomerContactIdPost
     */
    readonly customerId: string

    /**
     * 
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesCustomerContactIdPost
     */
    readonly customerContactId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesCustomerContactIdPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1CustomersCustomerIdInvitesGetPost operation in CustomersInvitesApi.
 * @export
 * @interface CustomersInvitesApiApiV1CustomersCustomerIdInvitesGetPostRequest
 */
export interface CustomersInvitesApiApiV1CustomersCustomerIdInvitesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesGetPost
     */
    readonly customerId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CustomersInviteGetPaginatedDto}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesGetPost
     */
    readonly customersInviteGetPaginatedDto?: CustomersInviteGetPaginatedDto
}

/**
 * Request parameters for apiV1CustomersCustomerIdInvitesInviteIdDelete operation in CustomersInvitesApi.
 * @export
 * @interface CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdDeleteRequest
 */
export interface CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdDelete
     */
    readonly customerId: string

    /**
     * 
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdDelete
     */
    readonly inviteId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1CustomersCustomerIdInvitesInviteIdResendPost operation in CustomersInvitesApi.
 * @export
 * @interface CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdResendPostRequest
 */
export interface CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdResendPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdResendPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdResendPost
     */
    readonly customerId: string

    /**
     * 
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdResendPost
     */
    readonly inviteId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdResendPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1CustomersCustomerIdInvitesPost operation in CustomersInvitesApi.
 * @export
 * @interface CustomersInvitesApiApiV1CustomersCustomerIdInvitesPostRequest
 */
export interface CustomersInvitesApiApiV1CustomersCustomerIdInvitesPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesPost
     */
    readonly customerId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CustomerInviteAsUserDto}
     * @memberof CustomersInvitesApiApiV1CustomersCustomerIdInvitesPost
     */
    readonly customerInviteAsUserDto?: CustomerInviteAsUserDto
}

/**
 * CustomersInvitesApi - object-oriented interface
 * @export
 * @class CustomersInvitesApi
 * @extends {BaseAPI}
 */
export class CustomersInvitesApi extends BaseAPI {
    /**
     * 
     * @param {CustomersInvitesApiApiV1CustomersCustomerIdInvitesCustomerContactIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersInvitesApi
     */
    public apiV1CustomersCustomerIdInvitesCustomerContactIdPost(requestParameters: CustomersInvitesApiApiV1CustomersCustomerIdInvitesCustomerContactIdPostRequest, options?: RawAxiosRequestConfig) {
        return CustomersInvitesApiFp(this.configuration).apiV1CustomersCustomerIdInvitesCustomerContactIdPost(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.customerContactId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersInvitesApiApiV1CustomersCustomerIdInvitesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersInvitesApi
     */
    public apiV1CustomersCustomerIdInvitesGetPost(requestParameters: CustomersInvitesApiApiV1CustomersCustomerIdInvitesGetPostRequest, options?: RawAxiosRequestConfig) {
        return CustomersInvitesApiFp(this.configuration).apiV1CustomersCustomerIdInvitesGetPost(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.nexusOpsAppVersion, requestParameters.customersInviteGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersInvitesApi
     */
    public apiV1CustomersCustomerIdInvitesInviteIdDelete(requestParameters: CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CustomersInvitesApiFp(this.configuration).apiV1CustomersCustomerIdInvitesInviteIdDelete(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdResendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersInvitesApi
     */
    public apiV1CustomersCustomerIdInvitesInviteIdResendPost(requestParameters: CustomersInvitesApiApiV1CustomersCustomerIdInvitesInviteIdResendPostRequest, options?: RawAxiosRequestConfig) {
        return CustomersInvitesApiFp(this.configuration).apiV1CustomersCustomerIdInvitesInviteIdResendPost(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersInvitesApiApiV1CustomersCustomerIdInvitesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersInvitesApi
     */
    public apiV1CustomersCustomerIdInvitesPost(requestParameters: CustomersInvitesApiApiV1CustomersCustomerIdInvitesPostRequest, options?: RawAxiosRequestConfig) {
        return CustomersInvitesApiFp(this.configuration).apiV1CustomersCustomerIdInvitesPost(requestParameters.nexusOpsTenant, requestParameters.customerId, requestParameters.nexusOpsAppVersion, requestParameters.customerInviteAsUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DamageCostEvaluationAggregatesApi - axios parameter creator
 * @export
 */
export const DamageCostEvaluationAggregatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsAggregatesAggregateIdDelete: async (nexusOpsTenant: string, aggregateId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsAggregatesAggregateIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'aggregateId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsAggregatesAggregateIdDelete', 'aggregateId', aggregateId)
            const localVarPath = `/api/v1/damage-cost-evaluations/aggregates/{aggregateId}`
                .replace(`{${"aggregateId"}}`, encodeURIComponent(String(aggregateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGet: async (nexusOpsTenant: string, aggregateId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'aggregateId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGet', 'aggregateId', aggregateId)
            const localVarPath = `/api/v1/damage-cost-evaluations/aggregates/{aggregateId}/download/pdf`
                .replace(`{${"aggregateId"}}`, encodeURIComponent(String(aggregateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsAggregatesAggregateIdGet: async (nexusOpsTenant: string, aggregateId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsAggregatesAggregateIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'aggregateId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsAggregatesAggregateIdGet', 'aggregateId', aggregateId)
            const localVarPath = `/api/v1/damage-cost-evaluations/aggregates/{aggregateId}`
                .replace(`{${"aggregateId"}}`, encodeURIComponent(String(aggregateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} itemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete: async (nexusOpsTenant: string, aggregateId: string, itemId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'aggregateId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete', 'aggregateId', aggregateId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete', 'itemId', itemId)
            const localVarPath = `/api/v1/damage-cost-evaluations/aggregates/{aggregateId}/items/{itemId}`
                .replace(`{${"aggregateId"}}`, encodeURIComponent(String(aggregateId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageCostEvaluationAggregateGetPaginatedDto} [damageCostEvaluationAggregateGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsAggregatesGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, damageCostEvaluationAggregateGetPaginatedDto?: DamageCostEvaluationAggregateGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsAggregatesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/damage-cost-evaluations/aggregates/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCostEvaluationAggregateGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageCostEvaluationAggregateSearchPaginatedDto} [damageCostEvaluationAggregateSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsAggregatesSearchPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, damageCostEvaluationAggregateSearchPaginatedDto?: DamageCostEvaluationAggregateSearchPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsAggregatesSearchPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/damage-cost-evaluations/aggregates/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCostEvaluationAggregateSearchPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DamageCostEvaluationAggregatesApi - functional programming interface
 * @export
 */
export const DamageCostEvaluationAggregatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DamageCostEvaluationAggregatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsAggregatesAggregateIdDelete(nexusOpsTenant: string, aggregateId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsAggregatesAggregateIdDelete(nexusOpsTenant, aggregateId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationAggregatesApi.apiV1DamageCostEvaluationsAggregatesAggregateIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGet(nexusOpsTenant: string, aggregateId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGet(nexusOpsTenant, aggregateId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationAggregatesApi.apiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsAggregatesAggregateIdGet(nexusOpsTenant: string, aggregateId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCostEvaluationAggregateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsAggregatesAggregateIdGet(nexusOpsTenant, aggregateId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationAggregatesApi.apiV1DamageCostEvaluationsAggregatesAggregateIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} itemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete(nexusOpsTenant: string, aggregateId: string, itemId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCostEvaluationAggregateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete(nexusOpsTenant, aggregateId, itemId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationAggregatesApi.apiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageCostEvaluationAggregateGetPaginatedDto} [damageCostEvaluationAggregateGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsAggregatesGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, damageCostEvaluationAggregateGetPaginatedDto?: DamageCostEvaluationAggregateGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfDamageCostEvaluationAggregateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsAggregatesGetPost(nexusOpsTenant, nexusOpsAppVersion, damageCostEvaluationAggregateGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationAggregatesApi.apiV1DamageCostEvaluationsAggregatesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageCostEvaluationAggregateSearchPaginatedDto} [damageCostEvaluationAggregateSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsAggregatesSearchPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, damageCostEvaluationAggregateSearchPaginatedDto?: DamageCostEvaluationAggregateSearchPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfDamageCostEvaluationAggregateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsAggregatesSearchPost(nexusOpsTenant, nexusOpsAppVersion, damageCostEvaluationAggregateSearchPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationAggregatesApi.apiV1DamageCostEvaluationsAggregatesSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DamageCostEvaluationAggregatesApi - factory interface
 * @export
 */
export const DamageCostEvaluationAggregatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DamageCostEvaluationAggregatesApiFp(configuration)
    return {
        /**
         * 
         * @param {DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsAggregatesAggregateIdDelete(requestParameters: DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DamageCostEvaluationsAggregatesAggregateIdDelete(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGet(requestParameters: DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsAggregatesAggregateIdGet(requestParameters: DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageCostEvaluationAggregateDto> {
            return localVarFp.apiV1DamageCostEvaluationsAggregatesAggregateIdGet(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete(requestParameters: DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageCostEvaluationAggregateDto> {
            return localVarFp.apiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.itemId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsAggregatesGetPost(requestParameters: DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfDamageCostEvaluationAggregateDto> {
            return localVarFp.apiV1DamageCostEvaluationsAggregatesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageCostEvaluationAggregateGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsAggregatesSearchPost(requestParameters: DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesSearchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfDamageCostEvaluationAggregateDto> {
            return localVarFp.apiV1DamageCostEvaluationsAggregatesSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageCostEvaluationAggregateSearchPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DamageCostEvaluationsAggregatesAggregateIdDelete operation in DamageCostEvaluationAggregatesApi.
 * @export
 * @interface DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDeleteRequest
 */
export interface DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDelete
     */
    readonly aggregateId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGet operation in DamageCostEvaluationAggregatesApi.
 * @export
 * @interface DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGetRequest
 */
export interface DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGet
     */
    readonly aggregateId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageCostEvaluationsAggregatesAggregateIdGet operation in DamageCostEvaluationAggregatesApi.
 * @export
 * @interface DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdGetRequest
 */
export interface DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdGet
     */
    readonly aggregateId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete operation in DamageCostEvaluationAggregatesApi.
 * @export
 * @interface DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDeleteRequest
 */
export interface DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete
     */
    readonly aggregateId: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete
     */
    readonly itemId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageCostEvaluationsAggregatesGetPost operation in DamageCostEvaluationAggregatesApi.
 * @export
 * @interface DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesGetPostRequest
 */
export interface DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DamageCostEvaluationAggregateGetPaginatedDto}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesGetPost
     */
    readonly damageCostEvaluationAggregateGetPaginatedDto?: DamageCostEvaluationAggregateGetPaginatedDto
}

/**
 * Request parameters for apiV1DamageCostEvaluationsAggregatesSearchPost operation in DamageCostEvaluationAggregatesApi.
 * @export
 * @interface DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesSearchPostRequest
 */
export interface DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesSearchPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesSearchPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesSearchPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DamageCostEvaluationAggregateSearchPaginatedDto}
     * @memberof DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesSearchPost
     */
    readonly damageCostEvaluationAggregateSearchPaginatedDto?: DamageCostEvaluationAggregateSearchPaginatedDto
}

/**
 * DamageCostEvaluationAggregatesApi - object-oriented interface
 * @export
 * @class DamageCostEvaluationAggregatesApi
 * @extends {BaseAPI}
 */
export class DamageCostEvaluationAggregatesApi extends BaseAPI {
    /**
     * 
     * @param {DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationAggregatesApi
     */
    public apiV1DamageCostEvaluationsAggregatesAggregateIdDelete(requestParameters: DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationAggregatesApiFp(this.configuration).apiV1DamageCostEvaluationsAggregatesAggregateIdDelete(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationAggregatesApi
     */
    public apiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGet(requestParameters: DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationAggregatesApiFp(this.configuration).apiV1DamageCostEvaluationsAggregatesAggregateIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationAggregatesApi
     */
    public apiV1DamageCostEvaluationsAggregatesAggregateIdGet(requestParameters: DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdGetRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationAggregatesApiFp(this.configuration).apiV1DamageCostEvaluationsAggregatesAggregateIdGet(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationAggregatesApi
     */
    public apiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete(requestParameters: DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationAggregatesApiFp(this.configuration).apiV1DamageCostEvaluationsAggregatesAggregateIdItemsItemIdDelete(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.itemId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationAggregatesApi
     */
    public apiV1DamageCostEvaluationsAggregatesGetPost(requestParameters: DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesGetPostRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationAggregatesApiFp(this.configuration).apiV1DamageCostEvaluationsAggregatesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageCostEvaluationAggregateGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationAggregatesApi
     */
    public apiV1DamageCostEvaluationsAggregatesSearchPost(requestParameters: DamageCostEvaluationAggregatesApiApiV1DamageCostEvaluationsAggregatesSearchPostRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationAggregatesApiFp(this.configuration).apiV1DamageCostEvaluationsAggregatesSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageCostEvaluationAggregateSearchPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DamageCostEvaluationsApi - axios parameter creator
 * @export
 */
export const DamageCostEvaluationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/damage-cost-evaluations/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsByIdsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsByIdsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/damage-cost-evaluations/by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/damage-cost-evaluations/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut: async (nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageCostEvaluationId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut', 'damageCostEvaluationId', damageCostEvaluationId)
            const localVarPath = `/api/v1/damage-cost-evaluations/{damageCostEvaluationId}/add-assignment`
                .replace(`{${"damageCostEvaluationId"}}`, encodeURIComponent(String(damageCostEvaluationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentAddEntityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddDamageCostEvaluationToContractDto} [addDamageCostEvaluationToContractDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut: async (nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, addDamageCostEvaluationToContractDto?: AddDamageCostEvaluationToContractDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageCostEvaluationId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut', 'damageCostEvaluationId', damageCostEvaluationId)
            const localVarPath = `/api/v1/damage-cost-evaluations/{damageCostEvaluationId}/add-contract`
                .replace(`{${"damageCostEvaluationId"}}`, encodeURIComponent(String(damageCostEvaluationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDamageCostEvaluationToContractDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralBillToInfoOfEntityUpdateDto} [generalBillToInfoOfEntityUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut: async (nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, generalBillToInfoOfEntityUpdateDto?: GeneralBillToInfoOfEntityUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageCostEvaluationId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut', 'damageCostEvaluationId', damageCostEvaluationId)
            const localVarPath = `/api/v1/damage-cost-evaluations/{damageCostEvaluationId}/bill-to-info`
                .replace(`{${"damageCostEvaluationId"}}`, encodeURIComponent(String(damageCostEvaluationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalBillToInfoOfEntityUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPost: async (nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageCostEvaluationId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPost', 'damageCostEvaluationId', damageCostEvaluationId)
            const localVarPath = `/api/v1/damage-cost-evaluations/{damageCostEvaluationId}/damage-corrections/apply`
                .replace(`{${"damageCostEvaluationId"}}`, encodeURIComponent(String(damageCostEvaluationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdDelete: async (nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageCostEvaluationId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdDelete', 'damageCostEvaluationId', damageCostEvaluationId)
            const localVarPath = `/api/v1/damage-cost-evaluations/{damageCostEvaluationId}`
                .replace(`{${"damageCostEvaluationId"}}`, encodeURIComponent(String(damageCostEvaluationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGet: async (nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageCostEvaluationId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGet', 'damageCostEvaluationId', damageCostEvaluationId)
            const localVarPath = `/api/v1/damage-cost-evaluations/{damageCostEvaluationId}/download/pdf`
                .replace(`{${"damageCostEvaluationId"}}`, encodeURIComponent(String(damageCostEvaluationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut: async (nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageCostEvaluationId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut', 'damageCostEvaluationId', damageCostEvaluationId)
            const localVarPath = `/api/v1/damage-cost-evaluations/{damageCostEvaluationId}/external-number`
                .replace(`{${"damageCostEvaluationId"}}`, encodeURIComponent(String(damageCostEvaluationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalExternalNumberInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdGet: async (nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageCostEvaluationId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdGet', 'damageCostEvaluationId', damageCostEvaluationId)
            const localVarPath = `/api/v1/damage-cost-evaluations/{damageCostEvaluationId}`
                .replace(`{${"damageCostEvaluationId"}}`, encodeURIComponent(String(damageCostEvaluationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut: async (nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageCostEvaluationId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut', 'damageCostEvaluationId', damageCostEvaluationId)
            const localVarPath = `/api/v1/damage-cost-evaluations/{damageCostEvaluationId}/notes`
                .replace(`{${"damageCostEvaluationId"}}`, encodeURIComponent(String(damageCostEvaluationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalNotesInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageCostEvaluationUpdateDto} [damageCostEvaluationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdPut: async (nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, damageCostEvaluationUpdateDto?: DamageCostEvaluationUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageCostEvaluationId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdPut', 'damageCostEvaluationId', damageCostEvaluationId)
            const localVarPath = `/api/v1/damage-cost-evaluations/{damageCostEvaluationId}`
                .replace(`{${"damageCostEvaluationId"}}`, encodeURIComponent(String(damageCostEvaluationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCostEvaluationUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGet: async (nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageCostEvaluationId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGet', 'damageCostEvaluationId', damageCostEvaluationId)
            const localVarPath = `/api/v1/damage-cost-evaluations/{damageCostEvaluationId}/repair-specs`
                .replace(`{${"damageCostEvaluationId"}}`, encodeURIComponent(String(damageCostEvaluationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPost: async (nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageCostEvaluationId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPost', 'damageCostEvaluationId', damageCostEvaluationId)
            const localVarPath = `/api/v1/damage-cost-evaluations/{damageCostEvaluationId}/send-to-customer`
                .replace(`{${"damageCostEvaluationId"}}`, encodeURIComponent(String(damageCostEvaluationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageCostEvaluationCompleteDto} [damageCostEvaluationCompleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost: async (nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, damageCostEvaluationCompleteDto?: DamageCostEvaluationCompleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageCostEvaluationId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost', 'damageCostEvaluationId', damageCostEvaluationId)
            const localVarPath = `/api/v1/damage-cost-evaluations/{damageCostEvaluationId}/stage/complete`
                .replace(`{${"damageCostEvaluationId"}}`, encodeURIComponent(String(damageCostEvaluationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCostEvaluationCompleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStageUpdateDtoOfDamageCostEvaluationStage} [generalStageUpdateDtoOfDamageCostEvaluationStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut: async (nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, generalStageUpdateDtoOfDamageCostEvaluationStage?: GeneralStageUpdateDtoOfDamageCostEvaluationStage, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageCostEvaluationId' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut', 'damageCostEvaluationId', damageCostEvaluationId)
            const localVarPath = `/api/v1/damage-cost-evaluations/{damageCostEvaluationId}/stage`
                .replace(`{${"damageCostEvaluationId"}}`, encodeURIComponent(String(damageCostEvaluationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalStageUpdateDtoOfDamageCostEvaluationStage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageCostEvaluationGetPaginatedDto} [damageCostEvaluationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, damageCostEvaluationGetPaginatedDto?: DamageCostEvaluationGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/damage-cost-evaluations/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCostEvaluationGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageCostEvaluationCreateDto} [damageCostEvaluationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, damageCostEvaluationCreateDto?: DamageCostEvaluationCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageCostEvaluationsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/damage-cost-evaluations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCostEvaluationCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DamageCostEvaluationsApi - functional programming interface
 * @export
 */
export const DamageCostEvaluationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DamageCostEvaluationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsByIdsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DamageCostEvaluationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsByIdsGet(nexusOpsTenant, nexusOpsAppVersion, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsByIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCostEvaluationCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut(nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCostEvaluationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut(nexusOpsTenant, damageCostEvaluationId, nexusOpsAppVersion, assignmentAddEntityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddDamageCostEvaluationToContractDto} [addDamageCostEvaluationToContractDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut(nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, addDamageCostEvaluationToContractDto?: AddDamageCostEvaluationToContractDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCostEvaluationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut(nexusOpsTenant, damageCostEvaluationId, nexusOpsAppVersion, addDamageCostEvaluationToContractDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralBillToInfoOfEntityUpdateDto} [generalBillToInfoOfEntityUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut(nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, generalBillToInfoOfEntityUpdateDto?: GeneralBillToInfoOfEntityUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCostEvaluationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut(nexusOpsTenant, damageCostEvaluationId, nexusOpsAppVersion, generalBillToInfoOfEntityUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPost(nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCostEvaluationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPost(nexusOpsTenant, damageCostEvaluationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsDamageCostEvaluationIdDelete(nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsDamageCostEvaluationIdDelete(nexusOpsTenant, damageCostEvaluationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsDamageCostEvaluationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGet(nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGet(nexusOpsTenant, damageCostEvaluationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut(nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCostEvaluationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut(nexusOpsTenant, damageCostEvaluationId, nexusOpsAppVersion, generalExternalNumberInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsDamageCostEvaluationIdGet(nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCostEvaluationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsDamageCostEvaluationIdGet(nexusOpsTenant, damageCostEvaluationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsDamageCostEvaluationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut(nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCostEvaluationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut(nexusOpsTenant, damageCostEvaluationId, nexusOpsAppVersion, generalNotesInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageCostEvaluationUpdateDto} [damageCostEvaluationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsDamageCostEvaluationIdPut(nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, damageCostEvaluationUpdateDto?: DamageCostEvaluationUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCostEvaluationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsDamageCostEvaluationIdPut(nexusOpsTenant, damageCostEvaluationId, nexusOpsAppVersion, damageCostEvaluationUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsDamageCostEvaluationIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGet(nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RepairSpecDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGet(nexusOpsTenant, damageCostEvaluationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPost(nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPost(nexusOpsTenant, damageCostEvaluationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageCostEvaluationCompleteDto} [damageCostEvaluationCompleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost(nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, damageCostEvaluationCompleteDto?: DamageCostEvaluationCompleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCostEvaluationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost(nexusOpsTenant, damageCostEvaluationId, nexusOpsAppVersion, damageCostEvaluationCompleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageCostEvaluationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStageUpdateDtoOfDamageCostEvaluationStage} [generalStageUpdateDtoOfDamageCostEvaluationStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut(nexusOpsTenant: string, damageCostEvaluationId: string, nexusOpsAppVersion?: string, generalStageUpdateDtoOfDamageCostEvaluationStage?: GeneralStageUpdateDtoOfDamageCostEvaluationStage, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCostEvaluationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut(nexusOpsTenant, damageCostEvaluationId, nexusOpsAppVersion, generalStageUpdateDtoOfDamageCostEvaluationStage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageCostEvaluationGetPaginatedDto} [damageCostEvaluationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, damageCostEvaluationGetPaginatedDto?: DamageCostEvaluationGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfDamageCostEvaluationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsGetPost(nexusOpsTenant, nexusOpsAppVersion, damageCostEvaluationGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageCostEvaluationCreateDto} [damageCostEvaluationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageCostEvaluationsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, damageCostEvaluationCreateDto?: DamageCostEvaluationCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCostEvaluationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageCostEvaluationsPost(nexusOpsTenant, nexusOpsAppVersion, damageCostEvaluationCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageCostEvaluationsApi.apiV1DamageCostEvaluationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DamageCostEvaluationsApi - factory interface
 * @export
 */
export const DamageCostEvaluationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DamageCostEvaluationsApiFp(configuration)
    return {
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsBulkDeleteDelete(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DamageCostEvaluationsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsByIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsByIdsGet(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsByIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DamageCostEvaluationDto>> {
            return localVarFp.apiV1DamageCostEvaluationsByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsCountersGet(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageCostEvaluationCountersDto> {
            return localVarFp.apiV1DamageCostEvaluationsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageCostEvaluationDto> {
            return localVarFp.apiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageCostEvaluationDto> {
            return localVarFp.apiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.addDamageCostEvaluationToContractDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageCostEvaluationDto> {
            return localVarFp.apiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.generalBillToInfoOfEntityUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPost(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageCostEvaluationDto> {
            return localVarFp.apiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPost(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdDelete(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DamageCostEvaluationsDamageCostEvaluationIdDelete(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGet(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageCostEvaluationDto> {
            return localVarFp.apiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdGet(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageCostEvaluationDto> {
            return localVarFp.apiV1DamageCostEvaluationsDamageCostEvaluationIdGet(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageCostEvaluationDto> {
            return localVarFp.apiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdPut(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageCostEvaluationDto> {
            return localVarFp.apiV1DamageCostEvaluationsDamageCostEvaluationIdPut(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.damageCostEvaluationUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGet(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RepairSpecDto>> {
            return localVarFp.apiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGet(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPost(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPost(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageCostEvaluationDto> {
            return localVarFp.apiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.damageCostEvaluationCompleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageCostEvaluationDto> {
            return localVarFp.apiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.generalStageUpdateDtoOfDamageCostEvaluationStage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsGetPost(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfDamageCostEvaluationDto> {
            return localVarFp.apiV1DamageCostEvaluationsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageCostEvaluationGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageCostEvaluationsPost(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageCostEvaluationDto> {
            return localVarFp.apiV1DamageCostEvaluationsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageCostEvaluationCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DamageCostEvaluationsBulkDeleteDelete operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsBulkDeleteDeleteRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1DamageCostEvaluationsByIdsGet operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsByIdsGetRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsByIdsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsByIdsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsByIdsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsByIdsGet
     */
    readonly ids?: Array<string>
}

/**
 * Request parameters for apiV1DamageCostEvaluationsCountersGet operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsCountersGetRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPutRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut
     */
    readonly damageCostEvaluationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentAddEntityDto}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut
     */
    readonly assignmentAddEntityDto?: AssignmentAddEntityDto
}

/**
 * Request parameters for apiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPutRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut
     */
    readonly damageCostEvaluationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AddDamageCostEvaluationToContractDto}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut
     */
    readonly addDamageCostEvaluationToContractDto?: AddDamageCostEvaluationToContractDto
}

/**
 * Request parameters for apiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPutRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut
     */
    readonly damageCostEvaluationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralBillToInfoOfEntityUpdateDto}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut
     */
    readonly generalBillToInfoOfEntityUpdateDto?: GeneralBillToInfoOfEntityUpdateDto
}

/**
 * Request parameters for apiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPost operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPostRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPost
     */
    readonly damageCostEvaluationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageCostEvaluationsDamageCostEvaluationIdDelete operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDeleteRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDelete
     */
    readonly damageCostEvaluationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGet operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGetRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGet
     */
    readonly damageCostEvaluationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPutRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut
     */
    readonly damageCostEvaluationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralExternalNumberInputDto}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut
     */
    readonly generalExternalNumberInputDto?: GeneralExternalNumberInputDto
}

/**
 * Request parameters for apiV1DamageCostEvaluationsDamageCostEvaluationIdGet operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdGetRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdGet
     */
    readonly damageCostEvaluationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPutRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut
     */
    readonly damageCostEvaluationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralNotesInputDto}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut
     */
    readonly generalNotesInputDto?: GeneralNotesInputDto
}

/**
 * Request parameters for apiV1DamageCostEvaluationsDamageCostEvaluationIdPut operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdPutRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdPut
     */
    readonly damageCostEvaluationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DamageCostEvaluationUpdateDto}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdPut
     */
    readonly damageCostEvaluationUpdateDto?: DamageCostEvaluationUpdateDto
}

/**
 * Request parameters for apiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGet operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGetRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGet
     */
    readonly damageCostEvaluationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPost operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPostRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPost
     */
    readonly damageCostEvaluationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePostRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost
     */
    readonly damageCostEvaluationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DamageCostEvaluationCompleteDto}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost
     */
    readonly damageCostEvaluationCompleteDto?: DamageCostEvaluationCompleteDto
}

/**
 * Request parameters for apiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStagePutRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut
     */
    readonly damageCostEvaluationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralStageUpdateDtoOfDamageCostEvaluationStage}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut
     */
    readonly generalStageUpdateDtoOfDamageCostEvaluationStage?: GeneralStageUpdateDtoOfDamageCostEvaluationStage
}

/**
 * Request parameters for apiV1DamageCostEvaluationsGetPost operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsGetPostRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DamageCostEvaluationGetPaginatedDto}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsGetPost
     */
    readonly damageCostEvaluationGetPaginatedDto?: DamageCostEvaluationGetPaginatedDto
}

/**
 * Request parameters for apiV1DamageCostEvaluationsPost operation in DamageCostEvaluationsApi.
 * @export
 * @interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsPostRequest
 */
export interface DamageCostEvaluationsApiApiV1DamageCostEvaluationsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DamageCostEvaluationCreateDto}
     * @memberof DamageCostEvaluationsApiApiV1DamageCostEvaluationsPost
     */
    readonly damageCostEvaluationCreateDto?: DamageCostEvaluationCreateDto
}

/**
 * DamageCostEvaluationsApi - object-oriented interface
 * @export
 * @class DamageCostEvaluationsApi
 * @extends {BaseAPI}
 */
export class DamageCostEvaluationsApi extends BaseAPI {
    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsBulkDeleteDelete(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsByIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsByIdsGet(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsByIdsGetRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsCountersGet(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsCountersGetRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPutRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsDamageCostEvaluationIdAddAssignmentPut(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPutRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsDamageCostEvaluationIdAddContractPut(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.addDamageCostEvaluationToContractDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPutRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsDamageCostEvaluationIdBillToInfoPut(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.generalBillToInfoOfEntityUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPost(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPostRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsDamageCostEvaluationIdDamageCorrectionsApplyPost(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsDamageCostEvaluationIdDelete(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsDamageCostEvaluationIdDelete(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGet(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsDamageCostEvaluationIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPutRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsDamageCostEvaluationIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsDamageCostEvaluationIdGet(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdGetRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsDamageCostEvaluationIdGet(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPutRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsDamageCostEvaluationIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsDamageCostEvaluationIdPut(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdPutRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsDamageCostEvaluationIdPut(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.damageCostEvaluationUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGet(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGetRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsDamageCostEvaluationIdRepairSpecsGet(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPost(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPostRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsDamageCostEvaluationIdSendToCustomerPost(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePostRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsDamageCostEvaluationIdStageCompletePost(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.damageCostEvaluationCompleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsDamageCostEvaluationIdStagePutRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsDamageCostEvaluationIdStagePut(requestParameters.nexusOpsTenant, requestParameters.damageCostEvaluationId, requestParameters.nexusOpsAppVersion, requestParameters.generalStageUpdateDtoOfDamageCostEvaluationStage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsGetPost(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsGetPostRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageCostEvaluationGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageCostEvaluationsApiApiV1DamageCostEvaluationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageCostEvaluationsApi
     */
    public apiV1DamageCostEvaluationsPost(requestParameters: DamageCostEvaluationsApiApiV1DamageCostEvaluationsPostRequest, options?: RawAxiosRequestConfig) {
        return DamageCostEvaluationsApiFp(this.configuration).apiV1DamageCostEvaluationsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageCostEvaluationCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DamageDetectionAggregatesApi - axios parameter creator
 * @export
 */
export const DamageDetectionAggregatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsAggregatesAggregateIdDelete: async (nexusOpsTenant: string, aggregateId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsAggregatesAggregateIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'aggregateId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsAggregatesAggregateIdDelete', 'aggregateId', aggregateId)
            const localVarPath = `/api/v1/damage-detections/aggregates/{aggregateId}`
                .replace(`{${"aggregateId"}}`, encodeURIComponent(String(aggregateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGet: async (nexusOpsTenant: string, aggregateId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'aggregateId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGet', 'aggregateId', aggregateId)
            const localVarPath = `/api/v1/damage-detections/aggregates/{aggregateId}/download/pdf`
                .replace(`{${"aggregateId"}}`, encodeURIComponent(String(aggregateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsAggregatesAggregateIdGet: async (nexusOpsTenant: string, aggregateId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsAggregatesAggregateIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'aggregateId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsAggregatesAggregateIdGet', 'aggregateId', aggregateId)
            const localVarPath = `/api/v1/damage-detections/aggregates/{aggregateId}`
                .replace(`{${"aggregateId"}}`, encodeURIComponent(String(aggregateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} itemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete: async (nexusOpsTenant: string, aggregateId: string, itemId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'aggregateId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete', 'aggregateId', aggregateId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete', 'itemId', itemId)
            const localVarPath = `/api/v1/damage-detections/aggregates/{aggregateId}/items/{itemId}`
                .replace(`{${"aggregateId"}}`, encodeURIComponent(String(aggregateId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {StartCostEvaluationDto} [startCostEvaluationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost: async (nexusOpsTenant: string, aggregateId: string, nexusOpsAppVersion?: string, startCostEvaluationDto?: StartCostEvaluationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'aggregateId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost', 'aggregateId', aggregateId)
            const localVarPath = `/api/v1/damage-detections/aggregates/{aggregateId}/start-cost-evaluation`
                .replace(`{${"aggregateId"}}`, encodeURIComponent(String(aggregateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCostEvaluationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageDetectionAggregateGetPaginatedDto} [damageDetectionAggregateGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsAggregatesGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, damageDetectionAggregateGetPaginatedDto?: DamageDetectionAggregateGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsAggregatesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/damage-detections/aggregates/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageDetectionAggregateGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageDetectionAggregateSearchPaginatedDto} [damageDetectionAggregateSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsAggregatesSearchPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, damageDetectionAggregateSearchPaginatedDto?: DamageDetectionAggregateSearchPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsAggregatesSearchPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/damage-detections/aggregates/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageDetectionAggregateSearchPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DamageDetectionAggregatesApi - functional programming interface
 * @export
 */
export const DamageDetectionAggregatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DamageDetectionAggregatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsAggregatesAggregateIdDelete(nexusOpsTenant: string, aggregateId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsAggregatesAggregateIdDelete(nexusOpsTenant, aggregateId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionAggregatesApi.apiV1DamageDetectionsAggregatesAggregateIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGet(nexusOpsTenant: string, aggregateId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGet(nexusOpsTenant, aggregateId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionAggregatesApi.apiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsAggregatesAggregateIdGet(nexusOpsTenant: string, aggregateId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionAggregateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsAggregatesAggregateIdGet(nexusOpsTenant, aggregateId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionAggregatesApi.apiV1DamageDetectionsAggregatesAggregateIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} itemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete(nexusOpsTenant: string, aggregateId: string, itemId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionAggregateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete(nexusOpsTenant, aggregateId, itemId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionAggregatesApi.apiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} aggregateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {StartCostEvaluationDto} [startCostEvaluationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost(nexusOpsTenant: string, aggregateId: string, nexusOpsAppVersion?: string, startCostEvaluationDto?: StartCostEvaluationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartCostEvaluationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost(nexusOpsTenant, aggregateId, nexusOpsAppVersion, startCostEvaluationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionAggregatesApi.apiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageDetectionAggregateGetPaginatedDto} [damageDetectionAggregateGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsAggregatesGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, damageDetectionAggregateGetPaginatedDto?: DamageDetectionAggregateGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfDamageDetectionAggregateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsAggregatesGetPost(nexusOpsTenant, nexusOpsAppVersion, damageDetectionAggregateGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionAggregatesApi.apiV1DamageDetectionsAggregatesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageDetectionAggregateSearchPaginatedDto} [damageDetectionAggregateSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsAggregatesSearchPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, damageDetectionAggregateSearchPaginatedDto?: DamageDetectionAggregateSearchPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfDamageDetectionAggregateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsAggregatesSearchPost(nexusOpsTenant, nexusOpsAppVersion, damageDetectionAggregateSearchPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionAggregatesApi.apiV1DamageDetectionsAggregatesSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DamageDetectionAggregatesApi - factory interface
 * @export
 */
export const DamageDetectionAggregatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DamageDetectionAggregatesApiFp(configuration)
    return {
        /**
         * 
         * @param {DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsAggregatesAggregateIdDelete(requestParameters: DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DamageDetectionsAggregatesAggregateIdDelete(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGet(requestParameters: DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsAggregatesAggregateIdGet(requestParameters: DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionAggregateDto> {
            return localVarFp.apiV1DamageDetectionsAggregatesAggregateIdGet(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete(requestParameters: DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionAggregateDto> {
            return localVarFp.apiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.itemId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost(requestParameters: DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartCostEvaluationResponseDto> {
            return localVarFp.apiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.nexusOpsAppVersion, requestParameters.startCostEvaluationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsAggregatesGetPost(requestParameters: DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfDamageDetectionAggregateDto> {
            return localVarFp.apiV1DamageDetectionsAggregatesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageDetectionAggregateGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsAggregatesSearchPost(requestParameters: DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesSearchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfDamageDetectionAggregateDto> {
            return localVarFp.apiV1DamageDetectionsAggregatesSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageDetectionAggregateSearchPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DamageDetectionsAggregatesAggregateIdDelete operation in DamageDetectionAggregatesApi.
 * @export
 * @interface DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDeleteRequest
 */
export interface DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDelete
     */
    readonly aggregateId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGet operation in DamageDetectionAggregatesApi.
 * @export
 * @interface DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGetRequest
 */
export interface DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGet
     */
    readonly aggregateId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageDetectionsAggregatesAggregateIdGet operation in DamageDetectionAggregatesApi.
 * @export
 * @interface DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdGetRequest
 */
export interface DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdGet
     */
    readonly aggregateId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete operation in DamageDetectionAggregatesApi.
 * @export
 * @interface DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDeleteRequest
 */
export interface DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete
     */
    readonly aggregateId: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete
     */
    readonly itemId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost operation in DamageDetectionAggregatesApi.
 * @export
 * @interface DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPostRequest
 */
export interface DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost
     */
    readonly aggregateId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {StartCostEvaluationDto}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost
     */
    readonly startCostEvaluationDto?: StartCostEvaluationDto
}

/**
 * Request parameters for apiV1DamageDetectionsAggregatesGetPost operation in DamageDetectionAggregatesApi.
 * @export
 * @interface DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesGetPostRequest
 */
export interface DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DamageDetectionAggregateGetPaginatedDto}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesGetPost
     */
    readonly damageDetectionAggregateGetPaginatedDto?: DamageDetectionAggregateGetPaginatedDto
}

/**
 * Request parameters for apiV1DamageDetectionsAggregatesSearchPost operation in DamageDetectionAggregatesApi.
 * @export
 * @interface DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesSearchPostRequest
 */
export interface DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesSearchPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesSearchPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesSearchPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DamageDetectionAggregateSearchPaginatedDto}
     * @memberof DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesSearchPost
     */
    readonly damageDetectionAggregateSearchPaginatedDto?: DamageDetectionAggregateSearchPaginatedDto
}

/**
 * DamageDetectionAggregatesApi - object-oriented interface
 * @export
 * @class DamageDetectionAggregatesApi
 * @extends {BaseAPI}
 */
export class DamageDetectionAggregatesApi extends BaseAPI {
    /**
     * 
     * @param {DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionAggregatesApi
     */
    public apiV1DamageDetectionsAggregatesAggregateIdDelete(requestParameters: DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionAggregatesApiFp(this.configuration).apiV1DamageDetectionsAggregatesAggregateIdDelete(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionAggregatesApi
     */
    public apiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGet(requestParameters: DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionAggregatesApiFp(this.configuration).apiV1DamageDetectionsAggregatesAggregateIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionAggregatesApi
     */
    public apiV1DamageDetectionsAggregatesAggregateIdGet(requestParameters: DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdGetRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionAggregatesApiFp(this.configuration).apiV1DamageDetectionsAggregatesAggregateIdGet(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionAggregatesApi
     */
    public apiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete(requestParameters: DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionAggregatesApiFp(this.configuration).apiV1DamageDetectionsAggregatesAggregateIdItemsItemIdDelete(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.itemId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionAggregatesApi
     */
    public apiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost(requestParameters: DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPostRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionAggregatesApiFp(this.configuration).apiV1DamageDetectionsAggregatesAggregateIdStartCostEvaluationPost(requestParameters.nexusOpsTenant, requestParameters.aggregateId, requestParameters.nexusOpsAppVersion, requestParameters.startCostEvaluationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionAggregatesApi
     */
    public apiV1DamageDetectionsAggregatesGetPost(requestParameters: DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesGetPostRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionAggregatesApiFp(this.configuration).apiV1DamageDetectionsAggregatesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageDetectionAggregateGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionAggregatesApi
     */
    public apiV1DamageDetectionsAggregatesSearchPost(requestParameters: DamageDetectionAggregatesApiApiV1DamageDetectionsAggregatesSearchPostRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionAggregatesApiFp(this.configuration).apiV1DamageDetectionsAggregatesSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageDetectionAggregateSearchPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DamageDetectionsApi - axios parameter creator
 * @export
 */
export const DamageDetectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageDetectionBulkDeleteDto} [damageDetectionBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, damageDetectionBulkDeleteDto?: DamageDetectionBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/damage-detections/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageDetectionBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsByIdsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsByIdsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/damage-detections/by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/damage-detections/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdAddAssignmentPost: async (nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdAddAssignmentPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdAddAssignmentPost', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/damage-detections/{damageDetectionId}/add-assignment`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentAddEntityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddDamageDetectionToContractDto} [addDamageDetectionToContractDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdAddToContractPost: async (nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, addDamageDetectionToContractDto?: AddDamageDetectionToContractDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdAddToContractPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdAddToContractPost', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/damage-detections/{damageDetectionId}/add-to-contract`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDamageDetectionToContractDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {DamageDetectionDeleteDto} [damageDetectionDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdDelete: async (nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, damageDetectionDeleteDto?: DamageDetectionDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdDelete', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/damage-detections/{damageDetectionId}`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageDetectionDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdDownloadPdfGet: async (nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdDownloadPdfGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdDownloadPdfGet', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/damage-detections/{damageDetectionId}/download/pdf`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdExternalNumberPut: async (nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdExternalNumberPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdExternalNumberPut', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/damage-detections/{damageDetectionId}/external-number`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalExternalNumberInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdGet: async (nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdGet', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/damage-detections/{damageDetectionId}`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageDetectionMigrateToNewVisualModelDto} [damageDetectionMigrateToNewVisualModelDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost: async (nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, damageDetectionMigrateToNewVisualModelDto?: DamageDetectionMigrateToNewVisualModelDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/damage-detections/{damageDetectionId}/migrate-to-new-visual-model`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageDetectionMigrateToNewVisualModelDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleMileageDto} [updateVehicleMileageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdMileagePut: async (nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, updateVehicleMileageDto?: UpdateVehicleMileageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdMileagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdMileagePut', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/damage-detections/{damageDetectionId}/mileage`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVehicleMileageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdNotesPut: async (nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdNotesPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdNotesPut', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/damage-detections/{damageDetectionId}/notes`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalNotesInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateDamageDetectionDto} [updateDamageDetectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdPut: async (nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, updateDamageDetectionDto?: UpdateDamageDetectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdPut', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/damage-detections/{damageDetectionId}`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDamageDetectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdSendToCustomerPost: async (nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdSendToCustomerPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdSendToCustomerPost', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/damage-detections/{damageDetectionId}/send-to-customer`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageDetectionSendToExternalDamageCostEvaluationDto} [damageDetectionSendToExternalDamageCostEvaluationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost: async (nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, damageDetectionSendToExternalDamageCostEvaluationDto?: DamageDetectionSendToExternalDamageCostEvaluationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/damage-detections/{damageDetectionId}/send-to-external-damage-cost-evaluation`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageDetectionSendToExternalDamageCostEvaluationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageDetectionGetPaginatedDto} [damageDetectionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, damageDetectionGetPaginatedDto?: DamageDetectionGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/damage-detections/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageDetectionGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateDamageDetectionDto} [createDamageDetectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createDamageDetectionDto?: CreateDamageDetectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DamageDetectionsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/damage-detections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDamageDetectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DamageDetectionsApi - functional programming interface
 * @export
 */
export const DamageDetectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DamageDetectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageDetectionBulkDeleteDto} [damageDetectionBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, damageDetectionBulkDeleteDto?: DamageDetectionBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, damageDetectionBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsByIdsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DamageDetectionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsByIdsGet(nexusOpsTenant, nexusOpsAppVersion, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsByIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsDamageDetectionIdAddAssignmentPost(nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsDamageDetectionIdAddAssignmentPost(nexusOpsTenant, damageDetectionId, nexusOpsAppVersion, assignmentAddEntityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsDamageDetectionIdAddAssignmentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddDamageDetectionToContractDto} [addDamageDetectionToContractDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsDamageDetectionIdAddToContractPost(nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, addDamageDetectionToContractDto?: AddDamageDetectionToContractDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsDamageDetectionIdAddToContractPost(nexusOpsTenant, damageDetectionId, nexusOpsAppVersion, addDamageDetectionToContractDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsDamageDetectionIdAddToContractPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {DamageDetectionDeleteDto} [damageDetectionDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsDamageDetectionIdDelete(nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, damageDetectionDeleteDto?: DamageDetectionDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsDamageDetectionIdDelete(nexusOpsTenant, damageDetectionId, nexusOpsAppVersion, isDeleteCascade, damageDetectionDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsDamageDetectionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsDamageDetectionIdDownloadPdfGet(nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsDamageDetectionIdDownloadPdfGet(nexusOpsTenant, damageDetectionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsDamageDetectionIdDownloadPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsDamageDetectionIdExternalNumberPut(nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsDamageDetectionIdExternalNumberPut(nexusOpsTenant, damageDetectionId, nexusOpsAppVersion, generalExternalNumberInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsDamageDetectionIdExternalNumberPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsDamageDetectionIdGet(nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsDamageDetectionIdGet(nexusOpsTenant, damageDetectionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsDamageDetectionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageDetectionMigrateToNewVisualModelDto} [damageDetectionMigrateToNewVisualModelDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost(nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, damageDetectionMigrateToNewVisualModelDto?: DamageDetectionMigrateToNewVisualModelDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost(nexusOpsTenant, damageDetectionId, nexusOpsAppVersion, damageDetectionMigrateToNewVisualModelDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleMileageDto} [updateVehicleMileageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsDamageDetectionIdMileagePut(nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, updateVehicleMileageDto?: UpdateVehicleMileageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsDamageDetectionIdMileagePut(nexusOpsTenant, damageDetectionId, nexusOpsAppVersion, updateVehicleMileageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsDamageDetectionIdMileagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsDamageDetectionIdNotesPut(nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsDamageDetectionIdNotesPut(nexusOpsTenant, damageDetectionId, nexusOpsAppVersion, generalNotesInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsDamageDetectionIdNotesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateDamageDetectionDto} [updateDamageDetectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsDamageDetectionIdPut(nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, updateDamageDetectionDto?: UpdateDamageDetectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsDamageDetectionIdPut(nexusOpsTenant, damageDetectionId, nexusOpsAppVersion, updateDamageDetectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsDamageDetectionIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsDamageDetectionIdSendToCustomerPost(nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsDamageDetectionIdSendToCustomerPost(nexusOpsTenant, damageDetectionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsDamageDetectionIdSendToCustomerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageDetectionSendToExternalDamageCostEvaluationDto} [damageDetectionSendToExternalDamageCostEvaluationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost(nexusOpsTenant: string, damageDetectionId: string, nexusOpsAppVersion?: string, damageDetectionSendToExternalDamageCostEvaluationDto?: DamageDetectionSendToExternalDamageCostEvaluationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionSendToExternalDamageCostEvaluationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost(nexusOpsTenant, damageDetectionId, nexusOpsAppVersion, damageDetectionSendToExternalDamageCostEvaluationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageDetectionGetPaginatedDto} [damageDetectionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, damageDetectionGetPaginatedDto?: DamageDetectionGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfDamageDetectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsGetPost(nexusOpsTenant, nexusOpsAppVersion, damageDetectionGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateDamageDetectionDto} [createDamageDetectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DamageDetectionsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createDamageDetectionDto?: CreateDamageDetectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DamageDetectionsPost(nexusOpsTenant, nexusOpsAppVersion, createDamageDetectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsApi.apiV1DamageDetectionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DamageDetectionsApi - factory interface
 * @export
 */
export const DamageDetectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DamageDetectionsApiFp(configuration)
    return {
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsBulkDeleteDelete(requestParameters: DamageDetectionsApiApiV1DamageDetectionsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DamageDetectionsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageDetectionBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsByIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsByIdsGet(requestParameters: DamageDetectionsApiApiV1DamageDetectionsByIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DamageDetectionDto>> {
            return localVarFp.apiV1DamageDetectionsByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsCountersGet(requestParameters: DamageDetectionsApiApiV1DamageDetectionsCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionCountersDto> {
            return localVarFp.apiV1DamageDetectionsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddAssignmentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdAddAssignmentPost(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddAssignmentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionDto> {
            return localVarFp.apiV1DamageDetectionsDamageDetectionIdAddAssignmentPost(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddToContractPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdAddToContractPost(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddToContractPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionDto> {
            return localVarFp.apiV1DamageDetectionsDamageDetectionIdAddToContractPost(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.addDamageDetectionToContractDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdDelete(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DamageDetectionsDamageDetectionIdDelete(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, requestParameters.damageDetectionDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDownloadPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdDownloadPdfGet(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1DamageDetectionsDamageDetectionIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdExternalNumberPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdExternalNumberPut(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdExternalNumberPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionDto> {
            return localVarFp.apiV1DamageDetectionsDamageDetectionIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdGet(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionDto> {
            return localVarFp.apiV1DamageDetectionsDamageDetectionIdGet(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionDto> {
            return localVarFp.apiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.damageDetectionMigrateToNewVisualModelDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMileagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdMileagePut(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMileagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionDto> {
            return localVarFp.apiV1DamageDetectionsDamageDetectionIdMileagePut(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleMileageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdNotesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdNotesPut(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdNotesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionDto> {
            return localVarFp.apiV1DamageDetectionsDamageDetectionIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdPut(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionDto> {
            return localVarFp.apiV1DamageDetectionsDamageDetectionIdPut(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.updateDamageDetectionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToCustomerPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdSendToCustomerPost(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToCustomerPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DamageDetectionsDamageDetectionIdSendToCustomerPost(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionSendToExternalDamageCostEvaluationResultDto> {
            return localVarFp.apiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.damageDetectionSendToExternalDamageCostEvaluationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsGetPost(requestParameters: DamageDetectionsApiApiV1DamageDetectionsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfDamageDetectionDto> {
            return localVarFp.apiV1DamageDetectionsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageDetectionGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsApiApiV1DamageDetectionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DamageDetectionsPost(requestParameters: DamageDetectionsApiApiV1DamageDetectionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionDto> {
            return localVarFp.apiV1DamageDetectionsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createDamageDetectionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DamageDetectionsBulkDeleteDelete operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsBulkDeleteDeleteRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DamageDetectionBulkDeleteDto}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsBulkDeleteDelete
     */
    readonly damageDetectionBulkDeleteDto?: DamageDetectionBulkDeleteDto
}

/**
 * Request parameters for apiV1DamageDetectionsByIdsGet operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsByIdsGetRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsByIdsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsByIdsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsByIdsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsByIdsGet
     */
    readonly ids?: Array<string>
}

/**
 * Request parameters for apiV1DamageDetectionsCountersGet operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsCountersGetRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageDetectionsDamageDetectionIdAddAssignmentPost operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddAssignmentPostRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddAssignmentPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddAssignmentPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddAssignmentPost
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddAssignmentPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentAddEntityDto}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddAssignmentPost
     */
    readonly assignmentAddEntityDto?: AssignmentAddEntityDto
}

/**
 * Request parameters for apiV1DamageDetectionsDamageDetectionIdAddToContractPost operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddToContractPostRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddToContractPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddToContractPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddToContractPost
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddToContractPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AddDamageDetectionToContractDto}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddToContractPost
     */
    readonly addDamageDetectionToContractDto?: AddDamageDetectionToContractDto
}

/**
 * Request parameters for apiV1DamageDetectionsDamageDetectionIdDelete operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDeleteRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDelete
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDelete
     */
    readonly isDeleteCascade?: boolean

    /**
     * 
     * @type {DamageDetectionDeleteDto}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDelete
     */
    readonly damageDetectionDeleteDto?: DamageDetectionDeleteDto
}

/**
 * Request parameters for apiV1DamageDetectionsDamageDetectionIdDownloadPdfGet operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDownloadPdfGetRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDownloadPdfGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDownloadPdfGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDownloadPdfGet
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDownloadPdfGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageDetectionsDamageDetectionIdExternalNumberPut operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdExternalNumberPutRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdExternalNumberPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdExternalNumberPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdExternalNumberPut
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdExternalNumberPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralExternalNumberInputDto}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdExternalNumberPut
     */
    readonly generalExternalNumberInputDto?: GeneralExternalNumberInputDto
}

/**
 * Request parameters for apiV1DamageDetectionsDamageDetectionIdGet operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdGetRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdGet
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPostRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DamageDetectionMigrateToNewVisualModelDto}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost
     */
    readonly damageDetectionMigrateToNewVisualModelDto?: DamageDetectionMigrateToNewVisualModelDto
}

/**
 * Request parameters for apiV1DamageDetectionsDamageDetectionIdMileagePut operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMileagePutRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMileagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMileagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMileagePut
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMileagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateVehicleMileageDto}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMileagePut
     */
    readonly updateVehicleMileageDto?: UpdateVehicleMileageDto
}

/**
 * Request parameters for apiV1DamageDetectionsDamageDetectionIdNotesPut operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdNotesPutRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdNotesPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdNotesPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdNotesPut
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdNotesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralNotesInputDto}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdNotesPut
     */
    readonly generalNotesInputDto?: GeneralNotesInputDto
}

/**
 * Request parameters for apiV1DamageDetectionsDamageDetectionIdPut operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdPutRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdPut
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateDamageDetectionDto}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdPut
     */
    readonly updateDamageDetectionDto?: UpdateDamageDetectionDto
}

/**
 * Request parameters for apiV1DamageDetectionsDamageDetectionIdSendToCustomerPost operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToCustomerPostRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToCustomerPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToCustomerPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToCustomerPost
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToCustomerPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPostRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DamageDetectionSendToExternalDamageCostEvaluationDto}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost
     */
    readonly damageDetectionSendToExternalDamageCostEvaluationDto?: DamageDetectionSendToExternalDamageCostEvaluationDto
}

/**
 * Request parameters for apiV1DamageDetectionsGetPost operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsGetPostRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DamageDetectionGetPaginatedDto}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsGetPost
     */
    readonly damageDetectionGetPaginatedDto?: DamageDetectionGetPaginatedDto
}

/**
 * Request parameters for apiV1DamageDetectionsPost operation in DamageDetectionsApi.
 * @export
 * @interface DamageDetectionsApiApiV1DamageDetectionsPostRequest
 */
export interface DamageDetectionsApiApiV1DamageDetectionsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateDamageDetectionDto}
     * @memberof DamageDetectionsApiApiV1DamageDetectionsPost
     */
    readonly createDamageDetectionDto?: CreateDamageDetectionDto
}

/**
 * DamageDetectionsApi - object-oriented interface
 * @export
 * @class DamageDetectionsApi
 * @extends {BaseAPI}
 */
export class DamageDetectionsApi extends BaseAPI {
    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsBulkDeleteDelete(requestParameters: DamageDetectionsApiApiV1DamageDetectionsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageDetectionBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsByIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsByIdsGet(requestParameters: DamageDetectionsApiApiV1DamageDetectionsByIdsGetRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsCountersGet(requestParameters: DamageDetectionsApiApiV1DamageDetectionsCountersGetRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddAssignmentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsDamageDetectionIdAddAssignmentPost(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddAssignmentPostRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsDamageDetectionIdAddAssignmentPost(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddToContractPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsDamageDetectionIdAddToContractPost(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdAddToContractPostRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsDamageDetectionIdAddToContractPost(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.addDamageDetectionToContractDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsDamageDetectionIdDelete(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsDamageDetectionIdDelete(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, requestParameters.damageDetectionDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDownloadPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsDamageDetectionIdDownloadPdfGet(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsDamageDetectionIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdExternalNumberPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsDamageDetectionIdExternalNumberPut(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdExternalNumberPutRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsDamageDetectionIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsDamageDetectionIdGet(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdGetRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsDamageDetectionIdGet(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPostRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsDamageDetectionIdMigrateToNewVisualModelPost(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.damageDetectionMigrateToNewVisualModelDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMileagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsDamageDetectionIdMileagePut(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdMileagePutRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsDamageDetectionIdMileagePut(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleMileageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdNotesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsDamageDetectionIdNotesPut(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdNotesPutRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsDamageDetectionIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsDamageDetectionIdPut(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdPutRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsDamageDetectionIdPut(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.updateDamageDetectionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToCustomerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsDamageDetectionIdSendToCustomerPost(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToCustomerPostRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsDamageDetectionIdSendToCustomerPost(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost(requestParameters: DamageDetectionsApiApiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPostRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsDamageDetectionIdSendToExternalDamageCostEvaluationPost(requestParameters.nexusOpsTenant, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.damageDetectionSendToExternalDamageCostEvaluationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsGetPost(requestParameters: DamageDetectionsApiApiV1DamageDetectionsGetPostRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.damageDetectionGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsApiApiV1DamageDetectionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsApi
     */
    public apiV1DamageDetectionsPost(requestParameters: DamageDetectionsApiApiV1DamageDetectionsPostRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsApiFp(this.configuration).apiV1DamageDetectionsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createDamageDetectionDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DamageDetectionsAdminApi - axios parameter creator
 * @export
 */
export const DamageDetectionsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {AttachmentsUpdateDto} [attachmentsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPut: async (damageDetectionId: string, nexusOpsAppVersion?: string, tenantId?: string, attachmentsUpdateDto?: AttachmentsUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPut', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/admin/damage-detections/{damageDetectionId}/attachments`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attachmentsUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGet: async (damageDetectionId: string, nexusOpsAppVersion?: string, tenantId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGet', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/admin/damage-detections/{damageDetectionId}/download/pdf`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminDamageDetectionsDamageDetectionIdGet: async (damageDetectionId: string, nexusOpsAppVersion?: string, tenantId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1AdminDamageDetectionsDamageDetectionIdGet', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/admin/damage-detections/{damageDetectionId}`
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} damageDetectionItemId 
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {AttachmentsUpdateDto} [attachmentsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut: async (damageDetectionItemId: string, damageDetectionId: string, nexusOpsAppVersion?: string, tenantId?: string, attachmentsUpdateDto?: AttachmentsUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageDetectionItemId' is not null or undefined
            assertParamExists('apiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut', 'damageDetectionItemId', damageDetectionItemId)
            // verify required parameter 'damageDetectionId' is not null or undefined
            assertParamExists('apiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut', 'damageDetectionId', damageDetectionId)
            const localVarPath = `/api/v1/admin/damage-detections/{damageDetectionId}/items/{damageDetectionItemId}/attachments`
                .replace(`{${"damageDetectionItemId"}}`, encodeURIComponent(String(damageDetectionItemId)))
                .replace(`{${"damageDetectionId"}}`, encodeURIComponent(String(damageDetectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attachmentsUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminDamageDetectionGetPaginatedDto} [adminDamageDetectionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminDamageDetectionsGetPost: async (nexusOpsAppVersion?: string, adminDamageDetectionGetPaginatedDto?: AdminDamageDetectionGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/damage-detections/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminDamageDetectionGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DamageDetectionsAdminApi - functional programming interface
 * @export
 */
export const DamageDetectionsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DamageDetectionsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {AttachmentsUpdateDto} [attachmentsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPut(damageDetectionId: string, nexusOpsAppVersion?: string, tenantId?: string, attachmentsUpdateDto?: AttachmentsUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPut(damageDetectionId, nexusOpsAppVersion, tenantId, attachmentsUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsAdminApi.apiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGet(damageDetectionId: string, nexusOpsAppVersion?: string, tenantId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGet(damageDetectionId, nexusOpsAppVersion, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsAdminApi.apiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminDamageDetectionsDamageDetectionIdGet(damageDetectionId: string, nexusOpsAppVersion?: string, tenantId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminDamageDetectionsDamageDetectionIdGet(damageDetectionId, nexusOpsAppVersion, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsAdminApi.apiV1AdminDamageDetectionsDamageDetectionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} damageDetectionItemId 
         * @param {string} damageDetectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {AttachmentsUpdateDto} [attachmentsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut(damageDetectionItemId: string, damageDetectionId: string, nexusOpsAppVersion?: string, tenantId?: string, attachmentsUpdateDto?: AttachmentsUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageDetectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut(damageDetectionItemId, damageDetectionId, nexusOpsAppVersion, tenantId, attachmentsUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsAdminApi.apiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminDamageDetectionGetPaginatedDto} [adminDamageDetectionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminDamageDetectionsGetPost(nexusOpsAppVersion?: string, adminDamageDetectionGetPaginatedDto?: AdminDamageDetectionGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfDamageDetectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminDamageDetectionsGetPost(nexusOpsAppVersion, adminDamageDetectionGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageDetectionsAdminApi.apiV1AdminDamageDetectionsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DamageDetectionsAdminApi - factory interface
 * @export
 */
export const DamageDetectionsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DamageDetectionsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPut(requestParameters: DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionDto> {
            return localVarFp.apiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPut(requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.attachmentsUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGet(requestParameters: DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGet(requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminDamageDetectionsDamageDetectionIdGet(requestParameters: DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionDto> {
            return localVarFp.apiV1AdminDamageDetectionsDamageDetectionIdGet(requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut(requestParameters: DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageDetectionDto> {
            return localVarFp.apiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut(requestParameters.damageDetectionItemId, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.attachmentsUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageDetectionsAdminApiApiV1AdminDamageDetectionsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminDamageDetectionsGetPost(requestParameters: DamageDetectionsAdminApiApiV1AdminDamageDetectionsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfDamageDetectionDto> {
            return localVarFp.apiV1AdminDamageDetectionsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminDamageDetectionGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPut operation in DamageDetectionsAdminApi.
 * @export
 * @interface DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPutRequest
 */
export interface DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPutRequest {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPut
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPut
     */
    readonly tenantId?: string

    /**
     * 
     * @type {AttachmentsUpdateDto}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPut
     */
    readonly attachmentsUpdateDto?: AttachmentsUpdateDto
}

/**
 * Request parameters for apiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGet operation in DamageDetectionsAdminApi.
 * @export
 * @interface DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGetRequest
 */
export interface DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGet
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGet
     */
    readonly tenantId?: string
}

/**
 * Request parameters for apiV1AdminDamageDetectionsDamageDetectionIdGet operation in DamageDetectionsAdminApi.
 * @export
 * @interface DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdGetRequest
 */
export interface DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdGet
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdGet
     */
    readonly tenantId?: string
}

/**
 * Request parameters for apiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut operation in DamageDetectionsAdminApi.
 * @export
 * @interface DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPutRequest
 */
export interface DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPutRequest {
    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut
     */
    readonly damageDetectionItemId: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut
     */
    readonly damageDetectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut
     */
    readonly tenantId?: string

    /**
     * 
     * @type {AttachmentsUpdateDto}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut
     */
    readonly attachmentsUpdateDto?: AttachmentsUpdateDto
}

/**
 * Request parameters for apiV1AdminDamageDetectionsGetPost operation in DamageDetectionsAdminApi.
 * @export
 * @interface DamageDetectionsAdminApiApiV1AdminDamageDetectionsGetPostRequest
 */
export interface DamageDetectionsAdminApiApiV1AdminDamageDetectionsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminDamageDetectionGetPaginatedDto}
     * @memberof DamageDetectionsAdminApiApiV1AdminDamageDetectionsGetPost
     */
    readonly adminDamageDetectionGetPaginatedDto?: AdminDamageDetectionGetPaginatedDto
}

/**
 * DamageDetectionsAdminApi - object-oriented interface
 * @export
 * @class DamageDetectionsAdminApi
 * @extends {BaseAPI}
 */
export class DamageDetectionsAdminApi extends BaseAPI {
    /**
     * 
     * @param {DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsAdminApi
     */
    public apiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPut(requestParameters: DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPutRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsAdminApiFp(this.configuration).apiV1AdminDamageDetectionsDamageDetectionIdAttachmentsPut(requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.attachmentsUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsAdminApi
     */
    public apiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGet(requestParameters: DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsAdminApiFp(this.configuration).apiV1AdminDamageDetectionsDamageDetectionIdDownloadPdfGet(requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsAdminApi
     */
    public apiV1AdminDamageDetectionsDamageDetectionIdGet(requestParameters: DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdGetRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsAdminApiFp(this.configuration).apiV1AdminDamageDetectionsDamageDetectionIdGet(requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsAdminApi
     */
    public apiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut(requestParameters: DamageDetectionsAdminApiApiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPutRequest, options?: RawAxiosRequestConfig) {
        return DamageDetectionsAdminApiFp(this.configuration).apiV1AdminDamageDetectionsDamageDetectionIdItemsDamageDetectionItemIdAttachmentsPut(requestParameters.damageDetectionItemId, requestParameters.damageDetectionId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.attachmentsUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageDetectionsAdminApiApiV1AdminDamageDetectionsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageDetectionsAdminApi
     */
    public apiV1AdminDamageDetectionsGetPost(requestParameters: DamageDetectionsAdminApiApiV1AdminDamageDetectionsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DamageDetectionsAdminApiFp(this.configuration).apiV1AdminDamageDetectionsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminDamageDetectionGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DamageTypesApi - axios parameter creator
 * @export
 */
export const DamageTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} damageTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataDamageTypesDamageTypeIdGet: async (damageTypeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageTypeId' is not null or undefined
            assertParamExists('apiV1ReferenceDataDamageTypesDamageTypeIdGet', 'damageTypeId', damageTypeId)
            const localVarPath = `/api/v1/reference-data/damage-types/{damageTypeId}`
                .replace(`{${"damageTypeId"}}`, encodeURIComponent(String(damageTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageTypeGetPaginatedDto} [damageTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataDamageTypesGetPost: async (nexusOpsAppVersion?: string, damageTypeGetPaginatedDto?: DamageTypeGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/damage-types/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageTypeGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DamageTypesApi - functional programming interface
 * @export
 */
export const DamageTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DamageTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} damageTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataDamageTypesDamageTypeIdGet(damageTypeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataDamageTypesDamageTypeIdGet(damageTypeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageTypesApi.apiV1ReferenceDataDamageTypesDamageTypeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DamageTypeGetPaginatedDto} [damageTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataDamageTypesGetPost(nexusOpsAppVersion?: string, damageTypeGetPaginatedDto?: DamageTypeGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfDamageTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataDamageTypesGetPost(nexusOpsAppVersion, damageTypeGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageTypesApi.apiV1ReferenceDataDamageTypesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DamageTypesApi - factory interface
 * @export
 */
export const DamageTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DamageTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {DamageTypesApiApiV1ReferenceDataDamageTypesDamageTypeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataDamageTypesDamageTypeIdGet(requestParameters: DamageTypesApiApiV1ReferenceDataDamageTypesDamageTypeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DamageTypeDto> {
            return localVarFp.apiV1ReferenceDataDamageTypesDamageTypeIdGet(requestParameters.damageTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageTypesApiApiV1ReferenceDataDamageTypesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataDamageTypesGetPost(requestParameters: DamageTypesApiApiV1ReferenceDataDamageTypesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfDamageTypeDto> {
            return localVarFp.apiV1ReferenceDataDamageTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.damageTypeGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ReferenceDataDamageTypesDamageTypeIdGet operation in DamageTypesApi.
 * @export
 * @interface DamageTypesApiApiV1ReferenceDataDamageTypesDamageTypeIdGetRequest
 */
export interface DamageTypesApiApiV1ReferenceDataDamageTypesDamageTypeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DamageTypesApiApiV1ReferenceDataDamageTypesDamageTypeIdGet
     */
    readonly damageTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageTypesApiApiV1ReferenceDataDamageTypesDamageTypeIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ReferenceDataDamageTypesGetPost operation in DamageTypesApi.
 * @export
 * @interface DamageTypesApiApiV1ReferenceDataDamageTypesGetPostRequest
 */
export interface DamageTypesApiApiV1ReferenceDataDamageTypesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageTypesApiApiV1ReferenceDataDamageTypesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DamageTypeGetPaginatedDto}
     * @memberof DamageTypesApiApiV1ReferenceDataDamageTypesGetPost
     */
    readonly damageTypeGetPaginatedDto?: DamageTypeGetPaginatedDto
}

/**
 * DamageTypesApi - object-oriented interface
 * @export
 * @class DamageTypesApi
 * @extends {BaseAPI}
 */
export class DamageTypesApi extends BaseAPI {
    /**
     * 
     * @param {DamageTypesApiApiV1ReferenceDataDamageTypesDamageTypeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageTypesApi
     */
    public apiV1ReferenceDataDamageTypesDamageTypeIdGet(requestParameters: DamageTypesApiApiV1ReferenceDataDamageTypesDamageTypeIdGetRequest, options?: RawAxiosRequestConfig) {
        return DamageTypesApiFp(this.configuration).apiV1ReferenceDataDamageTypesDamageTypeIdGet(requestParameters.damageTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageTypesApiApiV1ReferenceDataDamageTypesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageTypesApi
     */
    public apiV1ReferenceDataDamageTypesGetPost(requestParameters: DamageTypesApiApiV1ReferenceDataDamageTypesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DamageTypesApiFp(this.configuration).apiV1ReferenceDataDamageTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.damageTypeGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DamageTypesAdminApi - axios parameter creator
 * @export
 */
export const DamageTypesAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} damageTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataDamageTypesDamageTypeIdDelete: async (damageTypeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageTypeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataDamageTypesDamageTypeIdDelete', 'damageTypeId', damageTypeId)
            const localVarPath = `/api/v1/admin/reference-data/damage-types/{damageTypeId}`
                .replace(`{${"damageTypeId"}}`, encodeURIComponent(String(damageTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} damageTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataDamageTypesDamageTypeIdGet: async (damageTypeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageTypeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataDamageTypesDamageTypeIdGet', 'damageTypeId', damageTypeId)
            const localVarPath = `/api/v1/admin/reference-data/damage-types/{damageTypeId}`
                .replace(`{${"damageTypeId"}}`, encodeURIComponent(String(damageTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} damageTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateDamageTypeDto} [adminUpdateDamageTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataDamageTypesDamageTypeIdPut: async (damageTypeId: string, nexusOpsAppVersion?: string, adminUpdateDamageTypeDto?: AdminUpdateDamageTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageTypeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataDamageTypesDamageTypeIdPut', 'damageTypeId', damageTypeId)
            const localVarPath = `/api/v1/admin/reference-data/damage-types/{damageTypeId}`
                .replace(`{${"damageTypeId"}}`, encodeURIComponent(String(damageTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateDamageTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminDamageTypeGetPaginatedDto} [adminDamageTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataDamageTypesGetPost: async (nexusOpsAppVersion?: string, adminDamageTypeGetPaginatedDto?: AdminDamageTypeGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/damage-types/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminDamageTypeGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateDamageTypeDto} [adminCreateDamageTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataDamageTypesPost: async (nexusOpsAppVersion?: string, adminCreateDamageTypeDto?: AdminCreateDamageTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/damage-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateDamageTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DamageTypesAdminApi - functional programming interface
 * @export
 */
export const DamageTypesAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DamageTypesAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} damageTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataDamageTypesDamageTypeIdDelete(damageTypeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataDamageTypesDamageTypeIdDelete(damageTypeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageTypesAdminApi.apiV1AdminReferenceDataDamageTypesDamageTypeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} damageTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataDamageTypesDamageTypeIdGet(damageTypeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDamageTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataDamageTypesDamageTypeIdGet(damageTypeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageTypesAdminApi.apiV1AdminReferenceDataDamageTypesDamageTypeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} damageTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateDamageTypeDto} [adminUpdateDamageTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataDamageTypesDamageTypeIdPut(damageTypeId: string, nexusOpsAppVersion?: string, adminUpdateDamageTypeDto?: AdminUpdateDamageTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDamageTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataDamageTypesDamageTypeIdPut(damageTypeId, nexusOpsAppVersion, adminUpdateDamageTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageTypesAdminApi.apiV1AdminReferenceDataDamageTypesDamageTypeIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminDamageTypeGetPaginatedDto} [adminDamageTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataDamageTypesGetPost(nexusOpsAppVersion?: string, adminDamageTypeGetPaginatedDto?: AdminDamageTypeGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminDamageTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataDamageTypesGetPost(nexusOpsAppVersion, adminDamageTypeGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageTypesAdminApi.apiV1AdminReferenceDataDamageTypesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateDamageTypeDto} [adminCreateDamageTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataDamageTypesPost(nexusOpsAppVersion?: string, adminCreateDamageTypeDto?: AdminCreateDamageTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDamageTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataDamageTypesPost(nexusOpsAppVersion, adminCreateDamageTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DamageTypesAdminApi.apiV1AdminReferenceDataDamageTypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DamageTypesAdminApi - factory interface
 * @export
 */
export const DamageTypesAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DamageTypesAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataDamageTypesDamageTypeIdDelete(requestParameters: DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminReferenceDataDamageTypesDamageTypeIdDelete(requestParameters.damageTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataDamageTypesDamageTypeIdGet(requestParameters: DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDamageTypeDto> {
            return localVarFp.apiV1AdminReferenceDataDamageTypesDamageTypeIdGet(requestParameters.damageTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataDamageTypesDamageTypeIdPut(requestParameters: DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDamageTypeDto> {
            return localVarFp.apiV1AdminReferenceDataDamageTypesDamageTypeIdPut(requestParameters.damageTypeId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateDamageTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataDamageTypesGetPost(requestParameters: DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminDamageTypeDto> {
            return localVarFp.apiV1AdminReferenceDataDamageTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminDamageTypeGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataDamageTypesPost(requestParameters: DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminDamageTypeDto> {
            return localVarFp.apiV1AdminReferenceDataDamageTypesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateDamageTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminReferenceDataDamageTypesDamageTypeIdDelete operation in DamageTypesAdminApi.
 * @export
 * @interface DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdDeleteRequest
 */
export interface DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdDelete
     */
    readonly damageTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataDamageTypesDamageTypeIdGet operation in DamageTypesAdminApi.
 * @export
 * @interface DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdGetRequest
 */
export interface DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdGet
     */
    readonly damageTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataDamageTypesDamageTypeIdPut operation in DamageTypesAdminApi.
 * @export
 * @interface DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdPutRequest
 */
export interface DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdPut
     */
    readonly damageTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUpdateDamageTypeDto}
     * @memberof DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdPut
     */
    readonly adminUpdateDamageTypeDto?: AdminUpdateDamageTypeDto
}

/**
 * Request parameters for apiV1AdminReferenceDataDamageTypesGetPost operation in DamageTypesAdminApi.
 * @export
 * @interface DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesGetPostRequest
 */
export interface DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminDamageTypeGetPaginatedDto}
     * @memberof DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesGetPost
     */
    readonly adminDamageTypeGetPaginatedDto?: AdminDamageTypeGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminReferenceDataDamageTypesPost operation in DamageTypesAdminApi.
 * @export
 * @interface DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesPostRequest
 */
export interface DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateDamageTypeDto}
     * @memberof DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesPost
     */
    readonly adminCreateDamageTypeDto?: AdminCreateDamageTypeDto
}

/**
 * DamageTypesAdminApi - object-oriented interface
 * @export
 * @class DamageTypesAdminApi
 * @extends {BaseAPI}
 */
export class DamageTypesAdminApi extends BaseAPI {
    /**
     * 
     * @param {DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageTypesAdminApi
     */
    public apiV1AdminReferenceDataDamageTypesDamageTypeIdDelete(requestParameters: DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DamageTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataDamageTypesDamageTypeIdDelete(requestParameters.damageTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageTypesAdminApi
     */
    public apiV1AdminReferenceDataDamageTypesDamageTypeIdGet(requestParameters: DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdGetRequest, options?: RawAxiosRequestConfig) {
        return DamageTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataDamageTypesDamageTypeIdGet(requestParameters.damageTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageTypesAdminApi
     */
    public apiV1AdminReferenceDataDamageTypesDamageTypeIdPut(requestParameters: DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesDamageTypeIdPutRequest, options?: RawAxiosRequestConfig) {
        return DamageTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataDamageTypesDamageTypeIdPut(requestParameters.damageTypeId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateDamageTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageTypesAdminApi
     */
    public apiV1AdminReferenceDataDamageTypesGetPost(requestParameters: DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DamageTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataDamageTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminDamageTypeGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageTypesAdminApi
     */
    public apiV1AdminReferenceDataDamageTypesPost(requestParameters: DamageTypesAdminApiApiV1AdminReferenceDataDamageTypesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DamageTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataDamageTypesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateDamageTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataExportApi - axios parameter creator
 * @export
 */
export const DataExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataExportConfigGetPaginatedDto} [dataExportConfigGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataExportConfigsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, dataExportConfigGetPaginatedDto?: DataExportConfigGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataExportConfigsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/data/export/configs/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataExportConfigGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} id 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataExportConfigsIdDelete: async (nexusOpsTenant: string, id: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataExportConfigsIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1DataExportConfigsIdDelete', 'id', id)
            const localVarPath = `/api/v1/data/export/configs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} id 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataExportConfigsIdGet: async (nexusOpsTenant: string, id: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataExportConfigsIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1DataExportConfigsIdGet', 'id', id)
            const localVarPath = `/api/v1/data/export/configs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} id 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataExportConfigUpdateDto} [dataExportConfigUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataExportConfigsIdPut: async (nexusOpsTenant: string, id: string, nexusOpsAppVersion?: string, dataExportConfigUpdateDto?: DataExportConfigUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataExportConfigsIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1DataExportConfigsIdPut', 'id', id)
            const localVarPath = `/api/v1/data/export/configs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataExportConfigUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataExportConfigCreateDto} [dataExportConfigCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataExportConfigsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, dataExportConfigCreateDto?: DataExportConfigCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataExportConfigsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/data/export/configs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataExportConfigCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataExportRequestDto} [dataExportRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataExportPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, dataExportRequestDto?: DataExportRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataExportPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/data/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataExportRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ExportType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataExportPropertiesGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, type?: ExportType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataExportPropertiesGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/data/export/properties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataExportApi - functional programming interface
 * @export
 */
export const DataExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataExportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataExportConfigGetPaginatedDto} [dataExportConfigGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataExportConfigsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, dataExportConfigGetPaginatedDto?: DataExportConfigGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfDataExportConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataExportConfigsGetPost(nexusOpsTenant, nexusOpsAppVersion, dataExportConfigGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportApi.apiV1DataExportConfigsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} id 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataExportConfigsIdDelete(nexusOpsTenant: string, id: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataExportConfigsIdDelete(nexusOpsTenant, id, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportApi.apiV1DataExportConfigsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} id 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataExportConfigsIdGet(nexusOpsTenant: string, id: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataExportConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataExportConfigsIdGet(nexusOpsTenant, id, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportApi.apiV1DataExportConfigsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} id 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataExportConfigUpdateDto} [dataExportConfigUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataExportConfigsIdPut(nexusOpsTenant: string, id: string, nexusOpsAppVersion?: string, dataExportConfigUpdateDto?: DataExportConfigUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataExportConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataExportConfigsIdPut(nexusOpsTenant, id, nexusOpsAppVersion, dataExportConfigUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportApi.apiV1DataExportConfigsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataExportConfigCreateDto} [dataExportConfigCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataExportConfigsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, dataExportConfigCreateDto?: DataExportConfigCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataExportConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataExportConfigsPost(nexusOpsTenant, nexusOpsAppVersion, dataExportConfigCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportApi.apiV1DataExportConfigsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataExportRequestDto} [dataExportRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataExportPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, dataExportRequestDto?: DataExportRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataExportPost(nexusOpsTenant, nexusOpsAppVersion, dataExportRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportApi.apiV1DataExportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ExportType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataExportPropertiesGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, type?: ExportType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataExportPropertiesGet(nexusOpsTenant, nexusOpsAppVersion, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportApi.apiV1DataExportPropertiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataExportApi - factory interface
 * @export
 */
export const DataExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataExportApiFp(configuration)
    return {
        /**
         * 
         * @param {DataExportApiApiV1DataExportConfigsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataExportConfigsGetPost(requestParameters: DataExportApiApiV1DataExportConfigsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfDataExportConfigDto> {
            return localVarFp.apiV1DataExportConfigsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.dataExportConfigGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataExportApiApiV1DataExportConfigsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataExportConfigsIdDelete(requestParameters: DataExportApiApiV1DataExportConfigsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DataExportConfigsIdDelete(requestParameters.nexusOpsTenant, requestParameters.id, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataExportApiApiV1DataExportConfigsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataExportConfigsIdGet(requestParameters: DataExportApiApiV1DataExportConfigsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataExportConfigDto> {
            return localVarFp.apiV1DataExportConfigsIdGet(requestParameters.nexusOpsTenant, requestParameters.id, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataExportApiApiV1DataExportConfigsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataExportConfigsIdPut(requestParameters: DataExportApiApiV1DataExportConfigsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataExportConfigDto> {
            return localVarFp.apiV1DataExportConfigsIdPut(requestParameters.nexusOpsTenant, requestParameters.id, requestParameters.nexusOpsAppVersion, requestParameters.dataExportConfigUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataExportApiApiV1DataExportConfigsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataExportConfigsPost(requestParameters: DataExportApiApiV1DataExportConfigsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataExportConfigDto> {
            return localVarFp.apiV1DataExportConfigsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.dataExportConfigCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataExportApiApiV1DataExportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataExportPost(requestParameters: DataExportApiApiV1DataExportPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1DataExportPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.dataExportRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataExportApiApiV1DataExportPropertiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataExportPropertiesGet(requestParameters: DataExportApiApiV1DataExportPropertiesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV1DataExportPropertiesGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DataExportConfigsGetPost operation in DataExportApi.
 * @export
 * @interface DataExportApiApiV1DataExportConfigsGetPostRequest
 */
export interface DataExportApiApiV1DataExportConfigsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataExportApiApiV1DataExportConfigsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataExportApiApiV1DataExportConfigsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DataExportConfigGetPaginatedDto}
     * @memberof DataExportApiApiV1DataExportConfigsGetPost
     */
    readonly dataExportConfigGetPaginatedDto?: DataExportConfigGetPaginatedDto
}

/**
 * Request parameters for apiV1DataExportConfigsIdDelete operation in DataExportApi.
 * @export
 * @interface DataExportApiApiV1DataExportConfigsIdDeleteRequest
 */
export interface DataExportApiApiV1DataExportConfigsIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataExportApiApiV1DataExportConfigsIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DataExportApiApiV1DataExportConfigsIdDelete
     */
    readonly id: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataExportApiApiV1DataExportConfigsIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DataExportConfigsIdGet operation in DataExportApi.
 * @export
 * @interface DataExportApiApiV1DataExportConfigsIdGetRequest
 */
export interface DataExportApiApiV1DataExportConfigsIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataExportApiApiV1DataExportConfigsIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DataExportApiApiV1DataExportConfigsIdGet
     */
    readonly id: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataExportApiApiV1DataExportConfigsIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DataExportConfigsIdPut operation in DataExportApi.
 * @export
 * @interface DataExportApiApiV1DataExportConfigsIdPutRequest
 */
export interface DataExportApiApiV1DataExportConfigsIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataExportApiApiV1DataExportConfigsIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DataExportApiApiV1DataExportConfigsIdPut
     */
    readonly id: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataExportApiApiV1DataExportConfigsIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DataExportConfigUpdateDto}
     * @memberof DataExportApiApiV1DataExportConfigsIdPut
     */
    readonly dataExportConfigUpdateDto?: DataExportConfigUpdateDto
}

/**
 * Request parameters for apiV1DataExportConfigsPost operation in DataExportApi.
 * @export
 * @interface DataExportApiApiV1DataExportConfigsPostRequest
 */
export interface DataExportApiApiV1DataExportConfigsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataExportApiApiV1DataExportConfigsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataExportApiApiV1DataExportConfigsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DataExportConfigCreateDto}
     * @memberof DataExportApiApiV1DataExportConfigsPost
     */
    readonly dataExportConfigCreateDto?: DataExportConfigCreateDto
}

/**
 * Request parameters for apiV1DataExportPost operation in DataExportApi.
 * @export
 * @interface DataExportApiApiV1DataExportPostRequest
 */
export interface DataExportApiApiV1DataExportPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataExportApiApiV1DataExportPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataExportApiApiV1DataExportPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DataExportRequestDto}
     * @memberof DataExportApiApiV1DataExportPost
     */
    readonly dataExportRequestDto?: DataExportRequestDto
}

/**
 * Request parameters for apiV1DataExportPropertiesGet operation in DataExportApi.
 * @export
 * @interface DataExportApiApiV1DataExportPropertiesGetRequest
 */
export interface DataExportApiApiV1DataExportPropertiesGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataExportApiApiV1DataExportPropertiesGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataExportApiApiV1DataExportPropertiesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ExportType}
     * @memberof DataExportApiApiV1DataExportPropertiesGet
     */
    readonly type?: ExportType
}

/**
 * DataExportApi - object-oriented interface
 * @export
 * @class DataExportApi
 * @extends {BaseAPI}
 */
export class DataExportApi extends BaseAPI {
    /**
     * 
     * @param {DataExportApiApiV1DataExportConfigsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public apiV1DataExportConfigsGetPost(requestParameters: DataExportApiApiV1DataExportConfigsGetPostRequest, options?: RawAxiosRequestConfig) {
        return DataExportApiFp(this.configuration).apiV1DataExportConfigsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.dataExportConfigGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataExportApiApiV1DataExportConfigsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public apiV1DataExportConfigsIdDelete(requestParameters: DataExportApiApiV1DataExportConfigsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DataExportApiFp(this.configuration).apiV1DataExportConfigsIdDelete(requestParameters.nexusOpsTenant, requestParameters.id, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataExportApiApiV1DataExportConfigsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public apiV1DataExportConfigsIdGet(requestParameters: DataExportApiApiV1DataExportConfigsIdGetRequest, options?: RawAxiosRequestConfig) {
        return DataExportApiFp(this.configuration).apiV1DataExportConfigsIdGet(requestParameters.nexusOpsTenant, requestParameters.id, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataExportApiApiV1DataExportConfigsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public apiV1DataExportConfigsIdPut(requestParameters: DataExportApiApiV1DataExportConfigsIdPutRequest, options?: RawAxiosRequestConfig) {
        return DataExportApiFp(this.configuration).apiV1DataExportConfigsIdPut(requestParameters.nexusOpsTenant, requestParameters.id, requestParameters.nexusOpsAppVersion, requestParameters.dataExportConfigUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataExportApiApiV1DataExportConfigsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public apiV1DataExportConfigsPost(requestParameters: DataExportApiApiV1DataExportConfigsPostRequest, options?: RawAxiosRequestConfig) {
        return DataExportApiFp(this.configuration).apiV1DataExportConfigsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.dataExportConfigCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataExportApiApiV1DataExportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public apiV1DataExportPost(requestParameters: DataExportApiApiV1DataExportPostRequest, options?: RawAxiosRequestConfig) {
        return DataExportApiFp(this.configuration).apiV1DataExportPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.dataExportRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataExportApiApiV1DataExportPropertiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public apiV1DataExportPropertiesGet(requestParameters: DataExportApiApiV1DataExportPropertiesGetRequest, options?: RawAxiosRequestConfig) {
        return DataExportApiFp(this.configuration).apiV1DataExportPropertiesGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataGrantsApi - axios parameter creator
 * @export
 */
export const DataGrantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataGrantsCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataGrantsCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/data-grants/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} dataGrantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataGrantsDataGrantIdDelete: async (nexusOpsTenant: string, dataGrantId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataGrantsDataGrantIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'dataGrantId' is not null or undefined
            assertParamExists('apiV1DataGrantsDataGrantIdDelete', 'dataGrantId', dataGrantId)
            const localVarPath = `/api/v1/data-grants/{dataGrantId}`
                .replace(`{${"dataGrantId"}}`, encodeURIComponent(String(dataGrantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} dataGrantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataGrantsDataGrantIdGet: async (nexusOpsTenant: string, dataGrantId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataGrantsDataGrantIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'dataGrantId' is not null or undefined
            assertParamExists('apiV1DataGrantsDataGrantIdGet', 'dataGrantId', dataGrantId)
            const localVarPath = `/api/v1/data-grants/{dataGrantId}`
                .replace(`{${"dataGrantId"}}`, encodeURIComponent(String(dataGrantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} dataGrantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataGrantUpdateDto} [dataGrantUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataGrantsDataGrantIdPut: async (nexusOpsTenant: string, dataGrantId: string, nexusOpsAppVersion?: string, dataGrantUpdateDto?: DataGrantUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataGrantsDataGrantIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'dataGrantId' is not null or undefined
            assertParamExists('apiV1DataGrantsDataGrantIdPut', 'dataGrantId', dataGrantId)
            const localVarPath = `/api/v1/data-grants/{dataGrantId}`
                .replace(`{${"dataGrantId"}}`, encodeURIComponent(String(dataGrantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataGrantUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataGrantGetPaginatedDto} [dataGrantGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataGrantsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, dataGrantGetPaginatedDto?: DataGrantGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataGrantsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/data-grants/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataGrantGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataGrantCreateDto} [dataGrantCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataGrantsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, dataGrantCreateDto?: DataGrantCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataGrantsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/data-grants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataGrantCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataGrantSearchPaginatedDto} [dataGrantSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataGrantsSearchPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, dataGrantSearchPaginatedDto?: DataGrantSearchPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataGrantsSearchPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/data-grants/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataGrantSearchPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataGrantsApi - functional programming interface
 * @export
 */
export const DataGrantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataGrantsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataGrantsCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataGrantCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataGrantsCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataGrantsApi.apiV1DataGrantsCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} dataGrantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataGrantsDataGrantIdDelete(nexusOpsTenant: string, dataGrantId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataGrantsDataGrantIdDelete(nexusOpsTenant, dataGrantId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataGrantsApi.apiV1DataGrantsDataGrantIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} dataGrantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataGrantsDataGrantIdGet(nexusOpsTenant: string, dataGrantId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataGrantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataGrantsDataGrantIdGet(nexusOpsTenant, dataGrantId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataGrantsApi.apiV1DataGrantsDataGrantIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} dataGrantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataGrantUpdateDto} [dataGrantUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataGrantsDataGrantIdPut(nexusOpsTenant: string, dataGrantId: string, nexusOpsAppVersion?: string, dataGrantUpdateDto?: DataGrantUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataGrantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataGrantsDataGrantIdPut(nexusOpsTenant, dataGrantId, nexusOpsAppVersion, dataGrantUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataGrantsApi.apiV1DataGrantsDataGrantIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataGrantGetPaginatedDto} [dataGrantGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataGrantsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, dataGrantGetPaginatedDto?: DataGrantGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfDataGrantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataGrantsGetPost(nexusOpsTenant, nexusOpsAppVersion, dataGrantGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataGrantsApi.apiV1DataGrantsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataGrantCreateDto} [dataGrantCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataGrantsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, dataGrantCreateDto?: DataGrantCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataGrantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataGrantsPost(nexusOpsTenant, nexusOpsAppVersion, dataGrantCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataGrantsApi.apiV1DataGrantsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DataGrantSearchPaginatedDto} [dataGrantSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataGrantsSearchPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, dataGrantSearchPaginatedDto?: DataGrantSearchPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfDataGrantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataGrantsSearchPost(nexusOpsTenant, nexusOpsAppVersion, dataGrantSearchPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataGrantsApi.apiV1DataGrantsSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataGrantsApi - factory interface
 * @export
 */
export const DataGrantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataGrantsApiFp(configuration)
    return {
        /**
         * 
         * @param {DataGrantsApiApiV1DataGrantsCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataGrantsCountersGet(requestParameters: DataGrantsApiApiV1DataGrantsCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataGrantCountersDto> {
            return localVarFp.apiV1DataGrantsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataGrantsApiApiV1DataGrantsDataGrantIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataGrantsDataGrantIdDelete(requestParameters: DataGrantsApiApiV1DataGrantsDataGrantIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DataGrantsDataGrantIdDelete(requestParameters.nexusOpsTenant, requestParameters.dataGrantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataGrantsApiApiV1DataGrantsDataGrantIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataGrantsDataGrantIdGet(requestParameters: DataGrantsApiApiV1DataGrantsDataGrantIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataGrantDto> {
            return localVarFp.apiV1DataGrantsDataGrantIdGet(requestParameters.nexusOpsTenant, requestParameters.dataGrantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataGrantsApiApiV1DataGrantsDataGrantIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataGrantsDataGrantIdPut(requestParameters: DataGrantsApiApiV1DataGrantsDataGrantIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataGrantDto> {
            return localVarFp.apiV1DataGrantsDataGrantIdPut(requestParameters.nexusOpsTenant, requestParameters.dataGrantId, requestParameters.nexusOpsAppVersion, requestParameters.dataGrantUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataGrantsApiApiV1DataGrantsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataGrantsGetPost(requestParameters: DataGrantsApiApiV1DataGrantsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfDataGrantDto> {
            return localVarFp.apiV1DataGrantsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.dataGrantGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataGrantsApiApiV1DataGrantsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataGrantsPost(requestParameters: DataGrantsApiApiV1DataGrantsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataGrantDto> {
            return localVarFp.apiV1DataGrantsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.dataGrantCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataGrantsApiApiV1DataGrantsSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataGrantsSearchPost(requestParameters: DataGrantsApiApiV1DataGrantsSearchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfDataGrantDto> {
            return localVarFp.apiV1DataGrantsSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.dataGrantSearchPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DataGrantsCountersGet operation in DataGrantsApi.
 * @export
 * @interface DataGrantsApiApiV1DataGrantsCountersGetRequest
 */
export interface DataGrantsApiApiV1DataGrantsCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DataGrantsDataGrantIdDelete operation in DataGrantsApi.
 * @export
 * @interface DataGrantsApiApiV1DataGrantsDataGrantIdDeleteRequest
 */
export interface DataGrantsApiApiV1DataGrantsDataGrantIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsDataGrantIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsDataGrantIdDelete
     */
    readonly dataGrantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsDataGrantIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DataGrantsDataGrantIdGet operation in DataGrantsApi.
 * @export
 * @interface DataGrantsApiApiV1DataGrantsDataGrantIdGetRequest
 */
export interface DataGrantsApiApiV1DataGrantsDataGrantIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsDataGrantIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsDataGrantIdGet
     */
    readonly dataGrantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsDataGrantIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DataGrantsDataGrantIdPut operation in DataGrantsApi.
 * @export
 * @interface DataGrantsApiApiV1DataGrantsDataGrantIdPutRequest
 */
export interface DataGrantsApiApiV1DataGrantsDataGrantIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsDataGrantIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsDataGrantIdPut
     */
    readonly dataGrantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsDataGrantIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DataGrantUpdateDto}
     * @memberof DataGrantsApiApiV1DataGrantsDataGrantIdPut
     */
    readonly dataGrantUpdateDto?: DataGrantUpdateDto
}

/**
 * Request parameters for apiV1DataGrantsGetPost operation in DataGrantsApi.
 * @export
 * @interface DataGrantsApiApiV1DataGrantsGetPostRequest
 */
export interface DataGrantsApiApiV1DataGrantsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DataGrantGetPaginatedDto}
     * @memberof DataGrantsApiApiV1DataGrantsGetPost
     */
    readonly dataGrantGetPaginatedDto?: DataGrantGetPaginatedDto
}

/**
 * Request parameters for apiV1DataGrantsPost operation in DataGrantsApi.
 * @export
 * @interface DataGrantsApiApiV1DataGrantsPostRequest
 */
export interface DataGrantsApiApiV1DataGrantsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DataGrantCreateDto}
     * @memberof DataGrantsApiApiV1DataGrantsPost
     */
    readonly dataGrantCreateDto?: DataGrantCreateDto
}

/**
 * Request parameters for apiV1DataGrantsSearchPost operation in DataGrantsApi.
 * @export
 * @interface DataGrantsApiApiV1DataGrantsSearchPostRequest
 */
export interface DataGrantsApiApiV1DataGrantsSearchPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsSearchPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataGrantsApiApiV1DataGrantsSearchPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DataGrantSearchPaginatedDto}
     * @memberof DataGrantsApiApiV1DataGrantsSearchPost
     */
    readonly dataGrantSearchPaginatedDto?: DataGrantSearchPaginatedDto
}

/**
 * DataGrantsApi - object-oriented interface
 * @export
 * @class DataGrantsApi
 * @extends {BaseAPI}
 */
export class DataGrantsApi extends BaseAPI {
    /**
     * 
     * @param {DataGrantsApiApiV1DataGrantsCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGrantsApi
     */
    public apiV1DataGrantsCountersGet(requestParameters: DataGrantsApiApiV1DataGrantsCountersGetRequest, options?: RawAxiosRequestConfig) {
        return DataGrantsApiFp(this.configuration).apiV1DataGrantsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataGrantsApiApiV1DataGrantsDataGrantIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGrantsApi
     */
    public apiV1DataGrantsDataGrantIdDelete(requestParameters: DataGrantsApiApiV1DataGrantsDataGrantIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DataGrantsApiFp(this.configuration).apiV1DataGrantsDataGrantIdDelete(requestParameters.nexusOpsTenant, requestParameters.dataGrantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataGrantsApiApiV1DataGrantsDataGrantIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGrantsApi
     */
    public apiV1DataGrantsDataGrantIdGet(requestParameters: DataGrantsApiApiV1DataGrantsDataGrantIdGetRequest, options?: RawAxiosRequestConfig) {
        return DataGrantsApiFp(this.configuration).apiV1DataGrantsDataGrantIdGet(requestParameters.nexusOpsTenant, requestParameters.dataGrantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataGrantsApiApiV1DataGrantsDataGrantIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGrantsApi
     */
    public apiV1DataGrantsDataGrantIdPut(requestParameters: DataGrantsApiApiV1DataGrantsDataGrantIdPutRequest, options?: RawAxiosRequestConfig) {
        return DataGrantsApiFp(this.configuration).apiV1DataGrantsDataGrantIdPut(requestParameters.nexusOpsTenant, requestParameters.dataGrantId, requestParameters.nexusOpsAppVersion, requestParameters.dataGrantUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataGrantsApiApiV1DataGrantsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGrantsApi
     */
    public apiV1DataGrantsGetPost(requestParameters: DataGrantsApiApiV1DataGrantsGetPostRequest, options?: RawAxiosRequestConfig) {
        return DataGrantsApiFp(this.configuration).apiV1DataGrantsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.dataGrantGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataGrantsApiApiV1DataGrantsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGrantsApi
     */
    public apiV1DataGrantsPost(requestParameters: DataGrantsApiApiV1DataGrantsPostRequest, options?: RawAxiosRequestConfig) {
        return DataGrantsApiFp(this.configuration).apiV1DataGrantsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.dataGrantCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataGrantsApiApiV1DataGrantsSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataGrantsApi
     */
    public apiV1DataGrantsSearchPost(requestParameters: DataGrantsApiApiV1DataGrantsSearchPostRequest, options?: RawAxiosRequestConfig) {
        return DataGrantsApiFp(this.configuration).apiV1DataGrantsSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.dataGrantSearchPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataImportApi - axios parameter creator
 * @export
 */
export const DataImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ImportType} [type] 
         * @param {string} [mimeType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportFileExampleGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, type?: ImportType, mimeType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataImportFileExampleGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/data/import/file/example`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (mimeType !== undefined) {
                localVarQueryParameter['mimeType'] = mimeType;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ImportGetPaginatedDto} [importGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, importGetPaginatedDto?: ImportGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataImportGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/data/import/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} importId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportImportIdDataGet: async (nexusOpsTenant: string, importId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataImportImportIdDataGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'importId' is not null or undefined
            assertParamExists('apiV1DataImportImportIdDataGet', 'importId', importId)
            const localVarPath = `/api/v1/data/import/{importId}/data`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} importId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportImportIdGet: async (nexusOpsTenant: string, importId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataImportImportIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'importId' is not null or undefined
            assertParamExists('apiV1DataImportImportIdGet', 'importId', importId)
            const localVarPath = `/api/v1/data/import/{importId}`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} importId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {LaunchImportDto} [launchImportDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportImportIdLaunchPost: async (nexusOpsTenant: string, importId: string, nexusOpsAppVersion?: string, launchImportDto?: LaunchImportDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataImportImportIdLaunchPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'importId' is not null or undefined
            assertParamExists('apiV1DataImportImportIdLaunchPost', 'importId', importId)
            const localVarPath = `/api/v1/data/import/{importId}/launch`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(launchImportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} importId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {LaunchImportDto} [launchImportDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportImportIdLaunchSimulatePost: async (nexusOpsTenant: string, importId: string, nexusOpsAppVersion?: string, launchImportDto?: LaunchImportDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataImportImportIdLaunchSimulatePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'importId' is not null or undefined
            assertParamExists('apiV1DataImportImportIdLaunchSimulatePost', 'importId', importId)
            const localVarPath = `/api/v1/data/import/{importId}/launch/simulate`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(launchImportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} importId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportImportIdMappingAutomapPost: async (nexusOpsTenant: string, importId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataImportImportIdMappingAutomapPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'importId' is not null or undefined
            assertParamExists('apiV1DataImportImportIdMappingAutomapPost', 'importId', importId)
            const localVarPath = `/api/v1/data/import/{importId}/mapping/automap`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} importId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SubmitMappingDto} [submitMappingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportImportIdMappingSubmitPost: async (nexusOpsTenant: string, importId: string, nexusOpsAppVersion?: string, submitMappingDto?: SubmitMappingDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataImportImportIdMappingSubmitPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'importId' is not null or undefined
            assertParamExists('apiV1DataImportImportIdMappingSubmitPost', 'importId', importId)
            const localVarPath = `/api/v1/data/import/{importId}/mapping/submit`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitMappingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} importId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SubmitUploadDto} [submitUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportImportIdUploadSubmitPost: async (nexusOpsTenant: string, importId: string, nexusOpsAppVersion?: string, submitUploadDto?: SubmitUploadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataImportImportIdUploadSubmitPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'importId' is not null or undefined
            assertParamExists('apiV1DataImportImportIdUploadSubmitPost', 'importId', importId)
            const localVarPath = `/api/v1/data/import/{importId}/upload/submit`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitUploadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ApplyMappingToImportDto} [applyMappingToImportDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportMappingApplyPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, applyMappingToImportDto?: ApplyMappingToImportDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataImportMappingApplyPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/data/import/mapping/apply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyMappingToImportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataImportPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/data/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ImportType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportTemplatesGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, type?: ImportType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataImportTemplatesGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/data/import/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} templateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportTemplatesTemplateIdGet: async (nexusOpsTenant: string, templateId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataImportTemplatesTemplateIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('apiV1DataImportTemplatesTemplateIdGet', 'templateId', templateId)
            const localVarPath = `/api/v1/data/import/templates/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {ImportType} type 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportTypeSpecGet: async (nexusOpsTenant: string, type: ImportType, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DataImportTypeSpecGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('apiV1DataImportTypeSpecGet', 'type', type)
            const localVarPath = `/api/v1/data/import/{type}/spec`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataImportApi - functional programming interface
 * @export
 */
export const DataImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataImportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ImportType} [type] 
         * @param {string} [mimeType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataImportFileExampleGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, type?: ImportType, mimeType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataImportFileExampleGet(nexusOpsTenant, nexusOpsAppVersion, type, mimeType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiV1DataImportFileExampleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ImportGetPaginatedDto} [importGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataImportGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, importGetPaginatedDto?: ImportGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataImportGetPost(nexusOpsTenant, nexusOpsAppVersion, importGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiV1DataImportGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} importId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataImportImportIdDataGet(nexusOpsTenant: string, importId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TabularDtoOfString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataImportImportIdDataGet(nexusOpsTenant, importId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiV1DataImportImportIdDataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} importId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataImportImportIdGet(nexusOpsTenant: string, importId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataImportImportIdGet(nexusOpsTenant, importId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiV1DataImportImportIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} importId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {LaunchImportDto} [launchImportDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataImportImportIdLaunchPost(nexusOpsTenant: string, importId: string, nexusOpsAppVersion?: string, launchImportDto?: LaunchImportDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataImportImportIdLaunchPost(nexusOpsTenant, importId, nexusOpsAppVersion, launchImportDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiV1DataImportImportIdLaunchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} importId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {LaunchImportDto} [launchImportDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataImportImportIdLaunchSimulatePost(nexusOpsTenant: string, importId: string, nexusOpsAppVersion?: string, launchImportDto?: LaunchImportDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataImportImportIdLaunchSimulatePost(nexusOpsTenant, importId, nexusOpsAppVersion, launchImportDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiV1DataImportImportIdLaunchSimulatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} importId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataImportImportIdMappingAutomapPost(nexusOpsTenant: string, importId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportMappingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataImportImportIdMappingAutomapPost(nexusOpsTenant, importId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiV1DataImportImportIdMappingAutomapPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} importId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SubmitMappingDto} [submitMappingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataImportImportIdMappingSubmitPost(nexusOpsTenant: string, importId: string, nexusOpsAppVersion?: string, submitMappingDto?: SubmitMappingDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataImportImportIdMappingSubmitPost(nexusOpsTenant, importId, nexusOpsAppVersion, submitMappingDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiV1DataImportImportIdMappingSubmitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} importId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SubmitUploadDto} [submitUploadDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataImportImportIdUploadSubmitPost(nexusOpsTenant: string, importId: string, nexusOpsAppVersion?: string, submitUploadDto?: SubmitUploadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataImportImportIdUploadSubmitPost(nexusOpsTenant, importId, nexusOpsAppVersion, submitUploadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiV1DataImportImportIdUploadSubmitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ApplyMappingToImportDto} [applyMappingToImportDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataImportMappingApplyPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, applyMappingToImportDto?: ApplyMappingToImportDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataImportMappingApplyPost(nexusOpsTenant, nexusOpsAppVersion, applyMappingToImportDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiV1DataImportMappingApplyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataImportPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataImportPost(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiV1DataImportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ImportType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataImportTemplatesGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, type?: ImportType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ImportTemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataImportTemplatesGet(nexusOpsTenant, nexusOpsAppVersion, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiV1DataImportTemplatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} templateId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataImportTemplatesTemplateIdGet(nexusOpsTenant: string, templateId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataImportTemplatesTemplateIdGet(nexusOpsTenant, templateId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiV1DataImportTemplatesTemplateIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {ImportType} type 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DataImportTypeSpecGet(nexusOpsTenant: string, type: ImportType, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportModelSpecDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DataImportTypeSpecGet(nexusOpsTenant, type, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiV1DataImportTypeSpecGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataImportApi - factory interface
 * @export
 */
export const DataImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataImportApiFp(configuration)
    return {
        /**
         * 
         * @param {DataImportApiApiV1DataImportFileExampleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportFileExampleGet(requestParameters: DataImportApiApiV1DataImportFileExampleGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1DataImportFileExampleGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.type, requestParameters.mimeType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataImportApiApiV1DataImportGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportGetPost(requestParameters: DataImportApiApiV1DataImportGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfImportDto> {
            return localVarFp.apiV1DataImportGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.importGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataImportApiApiV1DataImportImportIdDataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportImportIdDataGet(requestParameters: DataImportApiApiV1DataImportImportIdDataGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TabularDtoOfString> {
            return localVarFp.apiV1DataImportImportIdDataGet(requestParameters.nexusOpsTenant, requestParameters.importId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataImportApiApiV1DataImportImportIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportImportIdGet(requestParameters: DataImportApiApiV1DataImportImportIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportDto> {
            return localVarFp.apiV1DataImportImportIdGet(requestParameters.nexusOpsTenant, requestParameters.importId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataImportApiApiV1DataImportImportIdLaunchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportImportIdLaunchPost(requestParameters: DataImportApiApiV1DataImportImportIdLaunchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportDto> {
            return localVarFp.apiV1DataImportImportIdLaunchPost(requestParameters.nexusOpsTenant, requestParameters.importId, requestParameters.nexusOpsAppVersion, requestParameters.launchImportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataImportApiApiV1DataImportImportIdLaunchSimulatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportImportIdLaunchSimulatePost(requestParameters: DataImportApiApiV1DataImportImportIdLaunchSimulatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportResultDto> {
            return localVarFp.apiV1DataImportImportIdLaunchSimulatePost(requestParameters.nexusOpsTenant, requestParameters.importId, requestParameters.nexusOpsAppVersion, requestParameters.launchImportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataImportApiApiV1DataImportImportIdMappingAutomapPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportImportIdMappingAutomapPost(requestParameters: DataImportApiApiV1DataImportImportIdMappingAutomapPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportMappingDto> {
            return localVarFp.apiV1DataImportImportIdMappingAutomapPost(requestParameters.nexusOpsTenant, requestParameters.importId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataImportApiApiV1DataImportImportIdMappingSubmitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportImportIdMappingSubmitPost(requestParameters: DataImportApiApiV1DataImportImportIdMappingSubmitPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportDto> {
            return localVarFp.apiV1DataImportImportIdMappingSubmitPost(requestParameters.nexusOpsTenant, requestParameters.importId, requestParameters.nexusOpsAppVersion, requestParameters.submitMappingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataImportApiApiV1DataImportImportIdUploadSubmitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportImportIdUploadSubmitPost(requestParameters: DataImportApiApiV1DataImportImportIdUploadSubmitPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportDto> {
            return localVarFp.apiV1DataImportImportIdUploadSubmitPost(requestParameters.nexusOpsTenant, requestParameters.importId, requestParameters.nexusOpsAppVersion, requestParameters.submitUploadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataImportApiApiV1DataImportMappingApplyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportMappingApplyPost(requestParameters: DataImportApiApiV1DataImportMappingApplyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportDto> {
            return localVarFp.apiV1DataImportMappingApplyPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.applyMappingToImportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataImportApiApiV1DataImportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportPost(requestParameters: DataImportApiApiV1DataImportPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportDto> {
            return localVarFp.apiV1DataImportPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataImportApiApiV1DataImportTemplatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportTemplatesGet(requestParameters: DataImportApiApiV1DataImportTemplatesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ImportTemplateDto>> {
            return localVarFp.apiV1DataImportTemplatesGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataImportApiApiV1DataImportTemplatesTemplateIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportTemplatesTemplateIdGet(requestParameters: DataImportApiApiV1DataImportTemplatesTemplateIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportTemplateDto> {
            return localVarFp.apiV1DataImportTemplatesTemplateIdGet(requestParameters.nexusOpsTenant, requestParameters.templateId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataImportApiApiV1DataImportTypeSpecGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DataImportTypeSpecGet(requestParameters: DataImportApiApiV1DataImportTypeSpecGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportModelSpecDto> {
            return localVarFp.apiV1DataImportTypeSpecGet(requestParameters.nexusOpsTenant, requestParameters.type, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DataImportFileExampleGet operation in DataImportApi.
 * @export
 * @interface DataImportApiApiV1DataImportFileExampleGetRequest
 */
export interface DataImportApiApiV1DataImportFileExampleGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataImportApiApiV1DataImportFileExampleGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataImportApiApiV1DataImportFileExampleGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ImportType}
     * @memberof DataImportApiApiV1DataImportFileExampleGet
     */
    readonly type?: ImportType

    /**
     * 
     * @type {string}
     * @memberof DataImportApiApiV1DataImportFileExampleGet
     */
    readonly mimeType?: string
}

/**
 * Request parameters for apiV1DataImportGetPost operation in DataImportApi.
 * @export
 * @interface DataImportApiApiV1DataImportGetPostRequest
 */
export interface DataImportApiApiV1DataImportGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataImportApiApiV1DataImportGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataImportApiApiV1DataImportGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ImportGetPaginatedDto}
     * @memberof DataImportApiApiV1DataImportGetPost
     */
    readonly importGetPaginatedDto?: ImportGetPaginatedDto
}

/**
 * Request parameters for apiV1DataImportImportIdDataGet operation in DataImportApi.
 * @export
 * @interface DataImportApiApiV1DataImportImportIdDataGetRequest
 */
export interface DataImportApiApiV1DataImportImportIdDataGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdDataGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdDataGet
     */
    readonly importId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdDataGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DataImportImportIdGet operation in DataImportApi.
 * @export
 * @interface DataImportApiApiV1DataImportImportIdGetRequest
 */
export interface DataImportApiApiV1DataImportImportIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdGet
     */
    readonly importId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DataImportImportIdLaunchPost operation in DataImportApi.
 * @export
 * @interface DataImportApiApiV1DataImportImportIdLaunchPostRequest
 */
export interface DataImportApiApiV1DataImportImportIdLaunchPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdLaunchPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdLaunchPost
     */
    readonly importId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdLaunchPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {LaunchImportDto}
     * @memberof DataImportApiApiV1DataImportImportIdLaunchPost
     */
    readonly launchImportDto?: LaunchImportDto
}

/**
 * Request parameters for apiV1DataImportImportIdLaunchSimulatePost operation in DataImportApi.
 * @export
 * @interface DataImportApiApiV1DataImportImportIdLaunchSimulatePostRequest
 */
export interface DataImportApiApiV1DataImportImportIdLaunchSimulatePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdLaunchSimulatePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdLaunchSimulatePost
     */
    readonly importId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdLaunchSimulatePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {LaunchImportDto}
     * @memberof DataImportApiApiV1DataImportImportIdLaunchSimulatePost
     */
    readonly launchImportDto?: LaunchImportDto
}

/**
 * Request parameters for apiV1DataImportImportIdMappingAutomapPost operation in DataImportApi.
 * @export
 * @interface DataImportApiApiV1DataImportImportIdMappingAutomapPostRequest
 */
export interface DataImportApiApiV1DataImportImportIdMappingAutomapPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdMappingAutomapPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdMappingAutomapPost
     */
    readonly importId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdMappingAutomapPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DataImportImportIdMappingSubmitPost operation in DataImportApi.
 * @export
 * @interface DataImportApiApiV1DataImportImportIdMappingSubmitPostRequest
 */
export interface DataImportApiApiV1DataImportImportIdMappingSubmitPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdMappingSubmitPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdMappingSubmitPost
     */
    readonly importId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdMappingSubmitPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {SubmitMappingDto}
     * @memberof DataImportApiApiV1DataImportImportIdMappingSubmitPost
     */
    readonly submitMappingDto?: SubmitMappingDto
}

/**
 * Request parameters for apiV1DataImportImportIdUploadSubmitPost operation in DataImportApi.
 * @export
 * @interface DataImportApiApiV1DataImportImportIdUploadSubmitPostRequest
 */
export interface DataImportApiApiV1DataImportImportIdUploadSubmitPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdUploadSubmitPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdUploadSubmitPost
     */
    readonly importId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataImportApiApiV1DataImportImportIdUploadSubmitPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {SubmitUploadDto}
     * @memberof DataImportApiApiV1DataImportImportIdUploadSubmitPost
     */
    readonly submitUploadDto?: SubmitUploadDto
}

/**
 * Request parameters for apiV1DataImportMappingApplyPost operation in DataImportApi.
 * @export
 * @interface DataImportApiApiV1DataImportMappingApplyPostRequest
 */
export interface DataImportApiApiV1DataImportMappingApplyPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataImportApiApiV1DataImportMappingApplyPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataImportApiApiV1DataImportMappingApplyPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ApplyMappingToImportDto}
     * @memberof DataImportApiApiV1DataImportMappingApplyPost
     */
    readonly applyMappingToImportDto?: ApplyMappingToImportDto
}

/**
 * Request parameters for apiV1DataImportPost operation in DataImportApi.
 * @export
 * @interface DataImportApiApiV1DataImportPostRequest
 */
export interface DataImportApiApiV1DataImportPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataImportApiApiV1DataImportPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataImportApiApiV1DataImportPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DataImportTemplatesGet operation in DataImportApi.
 * @export
 * @interface DataImportApiApiV1DataImportTemplatesGetRequest
 */
export interface DataImportApiApiV1DataImportTemplatesGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataImportApiApiV1DataImportTemplatesGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataImportApiApiV1DataImportTemplatesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ImportType}
     * @memberof DataImportApiApiV1DataImportTemplatesGet
     */
    readonly type?: ImportType
}

/**
 * Request parameters for apiV1DataImportTemplatesTemplateIdGet operation in DataImportApi.
 * @export
 * @interface DataImportApiApiV1DataImportTemplatesTemplateIdGetRequest
 */
export interface DataImportApiApiV1DataImportTemplatesTemplateIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataImportApiApiV1DataImportTemplatesTemplateIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DataImportApiApiV1DataImportTemplatesTemplateIdGet
     */
    readonly templateId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataImportApiApiV1DataImportTemplatesTemplateIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DataImportTypeSpecGet operation in DataImportApi.
 * @export
 * @interface DataImportApiApiV1DataImportTypeSpecGetRequest
 */
export interface DataImportApiApiV1DataImportTypeSpecGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DataImportApiApiV1DataImportTypeSpecGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {ImportType}
     * @memberof DataImportApiApiV1DataImportTypeSpecGet
     */
    readonly type: ImportType

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DataImportApiApiV1DataImportTypeSpecGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * DataImportApi - object-oriented interface
 * @export
 * @class DataImportApi
 * @extends {BaseAPI}
 */
export class DataImportApi extends BaseAPI {
    /**
     * 
     * @param {DataImportApiApiV1DataImportFileExampleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiV1DataImportFileExampleGet(requestParameters: DataImportApiApiV1DataImportFileExampleGetRequest, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiV1DataImportFileExampleGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.type, requestParameters.mimeType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataImportApiApiV1DataImportGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiV1DataImportGetPost(requestParameters: DataImportApiApiV1DataImportGetPostRequest, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiV1DataImportGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.importGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataImportApiApiV1DataImportImportIdDataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiV1DataImportImportIdDataGet(requestParameters: DataImportApiApiV1DataImportImportIdDataGetRequest, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiV1DataImportImportIdDataGet(requestParameters.nexusOpsTenant, requestParameters.importId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataImportApiApiV1DataImportImportIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiV1DataImportImportIdGet(requestParameters: DataImportApiApiV1DataImportImportIdGetRequest, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiV1DataImportImportIdGet(requestParameters.nexusOpsTenant, requestParameters.importId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataImportApiApiV1DataImportImportIdLaunchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiV1DataImportImportIdLaunchPost(requestParameters: DataImportApiApiV1DataImportImportIdLaunchPostRequest, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiV1DataImportImportIdLaunchPost(requestParameters.nexusOpsTenant, requestParameters.importId, requestParameters.nexusOpsAppVersion, requestParameters.launchImportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataImportApiApiV1DataImportImportIdLaunchSimulatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiV1DataImportImportIdLaunchSimulatePost(requestParameters: DataImportApiApiV1DataImportImportIdLaunchSimulatePostRequest, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiV1DataImportImportIdLaunchSimulatePost(requestParameters.nexusOpsTenant, requestParameters.importId, requestParameters.nexusOpsAppVersion, requestParameters.launchImportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataImportApiApiV1DataImportImportIdMappingAutomapPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiV1DataImportImportIdMappingAutomapPost(requestParameters: DataImportApiApiV1DataImportImportIdMappingAutomapPostRequest, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiV1DataImportImportIdMappingAutomapPost(requestParameters.nexusOpsTenant, requestParameters.importId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataImportApiApiV1DataImportImportIdMappingSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiV1DataImportImportIdMappingSubmitPost(requestParameters: DataImportApiApiV1DataImportImportIdMappingSubmitPostRequest, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiV1DataImportImportIdMappingSubmitPost(requestParameters.nexusOpsTenant, requestParameters.importId, requestParameters.nexusOpsAppVersion, requestParameters.submitMappingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataImportApiApiV1DataImportImportIdUploadSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiV1DataImportImportIdUploadSubmitPost(requestParameters: DataImportApiApiV1DataImportImportIdUploadSubmitPostRequest, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiV1DataImportImportIdUploadSubmitPost(requestParameters.nexusOpsTenant, requestParameters.importId, requestParameters.nexusOpsAppVersion, requestParameters.submitUploadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataImportApiApiV1DataImportMappingApplyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiV1DataImportMappingApplyPost(requestParameters: DataImportApiApiV1DataImportMappingApplyPostRequest, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiV1DataImportMappingApplyPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.applyMappingToImportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataImportApiApiV1DataImportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiV1DataImportPost(requestParameters: DataImportApiApiV1DataImportPostRequest, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiV1DataImportPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataImportApiApiV1DataImportTemplatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiV1DataImportTemplatesGet(requestParameters: DataImportApiApiV1DataImportTemplatesGetRequest, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiV1DataImportTemplatesGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataImportApiApiV1DataImportTemplatesTemplateIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiV1DataImportTemplatesTemplateIdGet(requestParameters: DataImportApiApiV1DataImportTemplatesTemplateIdGetRequest, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiV1DataImportTemplatesTemplateIdGet(requestParameters.nexusOpsTenant, requestParameters.templateId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataImportApiApiV1DataImportTypeSpecGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiV1DataImportTypeSpecGet(requestParameters: DataImportApiApiV1DataImportTypeSpecGetRequest, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiV1DataImportTypeSpecGet(requestParameters.nexusOpsTenant, requestParameters.type, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DepartmentsApi - axios parameter creator
 * @export
 */
export const DepartmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/departments/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdDelete: async (nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdDelete', 'departmentId', departmentId)
            const localVarPath = `/api/v1/departments/{departmentId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdGet: async (nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdGet', 'departmentId', departmentId)
            const localVarPath = `/api/v1/departments/{departmentId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdLocationsLocationIdDelete: async (nexusOpsTenant: string, departmentId: string, locationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdLocationsLocationIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdLocationsLocationIdDelete', 'departmentId', departmentId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdLocationsLocationIdDelete', 'locationId', locationId)
            const localVarPath = `/api/v1/departments/{departmentId}/locations/{locationId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddDepartmentLocationsDto} [addDepartmentLocationsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdLocationsPost: async (nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, addDepartmentLocationsDto?: AddDepartmentLocationsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdLocationsPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdLocationsPost', 'departmentId', departmentId)
            const localVarPath = `/api/v1/departments/{departmentId}/locations`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDepartmentLocationsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateDepartmentDto} [updateDepartmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdPut: async (nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, updateDepartmentDto?: UpdateDepartmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdPut', 'departmentId', departmentId)
            const localVarPath = `/api/v1/departments/{departmentId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDepartmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdReferenceGet: async (nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdReferenceGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdReferenceGet', 'departmentId', departmentId)
            const localVarPath = `/api/v1/departments/{departmentId}/reference`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UserGetPaginatedDto} [userGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdUsersCandidatesGetPost: async (nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, userGetPaginatedDto?: UserGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersCandidatesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersCandidatesGetPost', 'departmentId', departmentId)
            const localVarPath = `/api/v1/departments/{departmentId}/users/candidates/get`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UserGetPaginatedDto} [userGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdUsersGetPost: async (nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, userGetPaginatedDto?: UserGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersGetPost', 'departmentId', departmentId)
            const localVarPath = `/api/v1/departments/{departmentId}/users/get`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddUsersToLocationDto} [addUsersToLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost: async (nexusOpsTenant: string, departmentId: string, locationId: string, nexusOpsAppVersion?: string, addUsersToLocationDto?: AddUsersToLocationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost', 'departmentId', departmentId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost', 'locationId', locationId)
            const localVarPath = `/api/v1/departments/{departmentId}/users-locations/{locationId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addUsersToLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} userId 
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete: async (nexusOpsTenant: string, departmentId: string, userId: string, locationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete', 'departmentId', departmentId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete', 'userId', userId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete', 'locationId', locationId)
            const localVarPath = `/api/v1/departments/{departmentId}/users-locations/{locationId}/{userId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddUsersToDepartmentDto} [addUsersToDepartmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdUsersPost: async (nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, addUsersToDepartmentDto?: AddUsersToDepartmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersPost', 'departmentId', departmentId)
            const localVarPath = `/api/v1/departments/{departmentId}/users`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addUsersToDepartmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdUsersUserIdDelete: async (nexusOpsTenant: string, departmentId: string, userId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersUserIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersUserIdDelete', 'departmentId', departmentId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1DepartmentsDepartmentIdUsersUserIdDelete', 'userId', userId)
            const localVarPath = `/api/v1/departments/{departmentId}/users/{userId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DepartmentGetPaginatedDto} [departmentGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, departmentGetPaginatedDto?: DepartmentGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/departments/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(departmentGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateDepartmentDto} [createDepartmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createDepartmentDto?: CreateDepartmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DepartmentsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDepartmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentsApi - functional programming interface
 * @export
 */
export const DepartmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsDepartmentIdDelete(nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsDepartmentIdDelete(nexusOpsTenant, departmentId, nexusOpsAppVersion, isDeleteCascade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsDepartmentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsDepartmentIdGet(nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsDepartmentIdGet(nexusOpsTenant, departmentId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsDepartmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsDepartmentIdLocationsLocationIdDelete(nexusOpsTenant: string, departmentId: string, locationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsDepartmentIdLocationsLocationIdDelete(nexusOpsTenant, departmentId, locationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsDepartmentIdLocationsLocationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddDepartmentLocationsDto} [addDepartmentLocationsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsDepartmentIdLocationsPost(nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, addDepartmentLocationsDto?: AddDepartmentLocationsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsDepartmentIdLocationsPost(nexusOpsTenant, departmentId, nexusOpsAppVersion, addDepartmentLocationsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsDepartmentIdLocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateDepartmentDto} [updateDepartmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsDepartmentIdPut(nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, updateDepartmentDto?: UpdateDepartmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsDepartmentIdPut(nexusOpsTenant, departmentId, nexusOpsAppVersion, updateDepartmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsDepartmentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsDepartmentIdReferenceGet(nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentReferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsDepartmentIdReferenceGet(nexusOpsTenant, departmentId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsDepartmentIdReferenceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UserGetPaginatedDto} [userGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsDepartmentIdUsersCandidatesGetPost(nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, userGetPaginatedDto?: UserGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsDepartmentIdUsersCandidatesGetPost(nexusOpsTenant, departmentId, nexusOpsAppVersion, userGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsDepartmentIdUsersCandidatesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UserGetPaginatedDto} [userGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsDepartmentIdUsersGetPost(nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, userGetPaginatedDto?: UserGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsDepartmentIdUsersGetPost(nexusOpsTenant, departmentId, nexusOpsAppVersion, userGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsDepartmentIdUsersGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddUsersToLocationDto} [addUsersToLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost(nexusOpsTenant: string, departmentId: string, locationId: string, nexusOpsAppVersion?: string, addUsersToLocationDto?: AddUsersToLocationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost(nexusOpsTenant, departmentId, locationId, nexusOpsAppVersion, addUsersToLocationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} userId 
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete(nexusOpsTenant: string, departmentId: string, userId: string, locationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete(nexusOpsTenant, departmentId, userId, locationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddUsersToDepartmentDto} [addUsersToDepartmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsDepartmentIdUsersPost(nexusOpsTenant: string, departmentId: string, nexusOpsAppVersion?: string, addUsersToDepartmentDto?: AddUsersToDepartmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsDepartmentIdUsersPost(nexusOpsTenant, departmentId, nexusOpsAppVersion, addUsersToDepartmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsDepartmentIdUsersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} departmentId 
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsDepartmentIdUsersUserIdDelete(nexusOpsTenant: string, departmentId: string, userId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsDepartmentIdUsersUserIdDelete(nexusOpsTenant, departmentId, userId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsDepartmentIdUsersUserIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DepartmentGetPaginatedDto} [departmentGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, departmentGetPaginatedDto?: DepartmentGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfDepartmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsGetPost(nexusOpsTenant, nexusOpsAppVersion, departmentGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateDepartmentDto} [createDepartmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DepartmentsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createDepartmentDto?: CreateDepartmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DepartmentsPost(nexusOpsTenant, nexusOpsAppVersion, createDepartmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.apiV1DepartmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DepartmentsApi - factory interface
 * @export
 */
export const DepartmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentsApiFp(configuration)
    return {
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsBulkDeleteDelete(requestParameters: DepartmentsApiApiV1DepartmentsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DepartmentsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsDepartmentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdDelete(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DepartmentsDepartmentIdDelete(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsDepartmentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdGet(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DepartmentDto> {
            return localVarFp.apiV1DepartmentsDepartmentIdGet(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsDepartmentIdLocationsLocationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdLocationsLocationIdDelete(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdLocationsLocationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DepartmentDto> {
            return localVarFp.apiV1DepartmentsDepartmentIdLocationsLocationIdDelete(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.locationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsDepartmentIdLocationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdLocationsPost(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdLocationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DepartmentDto> {
            return localVarFp.apiV1DepartmentsDepartmentIdLocationsPost(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, requestParameters.addDepartmentLocationsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsDepartmentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdPut(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DepartmentDto> {
            return localVarFp.apiV1DepartmentsDepartmentIdPut(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, requestParameters.updateDepartmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsDepartmentIdReferenceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdReferenceGet(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdReferenceGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DepartmentReferenceDto> {
            return localVarFp.apiV1DepartmentsDepartmentIdReferenceGet(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsDepartmentIdUsersCandidatesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdUsersCandidatesGetPost(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdUsersCandidatesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfUserDto> {
            return localVarFp.apiV1DepartmentsDepartmentIdUsersCandidatesGetPost(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, requestParameters.userGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsDepartmentIdUsersGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdUsersGetPost(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdUsersGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfUserDto> {
            return localVarFp.apiV1DepartmentsDepartmentIdUsersGetPost(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, requestParameters.userGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DepartmentDto> {
            return localVarFp.apiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.locationId, requestParameters.nexusOpsAppVersion, requestParameters.addUsersToLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DepartmentDto> {
            return localVarFp.apiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.userId, requestParameters.locationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsDepartmentIdUsersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdUsersPost(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdUsersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DepartmentDto> {
            return localVarFp.apiV1DepartmentsDepartmentIdUsersPost(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, requestParameters.addUsersToDepartmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsDepartmentIdUsersUserIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsDepartmentIdUsersUserIdDelete(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdUsersUserIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DepartmentDto> {
            return localVarFp.apiV1DepartmentsDepartmentIdUsersUserIdDelete(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.userId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsGetPost(requestParameters: DepartmentsApiApiV1DepartmentsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfDepartmentDto> {
            return localVarFp.apiV1DepartmentsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.departmentGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DepartmentsApiApiV1DepartmentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsPost(requestParameters: DepartmentsApiApiV1DepartmentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DepartmentDto> {
            return localVarFp.apiV1DepartmentsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createDepartmentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DepartmentsBulkDeleteDelete operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsBulkDeleteDeleteRequest
 */
export interface DepartmentsApiApiV1DepartmentsBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof DepartmentsApiApiV1DepartmentsBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1DepartmentsDepartmentIdDelete operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsDepartmentIdDeleteRequest
 */
export interface DepartmentsApiApiV1DepartmentsDepartmentIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdDelete
     */
    readonly departmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdDelete
     */
    readonly isDeleteCascade?: boolean
}

/**
 * Request parameters for apiV1DepartmentsDepartmentIdGet operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsDepartmentIdGetRequest
 */
export interface DepartmentsApiApiV1DepartmentsDepartmentIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdGet
     */
    readonly departmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DepartmentsDepartmentIdLocationsLocationIdDelete operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsDepartmentIdLocationsLocationIdDeleteRequest
 */
export interface DepartmentsApiApiV1DepartmentsDepartmentIdLocationsLocationIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdLocationsLocationIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdLocationsLocationIdDelete
     */
    readonly departmentId: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdLocationsLocationIdDelete
     */
    readonly locationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdLocationsLocationIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DepartmentsDepartmentIdLocationsPost operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsDepartmentIdLocationsPostRequest
 */
export interface DepartmentsApiApiV1DepartmentsDepartmentIdLocationsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdLocationsPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdLocationsPost
     */
    readonly departmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdLocationsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AddDepartmentLocationsDto}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdLocationsPost
     */
    readonly addDepartmentLocationsDto?: AddDepartmentLocationsDto
}

/**
 * Request parameters for apiV1DepartmentsDepartmentIdPut operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsDepartmentIdPutRequest
 */
export interface DepartmentsApiApiV1DepartmentsDepartmentIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdPut
     */
    readonly departmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateDepartmentDto}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdPut
     */
    readonly updateDepartmentDto?: UpdateDepartmentDto
}

/**
 * Request parameters for apiV1DepartmentsDepartmentIdReferenceGet operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsDepartmentIdReferenceGetRequest
 */
export interface DepartmentsApiApiV1DepartmentsDepartmentIdReferenceGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdReferenceGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdReferenceGet
     */
    readonly departmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdReferenceGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DepartmentsDepartmentIdUsersCandidatesGetPost operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsDepartmentIdUsersCandidatesGetPostRequest
 */
export interface DepartmentsApiApiV1DepartmentsDepartmentIdUsersCandidatesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersCandidatesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersCandidatesGetPost
     */
    readonly departmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersCandidatesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UserGetPaginatedDto}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersCandidatesGetPost
     */
    readonly userGetPaginatedDto?: UserGetPaginatedDto
}

/**
 * Request parameters for apiV1DepartmentsDepartmentIdUsersGetPost operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsDepartmentIdUsersGetPostRequest
 */
export interface DepartmentsApiApiV1DepartmentsDepartmentIdUsersGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersGetPost
     */
    readonly departmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UserGetPaginatedDto}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersGetPost
     */
    readonly userGetPaginatedDto?: UserGetPaginatedDto
}

/**
 * Request parameters for apiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdPostRequest
 */
export interface DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost
     */
    readonly departmentId: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost
     */
    readonly locationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AddUsersToLocationDto}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost
     */
    readonly addUsersToLocationDto?: AddUsersToLocationDto
}

/**
 * Request parameters for apiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDeleteRequest
 */
export interface DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete
     */
    readonly departmentId: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete
     */
    readonly locationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DepartmentsDepartmentIdUsersPost operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsDepartmentIdUsersPostRequest
 */
export interface DepartmentsApiApiV1DepartmentsDepartmentIdUsersPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersPost
     */
    readonly departmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AddUsersToDepartmentDto}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersPost
     */
    readonly addUsersToDepartmentDto?: AddUsersToDepartmentDto
}

/**
 * Request parameters for apiV1DepartmentsDepartmentIdUsersUserIdDelete operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsDepartmentIdUsersUserIdDeleteRequest
 */
export interface DepartmentsApiApiV1DepartmentsDepartmentIdUsersUserIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersUserIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersUserIdDelete
     */
    readonly departmentId: string

    /**
     * 
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersUserIdDelete
     */
    readonly userId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsDepartmentIdUsersUserIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DepartmentsGetPost operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsGetPostRequest
 */
export interface DepartmentsApiApiV1DepartmentsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DepartmentGetPaginatedDto}
     * @memberof DepartmentsApiApiV1DepartmentsGetPost
     */
    readonly departmentGetPaginatedDto?: DepartmentGetPaginatedDto
}

/**
 * Request parameters for apiV1DepartmentsPost operation in DepartmentsApi.
 * @export
 * @interface DepartmentsApiApiV1DepartmentsPostRequest
 */
export interface DepartmentsApiApiV1DepartmentsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DepartmentsApiApiV1DepartmentsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateDepartmentDto}
     * @memberof DepartmentsApiApiV1DepartmentsPost
     */
    readonly createDepartmentDto?: CreateDepartmentDto
}

/**
 * DepartmentsApi - object-oriented interface
 * @export
 * @class DepartmentsApi
 * @extends {BaseAPI}
 */
export class DepartmentsApi extends BaseAPI {
    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsBulkDeleteDelete(requestParameters: DepartmentsApiApiV1DepartmentsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsDepartmentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsDepartmentIdDelete(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsDepartmentIdDelete(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsDepartmentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsDepartmentIdGet(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdGetRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsDepartmentIdGet(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsDepartmentIdLocationsLocationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsDepartmentIdLocationsLocationIdDelete(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdLocationsLocationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsDepartmentIdLocationsLocationIdDelete(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.locationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsDepartmentIdLocationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsDepartmentIdLocationsPost(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdLocationsPostRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsDepartmentIdLocationsPost(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, requestParameters.addDepartmentLocationsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsDepartmentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsDepartmentIdPut(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdPutRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsDepartmentIdPut(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, requestParameters.updateDepartmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsDepartmentIdReferenceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsDepartmentIdReferenceGet(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdReferenceGetRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsDepartmentIdReferenceGet(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsDepartmentIdUsersCandidatesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsDepartmentIdUsersCandidatesGetPost(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdUsersCandidatesGetPostRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsDepartmentIdUsersCandidatesGetPost(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, requestParameters.userGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsDepartmentIdUsersGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsDepartmentIdUsersGetPost(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdUsersGetPostRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsDepartmentIdUsersGetPost(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, requestParameters.userGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdPostRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsDepartmentIdUsersLocationsLocationIdPost(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.locationId, requestParameters.nexusOpsAppVersion, requestParameters.addUsersToLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsDepartmentIdUsersLocationsLocationIdUserIdDelete(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.userId, requestParameters.locationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsDepartmentIdUsersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsDepartmentIdUsersPost(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdUsersPostRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsDepartmentIdUsersPost(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, requestParameters.addUsersToDepartmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsDepartmentIdUsersUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsDepartmentIdUsersUserIdDelete(requestParameters: DepartmentsApiApiV1DepartmentsDepartmentIdUsersUserIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsDepartmentIdUsersUserIdDelete(requestParameters.nexusOpsTenant, requestParameters.departmentId, requestParameters.userId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsGetPost(requestParameters: DepartmentsApiApiV1DepartmentsGetPostRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.departmentGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DepartmentsApiApiV1DepartmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiV1DepartmentsPost(requestParameters: DepartmentsApiApiV1DepartmentsPostRequest, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).apiV1DepartmentsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createDepartmentDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DevApi - axios parameter creator
 * @export
 */
export const DevApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevOnboardingGetOrCreateForCurrentUserPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DevOnboardingGetOrCreateForCurrentUserPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/dev/onboarding/get-or-create-for-current-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevApi - functional programming interface
 * @export
 */
export const DevApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DevOnboardingGetOrCreateForCurrentUserPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DevOnboardingGetOrCreateForCurrentUserPost(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevApi.apiV1DevOnboardingGetOrCreateForCurrentUserPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevApi - factory interface
 * @export
 */
export const DevApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevApiFp(configuration)
    return {
        /**
         * 
         * @param {DevApiApiV1DevOnboardingGetOrCreateForCurrentUserPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevOnboardingGetOrCreateForCurrentUserPost(requestParameters: DevApiApiV1DevOnboardingGetOrCreateForCurrentUserPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingDto> {
            return localVarFp.apiV1DevOnboardingGetOrCreateForCurrentUserPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DevOnboardingGetOrCreateForCurrentUserPost operation in DevApi.
 * @export
 * @interface DevApiApiV1DevOnboardingGetOrCreateForCurrentUserPostRequest
 */
export interface DevApiApiV1DevOnboardingGetOrCreateForCurrentUserPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DevApiApiV1DevOnboardingGetOrCreateForCurrentUserPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DevApiApiV1DevOnboardingGetOrCreateForCurrentUserPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * DevApi - object-oriented interface
 * @export
 * @class DevApi
 * @extends {BaseAPI}
 */
export class DevApi extends BaseAPI {
    /**
     * 
     * @param {DevApiApiV1DevOnboardingGetOrCreateForCurrentUserPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevApi
     */
    public apiV1DevOnboardingGetOrCreateForCurrentUserPost(requestParameters: DevApiApiV1DevOnboardingGetOrCreateForCurrentUserPostRequest, options?: RawAxiosRequestConfig) {
        return DevApiFp(this.configuration).apiV1DevOnboardingGetOrCreateForCurrentUserPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeviceTokensApi - axios parameter creator
 * @export
 */
export const DeviceTokensApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RegisterDeviceTokenDto} [registerDeviceTokenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceTokensPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, registerDeviceTokenDto?: RegisterDeviceTokenDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DeviceTokensPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/device-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerDeviceTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceTokensApi - functional programming interface
 * @export
 */
export const DeviceTokensApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeviceTokensApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RegisterDeviceTokenDto} [registerDeviceTokenDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DeviceTokensPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, registerDeviceTokenDto?: RegisterDeviceTokenDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DeviceTokensPost(nexusOpsTenant, nexusOpsAppVersion, registerDeviceTokenDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceTokensApi.apiV1DeviceTokensPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeviceTokensApi - factory interface
 * @export
 */
export const DeviceTokensApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeviceTokensApiFp(configuration)
    return {
        /**
         * 
         * @param {DeviceTokensApiApiV1DeviceTokensPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceTokensPost(requestParameters: DeviceTokensApiApiV1DeviceTokensPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DeviceTokensPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.registerDeviceTokenDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DeviceTokensPost operation in DeviceTokensApi.
 * @export
 * @interface DeviceTokensApiApiV1DeviceTokensPostRequest
 */
export interface DeviceTokensApiApiV1DeviceTokensPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DeviceTokensApiApiV1DeviceTokensPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DeviceTokensApiApiV1DeviceTokensPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RegisterDeviceTokenDto}
     * @memberof DeviceTokensApiApiV1DeviceTokensPost
     */
    readonly registerDeviceTokenDto?: RegisterDeviceTokenDto
}

/**
 * DeviceTokensApi - object-oriented interface
 * @export
 * @class DeviceTokensApi
 * @extends {BaseAPI}
 */
export class DeviceTokensApi extends BaseAPI {
    /**
     * 
     * @param {DeviceTokensApiApiV1DeviceTokensPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceTokensApi
     */
    public apiV1DeviceTokensPost(requestParameters: DeviceTokensApiApiV1DeviceTokensPostRequest, options?: RawAxiosRequestConfig) {
        return DeviceTokensApiFp(this.configuration).apiV1DeviceTokensPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.registerDeviceTokenDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentIntelligenceApi - axios parameter creator
 * @export
 */
export const DocumentIntelligenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<File>} [inputFiles] 
         * @param {ExtractedDocumentType} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentIntelligenceExtractDataPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, inputFiles?: Array<File>, documentType?: ExtractedDocumentType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DocumentIntelligenceExtractDataPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/document-intelligence/extract-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }

            if (inputFiles) {
                inputFiles.forEach((element) => {
                    localVarFormParams.append('inputFiles', element as any);
                })
            }

    
            if (documentType !== undefined) { 
                localVarFormParams.append('documentType', documentType as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentIntelligenceApi - functional programming interface
 * @export
 */
export const DocumentIntelligenceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentIntelligenceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<File>} [inputFiles] 
         * @param {ExtractedDocumentType} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DocumentIntelligenceExtractDataPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, inputFiles?: Array<File>, documentType?: ExtractedDocumentType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDataExtractionResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DocumentIntelligenceExtractDataPost(nexusOpsTenant, nexusOpsAppVersion, inputFiles, documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentIntelligenceApi.apiV1DocumentIntelligenceExtractDataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentIntelligenceApi - factory interface
 * @export
 */
export const DocumentIntelligenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentIntelligenceApiFp(configuration)
    return {
        /**
         * 
         * @param {DocumentIntelligenceApiApiV1DocumentIntelligenceExtractDataPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentIntelligenceExtractDataPost(requestParameters: DocumentIntelligenceApiApiV1DocumentIntelligenceExtractDataPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDataExtractionResultDto> {
            return localVarFp.apiV1DocumentIntelligenceExtractDataPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.inputFiles, requestParameters.documentType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DocumentIntelligenceExtractDataPost operation in DocumentIntelligenceApi.
 * @export
 * @interface DocumentIntelligenceApiApiV1DocumentIntelligenceExtractDataPostRequest
 */
export interface DocumentIntelligenceApiApiV1DocumentIntelligenceExtractDataPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DocumentIntelligenceApiApiV1DocumentIntelligenceExtractDataPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DocumentIntelligenceApiApiV1DocumentIntelligenceExtractDataPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<File>}
     * @memberof DocumentIntelligenceApiApiV1DocumentIntelligenceExtractDataPost
     */
    readonly inputFiles?: Array<File>

    /**
     * 
     * @type {ExtractedDocumentType}
     * @memberof DocumentIntelligenceApiApiV1DocumentIntelligenceExtractDataPost
     */
    readonly documentType?: ExtractedDocumentType
}

/**
 * DocumentIntelligenceApi - object-oriented interface
 * @export
 * @class DocumentIntelligenceApi
 * @extends {BaseAPI}
 */
export class DocumentIntelligenceApi extends BaseAPI {
    /**
     * 
     * @param {DocumentIntelligenceApiApiV1DocumentIntelligenceExtractDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentIntelligenceApi
     */
    public apiV1DocumentIntelligenceExtractDataPost(requestParameters: DocumentIntelligenceApiApiV1DocumentIntelligenceExtractDataPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentIntelligenceApiFp(this.configuration).apiV1DocumentIntelligenceExtractDataPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.inputFiles, requestParameters.documentType, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RemoveDocumentAttachmentsDto} [removeDocumentAttachmentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdAttachmentsDelete: async (nexusOpsTenant: string, documentId: string, nexusOpsAppVersion?: string, removeDocumentAttachmentsDto?: RemoveDocumentAttachmentsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdAttachmentsDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdAttachmentsDelete', 'documentId', documentId)
            const localVarPath = `/api/v1/documents/{documentId}/attachments`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeDocumentAttachmentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddDocumentAttachmentsDto} [addDocumentAttachmentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdAttachmentsPost: async (nexusOpsTenant: string, documentId: string, nexusOpsAppVersion?: string, addDocumentAttachmentsDto?: AddDocumentAttachmentsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdAttachmentsPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdAttachmentsPost', 'documentId', documentId)
            const localVarPath = `/api/v1/documents/{documentId}/attachments`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDocumentAttachmentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdDelete: async (nexusOpsTenant: string, documentId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdDelete', 'documentId', documentId)
            const localVarPath = `/api/v1/documents/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdDownloadPdfGet: async (nexusOpsTenant: string, documentId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdDownloadPdfGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdDownloadPdfGet', 'documentId', documentId)
            const localVarPath = `/api/v1/documents/{documentId}/download/pdf`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdGet: async (nexusOpsTenant: string, documentId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdGet', 'documentId', documentId)
            const localVarPath = `/api/v1/documents/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} itemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RemoveDocumentItemAttachmentsDto} [removeDocumentItemAttachmentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete: async (nexusOpsTenant: string, documentId: string, itemId: string, nexusOpsAppVersion?: string, removeDocumentItemAttachmentsDto?: RemoveDocumentItemAttachmentsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete', 'documentId', documentId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete', 'itemId', itemId)
            const localVarPath = `/api/v1/documents/{documentId}/items/{itemId}/attachments`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeDocumentItemAttachmentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} itemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddDocumentItemAttachmentsDto} [addDocumentItemAttachmentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdItemsItemIdAttachmentsPost: async (nexusOpsTenant: string, documentId: string, itemId: string, nexusOpsAppVersion?: string, addDocumentItemAttachmentsDto?: AddDocumentItemAttachmentsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdItemsItemIdAttachmentsPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdItemsItemIdAttachmentsPost', 'documentId', documentId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdItemsItemIdAttachmentsPost', 'itemId', itemId)
            const localVarPath = `/api/v1/documents/{documentId}/items/{itemId}/attachments`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDocumentItemAttachmentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdSendToCustomerPost: async (nexusOpsTenant: string, documentId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdSendToCustomerPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdSendToCustomerPost', 'documentId', documentId)
            const localVarPath = `/api/v1/documents/{documentId}/send-to-customer`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateDocumentStageDto} [updateDocumentStageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdStagePut: async (nexusOpsTenant: string, documentId: string, nexusOpsAppVersion?: string, updateDocumentStageDto?: UpdateDocumentStageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdStagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiV1DocumentsDocumentIdStagePut', 'documentId', documentId)
            const localVarPath = `/api/v1/documents/{documentId}/stage`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDocumentStageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DocumentGetPaginatedDto} [documentGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, documentGetPaginatedDto?: DocumentGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1DocumentsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/documents/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RemoveDocumentAttachmentsDto} [removeDocumentAttachmentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DocumentsDocumentIdAttachmentsDelete(nexusOpsTenant: string, documentId: string, nexusOpsAppVersion?: string, removeDocumentAttachmentsDto?: RemoveDocumentAttachmentsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DocumentsDocumentIdAttachmentsDelete(nexusOpsTenant, documentId, nexusOpsAppVersion, removeDocumentAttachmentsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiV1DocumentsDocumentIdAttachmentsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddDocumentAttachmentsDto} [addDocumentAttachmentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DocumentsDocumentIdAttachmentsPost(nexusOpsTenant: string, documentId: string, nexusOpsAppVersion?: string, addDocumentAttachmentsDto?: AddDocumentAttachmentsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DocumentsDocumentIdAttachmentsPost(nexusOpsTenant, documentId, nexusOpsAppVersion, addDocumentAttachmentsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiV1DocumentsDocumentIdAttachmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DocumentsDocumentIdDelete(nexusOpsTenant: string, documentId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DocumentsDocumentIdDelete(nexusOpsTenant, documentId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiV1DocumentsDocumentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DocumentsDocumentIdDownloadPdfGet(nexusOpsTenant: string, documentId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DocumentsDocumentIdDownloadPdfGet(nexusOpsTenant, documentId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiV1DocumentsDocumentIdDownloadPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DocumentsDocumentIdGet(nexusOpsTenant: string, documentId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DocumentsDocumentIdGet(nexusOpsTenant, documentId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiV1DocumentsDocumentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} itemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RemoveDocumentItemAttachmentsDto} [removeDocumentItemAttachmentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete(nexusOpsTenant: string, documentId: string, itemId: string, nexusOpsAppVersion?: string, removeDocumentItemAttachmentsDto?: RemoveDocumentItemAttachmentsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete(nexusOpsTenant, documentId, itemId, nexusOpsAppVersion, removeDocumentItemAttachmentsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} itemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddDocumentItemAttachmentsDto} [addDocumentItemAttachmentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DocumentsDocumentIdItemsItemIdAttachmentsPost(nexusOpsTenant: string, documentId: string, itemId: string, nexusOpsAppVersion?: string, addDocumentItemAttachmentsDto?: AddDocumentItemAttachmentsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DocumentsDocumentIdItemsItemIdAttachmentsPost(nexusOpsTenant, documentId, itemId, nexusOpsAppVersion, addDocumentItemAttachmentsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiV1DocumentsDocumentIdItemsItemIdAttachmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DocumentsDocumentIdSendToCustomerPost(nexusOpsTenant: string, documentId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DocumentsDocumentIdSendToCustomerPost(nexusOpsTenant, documentId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiV1DocumentsDocumentIdSendToCustomerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} documentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateDocumentStageDto} [updateDocumentStageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DocumentsDocumentIdStagePut(nexusOpsTenant: string, documentId: string, nexusOpsAppVersion?: string, updateDocumentStageDto?: UpdateDocumentStageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DocumentsDocumentIdStagePut(nexusOpsTenant, documentId, nexusOpsAppVersion, updateDocumentStageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiV1DocumentsDocumentIdStagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {DocumentGetPaginatedDto} [documentGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DocumentsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, documentGetPaginatedDto?: DocumentGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DocumentsGetPost(nexusOpsTenant, nexusOpsAppVersion, documentGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiV1DocumentsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentsApiFp(configuration)
    return {
        /**
         * 
         * @param {DocumentsApiApiV1DocumentsDocumentIdAttachmentsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdAttachmentsDelete(requestParameters: DocumentsApiApiV1DocumentsDocumentIdAttachmentsDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDto> {
            return localVarFp.apiV1DocumentsDocumentIdAttachmentsDelete(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.nexusOpsAppVersion, requestParameters.removeDocumentAttachmentsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiV1DocumentsDocumentIdAttachmentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdAttachmentsPost(requestParameters: DocumentsApiApiV1DocumentsDocumentIdAttachmentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDto> {
            return localVarFp.apiV1DocumentsDocumentIdAttachmentsPost(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.nexusOpsAppVersion, requestParameters.addDocumentAttachmentsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiV1DocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdDelete(requestParameters: DocumentsApiApiV1DocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DocumentsDocumentIdDelete(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiV1DocumentsDocumentIdDownloadPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdDownloadPdfGet(requestParameters: DocumentsApiApiV1DocumentsDocumentIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1DocumentsDocumentIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiV1DocumentsDocumentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdGet(requestParameters: DocumentsApiApiV1DocumentsDocumentIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDto> {
            return localVarFp.apiV1DocumentsDocumentIdGet(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete(requestParameters: DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentItemDto> {
            return localVarFp.apiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.itemId, requestParameters.nexusOpsAppVersion, requestParameters.removeDocumentItemAttachmentsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdItemsItemIdAttachmentsPost(requestParameters: DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentItemDto> {
            return localVarFp.apiV1DocumentsDocumentIdItemsItemIdAttachmentsPost(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.itemId, requestParameters.nexusOpsAppVersion, requestParameters.addDocumentItemAttachmentsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiV1DocumentsDocumentIdSendToCustomerPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdSendToCustomerPost(requestParameters: DocumentsApiApiV1DocumentsDocumentIdSendToCustomerPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1DocumentsDocumentIdSendToCustomerPost(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiV1DocumentsDocumentIdStagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsDocumentIdStagePut(requestParameters: DocumentsApiApiV1DocumentsDocumentIdStagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDto> {
            return localVarFp.apiV1DocumentsDocumentIdStagePut(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.nexusOpsAppVersion, requestParameters.updateDocumentStageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentsApiApiV1DocumentsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsGetPost(requestParameters: DocumentsApiApiV1DocumentsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfDocumentDto> {
            return localVarFp.apiV1DocumentsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.documentGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1DocumentsDocumentIdAttachmentsDelete operation in DocumentsApi.
 * @export
 * @interface DocumentsApiApiV1DocumentsDocumentIdAttachmentsDeleteRequest
 */
export interface DocumentsApiApiV1DocumentsDocumentIdAttachmentsDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdAttachmentsDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdAttachmentsDelete
     */
    readonly documentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdAttachmentsDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RemoveDocumentAttachmentsDto}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdAttachmentsDelete
     */
    readonly removeDocumentAttachmentsDto?: RemoveDocumentAttachmentsDto
}

/**
 * Request parameters for apiV1DocumentsDocumentIdAttachmentsPost operation in DocumentsApi.
 * @export
 * @interface DocumentsApiApiV1DocumentsDocumentIdAttachmentsPostRequest
 */
export interface DocumentsApiApiV1DocumentsDocumentIdAttachmentsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdAttachmentsPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdAttachmentsPost
     */
    readonly documentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdAttachmentsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AddDocumentAttachmentsDto}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdAttachmentsPost
     */
    readonly addDocumentAttachmentsDto?: AddDocumentAttachmentsDto
}

/**
 * Request parameters for apiV1DocumentsDocumentIdDelete operation in DocumentsApi.
 * @export
 * @interface DocumentsApiApiV1DocumentsDocumentIdDeleteRequest
 */
export interface DocumentsApiApiV1DocumentsDocumentIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdDelete
     */
    readonly documentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DocumentsDocumentIdDownloadPdfGet operation in DocumentsApi.
 * @export
 * @interface DocumentsApiApiV1DocumentsDocumentIdDownloadPdfGetRequest
 */
export interface DocumentsApiApiV1DocumentsDocumentIdDownloadPdfGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdDownloadPdfGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdDownloadPdfGet
     */
    readonly documentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdDownloadPdfGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DocumentsDocumentIdGet operation in DocumentsApi.
 * @export
 * @interface DocumentsApiApiV1DocumentsDocumentIdGetRequest
 */
export interface DocumentsApiApiV1DocumentsDocumentIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdGet
     */
    readonly documentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete operation in DocumentsApi.
 * @export
 * @interface DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsDeleteRequest
 */
export interface DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete
     */
    readonly documentId: string

    /**
     * 
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete
     */
    readonly itemId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RemoveDocumentItemAttachmentsDto}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete
     */
    readonly removeDocumentItemAttachmentsDto?: RemoveDocumentItemAttachmentsDto
}

/**
 * Request parameters for apiV1DocumentsDocumentIdItemsItemIdAttachmentsPost operation in DocumentsApi.
 * @export
 * @interface DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsPostRequest
 */
export interface DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsPost
     */
    readonly documentId: string

    /**
     * 
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsPost
     */
    readonly itemId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AddDocumentItemAttachmentsDto}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsPost
     */
    readonly addDocumentItemAttachmentsDto?: AddDocumentItemAttachmentsDto
}

/**
 * Request parameters for apiV1DocumentsDocumentIdSendToCustomerPost operation in DocumentsApi.
 * @export
 * @interface DocumentsApiApiV1DocumentsDocumentIdSendToCustomerPostRequest
 */
export interface DocumentsApiApiV1DocumentsDocumentIdSendToCustomerPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdSendToCustomerPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdSendToCustomerPost
     */
    readonly documentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdSendToCustomerPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1DocumentsDocumentIdStagePut operation in DocumentsApi.
 * @export
 * @interface DocumentsApiApiV1DocumentsDocumentIdStagePutRequest
 */
export interface DocumentsApiApiV1DocumentsDocumentIdStagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdStagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdStagePut
     */
    readonly documentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdStagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateDocumentStageDto}
     * @memberof DocumentsApiApiV1DocumentsDocumentIdStagePut
     */
    readonly updateDocumentStageDto?: UpdateDocumentStageDto
}

/**
 * Request parameters for apiV1DocumentsGetPost operation in DocumentsApi.
 * @export
 * @interface DocumentsApiApiV1DocumentsGetPostRequest
 */
export interface DocumentsApiApiV1DocumentsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DocumentsApiApiV1DocumentsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {DocumentGetPaginatedDto}
     * @memberof DocumentsApiApiV1DocumentsGetPost
     */
    readonly documentGetPaginatedDto?: DocumentGetPaginatedDto
}

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     * 
     * @param {DocumentsApiApiV1DocumentsDocumentIdAttachmentsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public apiV1DocumentsDocumentIdAttachmentsDelete(requestParameters: DocumentsApiApiV1DocumentsDocumentIdAttachmentsDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiV1DocumentsDocumentIdAttachmentsDelete(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.nexusOpsAppVersion, requestParameters.removeDocumentAttachmentsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiV1DocumentsDocumentIdAttachmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public apiV1DocumentsDocumentIdAttachmentsPost(requestParameters: DocumentsApiApiV1DocumentsDocumentIdAttachmentsPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiV1DocumentsDocumentIdAttachmentsPost(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.nexusOpsAppVersion, requestParameters.addDocumentAttachmentsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiV1DocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public apiV1DocumentsDocumentIdDelete(requestParameters: DocumentsApiApiV1DocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiV1DocumentsDocumentIdDelete(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiV1DocumentsDocumentIdDownloadPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public apiV1DocumentsDocumentIdDownloadPdfGet(requestParameters: DocumentsApiApiV1DocumentsDocumentIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiV1DocumentsDocumentIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiV1DocumentsDocumentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public apiV1DocumentsDocumentIdGet(requestParameters: DocumentsApiApiV1DocumentsDocumentIdGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiV1DocumentsDocumentIdGet(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public apiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete(requestParameters: DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiV1DocumentsDocumentIdItemsItemIdAttachmentsDelete(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.itemId, requestParameters.nexusOpsAppVersion, requestParameters.removeDocumentItemAttachmentsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public apiV1DocumentsDocumentIdItemsItemIdAttachmentsPost(requestParameters: DocumentsApiApiV1DocumentsDocumentIdItemsItemIdAttachmentsPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiV1DocumentsDocumentIdItemsItemIdAttachmentsPost(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.itemId, requestParameters.nexusOpsAppVersion, requestParameters.addDocumentItemAttachmentsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiV1DocumentsDocumentIdSendToCustomerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public apiV1DocumentsDocumentIdSendToCustomerPost(requestParameters: DocumentsApiApiV1DocumentsDocumentIdSendToCustomerPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiV1DocumentsDocumentIdSendToCustomerPost(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiV1DocumentsDocumentIdStagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public apiV1DocumentsDocumentIdStagePut(requestParameters: DocumentsApiApiV1DocumentsDocumentIdStagePutRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiV1DocumentsDocumentIdStagePut(requestParameters.nexusOpsTenant, requestParameters.documentId, requestParameters.nexusOpsAppVersion, requestParameters.updateDocumentStageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentsApiApiV1DocumentsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public apiV1DocumentsGetPost(requestParameters: DocumentsApiApiV1DocumentsGetPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiV1DocumentsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.documentGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DomainEventsAdminApi - axios parameter creator
 * @export
 */
export const DomainEventsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SendTestEventsDto} [sendTestEventsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminDomainEventsTestSendPost: async (nexusOpsAppVersion?: string, sendTestEventsDto?: SendTestEventsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/domain-events/test/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendTestEventsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DomainEventsAdminApi - functional programming interface
 * @export
 */
export const DomainEventsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DomainEventsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SendTestEventsDto} [sendTestEventsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminDomainEventsTestSendPost(nexusOpsAppVersion?: string, sendTestEventsDto?: SendTestEventsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentIdentityTestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminDomainEventsTestSendPost(nexusOpsAppVersion, sendTestEventsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DomainEventsAdminApi.apiV1AdminDomainEventsTestSendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DomainEventsAdminApi - factory interface
 * @export
 */
export const DomainEventsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DomainEventsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {DomainEventsAdminApiApiV1AdminDomainEventsTestSendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminDomainEventsTestSendPost(requestParameters: DomainEventsAdminApiApiV1AdminDomainEventsTestSendPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CurrentIdentityTestDto> {
            return localVarFp.apiV1AdminDomainEventsTestSendPost(requestParameters.nexusOpsAppVersion, requestParameters.sendTestEventsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminDomainEventsTestSendPost operation in DomainEventsAdminApi.
 * @export
 * @interface DomainEventsAdminApiApiV1AdminDomainEventsTestSendPostRequest
 */
export interface DomainEventsAdminApiApiV1AdminDomainEventsTestSendPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof DomainEventsAdminApiApiV1AdminDomainEventsTestSendPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {SendTestEventsDto}
     * @memberof DomainEventsAdminApiApiV1AdminDomainEventsTestSendPost
     */
    readonly sendTestEventsDto?: SendTestEventsDto
}

/**
 * DomainEventsAdminApi - object-oriented interface
 * @export
 * @class DomainEventsAdminApi
 * @extends {BaseAPI}
 */
export class DomainEventsAdminApi extends BaseAPI {
    /**
     * 
     * @param {DomainEventsAdminApiApiV1AdminDomainEventsTestSendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainEventsAdminApi
     */
    public apiV1AdminDomainEventsTestSendPost(requestParameters: DomainEventsAdminApiApiV1AdminDomainEventsTestSendPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DomainEventsAdminApiFp(this.configuration).apiV1AdminDomainEventsTestSendPost(requestParameters.nexusOpsAppVersion, requestParameters.sendTestEventsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EnumsApi - axios parameter creator
 * @export
 */
export const EnumsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} enumTypeName 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsByTypeNameEnumTypeNameGet: async (enumTypeName: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enumTypeName' is not null or undefined
            assertParamExists('apiV1EnumsByTypeNameEnumTypeNameGet', 'enumTypeName', enumTypeName)
            const localVarPath = `/api/v1/enums/by-type-name/{enumTypeName}`
                .replace(`{${"enumTypeName"}}`, encodeURIComponent(String(enumTypeName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleProjection} [projection] Describes side of a vehicle in 3D space.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsByTypeNameVehicleareaGet: async (nexusOpsAppVersion?: string, projection?: VehicleProjection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/by-type-name/vehiclearea`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projection !== undefined) {
                localVarQueryParameter['projection'] = projection;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleArea} [area] Describes basic vehicle areas.
         * @param {VehicleProjection} [projection] Describes side of a vehicle in 3D space.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsByTypeNameVehiclepartcategoryGet: async (nexusOpsAppVersion?: string, area?: VehicleArea, projection?: VehicleProjection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/by-type-name/vehiclepartcategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (projection !== undefined) {
                localVarQueryParameter['projection'] = projection;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleArea} [area] Describes basic vehicle areas.
         * @param {VehicleProjection} [projection] Describes side of a vehicle in 3D space.
         * @param {VehiclePartCategory} [category] Describes general/basic categories of vehicle parts.  Vehicle part should belong to one of these categories for correct mapping and suggestions.  For instance, when mapping parts to damages and repair methods.
         * @param {VehiclePartType} [type] Further detalization of VehiclePartCategory.  Describes general types of vehicle parts.
         * @param {Array<VehiclePartType>} [types] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsByTypeNameVehiclepartdescriptorGet: async (nexusOpsAppVersion?: string, area?: VehicleArea, projection?: VehicleProjection, category?: VehiclePartCategory, type?: VehiclePartType, types?: Array<VehiclePartType>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/by-type-name/vehiclepartdescriptor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (projection !== undefined) {
                localVarQueryParameter['projection'] = projection;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (types) {
                localVarQueryParameter['types'] = types;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleArea} [area] Describes basic vehicle areas.
         * @param {VehicleProjection} [projection] Describes side of a vehicle in 3D space.
         * @param {VehiclePartCategory} [category] Describes general/basic categories of vehicle parts.  Vehicle part should belong to one of these categories for correct mapping and suggestions.  For instance, when mapping parts to damages and repair methods.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsByTypeNameVehicleparttypeGet: async (nexusOpsAppVersion?: string, area?: VehicleArea, projection?: VehicleProjection, category?: VehiclePartCategory, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/by-type-name/vehicleparttype`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (projection !== undefined) {
                localVarQueryParameter['projection'] = projection;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleArea} [area] Describes basic vehicle areas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsByTypeNameVehicleprojectionGet: async (nexusOpsAppVersion?: string, area?: VehicleArea, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/by-type-name/vehicleprojection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (area !== undefined) {
                localVarQueryParameter['area'] = area;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsCatalogGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [enumTypeName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsTransitionSpecGet: async (nexusOpsAppVersion?: string, enumTypeName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enums/transition-spec`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (enumTypeName !== undefined) {
                localVarQueryParameter['enumTypeName'] = enumTypeName;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnumsApi - functional programming interface
 * @export
 */
export const EnumsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnumsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} enumTypeName 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EnumsByTypeNameEnumTypeNameGet(enumTypeName: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnumDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EnumsByTypeNameEnumTypeNameGet(enumTypeName, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumsApi.apiV1EnumsByTypeNameEnumTypeNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleProjection} [projection] Describes side of a vehicle in 3D space.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EnumsByTypeNameVehicleareaGet(nexusOpsAppVersion?: string, projection?: VehicleProjection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnumDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EnumsByTypeNameVehicleareaGet(nexusOpsAppVersion, projection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumsApi.apiV1EnumsByTypeNameVehicleareaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleArea} [area] Describes basic vehicle areas.
         * @param {VehicleProjection} [projection] Describes side of a vehicle in 3D space.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EnumsByTypeNameVehiclepartcategoryGet(nexusOpsAppVersion?: string, area?: VehicleArea, projection?: VehicleProjection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnumDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EnumsByTypeNameVehiclepartcategoryGet(nexusOpsAppVersion, area, projection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumsApi.apiV1EnumsByTypeNameVehiclepartcategoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleArea} [area] Describes basic vehicle areas.
         * @param {VehicleProjection} [projection] Describes side of a vehicle in 3D space.
         * @param {VehiclePartCategory} [category] Describes general/basic categories of vehicle parts.  Vehicle part should belong to one of these categories for correct mapping and suggestions.  For instance, when mapping parts to damages and repair methods.
         * @param {VehiclePartType} [type] Further detalization of VehiclePartCategory.  Describes general types of vehicle parts.
         * @param {Array<VehiclePartType>} [types] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EnumsByTypeNameVehiclepartdescriptorGet(nexusOpsAppVersion?: string, area?: VehicleArea, projection?: VehicleProjection, category?: VehiclePartCategory, type?: VehiclePartType, types?: Array<VehiclePartType>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnumDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EnumsByTypeNameVehiclepartdescriptorGet(nexusOpsAppVersion, area, projection, category, type, types, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumsApi.apiV1EnumsByTypeNameVehiclepartdescriptorGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleArea} [area] Describes basic vehicle areas.
         * @param {VehicleProjection} [projection] Describes side of a vehicle in 3D space.
         * @param {VehiclePartCategory} [category] Describes general/basic categories of vehicle parts.  Vehicle part should belong to one of these categories for correct mapping and suggestions.  For instance, when mapping parts to damages and repair methods.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EnumsByTypeNameVehicleparttypeGet(nexusOpsAppVersion?: string, area?: VehicleArea, projection?: VehicleProjection, category?: VehiclePartCategory, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnumDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EnumsByTypeNameVehicleparttypeGet(nexusOpsAppVersion, area, projection, category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumsApi.apiV1EnumsByTypeNameVehicleparttypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleArea} [area] Describes basic vehicle areas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EnumsByTypeNameVehicleprojectionGet(nexusOpsAppVersion?: string, area?: VehicleArea, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnumDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EnumsByTypeNameVehicleprojectionGet(nexusOpsAppVersion, area, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumsApi.apiV1EnumsByTypeNameVehicleprojectionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EnumsCatalogGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumCatalogDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EnumsCatalogGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumsApi.apiV1EnumsCatalogGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [enumTypeName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EnumsTransitionSpecGet(nexusOpsAppVersion?: string, enumTypeName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumTransitionSpecDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EnumsTransitionSpecGet(nexusOpsAppVersion, enumTypeName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnumsApi.apiV1EnumsTransitionSpecGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EnumsApi - factory interface
 * @export
 */
export const EnumsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnumsApiFp(configuration)
    return {
        /**
         * 
         * @param {EnumsApiApiV1EnumsByTypeNameEnumTypeNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsByTypeNameEnumTypeNameGet(requestParameters: EnumsApiApiV1EnumsByTypeNameEnumTypeNameGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnumDto>> {
            return localVarFp.apiV1EnumsByTypeNameEnumTypeNameGet(requestParameters.enumTypeName, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumsApiApiV1EnumsByTypeNameVehicleareaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsByTypeNameVehicleareaGet(requestParameters: EnumsApiApiV1EnumsByTypeNameVehicleareaGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnumDto>> {
            return localVarFp.apiV1EnumsByTypeNameVehicleareaGet(requestParameters.nexusOpsAppVersion, requestParameters.projection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumsApiApiV1EnumsByTypeNameVehiclepartcategoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsByTypeNameVehiclepartcategoryGet(requestParameters: EnumsApiApiV1EnumsByTypeNameVehiclepartcategoryGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnumDto>> {
            return localVarFp.apiV1EnumsByTypeNameVehiclepartcategoryGet(requestParameters.nexusOpsAppVersion, requestParameters.area, requestParameters.projection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumsApiApiV1EnumsByTypeNameVehiclepartdescriptorGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsByTypeNameVehiclepartdescriptorGet(requestParameters: EnumsApiApiV1EnumsByTypeNameVehiclepartdescriptorGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnumDto>> {
            return localVarFp.apiV1EnumsByTypeNameVehiclepartdescriptorGet(requestParameters.nexusOpsAppVersion, requestParameters.area, requestParameters.projection, requestParameters.category, requestParameters.type, requestParameters.types, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumsApiApiV1EnumsByTypeNameVehicleparttypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsByTypeNameVehicleparttypeGet(requestParameters: EnumsApiApiV1EnumsByTypeNameVehicleparttypeGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnumDto>> {
            return localVarFp.apiV1EnumsByTypeNameVehicleparttypeGet(requestParameters.nexusOpsAppVersion, requestParameters.area, requestParameters.projection, requestParameters.category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumsApiApiV1EnumsByTypeNameVehicleprojectionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsByTypeNameVehicleprojectionGet(requestParameters: EnumsApiApiV1EnumsByTypeNameVehicleprojectionGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnumDto>> {
            return localVarFp.apiV1EnumsByTypeNameVehicleprojectionGet(requestParameters.nexusOpsAppVersion, requestParameters.area, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumsApiApiV1EnumsCatalogGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsCatalogGet(requestParameters: EnumsApiApiV1EnumsCatalogGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EnumCatalogDto> {
            return localVarFp.apiV1EnumsCatalogGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumsApiApiV1EnumsTransitionSpecGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EnumsTransitionSpecGet(requestParameters: EnumsApiApiV1EnumsTransitionSpecGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EnumTransitionSpecDto> {
            return localVarFp.apiV1EnumsTransitionSpecGet(requestParameters.nexusOpsAppVersion, requestParameters.enumTypeName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1EnumsByTypeNameEnumTypeNameGet operation in EnumsApi.
 * @export
 * @interface EnumsApiApiV1EnumsByTypeNameEnumTypeNameGetRequest
 */
export interface EnumsApiApiV1EnumsByTypeNameEnumTypeNameGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EnumsApiApiV1EnumsByTypeNameEnumTypeNameGet
     */
    readonly enumTypeName: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof EnumsApiApiV1EnumsByTypeNameEnumTypeNameGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1EnumsByTypeNameVehicleareaGet operation in EnumsApi.
 * @export
 * @interface EnumsApiApiV1EnumsByTypeNameVehicleareaGetRequest
 */
export interface EnumsApiApiV1EnumsByTypeNameVehicleareaGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehicleareaGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * Describes side of a vehicle in 3D space.
     * @type {VehicleProjection}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehicleareaGet
     */
    readonly projection?: VehicleProjection
}

/**
 * Request parameters for apiV1EnumsByTypeNameVehiclepartcategoryGet operation in EnumsApi.
 * @export
 * @interface EnumsApiApiV1EnumsByTypeNameVehiclepartcategoryGetRequest
 */
export interface EnumsApiApiV1EnumsByTypeNameVehiclepartcategoryGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehiclepartcategoryGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * Describes basic vehicle areas.
     * @type {VehicleArea}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehiclepartcategoryGet
     */
    readonly area?: VehicleArea

    /**
     * Describes side of a vehicle in 3D space.
     * @type {VehicleProjection}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehiclepartcategoryGet
     */
    readonly projection?: VehicleProjection
}

/**
 * Request parameters for apiV1EnumsByTypeNameVehiclepartdescriptorGet operation in EnumsApi.
 * @export
 * @interface EnumsApiApiV1EnumsByTypeNameVehiclepartdescriptorGetRequest
 */
export interface EnumsApiApiV1EnumsByTypeNameVehiclepartdescriptorGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehiclepartdescriptorGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * Describes basic vehicle areas.
     * @type {VehicleArea}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehiclepartdescriptorGet
     */
    readonly area?: VehicleArea

    /**
     * Describes side of a vehicle in 3D space.
     * @type {VehicleProjection}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehiclepartdescriptorGet
     */
    readonly projection?: VehicleProjection

    /**
     * Describes general/basic categories of vehicle parts.  Vehicle part should belong to one of these categories for correct mapping and suggestions.  For instance, when mapping parts to damages and repair methods.
     * @type {VehiclePartCategory}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehiclepartdescriptorGet
     */
    readonly category?: VehiclePartCategory

    /**
     * Further detalization of VehiclePartCategory.  Describes general types of vehicle parts.
     * @type {VehiclePartType}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehiclepartdescriptorGet
     */
    readonly type?: VehiclePartType

    /**
     * 
     * @type {Array<VehiclePartType>}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehiclepartdescriptorGet
     */
    readonly types?: Array<VehiclePartType>
}

/**
 * Request parameters for apiV1EnumsByTypeNameVehicleparttypeGet operation in EnumsApi.
 * @export
 * @interface EnumsApiApiV1EnumsByTypeNameVehicleparttypeGetRequest
 */
export interface EnumsApiApiV1EnumsByTypeNameVehicleparttypeGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehicleparttypeGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * Describes basic vehicle areas.
     * @type {VehicleArea}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehicleparttypeGet
     */
    readonly area?: VehicleArea

    /**
     * Describes side of a vehicle in 3D space.
     * @type {VehicleProjection}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehicleparttypeGet
     */
    readonly projection?: VehicleProjection

    /**
     * Describes general/basic categories of vehicle parts.  Vehicle part should belong to one of these categories for correct mapping and suggestions.  For instance, when mapping parts to damages and repair methods.
     * @type {VehiclePartCategory}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehicleparttypeGet
     */
    readonly category?: VehiclePartCategory
}

/**
 * Request parameters for apiV1EnumsByTypeNameVehicleprojectionGet operation in EnumsApi.
 * @export
 * @interface EnumsApiApiV1EnumsByTypeNameVehicleprojectionGetRequest
 */
export interface EnumsApiApiV1EnumsByTypeNameVehicleprojectionGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehicleprojectionGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * Describes basic vehicle areas.
     * @type {VehicleArea}
     * @memberof EnumsApiApiV1EnumsByTypeNameVehicleprojectionGet
     */
    readonly area?: VehicleArea
}

/**
 * Request parameters for apiV1EnumsCatalogGet operation in EnumsApi.
 * @export
 * @interface EnumsApiApiV1EnumsCatalogGetRequest
 */
export interface EnumsApiApiV1EnumsCatalogGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof EnumsApiApiV1EnumsCatalogGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1EnumsTransitionSpecGet operation in EnumsApi.
 * @export
 * @interface EnumsApiApiV1EnumsTransitionSpecGetRequest
 */
export interface EnumsApiApiV1EnumsTransitionSpecGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof EnumsApiApiV1EnumsTransitionSpecGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof EnumsApiApiV1EnumsTransitionSpecGet
     */
    readonly enumTypeName?: string
}

/**
 * EnumsApi - object-oriented interface
 * @export
 * @class EnumsApi
 * @extends {BaseAPI}
 */
export class EnumsApi extends BaseAPI {
    /**
     * 
     * @param {EnumsApiApiV1EnumsByTypeNameEnumTypeNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumsApi
     */
    public apiV1EnumsByTypeNameEnumTypeNameGet(requestParameters: EnumsApiApiV1EnumsByTypeNameEnumTypeNameGetRequest, options?: RawAxiosRequestConfig) {
        return EnumsApiFp(this.configuration).apiV1EnumsByTypeNameEnumTypeNameGet(requestParameters.enumTypeName, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumsApiApiV1EnumsByTypeNameVehicleareaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumsApi
     */
    public apiV1EnumsByTypeNameVehicleareaGet(requestParameters: EnumsApiApiV1EnumsByTypeNameVehicleareaGetRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumsApiFp(this.configuration).apiV1EnumsByTypeNameVehicleareaGet(requestParameters.nexusOpsAppVersion, requestParameters.projection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumsApiApiV1EnumsByTypeNameVehiclepartcategoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumsApi
     */
    public apiV1EnumsByTypeNameVehiclepartcategoryGet(requestParameters: EnumsApiApiV1EnumsByTypeNameVehiclepartcategoryGetRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumsApiFp(this.configuration).apiV1EnumsByTypeNameVehiclepartcategoryGet(requestParameters.nexusOpsAppVersion, requestParameters.area, requestParameters.projection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumsApiApiV1EnumsByTypeNameVehiclepartdescriptorGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumsApi
     */
    public apiV1EnumsByTypeNameVehiclepartdescriptorGet(requestParameters: EnumsApiApiV1EnumsByTypeNameVehiclepartdescriptorGetRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumsApiFp(this.configuration).apiV1EnumsByTypeNameVehiclepartdescriptorGet(requestParameters.nexusOpsAppVersion, requestParameters.area, requestParameters.projection, requestParameters.category, requestParameters.type, requestParameters.types, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumsApiApiV1EnumsByTypeNameVehicleparttypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumsApi
     */
    public apiV1EnumsByTypeNameVehicleparttypeGet(requestParameters: EnumsApiApiV1EnumsByTypeNameVehicleparttypeGetRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumsApiFp(this.configuration).apiV1EnumsByTypeNameVehicleparttypeGet(requestParameters.nexusOpsAppVersion, requestParameters.area, requestParameters.projection, requestParameters.category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumsApiApiV1EnumsByTypeNameVehicleprojectionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumsApi
     */
    public apiV1EnumsByTypeNameVehicleprojectionGet(requestParameters: EnumsApiApiV1EnumsByTypeNameVehicleprojectionGetRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumsApiFp(this.configuration).apiV1EnumsByTypeNameVehicleprojectionGet(requestParameters.nexusOpsAppVersion, requestParameters.area, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumsApiApiV1EnumsCatalogGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumsApi
     */
    public apiV1EnumsCatalogGet(requestParameters: EnumsApiApiV1EnumsCatalogGetRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumsApiFp(this.configuration).apiV1EnumsCatalogGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumsApiApiV1EnumsTransitionSpecGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnumsApi
     */
    public apiV1EnumsTransitionSpecGet(requestParameters: EnumsApiApiV1EnumsTransitionSpecGetRequest = {}, options?: RawAxiosRequestConfig) {
        return EnumsApiFp(this.configuration).apiV1EnumsTransitionSpecGet(requestParameters.nexusOpsAppVersion, requestParameters.enumTypeName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<File>} [files] 
         * @param {string} [responseOptionsFileUrlLifetime] Check out how C# TimeSpan is serialized to string for more info.
         * @param {string} [responseOptionsFileUrlExpiresAt] Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FilesAvatarUploadPost: async (nexusOpsAppVersion?: string, files?: Array<File>, responseOptionsFileUrlLifetime?: string, responseOptionsFileUrlExpiresAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/files/avatar/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
            if (responseOptionsFileUrlLifetime !== undefined) { 
                localVarFormParams.append('responseOptions.fileUrlLifetime', responseOptionsFileUrlLifetime as any);
            }
    
            if (responseOptionsFileUrlExpiresAt !== undefined) { 
                localVarFormParams.append('responseOptions.fileUrlExpiresAt', responseOptionsFileUrlExpiresAt as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<File>} [files] 
         * @param {string} [responseOptionsFileUrlLifetime] Check out how C# TimeSpan is serialized to string for more info.
         * @param {string} [responseOptionsFileUrlExpiresAt] Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FilesChatsChatIdAttachmentsUploadPost: async (chatId: string, nexusOpsAppVersion?: string, files?: Array<File>, responseOptionsFileUrlLifetime?: string, responseOptionsFileUrlExpiresAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1FilesChatsChatIdAttachmentsUploadPost', 'chatId', chatId)
            const localVarPath = `/api/v1/files/chats/{chatId}/attachments/upload`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
            if (responseOptionsFileUrlLifetime !== undefined) { 
                localVarFormParams.append('responseOptions.fileUrlLifetime', responseOptionsFileUrlLifetime as any);
            }
    
            if (responseOptionsFileUrlExpiresAt !== undefined) { 
                localVarFormParams.append('responseOptions.fileUrlExpiresAt', responseOptionsFileUrlExpiresAt as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes unused uploaded file.  Use this endpoint to directly cleanup recently uploaded files.
         * @param {string} fileId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FilesFileIdDelete: async (fileId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiV1FilesFileIdDelete', 'fileId', fileId)
            const localVarPath = `/api/v1/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<File>} [files] 
         * @param {string} [responseOptionsFileUrlLifetime] Check out how C# TimeSpan is serialized to string for more info.
         * @param {string} [responseOptionsFileUrlExpiresAt] Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FilesImportUploadPost: async (nexusOpsAppVersion?: string, files?: Array<File>, responseOptionsFileUrlLifetime?: string, responseOptionsFileUrlExpiresAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/files/import/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
            if (responseOptionsFileUrlLifetime !== undefined) { 
                localVarFormParams.append('responseOptions.fileUrlLifetime', responseOptionsFileUrlLifetime as any);
            }
    
            if (responseOptionsFileUrlExpiresAt !== undefined) { 
                localVarFormParams.append('responseOptions.fileUrlExpiresAt', responseOptionsFileUrlExpiresAt as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads multiple files.    NB: Prefer uploading each file in a separate request to avoid hitting request size limits.  Upload in a single request is only recommended for small files and when the number of files is limited.
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<File>} [files] 
         * @param {string} [responseOptionsFileUrlLifetime] Check out how C# TimeSpan is serialized to string for more info.
         * @param {string} [responseOptionsFileUrlExpiresAt] Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FilesUploadPost: async (nexusOpsAppVersion?: string, files?: Array<File>, responseOptionsFileUrlLifetime?: string, responseOptionsFileUrlExpiresAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/files/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
            if (responseOptionsFileUrlLifetime !== undefined) { 
                localVarFormParams.append('responseOptions.fileUrlLifetime', responseOptionsFileUrlLifetime as any);
            }
    
            if (responseOptionsFileUrlExpiresAt !== undefined) { 
                localVarFormParams.append('responseOptions.fileUrlExpiresAt', responseOptionsFileUrlExpiresAt as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FilesUploadSpecGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/files/upload/spec`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VehicleVisualModelType} type 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<File>} [files] 
         * @param {string} [responseOptionsFileUrlLifetime] Check out how C# TimeSpan is serialized to string for more info.
         * @param {string} [responseOptionsFileUrlExpiresAt] Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FilesVehicleVisualModelTypeImagesUploadPost: async (type: VehicleVisualModelType, nexusOpsAppVersion?: string, files?: Array<File>, responseOptionsFileUrlLifetime?: string, responseOptionsFileUrlExpiresAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('apiV1FilesVehicleVisualModelTypeImagesUploadPost', 'type', type)
            const localVarPath = `/api/v1/files/vehicle-visual-model/{type}/images/upload`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
            if (responseOptionsFileUrlLifetime !== undefined) { 
                localVarFormParams.append('responseOptions.fileUrlLifetime', responseOptionsFileUrlLifetime as any);
            }
    
            if (responseOptionsFileUrlExpiresAt !== undefined) { 
                localVarFormParams.append('responseOptions.fileUrlExpiresAt', responseOptionsFileUrlExpiresAt as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<File>} [files] 
         * @param {string} [responseOptionsFileUrlLifetime] Check out how C# TimeSpan is serialized to string for more info.
         * @param {string} [responseOptionsFileUrlExpiresAt] Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FilesAvatarUploadPost(nexusOpsAppVersion?: string, files?: Array<File>, responseOptionsFileUrlLifetime?: string, responseOptionsFileUrlExpiresAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadManyResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FilesAvatarUploadPost(nexusOpsAppVersion, files, responseOptionsFileUrlLifetime, responseOptionsFileUrlExpiresAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.apiV1FilesAvatarUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<File>} [files] 
         * @param {string} [responseOptionsFileUrlLifetime] Check out how C# TimeSpan is serialized to string for more info.
         * @param {string} [responseOptionsFileUrlExpiresAt] Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FilesChatsChatIdAttachmentsUploadPost(chatId: string, nexusOpsAppVersion?: string, files?: Array<File>, responseOptionsFileUrlLifetime?: string, responseOptionsFileUrlExpiresAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadManyResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FilesChatsChatIdAttachmentsUploadPost(chatId, nexusOpsAppVersion, files, responseOptionsFileUrlLifetime, responseOptionsFileUrlExpiresAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.apiV1FilesChatsChatIdAttachmentsUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes unused uploaded file.  Use this endpoint to directly cleanup recently uploaded files.
         * @param {string} fileId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FilesFileIdDelete(fileId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FilesFileIdDelete(fileId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.apiV1FilesFileIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<File>} [files] 
         * @param {string} [responseOptionsFileUrlLifetime] Check out how C# TimeSpan is serialized to string for more info.
         * @param {string} [responseOptionsFileUrlExpiresAt] Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FilesImportUploadPost(nexusOpsAppVersion?: string, files?: Array<File>, responseOptionsFileUrlLifetime?: string, responseOptionsFileUrlExpiresAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadManyResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FilesImportUploadPost(nexusOpsAppVersion, files, responseOptionsFileUrlLifetime, responseOptionsFileUrlExpiresAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.apiV1FilesImportUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Uploads multiple files.    NB: Prefer uploading each file in a separate request to avoid hitting request size limits.  Upload in a single request is only recommended for small files and when the number of files is limited.
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<File>} [files] 
         * @param {string} [responseOptionsFileUrlLifetime] Check out how C# TimeSpan is serialized to string for more info.
         * @param {string} [responseOptionsFileUrlExpiresAt] Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FilesUploadPost(nexusOpsAppVersion?: string, files?: Array<File>, responseOptionsFileUrlLifetime?: string, responseOptionsFileUrlExpiresAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadManyResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FilesUploadPost(nexusOpsAppVersion, files, responseOptionsFileUrlLifetime, responseOptionsFileUrlExpiresAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.apiV1FilesUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FilesUploadSpecGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadSpecDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FilesUploadSpecGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.apiV1FilesUploadSpecGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VehicleVisualModelType} type 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<File>} [files] 
         * @param {string} [responseOptionsFileUrlLifetime] Check out how C# TimeSpan is serialized to string for more info.
         * @param {string} [responseOptionsFileUrlExpiresAt] Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FilesVehicleVisualModelTypeImagesUploadPost(type: VehicleVisualModelType, nexusOpsAppVersion?: string, files?: Array<File>, responseOptionsFileUrlLifetime?: string, responseOptionsFileUrlExpiresAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadManyResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1FilesVehicleVisualModelTypeImagesUploadPost(type, nexusOpsAppVersion, files, responseOptionsFileUrlLifetime, responseOptionsFileUrlExpiresAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.apiV1FilesVehicleVisualModelTypeImagesUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileApiFp(configuration)
    return {
        /**
         * 
         * @param {FileApiApiV1FilesAvatarUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FilesAvatarUploadPost(requestParameters: FileApiApiV1FilesAvatarUploadPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<FileUploadManyResultDto> {
            return localVarFp.apiV1FilesAvatarUploadPost(requestParameters.nexusOpsAppVersion, requestParameters.files, requestParameters.responseOptionsFileUrlLifetime, requestParameters.responseOptionsFileUrlExpiresAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FileApiApiV1FilesChatsChatIdAttachmentsUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FilesChatsChatIdAttachmentsUploadPost(requestParameters: FileApiApiV1FilesChatsChatIdAttachmentsUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FileUploadManyResultDto> {
            return localVarFp.apiV1FilesChatsChatIdAttachmentsUploadPost(requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.files, requestParameters.responseOptionsFileUrlLifetime, requestParameters.responseOptionsFileUrlExpiresAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes unused uploaded file.  Use this endpoint to directly cleanup recently uploaded files.
         * @param {FileApiApiV1FilesFileIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FilesFileIdDelete(requestParameters: FileApiApiV1FilesFileIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1FilesFileIdDelete(requestParameters.fileId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FileApiApiV1FilesImportUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FilesImportUploadPost(requestParameters: FileApiApiV1FilesImportUploadPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<FileUploadManyResultDto> {
            return localVarFp.apiV1FilesImportUploadPost(requestParameters.nexusOpsAppVersion, requestParameters.files, requestParameters.responseOptionsFileUrlLifetime, requestParameters.responseOptionsFileUrlExpiresAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads multiple files.    NB: Prefer uploading each file in a separate request to avoid hitting request size limits.  Upload in a single request is only recommended for small files and when the number of files is limited.
         * @param {FileApiApiV1FilesUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FilesUploadPost(requestParameters: FileApiApiV1FilesUploadPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<FileUploadManyResultDto> {
            return localVarFp.apiV1FilesUploadPost(requestParameters.nexusOpsAppVersion, requestParameters.files, requestParameters.responseOptionsFileUrlLifetime, requestParameters.responseOptionsFileUrlExpiresAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FileApiApiV1FilesUploadSpecGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FilesUploadSpecGet(requestParameters: FileApiApiV1FilesUploadSpecGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<FileUploadSpecDto> {
            return localVarFp.apiV1FilesUploadSpecGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FileApiApiV1FilesVehicleVisualModelTypeImagesUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FilesVehicleVisualModelTypeImagesUploadPost(requestParameters: FileApiApiV1FilesVehicleVisualModelTypeImagesUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FileUploadManyResultDto> {
            return localVarFp.apiV1FilesVehicleVisualModelTypeImagesUploadPost(requestParameters.type, requestParameters.nexusOpsAppVersion, requestParameters.files, requestParameters.responseOptionsFileUrlLifetime, requestParameters.responseOptionsFileUrlExpiresAt, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1FilesAvatarUploadPost operation in FileApi.
 * @export
 * @interface FileApiApiV1FilesAvatarUploadPostRequest
 */
export interface FileApiApiV1FilesAvatarUploadPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FileApiApiV1FilesAvatarUploadPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<File>}
     * @memberof FileApiApiV1FilesAvatarUploadPost
     */
    readonly files?: Array<File>

    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof FileApiApiV1FilesAvatarUploadPost
     */
    readonly responseOptionsFileUrlLifetime?: string

    /**
     * Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof FileApiApiV1FilesAvatarUploadPost
     */
    readonly responseOptionsFileUrlExpiresAt?: string
}

/**
 * Request parameters for apiV1FilesChatsChatIdAttachmentsUploadPost operation in FileApi.
 * @export
 * @interface FileApiApiV1FilesChatsChatIdAttachmentsUploadPostRequest
 */
export interface FileApiApiV1FilesChatsChatIdAttachmentsUploadPostRequest {
    /**
     * 
     * @type {string}
     * @memberof FileApiApiV1FilesChatsChatIdAttachmentsUploadPost
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FileApiApiV1FilesChatsChatIdAttachmentsUploadPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<File>}
     * @memberof FileApiApiV1FilesChatsChatIdAttachmentsUploadPost
     */
    readonly files?: Array<File>

    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof FileApiApiV1FilesChatsChatIdAttachmentsUploadPost
     */
    readonly responseOptionsFileUrlLifetime?: string

    /**
     * Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof FileApiApiV1FilesChatsChatIdAttachmentsUploadPost
     */
    readonly responseOptionsFileUrlExpiresAt?: string
}

/**
 * Request parameters for apiV1FilesFileIdDelete operation in FileApi.
 * @export
 * @interface FileApiApiV1FilesFileIdDeleteRequest
 */
export interface FileApiApiV1FilesFileIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof FileApiApiV1FilesFileIdDelete
     */
    readonly fileId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FileApiApiV1FilesFileIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1FilesImportUploadPost operation in FileApi.
 * @export
 * @interface FileApiApiV1FilesImportUploadPostRequest
 */
export interface FileApiApiV1FilesImportUploadPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FileApiApiV1FilesImportUploadPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<File>}
     * @memberof FileApiApiV1FilesImportUploadPost
     */
    readonly files?: Array<File>

    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof FileApiApiV1FilesImportUploadPost
     */
    readonly responseOptionsFileUrlLifetime?: string

    /**
     * Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof FileApiApiV1FilesImportUploadPost
     */
    readonly responseOptionsFileUrlExpiresAt?: string
}

/**
 * Request parameters for apiV1FilesUploadPost operation in FileApi.
 * @export
 * @interface FileApiApiV1FilesUploadPostRequest
 */
export interface FileApiApiV1FilesUploadPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FileApiApiV1FilesUploadPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<File>}
     * @memberof FileApiApiV1FilesUploadPost
     */
    readonly files?: Array<File>

    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof FileApiApiV1FilesUploadPost
     */
    readonly responseOptionsFileUrlLifetime?: string

    /**
     * Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof FileApiApiV1FilesUploadPost
     */
    readonly responseOptionsFileUrlExpiresAt?: string
}

/**
 * Request parameters for apiV1FilesUploadSpecGet operation in FileApi.
 * @export
 * @interface FileApiApiV1FilesUploadSpecGetRequest
 */
export interface FileApiApiV1FilesUploadSpecGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FileApiApiV1FilesUploadSpecGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1FilesVehicleVisualModelTypeImagesUploadPost operation in FileApi.
 * @export
 * @interface FileApiApiV1FilesVehicleVisualModelTypeImagesUploadPostRequest
 */
export interface FileApiApiV1FilesVehicleVisualModelTypeImagesUploadPostRequest {
    /**
     * 
     * @type {VehicleVisualModelType}
     * @memberof FileApiApiV1FilesVehicleVisualModelTypeImagesUploadPost
     */
    readonly type: VehicleVisualModelType

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FileApiApiV1FilesVehicleVisualModelTypeImagesUploadPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<File>}
     * @memberof FileApiApiV1FilesVehicleVisualModelTypeImagesUploadPost
     */
    readonly files?: Array<File>

    /**
     * Check out how C# TimeSpan is serialized to string for more info.
     * @type {string}
     * @memberof FileApiApiV1FilesVehicleVisualModelTypeImagesUploadPost
     */
    readonly responseOptionsFileUrlLifetime?: string

    /**
     * Date-time string in &lt;a href&#x3D;\\\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\\\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof FileApiApiV1FilesVehicleVisualModelTypeImagesUploadPost
     */
    readonly responseOptionsFileUrlExpiresAt?: string
}

/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI {
    /**
     * 
     * @param {FileApiApiV1FilesAvatarUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FilesAvatarUploadPost(requestParameters: FileApiApiV1FilesAvatarUploadPostRequest = {}, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).apiV1FilesAvatarUploadPost(requestParameters.nexusOpsAppVersion, requestParameters.files, requestParameters.responseOptionsFileUrlLifetime, requestParameters.responseOptionsFileUrlExpiresAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FileApiApiV1FilesChatsChatIdAttachmentsUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FilesChatsChatIdAttachmentsUploadPost(requestParameters: FileApiApiV1FilesChatsChatIdAttachmentsUploadPostRequest, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).apiV1FilesChatsChatIdAttachmentsUploadPost(requestParameters.chatId, requestParameters.nexusOpsAppVersion, requestParameters.files, requestParameters.responseOptionsFileUrlLifetime, requestParameters.responseOptionsFileUrlExpiresAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes unused uploaded file.  Use this endpoint to directly cleanup recently uploaded files.
     * @param {FileApiApiV1FilesFileIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FilesFileIdDelete(requestParameters: FileApiApiV1FilesFileIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).apiV1FilesFileIdDelete(requestParameters.fileId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FileApiApiV1FilesImportUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FilesImportUploadPost(requestParameters: FileApiApiV1FilesImportUploadPostRequest = {}, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).apiV1FilesImportUploadPost(requestParameters.nexusOpsAppVersion, requestParameters.files, requestParameters.responseOptionsFileUrlLifetime, requestParameters.responseOptionsFileUrlExpiresAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads multiple files.    NB: Prefer uploading each file in a separate request to avoid hitting request size limits.  Upload in a single request is only recommended for small files and when the number of files is limited.
     * @param {FileApiApiV1FilesUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FilesUploadPost(requestParameters: FileApiApiV1FilesUploadPostRequest = {}, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).apiV1FilesUploadPost(requestParameters.nexusOpsAppVersion, requestParameters.files, requestParameters.responseOptionsFileUrlLifetime, requestParameters.responseOptionsFileUrlExpiresAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FileApiApiV1FilesUploadSpecGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FilesUploadSpecGet(requestParameters: FileApiApiV1FilesUploadSpecGetRequest = {}, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).apiV1FilesUploadSpecGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FileApiApiV1FilesVehicleVisualModelTypeImagesUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FilesVehicleVisualModelTypeImagesUploadPost(requestParameters: FileApiApiV1FilesVehicleVisualModelTypeImagesUploadPostRequest, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).apiV1FilesVehicleVisualModelTypeImagesUploadPost(requestParameters.type, requestParameters.nexusOpsAppVersion, requestParameters.files, requestParameters.responseOptionsFileUrlLifetime, requestParameters.responseOptionsFileUrlExpiresAt, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FilesAdminApi - axios parameter creator
 * @export
 */
export const FilesAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminFileDeleteDto} [adminFileDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminFilesFileIdDelete: async (fileId: string, nexusOpsAppVersion?: string, adminFileDeleteDto?: AdminFileDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiV1AdminFilesFileIdDelete', 'fileId', fileId)
            const localVarPath = `/api/v1/admin/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminFileDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isIncludeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminFilesFileIdGet: async (fileId: string, nexusOpsAppVersion?: string, isIncludeDeleted?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiV1AdminFilesFileIdGet', 'fileId', fileId)
            const localVarPath = `/api/v1/admin/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isIncludeDeleted !== undefined) {
                localVarQueryParameter['isIncludeDeleted'] = isIncludeDeleted;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminFileUndeleteDto} [adminFileUndeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminFilesFileIdUndeletePost: async (fileId: string, nexusOpsAppVersion?: string, adminFileUndeleteDto?: AdminFileUndeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiV1AdminFilesFileIdUndeletePost', 'fileId', fileId)
            const localVarPath = `/api/v1/admin/files/{fileId}/undelete`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminFileUndeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminFileGetPaginatedDto} [adminFileGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminFilesGetPost: async (nexusOpsAppVersion?: string, adminFileGetPaginatedDto?: AdminFileGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/files/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminFileGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesAdminApi - functional programming interface
 * @export
 */
export const FilesAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilesAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminFileDeleteDto} [adminFileDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminFilesFileIdDelete(fileId: string, nexusOpsAppVersion?: string, adminFileDeleteDto?: AdminFileDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminFilesFileIdDelete(fileId, nexusOpsAppVersion, adminFileDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesAdminApi.apiV1AdminFilesFileIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isIncludeDeleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminFilesFileIdGet(fileId: string, nexusOpsAppVersion?: string, isIncludeDeleted?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminFilesFileIdGet(fileId, nexusOpsAppVersion, isIncludeDeleted, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesAdminApi.apiV1AdminFilesFileIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminFileUndeleteDto} [adminFileUndeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminFilesFileIdUndeletePost(fileId: string, nexusOpsAppVersion?: string, adminFileUndeleteDto?: AdminFileUndeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminFilesFileIdUndeletePost(fileId, nexusOpsAppVersion, adminFileUndeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesAdminApi.apiV1AdminFilesFileIdUndeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminFileGetPaginatedDto} [adminFileGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminFilesGetPost(nexusOpsAppVersion?: string, adminFileGetPaginatedDto?: AdminFileGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminFileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminFilesGetPost(nexusOpsAppVersion, adminFileGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesAdminApi.apiV1AdminFilesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FilesAdminApi - factory interface
 * @export
 */
export const FilesAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilesAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {FilesAdminApiApiV1AdminFilesFileIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminFilesFileIdDelete(requestParameters: FilesAdminApiApiV1AdminFilesFileIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminFileDto> {
            return localVarFp.apiV1AdminFilesFileIdDelete(requestParameters.fileId, requestParameters.nexusOpsAppVersion, requestParameters.adminFileDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesAdminApiApiV1AdminFilesFileIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminFilesFileIdGet(requestParameters: FilesAdminApiApiV1AdminFilesFileIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminFileDto> {
            return localVarFp.apiV1AdminFilesFileIdGet(requestParameters.fileId, requestParameters.nexusOpsAppVersion, requestParameters.isIncludeDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesAdminApiApiV1AdminFilesFileIdUndeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminFilesFileIdUndeletePost(requestParameters: FilesAdminApiApiV1AdminFilesFileIdUndeletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminFileDto> {
            return localVarFp.apiV1AdminFilesFileIdUndeletePost(requestParameters.fileId, requestParameters.nexusOpsAppVersion, requestParameters.adminFileUndeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesAdminApiApiV1AdminFilesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminFilesGetPost(requestParameters: FilesAdminApiApiV1AdminFilesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminFileDto> {
            return localVarFp.apiV1AdminFilesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminFileGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminFilesFileIdDelete operation in FilesAdminApi.
 * @export
 * @interface FilesAdminApiApiV1AdminFilesFileIdDeleteRequest
 */
export interface FilesAdminApiApiV1AdminFilesFileIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof FilesAdminApiApiV1AdminFilesFileIdDelete
     */
    readonly fileId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FilesAdminApiApiV1AdminFilesFileIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminFileDeleteDto}
     * @memberof FilesAdminApiApiV1AdminFilesFileIdDelete
     */
    readonly adminFileDeleteDto?: AdminFileDeleteDto
}

/**
 * Request parameters for apiV1AdminFilesFileIdGet operation in FilesAdminApi.
 * @export
 * @interface FilesAdminApiApiV1AdminFilesFileIdGetRequest
 */
export interface FilesAdminApiApiV1AdminFilesFileIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FilesAdminApiApiV1AdminFilesFileIdGet
     */
    readonly fileId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FilesAdminApiApiV1AdminFilesFileIdGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof FilesAdminApiApiV1AdminFilesFileIdGet
     */
    readonly isIncludeDeleted?: boolean
}

/**
 * Request parameters for apiV1AdminFilesFileIdUndeletePost operation in FilesAdminApi.
 * @export
 * @interface FilesAdminApiApiV1AdminFilesFileIdUndeletePostRequest
 */
export interface FilesAdminApiApiV1AdminFilesFileIdUndeletePostRequest {
    /**
     * 
     * @type {string}
     * @memberof FilesAdminApiApiV1AdminFilesFileIdUndeletePost
     */
    readonly fileId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FilesAdminApiApiV1AdminFilesFileIdUndeletePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminFileUndeleteDto}
     * @memberof FilesAdminApiApiV1AdminFilesFileIdUndeletePost
     */
    readonly adminFileUndeleteDto?: AdminFileUndeleteDto
}

/**
 * Request parameters for apiV1AdminFilesGetPost operation in FilesAdminApi.
 * @export
 * @interface FilesAdminApiApiV1AdminFilesGetPostRequest
 */
export interface FilesAdminApiApiV1AdminFilesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FilesAdminApiApiV1AdminFilesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminFileGetPaginatedDto}
     * @memberof FilesAdminApiApiV1AdminFilesGetPost
     */
    readonly adminFileGetPaginatedDto?: AdminFileGetPaginatedDto
}

/**
 * FilesAdminApi - object-oriented interface
 * @export
 * @class FilesAdminApi
 * @extends {BaseAPI}
 */
export class FilesAdminApi extends BaseAPI {
    /**
     * 
     * @param {FilesAdminApiApiV1AdminFilesFileIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesAdminApi
     */
    public apiV1AdminFilesFileIdDelete(requestParameters: FilesAdminApiApiV1AdminFilesFileIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return FilesAdminApiFp(this.configuration).apiV1AdminFilesFileIdDelete(requestParameters.fileId, requestParameters.nexusOpsAppVersion, requestParameters.adminFileDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesAdminApiApiV1AdminFilesFileIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesAdminApi
     */
    public apiV1AdminFilesFileIdGet(requestParameters: FilesAdminApiApiV1AdminFilesFileIdGetRequest, options?: RawAxiosRequestConfig) {
        return FilesAdminApiFp(this.configuration).apiV1AdminFilesFileIdGet(requestParameters.fileId, requestParameters.nexusOpsAppVersion, requestParameters.isIncludeDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesAdminApiApiV1AdminFilesFileIdUndeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesAdminApi
     */
    public apiV1AdminFilesFileIdUndeletePost(requestParameters: FilesAdminApiApiV1AdminFilesFileIdUndeletePostRequest, options?: RawAxiosRequestConfig) {
        return FilesAdminApiFp(this.configuration).apiV1AdminFilesFileIdUndeletePost(requestParameters.fileId, requestParameters.nexusOpsAppVersion, requestParameters.adminFileUndeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesAdminApiApiV1AdminFilesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesAdminApi
     */
    public apiV1AdminFilesGetPost(requestParameters: FilesAdminApiApiV1AdminFilesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return FilesAdminApiFp(this.configuration).apiV1AdminFilesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminFileGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FrontEndAppUpdateInfoAdminApi - axios parameter creator
 * @export
 */
export const FrontEndAppUpdateInfoAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FrontEndAppType} appType 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {OperatingSystemType} [os] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAppUpdateInfoAppsAppTypeGet: async (appType: FrontEndAppType, nexusOpsAppVersion?: string, os?: OperatingSystemType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appType' is not null or undefined
            assertParamExists('apiV1AdminAppUpdateInfoAppsAppTypeGet', 'appType', appType)
            const localVarPath = `/api/v1/admin/app-update-info/apps/{appType}`
                .replace(`{${"appType"}}`, encodeURIComponent(String(appType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (os !== undefined) {
                localVarQueryParameter['os'] = os;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminFrontEndAppUpdateInfoDeleteDto} [adminFrontEndAppUpdateInfoDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAppUpdateInfoDelete: async (nexusOpsAppVersion?: string, adminFrontEndAppUpdateInfoDeleteDto?: AdminFrontEndAppUpdateInfoDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/app-update-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminFrontEndAppUpdateInfoDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAppUpdateInfoGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/app-update-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminFrontEndAppUpdateInfoCreateDto} [adminFrontEndAppUpdateInfoCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAppUpdateInfoPost: async (nexusOpsAppVersion?: string, adminFrontEndAppUpdateInfoCreateDto?: AdminFrontEndAppUpdateInfoCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/app-update-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminFrontEndAppUpdateInfoCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminFrontEndAppUpdateInfoUpdateDto} [adminFrontEndAppUpdateInfoUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAppUpdateInfoPut: async (nexusOpsAppVersion?: string, adminFrontEndAppUpdateInfoUpdateDto?: AdminFrontEndAppUpdateInfoUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/app-update-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminFrontEndAppUpdateInfoUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FrontEndAppUpdateInfoAdminApi - functional programming interface
 * @export
 */
export const FrontEndAppUpdateInfoAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FrontEndAppUpdateInfoAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {FrontEndAppType} appType 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {OperatingSystemType} [os] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAppUpdateInfoAppsAppTypeGet(appType: FrontEndAppType, nexusOpsAppVersion?: string, os?: OperatingSystemType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FrontEndAppUpdateInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAppUpdateInfoAppsAppTypeGet(appType, nexusOpsAppVersion, os, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FrontEndAppUpdateInfoAdminApi.apiV1AdminAppUpdateInfoAppsAppTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminFrontEndAppUpdateInfoDeleteDto} [adminFrontEndAppUpdateInfoDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAppUpdateInfoDelete(nexusOpsAppVersion?: string, adminFrontEndAppUpdateInfoDeleteDto?: AdminFrontEndAppUpdateInfoDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FrontEndMultiAppUpdateInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAppUpdateInfoDelete(nexusOpsAppVersion, adminFrontEndAppUpdateInfoDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FrontEndAppUpdateInfoAdminApi.apiV1AdminAppUpdateInfoDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAppUpdateInfoGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FrontEndMultiAppUpdateInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAppUpdateInfoGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FrontEndAppUpdateInfoAdminApi.apiV1AdminAppUpdateInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminFrontEndAppUpdateInfoCreateDto} [adminFrontEndAppUpdateInfoCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAppUpdateInfoPost(nexusOpsAppVersion?: string, adminFrontEndAppUpdateInfoCreateDto?: AdminFrontEndAppUpdateInfoCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FrontEndAppUpdateInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAppUpdateInfoPost(nexusOpsAppVersion, adminFrontEndAppUpdateInfoCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FrontEndAppUpdateInfoAdminApi.apiV1AdminAppUpdateInfoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminFrontEndAppUpdateInfoUpdateDto} [adminFrontEndAppUpdateInfoUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAppUpdateInfoPut(nexusOpsAppVersion?: string, adminFrontEndAppUpdateInfoUpdateDto?: AdminFrontEndAppUpdateInfoUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FrontEndMultiAppUpdateInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAppUpdateInfoPut(nexusOpsAppVersion, adminFrontEndAppUpdateInfoUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FrontEndAppUpdateInfoAdminApi.apiV1AdminAppUpdateInfoPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FrontEndAppUpdateInfoAdminApi - factory interface
 * @export
 */
export const FrontEndAppUpdateInfoAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FrontEndAppUpdateInfoAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoAppsAppTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAppUpdateInfoAppsAppTypeGet(requestParameters: FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoAppsAppTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FrontEndAppUpdateInfoDto> {
            return localVarFp.apiV1AdminAppUpdateInfoAppsAppTypeGet(requestParameters.appType, requestParameters.nexusOpsAppVersion, requestParameters.os, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAppUpdateInfoDelete(requestParameters: FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<FrontEndMultiAppUpdateInfoDto> {
            return localVarFp.apiV1AdminAppUpdateInfoDelete(requestParameters.nexusOpsAppVersion, requestParameters.adminFrontEndAppUpdateInfoDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAppUpdateInfoGet(requestParameters: FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<FrontEndMultiAppUpdateInfoDto> {
            return localVarFp.apiV1AdminAppUpdateInfoGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAppUpdateInfoPost(requestParameters: FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<FrontEndAppUpdateInfoDto> {
            return localVarFp.apiV1AdminAppUpdateInfoPost(requestParameters.nexusOpsAppVersion, requestParameters.adminFrontEndAppUpdateInfoCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAppUpdateInfoPut(requestParameters: FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPutRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<FrontEndMultiAppUpdateInfoDto> {
            return localVarFp.apiV1AdminAppUpdateInfoPut(requestParameters.nexusOpsAppVersion, requestParameters.adminFrontEndAppUpdateInfoUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminAppUpdateInfoAppsAppTypeGet operation in FrontEndAppUpdateInfoAdminApi.
 * @export
 * @interface FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoAppsAppTypeGetRequest
 */
export interface FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoAppsAppTypeGetRequest {
    /**
     * 
     * @type {FrontEndAppType}
     * @memberof FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoAppsAppTypeGet
     */
    readonly appType: FrontEndAppType

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoAppsAppTypeGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {OperatingSystemType}
     * @memberof FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoAppsAppTypeGet
     */
    readonly os?: OperatingSystemType
}

/**
 * Request parameters for apiV1AdminAppUpdateInfoDelete operation in FrontEndAppUpdateInfoAdminApi.
 * @export
 * @interface FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoDeleteRequest
 */
export interface FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoDeleteRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminFrontEndAppUpdateInfoDeleteDto}
     * @memberof FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoDelete
     */
    readonly adminFrontEndAppUpdateInfoDeleteDto?: AdminFrontEndAppUpdateInfoDeleteDto
}

/**
 * Request parameters for apiV1AdminAppUpdateInfoGet operation in FrontEndAppUpdateInfoAdminApi.
 * @export
 * @interface FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoGetRequest
 */
export interface FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminAppUpdateInfoPost operation in FrontEndAppUpdateInfoAdminApi.
 * @export
 * @interface FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPostRequest
 */
export interface FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminFrontEndAppUpdateInfoCreateDto}
     * @memberof FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPost
     */
    readonly adminFrontEndAppUpdateInfoCreateDto?: AdminFrontEndAppUpdateInfoCreateDto
}

/**
 * Request parameters for apiV1AdminAppUpdateInfoPut operation in FrontEndAppUpdateInfoAdminApi.
 * @export
 * @interface FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPutRequest
 */
export interface FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPutRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminFrontEndAppUpdateInfoUpdateDto}
     * @memberof FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPut
     */
    readonly adminFrontEndAppUpdateInfoUpdateDto?: AdminFrontEndAppUpdateInfoUpdateDto
}

/**
 * FrontEndAppUpdateInfoAdminApi - object-oriented interface
 * @export
 * @class FrontEndAppUpdateInfoAdminApi
 * @extends {BaseAPI}
 */
export class FrontEndAppUpdateInfoAdminApi extends BaseAPI {
    /**
     * 
     * @param {FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoAppsAppTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontEndAppUpdateInfoAdminApi
     */
    public apiV1AdminAppUpdateInfoAppsAppTypeGet(requestParameters: FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoAppsAppTypeGetRequest, options?: RawAxiosRequestConfig) {
        return FrontEndAppUpdateInfoAdminApiFp(this.configuration).apiV1AdminAppUpdateInfoAppsAppTypeGet(requestParameters.appType, requestParameters.nexusOpsAppVersion, requestParameters.os, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontEndAppUpdateInfoAdminApi
     */
    public apiV1AdminAppUpdateInfoDelete(requestParameters: FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return FrontEndAppUpdateInfoAdminApiFp(this.configuration).apiV1AdminAppUpdateInfoDelete(requestParameters.nexusOpsAppVersion, requestParameters.adminFrontEndAppUpdateInfoDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontEndAppUpdateInfoAdminApi
     */
    public apiV1AdminAppUpdateInfoGet(requestParameters: FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoGetRequest = {}, options?: RawAxiosRequestConfig) {
        return FrontEndAppUpdateInfoAdminApiFp(this.configuration).apiV1AdminAppUpdateInfoGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontEndAppUpdateInfoAdminApi
     */
    public apiV1AdminAppUpdateInfoPost(requestParameters: FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPostRequest = {}, options?: RawAxiosRequestConfig) {
        return FrontEndAppUpdateInfoAdminApiFp(this.configuration).apiV1AdminAppUpdateInfoPost(requestParameters.nexusOpsAppVersion, requestParameters.adminFrontEndAppUpdateInfoCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontEndAppUpdateInfoAdminApi
     */
    public apiV1AdminAppUpdateInfoPut(requestParameters: FrontEndAppUpdateInfoAdminApiApiV1AdminAppUpdateInfoPutRequest = {}, options?: RawAxiosRequestConfig) {
        return FrontEndAppUpdateInfoAdminApiFp(this.configuration).apiV1AdminAppUpdateInfoPut(requestParameters.nexusOpsAppVersion, requestParameters.adminFrontEndAppUpdateInfoUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeneralBrandingApi - axios parameter creator
 * @export
 */
export const GeneralBrandingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralBrandingInputMetaGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GeneralBrandingInputMetaGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/general/branding/input/meta`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralBrandingApi - functional programming interface
 * @export
 */
export const GeneralBrandingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralBrandingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GeneralBrandingInputMetaGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralBrandingInputMetaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GeneralBrandingInputMetaGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralBrandingApi.apiV1GeneralBrandingInputMetaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralBrandingApi - factory interface
 * @export
 */
export const GeneralBrandingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralBrandingApiFp(configuration)
    return {
        /**
         * 
         * @param {GeneralBrandingApiApiV1GeneralBrandingInputMetaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralBrandingInputMetaGet(requestParameters: GeneralBrandingApiApiV1GeneralBrandingInputMetaGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralBrandingInputMetaDto> {
            return localVarFp.apiV1GeneralBrandingInputMetaGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1GeneralBrandingInputMetaGet operation in GeneralBrandingApi.
 * @export
 * @interface GeneralBrandingApiApiV1GeneralBrandingInputMetaGetRequest
 */
export interface GeneralBrandingApiApiV1GeneralBrandingInputMetaGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralBrandingApiApiV1GeneralBrandingInputMetaGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralBrandingApiApiV1GeneralBrandingInputMetaGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * GeneralBrandingApi - object-oriented interface
 * @export
 * @class GeneralBrandingApi
 * @extends {BaseAPI}
 */
export class GeneralBrandingApi extends BaseAPI {
    /**
     * 
     * @param {GeneralBrandingApiApiV1GeneralBrandingInputMetaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralBrandingApi
     */
    public apiV1GeneralBrandingInputMetaGet(requestParameters: GeneralBrandingApiApiV1GeneralBrandingInputMetaGetRequest, options?: RawAxiosRequestConfig) {
        return GeneralBrandingApiFp(this.configuration).apiV1GeneralBrandingInputMetaGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeneralEventLogsApi - axios parameter creator
 * @export
 */
export const GeneralEventLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} entityId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralEventLogGetPaginatedDto} [generalEventLogGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralEventLogsEntityIdGetPost: async (nexusOpsTenant: string, entityId: string, nexusOpsAppVersion?: string, generalEventLogGetPaginatedDto?: GeneralEventLogGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GeneralEventLogsEntityIdGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiV1GeneralEventLogsEntityIdGetPost', 'entityId', entityId)
            const localVarPath = `/api/v1/general/event-logs/{entityId}/get`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalEventLogGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} id 
         * @param {string} entityId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralEventLogsEntityIdIdGet: async (nexusOpsTenant: string, id: string, entityId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GeneralEventLogsEntityIdIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1GeneralEventLogsEntityIdIdGet', 'id', id)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiV1GeneralEventLogsEntityIdIdGet', 'entityId', entityId)
            const localVarPath = `/api/v1/general/event-logs/{entityId}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralEventLogsApi - functional programming interface
 * @export
 */
export const GeneralEventLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralEventLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} entityId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralEventLogGetPaginatedDto} [generalEventLogGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GeneralEventLogsEntityIdGetPost(nexusOpsTenant: string, entityId: string, nexusOpsAppVersion?: string, generalEventLogGetPaginatedDto?: GeneralEventLogGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfGeneralEventLogDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GeneralEventLogsEntityIdGetPost(nexusOpsTenant, entityId, nexusOpsAppVersion, generalEventLogGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralEventLogsApi.apiV1GeneralEventLogsEntityIdGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} id 
         * @param {string} entityId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GeneralEventLogsEntityIdIdGet(nexusOpsTenant: string, id: string, entityId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralEventLogDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GeneralEventLogsEntityIdIdGet(nexusOpsTenant, id, entityId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralEventLogsApi.apiV1GeneralEventLogsEntityIdIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralEventLogsApi - factory interface
 * @export
 */
export const GeneralEventLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralEventLogsApiFp(configuration)
    return {
        /**
         * 
         * @param {GeneralEventLogsApiApiV1GeneralEventLogsEntityIdGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralEventLogsEntityIdGetPost(requestParameters: GeneralEventLogsApiApiV1GeneralEventLogsEntityIdGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfGeneralEventLogDto> {
            return localVarFp.apiV1GeneralEventLogsEntityIdGetPost(requestParameters.nexusOpsTenant, requestParameters.entityId, requestParameters.nexusOpsAppVersion, requestParameters.generalEventLogGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralEventLogsApiApiV1GeneralEventLogsEntityIdIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralEventLogsEntityIdIdGet(requestParameters: GeneralEventLogsApiApiV1GeneralEventLogsEntityIdIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralEventLogDto> {
            return localVarFp.apiV1GeneralEventLogsEntityIdIdGet(requestParameters.nexusOpsTenant, requestParameters.id, requestParameters.entityId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1GeneralEventLogsEntityIdGetPost operation in GeneralEventLogsApi.
 * @export
 * @interface GeneralEventLogsApiApiV1GeneralEventLogsEntityIdGetPostRequest
 */
export interface GeneralEventLogsApiApiV1GeneralEventLogsEntityIdGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralEventLogsApiApiV1GeneralEventLogsEntityIdGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof GeneralEventLogsApiApiV1GeneralEventLogsEntityIdGetPost
     */
    readonly entityId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralEventLogsApiApiV1GeneralEventLogsEntityIdGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralEventLogGetPaginatedDto}
     * @memberof GeneralEventLogsApiApiV1GeneralEventLogsEntityIdGetPost
     */
    readonly generalEventLogGetPaginatedDto?: GeneralEventLogGetPaginatedDto
}

/**
 * Request parameters for apiV1GeneralEventLogsEntityIdIdGet operation in GeneralEventLogsApi.
 * @export
 * @interface GeneralEventLogsApiApiV1GeneralEventLogsEntityIdIdGetRequest
 */
export interface GeneralEventLogsApiApiV1GeneralEventLogsEntityIdIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralEventLogsApiApiV1GeneralEventLogsEntityIdIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof GeneralEventLogsApiApiV1GeneralEventLogsEntityIdIdGet
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof GeneralEventLogsApiApiV1GeneralEventLogsEntityIdIdGet
     */
    readonly entityId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralEventLogsApiApiV1GeneralEventLogsEntityIdIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * GeneralEventLogsApi - object-oriented interface
 * @export
 * @class GeneralEventLogsApi
 * @extends {BaseAPI}
 */
export class GeneralEventLogsApi extends BaseAPI {
    /**
     * 
     * @param {GeneralEventLogsApiApiV1GeneralEventLogsEntityIdGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralEventLogsApi
     */
    public apiV1GeneralEventLogsEntityIdGetPost(requestParameters: GeneralEventLogsApiApiV1GeneralEventLogsEntityIdGetPostRequest, options?: RawAxiosRequestConfig) {
        return GeneralEventLogsApiFp(this.configuration).apiV1GeneralEventLogsEntityIdGetPost(requestParameters.nexusOpsTenant, requestParameters.entityId, requestParameters.nexusOpsAppVersion, requestParameters.generalEventLogGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralEventLogsApiApiV1GeneralEventLogsEntityIdIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralEventLogsApi
     */
    public apiV1GeneralEventLogsEntityIdIdGet(requestParameters: GeneralEventLogsApiApiV1GeneralEventLogsEntityIdIdGetRequest, options?: RawAxiosRequestConfig) {
        return GeneralEventLogsApiFp(this.configuration).apiV1GeneralEventLogsEntityIdIdGet(requestParameters.nexusOpsTenant, requestParameters.id, requestParameters.entityId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeneralHistoryApi - axios parameter creator
 * @export
 */
export const GeneralHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralHistoryBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GeneralHistoryBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/general-history/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} generalHistoryId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralHistoryGeneralHistoryIdDelete: async (nexusOpsTenant: string, generalHistoryId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GeneralHistoryGeneralHistoryIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'generalHistoryId' is not null or undefined
            assertParamExists('apiV1GeneralHistoryGeneralHistoryIdDelete', 'generalHistoryId', generalHistoryId)
            const localVarPath = `/api/v1/general-history/{generalHistoryId}`
                .replace(`{${"generalHistoryId"}}`, encodeURIComponent(String(generalHistoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} generalHistoryId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralHistoryGeneralHistoryIdGet: async (nexusOpsTenant: string, generalHistoryId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GeneralHistoryGeneralHistoryIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'generalHistoryId' is not null or undefined
            assertParamExists('apiV1GeneralHistoryGeneralHistoryIdGet', 'generalHistoryId', generalHistoryId)
            const localVarPath = `/api/v1/general-history/{generalHistoryId}`
                .replace(`{${"generalHistoryId"}}`, encodeURIComponent(String(generalHistoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} generalHistoryId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralHistoryUpdateDto} [generalHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralHistoryGeneralHistoryIdPut: async (nexusOpsTenant: string, generalHistoryId: string, nexusOpsAppVersion?: string, generalHistoryUpdateDto?: GeneralHistoryUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GeneralHistoryGeneralHistoryIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'generalHistoryId' is not null or undefined
            assertParamExists('apiV1GeneralHistoryGeneralHistoryIdPut', 'generalHistoryId', generalHistoryId)
            const localVarPath = `/api/v1/general-history/{generalHistoryId}`
                .replace(`{${"generalHistoryId"}}`, encodeURIComponent(String(generalHistoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalHistoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralHistoryGetPaginatedDto} [generalHistoryGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralHistoryGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, generalHistoryGetPaginatedDto?: GeneralHistoryGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GeneralHistoryGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/general-history/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalHistoryGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralHistoryCreateDto} [generalHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralHistoryPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, generalHistoryCreateDto?: GeneralHistoryCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GeneralHistoryPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/general-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalHistoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralHistoryApi - functional programming interface
 * @export
 */
export const GeneralHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GeneralHistoryBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GeneralHistoryBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralHistoryApi.apiV1GeneralHistoryBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} generalHistoryId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GeneralHistoryGeneralHistoryIdDelete(nexusOpsTenant: string, generalHistoryId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GeneralHistoryGeneralHistoryIdDelete(nexusOpsTenant, generalHistoryId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralHistoryApi.apiV1GeneralHistoryGeneralHistoryIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} generalHistoryId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GeneralHistoryGeneralHistoryIdGet(nexusOpsTenant: string, generalHistoryId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GeneralHistoryGeneralHistoryIdGet(nexusOpsTenant, generalHistoryId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralHistoryApi.apiV1GeneralHistoryGeneralHistoryIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} generalHistoryId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralHistoryUpdateDto} [generalHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GeneralHistoryGeneralHistoryIdPut(nexusOpsTenant: string, generalHistoryId: string, nexusOpsAppVersion?: string, generalHistoryUpdateDto?: GeneralHistoryUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GeneralHistoryGeneralHistoryIdPut(nexusOpsTenant, generalHistoryId, nexusOpsAppVersion, generalHistoryUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralHistoryApi.apiV1GeneralHistoryGeneralHistoryIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralHistoryGetPaginatedDto} [generalHistoryGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GeneralHistoryGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, generalHistoryGetPaginatedDto?: GeneralHistoryGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfGeneralHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GeneralHistoryGetPost(nexusOpsTenant, nexusOpsAppVersion, generalHistoryGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralHistoryApi.apiV1GeneralHistoryGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralHistoryCreateDto} [generalHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GeneralHistoryPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, generalHistoryCreateDto?: GeneralHistoryCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GeneralHistoryPost(nexusOpsTenant, nexusOpsAppVersion, generalHistoryCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralHistoryApi.apiV1GeneralHistoryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralHistoryApi - factory interface
 * @export
 */
export const GeneralHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {GeneralHistoryApiApiV1GeneralHistoryBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralHistoryBulkDeleteDelete(requestParameters: GeneralHistoryApiApiV1GeneralHistoryBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1GeneralHistoryBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralHistoryGeneralHistoryIdDelete(requestParameters: GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1GeneralHistoryGeneralHistoryIdDelete(requestParameters.nexusOpsTenant, requestParameters.generalHistoryId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralHistoryGeneralHistoryIdGet(requestParameters: GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralHistoryDto> {
            return localVarFp.apiV1GeneralHistoryGeneralHistoryIdGet(requestParameters.nexusOpsTenant, requestParameters.generalHistoryId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralHistoryGeneralHistoryIdPut(requestParameters: GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralHistoryDto> {
            return localVarFp.apiV1GeneralHistoryGeneralHistoryIdPut(requestParameters.nexusOpsTenant, requestParameters.generalHistoryId, requestParameters.nexusOpsAppVersion, requestParameters.generalHistoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralHistoryApiApiV1GeneralHistoryGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralHistoryGetPost(requestParameters: GeneralHistoryApiApiV1GeneralHistoryGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfGeneralHistoryDto> {
            return localVarFp.apiV1GeneralHistoryGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalHistoryGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralHistoryApiApiV1GeneralHistoryPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralHistoryPost(requestParameters: GeneralHistoryApiApiV1GeneralHistoryPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralHistoryDto> {
            return localVarFp.apiV1GeneralHistoryPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalHistoryCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1GeneralHistoryBulkDeleteDelete operation in GeneralHistoryApi.
 * @export
 * @interface GeneralHistoryApiApiV1GeneralHistoryBulkDeleteDeleteRequest
 */
export interface GeneralHistoryApiApiV1GeneralHistoryBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1GeneralHistoryGeneralHistoryIdDelete operation in GeneralHistoryApi.
 * @export
 * @interface GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdDeleteRequest
 */
export interface GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdDelete
     */
    readonly generalHistoryId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1GeneralHistoryGeneralHistoryIdGet operation in GeneralHistoryApi.
 * @export
 * @interface GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdGetRequest
 */
export interface GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdGet
     */
    readonly generalHistoryId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1GeneralHistoryGeneralHistoryIdPut operation in GeneralHistoryApi.
 * @export
 * @interface GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdPutRequest
 */
export interface GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdPut
     */
    readonly generalHistoryId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralHistoryUpdateDto}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdPut
     */
    readonly generalHistoryUpdateDto?: GeneralHistoryUpdateDto
}

/**
 * Request parameters for apiV1GeneralHistoryGetPost operation in GeneralHistoryApi.
 * @export
 * @interface GeneralHistoryApiApiV1GeneralHistoryGetPostRequest
 */
export interface GeneralHistoryApiApiV1GeneralHistoryGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralHistoryGetPaginatedDto}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryGetPost
     */
    readonly generalHistoryGetPaginatedDto?: GeneralHistoryGetPaginatedDto
}

/**
 * Request parameters for apiV1GeneralHistoryPost operation in GeneralHistoryApi.
 * @export
 * @interface GeneralHistoryApiApiV1GeneralHistoryPostRequest
 */
export interface GeneralHistoryApiApiV1GeneralHistoryPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralHistoryCreateDto}
     * @memberof GeneralHistoryApiApiV1GeneralHistoryPost
     */
    readonly generalHistoryCreateDto?: GeneralHistoryCreateDto
}

/**
 * GeneralHistoryApi - object-oriented interface
 * @export
 * @class GeneralHistoryApi
 * @extends {BaseAPI}
 */
export class GeneralHistoryApi extends BaseAPI {
    /**
     * 
     * @param {GeneralHistoryApiApiV1GeneralHistoryBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralHistoryApi
     */
    public apiV1GeneralHistoryBulkDeleteDelete(requestParameters: GeneralHistoryApiApiV1GeneralHistoryBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return GeneralHistoryApiFp(this.configuration).apiV1GeneralHistoryBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralHistoryApi
     */
    public apiV1GeneralHistoryGeneralHistoryIdDelete(requestParameters: GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return GeneralHistoryApiFp(this.configuration).apiV1GeneralHistoryGeneralHistoryIdDelete(requestParameters.nexusOpsTenant, requestParameters.generalHistoryId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralHistoryApi
     */
    public apiV1GeneralHistoryGeneralHistoryIdGet(requestParameters: GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdGetRequest, options?: RawAxiosRequestConfig) {
        return GeneralHistoryApiFp(this.configuration).apiV1GeneralHistoryGeneralHistoryIdGet(requestParameters.nexusOpsTenant, requestParameters.generalHistoryId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralHistoryApi
     */
    public apiV1GeneralHistoryGeneralHistoryIdPut(requestParameters: GeneralHistoryApiApiV1GeneralHistoryGeneralHistoryIdPutRequest, options?: RawAxiosRequestConfig) {
        return GeneralHistoryApiFp(this.configuration).apiV1GeneralHistoryGeneralHistoryIdPut(requestParameters.nexusOpsTenant, requestParameters.generalHistoryId, requestParameters.nexusOpsAppVersion, requestParameters.generalHistoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralHistoryApiApiV1GeneralHistoryGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralHistoryApi
     */
    public apiV1GeneralHistoryGetPost(requestParameters: GeneralHistoryApiApiV1GeneralHistoryGetPostRequest, options?: RawAxiosRequestConfig) {
        return GeneralHistoryApiFp(this.configuration).apiV1GeneralHistoryGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalHistoryGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralHistoryApiApiV1GeneralHistoryPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralHistoryApi
     */
    public apiV1GeneralHistoryPost(requestParameters: GeneralHistoryApiApiV1GeneralHistoryPostRequest, options?: RawAxiosRequestConfig) {
        return GeneralHistoryApiFp(this.configuration).apiV1GeneralHistoryPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalHistoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeneralReferenceDataApi - axios parameter creator
 * @export
 */
export const GeneralReferenceDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataGeneralCountriesGet: async (nexusOpsAppVersion?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/general/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataGeneralCulturesDefaultGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/general/cultures/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataGeneralCulturesGet: async (nexusOpsAppVersion?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/general/cultures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataGeneralCurrenciesDefaultGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/general/currencies/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataGeneralCurrenciesGet: async (nexusOpsAppVersion?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/general/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataGeneralTimeZonesDefaultGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/general/time-zones/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataGeneralTimeZonesGet: async (nexusOpsAppVersion?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/general/time-zones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralReferenceDataApi - functional programming interface
 * @export
 */
export const GeneralReferenceDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralReferenceDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataGeneralCountriesGet(nexusOpsAppVersion?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCountryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataGeneralCountriesGet(nexusOpsAppVersion, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralReferenceDataApi.apiV1ReferenceDataGeneralCountriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataGeneralCulturesDefaultGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralCultureDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataGeneralCulturesDefaultGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralReferenceDataApi.apiV1ReferenceDataGeneralCulturesDefaultGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataGeneralCulturesGet(nexusOpsAppVersion?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCultureDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataGeneralCulturesGet(nexusOpsAppVersion, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralReferenceDataApi.apiV1ReferenceDataGeneralCulturesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataGeneralCurrenciesDefaultGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralCurrencyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataGeneralCurrenciesDefaultGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralReferenceDataApi.apiV1ReferenceDataGeneralCurrenciesDefaultGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataGeneralCurrenciesGet(nexusOpsAppVersion?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCurrencyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataGeneralCurrenciesGet(nexusOpsAppVersion, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralReferenceDataApi.apiV1ReferenceDataGeneralCurrenciesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataGeneralTimeZonesDefaultGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralTimeZoneDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataGeneralTimeZonesDefaultGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralReferenceDataApi.apiV1ReferenceDataGeneralTimeZonesDefaultGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataGeneralTimeZonesGet(nexusOpsAppVersion?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralTimeZoneDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataGeneralTimeZonesGet(nexusOpsAppVersion, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralReferenceDataApi.apiV1ReferenceDataGeneralTimeZonesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralReferenceDataApi - factory interface
 * @export
 */
export const GeneralReferenceDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralReferenceDataApiFp(configuration)
    return {
        /**
         * 
         * @param {GeneralReferenceDataApiApiV1ReferenceDataGeneralCountriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataGeneralCountriesGet(requestParameters: GeneralReferenceDataApiApiV1ReferenceDataGeneralCountriesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCountryDto>> {
            return localVarFp.apiV1ReferenceDataGeneralCountriesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesDefaultGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataGeneralCulturesDefaultGet(requestParameters: GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesDefaultGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralCultureDto> {
            return localVarFp.apiV1ReferenceDataGeneralCulturesDefaultGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataGeneralCulturesGet(requestParameters: GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCultureDto>> {
            return localVarFp.apiV1ReferenceDataGeneralCulturesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesDefaultGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataGeneralCurrenciesDefaultGet(requestParameters: GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesDefaultGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralCurrencyDto> {
            return localVarFp.apiV1ReferenceDataGeneralCurrenciesDefaultGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataGeneralCurrenciesGet(requestParameters: GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCurrencyDto>> {
            return localVarFp.apiV1ReferenceDataGeneralCurrenciesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesDefaultGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataGeneralTimeZonesDefaultGet(requestParameters: GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesDefaultGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralTimeZoneDto> {
            return localVarFp.apiV1ReferenceDataGeneralTimeZonesDefaultGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataGeneralTimeZonesGet(requestParameters: GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralTimeZoneDto>> {
            return localVarFp.apiV1ReferenceDataGeneralTimeZonesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ReferenceDataGeneralCountriesGet operation in GeneralReferenceDataApi.
 * @export
 * @interface GeneralReferenceDataApiApiV1ReferenceDataGeneralCountriesGetRequest
 */
export interface GeneralReferenceDataApiApiV1ReferenceDataGeneralCountriesGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralReferenceDataApiApiV1ReferenceDataGeneralCountriesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof GeneralReferenceDataApiApiV1ReferenceDataGeneralCountriesGet
     */
    readonly search?: string
}

/**
 * Request parameters for apiV1ReferenceDataGeneralCulturesDefaultGet operation in GeneralReferenceDataApi.
 * @export
 * @interface GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesDefaultGetRequest
 */
export interface GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesDefaultGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesDefaultGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ReferenceDataGeneralCulturesGet operation in GeneralReferenceDataApi.
 * @export
 * @interface GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesGetRequest
 */
export interface GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesGet
     */
    readonly search?: string
}

/**
 * Request parameters for apiV1ReferenceDataGeneralCurrenciesDefaultGet operation in GeneralReferenceDataApi.
 * @export
 * @interface GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesDefaultGetRequest
 */
export interface GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesDefaultGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesDefaultGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ReferenceDataGeneralCurrenciesGet operation in GeneralReferenceDataApi.
 * @export
 * @interface GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesGetRequest
 */
export interface GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesGet
     */
    readonly search?: string
}

/**
 * Request parameters for apiV1ReferenceDataGeneralTimeZonesDefaultGet operation in GeneralReferenceDataApi.
 * @export
 * @interface GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesDefaultGetRequest
 */
export interface GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesDefaultGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesDefaultGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ReferenceDataGeneralTimeZonesGet operation in GeneralReferenceDataApi.
 * @export
 * @interface GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesGetRequest
 */
export interface GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesGet
     */
    readonly search?: string
}

/**
 * GeneralReferenceDataApi - object-oriented interface
 * @export
 * @class GeneralReferenceDataApi
 * @extends {BaseAPI}
 */
export class GeneralReferenceDataApi extends BaseAPI {
    /**
     * 
     * @param {GeneralReferenceDataApiApiV1ReferenceDataGeneralCountriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralReferenceDataApi
     */
    public apiV1ReferenceDataGeneralCountriesGet(requestParameters: GeneralReferenceDataApiApiV1ReferenceDataGeneralCountriesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralReferenceDataApiFp(this.configuration).apiV1ReferenceDataGeneralCountriesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesDefaultGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralReferenceDataApi
     */
    public apiV1ReferenceDataGeneralCulturesDefaultGet(requestParameters: GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesDefaultGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralReferenceDataApiFp(this.configuration).apiV1ReferenceDataGeneralCulturesDefaultGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralReferenceDataApi
     */
    public apiV1ReferenceDataGeneralCulturesGet(requestParameters: GeneralReferenceDataApiApiV1ReferenceDataGeneralCulturesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralReferenceDataApiFp(this.configuration).apiV1ReferenceDataGeneralCulturesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesDefaultGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralReferenceDataApi
     */
    public apiV1ReferenceDataGeneralCurrenciesDefaultGet(requestParameters: GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesDefaultGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralReferenceDataApiFp(this.configuration).apiV1ReferenceDataGeneralCurrenciesDefaultGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralReferenceDataApi
     */
    public apiV1ReferenceDataGeneralCurrenciesGet(requestParameters: GeneralReferenceDataApiApiV1ReferenceDataGeneralCurrenciesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralReferenceDataApiFp(this.configuration).apiV1ReferenceDataGeneralCurrenciesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesDefaultGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralReferenceDataApi
     */
    public apiV1ReferenceDataGeneralTimeZonesDefaultGet(requestParameters: GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesDefaultGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralReferenceDataApiFp(this.configuration).apiV1ReferenceDataGeneralTimeZonesDefaultGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralReferenceDataApi
     */
    public apiV1ReferenceDataGeneralTimeZonesGet(requestParameters: GeneralReferenceDataApiApiV1ReferenceDataGeneralTimeZonesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralReferenceDataApiFp(this.configuration).apiV1ReferenceDataGeneralTimeZonesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeneralReferenceDataAdminApi - axios parameter creator
 * @export
 */
export const GeneralReferenceDataAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataGeneralCountriesGet: async (nexusOpsAppVersion?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/general/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataGeneralCulturesDefaultGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/general/cultures/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataGeneralCulturesGet: async (nexusOpsAppVersion?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/general/cultures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataGeneralCurrenciesDefaultGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/general/currencies/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataGeneralCurrenciesGet: async (nexusOpsAppVersion?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/general/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataGeneralTimeZonesDefaultGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/general/time-zones/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataGeneralTimeZonesGet: async (nexusOpsAppVersion?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/general/time-zones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralReferenceDataAdminApi - functional programming interface
 * @export
 */
export const GeneralReferenceDataAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralReferenceDataAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataGeneralCountriesGet(nexusOpsAppVersion?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCountryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataGeneralCountriesGet(nexusOpsAppVersion, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralReferenceDataAdminApi.apiV1AdminReferenceDataGeneralCountriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataGeneralCulturesDefaultGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralCultureDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataGeneralCulturesDefaultGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralReferenceDataAdminApi.apiV1AdminReferenceDataGeneralCulturesDefaultGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataGeneralCulturesGet(nexusOpsAppVersion?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCultureDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataGeneralCulturesGet(nexusOpsAppVersion, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralReferenceDataAdminApi.apiV1AdminReferenceDataGeneralCulturesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataGeneralCurrenciesDefaultGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralCurrencyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataGeneralCurrenciesDefaultGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralReferenceDataAdminApi.apiV1AdminReferenceDataGeneralCurrenciesDefaultGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataGeneralCurrenciesGet(nexusOpsAppVersion?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCurrencyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataGeneralCurrenciesGet(nexusOpsAppVersion, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralReferenceDataAdminApi.apiV1AdminReferenceDataGeneralCurrenciesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataGeneralTimeZonesDefaultGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralTimeZoneDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataGeneralTimeZonesDefaultGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralReferenceDataAdminApi.apiV1AdminReferenceDataGeneralTimeZonesDefaultGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataGeneralTimeZonesGet(nexusOpsAppVersion?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralTimeZoneDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataGeneralTimeZonesGet(nexusOpsAppVersion, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralReferenceDataAdminApi.apiV1AdminReferenceDataGeneralTimeZonesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralReferenceDataAdminApi - factory interface
 * @export
 */
export const GeneralReferenceDataAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralReferenceDataAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCountriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataGeneralCountriesGet(requestParameters: GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCountriesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCountryDto>> {
            return localVarFp.apiV1AdminReferenceDataGeneralCountriesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesDefaultGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataGeneralCulturesDefaultGet(requestParameters: GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesDefaultGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralCultureDto> {
            return localVarFp.apiV1AdminReferenceDataGeneralCulturesDefaultGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataGeneralCulturesGet(requestParameters: GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCultureDto>> {
            return localVarFp.apiV1AdminReferenceDataGeneralCulturesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesDefaultGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataGeneralCurrenciesDefaultGet(requestParameters: GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesDefaultGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralCurrencyDto> {
            return localVarFp.apiV1AdminReferenceDataGeneralCurrenciesDefaultGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataGeneralCurrenciesGet(requestParameters: GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCurrencyDto>> {
            return localVarFp.apiV1AdminReferenceDataGeneralCurrenciesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesDefaultGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataGeneralTimeZonesDefaultGet(requestParameters: GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesDefaultGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralTimeZoneDto> {
            return localVarFp.apiV1AdminReferenceDataGeneralTimeZonesDefaultGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataGeneralTimeZonesGet(requestParameters: GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralTimeZoneDto>> {
            return localVarFp.apiV1AdminReferenceDataGeneralTimeZonesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminReferenceDataGeneralCountriesGet operation in GeneralReferenceDataAdminApi.
 * @export
 * @interface GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCountriesGetRequest
 */
export interface GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCountriesGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCountriesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCountriesGet
     */
    readonly search?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataGeneralCulturesDefaultGet operation in GeneralReferenceDataAdminApi.
 * @export
 * @interface GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesDefaultGetRequest
 */
export interface GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesDefaultGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesDefaultGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataGeneralCulturesGet operation in GeneralReferenceDataAdminApi.
 * @export
 * @interface GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesGetRequest
 */
export interface GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesGet
     */
    readonly search?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataGeneralCurrenciesDefaultGet operation in GeneralReferenceDataAdminApi.
 * @export
 * @interface GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesDefaultGetRequest
 */
export interface GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesDefaultGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesDefaultGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataGeneralCurrenciesGet operation in GeneralReferenceDataAdminApi.
 * @export
 * @interface GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesGetRequest
 */
export interface GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesGet
     */
    readonly search?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataGeneralTimeZonesDefaultGet operation in GeneralReferenceDataAdminApi.
 * @export
 * @interface GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesDefaultGetRequest
 */
export interface GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesDefaultGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesDefaultGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataGeneralTimeZonesGet operation in GeneralReferenceDataAdminApi.
 * @export
 * @interface GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesGetRequest
 */
export interface GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesGet
     */
    readonly search?: string
}

/**
 * GeneralReferenceDataAdminApi - object-oriented interface
 * @export
 * @class GeneralReferenceDataAdminApi
 * @extends {BaseAPI}
 */
export class GeneralReferenceDataAdminApi extends BaseAPI {
    /**
     * 
     * @param {GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCountriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralReferenceDataAdminApi
     */
    public apiV1AdminReferenceDataGeneralCountriesGet(requestParameters: GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCountriesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralReferenceDataAdminApiFp(this.configuration).apiV1AdminReferenceDataGeneralCountriesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesDefaultGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralReferenceDataAdminApi
     */
    public apiV1AdminReferenceDataGeneralCulturesDefaultGet(requestParameters: GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesDefaultGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralReferenceDataAdminApiFp(this.configuration).apiV1AdminReferenceDataGeneralCulturesDefaultGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralReferenceDataAdminApi
     */
    public apiV1AdminReferenceDataGeneralCulturesGet(requestParameters: GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCulturesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralReferenceDataAdminApiFp(this.configuration).apiV1AdminReferenceDataGeneralCulturesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesDefaultGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralReferenceDataAdminApi
     */
    public apiV1AdminReferenceDataGeneralCurrenciesDefaultGet(requestParameters: GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesDefaultGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralReferenceDataAdminApiFp(this.configuration).apiV1AdminReferenceDataGeneralCurrenciesDefaultGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralReferenceDataAdminApi
     */
    public apiV1AdminReferenceDataGeneralCurrenciesGet(requestParameters: GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralCurrenciesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralReferenceDataAdminApiFp(this.configuration).apiV1AdminReferenceDataGeneralCurrenciesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesDefaultGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralReferenceDataAdminApi
     */
    public apiV1AdminReferenceDataGeneralTimeZonesDefaultGet(requestParameters: GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesDefaultGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralReferenceDataAdminApiFp(this.configuration).apiV1AdminReferenceDataGeneralTimeZonesDefaultGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralReferenceDataAdminApi
     */
    public apiV1AdminReferenceDataGeneralTimeZonesGet(requestParameters: GeneralReferenceDataAdminApiApiV1AdminReferenceDataGeneralTimeZonesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralReferenceDataAdminApiFp(this.configuration).apiV1AdminReferenceDataGeneralTimeZonesGet(requestParameters.nexusOpsAppVersion, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeneralScopesApi - axios parameter creator
 * @export
 */
export const GeneralScopesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralScopeDto} [generalScopeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralScopesGetUnwoundPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, generalScopeDto?: GeneralScopeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GeneralScopesGetUnwoundPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/general/scopes/get/unwound`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalScopeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralScopesApi - functional programming interface
 * @export
 */
export const GeneralScopesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralScopesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralScopeDto} [generalScopeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GeneralScopesGetUnwoundPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, generalScopeDto?: GeneralScopeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralScopeUnwoundDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GeneralScopesGetUnwoundPost(nexusOpsTenant, nexusOpsAppVersion, generalScopeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralScopesApi.apiV1GeneralScopesGetUnwoundPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralScopesApi - factory interface
 * @export
 */
export const GeneralScopesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralScopesApiFp(configuration)
    return {
        /**
         * 
         * @param {GeneralScopesApiApiV1GeneralScopesGetUnwoundPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralScopesGetUnwoundPost(requestParameters: GeneralScopesApiApiV1GeneralScopesGetUnwoundPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralScopeUnwoundDto> {
            return localVarFp.apiV1GeneralScopesGetUnwoundPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalScopeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1GeneralScopesGetUnwoundPost operation in GeneralScopesApi.
 * @export
 * @interface GeneralScopesApiApiV1GeneralScopesGetUnwoundPostRequest
 */
export interface GeneralScopesApiApiV1GeneralScopesGetUnwoundPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralScopesApiApiV1GeneralScopesGetUnwoundPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralScopesApiApiV1GeneralScopesGetUnwoundPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralScopeDto}
     * @memberof GeneralScopesApiApiV1GeneralScopesGetUnwoundPost
     */
    readonly generalScopeDto?: GeneralScopeDto
}

/**
 * GeneralScopesApi - object-oriented interface
 * @export
 * @class GeneralScopesApi
 * @extends {BaseAPI}
 */
export class GeneralScopesApi extends BaseAPI {
    /**
     * 
     * @param {GeneralScopesApiApiV1GeneralScopesGetUnwoundPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralScopesApi
     */
    public apiV1GeneralScopesGetUnwoundPost(requestParameters: GeneralScopesApiApiV1GeneralScopesGetUnwoundPostRequest, options?: RawAxiosRequestConfig) {
        return GeneralScopesApiFp(this.configuration).apiV1GeneralScopesGetUnwoundPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalScopeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeneralStatusHistoryApi - axios parameter creator
 * @export
 */
export const GeneralStatusHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} generalStatusHistoryId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralStatusHistoryGeneralStatusHistoryIdGet: async (nexusOpsTenant: string, generalStatusHistoryId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GeneralStatusHistoryGeneralStatusHistoryIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'generalStatusHistoryId' is not null or undefined
            assertParamExists('apiV1GeneralStatusHistoryGeneralStatusHistoryIdGet', 'generalStatusHistoryId', generalStatusHistoryId)
            const localVarPath = `/api/v1/general-status-history/{generalStatusHistoryId}`
                .replace(`{${"generalStatusHistoryId"}}`, encodeURIComponent(String(generalStatusHistoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStatusHistoryGetPaginatedDto} [generalStatusHistoryGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralStatusHistoryGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, generalStatusHistoryGetPaginatedDto?: GeneralStatusHistoryGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GeneralStatusHistoryGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/general-status-history/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalStatusHistoryGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralStatusHistoryApi - functional programming interface
 * @export
 */
export const GeneralStatusHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralStatusHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} generalStatusHistoryId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GeneralStatusHistoryGeneralStatusHistoryIdGet(nexusOpsTenant: string, generalStatusHistoryId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralStatusHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GeneralStatusHistoryGeneralStatusHistoryIdGet(nexusOpsTenant, generalStatusHistoryId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralStatusHistoryApi.apiV1GeneralStatusHistoryGeneralStatusHistoryIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStatusHistoryGetPaginatedDto} [generalStatusHistoryGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GeneralStatusHistoryGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, generalStatusHistoryGetPaginatedDto?: GeneralStatusHistoryGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfGeneralStatusHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GeneralStatusHistoryGetPost(nexusOpsTenant, nexusOpsAppVersion, generalStatusHistoryGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralStatusHistoryApi.apiV1GeneralStatusHistoryGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralStatusHistoryApi - factory interface
 * @export
 */
export const GeneralStatusHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralStatusHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {GeneralStatusHistoryApiApiV1GeneralStatusHistoryGeneralStatusHistoryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralStatusHistoryGeneralStatusHistoryIdGet(requestParameters: GeneralStatusHistoryApiApiV1GeneralStatusHistoryGeneralStatusHistoryIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralStatusHistoryDto> {
            return localVarFp.apiV1GeneralStatusHistoryGeneralStatusHistoryIdGet(requestParameters.nexusOpsTenant, requestParameters.generalStatusHistoryId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralStatusHistoryApiApiV1GeneralStatusHistoryGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeneralStatusHistoryGetPost(requestParameters: GeneralStatusHistoryApiApiV1GeneralStatusHistoryGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfGeneralStatusHistoryDto> {
            return localVarFp.apiV1GeneralStatusHistoryGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalStatusHistoryGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1GeneralStatusHistoryGeneralStatusHistoryIdGet operation in GeneralStatusHistoryApi.
 * @export
 * @interface GeneralStatusHistoryApiApiV1GeneralStatusHistoryGeneralStatusHistoryIdGetRequest
 */
export interface GeneralStatusHistoryApiApiV1GeneralStatusHistoryGeneralStatusHistoryIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralStatusHistoryApiApiV1GeneralStatusHistoryGeneralStatusHistoryIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof GeneralStatusHistoryApiApiV1GeneralStatusHistoryGeneralStatusHistoryIdGet
     */
    readonly generalStatusHistoryId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralStatusHistoryApiApiV1GeneralStatusHistoryGeneralStatusHistoryIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1GeneralStatusHistoryGetPost operation in GeneralStatusHistoryApi.
 * @export
 * @interface GeneralStatusHistoryApiApiV1GeneralStatusHistoryGetPostRequest
 */
export interface GeneralStatusHistoryApiApiV1GeneralStatusHistoryGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralStatusHistoryApiApiV1GeneralStatusHistoryGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralStatusHistoryApiApiV1GeneralStatusHistoryGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralStatusHistoryGetPaginatedDto}
     * @memberof GeneralStatusHistoryApiApiV1GeneralStatusHistoryGetPost
     */
    readonly generalStatusHistoryGetPaginatedDto?: GeneralStatusHistoryGetPaginatedDto
}

/**
 * GeneralStatusHistoryApi - object-oriented interface
 * @export
 * @class GeneralStatusHistoryApi
 * @extends {BaseAPI}
 */
export class GeneralStatusHistoryApi extends BaseAPI {
    /**
     * 
     * @param {GeneralStatusHistoryApiApiV1GeneralStatusHistoryGeneralStatusHistoryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralStatusHistoryApi
     */
    public apiV1GeneralStatusHistoryGeneralStatusHistoryIdGet(requestParameters: GeneralStatusHistoryApiApiV1GeneralStatusHistoryGeneralStatusHistoryIdGetRequest, options?: RawAxiosRequestConfig) {
        return GeneralStatusHistoryApiFp(this.configuration).apiV1GeneralStatusHistoryGeneralStatusHistoryIdGet(requestParameters.nexusOpsTenant, requestParameters.generalStatusHistoryId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralStatusHistoryApiApiV1GeneralStatusHistoryGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralStatusHistoryApi
     */
    public apiV1GeneralStatusHistoryGetPost(requestParameters: GeneralStatusHistoryApiApiV1GeneralStatusHistoryGetPostRequest, options?: RawAxiosRequestConfig) {
        return GeneralStatusHistoryApiFp(this.configuration).apiV1GeneralStatusHistoryGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalStatusHistoryGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeneralTagsApi - axios parameter creator
 * @export
 */
export const GeneralTagsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customTagId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralByCustomTagCustomTagIdGet: async (nexusOpsTenant: string, customTagId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsGeneralByCustomTagCustomTagIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'customTagId' is not null or undefined
            assertParamExists('apiV1TagsGeneralByCustomTagCustomTagIdGet', 'customTagId', customTagId)
            const localVarPath = `/api/v1/tags/general/by-custom-tag/{customTagId}`
                .replace(`{${"customTagId"}}`, encodeURIComponent(String(customTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customTagId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGet: async (nexusOpsTenant: string, customTagId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'customTagId' is not null or undefined
            assertParamExists('apiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGet', 'customTagId', customTagId)
            const localVarPath = `/api/v1/tags/general/candidates/get/by-custom-tag/{customTagId}`
                .replace(`{${"customTagId"}}`, encodeURIComponent(String(customTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralTagCandidatesByScopeRequestDto} [generalTagCandidatesByScopeRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralCandidatesGetByScopePost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, generalTagCandidatesByScopeRequestDto?: GeneralTagCandidatesByScopeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsGeneralCandidatesGetByScopePost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tags/general/candidates/get/by-scope`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalTagCandidatesByScopeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralTagCandidatesRequestDto} [generalTagCandidatesRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralCandidatesGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, generalTagCandidatesRequestDto?: GeneralTagCandidatesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsGeneralCandidatesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tags/general/candidates/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalTagCandidatesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralAttachedTagsOfEntitiesDeleteDto} [generalAttachedTagsOfEntitiesDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralForEntitiesDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, generalAttachedTagsOfEntitiesDeleteDto?: GeneralAttachedTagsOfEntitiesDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsGeneralForEntitiesDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tags/general/for-entities/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalAttachedTagsOfEntitiesDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralAttachedTagsOfEntitiesUpdateDto} [generalAttachedTagsOfEntitiesUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralForEntitiesUpdatePut: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, generalAttachedTagsOfEntitiesUpdateDto?: GeneralAttachedTagsOfEntitiesUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsGeneralForEntitiesUpdatePut', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tags/general/for-entities/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalAttachedTagsOfEntitiesUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralAttachedTagsOfEntityDeleteDto} [generalAttachedTagsOfEntityDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralForEntityDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, generalAttachedTagsOfEntityDeleteDto?: GeneralAttachedTagsOfEntityDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsGeneralForEntityDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tags/general/for-entity/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalAttachedTagsOfEntityDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TagEntityType} [entityType] Entity where tag can be placed.  Must contain only values from EntityType.
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralForEntityGetGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityType?: TagEntityType, entityId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsGeneralForEntityGetGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tags/general/for-entity/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralAttachedTagsOfEntityUpdateDto} [generalAttachedTagsOfEntityUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralForEntityUpdatePut: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, generalAttachedTagsOfEntityUpdateDto?: GeneralAttachedTagsOfEntityUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TagsGeneralForEntityUpdatePut', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tags/general/for-entity/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalAttachedTagsOfEntityUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralTagsApi - functional programming interface
 * @export
 */
export const GeneralTagsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralTagsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customTagId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsGeneralByCustomTagCustomTagIdGet(nexusOpsTenant: string, customTagId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralTagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsGeneralByCustomTagCustomTagIdGet(nexusOpsTenant, customTagId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralTagsApi.apiV1TagsGeneralByCustomTagCustomTagIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} customTagId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGet(nexusOpsTenant: string, customTagId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralTagCandidateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGet(nexusOpsTenant, customTagId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralTagsApi.apiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralTagCandidatesByScopeRequestDto} [generalTagCandidatesByScopeRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsGeneralCandidatesGetByScopePost(nexusOpsTenant: string, nexusOpsAppVersion?: string, generalTagCandidatesByScopeRequestDto?: GeneralTagCandidatesByScopeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfGeneralTagCandidateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsGeneralCandidatesGetByScopePost(nexusOpsTenant, nexusOpsAppVersion, generalTagCandidatesByScopeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralTagsApi.apiV1TagsGeneralCandidatesGetByScopePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralTagCandidatesRequestDto} [generalTagCandidatesRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsGeneralCandidatesGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, generalTagCandidatesRequestDto?: GeneralTagCandidatesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfGeneralTagCandidateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsGeneralCandidatesGetPost(nexusOpsTenant, nexusOpsAppVersion, generalTagCandidatesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralTagsApi.apiV1TagsGeneralCandidatesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralAttachedTagsOfEntitiesDeleteDto} [generalAttachedTagsOfEntitiesDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsGeneralForEntitiesDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, generalAttachedTagsOfEntitiesDeleteDto?: GeneralAttachedTagsOfEntitiesDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsGeneralForEntitiesDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, generalAttachedTagsOfEntitiesDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralTagsApi.apiV1TagsGeneralForEntitiesDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralAttachedTagsOfEntitiesUpdateDto} [generalAttachedTagsOfEntitiesUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsGeneralForEntitiesUpdatePut(nexusOpsTenant: string, nexusOpsAppVersion?: string, generalAttachedTagsOfEntitiesUpdateDto?: GeneralAttachedTagsOfEntitiesUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsGeneralForEntitiesUpdatePut(nexusOpsTenant, nexusOpsAppVersion, generalAttachedTagsOfEntitiesUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralTagsApi.apiV1TagsGeneralForEntitiesUpdatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralAttachedTagsOfEntityDeleteDto} [generalAttachedTagsOfEntityDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsGeneralForEntityDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, generalAttachedTagsOfEntityDeleteDto?: GeneralAttachedTagsOfEntityDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralAttachedTagsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsGeneralForEntityDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, generalAttachedTagsOfEntityDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralTagsApi.apiV1TagsGeneralForEntityDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TagEntityType} [entityType] Entity where tag can be placed.  Must contain only values from EntityType.
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsGeneralForEntityGetGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityType?: TagEntityType, entityId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralAttachedTagsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsGeneralForEntityGetGet(nexusOpsTenant, nexusOpsAppVersion, entityType, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralTagsApi.apiV1TagsGeneralForEntityGetGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralAttachedTagsOfEntityUpdateDto} [generalAttachedTagsOfEntityUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TagsGeneralForEntityUpdatePut(nexusOpsTenant: string, nexusOpsAppVersion?: string, generalAttachedTagsOfEntityUpdateDto?: GeneralAttachedTagsOfEntityUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralAttachedTagsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TagsGeneralForEntityUpdatePut(nexusOpsTenant, nexusOpsAppVersion, generalAttachedTagsOfEntityUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralTagsApi.apiV1TagsGeneralForEntityUpdatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralTagsApi - factory interface
 * @export
 */
export const GeneralTagsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralTagsApiFp(configuration)
    return {
        /**
         * 
         * @param {GeneralTagsApiApiV1TagsGeneralByCustomTagCustomTagIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralByCustomTagCustomTagIdGet(requestParameters: GeneralTagsApiApiV1TagsGeneralByCustomTagCustomTagIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralTagDto> {
            return localVarFp.apiV1TagsGeneralByCustomTagCustomTagIdGet(requestParameters.nexusOpsTenant, requestParameters.customTagId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralTagsApiApiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGet(requestParameters: GeneralTagsApiApiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralTagCandidateDto> {
            return localVarFp.apiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGet(requestParameters.nexusOpsTenant, requestParameters.customTagId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralTagsApiApiV1TagsGeneralCandidatesGetByScopePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralCandidatesGetByScopePost(requestParameters: GeneralTagsApiApiV1TagsGeneralCandidatesGetByScopePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfGeneralTagCandidateDto> {
            return localVarFp.apiV1TagsGeneralCandidatesGetByScopePost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalTagCandidatesByScopeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralTagsApiApiV1TagsGeneralCandidatesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralCandidatesGetPost(requestParameters: GeneralTagsApiApiV1TagsGeneralCandidatesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfGeneralTagCandidateDto> {
            return localVarFp.apiV1TagsGeneralCandidatesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalTagCandidatesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralTagsApiApiV1TagsGeneralForEntitiesDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralForEntitiesDeleteDelete(requestParameters: GeneralTagsApiApiV1TagsGeneralForEntitiesDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1TagsGeneralForEntitiesDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalAttachedTagsOfEntitiesDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralTagsApiApiV1TagsGeneralForEntitiesUpdatePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralForEntitiesUpdatePut(requestParameters: GeneralTagsApiApiV1TagsGeneralForEntitiesUpdatePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1TagsGeneralForEntitiesUpdatePut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalAttachedTagsOfEntitiesUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralTagsApiApiV1TagsGeneralForEntityDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralForEntityDeleteDelete(requestParameters: GeneralTagsApiApiV1TagsGeneralForEntityDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralAttachedTagsDto> {
            return localVarFp.apiV1TagsGeneralForEntityDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalAttachedTagsOfEntityDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralTagsApiApiV1TagsGeneralForEntityGetGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralForEntityGetGet(requestParameters: GeneralTagsApiApiV1TagsGeneralForEntityGetGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralAttachedTagsDto> {
            return localVarFp.apiV1TagsGeneralForEntityGetGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityType, requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralTagsApiApiV1TagsGeneralForEntityUpdatePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TagsGeneralForEntityUpdatePut(requestParameters: GeneralTagsApiApiV1TagsGeneralForEntityUpdatePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralAttachedTagsDto> {
            return localVarFp.apiV1TagsGeneralForEntityUpdatePut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalAttachedTagsOfEntityUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1TagsGeneralByCustomTagCustomTagIdGet operation in GeneralTagsApi.
 * @export
 * @interface GeneralTagsApiApiV1TagsGeneralByCustomTagCustomTagIdGetRequest
 */
export interface GeneralTagsApiApiV1TagsGeneralByCustomTagCustomTagIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralByCustomTagCustomTagIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralByCustomTagCustomTagIdGet
     */
    readonly customTagId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralByCustomTagCustomTagIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGet operation in GeneralTagsApi.
 * @export
 * @interface GeneralTagsApiApiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGetRequest
 */
export interface GeneralTagsApiApiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGet
     */
    readonly customTagId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TagsGeneralCandidatesGetByScopePost operation in GeneralTagsApi.
 * @export
 * @interface GeneralTagsApiApiV1TagsGeneralCandidatesGetByScopePostRequest
 */
export interface GeneralTagsApiApiV1TagsGeneralCandidatesGetByScopePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralCandidatesGetByScopePost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralCandidatesGetByScopePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralTagCandidatesByScopeRequestDto}
     * @memberof GeneralTagsApiApiV1TagsGeneralCandidatesGetByScopePost
     */
    readonly generalTagCandidatesByScopeRequestDto?: GeneralTagCandidatesByScopeRequestDto
}

/**
 * Request parameters for apiV1TagsGeneralCandidatesGetPost operation in GeneralTagsApi.
 * @export
 * @interface GeneralTagsApiApiV1TagsGeneralCandidatesGetPostRequest
 */
export interface GeneralTagsApiApiV1TagsGeneralCandidatesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralCandidatesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralCandidatesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralTagCandidatesRequestDto}
     * @memberof GeneralTagsApiApiV1TagsGeneralCandidatesGetPost
     */
    readonly generalTagCandidatesRequestDto?: GeneralTagCandidatesRequestDto
}

/**
 * Request parameters for apiV1TagsGeneralForEntitiesDeleteDelete operation in GeneralTagsApi.
 * @export
 * @interface GeneralTagsApiApiV1TagsGeneralForEntitiesDeleteDeleteRequest
 */
export interface GeneralTagsApiApiV1TagsGeneralForEntitiesDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntitiesDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntitiesDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralAttachedTagsOfEntitiesDeleteDto}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntitiesDeleteDelete
     */
    readonly generalAttachedTagsOfEntitiesDeleteDto?: GeneralAttachedTagsOfEntitiesDeleteDto
}

/**
 * Request parameters for apiV1TagsGeneralForEntitiesUpdatePut operation in GeneralTagsApi.
 * @export
 * @interface GeneralTagsApiApiV1TagsGeneralForEntitiesUpdatePutRequest
 */
export interface GeneralTagsApiApiV1TagsGeneralForEntitiesUpdatePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntitiesUpdatePut
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntitiesUpdatePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralAttachedTagsOfEntitiesUpdateDto}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntitiesUpdatePut
     */
    readonly generalAttachedTagsOfEntitiesUpdateDto?: GeneralAttachedTagsOfEntitiesUpdateDto
}

/**
 * Request parameters for apiV1TagsGeneralForEntityDeleteDelete operation in GeneralTagsApi.
 * @export
 * @interface GeneralTagsApiApiV1TagsGeneralForEntityDeleteDeleteRequest
 */
export interface GeneralTagsApiApiV1TagsGeneralForEntityDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntityDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntityDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralAttachedTagsOfEntityDeleteDto}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntityDeleteDelete
     */
    readonly generalAttachedTagsOfEntityDeleteDto?: GeneralAttachedTagsOfEntityDeleteDto
}

/**
 * Request parameters for apiV1TagsGeneralForEntityGetGet operation in GeneralTagsApi.
 * @export
 * @interface GeneralTagsApiApiV1TagsGeneralForEntityGetGetRequest
 */
export interface GeneralTagsApiApiV1TagsGeneralForEntityGetGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntityGetGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntityGetGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * Entity where tag can be placed.  Must contain only values from EntityType.
     * @type {TagEntityType}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntityGetGet
     */
    readonly entityType?: TagEntityType

    /**
     * 
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntityGetGet
     */
    readonly entityId?: string
}

/**
 * Request parameters for apiV1TagsGeneralForEntityUpdatePut operation in GeneralTagsApi.
 * @export
 * @interface GeneralTagsApiApiV1TagsGeneralForEntityUpdatePutRequest
 */
export interface GeneralTagsApiApiV1TagsGeneralForEntityUpdatePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntityUpdatePut
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntityUpdatePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralAttachedTagsOfEntityUpdateDto}
     * @memberof GeneralTagsApiApiV1TagsGeneralForEntityUpdatePut
     */
    readonly generalAttachedTagsOfEntityUpdateDto?: GeneralAttachedTagsOfEntityUpdateDto
}

/**
 * GeneralTagsApi - object-oriented interface
 * @export
 * @class GeneralTagsApi
 * @extends {BaseAPI}
 */
export class GeneralTagsApi extends BaseAPI {
    /**
     * 
     * @param {GeneralTagsApiApiV1TagsGeneralByCustomTagCustomTagIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralTagsApi
     */
    public apiV1TagsGeneralByCustomTagCustomTagIdGet(requestParameters: GeneralTagsApiApiV1TagsGeneralByCustomTagCustomTagIdGetRequest, options?: RawAxiosRequestConfig) {
        return GeneralTagsApiFp(this.configuration).apiV1TagsGeneralByCustomTagCustomTagIdGet(requestParameters.nexusOpsTenant, requestParameters.customTagId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralTagsApiApiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralTagsApi
     */
    public apiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGet(requestParameters: GeneralTagsApiApiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGetRequest, options?: RawAxiosRequestConfig) {
        return GeneralTagsApiFp(this.configuration).apiV1TagsGeneralCandidatesGetByCustomTagCustomTagIdGet(requestParameters.nexusOpsTenant, requestParameters.customTagId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralTagsApiApiV1TagsGeneralCandidatesGetByScopePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralTagsApi
     */
    public apiV1TagsGeneralCandidatesGetByScopePost(requestParameters: GeneralTagsApiApiV1TagsGeneralCandidatesGetByScopePostRequest, options?: RawAxiosRequestConfig) {
        return GeneralTagsApiFp(this.configuration).apiV1TagsGeneralCandidatesGetByScopePost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalTagCandidatesByScopeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralTagsApiApiV1TagsGeneralCandidatesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralTagsApi
     */
    public apiV1TagsGeneralCandidatesGetPost(requestParameters: GeneralTagsApiApiV1TagsGeneralCandidatesGetPostRequest, options?: RawAxiosRequestConfig) {
        return GeneralTagsApiFp(this.configuration).apiV1TagsGeneralCandidatesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalTagCandidatesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralTagsApiApiV1TagsGeneralForEntitiesDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralTagsApi
     */
    public apiV1TagsGeneralForEntitiesDeleteDelete(requestParameters: GeneralTagsApiApiV1TagsGeneralForEntitiesDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return GeneralTagsApiFp(this.configuration).apiV1TagsGeneralForEntitiesDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalAttachedTagsOfEntitiesDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralTagsApiApiV1TagsGeneralForEntitiesUpdatePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralTagsApi
     */
    public apiV1TagsGeneralForEntitiesUpdatePut(requestParameters: GeneralTagsApiApiV1TagsGeneralForEntitiesUpdatePutRequest, options?: RawAxiosRequestConfig) {
        return GeneralTagsApiFp(this.configuration).apiV1TagsGeneralForEntitiesUpdatePut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalAttachedTagsOfEntitiesUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralTagsApiApiV1TagsGeneralForEntityDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralTagsApi
     */
    public apiV1TagsGeneralForEntityDeleteDelete(requestParameters: GeneralTagsApiApiV1TagsGeneralForEntityDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return GeneralTagsApiFp(this.configuration).apiV1TagsGeneralForEntityDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalAttachedTagsOfEntityDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralTagsApiApiV1TagsGeneralForEntityGetGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralTagsApi
     */
    public apiV1TagsGeneralForEntityGetGet(requestParameters: GeneralTagsApiApiV1TagsGeneralForEntityGetGetRequest, options?: RawAxiosRequestConfig) {
        return GeneralTagsApiFp(this.configuration).apiV1TagsGeneralForEntityGetGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityType, requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralTagsApiApiV1TagsGeneralForEntityUpdatePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralTagsApi
     */
    public apiV1TagsGeneralForEntityUpdatePut(requestParameters: GeneralTagsApiApiV1TagsGeneralForEntityUpdatePutRequest, options?: RawAxiosRequestConfig) {
        return GeneralTagsApiFp(this.configuration).apiV1TagsGeneralForEntityUpdatePut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalAttachedTagsOfEntityUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GlobalSearchApi - axios parameter creator
 * @export
 */
export const GlobalSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {number} [limitPerCategory] 
         * @param {string} [search] 
         * @param {GlobalSearchCategory} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SearchGlobalGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, offset?: number, limit?: number, limitPerCategory?: number, search?: string, category?: GlobalSearchCategory, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SearchGlobalGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/search/global`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (limitPerCategory !== undefined) {
                localVarQueryParameter['limitPerCategory'] = limitPerCategory;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalSearchApi - functional programming interface
 * @export
 */
export const GlobalSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlobalSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {number} [limitPerCategory] 
         * @param {string} [search] 
         * @param {GlobalSearchCategory} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SearchGlobalGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, offset?: number, limit?: number, limitPerCategory?: number, search?: string, category?: GlobalSearchCategory, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalSearchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SearchGlobalGet(nexusOpsTenant, nexusOpsAppVersion, offset, limit, limitPerCategory, search, category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlobalSearchApi.apiV1SearchGlobalGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GlobalSearchApi - factory interface
 * @export
 */
export const GlobalSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlobalSearchApiFp(configuration)
    return {
        /**
         * 
         * @param {GlobalSearchApiApiV1SearchGlobalGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SearchGlobalGet(requestParameters: GlobalSearchApiApiV1SearchGlobalGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GlobalSearchResultDto> {
            return localVarFp.apiV1SearchGlobalGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.offset, requestParameters.limit, requestParameters.limitPerCategory, requestParameters.search, requestParameters.category, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1SearchGlobalGet operation in GlobalSearchApi.
 * @export
 * @interface GlobalSearchApiApiV1SearchGlobalGetRequest
 */
export interface GlobalSearchApiApiV1SearchGlobalGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof GlobalSearchApiApiV1SearchGlobalGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GlobalSearchApiApiV1SearchGlobalGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {number}
     * @memberof GlobalSearchApiApiV1SearchGlobalGet
     */
    readonly offset?: number

    /**
     * 
     * @type {number}
     * @memberof GlobalSearchApiApiV1SearchGlobalGet
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof GlobalSearchApiApiV1SearchGlobalGet
     */
    readonly limitPerCategory?: number

    /**
     * 
     * @type {string}
     * @memberof GlobalSearchApiApiV1SearchGlobalGet
     */
    readonly search?: string

    /**
     * 
     * @type {GlobalSearchCategory}
     * @memberof GlobalSearchApiApiV1SearchGlobalGet
     */
    readonly category?: GlobalSearchCategory
}

/**
 * GlobalSearchApi - object-oriented interface
 * @export
 * @class GlobalSearchApi
 * @extends {BaseAPI}
 */
export class GlobalSearchApi extends BaseAPI {
    /**
     * 
     * @param {GlobalSearchApiApiV1SearchGlobalGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalSearchApi
     */
    public apiV1SearchGlobalGet(requestParameters: GlobalSearchApiApiV1SearchGlobalGetRequest, options?: RawAxiosRequestConfig) {
        return GlobalSearchApiFp(this.configuration).apiV1SearchGlobalGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.offset, requestParameters.limit, requestParameters.limitPerCategory, requestParameters.search, requestParameters.category, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GuidanceNuclinoAdminApi - axios parameter creator
 * @export
 */
export const GuidanceNuclinoAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [itemId] 
         * @param {string} [itemUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceNuclinoItemsContentGet: async (nexusOpsAppVersion?: string, itemId?: string, itemUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/guidance/nuclino/items/content`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (itemId !== undefined) {
                localVarQueryParameter['itemId'] = itemId;
            }

            if (itemUrl !== undefined) {
                localVarQueryParameter['itemUrl'] = itemUrl;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GuidanceNuclinoAdminApi - functional programming interface
 * @export
 */
export const GuidanceNuclinoAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GuidanceNuclinoAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [itemId] 
         * @param {string} [itemUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminGuidanceNuclinoItemsContentGet(nexusOpsAppVersion?: string, itemId?: string, itemUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingStepDefinitionContentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminGuidanceNuclinoItemsContentGet(nexusOpsAppVersion, itemId, itemUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GuidanceNuclinoAdminApi.apiV1AdminGuidanceNuclinoItemsContentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GuidanceNuclinoAdminApi - factory interface
 * @export
 */
export const GuidanceNuclinoAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GuidanceNuclinoAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {GuidanceNuclinoAdminApiApiV1AdminGuidanceNuclinoItemsContentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceNuclinoItemsContentGet(requestParameters: GuidanceNuclinoAdminApiApiV1AdminGuidanceNuclinoItemsContentGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingStepDefinitionContentDto> {
            return localVarFp.apiV1AdminGuidanceNuclinoItemsContentGet(requestParameters.nexusOpsAppVersion, requestParameters.itemId, requestParameters.itemUrl, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminGuidanceNuclinoItemsContentGet operation in GuidanceNuclinoAdminApi.
 * @export
 * @interface GuidanceNuclinoAdminApiApiV1AdminGuidanceNuclinoItemsContentGetRequest
 */
export interface GuidanceNuclinoAdminApiApiV1AdminGuidanceNuclinoItemsContentGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof GuidanceNuclinoAdminApiApiV1AdminGuidanceNuclinoItemsContentGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof GuidanceNuclinoAdminApiApiV1AdminGuidanceNuclinoItemsContentGet
     */
    readonly itemId?: string

    /**
     * 
     * @type {string}
     * @memberof GuidanceNuclinoAdminApiApiV1AdminGuidanceNuclinoItemsContentGet
     */
    readonly itemUrl?: string
}

/**
 * GuidanceNuclinoAdminApi - object-oriented interface
 * @export
 * @class GuidanceNuclinoAdminApi
 * @extends {BaseAPI}
 */
export class GuidanceNuclinoAdminApi extends BaseAPI {
    /**
     * 
     * @param {GuidanceNuclinoAdminApiApiV1AdminGuidanceNuclinoItemsContentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuidanceNuclinoAdminApi
     */
    public apiV1AdminGuidanceNuclinoItemsContentGet(requestParameters: GuidanceNuclinoAdminApiApiV1AdminGuidanceNuclinoItemsContentGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GuidanceNuclinoAdminApiFp(this.configuration).apiV1AdminGuidanceNuclinoItemsContentGet(requestParameters.nexusOpsAppVersion, requestParameters.itemId, requestParameters.itemUrl, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IntegrationApiClientsApi - axios parameter creator
 * @export
 */
export const IntegrationApiClientsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {IntegrationApiClientGetPaginatedDto} [integrationApiClientGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, integrationApiClientGetPaginatedDto?: IntegrationApiClientGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/integration/api-clients/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(integrationApiClientGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsIntegrationApiClientIdDelete: async (nexusOpsTenant: string, integrationApiClientId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'integrationApiClientId' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdDelete', 'integrationApiClientId', integrationApiClientId)
            const localVarPath = `/api/v1/integration/api-clients/{integrationApiClientId}`
                .replace(`{${"integrationApiClientId"}}`, encodeURIComponent(String(integrationApiClientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsIntegrationApiClientIdGet: async (nexusOpsTenant: string, integrationApiClientId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'integrationApiClientId' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdGet', 'integrationApiClientId', integrationApiClientId)
            const localVarPath = `/api/v1/integration/api-clients/{integrationApiClientId}`
                .replace(`{${"integrationApiClientId"}}`, encodeURIComponent(String(integrationApiClientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} integrationApiClientId 
         * @param {string} keyId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {IntegrationApiClientKeyInputDto} [integrationApiClientKeyInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut: async (nexusOpsTenant: string, integrationApiClientId: string, keyId: string, nexusOpsAppVersion?: string, integrationApiClientKeyInputDto?: IntegrationApiClientKeyInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'integrationApiClientId' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut', 'integrationApiClientId', integrationApiClientId)
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut', 'keyId', keyId)
            const localVarPath = `/api/v1/integration/api-clients/{integrationApiClientId}/keys/{keyId}`
                .replace(`{${"integrationApiClientId"}}`, encodeURIComponent(String(integrationApiClientId)))
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(integrationApiClientKeyInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} integrationApiClientId 
         * @param {string} keyId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost: async (nexusOpsTenant: string, integrationApiClientId: string, keyId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'integrationApiClientId' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost', 'integrationApiClientId', integrationApiClientId)
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost', 'keyId', keyId)
            const localVarPath = `/api/v1/integration/api-clients/{integrationApiClientId}/keys/{keyId}/revoke`
                .replace(`{${"integrationApiClientId"}}`, encodeURIComponent(String(integrationApiClientId)))
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} integrationApiClientId 
         * @param {string} keyId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet: async (nexusOpsTenant: string, integrationApiClientId: string, keyId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'integrationApiClientId' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet', 'integrationApiClientId', integrationApiClientId)
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet', 'keyId', keyId)
            const localVarPath = `/api/v1/integration/api-clients/{integrationApiClientId}/keys/{keyId}/value`
                .replace(`{${"integrationApiClientId"}}`, encodeURIComponent(String(integrationApiClientId)))
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {IntegrationApiClientKeyInputDto} [integrationApiClientKeyInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsIntegrationApiClientIdKeysPost: async (nexusOpsTenant: string, integrationApiClientId: string, nexusOpsAppVersion?: string, integrationApiClientKeyInputDto?: IntegrationApiClientKeyInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdKeysPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'integrationApiClientId' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdKeysPost', 'integrationApiClientId', integrationApiClientId)
            const localVarPath = `/api/v1/integration/api-clients/{integrationApiClientId}/keys`
                .replace(`{${"integrationApiClientId"}}`, encodeURIComponent(String(integrationApiClientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(integrationApiClientKeyInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {IntegrationApiClientUpdateDto} [integrationApiClientUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsIntegrationApiClientIdPut: async (nexusOpsTenant: string, integrationApiClientId: string, nexusOpsAppVersion?: string, integrationApiClientUpdateDto?: IntegrationApiClientUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'integrationApiClientId' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsIntegrationApiClientIdPut', 'integrationApiClientId', integrationApiClientId)
            const localVarPath = `/api/v1/integration/api-clients/{integrationApiClientId}`
                .replace(`{${"integrationApiClientId"}}`, encodeURIComponent(String(integrationApiClientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(integrationApiClientUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {IntegrationApiClientCreateDto} [integrationApiClientCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, integrationApiClientCreateDto?: IntegrationApiClientCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/integration/api-clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(integrationApiClientCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {IntegrationApiClientSearchPaginatedDto} [integrationApiClientSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsSearchPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, integrationApiClientSearchPaginatedDto?: IntegrationApiClientSearchPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1IntegrationApiClientsSearchPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/integration/api-clients/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(integrationApiClientSearchPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationApiClientsApi - functional programming interface
 * @export
 */
export const IntegrationApiClientsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationApiClientsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {IntegrationApiClientGetPaginatedDto} [integrationApiClientGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1IntegrationApiClientsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, integrationApiClientGetPaginatedDto?: IntegrationApiClientGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfIntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IntegrationApiClientsGetPost(nexusOpsTenant, nexusOpsAppVersion, integrationApiClientGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsApi.apiV1IntegrationApiClientsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1IntegrationApiClientsIntegrationApiClientIdDelete(nexusOpsTenant: string, integrationApiClientId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IntegrationApiClientsIntegrationApiClientIdDelete(nexusOpsTenant, integrationApiClientId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsApi.apiV1IntegrationApiClientsIntegrationApiClientIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1IntegrationApiClientsIntegrationApiClientIdGet(nexusOpsTenant: string, integrationApiClientId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IntegrationApiClientsIntegrationApiClientIdGet(nexusOpsTenant, integrationApiClientId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsApi.apiV1IntegrationApiClientsIntegrationApiClientIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} integrationApiClientId 
         * @param {string} keyId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {IntegrationApiClientKeyInputDto} [integrationApiClientKeyInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut(nexusOpsTenant: string, integrationApiClientId: string, keyId: string, nexusOpsAppVersion?: string, integrationApiClientKeyInputDto?: IntegrationApiClientKeyInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut(nexusOpsTenant, integrationApiClientId, keyId, nexusOpsAppVersion, integrationApiClientKeyInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsApi.apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} integrationApiClientId 
         * @param {string} keyId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost(nexusOpsTenant: string, integrationApiClientId: string, keyId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost(nexusOpsTenant, integrationApiClientId, keyId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsApi.apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} integrationApiClientId 
         * @param {string} keyId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet(nexusOpsTenant: string, integrationApiClientId: string, keyId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationApiClientKeyValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet(nexusOpsTenant, integrationApiClientId, keyId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsApi.apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {IntegrationApiClientKeyInputDto} [integrationApiClientKeyInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1IntegrationApiClientsIntegrationApiClientIdKeysPost(nexusOpsTenant: string, integrationApiClientId: string, nexusOpsAppVersion?: string, integrationApiClientKeyInputDto?: IntegrationApiClientKeyInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IntegrationApiClientsIntegrationApiClientIdKeysPost(nexusOpsTenant, integrationApiClientId, nexusOpsAppVersion, integrationApiClientKeyInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsApi.apiV1IntegrationApiClientsIntegrationApiClientIdKeysPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {IntegrationApiClientUpdateDto} [integrationApiClientUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1IntegrationApiClientsIntegrationApiClientIdPut(nexusOpsTenant: string, integrationApiClientId: string, nexusOpsAppVersion?: string, integrationApiClientUpdateDto?: IntegrationApiClientUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IntegrationApiClientsIntegrationApiClientIdPut(nexusOpsTenant, integrationApiClientId, nexusOpsAppVersion, integrationApiClientUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsApi.apiV1IntegrationApiClientsIntegrationApiClientIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {IntegrationApiClientCreateDto} [integrationApiClientCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1IntegrationApiClientsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, integrationApiClientCreateDto?: IntegrationApiClientCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IntegrationApiClientsPost(nexusOpsTenant, nexusOpsAppVersion, integrationApiClientCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsApi.apiV1IntegrationApiClientsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {IntegrationApiClientSearchPaginatedDto} [integrationApiClientSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1IntegrationApiClientsSearchPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, integrationApiClientSearchPaginatedDto?: IntegrationApiClientSearchPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfIntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IntegrationApiClientsSearchPost(nexusOpsTenant, nexusOpsAppVersion, integrationApiClientSearchPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsApi.apiV1IntegrationApiClientsSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IntegrationApiClientsApi - factory interface
 * @export
 */
export const IntegrationApiClientsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationApiClientsApiFp(configuration)
    return {
        /**
         * 
         * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsGetPost(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfIntegrationApiClientDto> {
            return localVarFp.apiV1IntegrationApiClientsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.integrationApiClientGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsIntegrationApiClientIdDelete(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1IntegrationApiClientsIntegrationApiClientIdDelete(requestParameters.nexusOpsTenant, requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsIntegrationApiClientIdGet(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationApiClientDto> {
            return localVarFp.apiV1IntegrationApiClientsIntegrationApiClientIdGet(requestParameters.nexusOpsTenant, requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationApiClientDto> {
            return localVarFp.apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut(requestParameters.nexusOpsTenant, requestParameters.integrationApiClientId, requestParameters.keyId, requestParameters.nexusOpsAppVersion, requestParameters.integrationApiClientKeyInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationApiClientDto> {
            return localVarFp.apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost(requestParameters.nexusOpsTenant, requestParameters.integrationApiClientId, requestParameters.keyId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationApiClientKeyValueDto> {
            return localVarFp.apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet(requestParameters.nexusOpsTenant, requestParameters.integrationApiClientId, requestParameters.keyId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsIntegrationApiClientIdKeysPost(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationApiClientDto> {
            return localVarFp.apiV1IntegrationApiClientsIntegrationApiClientIdKeysPost(requestParameters.nexusOpsTenant, requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, requestParameters.integrationApiClientKeyInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsIntegrationApiClientIdPut(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationApiClientDto> {
            return localVarFp.apiV1IntegrationApiClientsIntegrationApiClientIdPut(requestParameters.nexusOpsTenant, requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, requestParameters.integrationApiClientUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsPost(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationApiClientDto> {
            return localVarFp.apiV1IntegrationApiClientsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.integrationApiClientCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationApiClientsSearchPost(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsSearchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfIntegrationApiClientDto> {
            return localVarFp.apiV1IntegrationApiClientsSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.integrationApiClientSearchPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1IntegrationApiClientsGetPost operation in IntegrationApiClientsApi.
 * @export
 * @interface IntegrationApiClientsApiApiV1IntegrationApiClientsGetPostRequest
 */
export interface IntegrationApiClientsApiApiV1IntegrationApiClientsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {IntegrationApiClientGetPaginatedDto}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsGetPost
     */
    readonly integrationApiClientGetPaginatedDto?: IntegrationApiClientGetPaginatedDto
}

/**
 * Request parameters for apiV1IntegrationApiClientsIntegrationApiClientIdDelete operation in IntegrationApiClientsApi.
 * @export
 * @interface IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdDeleteRequest
 */
export interface IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdDelete
     */
    readonly integrationApiClientId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1IntegrationApiClientsIntegrationApiClientIdGet operation in IntegrationApiClientsApi.
 * @export
 * @interface IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdGetRequest
 */
export interface IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdGet
     */
    readonly integrationApiClientId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut operation in IntegrationApiClientsApi.
 * @export
 * @interface IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPutRequest
 */
export interface IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut
     */
    readonly integrationApiClientId: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut
     */
    readonly keyId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {IntegrationApiClientKeyInputDto}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut
     */
    readonly integrationApiClientKeyInputDto?: IntegrationApiClientKeyInputDto
}

/**
 * Request parameters for apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost operation in IntegrationApiClientsApi.
 * @export
 * @interface IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePostRequest
 */
export interface IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost
     */
    readonly integrationApiClientId: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost
     */
    readonly keyId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet operation in IntegrationApiClientsApi.
 * @export
 * @interface IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGetRequest
 */
export interface IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet
     */
    readonly integrationApiClientId: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet
     */
    readonly keyId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1IntegrationApiClientsIntegrationApiClientIdKeysPost operation in IntegrationApiClientsApi.
 * @export
 * @interface IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysPostRequest
 */
export interface IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysPost
     */
    readonly integrationApiClientId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {IntegrationApiClientKeyInputDto}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysPost
     */
    readonly integrationApiClientKeyInputDto?: IntegrationApiClientKeyInputDto
}

/**
 * Request parameters for apiV1IntegrationApiClientsIntegrationApiClientIdPut operation in IntegrationApiClientsApi.
 * @export
 * @interface IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdPutRequest
 */
export interface IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdPut
     */
    readonly integrationApiClientId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {IntegrationApiClientUpdateDto}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdPut
     */
    readonly integrationApiClientUpdateDto?: IntegrationApiClientUpdateDto
}

/**
 * Request parameters for apiV1IntegrationApiClientsPost operation in IntegrationApiClientsApi.
 * @export
 * @interface IntegrationApiClientsApiApiV1IntegrationApiClientsPostRequest
 */
export interface IntegrationApiClientsApiApiV1IntegrationApiClientsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {IntegrationApiClientCreateDto}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsPost
     */
    readonly integrationApiClientCreateDto?: IntegrationApiClientCreateDto
}

/**
 * Request parameters for apiV1IntegrationApiClientsSearchPost operation in IntegrationApiClientsApi.
 * @export
 * @interface IntegrationApiClientsApiApiV1IntegrationApiClientsSearchPostRequest
 */
export interface IntegrationApiClientsApiApiV1IntegrationApiClientsSearchPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsSearchPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsSearchPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {IntegrationApiClientSearchPaginatedDto}
     * @memberof IntegrationApiClientsApiApiV1IntegrationApiClientsSearchPost
     */
    readonly integrationApiClientSearchPaginatedDto?: IntegrationApiClientSearchPaginatedDto
}

/**
 * IntegrationApiClientsApi - object-oriented interface
 * @export
 * @class IntegrationApiClientsApi
 * @extends {BaseAPI}
 */
export class IntegrationApiClientsApi extends BaseAPI {
    /**
     * 
     * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsApi
     */
    public apiV1IntegrationApiClientsGetPost(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsGetPostRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsApiFp(this.configuration).apiV1IntegrationApiClientsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.integrationApiClientGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsApi
     */
    public apiV1IntegrationApiClientsIntegrationApiClientIdDelete(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsApiFp(this.configuration).apiV1IntegrationApiClientsIntegrationApiClientIdDelete(requestParameters.nexusOpsTenant, requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsApi
     */
    public apiV1IntegrationApiClientsIntegrationApiClientIdGet(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdGetRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsApiFp(this.configuration).apiV1IntegrationApiClientsIntegrationApiClientIdGet(requestParameters.nexusOpsTenant, requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsApi
     */
    public apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPutRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsApiFp(this.configuration).apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut(requestParameters.nexusOpsTenant, requestParameters.integrationApiClientId, requestParameters.keyId, requestParameters.nexusOpsAppVersion, requestParameters.integrationApiClientKeyInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsApi
     */
    public apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePostRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsApiFp(this.configuration).apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost(requestParameters.nexusOpsTenant, requestParameters.integrationApiClientId, requestParameters.keyId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsApi
     */
    public apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGetRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsApiFp(this.configuration).apiV1IntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet(requestParameters.nexusOpsTenant, requestParameters.integrationApiClientId, requestParameters.keyId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsApi
     */
    public apiV1IntegrationApiClientsIntegrationApiClientIdKeysPost(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdKeysPostRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsApiFp(this.configuration).apiV1IntegrationApiClientsIntegrationApiClientIdKeysPost(requestParameters.nexusOpsTenant, requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, requestParameters.integrationApiClientKeyInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsApi
     */
    public apiV1IntegrationApiClientsIntegrationApiClientIdPut(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsIntegrationApiClientIdPutRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsApiFp(this.configuration).apiV1IntegrationApiClientsIntegrationApiClientIdPut(requestParameters.nexusOpsTenant, requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, requestParameters.integrationApiClientUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsApi
     */
    public apiV1IntegrationApiClientsPost(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsPostRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsApiFp(this.configuration).apiV1IntegrationApiClientsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.integrationApiClientCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsApiApiV1IntegrationApiClientsSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsApi
     */
    public apiV1IntegrationApiClientsSearchPost(requestParameters: IntegrationApiClientsApiApiV1IntegrationApiClientsSearchPostRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsApiFp(this.configuration).apiV1IntegrationApiClientsSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.integrationApiClientSearchPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IntegrationApiClientsAdminApi - axios parameter creator
 * @export
 */
export const IntegrationApiClientsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminIntegrationApiClientGetPaginatedDto} [adminIntegrationApiClientGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsGetPost: async (nexusOpsAppVersion?: string, adminIntegrationApiClientGetPaginatedDto?: AdminIntegrationApiClientGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/integration/api-clients/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminIntegrationApiClientGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsIntegrationApiClientIdDelete: async (integrationApiClientId: string, nexusOpsAppVersion?: string, tenantId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integrationApiClientId' is not null or undefined
            assertParamExists('apiV1AdminIntegrationApiClientsIntegrationApiClientIdDelete', 'integrationApiClientId', integrationApiClientId)
            const localVarPath = `/api/v1/admin/integration/api-clients/{integrationApiClientId}`
                .replace(`{${"integrationApiClientId"}}`, encodeURIComponent(String(integrationApiClientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsIntegrationApiClientIdGet: async (integrationApiClientId: string, nexusOpsAppVersion?: string, tenantId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integrationApiClientId' is not null or undefined
            assertParamExists('apiV1AdminIntegrationApiClientsIntegrationApiClientIdGet', 'integrationApiClientId', integrationApiClientId)
            const localVarPath = `/api/v1/admin/integration/api-clients/{integrationApiClientId}`
                .replace(`{${"integrationApiClientId"}}`, encodeURIComponent(String(integrationApiClientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} integrationApiClientId 
         * @param {string} keyId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {IntegrationApiClientKeyInputDto} [integrationApiClientKeyInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut: async (integrationApiClientId: string, keyId: string, nexusOpsAppVersion?: string, tenantId?: string, integrationApiClientKeyInputDto?: IntegrationApiClientKeyInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integrationApiClientId' is not null or undefined
            assertParamExists('apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut', 'integrationApiClientId', integrationApiClientId)
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut', 'keyId', keyId)
            const localVarPath = `/api/v1/admin/integration/api-clients/{integrationApiClientId}/keys/{keyId}`
                .replace(`{${"integrationApiClientId"}}`, encodeURIComponent(String(integrationApiClientId)))
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(integrationApiClientKeyInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} integrationApiClientId 
         * @param {string} keyId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost: async (integrationApiClientId: string, keyId: string, nexusOpsAppVersion?: string, tenantId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integrationApiClientId' is not null or undefined
            assertParamExists('apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost', 'integrationApiClientId', integrationApiClientId)
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost', 'keyId', keyId)
            const localVarPath = `/api/v1/admin/integration/api-clients/{integrationApiClientId}/keys/{keyId}/revoke`
                .replace(`{${"integrationApiClientId"}}`, encodeURIComponent(String(integrationApiClientId)))
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} integrationApiClientId 
         * @param {string} keyId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet: async (integrationApiClientId: string, keyId: string, nexusOpsAppVersion?: string, tenantId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integrationApiClientId' is not null or undefined
            assertParamExists('apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet', 'integrationApiClientId', integrationApiClientId)
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet', 'keyId', keyId)
            const localVarPath = `/api/v1/admin/integration/api-clients/{integrationApiClientId}/keys/{keyId}/value`
                .replace(`{${"integrationApiClientId"}}`, encodeURIComponent(String(integrationApiClientId)))
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {IntegrationApiClientKeyInputDto} [integrationApiClientKeyInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPost: async (integrationApiClientId: string, nexusOpsAppVersion?: string, tenantId?: string, integrationApiClientKeyInputDto?: IntegrationApiClientKeyInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integrationApiClientId' is not null or undefined
            assertParamExists('apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPost', 'integrationApiClientId', integrationApiClientId)
            const localVarPath = `/api/v1/admin/integration/api-clients/{integrationApiClientId}/keys`
                .replace(`{${"integrationApiClientId"}}`, encodeURIComponent(String(integrationApiClientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(integrationApiClientKeyInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {IntegrationApiClientUpdateDto} [integrationApiClientUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsIntegrationApiClientIdPut: async (integrationApiClientId: string, nexusOpsAppVersion?: string, tenantId?: string, integrationApiClientUpdateDto?: IntegrationApiClientUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integrationApiClientId' is not null or undefined
            assertParamExists('apiV1AdminIntegrationApiClientsIntegrationApiClientIdPut', 'integrationApiClientId', integrationApiClientId)
            const localVarPath = `/api/v1/admin/integration/api-clients/{integrationApiClientId}`
                .replace(`{${"integrationApiClientId"}}`, encodeURIComponent(String(integrationApiClientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(integrationApiClientUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {IntegrationApiClientCreateDto} [integrationApiClientCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsPost: async (nexusOpsAppVersion?: string, tenantId?: string, integrationApiClientCreateDto?: IntegrationApiClientCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/integration/api-clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(integrationApiClientCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationApiClientsAdminApi - functional programming interface
 * @export
 */
export const IntegrationApiClientsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationApiClientsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminIntegrationApiClientGetPaginatedDto} [adminIntegrationApiClientGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminIntegrationApiClientsGetPost(nexusOpsAppVersion?: string, adminIntegrationApiClientGetPaginatedDto?: AdminIntegrationApiClientGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfIntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminIntegrationApiClientsGetPost(nexusOpsAppVersion, adminIntegrationApiClientGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsAdminApi.apiV1AdminIntegrationApiClientsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminIntegrationApiClientsIntegrationApiClientIdDelete(integrationApiClientId: string, nexusOpsAppVersion?: string, tenantId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminIntegrationApiClientsIntegrationApiClientIdDelete(integrationApiClientId, nexusOpsAppVersion, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsAdminApi.apiV1AdminIntegrationApiClientsIntegrationApiClientIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminIntegrationApiClientsIntegrationApiClientIdGet(integrationApiClientId: string, nexusOpsAppVersion?: string, tenantId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminIntegrationApiClientsIntegrationApiClientIdGet(integrationApiClientId, nexusOpsAppVersion, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsAdminApi.apiV1AdminIntegrationApiClientsIntegrationApiClientIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} integrationApiClientId 
         * @param {string} keyId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {IntegrationApiClientKeyInputDto} [integrationApiClientKeyInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut(integrationApiClientId: string, keyId: string, nexusOpsAppVersion?: string, tenantId?: string, integrationApiClientKeyInputDto?: IntegrationApiClientKeyInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut(integrationApiClientId, keyId, nexusOpsAppVersion, tenantId, integrationApiClientKeyInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsAdminApi.apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} integrationApiClientId 
         * @param {string} keyId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost(integrationApiClientId: string, keyId: string, nexusOpsAppVersion?: string, tenantId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost(integrationApiClientId, keyId, nexusOpsAppVersion, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsAdminApi.apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} integrationApiClientId 
         * @param {string} keyId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet(integrationApiClientId: string, keyId: string, nexusOpsAppVersion?: string, tenantId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationApiClientKeyValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet(integrationApiClientId, keyId, nexusOpsAppVersion, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsAdminApi.apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {IntegrationApiClientKeyInputDto} [integrationApiClientKeyInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPost(integrationApiClientId: string, nexusOpsAppVersion?: string, tenantId?: string, integrationApiClientKeyInputDto?: IntegrationApiClientKeyInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPost(integrationApiClientId, nexusOpsAppVersion, tenantId, integrationApiClientKeyInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsAdminApi.apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} integrationApiClientId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {IntegrationApiClientUpdateDto} [integrationApiClientUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminIntegrationApiClientsIntegrationApiClientIdPut(integrationApiClientId: string, nexusOpsAppVersion?: string, tenantId?: string, integrationApiClientUpdateDto?: IntegrationApiClientUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminIntegrationApiClientsIntegrationApiClientIdPut(integrationApiClientId, nexusOpsAppVersion, tenantId, integrationApiClientUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsAdminApi.apiV1AdminIntegrationApiClientsIntegrationApiClientIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {IntegrationApiClientCreateDto} [integrationApiClientCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminIntegrationApiClientsPost(nexusOpsAppVersion?: string, tenantId?: string, integrationApiClientCreateDto?: IntegrationApiClientCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminIntegrationApiClientsPost(nexusOpsAppVersion, tenantId, integrationApiClientCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApiClientsAdminApi.apiV1AdminIntegrationApiClientsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IntegrationApiClientsAdminApi - factory interface
 * @export
 */
export const IntegrationApiClientsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationApiClientsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsGetPost(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfIntegrationApiClientDto> {
            return localVarFp.apiV1AdminIntegrationApiClientsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminIntegrationApiClientGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsIntegrationApiClientIdDelete(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminIntegrationApiClientsIntegrationApiClientIdDelete(requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsIntegrationApiClientIdGet(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationApiClientDto> {
            return localVarFp.apiV1AdminIntegrationApiClientsIntegrationApiClientIdGet(requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationApiClientDto> {
            return localVarFp.apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut(requestParameters.integrationApiClientId, requestParameters.keyId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.integrationApiClientKeyInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationApiClientDto> {
            return localVarFp.apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost(requestParameters.integrationApiClientId, requestParameters.keyId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationApiClientKeyValueDto> {
            return localVarFp.apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet(requestParameters.integrationApiClientId, requestParameters.keyId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPost(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationApiClientDto> {
            return localVarFp.apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPost(requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.integrationApiClientKeyInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsIntegrationApiClientIdPut(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationApiClientDto> {
            return localVarFp.apiV1AdminIntegrationApiClientsIntegrationApiClientIdPut(requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.integrationApiClientUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminIntegrationApiClientsPost(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationApiClientDto> {
            return localVarFp.apiV1AdminIntegrationApiClientsPost(requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.integrationApiClientCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminIntegrationApiClientsGetPost operation in IntegrationApiClientsAdminApi.
 * @export
 * @interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsGetPostRequest
 */
export interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminIntegrationApiClientGetPaginatedDto}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsGetPost
     */
    readonly adminIntegrationApiClientGetPaginatedDto?: AdminIntegrationApiClientGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminIntegrationApiClientsIntegrationApiClientIdDelete operation in IntegrationApiClientsAdminApi.
 * @export
 * @interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdDeleteRequest
 */
export interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdDelete
     */
    readonly integrationApiClientId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdDelete
     */
    readonly tenantId?: string
}

/**
 * Request parameters for apiV1AdminIntegrationApiClientsIntegrationApiClientIdGet operation in IntegrationApiClientsAdminApi.
 * @export
 * @interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdGetRequest
 */
export interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdGet
     */
    readonly integrationApiClientId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdGet
     */
    readonly tenantId?: string
}

/**
 * Request parameters for apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut operation in IntegrationApiClientsAdminApi.
 * @export
 * @interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPutRequest
 */
export interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut
     */
    readonly integrationApiClientId: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut
     */
    readonly keyId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut
     */
    readonly tenantId?: string

    /**
     * 
     * @type {IntegrationApiClientKeyInputDto}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut
     */
    readonly integrationApiClientKeyInputDto?: IntegrationApiClientKeyInputDto
}

/**
 * Request parameters for apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost operation in IntegrationApiClientsAdminApi.
 * @export
 * @interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePostRequest
 */
export interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePostRequest {
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost
     */
    readonly integrationApiClientId: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost
     */
    readonly keyId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost
     */
    readonly tenantId?: string
}

/**
 * Request parameters for apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet operation in IntegrationApiClientsAdminApi.
 * @export
 * @interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGetRequest
 */
export interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGetRequest {
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet
     */
    readonly integrationApiClientId: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet
     */
    readonly keyId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet
     */
    readonly tenantId?: string
}

/**
 * Request parameters for apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPost operation in IntegrationApiClientsAdminApi.
 * @export
 * @interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPostRequest
 */
export interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPostRequest {
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPost
     */
    readonly integrationApiClientId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPost
     */
    readonly tenantId?: string

    /**
     * 
     * @type {IntegrationApiClientKeyInputDto}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPost
     */
    readonly integrationApiClientKeyInputDto?: IntegrationApiClientKeyInputDto
}

/**
 * Request parameters for apiV1AdminIntegrationApiClientsIntegrationApiClientIdPut operation in IntegrationApiClientsAdminApi.
 * @export
 * @interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdPutRequest
 */
export interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdPut
     */
    readonly integrationApiClientId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdPut
     */
    readonly tenantId?: string

    /**
     * 
     * @type {IntegrationApiClientUpdateDto}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdPut
     */
    readonly integrationApiClientUpdateDto?: IntegrationApiClientUpdateDto
}

/**
 * Request parameters for apiV1AdminIntegrationApiClientsPost operation in IntegrationApiClientsAdminApi.
 * @export
 * @interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsPostRequest
 */
export interface IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsPost
     */
    readonly tenantId?: string

    /**
     * 
     * @type {IntegrationApiClientCreateDto}
     * @memberof IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsPost
     */
    readonly integrationApiClientCreateDto?: IntegrationApiClientCreateDto
}

/**
 * IntegrationApiClientsAdminApi - object-oriented interface
 * @export
 * @class IntegrationApiClientsAdminApi
 * @extends {BaseAPI}
 */
export class IntegrationApiClientsAdminApi extends BaseAPI {
    /**
     * 
     * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsAdminApi
     */
    public apiV1AdminIntegrationApiClientsGetPost(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsAdminApiFp(this.configuration).apiV1AdminIntegrationApiClientsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminIntegrationApiClientGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsAdminApi
     */
    public apiV1AdminIntegrationApiClientsIntegrationApiClientIdDelete(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsAdminApiFp(this.configuration).apiV1AdminIntegrationApiClientsIntegrationApiClientIdDelete(requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsAdminApi
     */
    public apiV1AdminIntegrationApiClientsIntegrationApiClientIdGet(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdGetRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsAdminApiFp(this.configuration).apiV1AdminIntegrationApiClientsIntegrationApiClientIdGet(requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsAdminApi
     */
    public apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPutRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsAdminApiFp(this.configuration).apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdPut(requestParameters.integrationApiClientId, requestParameters.keyId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.integrationApiClientKeyInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsAdminApi
     */
    public apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePostRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsAdminApiFp(this.configuration).apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdRevokePost(requestParameters.integrationApiClientId, requestParameters.keyId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsAdminApi
     */
    public apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGetRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsAdminApiFp(this.configuration).apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysKeyIdValueGet(requestParameters.integrationApiClientId, requestParameters.keyId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsAdminApi
     */
    public apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPost(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPostRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsAdminApiFp(this.configuration).apiV1AdminIntegrationApiClientsIntegrationApiClientIdKeysPost(requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.integrationApiClientKeyInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsAdminApi
     */
    public apiV1AdminIntegrationApiClientsIntegrationApiClientIdPut(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsIntegrationApiClientIdPutRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsAdminApiFp(this.configuration).apiV1AdminIntegrationApiClientsIntegrationApiClientIdPut(requestParameters.integrationApiClientId, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.integrationApiClientUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiClientsAdminApi
     */
    public apiV1AdminIntegrationApiClientsPost(requestParameters: IntegrationApiClientsAdminApiApiV1AdminIntegrationApiClientsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return IntegrationApiClientsAdminApiFp(this.configuration).apiV1AdminIntegrationApiClientsPost(requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.integrationApiClientCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvitesApi - axios parameter creator
 * @export
 */
export const InvitesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvitesInviteIdAcceptPost: async (inviteId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('apiV1InvitesInviteIdAcceptPost', 'inviteId', inviteId)
            const localVarPath = `/api/v1/invites/{inviteId}/accept`
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvitesInviteIdAnonymouslyGet: async (inviteId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('apiV1InvitesInviteIdAnonymouslyGet', 'inviteId', inviteId)
            const localVarPath = `/api/v1/invites/{inviteId}/anonymously`
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RegisterInvitedUserDto} [registerInvitedUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvitesInviteIdRegisterPost: async (inviteId: string, nexusOpsAppVersion?: string, registerInvitedUserDto?: RegisterInvitedUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('apiV1InvitesInviteIdRegisterPost', 'inviteId', inviteId)
            const localVarPath = `/api/v1/invites/{inviteId}/register`
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerInvitedUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvitesInviteIdRejectPost: async (inviteId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('apiV1InvitesInviteIdRejectPost', 'inviteId', inviteId)
            const localVarPath = `/api/v1/invites/{inviteId}/reject`
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvitesMyGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/invites/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvitesMyInviteIdGet: async (inviteId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('apiV1InvitesMyInviteIdGet', 'inviteId', inviteId)
            const localVarPath = `/api/v1/invites/my/{inviteId}`
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {InviteCheckUserExistsDto} [inviteCheckUserExistsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvitesUserExistsAnonymouslyPost: async (nexusOpsAppVersion?: string, inviteCheckUserExistsDto?: InviteCheckUserExistsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/invites/user-exists/anonymously`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteCheckUserExistsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvitesApi - functional programming interface
 * @export
 */
export const InvitesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvitesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvitesInviteIdAcceptPost(inviteId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InvitesInviteIdAcceptPost(inviteId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.apiV1InvitesInviteIdAcceptPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvitesInviteIdAnonymouslyGet(inviteId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InvitesInviteIdAnonymouslyGet(inviteId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.apiV1InvitesInviteIdAnonymouslyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RegisterInvitedUserDto} [registerInvitedUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvitesInviteIdRegisterPost(inviteId: string, nexusOpsAppVersion?: string, registerInvitedUserDto?: RegisterInvitedUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InvitesInviteIdRegisterPost(inviteId, nexusOpsAppVersion, registerInvitedUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.apiV1InvitesInviteIdRegisterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvitesInviteIdRejectPost(inviteId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InvitesInviteIdRejectPost(inviteId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.apiV1InvitesInviteIdRejectPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvitesMyGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InviteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InvitesMyGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.apiV1InvitesMyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvitesMyInviteIdGet(inviteId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InvitesMyInviteIdGet(inviteId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.apiV1InvitesMyInviteIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {InviteCheckUserExistsDto} [inviteCheckUserExistsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvitesUserExistsAnonymouslyPost(nexusOpsAppVersion?: string, inviteCheckUserExistsDto?: InviteCheckUserExistsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteUserExistsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InvitesUserExistsAnonymouslyPost(nexusOpsAppVersion, inviteCheckUserExistsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.apiV1InvitesUserExistsAnonymouslyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvitesApi - factory interface
 * @export
 */
export const InvitesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvitesApiFp(configuration)
    return {
        /**
         * 
         * @param {InvitesApiApiV1InvitesInviteIdAcceptPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvitesInviteIdAcceptPost(requestParameters: InvitesApiApiV1InvitesInviteIdAcceptPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1InvitesInviteIdAcceptPost(requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvitesApiApiV1InvitesInviteIdAnonymouslyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvitesInviteIdAnonymouslyGet(requestParameters: InvitesApiApiV1InvitesInviteIdAnonymouslyGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<InviteDto> {
            return localVarFp.apiV1InvitesInviteIdAnonymouslyGet(requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvitesApiApiV1InvitesInviteIdRegisterPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvitesInviteIdRegisterPost(requestParameters: InvitesApiApiV1InvitesInviteIdRegisterPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1InvitesInviteIdRegisterPost(requestParameters.inviteId, requestParameters.nexusOpsAppVersion, requestParameters.registerInvitedUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvitesApiApiV1InvitesInviteIdRejectPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvitesInviteIdRejectPost(requestParameters: InvitesApiApiV1InvitesInviteIdRejectPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1InvitesInviteIdRejectPost(requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvitesApiApiV1InvitesMyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvitesMyGet(requestParameters: InvitesApiApiV1InvitesMyGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<InviteDto>> {
            return localVarFp.apiV1InvitesMyGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvitesApiApiV1InvitesMyInviteIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvitesMyInviteIdGet(requestParameters: InvitesApiApiV1InvitesMyInviteIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<InviteDto> {
            return localVarFp.apiV1InvitesMyInviteIdGet(requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvitesApiApiV1InvitesUserExistsAnonymouslyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvitesUserExistsAnonymouslyPost(requestParameters: InvitesApiApiV1InvitesUserExistsAnonymouslyPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<InviteUserExistsDto> {
            return localVarFp.apiV1InvitesUserExistsAnonymouslyPost(requestParameters.nexusOpsAppVersion, requestParameters.inviteCheckUserExistsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1InvitesInviteIdAcceptPost operation in InvitesApi.
 * @export
 * @interface InvitesApiApiV1InvitesInviteIdAcceptPostRequest
 */
export interface InvitesApiApiV1InvitesInviteIdAcceptPostRequest {
    /**
     * 
     * @type {string}
     * @memberof InvitesApiApiV1InvitesInviteIdAcceptPost
     */
    readonly inviteId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvitesApiApiV1InvitesInviteIdAcceptPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1InvitesInviteIdAnonymouslyGet operation in InvitesApi.
 * @export
 * @interface InvitesApiApiV1InvitesInviteIdAnonymouslyGetRequest
 */
export interface InvitesApiApiV1InvitesInviteIdAnonymouslyGetRequest {
    /**
     * 
     * @type {string}
     * @memberof InvitesApiApiV1InvitesInviteIdAnonymouslyGet
     */
    readonly inviteId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvitesApiApiV1InvitesInviteIdAnonymouslyGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1InvitesInviteIdRegisterPost operation in InvitesApi.
 * @export
 * @interface InvitesApiApiV1InvitesInviteIdRegisterPostRequest
 */
export interface InvitesApiApiV1InvitesInviteIdRegisterPostRequest {
    /**
     * 
     * @type {string}
     * @memberof InvitesApiApiV1InvitesInviteIdRegisterPost
     */
    readonly inviteId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvitesApiApiV1InvitesInviteIdRegisterPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RegisterInvitedUserDto}
     * @memberof InvitesApiApiV1InvitesInviteIdRegisterPost
     */
    readonly registerInvitedUserDto?: RegisterInvitedUserDto
}

/**
 * Request parameters for apiV1InvitesInviteIdRejectPost operation in InvitesApi.
 * @export
 * @interface InvitesApiApiV1InvitesInviteIdRejectPostRequest
 */
export interface InvitesApiApiV1InvitesInviteIdRejectPostRequest {
    /**
     * 
     * @type {string}
     * @memberof InvitesApiApiV1InvitesInviteIdRejectPost
     */
    readonly inviteId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvitesApiApiV1InvitesInviteIdRejectPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1InvitesMyGet operation in InvitesApi.
 * @export
 * @interface InvitesApiApiV1InvitesMyGetRequest
 */
export interface InvitesApiApiV1InvitesMyGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvitesApiApiV1InvitesMyGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1InvitesMyInviteIdGet operation in InvitesApi.
 * @export
 * @interface InvitesApiApiV1InvitesMyInviteIdGetRequest
 */
export interface InvitesApiApiV1InvitesMyInviteIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof InvitesApiApiV1InvitesMyInviteIdGet
     */
    readonly inviteId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvitesApiApiV1InvitesMyInviteIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1InvitesUserExistsAnonymouslyPost operation in InvitesApi.
 * @export
 * @interface InvitesApiApiV1InvitesUserExistsAnonymouslyPostRequest
 */
export interface InvitesApiApiV1InvitesUserExistsAnonymouslyPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvitesApiApiV1InvitesUserExistsAnonymouslyPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {InviteCheckUserExistsDto}
     * @memberof InvitesApiApiV1InvitesUserExistsAnonymouslyPost
     */
    readonly inviteCheckUserExistsDto?: InviteCheckUserExistsDto
}

/**
 * InvitesApi - object-oriented interface
 * @export
 * @class InvitesApi
 * @extends {BaseAPI}
 */
export class InvitesApi extends BaseAPI {
    /**
     * 
     * @param {InvitesApiApiV1InvitesInviteIdAcceptPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitesApi
     */
    public apiV1InvitesInviteIdAcceptPost(requestParameters: InvitesApiApiV1InvitesInviteIdAcceptPostRequest, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).apiV1InvitesInviteIdAcceptPost(requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvitesApiApiV1InvitesInviteIdAnonymouslyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitesApi
     */
    public apiV1InvitesInviteIdAnonymouslyGet(requestParameters: InvitesApiApiV1InvitesInviteIdAnonymouslyGetRequest, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).apiV1InvitesInviteIdAnonymouslyGet(requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvitesApiApiV1InvitesInviteIdRegisterPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitesApi
     */
    public apiV1InvitesInviteIdRegisterPost(requestParameters: InvitesApiApiV1InvitesInviteIdRegisterPostRequest, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).apiV1InvitesInviteIdRegisterPost(requestParameters.inviteId, requestParameters.nexusOpsAppVersion, requestParameters.registerInvitedUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvitesApiApiV1InvitesInviteIdRejectPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitesApi
     */
    public apiV1InvitesInviteIdRejectPost(requestParameters: InvitesApiApiV1InvitesInviteIdRejectPostRequest, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).apiV1InvitesInviteIdRejectPost(requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvitesApiApiV1InvitesMyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitesApi
     */
    public apiV1InvitesMyGet(requestParameters: InvitesApiApiV1InvitesMyGetRequest = {}, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).apiV1InvitesMyGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvitesApiApiV1InvitesMyInviteIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitesApi
     */
    public apiV1InvitesMyInviteIdGet(requestParameters: InvitesApiApiV1InvitesMyInviteIdGetRequest, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).apiV1InvitesMyInviteIdGet(requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvitesApiApiV1InvitesUserExistsAnonymouslyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitesApi
     */
    public apiV1InvitesUserExistsAnonymouslyPost(requestParameters: InvitesApiApiV1InvitesUserExistsAnonymouslyPostRequest = {}, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).apiV1InvitesUserExistsAnonymouslyPost(requestParameters.nexusOpsAppVersion, requestParameters.inviteCheckUserExistsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvitesAdminApi - axios parameter creator
 * @export
 */
export const InvitesAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateAnonymousInviteDto} [adminCreateAnonymousInviteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvitesAnonymousPost: async (nexusOpsAppVersion?: string, adminCreateAnonymousInviteDto?: AdminCreateAnonymousInviteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/invites/anonymous`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateAnonymousInviteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminInviteGetPaginatedDto} [adminInviteGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvitesGetPost: async (nexusOpsAppVersion?: string, adminInviteGetPaginatedDto?: AdminInviteGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/invites/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminInviteGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvitesInviteIdGet: async (inviteId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('apiV1AdminInvitesInviteIdGet', 'inviteId', inviteId)
            const localVarPath = `/api/v1/admin/invites/{inviteId}`
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateInviteDto} [adminCreateInviteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvitesPost: async (nexusOpsAppVersion?: string, adminCreateInviteDto?: AdminCreateInviteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateInviteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvitesAdminApi - functional programming interface
 * @export
 */
export const InvitesAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvitesAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateAnonymousInviteDto} [adminCreateAnonymousInviteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminInvitesAnonymousPost(nexusOpsAppVersion?: string, adminCreateAnonymousInviteDto?: AdminCreateAnonymousInviteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInviteAnonymousResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminInvitesAnonymousPost(nexusOpsAppVersion, adminCreateAnonymousInviteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesAdminApi.apiV1AdminInvitesAnonymousPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminInviteGetPaginatedDto} [adminInviteGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminInvitesGetPost(nexusOpsAppVersion?: string, adminInviteGetPaginatedDto?: AdminInviteGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminInviteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminInvitesGetPost(nexusOpsAppVersion, adminInviteGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesAdminApi.apiV1AdminInvitesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminInvitesInviteIdGet(inviteId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInviteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminInvitesInviteIdGet(inviteId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesAdminApi.apiV1AdminInvitesInviteIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateInviteDto} [adminCreateInviteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminInvitesPost(nexusOpsAppVersion?: string, adminCreateInviteDto?: AdminCreateInviteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInvitePersonalResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminInvitesPost(nexusOpsAppVersion, adminCreateInviteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesAdminApi.apiV1AdminInvitesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvitesAdminApi - factory interface
 * @export
 */
export const InvitesAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvitesAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {InvitesAdminApiApiV1AdminInvitesAnonymousPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvitesAnonymousPost(requestParameters: InvitesAdminApiApiV1AdminInvitesAnonymousPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminInviteAnonymousResultDto> {
            return localVarFp.apiV1AdminInvitesAnonymousPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateAnonymousInviteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvitesAdminApiApiV1AdminInvitesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvitesGetPost(requestParameters: InvitesAdminApiApiV1AdminInvitesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminInviteDto> {
            return localVarFp.apiV1AdminInvitesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminInviteGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvitesAdminApiApiV1AdminInvitesInviteIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvitesInviteIdGet(requestParameters: InvitesAdminApiApiV1AdminInvitesInviteIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminInviteDto> {
            return localVarFp.apiV1AdminInvitesInviteIdGet(requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvitesAdminApiApiV1AdminInvitesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvitesPost(requestParameters: InvitesAdminApiApiV1AdminInvitesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminInvitePersonalResultDto> {
            return localVarFp.apiV1AdminInvitesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateInviteDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminInvitesAnonymousPost operation in InvitesAdminApi.
 * @export
 * @interface InvitesAdminApiApiV1AdminInvitesAnonymousPostRequest
 */
export interface InvitesAdminApiApiV1AdminInvitesAnonymousPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvitesAdminApiApiV1AdminInvitesAnonymousPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateAnonymousInviteDto}
     * @memberof InvitesAdminApiApiV1AdminInvitesAnonymousPost
     */
    readonly adminCreateAnonymousInviteDto?: AdminCreateAnonymousInviteDto
}

/**
 * Request parameters for apiV1AdminInvitesGetPost operation in InvitesAdminApi.
 * @export
 * @interface InvitesAdminApiApiV1AdminInvitesGetPostRequest
 */
export interface InvitesAdminApiApiV1AdminInvitesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvitesAdminApiApiV1AdminInvitesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminInviteGetPaginatedDto}
     * @memberof InvitesAdminApiApiV1AdminInvitesGetPost
     */
    readonly adminInviteGetPaginatedDto?: AdminInviteGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminInvitesInviteIdGet operation in InvitesAdminApi.
 * @export
 * @interface InvitesAdminApiApiV1AdminInvitesInviteIdGetRequest
 */
export interface InvitesAdminApiApiV1AdminInvitesInviteIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof InvitesAdminApiApiV1AdminInvitesInviteIdGet
     */
    readonly inviteId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvitesAdminApiApiV1AdminInvitesInviteIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminInvitesPost operation in InvitesAdminApi.
 * @export
 * @interface InvitesAdminApiApiV1AdminInvitesPostRequest
 */
export interface InvitesAdminApiApiV1AdminInvitesPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvitesAdminApiApiV1AdminInvitesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateInviteDto}
     * @memberof InvitesAdminApiApiV1AdminInvitesPost
     */
    readonly adminCreateInviteDto?: AdminCreateInviteDto
}

/**
 * InvitesAdminApi - object-oriented interface
 * @export
 * @class InvitesAdminApi
 * @extends {BaseAPI}
 */
export class InvitesAdminApi extends BaseAPI {
    /**
     * 
     * @param {InvitesAdminApiApiV1AdminInvitesAnonymousPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitesAdminApi
     */
    public apiV1AdminInvitesAnonymousPost(requestParameters: InvitesAdminApiApiV1AdminInvitesAnonymousPostRequest = {}, options?: RawAxiosRequestConfig) {
        return InvitesAdminApiFp(this.configuration).apiV1AdminInvitesAnonymousPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateAnonymousInviteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvitesAdminApiApiV1AdminInvitesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitesAdminApi
     */
    public apiV1AdminInvitesGetPost(requestParameters: InvitesAdminApiApiV1AdminInvitesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return InvitesAdminApiFp(this.configuration).apiV1AdminInvitesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminInviteGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvitesAdminApiApiV1AdminInvitesInviteIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitesAdminApi
     */
    public apiV1AdminInvitesInviteIdGet(requestParameters: InvitesAdminApiApiV1AdminInvitesInviteIdGetRequest, options?: RawAxiosRequestConfig) {
        return InvitesAdminApiFp(this.configuration).apiV1AdminInvitesInviteIdGet(requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvitesAdminApiApiV1AdminInvitesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitesAdminApi
     */
    public apiV1AdminInvitesPost(requestParameters: InvitesAdminApiApiV1AdminInvitesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return InvitesAdminApiFp(this.configuration).apiV1AdminInvitesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateInviteDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoicesApi - axios parameter creator
 * @export
 */
export const InvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {InvoiceGetPaginatedDto} [invoiceGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvoicesGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, invoiceGetPaginatedDto?: InvoiceGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1InvoicesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/invoices/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoiceGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} invoiceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvoicesInvoiceIdDownloadPdfGet: async (nexusOpsTenant: string, invoiceId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1InvoicesInvoiceIdDownloadPdfGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('apiV1InvoicesInvoiceIdDownloadPdfGet', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/invoices/{invoiceId}/download/pdf`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} invoiceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvoicesInvoiceIdGet: async (nexusOpsTenant: string, invoiceId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1InvoicesInvoiceIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('apiV1InvoicesInvoiceIdGet', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/invoices/{invoiceId}`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoicesApi - functional programming interface
 * @export
 */
export const InvoicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {InvoiceGetPaginatedDto} [invoiceGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvoicesGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, invoiceGetPaginatedDto?: InvoiceGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfInvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InvoicesGetPost(nexusOpsTenant, nexusOpsAppVersion, invoiceGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.apiV1InvoicesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} invoiceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvoicesInvoiceIdDownloadPdfGet(nexusOpsTenant: string, invoiceId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InvoicesInvoiceIdDownloadPdfGet(nexusOpsTenant, invoiceId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.apiV1InvoicesInvoiceIdDownloadPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} invoiceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InvoicesInvoiceIdGet(nexusOpsTenant: string, invoiceId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InvoicesInvoiceIdGet(nexusOpsTenant, invoiceId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.apiV1InvoicesInvoiceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoicesApi - factory interface
 * @export
 */
export const InvoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoicesApiFp(configuration)
    return {
        /**
         * 
         * @param {InvoicesApiApiV1InvoicesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvoicesGetPost(requestParameters: InvoicesApiApiV1InvoicesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfInvoiceDto> {
            return localVarFp.apiV1InvoicesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.invoiceGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiApiV1InvoicesInvoiceIdDownloadPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvoicesInvoiceIdDownloadPdfGet(requestParameters: InvoicesApiApiV1InvoicesInvoiceIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1InvoicesInvoiceIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.invoiceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesApiApiV1InvoicesInvoiceIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InvoicesInvoiceIdGet(requestParameters: InvoicesApiApiV1InvoicesInvoiceIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceDto> {
            return localVarFp.apiV1InvoicesInvoiceIdGet(requestParameters.nexusOpsTenant, requestParameters.invoiceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1InvoicesGetPost operation in InvoicesApi.
 * @export
 * @interface InvoicesApiApiV1InvoicesGetPostRequest
 */
export interface InvoicesApiApiV1InvoicesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof InvoicesApiApiV1InvoicesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvoicesApiApiV1InvoicesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {InvoiceGetPaginatedDto}
     * @memberof InvoicesApiApiV1InvoicesGetPost
     */
    readonly invoiceGetPaginatedDto?: InvoiceGetPaginatedDto
}

/**
 * Request parameters for apiV1InvoicesInvoiceIdDownloadPdfGet operation in InvoicesApi.
 * @export
 * @interface InvoicesApiApiV1InvoicesInvoiceIdDownloadPdfGetRequest
 */
export interface InvoicesApiApiV1InvoicesInvoiceIdDownloadPdfGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof InvoicesApiApiV1InvoicesInvoiceIdDownloadPdfGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof InvoicesApiApiV1InvoicesInvoiceIdDownloadPdfGet
     */
    readonly invoiceId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvoicesApiApiV1InvoicesInvoiceIdDownloadPdfGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1InvoicesInvoiceIdGet operation in InvoicesApi.
 * @export
 * @interface InvoicesApiApiV1InvoicesInvoiceIdGetRequest
 */
export interface InvoicesApiApiV1InvoicesInvoiceIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof InvoicesApiApiV1InvoicesInvoiceIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof InvoicesApiApiV1InvoicesInvoiceIdGet
     */
    readonly invoiceId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvoicesApiApiV1InvoicesInvoiceIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * InvoicesApi - object-oriented interface
 * @export
 * @class InvoicesApi
 * @extends {BaseAPI}
 */
export class InvoicesApi extends BaseAPI {
    /**
     * 
     * @param {InvoicesApiApiV1InvoicesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public apiV1InvoicesGetPost(requestParameters: InvoicesApiApiV1InvoicesGetPostRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).apiV1InvoicesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.invoiceGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiApiV1InvoicesInvoiceIdDownloadPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public apiV1InvoicesInvoiceIdDownloadPdfGet(requestParameters: InvoicesApiApiV1InvoicesInvoiceIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).apiV1InvoicesInvoiceIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.invoiceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesApiApiV1InvoicesInvoiceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public apiV1InvoicesInvoiceIdGet(requestParameters: InvoicesApiApiV1InvoicesInvoiceIdGetRequest, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).apiV1InvoicesInvoiceIdGet(requestParameters.nexusOpsTenant, requestParameters.invoiceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoicesAdminApi - axios parameter creator
 * @export
 */
export const InvoicesAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminInvoiceGetPaginatedDto} [adminInvoiceGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvoicesGetPost: async (nexusOpsAppVersion?: string, adminInvoiceGetPaginatedDto?: AdminInvoiceGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/invoices/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminInvoiceGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvoicesInvoiceIdCancelPost: async (invoiceId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('apiV1AdminInvoicesInvoiceIdCancelPost', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/admin/invoices/{invoiceId}/cancel`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvoicesInvoiceIdConfirmPost: async (invoiceId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('apiV1AdminInvoicesInvoiceIdConfirmPost', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/admin/invoices/{invoiceId}/confirm`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvoicesInvoiceIdDownloadPdfGet: async (invoiceId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('apiV1AdminInvoicesInvoiceIdDownloadPdfGet', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/admin/invoices/{invoiceId}/download/pdf`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvoicesInvoiceIdGet: async (invoiceId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('apiV1AdminInvoicesInvoiceIdGet', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/admin/invoices/{invoiceId}`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoicesAdminApi - functional programming interface
 * @export
 */
export const InvoicesAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoicesAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminInvoiceGetPaginatedDto} [adminInvoiceGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminInvoicesGetPost(nexusOpsAppVersion?: string, adminInvoiceGetPaginatedDto?: AdminInvoiceGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminInvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminInvoicesGetPost(nexusOpsAppVersion, adminInvoiceGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesAdminApi.apiV1AdminInvoicesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminInvoicesInvoiceIdCancelPost(invoiceId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminInvoicesInvoiceIdCancelPost(invoiceId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesAdminApi.apiV1AdminInvoicesInvoiceIdCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminInvoicesInvoiceIdConfirmPost(invoiceId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminInvoicesInvoiceIdConfirmPost(invoiceId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesAdminApi.apiV1AdminInvoicesInvoiceIdConfirmPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminInvoicesInvoiceIdDownloadPdfGet(invoiceId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminInvoicesInvoiceIdDownloadPdfGet(invoiceId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesAdminApi.apiV1AdminInvoicesInvoiceIdDownloadPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminInvoicesInvoiceIdGet(invoiceId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminInvoicesInvoiceIdGet(invoiceId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesAdminApi.apiV1AdminInvoicesInvoiceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoicesAdminApi - factory interface
 * @export
 */
export const InvoicesAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoicesAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {InvoicesAdminApiApiV1AdminInvoicesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvoicesGetPost(requestParameters: InvoicesAdminApiApiV1AdminInvoicesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminInvoiceDto> {
            return localVarFp.apiV1AdminInvoicesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminInvoiceGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesAdminApiApiV1AdminInvoicesInvoiceIdCancelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvoicesInvoiceIdCancelPost(requestParameters: InvoicesAdminApiApiV1AdminInvoicesInvoiceIdCancelPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminInvoiceDto> {
            return localVarFp.apiV1AdminInvoicesInvoiceIdCancelPost(requestParameters.invoiceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesAdminApiApiV1AdminInvoicesInvoiceIdConfirmPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvoicesInvoiceIdConfirmPost(requestParameters: InvoicesAdminApiApiV1AdminInvoicesInvoiceIdConfirmPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminInvoiceDto> {
            return localVarFp.apiV1AdminInvoicesInvoiceIdConfirmPost(requestParameters.invoiceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesAdminApiApiV1AdminInvoicesInvoiceIdDownloadPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvoicesInvoiceIdDownloadPdfGet(requestParameters: InvoicesAdminApiApiV1AdminInvoicesInvoiceIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1AdminInvoicesInvoiceIdDownloadPdfGet(requestParameters.invoiceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InvoicesAdminApiApiV1AdminInvoicesInvoiceIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminInvoicesInvoiceIdGet(requestParameters: InvoicesAdminApiApiV1AdminInvoicesInvoiceIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminInvoiceDto> {
            return localVarFp.apiV1AdminInvoicesInvoiceIdGet(requestParameters.invoiceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminInvoicesGetPost operation in InvoicesAdminApi.
 * @export
 * @interface InvoicesAdminApiApiV1AdminInvoicesGetPostRequest
 */
export interface InvoicesAdminApiApiV1AdminInvoicesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvoicesAdminApiApiV1AdminInvoicesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminInvoiceGetPaginatedDto}
     * @memberof InvoicesAdminApiApiV1AdminInvoicesGetPost
     */
    readonly adminInvoiceGetPaginatedDto?: AdminInvoiceGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminInvoicesInvoiceIdCancelPost operation in InvoicesAdminApi.
 * @export
 * @interface InvoicesAdminApiApiV1AdminInvoicesInvoiceIdCancelPostRequest
 */
export interface InvoicesAdminApiApiV1AdminInvoicesInvoiceIdCancelPostRequest {
    /**
     * 
     * @type {string}
     * @memberof InvoicesAdminApiApiV1AdminInvoicesInvoiceIdCancelPost
     */
    readonly invoiceId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvoicesAdminApiApiV1AdminInvoicesInvoiceIdCancelPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminInvoicesInvoiceIdConfirmPost operation in InvoicesAdminApi.
 * @export
 * @interface InvoicesAdminApiApiV1AdminInvoicesInvoiceIdConfirmPostRequest
 */
export interface InvoicesAdminApiApiV1AdminInvoicesInvoiceIdConfirmPostRequest {
    /**
     * 
     * @type {string}
     * @memberof InvoicesAdminApiApiV1AdminInvoicesInvoiceIdConfirmPost
     */
    readonly invoiceId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvoicesAdminApiApiV1AdminInvoicesInvoiceIdConfirmPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminInvoicesInvoiceIdDownloadPdfGet operation in InvoicesAdminApi.
 * @export
 * @interface InvoicesAdminApiApiV1AdminInvoicesInvoiceIdDownloadPdfGetRequest
 */
export interface InvoicesAdminApiApiV1AdminInvoicesInvoiceIdDownloadPdfGetRequest {
    /**
     * 
     * @type {string}
     * @memberof InvoicesAdminApiApiV1AdminInvoicesInvoiceIdDownloadPdfGet
     */
    readonly invoiceId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvoicesAdminApiApiV1AdminInvoicesInvoiceIdDownloadPdfGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminInvoicesInvoiceIdGet operation in InvoicesAdminApi.
 * @export
 * @interface InvoicesAdminApiApiV1AdminInvoicesInvoiceIdGetRequest
 */
export interface InvoicesAdminApiApiV1AdminInvoicesInvoiceIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof InvoicesAdminApiApiV1AdminInvoicesInvoiceIdGet
     */
    readonly invoiceId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof InvoicesAdminApiApiV1AdminInvoicesInvoiceIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * InvoicesAdminApi - object-oriented interface
 * @export
 * @class InvoicesAdminApi
 * @extends {BaseAPI}
 */
export class InvoicesAdminApi extends BaseAPI {
    /**
     * 
     * @param {InvoicesAdminApiApiV1AdminInvoicesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesAdminApi
     */
    public apiV1AdminInvoicesGetPost(requestParameters: InvoicesAdminApiApiV1AdminInvoicesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return InvoicesAdminApiFp(this.configuration).apiV1AdminInvoicesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminInvoiceGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesAdminApiApiV1AdminInvoicesInvoiceIdCancelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesAdminApi
     */
    public apiV1AdminInvoicesInvoiceIdCancelPost(requestParameters: InvoicesAdminApiApiV1AdminInvoicesInvoiceIdCancelPostRequest, options?: RawAxiosRequestConfig) {
        return InvoicesAdminApiFp(this.configuration).apiV1AdminInvoicesInvoiceIdCancelPost(requestParameters.invoiceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesAdminApiApiV1AdminInvoicesInvoiceIdConfirmPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesAdminApi
     */
    public apiV1AdminInvoicesInvoiceIdConfirmPost(requestParameters: InvoicesAdminApiApiV1AdminInvoicesInvoiceIdConfirmPostRequest, options?: RawAxiosRequestConfig) {
        return InvoicesAdminApiFp(this.configuration).apiV1AdminInvoicesInvoiceIdConfirmPost(requestParameters.invoiceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesAdminApiApiV1AdminInvoicesInvoiceIdDownloadPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesAdminApi
     */
    public apiV1AdminInvoicesInvoiceIdDownloadPdfGet(requestParameters: InvoicesAdminApiApiV1AdminInvoicesInvoiceIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig) {
        return InvoicesAdminApiFp(this.configuration).apiV1AdminInvoicesInvoiceIdDownloadPdfGet(requestParameters.invoiceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InvoicesAdminApiApiV1AdminInvoicesInvoiceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesAdminApi
     */
    public apiV1AdminInvoicesInvoiceIdGet(requestParameters: InvoicesAdminApiApiV1AdminInvoicesInvoiceIdGetRequest, options?: RawAxiosRequestConfig) {
        return InvoicesAdminApiFp(this.configuration).apiV1AdminInvoicesInvoiceIdGet(requestParameters.invoiceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1LocationsBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/locations/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {LocationGetPaginatedDto} [locationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, locationGetPaginatedDto?: LocationGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1LocationsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/locations/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdDelete: async (nexusOpsTenant: string, locationId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdDelete', 'locationId', locationId)
            const localVarPath = `/api/v1/locations/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdGet: async (nexusOpsTenant: string, locationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdGet', 'locationId', locationId)
            const localVarPath = `/api/v1/locations/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateLocationDto} [updateLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdPut: async (nexusOpsTenant: string, locationId: string, nexusOpsAppVersion?: string, updateLocationDto?: UpdateLocationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdPut', 'locationId', locationId)
            const localVarPath = `/api/v1/locations/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdReferenceGet: async (nexusOpsTenant: string, locationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdReferenceGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdReferenceGet', 'locationId', locationId)
            const localVarPath = `/api/v1/locations/{locationId}/reference`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddLocationSpotsDto} [addLocationSpotsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdSpotsPost: async (nexusOpsTenant: string, locationId: string, nexusOpsAppVersion?: string, addLocationSpotsDto?: AddLocationSpotsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdSpotsPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdSpotsPost', 'locationId', locationId)
            const localVarPath = `/api/v1/locations/{locationId}/spots`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addLocationSpotsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} spotId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdSpotsSpotIdDelete: async (nexusOpsTenant: string, locationId: string, spotId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdSpotsSpotIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdSpotsSpotIdDelete', 'locationId', locationId)
            // verify required parameter 'spotId' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdSpotsSpotIdDelete', 'spotId', spotId)
            const localVarPath = `/api/v1/locations/{locationId}/spots/{spotId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"spotId"}}`, encodeURIComponent(String(spotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UserGetPaginatedDto} [userGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdUsersGetPost: async (nexusOpsTenant: string, locationId: string, nexusOpsAppVersion?: string, userGetPaginatedDto?: UserGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdUsersGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdUsersGetPost', 'locationId', locationId)
            const localVarPath = `/api/v1/locations/{locationId}/users/get`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddUsersToLocationDto} [addUsersToLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdUsersPost: async (nexusOpsTenant: string, locationId: string, nexusOpsAppVersion?: string, addUsersToLocationDto?: AddUsersToLocationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdUsersPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdUsersPost', 'locationId', locationId)
            const localVarPath = `/api/v1/locations/{locationId}/users`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addUsersToLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdUsersUserIdDelete: async (nexusOpsTenant: string, locationId: string, userId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdUsersUserIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdUsersUserIdDelete', 'locationId', locationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1LocationsLocationIdUsersUserIdDelete', 'userId', userId)
            const localVarPath = `/api/v1/locations/{locationId}/users/{userId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateLocationDto} [createLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createLocationDto?: CreateLocationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1LocationsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LocationsBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LocationsBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiV1LocationsBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {LocationGetPaginatedDto} [locationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LocationsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, locationGetPaginatedDto?: LocationGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfLocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LocationsGetPost(nexusOpsTenant, nexusOpsAppVersion, locationGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiV1LocationsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LocationsLocationIdDelete(nexusOpsTenant: string, locationId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LocationsLocationIdDelete(nexusOpsTenant, locationId, nexusOpsAppVersion, isDeleteCascade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiV1LocationsLocationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LocationsLocationIdGet(nexusOpsTenant: string, locationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LocationsLocationIdGet(nexusOpsTenant, locationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiV1LocationsLocationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateLocationDto} [updateLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LocationsLocationIdPut(nexusOpsTenant: string, locationId: string, nexusOpsAppVersion?: string, updateLocationDto?: UpdateLocationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LocationsLocationIdPut(nexusOpsTenant, locationId, nexusOpsAppVersion, updateLocationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiV1LocationsLocationIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LocationsLocationIdReferenceGet(nexusOpsTenant: string, locationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationReferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LocationsLocationIdReferenceGet(nexusOpsTenant, locationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiV1LocationsLocationIdReferenceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddLocationSpotsDto} [addLocationSpotsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LocationsLocationIdSpotsPost(nexusOpsTenant: string, locationId: string, nexusOpsAppVersion?: string, addLocationSpotsDto?: AddLocationSpotsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LocationsLocationIdSpotsPost(nexusOpsTenant, locationId, nexusOpsAppVersion, addLocationSpotsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiV1LocationsLocationIdSpotsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} spotId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LocationsLocationIdSpotsSpotIdDelete(nexusOpsTenant: string, locationId: string, spotId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LocationsLocationIdSpotsSpotIdDelete(nexusOpsTenant, locationId, spotId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiV1LocationsLocationIdSpotsSpotIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UserGetPaginatedDto} [userGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LocationsLocationIdUsersGetPost(nexusOpsTenant: string, locationId: string, nexusOpsAppVersion?: string, userGetPaginatedDto?: UserGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LocationsLocationIdUsersGetPost(nexusOpsTenant, locationId, nexusOpsAppVersion, userGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiV1LocationsLocationIdUsersGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddUsersToLocationDto} [addUsersToLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LocationsLocationIdUsersPost(nexusOpsTenant: string, locationId: string, nexusOpsAppVersion?: string, addUsersToLocationDto?: AddUsersToLocationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LocationsLocationIdUsersPost(nexusOpsTenant, locationId, nexusOpsAppVersion, addUsersToLocationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiV1LocationsLocationIdUsersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} locationId 
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LocationsLocationIdUsersUserIdDelete(nexusOpsTenant: string, locationId: string, userId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LocationsLocationIdUsersUserIdDelete(nexusOpsTenant, locationId, userId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiV1LocationsLocationIdUsersUserIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateLocationDto} [createLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LocationsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createLocationDto?: CreateLocationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1LocationsPost(nexusOpsTenant, nexusOpsAppVersion, createLocationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.apiV1LocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         * 
         * @param {LocationsApiApiV1LocationsBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsBulkDeleteDelete(requestParameters: LocationsApiApiV1LocationsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1LocationsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiV1LocationsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsGetPost(requestParameters: LocationsApiApiV1LocationsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfLocationDto> {
            return localVarFp.apiV1LocationsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.locationGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiV1LocationsLocationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdDelete(requestParameters: LocationsApiApiV1LocationsLocationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1LocationsLocationIdDelete(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiV1LocationsLocationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdGet(requestParameters: LocationsApiApiV1LocationsLocationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationDto> {
            return localVarFp.apiV1LocationsLocationIdGet(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiV1LocationsLocationIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdPut(requestParameters: LocationsApiApiV1LocationsLocationIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationDto> {
            return localVarFp.apiV1LocationsLocationIdPut(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.nexusOpsAppVersion, requestParameters.updateLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiV1LocationsLocationIdReferenceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdReferenceGet(requestParameters: LocationsApiApiV1LocationsLocationIdReferenceGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationReferenceDto> {
            return localVarFp.apiV1LocationsLocationIdReferenceGet(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiV1LocationsLocationIdSpotsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdSpotsPost(requestParameters: LocationsApiApiV1LocationsLocationIdSpotsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationDto> {
            return localVarFp.apiV1LocationsLocationIdSpotsPost(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.nexusOpsAppVersion, requestParameters.addLocationSpotsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiV1LocationsLocationIdSpotsSpotIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdSpotsSpotIdDelete(requestParameters: LocationsApiApiV1LocationsLocationIdSpotsSpotIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationDto> {
            return localVarFp.apiV1LocationsLocationIdSpotsSpotIdDelete(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.spotId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiV1LocationsLocationIdUsersGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdUsersGetPost(requestParameters: LocationsApiApiV1LocationsLocationIdUsersGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfUserDto> {
            return localVarFp.apiV1LocationsLocationIdUsersGetPost(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.nexusOpsAppVersion, requestParameters.userGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiV1LocationsLocationIdUsersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdUsersPost(requestParameters: LocationsApiApiV1LocationsLocationIdUsersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationDto> {
            return localVarFp.apiV1LocationsLocationIdUsersPost(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.nexusOpsAppVersion, requestParameters.addUsersToLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiV1LocationsLocationIdUsersUserIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsLocationIdUsersUserIdDelete(requestParameters: LocationsApiApiV1LocationsLocationIdUsersUserIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationDto> {
            return localVarFp.apiV1LocationsLocationIdUsersUserIdDelete(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.userId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationsApiApiV1LocationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LocationsPost(requestParameters: LocationsApiApiV1LocationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationDto> {
            return localVarFp.apiV1LocationsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createLocationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1LocationsBulkDeleteDelete operation in LocationsApi.
 * @export
 * @interface LocationsApiApiV1LocationsBulkDeleteDeleteRequest
 */
export interface LocationsApiApiV1LocationsBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof LocationsApiApiV1LocationsBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof LocationsApiApiV1LocationsBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof LocationsApiApiV1LocationsBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1LocationsGetPost operation in LocationsApi.
 * @export
 * @interface LocationsApiApiV1LocationsGetPostRequest
 */
export interface LocationsApiApiV1LocationsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof LocationsApiApiV1LocationsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof LocationsApiApiV1LocationsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {LocationGetPaginatedDto}
     * @memberof LocationsApiApiV1LocationsGetPost
     */
    readonly locationGetPaginatedDto?: LocationGetPaginatedDto
}

/**
 * Request parameters for apiV1LocationsLocationIdDelete operation in LocationsApi.
 * @export
 * @interface LocationsApiApiV1LocationsLocationIdDeleteRequest
 */
export interface LocationsApiApiV1LocationsLocationIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdDelete
     */
    readonly locationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof LocationsApiApiV1LocationsLocationIdDelete
     */
    readonly isDeleteCascade?: boolean
}

/**
 * Request parameters for apiV1LocationsLocationIdGet operation in LocationsApi.
 * @export
 * @interface LocationsApiApiV1LocationsLocationIdGetRequest
 */
export interface LocationsApiApiV1LocationsLocationIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdGet
     */
    readonly locationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1LocationsLocationIdPut operation in LocationsApi.
 * @export
 * @interface LocationsApiApiV1LocationsLocationIdPutRequest
 */
export interface LocationsApiApiV1LocationsLocationIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdPut
     */
    readonly locationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateLocationDto}
     * @memberof LocationsApiApiV1LocationsLocationIdPut
     */
    readonly updateLocationDto?: UpdateLocationDto
}

/**
 * Request parameters for apiV1LocationsLocationIdReferenceGet operation in LocationsApi.
 * @export
 * @interface LocationsApiApiV1LocationsLocationIdReferenceGetRequest
 */
export interface LocationsApiApiV1LocationsLocationIdReferenceGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdReferenceGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdReferenceGet
     */
    readonly locationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdReferenceGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1LocationsLocationIdSpotsPost operation in LocationsApi.
 * @export
 * @interface LocationsApiApiV1LocationsLocationIdSpotsPostRequest
 */
export interface LocationsApiApiV1LocationsLocationIdSpotsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdSpotsPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdSpotsPost
     */
    readonly locationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdSpotsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AddLocationSpotsDto}
     * @memberof LocationsApiApiV1LocationsLocationIdSpotsPost
     */
    readonly addLocationSpotsDto?: AddLocationSpotsDto
}

/**
 * Request parameters for apiV1LocationsLocationIdSpotsSpotIdDelete operation in LocationsApi.
 * @export
 * @interface LocationsApiApiV1LocationsLocationIdSpotsSpotIdDeleteRequest
 */
export interface LocationsApiApiV1LocationsLocationIdSpotsSpotIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdSpotsSpotIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdSpotsSpotIdDelete
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdSpotsSpotIdDelete
     */
    readonly spotId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdSpotsSpotIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1LocationsLocationIdUsersGetPost operation in LocationsApi.
 * @export
 * @interface LocationsApiApiV1LocationsLocationIdUsersGetPostRequest
 */
export interface LocationsApiApiV1LocationsLocationIdUsersGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdUsersGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdUsersGetPost
     */
    readonly locationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdUsersGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UserGetPaginatedDto}
     * @memberof LocationsApiApiV1LocationsLocationIdUsersGetPost
     */
    readonly userGetPaginatedDto?: UserGetPaginatedDto
}

/**
 * Request parameters for apiV1LocationsLocationIdUsersPost operation in LocationsApi.
 * @export
 * @interface LocationsApiApiV1LocationsLocationIdUsersPostRequest
 */
export interface LocationsApiApiV1LocationsLocationIdUsersPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdUsersPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdUsersPost
     */
    readonly locationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdUsersPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AddUsersToLocationDto}
     * @memberof LocationsApiApiV1LocationsLocationIdUsersPost
     */
    readonly addUsersToLocationDto?: AddUsersToLocationDto
}

/**
 * Request parameters for apiV1LocationsLocationIdUsersUserIdDelete operation in LocationsApi.
 * @export
 * @interface LocationsApiApiV1LocationsLocationIdUsersUserIdDeleteRequest
 */
export interface LocationsApiApiV1LocationsLocationIdUsersUserIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdUsersUserIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdUsersUserIdDelete
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdUsersUserIdDelete
     */
    readonly userId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof LocationsApiApiV1LocationsLocationIdUsersUserIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1LocationsPost operation in LocationsApi.
 * @export
 * @interface LocationsApiApiV1LocationsPostRequest
 */
export interface LocationsApiApiV1LocationsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof LocationsApiApiV1LocationsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof LocationsApiApiV1LocationsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateLocationDto}
     * @memberof LocationsApiApiV1LocationsPost
     */
    readonly createLocationDto?: CreateLocationDto
}

/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     * 
     * @param {LocationsApiApiV1LocationsBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public apiV1LocationsBulkDeleteDelete(requestParameters: LocationsApiApiV1LocationsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiV1LocationsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiV1LocationsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public apiV1LocationsGetPost(requestParameters: LocationsApiApiV1LocationsGetPostRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiV1LocationsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.locationGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiV1LocationsLocationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public apiV1LocationsLocationIdDelete(requestParameters: LocationsApiApiV1LocationsLocationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiV1LocationsLocationIdDelete(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiV1LocationsLocationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public apiV1LocationsLocationIdGet(requestParameters: LocationsApiApiV1LocationsLocationIdGetRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiV1LocationsLocationIdGet(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiV1LocationsLocationIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public apiV1LocationsLocationIdPut(requestParameters: LocationsApiApiV1LocationsLocationIdPutRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiV1LocationsLocationIdPut(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.nexusOpsAppVersion, requestParameters.updateLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiV1LocationsLocationIdReferenceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public apiV1LocationsLocationIdReferenceGet(requestParameters: LocationsApiApiV1LocationsLocationIdReferenceGetRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiV1LocationsLocationIdReferenceGet(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiV1LocationsLocationIdSpotsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public apiV1LocationsLocationIdSpotsPost(requestParameters: LocationsApiApiV1LocationsLocationIdSpotsPostRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiV1LocationsLocationIdSpotsPost(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.nexusOpsAppVersion, requestParameters.addLocationSpotsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiV1LocationsLocationIdSpotsSpotIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public apiV1LocationsLocationIdSpotsSpotIdDelete(requestParameters: LocationsApiApiV1LocationsLocationIdSpotsSpotIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiV1LocationsLocationIdSpotsSpotIdDelete(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.spotId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiV1LocationsLocationIdUsersGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public apiV1LocationsLocationIdUsersGetPost(requestParameters: LocationsApiApiV1LocationsLocationIdUsersGetPostRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiV1LocationsLocationIdUsersGetPost(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.nexusOpsAppVersion, requestParameters.userGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiV1LocationsLocationIdUsersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public apiV1LocationsLocationIdUsersPost(requestParameters: LocationsApiApiV1LocationsLocationIdUsersPostRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiV1LocationsLocationIdUsersPost(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.nexusOpsAppVersion, requestParameters.addUsersToLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiV1LocationsLocationIdUsersUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public apiV1LocationsLocationIdUsersUserIdDelete(requestParameters: LocationsApiApiV1LocationsLocationIdUsersUserIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiV1LocationsLocationIdUsersUserIdDelete(requestParameters.nexusOpsTenant, requestParameters.locationId, requestParameters.userId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiApiV1LocationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public apiV1LocationsPost(requestParameters: LocationsApiApiV1LocationsPostRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).apiV1LocationsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createLocationDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MaintenancesApi - axios parameter creator
 * @export
 */
export const MaintenancesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1MaintenancesBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/maintenances/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesByIdsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1MaintenancesByIdsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/maintenances/by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1MaintenancesCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/maintenances/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {MaintenanceGetPaginatedDto} [maintenanceGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, maintenanceGetPaginatedDto?: MaintenanceGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1MaintenancesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/maintenances/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(maintenanceGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdAddAssignmentPost: async (nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdAddAssignmentPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdAddAssignmentPost', 'maintenanceId', maintenanceId)
            const localVarPath = `/api/v1/maintenances/{maintenanceId}/add-assignment`
                .replace(`{${"maintenanceId"}}`, encodeURIComponent(String(maintenanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentAddEntityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdDelete: async (nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdDelete', 'maintenanceId', maintenanceId)
            const localVarPath = `/api/v1/maintenances/{maintenanceId}`
                .replace(`{${"maintenanceId"}}`, encodeURIComponent(String(maintenanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdExternalNumberPut: async (nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdExternalNumberPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdExternalNumberPut', 'maintenanceId', maintenanceId)
            const localVarPath = `/api/v1/maintenances/{maintenanceId}/external-number`
                .replace(`{${"maintenanceId"}}`, encodeURIComponent(String(maintenanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalExternalNumberInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdGet: async (nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdGet', 'maintenanceId', maintenanceId)
            const localVarPath = `/api/v1/maintenances/{maintenanceId}`
                .replace(`{${"maintenanceId"}}`, encodeURIComponent(String(maintenanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleMileageDto} [updateVehicleMileageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdMileagePut: async (nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, updateVehicleMileageDto?: UpdateVehicleMileageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdMileagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdMileagePut', 'maintenanceId', maintenanceId)
            const localVarPath = `/api/v1/maintenances/{maintenanceId}/mileage`
                .replace(`{${"maintenanceId"}}`, encodeURIComponent(String(maintenanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVehicleMileageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdNotesPut: async (nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdNotesPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdNotesPut', 'maintenanceId', maintenanceId)
            const localVarPath = `/api/v1/maintenances/{maintenanceId}/notes`
                .replace(`{${"maintenanceId"}}`, encodeURIComponent(String(maintenanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalNotesInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateMaintenanceDto} [updateMaintenanceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdPut: async (nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, updateMaintenanceDto?: UpdateMaintenanceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdPut', 'maintenanceId', maintenanceId)
            const localVarPath = `/api/v1/maintenances/{maintenanceId}`
                .replace(`{${"maintenanceId"}}`, encodeURIComponent(String(maintenanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMaintenanceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStageUpdateDtoOfMaintenanceStage} [generalStageUpdateDtoOfMaintenanceStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdStagePut: async (nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, generalStageUpdateDtoOfMaintenanceStage?: GeneralStageUpdateDtoOfMaintenanceStage, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdStagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('apiV1MaintenancesMaintenanceIdStagePut', 'maintenanceId', maintenanceId)
            const localVarPath = `/api/v1/maintenances/{maintenanceId}/stage`
                .replace(`{${"maintenanceId"}}`, encodeURIComponent(String(maintenanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalStageUpdateDtoOfMaintenanceStage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateMaintenanceDto} [createMaintenanceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createMaintenanceDto?: CreateMaintenanceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1MaintenancesPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/maintenances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMaintenanceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaintenancesApi - functional programming interface
 * @export
 */
export const MaintenancesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaintenancesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MaintenancesBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MaintenancesBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenancesApi.apiV1MaintenancesBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MaintenancesByIdsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MaintenanceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MaintenancesByIdsGet(nexusOpsTenant, nexusOpsAppVersion, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenancesApi.apiV1MaintenancesByIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MaintenancesCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MaintenancesCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenancesApi.apiV1MaintenancesCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {MaintenanceGetPaginatedDto} [maintenanceGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MaintenancesGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, maintenanceGetPaginatedDto?: MaintenanceGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfMaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MaintenancesGetPost(nexusOpsTenant, nexusOpsAppVersion, maintenanceGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenancesApi.apiV1MaintenancesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MaintenancesMaintenanceIdAddAssignmentPost(nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MaintenancesMaintenanceIdAddAssignmentPost(nexusOpsTenant, maintenanceId, nexusOpsAppVersion, assignmentAddEntityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenancesApi.apiV1MaintenancesMaintenanceIdAddAssignmentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MaintenancesMaintenanceIdDelete(nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MaintenancesMaintenanceIdDelete(nexusOpsTenant, maintenanceId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenancesApi.apiV1MaintenancesMaintenanceIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MaintenancesMaintenanceIdExternalNumberPut(nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MaintenancesMaintenanceIdExternalNumberPut(nexusOpsTenant, maintenanceId, nexusOpsAppVersion, generalExternalNumberInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenancesApi.apiV1MaintenancesMaintenanceIdExternalNumberPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MaintenancesMaintenanceIdGet(nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MaintenancesMaintenanceIdGet(nexusOpsTenant, maintenanceId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenancesApi.apiV1MaintenancesMaintenanceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleMileageDto} [updateVehicleMileageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MaintenancesMaintenanceIdMileagePut(nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, updateVehicleMileageDto?: UpdateVehicleMileageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MaintenancesMaintenanceIdMileagePut(nexusOpsTenant, maintenanceId, nexusOpsAppVersion, updateVehicleMileageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenancesApi.apiV1MaintenancesMaintenanceIdMileagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MaintenancesMaintenanceIdNotesPut(nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MaintenancesMaintenanceIdNotesPut(nexusOpsTenant, maintenanceId, nexusOpsAppVersion, generalNotesInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenancesApi.apiV1MaintenancesMaintenanceIdNotesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateMaintenanceDto} [updateMaintenanceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MaintenancesMaintenanceIdPut(nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, updateMaintenanceDto?: UpdateMaintenanceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MaintenancesMaintenanceIdPut(nexusOpsTenant, maintenanceId, nexusOpsAppVersion, updateMaintenanceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenancesApi.apiV1MaintenancesMaintenanceIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} maintenanceId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStageUpdateDtoOfMaintenanceStage} [generalStageUpdateDtoOfMaintenanceStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MaintenancesMaintenanceIdStagePut(nexusOpsTenant: string, maintenanceId: string, nexusOpsAppVersion?: string, generalStageUpdateDtoOfMaintenanceStage?: GeneralStageUpdateDtoOfMaintenanceStage, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MaintenancesMaintenanceIdStagePut(nexusOpsTenant, maintenanceId, nexusOpsAppVersion, generalStageUpdateDtoOfMaintenanceStage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenancesApi.apiV1MaintenancesMaintenanceIdStagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateMaintenanceDto} [createMaintenanceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MaintenancesPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createMaintenanceDto?: CreateMaintenanceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MaintenancesPost(nexusOpsTenant, nexusOpsAppVersion, createMaintenanceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenancesApi.apiV1MaintenancesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MaintenancesApi - factory interface
 * @export
 */
export const MaintenancesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaintenancesApiFp(configuration)
    return {
        /**
         * 
         * @param {MaintenancesApiApiV1MaintenancesBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesBulkDeleteDelete(requestParameters: MaintenancesApiApiV1MaintenancesBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1MaintenancesBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MaintenancesApiApiV1MaintenancesByIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesByIdsGet(requestParameters: MaintenancesApiApiV1MaintenancesByIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MaintenanceDto>> {
            return localVarFp.apiV1MaintenancesByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MaintenancesApiApiV1MaintenancesCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesCountersGet(requestParameters: MaintenancesApiApiV1MaintenancesCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceCountersDto> {
            return localVarFp.apiV1MaintenancesCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MaintenancesApiApiV1MaintenancesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesGetPost(requestParameters: MaintenancesApiApiV1MaintenancesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfMaintenanceDto> {
            return localVarFp.apiV1MaintenancesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.maintenanceGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdAddAssignmentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdAddAssignmentPost(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdAddAssignmentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceDto> {
            return localVarFp.apiV1MaintenancesMaintenanceIdAddAssignmentPost(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdDelete(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1MaintenancesMaintenanceIdDelete(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdExternalNumberPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdExternalNumberPut(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdExternalNumberPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceDto> {
            return localVarFp.apiV1MaintenancesMaintenanceIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdGet(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceDto> {
            return localVarFp.apiV1MaintenancesMaintenanceIdGet(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdMileagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdMileagePut(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdMileagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceDto> {
            return localVarFp.apiV1MaintenancesMaintenanceIdMileagePut(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleMileageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdNotesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdNotesPut(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdNotesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceDto> {
            return localVarFp.apiV1MaintenancesMaintenanceIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdPut(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceDto> {
            return localVarFp.apiV1MaintenancesMaintenanceIdPut(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, requestParameters.updateMaintenanceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdStagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesMaintenanceIdStagePut(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdStagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceDto> {
            return localVarFp.apiV1MaintenancesMaintenanceIdStagePut(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, requestParameters.generalStageUpdateDtoOfMaintenanceStage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MaintenancesApiApiV1MaintenancesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MaintenancesPost(requestParameters: MaintenancesApiApiV1MaintenancesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceDto> {
            return localVarFp.apiV1MaintenancesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createMaintenanceDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1MaintenancesBulkDeleteDelete operation in MaintenancesApi.
 * @export
 * @interface MaintenancesApiApiV1MaintenancesBulkDeleteDeleteRequest
 */
export interface MaintenancesApiApiV1MaintenancesBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof MaintenancesApiApiV1MaintenancesBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1MaintenancesByIdsGet operation in MaintenancesApi.
 * @export
 * @interface MaintenancesApiApiV1MaintenancesByIdsGetRequest
 */
export interface MaintenancesApiApiV1MaintenancesByIdsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesByIdsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesByIdsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof MaintenancesApiApiV1MaintenancesByIdsGet
     */
    readonly ids?: Array<string>
}

/**
 * Request parameters for apiV1MaintenancesCountersGet operation in MaintenancesApi.
 * @export
 * @interface MaintenancesApiApiV1MaintenancesCountersGetRequest
 */
export interface MaintenancesApiApiV1MaintenancesCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1MaintenancesGetPost operation in MaintenancesApi.
 * @export
 * @interface MaintenancesApiApiV1MaintenancesGetPostRequest
 */
export interface MaintenancesApiApiV1MaintenancesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {MaintenanceGetPaginatedDto}
     * @memberof MaintenancesApiApiV1MaintenancesGetPost
     */
    readonly maintenanceGetPaginatedDto?: MaintenanceGetPaginatedDto
}

/**
 * Request parameters for apiV1MaintenancesMaintenanceIdAddAssignmentPost operation in MaintenancesApi.
 * @export
 * @interface MaintenancesApiApiV1MaintenancesMaintenanceIdAddAssignmentPostRequest
 */
export interface MaintenancesApiApiV1MaintenancesMaintenanceIdAddAssignmentPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdAddAssignmentPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdAddAssignmentPost
     */
    readonly maintenanceId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdAddAssignmentPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentAddEntityDto}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdAddAssignmentPost
     */
    readonly assignmentAddEntityDto?: AssignmentAddEntityDto
}

/**
 * Request parameters for apiV1MaintenancesMaintenanceIdDelete operation in MaintenancesApi.
 * @export
 * @interface MaintenancesApiApiV1MaintenancesMaintenanceIdDeleteRequest
 */
export interface MaintenancesApiApiV1MaintenancesMaintenanceIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdDelete
     */
    readonly maintenanceId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1MaintenancesMaintenanceIdExternalNumberPut operation in MaintenancesApi.
 * @export
 * @interface MaintenancesApiApiV1MaintenancesMaintenanceIdExternalNumberPutRequest
 */
export interface MaintenancesApiApiV1MaintenancesMaintenanceIdExternalNumberPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdExternalNumberPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdExternalNumberPut
     */
    readonly maintenanceId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdExternalNumberPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralExternalNumberInputDto}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdExternalNumberPut
     */
    readonly generalExternalNumberInputDto?: GeneralExternalNumberInputDto
}

/**
 * Request parameters for apiV1MaintenancesMaintenanceIdGet operation in MaintenancesApi.
 * @export
 * @interface MaintenancesApiApiV1MaintenancesMaintenanceIdGetRequest
 */
export interface MaintenancesApiApiV1MaintenancesMaintenanceIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdGet
     */
    readonly maintenanceId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1MaintenancesMaintenanceIdMileagePut operation in MaintenancesApi.
 * @export
 * @interface MaintenancesApiApiV1MaintenancesMaintenanceIdMileagePutRequest
 */
export interface MaintenancesApiApiV1MaintenancesMaintenanceIdMileagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdMileagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdMileagePut
     */
    readonly maintenanceId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdMileagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateVehicleMileageDto}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdMileagePut
     */
    readonly updateVehicleMileageDto?: UpdateVehicleMileageDto
}

/**
 * Request parameters for apiV1MaintenancesMaintenanceIdNotesPut operation in MaintenancesApi.
 * @export
 * @interface MaintenancesApiApiV1MaintenancesMaintenanceIdNotesPutRequest
 */
export interface MaintenancesApiApiV1MaintenancesMaintenanceIdNotesPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdNotesPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdNotesPut
     */
    readonly maintenanceId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdNotesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralNotesInputDto}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdNotesPut
     */
    readonly generalNotesInputDto?: GeneralNotesInputDto
}

/**
 * Request parameters for apiV1MaintenancesMaintenanceIdPut operation in MaintenancesApi.
 * @export
 * @interface MaintenancesApiApiV1MaintenancesMaintenanceIdPutRequest
 */
export interface MaintenancesApiApiV1MaintenancesMaintenanceIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdPut
     */
    readonly maintenanceId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateMaintenanceDto}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdPut
     */
    readonly updateMaintenanceDto?: UpdateMaintenanceDto
}

/**
 * Request parameters for apiV1MaintenancesMaintenanceIdStagePut operation in MaintenancesApi.
 * @export
 * @interface MaintenancesApiApiV1MaintenancesMaintenanceIdStagePutRequest
 */
export interface MaintenancesApiApiV1MaintenancesMaintenanceIdStagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdStagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdStagePut
     */
    readonly maintenanceId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdStagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralStageUpdateDtoOfMaintenanceStage}
     * @memberof MaintenancesApiApiV1MaintenancesMaintenanceIdStagePut
     */
    readonly generalStageUpdateDtoOfMaintenanceStage?: GeneralStageUpdateDtoOfMaintenanceStage
}

/**
 * Request parameters for apiV1MaintenancesPost operation in MaintenancesApi.
 * @export
 * @interface MaintenancesApiApiV1MaintenancesPostRequest
 */
export interface MaintenancesApiApiV1MaintenancesPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof MaintenancesApiApiV1MaintenancesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateMaintenanceDto}
     * @memberof MaintenancesApiApiV1MaintenancesPost
     */
    readonly createMaintenanceDto?: CreateMaintenanceDto
}

/**
 * MaintenancesApi - object-oriented interface
 * @export
 * @class MaintenancesApi
 * @extends {BaseAPI}
 */
export class MaintenancesApi extends BaseAPI {
    /**
     * 
     * @param {MaintenancesApiApiV1MaintenancesBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApi
     */
    public apiV1MaintenancesBulkDeleteDelete(requestParameters: MaintenancesApiApiV1MaintenancesBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return MaintenancesApiFp(this.configuration).apiV1MaintenancesBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MaintenancesApiApiV1MaintenancesByIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApi
     */
    public apiV1MaintenancesByIdsGet(requestParameters: MaintenancesApiApiV1MaintenancesByIdsGetRequest, options?: RawAxiosRequestConfig) {
        return MaintenancesApiFp(this.configuration).apiV1MaintenancesByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MaintenancesApiApiV1MaintenancesCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApi
     */
    public apiV1MaintenancesCountersGet(requestParameters: MaintenancesApiApiV1MaintenancesCountersGetRequest, options?: RawAxiosRequestConfig) {
        return MaintenancesApiFp(this.configuration).apiV1MaintenancesCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MaintenancesApiApiV1MaintenancesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApi
     */
    public apiV1MaintenancesGetPost(requestParameters: MaintenancesApiApiV1MaintenancesGetPostRequest, options?: RawAxiosRequestConfig) {
        return MaintenancesApiFp(this.configuration).apiV1MaintenancesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.maintenanceGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdAddAssignmentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApi
     */
    public apiV1MaintenancesMaintenanceIdAddAssignmentPost(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdAddAssignmentPostRequest, options?: RawAxiosRequestConfig) {
        return MaintenancesApiFp(this.configuration).apiV1MaintenancesMaintenanceIdAddAssignmentPost(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApi
     */
    public apiV1MaintenancesMaintenanceIdDelete(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return MaintenancesApiFp(this.configuration).apiV1MaintenancesMaintenanceIdDelete(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdExternalNumberPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApi
     */
    public apiV1MaintenancesMaintenanceIdExternalNumberPut(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdExternalNumberPutRequest, options?: RawAxiosRequestConfig) {
        return MaintenancesApiFp(this.configuration).apiV1MaintenancesMaintenanceIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApi
     */
    public apiV1MaintenancesMaintenanceIdGet(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdGetRequest, options?: RawAxiosRequestConfig) {
        return MaintenancesApiFp(this.configuration).apiV1MaintenancesMaintenanceIdGet(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdMileagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApi
     */
    public apiV1MaintenancesMaintenanceIdMileagePut(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdMileagePutRequest, options?: RawAxiosRequestConfig) {
        return MaintenancesApiFp(this.configuration).apiV1MaintenancesMaintenanceIdMileagePut(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleMileageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdNotesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApi
     */
    public apiV1MaintenancesMaintenanceIdNotesPut(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdNotesPutRequest, options?: RawAxiosRequestConfig) {
        return MaintenancesApiFp(this.configuration).apiV1MaintenancesMaintenanceIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApi
     */
    public apiV1MaintenancesMaintenanceIdPut(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdPutRequest, options?: RawAxiosRequestConfig) {
        return MaintenancesApiFp(this.configuration).apiV1MaintenancesMaintenanceIdPut(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, requestParameters.updateMaintenanceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MaintenancesApiApiV1MaintenancesMaintenanceIdStagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApi
     */
    public apiV1MaintenancesMaintenanceIdStagePut(requestParameters: MaintenancesApiApiV1MaintenancesMaintenanceIdStagePutRequest, options?: RawAxiosRequestConfig) {
        return MaintenancesApiFp(this.configuration).apiV1MaintenancesMaintenanceIdStagePut(requestParameters.nexusOpsTenant, requestParameters.maintenanceId, requestParameters.nexusOpsAppVersion, requestParameters.generalStageUpdateDtoOfMaintenanceStage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MaintenancesApiApiV1MaintenancesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenancesApi
     */
    public apiV1MaintenancesPost(requestParameters: MaintenancesApiApiV1MaintenancesPostRequest, options?: RawAxiosRequestConfig) {
        return MaintenancesApiFp(this.configuration).apiV1MaintenancesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createMaintenanceDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NegotiationsApi - axios parameter creator
 * @export
 */
export const NegotiationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [negotiationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsAllowedActionsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, negotiationIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsAllowedActionsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/negotiations/allowed-actions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (negotiationIds) {
                localVarQueryParameter['negotiationIds'] = negotiationIds;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsByIdsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsByIdsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/negotiations/by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsChatsChatIdCurrentAllGet: async (nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsChatsChatIdCurrentAllGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('apiV1NegotiationsChatsChatIdCurrentAllGet', 'chatId', chatId)
            const localVarPath = `/api/v1/negotiations/chats/{chatId}/current/all`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {NegotiationGetPaginatedDto} [negotiationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, negotiationGetPaginatedDto?: NegotiationGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/negotiations/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(negotiationGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdAllowedActionsGet: async (nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdAllowedActionsGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'negotiationId' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdAllowedActionsGet', 'negotiationId', negotiationId)
            const localVarPath = `/api/v1/negotiations/{negotiationId}/allowed-actions`
                .replace(`{${"negotiationId"}}`, encodeURIComponent(String(negotiationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdDelete: async (nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'negotiationId' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdDelete', 'negotiationId', negotiationId)
            const localVarPath = `/api/v1/negotiations/{negotiationId}`
                .replace(`{${"negotiationId"}}`, encodeURIComponent(String(negotiationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdGet: async (nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'negotiationId' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdGet', 'negotiationId', negotiationId)
            const localVarPath = `/api/v1/negotiations/{negotiationId}`
                .replace(`{${"negotiationId"}}`, encodeURIComponent(String(negotiationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateNegotiationProposalDto} [createNegotiationProposalDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdProposalsPost: async (nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, createNegotiationProposalDto?: CreateNegotiationProposalDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdProposalsPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'negotiationId' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdProposalsPost', 'negotiationId', negotiationId)
            const localVarPath = `/api/v1/negotiations/{negotiationId}/proposals`
                .replace(`{${"negotiationId"}}`, encodeURIComponent(String(negotiationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNegotiationProposalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} proposalId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateNegotiationProposalDto} [updateNegotiationProposalDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdProposalsProposalIdPut: async (nexusOpsTenant: string, negotiationId: string, proposalId: string, nexusOpsAppVersion?: string, updateNegotiationProposalDto?: UpdateNegotiationProposalDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdProposalsProposalIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'negotiationId' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdProposalsProposalIdPut', 'negotiationId', negotiationId)
            // verify required parameter 'proposalId' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdProposalsProposalIdPut', 'proposalId', proposalId)
            const localVarPath = `/api/v1/negotiations/{negotiationId}/proposals/{proposalId}`
                .replace(`{${"negotiationId"}}`, encodeURIComponent(String(negotiationId)))
                .replace(`{${"proposalId"}}`, encodeURIComponent(String(proposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNegotiationProposalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateNegotiationDto} [updateNegotiationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdPut: async (nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, updateNegotiationDto?: UpdateNegotiationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'negotiationId' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdPut', 'negotiationId', negotiationId)
            const localVarPath = `/api/v1/negotiations/{negotiationId}`
                .replace(`{${"negotiationId"}}`, encodeURIComponent(String(negotiationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNegotiationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AgreeOrDisagreeWithNegotiationProposalResponseDto} [agreeOrDisagreeWithNegotiationProposalResponseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdRespondAgreePost: async (nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, agreeOrDisagreeWithNegotiationProposalResponseDto?: AgreeOrDisagreeWithNegotiationProposalResponseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdRespondAgreePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'negotiationId' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdRespondAgreePost', 'negotiationId', negotiationId)
            const localVarPath = `/api/v1/negotiations/{negotiationId}/respond/agree`
                .replace(`{${"negotiationId"}}`, encodeURIComponent(String(negotiationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agreeOrDisagreeWithNegotiationProposalResponseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AgreeOrDisagreeWithNegotiationProposalResponseDto} [agreeOrDisagreeWithNegotiationProposalResponseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdRespondDisagreePost: async (nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, agreeOrDisagreeWithNegotiationProposalResponseDto?: AgreeOrDisagreeWithNegotiationProposalResponseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdRespondDisagreePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'negotiationId' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdRespondDisagreePost', 'negotiationId', negotiationId)
            const localVarPath = `/api/v1/negotiations/{negotiationId}/respond/disagree`
                .replace(`{${"negotiationId"}}`, encodeURIComponent(String(negotiationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agreeOrDisagreeWithNegotiationProposalResponseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RespondOnNegotiationProposalDto} [respondOnNegotiationProposalDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdRespondPost: async (nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, respondOnNegotiationProposalDto?: RespondOnNegotiationProposalDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdRespondPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'negotiationId' is not null or undefined
            assertParamExists('apiV1NegotiationsNegotiationIdRespondPost', 'negotiationId', negotiationId)
            const localVarPath = `/api/v1/negotiations/{negotiationId}/respond`
                .replace(`{${"negotiationId"}}`, encodeURIComponent(String(negotiationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(respondOnNegotiationProposalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get info to respond on many negotiation proposals in one or multiple negotiations.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RespondOnManyProposalsInfoRequestDto} [respondOnManyProposalsInfoRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsProposalsRespondOnManyInfoGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, respondOnManyProposalsInfoRequestDto?: RespondOnManyProposalsInfoRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsProposalsRespondOnManyInfoGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/negotiations/proposals/respond-on-many/info/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(respondOnManyProposalsInfoRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Respond on many negotiation proposals in one or multiple negotiations.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RespondOnManyProposalsDto} [respondOnManyProposalsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsProposalsRespondOnManyNegotiationsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, respondOnManyProposalsDto?: RespondOnManyProposalsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NegotiationsProposalsRespondOnManyNegotiationsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/negotiations/proposals/respond-on-many-negotiations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(respondOnManyProposalsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NegotiationsApi - functional programming interface
 * @export
 */
export const NegotiationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NegotiationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [negotiationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsAllowedActionsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, negotiationIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NegotiationAllowedActionsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsAllowedActionsGet(nexusOpsTenant, nexusOpsAppVersion, negotiationIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsAllowedActionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsByIdsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NegotiationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsByIdsGet(nexusOpsTenant, nexusOpsAppVersion, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsByIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} chatId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsChatsChatIdCurrentAllGet(nexusOpsTenant: string, chatId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NegotiationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsChatsChatIdCurrentAllGet(nexusOpsTenant, chatId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsChatsChatIdCurrentAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {NegotiationGetPaginatedDto} [negotiationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, negotiationGetPaginatedDto?: NegotiationGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfNegotiationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsGetPost(nexusOpsTenant, nexusOpsAppVersion, negotiationGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsNegotiationIdAllowedActionsGet(nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NegotiationAllowedActionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsNegotiationIdAllowedActionsGet(nexusOpsTenant, negotiationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsNegotiationIdAllowedActionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsNegotiationIdDelete(nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsNegotiationIdDelete(nexusOpsTenant, negotiationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsNegotiationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsNegotiationIdGet(nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NegotiationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsNegotiationIdGet(nexusOpsTenant, negotiationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsNegotiationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateNegotiationProposalDto} [createNegotiationProposalDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsNegotiationIdProposalsPost(nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, createNegotiationProposalDto?: CreateNegotiationProposalDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NegotiationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsNegotiationIdProposalsPost(nexusOpsTenant, negotiationId, nexusOpsAppVersion, createNegotiationProposalDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsNegotiationIdProposalsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} proposalId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateNegotiationProposalDto} [updateNegotiationProposalDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsNegotiationIdProposalsProposalIdPut(nexusOpsTenant: string, negotiationId: string, proposalId: string, nexusOpsAppVersion?: string, updateNegotiationProposalDto?: UpdateNegotiationProposalDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NegotiationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsNegotiationIdProposalsProposalIdPut(nexusOpsTenant, negotiationId, proposalId, nexusOpsAppVersion, updateNegotiationProposalDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsNegotiationIdProposalsProposalIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateNegotiationDto} [updateNegotiationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsNegotiationIdPut(nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, updateNegotiationDto?: UpdateNegotiationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NegotiationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsNegotiationIdPut(nexusOpsTenant, negotiationId, nexusOpsAppVersion, updateNegotiationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsNegotiationIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AgreeOrDisagreeWithNegotiationProposalResponseDto} [agreeOrDisagreeWithNegotiationProposalResponseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsNegotiationIdRespondAgreePost(nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, agreeOrDisagreeWithNegotiationProposalResponseDto?: AgreeOrDisagreeWithNegotiationProposalResponseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NegotiationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsNegotiationIdRespondAgreePost(nexusOpsTenant, negotiationId, nexusOpsAppVersion, agreeOrDisagreeWithNegotiationProposalResponseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsNegotiationIdRespondAgreePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AgreeOrDisagreeWithNegotiationProposalResponseDto} [agreeOrDisagreeWithNegotiationProposalResponseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsNegotiationIdRespondDisagreePost(nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, agreeOrDisagreeWithNegotiationProposalResponseDto?: AgreeOrDisagreeWithNegotiationProposalResponseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NegotiationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsNegotiationIdRespondDisagreePost(nexusOpsTenant, negotiationId, nexusOpsAppVersion, agreeOrDisagreeWithNegotiationProposalResponseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsNegotiationIdRespondDisagreePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} negotiationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RespondOnNegotiationProposalDto} [respondOnNegotiationProposalDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsNegotiationIdRespondPost(nexusOpsTenant: string, negotiationId: string, nexusOpsAppVersion?: string, respondOnNegotiationProposalDto?: RespondOnNegotiationProposalDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NegotiationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsNegotiationIdRespondPost(nexusOpsTenant, negotiationId, nexusOpsAppVersion, respondOnNegotiationProposalDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsNegotiationIdRespondPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get info to respond on many negotiation proposals in one or multiple negotiations.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RespondOnManyProposalsInfoRequestDto} [respondOnManyProposalsInfoRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsProposalsRespondOnManyInfoGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, respondOnManyProposalsInfoRequestDto?: RespondOnManyProposalsInfoRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RespondOnManyProposalsInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsProposalsRespondOnManyInfoGetPost(nexusOpsTenant, nexusOpsAppVersion, respondOnManyProposalsInfoRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsProposalsRespondOnManyInfoGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Respond on many negotiation proposals in one or multiple negotiations.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RespondOnManyProposalsDto} [respondOnManyProposalsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NegotiationsProposalsRespondOnManyNegotiationsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, respondOnManyProposalsDto?: RespondOnManyProposalsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NegotiationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NegotiationsProposalsRespondOnManyNegotiationsPost(nexusOpsTenant, nexusOpsAppVersion, respondOnManyProposalsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NegotiationsApi.apiV1NegotiationsProposalsRespondOnManyNegotiationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NegotiationsApi - factory interface
 * @export
 */
export const NegotiationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NegotiationsApiFp(configuration)
    return {
        /**
         * 
         * @param {NegotiationsApiApiV1NegotiationsAllowedActionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsAllowedActionsGet(requestParameters: NegotiationsApiApiV1NegotiationsAllowedActionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<NegotiationAllowedActionsDto>> {
            return localVarFp.apiV1NegotiationsAllowedActionsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.negotiationIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NegotiationsApiApiV1NegotiationsByIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsByIdsGet(requestParameters: NegotiationsApiApiV1NegotiationsByIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<NegotiationDto>> {
            return localVarFp.apiV1NegotiationsByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NegotiationsApiApiV1NegotiationsChatsChatIdCurrentAllGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsChatsChatIdCurrentAllGet(requestParameters: NegotiationsApiApiV1NegotiationsChatsChatIdCurrentAllGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<NegotiationDto>> {
            return localVarFp.apiV1NegotiationsChatsChatIdCurrentAllGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NegotiationsApiApiV1NegotiationsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsGetPost(requestParameters: NegotiationsApiApiV1NegotiationsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfNegotiationDto> {
            return localVarFp.apiV1NegotiationsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.negotiationGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NegotiationsApiApiV1NegotiationsNegotiationIdAllowedActionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdAllowedActionsGet(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdAllowedActionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<NegotiationAllowedActionsDto> {
            return localVarFp.apiV1NegotiationsNegotiationIdAllowedActionsGet(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NegotiationsApiApiV1NegotiationsNegotiationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdDelete(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1NegotiationsNegotiationIdDelete(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NegotiationsApiApiV1NegotiationsNegotiationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdGet(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<NegotiationDto> {
            return localVarFp.apiV1NegotiationsNegotiationIdGet(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NegotiationsApiApiV1NegotiationsNegotiationIdProposalsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdProposalsPost(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdProposalsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<NegotiationDto> {
            return localVarFp.apiV1NegotiationsNegotiationIdProposalsPost(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, requestParameters.createNegotiationProposalDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NegotiationsApiApiV1NegotiationsNegotiationIdProposalsProposalIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdProposalsProposalIdPut(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdProposalsProposalIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<NegotiationDto> {
            return localVarFp.apiV1NegotiationsNegotiationIdProposalsProposalIdPut(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.proposalId, requestParameters.nexusOpsAppVersion, requestParameters.updateNegotiationProposalDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NegotiationsApiApiV1NegotiationsNegotiationIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdPut(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<NegotiationDto> {
            return localVarFp.apiV1NegotiationsNegotiationIdPut(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, requestParameters.updateNegotiationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NegotiationsApiApiV1NegotiationsNegotiationIdRespondAgreePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdRespondAgreePost(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdRespondAgreePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<NegotiationDto> {
            return localVarFp.apiV1NegotiationsNegotiationIdRespondAgreePost(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, requestParameters.agreeOrDisagreeWithNegotiationProposalResponseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NegotiationsApiApiV1NegotiationsNegotiationIdRespondDisagreePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdRespondDisagreePost(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdRespondDisagreePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<NegotiationDto> {
            return localVarFp.apiV1NegotiationsNegotiationIdRespondDisagreePost(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, requestParameters.agreeOrDisagreeWithNegotiationProposalResponseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NegotiationsApiApiV1NegotiationsNegotiationIdRespondPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsNegotiationIdRespondPost(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdRespondPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<NegotiationDto> {
            return localVarFp.apiV1NegotiationsNegotiationIdRespondPost(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, requestParameters.respondOnNegotiationProposalDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get info to respond on many negotiation proposals in one or multiple negotiations.
         * @param {NegotiationsApiApiV1NegotiationsProposalsRespondOnManyInfoGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsProposalsRespondOnManyInfoGetPost(requestParameters: NegotiationsApiApiV1NegotiationsProposalsRespondOnManyInfoGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RespondOnManyProposalsInfoDto> {
            return localVarFp.apiV1NegotiationsProposalsRespondOnManyInfoGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.respondOnManyProposalsInfoRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Respond on many negotiation proposals in one or multiple negotiations.
         * @param {NegotiationsApiApiV1NegotiationsProposalsRespondOnManyNegotiationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NegotiationsProposalsRespondOnManyNegotiationsPost(requestParameters: NegotiationsApiApiV1NegotiationsProposalsRespondOnManyNegotiationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<NegotiationDto>> {
            return localVarFp.apiV1NegotiationsProposalsRespondOnManyNegotiationsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.respondOnManyProposalsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1NegotiationsAllowedActionsGet operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsAllowedActionsGetRequest
 */
export interface NegotiationsApiApiV1NegotiationsAllowedActionsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsAllowedActionsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsAllowedActionsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof NegotiationsApiApiV1NegotiationsAllowedActionsGet
     */
    readonly negotiationIds?: Array<string>
}

/**
 * Request parameters for apiV1NegotiationsByIdsGet operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsByIdsGetRequest
 */
export interface NegotiationsApiApiV1NegotiationsByIdsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsByIdsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsByIdsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof NegotiationsApiApiV1NegotiationsByIdsGet
     */
    readonly ids?: Array<string>
}

/**
 * Request parameters for apiV1NegotiationsChatsChatIdCurrentAllGet operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsChatsChatIdCurrentAllGetRequest
 */
export interface NegotiationsApiApiV1NegotiationsChatsChatIdCurrentAllGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsChatsChatIdCurrentAllGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsChatsChatIdCurrentAllGet
     */
    readonly chatId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsChatsChatIdCurrentAllGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1NegotiationsGetPost operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsGetPostRequest
 */
export interface NegotiationsApiApiV1NegotiationsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {NegotiationGetPaginatedDto}
     * @memberof NegotiationsApiApiV1NegotiationsGetPost
     */
    readonly negotiationGetPaginatedDto?: NegotiationGetPaginatedDto
}

/**
 * Request parameters for apiV1NegotiationsNegotiationIdAllowedActionsGet operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsNegotiationIdAllowedActionsGetRequest
 */
export interface NegotiationsApiApiV1NegotiationsNegotiationIdAllowedActionsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdAllowedActionsGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdAllowedActionsGet
     */
    readonly negotiationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdAllowedActionsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1NegotiationsNegotiationIdDelete operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsNegotiationIdDeleteRequest
 */
export interface NegotiationsApiApiV1NegotiationsNegotiationIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdDelete
     */
    readonly negotiationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1NegotiationsNegotiationIdGet operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsNegotiationIdGetRequest
 */
export interface NegotiationsApiApiV1NegotiationsNegotiationIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdGet
     */
    readonly negotiationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1NegotiationsNegotiationIdProposalsPost operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsNegotiationIdProposalsPostRequest
 */
export interface NegotiationsApiApiV1NegotiationsNegotiationIdProposalsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdProposalsPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdProposalsPost
     */
    readonly negotiationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdProposalsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateNegotiationProposalDto}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdProposalsPost
     */
    readonly createNegotiationProposalDto?: CreateNegotiationProposalDto
}

/**
 * Request parameters for apiV1NegotiationsNegotiationIdProposalsProposalIdPut operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsNegotiationIdProposalsProposalIdPutRequest
 */
export interface NegotiationsApiApiV1NegotiationsNegotiationIdProposalsProposalIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdProposalsProposalIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdProposalsProposalIdPut
     */
    readonly negotiationId: string

    /**
     * 
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdProposalsProposalIdPut
     */
    readonly proposalId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdProposalsProposalIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateNegotiationProposalDto}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdProposalsProposalIdPut
     */
    readonly updateNegotiationProposalDto?: UpdateNegotiationProposalDto
}

/**
 * Request parameters for apiV1NegotiationsNegotiationIdPut operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsNegotiationIdPutRequest
 */
export interface NegotiationsApiApiV1NegotiationsNegotiationIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdPut
     */
    readonly negotiationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateNegotiationDto}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdPut
     */
    readonly updateNegotiationDto?: UpdateNegotiationDto
}

/**
 * Request parameters for apiV1NegotiationsNegotiationIdRespondAgreePost operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsNegotiationIdRespondAgreePostRequest
 */
export interface NegotiationsApiApiV1NegotiationsNegotiationIdRespondAgreePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdRespondAgreePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdRespondAgreePost
     */
    readonly negotiationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdRespondAgreePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AgreeOrDisagreeWithNegotiationProposalResponseDto}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdRespondAgreePost
     */
    readonly agreeOrDisagreeWithNegotiationProposalResponseDto?: AgreeOrDisagreeWithNegotiationProposalResponseDto
}

/**
 * Request parameters for apiV1NegotiationsNegotiationIdRespondDisagreePost operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsNegotiationIdRespondDisagreePostRequest
 */
export interface NegotiationsApiApiV1NegotiationsNegotiationIdRespondDisagreePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdRespondDisagreePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdRespondDisagreePost
     */
    readonly negotiationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdRespondDisagreePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AgreeOrDisagreeWithNegotiationProposalResponseDto}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdRespondDisagreePost
     */
    readonly agreeOrDisagreeWithNegotiationProposalResponseDto?: AgreeOrDisagreeWithNegotiationProposalResponseDto
}

/**
 * Request parameters for apiV1NegotiationsNegotiationIdRespondPost operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsNegotiationIdRespondPostRequest
 */
export interface NegotiationsApiApiV1NegotiationsNegotiationIdRespondPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdRespondPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdRespondPost
     */
    readonly negotiationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdRespondPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RespondOnNegotiationProposalDto}
     * @memberof NegotiationsApiApiV1NegotiationsNegotiationIdRespondPost
     */
    readonly respondOnNegotiationProposalDto?: RespondOnNegotiationProposalDto
}

/**
 * Request parameters for apiV1NegotiationsProposalsRespondOnManyInfoGetPost operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsProposalsRespondOnManyInfoGetPostRequest
 */
export interface NegotiationsApiApiV1NegotiationsProposalsRespondOnManyInfoGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsProposalsRespondOnManyInfoGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsProposalsRespondOnManyInfoGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RespondOnManyProposalsInfoRequestDto}
     * @memberof NegotiationsApiApiV1NegotiationsProposalsRespondOnManyInfoGetPost
     */
    readonly respondOnManyProposalsInfoRequestDto?: RespondOnManyProposalsInfoRequestDto
}

/**
 * Request parameters for apiV1NegotiationsProposalsRespondOnManyNegotiationsPost operation in NegotiationsApi.
 * @export
 * @interface NegotiationsApiApiV1NegotiationsProposalsRespondOnManyNegotiationsPostRequest
 */
export interface NegotiationsApiApiV1NegotiationsProposalsRespondOnManyNegotiationsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsProposalsRespondOnManyNegotiationsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NegotiationsApiApiV1NegotiationsProposalsRespondOnManyNegotiationsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RespondOnManyProposalsDto}
     * @memberof NegotiationsApiApiV1NegotiationsProposalsRespondOnManyNegotiationsPost
     */
    readonly respondOnManyProposalsDto?: RespondOnManyProposalsDto
}

/**
 * NegotiationsApi - object-oriented interface
 * @export
 * @class NegotiationsApi
 * @extends {BaseAPI}
 */
export class NegotiationsApi extends BaseAPI {
    /**
     * 
     * @param {NegotiationsApiApiV1NegotiationsAllowedActionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsAllowedActionsGet(requestParameters: NegotiationsApiApiV1NegotiationsAllowedActionsGetRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsAllowedActionsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.negotiationIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NegotiationsApiApiV1NegotiationsByIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsByIdsGet(requestParameters: NegotiationsApiApiV1NegotiationsByIdsGetRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NegotiationsApiApiV1NegotiationsChatsChatIdCurrentAllGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsChatsChatIdCurrentAllGet(requestParameters: NegotiationsApiApiV1NegotiationsChatsChatIdCurrentAllGetRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsChatsChatIdCurrentAllGet(requestParameters.nexusOpsTenant, requestParameters.chatId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NegotiationsApiApiV1NegotiationsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsGetPost(requestParameters: NegotiationsApiApiV1NegotiationsGetPostRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.negotiationGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NegotiationsApiApiV1NegotiationsNegotiationIdAllowedActionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsNegotiationIdAllowedActionsGet(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdAllowedActionsGetRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsNegotiationIdAllowedActionsGet(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NegotiationsApiApiV1NegotiationsNegotiationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsNegotiationIdDelete(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsNegotiationIdDelete(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NegotiationsApiApiV1NegotiationsNegotiationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsNegotiationIdGet(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdGetRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsNegotiationIdGet(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NegotiationsApiApiV1NegotiationsNegotiationIdProposalsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsNegotiationIdProposalsPost(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdProposalsPostRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsNegotiationIdProposalsPost(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, requestParameters.createNegotiationProposalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NegotiationsApiApiV1NegotiationsNegotiationIdProposalsProposalIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsNegotiationIdProposalsProposalIdPut(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdProposalsProposalIdPutRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsNegotiationIdProposalsProposalIdPut(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.proposalId, requestParameters.nexusOpsAppVersion, requestParameters.updateNegotiationProposalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NegotiationsApiApiV1NegotiationsNegotiationIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsNegotiationIdPut(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdPutRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsNegotiationIdPut(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, requestParameters.updateNegotiationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NegotiationsApiApiV1NegotiationsNegotiationIdRespondAgreePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsNegotiationIdRespondAgreePost(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdRespondAgreePostRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsNegotiationIdRespondAgreePost(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, requestParameters.agreeOrDisagreeWithNegotiationProposalResponseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NegotiationsApiApiV1NegotiationsNegotiationIdRespondDisagreePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsNegotiationIdRespondDisagreePost(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdRespondDisagreePostRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsNegotiationIdRespondDisagreePost(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, requestParameters.agreeOrDisagreeWithNegotiationProposalResponseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NegotiationsApiApiV1NegotiationsNegotiationIdRespondPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsNegotiationIdRespondPost(requestParameters: NegotiationsApiApiV1NegotiationsNegotiationIdRespondPostRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsNegotiationIdRespondPost(requestParameters.nexusOpsTenant, requestParameters.negotiationId, requestParameters.nexusOpsAppVersion, requestParameters.respondOnNegotiationProposalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get info to respond on many negotiation proposals in one or multiple negotiations.
     * @param {NegotiationsApiApiV1NegotiationsProposalsRespondOnManyInfoGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsProposalsRespondOnManyInfoGetPost(requestParameters: NegotiationsApiApiV1NegotiationsProposalsRespondOnManyInfoGetPostRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsProposalsRespondOnManyInfoGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.respondOnManyProposalsInfoRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Respond on many negotiation proposals in one or multiple negotiations.
     * @param {NegotiationsApiApiV1NegotiationsProposalsRespondOnManyNegotiationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NegotiationsApi
     */
    public apiV1NegotiationsProposalsRespondOnManyNegotiationsPost(requestParameters: NegotiationsApiApiV1NegotiationsProposalsRespondOnManyNegotiationsPostRequest, options?: RawAxiosRequestConfig) {
        return NegotiationsApiFp(this.configuration).apiV1NegotiationsProposalsRespondOnManyNegotiationsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.respondOnManyProposalsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsAllDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NotificationsAllDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/notifications/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsAllMarkAsReadPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NotificationsAllMarkAsReadPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/notifications/all/mark-as-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {NotificationImportance} [importance] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantId?: string, importance?: NotificationImportance, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NotificationsCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/notifications/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (importance !== undefined) {
                localVarQueryParameter['importance'] = importance;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {string} [tenantId] 
         * @param {NotificationImportance} [importance] 
         * @param {boolean} [isRead] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, offset?: number, limit?: number, tenantId?: string, importance?: NotificationImportance, isRead?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NotificationsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (importance !== undefined) {
                localVarQueryParameter['importance'] = importance;
            }

            if (isRead !== undefined) {
                localVarQueryParameter['isRead'] = isRead;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} notificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsNotificationIdDelete: async (nexusOpsTenant: string, notificationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NotificationsNotificationIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('apiV1NotificationsNotificationIdDelete', 'notificationId', notificationId)
            const localVarPath = `/api/v1/notifications/{notificationId}`
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} notificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsNotificationIdMarkAsReadPost: async (nexusOpsTenant: string, notificationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NotificationsNotificationIdMarkAsReadPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('apiV1NotificationsNotificationIdMarkAsReadPost', 'notificationId', notificationId)
            const localVarPath = `/api/v1/notifications/{notificationId}/mark-as-read`
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {NotificationSendTestDto} [notificationSendTestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsTestSendPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, notificationSendTestDto?: NotificationSendTestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1NotificationsTestSendPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/notifications/test/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationSendTestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NotificationsAllDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NotificationsAllDelete(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1NotificationsAllDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NotificationsAllMarkAsReadPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NotificationsAllMarkAsReadPost(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1NotificationsAllMarkAsReadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {NotificationImportance} [importance] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NotificationsCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantId?: string, importance?: NotificationImportance, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NotificationsCountersGet(nexusOpsTenant, nexusOpsAppVersion, tenantId, importance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1NotificationsCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {string} [tenantId] 
         * @param {NotificationImportance} [importance] 
         * @param {boolean} [isRead] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NotificationsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, offset?: number, limit?: number, tenantId?: string, importance?: NotificationImportance, isRead?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfNotificationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NotificationsGet(nexusOpsTenant, nexusOpsAppVersion, offset, limit, tenantId, importance, isRead, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1NotificationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} notificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NotificationsNotificationIdDelete(nexusOpsTenant: string, notificationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NotificationsNotificationIdDelete(nexusOpsTenant, notificationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1NotificationsNotificationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} notificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NotificationsNotificationIdMarkAsReadPost(nexusOpsTenant: string, notificationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NotificationsNotificationIdMarkAsReadPost(nexusOpsTenant, notificationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1NotificationsNotificationIdMarkAsReadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {NotificationSendTestDto} [notificationSendTestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NotificationsTestSendPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, notificationSendTestDto?: NotificationSendTestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NotificationsTestSendPost(nexusOpsTenant, nexusOpsAppVersion, notificationSendTestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiV1NotificationsTestSendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @param {NotificationsApiApiV1NotificationsAllDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsAllDelete(requestParameters: NotificationsApiApiV1NotificationsAllDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1NotificationsAllDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiApiV1NotificationsAllMarkAsReadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsAllMarkAsReadPost(requestParameters: NotificationsApiApiV1NotificationsAllMarkAsReadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1NotificationsAllMarkAsReadPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiApiV1NotificationsCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsCountersGet(requestParameters: NotificationsApiApiV1NotificationsCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotificationCountersDto> {
            return localVarFp.apiV1NotificationsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.importance, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiApiV1NotificationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsGet(requestParameters: NotificationsApiApiV1NotificationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfNotificationDto> {
            return localVarFp.apiV1NotificationsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.offset, requestParameters.limit, requestParameters.tenantId, requestParameters.importance, requestParameters.isRead, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiApiV1NotificationsNotificationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsNotificationIdDelete(requestParameters: NotificationsApiApiV1NotificationsNotificationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1NotificationsNotificationIdDelete(requestParameters.nexusOpsTenant, requestParameters.notificationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiApiV1NotificationsNotificationIdMarkAsReadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsNotificationIdMarkAsReadPost(requestParameters: NotificationsApiApiV1NotificationsNotificationIdMarkAsReadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1NotificationsNotificationIdMarkAsReadPost(requestParameters.nexusOpsTenant, requestParameters.notificationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiApiV1NotificationsTestSendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsTestSendPost(requestParameters: NotificationsApiApiV1NotificationsTestSendPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1NotificationsTestSendPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.notificationSendTestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1NotificationsAllDelete operation in NotificationsApi.
 * @export
 * @interface NotificationsApiApiV1NotificationsAllDeleteRequest
 */
export interface NotificationsApiApiV1NotificationsAllDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsAllDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsAllDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1NotificationsAllMarkAsReadPost operation in NotificationsApi.
 * @export
 * @interface NotificationsApiApiV1NotificationsAllMarkAsReadPostRequest
 */
export interface NotificationsApiApiV1NotificationsAllMarkAsReadPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsAllMarkAsReadPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsAllMarkAsReadPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1NotificationsCountersGet operation in NotificationsApi.
 * @export
 * @interface NotificationsApiApiV1NotificationsCountersGetRequest
 */
export interface NotificationsApiApiV1NotificationsCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsCountersGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsCountersGet
     */
    readonly tenantId?: string

    /**
     * 
     * @type {NotificationImportance}
     * @memberof NotificationsApiApiV1NotificationsCountersGet
     */
    readonly importance?: NotificationImportance
}

/**
 * Request parameters for apiV1NotificationsGet operation in NotificationsApi.
 * @export
 * @interface NotificationsApiApiV1NotificationsGetRequest
 */
export interface NotificationsApiApiV1NotificationsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {number}
     * @memberof NotificationsApiApiV1NotificationsGet
     */
    readonly offset?: number

    /**
     * 
     * @type {number}
     * @memberof NotificationsApiApiV1NotificationsGet
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsGet
     */
    readonly tenantId?: string

    /**
     * 
     * @type {NotificationImportance}
     * @memberof NotificationsApiApiV1NotificationsGet
     */
    readonly importance?: NotificationImportance

    /**
     * 
     * @type {boolean}
     * @memberof NotificationsApiApiV1NotificationsGet
     */
    readonly isRead?: boolean
}

/**
 * Request parameters for apiV1NotificationsNotificationIdDelete operation in NotificationsApi.
 * @export
 * @interface NotificationsApiApiV1NotificationsNotificationIdDeleteRequest
 */
export interface NotificationsApiApiV1NotificationsNotificationIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsNotificationIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsNotificationIdDelete
     */
    readonly notificationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsNotificationIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1NotificationsNotificationIdMarkAsReadPost operation in NotificationsApi.
 * @export
 * @interface NotificationsApiApiV1NotificationsNotificationIdMarkAsReadPostRequest
 */
export interface NotificationsApiApiV1NotificationsNotificationIdMarkAsReadPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsNotificationIdMarkAsReadPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsNotificationIdMarkAsReadPost
     */
    readonly notificationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsNotificationIdMarkAsReadPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1NotificationsTestSendPost operation in NotificationsApi.
 * @export
 * @interface NotificationsApiApiV1NotificationsTestSendPostRequest
 */
export interface NotificationsApiApiV1NotificationsTestSendPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsTestSendPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NotificationsApiApiV1NotificationsTestSendPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {NotificationSendTestDto}
     * @memberof NotificationsApiApiV1NotificationsTestSendPost
     */
    readonly notificationSendTestDto?: NotificationSendTestDto
}

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @param {NotificationsApiApiV1NotificationsAllDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1NotificationsAllDelete(requestParameters: NotificationsApiApiV1NotificationsAllDeleteRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1NotificationsAllDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiApiV1NotificationsAllMarkAsReadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1NotificationsAllMarkAsReadPost(requestParameters: NotificationsApiApiV1NotificationsAllMarkAsReadPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1NotificationsAllMarkAsReadPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiApiV1NotificationsCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1NotificationsCountersGet(requestParameters: NotificationsApiApiV1NotificationsCountersGetRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1NotificationsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.importance, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiApiV1NotificationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1NotificationsGet(requestParameters: NotificationsApiApiV1NotificationsGetRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1NotificationsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.offset, requestParameters.limit, requestParameters.tenantId, requestParameters.importance, requestParameters.isRead, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiApiV1NotificationsNotificationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1NotificationsNotificationIdDelete(requestParameters: NotificationsApiApiV1NotificationsNotificationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1NotificationsNotificationIdDelete(requestParameters.nexusOpsTenant, requestParameters.notificationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiApiV1NotificationsNotificationIdMarkAsReadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1NotificationsNotificationIdMarkAsReadPost(requestParameters: NotificationsApiApiV1NotificationsNotificationIdMarkAsReadPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1NotificationsNotificationIdMarkAsReadPost(requestParameters.nexusOpsTenant, requestParameters.notificationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiApiV1NotificationsTestSendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiV1NotificationsTestSendPost(requestParameters: NotificationsApiApiV1NotificationsTestSendPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiV1NotificationsTestSendPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.notificationSendTestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationsAdminApi - axios parameter creator
 * @export
 */
export const NotificationsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminNotificationGetPaginatedDto} [adminNotificationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminNotificationsGetPost: async (nexusOpsAppVersion?: string, adminNotificationGetPaginatedDto?: AdminNotificationGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/notifications/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminNotificationGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminNotificationsNotificationIdGet: async (notificationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('apiV1AdminNotificationsNotificationIdGet', 'notificationId', notificationId)
            const localVarPath = `/api/v1/admin/notifications/{notificationId}`
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminNotificationsNotificationIdResendPost: async (notificationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('apiV1AdminNotificationsNotificationIdResendPost', 'notificationId', notificationId)
            const localVarPath = `/api/v1/admin/notifications/{notificationId}/resend`
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateNotificationDto} [adminCreateNotificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminNotificationsPost: async (nexusOpsAppVersion?: string, adminCreateNotificationDto?: AdminCreateNotificationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateNotificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsAdminApi - functional programming interface
 * @export
 */
export const NotificationsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminNotificationGetPaginatedDto} [adminNotificationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminNotificationsGetPost(nexusOpsAppVersion?: string, adminNotificationGetPaginatedDto?: AdminNotificationGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminNotificationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminNotificationsGetPost(nexusOpsAppVersion, adminNotificationGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsAdminApi.apiV1AdminNotificationsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminNotificationsNotificationIdGet(notificationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNotificationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminNotificationsNotificationIdGet(notificationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsAdminApi.apiV1AdminNotificationsNotificationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminNotificationsNotificationIdResendPost(notificationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNotificationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminNotificationsNotificationIdResendPost(notificationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsAdminApi.apiV1AdminNotificationsNotificationIdResendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateNotificationDto} [adminCreateNotificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminNotificationsPost(nexusOpsAppVersion?: string, adminCreateNotificationDto?: AdminCreateNotificationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNotificationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminNotificationsPost(nexusOpsAppVersion, adminCreateNotificationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsAdminApi.apiV1AdminNotificationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsAdminApi - factory interface
 * @export
 */
export const NotificationsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {NotificationsAdminApiApiV1AdminNotificationsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminNotificationsGetPost(requestParameters: NotificationsAdminApiApiV1AdminNotificationsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminNotificationDto> {
            return localVarFp.apiV1AdminNotificationsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminNotificationGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsAdminApiApiV1AdminNotificationsNotificationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminNotificationsNotificationIdGet(requestParameters: NotificationsAdminApiApiV1AdminNotificationsNotificationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNotificationDto> {
            return localVarFp.apiV1AdminNotificationsNotificationIdGet(requestParameters.notificationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsAdminApiApiV1AdminNotificationsNotificationIdResendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminNotificationsNotificationIdResendPost(requestParameters: NotificationsAdminApiApiV1AdminNotificationsNotificationIdResendPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNotificationDto> {
            return localVarFp.apiV1AdminNotificationsNotificationIdResendPost(requestParameters.notificationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsAdminApiApiV1AdminNotificationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminNotificationsPost(requestParameters: NotificationsAdminApiApiV1AdminNotificationsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminNotificationDto> {
            return localVarFp.apiV1AdminNotificationsPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateNotificationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminNotificationsGetPost operation in NotificationsAdminApi.
 * @export
 * @interface NotificationsAdminApiApiV1AdminNotificationsGetPostRequest
 */
export interface NotificationsAdminApiApiV1AdminNotificationsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NotificationsAdminApiApiV1AdminNotificationsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminNotificationGetPaginatedDto}
     * @memberof NotificationsAdminApiApiV1AdminNotificationsGetPost
     */
    readonly adminNotificationGetPaginatedDto?: AdminNotificationGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminNotificationsNotificationIdGet operation in NotificationsAdminApi.
 * @export
 * @interface NotificationsAdminApiApiV1AdminNotificationsNotificationIdGetRequest
 */
export interface NotificationsAdminApiApiV1AdminNotificationsNotificationIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationsAdminApiApiV1AdminNotificationsNotificationIdGet
     */
    readonly notificationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NotificationsAdminApiApiV1AdminNotificationsNotificationIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminNotificationsNotificationIdResendPost operation in NotificationsAdminApi.
 * @export
 * @interface NotificationsAdminApiApiV1AdminNotificationsNotificationIdResendPostRequest
 */
export interface NotificationsAdminApiApiV1AdminNotificationsNotificationIdResendPostRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationsAdminApiApiV1AdminNotificationsNotificationIdResendPost
     */
    readonly notificationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NotificationsAdminApiApiV1AdminNotificationsNotificationIdResendPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminNotificationsPost operation in NotificationsAdminApi.
 * @export
 * @interface NotificationsAdminApiApiV1AdminNotificationsPostRequest
 */
export interface NotificationsAdminApiApiV1AdminNotificationsPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof NotificationsAdminApiApiV1AdminNotificationsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateNotificationDto}
     * @memberof NotificationsAdminApiApiV1AdminNotificationsPost
     */
    readonly adminCreateNotificationDto?: AdminCreateNotificationDto
}

/**
 * NotificationsAdminApi - object-oriented interface
 * @export
 * @class NotificationsAdminApi
 * @extends {BaseAPI}
 */
export class NotificationsAdminApi extends BaseAPI {
    /**
     * 
     * @param {NotificationsAdminApiApiV1AdminNotificationsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsAdminApi
     */
    public apiV1AdminNotificationsGetPost(requestParameters: NotificationsAdminApiApiV1AdminNotificationsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsAdminApiFp(this.configuration).apiV1AdminNotificationsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminNotificationGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsAdminApiApiV1AdminNotificationsNotificationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsAdminApi
     */
    public apiV1AdminNotificationsNotificationIdGet(requestParameters: NotificationsAdminApiApiV1AdminNotificationsNotificationIdGetRequest, options?: RawAxiosRequestConfig) {
        return NotificationsAdminApiFp(this.configuration).apiV1AdminNotificationsNotificationIdGet(requestParameters.notificationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsAdminApiApiV1AdminNotificationsNotificationIdResendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsAdminApi
     */
    public apiV1AdminNotificationsNotificationIdResendPost(requestParameters: NotificationsAdminApiApiV1AdminNotificationsNotificationIdResendPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationsAdminApiFp(this.configuration).apiV1AdminNotificationsNotificationIdResendPost(requestParameters.notificationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsAdminApiApiV1AdminNotificationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsAdminApi
     */
    public apiV1AdminNotificationsPost(requestParameters: NotificationsAdminApiApiV1AdminNotificationsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsAdminApiFp(this.configuration).apiV1AdminNotificationsPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateNotificationDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OnboardingDefinitionsApi - axios parameter creator
 * @export
 */
export const OnboardingDefinitionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingDefinitionId 
         * @param {string} stepDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet: async (nexusOpsTenant: string, onboardingDefinitionId: string, stepDefinitionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'onboardingDefinitionId' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet', 'onboardingDefinitionId', onboardingDefinitionId)
            // verify required parameter 'stepDefinitionId' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet', 'stepDefinitionId', stepDefinitionId)
            const localVarPath = `/api/v1/guidance/onboarding-definitions/{onboardingDefinitionId}/steps/{stepDefinitionId}/content`
                .replace(`{${"onboardingDefinitionId"}}`, encodeURIComponent(String(onboardingDefinitionId)))
                .replace(`{${"stepDefinitionId"}}`, encodeURIComponent(String(stepDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingDefinitionsApi - functional programming interface
 * @export
 */
export const OnboardingDefinitionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingDefinitionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingDefinitionId 
         * @param {string} stepDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet(nexusOpsTenant: string, onboardingDefinitionId: string, stepDefinitionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingStepDefinitionContentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet(nexusOpsTenant, onboardingDefinitionId, stepDefinitionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingDefinitionsApi.apiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OnboardingDefinitionsApi - factory interface
 * @export
 */
export const OnboardingDefinitionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingDefinitionsApiFp(configuration)
    return {
        /**
         * 
         * @param {OnboardingDefinitionsApiApiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet(requestParameters: OnboardingDefinitionsApiApiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingStepDefinitionContentDto> {
            return localVarFp.apiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet(requestParameters.nexusOpsTenant, requestParameters.onboardingDefinitionId, requestParameters.stepDefinitionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet operation in OnboardingDefinitionsApi.
 * @export
 * @interface OnboardingDefinitionsApiApiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGetRequest
 */
export interface OnboardingDefinitionsApiApiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof OnboardingDefinitionsApiApiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionsApiApiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet
     */
    readonly onboardingDefinitionId: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionsApiApiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet
     */
    readonly stepDefinitionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingDefinitionsApiApiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * OnboardingDefinitionsApi - object-oriented interface
 * @export
 * @class OnboardingDefinitionsApi
 * @extends {BaseAPI}
 */
export class OnboardingDefinitionsApi extends BaseAPI {
    /**
     * 
     * @param {OnboardingDefinitionsApiApiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingDefinitionsApi
     */
    public apiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet(requestParameters: OnboardingDefinitionsApiApiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGetRequest, options?: RawAxiosRequestConfig) {
        return OnboardingDefinitionsApiFp(this.configuration).apiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet(requestParameters.nexusOpsTenant, requestParameters.onboardingDefinitionId, requestParameters.stepDefinitionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OnboardingDefinitionsAdminApi - axios parameter creator
 * @export
 */
export const OnboardingDefinitionsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {OnboardingDefinitionGetPaginatedAdminDto} [onboardingDefinitionGetPaginatedAdminDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingDefinitionsGetPost: async (nexusOpsAppVersion?: string, onboardingDefinitionGetPaginatedAdminDto?: OnboardingDefinitionGetPaginatedAdminDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/guidance/onboarding-definitions/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardingDefinitionGetPaginatedAdminDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} onboardingDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePost: async (onboardingDefinitionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingDefinitionId' is not null or undefined
            assertParamExists('apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePost', 'onboardingDefinitionId', onboardingDefinitionId)
            const localVarPath = `/api/v1/admin/guidance/onboarding-definitions/{onboardingDefinitionId}/cache/invalidate`
                .replace(`{${"onboardingDefinitionId"}}`, encodeURIComponent(String(onboardingDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} onboardingDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGet: async (onboardingDefinitionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingDefinitionId' is not null or undefined
            assertParamExists('apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGet', 'onboardingDefinitionId', onboardingDefinitionId)
            const localVarPath = `/api/v1/admin/guidance/onboarding-definitions/{onboardingDefinitionId}`
                .replace(`{${"onboardingDefinitionId"}}`, encodeURIComponent(String(onboardingDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} onboardingDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {OnboardingDefinitionUpdateAdminDto} [onboardingDefinitionUpdateAdminDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPut: async (onboardingDefinitionId: string, nexusOpsAppVersion?: string, onboardingDefinitionUpdateAdminDto?: OnboardingDefinitionUpdateAdminDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingDefinitionId' is not null or undefined
            assertParamExists('apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPut', 'onboardingDefinitionId', onboardingDefinitionId)
            const localVarPath = `/api/v1/admin/guidance/onboarding-definitions/{onboardingDefinitionId}`
                .replace(`{${"onboardingDefinitionId"}}`, encodeURIComponent(String(onboardingDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardingDefinitionUpdateAdminDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} onboardingDefinitionId 
         * @param {string} stepDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet: async (onboardingDefinitionId: string, stepDefinitionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingDefinitionId' is not null or undefined
            assertParamExists('apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet', 'onboardingDefinitionId', onboardingDefinitionId)
            // verify required parameter 'stepDefinitionId' is not null or undefined
            assertParamExists('apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet', 'stepDefinitionId', stepDefinitionId)
            const localVarPath = `/api/v1/admin/guidance/onboarding-definitions/{onboardingDefinitionId}/steps/{stepDefinitionId}/content`
                .replace(`{${"onboardingDefinitionId"}}`, encodeURIComponent(String(onboardingDefinitionId)))
                .replace(`{${"stepDefinitionId"}}`, encodeURIComponent(String(stepDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingDefinitionsAdminApi - functional programming interface
 * @export
 */
export const OnboardingDefinitionsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingDefinitionsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {OnboardingDefinitionGetPaginatedAdminDto} [onboardingDefinitionGetPaginatedAdminDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminGuidanceOnboardingDefinitionsGetPost(nexusOpsAppVersion?: string, onboardingDefinitionGetPaginatedAdminDto?: OnboardingDefinitionGetPaginatedAdminDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfOnboardingDefinitionAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminGuidanceOnboardingDefinitionsGetPost(nexusOpsAppVersion, onboardingDefinitionGetPaginatedAdminDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingDefinitionsAdminApi.apiV1AdminGuidanceOnboardingDefinitionsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} onboardingDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePost(onboardingDefinitionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePost(onboardingDefinitionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingDefinitionsAdminApi.apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} onboardingDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGet(onboardingDefinitionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingDefinitionAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGet(onboardingDefinitionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingDefinitionsAdminApi.apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} onboardingDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {OnboardingDefinitionUpdateAdminDto} [onboardingDefinitionUpdateAdminDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPut(onboardingDefinitionId: string, nexusOpsAppVersion?: string, onboardingDefinitionUpdateAdminDto?: OnboardingDefinitionUpdateAdminDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingDefinitionAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPut(onboardingDefinitionId, nexusOpsAppVersion, onboardingDefinitionUpdateAdminDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingDefinitionsAdminApi.apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} onboardingDefinitionId 
         * @param {string} stepDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet(onboardingDefinitionId: string, stepDefinitionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingStepDefinitionContentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet(onboardingDefinitionId, stepDefinitionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingDefinitionsAdminApi.apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OnboardingDefinitionsAdminApi - factory interface
 * @export
 */
export const OnboardingDefinitionsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingDefinitionsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingDefinitionsGetPost(requestParameters: OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfOnboardingDefinitionAdminDto> {
            return localVarFp.apiV1AdminGuidanceOnboardingDefinitionsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.onboardingDefinitionGetPaginatedAdminDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePost(requestParameters: OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePost(requestParameters.onboardingDefinitionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGet(requestParameters: OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingDefinitionAdminDto> {
            return localVarFp.apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGet(requestParameters.onboardingDefinitionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPut(requestParameters: OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingDefinitionAdminDto> {
            return localVarFp.apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPut(requestParameters.onboardingDefinitionId, requestParameters.nexusOpsAppVersion, requestParameters.onboardingDefinitionUpdateAdminDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet(requestParameters: OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingStepDefinitionContentDto> {
            return localVarFp.apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet(requestParameters.onboardingDefinitionId, requestParameters.stepDefinitionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminGuidanceOnboardingDefinitionsGetPost operation in OnboardingDefinitionsAdminApi.
 * @export
 * @interface OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsGetPostRequest
 */
export interface OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {OnboardingDefinitionGetPaginatedAdminDto}
     * @memberof OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsGetPost
     */
    readonly onboardingDefinitionGetPaginatedAdminDto?: OnboardingDefinitionGetPaginatedAdminDto
}

/**
 * Request parameters for apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePost operation in OnboardingDefinitionsAdminApi.
 * @export
 * @interface OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePostRequest
 */
export interface OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePost
     */
    readonly onboardingDefinitionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGet operation in OnboardingDefinitionsAdminApi.
 * @export
 * @interface OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGetRequest
 */
export interface OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGet
     */
    readonly onboardingDefinitionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPut operation in OnboardingDefinitionsAdminApi.
 * @export
 * @interface OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPutRequest
 */
export interface OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPut
     */
    readonly onboardingDefinitionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {OnboardingDefinitionUpdateAdminDto}
     * @memberof OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPut
     */
    readonly onboardingDefinitionUpdateAdminDto?: OnboardingDefinitionUpdateAdminDto
}

/**
 * Request parameters for apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet operation in OnboardingDefinitionsAdminApi.
 * @export
 * @interface OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGetRequest
 */
export interface OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGetRequest {
    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet
     */
    readonly onboardingDefinitionId: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet
     */
    readonly stepDefinitionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * OnboardingDefinitionsAdminApi - object-oriented interface
 * @export
 * @class OnboardingDefinitionsAdminApi
 * @extends {BaseAPI}
 */
export class OnboardingDefinitionsAdminApi extends BaseAPI {
    /**
     * 
     * @param {OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingDefinitionsAdminApi
     */
    public apiV1AdminGuidanceOnboardingDefinitionsGetPost(requestParameters: OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return OnboardingDefinitionsAdminApiFp(this.configuration).apiV1AdminGuidanceOnboardingDefinitionsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.onboardingDefinitionGetPaginatedAdminDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingDefinitionsAdminApi
     */
    public apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePost(requestParameters: OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePostRequest, options?: RawAxiosRequestConfig) {
        return OnboardingDefinitionsAdminApiFp(this.configuration).apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdCacheInvalidatePost(requestParameters.onboardingDefinitionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingDefinitionsAdminApi
     */
    public apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGet(requestParameters: OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGetRequest, options?: RawAxiosRequestConfig) {
        return OnboardingDefinitionsAdminApiFp(this.configuration).apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdGet(requestParameters.onboardingDefinitionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingDefinitionsAdminApi
     */
    public apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPut(requestParameters: OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPutRequest, options?: RawAxiosRequestConfig) {
        return OnboardingDefinitionsAdminApiFp(this.configuration).apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdPut(requestParameters.onboardingDefinitionId, requestParameters.nexusOpsAppVersion, requestParameters.onboardingDefinitionUpdateAdminDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingDefinitionsAdminApi
     */
    public apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet(requestParameters: OnboardingDefinitionsAdminApiApiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGetRequest, options?: RawAxiosRequestConfig) {
        return OnboardingDefinitionsAdminApiFp(this.configuration).apiV1AdminGuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet(requestParameters.onboardingDefinitionId, requestParameters.stepDefinitionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OnboardingsApi - axios parameter creator
 * @export
 */
export const OnboardingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdCompletePost: async (nexusOpsTenant: string, onboardingId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdCompletePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'onboardingId' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdCompletePost', 'onboardingId', onboardingId)
            const localVarPath = `/api/v1/guidance/onboardings/{onboardingId}/complete`
                .replace(`{${"onboardingId"}}`, encodeURIComponent(String(onboardingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdGet: async (nexusOpsTenant: string, onboardingId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'onboardingId' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdGet', 'onboardingId', onboardingId)
            const localVarPath = `/api/v1/guidance/onboardings/{onboardingId}`
                .replace(`{${"onboardingId"}}`, encodeURIComponent(String(onboardingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePost: async (nexusOpsTenant: string, onboardingId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'onboardingId' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePost', 'onboardingId', onboardingId)
            const localVarPath = `/api/v1/guidance/onboardings/{onboardingId}/is-show-on-launch/toggle`
                .replace(`{${"onboardingId"}}`, encodeURIComponent(String(onboardingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdSkipPost: async (nexusOpsTenant: string, onboardingId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdSkipPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'onboardingId' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdSkipPost', 'onboardingId', onboardingId)
            const localVarPath = `/api/v1/guidance/onboardings/{onboardingId}/skip`
                .replace(`{${"onboardingId"}}`, encodeURIComponent(String(onboardingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdStartPost: async (nexusOpsTenant: string, onboardingId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdStartPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'onboardingId' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdStartPost', 'onboardingId', onboardingId)
            const localVarPath = `/api/v1/guidance/onboardings/{onboardingId}/start`
                .replace(`{${"onboardingId"}}`, encodeURIComponent(String(onboardingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} stepDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost: async (nexusOpsTenant: string, onboardingId: string, stepDefinitionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'onboardingId' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost', 'onboardingId', onboardingId)
            // verify required parameter 'stepDefinitionId' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost', 'stepDefinitionId', stepDefinitionId)
            const localVarPath = `/api/v1/guidance/onboardings/{onboardingId}/steps/{stepDefinitionId}/complete`
                .replace(`{${"onboardingId"}}`, encodeURIComponent(String(onboardingId)))
                .replace(`{${"stepDefinitionId"}}`, encodeURIComponent(String(stepDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} stepDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost: async (nexusOpsTenant: string, onboardingId: string, stepDefinitionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'onboardingId' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost', 'onboardingId', onboardingId)
            // verify required parameter 'stepDefinitionId' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost', 'stepDefinitionId', stepDefinitionId)
            const localVarPath = `/api/v1/guidance/onboardings/{onboardingId}/steps/{stepDefinitionId}/skip`
                .replace(`{${"onboardingId"}}`, encodeURIComponent(String(onboardingId)))
                .replace(`{${"stepDefinitionId"}}`, encodeURIComponent(String(stepDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} stepDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost: async (nexusOpsTenant: string, onboardingId: string, stepDefinitionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'onboardingId' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost', 'onboardingId', onboardingId)
            // verify required parameter 'stepDefinitionId' is not null or undefined
            assertParamExists('apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost', 'stepDefinitionId', stepDefinitionId)
            const localVarPath = `/api/v1/guidance/onboardings/{onboardingId}/steps/{stepDefinitionId}/start`
                .replace(`{${"onboardingId"}}`, encodeURIComponent(String(onboardingId)))
                .replace(`{${"stepDefinitionId"}}`, encodeURIComponent(String(stepDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingsApi - functional programming interface
 * @export
 */
export const OnboardingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GuidanceOnboardingsOnboardingIdCompletePost(nexusOpsTenant: string, onboardingId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GuidanceOnboardingsOnboardingIdCompletePost(nexusOpsTenant, onboardingId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingsApi.apiV1GuidanceOnboardingsOnboardingIdCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GuidanceOnboardingsOnboardingIdGet(nexusOpsTenant: string, onboardingId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GuidanceOnboardingsOnboardingIdGet(nexusOpsTenant, onboardingId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingsApi.apiV1GuidanceOnboardingsOnboardingIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePost(nexusOpsTenant: string, onboardingId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePost(nexusOpsTenant, onboardingId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingsApi.apiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GuidanceOnboardingsOnboardingIdSkipPost(nexusOpsTenant: string, onboardingId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GuidanceOnboardingsOnboardingIdSkipPost(nexusOpsTenant, onboardingId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingsApi.apiV1GuidanceOnboardingsOnboardingIdSkipPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GuidanceOnboardingsOnboardingIdStartPost(nexusOpsTenant: string, onboardingId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GuidanceOnboardingsOnboardingIdStartPost(nexusOpsTenant, onboardingId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingsApi.apiV1GuidanceOnboardingsOnboardingIdStartPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} stepDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost(nexusOpsTenant: string, onboardingId: string, stepDefinitionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost(nexusOpsTenant, onboardingId, stepDefinitionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingsApi.apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} stepDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost(nexusOpsTenant: string, onboardingId: string, stepDefinitionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost(nexusOpsTenant, onboardingId, stepDefinitionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingsApi.apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} onboardingId 
         * @param {string} stepDefinitionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost(nexusOpsTenant: string, onboardingId: string, stepDefinitionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost(nexusOpsTenant, onboardingId, stepDefinitionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingsApi.apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OnboardingsApi - factory interface
 * @export
 */
export const OnboardingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingsApiFp(configuration)
    return {
        /**
         * 
         * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdCompletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdCompletePost(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdCompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingDto> {
            return localVarFp.apiV1GuidanceOnboardingsOnboardingIdCompletePost(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdGet(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingDto> {
            return localVarFp.apiV1GuidanceOnboardingsOnboardingIdGet(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePost(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingDto> {
            return localVarFp.apiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePost(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdSkipPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdSkipPost(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdSkipPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingDto> {
            return localVarFp.apiV1GuidanceOnboardingsOnboardingIdSkipPost(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStartPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdStartPost(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStartPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingDto> {
            return localVarFp.apiV1GuidanceOnboardingsOnboardingIdStartPost(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingDto> {
            return localVarFp.apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.stepDefinitionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingDto> {
            return localVarFp.apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.stepDefinitionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingDto> {
            return localVarFp.apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.stepDefinitionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1GuidanceOnboardingsOnboardingIdCompletePost operation in OnboardingsApi.
 * @export
 * @interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdCompletePostRequest
 */
export interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdCompletePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdCompletePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdCompletePost
     */
    readonly onboardingId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdCompletePost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1GuidanceOnboardingsOnboardingIdGet operation in OnboardingsApi.
 * @export
 * @interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdGetRequest
 */
export interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdGet
     */
    readonly onboardingId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePost operation in OnboardingsApi.
 * @export
 * @interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePostRequest
 */
export interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePost
     */
    readonly onboardingId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1GuidanceOnboardingsOnboardingIdSkipPost operation in OnboardingsApi.
 * @export
 * @interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdSkipPostRequest
 */
export interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdSkipPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdSkipPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdSkipPost
     */
    readonly onboardingId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdSkipPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1GuidanceOnboardingsOnboardingIdStartPost operation in OnboardingsApi.
 * @export
 * @interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStartPostRequest
 */
export interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStartPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStartPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStartPost
     */
    readonly onboardingId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStartPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost operation in OnboardingsApi.
 * @export
 * @interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePostRequest
 */
export interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost
     */
    readonly onboardingId: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost
     */
    readonly stepDefinitionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost operation in OnboardingsApi.
 * @export
 * @interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPostRequest
 */
export interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost
     */
    readonly onboardingId: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost
     */
    readonly stepDefinitionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost operation in OnboardingsApi.
 * @export
 * @interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPostRequest
 */
export interface OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost
     */
    readonly onboardingId: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost
     */
    readonly stepDefinitionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * OnboardingsApi - object-oriented interface
 * @export
 * @class OnboardingsApi
 * @extends {BaseAPI}
 */
export class OnboardingsApi extends BaseAPI {
    /**
     * 
     * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingsApi
     */
    public apiV1GuidanceOnboardingsOnboardingIdCompletePost(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdCompletePostRequest, options?: RawAxiosRequestConfig) {
        return OnboardingsApiFp(this.configuration).apiV1GuidanceOnboardingsOnboardingIdCompletePost(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingsApi
     */
    public apiV1GuidanceOnboardingsOnboardingIdGet(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdGetRequest, options?: RawAxiosRequestConfig) {
        return OnboardingsApiFp(this.configuration).apiV1GuidanceOnboardingsOnboardingIdGet(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingsApi
     */
    public apiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePost(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePostRequest, options?: RawAxiosRequestConfig) {
        return OnboardingsApiFp(this.configuration).apiV1GuidanceOnboardingsOnboardingIdIsShowOnLaunchTogglePost(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdSkipPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingsApi
     */
    public apiV1GuidanceOnboardingsOnboardingIdSkipPost(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdSkipPostRequest, options?: RawAxiosRequestConfig) {
        return OnboardingsApiFp(this.configuration).apiV1GuidanceOnboardingsOnboardingIdSkipPost(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStartPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingsApi
     */
    public apiV1GuidanceOnboardingsOnboardingIdStartPost(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStartPostRequest, options?: RawAxiosRequestConfig) {
        return OnboardingsApiFp(this.configuration).apiV1GuidanceOnboardingsOnboardingIdStartPost(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingsApi
     */
    public apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePostRequest, options?: RawAxiosRequestConfig) {
        return OnboardingsApiFp(this.configuration).apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdCompletePost(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.stepDefinitionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingsApi
     */
    public apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPostRequest, options?: RawAxiosRequestConfig) {
        return OnboardingsApiFp(this.configuration).apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdSkipPost(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.stepDefinitionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingsApi
     */
    public apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost(requestParameters: OnboardingsApiApiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPostRequest, options?: RawAxiosRequestConfig) {
        return OnboardingsApiFp(this.configuration).apiV1GuidanceOnboardingsOnboardingIdStepsStepDefinitionIdStartPost(requestParameters.nexusOpsTenant, requestParameters.onboardingId, requestParameters.stepDefinitionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OnboardingsAdminApi - axios parameter creator
 * @export
 */
export const OnboardingsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPost: async (nexusOpsAppVersion?: string, tenantId?: string, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/guidance/onboardings/get-or-create-for-tenant-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {OnboardingGetPaginatedAdminDto} [onboardingGetPaginatedAdminDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingsGetPost: async (nexusOpsAppVersion?: string, onboardingGetPaginatedAdminDto?: OnboardingGetPaginatedAdminDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/guidance/onboardings/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardingGetPaginatedAdminDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} onboardingId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingsOnboardingIdGet: async (onboardingId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingId' is not null or undefined
            assertParamExists('apiV1AdminGuidanceOnboardingsOnboardingIdGet', 'onboardingId', onboardingId)
            const localVarPath = `/api/v1/admin/guidance/onboardings/{onboardingId}`
                .replace(`{${"onboardingId"}}`, encodeURIComponent(String(onboardingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingsAdminApi - functional programming interface
 * @export
 */
export const OnboardingsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [tenantId] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPost(nexusOpsAppVersion?: string, tenantId?: string, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPost(nexusOpsAppVersion, tenantId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingsAdminApi.apiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {OnboardingGetPaginatedAdminDto} [onboardingGetPaginatedAdminDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminGuidanceOnboardingsGetPost(nexusOpsAppVersion?: string, onboardingGetPaginatedAdminDto?: OnboardingGetPaginatedAdminDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfOnboardingAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminGuidanceOnboardingsGetPost(nexusOpsAppVersion, onboardingGetPaginatedAdminDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingsAdminApi.apiV1AdminGuidanceOnboardingsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} onboardingId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminGuidanceOnboardingsOnboardingIdGet(onboardingId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminGuidanceOnboardingsOnboardingIdGet(onboardingId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingsAdminApi.apiV1AdminGuidanceOnboardingsOnboardingIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OnboardingsAdminApi - factory interface
 * @export
 */
export const OnboardingsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPost(requestParameters: OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingAdminDto> {
            return localVarFp.apiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPost(requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingsGetPost(requestParameters: OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfOnboardingAdminDto> {
            return localVarFp.apiV1AdminGuidanceOnboardingsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.onboardingGetPaginatedAdminDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnboardingsAdminApiApiV1AdminGuidanceOnboardingsOnboardingIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGuidanceOnboardingsOnboardingIdGet(requestParameters: OnboardingsAdminApiApiV1AdminGuidanceOnboardingsOnboardingIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingAdminDto> {
            return localVarFp.apiV1AdminGuidanceOnboardingsOnboardingIdGet(requestParameters.onboardingId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPost operation in OnboardingsAdminApi.
 * @export
 * @interface OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPostRequest
 */
export interface OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPost
     */
    readonly tenantId?: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPost
     */
    readonly userId?: string
}

/**
 * Request parameters for apiV1AdminGuidanceOnboardingsGetPost operation in OnboardingsAdminApi.
 * @export
 * @interface OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetPostRequest
 */
export interface OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {OnboardingGetPaginatedAdminDto}
     * @memberof OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetPost
     */
    readonly onboardingGetPaginatedAdminDto?: OnboardingGetPaginatedAdminDto
}

/**
 * Request parameters for apiV1AdminGuidanceOnboardingsOnboardingIdGet operation in OnboardingsAdminApi.
 * @export
 * @interface OnboardingsAdminApiApiV1AdminGuidanceOnboardingsOnboardingIdGetRequest
 */
export interface OnboardingsAdminApiApiV1AdminGuidanceOnboardingsOnboardingIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof OnboardingsAdminApiApiV1AdminGuidanceOnboardingsOnboardingIdGet
     */
    readonly onboardingId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OnboardingsAdminApiApiV1AdminGuidanceOnboardingsOnboardingIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * OnboardingsAdminApi - object-oriented interface
 * @export
 * @class OnboardingsAdminApi
 * @extends {BaseAPI}
 */
export class OnboardingsAdminApi extends BaseAPI {
    /**
     * 
     * @param {OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingsAdminApi
     */
    public apiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPost(requestParameters: OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPostRequest = {}, options?: RawAxiosRequestConfig) {
        return OnboardingsAdminApiFp(this.configuration).apiV1AdminGuidanceOnboardingsGetOrCreateForTenantUserPost(requestParameters.nexusOpsAppVersion, requestParameters.tenantId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingsAdminApi
     */
    public apiV1AdminGuidanceOnboardingsGetPost(requestParameters: OnboardingsAdminApiApiV1AdminGuidanceOnboardingsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return OnboardingsAdminApiFp(this.configuration).apiV1AdminGuidanceOnboardingsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.onboardingGetPaginatedAdminDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnboardingsAdminApiApiV1AdminGuidanceOnboardingsOnboardingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingsAdminApi
     */
    public apiV1AdminGuidanceOnboardingsOnboardingIdGet(requestParameters: OnboardingsAdminApiApiV1AdminGuidanceOnboardingsOnboardingIdGetRequest, options?: RawAxiosRequestConfig) {
        return OnboardingsAdminApiFp(this.configuration).apiV1AdminGuidanceOnboardingsOnboardingIdGet(requestParameters.onboardingId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OneflowApi - axios parameter creator
 * @export
 */
export const OneflowApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns defaults configured for current tenant user.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProvidersOneflowDefaultsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProvidersOneflowDefaultsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/providers/oneflow/defaults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all available templates for current tenant user in configured Oneflow workspace.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProvidersOneflowTemplatesGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProvidersOneflowTemplatesGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/providers/oneflow/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OneflowApi - functional programming interface
 * @export
 */
export const OneflowApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OneflowApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns defaults configured for current tenant user.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProvidersOneflowDefaultsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OneflowDefaultsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProvidersOneflowDefaultsGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OneflowApi.apiV1ProvidersOneflowDefaultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns all available templates for current tenant user in configured Oneflow workspace.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProvidersOneflowTemplatesGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OneflowTemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProvidersOneflowTemplatesGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OneflowApi.apiV1ProvidersOneflowTemplatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OneflowApi - factory interface
 * @export
 */
export const OneflowApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OneflowApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns defaults configured for current tenant user.
         * @param {OneflowApiApiV1ProvidersOneflowDefaultsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProvidersOneflowDefaultsGet(requestParameters: OneflowApiApiV1ProvidersOneflowDefaultsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OneflowDefaultsDto> {
            return localVarFp.apiV1ProvidersOneflowDefaultsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all available templates for current tenant user in configured Oneflow workspace.
         * @param {OneflowApiApiV1ProvidersOneflowTemplatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProvidersOneflowTemplatesGet(requestParameters: OneflowApiApiV1ProvidersOneflowTemplatesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<OneflowTemplateDto>> {
            return localVarFp.apiV1ProvidersOneflowTemplatesGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ProvidersOneflowDefaultsGet operation in OneflowApi.
 * @export
 * @interface OneflowApiApiV1ProvidersOneflowDefaultsGetRequest
 */
export interface OneflowApiApiV1ProvidersOneflowDefaultsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof OneflowApiApiV1ProvidersOneflowDefaultsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OneflowApiApiV1ProvidersOneflowDefaultsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ProvidersOneflowTemplatesGet operation in OneflowApi.
 * @export
 * @interface OneflowApiApiV1ProvidersOneflowTemplatesGetRequest
 */
export interface OneflowApiApiV1ProvidersOneflowTemplatesGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof OneflowApiApiV1ProvidersOneflowTemplatesGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OneflowApiApiV1ProvidersOneflowTemplatesGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * OneflowApi - object-oriented interface
 * @export
 * @class OneflowApi
 * @extends {BaseAPI}
 */
export class OneflowApi extends BaseAPI {
    /**
     * 
     * @summary Returns defaults configured for current tenant user.
     * @param {OneflowApiApiV1ProvidersOneflowDefaultsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OneflowApi
     */
    public apiV1ProvidersOneflowDefaultsGet(requestParameters: OneflowApiApiV1ProvidersOneflowDefaultsGetRequest, options?: RawAxiosRequestConfig) {
        return OneflowApiFp(this.configuration).apiV1ProvidersOneflowDefaultsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all available templates for current tenant user in configured Oneflow workspace.
     * @param {OneflowApiApiV1ProvidersOneflowTemplatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OneflowApi
     */
    public apiV1ProvidersOneflowTemplatesGet(requestParameters: OneflowApiApiV1ProvidersOneflowTemplatesGetRequest, options?: RawAxiosRequestConfig) {
        return OneflowApiFp(this.configuration).apiV1ProvidersOneflowTemplatesGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OperationsApi - axios parameter creator
 * @export
 */
export const OperationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1OperationsCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/operations/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperationsApi - functional programming interface
 * @export
 */
export const OperationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperationsApi.apiV1OperationsCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OperationsApi - factory interface
 * @export
 */
export const OperationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperationsApiFp(configuration)
    return {
        /**
         * 
         * @param {OperationsApiApiV1OperationsCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsCountersGet(requestParameters: OperationsApiApiV1OperationsCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OperationCountersDto> {
            return localVarFp.apiV1OperationsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1OperationsCountersGet operation in OperationsApi.
 * @export
 * @interface OperationsApiApiV1OperationsCountersGetRequest
 */
export interface OperationsApiApiV1OperationsCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof OperationsApiApiV1OperationsCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof OperationsApiApiV1OperationsCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * OperationsApi - object-oriented interface
 * @export
 * @class OperationsApi
 * @extends {BaseAPI}
 */
export class OperationsApi extends BaseAPI {
    /**
     * 
     * @param {OperationsApiApiV1OperationsCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsCountersGet(requestParameters: OperationsApiApiV1OperationsCountersGetRequest, options?: RawAxiosRequestConfig) {
        return OperationsApiFp(this.configuration).apiV1OperationsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PartiesApi - axios parameter creator
 * @export
 */
export const PartiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} partyId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesPartyIdGet: async (nexusOpsTenant: string, partyId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PartiesPartyIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'partyId' is not null or undefined
            assertParamExists('apiV1PartiesPartyIdGet', 'partyId', partyId)
            const localVarPath = `/api/v1/parties/{partyId}`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesUserMembershipGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PartiesUserMembershipGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/parties/user/membership`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartiesApi - functional programming interface
 * @export
 */
export const PartiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} partyId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PartiesPartyIdGet(nexusOpsTenant: string, partyId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PartiesPartyIdGet(nexusOpsTenant, partyId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartiesApi.apiV1PartiesPartyIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PartiesUserMembershipGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPartiesMembershipDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PartiesUserMembershipGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartiesApi.apiV1PartiesUserMembershipGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PartiesApi - factory interface
 * @export
 */
export const PartiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartiesApiFp(configuration)
    return {
        /**
         * 
         * @param {PartiesApiApiV1PartiesPartyIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesPartyIdGet(requestParameters: PartiesApiApiV1PartiesPartyIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartyDto> {
            return localVarFp.apiV1PartiesPartyIdGet(requestParameters.nexusOpsTenant, requestParameters.partyId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PartiesApiApiV1PartiesUserMembershipGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesUserMembershipGet(requestParameters: PartiesApiApiV1PartiesUserMembershipGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserPartiesMembershipDto> {
            return localVarFp.apiV1PartiesUserMembershipGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1PartiesPartyIdGet operation in PartiesApi.
 * @export
 * @interface PartiesApiApiV1PartiesPartyIdGetRequest
 */
export interface PartiesApiApiV1PartiesPartyIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PartiesApiApiV1PartiesPartyIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PartiesApiApiV1PartiesPartyIdGet
     */
    readonly partyId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PartiesApiApiV1PartiesPartyIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1PartiesUserMembershipGet operation in PartiesApi.
 * @export
 * @interface PartiesApiApiV1PartiesUserMembershipGetRequest
 */
export interface PartiesApiApiV1PartiesUserMembershipGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PartiesApiApiV1PartiesUserMembershipGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PartiesApiApiV1PartiesUserMembershipGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * PartiesApi - object-oriented interface
 * @export
 * @class PartiesApi
 * @extends {BaseAPI}
 */
export class PartiesApi extends BaseAPI {
    /**
     * 
     * @param {PartiesApiApiV1PartiesPartyIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartiesApi
     */
    public apiV1PartiesPartyIdGet(requestParameters: PartiesApiApiV1PartiesPartyIdGetRequest, options?: RawAxiosRequestConfig) {
        return PartiesApiFp(this.configuration).apiV1PartiesPartyIdGet(requestParameters.nexusOpsTenant, requestParameters.partyId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PartiesApiApiV1PartiesUserMembershipGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartiesApi
     */
    public apiV1PartiesUserMembershipGet(requestParameters: PartiesApiApiV1PartiesUserMembershipGetRequest, options?: RawAxiosRequestConfig) {
        return PartiesApiFp(this.configuration).apiV1PartiesUserMembershipGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CheckoutManualDto} [checkoutManualDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PaymentsCheckoutManualPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, checkoutManualDto?: CheckoutManualDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PaymentsCheckoutManualPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/payments/checkout/manual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutManualDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PaymentsPaymentProfileGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PaymentsPaymentProfileGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/payments/payment-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantPaymentProfileInputDto} [tenantPaymentProfileInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PaymentsPaymentProfilePut: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantPaymentProfileInputDto?: TenantPaymentProfileInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PaymentsPaymentProfilePut', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/payments/payment-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantPaymentProfileInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CheckoutManualDto} [checkoutManualDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PaymentsCheckoutManualPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, checkoutManualDto?: CheckoutManualDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PaymentsCheckoutManualPost(nexusOpsTenant, nexusOpsAppVersion, checkoutManualDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.apiV1PaymentsCheckoutManualPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PaymentsPaymentProfileGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantPaymentProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PaymentsPaymentProfileGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.apiV1PaymentsPaymentProfileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantPaymentProfileInputDto} [tenantPaymentProfileInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PaymentsPaymentProfilePut(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantPaymentProfileInputDto?: TenantPaymentProfileInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantPaymentProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PaymentsPaymentProfilePut(nexusOpsTenant, nexusOpsAppVersion, tenantPaymentProfileInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.apiV1PaymentsPaymentProfilePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * 
         * @param {PaymentsApiApiV1PaymentsCheckoutManualPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PaymentsCheckoutManualPost(requestParameters: PaymentsApiApiV1PaymentsCheckoutManualPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1PaymentsCheckoutManualPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.checkoutManualDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentsApiApiV1PaymentsPaymentProfileGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PaymentsPaymentProfileGet(requestParameters: PaymentsApiApiV1PaymentsPaymentProfileGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantPaymentProfileDto> {
            return localVarFp.apiV1PaymentsPaymentProfileGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentsApiApiV1PaymentsPaymentProfilePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PaymentsPaymentProfilePut(requestParameters: PaymentsApiApiV1PaymentsPaymentProfilePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantPaymentProfileDto> {
            return localVarFp.apiV1PaymentsPaymentProfilePut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantPaymentProfileInputDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1PaymentsCheckoutManualPost operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiV1PaymentsCheckoutManualPostRequest
 */
export interface PaymentsApiApiV1PaymentsCheckoutManualPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PaymentsApiApiV1PaymentsCheckoutManualPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PaymentsApiApiV1PaymentsCheckoutManualPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CheckoutManualDto}
     * @memberof PaymentsApiApiV1PaymentsCheckoutManualPost
     */
    readonly checkoutManualDto?: CheckoutManualDto
}

/**
 * Request parameters for apiV1PaymentsPaymentProfileGet operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiV1PaymentsPaymentProfileGetRequest
 */
export interface PaymentsApiApiV1PaymentsPaymentProfileGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PaymentsApiApiV1PaymentsPaymentProfileGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PaymentsApiApiV1PaymentsPaymentProfileGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1PaymentsPaymentProfilePut operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiV1PaymentsPaymentProfilePutRequest
 */
export interface PaymentsApiApiV1PaymentsPaymentProfilePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PaymentsApiApiV1PaymentsPaymentProfilePut
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PaymentsApiApiV1PaymentsPaymentProfilePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantPaymentProfileInputDto}
     * @memberof PaymentsApiApiV1PaymentsPaymentProfilePut
     */
    readonly tenantPaymentProfileInputDto?: TenantPaymentProfileInputDto
}

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     * 
     * @param {PaymentsApiApiV1PaymentsCheckoutManualPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public apiV1PaymentsCheckoutManualPost(requestParameters: PaymentsApiApiV1PaymentsCheckoutManualPostRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).apiV1PaymentsCheckoutManualPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.checkoutManualDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentsApiApiV1PaymentsPaymentProfileGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public apiV1PaymentsPaymentProfileGet(requestParameters: PaymentsApiApiV1PaymentsPaymentProfileGetRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).apiV1PaymentsPaymentProfileGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentsApiApiV1PaymentsPaymentProfilePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public apiV1PaymentsPaymentProfilePut(requestParameters: PaymentsApiApiV1PaymentsPaymentProfilePutRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).apiV1PaymentsPaymentProfilePut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantPaymentProfileInputDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PingApi - axios parameter creator
 * @export
 */
export const PingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Used to check that the service instance is up and running. Returns \"pong\" if so.
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PingGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PingApi - functional programming interface
 * @export
 */
export const PingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Used to check that the service instance is up and running. Returns \"pong\" if so.
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PingGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PingGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PingApi.apiV1PingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PingApi - factory interface
 * @export
 */
export const PingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PingApiFp(configuration)
    return {
        /**
         * 
         * @summary Used to check that the service instance is up and running. Returns \"pong\" if so.
         * @param {PingApiApiV1PingGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PingGet(requestParameters: PingApiApiV1PingGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV1PingGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1PingGet operation in PingApi.
 * @export
 * @interface PingApiApiV1PingGetRequest
 */
export interface PingApiApiV1PingGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PingApiApiV1PingGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * PingApi - object-oriented interface
 * @export
 * @class PingApi
 * @extends {BaseAPI}
 */
export class PingApi extends BaseAPI {
    /**
     * 
     * @summary Used to check that the service instance is up and running. Returns \"pong\" if so.
     * @param {PingApiApiV1PingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingApi
     */
    public apiV1PingGet(requestParameters: PingApiApiV1PingGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PingApiFp(this.configuration).apiV1PingGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PoolItemsApi - axios parameter creator
 * @export
 */
export const PoolItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolItemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolItemsPoolItemIdGet: async (nexusOpsTenant: string, poolItemId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolItemsPoolItemIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolItemId' is not null or undefined
            assertParamExists('apiV1PoolItemsPoolItemIdGet', 'poolItemId', poolItemId)
            const localVarPath = `/api/v1/pool-items/{poolItemId}`
                .replace(`{${"poolItemId"}}`, encodeURIComponent(String(poolItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsAllDelete: async (nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsAllDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsAllDelete', 'poolId', poolId)
            const localVarPath = `/api/v1/pools/{poolId}/items/all`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {PoolItemEntityType} [entityType] Describes entity types that are suitable for pools.  Must contain only values from EntityType.
         * @param {Array<string>} [includeIds] 
         * @param {Array<string>} [excludeIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsCandidatesGet: async (nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, offset?: number, limit?: number, search?: string, entityType?: PoolItemEntityType, includeIds?: Array<string>, excludeIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsCandidatesGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsCandidatesGet', 'poolId', poolId)
            const localVarPath = `/api/v1/pools/{poolId}/items/candidates`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (includeIds) {
                localVarQueryParameter['includeIds'] = includeIds;
            }

            if (excludeIds) {
                localVarQueryParameter['excludeIds'] = excludeIds;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemCreateManyDto} [poolItemCreateManyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsCreateManyPost: async (nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, poolItemCreateManyDto?: PoolItemCreateManyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsCreateManyPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsCreateManyPost', 'poolId', poolId)
            const localVarPath = `/api/v1/pools/{poolId}/items/create-many`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(poolItemCreateManyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemGetPaginatedDto} [poolItemGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsGetPost: async (nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, poolItemGetPaginatedDto?: PoolItemGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsGetPost', 'poolId', poolId)
            const localVarPath = `/api/v1/pools/{poolId}/items/get`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(poolItemGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} poolItemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsPoolItemIdDelete: async (nexusOpsTenant: string, poolId: string, poolItemId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsPoolItemIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsPoolItemIdDelete', 'poolId', poolId)
            // verify required parameter 'poolItemId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsPoolItemIdDelete', 'poolItemId', poolItemId)
            const localVarPath = `/api/v1/pools/{poolId}/items/{poolItemId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"poolItemId"}}`, encodeURIComponent(String(poolItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} poolItemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsPoolItemIdGet: async (nexusOpsTenant: string, poolId: string, poolItemId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsPoolItemIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsPoolItemIdGet', 'poolId', poolId)
            // verify required parameter 'poolItemId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsPoolItemIdGet', 'poolItemId', poolItemId)
            const localVarPath = `/api/v1/pools/{poolId}/items/{poolItemId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"poolItemId"}}`, encodeURIComponent(String(poolItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} poolItemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemUpdateDto} [poolItemUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsPoolItemIdPut: async (nexusOpsTenant: string, poolId: string, poolItemId: string, nexusOpsAppVersion?: string, poolItemUpdateDto?: PoolItemUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsPoolItemIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsPoolItemIdPut', 'poolId', poolId)
            // verify required parameter 'poolItemId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsPoolItemIdPut', 'poolItemId', poolItemId)
            const localVarPath = `/api/v1/pools/{poolId}/items/{poolItemId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"poolItemId"}}`, encodeURIComponent(String(poolItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(poolItemUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} poolItemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemUpdateStatusDto} [poolItemUpdateStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsPoolItemIdStatusPut: async (nexusOpsTenant: string, poolId: string, poolItemId: string, nexusOpsAppVersion?: string, poolItemUpdateStatusDto?: PoolItemUpdateStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsPoolItemIdStatusPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsPoolItemIdStatusPut', 'poolId', poolId)
            // verify required parameter 'poolItemId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsPoolItemIdStatusPut', 'poolItemId', poolItemId)
            const localVarPath = `/api/v1/pools/{poolId}/items/{poolItemId}/status`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)))
                .replace(`{${"poolItemId"}}`, encodeURIComponent(String(poolItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(poolItemUpdateStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemCreateDto} [poolItemCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsPost: async (nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, poolItemCreateDto?: PoolItemCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsPost', 'poolId', poolId)
            const localVarPath = `/api/v1/pools/{poolId}/items`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(poolItemCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemSearchPaginatedDto} [poolItemSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsSearchPost: async (nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, poolItemSearchPaginatedDto?: PoolItemSearchPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsSearchPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdItemsSearchPost', 'poolId', poolId)
            const localVarPath = `/api/v1/pools/{poolId}/items/search`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(poolItemSearchPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoolItemsApi - functional programming interface
 * @export
 */
export const PoolItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PoolItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolItemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolItemsPoolItemIdGet(nexusOpsTenant: string, poolItemId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolItemsPoolItemIdGet(nexusOpsTenant, poolItemId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolItemsApi.apiV1PoolItemsPoolItemIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPoolIdItemsAllDelete(nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPoolIdItemsAllDelete(nexusOpsTenant, poolId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolItemsApi.apiV1PoolsPoolIdItemsAllDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {PoolItemEntityType} [entityType] Describes entity types that are suitable for pools.  Must contain only values from EntityType.
         * @param {Array<string>} [includeIds] 
         * @param {Array<string>} [excludeIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPoolIdItemsCandidatesGet(nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, offset?: number, limit?: number, search?: string, entityType?: PoolItemEntityType, includeIds?: Array<string>, excludeIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfPoolItemCandidateEntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPoolIdItemsCandidatesGet(nexusOpsTenant, poolId, nexusOpsAppVersion, offset, limit, search, entityType, includeIds, excludeIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolItemsApi.apiV1PoolsPoolIdItemsCandidatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemCreateManyDto} [poolItemCreateManyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPoolIdItemsCreateManyPost(nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, poolItemCreateManyDto?: PoolItemCreateManyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PoolItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPoolIdItemsCreateManyPost(nexusOpsTenant, poolId, nexusOpsAppVersion, poolItemCreateManyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolItemsApi.apiV1PoolsPoolIdItemsCreateManyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemGetPaginatedDto} [poolItemGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPoolIdItemsGetPost(nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, poolItemGetPaginatedDto?: PoolItemGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfPoolItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPoolIdItemsGetPost(nexusOpsTenant, poolId, nexusOpsAppVersion, poolItemGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolItemsApi.apiV1PoolsPoolIdItemsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} poolItemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPoolIdItemsPoolItemIdDelete(nexusOpsTenant: string, poolId: string, poolItemId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPoolIdItemsPoolItemIdDelete(nexusOpsTenant, poolId, poolItemId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolItemsApi.apiV1PoolsPoolIdItemsPoolItemIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} poolItemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPoolIdItemsPoolItemIdGet(nexusOpsTenant: string, poolId: string, poolItemId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPoolIdItemsPoolItemIdGet(nexusOpsTenant, poolId, poolItemId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolItemsApi.apiV1PoolsPoolIdItemsPoolItemIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} poolItemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemUpdateDto} [poolItemUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPoolIdItemsPoolItemIdPut(nexusOpsTenant: string, poolId: string, poolItemId: string, nexusOpsAppVersion?: string, poolItemUpdateDto?: PoolItemUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPoolIdItemsPoolItemIdPut(nexusOpsTenant, poolId, poolItemId, nexusOpsAppVersion, poolItemUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolItemsApi.apiV1PoolsPoolIdItemsPoolItemIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} poolItemId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemUpdateStatusDto} [poolItemUpdateStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPoolIdItemsPoolItemIdStatusPut(nexusOpsTenant: string, poolId: string, poolItemId: string, nexusOpsAppVersion?: string, poolItemUpdateStatusDto?: PoolItemUpdateStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPoolIdItemsPoolItemIdStatusPut(nexusOpsTenant, poolId, poolItemId, nexusOpsAppVersion, poolItemUpdateStatusDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolItemsApi.apiV1PoolsPoolIdItemsPoolItemIdStatusPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemCreateDto} [poolItemCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPoolIdItemsPost(nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, poolItemCreateDto?: PoolItemCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPoolIdItemsPost(nexusOpsTenant, poolId, nexusOpsAppVersion, poolItemCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolItemsApi.apiV1PoolsPoolIdItemsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemSearchPaginatedDto} [poolItemSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPoolIdItemsSearchPost(nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, poolItemSearchPaginatedDto?: PoolItemSearchPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfPoolItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPoolIdItemsSearchPost(nexusOpsTenant, poolId, nexusOpsAppVersion, poolItemSearchPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolItemsApi.apiV1PoolsPoolIdItemsSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PoolItemsApi - factory interface
 * @export
 */
export const PoolItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PoolItemsApiFp(configuration)
    return {
        /**
         * 
         * @param {PoolItemsApiApiV1PoolItemsPoolItemIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolItemsPoolItemIdGet(requestParameters: PoolItemsApiApiV1PoolItemsPoolItemIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoolItemDto> {
            return localVarFp.apiV1PoolItemsPoolItemIdGet(requestParameters.nexusOpsTenant, requestParameters.poolItemId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolItemsApiApiV1PoolsPoolIdItemsAllDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsAllDelete(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsAllDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1PoolsPoolIdItemsAllDelete(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsCandidatesGet(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfPoolItemCandidateEntityDto> {
            return localVarFp.apiV1PoolsPoolIdItemsCandidatesGet(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, requestParameters.offset, requestParameters.limit, requestParameters.search, requestParameters.entityType, requestParameters.includeIds, requestParameters.excludeIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolItemsApiApiV1PoolsPoolIdItemsCreateManyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsCreateManyPost(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsCreateManyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PoolItemDto>> {
            return localVarFp.apiV1PoolsPoolIdItemsCreateManyPost(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, requestParameters.poolItemCreateManyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolItemsApiApiV1PoolsPoolIdItemsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsGetPost(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfPoolItemDto> {
            return localVarFp.apiV1PoolsPoolIdItemsGetPost(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, requestParameters.poolItemGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsPoolItemIdDelete(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1PoolsPoolIdItemsPoolItemIdDelete(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.poolItemId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsPoolItemIdGet(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoolItemDto> {
            return localVarFp.apiV1PoolsPoolIdItemsPoolItemIdGet(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.poolItemId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsPoolItemIdPut(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoolItemDto> {
            return localVarFp.apiV1PoolsPoolIdItemsPoolItemIdPut(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.poolItemId, requestParameters.nexusOpsAppVersion, requestParameters.poolItemUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdStatusPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsPoolItemIdStatusPut(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdStatusPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoolItemDto> {
            return localVarFp.apiV1PoolsPoolIdItemsPoolItemIdStatusPut(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.poolItemId, requestParameters.nexusOpsAppVersion, requestParameters.poolItemUpdateStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolItemsApiApiV1PoolsPoolIdItemsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsPost(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoolItemDto> {
            return localVarFp.apiV1PoolsPoolIdItemsPost(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, requestParameters.poolItemCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolItemsApiApiV1PoolsPoolIdItemsSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdItemsSearchPost(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsSearchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfPoolItemDto> {
            return localVarFp.apiV1PoolsPoolIdItemsSearchPost(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, requestParameters.poolItemSearchPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1PoolItemsPoolItemIdGet operation in PoolItemsApi.
 * @export
 * @interface PoolItemsApiApiV1PoolItemsPoolItemIdGetRequest
 */
export interface PoolItemsApiApiV1PoolItemsPoolItemIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolItemsPoolItemIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolItemsPoolItemIdGet
     */
    readonly poolItemId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolItemsPoolItemIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1PoolsPoolIdItemsAllDelete operation in PoolItemsApi.
 * @export
 * @interface PoolItemsApiApiV1PoolsPoolIdItemsAllDeleteRequest
 */
export interface PoolItemsApiApiV1PoolsPoolIdItemsAllDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsAllDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsAllDelete
     */
    readonly poolId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsAllDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1PoolsPoolIdItemsCandidatesGet operation in PoolItemsApi.
 * @export
 * @interface PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGetRequest
 */
export interface PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGet
     */
    readonly poolId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {number}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGet
     */
    readonly offset?: number

    /**
     * 
     * @type {number}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGet
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGet
     */
    readonly search?: string

    /**
     * Describes entity types that are suitable for pools.  Must contain only values from EntityType.
     * @type {PoolItemEntityType}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGet
     */
    readonly entityType?: PoolItemEntityType

    /**
     * 
     * @type {Array<string>}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGet
     */
    readonly includeIds?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGet
     */
    readonly excludeIds?: Array<string>
}

/**
 * Request parameters for apiV1PoolsPoolIdItemsCreateManyPost operation in PoolItemsApi.
 * @export
 * @interface PoolItemsApiApiV1PoolsPoolIdItemsCreateManyPostRequest
 */
export interface PoolItemsApiApiV1PoolsPoolIdItemsCreateManyPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsCreateManyPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsCreateManyPost
     */
    readonly poolId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsCreateManyPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {PoolItemCreateManyDto}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsCreateManyPost
     */
    readonly poolItemCreateManyDto?: PoolItemCreateManyDto
}

/**
 * Request parameters for apiV1PoolsPoolIdItemsGetPost operation in PoolItemsApi.
 * @export
 * @interface PoolItemsApiApiV1PoolsPoolIdItemsGetPostRequest
 */
export interface PoolItemsApiApiV1PoolsPoolIdItemsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsGetPost
     */
    readonly poolId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {PoolItemGetPaginatedDto}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsGetPost
     */
    readonly poolItemGetPaginatedDto?: PoolItemGetPaginatedDto
}

/**
 * Request parameters for apiV1PoolsPoolIdItemsPoolItemIdDelete operation in PoolItemsApi.
 * @export
 * @interface PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdDeleteRequest
 */
export interface PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdDelete
     */
    readonly poolId: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdDelete
     */
    readonly poolItemId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1PoolsPoolIdItemsPoolItemIdGet operation in PoolItemsApi.
 * @export
 * @interface PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdGetRequest
 */
export interface PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdGet
     */
    readonly poolId: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdGet
     */
    readonly poolItemId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1PoolsPoolIdItemsPoolItemIdPut operation in PoolItemsApi.
 * @export
 * @interface PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdPutRequest
 */
export interface PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdPut
     */
    readonly poolId: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdPut
     */
    readonly poolItemId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {PoolItemUpdateDto}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdPut
     */
    readonly poolItemUpdateDto?: PoolItemUpdateDto
}

/**
 * Request parameters for apiV1PoolsPoolIdItemsPoolItemIdStatusPut operation in PoolItemsApi.
 * @export
 * @interface PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdStatusPutRequest
 */
export interface PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdStatusPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdStatusPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdStatusPut
     */
    readonly poolId: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdStatusPut
     */
    readonly poolItemId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdStatusPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {PoolItemUpdateStatusDto}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdStatusPut
     */
    readonly poolItemUpdateStatusDto?: PoolItemUpdateStatusDto
}

/**
 * Request parameters for apiV1PoolsPoolIdItemsPost operation in PoolItemsApi.
 * @export
 * @interface PoolItemsApiApiV1PoolsPoolIdItemsPostRequest
 */
export interface PoolItemsApiApiV1PoolsPoolIdItemsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPost
     */
    readonly poolId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {PoolItemCreateDto}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsPost
     */
    readonly poolItemCreateDto?: PoolItemCreateDto
}

/**
 * Request parameters for apiV1PoolsPoolIdItemsSearchPost operation in PoolItemsApi.
 * @export
 * @interface PoolItemsApiApiV1PoolsPoolIdItemsSearchPostRequest
 */
export interface PoolItemsApiApiV1PoolsPoolIdItemsSearchPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsSearchPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsSearchPost
     */
    readonly poolId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsSearchPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {PoolItemSearchPaginatedDto}
     * @memberof PoolItemsApiApiV1PoolsPoolIdItemsSearchPost
     */
    readonly poolItemSearchPaginatedDto?: PoolItemSearchPaginatedDto
}

/**
 * PoolItemsApi - object-oriented interface
 * @export
 * @class PoolItemsApi
 * @extends {BaseAPI}
 */
export class PoolItemsApi extends BaseAPI {
    /**
     * 
     * @param {PoolItemsApiApiV1PoolItemsPoolItemIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolItemsApi
     */
    public apiV1PoolItemsPoolItemIdGet(requestParameters: PoolItemsApiApiV1PoolItemsPoolItemIdGetRequest, options?: RawAxiosRequestConfig) {
        return PoolItemsApiFp(this.configuration).apiV1PoolItemsPoolItemIdGet(requestParameters.nexusOpsTenant, requestParameters.poolItemId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolItemsApiApiV1PoolsPoolIdItemsAllDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolItemsApi
     */
    public apiV1PoolsPoolIdItemsAllDelete(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsAllDeleteRequest, options?: RawAxiosRequestConfig) {
        return PoolItemsApiFp(this.configuration).apiV1PoolsPoolIdItemsAllDelete(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolItemsApi
     */
    public apiV1PoolsPoolIdItemsCandidatesGet(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsCandidatesGetRequest, options?: RawAxiosRequestConfig) {
        return PoolItemsApiFp(this.configuration).apiV1PoolsPoolIdItemsCandidatesGet(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, requestParameters.offset, requestParameters.limit, requestParameters.search, requestParameters.entityType, requestParameters.includeIds, requestParameters.excludeIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolItemsApiApiV1PoolsPoolIdItemsCreateManyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolItemsApi
     */
    public apiV1PoolsPoolIdItemsCreateManyPost(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsCreateManyPostRequest, options?: RawAxiosRequestConfig) {
        return PoolItemsApiFp(this.configuration).apiV1PoolsPoolIdItemsCreateManyPost(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, requestParameters.poolItemCreateManyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolItemsApiApiV1PoolsPoolIdItemsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolItemsApi
     */
    public apiV1PoolsPoolIdItemsGetPost(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsGetPostRequest, options?: RawAxiosRequestConfig) {
        return PoolItemsApiFp(this.configuration).apiV1PoolsPoolIdItemsGetPost(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, requestParameters.poolItemGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolItemsApi
     */
    public apiV1PoolsPoolIdItemsPoolItemIdDelete(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return PoolItemsApiFp(this.configuration).apiV1PoolsPoolIdItemsPoolItemIdDelete(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.poolItemId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolItemsApi
     */
    public apiV1PoolsPoolIdItemsPoolItemIdGet(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdGetRequest, options?: RawAxiosRequestConfig) {
        return PoolItemsApiFp(this.configuration).apiV1PoolsPoolIdItemsPoolItemIdGet(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.poolItemId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolItemsApi
     */
    public apiV1PoolsPoolIdItemsPoolItemIdPut(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdPutRequest, options?: RawAxiosRequestConfig) {
        return PoolItemsApiFp(this.configuration).apiV1PoolsPoolIdItemsPoolItemIdPut(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.poolItemId, requestParameters.nexusOpsAppVersion, requestParameters.poolItemUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdStatusPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolItemsApi
     */
    public apiV1PoolsPoolIdItemsPoolItemIdStatusPut(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsPoolItemIdStatusPutRequest, options?: RawAxiosRequestConfig) {
        return PoolItemsApiFp(this.configuration).apiV1PoolsPoolIdItemsPoolItemIdStatusPut(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.poolItemId, requestParameters.nexusOpsAppVersion, requestParameters.poolItemUpdateStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolItemsApiApiV1PoolsPoolIdItemsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolItemsApi
     */
    public apiV1PoolsPoolIdItemsPost(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsPostRequest, options?: RawAxiosRequestConfig) {
        return PoolItemsApiFp(this.configuration).apiV1PoolsPoolIdItemsPost(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, requestParameters.poolItemCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolItemsApiApiV1PoolsPoolIdItemsSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolItemsApi
     */
    public apiV1PoolsPoolIdItemsSearchPost(requestParameters: PoolItemsApiApiV1PoolsPoolIdItemsSearchPostRequest, options?: RawAxiosRequestConfig) {
        return PoolItemsApiFp(this.configuration).apiV1PoolsPoolIdItemsSearchPost(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, requestParameters.poolItemSearchPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PoolsApi - axios parameter creator
 * @export
 */
export const PoolsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemEntityType} [entityType] Describes entity types that are suitable for pools.  Must contain only values from EntityType.
         * @param {string} [entityId] 
         * @param {boolean} [isIncludeAssetPools] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsForEntityAllGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityType?: PoolItemEntityType, entityId?: string, isIncludeAssetPools?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsForEntityAllGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/pools/for-entity/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (isIncludeAssetPools !== undefined) {
                localVarQueryParameter['isIncludeAssetPools'] = isIncludeAssetPools;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {PoolItemEntityType} [entityType] Describes entity types that are suitable for pools.  Must contain only values from EntityType.
         * @param {string} [entityId] 
         * @param {boolean} [isIncludeAssetPools] 
         * @param {string} [search] 
         * @param {Array<string>} [ids] 
         * @param {Array<string>} [includeIds] 
         * @param {string} [from] Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {string} [to] Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {string} [sortBy] Comma-separated list of fields to sort by.
         * @param {string} [sortOrder] Comma-separated list of sort orders, with indexes corresponding to fields.  See values in SortOrder enum.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsForEntityGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, offset?: number, limit?: number, entityType?: PoolItemEntityType, entityId?: string, isIncludeAssetPools?: boolean, search?: string, ids?: Array<string>, includeIds?: Array<string>, from?: string, to?: string, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsForEntityGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/pools/for-entity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (isIncludeAssetPools !== undefined) {
                localVarQueryParameter['isIncludeAssetPools'] = isIncludeAssetPools;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (includeIds) {
                localVarQueryParameter['includeIds'] = includeIds;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntitiesPoolsGetRequestDto} [entitiesPoolsGetRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsGetForEntitiesPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entitiesPoolsGetRequestDto?: EntitiesPoolsGetRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsGetForEntitiesPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/pools/get/for-entities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entitiesPoolsGetRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolGetPaginatedDto} [poolGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, poolGetPaginatedDto?: PoolGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/pools/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(poolGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [poolIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsIntersectionGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, poolIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsIntersectionGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/pools/intersection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (poolIds) {
                localVarQueryParameter['poolIds'] = poolIds;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemStatus} [status] 
         * @param {PoolItemEntityType} [entityType] Describes entity types that are suitable for pools.  Must contain only values from EntityType.
         * @param {string} [dateRangeFrom] Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {string} [dateRangeTo] Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {boolean} [isIncludeItemIds] 
         * @param {number} [itemIdsLimit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdAvailabilityGet: async (nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, status?: PoolItemStatus, entityType?: PoolItemEntityType, dateRangeFrom?: string, dateRangeTo?: string, isIncludeItemIds?: boolean, itemIdsLimit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdAvailabilityGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdAvailabilityGet', 'poolId', poolId)
            const localVarPath = `/api/v1/pools/{poolId}/availability`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (dateRangeFrom !== undefined) {
                localVarQueryParameter['dateRange.from'] = dateRangeFrom;
            }

            if (dateRangeTo !== undefined) {
                localVarQueryParameter['dateRange.to'] = dateRangeTo;
            }

            if (isIncludeItemIds !== undefined) {
                localVarQueryParameter['isIncludeItemIds'] = isIncludeItemIds;
            }

            if (itemIdsLimit !== undefined) {
                localVarQueryParameter['itemIdsLimit'] = itemIdsLimit;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdDelete: async (nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdDelete', 'poolId', poolId)
            const localVarPath = `/api/v1/pools/{poolId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdGet: async (nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdGet', 'poolId', poolId)
            const localVarPath = `/api/v1/pools/{poolId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolUpdateDto} [poolUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdPut: async (nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, poolUpdateDto?: PoolUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('apiV1PoolsPoolIdPut', 'poolId', poolId)
            const localVarPath = `/api/v1/pools/{poolId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(poolUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolCreateDto} [poolCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, poolCreateDto?: PoolCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/pools`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(poolCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolSearchPaginatedDto} [poolSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsSearchPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, poolSearchPaginatedDto?: PoolSearchPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1PoolsSearchPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/pools/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(poolSearchPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoolsApi - functional programming interface
 * @export
 */
export const PoolsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PoolsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemEntityType} [entityType] Describes entity types that are suitable for pools.  Must contain only values from EntityType.
         * @param {string} [entityId] 
         * @param {boolean} [isIncludeAssetPools] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsForEntityAllGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityType?: PoolItemEntityType, entityId?: string, isIncludeAssetPools?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityPoolsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsForEntityAllGet(nexusOpsTenant, nexusOpsAppVersion, entityType, entityId, isIncludeAssetPools, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolsApi.apiV1PoolsForEntityAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {PoolItemEntityType} [entityType] Describes entity types that are suitable for pools.  Must contain only values from EntityType.
         * @param {string} [entityId] 
         * @param {boolean} [isIncludeAssetPools] 
         * @param {string} [search] 
         * @param {Array<string>} [ids] 
         * @param {Array<string>} [includeIds] 
         * @param {string} [from] Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {string} [to] Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {string} [sortBy] Comma-separated list of fields to sort by.
         * @param {string} [sortOrder] Comma-separated list of sort orders, with indexes corresponding to fields.  See values in SortOrder enum.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsForEntityGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, offset?: number, limit?: number, entityType?: PoolItemEntityType, entityId?: string, isIncludeAssetPools?: boolean, search?: string, ids?: Array<string>, includeIds?: Array<string>, from?: string, to?: string, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfPoolDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsForEntityGet(nexusOpsTenant, nexusOpsAppVersion, offset, limit, entityType, entityId, isIncludeAssetPools, search, ids, includeIds, from, to, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolsApi.apiV1PoolsForEntityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntitiesPoolsGetRequestDto} [entitiesPoolsGetRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsGetForEntitiesPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, entitiesPoolsGetRequestDto?: EntitiesPoolsGetRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityPoolsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsGetForEntitiesPost(nexusOpsTenant, nexusOpsAppVersion, entitiesPoolsGetRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolsApi.apiV1PoolsGetForEntitiesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolGetPaginatedDto} [poolGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, poolGetPaginatedDto?: PoolGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfPoolDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsGetPost(nexusOpsTenant, nexusOpsAppVersion, poolGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolsApi.apiV1PoolsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [poolIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsIntersectionGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, poolIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolsIntersectionResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsIntersectionGet(nexusOpsTenant, nexusOpsAppVersion, poolIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolsApi.apiV1PoolsIntersectionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolItemStatus} [status] 
         * @param {PoolItemEntityType} [entityType] Describes entity types that are suitable for pools.  Must contain only values from EntityType.
         * @param {string} [dateRangeFrom] Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {string} [dateRangeTo] Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {boolean} [isIncludeItemIds] 
         * @param {number} [itemIdsLimit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPoolIdAvailabilityGet(nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, status?: PoolItemStatus, entityType?: PoolItemEntityType, dateRangeFrom?: string, dateRangeTo?: string, isIncludeItemIds?: boolean, itemIdsLimit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolAvailabilityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPoolIdAvailabilityGet(nexusOpsTenant, poolId, nexusOpsAppVersion, status, entityType, dateRangeFrom, dateRangeTo, isIncludeItemIds, itemIdsLimit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolsApi.apiV1PoolsPoolIdAvailabilityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPoolIdDelete(nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPoolIdDelete(nexusOpsTenant, poolId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolsApi.apiV1PoolsPoolIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPoolIdGet(nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPoolIdGet(nexusOpsTenant, poolId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolsApi.apiV1PoolsPoolIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} poolId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolUpdateDto} [poolUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPoolIdPut(nexusOpsTenant: string, poolId: string, nexusOpsAppVersion?: string, poolUpdateDto?: PoolUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPoolIdPut(nexusOpsTenant, poolId, nexusOpsAppVersion, poolUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolsApi.apiV1PoolsPoolIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolCreateDto} [poolCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, poolCreateDto?: PoolCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsPost(nexusOpsTenant, nexusOpsAppVersion, poolCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolsApi.apiV1PoolsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {PoolSearchPaginatedDto} [poolSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PoolsSearchPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, poolSearchPaginatedDto?: PoolSearchPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfPoolDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PoolsSearchPost(nexusOpsTenant, nexusOpsAppVersion, poolSearchPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolsApi.apiV1PoolsSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PoolsApi - factory interface
 * @export
 */
export const PoolsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PoolsApiFp(configuration)
    return {
        /**
         * 
         * @param {PoolsApiApiV1PoolsForEntityAllGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsForEntityAllGet(requestParameters: PoolsApiApiV1PoolsForEntityAllGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityPoolsDto> {
            return localVarFp.apiV1PoolsForEntityAllGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityType, requestParameters.entityId, requestParameters.isIncludeAssetPools, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolsApiApiV1PoolsForEntityGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsForEntityGet(requestParameters: PoolsApiApiV1PoolsForEntityGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfPoolDto> {
            return localVarFp.apiV1PoolsForEntityGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.offset, requestParameters.limit, requestParameters.entityType, requestParameters.entityId, requestParameters.isIncludeAssetPools, requestParameters.search, requestParameters.ids, requestParameters.includeIds, requestParameters.from, requestParameters.to, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolsApiApiV1PoolsGetForEntitiesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsGetForEntitiesPost(requestParameters: PoolsApiApiV1PoolsGetForEntitiesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityPoolsDto>> {
            return localVarFp.apiV1PoolsGetForEntitiesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entitiesPoolsGetRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolsApiApiV1PoolsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsGetPost(requestParameters: PoolsApiApiV1PoolsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfPoolDto> {
            return localVarFp.apiV1PoolsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.poolGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolsApiApiV1PoolsIntersectionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsIntersectionGet(requestParameters: PoolsApiApiV1PoolsIntersectionGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoolsIntersectionResultDto> {
            return localVarFp.apiV1PoolsIntersectionGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.poolIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolsApiApiV1PoolsPoolIdAvailabilityGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdAvailabilityGet(requestParameters: PoolsApiApiV1PoolsPoolIdAvailabilityGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoolAvailabilityDto> {
            return localVarFp.apiV1PoolsPoolIdAvailabilityGet(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, requestParameters.status, requestParameters.entityType, requestParameters.dateRangeFrom, requestParameters.dateRangeTo, requestParameters.isIncludeItemIds, requestParameters.itemIdsLimit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolsApiApiV1PoolsPoolIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdDelete(requestParameters: PoolsApiApiV1PoolsPoolIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1PoolsPoolIdDelete(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolsApiApiV1PoolsPoolIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdGet(requestParameters: PoolsApiApiV1PoolsPoolIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoolDto> {
            return localVarFp.apiV1PoolsPoolIdGet(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolsApiApiV1PoolsPoolIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPoolIdPut(requestParameters: PoolsApiApiV1PoolsPoolIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoolDto> {
            return localVarFp.apiV1PoolsPoolIdPut(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, requestParameters.poolUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolsApiApiV1PoolsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsPost(requestParameters: PoolsApiApiV1PoolsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoolDto> {
            return localVarFp.apiV1PoolsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.poolCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PoolsApiApiV1PoolsSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PoolsSearchPost(requestParameters: PoolsApiApiV1PoolsSearchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfPoolDto> {
            return localVarFp.apiV1PoolsSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.poolSearchPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1PoolsForEntityAllGet operation in PoolsApi.
 * @export
 * @interface PoolsApiApiV1PoolsForEntityAllGetRequest
 */
export interface PoolsApiApiV1PoolsForEntityAllGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolsApiApiV1PoolsForEntityAllGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsForEntityAllGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * Describes entity types that are suitable for pools.  Must contain only values from EntityType.
     * @type {PoolItemEntityType}
     * @memberof PoolsApiApiV1PoolsForEntityAllGet
     */
    readonly entityType?: PoolItemEntityType

    /**
     * 
     * @type {string}
     * @memberof PoolsApiApiV1PoolsForEntityAllGet
     */
    readonly entityId?: string

    /**
     * 
     * @type {boolean}
     * @memberof PoolsApiApiV1PoolsForEntityAllGet
     */
    readonly isIncludeAssetPools?: boolean
}

/**
 * Request parameters for apiV1PoolsForEntityGet operation in PoolsApi.
 * @export
 * @interface PoolsApiApiV1PoolsForEntityGetRequest
 */
export interface PoolsApiApiV1PoolsForEntityGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolsApiApiV1PoolsForEntityGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsForEntityGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {number}
     * @memberof PoolsApiApiV1PoolsForEntityGet
     */
    readonly offset?: number

    /**
     * 
     * @type {number}
     * @memberof PoolsApiApiV1PoolsForEntityGet
     */
    readonly limit?: number

    /**
     * Describes entity types that are suitable for pools.  Must contain only values from EntityType.
     * @type {PoolItemEntityType}
     * @memberof PoolsApiApiV1PoolsForEntityGet
     */
    readonly entityType?: PoolItemEntityType

    /**
     * 
     * @type {string}
     * @memberof PoolsApiApiV1PoolsForEntityGet
     */
    readonly entityId?: string

    /**
     * 
     * @type {boolean}
     * @memberof PoolsApiApiV1PoolsForEntityGet
     */
    readonly isIncludeAssetPools?: boolean

    /**
     * 
     * @type {string}
     * @memberof PoolsApiApiV1PoolsForEntityGet
     */
    readonly search?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof PoolsApiApiV1PoolsForEntityGet
     */
    readonly ids?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof PoolsApiApiV1PoolsForEntityGet
     */
    readonly includeIds?: Array<string>

    /**
     * Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsForEntityGet
     */
    readonly from?: string

    /**
     * Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsForEntityGet
     */
    readonly to?: string

    /**
     * Comma-separated list of fields to sort by.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsForEntityGet
     */
    readonly sortBy?: string

    /**
     * Comma-separated list of sort orders, with indexes corresponding to fields.  See values in SortOrder enum.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsForEntityGet
     */
    readonly sortOrder?: string
}

/**
 * Request parameters for apiV1PoolsGetForEntitiesPost operation in PoolsApi.
 * @export
 * @interface PoolsApiApiV1PoolsGetForEntitiesPostRequest
 */
export interface PoolsApiApiV1PoolsGetForEntitiesPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolsApiApiV1PoolsGetForEntitiesPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsGetForEntitiesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntitiesPoolsGetRequestDto}
     * @memberof PoolsApiApiV1PoolsGetForEntitiesPost
     */
    readonly entitiesPoolsGetRequestDto?: EntitiesPoolsGetRequestDto
}

/**
 * Request parameters for apiV1PoolsGetPost operation in PoolsApi.
 * @export
 * @interface PoolsApiApiV1PoolsGetPostRequest
 */
export interface PoolsApiApiV1PoolsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolsApiApiV1PoolsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {PoolGetPaginatedDto}
     * @memberof PoolsApiApiV1PoolsGetPost
     */
    readonly poolGetPaginatedDto?: PoolGetPaginatedDto
}

/**
 * Request parameters for apiV1PoolsIntersectionGet operation in PoolsApi.
 * @export
 * @interface PoolsApiApiV1PoolsIntersectionGetRequest
 */
export interface PoolsApiApiV1PoolsIntersectionGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolsApiApiV1PoolsIntersectionGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsIntersectionGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof PoolsApiApiV1PoolsIntersectionGet
     */
    readonly poolIds?: Array<string>
}

/**
 * Request parameters for apiV1PoolsPoolIdAvailabilityGet operation in PoolsApi.
 * @export
 * @interface PoolsApiApiV1PoolsPoolIdAvailabilityGetRequest
 */
export interface PoolsApiApiV1PoolsPoolIdAvailabilityGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPoolIdAvailabilityGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPoolIdAvailabilityGet
     */
    readonly poolId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPoolIdAvailabilityGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {PoolItemStatus}
     * @memberof PoolsApiApiV1PoolsPoolIdAvailabilityGet
     */
    readonly status?: PoolItemStatus

    /**
     * Describes entity types that are suitable for pools.  Must contain only values from EntityType.
     * @type {PoolItemEntityType}
     * @memberof PoolsApiApiV1PoolsPoolIdAvailabilityGet
     */
    readonly entityType?: PoolItemEntityType

    /**
     * Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPoolIdAvailabilityGet
     */
    readonly dateRangeFrom?: string

    /**
     * Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPoolIdAvailabilityGet
     */
    readonly dateRangeTo?: string

    /**
     * 
     * @type {boolean}
     * @memberof PoolsApiApiV1PoolsPoolIdAvailabilityGet
     */
    readonly isIncludeItemIds?: boolean

    /**
     * 
     * @type {number}
     * @memberof PoolsApiApiV1PoolsPoolIdAvailabilityGet
     */
    readonly itemIdsLimit?: number
}

/**
 * Request parameters for apiV1PoolsPoolIdDelete operation in PoolsApi.
 * @export
 * @interface PoolsApiApiV1PoolsPoolIdDeleteRequest
 */
export interface PoolsApiApiV1PoolsPoolIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPoolIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPoolIdDelete
     */
    readonly poolId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPoolIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1PoolsPoolIdGet operation in PoolsApi.
 * @export
 * @interface PoolsApiApiV1PoolsPoolIdGetRequest
 */
export interface PoolsApiApiV1PoolsPoolIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPoolIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPoolIdGet
     */
    readonly poolId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPoolIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1PoolsPoolIdPut operation in PoolsApi.
 * @export
 * @interface PoolsApiApiV1PoolsPoolIdPutRequest
 */
export interface PoolsApiApiV1PoolsPoolIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPoolIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPoolIdPut
     */
    readonly poolId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPoolIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {PoolUpdateDto}
     * @memberof PoolsApiApiV1PoolsPoolIdPut
     */
    readonly poolUpdateDto?: PoolUpdateDto
}

/**
 * Request parameters for apiV1PoolsPost operation in PoolsApi.
 * @export
 * @interface PoolsApiApiV1PoolsPostRequest
 */
export interface PoolsApiApiV1PoolsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {PoolCreateDto}
     * @memberof PoolsApiApiV1PoolsPost
     */
    readonly poolCreateDto?: PoolCreateDto
}

/**
 * Request parameters for apiV1PoolsSearchPost operation in PoolsApi.
 * @export
 * @interface PoolsApiApiV1PoolsSearchPostRequest
 */
export interface PoolsApiApiV1PoolsSearchPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof PoolsApiApiV1PoolsSearchPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof PoolsApiApiV1PoolsSearchPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {PoolSearchPaginatedDto}
     * @memberof PoolsApiApiV1PoolsSearchPost
     */
    readonly poolSearchPaginatedDto?: PoolSearchPaginatedDto
}

/**
 * PoolsApi - object-oriented interface
 * @export
 * @class PoolsApi
 * @extends {BaseAPI}
 */
export class PoolsApi extends BaseAPI {
    /**
     * 
     * @param {PoolsApiApiV1PoolsForEntityAllGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    public apiV1PoolsForEntityAllGet(requestParameters: PoolsApiApiV1PoolsForEntityAllGetRequest, options?: RawAxiosRequestConfig) {
        return PoolsApiFp(this.configuration).apiV1PoolsForEntityAllGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityType, requestParameters.entityId, requestParameters.isIncludeAssetPools, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolsApiApiV1PoolsForEntityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    public apiV1PoolsForEntityGet(requestParameters: PoolsApiApiV1PoolsForEntityGetRequest, options?: RawAxiosRequestConfig) {
        return PoolsApiFp(this.configuration).apiV1PoolsForEntityGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.offset, requestParameters.limit, requestParameters.entityType, requestParameters.entityId, requestParameters.isIncludeAssetPools, requestParameters.search, requestParameters.ids, requestParameters.includeIds, requestParameters.from, requestParameters.to, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolsApiApiV1PoolsGetForEntitiesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    public apiV1PoolsGetForEntitiesPost(requestParameters: PoolsApiApiV1PoolsGetForEntitiesPostRequest, options?: RawAxiosRequestConfig) {
        return PoolsApiFp(this.configuration).apiV1PoolsGetForEntitiesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entitiesPoolsGetRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolsApiApiV1PoolsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    public apiV1PoolsGetPost(requestParameters: PoolsApiApiV1PoolsGetPostRequest, options?: RawAxiosRequestConfig) {
        return PoolsApiFp(this.configuration).apiV1PoolsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.poolGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolsApiApiV1PoolsIntersectionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    public apiV1PoolsIntersectionGet(requestParameters: PoolsApiApiV1PoolsIntersectionGetRequest, options?: RawAxiosRequestConfig) {
        return PoolsApiFp(this.configuration).apiV1PoolsIntersectionGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.poolIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolsApiApiV1PoolsPoolIdAvailabilityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    public apiV1PoolsPoolIdAvailabilityGet(requestParameters: PoolsApiApiV1PoolsPoolIdAvailabilityGetRequest, options?: RawAxiosRequestConfig) {
        return PoolsApiFp(this.configuration).apiV1PoolsPoolIdAvailabilityGet(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, requestParameters.status, requestParameters.entityType, requestParameters.dateRangeFrom, requestParameters.dateRangeTo, requestParameters.isIncludeItemIds, requestParameters.itemIdsLimit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolsApiApiV1PoolsPoolIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    public apiV1PoolsPoolIdDelete(requestParameters: PoolsApiApiV1PoolsPoolIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return PoolsApiFp(this.configuration).apiV1PoolsPoolIdDelete(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolsApiApiV1PoolsPoolIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    public apiV1PoolsPoolIdGet(requestParameters: PoolsApiApiV1PoolsPoolIdGetRequest, options?: RawAxiosRequestConfig) {
        return PoolsApiFp(this.configuration).apiV1PoolsPoolIdGet(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolsApiApiV1PoolsPoolIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    public apiV1PoolsPoolIdPut(requestParameters: PoolsApiApiV1PoolsPoolIdPutRequest, options?: RawAxiosRequestConfig) {
        return PoolsApiFp(this.configuration).apiV1PoolsPoolIdPut(requestParameters.nexusOpsTenant, requestParameters.poolId, requestParameters.nexusOpsAppVersion, requestParameters.poolUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolsApiApiV1PoolsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    public apiV1PoolsPost(requestParameters: PoolsApiApiV1PoolsPostRequest, options?: RawAxiosRequestConfig) {
        return PoolsApiFp(this.configuration).apiV1PoolsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.poolCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PoolsApiApiV1PoolsSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    public apiV1PoolsSearchPost(requestParameters: PoolsApiApiV1PoolsSearchPostRequest, options?: RawAxiosRequestConfig) {
        return PoolsApiFp(this.configuration).apiV1PoolsSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.poolSearchPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductLocationsApi - axios parameter creator
 * @export
 */
export const ProductLocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProductLocationsBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/product/locations/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ProductLocationGetPaginatedDto} [productLocationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, productLocationGetPaginatedDto?: ProductLocationGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProductLocationsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/product/locations/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productLocationGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateProductLocationDto} [createProductLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createProductLocationDto?: CreateProductLocationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProductLocationsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/product/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} productLocationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsProductLocationIdDelete: async (nexusOpsTenant: string, productLocationId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProductLocationsProductLocationIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'productLocationId' is not null or undefined
            assertParamExists('apiV1ProductLocationsProductLocationIdDelete', 'productLocationId', productLocationId)
            const localVarPath = `/api/v1/product/locations/{productLocationId}`
                .replace(`{${"productLocationId"}}`, encodeURIComponent(String(productLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} productLocationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsProductLocationIdGet: async (nexusOpsTenant: string, productLocationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProductLocationsProductLocationIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'productLocationId' is not null or undefined
            assertParamExists('apiV1ProductLocationsProductLocationIdGet', 'productLocationId', productLocationId)
            const localVarPath = `/api/v1/product/locations/{productLocationId}`
                .replace(`{${"productLocationId"}}`, encodeURIComponent(String(productLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} productLocationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateProductLocationDto} [updateProductLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsProductLocationIdPut: async (nexusOpsTenant: string, productLocationId: string, nexusOpsAppVersion?: string, updateProductLocationDto?: UpdateProductLocationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProductLocationsProductLocationIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'productLocationId' is not null or undefined
            assertParamExists('apiV1ProductLocationsProductLocationIdPut', 'productLocationId', productLocationId)
            const localVarPath = `/api/v1/product/locations/{productLocationId}`
                .replace(`{${"productLocationId"}}`, encodeURIComponent(String(productLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} productLocationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddProductLocationSpotsDto} [addProductLocationSpotsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsProductLocationIdSpotsPost: async (nexusOpsTenant: string, productLocationId: string, nexusOpsAppVersion?: string, addProductLocationSpotsDto?: AddProductLocationSpotsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProductLocationsProductLocationIdSpotsPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'productLocationId' is not null or undefined
            assertParamExists('apiV1ProductLocationsProductLocationIdSpotsPost', 'productLocationId', productLocationId)
            const localVarPath = `/api/v1/product/locations/{productLocationId}/spots`
                .replace(`{${"productLocationId"}}`, encodeURIComponent(String(productLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addProductLocationSpotsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} productLocationId 
         * @param {string} spotId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsProductLocationIdSpotsSpotIdDelete: async (nexusOpsTenant: string, productLocationId: string, spotId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProductLocationsProductLocationIdSpotsSpotIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'productLocationId' is not null or undefined
            assertParamExists('apiV1ProductLocationsProductLocationIdSpotsSpotIdDelete', 'productLocationId', productLocationId)
            // verify required parameter 'spotId' is not null or undefined
            assertParamExists('apiV1ProductLocationsProductLocationIdSpotsSpotIdDelete', 'spotId', spotId)
            const localVarPath = `/api/v1/product/locations/{productLocationId}/spots/{spotId}`
                .replace(`{${"productLocationId"}}`, encodeURIComponent(String(productLocationId)))
                .replace(`{${"spotId"}}`, encodeURIComponent(String(spotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductLocationsApi - functional programming interface
 * @export
 */
export const ProductLocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductLocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductLocationsBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductLocationsBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductLocationsApi.apiV1ProductLocationsBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ProductLocationGetPaginatedDto} [productLocationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductLocationsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, productLocationGetPaginatedDto?: ProductLocationGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfProductLocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductLocationsGetPost(nexusOpsTenant, nexusOpsAppVersion, productLocationGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductLocationsApi.apiV1ProductLocationsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateProductLocationDto} [createProductLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductLocationsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createProductLocationDto?: CreateProductLocationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductLocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductLocationsPost(nexusOpsTenant, nexusOpsAppVersion, createProductLocationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductLocationsApi.apiV1ProductLocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} productLocationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductLocationsProductLocationIdDelete(nexusOpsTenant: string, productLocationId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductLocationsProductLocationIdDelete(nexusOpsTenant, productLocationId, nexusOpsAppVersion, isDeleteCascade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductLocationsApi.apiV1ProductLocationsProductLocationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} productLocationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductLocationsProductLocationIdGet(nexusOpsTenant: string, productLocationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductLocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductLocationsProductLocationIdGet(nexusOpsTenant, productLocationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductLocationsApi.apiV1ProductLocationsProductLocationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} productLocationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateProductLocationDto} [updateProductLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductLocationsProductLocationIdPut(nexusOpsTenant: string, productLocationId: string, nexusOpsAppVersion?: string, updateProductLocationDto?: UpdateProductLocationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductLocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductLocationsProductLocationIdPut(nexusOpsTenant, productLocationId, nexusOpsAppVersion, updateProductLocationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductLocationsApi.apiV1ProductLocationsProductLocationIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} productLocationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AddProductLocationSpotsDto} [addProductLocationSpotsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductLocationsProductLocationIdSpotsPost(nexusOpsTenant: string, productLocationId: string, nexusOpsAppVersion?: string, addProductLocationSpotsDto?: AddProductLocationSpotsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductLocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductLocationsProductLocationIdSpotsPost(nexusOpsTenant, productLocationId, nexusOpsAppVersion, addProductLocationSpotsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductLocationsApi.apiV1ProductLocationsProductLocationIdSpotsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} productLocationId 
         * @param {string} spotId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductLocationsProductLocationIdSpotsSpotIdDelete(nexusOpsTenant: string, productLocationId: string, spotId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductLocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductLocationsProductLocationIdSpotsSpotIdDelete(nexusOpsTenant, productLocationId, spotId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductLocationsApi.apiV1ProductLocationsProductLocationIdSpotsSpotIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductLocationsApi - factory interface
 * @export
 */
export const ProductLocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductLocationsApiFp(configuration)
    return {
        /**
         * 
         * @param {ProductLocationsApiApiV1ProductLocationsBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsBulkDeleteDelete(requestParameters: ProductLocationsApiApiV1ProductLocationsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1ProductLocationsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductLocationsApiApiV1ProductLocationsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsGetPost(requestParameters: ProductLocationsApiApiV1ProductLocationsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfProductLocationDto> {
            return localVarFp.apiV1ProductLocationsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.productLocationGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductLocationsApiApiV1ProductLocationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsPost(requestParameters: ProductLocationsApiApiV1ProductLocationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductLocationDto> {
            return localVarFp.apiV1ProductLocationsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createProductLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductLocationsApiApiV1ProductLocationsProductLocationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsProductLocationIdDelete(requestParameters: ProductLocationsApiApiV1ProductLocationsProductLocationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1ProductLocationsProductLocationIdDelete(requestParameters.nexusOpsTenant, requestParameters.productLocationId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductLocationsApiApiV1ProductLocationsProductLocationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsProductLocationIdGet(requestParameters: ProductLocationsApiApiV1ProductLocationsProductLocationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductLocationDto> {
            return localVarFp.apiV1ProductLocationsProductLocationIdGet(requestParameters.nexusOpsTenant, requestParameters.productLocationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductLocationsApiApiV1ProductLocationsProductLocationIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsProductLocationIdPut(requestParameters: ProductLocationsApiApiV1ProductLocationsProductLocationIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductLocationDto> {
            return localVarFp.apiV1ProductLocationsProductLocationIdPut(requestParameters.nexusOpsTenant, requestParameters.productLocationId, requestParameters.nexusOpsAppVersion, requestParameters.updateProductLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsProductLocationIdSpotsPost(requestParameters: ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductLocationDto> {
            return localVarFp.apiV1ProductLocationsProductLocationIdSpotsPost(requestParameters.nexusOpsTenant, requestParameters.productLocationId, requestParameters.nexusOpsAppVersion, requestParameters.addProductLocationSpotsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsSpotIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductLocationsProductLocationIdSpotsSpotIdDelete(requestParameters: ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsSpotIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductLocationDto> {
            return localVarFp.apiV1ProductLocationsProductLocationIdSpotsSpotIdDelete(requestParameters.nexusOpsTenant, requestParameters.productLocationId, requestParameters.spotId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ProductLocationsBulkDeleteDelete operation in ProductLocationsApi.
 * @export
 * @interface ProductLocationsApiApiV1ProductLocationsBulkDeleteDeleteRequest
 */
export interface ProductLocationsApiApiV1ProductLocationsBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof ProductLocationsApiApiV1ProductLocationsBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1ProductLocationsGetPost operation in ProductLocationsApi.
 * @export
 * @interface ProductLocationsApiApiV1ProductLocationsGetPostRequest
 */
export interface ProductLocationsApiApiV1ProductLocationsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ProductLocationGetPaginatedDto}
     * @memberof ProductLocationsApiApiV1ProductLocationsGetPost
     */
    readonly productLocationGetPaginatedDto?: ProductLocationGetPaginatedDto
}

/**
 * Request parameters for apiV1ProductLocationsPost operation in ProductLocationsApi.
 * @export
 * @interface ProductLocationsApiApiV1ProductLocationsPostRequest
 */
export interface ProductLocationsApiApiV1ProductLocationsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateProductLocationDto}
     * @memberof ProductLocationsApiApiV1ProductLocationsPost
     */
    readonly createProductLocationDto?: CreateProductLocationDto
}

/**
 * Request parameters for apiV1ProductLocationsProductLocationIdDelete operation in ProductLocationsApi.
 * @export
 * @interface ProductLocationsApiApiV1ProductLocationsProductLocationIdDeleteRequest
 */
export interface ProductLocationsApiApiV1ProductLocationsProductLocationIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdDelete
     */
    readonly productLocationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdDelete
     */
    readonly isDeleteCascade?: boolean
}

/**
 * Request parameters for apiV1ProductLocationsProductLocationIdGet operation in ProductLocationsApi.
 * @export
 * @interface ProductLocationsApiApiV1ProductLocationsProductLocationIdGetRequest
 */
export interface ProductLocationsApiApiV1ProductLocationsProductLocationIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdGet
     */
    readonly productLocationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ProductLocationsProductLocationIdPut operation in ProductLocationsApi.
 * @export
 * @interface ProductLocationsApiApiV1ProductLocationsProductLocationIdPutRequest
 */
export interface ProductLocationsApiApiV1ProductLocationsProductLocationIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdPut
     */
    readonly productLocationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateProductLocationDto}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdPut
     */
    readonly updateProductLocationDto?: UpdateProductLocationDto
}

/**
 * Request parameters for apiV1ProductLocationsProductLocationIdSpotsPost operation in ProductLocationsApi.
 * @export
 * @interface ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsPostRequest
 */
export interface ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsPost
     */
    readonly productLocationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AddProductLocationSpotsDto}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsPost
     */
    readonly addProductLocationSpotsDto?: AddProductLocationSpotsDto
}

/**
 * Request parameters for apiV1ProductLocationsProductLocationIdSpotsSpotIdDelete operation in ProductLocationsApi.
 * @export
 * @interface ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsSpotIdDeleteRequest
 */
export interface ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsSpotIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsSpotIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsSpotIdDelete
     */
    readonly productLocationId: string

    /**
     * 
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsSpotIdDelete
     */
    readonly spotId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsSpotIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * ProductLocationsApi - object-oriented interface
 * @export
 * @class ProductLocationsApi
 * @extends {BaseAPI}
 */
export class ProductLocationsApi extends BaseAPI {
    /**
     * 
     * @param {ProductLocationsApiApiV1ProductLocationsBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductLocationsApi
     */
    public apiV1ProductLocationsBulkDeleteDelete(requestParameters: ProductLocationsApiApiV1ProductLocationsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return ProductLocationsApiFp(this.configuration).apiV1ProductLocationsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductLocationsApiApiV1ProductLocationsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductLocationsApi
     */
    public apiV1ProductLocationsGetPost(requestParameters: ProductLocationsApiApiV1ProductLocationsGetPostRequest, options?: RawAxiosRequestConfig) {
        return ProductLocationsApiFp(this.configuration).apiV1ProductLocationsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.productLocationGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductLocationsApiApiV1ProductLocationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductLocationsApi
     */
    public apiV1ProductLocationsPost(requestParameters: ProductLocationsApiApiV1ProductLocationsPostRequest, options?: RawAxiosRequestConfig) {
        return ProductLocationsApiFp(this.configuration).apiV1ProductLocationsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createProductLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductLocationsApiApiV1ProductLocationsProductLocationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductLocationsApi
     */
    public apiV1ProductLocationsProductLocationIdDelete(requestParameters: ProductLocationsApiApiV1ProductLocationsProductLocationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ProductLocationsApiFp(this.configuration).apiV1ProductLocationsProductLocationIdDelete(requestParameters.nexusOpsTenant, requestParameters.productLocationId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductLocationsApiApiV1ProductLocationsProductLocationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductLocationsApi
     */
    public apiV1ProductLocationsProductLocationIdGet(requestParameters: ProductLocationsApiApiV1ProductLocationsProductLocationIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProductLocationsApiFp(this.configuration).apiV1ProductLocationsProductLocationIdGet(requestParameters.nexusOpsTenant, requestParameters.productLocationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductLocationsApiApiV1ProductLocationsProductLocationIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductLocationsApi
     */
    public apiV1ProductLocationsProductLocationIdPut(requestParameters: ProductLocationsApiApiV1ProductLocationsProductLocationIdPutRequest, options?: RawAxiosRequestConfig) {
        return ProductLocationsApiFp(this.configuration).apiV1ProductLocationsProductLocationIdPut(requestParameters.nexusOpsTenant, requestParameters.productLocationId, requestParameters.nexusOpsAppVersion, requestParameters.updateProductLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductLocationsApi
     */
    public apiV1ProductLocationsProductLocationIdSpotsPost(requestParameters: ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsPostRequest, options?: RawAxiosRequestConfig) {
        return ProductLocationsApiFp(this.configuration).apiV1ProductLocationsProductLocationIdSpotsPost(requestParameters.nexusOpsTenant, requestParameters.productLocationId, requestParameters.nexusOpsAppVersion, requestParameters.addProductLocationSpotsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsSpotIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductLocationsApi
     */
    public apiV1ProductLocationsProductLocationIdSpotsSpotIdDelete(requestParameters: ProductLocationsApiApiV1ProductLocationsProductLocationIdSpotsSpotIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ProductLocationsApiFp(this.configuration).apiV1ProductLocationsProductLocationIdSpotsSpotIdDelete(requestParameters.nexusOpsTenant, requestParameters.productLocationId, requestParameters.spotId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfileAuthorizationGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProfileAuthorizationGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/profile/authorization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfileGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProfileGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilePermissionsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProfilePermissionsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/profile/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralAvatarAddDto} [generalAvatarAddDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilePersonalInfoAvatarPut: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, generalAvatarAddDto?: GeneralAvatarAddDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProfilePersonalInfoAvatarPut', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/profile/personal-info/avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalAvatarAddDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilePersonalInfoAvatarRemoveDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProfilePersonalInfoAvatarRemoveDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/profile/personal-info/avatar/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ProfilePersonalInfoUpdateDto} [profilePersonalInfoUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilePersonalInfoPut: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, profilePersonalInfoUpdateDto?: ProfilePersonalInfoUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProfilePersonalInfoPut', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/profile/personal-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profilePersonalInfoUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfileRolesGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProfileRolesGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/profile/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfileSettingsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProfileSettingsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/profile/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UserSettingsInputDto} [userSettingsInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfileSettingsPut: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, userSettingsInputDto?: UserSettingsInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProfileSettingsPut', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/profile/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSettingsInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfileTenantsCurrentGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProfileTenantsCurrentGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/profile/tenants/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfileTenantsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1ProfileTenantsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/profile/tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProfileAuthorizationGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizationProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProfileAuthorizationGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1ProfileAuthorizationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProfileGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProfileGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1ProfileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProfilePermissionsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfilePermissionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProfilePermissionsGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1ProfilePermissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralAvatarAddDto} [generalAvatarAddDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProfilePersonalInfoAvatarPut(nexusOpsTenant: string, nexusOpsAppVersion?: string, generalAvatarAddDto?: GeneralAvatarAddDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProfilePersonalInfoAvatarPut(nexusOpsTenant, nexusOpsAppVersion, generalAvatarAddDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1ProfilePersonalInfoAvatarPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProfilePersonalInfoAvatarRemoveDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProfilePersonalInfoAvatarRemoveDelete(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1ProfilePersonalInfoAvatarRemoveDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ProfilePersonalInfoUpdateDto} [profilePersonalInfoUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProfilePersonalInfoPut(nexusOpsTenant: string, nexusOpsAppVersion?: string, profilePersonalInfoUpdateDto?: ProfilePersonalInfoUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProfilePersonalInfoPut(nexusOpsTenant, nexusOpsAppVersion, profilePersonalInfoUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1ProfilePersonalInfoPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProfileRolesGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileRolesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProfileRolesGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1ProfileRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProfileSettingsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProfileSettingsGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1ProfileSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UserSettingsInputDto} [userSettingsInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProfileSettingsPut(nexusOpsTenant: string, nexusOpsAppVersion?: string, userSettingsInputDto?: UserSettingsInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProfileSettingsPut(nexusOpsTenant, nexusOpsAppVersion, userSettingsInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1ProfileSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProfileTenantsCurrentGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProfileTenantsCurrentGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1ProfileTenantsCurrentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProfileTenantsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProfileTenantsGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.apiV1ProfileTenantsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileApiFp(configuration)
    return {
        /**
         * 
         * @param {ProfileApiApiV1ProfileAuthorizationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfileAuthorizationGet(requestParameters: ProfileApiApiV1ProfileAuthorizationGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthorizationProfileDto> {
            return localVarFp.apiV1ProfileAuthorizationGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProfileApiApiV1ProfileGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfileGet(requestParameters: ProfileApiApiV1ProfileGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfileDto> {
            return localVarFp.apiV1ProfileGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProfileApiApiV1ProfilePermissionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilePermissionsGet(requestParameters: ProfileApiApiV1ProfilePermissionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfilePermissionsDto> {
            return localVarFp.apiV1ProfilePermissionsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProfileApiApiV1ProfilePersonalInfoAvatarPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilePersonalInfoAvatarPut(requestParameters: ProfileApiApiV1ProfilePersonalInfoAvatarPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfileDto> {
            return localVarFp.apiV1ProfilePersonalInfoAvatarPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalAvatarAddDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProfileApiApiV1ProfilePersonalInfoAvatarRemoveDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilePersonalInfoAvatarRemoveDelete(requestParameters: ProfileApiApiV1ProfilePersonalInfoAvatarRemoveDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfileDto> {
            return localVarFp.apiV1ProfilePersonalInfoAvatarRemoveDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProfileApiApiV1ProfilePersonalInfoPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilePersonalInfoPut(requestParameters: ProfileApiApiV1ProfilePersonalInfoPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfileDto> {
            return localVarFp.apiV1ProfilePersonalInfoPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.profilePersonalInfoUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProfileApiApiV1ProfileRolesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfileRolesGet(requestParameters: ProfileApiApiV1ProfileRolesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfileRolesDto> {
            return localVarFp.apiV1ProfileRolesGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProfileApiApiV1ProfileSettingsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfileSettingsGet(requestParameters: ProfileApiApiV1ProfileSettingsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSettingsDto> {
            return localVarFp.apiV1ProfileSettingsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProfileApiApiV1ProfileSettingsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfileSettingsPut(requestParameters: ProfileApiApiV1ProfileSettingsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSettingsDto> {
            return localVarFp.apiV1ProfileSettingsPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.userSettingsInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProfileApiApiV1ProfileTenantsCurrentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfileTenantsCurrentGet(requestParameters: ProfileApiApiV1ProfileTenantsCurrentGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantDto> {
            return localVarFp.apiV1ProfileTenantsCurrentGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProfileApiApiV1ProfileTenantsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfileTenantsGet(requestParameters: ProfileApiApiV1ProfileTenantsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TenantDto>> {
            return localVarFp.apiV1ProfileTenantsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ProfileAuthorizationGet operation in ProfileApi.
 * @export
 * @interface ProfileApiApiV1ProfileAuthorizationGetRequest
 */
export interface ProfileApiApiV1ProfileAuthorizationGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProfileApiApiV1ProfileAuthorizationGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProfileApiApiV1ProfileAuthorizationGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ProfileGet operation in ProfileApi.
 * @export
 * @interface ProfileApiApiV1ProfileGetRequest
 */
export interface ProfileApiApiV1ProfileGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProfileApiApiV1ProfileGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProfileApiApiV1ProfileGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ProfilePermissionsGet operation in ProfileApi.
 * @export
 * @interface ProfileApiApiV1ProfilePermissionsGetRequest
 */
export interface ProfileApiApiV1ProfilePermissionsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProfileApiApiV1ProfilePermissionsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProfileApiApiV1ProfilePermissionsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ProfilePersonalInfoAvatarPut operation in ProfileApi.
 * @export
 * @interface ProfileApiApiV1ProfilePersonalInfoAvatarPutRequest
 */
export interface ProfileApiApiV1ProfilePersonalInfoAvatarPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProfileApiApiV1ProfilePersonalInfoAvatarPut
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProfileApiApiV1ProfilePersonalInfoAvatarPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralAvatarAddDto}
     * @memberof ProfileApiApiV1ProfilePersonalInfoAvatarPut
     */
    readonly generalAvatarAddDto?: GeneralAvatarAddDto
}

/**
 * Request parameters for apiV1ProfilePersonalInfoAvatarRemoveDelete operation in ProfileApi.
 * @export
 * @interface ProfileApiApiV1ProfilePersonalInfoAvatarRemoveDeleteRequest
 */
export interface ProfileApiApiV1ProfilePersonalInfoAvatarRemoveDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProfileApiApiV1ProfilePersonalInfoAvatarRemoveDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProfileApiApiV1ProfilePersonalInfoAvatarRemoveDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ProfilePersonalInfoPut operation in ProfileApi.
 * @export
 * @interface ProfileApiApiV1ProfilePersonalInfoPutRequest
 */
export interface ProfileApiApiV1ProfilePersonalInfoPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProfileApiApiV1ProfilePersonalInfoPut
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProfileApiApiV1ProfilePersonalInfoPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ProfilePersonalInfoUpdateDto}
     * @memberof ProfileApiApiV1ProfilePersonalInfoPut
     */
    readonly profilePersonalInfoUpdateDto?: ProfilePersonalInfoUpdateDto
}

/**
 * Request parameters for apiV1ProfileRolesGet operation in ProfileApi.
 * @export
 * @interface ProfileApiApiV1ProfileRolesGetRequest
 */
export interface ProfileApiApiV1ProfileRolesGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProfileApiApiV1ProfileRolesGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProfileApiApiV1ProfileRolesGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ProfileSettingsGet operation in ProfileApi.
 * @export
 * @interface ProfileApiApiV1ProfileSettingsGetRequest
 */
export interface ProfileApiApiV1ProfileSettingsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProfileApiApiV1ProfileSettingsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProfileApiApiV1ProfileSettingsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ProfileSettingsPut operation in ProfileApi.
 * @export
 * @interface ProfileApiApiV1ProfileSettingsPutRequest
 */
export interface ProfileApiApiV1ProfileSettingsPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProfileApiApiV1ProfileSettingsPut
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProfileApiApiV1ProfileSettingsPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UserSettingsInputDto}
     * @memberof ProfileApiApiV1ProfileSettingsPut
     */
    readonly userSettingsInputDto?: UserSettingsInputDto
}

/**
 * Request parameters for apiV1ProfileTenantsCurrentGet operation in ProfileApi.
 * @export
 * @interface ProfileApiApiV1ProfileTenantsCurrentGetRequest
 */
export interface ProfileApiApiV1ProfileTenantsCurrentGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProfileApiApiV1ProfileTenantsCurrentGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProfileApiApiV1ProfileTenantsCurrentGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ProfileTenantsGet operation in ProfileApi.
 * @export
 * @interface ProfileApiApiV1ProfileTenantsGetRequest
 */
export interface ProfileApiApiV1ProfileTenantsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof ProfileApiApiV1ProfileTenantsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof ProfileApiApiV1ProfileTenantsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
    /**
     * 
     * @param {ProfileApiApiV1ProfileAuthorizationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiV1ProfileAuthorizationGet(requestParameters: ProfileApiApiV1ProfileAuthorizationGetRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1ProfileAuthorizationGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProfileApiApiV1ProfileGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiV1ProfileGet(requestParameters: ProfileApiApiV1ProfileGetRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1ProfileGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProfileApiApiV1ProfilePermissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiV1ProfilePermissionsGet(requestParameters: ProfileApiApiV1ProfilePermissionsGetRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1ProfilePermissionsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProfileApiApiV1ProfilePersonalInfoAvatarPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiV1ProfilePersonalInfoAvatarPut(requestParameters: ProfileApiApiV1ProfilePersonalInfoAvatarPutRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1ProfilePersonalInfoAvatarPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.generalAvatarAddDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProfileApiApiV1ProfilePersonalInfoAvatarRemoveDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiV1ProfilePersonalInfoAvatarRemoveDelete(requestParameters: ProfileApiApiV1ProfilePersonalInfoAvatarRemoveDeleteRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1ProfilePersonalInfoAvatarRemoveDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProfileApiApiV1ProfilePersonalInfoPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiV1ProfilePersonalInfoPut(requestParameters: ProfileApiApiV1ProfilePersonalInfoPutRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1ProfilePersonalInfoPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.profilePersonalInfoUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProfileApiApiV1ProfileRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiV1ProfileRolesGet(requestParameters: ProfileApiApiV1ProfileRolesGetRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1ProfileRolesGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProfileApiApiV1ProfileSettingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiV1ProfileSettingsGet(requestParameters: ProfileApiApiV1ProfileSettingsGetRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1ProfileSettingsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProfileApiApiV1ProfileSettingsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiV1ProfileSettingsPut(requestParameters: ProfileApiApiV1ProfileSettingsPutRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1ProfileSettingsPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.userSettingsInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProfileApiApiV1ProfileTenantsCurrentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiV1ProfileTenantsCurrentGet(requestParameters: ProfileApiApiV1ProfileTenantsCurrentGetRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1ProfileTenantsCurrentGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProfileApiApiV1ProfileTenantsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiV1ProfileTenantsGet(requestParameters: ProfileApiApiV1ProfileTenantsGetRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiV1ProfileTenantsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RepairCatalogsApi - axios parameter creator
 * @export
 */
export const RepairCatalogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairCatalogGetPaginatedDto} [repairCatalogGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairCatalogsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, repairCatalogGetPaginatedDto?: RepairCatalogGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairCatalogsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair/catalogs/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairCatalogGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [sourceCatalogId] 
         * @param {string} [targetCatalogId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairCatalogsImportFromCatalogInfoGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, sourceCatalogId?: string, targetCatalogId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairCatalogsImportFromCatalogInfoGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair/catalogs/import/from-catalog/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sourceCatalogId !== undefined) {
                localVarQueryParameter['sourceCatalogId'] = sourceCatalogId;
            }

            if (targetCatalogId !== undefined) {
                localVarQueryParameter['targetCatalogId'] = targetCatalogId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ImportFromCatalogDto} [importFromCatalogDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairCatalogsImportFromCatalogPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, importFromCatalogDto?: ImportFromCatalogDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairCatalogsImportFromCatalogPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair/catalogs/import/from-catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importFromCatalogDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairCatalogId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairCatalogsRepairCatalogIdGet: async (nexusOpsTenant: string, repairCatalogId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairCatalogsRepairCatalogIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairCatalogId' is not null or undefined
            assertParamExists('apiV1RepairCatalogsRepairCatalogIdGet', 'repairCatalogId', repairCatalogId)
            const localVarPath = `/api/v1/repair/catalogs/{repairCatalogId}`
                .replace(`{${"repairCatalogId"}}`, encodeURIComponent(String(repairCatalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairCatalogSearchPaginatedDto} [repairCatalogSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairCatalogsSearchPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, repairCatalogSearchPaginatedDto?: RepairCatalogSearchPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairCatalogsSearchPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair/catalogs/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairCatalogSearchPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepairCatalogsApi - functional programming interface
 * @export
 */
export const RepairCatalogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepairCatalogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairCatalogGetPaginatedDto} [repairCatalogGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairCatalogsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, repairCatalogGetPaginatedDto?: RepairCatalogGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfRepairCatalogDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairCatalogsGetPost(nexusOpsTenant, nexusOpsAppVersion, repairCatalogGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairCatalogsApi.apiV1RepairCatalogsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [sourceCatalogId] 
         * @param {string} [targetCatalogId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairCatalogsImportFromCatalogInfoGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, sourceCatalogId?: string, targetCatalogId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportFromCatalogInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairCatalogsImportFromCatalogInfoGet(nexusOpsTenant, nexusOpsAppVersion, sourceCatalogId, targetCatalogId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairCatalogsApi.apiV1RepairCatalogsImportFromCatalogInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ImportFromCatalogDto} [importFromCatalogDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairCatalogsImportFromCatalogPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, importFromCatalogDto?: ImportFromCatalogDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairCatalogsImportFromCatalogPost(nexusOpsTenant, nexusOpsAppVersion, importFromCatalogDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairCatalogsApi.apiV1RepairCatalogsImportFromCatalogPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairCatalogId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairCatalogsRepairCatalogIdGet(nexusOpsTenant: string, repairCatalogId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairCatalogDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairCatalogsRepairCatalogIdGet(nexusOpsTenant, repairCatalogId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairCatalogsApi.apiV1RepairCatalogsRepairCatalogIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairCatalogSearchPaginatedDto} [repairCatalogSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairCatalogsSearchPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, repairCatalogSearchPaginatedDto?: RepairCatalogSearchPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfRepairCatalogDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairCatalogsSearchPost(nexusOpsTenant, nexusOpsAppVersion, repairCatalogSearchPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairCatalogsApi.apiV1RepairCatalogsSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RepairCatalogsApi - factory interface
 * @export
 */
export const RepairCatalogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepairCatalogsApiFp(configuration)
    return {
        /**
         * 
         * @param {RepairCatalogsApiApiV1RepairCatalogsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairCatalogsGetPost(requestParameters: RepairCatalogsApiApiV1RepairCatalogsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfRepairCatalogDto> {
            return localVarFp.apiV1RepairCatalogsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairCatalogGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogInfoGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairCatalogsImportFromCatalogInfoGet(requestParameters: RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogInfoGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportFromCatalogInfoDto> {
            return localVarFp.apiV1RepairCatalogsImportFromCatalogInfoGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.sourceCatalogId, requestParameters.targetCatalogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairCatalogsImportFromCatalogPost(requestParameters: RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1RepairCatalogsImportFromCatalogPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.importFromCatalogDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairCatalogsApiApiV1RepairCatalogsRepairCatalogIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairCatalogsRepairCatalogIdGet(requestParameters: RepairCatalogsApiApiV1RepairCatalogsRepairCatalogIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairCatalogDto> {
            return localVarFp.apiV1RepairCatalogsRepairCatalogIdGet(requestParameters.nexusOpsTenant, requestParameters.repairCatalogId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairCatalogsApiApiV1RepairCatalogsSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairCatalogsSearchPost(requestParameters: RepairCatalogsApiApiV1RepairCatalogsSearchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfRepairCatalogDto> {
            return localVarFp.apiV1RepairCatalogsSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairCatalogSearchPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1RepairCatalogsGetPost operation in RepairCatalogsApi.
 * @export
 * @interface RepairCatalogsApiApiV1RepairCatalogsGetPostRequest
 */
export interface RepairCatalogsApiApiV1RepairCatalogsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RepairCatalogGetPaginatedDto}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsGetPost
     */
    readonly repairCatalogGetPaginatedDto?: RepairCatalogGetPaginatedDto
}

/**
 * Request parameters for apiV1RepairCatalogsImportFromCatalogInfoGet operation in RepairCatalogsApi.
 * @export
 * @interface RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogInfoGetRequest
 */
export interface RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogInfoGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogInfoGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogInfoGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogInfoGet
     */
    readonly sourceCatalogId?: string

    /**
     * 
     * @type {string}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogInfoGet
     */
    readonly targetCatalogId?: string
}

/**
 * Request parameters for apiV1RepairCatalogsImportFromCatalogPost operation in RepairCatalogsApi.
 * @export
 * @interface RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogPostRequest
 */
export interface RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ImportFromCatalogDto}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogPost
     */
    readonly importFromCatalogDto?: ImportFromCatalogDto
}

/**
 * Request parameters for apiV1RepairCatalogsRepairCatalogIdGet operation in RepairCatalogsApi.
 * @export
 * @interface RepairCatalogsApiApiV1RepairCatalogsRepairCatalogIdGetRequest
 */
export interface RepairCatalogsApiApiV1RepairCatalogsRepairCatalogIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsRepairCatalogIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsRepairCatalogIdGet
     */
    readonly repairCatalogId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsRepairCatalogIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairCatalogsSearchPost operation in RepairCatalogsApi.
 * @export
 * @interface RepairCatalogsApiApiV1RepairCatalogsSearchPostRequest
 */
export interface RepairCatalogsApiApiV1RepairCatalogsSearchPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsSearchPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsSearchPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RepairCatalogSearchPaginatedDto}
     * @memberof RepairCatalogsApiApiV1RepairCatalogsSearchPost
     */
    readonly repairCatalogSearchPaginatedDto?: RepairCatalogSearchPaginatedDto
}

/**
 * RepairCatalogsApi - object-oriented interface
 * @export
 * @class RepairCatalogsApi
 * @extends {BaseAPI}
 */
export class RepairCatalogsApi extends BaseAPI {
    /**
     * 
     * @param {RepairCatalogsApiApiV1RepairCatalogsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairCatalogsApi
     */
    public apiV1RepairCatalogsGetPost(requestParameters: RepairCatalogsApiApiV1RepairCatalogsGetPostRequest, options?: RawAxiosRequestConfig) {
        return RepairCatalogsApiFp(this.configuration).apiV1RepairCatalogsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairCatalogGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogInfoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairCatalogsApi
     */
    public apiV1RepairCatalogsImportFromCatalogInfoGet(requestParameters: RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogInfoGetRequest, options?: RawAxiosRequestConfig) {
        return RepairCatalogsApiFp(this.configuration).apiV1RepairCatalogsImportFromCatalogInfoGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.sourceCatalogId, requestParameters.targetCatalogId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairCatalogsApi
     */
    public apiV1RepairCatalogsImportFromCatalogPost(requestParameters: RepairCatalogsApiApiV1RepairCatalogsImportFromCatalogPostRequest, options?: RawAxiosRequestConfig) {
        return RepairCatalogsApiFp(this.configuration).apiV1RepairCatalogsImportFromCatalogPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.importFromCatalogDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairCatalogsApiApiV1RepairCatalogsRepairCatalogIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairCatalogsApi
     */
    public apiV1RepairCatalogsRepairCatalogIdGet(requestParameters: RepairCatalogsApiApiV1RepairCatalogsRepairCatalogIdGetRequest, options?: RawAxiosRequestConfig) {
        return RepairCatalogsApiFp(this.configuration).apiV1RepairCatalogsRepairCatalogIdGet(requestParameters.nexusOpsTenant, requestParameters.repairCatalogId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairCatalogsApiApiV1RepairCatalogsSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairCatalogsApi
     */
    public apiV1RepairCatalogsSearchPost(requestParameters: RepairCatalogsApiApiV1RepairCatalogsSearchPostRequest, options?: RawAxiosRequestConfig) {
        return RepairCatalogsApiFp(this.configuration).apiV1RepairCatalogsSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairCatalogSearchPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RepairMaterialsApi - axios parameter creator
 * @export
 */
export const RepairMaterialsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairMaterialGetPaginatedDto} [repairMaterialGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairMaterialsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, repairMaterialGetPaginatedDto?: RepairMaterialGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairMaterialsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair/materials/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairMaterialGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairMaterialDto} [createRepairMaterialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairMaterialsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createRepairMaterialDto?: CreateRepairMaterialDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairMaterialsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair/materials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRepairMaterialDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairMaterialId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairMaterialsRepairMaterialIdDelete: async (nexusOpsTenant: string, repairMaterialId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairMaterialsRepairMaterialIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairMaterialId' is not null or undefined
            assertParamExists('apiV1RepairMaterialsRepairMaterialIdDelete', 'repairMaterialId', repairMaterialId)
            const localVarPath = `/api/v1/repair/materials/{repairMaterialId}`
                .replace(`{${"repairMaterialId"}}`, encodeURIComponent(String(repairMaterialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairMaterialId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairMaterialsRepairMaterialIdDeleteInfoGet: async (nexusOpsTenant: string, repairMaterialId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairMaterialsRepairMaterialIdDeleteInfoGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairMaterialId' is not null or undefined
            assertParamExists('apiV1RepairMaterialsRepairMaterialIdDeleteInfoGet', 'repairMaterialId', repairMaterialId)
            const localVarPath = `/api/v1/repair/materials/{repairMaterialId}/delete/info`
                .replace(`{${"repairMaterialId"}}`, encodeURIComponent(String(repairMaterialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairMaterialId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairMaterialsRepairMaterialIdGet: async (nexusOpsTenant: string, repairMaterialId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairMaterialsRepairMaterialIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairMaterialId' is not null or undefined
            assertParamExists('apiV1RepairMaterialsRepairMaterialIdGet', 'repairMaterialId', repairMaterialId)
            const localVarPath = `/api/v1/repair/materials/{repairMaterialId}`
                .replace(`{${"repairMaterialId"}}`, encodeURIComponent(String(repairMaterialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairMaterialId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairMaterialDto} [updateRepairMaterialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairMaterialsRepairMaterialIdPut: async (nexusOpsTenant: string, repairMaterialId: string, nexusOpsAppVersion?: string, updateRepairMaterialDto?: UpdateRepairMaterialDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairMaterialsRepairMaterialIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairMaterialId' is not null or undefined
            assertParamExists('apiV1RepairMaterialsRepairMaterialIdPut', 'repairMaterialId', repairMaterialId)
            const localVarPath = `/api/v1/repair/materials/{repairMaterialId}`
                .replace(`{${"repairMaterialId"}}`, encodeURIComponent(String(repairMaterialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRepairMaterialDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepairMaterialsApi - functional programming interface
 * @export
 */
export const RepairMaterialsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepairMaterialsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairMaterialGetPaginatedDto} [repairMaterialGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairMaterialsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, repairMaterialGetPaginatedDto?: RepairMaterialGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfRepairMaterialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairMaterialsGetPost(nexusOpsTenant, nexusOpsAppVersion, repairMaterialGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairMaterialsApi.apiV1RepairMaterialsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairMaterialDto} [createRepairMaterialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairMaterialsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createRepairMaterialDto?: CreateRepairMaterialDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairMaterialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairMaterialsPost(nexusOpsTenant, nexusOpsAppVersion, createRepairMaterialDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairMaterialsApi.apiV1RepairMaterialsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairMaterialId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairMaterialsRepairMaterialIdDelete(nexusOpsTenant: string, repairMaterialId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairMaterialsRepairMaterialIdDelete(nexusOpsTenant, repairMaterialId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairMaterialsApi.apiV1RepairMaterialsRepairMaterialIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairMaterialId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairMaterialsRepairMaterialIdDeleteInfoGet(nexusOpsTenant: string, repairMaterialId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteRepairMaterialInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairMaterialsRepairMaterialIdDeleteInfoGet(nexusOpsTenant, repairMaterialId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairMaterialsApi.apiV1RepairMaterialsRepairMaterialIdDeleteInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairMaterialId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairMaterialsRepairMaterialIdGet(nexusOpsTenant: string, repairMaterialId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairMaterialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairMaterialsRepairMaterialIdGet(nexusOpsTenant, repairMaterialId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairMaterialsApi.apiV1RepairMaterialsRepairMaterialIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairMaterialId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairMaterialDto} [updateRepairMaterialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairMaterialsRepairMaterialIdPut(nexusOpsTenant: string, repairMaterialId: string, nexusOpsAppVersion?: string, updateRepairMaterialDto?: UpdateRepairMaterialDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairMaterialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairMaterialsRepairMaterialIdPut(nexusOpsTenant, repairMaterialId, nexusOpsAppVersion, updateRepairMaterialDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairMaterialsApi.apiV1RepairMaterialsRepairMaterialIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RepairMaterialsApi - factory interface
 * @export
 */
export const RepairMaterialsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepairMaterialsApiFp(configuration)
    return {
        /**
         * 
         * @param {RepairMaterialsApiApiV1RepairMaterialsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairMaterialsGetPost(requestParameters: RepairMaterialsApiApiV1RepairMaterialsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfRepairMaterialDto> {
            return localVarFp.apiV1RepairMaterialsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairMaterialGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairMaterialsApiApiV1RepairMaterialsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairMaterialsPost(requestParameters: RepairMaterialsApiApiV1RepairMaterialsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairMaterialDto> {
            return localVarFp.apiV1RepairMaterialsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createRepairMaterialDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairMaterialsRepairMaterialIdDelete(requestParameters: RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1RepairMaterialsRepairMaterialIdDelete(requestParameters.nexusOpsTenant, requestParameters.repairMaterialId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteInfoGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairMaterialsRepairMaterialIdDeleteInfoGet(requestParameters: RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteInfoGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteRepairMaterialInfoDto> {
            return localVarFp.apiV1RepairMaterialsRepairMaterialIdDeleteInfoGet(requestParameters.nexusOpsTenant, requestParameters.repairMaterialId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairMaterialsRepairMaterialIdGet(requestParameters: RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairMaterialDto> {
            return localVarFp.apiV1RepairMaterialsRepairMaterialIdGet(requestParameters.nexusOpsTenant, requestParameters.repairMaterialId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairMaterialsRepairMaterialIdPut(requestParameters: RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairMaterialDto> {
            return localVarFp.apiV1RepairMaterialsRepairMaterialIdPut(requestParameters.nexusOpsTenant, requestParameters.repairMaterialId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairMaterialDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1RepairMaterialsGetPost operation in RepairMaterialsApi.
 * @export
 * @interface RepairMaterialsApiApiV1RepairMaterialsGetPostRequest
 */
export interface RepairMaterialsApiApiV1RepairMaterialsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RepairMaterialGetPaginatedDto}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsGetPost
     */
    readonly repairMaterialGetPaginatedDto?: RepairMaterialGetPaginatedDto
}

/**
 * Request parameters for apiV1RepairMaterialsPost operation in RepairMaterialsApi.
 * @export
 * @interface RepairMaterialsApiApiV1RepairMaterialsPostRequest
 */
export interface RepairMaterialsApiApiV1RepairMaterialsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateRepairMaterialDto}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsPost
     */
    readonly createRepairMaterialDto?: CreateRepairMaterialDto
}

/**
 * Request parameters for apiV1RepairMaterialsRepairMaterialIdDelete operation in RepairMaterialsApi.
 * @export
 * @interface RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteRequest
 */
export interface RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDelete
     */
    readonly repairMaterialId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairMaterialsRepairMaterialIdDeleteInfoGet operation in RepairMaterialsApi.
 * @export
 * @interface RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteInfoGetRequest
 */
export interface RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteInfoGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteInfoGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteInfoGet
     */
    readonly repairMaterialId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteInfoGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairMaterialsRepairMaterialIdGet operation in RepairMaterialsApi.
 * @export
 * @interface RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdGetRequest
 */
export interface RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdGet
     */
    readonly repairMaterialId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairMaterialsRepairMaterialIdPut operation in RepairMaterialsApi.
 * @export
 * @interface RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdPutRequest
 */
export interface RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdPut
     */
    readonly repairMaterialId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateRepairMaterialDto}
     * @memberof RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdPut
     */
    readonly updateRepairMaterialDto?: UpdateRepairMaterialDto
}

/**
 * RepairMaterialsApi - object-oriented interface
 * @export
 * @class RepairMaterialsApi
 * @extends {BaseAPI}
 */
export class RepairMaterialsApi extends BaseAPI {
    /**
     * 
     * @param {RepairMaterialsApiApiV1RepairMaterialsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairMaterialsApi
     */
    public apiV1RepairMaterialsGetPost(requestParameters: RepairMaterialsApiApiV1RepairMaterialsGetPostRequest, options?: RawAxiosRequestConfig) {
        return RepairMaterialsApiFp(this.configuration).apiV1RepairMaterialsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairMaterialGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairMaterialsApiApiV1RepairMaterialsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairMaterialsApi
     */
    public apiV1RepairMaterialsPost(requestParameters: RepairMaterialsApiApiV1RepairMaterialsPostRequest, options?: RawAxiosRequestConfig) {
        return RepairMaterialsApiFp(this.configuration).apiV1RepairMaterialsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createRepairMaterialDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairMaterialsApi
     */
    public apiV1RepairMaterialsRepairMaterialIdDelete(requestParameters: RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return RepairMaterialsApiFp(this.configuration).apiV1RepairMaterialsRepairMaterialIdDelete(requestParameters.nexusOpsTenant, requestParameters.repairMaterialId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteInfoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairMaterialsApi
     */
    public apiV1RepairMaterialsRepairMaterialIdDeleteInfoGet(requestParameters: RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdDeleteInfoGetRequest, options?: RawAxiosRequestConfig) {
        return RepairMaterialsApiFp(this.configuration).apiV1RepairMaterialsRepairMaterialIdDeleteInfoGet(requestParameters.nexusOpsTenant, requestParameters.repairMaterialId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairMaterialsApi
     */
    public apiV1RepairMaterialsRepairMaterialIdGet(requestParameters: RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdGetRequest, options?: RawAxiosRequestConfig) {
        return RepairMaterialsApiFp(this.configuration).apiV1RepairMaterialsRepairMaterialIdGet(requestParameters.nexusOpsTenant, requestParameters.repairMaterialId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairMaterialsApi
     */
    public apiV1RepairMaterialsRepairMaterialIdPut(requestParameters: RepairMaterialsApiApiV1RepairMaterialsRepairMaterialIdPutRequest, options?: RawAxiosRequestConfig) {
        return RepairMaterialsApiFp(this.configuration).apiV1RepairMaterialsRepairMaterialIdPut(requestParameters.nexusOpsTenant, requestParameters.repairMaterialId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairMaterialDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RepairMaterialsAdminApi - axios parameter creator
 * @export
 */
export const RepairMaterialsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairMaterialGetPaginatedDto} [repairMaterialGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairMaterialsGetPost: async (nexusOpsAppVersion?: string, repairMaterialGetPaginatedDto?: RepairMaterialGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/repair/materials/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairMaterialGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairMaterialDto} [createRepairMaterialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairMaterialsPost: async (nexusOpsAppVersion?: string, createRepairMaterialDto?: CreateRepairMaterialDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/repair/materials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRepairMaterialDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repairMaterialId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairMaterialsRepairMaterialIdDelete: async (repairMaterialId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairMaterialId' is not null or undefined
            assertParamExists('apiV1AdminRepairMaterialsRepairMaterialIdDelete', 'repairMaterialId', repairMaterialId)
            const localVarPath = `/api/v1/admin/repair/materials/{repairMaterialId}`
                .replace(`{${"repairMaterialId"}}`, encodeURIComponent(String(repairMaterialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repairMaterialId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairMaterialsRepairMaterialIdGet: async (repairMaterialId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairMaterialId' is not null or undefined
            assertParamExists('apiV1AdminRepairMaterialsRepairMaterialIdGet', 'repairMaterialId', repairMaterialId)
            const localVarPath = `/api/v1/admin/repair/materials/{repairMaterialId}`
                .replace(`{${"repairMaterialId"}}`, encodeURIComponent(String(repairMaterialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repairMaterialId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairMaterialDto} [updateRepairMaterialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairMaterialsRepairMaterialIdPut: async (repairMaterialId: string, nexusOpsAppVersion?: string, updateRepairMaterialDto?: UpdateRepairMaterialDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairMaterialId' is not null or undefined
            assertParamExists('apiV1AdminRepairMaterialsRepairMaterialIdPut', 'repairMaterialId', repairMaterialId)
            const localVarPath = `/api/v1/admin/repair/materials/{repairMaterialId}`
                .replace(`{${"repairMaterialId"}}`, encodeURIComponent(String(repairMaterialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRepairMaterialDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepairMaterialsAdminApi - functional programming interface
 * @export
 */
export const RepairMaterialsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepairMaterialsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairMaterialGetPaginatedDto} [repairMaterialGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairMaterialsGetPost(nexusOpsAppVersion?: string, repairMaterialGetPaginatedDto?: RepairMaterialGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfRepairMaterialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairMaterialsGetPost(nexusOpsAppVersion, repairMaterialGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairMaterialsAdminApi.apiV1AdminRepairMaterialsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairMaterialDto} [createRepairMaterialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairMaterialsPost(nexusOpsAppVersion?: string, createRepairMaterialDto?: CreateRepairMaterialDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairMaterialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairMaterialsPost(nexusOpsAppVersion, createRepairMaterialDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairMaterialsAdminApi.apiV1AdminRepairMaterialsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repairMaterialId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairMaterialsRepairMaterialIdDelete(repairMaterialId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairMaterialsRepairMaterialIdDelete(repairMaterialId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairMaterialsAdminApi.apiV1AdminRepairMaterialsRepairMaterialIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repairMaterialId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairMaterialsRepairMaterialIdGet(repairMaterialId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairMaterialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairMaterialsRepairMaterialIdGet(repairMaterialId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairMaterialsAdminApi.apiV1AdminRepairMaterialsRepairMaterialIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repairMaterialId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairMaterialDto} [updateRepairMaterialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairMaterialsRepairMaterialIdPut(repairMaterialId: string, nexusOpsAppVersion?: string, updateRepairMaterialDto?: UpdateRepairMaterialDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairMaterialDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairMaterialsRepairMaterialIdPut(repairMaterialId, nexusOpsAppVersion, updateRepairMaterialDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairMaterialsAdminApi.apiV1AdminRepairMaterialsRepairMaterialIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RepairMaterialsAdminApi - factory interface
 * @export
 */
export const RepairMaterialsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepairMaterialsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {RepairMaterialsAdminApiApiV1AdminRepairMaterialsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairMaterialsGetPost(requestParameters: RepairMaterialsAdminApiApiV1AdminRepairMaterialsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfRepairMaterialDto> {
            return localVarFp.apiV1AdminRepairMaterialsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.repairMaterialGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairMaterialsAdminApiApiV1AdminRepairMaterialsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairMaterialsPost(requestParameters: RepairMaterialsAdminApiApiV1AdminRepairMaterialsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RepairMaterialDto> {
            return localVarFp.apiV1AdminRepairMaterialsPost(requestParameters.nexusOpsAppVersion, requestParameters.createRepairMaterialDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairMaterialsRepairMaterialIdDelete(requestParameters: RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminRepairMaterialsRepairMaterialIdDelete(requestParameters.repairMaterialId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairMaterialsRepairMaterialIdGet(requestParameters: RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairMaterialDto> {
            return localVarFp.apiV1AdminRepairMaterialsRepairMaterialIdGet(requestParameters.repairMaterialId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairMaterialsRepairMaterialIdPut(requestParameters: RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairMaterialDto> {
            return localVarFp.apiV1AdminRepairMaterialsRepairMaterialIdPut(requestParameters.repairMaterialId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairMaterialDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminRepairMaterialsGetPost operation in RepairMaterialsAdminApi.
 * @export
 * @interface RepairMaterialsAdminApiApiV1AdminRepairMaterialsGetPostRequest
 */
export interface RepairMaterialsAdminApiApiV1AdminRepairMaterialsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairMaterialsAdminApiApiV1AdminRepairMaterialsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RepairMaterialGetPaginatedDto}
     * @memberof RepairMaterialsAdminApiApiV1AdminRepairMaterialsGetPost
     */
    readonly repairMaterialGetPaginatedDto?: RepairMaterialGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminRepairMaterialsPost operation in RepairMaterialsAdminApi.
 * @export
 * @interface RepairMaterialsAdminApiApiV1AdminRepairMaterialsPostRequest
 */
export interface RepairMaterialsAdminApiApiV1AdminRepairMaterialsPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairMaterialsAdminApiApiV1AdminRepairMaterialsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateRepairMaterialDto}
     * @memberof RepairMaterialsAdminApiApiV1AdminRepairMaterialsPost
     */
    readonly createRepairMaterialDto?: CreateRepairMaterialDto
}

/**
 * Request parameters for apiV1AdminRepairMaterialsRepairMaterialIdDelete operation in RepairMaterialsAdminApi.
 * @export
 * @interface RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdDeleteRequest
 */
export interface RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdDelete
     */
    readonly repairMaterialId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminRepairMaterialsRepairMaterialIdGet operation in RepairMaterialsAdminApi.
 * @export
 * @interface RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdGetRequest
 */
export interface RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdGet
     */
    readonly repairMaterialId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminRepairMaterialsRepairMaterialIdPut operation in RepairMaterialsAdminApi.
 * @export
 * @interface RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdPutRequest
 */
export interface RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdPut
     */
    readonly repairMaterialId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateRepairMaterialDto}
     * @memberof RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdPut
     */
    readonly updateRepairMaterialDto?: UpdateRepairMaterialDto
}

/**
 * RepairMaterialsAdminApi - object-oriented interface
 * @export
 * @class RepairMaterialsAdminApi
 * @extends {BaseAPI}
 */
export class RepairMaterialsAdminApi extends BaseAPI {
    /**
     * 
     * @param {RepairMaterialsAdminApiApiV1AdminRepairMaterialsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairMaterialsAdminApi
     */
    public apiV1AdminRepairMaterialsGetPost(requestParameters: RepairMaterialsAdminApiApiV1AdminRepairMaterialsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return RepairMaterialsAdminApiFp(this.configuration).apiV1AdminRepairMaterialsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.repairMaterialGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairMaterialsAdminApiApiV1AdminRepairMaterialsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairMaterialsAdminApi
     */
    public apiV1AdminRepairMaterialsPost(requestParameters: RepairMaterialsAdminApiApiV1AdminRepairMaterialsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return RepairMaterialsAdminApiFp(this.configuration).apiV1AdminRepairMaterialsPost(requestParameters.nexusOpsAppVersion, requestParameters.createRepairMaterialDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairMaterialsAdminApi
     */
    public apiV1AdminRepairMaterialsRepairMaterialIdDelete(requestParameters: RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return RepairMaterialsAdminApiFp(this.configuration).apiV1AdminRepairMaterialsRepairMaterialIdDelete(requestParameters.repairMaterialId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairMaterialsAdminApi
     */
    public apiV1AdminRepairMaterialsRepairMaterialIdGet(requestParameters: RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdGetRequest, options?: RawAxiosRequestConfig) {
        return RepairMaterialsAdminApiFp(this.configuration).apiV1AdminRepairMaterialsRepairMaterialIdGet(requestParameters.repairMaterialId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairMaterialsAdminApi
     */
    public apiV1AdminRepairMaterialsRepairMaterialIdPut(requestParameters: RepairMaterialsAdminApiApiV1AdminRepairMaterialsRepairMaterialIdPutRequest, options?: RawAxiosRequestConfig) {
        return RepairMaterialsAdminApiFp(this.configuration).apiV1AdminRepairMaterialsRepairMaterialIdPut(requestParameters.repairMaterialId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairMaterialDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RepairOperationsApi - axios parameter creator
 * @export
 */
export const RepairOperationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair-operations/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsByIdsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsByIdsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair-operations/by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair-operations/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairOperationGetPaginatedDto} [repairOperationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, repairOperationGetPaginatedDto?: RepairOperationGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair-operations/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairOperationGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairOperationDto} [createRepairOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createRepairOperationDto?: CreateRepairOperationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair-operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRepairOperationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdAddAssignmentPost: async (nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdAddAssignmentPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairOperationId' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdAddAssignmentPost', 'repairOperationId', repairOperationId)
            const localVarPath = `/api/v1/repair-operations/{repairOperationId}/add-assignment`
                .replace(`{${"repairOperationId"}}`, encodeURIComponent(String(repairOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentAddEntityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairOperationAddVehicleDamagesDto} [repairOperationAddVehicleDamagesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdDamagesAddPost: async (nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, repairOperationAddVehicleDamagesDto?: RepairOperationAddVehicleDamagesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdDamagesAddPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairOperationId' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdDamagesAddPost', 'repairOperationId', repairOperationId)
            const localVarPath = `/api/v1/repair-operations/{repairOperationId}/damages/add`
                .replace(`{${"repairOperationId"}}`, encodeURIComponent(String(repairOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairOperationAddVehicleDamagesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdDelete: async (nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairOperationId' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdDelete', 'repairOperationId', repairOperationId)
            const localVarPath = `/api/v1/repair-operations/{repairOperationId}`
                .replace(`{${"repairOperationId"}}`, encodeURIComponent(String(repairOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdDownloadPdfGet: async (nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdDownloadPdfGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairOperationId' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdDownloadPdfGet', 'repairOperationId', repairOperationId)
            const localVarPath = `/api/v1/repair-operations/{repairOperationId}/download/pdf`
                .replace(`{${"repairOperationId"}}`, encodeURIComponent(String(repairOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdExternalNumberPut: async (nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdExternalNumberPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairOperationId' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdExternalNumberPut', 'repairOperationId', repairOperationId)
            const localVarPath = `/api/v1/repair-operations/{repairOperationId}/external-number`
                .replace(`{${"repairOperationId"}}`, encodeURIComponent(String(repairOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalExternalNumberInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdGet: async (nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairOperationId' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdGet', 'repairOperationId', repairOperationId)
            const localVarPath = `/api/v1/repair-operations/{repairOperationId}`
                .replace(`{${"repairOperationId"}}`, encodeURIComponent(String(repairOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleMileageDto} [updateVehicleMileageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdMileagePut: async (nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, updateVehicleMileageDto?: UpdateVehicleMileageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdMileagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairOperationId' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdMileagePut', 'repairOperationId', repairOperationId)
            const localVarPath = `/api/v1/repair-operations/{repairOperationId}/mileage`
                .replace(`{${"repairOperationId"}}`, encodeURIComponent(String(repairOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVehicleMileageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdNotesPut: async (nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdNotesPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairOperationId' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdNotesPut', 'repairOperationId', repairOperationId)
            const localVarPath = `/api/v1/repair-operations/{repairOperationId}/notes`
                .replace(`{${"repairOperationId"}}`, encodeURIComponent(String(repairOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalNotesInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairOperationDto} [updateRepairOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdPut: async (nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, updateRepairOperationDto?: UpdateRepairOperationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairOperationId' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdPut', 'repairOperationId', repairOperationId)
            const localVarPath = `/api/v1/repair-operations/{repairOperationId}`
                .replace(`{${"repairOperationId"}}`, encodeURIComponent(String(repairOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRepairOperationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStageUpdateDtoOfRepairOperationStage} [generalStageUpdateDtoOfRepairOperationStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdStagePut: async (nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, generalStageUpdateDtoOfRepairOperationStage?: GeneralStageUpdateDtoOfRepairOperationStage, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdStagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairOperationId' is not null or undefined
            assertParamExists('apiV1RepairOperationsRepairOperationIdStagePut', 'repairOperationId', repairOperationId)
            const localVarPath = `/api/v1/repair-operations/{repairOperationId}/stage`
                .replace(`{${"repairOperationId"}}`, encodeURIComponent(String(repairOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalStageUpdateDtoOfRepairOperationStage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairOperationSearchPaginatedDto} [repairOperationSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsSearchPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, repairOperationSearchPaginatedDto?: RepairOperationSearchPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairOperationsSearchPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair-operations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairOperationSearchPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepairOperationsApi - functional programming interface
 * @export
 */
export const RepairOperationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepairOperationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsByIdsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RepairOperationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsByIdsGet(nexusOpsTenant, nexusOpsAppVersion, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsByIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairOperationCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairOperationGetPaginatedDto} [repairOperationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, repairOperationGetPaginatedDto?: RepairOperationGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfRepairOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsGetPost(nexusOpsTenant, nexusOpsAppVersion, repairOperationGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairOperationDto} [createRepairOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createRepairOperationDto?: CreateRepairOperationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsPost(nexusOpsTenant, nexusOpsAppVersion, createRepairOperationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsRepairOperationIdAddAssignmentPost(nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsRepairOperationIdAddAssignmentPost(nexusOpsTenant, repairOperationId, nexusOpsAppVersion, assignmentAddEntityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsRepairOperationIdAddAssignmentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairOperationAddVehicleDamagesDto} [repairOperationAddVehicleDamagesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsRepairOperationIdDamagesAddPost(nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, repairOperationAddVehicleDamagesDto?: RepairOperationAddVehicleDamagesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsRepairOperationIdDamagesAddPost(nexusOpsTenant, repairOperationId, nexusOpsAppVersion, repairOperationAddVehicleDamagesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsRepairOperationIdDamagesAddPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsRepairOperationIdDelete(nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsRepairOperationIdDelete(nexusOpsTenant, repairOperationId, nexusOpsAppVersion, isDeleteCascade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsRepairOperationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsRepairOperationIdDownloadPdfGet(nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsRepairOperationIdDownloadPdfGet(nexusOpsTenant, repairOperationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsRepairOperationIdDownloadPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsRepairOperationIdExternalNumberPut(nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsRepairOperationIdExternalNumberPut(nexusOpsTenant, repairOperationId, nexusOpsAppVersion, generalExternalNumberInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsRepairOperationIdExternalNumberPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsRepairOperationIdGet(nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsRepairOperationIdGet(nexusOpsTenant, repairOperationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsRepairOperationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleMileageDto} [updateVehicleMileageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsRepairOperationIdMileagePut(nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, updateVehicleMileageDto?: UpdateVehicleMileageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsRepairOperationIdMileagePut(nexusOpsTenant, repairOperationId, nexusOpsAppVersion, updateVehicleMileageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsRepairOperationIdMileagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsRepairOperationIdNotesPut(nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsRepairOperationIdNotesPut(nexusOpsTenant, repairOperationId, nexusOpsAppVersion, generalNotesInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsRepairOperationIdNotesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairOperationDto} [updateRepairOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsRepairOperationIdPut(nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, updateRepairOperationDto?: UpdateRepairOperationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsRepairOperationIdPut(nexusOpsTenant, repairOperationId, nexusOpsAppVersion, updateRepairOperationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsRepairOperationIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStageUpdateDtoOfRepairOperationStage} [generalStageUpdateDtoOfRepairOperationStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsRepairOperationIdStagePut(nexusOpsTenant: string, repairOperationId: string, nexusOpsAppVersion?: string, generalStageUpdateDtoOfRepairOperationStage?: GeneralStageUpdateDtoOfRepairOperationStage, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsRepairOperationIdStagePut(nexusOpsTenant, repairOperationId, nexusOpsAppVersion, generalStageUpdateDtoOfRepairOperationStage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsRepairOperationIdStagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairOperationSearchPaginatedDto} [repairOperationSearchPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairOperationsSearchPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, repairOperationSearchPaginatedDto?: RepairOperationSearchPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfRepairOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairOperationsSearchPost(nexusOpsTenant, nexusOpsAppVersion, repairOperationSearchPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairOperationsApi.apiV1RepairOperationsSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RepairOperationsApi - factory interface
 * @export
 */
export const RepairOperationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepairOperationsApiFp(configuration)
    return {
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsBulkDeleteDelete(requestParameters: RepairOperationsApiApiV1RepairOperationsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1RepairOperationsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsByIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsByIdsGet(requestParameters: RepairOperationsApiApiV1RepairOperationsByIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RepairOperationDto>> {
            return localVarFp.apiV1RepairOperationsByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsCountersGet(requestParameters: RepairOperationsApiApiV1RepairOperationsCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairOperationCountersDto> {
            return localVarFp.apiV1RepairOperationsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsGetPost(requestParameters: RepairOperationsApiApiV1RepairOperationsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfRepairOperationDto> {
            return localVarFp.apiV1RepairOperationsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairOperationGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsPost(requestParameters: RepairOperationsApiApiV1RepairOperationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairOperationDto> {
            return localVarFp.apiV1RepairOperationsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createRepairOperationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdAddAssignmentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdAddAssignmentPost(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdAddAssignmentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairOperationDto> {
            return localVarFp.apiV1RepairOperationsRepairOperationIdAddAssignmentPost(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdDamagesAddPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdDamagesAddPost(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdDamagesAddPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairOperationDto> {
            return localVarFp.apiV1RepairOperationsRepairOperationIdDamagesAddPost(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.repairOperationAddVehicleDamagesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdDelete(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1RepairOperationsRepairOperationIdDelete(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdDownloadPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdDownloadPdfGet(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1RepairOperationsRepairOperationIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdExternalNumberPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdExternalNumberPut(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdExternalNumberPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairOperationDto> {
            return localVarFp.apiV1RepairOperationsRepairOperationIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdGet(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairOperationDto> {
            return localVarFp.apiV1RepairOperationsRepairOperationIdGet(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdMileagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdMileagePut(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdMileagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairOperationDto> {
            return localVarFp.apiV1RepairOperationsRepairOperationIdMileagePut(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleMileageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdNotesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdNotesPut(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdNotesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairOperationDto> {
            return localVarFp.apiV1RepairOperationsRepairOperationIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdPut(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairOperationDto> {
            return localVarFp.apiV1RepairOperationsRepairOperationIdPut(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairOperationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdStagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsRepairOperationIdStagePut(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdStagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairOperationDto> {
            return localVarFp.apiV1RepairOperationsRepairOperationIdStagePut(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.generalStageUpdateDtoOfRepairOperationStage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairOperationsApiApiV1RepairOperationsSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairOperationsSearchPost(requestParameters: RepairOperationsApiApiV1RepairOperationsSearchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfRepairOperationDto> {
            return localVarFp.apiV1RepairOperationsSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairOperationSearchPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1RepairOperationsBulkDeleteDelete operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsBulkDeleteDeleteRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof RepairOperationsApiApiV1RepairOperationsBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1RepairOperationsByIdsGet operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsByIdsGetRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsByIdsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsByIdsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsByIdsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof RepairOperationsApiApiV1RepairOperationsByIdsGet
     */
    readonly ids?: Array<string>
}

/**
 * Request parameters for apiV1RepairOperationsCountersGet operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsCountersGetRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairOperationsGetPost operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsGetPostRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RepairOperationGetPaginatedDto}
     * @memberof RepairOperationsApiApiV1RepairOperationsGetPost
     */
    readonly repairOperationGetPaginatedDto?: RepairOperationGetPaginatedDto
}

/**
 * Request parameters for apiV1RepairOperationsPost operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsPostRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateRepairOperationDto}
     * @memberof RepairOperationsApiApiV1RepairOperationsPost
     */
    readonly createRepairOperationDto?: CreateRepairOperationDto
}

/**
 * Request parameters for apiV1RepairOperationsRepairOperationIdAddAssignmentPost operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdAddAssignmentPostRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdAddAssignmentPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdAddAssignmentPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdAddAssignmentPost
     */
    readonly repairOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdAddAssignmentPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentAddEntityDto}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdAddAssignmentPost
     */
    readonly assignmentAddEntityDto?: AssignmentAddEntityDto
}

/**
 * Request parameters for apiV1RepairOperationsRepairOperationIdDamagesAddPost operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdDamagesAddPostRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdDamagesAddPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdDamagesAddPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdDamagesAddPost
     */
    readonly repairOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdDamagesAddPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RepairOperationAddVehicleDamagesDto}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdDamagesAddPost
     */
    readonly repairOperationAddVehicleDamagesDto?: RepairOperationAddVehicleDamagesDto
}

/**
 * Request parameters for apiV1RepairOperationsRepairOperationIdDelete operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdDeleteRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdDelete
     */
    readonly repairOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdDelete
     */
    readonly isDeleteCascade?: boolean
}

/**
 * Request parameters for apiV1RepairOperationsRepairOperationIdDownloadPdfGet operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdDownloadPdfGetRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdDownloadPdfGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdDownloadPdfGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdDownloadPdfGet
     */
    readonly repairOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdDownloadPdfGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairOperationsRepairOperationIdExternalNumberPut operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdExternalNumberPutRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdExternalNumberPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdExternalNumberPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdExternalNumberPut
     */
    readonly repairOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdExternalNumberPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralExternalNumberInputDto}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdExternalNumberPut
     */
    readonly generalExternalNumberInputDto?: GeneralExternalNumberInputDto
}

/**
 * Request parameters for apiV1RepairOperationsRepairOperationIdGet operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdGetRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdGet
     */
    readonly repairOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairOperationsRepairOperationIdMileagePut operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdMileagePutRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdMileagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdMileagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdMileagePut
     */
    readonly repairOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdMileagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateVehicleMileageDto}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdMileagePut
     */
    readonly updateVehicleMileageDto?: UpdateVehicleMileageDto
}

/**
 * Request parameters for apiV1RepairOperationsRepairOperationIdNotesPut operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdNotesPutRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdNotesPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdNotesPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdNotesPut
     */
    readonly repairOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdNotesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralNotesInputDto}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdNotesPut
     */
    readonly generalNotesInputDto?: GeneralNotesInputDto
}

/**
 * Request parameters for apiV1RepairOperationsRepairOperationIdPut operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdPutRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdPut
     */
    readonly repairOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateRepairOperationDto}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdPut
     */
    readonly updateRepairOperationDto?: UpdateRepairOperationDto
}

/**
 * Request parameters for apiV1RepairOperationsRepairOperationIdStagePut operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdStagePutRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsRepairOperationIdStagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdStagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdStagePut
     */
    readonly repairOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdStagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralStageUpdateDtoOfRepairOperationStage}
     * @memberof RepairOperationsApiApiV1RepairOperationsRepairOperationIdStagePut
     */
    readonly generalStageUpdateDtoOfRepairOperationStage?: GeneralStageUpdateDtoOfRepairOperationStage
}

/**
 * Request parameters for apiV1RepairOperationsSearchPost operation in RepairOperationsApi.
 * @export
 * @interface RepairOperationsApiApiV1RepairOperationsSearchPostRequest
 */
export interface RepairOperationsApiApiV1RepairOperationsSearchPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsSearchPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairOperationsApiApiV1RepairOperationsSearchPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RepairOperationSearchPaginatedDto}
     * @memberof RepairOperationsApiApiV1RepairOperationsSearchPost
     */
    readonly repairOperationSearchPaginatedDto?: RepairOperationSearchPaginatedDto
}

/**
 * RepairOperationsApi - object-oriented interface
 * @export
 * @class RepairOperationsApi
 * @extends {BaseAPI}
 */
export class RepairOperationsApi extends BaseAPI {
    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsBulkDeleteDelete(requestParameters: RepairOperationsApiApiV1RepairOperationsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsByIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsByIdsGet(requestParameters: RepairOperationsApiApiV1RepairOperationsByIdsGetRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsCountersGet(requestParameters: RepairOperationsApiApiV1RepairOperationsCountersGetRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsGetPost(requestParameters: RepairOperationsApiApiV1RepairOperationsGetPostRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairOperationGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsPost(requestParameters: RepairOperationsApiApiV1RepairOperationsPostRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createRepairOperationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdAddAssignmentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsRepairOperationIdAddAssignmentPost(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdAddAssignmentPostRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsRepairOperationIdAddAssignmentPost(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdDamagesAddPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsRepairOperationIdDamagesAddPost(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdDamagesAddPostRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsRepairOperationIdDamagesAddPost(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.repairOperationAddVehicleDamagesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsRepairOperationIdDelete(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsRepairOperationIdDelete(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdDownloadPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsRepairOperationIdDownloadPdfGet(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsRepairOperationIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdExternalNumberPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsRepairOperationIdExternalNumberPut(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdExternalNumberPutRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsRepairOperationIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsRepairOperationIdGet(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdGetRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsRepairOperationIdGet(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdMileagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsRepairOperationIdMileagePut(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdMileagePutRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsRepairOperationIdMileagePut(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleMileageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdNotesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsRepairOperationIdNotesPut(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdNotesPutRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsRepairOperationIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsRepairOperationIdPut(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdPutRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsRepairOperationIdPut(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairOperationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsRepairOperationIdStagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsRepairOperationIdStagePut(requestParameters: RepairOperationsApiApiV1RepairOperationsRepairOperationIdStagePutRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsRepairOperationIdStagePut(requestParameters.nexusOpsTenant, requestParameters.repairOperationId, requestParameters.nexusOpsAppVersion, requestParameters.generalStageUpdateDtoOfRepairOperationStage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairOperationsApiApiV1RepairOperationsSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairOperationsApi
     */
    public apiV1RepairOperationsSearchPost(requestParameters: RepairOperationsApiApiV1RepairOperationsSearchPostRequest, options?: RawAxiosRequestConfig) {
        return RepairOperationsApiFp(this.configuration).apiV1RepairOperationsSearchPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairOperationSearchPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RepairSparePartApi - axios parameter creator
 * @export
 */
export const RepairSparePartApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairSparePartGetPaginatedDto} [repairSparePartGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSparePartsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, repairSparePartGetPaginatedDto?: RepairSparePartGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairSparePartsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair/spare-parts/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairSparePartGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairSparePartDto} [createRepairSparePartDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSparePartsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createRepairSparePartDto?: CreateRepairSparePartDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairSparePartsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair/spare-parts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRepairSparePartDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSparePartsRepairSparePartIdDelete: async (nexusOpsTenant: string, repairSparePartId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairSparePartsRepairSparePartIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairSparePartId' is not null or undefined
            assertParamExists('apiV1RepairSparePartsRepairSparePartIdDelete', 'repairSparePartId', repairSparePartId)
            const localVarPath = `/api/v1/repair/spare-parts/{repairSparePartId}`
                .replace(`{${"repairSparePartId"}}`, encodeURIComponent(String(repairSparePartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSparePartsRepairSparePartIdDeleteInfoGet: async (nexusOpsTenant: string, repairSparePartId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairSparePartsRepairSparePartIdDeleteInfoGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairSparePartId' is not null or undefined
            assertParamExists('apiV1RepairSparePartsRepairSparePartIdDeleteInfoGet', 'repairSparePartId', repairSparePartId)
            const localVarPath = `/api/v1/repair/spare-parts/{repairSparePartId}/delete/info`
                .replace(`{${"repairSparePartId"}}`, encodeURIComponent(String(repairSparePartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSparePartsRepairSparePartIdGet: async (nexusOpsTenant: string, repairSparePartId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairSparePartsRepairSparePartIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairSparePartId' is not null or undefined
            assertParamExists('apiV1RepairSparePartsRepairSparePartIdGet', 'repairSparePartId', repairSparePartId)
            const localVarPath = `/api/v1/repair/spare-parts/{repairSparePartId}`
                .replace(`{${"repairSparePartId"}}`, encodeURIComponent(String(repairSparePartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairSparePartDto} [updateRepairSparePartDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSparePartsRepairSparePartIdPut: async (nexusOpsTenant: string, repairSparePartId: string, nexusOpsAppVersion?: string, updateRepairSparePartDto?: UpdateRepairSparePartDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairSparePartsRepairSparePartIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairSparePartId' is not null or undefined
            assertParamExists('apiV1RepairSparePartsRepairSparePartIdPut', 'repairSparePartId', repairSparePartId)
            const localVarPath = `/api/v1/repair/spare-parts/{repairSparePartId}`
                .replace(`{${"repairSparePartId"}}`, encodeURIComponent(String(repairSparePartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRepairSparePartDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepairSparePartApi - functional programming interface
 * @export
 */
export const RepairSparePartApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepairSparePartApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairSparePartGetPaginatedDto} [repairSparePartGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairSparePartsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, repairSparePartGetPaginatedDto?: RepairSparePartGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfRepairSparePartDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairSparePartsGetPost(nexusOpsTenant, nexusOpsAppVersion, repairSparePartGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSparePartApi.apiV1RepairSparePartsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairSparePartDto} [createRepairSparePartDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairSparePartsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createRepairSparePartDto?: CreateRepairSparePartDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairSparePartDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairSparePartsPost(nexusOpsTenant, nexusOpsAppVersion, createRepairSparePartDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSparePartApi.apiV1RepairSparePartsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairSparePartsRepairSparePartIdDelete(nexusOpsTenant: string, repairSparePartId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairSparePartsRepairSparePartIdDelete(nexusOpsTenant, repairSparePartId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSparePartApi.apiV1RepairSparePartsRepairSparePartIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairSparePartsRepairSparePartIdDeleteInfoGet(nexusOpsTenant: string, repairSparePartId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteRepairSparePartInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairSparePartsRepairSparePartIdDeleteInfoGet(nexusOpsTenant, repairSparePartId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSparePartApi.apiV1RepairSparePartsRepairSparePartIdDeleteInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairSparePartsRepairSparePartIdGet(nexusOpsTenant: string, repairSparePartId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairSparePartDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairSparePartsRepairSparePartIdGet(nexusOpsTenant, repairSparePartId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSparePartApi.apiV1RepairSparePartsRepairSparePartIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairSparePartDto} [updateRepairSparePartDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairSparePartsRepairSparePartIdPut(nexusOpsTenant: string, repairSparePartId: string, nexusOpsAppVersion?: string, updateRepairSparePartDto?: UpdateRepairSparePartDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairSparePartDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairSparePartsRepairSparePartIdPut(nexusOpsTenant, repairSparePartId, nexusOpsAppVersion, updateRepairSparePartDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSparePartApi.apiV1RepairSparePartsRepairSparePartIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RepairSparePartApi - factory interface
 * @export
 */
export const RepairSparePartApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepairSparePartApiFp(configuration)
    return {
        /**
         * 
         * @param {RepairSparePartApiApiV1RepairSparePartsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSparePartsGetPost(requestParameters: RepairSparePartApiApiV1RepairSparePartsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfRepairSparePartDto> {
            return localVarFp.apiV1RepairSparePartsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairSparePartGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSparePartApiApiV1RepairSparePartsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSparePartsPost(requestParameters: RepairSparePartApiApiV1RepairSparePartsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairSparePartDto> {
            return localVarFp.apiV1RepairSparePartsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createRepairSparePartDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSparePartsRepairSparePartIdDelete(requestParameters: RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1RepairSparePartsRepairSparePartIdDelete(requestParameters.nexusOpsTenant, requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteInfoGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSparePartsRepairSparePartIdDeleteInfoGet(requestParameters: RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteInfoGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteRepairSparePartInfoDto> {
            return localVarFp.apiV1RepairSparePartsRepairSparePartIdDeleteInfoGet(requestParameters.nexusOpsTenant, requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSparePartsRepairSparePartIdGet(requestParameters: RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairSparePartDto> {
            return localVarFp.apiV1RepairSparePartsRepairSparePartIdGet(requestParameters.nexusOpsTenant, requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSparePartsRepairSparePartIdPut(requestParameters: RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairSparePartDto> {
            return localVarFp.apiV1RepairSparePartsRepairSparePartIdPut(requestParameters.nexusOpsTenant, requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairSparePartDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1RepairSparePartsGetPost operation in RepairSparePartApi.
 * @export
 * @interface RepairSparePartApiApiV1RepairSparePartsGetPostRequest
 */
export interface RepairSparePartApiApiV1RepairSparePartsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RepairSparePartGetPaginatedDto}
     * @memberof RepairSparePartApiApiV1RepairSparePartsGetPost
     */
    readonly repairSparePartGetPaginatedDto?: RepairSparePartGetPaginatedDto
}

/**
 * Request parameters for apiV1RepairSparePartsPost operation in RepairSparePartApi.
 * @export
 * @interface RepairSparePartApiApiV1RepairSparePartsPostRequest
 */
export interface RepairSparePartApiApiV1RepairSparePartsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateRepairSparePartDto}
     * @memberof RepairSparePartApiApiV1RepairSparePartsPost
     */
    readonly createRepairSparePartDto?: CreateRepairSparePartDto
}

/**
 * Request parameters for apiV1RepairSparePartsRepairSparePartIdDelete operation in RepairSparePartApi.
 * @export
 * @interface RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteRequest
 */
export interface RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDelete
     */
    readonly repairSparePartId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairSparePartsRepairSparePartIdDeleteInfoGet operation in RepairSparePartApi.
 * @export
 * @interface RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteInfoGetRequest
 */
export interface RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteInfoGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteInfoGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteInfoGet
     */
    readonly repairSparePartId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteInfoGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairSparePartsRepairSparePartIdGet operation in RepairSparePartApi.
 * @export
 * @interface RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdGetRequest
 */
export interface RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdGet
     */
    readonly repairSparePartId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairSparePartsRepairSparePartIdPut operation in RepairSparePartApi.
 * @export
 * @interface RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdPutRequest
 */
export interface RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdPut
     */
    readonly repairSparePartId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateRepairSparePartDto}
     * @memberof RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdPut
     */
    readonly updateRepairSparePartDto?: UpdateRepairSparePartDto
}

/**
 * RepairSparePartApi - object-oriented interface
 * @export
 * @class RepairSparePartApi
 * @extends {BaseAPI}
 */
export class RepairSparePartApi extends BaseAPI {
    /**
     * 
     * @param {RepairSparePartApiApiV1RepairSparePartsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSparePartApi
     */
    public apiV1RepairSparePartsGetPost(requestParameters: RepairSparePartApiApiV1RepairSparePartsGetPostRequest, options?: RawAxiosRequestConfig) {
        return RepairSparePartApiFp(this.configuration).apiV1RepairSparePartsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairSparePartGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSparePartApiApiV1RepairSparePartsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSparePartApi
     */
    public apiV1RepairSparePartsPost(requestParameters: RepairSparePartApiApiV1RepairSparePartsPostRequest, options?: RawAxiosRequestConfig) {
        return RepairSparePartApiFp(this.configuration).apiV1RepairSparePartsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createRepairSparePartDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSparePartApi
     */
    public apiV1RepairSparePartsRepairSparePartIdDelete(requestParameters: RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return RepairSparePartApiFp(this.configuration).apiV1RepairSparePartsRepairSparePartIdDelete(requestParameters.nexusOpsTenant, requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteInfoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSparePartApi
     */
    public apiV1RepairSparePartsRepairSparePartIdDeleteInfoGet(requestParameters: RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdDeleteInfoGetRequest, options?: RawAxiosRequestConfig) {
        return RepairSparePartApiFp(this.configuration).apiV1RepairSparePartsRepairSparePartIdDeleteInfoGet(requestParameters.nexusOpsTenant, requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSparePartApi
     */
    public apiV1RepairSparePartsRepairSparePartIdGet(requestParameters: RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdGetRequest, options?: RawAxiosRequestConfig) {
        return RepairSparePartApiFp(this.configuration).apiV1RepairSparePartsRepairSparePartIdGet(requestParameters.nexusOpsTenant, requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSparePartApi
     */
    public apiV1RepairSparePartsRepairSparePartIdPut(requestParameters: RepairSparePartApiApiV1RepairSparePartsRepairSparePartIdPutRequest, options?: RawAxiosRequestConfig) {
        return RepairSparePartApiFp(this.configuration).apiV1RepairSparePartsRepairSparePartIdPut(requestParameters.nexusOpsTenant, requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairSparePartDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RepairSparePartAdminApi - axios parameter creator
 * @export
 */
export const RepairSparePartAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairSparePartGetPaginatedDto} [repairSparePartGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSparePartsGetPost: async (nexusOpsAppVersion?: string, repairSparePartGetPaginatedDto?: RepairSparePartGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/repair/spare-parts/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairSparePartGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairSparePartDto} [createRepairSparePartDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSparePartsPost: async (nexusOpsAppVersion?: string, createRepairSparePartDto?: CreateRepairSparePartDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/repair/spare-parts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRepairSparePartDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSparePartsRepairSparePartIdDelete: async (repairSparePartId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairSparePartId' is not null or undefined
            assertParamExists('apiV1AdminRepairSparePartsRepairSparePartIdDelete', 'repairSparePartId', repairSparePartId)
            const localVarPath = `/api/v1/admin/repair/spare-parts/{repairSparePartId}`
                .replace(`{${"repairSparePartId"}}`, encodeURIComponent(String(repairSparePartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGet: async (repairSparePartId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairSparePartId' is not null or undefined
            assertParamExists('apiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGet', 'repairSparePartId', repairSparePartId)
            const localVarPath = `/api/v1/admin/repair/spare-parts/{repairSparePartId}/delete/info`
                .replace(`{${"repairSparePartId"}}`, encodeURIComponent(String(repairSparePartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSparePartsRepairSparePartIdGet: async (repairSparePartId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairSparePartId' is not null or undefined
            assertParamExists('apiV1AdminRepairSparePartsRepairSparePartIdGet', 'repairSparePartId', repairSparePartId)
            const localVarPath = `/api/v1/admin/repair/spare-parts/{repairSparePartId}`
                .replace(`{${"repairSparePartId"}}`, encodeURIComponent(String(repairSparePartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairSparePartDto} [updateRepairSparePartDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSparePartsRepairSparePartIdPut: async (repairSparePartId: string, nexusOpsAppVersion?: string, updateRepairSparePartDto?: UpdateRepairSparePartDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairSparePartId' is not null or undefined
            assertParamExists('apiV1AdminRepairSparePartsRepairSparePartIdPut', 'repairSparePartId', repairSparePartId)
            const localVarPath = `/api/v1/admin/repair/spare-parts/{repairSparePartId}`
                .replace(`{${"repairSparePartId"}}`, encodeURIComponent(String(repairSparePartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRepairSparePartDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepairSparePartAdminApi - functional programming interface
 * @export
 */
export const RepairSparePartAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepairSparePartAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairSparePartGetPaginatedDto} [repairSparePartGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairSparePartsGetPost(nexusOpsAppVersion?: string, repairSparePartGetPaginatedDto?: RepairSparePartGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfRepairSparePartDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairSparePartsGetPost(nexusOpsAppVersion, repairSparePartGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSparePartAdminApi.apiV1AdminRepairSparePartsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairSparePartDto} [createRepairSparePartDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairSparePartsPost(nexusOpsAppVersion?: string, createRepairSparePartDto?: CreateRepairSparePartDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairSparePartDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairSparePartsPost(nexusOpsAppVersion, createRepairSparePartDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSparePartAdminApi.apiV1AdminRepairSparePartsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairSparePartsRepairSparePartIdDelete(repairSparePartId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairSparePartsRepairSparePartIdDelete(repairSparePartId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSparePartAdminApi.apiV1AdminRepairSparePartsRepairSparePartIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGet(repairSparePartId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteRepairSparePartInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGet(repairSparePartId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSparePartAdminApi.apiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairSparePartsRepairSparePartIdGet(repairSparePartId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairSparePartDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairSparePartsRepairSparePartIdGet(repairSparePartId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSparePartAdminApi.apiV1AdminRepairSparePartsRepairSparePartIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repairSparePartId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairSparePartDto} [updateRepairSparePartDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairSparePartsRepairSparePartIdPut(repairSparePartId: string, nexusOpsAppVersion?: string, updateRepairSparePartDto?: UpdateRepairSparePartDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairSparePartDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairSparePartsRepairSparePartIdPut(repairSparePartId, nexusOpsAppVersion, updateRepairSparePartDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSparePartAdminApi.apiV1AdminRepairSparePartsRepairSparePartIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RepairSparePartAdminApi - factory interface
 * @export
 */
export const RepairSparePartAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepairSparePartAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {RepairSparePartAdminApiApiV1AdminRepairSparePartsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSparePartsGetPost(requestParameters: RepairSparePartAdminApiApiV1AdminRepairSparePartsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfRepairSparePartDto> {
            return localVarFp.apiV1AdminRepairSparePartsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.repairSparePartGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSparePartAdminApiApiV1AdminRepairSparePartsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSparePartsPost(requestParameters: RepairSparePartAdminApiApiV1AdminRepairSparePartsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RepairSparePartDto> {
            return localVarFp.apiV1AdminRepairSparePartsPost(requestParameters.nexusOpsAppVersion, requestParameters.createRepairSparePartDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSparePartsRepairSparePartIdDelete(requestParameters: RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminRepairSparePartsRepairSparePartIdDelete(requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGet(requestParameters: RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteRepairSparePartInfoDto> {
            return localVarFp.apiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGet(requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSparePartsRepairSparePartIdGet(requestParameters: RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairSparePartDto> {
            return localVarFp.apiV1AdminRepairSparePartsRepairSparePartIdGet(requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSparePartsRepairSparePartIdPut(requestParameters: RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairSparePartDto> {
            return localVarFp.apiV1AdminRepairSparePartsRepairSparePartIdPut(requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairSparePartDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminRepairSparePartsGetPost operation in RepairSparePartAdminApi.
 * @export
 * @interface RepairSparePartAdminApiApiV1AdminRepairSparePartsGetPostRequest
 */
export interface RepairSparePartAdminApiApiV1AdminRepairSparePartsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSparePartAdminApiApiV1AdminRepairSparePartsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RepairSparePartGetPaginatedDto}
     * @memberof RepairSparePartAdminApiApiV1AdminRepairSparePartsGetPost
     */
    readonly repairSparePartGetPaginatedDto?: RepairSparePartGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminRepairSparePartsPost operation in RepairSparePartAdminApi.
 * @export
 * @interface RepairSparePartAdminApiApiV1AdminRepairSparePartsPostRequest
 */
export interface RepairSparePartAdminApiApiV1AdminRepairSparePartsPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSparePartAdminApiApiV1AdminRepairSparePartsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateRepairSparePartDto}
     * @memberof RepairSparePartAdminApiApiV1AdminRepairSparePartsPost
     */
    readonly createRepairSparePartDto?: CreateRepairSparePartDto
}

/**
 * Request parameters for apiV1AdminRepairSparePartsRepairSparePartIdDelete operation in RepairSparePartAdminApi.
 * @export
 * @interface RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDeleteRequest
 */
export interface RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDelete
     */
    readonly repairSparePartId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGet operation in RepairSparePartAdminApi.
 * @export
 * @interface RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGetRequest
 */
export interface RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGet
     */
    readonly repairSparePartId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminRepairSparePartsRepairSparePartIdGet operation in RepairSparePartAdminApi.
 * @export
 * @interface RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdGetRequest
 */
export interface RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdGet
     */
    readonly repairSparePartId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminRepairSparePartsRepairSparePartIdPut operation in RepairSparePartAdminApi.
 * @export
 * @interface RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdPutRequest
 */
export interface RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdPut
     */
    readonly repairSparePartId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateRepairSparePartDto}
     * @memberof RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdPut
     */
    readonly updateRepairSparePartDto?: UpdateRepairSparePartDto
}

/**
 * RepairSparePartAdminApi - object-oriented interface
 * @export
 * @class RepairSparePartAdminApi
 * @extends {BaseAPI}
 */
export class RepairSparePartAdminApi extends BaseAPI {
    /**
     * 
     * @param {RepairSparePartAdminApiApiV1AdminRepairSparePartsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSparePartAdminApi
     */
    public apiV1AdminRepairSparePartsGetPost(requestParameters: RepairSparePartAdminApiApiV1AdminRepairSparePartsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return RepairSparePartAdminApiFp(this.configuration).apiV1AdminRepairSparePartsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.repairSparePartGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSparePartAdminApiApiV1AdminRepairSparePartsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSparePartAdminApi
     */
    public apiV1AdminRepairSparePartsPost(requestParameters: RepairSparePartAdminApiApiV1AdminRepairSparePartsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return RepairSparePartAdminApiFp(this.configuration).apiV1AdminRepairSparePartsPost(requestParameters.nexusOpsAppVersion, requestParameters.createRepairSparePartDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSparePartAdminApi
     */
    public apiV1AdminRepairSparePartsRepairSparePartIdDelete(requestParameters: RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return RepairSparePartAdminApiFp(this.configuration).apiV1AdminRepairSparePartsRepairSparePartIdDelete(requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSparePartAdminApi
     */
    public apiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGet(requestParameters: RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGetRequest, options?: RawAxiosRequestConfig) {
        return RepairSparePartAdminApiFp(this.configuration).apiV1AdminRepairSparePartsRepairSparePartIdDeleteInfoGet(requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSparePartAdminApi
     */
    public apiV1AdminRepairSparePartsRepairSparePartIdGet(requestParameters: RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdGetRequest, options?: RawAxiosRequestConfig) {
        return RepairSparePartAdminApiFp(this.configuration).apiV1AdminRepairSparePartsRepairSparePartIdGet(requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSparePartAdminApi
     */
    public apiV1AdminRepairSparePartsRepairSparePartIdPut(requestParameters: RepairSparePartAdminApiApiV1AdminRepairSparePartsRepairSparePartIdPutRequest, options?: RawAxiosRequestConfig) {
        return RepairSparePartAdminApiFp(this.configuration).apiV1AdminRepairSparePartsRepairSparePartIdPut(requestParameters.repairSparePartId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairSparePartDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RepairSpecsApi - axios parameter creator
 * @export
 */
export const RepairSpecsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairSpecGetPaginatedDto} [repairSpecGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSpecsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, repairSpecGetPaginatedDto?: RepairSpecGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairSpecsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair/specs/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairSpecGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairSpecDto} [createRepairSpecDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSpecsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createRepairSpecDto?: CreateRepairSpecDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairSpecsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair/specs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRepairSpecDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairSpecId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSpecsRepairSpecIdDelete: async (nexusOpsTenant: string, repairSpecId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairSpecsRepairSpecIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairSpecId' is not null or undefined
            assertParamExists('apiV1RepairSpecsRepairSpecIdDelete', 'repairSpecId', repairSpecId)
            const localVarPath = `/api/v1/repair/specs/{repairSpecId}`
                .replace(`{${"repairSpecId"}}`, encodeURIComponent(String(repairSpecId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairSpecId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSpecsRepairSpecIdGet: async (nexusOpsTenant: string, repairSpecId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairSpecsRepairSpecIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairSpecId' is not null or undefined
            assertParamExists('apiV1RepairSpecsRepairSpecIdGet', 'repairSpecId', repairSpecId)
            const localVarPath = `/api/v1/repair/specs/{repairSpecId}`
                .replace(`{${"repairSpecId"}}`, encodeURIComponent(String(repairSpecId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairSpecId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairSpecDto} [updateRepairSpecDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSpecsRepairSpecIdPut: async (nexusOpsTenant: string, repairSpecId: string, nexusOpsAppVersion?: string, updateRepairSpecDto?: UpdateRepairSpecDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairSpecsRepairSpecIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairSpecId' is not null or undefined
            assertParamExists('apiV1RepairSpecsRepairSpecIdPut', 'repairSpecId', repairSpecId)
            const localVarPath = `/api/v1/repair/specs/{repairSpecId}`
                .replace(`{${"repairSpecId"}}`, encodeURIComponent(String(repairSpecId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRepairSpecDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {string} [excludeId] 
         * @param {string} [excludeName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSpecsSuggestionsNameGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, limit?: number, search?: string, excludeId?: string, excludeName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairSpecsSuggestionsNameGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair/specs/suggestions/name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (excludeId !== undefined) {
                localVarQueryParameter['excludeId'] = excludeId;
            }

            if (excludeName !== undefined) {
                localVarQueryParameter['excludeName'] = excludeName;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepairSpecsApi - functional programming interface
 * @export
 */
export const RepairSpecsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepairSpecsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairSpecGetPaginatedDto} [repairSpecGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairSpecsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, repairSpecGetPaginatedDto?: RepairSpecGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfRepairSpecDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairSpecsGetPost(nexusOpsTenant, nexusOpsAppVersion, repairSpecGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSpecsApi.apiV1RepairSpecsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairSpecDto} [createRepairSpecDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairSpecsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createRepairSpecDto?: CreateRepairSpecDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairSpecDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairSpecsPost(nexusOpsTenant, nexusOpsAppVersion, createRepairSpecDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSpecsApi.apiV1RepairSpecsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairSpecId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairSpecsRepairSpecIdDelete(nexusOpsTenant: string, repairSpecId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairSpecsRepairSpecIdDelete(nexusOpsTenant, repairSpecId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSpecsApi.apiV1RepairSpecsRepairSpecIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairSpecId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairSpecsRepairSpecIdGet(nexusOpsTenant: string, repairSpecId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairSpecDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairSpecsRepairSpecIdGet(nexusOpsTenant, repairSpecId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSpecsApi.apiV1RepairSpecsRepairSpecIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairSpecId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairSpecDto} [updateRepairSpecDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairSpecsRepairSpecIdPut(nexusOpsTenant: string, repairSpecId: string, nexusOpsAppVersion?: string, updateRepairSpecDto?: UpdateRepairSpecDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairSpecDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairSpecsRepairSpecIdPut(nexusOpsTenant, repairSpecId, nexusOpsAppVersion, updateRepairSpecDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSpecsApi.apiV1RepairSpecsRepairSpecIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {number} [limit] 
         * @param {string} [search] 
         * @param {string} [excludeId] 
         * @param {string} [excludeName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairSpecsSuggestionsNameGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, limit?: number, search?: string, excludeId?: string, excludeName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairSpecNameSuggestionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairSpecsSuggestionsNameGet(nexusOpsTenant, nexusOpsAppVersion, limit, search, excludeId, excludeName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSpecsApi.apiV1RepairSpecsSuggestionsNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RepairSpecsApi - factory interface
 * @export
 */
export const RepairSpecsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepairSpecsApiFp(configuration)
    return {
        /**
         * 
         * @param {RepairSpecsApiApiV1RepairSpecsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSpecsGetPost(requestParameters: RepairSpecsApiApiV1RepairSpecsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfRepairSpecDto> {
            return localVarFp.apiV1RepairSpecsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairSpecGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSpecsApiApiV1RepairSpecsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSpecsPost(requestParameters: RepairSpecsApiApiV1RepairSpecsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairSpecDto> {
            return localVarFp.apiV1RepairSpecsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createRepairSpecDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSpecsApiApiV1RepairSpecsRepairSpecIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSpecsRepairSpecIdDelete(requestParameters: RepairSpecsApiApiV1RepairSpecsRepairSpecIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1RepairSpecsRepairSpecIdDelete(requestParameters.nexusOpsTenant, requestParameters.repairSpecId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSpecsApiApiV1RepairSpecsRepairSpecIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSpecsRepairSpecIdGet(requestParameters: RepairSpecsApiApiV1RepairSpecsRepairSpecIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairSpecDto> {
            return localVarFp.apiV1RepairSpecsRepairSpecIdGet(requestParameters.nexusOpsTenant, requestParameters.repairSpecId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSpecsApiApiV1RepairSpecsRepairSpecIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSpecsRepairSpecIdPut(requestParameters: RepairSpecsApiApiV1RepairSpecsRepairSpecIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairSpecDto> {
            return localVarFp.apiV1RepairSpecsRepairSpecIdPut(requestParameters.nexusOpsTenant, requestParameters.repairSpecId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairSpecDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSpecsApiApiV1RepairSpecsSuggestionsNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairSpecsSuggestionsNameGet(requestParameters: RepairSpecsApiApiV1RepairSpecsSuggestionsNameGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairSpecNameSuggestionsDto> {
            return localVarFp.apiV1RepairSpecsSuggestionsNameGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.limit, requestParameters.search, requestParameters.excludeId, requestParameters.excludeName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1RepairSpecsGetPost operation in RepairSpecsApi.
 * @export
 * @interface RepairSpecsApiApiV1RepairSpecsGetPostRequest
 */
export interface RepairSpecsApiApiV1RepairSpecsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RepairSpecGetPaginatedDto}
     * @memberof RepairSpecsApiApiV1RepairSpecsGetPost
     */
    readonly repairSpecGetPaginatedDto?: RepairSpecGetPaginatedDto
}

/**
 * Request parameters for apiV1RepairSpecsPost operation in RepairSpecsApi.
 * @export
 * @interface RepairSpecsApiApiV1RepairSpecsPostRequest
 */
export interface RepairSpecsApiApiV1RepairSpecsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateRepairSpecDto}
     * @memberof RepairSpecsApiApiV1RepairSpecsPost
     */
    readonly createRepairSpecDto?: CreateRepairSpecDto
}

/**
 * Request parameters for apiV1RepairSpecsRepairSpecIdDelete operation in RepairSpecsApi.
 * @export
 * @interface RepairSpecsApiApiV1RepairSpecsRepairSpecIdDeleteRequest
 */
export interface RepairSpecsApiApiV1RepairSpecsRepairSpecIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsRepairSpecIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsRepairSpecIdDelete
     */
    readonly repairSpecId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsRepairSpecIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairSpecsRepairSpecIdGet operation in RepairSpecsApi.
 * @export
 * @interface RepairSpecsApiApiV1RepairSpecsRepairSpecIdGetRequest
 */
export interface RepairSpecsApiApiV1RepairSpecsRepairSpecIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsRepairSpecIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsRepairSpecIdGet
     */
    readonly repairSpecId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsRepairSpecIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairSpecsRepairSpecIdPut operation in RepairSpecsApi.
 * @export
 * @interface RepairSpecsApiApiV1RepairSpecsRepairSpecIdPutRequest
 */
export interface RepairSpecsApiApiV1RepairSpecsRepairSpecIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsRepairSpecIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsRepairSpecIdPut
     */
    readonly repairSpecId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsRepairSpecIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateRepairSpecDto}
     * @memberof RepairSpecsApiApiV1RepairSpecsRepairSpecIdPut
     */
    readonly updateRepairSpecDto?: UpdateRepairSpecDto
}

/**
 * Request parameters for apiV1RepairSpecsSuggestionsNameGet operation in RepairSpecsApi.
 * @export
 * @interface RepairSpecsApiApiV1RepairSpecsSuggestionsNameGetRequest
 */
export interface RepairSpecsApiApiV1RepairSpecsSuggestionsNameGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsSuggestionsNameGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsSuggestionsNameGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {number}
     * @memberof RepairSpecsApiApiV1RepairSpecsSuggestionsNameGet
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsSuggestionsNameGet
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsSuggestionsNameGet
     */
    readonly excludeId?: string

    /**
     * 
     * @type {string}
     * @memberof RepairSpecsApiApiV1RepairSpecsSuggestionsNameGet
     */
    readonly excludeName?: string
}

/**
 * RepairSpecsApi - object-oriented interface
 * @export
 * @class RepairSpecsApi
 * @extends {BaseAPI}
 */
export class RepairSpecsApi extends BaseAPI {
    /**
     * 
     * @param {RepairSpecsApiApiV1RepairSpecsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSpecsApi
     */
    public apiV1RepairSpecsGetPost(requestParameters: RepairSpecsApiApiV1RepairSpecsGetPostRequest, options?: RawAxiosRequestConfig) {
        return RepairSpecsApiFp(this.configuration).apiV1RepairSpecsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairSpecGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSpecsApiApiV1RepairSpecsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSpecsApi
     */
    public apiV1RepairSpecsPost(requestParameters: RepairSpecsApiApiV1RepairSpecsPostRequest, options?: RawAxiosRequestConfig) {
        return RepairSpecsApiFp(this.configuration).apiV1RepairSpecsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createRepairSpecDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSpecsApiApiV1RepairSpecsRepairSpecIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSpecsApi
     */
    public apiV1RepairSpecsRepairSpecIdDelete(requestParameters: RepairSpecsApiApiV1RepairSpecsRepairSpecIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return RepairSpecsApiFp(this.configuration).apiV1RepairSpecsRepairSpecIdDelete(requestParameters.nexusOpsTenant, requestParameters.repairSpecId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSpecsApiApiV1RepairSpecsRepairSpecIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSpecsApi
     */
    public apiV1RepairSpecsRepairSpecIdGet(requestParameters: RepairSpecsApiApiV1RepairSpecsRepairSpecIdGetRequest, options?: RawAxiosRequestConfig) {
        return RepairSpecsApiFp(this.configuration).apiV1RepairSpecsRepairSpecIdGet(requestParameters.nexusOpsTenant, requestParameters.repairSpecId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSpecsApiApiV1RepairSpecsRepairSpecIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSpecsApi
     */
    public apiV1RepairSpecsRepairSpecIdPut(requestParameters: RepairSpecsApiApiV1RepairSpecsRepairSpecIdPutRequest, options?: RawAxiosRequestConfig) {
        return RepairSpecsApiFp(this.configuration).apiV1RepairSpecsRepairSpecIdPut(requestParameters.nexusOpsTenant, requestParameters.repairSpecId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairSpecDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSpecsApiApiV1RepairSpecsSuggestionsNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSpecsApi
     */
    public apiV1RepairSpecsSuggestionsNameGet(requestParameters: RepairSpecsApiApiV1RepairSpecsSuggestionsNameGetRequest, options?: RawAxiosRequestConfig) {
        return RepairSpecsApiFp(this.configuration).apiV1RepairSpecsSuggestionsNameGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.limit, requestParameters.search, requestParameters.excludeId, requestParameters.excludeName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RepairSpecsAdminApi - axios parameter creator
 * @export
 */
export const RepairSpecsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairSpecGetPaginatedDto} [repairSpecGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSpecsGetPost: async (nexusOpsAppVersion?: string, repairSpecGetPaginatedDto?: RepairSpecGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/repair/specs/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairSpecGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairSpecDto} [createRepairSpecDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSpecsPost: async (nexusOpsAppVersion?: string, createRepairSpecDto?: CreateRepairSpecDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/repair/specs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRepairSpecDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repairSpecId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSpecsRepairSpecIdDelete: async (repairSpecId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairSpecId' is not null or undefined
            assertParamExists('apiV1AdminRepairSpecsRepairSpecIdDelete', 'repairSpecId', repairSpecId)
            const localVarPath = `/api/v1/admin/repair/specs/{repairSpecId}`
                .replace(`{${"repairSpecId"}}`, encodeURIComponent(String(repairSpecId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repairSpecId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSpecsRepairSpecIdGet: async (repairSpecId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairSpecId' is not null or undefined
            assertParamExists('apiV1AdminRepairSpecsRepairSpecIdGet', 'repairSpecId', repairSpecId)
            const localVarPath = `/api/v1/admin/repair/specs/{repairSpecId}`
                .replace(`{${"repairSpecId"}}`, encodeURIComponent(String(repairSpecId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repairSpecId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairSpecDto} [updateRepairSpecDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSpecsRepairSpecIdPut: async (repairSpecId: string, nexusOpsAppVersion?: string, updateRepairSpecDto?: UpdateRepairSpecDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairSpecId' is not null or undefined
            assertParamExists('apiV1AdminRepairSpecsRepairSpecIdPut', 'repairSpecId', repairSpecId)
            const localVarPath = `/api/v1/admin/repair/specs/{repairSpecId}`
                .replace(`{${"repairSpecId"}}`, encodeURIComponent(String(repairSpecId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRepairSpecDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepairSpecsAdminApi - functional programming interface
 * @export
 */
export const RepairSpecsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepairSpecsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairSpecGetPaginatedDto} [repairSpecGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairSpecsGetPost(nexusOpsAppVersion?: string, repairSpecGetPaginatedDto?: RepairSpecGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfRepairSpecDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairSpecsGetPost(nexusOpsAppVersion, repairSpecGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSpecsAdminApi.apiV1AdminRepairSpecsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairSpecDto} [createRepairSpecDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairSpecsPost(nexusOpsAppVersion?: string, createRepairSpecDto?: CreateRepairSpecDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairSpecDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairSpecsPost(nexusOpsAppVersion, createRepairSpecDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSpecsAdminApi.apiV1AdminRepairSpecsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repairSpecId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairSpecsRepairSpecIdDelete(repairSpecId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairSpecsRepairSpecIdDelete(repairSpecId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSpecsAdminApi.apiV1AdminRepairSpecsRepairSpecIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repairSpecId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairSpecsRepairSpecIdGet(repairSpecId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairSpecDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairSpecsRepairSpecIdGet(repairSpecId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSpecsAdminApi.apiV1AdminRepairSpecsRepairSpecIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repairSpecId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairSpecDto} [updateRepairSpecDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairSpecsRepairSpecIdPut(repairSpecId: string, nexusOpsAppVersion?: string, updateRepairSpecDto?: UpdateRepairSpecDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairSpecDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairSpecsRepairSpecIdPut(repairSpecId, nexusOpsAppVersion, updateRepairSpecDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairSpecsAdminApi.apiV1AdminRepairSpecsRepairSpecIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RepairSpecsAdminApi - factory interface
 * @export
 */
export const RepairSpecsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepairSpecsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {RepairSpecsAdminApiApiV1AdminRepairSpecsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSpecsGetPost(requestParameters: RepairSpecsAdminApiApiV1AdminRepairSpecsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfRepairSpecDto> {
            return localVarFp.apiV1AdminRepairSpecsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.repairSpecGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSpecsAdminApiApiV1AdminRepairSpecsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSpecsPost(requestParameters: RepairSpecsAdminApiApiV1AdminRepairSpecsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RepairSpecDto> {
            return localVarFp.apiV1AdminRepairSpecsPost(requestParameters.nexusOpsAppVersion, requestParameters.createRepairSpecDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSpecsRepairSpecIdDelete(requestParameters: RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminRepairSpecsRepairSpecIdDelete(requestParameters.repairSpecId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSpecsRepairSpecIdGet(requestParameters: RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairSpecDto> {
            return localVarFp.apiV1AdminRepairSpecsRepairSpecIdGet(requestParameters.repairSpecId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairSpecsRepairSpecIdPut(requestParameters: RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairSpecDto> {
            return localVarFp.apiV1AdminRepairSpecsRepairSpecIdPut(requestParameters.repairSpecId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairSpecDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminRepairSpecsGetPost operation in RepairSpecsAdminApi.
 * @export
 * @interface RepairSpecsAdminApiApiV1AdminRepairSpecsGetPostRequest
 */
export interface RepairSpecsAdminApiApiV1AdminRepairSpecsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSpecsAdminApiApiV1AdminRepairSpecsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RepairSpecGetPaginatedDto}
     * @memberof RepairSpecsAdminApiApiV1AdminRepairSpecsGetPost
     */
    readonly repairSpecGetPaginatedDto?: RepairSpecGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminRepairSpecsPost operation in RepairSpecsAdminApi.
 * @export
 * @interface RepairSpecsAdminApiApiV1AdminRepairSpecsPostRequest
 */
export interface RepairSpecsAdminApiApiV1AdminRepairSpecsPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSpecsAdminApiApiV1AdminRepairSpecsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateRepairSpecDto}
     * @memberof RepairSpecsAdminApiApiV1AdminRepairSpecsPost
     */
    readonly createRepairSpecDto?: CreateRepairSpecDto
}

/**
 * Request parameters for apiV1AdminRepairSpecsRepairSpecIdDelete operation in RepairSpecsAdminApi.
 * @export
 * @interface RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdDeleteRequest
 */
export interface RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdDelete
     */
    readonly repairSpecId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminRepairSpecsRepairSpecIdGet operation in RepairSpecsAdminApi.
 * @export
 * @interface RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdGetRequest
 */
export interface RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdGet
     */
    readonly repairSpecId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminRepairSpecsRepairSpecIdPut operation in RepairSpecsAdminApi.
 * @export
 * @interface RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdPutRequest
 */
export interface RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdPut
     */
    readonly repairSpecId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateRepairSpecDto}
     * @memberof RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdPut
     */
    readonly updateRepairSpecDto?: UpdateRepairSpecDto
}

/**
 * RepairSpecsAdminApi - object-oriented interface
 * @export
 * @class RepairSpecsAdminApi
 * @extends {BaseAPI}
 */
export class RepairSpecsAdminApi extends BaseAPI {
    /**
     * 
     * @param {RepairSpecsAdminApiApiV1AdminRepairSpecsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSpecsAdminApi
     */
    public apiV1AdminRepairSpecsGetPost(requestParameters: RepairSpecsAdminApiApiV1AdminRepairSpecsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return RepairSpecsAdminApiFp(this.configuration).apiV1AdminRepairSpecsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.repairSpecGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSpecsAdminApiApiV1AdminRepairSpecsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSpecsAdminApi
     */
    public apiV1AdminRepairSpecsPost(requestParameters: RepairSpecsAdminApiApiV1AdminRepairSpecsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return RepairSpecsAdminApiFp(this.configuration).apiV1AdminRepairSpecsPost(requestParameters.nexusOpsAppVersion, requestParameters.createRepairSpecDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSpecsAdminApi
     */
    public apiV1AdminRepairSpecsRepairSpecIdDelete(requestParameters: RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return RepairSpecsAdminApiFp(this.configuration).apiV1AdminRepairSpecsRepairSpecIdDelete(requestParameters.repairSpecId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSpecsAdminApi
     */
    public apiV1AdminRepairSpecsRepairSpecIdGet(requestParameters: RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdGetRequest, options?: RawAxiosRequestConfig) {
        return RepairSpecsAdminApiFp(this.configuration).apiV1AdminRepairSpecsRepairSpecIdGet(requestParameters.repairSpecId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairSpecsAdminApi
     */
    public apiV1AdminRepairSpecsRepairSpecIdPut(requestParameters: RepairSpecsAdminApiApiV1AdminRepairSpecsRepairSpecIdPutRequest, options?: RawAxiosRequestConfig) {
        return RepairSpecsAdminApiFp(this.configuration).apiV1AdminRepairSpecsRepairSpecIdPut(requestParameters.repairSpecId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairSpecDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RepairWorkApi - axios parameter creator
 * @export
 */
export const RepairWorkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairWorkGetPaginatedDto} [repairWorkGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairWorkGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, repairWorkGetPaginatedDto?: RepairWorkGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairWorkGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair/work/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairWorkGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairWorkDto} [createRepairWorkDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairWorkPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createRepairWorkDto?: CreateRepairWorkDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairWorkPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/repair/work`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRepairWorkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairWorkId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairWorkRepairWorkIdDelete: async (nexusOpsTenant: string, repairWorkId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairWorkRepairWorkIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairWorkId' is not null or undefined
            assertParamExists('apiV1RepairWorkRepairWorkIdDelete', 'repairWorkId', repairWorkId)
            const localVarPath = `/api/v1/repair/work/{repairWorkId}`
                .replace(`{${"repairWorkId"}}`, encodeURIComponent(String(repairWorkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairWorkId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairWorkRepairWorkIdDeleteInfoGet: async (nexusOpsTenant: string, repairWorkId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairWorkRepairWorkIdDeleteInfoGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairWorkId' is not null or undefined
            assertParamExists('apiV1RepairWorkRepairWorkIdDeleteInfoGet', 'repairWorkId', repairWorkId)
            const localVarPath = `/api/v1/repair/work/{repairWorkId}/delete/info`
                .replace(`{${"repairWorkId"}}`, encodeURIComponent(String(repairWorkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairWorkId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairWorkRepairWorkIdGet: async (nexusOpsTenant: string, repairWorkId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairWorkRepairWorkIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairWorkId' is not null or undefined
            assertParamExists('apiV1RepairWorkRepairWorkIdGet', 'repairWorkId', repairWorkId)
            const localVarPath = `/api/v1/repair/work/{repairWorkId}`
                .replace(`{${"repairWorkId"}}`, encodeURIComponent(String(repairWorkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairWorkId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairWorkDto} [updateRepairWorkDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairWorkRepairWorkIdPut: async (nexusOpsTenant: string, repairWorkId: string, nexusOpsAppVersion?: string, updateRepairWorkDto?: UpdateRepairWorkDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1RepairWorkRepairWorkIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'repairWorkId' is not null or undefined
            assertParamExists('apiV1RepairWorkRepairWorkIdPut', 'repairWorkId', repairWorkId)
            const localVarPath = `/api/v1/repair/work/{repairWorkId}`
                .replace(`{${"repairWorkId"}}`, encodeURIComponent(String(repairWorkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRepairWorkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepairWorkApi - functional programming interface
 * @export
 */
export const RepairWorkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepairWorkApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairWorkGetPaginatedDto} [repairWorkGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairWorkGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, repairWorkGetPaginatedDto?: RepairWorkGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfRepairWorkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairWorkGetPost(nexusOpsTenant, nexusOpsAppVersion, repairWorkGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairWorkApi.apiV1RepairWorkGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairWorkDto} [createRepairWorkDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairWorkPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createRepairWorkDto?: CreateRepairWorkDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairWorkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairWorkPost(nexusOpsTenant, nexusOpsAppVersion, createRepairWorkDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairWorkApi.apiV1RepairWorkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairWorkId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairWorkRepairWorkIdDelete(nexusOpsTenant: string, repairWorkId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairWorkRepairWorkIdDelete(nexusOpsTenant, repairWorkId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairWorkApi.apiV1RepairWorkRepairWorkIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairWorkId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairWorkRepairWorkIdDeleteInfoGet(nexusOpsTenant: string, repairWorkId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteRepairWorkInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairWorkRepairWorkIdDeleteInfoGet(nexusOpsTenant, repairWorkId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairWorkApi.apiV1RepairWorkRepairWorkIdDeleteInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairWorkId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairWorkRepairWorkIdGet(nexusOpsTenant: string, repairWorkId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairWorkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairWorkRepairWorkIdGet(nexusOpsTenant, repairWorkId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairWorkApi.apiV1RepairWorkRepairWorkIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} repairWorkId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairWorkDto} [updateRepairWorkDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RepairWorkRepairWorkIdPut(nexusOpsTenant: string, repairWorkId: string, nexusOpsAppVersion?: string, updateRepairWorkDto?: UpdateRepairWorkDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairWorkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RepairWorkRepairWorkIdPut(nexusOpsTenant, repairWorkId, nexusOpsAppVersion, updateRepairWorkDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairWorkApi.apiV1RepairWorkRepairWorkIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RepairWorkApi - factory interface
 * @export
 */
export const RepairWorkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepairWorkApiFp(configuration)
    return {
        /**
         * 
         * @param {RepairWorkApiApiV1RepairWorkGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairWorkGetPost(requestParameters: RepairWorkApiApiV1RepairWorkGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfRepairWorkDto> {
            return localVarFp.apiV1RepairWorkGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairWorkGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairWorkApiApiV1RepairWorkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairWorkPost(requestParameters: RepairWorkApiApiV1RepairWorkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairWorkDto> {
            return localVarFp.apiV1RepairWorkPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createRepairWorkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairWorkRepairWorkIdDelete(requestParameters: RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1RepairWorkRepairWorkIdDelete(requestParameters.nexusOpsTenant, requestParameters.repairWorkId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteInfoGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairWorkRepairWorkIdDeleteInfoGet(requestParameters: RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteInfoGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteRepairWorkInfoDto> {
            return localVarFp.apiV1RepairWorkRepairWorkIdDeleteInfoGet(requestParameters.nexusOpsTenant, requestParameters.repairWorkId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairWorkApiApiV1RepairWorkRepairWorkIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairWorkRepairWorkIdGet(requestParameters: RepairWorkApiApiV1RepairWorkRepairWorkIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairWorkDto> {
            return localVarFp.apiV1RepairWorkRepairWorkIdGet(requestParameters.nexusOpsTenant, requestParameters.repairWorkId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairWorkApiApiV1RepairWorkRepairWorkIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RepairWorkRepairWorkIdPut(requestParameters: RepairWorkApiApiV1RepairWorkRepairWorkIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairWorkDto> {
            return localVarFp.apiV1RepairWorkRepairWorkIdPut(requestParameters.nexusOpsTenant, requestParameters.repairWorkId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairWorkDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1RepairWorkGetPost operation in RepairWorkApi.
 * @export
 * @interface RepairWorkApiApiV1RepairWorkGetPostRequest
 */
export interface RepairWorkApiApiV1RepairWorkGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RepairWorkGetPaginatedDto}
     * @memberof RepairWorkApiApiV1RepairWorkGetPost
     */
    readonly repairWorkGetPaginatedDto?: RepairWorkGetPaginatedDto
}

/**
 * Request parameters for apiV1RepairWorkPost operation in RepairWorkApi.
 * @export
 * @interface RepairWorkApiApiV1RepairWorkPostRequest
 */
export interface RepairWorkApiApiV1RepairWorkPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateRepairWorkDto}
     * @memberof RepairWorkApiApiV1RepairWorkPost
     */
    readonly createRepairWorkDto?: CreateRepairWorkDto
}

/**
 * Request parameters for apiV1RepairWorkRepairWorkIdDelete operation in RepairWorkApi.
 * @export
 * @interface RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteRequest
 */
export interface RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkRepairWorkIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkRepairWorkIdDelete
     */
    readonly repairWorkId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkRepairWorkIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairWorkRepairWorkIdDeleteInfoGet operation in RepairWorkApi.
 * @export
 * @interface RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteInfoGetRequest
 */
export interface RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteInfoGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteInfoGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteInfoGet
     */
    readonly repairWorkId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteInfoGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairWorkRepairWorkIdGet operation in RepairWorkApi.
 * @export
 * @interface RepairWorkApiApiV1RepairWorkRepairWorkIdGetRequest
 */
export interface RepairWorkApiApiV1RepairWorkRepairWorkIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkRepairWorkIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkRepairWorkIdGet
     */
    readonly repairWorkId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkRepairWorkIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1RepairWorkRepairWorkIdPut operation in RepairWorkApi.
 * @export
 * @interface RepairWorkApiApiV1RepairWorkRepairWorkIdPutRequest
 */
export interface RepairWorkApiApiV1RepairWorkRepairWorkIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkRepairWorkIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkRepairWorkIdPut
     */
    readonly repairWorkId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairWorkApiApiV1RepairWorkRepairWorkIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateRepairWorkDto}
     * @memberof RepairWorkApiApiV1RepairWorkRepairWorkIdPut
     */
    readonly updateRepairWorkDto?: UpdateRepairWorkDto
}

/**
 * RepairWorkApi - object-oriented interface
 * @export
 * @class RepairWorkApi
 * @extends {BaseAPI}
 */
export class RepairWorkApi extends BaseAPI {
    /**
     * 
     * @param {RepairWorkApiApiV1RepairWorkGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairWorkApi
     */
    public apiV1RepairWorkGetPost(requestParameters: RepairWorkApiApiV1RepairWorkGetPostRequest, options?: RawAxiosRequestConfig) {
        return RepairWorkApiFp(this.configuration).apiV1RepairWorkGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.repairWorkGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairWorkApiApiV1RepairWorkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairWorkApi
     */
    public apiV1RepairWorkPost(requestParameters: RepairWorkApiApiV1RepairWorkPostRequest, options?: RawAxiosRequestConfig) {
        return RepairWorkApiFp(this.configuration).apiV1RepairWorkPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createRepairWorkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairWorkApi
     */
    public apiV1RepairWorkRepairWorkIdDelete(requestParameters: RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return RepairWorkApiFp(this.configuration).apiV1RepairWorkRepairWorkIdDelete(requestParameters.nexusOpsTenant, requestParameters.repairWorkId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteInfoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairWorkApi
     */
    public apiV1RepairWorkRepairWorkIdDeleteInfoGet(requestParameters: RepairWorkApiApiV1RepairWorkRepairWorkIdDeleteInfoGetRequest, options?: RawAxiosRequestConfig) {
        return RepairWorkApiFp(this.configuration).apiV1RepairWorkRepairWorkIdDeleteInfoGet(requestParameters.nexusOpsTenant, requestParameters.repairWorkId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairWorkApiApiV1RepairWorkRepairWorkIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairWorkApi
     */
    public apiV1RepairWorkRepairWorkIdGet(requestParameters: RepairWorkApiApiV1RepairWorkRepairWorkIdGetRequest, options?: RawAxiosRequestConfig) {
        return RepairWorkApiFp(this.configuration).apiV1RepairWorkRepairWorkIdGet(requestParameters.nexusOpsTenant, requestParameters.repairWorkId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairWorkApiApiV1RepairWorkRepairWorkIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairWorkApi
     */
    public apiV1RepairWorkRepairWorkIdPut(requestParameters: RepairWorkApiApiV1RepairWorkRepairWorkIdPutRequest, options?: RawAxiosRequestConfig) {
        return RepairWorkApiFp(this.configuration).apiV1RepairWorkRepairWorkIdPut(requestParameters.nexusOpsTenant, requestParameters.repairWorkId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairWorkDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RepairWorkAdminApi - axios parameter creator
 * @export
 */
export const RepairWorkAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairWorkGetPaginatedDto} [repairWorkGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairWorkGetPost: async (nexusOpsAppVersion?: string, repairWorkGetPaginatedDto?: RepairWorkGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/repair/work/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairWorkGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairWorkDto} [createRepairWorkDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairWorkPost: async (nexusOpsAppVersion?: string, createRepairWorkDto?: CreateRepairWorkDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/repair/work`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRepairWorkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repairWorkId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairWorkRepairWorkIdDelete: async (repairWorkId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairWorkId' is not null or undefined
            assertParamExists('apiV1AdminRepairWorkRepairWorkIdDelete', 'repairWorkId', repairWorkId)
            const localVarPath = `/api/v1/admin/repair/work/{repairWorkId}`
                .replace(`{${"repairWorkId"}}`, encodeURIComponent(String(repairWorkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repairWorkId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairWorkRepairWorkIdGet: async (repairWorkId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairWorkId' is not null or undefined
            assertParamExists('apiV1AdminRepairWorkRepairWorkIdGet', 'repairWorkId', repairWorkId)
            const localVarPath = `/api/v1/admin/repair/work/{repairWorkId}`
                .replace(`{${"repairWorkId"}}`, encodeURIComponent(String(repairWorkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repairWorkId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairWorkDto} [updateRepairWorkDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairWorkRepairWorkIdPut: async (repairWorkId: string, nexusOpsAppVersion?: string, updateRepairWorkDto?: UpdateRepairWorkDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repairWorkId' is not null or undefined
            assertParamExists('apiV1AdminRepairWorkRepairWorkIdPut', 'repairWorkId', repairWorkId)
            const localVarPath = `/api/v1/admin/repair/work/{repairWorkId}`
                .replace(`{${"repairWorkId"}}`, encodeURIComponent(String(repairWorkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRepairWorkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepairWorkAdminApi - functional programming interface
 * @export
 */
export const RepairWorkAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepairWorkAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {RepairWorkGetPaginatedDto} [repairWorkGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairWorkGetPost(nexusOpsAppVersion?: string, repairWorkGetPaginatedDto?: RepairWorkGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfRepairWorkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairWorkGetPost(nexusOpsAppVersion, repairWorkGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairWorkAdminApi.apiV1AdminRepairWorkGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateRepairWorkDto} [createRepairWorkDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairWorkPost(nexusOpsAppVersion?: string, createRepairWorkDto?: CreateRepairWorkDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairWorkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairWorkPost(nexusOpsAppVersion, createRepairWorkDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairWorkAdminApi.apiV1AdminRepairWorkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repairWorkId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairWorkRepairWorkIdDelete(repairWorkId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairWorkRepairWorkIdDelete(repairWorkId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairWorkAdminApi.apiV1AdminRepairWorkRepairWorkIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repairWorkId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairWorkRepairWorkIdGet(repairWorkId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairWorkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairWorkRepairWorkIdGet(repairWorkId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairWorkAdminApi.apiV1AdminRepairWorkRepairWorkIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repairWorkId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateRepairWorkDto} [updateRepairWorkDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminRepairWorkRepairWorkIdPut(repairWorkId: string, nexusOpsAppVersion?: string, updateRepairWorkDto?: UpdateRepairWorkDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairWorkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminRepairWorkRepairWorkIdPut(repairWorkId, nexusOpsAppVersion, updateRepairWorkDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepairWorkAdminApi.apiV1AdminRepairWorkRepairWorkIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RepairWorkAdminApi - factory interface
 * @export
 */
export const RepairWorkAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepairWorkAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {RepairWorkAdminApiApiV1AdminRepairWorkGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairWorkGetPost(requestParameters: RepairWorkAdminApiApiV1AdminRepairWorkGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfRepairWorkDto> {
            return localVarFp.apiV1AdminRepairWorkGetPost(requestParameters.nexusOpsAppVersion, requestParameters.repairWorkGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairWorkAdminApiApiV1AdminRepairWorkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairWorkPost(requestParameters: RepairWorkAdminApiApiV1AdminRepairWorkPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RepairWorkDto> {
            return localVarFp.apiV1AdminRepairWorkPost(requestParameters.nexusOpsAppVersion, requestParameters.createRepairWorkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairWorkRepairWorkIdDelete(requestParameters: RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminRepairWorkRepairWorkIdDelete(requestParameters.repairWorkId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairWorkRepairWorkIdGet(requestParameters: RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairWorkDto> {
            return localVarFp.apiV1AdminRepairWorkRepairWorkIdGet(requestParameters.repairWorkId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminRepairWorkRepairWorkIdPut(requestParameters: RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RepairWorkDto> {
            return localVarFp.apiV1AdminRepairWorkRepairWorkIdPut(requestParameters.repairWorkId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairWorkDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminRepairWorkGetPost operation in RepairWorkAdminApi.
 * @export
 * @interface RepairWorkAdminApiApiV1AdminRepairWorkGetPostRequest
 */
export interface RepairWorkAdminApiApiV1AdminRepairWorkGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairWorkAdminApiApiV1AdminRepairWorkGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {RepairWorkGetPaginatedDto}
     * @memberof RepairWorkAdminApiApiV1AdminRepairWorkGetPost
     */
    readonly repairWorkGetPaginatedDto?: RepairWorkGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminRepairWorkPost operation in RepairWorkAdminApi.
 * @export
 * @interface RepairWorkAdminApiApiV1AdminRepairWorkPostRequest
 */
export interface RepairWorkAdminApiApiV1AdminRepairWorkPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairWorkAdminApiApiV1AdminRepairWorkPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateRepairWorkDto}
     * @memberof RepairWorkAdminApiApiV1AdminRepairWorkPost
     */
    readonly createRepairWorkDto?: CreateRepairWorkDto
}

/**
 * Request parameters for apiV1AdminRepairWorkRepairWorkIdDelete operation in RepairWorkAdminApi.
 * @export
 * @interface RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdDeleteRequest
 */
export interface RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdDelete
     */
    readonly repairWorkId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminRepairWorkRepairWorkIdGet operation in RepairWorkAdminApi.
 * @export
 * @interface RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdGetRequest
 */
export interface RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdGet
     */
    readonly repairWorkId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminRepairWorkRepairWorkIdPut operation in RepairWorkAdminApi.
 * @export
 * @interface RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdPutRequest
 */
export interface RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdPut
     */
    readonly repairWorkId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateRepairWorkDto}
     * @memberof RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdPut
     */
    readonly updateRepairWorkDto?: UpdateRepairWorkDto
}

/**
 * RepairWorkAdminApi - object-oriented interface
 * @export
 * @class RepairWorkAdminApi
 * @extends {BaseAPI}
 */
export class RepairWorkAdminApi extends BaseAPI {
    /**
     * 
     * @param {RepairWorkAdminApiApiV1AdminRepairWorkGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairWorkAdminApi
     */
    public apiV1AdminRepairWorkGetPost(requestParameters: RepairWorkAdminApiApiV1AdminRepairWorkGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return RepairWorkAdminApiFp(this.configuration).apiV1AdminRepairWorkGetPost(requestParameters.nexusOpsAppVersion, requestParameters.repairWorkGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairWorkAdminApiApiV1AdminRepairWorkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairWorkAdminApi
     */
    public apiV1AdminRepairWorkPost(requestParameters: RepairWorkAdminApiApiV1AdminRepairWorkPostRequest = {}, options?: RawAxiosRequestConfig) {
        return RepairWorkAdminApiFp(this.configuration).apiV1AdminRepairWorkPost(requestParameters.nexusOpsAppVersion, requestParameters.createRepairWorkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairWorkAdminApi
     */
    public apiV1AdminRepairWorkRepairWorkIdDelete(requestParameters: RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return RepairWorkAdminApiFp(this.configuration).apiV1AdminRepairWorkRepairWorkIdDelete(requestParameters.repairWorkId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairWorkAdminApi
     */
    public apiV1AdminRepairWorkRepairWorkIdGet(requestParameters: RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdGetRequest, options?: RawAxiosRequestConfig) {
        return RepairWorkAdminApiFp(this.configuration).apiV1AdminRepairWorkRepairWorkIdGet(requestParameters.repairWorkId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairWorkAdminApi
     */
    public apiV1AdminRepairWorkRepairWorkIdPut(requestParameters: RepairWorkAdminApiApiV1AdminRepairWorkRepairWorkIdPutRequest, options?: RawAxiosRequestConfig) {
        return RepairWorkAdminApiFp(this.configuration).apiV1AdminRepairWorkRepairWorkIdPut(requestParameters.repairWorkId, requestParameters.nexusOpsAppVersion, requestParameters.updateRepairWorkDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SpotsApi - axios parameter creator
 * @export
 */
export const SpotsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SpotsBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SpotsBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/spots/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SpotGetPaginatedDto} [spotGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SpotsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, spotGetPaginatedDto?: SpotGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SpotsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/spots/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(spotGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateSpotDto} [createSpotDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SpotsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createSpotDto?: CreateSpotDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SpotsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/spots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSpotDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} spotId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SpotsSpotIdDelete: async (nexusOpsTenant: string, spotId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SpotsSpotIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'spotId' is not null or undefined
            assertParamExists('apiV1SpotsSpotIdDelete', 'spotId', spotId)
            const localVarPath = `/api/v1/spots/{spotId}`
                .replace(`{${"spotId"}}`, encodeURIComponent(String(spotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} spotId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SpotsSpotIdGet: async (nexusOpsTenant: string, spotId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SpotsSpotIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'spotId' is not null or undefined
            assertParamExists('apiV1SpotsSpotIdGet', 'spotId', spotId)
            const localVarPath = `/api/v1/spots/{spotId}`
                .replace(`{${"spotId"}}`, encodeURIComponent(String(spotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} spotId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateSpotDto} [updateSpotDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SpotsSpotIdPut: async (nexusOpsTenant: string, spotId: string, nexusOpsAppVersion?: string, updateSpotDto?: UpdateSpotDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SpotsSpotIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'spotId' is not null or undefined
            assertParamExists('apiV1SpotsSpotIdPut', 'spotId', spotId)
            const localVarPath = `/api/v1/spots/{spotId}`
                .replace(`{${"spotId"}}`, encodeURIComponent(String(spotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSpotDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} spotId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SpotsSpotIdReferenceGet: async (nexusOpsTenant: string, spotId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SpotsSpotIdReferenceGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'spotId' is not null or undefined
            assertParamExists('apiV1SpotsSpotIdReferenceGet', 'spotId', spotId)
            const localVarPath = `/api/v1/spots/{spotId}/reference`
                .replace(`{${"spotId"}}`, encodeURIComponent(String(spotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SpotsApi - functional programming interface
 * @export
 */
export const SpotsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SpotsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SpotsBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SpotsBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpotsApi.apiV1SpotsBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SpotGetPaginatedDto} [spotGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SpotsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, spotGetPaginatedDto?: SpotGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfSpotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SpotsGetPost(nexusOpsTenant, nexusOpsAppVersion, spotGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpotsApi.apiV1SpotsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateSpotDto} [createSpotDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SpotsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createSpotDto?: CreateSpotDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SpotsPost(nexusOpsTenant, nexusOpsAppVersion, createSpotDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpotsApi.apiV1SpotsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} spotId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SpotsSpotIdDelete(nexusOpsTenant: string, spotId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SpotsSpotIdDelete(nexusOpsTenant, spotId, nexusOpsAppVersion, isDeleteCascade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpotsApi.apiV1SpotsSpotIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} spotId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SpotsSpotIdGet(nexusOpsTenant: string, spotId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SpotsSpotIdGet(nexusOpsTenant, spotId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpotsApi.apiV1SpotsSpotIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} spotId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateSpotDto} [updateSpotDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SpotsSpotIdPut(nexusOpsTenant: string, spotId: string, nexusOpsAppVersion?: string, updateSpotDto?: UpdateSpotDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SpotsSpotIdPut(nexusOpsTenant, spotId, nexusOpsAppVersion, updateSpotDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpotsApi.apiV1SpotsSpotIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} spotId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SpotsSpotIdReferenceGet(nexusOpsTenant: string, spotId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpotReferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SpotsSpotIdReferenceGet(nexusOpsTenant, spotId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpotsApi.apiV1SpotsSpotIdReferenceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SpotsApi - factory interface
 * @export
 */
export const SpotsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SpotsApiFp(configuration)
    return {
        /**
         * 
         * @param {SpotsApiApiV1SpotsBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SpotsBulkDeleteDelete(requestParameters: SpotsApiApiV1SpotsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1SpotsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SpotsApiApiV1SpotsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SpotsGetPost(requestParameters: SpotsApiApiV1SpotsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfSpotDto> {
            return localVarFp.apiV1SpotsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.spotGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SpotsApiApiV1SpotsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SpotsPost(requestParameters: SpotsApiApiV1SpotsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpotDto> {
            return localVarFp.apiV1SpotsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createSpotDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SpotsApiApiV1SpotsSpotIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SpotsSpotIdDelete(requestParameters: SpotsApiApiV1SpotsSpotIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1SpotsSpotIdDelete(requestParameters.nexusOpsTenant, requestParameters.spotId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SpotsApiApiV1SpotsSpotIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SpotsSpotIdGet(requestParameters: SpotsApiApiV1SpotsSpotIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpotDto> {
            return localVarFp.apiV1SpotsSpotIdGet(requestParameters.nexusOpsTenant, requestParameters.spotId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SpotsApiApiV1SpotsSpotIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SpotsSpotIdPut(requestParameters: SpotsApiApiV1SpotsSpotIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpotDto> {
            return localVarFp.apiV1SpotsSpotIdPut(requestParameters.nexusOpsTenant, requestParameters.spotId, requestParameters.nexusOpsAppVersion, requestParameters.updateSpotDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SpotsApiApiV1SpotsSpotIdReferenceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SpotsSpotIdReferenceGet(requestParameters: SpotsApiApiV1SpotsSpotIdReferenceGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpotReferenceDto> {
            return localVarFp.apiV1SpotsSpotIdReferenceGet(requestParameters.nexusOpsTenant, requestParameters.spotId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1SpotsBulkDeleteDelete operation in SpotsApi.
 * @export
 * @interface SpotsApiApiV1SpotsBulkDeleteDeleteRequest
 */
export interface SpotsApiApiV1SpotsBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SpotsApiApiV1SpotsBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SpotsApiApiV1SpotsBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof SpotsApiApiV1SpotsBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1SpotsGetPost operation in SpotsApi.
 * @export
 * @interface SpotsApiApiV1SpotsGetPostRequest
 */
export interface SpotsApiApiV1SpotsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SpotsApiApiV1SpotsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SpotsApiApiV1SpotsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {SpotGetPaginatedDto}
     * @memberof SpotsApiApiV1SpotsGetPost
     */
    readonly spotGetPaginatedDto?: SpotGetPaginatedDto
}

/**
 * Request parameters for apiV1SpotsPost operation in SpotsApi.
 * @export
 * @interface SpotsApiApiV1SpotsPostRequest
 */
export interface SpotsApiApiV1SpotsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SpotsApiApiV1SpotsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SpotsApiApiV1SpotsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateSpotDto}
     * @memberof SpotsApiApiV1SpotsPost
     */
    readonly createSpotDto?: CreateSpotDto
}

/**
 * Request parameters for apiV1SpotsSpotIdDelete operation in SpotsApi.
 * @export
 * @interface SpotsApiApiV1SpotsSpotIdDeleteRequest
 */
export interface SpotsApiApiV1SpotsSpotIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SpotsApiApiV1SpotsSpotIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof SpotsApiApiV1SpotsSpotIdDelete
     */
    readonly spotId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SpotsApiApiV1SpotsSpotIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof SpotsApiApiV1SpotsSpotIdDelete
     */
    readonly isDeleteCascade?: boolean
}

/**
 * Request parameters for apiV1SpotsSpotIdGet operation in SpotsApi.
 * @export
 * @interface SpotsApiApiV1SpotsSpotIdGetRequest
 */
export interface SpotsApiApiV1SpotsSpotIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SpotsApiApiV1SpotsSpotIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof SpotsApiApiV1SpotsSpotIdGet
     */
    readonly spotId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SpotsApiApiV1SpotsSpotIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1SpotsSpotIdPut operation in SpotsApi.
 * @export
 * @interface SpotsApiApiV1SpotsSpotIdPutRequest
 */
export interface SpotsApiApiV1SpotsSpotIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SpotsApiApiV1SpotsSpotIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof SpotsApiApiV1SpotsSpotIdPut
     */
    readonly spotId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SpotsApiApiV1SpotsSpotIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateSpotDto}
     * @memberof SpotsApiApiV1SpotsSpotIdPut
     */
    readonly updateSpotDto?: UpdateSpotDto
}

/**
 * Request parameters for apiV1SpotsSpotIdReferenceGet operation in SpotsApi.
 * @export
 * @interface SpotsApiApiV1SpotsSpotIdReferenceGetRequest
 */
export interface SpotsApiApiV1SpotsSpotIdReferenceGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SpotsApiApiV1SpotsSpotIdReferenceGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof SpotsApiApiV1SpotsSpotIdReferenceGet
     */
    readonly spotId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SpotsApiApiV1SpotsSpotIdReferenceGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * SpotsApi - object-oriented interface
 * @export
 * @class SpotsApi
 * @extends {BaseAPI}
 */
export class SpotsApi extends BaseAPI {
    /**
     * 
     * @param {SpotsApiApiV1SpotsBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotsApi
     */
    public apiV1SpotsBulkDeleteDelete(requestParameters: SpotsApiApiV1SpotsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return SpotsApiFp(this.configuration).apiV1SpotsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SpotsApiApiV1SpotsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotsApi
     */
    public apiV1SpotsGetPost(requestParameters: SpotsApiApiV1SpotsGetPostRequest, options?: RawAxiosRequestConfig) {
        return SpotsApiFp(this.configuration).apiV1SpotsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.spotGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SpotsApiApiV1SpotsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotsApi
     */
    public apiV1SpotsPost(requestParameters: SpotsApiApiV1SpotsPostRequest, options?: RawAxiosRequestConfig) {
        return SpotsApiFp(this.configuration).apiV1SpotsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createSpotDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SpotsApiApiV1SpotsSpotIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotsApi
     */
    public apiV1SpotsSpotIdDelete(requestParameters: SpotsApiApiV1SpotsSpotIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SpotsApiFp(this.configuration).apiV1SpotsSpotIdDelete(requestParameters.nexusOpsTenant, requestParameters.spotId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SpotsApiApiV1SpotsSpotIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotsApi
     */
    public apiV1SpotsSpotIdGet(requestParameters: SpotsApiApiV1SpotsSpotIdGetRequest, options?: RawAxiosRequestConfig) {
        return SpotsApiFp(this.configuration).apiV1SpotsSpotIdGet(requestParameters.nexusOpsTenant, requestParameters.spotId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SpotsApiApiV1SpotsSpotIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotsApi
     */
    public apiV1SpotsSpotIdPut(requestParameters: SpotsApiApiV1SpotsSpotIdPutRequest, options?: RawAxiosRequestConfig) {
        return SpotsApiFp(this.configuration).apiV1SpotsSpotIdPut(requestParameters.nexusOpsTenant, requestParameters.spotId, requestParameters.nexusOpsAppVersion, requestParameters.updateSpotDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SpotsApiApiV1SpotsSpotIdReferenceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotsApi
     */
    public apiV1SpotsSpotIdReferenceGet(requestParameters: SpotsApiApiV1SpotsSpotIdReferenceGetRequest, options?: RawAxiosRequestConfig) {
        return SpotsApiFp(this.configuration).apiV1SpotsSpotIdReferenceGet(requestParameters.nexusOpsTenant, requestParameters.spotId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionPlansApi - axios parameter creator
 * @export
 */
export const SubscriptionPlansApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubscriptionsPlansGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SubscriptionsPlansGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/subscriptions/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionPlansApi - functional programming interface
 * @export
 */
export const SubscriptionPlansApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionPlansApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SubscriptionsPlansGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubscriptionPlanDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SubscriptionsPlansGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionPlansApi.apiV1SubscriptionsPlansGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionPlansApi - factory interface
 * @export
 */
export const SubscriptionPlansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionPlansApiFp(configuration)
    return {
        /**
         * 
         * @param {SubscriptionPlansApiApiV1SubscriptionsPlansGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubscriptionsPlansGet(requestParameters: SubscriptionPlansApiApiV1SubscriptionsPlansGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SubscriptionPlanDto>> {
            return localVarFp.apiV1SubscriptionsPlansGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1SubscriptionsPlansGet operation in SubscriptionPlansApi.
 * @export
 * @interface SubscriptionPlansApiApiV1SubscriptionsPlansGetRequest
 */
export interface SubscriptionPlansApiApiV1SubscriptionsPlansGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SubscriptionPlansApiApiV1SubscriptionsPlansGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SubscriptionPlansApiApiV1SubscriptionsPlansGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * SubscriptionPlansApi - object-oriented interface
 * @export
 * @class SubscriptionPlansApi
 * @extends {BaseAPI}
 */
export class SubscriptionPlansApi extends BaseAPI {
    /**
     * 
     * @param {SubscriptionPlansApiApiV1SubscriptionsPlansGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPlansApi
     */
    public apiV1SubscriptionsPlansGet(requestParameters: SubscriptionPlansApiApiV1SubscriptionsPlansGetRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionPlansApiFp(this.configuration).apiV1SubscriptionsPlansGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionPlansAdminApi - axios parameter creator
 * @export
 */
export const SubscriptionPlansAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSubscriptionsPlansGet: async (nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/subscriptions/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateSubscriptionPlanDto} [adminCreateSubscriptionPlanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSubscriptionsPlansPost: async (nexusOpsAppVersion?: string, adminCreateSubscriptionPlanDto?: AdminCreateSubscriptionPlanDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/subscriptions/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateSubscriptionPlanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSubscriptionsPlansSubscriptionPlanIdDelete: async (subscriptionPlanId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionPlanId' is not null or undefined
            assertParamExists('apiV1AdminSubscriptionsPlansSubscriptionPlanIdDelete', 'subscriptionPlanId', subscriptionPlanId)
            const localVarPath = `/api/v1/admin/subscriptions/plans/{subscriptionPlanId}`
                .replace(`{${"subscriptionPlanId"}}`, encodeURIComponent(String(subscriptionPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSubscriptionsPlansSubscriptionPlanIdGet: async (subscriptionPlanId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionPlanId' is not null or undefined
            assertParamExists('apiV1AdminSubscriptionsPlansSubscriptionPlanIdGet', 'subscriptionPlanId', subscriptionPlanId)
            const localVarPath = `/api/v1/admin/subscriptions/plans/{subscriptionPlanId}`
                .replace(`{${"subscriptionPlanId"}}`, encodeURIComponent(String(subscriptionPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateSubscriptionPlanDto} [adminUpdateSubscriptionPlanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSubscriptionsPlansSubscriptionPlanIdPut: async (subscriptionPlanId: string, nexusOpsAppVersion?: string, adminUpdateSubscriptionPlanDto?: AdminUpdateSubscriptionPlanDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionPlanId' is not null or undefined
            assertParamExists('apiV1AdminSubscriptionsPlansSubscriptionPlanIdPut', 'subscriptionPlanId', subscriptionPlanId)
            const localVarPath = `/api/v1/admin/subscriptions/plans/{subscriptionPlanId}`
                .replace(`{${"subscriptionPlanId"}}`, encodeURIComponent(String(subscriptionPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateSubscriptionPlanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionPlansAdminApi - functional programming interface
 * @export
 */
export const SubscriptionPlansAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionPlansAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminSubscriptionsPlansGet(nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminSubscriptionPlanDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSubscriptionsPlansGet(nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionPlansAdminApi.apiV1AdminSubscriptionsPlansGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateSubscriptionPlanDto} [adminCreateSubscriptionPlanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminSubscriptionsPlansPost(nexusOpsAppVersion?: string, adminCreateSubscriptionPlanDto?: AdminCreateSubscriptionPlanDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSubscriptionPlanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSubscriptionsPlansPost(nexusOpsAppVersion, adminCreateSubscriptionPlanDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionPlansAdminApi.apiV1AdminSubscriptionsPlansPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminSubscriptionsPlansSubscriptionPlanIdDelete(subscriptionPlanId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSubscriptionsPlansSubscriptionPlanIdDelete(subscriptionPlanId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionPlansAdminApi.apiV1AdminSubscriptionsPlansSubscriptionPlanIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminSubscriptionsPlansSubscriptionPlanIdGet(subscriptionPlanId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSubscriptionPlanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSubscriptionsPlansSubscriptionPlanIdGet(subscriptionPlanId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionPlansAdminApi.apiV1AdminSubscriptionsPlansSubscriptionPlanIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subscriptionPlanId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateSubscriptionPlanDto} [adminUpdateSubscriptionPlanDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminSubscriptionsPlansSubscriptionPlanIdPut(subscriptionPlanId: string, nexusOpsAppVersion?: string, adminUpdateSubscriptionPlanDto?: AdminUpdateSubscriptionPlanDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSubscriptionPlanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSubscriptionsPlansSubscriptionPlanIdPut(subscriptionPlanId, nexusOpsAppVersion, adminUpdateSubscriptionPlanDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionPlansAdminApi.apiV1AdminSubscriptionsPlansSubscriptionPlanIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionPlansAdminApi - factory interface
 * @export
 */
export const SubscriptionPlansAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionPlansAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSubscriptionsPlansGet(requestParameters: SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminSubscriptionPlanDto>> {
            return localVarFp.apiV1AdminSubscriptionsPlansGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSubscriptionsPlansPost(requestParameters: SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminSubscriptionPlanDto> {
            return localVarFp.apiV1AdminSubscriptionsPlansPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateSubscriptionPlanDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSubscriptionsPlansSubscriptionPlanIdDelete(requestParameters: SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminSubscriptionsPlansSubscriptionPlanIdDelete(requestParameters.subscriptionPlanId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSubscriptionsPlansSubscriptionPlanIdGet(requestParameters: SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSubscriptionPlanDto> {
            return localVarFp.apiV1AdminSubscriptionsPlansSubscriptionPlanIdGet(requestParameters.subscriptionPlanId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSubscriptionsPlansSubscriptionPlanIdPut(requestParameters: SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSubscriptionPlanDto> {
            return localVarFp.apiV1AdminSubscriptionsPlansSubscriptionPlanIdPut(requestParameters.subscriptionPlanId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateSubscriptionPlanDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminSubscriptionsPlansGet operation in SubscriptionPlansAdminApi.
 * @export
 * @interface SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansGetRequest
 */
export interface SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminSubscriptionsPlansPost operation in SubscriptionPlansAdminApi.
 * @export
 * @interface SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansPostRequest
 */
export interface SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateSubscriptionPlanDto}
     * @memberof SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansPost
     */
    readonly adminCreateSubscriptionPlanDto?: AdminCreateSubscriptionPlanDto
}

/**
 * Request parameters for apiV1AdminSubscriptionsPlansSubscriptionPlanIdDelete operation in SubscriptionPlansAdminApi.
 * @export
 * @interface SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdDeleteRequest
 */
export interface SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdDelete
     */
    readonly subscriptionPlanId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminSubscriptionsPlansSubscriptionPlanIdGet operation in SubscriptionPlansAdminApi.
 * @export
 * @interface SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdGetRequest
 */
export interface SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdGet
     */
    readonly subscriptionPlanId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminSubscriptionsPlansSubscriptionPlanIdPut operation in SubscriptionPlansAdminApi.
 * @export
 * @interface SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdPutRequest
 */
export interface SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdPut
     */
    readonly subscriptionPlanId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUpdateSubscriptionPlanDto}
     * @memberof SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdPut
     */
    readonly adminUpdateSubscriptionPlanDto?: AdminUpdateSubscriptionPlanDto
}

/**
 * SubscriptionPlansAdminApi - object-oriented interface
 * @export
 * @class SubscriptionPlansAdminApi
 * @extends {BaseAPI}
 */
export class SubscriptionPlansAdminApi extends BaseAPI {
    /**
     * 
     * @param {SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPlansAdminApi
     */
    public apiV1AdminSubscriptionsPlansGet(requestParameters: SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansGetRequest = {}, options?: RawAxiosRequestConfig) {
        return SubscriptionPlansAdminApiFp(this.configuration).apiV1AdminSubscriptionsPlansGet(requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPlansAdminApi
     */
    public apiV1AdminSubscriptionsPlansPost(requestParameters: SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansPostRequest = {}, options?: RawAxiosRequestConfig) {
        return SubscriptionPlansAdminApiFp(this.configuration).apiV1AdminSubscriptionsPlansPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateSubscriptionPlanDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPlansAdminApi
     */
    public apiV1AdminSubscriptionsPlansSubscriptionPlanIdDelete(requestParameters: SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionPlansAdminApiFp(this.configuration).apiV1AdminSubscriptionsPlansSubscriptionPlanIdDelete(requestParameters.subscriptionPlanId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPlansAdminApi
     */
    public apiV1AdminSubscriptionsPlansSubscriptionPlanIdGet(requestParameters: SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdGetRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionPlansAdminApiFp(this.configuration).apiV1AdminSubscriptionsPlansSubscriptionPlanIdGet(requestParameters.subscriptionPlanId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPlansAdminApi
     */
    public apiV1AdminSubscriptionsPlansSubscriptionPlanIdPut(requestParameters: SubscriptionPlansAdminApiApiV1AdminSubscriptionsPlansSubscriptionPlanIdPutRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionPlansAdminApiFp(this.configuration).apiV1AdminSubscriptionsPlansSubscriptionPlanIdPut(requestParameters.subscriptionPlanId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateSubscriptionPlanDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionsApi - axios parameter creator
 * @export
 */
export const SubscriptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubscriptionsCurrentGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SubscriptionsCurrentGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/subscriptions/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SubscriptionGetPaginatedDto} [subscriptionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubscriptionsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, subscriptionGetPaginatedDto?: SubscriptionGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SubscriptionsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/subscriptions/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionsApi - functional programming interface
 * @export
 */
export const SubscriptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SubscriptionsCurrentGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SubscriptionsCurrentGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.apiV1SubscriptionsCurrentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SubscriptionGetPaginatedDto} [subscriptionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SubscriptionsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, subscriptionGetPaginatedDto?: SubscriptionGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SubscriptionsGetPost(nexusOpsTenant, nexusOpsAppVersion, subscriptionGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.apiV1SubscriptionsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionsApi - factory interface
 * @export
 */
export const SubscriptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionsApiFp(configuration)
    return {
        /**
         * 
         * @param {SubscriptionsApiApiV1SubscriptionsCurrentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubscriptionsCurrentGet(requestParameters: SubscriptionsApiApiV1SubscriptionsCurrentGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionDto> {
            return localVarFp.apiV1SubscriptionsCurrentGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscriptionsApiApiV1SubscriptionsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubscriptionsGetPost(requestParameters: SubscriptionsApiApiV1SubscriptionsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfSubscriptionDto> {
            return localVarFp.apiV1SubscriptionsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.subscriptionGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1SubscriptionsCurrentGet operation in SubscriptionsApi.
 * @export
 * @interface SubscriptionsApiApiV1SubscriptionsCurrentGetRequest
 */
export interface SubscriptionsApiApiV1SubscriptionsCurrentGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SubscriptionsApiApiV1SubscriptionsCurrentGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SubscriptionsApiApiV1SubscriptionsCurrentGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1SubscriptionsGetPost operation in SubscriptionsApi.
 * @export
 * @interface SubscriptionsApiApiV1SubscriptionsGetPostRequest
 */
export interface SubscriptionsApiApiV1SubscriptionsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SubscriptionsApiApiV1SubscriptionsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SubscriptionsApiApiV1SubscriptionsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {SubscriptionGetPaginatedDto}
     * @memberof SubscriptionsApiApiV1SubscriptionsGetPost
     */
    readonly subscriptionGetPaginatedDto?: SubscriptionGetPaginatedDto
}

/**
 * SubscriptionsApi - object-oriented interface
 * @export
 * @class SubscriptionsApi
 * @extends {BaseAPI}
 */
export class SubscriptionsApi extends BaseAPI {
    /**
     * 
     * @param {SubscriptionsApiApiV1SubscriptionsCurrentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public apiV1SubscriptionsCurrentGet(requestParameters: SubscriptionsApiApiV1SubscriptionsCurrentGetRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).apiV1SubscriptionsCurrentGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscriptionsApiApiV1SubscriptionsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public apiV1SubscriptionsGetPost(requestParameters: SubscriptionsApiApiV1SubscriptionsGetPostRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).apiV1SubscriptionsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.subscriptionGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionsAdminApi - axios parameter creator
 * @export
 */
export const SubscriptionsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminSubscriptionGetPaginatedDto} [adminSubscriptionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSubscriptionsGetPost: async (nexusOpsAppVersion?: string, adminSubscriptionGetPaginatedDto?: AdminSubscriptionGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/subscriptions/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSubscriptionGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionsAdminApi - functional programming interface
 * @export
 */
export const SubscriptionsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminSubscriptionGetPaginatedDto} [adminSubscriptionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminSubscriptionsGetPost(nexusOpsAppVersion?: string, adminSubscriptionGetPaginatedDto?: AdminSubscriptionGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSubscriptionsGetPost(nexusOpsAppVersion, adminSubscriptionGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsAdminApi.apiV1AdminSubscriptionsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionsAdminApi - factory interface
 * @export
 */
export const SubscriptionsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {SubscriptionsAdminApiApiV1AdminSubscriptionsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSubscriptionsGetPost(requestParameters: SubscriptionsAdminApiApiV1AdminSubscriptionsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminSubscriptionDto> {
            return localVarFp.apiV1AdminSubscriptionsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminSubscriptionGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminSubscriptionsGetPost operation in SubscriptionsAdminApi.
 * @export
 * @interface SubscriptionsAdminApiApiV1AdminSubscriptionsGetPostRequest
 */
export interface SubscriptionsAdminApiApiV1AdminSubscriptionsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SubscriptionsAdminApiApiV1AdminSubscriptionsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminSubscriptionGetPaginatedDto}
     * @memberof SubscriptionsAdminApiApiV1AdminSubscriptionsGetPost
     */
    readonly adminSubscriptionGetPaginatedDto?: AdminSubscriptionGetPaginatedDto
}

/**
 * SubscriptionsAdminApi - object-oriented interface
 * @export
 * @class SubscriptionsAdminApi
 * @extends {BaseAPI}
 */
export class SubscriptionsAdminApi extends BaseAPI {
    /**
     * 
     * @param {SubscriptionsAdminApiApiV1AdminSubscriptionsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsAdminApi
     */
    public apiV1AdminSubscriptionsGetPost(requestParameters: SubscriptionsAdminApiApiV1AdminSubscriptionsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return SubscriptionsAdminApiFp(this.configuration).apiV1AdminSubscriptionsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminSubscriptionGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SuppliersApi - axios parameter creator
 * @export
 */
export const SuppliersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SuppliersBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/suppliers/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SupplierGetPaginatedDto} [supplierGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, supplierGetPaginatedDto?: SupplierGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SuppliersGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/suppliers/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supplierGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateSupplierDto} [createSupplierDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createSupplierDto?: CreateSupplierDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SuppliersPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSupplierDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} supplierId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersSupplierIdDelete: async (nexusOpsTenant: string, supplierId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SuppliersSupplierIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('apiV1SuppliersSupplierIdDelete', 'supplierId', supplierId)
            const localVarPath = `/api/v1/suppliers/{supplierId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} supplierId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersSupplierIdGet: async (nexusOpsTenant: string, supplierId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SuppliersSupplierIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('apiV1SuppliersSupplierIdGet', 'supplierId', supplierId)
            const localVarPath = `/api/v1/suppliers/{supplierId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} supplierId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateSupplierDto} [updateSupplierDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersSupplierIdPut: async (nexusOpsTenant: string, supplierId: string, nexusOpsAppVersion?: string, updateSupplierDto?: UpdateSupplierDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1SuppliersSupplierIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('apiV1SuppliersSupplierIdPut', 'supplierId', supplierId)
            const localVarPath = `/api/v1/suppliers/{supplierId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSupplierDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuppliersApi - functional programming interface
 * @export
 */
export const SuppliersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuppliersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SuppliersBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SuppliersBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuppliersApi.apiV1SuppliersBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {SupplierGetPaginatedDto} [supplierGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SuppliersGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, supplierGetPaginatedDto?: SupplierGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfSupplierDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SuppliersGetPost(nexusOpsTenant, nexusOpsAppVersion, supplierGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuppliersApi.apiV1SuppliersGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateSupplierDto} [createSupplierDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SuppliersPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createSupplierDto?: CreateSupplierDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SuppliersPost(nexusOpsTenant, nexusOpsAppVersion, createSupplierDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuppliersApi.apiV1SuppliersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} supplierId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SuppliersSupplierIdDelete(nexusOpsTenant: string, supplierId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SuppliersSupplierIdDelete(nexusOpsTenant, supplierId, nexusOpsAppVersion, isDeleteCascade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuppliersApi.apiV1SuppliersSupplierIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} supplierId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SuppliersSupplierIdGet(nexusOpsTenant: string, supplierId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SuppliersSupplierIdGet(nexusOpsTenant, supplierId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuppliersApi.apiV1SuppliersSupplierIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} supplierId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateSupplierDto} [updateSupplierDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SuppliersSupplierIdPut(nexusOpsTenant: string, supplierId: string, nexusOpsAppVersion?: string, updateSupplierDto?: UpdateSupplierDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SuppliersSupplierIdPut(nexusOpsTenant, supplierId, nexusOpsAppVersion, updateSupplierDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuppliersApi.apiV1SuppliersSupplierIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SuppliersApi - factory interface
 * @export
 */
export const SuppliersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuppliersApiFp(configuration)
    return {
        /**
         * 
         * @param {SuppliersApiApiV1SuppliersBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersBulkDeleteDelete(requestParameters: SuppliersApiApiV1SuppliersBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1SuppliersBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SuppliersApiApiV1SuppliersGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersGetPost(requestParameters: SuppliersApiApiV1SuppliersGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfSupplierDto> {
            return localVarFp.apiV1SuppliersGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.supplierGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SuppliersApiApiV1SuppliersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersPost(requestParameters: SuppliersApiApiV1SuppliersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierDto> {
            return localVarFp.apiV1SuppliersPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createSupplierDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SuppliersApiApiV1SuppliersSupplierIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersSupplierIdDelete(requestParameters: SuppliersApiApiV1SuppliersSupplierIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1SuppliersSupplierIdDelete(requestParameters.nexusOpsTenant, requestParameters.supplierId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SuppliersApiApiV1SuppliersSupplierIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersSupplierIdGet(requestParameters: SuppliersApiApiV1SuppliersSupplierIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierDto> {
            return localVarFp.apiV1SuppliersSupplierIdGet(requestParameters.nexusOpsTenant, requestParameters.supplierId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SuppliersApiApiV1SuppliersSupplierIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersSupplierIdPut(requestParameters: SuppliersApiApiV1SuppliersSupplierIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupplierDto> {
            return localVarFp.apiV1SuppliersSupplierIdPut(requestParameters.nexusOpsTenant, requestParameters.supplierId, requestParameters.nexusOpsAppVersion, requestParameters.updateSupplierDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1SuppliersBulkDeleteDelete operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiV1SuppliersBulkDeleteDeleteRequest
 */
export interface SuppliersApiApiV1SuppliersBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof SuppliersApiApiV1SuppliersBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1SuppliersGetPost operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiV1SuppliersGetPostRequest
 */
export interface SuppliersApiApiV1SuppliersGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {SupplierGetPaginatedDto}
     * @memberof SuppliersApiApiV1SuppliersGetPost
     */
    readonly supplierGetPaginatedDto?: SupplierGetPaginatedDto
}

/**
 * Request parameters for apiV1SuppliersPost operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiV1SuppliersPostRequest
 */
export interface SuppliersApiApiV1SuppliersPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateSupplierDto}
     * @memberof SuppliersApiApiV1SuppliersPost
     */
    readonly createSupplierDto?: CreateSupplierDto
}

/**
 * Request parameters for apiV1SuppliersSupplierIdDelete operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiV1SuppliersSupplierIdDeleteRequest
 */
export interface SuppliersApiApiV1SuppliersSupplierIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersSupplierIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersSupplierIdDelete
     */
    readonly supplierId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersSupplierIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof SuppliersApiApiV1SuppliersSupplierIdDelete
     */
    readonly isDeleteCascade?: boolean
}

/**
 * Request parameters for apiV1SuppliersSupplierIdGet operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiV1SuppliersSupplierIdGetRequest
 */
export interface SuppliersApiApiV1SuppliersSupplierIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersSupplierIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersSupplierIdGet
     */
    readonly supplierId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersSupplierIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1SuppliersSupplierIdPut operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiV1SuppliersSupplierIdPutRequest
 */
export interface SuppliersApiApiV1SuppliersSupplierIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersSupplierIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersSupplierIdPut
     */
    readonly supplierId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SuppliersApiApiV1SuppliersSupplierIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateSupplierDto}
     * @memberof SuppliersApiApiV1SuppliersSupplierIdPut
     */
    readonly updateSupplierDto?: UpdateSupplierDto
}

/**
 * SuppliersApi - object-oriented interface
 * @export
 * @class SuppliersApi
 * @extends {BaseAPI}
 */
export class SuppliersApi extends BaseAPI {
    /**
     * 
     * @param {SuppliersApiApiV1SuppliersBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiV1SuppliersBulkDeleteDelete(requestParameters: SuppliersApiApiV1SuppliersBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiV1SuppliersBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiV1SuppliersGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiV1SuppliersGetPost(requestParameters: SuppliersApiApiV1SuppliersGetPostRequest, options?: RawAxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiV1SuppliersGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.supplierGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiV1SuppliersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiV1SuppliersPost(requestParameters: SuppliersApiApiV1SuppliersPostRequest, options?: RawAxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiV1SuppliersPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createSupplierDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiV1SuppliersSupplierIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiV1SuppliersSupplierIdDelete(requestParameters: SuppliersApiApiV1SuppliersSupplierIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiV1SuppliersSupplierIdDelete(requestParameters.nexusOpsTenant, requestParameters.supplierId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiV1SuppliersSupplierIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiV1SuppliersSupplierIdGet(requestParameters: SuppliersApiApiV1SuppliersSupplierIdGetRequest, options?: RawAxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiV1SuppliersSupplierIdGet(requestParameters.nexusOpsTenant, requestParameters.supplierId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiV1SuppliersSupplierIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiV1SuppliersSupplierIdPut(requestParameters: SuppliersApiApiV1SuppliersSupplierIdPutRequest, options?: RawAxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiV1SuppliersSupplierIdPut(requestParameters.nexusOpsTenant, requestParameters.supplierId, requestParameters.nexusOpsAppVersion, requestParameters.updateSupplierDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemCacheAdminApi - axios parameter creator
 * @export
 */
export const SystemCacheAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminClearCacheDto} [adminClearCacheDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSystemCacheClearDelete: async (nexusOpsAppVersion?: string, adminClearCacheDto?: AdminClearCacheDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/system/cache/clear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminClearCacheDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemCacheAdminApi - functional programming interface
 * @export
 */
export const SystemCacheAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemCacheAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminClearCacheDto} [adminClearCacheDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminSystemCacheClearDelete(nexusOpsAppVersion?: string, adminClearCacheDto?: AdminClearCacheDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSystemCacheClearDelete(nexusOpsAppVersion, adminClearCacheDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemCacheAdminApi.apiV1AdminSystemCacheClearDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SystemCacheAdminApi - factory interface
 * @export
 */
export const SystemCacheAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemCacheAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {SystemCacheAdminApiApiV1AdminSystemCacheClearDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminSystemCacheClearDelete(requestParameters: SystemCacheAdminApiApiV1AdminSystemCacheClearDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminSystemCacheClearDelete(requestParameters.nexusOpsAppVersion, requestParameters.adminClearCacheDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminSystemCacheClearDelete operation in SystemCacheAdminApi.
 * @export
 * @interface SystemCacheAdminApiApiV1AdminSystemCacheClearDeleteRequest
 */
export interface SystemCacheAdminApiApiV1AdminSystemCacheClearDeleteRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof SystemCacheAdminApiApiV1AdminSystemCacheClearDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminClearCacheDto}
     * @memberof SystemCacheAdminApiApiV1AdminSystemCacheClearDelete
     */
    readonly adminClearCacheDto?: AdminClearCacheDto
}

/**
 * SystemCacheAdminApi - object-oriented interface
 * @export
 * @class SystemCacheAdminApi
 * @extends {BaseAPI}
 */
export class SystemCacheAdminApi extends BaseAPI {
    /**
     * 
     * @param {SystemCacheAdminApiApiV1AdminSystemCacheClearDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemCacheAdminApi
     */
    public apiV1AdminSystemCacheClearDelete(requestParameters: SystemCacheAdminApiApiV1AdminSystemCacheClearDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return SystemCacheAdminApiFp(this.configuration).apiV1AdminSystemCacheClearDelete(requestParameters.nexusOpsAppVersion, requestParameters.adminClearCacheDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantAccountApi - axios parameter creator
 * @export
 */
export const TenantAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountPermissionsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantAccountPermissionsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant/account/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [targetUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRoleAssignmentsRestrictionsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, targetUserId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantAccountRoleAssignmentsRestrictionsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant/account/role-assignments/restrictions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (targetUserId !== undefined) {
                localVarQueryParameter['targetUserId'] = targetUserId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [roleIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRolesByIdsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, roleIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantAccountRolesByIdsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant/account/roles/by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (roleIds) {
                localVarQueryParameter['roleIds'] = roleIds;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [sortBy] Comma-separated list of fields to sort by.
         * @param {string} [sortOrder] Comma-separated list of sort orders, with indexes corresponding to fields.  See values in SortOrder enum.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRolesGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantAccountRolesGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant/account/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateTenantRoleDto} [createTenantRoleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRolesPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createTenantRoleDto?: CreateTenantRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantAccountRolesPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant/account/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTenantRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRolesRoleIdDelete: async (nexusOpsTenant: string, roleId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantAccountRolesRoleIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiV1TenantAccountRolesRoleIdDelete', 'roleId', roleId)
            const localVarPath = `/api/v1/tenant/account/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRolesRoleIdGet: async (nexusOpsTenant: string, roleId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantAccountRolesRoleIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiV1TenantAccountRolesRoleIdGet', 'roleId', roleId)
            const localVarPath = `/api/v1/tenant/account/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRolesRoleIdPermissionsGet: async (nexusOpsTenant: string, roleId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantAccountRolesRoleIdPermissionsGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiV1TenantAccountRolesRoleIdPermissionsGet', 'roleId', roleId)
            const localVarPath = `/api/v1/tenant/account/roles/{roleId}/permissions`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateTenantRoleDto} [updateTenantRoleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRolesRoleIdPut: async (nexusOpsTenant: string, roleId: string, nexusOpsAppVersion?: string, updateTenantRoleDto?: UpdateTenantRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantAccountRolesRoleIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiV1TenantAccountRolesRoleIdPut', 'roleId', roleId)
            const localVarPath = `/api/v1/tenant/account/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTenantRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateUserRolesDto} [updateUserRolesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountUsersUserIdRolesPut: async (nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, updateUserRolesDto?: UpdateUserRolesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantAccountUsersUserIdRolesPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1TenantAccountUsersUserIdRolesPut', 'userId', userId)
            const localVarPath = `/api/v1/tenant/account/users/{userId}/roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRolesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantAccountApi - functional programming interface
 * @export
 */
export const TenantAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantAccountPermissionsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionMetaDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantAccountPermissionsGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantAccountApi.apiV1TenantAccountPermissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [targetUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantAccountRoleAssignmentsRestrictionsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, targetUserId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleAssignmentRestrictionsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantAccountRoleAssignmentsRestrictionsGet(nexusOpsTenant, nexusOpsAppVersion, targetUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantAccountApi.apiV1TenantAccountRoleAssignmentsRestrictionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [roleIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantAccountRolesByIdsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, roleIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantAccountRolesByIdsGet(nexusOpsTenant, nexusOpsAppVersion, roleIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantAccountApi.apiV1TenantAccountRolesByIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [sortBy] Comma-separated list of fields to sort by.
         * @param {string} [sortOrder] Comma-separated list of sort orders, with indexes corresponding to fields.  See values in SortOrder enum.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantAccountRolesGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantAccountRolesGet(nexusOpsTenant, nexusOpsAppVersion, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantAccountApi.apiV1TenantAccountRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateTenantRoleDto} [createTenantRoleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantAccountRolesPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createTenantRoleDto?: CreateTenantRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantAccountRolesPost(nexusOpsTenant, nexusOpsAppVersion, createTenantRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantAccountApi.apiV1TenantAccountRolesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantAccountRolesRoleIdDelete(nexusOpsTenant: string, roleId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantAccountRolesRoleIdDelete(nexusOpsTenant, roleId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantAccountApi.apiV1TenantAccountRolesRoleIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantAccountRolesRoleIdGet(nexusOpsTenant: string, roleId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantAccountRolesRoleIdGet(nexusOpsTenant, roleId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantAccountApi.apiV1TenantAccountRolesRoleIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantAccountRolesRoleIdPermissionsGet(nexusOpsTenant: string, roleId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionMetaDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantAccountRolesRoleIdPermissionsGet(nexusOpsTenant, roleId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantAccountApi.apiV1TenantAccountRolesRoleIdPermissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} roleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateTenantRoleDto} [updateTenantRoleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantAccountRolesRoleIdPut(nexusOpsTenant: string, roleId: string, nexusOpsAppVersion?: string, updateTenantRoleDto?: UpdateTenantRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantAccountRolesRoleIdPut(nexusOpsTenant, roleId, nexusOpsAppVersion, updateTenantRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantAccountApi.apiV1TenantAccountRolesRoleIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateUserRolesDto} [updateUserRolesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantAccountUsersUserIdRolesPut(nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, updateUserRolesDto?: UpdateUserRolesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantAccountUsersUserIdRolesPut(nexusOpsTenant, userId, nexusOpsAppVersion, updateUserRolesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantAccountApi.apiV1TenantAccountUsersUserIdRolesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantAccountApi - factory interface
 * @export
 */
export const TenantAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantAccountApiFp(configuration)
    return {
        /**
         * 
         * @param {TenantAccountApiApiV1TenantAccountPermissionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountPermissionsGet(requestParameters: TenantAccountApiApiV1TenantAccountPermissionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PermissionMetaDto>> {
            return localVarFp.apiV1TenantAccountPermissionsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantAccountApiApiV1TenantAccountRoleAssignmentsRestrictionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRoleAssignmentsRestrictionsGet(requestParameters: TenantAccountApiApiV1TenantAccountRoleAssignmentsRestrictionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RoleAssignmentRestrictionsDto> {
            return localVarFp.apiV1TenantAccountRoleAssignmentsRestrictionsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.targetUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantAccountApiApiV1TenantAccountRolesByIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRolesByIdsGet(requestParameters: TenantAccountApiApiV1TenantAccountRolesByIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleDto>> {
            return localVarFp.apiV1TenantAccountRolesByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.roleIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantAccountApiApiV1TenantAccountRolesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRolesGet(requestParameters: TenantAccountApiApiV1TenantAccountRolesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleDto>> {
            return localVarFp.apiV1TenantAccountRolesGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantAccountApiApiV1TenantAccountRolesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRolesPost(requestParameters: TenantAccountApiApiV1TenantAccountRolesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RoleDto> {
            return localVarFp.apiV1TenantAccountRolesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createTenantRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantAccountApiApiV1TenantAccountRolesRoleIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRolesRoleIdDelete(requestParameters: TenantAccountApiApiV1TenantAccountRolesRoleIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1TenantAccountRolesRoleIdDelete(requestParameters.nexusOpsTenant, requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantAccountApiApiV1TenantAccountRolesRoleIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRolesRoleIdGet(requestParameters: TenantAccountApiApiV1TenantAccountRolesRoleIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RoleDto> {
            return localVarFp.apiV1TenantAccountRolesRoleIdGet(requestParameters.nexusOpsTenant, requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantAccountApiApiV1TenantAccountRolesRoleIdPermissionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRolesRoleIdPermissionsGet(requestParameters: TenantAccountApiApiV1TenantAccountRolesRoleIdPermissionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PermissionMetaDto>> {
            return localVarFp.apiV1TenantAccountRolesRoleIdPermissionsGet(requestParameters.nexusOpsTenant, requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantAccountApiApiV1TenantAccountRolesRoleIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountRolesRoleIdPut(requestParameters: TenantAccountApiApiV1TenantAccountRolesRoleIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<RoleDto> {
            return localVarFp.apiV1TenantAccountRolesRoleIdPut(requestParameters.nexusOpsTenant, requestParameters.roleId, requestParameters.nexusOpsAppVersion, requestParameters.updateTenantRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantAccountApiApiV1TenantAccountUsersUserIdRolesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantAccountUsersUserIdRolesPut(requestParameters: TenantAccountApiApiV1TenantAccountUsersUserIdRolesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1TenantAccountUsersUserIdRolesPut(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, requestParameters.updateUserRolesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1TenantAccountPermissionsGet operation in TenantAccountApi.
 * @export
 * @interface TenantAccountApiApiV1TenantAccountPermissionsGetRequest
 */
export interface TenantAccountApiApiV1TenantAccountPermissionsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountPermissionsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountPermissionsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantAccountRoleAssignmentsRestrictionsGet operation in TenantAccountApi.
 * @export
 * @interface TenantAccountApiApiV1TenantAccountRoleAssignmentsRestrictionsGetRequest
 */
export interface TenantAccountApiApiV1TenantAccountRoleAssignmentsRestrictionsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRoleAssignmentsRestrictionsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRoleAssignmentsRestrictionsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRoleAssignmentsRestrictionsGet
     */
    readonly targetUserId?: string
}

/**
 * Request parameters for apiV1TenantAccountRolesByIdsGet operation in TenantAccountApi.
 * @export
 * @interface TenantAccountApiApiV1TenantAccountRolesByIdsGetRequest
 */
export interface TenantAccountApiApiV1TenantAccountRolesByIdsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesByIdsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesByIdsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof TenantAccountApiApiV1TenantAccountRolesByIdsGet
     */
    readonly roleIds?: Array<string>
}

/**
 * Request parameters for apiV1TenantAccountRolesGet operation in TenantAccountApi.
 * @export
 * @interface TenantAccountApiApiV1TenantAccountRolesGetRequest
 */
export interface TenantAccountApiApiV1TenantAccountRolesGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * Comma-separated list of fields to sort by.
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesGet
     */
    readonly sortBy?: string

    /**
     * Comma-separated list of sort orders, with indexes corresponding to fields.  See values in SortOrder enum.
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesGet
     */
    readonly sortOrder?: string
}

/**
 * Request parameters for apiV1TenantAccountRolesPost operation in TenantAccountApi.
 * @export
 * @interface TenantAccountApiApiV1TenantAccountRolesPostRequest
 */
export interface TenantAccountApiApiV1TenantAccountRolesPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateTenantRoleDto}
     * @memberof TenantAccountApiApiV1TenantAccountRolesPost
     */
    readonly createTenantRoleDto?: CreateTenantRoleDto
}

/**
 * Request parameters for apiV1TenantAccountRolesRoleIdDelete operation in TenantAccountApi.
 * @export
 * @interface TenantAccountApiApiV1TenantAccountRolesRoleIdDeleteRequest
 */
export interface TenantAccountApiApiV1TenantAccountRolesRoleIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesRoleIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesRoleIdDelete
     */
    readonly roleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesRoleIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantAccountRolesRoleIdGet operation in TenantAccountApi.
 * @export
 * @interface TenantAccountApiApiV1TenantAccountRolesRoleIdGetRequest
 */
export interface TenantAccountApiApiV1TenantAccountRolesRoleIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesRoleIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesRoleIdGet
     */
    readonly roleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesRoleIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantAccountRolesRoleIdPermissionsGet operation in TenantAccountApi.
 * @export
 * @interface TenantAccountApiApiV1TenantAccountRolesRoleIdPermissionsGetRequest
 */
export interface TenantAccountApiApiV1TenantAccountRolesRoleIdPermissionsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesRoleIdPermissionsGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesRoleIdPermissionsGet
     */
    readonly roleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesRoleIdPermissionsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantAccountRolesRoleIdPut operation in TenantAccountApi.
 * @export
 * @interface TenantAccountApiApiV1TenantAccountRolesRoleIdPutRequest
 */
export interface TenantAccountApiApiV1TenantAccountRolesRoleIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesRoleIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesRoleIdPut
     */
    readonly roleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountRolesRoleIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateTenantRoleDto}
     * @memberof TenantAccountApiApiV1TenantAccountRolesRoleIdPut
     */
    readonly updateTenantRoleDto?: UpdateTenantRoleDto
}

/**
 * Request parameters for apiV1TenantAccountUsersUserIdRolesPut operation in TenantAccountApi.
 * @export
 * @interface TenantAccountApiApiV1TenantAccountUsersUserIdRolesPutRequest
 */
export interface TenantAccountApiApiV1TenantAccountUsersUserIdRolesPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountUsersUserIdRolesPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountUsersUserIdRolesPut
     */
    readonly userId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantAccountApiApiV1TenantAccountUsersUserIdRolesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateUserRolesDto}
     * @memberof TenantAccountApiApiV1TenantAccountUsersUserIdRolesPut
     */
    readonly updateUserRolesDto?: UpdateUserRolesDto
}

/**
 * TenantAccountApi - object-oriented interface
 * @export
 * @class TenantAccountApi
 * @extends {BaseAPI}
 */
export class TenantAccountApi extends BaseAPI {
    /**
     * 
     * @param {TenantAccountApiApiV1TenantAccountPermissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantAccountApi
     */
    public apiV1TenantAccountPermissionsGet(requestParameters: TenantAccountApiApiV1TenantAccountPermissionsGetRequest, options?: RawAxiosRequestConfig) {
        return TenantAccountApiFp(this.configuration).apiV1TenantAccountPermissionsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantAccountApiApiV1TenantAccountRoleAssignmentsRestrictionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantAccountApi
     */
    public apiV1TenantAccountRoleAssignmentsRestrictionsGet(requestParameters: TenantAccountApiApiV1TenantAccountRoleAssignmentsRestrictionsGetRequest, options?: RawAxiosRequestConfig) {
        return TenantAccountApiFp(this.configuration).apiV1TenantAccountRoleAssignmentsRestrictionsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.targetUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantAccountApiApiV1TenantAccountRolesByIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantAccountApi
     */
    public apiV1TenantAccountRolesByIdsGet(requestParameters: TenantAccountApiApiV1TenantAccountRolesByIdsGetRequest, options?: RawAxiosRequestConfig) {
        return TenantAccountApiFp(this.configuration).apiV1TenantAccountRolesByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.roleIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantAccountApiApiV1TenantAccountRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantAccountApi
     */
    public apiV1TenantAccountRolesGet(requestParameters: TenantAccountApiApiV1TenantAccountRolesGetRequest, options?: RawAxiosRequestConfig) {
        return TenantAccountApiFp(this.configuration).apiV1TenantAccountRolesGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantAccountApiApiV1TenantAccountRolesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantAccountApi
     */
    public apiV1TenantAccountRolesPost(requestParameters: TenantAccountApiApiV1TenantAccountRolesPostRequest, options?: RawAxiosRequestConfig) {
        return TenantAccountApiFp(this.configuration).apiV1TenantAccountRolesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createTenantRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantAccountApiApiV1TenantAccountRolesRoleIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantAccountApi
     */
    public apiV1TenantAccountRolesRoleIdDelete(requestParameters: TenantAccountApiApiV1TenantAccountRolesRoleIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TenantAccountApiFp(this.configuration).apiV1TenantAccountRolesRoleIdDelete(requestParameters.nexusOpsTenant, requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantAccountApiApiV1TenantAccountRolesRoleIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantAccountApi
     */
    public apiV1TenantAccountRolesRoleIdGet(requestParameters: TenantAccountApiApiV1TenantAccountRolesRoleIdGetRequest, options?: RawAxiosRequestConfig) {
        return TenantAccountApiFp(this.configuration).apiV1TenantAccountRolesRoleIdGet(requestParameters.nexusOpsTenant, requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantAccountApiApiV1TenantAccountRolesRoleIdPermissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantAccountApi
     */
    public apiV1TenantAccountRolesRoleIdPermissionsGet(requestParameters: TenantAccountApiApiV1TenantAccountRolesRoleIdPermissionsGetRequest, options?: RawAxiosRequestConfig) {
        return TenantAccountApiFp(this.configuration).apiV1TenantAccountRolesRoleIdPermissionsGet(requestParameters.nexusOpsTenant, requestParameters.roleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantAccountApiApiV1TenantAccountRolesRoleIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantAccountApi
     */
    public apiV1TenantAccountRolesRoleIdPut(requestParameters: TenantAccountApiApiV1TenantAccountRolesRoleIdPutRequest, options?: RawAxiosRequestConfig) {
        return TenantAccountApiFp(this.configuration).apiV1TenantAccountRolesRoleIdPut(requestParameters.nexusOpsTenant, requestParameters.roleId, requestParameters.nexusOpsAppVersion, requestParameters.updateTenantRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantAccountApiApiV1TenantAccountUsersUserIdRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantAccountApi
     */
    public apiV1TenantAccountUsersUserIdRolesPut(requestParameters: TenantAccountApiApiV1TenantAccountUsersUserIdRolesPutRequest, options?: RawAxiosRequestConfig) {
        return TenantAccountApiFp(this.configuration).apiV1TenantAccountUsersUserIdRolesPut(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, requestParameters.updateUserRolesDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantConnectionRequestsApi - axios parameter creator
 * @export
 */
export const TenantConnectionRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionRequestsCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionRequestsCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-connection-requests/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantConnectionRequestGetPaginatedDto} [tenantConnectionRequestGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionRequestsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantConnectionRequestGetPaginatedDto?: TenantConnectionRequestGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionRequestsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-connection-requests/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantConnectionRequestGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantConnectionRequestCreateDto} [tenantConnectionRequestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionRequestsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantConnectionRequestCreateDto?: TenantConnectionRequestCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionRequestsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-connection-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantConnectionRequestCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantConnectionRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGet: async (nexusOpsTenant: string, tenantConnectionRequestId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantConnectionRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGet', 'tenantConnectionRequestId', tenantConnectionRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-connection-requests/{tenantConnectionRequestId}`
                .replace(`{${"tenantConnectionRequestId"}}`, encodeURIComponent(String(tenantConnectionRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantConnectionRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantConnectionRequestRespondDto} [tenantConnectionRequestRespondDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost: async (nexusOpsTenant: string, tenantConnectionRequestId: string, nexusOpsAppVersion?: string, tenantConnectionRequestRespondDto?: TenantConnectionRequestRespondDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantConnectionRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost', 'tenantConnectionRequestId', tenantConnectionRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-connection-requests/{tenantConnectionRequestId}/respond`
                .replace(`{${"tenantConnectionRequestId"}}`, encodeURIComponent(String(tenantConnectionRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantConnectionRequestRespondDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantConnectionRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePost: async (nexusOpsTenant: string, tenantConnectionRequestId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantConnectionRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePost', 'tenantConnectionRequestId', tenantConnectionRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-connection-requests/{tenantConnectionRequestId}/revoke`
                .replace(`{${"tenantConnectionRequestId"}}`, encodeURIComponent(String(tenantConnectionRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantConnectionRequestsApi - functional programming interface
 * @export
 */
export const TenantConnectionRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantConnectionRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantConnectionRequestsCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConnectionRequestCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantConnectionRequestsCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantConnectionRequestsApi.apiV1TenantToTenantTenantConnectionRequestsCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantConnectionRequestGetPaginatedDto} [tenantConnectionRequestGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantConnectionRequestsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantConnectionRequestGetPaginatedDto?: TenantConnectionRequestGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfTenantConnectionRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantConnectionRequestsGetPost(nexusOpsTenant, nexusOpsAppVersion, tenantConnectionRequestGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantConnectionRequestsApi.apiV1TenantToTenantTenantConnectionRequestsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantConnectionRequestCreateDto} [tenantConnectionRequestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantConnectionRequestsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantConnectionRequestCreateDto?: TenantConnectionRequestCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConnectionRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantConnectionRequestsPost(nexusOpsTenant, nexusOpsAppVersion, tenantConnectionRequestCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantConnectionRequestsApi.apiV1TenantToTenantTenantConnectionRequestsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantConnectionRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGet(nexusOpsTenant: string, tenantConnectionRequestId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConnectionRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGet(nexusOpsTenant, tenantConnectionRequestId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantConnectionRequestsApi.apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantConnectionRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantConnectionRequestRespondDto} [tenantConnectionRequestRespondDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost(nexusOpsTenant: string, tenantConnectionRequestId: string, nexusOpsAppVersion?: string, tenantConnectionRequestRespondDto?: TenantConnectionRequestRespondDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConnectionRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost(nexusOpsTenant, tenantConnectionRequestId, nexusOpsAppVersion, tenantConnectionRequestRespondDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantConnectionRequestsApi.apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantConnectionRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePost(nexusOpsTenant: string, tenantConnectionRequestId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConnectionRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePost(nexusOpsTenant, tenantConnectionRequestId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantConnectionRequestsApi.apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantConnectionRequestsApi - factory interface
 * @export
 */
export const TenantConnectionRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantConnectionRequestsApiFp(configuration)
    return {
        /**
         * 
         * @param {TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionRequestsCountersGet(requestParameters: TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantConnectionRequestCountersDto> {
            return localVarFp.apiV1TenantToTenantTenantConnectionRequestsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionRequestsGetPost(requestParameters: TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfTenantConnectionRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantConnectionRequestsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantConnectionRequestGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionRequestsPost(requestParameters: TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantConnectionRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantConnectionRequestsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantConnectionRequestCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGet(requestParameters: TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantConnectionRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGet(requestParameters.nexusOpsTenant, requestParameters.tenantConnectionRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost(requestParameters: TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantConnectionRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost(requestParameters.nexusOpsTenant, requestParameters.tenantConnectionRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantConnectionRequestRespondDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePost(requestParameters: TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantConnectionRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePost(requestParameters.nexusOpsTenant, requestParameters.tenantConnectionRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1TenantToTenantTenantConnectionRequestsCountersGet operation in TenantConnectionRequestsApi.
 * @export
 * @interface TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsCountersGetRequest
 */
export interface TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantToTenantTenantConnectionRequestsGetPost operation in TenantConnectionRequestsApi.
 * @export
 * @interface TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsGetPostRequest
 */
export interface TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantConnectionRequestGetPaginatedDto}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsGetPost
     */
    readonly tenantConnectionRequestGetPaginatedDto?: TenantConnectionRequestGetPaginatedDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantConnectionRequestsPost operation in TenantConnectionRequestsApi.
 * @export
 * @interface TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsPostRequest
 */
export interface TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantConnectionRequestCreateDto}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsPost
     */
    readonly tenantConnectionRequestCreateDto?: TenantConnectionRequestCreateDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGet operation in TenantConnectionRequestsApi.
 * @export
 * @interface TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGetRequest
 */
export interface TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGet
     */
    readonly tenantConnectionRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost operation in TenantConnectionRequestsApi.
 * @export
 * @interface TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPostRequest
 */
export interface TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost
     */
    readonly tenantConnectionRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantConnectionRequestRespondDto}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost
     */
    readonly tenantConnectionRequestRespondDto?: TenantConnectionRequestRespondDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePost operation in TenantConnectionRequestsApi.
 * @export
 * @interface TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePostRequest
 */
export interface TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePost
     */
    readonly tenantConnectionRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * TenantConnectionRequestsApi - object-oriented interface
 * @export
 * @class TenantConnectionRequestsApi
 * @extends {BaseAPI}
 */
export class TenantConnectionRequestsApi extends BaseAPI {
    /**
     * 
     * @param {TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConnectionRequestsApi
     */
    public apiV1TenantToTenantTenantConnectionRequestsCountersGet(requestParameters: TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsCountersGetRequest, options?: RawAxiosRequestConfig) {
        return TenantConnectionRequestsApiFp(this.configuration).apiV1TenantToTenantTenantConnectionRequestsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConnectionRequestsApi
     */
    public apiV1TenantToTenantTenantConnectionRequestsGetPost(requestParameters: TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsGetPostRequest, options?: RawAxiosRequestConfig) {
        return TenantConnectionRequestsApiFp(this.configuration).apiV1TenantToTenantTenantConnectionRequestsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantConnectionRequestGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConnectionRequestsApi
     */
    public apiV1TenantToTenantTenantConnectionRequestsPost(requestParameters: TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsPostRequest, options?: RawAxiosRequestConfig) {
        return TenantConnectionRequestsApiFp(this.configuration).apiV1TenantToTenantTenantConnectionRequestsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantConnectionRequestCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConnectionRequestsApi
     */
    public apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGet(requestParameters: TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGetRequest, options?: RawAxiosRequestConfig) {
        return TenantConnectionRequestsApiFp(this.configuration).apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdGet(requestParameters.nexusOpsTenant, requestParameters.tenantConnectionRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConnectionRequestsApi
     */
    public apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost(requestParameters: TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPostRequest, options?: RawAxiosRequestConfig) {
        return TenantConnectionRequestsApiFp(this.configuration).apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRespondPost(requestParameters.nexusOpsTenant, requestParameters.tenantConnectionRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantConnectionRequestRespondDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConnectionRequestsApi
     */
    public apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePost(requestParameters: TenantConnectionRequestsApiApiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePostRequest, options?: RawAxiosRequestConfig) {
        return TenantConnectionRequestsApiFp(this.configuration).apiV1TenantToTenantTenantConnectionRequestsTenantConnectionRequestIdRevokePost(requestParameters.nexusOpsTenant, requestParameters.tenantConnectionRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantConnectionsApi - axios parameter creator
 * @export
 */
export const TenantConnectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionsCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionsCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-connections/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantConnectionGetPaginatedDto} [tenantConnectionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantConnectionGetPaginatedDto?: TenantConnectionGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-connections/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantConnectionGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantConnectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPost: async (nexusOpsTenant: string, tenantConnectionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantConnectionId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPost', 'tenantConnectionId', tenantConnectionId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-connections/{tenantConnectionId}/end`
                .replace(`{${"tenantConnectionId"}}`, encodeURIComponent(String(tenantConnectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantConnectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionsTenantConnectionIdGet: async (nexusOpsTenant: string, tenantConnectionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionsTenantConnectionIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantConnectionId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionsTenantConnectionIdGet', 'tenantConnectionId', tenantConnectionId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-connections/{tenantConnectionId}`
                .replace(`{${"tenantConnectionId"}}`, encodeURIComponent(String(tenantConnectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantConnectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantConnectionUpdateDto} [tenantConnectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionsTenantConnectionIdPut: async (nexusOpsTenant: string, tenantConnectionId: string, nexusOpsAppVersion?: string, tenantConnectionUpdateDto?: TenantConnectionUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionsTenantConnectionIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantConnectionId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantConnectionsTenantConnectionIdPut', 'tenantConnectionId', tenantConnectionId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-connections/{tenantConnectionId}`
                .replace(`{${"tenantConnectionId"}}`, encodeURIComponent(String(tenantConnectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantConnectionUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantConnectionsApi - functional programming interface
 * @export
 */
export const TenantConnectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantConnectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantConnectionsCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConnectionCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantConnectionsCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantConnectionsApi.apiV1TenantToTenantTenantConnectionsCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantConnectionGetPaginatedDto} [tenantConnectionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantConnectionsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantConnectionGetPaginatedDto?: TenantConnectionGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfTenantConnectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantConnectionsGetPost(nexusOpsTenant, nexusOpsAppVersion, tenantConnectionGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantConnectionsApi.apiV1TenantToTenantTenantConnectionsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantConnectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPost(nexusOpsTenant: string, tenantConnectionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConnectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPost(nexusOpsTenant, tenantConnectionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantConnectionsApi.apiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantConnectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantConnectionsTenantConnectionIdGet(nexusOpsTenant: string, tenantConnectionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConnectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantConnectionsTenantConnectionIdGet(nexusOpsTenant, tenantConnectionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantConnectionsApi.apiV1TenantToTenantTenantConnectionsTenantConnectionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantConnectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantConnectionUpdateDto} [tenantConnectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantConnectionsTenantConnectionIdPut(nexusOpsTenant: string, tenantConnectionId: string, nexusOpsAppVersion?: string, tenantConnectionUpdateDto?: TenantConnectionUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConnectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantConnectionsTenantConnectionIdPut(nexusOpsTenant, tenantConnectionId, nexusOpsAppVersion, tenantConnectionUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantConnectionsApi.apiV1TenantToTenantTenantConnectionsTenantConnectionIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantConnectionsApi - factory interface
 * @export
 */
export const TenantConnectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantConnectionsApiFp(configuration)
    return {
        /**
         * 
         * @param {TenantConnectionsApiApiV1TenantToTenantTenantConnectionsCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionsCountersGet(requestParameters: TenantConnectionsApiApiV1TenantToTenantTenantConnectionsCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantConnectionCountersDto> {
            return localVarFp.apiV1TenantToTenantTenantConnectionsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantConnectionsApiApiV1TenantToTenantTenantConnectionsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionsGetPost(requestParameters: TenantConnectionsApiApiV1TenantToTenantTenantConnectionsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfTenantConnectionDto> {
            return localVarFp.apiV1TenantToTenantTenantConnectionsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantConnectionGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPost(requestParameters: TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantConnectionDto> {
            return localVarFp.apiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPost(requestParameters.nexusOpsTenant, requestParameters.tenantConnectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionsTenantConnectionIdGet(requestParameters: TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantConnectionDto> {
            return localVarFp.apiV1TenantToTenantTenantConnectionsTenantConnectionIdGet(requestParameters.nexusOpsTenant, requestParameters.tenantConnectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantConnectionsTenantConnectionIdPut(requestParameters: TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantConnectionDto> {
            return localVarFp.apiV1TenantToTenantTenantConnectionsTenantConnectionIdPut(requestParameters.nexusOpsTenant, requestParameters.tenantConnectionId, requestParameters.nexusOpsAppVersion, requestParameters.tenantConnectionUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1TenantToTenantTenantConnectionsCountersGet operation in TenantConnectionsApi.
 * @export
 * @interface TenantConnectionsApiApiV1TenantToTenantTenantConnectionsCountersGetRequest
 */
export interface TenantConnectionsApiApiV1TenantToTenantTenantConnectionsCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantToTenantTenantConnectionsGetPost operation in TenantConnectionsApi.
 * @export
 * @interface TenantConnectionsApiApiV1TenantToTenantTenantConnectionsGetPostRequest
 */
export interface TenantConnectionsApiApiV1TenantToTenantTenantConnectionsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantConnectionGetPaginatedDto}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsGetPost
     */
    readonly tenantConnectionGetPaginatedDto?: TenantConnectionGetPaginatedDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPost operation in TenantConnectionsApi.
 * @export
 * @interface TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPostRequest
 */
export interface TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPost
     */
    readonly tenantConnectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantToTenantTenantConnectionsTenantConnectionIdGet operation in TenantConnectionsApi.
 * @export
 * @interface TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdGetRequest
 */
export interface TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdGet
     */
    readonly tenantConnectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantToTenantTenantConnectionsTenantConnectionIdPut operation in TenantConnectionsApi.
 * @export
 * @interface TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdPutRequest
 */
export interface TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdPut
     */
    readonly tenantConnectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantConnectionUpdateDto}
     * @memberof TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdPut
     */
    readonly tenantConnectionUpdateDto?: TenantConnectionUpdateDto
}

/**
 * TenantConnectionsApi - object-oriented interface
 * @export
 * @class TenantConnectionsApi
 * @extends {BaseAPI}
 */
export class TenantConnectionsApi extends BaseAPI {
    /**
     * 
     * @param {TenantConnectionsApiApiV1TenantToTenantTenantConnectionsCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConnectionsApi
     */
    public apiV1TenantToTenantTenantConnectionsCountersGet(requestParameters: TenantConnectionsApiApiV1TenantToTenantTenantConnectionsCountersGetRequest, options?: RawAxiosRequestConfig) {
        return TenantConnectionsApiFp(this.configuration).apiV1TenantToTenantTenantConnectionsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantConnectionsApiApiV1TenantToTenantTenantConnectionsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConnectionsApi
     */
    public apiV1TenantToTenantTenantConnectionsGetPost(requestParameters: TenantConnectionsApiApiV1TenantToTenantTenantConnectionsGetPostRequest, options?: RawAxiosRequestConfig) {
        return TenantConnectionsApiFp(this.configuration).apiV1TenantToTenantTenantConnectionsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantConnectionGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConnectionsApi
     */
    public apiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPost(requestParameters: TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPostRequest, options?: RawAxiosRequestConfig) {
        return TenantConnectionsApiFp(this.configuration).apiV1TenantToTenantTenantConnectionsTenantConnectionIdEndPost(requestParameters.nexusOpsTenant, requestParameters.tenantConnectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConnectionsApi
     */
    public apiV1TenantToTenantTenantConnectionsTenantConnectionIdGet(requestParameters: TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdGetRequest, options?: RawAxiosRequestConfig) {
        return TenantConnectionsApiFp(this.configuration).apiV1TenantToTenantTenantConnectionsTenantConnectionIdGet(requestParameters.nexusOpsTenant, requestParameters.tenantConnectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConnectionsApi
     */
    public apiV1TenantToTenantTenantConnectionsTenantConnectionIdPut(requestParameters: TenantConnectionsApiApiV1TenantToTenantTenantConnectionsTenantConnectionIdPutRequest, options?: RawAxiosRequestConfig) {
        return TenantConnectionsApiFp(this.configuration).apiV1TenantToTenantTenantConnectionsTenantConnectionIdPut(requestParameters.nexusOpsTenant, requestParameters.tenantConnectionId, requestParameters.nexusOpsAppVersion, requestParameters.tenantConnectionUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantInvitesApi - axios parameter creator
 * @export
 */
export const TenantInvitesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {InviteAnonymousUserDto} [inviteAnonymousUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantInvitesAnonymousPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, inviteAnonymousUserDto?: InviteAnonymousUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantInvitesAnonymousPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant/invites/anonymous`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteAnonymousUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantInviteGetPaginatedDto} [tenantInviteGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantInvitesGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantInviteGetPaginatedDto?: TenantInviteGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantInvitesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant/invites/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantInviteGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantInvitesInviteIdDelete: async (nexusOpsTenant: string, inviteId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantInvitesInviteIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('apiV1TenantInvitesInviteIdDelete', 'inviteId', inviteId)
            const localVarPath = `/api/v1/tenant/invites/{inviteId}`
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantInvitesInviteIdGet: async (nexusOpsTenant: string, inviteId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantInvitesInviteIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('apiV1TenantInvitesInviteIdGet', 'inviteId', inviteId)
            const localVarPath = `/api/v1/tenant/invites/{inviteId}`
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantInvitesInviteIdResendPost: async (nexusOpsTenant: string, inviteId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantInvitesInviteIdResendPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('apiV1TenantInvitesInviteIdResendPost', 'inviteId', inviteId)
            const localVarPath = `/api/v1/tenant/invites/{inviteId}/resend`
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {InviteUserDto} [inviteUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantInvitesPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, inviteUserDto?: InviteUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantInvitesPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant/invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantInvitesApi - functional programming interface
 * @export
 */
export const TenantInvitesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantInvitesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {InviteAnonymousUserDto} [inviteAnonymousUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantInvitesAnonymousPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, inviteAnonymousUserDto?: InviteAnonymousUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteAnonymousUserResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantInvitesAnonymousPost(nexusOpsTenant, nexusOpsAppVersion, inviteAnonymousUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantInvitesApi.apiV1TenantInvitesAnonymousPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantInviteGetPaginatedDto} [tenantInviteGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantInvitesGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantInviteGetPaginatedDto?: TenantInviteGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfTenantInviteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantInvitesGetPost(nexusOpsTenant, nexusOpsAppVersion, tenantInviteGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantInvitesApi.apiV1TenantInvitesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantInvitesInviteIdDelete(nexusOpsTenant: string, inviteId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantInvitesInviteIdDelete(nexusOpsTenant, inviteId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantInvitesApi.apiV1TenantInvitesInviteIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantInvitesInviteIdGet(nexusOpsTenant: string, inviteId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantInviteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantInvitesInviteIdGet(nexusOpsTenant, inviteId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantInvitesApi.apiV1TenantInvitesInviteIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} inviteId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantInvitesInviteIdResendPost(nexusOpsTenant: string, inviteId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantInvitesInviteIdResendPost(nexusOpsTenant, inviteId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantInvitesApi.apiV1TenantInvitesInviteIdResendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {InviteUserDto} [inviteUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantInvitesPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, inviteUserDto?: InviteUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantInvitesPost(nexusOpsTenant, nexusOpsAppVersion, inviteUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantInvitesApi.apiV1TenantInvitesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantInvitesApi - factory interface
 * @export
 */
export const TenantInvitesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantInvitesApiFp(configuration)
    return {
        /**
         * 
         * @param {TenantInvitesApiApiV1TenantInvitesAnonymousPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantInvitesAnonymousPost(requestParameters: TenantInvitesApiApiV1TenantInvitesAnonymousPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<InviteAnonymousUserResultDto> {
            return localVarFp.apiV1TenantInvitesAnonymousPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.inviteAnonymousUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantInvitesApiApiV1TenantInvitesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantInvitesGetPost(requestParameters: TenantInvitesApiApiV1TenantInvitesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfTenantInviteDto> {
            return localVarFp.apiV1TenantInvitesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantInviteGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantInvitesApiApiV1TenantInvitesInviteIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantInvitesInviteIdDelete(requestParameters: TenantInvitesApiApiV1TenantInvitesInviteIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1TenantInvitesInviteIdDelete(requestParameters.nexusOpsTenant, requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantInvitesApiApiV1TenantInvitesInviteIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantInvitesInviteIdGet(requestParameters: TenantInvitesApiApiV1TenantInvitesInviteIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantInviteDto> {
            return localVarFp.apiV1TenantInvitesInviteIdGet(requestParameters.nexusOpsTenant, requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantInvitesApiApiV1TenantInvitesInviteIdResendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantInvitesInviteIdResendPost(requestParameters: TenantInvitesApiApiV1TenantInvitesInviteIdResendPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1TenantInvitesInviteIdResendPost(requestParameters.nexusOpsTenant, requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantInvitesApiApiV1TenantInvitesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantInvitesPost(requestParameters: TenantInvitesApiApiV1TenantInvitesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1TenantInvitesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.inviteUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1TenantInvitesAnonymousPost operation in TenantInvitesApi.
 * @export
 * @interface TenantInvitesApiApiV1TenantInvitesAnonymousPostRequest
 */
export interface TenantInvitesApiApiV1TenantInvitesAnonymousPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesAnonymousPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesAnonymousPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {InviteAnonymousUserDto}
     * @memberof TenantInvitesApiApiV1TenantInvitesAnonymousPost
     */
    readonly inviteAnonymousUserDto?: InviteAnonymousUserDto
}

/**
 * Request parameters for apiV1TenantInvitesGetPost operation in TenantInvitesApi.
 * @export
 * @interface TenantInvitesApiApiV1TenantInvitesGetPostRequest
 */
export interface TenantInvitesApiApiV1TenantInvitesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantInviteGetPaginatedDto}
     * @memberof TenantInvitesApiApiV1TenantInvitesGetPost
     */
    readonly tenantInviteGetPaginatedDto?: TenantInviteGetPaginatedDto
}

/**
 * Request parameters for apiV1TenantInvitesInviteIdDelete operation in TenantInvitesApi.
 * @export
 * @interface TenantInvitesApiApiV1TenantInvitesInviteIdDeleteRequest
 */
export interface TenantInvitesApiApiV1TenantInvitesInviteIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesInviteIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesInviteIdDelete
     */
    readonly inviteId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesInviteIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantInvitesInviteIdGet operation in TenantInvitesApi.
 * @export
 * @interface TenantInvitesApiApiV1TenantInvitesInviteIdGetRequest
 */
export interface TenantInvitesApiApiV1TenantInvitesInviteIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesInviteIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesInviteIdGet
     */
    readonly inviteId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesInviteIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantInvitesInviteIdResendPost operation in TenantInvitesApi.
 * @export
 * @interface TenantInvitesApiApiV1TenantInvitesInviteIdResendPostRequest
 */
export interface TenantInvitesApiApiV1TenantInvitesInviteIdResendPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesInviteIdResendPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesInviteIdResendPost
     */
    readonly inviteId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesInviteIdResendPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantInvitesPost operation in TenantInvitesApi.
 * @export
 * @interface TenantInvitesApiApiV1TenantInvitesPostRequest
 */
export interface TenantInvitesApiApiV1TenantInvitesPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantInvitesApiApiV1TenantInvitesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {InviteUserDto}
     * @memberof TenantInvitesApiApiV1TenantInvitesPost
     */
    readonly inviteUserDto?: InviteUserDto
}

/**
 * TenantInvitesApi - object-oriented interface
 * @export
 * @class TenantInvitesApi
 * @extends {BaseAPI}
 */
export class TenantInvitesApi extends BaseAPI {
    /**
     * 
     * @param {TenantInvitesApiApiV1TenantInvitesAnonymousPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantInvitesApi
     */
    public apiV1TenantInvitesAnonymousPost(requestParameters: TenantInvitesApiApiV1TenantInvitesAnonymousPostRequest, options?: RawAxiosRequestConfig) {
        return TenantInvitesApiFp(this.configuration).apiV1TenantInvitesAnonymousPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.inviteAnonymousUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantInvitesApiApiV1TenantInvitesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantInvitesApi
     */
    public apiV1TenantInvitesGetPost(requestParameters: TenantInvitesApiApiV1TenantInvitesGetPostRequest, options?: RawAxiosRequestConfig) {
        return TenantInvitesApiFp(this.configuration).apiV1TenantInvitesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantInviteGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantInvitesApiApiV1TenantInvitesInviteIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantInvitesApi
     */
    public apiV1TenantInvitesInviteIdDelete(requestParameters: TenantInvitesApiApiV1TenantInvitesInviteIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TenantInvitesApiFp(this.configuration).apiV1TenantInvitesInviteIdDelete(requestParameters.nexusOpsTenant, requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantInvitesApiApiV1TenantInvitesInviteIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantInvitesApi
     */
    public apiV1TenantInvitesInviteIdGet(requestParameters: TenantInvitesApiApiV1TenantInvitesInviteIdGetRequest, options?: RawAxiosRequestConfig) {
        return TenantInvitesApiFp(this.configuration).apiV1TenantInvitesInviteIdGet(requestParameters.nexusOpsTenant, requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantInvitesApiApiV1TenantInvitesInviteIdResendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantInvitesApi
     */
    public apiV1TenantInvitesInviteIdResendPost(requestParameters: TenantInvitesApiApiV1TenantInvitesInviteIdResendPostRequest, options?: RawAxiosRequestConfig) {
        return TenantInvitesApiFp(this.configuration).apiV1TenantInvitesInviteIdResendPost(requestParameters.nexusOpsTenant, requestParameters.inviteId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantInvitesApiApiV1TenantInvitesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantInvitesApi
     */
    public apiV1TenantInvitesPost(requestParameters: TenantInvitesApiApiV1TenantInvitesPostRequest, options?: RawAxiosRequestConfig) {
        return TenantInvitesApiFp(this.configuration).apiV1TenantInvitesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.inviteUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantProfileApi - axios parameter creator
 * @export
 */
export const TenantProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantProfileGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantProfileGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantProfileUpdateDto} [tenantProfileUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantProfileProfilePut: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantProfileUpdateDto?: TenantProfileUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantProfileProfilePut', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant/profile/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantProfileUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantProfileSettingsEmailGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantProfileSettingsEmailGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant/profile/settings/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantEmailSettingsInputDto} [tenantEmailSettingsInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantProfileSettingsEmailPut: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantEmailSettingsInputDto?: TenantEmailSettingsInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantProfileSettingsEmailPut', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant/profile/settings/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantEmailSettingsInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantProfileSettingsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantProfileSettingsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant/profile/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantSettingsInputDto} [tenantSettingsInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantProfileSettingsPut: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantSettingsInputDto?: TenantSettingsInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantProfileSettingsPut', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant/profile/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantSettingsInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantProfileApi - functional programming interface
 * @export
 */
export const TenantProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantProfileGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantProfileGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantProfileApi.apiV1TenantProfileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantProfileUpdateDto} [tenantProfileUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantProfileProfilePut(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantProfileUpdateDto?: TenantProfileUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantProfileProfilePut(nexusOpsTenant, nexusOpsAppVersion, tenantProfileUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantProfileApi.apiV1TenantProfileProfilePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantProfileSettingsEmailGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantEmailSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantProfileSettingsEmailGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantProfileApi.apiV1TenantProfileSettingsEmailGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantEmailSettingsInputDto} [tenantEmailSettingsInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantProfileSettingsEmailPut(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantEmailSettingsInputDto?: TenantEmailSettingsInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantEmailSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantProfileSettingsEmailPut(nexusOpsTenant, nexusOpsAppVersion, tenantEmailSettingsInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantProfileApi.apiV1TenantProfileSettingsEmailPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantProfileSettingsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantProfileSettingsGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantProfileApi.apiV1TenantProfileSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantSettingsInputDto} [tenantSettingsInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantProfileSettingsPut(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantSettingsInputDto?: TenantSettingsInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantProfileSettingsPut(nexusOpsTenant, nexusOpsAppVersion, tenantSettingsInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantProfileApi.apiV1TenantProfileSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantProfileApi - factory interface
 * @export
 */
export const TenantProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantProfileApiFp(configuration)
    return {
        /**
         * 
         * @param {TenantProfileApiApiV1TenantProfileGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantProfileGet(requestParameters: TenantProfileApiApiV1TenantProfileGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantProfileDto> {
            return localVarFp.apiV1TenantProfileGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantProfileApiApiV1TenantProfileProfilePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantProfileProfilePut(requestParameters: TenantProfileApiApiV1TenantProfileProfilePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantProfileDto> {
            return localVarFp.apiV1TenantProfileProfilePut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantProfileUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantProfileApiApiV1TenantProfileSettingsEmailGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantProfileSettingsEmailGet(requestParameters: TenantProfileApiApiV1TenantProfileSettingsEmailGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantEmailSettingsDto> {
            return localVarFp.apiV1TenantProfileSettingsEmailGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantProfileApiApiV1TenantProfileSettingsEmailPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantProfileSettingsEmailPut(requestParameters: TenantProfileApiApiV1TenantProfileSettingsEmailPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantEmailSettingsDto> {
            return localVarFp.apiV1TenantProfileSettingsEmailPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantEmailSettingsInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantProfileApiApiV1TenantProfileSettingsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantProfileSettingsGet(requestParameters: TenantProfileApiApiV1TenantProfileSettingsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantSettingsDto> {
            return localVarFp.apiV1TenantProfileSettingsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantProfileApiApiV1TenantProfileSettingsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantProfileSettingsPut(requestParameters: TenantProfileApiApiV1TenantProfileSettingsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantSettingsDto> {
            return localVarFp.apiV1TenantProfileSettingsPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantSettingsInputDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1TenantProfileGet operation in TenantProfileApi.
 * @export
 * @interface TenantProfileApiApiV1TenantProfileGetRequest
 */
export interface TenantProfileApiApiV1TenantProfileGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantProfileApiApiV1TenantProfileGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantProfileApiApiV1TenantProfileGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantProfileProfilePut operation in TenantProfileApi.
 * @export
 * @interface TenantProfileApiApiV1TenantProfileProfilePutRequest
 */
export interface TenantProfileApiApiV1TenantProfileProfilePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantProfileApiApiV1TenantProfileProfilePut
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantProfileApiApiV1TenantProfileProfilePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantProfileUpdateDto}
     * @memberof TenantProfileApiApiV1TenantProfileProfilePut
     */
    readonly tenantProfileUpdateDto?: TenantProfileUpdateDto
}

/**
 * Request parameters for apiV1TenantProfileSettingsEmailGet operation in TenantProfileApi.
 * @export
 * @interface TenantProfileApiApiV1TenantProfileSettingsEmailGetRequest
 */
export interface TenantProfileApiApiV1TenantProfileSettingsEmailGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantProfileApiApiV1TenantProfileSettingsEmailGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantProfileApiApiV1TenantProfileSettingsEmailGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantProfileSettingsEmailPut operation in TenantProfileApi.
 * @export
 * @interface TenantProfileApiApiV1TenantProfileSettingsEmailPutRequest
 */
export interface TenantProfileApiApiV1TenantProfileSettingsEmailPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantProfileApiApiV1TenantProfileSettingsEmailPut
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantProfileApiApiV1TenantProfileSettingsEmailPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantEmailSettingsInputDto}
     * @memberof TenantProfileApiApiV1TenantProfileSettingsEmailPut
     */
    readonly tenantEmailSettingsInputDto?: TenantEmailSettingsInputDto
}

/**
 * Request parameters for apiV1TenantProfileSettingsGet operation in TenantProfileApi.
 * @export
 * @interface TenantProfileApiApiV1TenantProfileSettingsGetRequest
 */
export interface TenantProfileApiApiV1TenantProfileSettingsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantProfileApiApiV1TenantProfileSettingsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantProfileApiApiV1TenantProfileSettingsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantProfileSettingsPut operation in TenantProfileApi.
 * @export
 * @interface TenantProfileApiApiV1TenantProfileSettingsPutRequest
 */
export interface TenantProfileApiApiV1TenantProfileSettingsPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantProfileApiApiV1TenantProfileSettingsPut
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantProfileApiApiV1TenantProfileSettingsPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantSettingsInputDto}
     * @memberof TenantProfileApiApiV1TenantProfileSettingsPut
     */
    readonly tenantSettingsInputDto?: TenantSettingsInputDto
}

/**
 * TenantProfileApi - object-oriented interface
 * @export
 * @class TenantProfileApi
 * @extends {BaseAPI}
 */
export class TenantProfileApi extends BaseAPI {
    /**
     * 
     * @param {TenantProfileApiApiV1TenantProfileGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantProfileApi
     */
    public apiV1TenantProfileGet(requestParameters: TenantProfileApiApiV1TenantProfileGetRequest, options?: RawAxiosRequestConfig) {
        return TenantProfileApiFp(this.configuration).apiV1TenantProfileGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantProfileApiApiV1TenantProfileProfilePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantProfileApi
     */
    public apiV1TenantProfileProfilePut(requestParameters: TenantProfileApiApiV1TenantProfileProfilePutRequest, options?: RawAxiosRequestConfig) {
        return TenantProfileApiFp(this.configuration).apiV1TenantProfileProfilePut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantProfileUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantProfileApiApiV1TenantProfileSettingsEmailGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantProfileApi
     */
    public apiV1TenantProfileSettingsEmailGet(requestParameters: TenantProfileApiApiV1TenantProfileSettingsEmailGetRequest, options?: RawAxiosRequestConfig) {
        return TenantProfileApiFp(this.configuration).apiV1TenantProfileSettingsEmailGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantProfileApiApiV1TenantProfileSettingsEmailPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantProfileApi
     */
    public apiV1TenantProfileSettingsEmailPut(requestParameters: TenantProfileApiApiV1TenantProfileSettingsEmailPutRequest, options?: RawAxiosRequestConfig) {
        return TenantProfileApiFp(this.configuration).apiV1TenantProfileSettingsEmailPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantEmailSettingsInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantProfileApiApiV1TenantProfileSettingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantProfileApi
     */
    public apiV1TenantProfileSettingsGet(requestParameters: TenantProfileApiApiV1TenantProfileSettingsGetRequest, options?: RawAxiosRequestConfig) {
        return TenantProfileApiFp(this.configuration).apiV1TenantProfileSettingsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantProfileApiApiV1TenantProfileSettingsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantProfileApi
     */
    public apiV1TenantProfileSettingsPut(requestParameters: TenantProfileApiApiV1TenantProfileSettingsPutRequest, options?: RawAxiosRequestConfig) {
        return TenantProfileApiFp(this.configuration).apiV1TenantProfileSettingsPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantSettingsInputDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantRequestsApi - axios parameter creator
 * @export
 */
export const TenantRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestInferBillToInfoInputDto} [tenantRequestInferBillToInfoInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsBillToInfoInferPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantRequestInferBillToInfoInputDto?: TenantRequestInferBillToInfoInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsBillToInfoInferPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/bill-to-info/infer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantRequestInferBillToInfoInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestGetPaginatedDto} [tenantRequestGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantRequestGetPaginatedDto?: TenantRequestGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantRequestGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestCreateDto} [tenantRequestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantRequestCreateDto?: TenantRequestCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantRequestCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdDelete: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdDelete', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}/external-number`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalExternalNumberInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdGet: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdGet', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestUpdateDto} [tenantRequestUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdPut: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestUpdateDto?: TenantRequestUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdPut', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantRequestUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestApplyResultDto} [tenantRequestApplyResultDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestApplyResultDto?: TenantRequestApplyResultDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}/result/apply`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantRequestApplyResultDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestOperationResultInputDto} [tenantRequestOperationResultInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestOperationResultInputDto?: TenantRequestOperationResultInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}/result/operation`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantRequestOperationResultInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestResultInputDto} [tenantRequestResultInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdResultPut: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestResultInputDto?: TenantRequestResultInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdResultPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdResultPut', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}/result`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantRequestResultInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestCloseDto} [tenantRequestCloseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestCloseDto?: TenantRequestCloseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}/stage/close`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantRequestCloseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePost: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePost', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}/stage/complete`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPost: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPost', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}/stage/draft`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPost: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPost', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}/stage/report`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestRespondDto} [tenantRequestRespondDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestRespondDto?: TenantRequestRespondDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}/stage/respond`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantRequestRespondDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestReturnDto} [tenantRequestReturnDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestReturnDto?: TenantRequestReturnDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}/stage/return`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantRequestReturnDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestReworkDto} [tenantRequestReworkDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestReworkDto?: TenantRequestReworkDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}/stage/rework`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantRequestReworkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPost: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPost', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}/stage/send`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPost: async (nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPost', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/{tenantRequestId}/stage/start`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestCreateDto} [tenantRequestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsValidatePost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantRequestCreateDto?: TenantRequestCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantTenantRequestsValidatePost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant-to-tenant/tenant-requests/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantRequestCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantRequestsApi - functional programming interface
 * @export
 */
export const TenantRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestInferBillToInfoInputDto} [tenantRequestInferBillToInfoInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsBillToInfoInferPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantRequestInferBillToInfoInputDto?: TenantRequestInferBillToInfoInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralBillToInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsBillToInfoInferPost(nexusOpsTenant, nexusOpsAppVersion, tenantRequestInferBillToInfoInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsBillToInfoInferPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestGetPaginatedDto} [tenantRequestGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantRequestGetPaginatedDto?: TenantRequestGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfTenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsGetPost(nexusOpsTenant, nexusOpsAppVersion, tenantRequestGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestCreateDto} [tenantRequestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantRequestCreateDto?: TenantRequestCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsPost(nexusOpsTenant, nexusOpsAppVersion, tenantRequestCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdDelete(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdDelete(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, generalExternalNumberInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdGet(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdGet(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestUpdateDto} [tenantRequestUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdPut(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestUpdateDto?: TenantRequestUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdPut(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, tenantRequestUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestApplyResultDto} [tenantRequestApplyResultDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestApplyResultDto?: TenantRequestApplyResultDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, tenantRequestApplyResultDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestOperationResultInputDto} [tenantRequestOperationResultInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestOperationResultInputDto?: TenantRequestOperationResultInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, tenantRequestOperationResultInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestResultInputDto} [tenantRequestResultInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdResultPut(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestResultInputDto?: TenantRequestResultInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdResultPut(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, tenantRequestResultInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdResultPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestCloseDto} [tenantRequestCloseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestCloseDto?: TenantRequestCloseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, tenantRequestCloseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePost(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePost(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPost(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPost(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPost(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPost(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestRespondDto} [tenantRequestRespondDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestRespondDto?: TenantRequestRespondDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, tenantRequestRespondDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestReturnDto} [tenantRequestReturnDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestReturnDto?: TenantRequestReturnDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, tenantRequestReturnDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestReworkDto} [tenantRequestReworkDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, tenantRequestReworkDto?: TenantRequestReworkDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, tenantRequestReworkDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPost(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPost(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPost(nexusOpsTenant: string, tenantRequestId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPost(nexusOpsTenant, tenantRequestId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestCreateDto} [tenantRequestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantTenantRequestsValidatePost(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantRequestCreateDto?: TenantRequestCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantTenantRequestsValidatePost(nexusOpsTenant, nexusOpsAppVersion, tenantRequestCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsApi.apiV1TenantToTenantTenantRequestsValidatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantRequestsApi - factory interface
 * @export
 */
export const TenantRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantRequestsApiFp(configuration)
    return {
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsBillToInfoInferPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsBillToInfoInferPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsBillToInfoInferPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralBillToInfoDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsBillToInfoInferPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestInferBillToInfoInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsCountersGet(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestCountersDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsGetPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfTenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdDelete(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdDelete(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdGet(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdGet(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdPut(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdPut(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestApplyResultDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestOperationResultInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdResultPut(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdResultPut(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestResultInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestCloseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestRespondDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestReturnDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestReworkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsValidatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantTenantRequestsValidatePost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsValidatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1TenantToTenantTenantRequestsValidatePost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsBillToInfoInferPost operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsBillToInfoInferPostRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsBillToInfoInferPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsBillToInfoInferPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsBillToInfoInferPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantRequestInferBillToInfoInputDto}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsBillToInfoInferPost
     */
    readonly tenantRequestInferBillToInfoInputDto?: TenantRequestInferBillToInfoInputDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsCountersGet operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsCountersGetRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsGetPost operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsGetPostRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantRequestGetPaginatedDto}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsGetPost
     */
    readonly tenantRequestGetPaginatedDto?: TenantRequestGetPaginatedDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsPost operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsPostRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantRequestCreateDto}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsPost
     */
    readonly tenantRequestCreateDto?: TenantRequestCreateDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdDelete operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdDeleteRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdDelete
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPutRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralExternalNumberInputDto}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut
     */
    readonly generalExternalNumberInputDto?: GeneralExternalNumberInputDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdGet operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdGetRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdGet
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdPut operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdPutRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdPut
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantRequestUpdateDto}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdPut
     */
    readonly tenantRequestUpdateDto?: TenantRequestUpdateDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPostRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantRequestApplyResultDto}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost
     */
    readonly tenantRequestApplyResultDto?: TenantRequestApplyResultDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPutRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantRequestOperationResultInputDto}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut
     */
    readonly tenantRequestOperationResultInputDto?: TenantRequestOperationResultInputDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdResultPut operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultPutRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultPut
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantRequestResultInputDto}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultPut
     */
    readonly tenantRequestResultInputDto?: TenantRequestResultInputDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePostRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantRequestCloseDto}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost
     */
    readonly tenantRequestCloseDto?: TenantRequestCloseDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePost operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePostRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePost
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPost operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPostRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPost
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPost operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPostRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPost
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPostRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantRequestRespondDto}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost
     */
    readonly tenantRequestRespondDto?: TenantRequestRespondDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPostRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantRequestReturnDto}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost
     */
    readonly tenantRequestReturnDto?: TenantRequestReturnDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPostRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantRequestReworkDto}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost
     */
    readonly tenantRequestReworkDto?: TenantRequestReworkDto
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPost operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPostRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPost
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPost operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPostRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPost
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1TenantToTenantTenantRequestsValidatePost operation in TenantRequestsApi.
 * @export
 * @interface TenantRequestsApiApiV1TenantToTenantTenantRequestsValidatePostRequest
 */
export interface TenantRequestsApiApiV1TenantToTenantTenantRequestsValidatePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsValidatePost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsValidatePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantRequestCreateDto}
     * @memberof TenantRequestsApiApiV1TenantToTenantTenantRequestsValidatePost
     */
    readonly tenantRequestCreateDto?: TenantRequestCreateDto
}

/**
 * TenantRequestsApi - object-oriented interface
 * @export
 * @class TenantRequestsApi
 * @extends {BaseAPI}
 */
export class TenantRequestsApi extends BaseAPI {
    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsBillToInfoInferPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsBillToInfoInferPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsBillToInfoInferPostRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsBillToInfoInferPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestInferBillToInfoInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsCountersGet(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsCountersGetRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsGetPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsGetPostRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsPostRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdDelete(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdDelete(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPutRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdGet(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdGetRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdGet(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdPut(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdPutRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdPut(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPostRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdResultApplyPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestApplyResultDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPutRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdResultOperationPut(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestOperationResultInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdResultPut(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdResultPutRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdResultPut(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestResultInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePostRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdStageClosePost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestCloseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePostRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdStageCompletePost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPostRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdStageDraftPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPostRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdStageReportPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPostRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdStageRespondPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestRespondDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPostRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdStageReturnPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestReturnDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPostRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdStageReworkPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestReworkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPostRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdStageSendPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPostRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsTenantRequestIdStageStartPost(requestParameters.nexusOpsTenant, requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsApiApiV1TenantToTenantTenantRequestsValidatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsApi
     */
    public apiV1TenantToTenantTenantRequestsValidatePost(requestParameters: TenantRequestsApiApiV1TenantToTenantTenantRequestsValidatePostRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsApiFp(this.configuration).apiV1TenantToTenantTenantRequestsValidatePost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantRequestsAdminApi - axios parameter creator
 * @export
 */
export const TenantRequestsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestGetPaginatedDto} [tenantRequestGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantToTenantTenantRequestsGetPost: async (nexusOpsAppVersion?: string, tenantRequestGetPaginatedDto?: TenantRequestGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/tenant-to-tenant/tenant-requests/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantRequestGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantToTenantTenantRequestsTenantRequestIdDelete: async (tenantRequestId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1AdminTenantToTenantTenantRequestsTenantRequestIdDelete', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/admin/tenant-to-tenant/tenant-requests/{tenantRequestId}`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantToTenantTenantRequestsTenantRequestIdGet: async (tenantRequestId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantRequestId' is not null or undefined
            assertParamExists('apiV1AdminTenantToTenantTenantRequestsTenantRequestIdGet', 'tenantRequestId', tenantRequestId)
            const localVarPath = `/api/v1/admin/tenant-to-tenant/tenant-requests/{tenantRequestId}`
                .replace(`{${"tenantRequestId"}}`, encodeURIComponent(String(tenantRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantRequestsAdminApi - functional programming interface
 * @export
 */
export const TenantRequestsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantRequestsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantRequestGetPaginatedDto} [tenantRequestGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminTenantToTenantTenantRequestsGetPost(nexusOpsAppVersion?: string, tenantRequestGetPaginatedDto?: TenantRequestGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfTenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminTenantToTenantTenantRequestsGetPost(nexusOpsAppVersion, tenantRequestGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsAdminApi.apiV1AdminTenantToTenantTenantRequestsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminTenantToTenantTenantRequestsTenantRequestIdDelete(tenantRequestId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminTenantToTenantTenantRequestsTenantRequestIdDelete(tenantRequestId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsAdminApi.apiV1AdminTenantToTenantTenantRequestsTenantRequestIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantRequestId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminTenantToTenantTenantRequestsTenantRequestIdGet(tenantRequestId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminTenantToTenantTenantRequestsTenantRequestIdGet(tenantRequestId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRequestsAdminApi.apiV1AdminTenantToTenantTenantRequestsTenantRequestIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantRequestsAdminApi - factory interface
 * @export
 */
export const TenantRequestsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantRequestsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantToTenantTenantRequestsGetPost(requestParameters: TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfTenantRequestDto> {
            return localVarFp.apiV1AdminTenantToTenantTenantRequestsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantToTenantTenantRequestsTenantRequestIdDelete(requestParameters: TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminTenantToTenantTenantRequestsTenantRequestIdDelete(requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantToTenantTenantRequestsTenantRequestIdGet(requestParameters: TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantRequestDto> {
            return localVarFp.apiV1AdminTenantToTenantTenantRequestsTenantRequestIdGet(requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminTenantToTenantTenantRequestsGetPost operation in TenantRequestsAdminApi.
 * @export
 * @interface TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsGetPostRequest
 */
export interface TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantRequestGetPaginatedDto}
     * @memberof TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsGetPost
     */
    readonly tenantRequestGetPaginatedDto?: TenantRequestGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminTenantToTenantTenantRequestsTenantRequestIdDelete operation in TenantRequestsAdminApi.
 * @export
 * @interface TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdDeleteRequest
 */
export interface TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdDelete
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminTenantToTenantTenantRequestsTenantRequestIdGet operation in TenantRequestsAdminApi.
 * @export
 * @interface TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdGetRequest
 */
export interface TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdGet
     */
    readonly tenantRequestId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * TenantRequestsAdminApi - object-oriented interface
 * @export
 * @class TenantRequestsAdminApi
 * @extends {BaseAPI}
 */
export class TenantRequestsAdminApi extends BaseAPI {
    /**
     * 
     * @param {TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsAdminApi
     */
    public apiV1AdminTenantToTenantTenantRequestsGetPost(requestParameters: TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return TenantRequestsAdminApiFp(this.configuration).apiV1AdminTenantToTenantTenantRequestsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.tenantRequestGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsAdminApi
     */
    public apiV1AdminTenantToTenantTenantRequestsTenantRequestIdDelete(requestParameters: TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsAdminApiFp(this.configuration).apiV1AdminTenantToTenantTenantRequestsTenantRequestIdDelete(requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRequestsAdminApi
     */
    public apiV1AdminTenantToTenantTenantRequestsTenantRequestIdGet(requestParameters: TenantRequestsAdminApiApiV1AdminTenantToTenantTenantRequestsTenantRequestIdGetRequest, options?: RawAxiosRequestConfig) {
        return TenantRequestsAdminApiFp(this.configuration).apiV1AdminTenantToTenantTenantRequestsTenantRequestIdGet(requestParameters.tenantRequestId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantStructureApi - axios parameter creator
 * @export
 */
export const TenantStructureApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantMembershipOfEntityUpdateDto} [tenantMembershipOfEntityUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantStructureMembershipEntityPut: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantMembershipOfEntityUpdateDto?: TenantMembershipOfEntityUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantStructureMembershipEntityPut', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant-structure/membership/entity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantMembershipOfEntityUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantStructureApi - functional programming interface
 * @export
 */
export const TenantStructureApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantStructureApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantMembershipOfEntityUpdateDto} [tenantMembershipOfEntityUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantStructureMembershipEntityPut(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantMembershipOfEntityUpdateDto?: TenantMembershipOfEntityUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantStructureMembershipEntityPut(nexusOpsTenant, nexusOpsAppVersion, tenantMembershipOfEntityUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantStructureApi.apiV1TenantStructureMembershipEntityPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantStructureApi - factory interface
 * @export
 */
export const TenantStructureApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantStructureApiFp(configuration)
    return {
        /**
         * 
         * @param {TenantStructureApiApiV1TenantStructureMembershipEntityPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantStructureMembershipEntityPut(requestParameters: TenantStructureApiApiV1TenantStructureMembershipEntityPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1TenantStructureMembershipEntityPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantMembershipOfEntityUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1TenantStructureMembershipEntityPut operation in TenantStructureApi.
 * @export
 * @interface TenantStructureApiApiV1TenantStructureMembershipEntityPutRequest
 */
export interface TenantStructureApiApiV1TenantStructureMembershipEntityPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantStructureApiApiV1TenantStructureMembershipEntityPut
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantStructureApiApiV1TenantStructureMembershipEntityPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantMembershipOfEntityUpdateDto}
     * @memberof TenantStructureApiApiV1TenantStructureMembershipEntityPut
     */
    readonly tenantMembershipOfEntityUpdateDto?: TenantMembershipOfEntityUpdateDto
}

/**
 * TenantStructureApi - object-oriented interface
 * @export
 * @class TenantStructureApi
 * @extends {BaseAPI}
 */
export class TenantStructureApi extends BaseAPI {
    /**
     * 
     * @param {TenantStructureApiApiV1TenantStructureMembershipEntityPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantStructureApi
     */
    public apiV1TenantStructureMembershipEntityPut(requestParameters: TenantStructureApiApiV1TenantStructureMembershipEntityPutRequest, options?: RawAxiosRequestConfig) {
        return TenantStructureApiFp(this.configuration).apiV1TenantStructureMembershipEntityPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantMembershipOfEntityUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantToTenantApi - axios parameter creator
 * @export
 */
export const TenantToTenantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantToTenantCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenant-to-tenant/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantToTenantApi - functional programming interface
 * @export
 */
export const TenantToTenantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantToTenantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantToTenantCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantToTenantCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantToTenantCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantToTenantApi.apiV1TenantToTenantCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantToTenantApi - factory interface
 * @export
 */
export const TenantToTenantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantToTenantApiFp(configuration)
    return {
        /**
         * 
         * @param {TenantToTenantApiApiV1TenantToTenantCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantToTenantCountersGet(requestParameters: TenantToTenantApiApiV1TenantToTenantCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantToTenantCountersDto> {
            return localVarFp.apiV1TenantToTenantCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1TenantToTenantCountersGet operation in TenantToTenantApi.
 * @export
 * @interface TenantToTenantApiApiV1TenantToTenantCountersGetRequest
 */
export interface TenantToTenantApiApiV1TenantToTenantCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantToTenantApiApiV1TenantToTenantCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantToTenantApiApiV1TenantToTenantCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * TenantToTenantApi - object-oriented interface
 * @export
 * @class TenantToTenantApi
 * @extends {BaseAPI}
 */
export class TenantToTenantApi extends BaseAPI {
    /**
     * 
     * @param {TenantToTenantApiApiV1TenantToTenantCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantToTenantApi
     */
    public apiV1TenantToTenantCountersGet(requestParameters: TenantToTenantApiApiV1TenantToTenantCountersGetRequest, options?: RawAxiosRequestConfig) {
        return TenantToTenantApiFp(this.configuration).apiV1TenantToTenantCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantsApi - axios parameter creator
 * @export
 */
export const TenantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantGetPaginatedDto} [tenantGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantGetPaginatedDto?: TenantGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/tenants/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantsTenantIdGet: async (nexusOpsTenant: string, tenantId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1TenantsTenantIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiV1TenantsTenantIdGet', 'tenantId', tenantId)
            const localVarPath = `/api/v1/tenants/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantsApi - functional programming interface
 * @export
 */
export const TenantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantGetPaginatedDto} [tenantGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, tenantGetPaginatedDto?: TenantGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfTenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantsGetPost(nexusOpsTenant, nexusOpsAppVersion, tenantGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.apiV1TenantsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantsTenantIdGet(nexusOpsTenant: string, tenantId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantsTenantIdGet(nexusOpsTenant, tenantId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.apiV1TenantsTenantIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantsApi - factory interface
 * @export
 */
export const TenantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantsApiFp(configuration)
    return {
        /**
         * 
         * @param {TenantsApiApiV1TenantsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantsGetPost(requestParameters: TenantsApiApiV1TenantsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfTenantDto> {
            return localVarFp.apiV1TenantsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantsApiApiV1TenantsTenantIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantsTenantIdGet(requestParameters: TenantsApiApiV1TenantsTenantIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantDto> {
            return localVarFp.apiV1TenantsTenantIdGet(requestParameters.nexusOpsTenant, requestParameters.tenantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1TenantsGetPost operation in TenantsApi.
 * @export
 * @interface TenantsApiApiV1TenantsGetPostRequest
 */
export interface TenantsApiApiV1TenantsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantsApiApiV1TenantsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantsApiApiV1TenantsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantGetPaginatedDto}
     * @memberof TenantsApiApiV1TenantsGetPost
     */
    readonly tenantGetPaginatedDto?: TenantGetPaginatedDto
}

/**
 * Request parameters for apiV1TenantsTenantIdGet operation in TenantsApi.
 * @export
 * @interface TenantsApiApiV1TenantsTenantIdGetRequest
 */
export interface TenantsApiApiV1TenantsTenantIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TenantsApiApiV1TenantsTenantIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TenantsApiApiV1TenantsTenantIdGet
     */
    readonly tenantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantsApiApiV1TenantsTenantIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * TenantsApi - object-oriented interface
 * @export
 * @class TenantsApi
 * @extends {BaseAPI}
 */
export class TenantsApi extends BaseAPI {
    /**
     * 
     * @param {TenantsApiApiV1TenantsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public apiV1TenantsGetPost(requestParameters: TenantsApiApiV1TenantsGetPostRequest, options?: RawAxiosRequestConfig) {
        return TenantsApiFp(this.configuration).apiV1TenantsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.tenantGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantsApiApiV1TenantsTenantIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public apiV1TenantsTenantIdGet(requestParameters: TenantsApiApiV1TenantsTenantIdGetRequest, options?: RawAxiosRequestConfig) {
        return TenantsApiFp(this.configuration).apiV1TenantsTenantIdGet(requestParameters.nexusOpsTenant, requestParameters.tenantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantsAdminApi - axios parameter creator
 * @export
 */
export const TenantsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminTenantGetPaginatedDto} [adminTenantGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantsGetPost: async (nexusOpsAppVersion?: string, adminTenantGetPaginatedDto?: AdminTenantGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/tenants/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminTenantGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} targetTenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantSuspendAdminDto} [tenantSuspendAdminDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantsTargetTenantIdSuspendPost: async (targetTenantId: string, nexusOpsAppVersion?: string, tenantSuspendAdminDto?: TenantSuspendAdminDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetTenantId' is not null or undefined
            assertParamExists('apiV1AdminTenantsTargetTenantIdSuspendPost', 'targetTenantId', targetTenantId)
            const localVarPath = `/api/v1/admin/tenants/{targetTenantId}/suspend`
                .replace(`{${"targetTenantId"}}`, encodeURIComponent(String(targetTenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantSuspendAdminDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} targetTenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantUnsuspendAdminDto} [tenantUnsuspendAdminDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantsTargetTenantIdUnsuspendPost: async (targetTenantId: string, nexusOpsAppVersion?: string, tenantUnsuspendAdminDto?: TenantUnsuspendAdminDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetTenantId' is not null or undefined
            assertParamExists('apiV1AdminTenantsTargetTenantIdUnsuspendPost', 'targetTenantId', targetTenantId)
            const localVarPath = `/api/v1/admin/tenants/{targetTenantId}/unsuspend`
                .replace(`{${"targetTenantId"}}`, encodeURIComponent(String(targetTenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantUnsuspendAdminDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantsTenantIdGet: async (tenantId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiV1AdminTenantsTenantIdGet', 'tenantId', tenantId)
            const localVarPath = `/api/v1/admin/tenants/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminTenantUpdateModeDto} [adminTenantUpdateModeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantsTenantIdModePut: async (tenantId: string, nexusOpsAppVersion?: string, adminTenantUpdateModeDto?: AdminTenantUpdateModeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiV1AdminTenantsTenantIdModePut', 'tenantId', tenantId)
            const localVarPath = `/api/v1/admin/tenants/{tenantId}/mode`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminTenantUpdateModeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantsAdminApi - functional programming interface
 * @export
 */
export const TenantsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminTenantGetPaginatedDto} [adminTenantGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminTenantsGetPost(nexusOpsAppVersion?: string, adminTenantGetPaginatedDto?: AdminTenantGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminTenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminTenantsGetPost(nexusOpsAppVersion, adminTenantGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsAdminApi.apiV1AdminTenantsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} targetTenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantSuspendAdminDto} [tenantSuspendAdminDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminTenantsTargetTenantIdSuspendPost(targetTenantId: string, nexusOpsAppVersion?: string, tenantSuspendAdminDto?: TenantSuspendAdminDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminTenantsTargetTenantIdSuspendPost(targetTenantId, nexusOpsAppVersion, tenantSuspendAdminDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsAdminApi.apiV1AdminTenantsTargetTenantIdSuspendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} targetTenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TenantUnsuspendAdminDto} [tenantUnsuspendAdminDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminTenantsTargetTenantIdUnsuspendPost(targetTenantId: string, nexusOpsAppVersion?: string, tenantUnsuspendAdminDto?: TenantUnsuspendAdminDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminTenantsTargetTenantIdUnsuspendPost(targetTenantId, nexusOpsAppVersion, tenantUnsuspendAdminDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsAdminApi.apiV1AdminTenantsTargetTenantIdUnsuspendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminTenantsTenantIdGet(tenantId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminTenantsTenantIdGet(tenantId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsAdminApi.apiV1AdminTenantsTenantIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminTenantUpdateModeDto} [adminTenantUpdateModeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminTenantsTenantIdModePut(tenantId: string, nexusOpsAppVersion?: string, adminTenantUpdateModeDto?: AdminTenantUpdateModeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminTenantsTenantIdModePut(tenantId, nexusOpsAppVersion, adminTenantUpdateModeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsAdminApi.apiV1AdminTenantsTenantIdModePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantsAdminApi - factory interface
 * @export
 */
export const TenantsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {TenantsAdminApiApiV1AdminTenantsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantsGetPost(requestParameters: TenantsAdminApiApiV1AdminTenantsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminTenantDto> {
            return localVarFp.apiV1AdminTenantsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminTenantGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantsAdminApiApiV1AdminTenantsTargetTenantIdSuspendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantsTargetTenantIdSuspendPost(requestParameters: TenantsAdminApiApiV1AdminTenantsTargetTenantIdSuspendPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminTenantDto> {
            return localVarFp.apiV1AdminTenantsTargetTenantIdSuspendPost(requestParameters.targetTenantId, requestParameters.nexusOpsAppVersion, requestParameters.tenantSuspendAdminDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantsAdminApiApiV1AdminTenantsTargetTenantIdUnsuspendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantsTargetTenantIdUnsuspendPost(requestParameters: TenantsAdminApiApiV1AdminTenantsTargetTenantIdUnsuspendPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminTenantDto> {
            return localVarFp.apiV1AdminTenantsTargetTenantIdUnsuspendPost(requestParameters.targetTenantId, requestParameters.nexusOpsAppVersion, requestParameters.tenantUnsuspendAdminDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantsAdminApiApiV1AdminTenantsTenantIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantsTenantIdGet(requestParameters: TenantsAdminApiApiV1AdminTenantsTenantIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminTenantDto> {
            return localVarFp.apiV1AdminTenantsTenantIdGet(requestParameters.tenantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TenantsAdminApiApiV1AdminTenantsTenantIdModePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminTenantsTenantIdModePut(requestParameters: TenantsAdminApiApiV1AdminTenantsTenantIdModePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminTenantDto> {
            return localVarFp.apiV1AdminTenantsTenantIdModePut(requestParameters.tenantId, requestParameters.nexusOpsAppVersion, requestParameters.adminTenantUpdateModeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminTenantsGetPost operation in TenantsAdminApi.
 * @export
 * @interface TenantsAdminApiApiV1AdminTenantsGetPostRequest
 */
export interface TenantsAdminApiApiV1AdminTenantsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantsAdminApiApiV1AdminTenantsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminTenantGetPaginatedDto}
     * @memberof TenantsAdminApiApiV1AdminTenantsGetPost
     */
    readonly adminTenantGetPaginatedDto?: AdminTenantGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminTenantsTargetTenantIdSuspendPost operation in TenantsAdminApi.
 * @export
 * @interface TenantsAdminApiApiV1AdminTenantsTargetTenantIdSuspendPostRequest
 */
export interface TenantsAdminApiApiV1AdminTenantsTargetTenantIdSuspendPostRequest {
    /**
     * 
     * @type {string}
     * @memberof TenantsAdminApiApiV1AdminTenantsTargetTenantIdSuspendPost
     */
    readonly targetTenantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantsAdminApiApiV1AdminTenantsTargetTenantIdSuspendPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantSuspendAdminDto}
     * @memberof TenantsAdminApiApiV1AdminTenantsTargetTenantIdSuspendPost
     */
    readonly tenantSuspendAdminDto?: TenantSuspendAdminDto
}

/**
 * Request parameters for apiV1AdminTenantsTargetTenantIdUnsuspendPost operation in TenantsAdminApi.
 * @export
 * @interface TenantsAdminApiApiV1AdminTenantsTargetTenantIdUnsuspendPostRequest
 */
export interface TenantsAdminApiApiV1AdminTenantsTargetTenantIdUnsuspendPostRequest {
    /**
     * 
     * @type {string}
     * @memberof TenantsAdminApiApiV1AdminTenantsTargetTenantIdUnsuspendPost
     */
    readonly targetTenantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantsAdminApiApiV1AdminTenantsTargetTenantIdUnsuspendPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TenantUnsuspendAdminDto}
     * @memberof TenantsAdminApiApiV1AdminTenantsTargetTenantIdUnsuspendPost
     */
    readonly tenantUnsuspendAdminDto?: TenantUnsuspendAdminDto
}

/**
 * Request parameters for apiV1AdminTenantsTenantIdGet operation in TenantsAdminApi.
 * @export
 * @interface TenantsAdminApiApiV1AdminTenantsTenantIdGetRequest
 */
export interface TenantsAdminApiApiV1AdminTenantsTenantIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TenantsAdminApiApiV1AdminTenantsTenantIdGet
     */
    readonly tenantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantsAdminApiApiV1AdminTenantsTenantIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminTenantsTenantIdModePut operation in TenantsAdminApi.
 * @export
 * @interface TenantsAdminApiApiV1AdminTenantsTenantIdModePutRequest
 */
export interface TenantsAdminApiApiV1AdminTenantsTenantIdModePutRequest {
    /**
     * 
     * @type {string}
     * @memberof TenantsAdminApiApiV1AdminTenantsTenantIdModePut
     */
    readonly tenantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TenantsAdminApiApiV1AdminTenantsTenantIdModePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminTenantUpdateModeDto}
     * @memberof TenantsAdminApiApiV1AdminTenantsTenantIdModePut
     */
    readonly adminTenantUpdateModeDto?: AdminTenantUpdateModeDto
}

/**
 * TenantsAdminApi - object-oriented interface
 * @export
 * @class TenantsAdminApi
 * @extends {BaseAPI}
 */
export class TenantsAdminApi extends BaseAPI {
    /**
     * 
     * @param {TenantsAdminApiApiV1AdminTenantsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsAdminApi
     */
    public apiV1AdminTenantsGetPost(requestParameters: TenantsAdminApiApiV1AdminTenantsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return TenantsAdminApiFp(this.configuration).apiV1AdminTenantsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminTenantGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantsAdminApiApiV1AdminTenantsTargetTenantIdSuspendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsAdminApi
     */
    public apiV1AdminTenantsTargetTenantIdSuspendPost(requestParameters: TenantsAdminApiApiV1AdminTenantsTargetTenantIdSuspendPostRequest, options?: RawAxiosRequestConfig) {
        return TenantsAdminApiFp(this.configuration).apiV1AdminTenantsTargetTenantIdSuspendPost(requestParameters.targetTenantId, requestParameters.nexusOpsAppVersion, requestParameters.tenantSuspendAdminDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantsAdminApiApiV1AdminTenantsTargetTenantIdUnsuspendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsAdminApi
     */
    public apiV1AdminTenantsTargetTenantIdUnsuspendPost(requestParameters: TenantsAdminApiApiV1AdminTenantsTargetTenantIdUnsuspendPostRequest, options?: RawAxiosRequestConfig) {
        return TenantsAdminApiFp(this.configuration).apiV1AdminTenantsTargetTenantIdUnsuspendPost(requestParameters.targetTenantId, requestParameters.nexusOpsAppVersion, requestParameters.tenantUnsuspendAdminDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantsAdminApiApiV1AdminTenantsTenantIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsAdminApi
     */
    public apiV1AdminTenantsTenantIdGet(requestParameters: TenantsAdminApiApiV1AdminTenantsTenantIdGetRequest, options?: RawAxiosRequestConfig) {
        return TenantsAdminApiFp(this.configuration).apiV1AdminTenantsTenantIdGet(requestParameters.tenantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TenantsAdminApiApiV1AdminTenantsTenantIdModePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsAdminApi
     */
    public apiV1AdminTenantsTenantIdModePut(requestParameters: TenantsAdminApiApiV1AdminTenantsTenantIdModePutRequest, options?: RawAxiosRequestConfig) {
        return TenantsAdminApiFp(this.configuration).apiV1AdminTenantsTenantIdModePut(requestParameters.tenantId, requestParameters.nexusOpsAppVersion, requestParameters.adminTenantUpdateModeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserSecretsApi - axios parameter creator
 * @export
 */
export const UserSecretsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userSecretId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserSecretsUserSecretIdValueGet: async (nexusOpsTenant: string, userSecretId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1UserSecretsUserSecretIdValueGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userSecretId' is not null or undefined
            assertParamExists('apiV1UserSecretsUserSecretIdValueGet', 'userSecretId', userSecretId)
            const localVarPath = `/api/v1/user-secrets/{userSecretId}/value`
                .replace(`{${"userSecretId"}}`, encodeURIComponent(String(userSecretId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserSecretsApi - functional programming interface
 * @export
 */
export const UserSecretsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserSecretsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userSecretId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserSecretsUserSecretIdValueGet(nexusOpsTenant: string, userSecretId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSecretValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserSecretsUserSecretIdValueGet(nexusOpsTenant, userSecretId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSecretsApi.apiV1UserSecretsUserSecretIdValueGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserSecretsApi - factory interface
 * @export
 */
export const UserSecretsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserSecretsApiFp(configuration)
    return {
        /**
         * 
         * @param {UserSecretsApiApiV1UserSecretsUserSecretIdValueGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserSecretsUserSecretIdValueGet(requestParameters: UserSecretsApiApiV1UserSecretsUserSecretIdValueGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSecretValueDto> {
            return localVarFp.apiV1UserSecretsUserSecretIdValueGet(requestParameters.nexusOpsTenant, requestParameters.userSecretId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1UserSecretsUserSecretIdValueGet operation in UserSecretsApi.
 * @export
 * @interface UserSecretsApiApiV1UserSecretsUserSecretIdValueGetRequest
 */
export interface UserSecretsApiApiV1UserSecretsUserSecretIdValueGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UserSecretsApiApiV1UserSecretsUserSecretIdValueGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UserSecretsApiApiV1UserSecretsUserSecretIdValueGet
     */
    readonly userSecretId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UserSecretsApiApiV1UserSecretsUserSecretIdValueGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * UserSecretsApi - object-oriented interface
 * @export
 * @class UserSecretsApi
 * @extends {BaseAPI}
 */
export class UserSecretsApi extends BaseAPI {
    /**
     * 
     * @param {UserSecretsApiApiV1UserSecretsUserSecretIdValueGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSecretsApi
     */
    public apiV1UserSecretsUserSecretIdValueGet(requestParameters: UserSecretsApiApiV1UserSecretsUserSecretIdValueGetRequest, options?: RawAxiosRequestConfig) {
        return UserSecretsApiFp(this.configuration).apiV1UserSecretsUserSecretIdValueGet(requestParameters.nexusOpsTenant, requestParameters.userSecretId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByIdsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1UsersByIdsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/users/by-ids/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UserGetPaginatedDto} [userGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, userGetPaginatedDto?: UserGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1UsersGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/users/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} targetUserId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UserSuspendDto} [userSuspendDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersTargetUserIdSuspendPost: async (nexusOpsTenant: string, targetUserId: string, nexusOpsAppVersion?: string, userSuspendDto?: UserSuspendDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1UsersTargetUserIdSuspendPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'targetUserId' is not null or undefined
            assertParamExists('apiV1UsersTargetUserIdSuspendPost', 'targetUserId', targetUserId)
            const localVarPath = `/api/v1/users/{targetUserId}/suspend`
                .replace(`{${"targetUserId"}}`, encodeURIComponent(String(targetUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSuspendDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} targetUserId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UserUnsuspendDto} [userUnsuspendDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersTargetUserIdUnsuspendPost: async (nexusOpsTenant: string, targetUserId: string, nexusOpsAppVersion?: string, userUnsuspendDto?: UserUnsuspendDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1UsersTargetUserIdUnsuspendPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'targetUserId' is not null or undefined
            assertParamExists('apiV1UsersTargetUserIdUnsuspendPost', 'targetUserId', targetUserId)
            const localVarPath = `/api/v1/users/{targetUserId}/unsuspend`
                .replace(`{${"targetUserId"}}`, encodeURIComponent(String(targetUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUnsuspendDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdDelete: async (nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1UsersUserIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1UsersUserIdDelete', 'userId', userId)
            const localVarPath = `/api/v1/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdDepartmentsDepartmentIdDelete: async (nexusOpsTenant: string, userId: string, departmentId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1UsersUserIdDepartmentsDepartmentIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1UsersUserIdDepartmentsDepartmentIdDelete', 'userId', userId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('apiV1UsersUserIdDepartmentsDepartmentIdDelete', 'departmentId', departmentId)
            const localVarPath = `/api/v1/users/{userId}/departments/{departmentId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdDepartmentsDepartmentIdPost: async (nexusOpsTenant: string, userId: string, departmentId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1UsersUserIdDepartmentsDepartmentIdPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1UsersUserIdDepartmentsDepartmentIdPost', 'userId', userId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('apiV1UsersUserIdDepartmentsDepartmentIdPost', 'departmentId', departmentId)
            const localVarPath = `/api/v1/users/{userId}/departments/{departmentId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdDepartmentsGet: async (nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1UsersUserIdDepartmentsGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1UsersUserIdDepartmentsGet', 'userId', userId)
            const localVarPath = `/api/v1/users/{userId}/departments`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdGet: async (nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1UsersUserIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1UsersUserIdGet', 'userId', userId)
            const localVarPath = `/api/v1/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdLocationsGet: async (nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1UsersUserIdLocationsGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1UsersUserIdLocationsGet', 'userId', userId)
            const localVarPath = `/api/v1/users/{userId}/locations`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdLocationsLocationIdDelete: async (nexusOpsTenant: string, userId: string, locationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1UsersUserIdLocationsLocationIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1UsersUserIdLocationsLocationIdDelete', 'userId', userId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiV1UsersUserIdLocationsLocationIdDelete', 'locationId', locationId)
            const localVarPath = `/api/v1/users/{userId}/locations/{locationId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdLocationsLocationIdPost: async (nexusOpsTenant: string, userId: string, locationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1UsersUserIdLocationsLocationIdPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1UsersUserIdLocationsLocationIdPost', 'userId', userId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('apiV1UsersUserIdLocationsLocationIdPost', 'locationId', locationId)
            const localVarPath = `/api/v1/users/{userId}/locations/{locationId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateTenantUserDto} [updateTenantUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdPut: async (nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, updateTenantUserDto?: UpdateTenantUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1UsersUserIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1UsersUserIdPut', 'userId', userId)
            const localVarPath = `/api/v1/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTenantUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersByIdsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersByIdsGetPost(nexusOpsTenant, nexusOpsAppVersion, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiV1UsersByIdsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UserGetPaginatedDto} [userGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, userGetPaginatedDto?: UserGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersGetPost(nexusOpsTenant, nexusOpsAppVersion, userGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiV1UsersGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} targetUserId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UserSuspendDto} [userSuspendDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersTargetUserIdSuspendPost(nexusOpsTenant: string, targetUserId: string, nexusOpsAppVersion?: string, userSuspendDto?: UserSuspendDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersTargetUserIdSuspendPost(nexusOpsTenant, targetUserId, nexusOpsAppVersion, userSuspendDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiV1UsersTargetUserIdSuspendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} targetUserId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UserUnsuspendDto} [userUnsuspendDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersTargetUserIdUnsuspendPost(nexusOpsTenant: string, targetUserId: string, nexusOpsAppVersion?: string, userUnsuspendDto?: UserUnsuspendDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersTargetUserIdUnsuspendPost(nexusOpsTenant, targetUserId, nexusOpsAppVersion, userUnsuspendDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiV1UsersTargetUserIdUnsuspendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersUserIdDelete(nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdDelete(nexusOpsTenant, userId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiV1UsersUserIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersUserIdDepartmentsDepartmentIdDelete(nexusOpsTenant: string, userId: string, departmentId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdDepartmentsDepartmentIdDelete(nexusOpsTenant, userId, departmentId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiV1UsersUserIdDepartmentsDepartmentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} departmentId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersUserIdDepartmentsDepartmentIdPost(nexusOpsTenant: string, userId: string, departmentId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdDepartmentsDepartmentIdPost(nexusOpsTenant, userId, departmentId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiV1UsersUserIdDepartmentsDepartmentIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersUserIdDepartmentsGet(nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DepartmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdDepartmentsGet(nexusOpsTenant, userId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiV1UsersUserIdDepartmentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersUserIdGet(nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdGet(nexusOpsTenant, userId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiV1UsersUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersUserIdLocationsGet(nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdLocationsGet(nexusOpsTenant, userId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiV1UsersUserIdLocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersUserIdLocationsLocationIdDelete(nexusOpsTenant: string, userId: string, locationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdLocationsLocationIdDelete(nexusOpsTenant, userId, locationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiV1UsersUserIdLocationsLocationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} locationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersUserIdLocationsLocationIdPost(nexusOpsTenant: string, userId: string, locationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdLocationsLocationIdPost(nexusOpsTenant, userId, locationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiV1UsersUserIdLocationsLocationIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateTenantUserDto} [updateTenantUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersUserIdPut(nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, updateTenantUserDto?: UpdateTenantUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdPut(nexusOpsTenant, userId, nexusOpsAppVersion, updateTenantUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiV1UsersUserIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {UsersApiApiV1UsersByIdsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByIdsGetPost(requestParameters: UsersApiApiV1UsersByIdsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserDto>> {
            return localVarFp.apiV1UsersByIdsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiV1UsersGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersGetPost(requestParameters: UsersApiApiV1UsersGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfUserDto> {
            return localVarFp.apiV1UsersGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.userGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiV1UsersTargetUserIdSuspendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersTargetUserIdSuspendPost(requestParameters: UsersApiApiV1UsersTargetUserIdSuspendPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.apiV1UsersTargetUserIdSuspendPost(requestParameters.nexusOpsTenant, requestParameters.targetUserId, requestParameters.nexusOpsAppVersion, requestParameters.userSuspendDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiV1UsersTargetUserIdUnsuspendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersTargetUserIdUnsuspendPost(requestParameters: UsersApiApiV1UsersTargetUserIdUnsuspendPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.apiV1UsersTargetUserIdUnsuspendPost(requestParameters.nexusOpsTenant, requestParameters.targetUserId, requestParameters.nexusOpsAppVersion, requestParameters.userUnsuspendDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiV1UsersUserIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdDelete(requestParameters: UsersApiApiV1UsersUserIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1UsersUserIdDelete(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiV1UsersUserIdDepartmentsDepartmentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdDepartmentsDepartmentIdDelete(requestParameters: UsersApiApiV1UsersUserIdDepartmentsDepartmentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.apiV1UsersUserIdDepartmentsDepartmentIdDelete(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiV1UsersUserIdDepartmentsDepartmentIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdDepartmentsDepartmentIdPost(requestParameters: UsersApiApiV1UsersUserIdDepartmentsDepartmentIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.apiV1UsersUserIdDepartmentsDepartmentIdPost(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiV1UsersUserIdDepartmentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdDepartmentsGet(requestParameters: UsersApiApiV1UsersUserIdDepartmentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DepartmentDto>> {
            return localVarFp.apiV1UsersUserIdDepartmentsGet(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiV1UsersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdGet(requestParameters: UsersApiApiV1UsersUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.apiV1UsersUserIdGet(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiV1UsersUserIdLocationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdLocationsGet(requestParameters: UsersApiApiV1UsersUserIdLocationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<LocationDto>> {
            return localVarFp.apiV1UsersUserIdLocationsGet(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiV1UsersUserIdLocationsLocationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdLocationsLocationIdDelete(requestParameters: UsersApiApiV1UsersUserIdLocationsLocationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.apiV1UsersUserIdLocationsLocationIdDelete(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.locationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiV1UsersUserIdLocationsLocationIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdLocationsLocationIdPost(requestParameters: UsersApiApiV1UsersUserIdLocationsLocationIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.apiV1UsersUserIdLocationsLocationIdPost(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.locationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiApiV1UsersUserIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersUserIdPut(requestParameters: UsersApiApiV1UsersUserIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.apiV1UsersUserIdPut(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, requestParameters.updateTenantUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1UsersByIdsGetPost operation in UsersApi.
 * @export
 * @interface UsersApiApiV1UsersByIdsGetPostRequest
 */
export interface UsersApiApiV1UsersByIdsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersApiApiV1UsersByIdsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersApiApiV1UsersByIdsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof UsersApiApiV1UsersByIdsGetPost
     */
    readonly requestBody?: Array<string>
}

/**
 * Request parameters for apiV1UsersGetPost operation in UsersApi.
 * @export
 * @interface UsersApiApiV1UsersGetPostRequest
 */
export interface UsersApiApiV1UsersGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersApiApiV1UsersGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersApiApiV1UsersGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UserGetPaginatedDto}
     * @memberof UsersApiApiV1UsersGetPost
     */
    readonly userGetPaginatedDto?: UserGetPaginatedDto
}

/**
 * Request parameters for apiV1UsersTargetUserIdSuspendPost operation in UsersApi.
 * @export
 * @interface UsersApiApiV1UsersTargetUserIdSuspendPostRequest
 */
export interface UsersApiApiV1UsersTargetUserIdSuspendPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersApiApiV1UsersTargetUserIdSuspendPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersTargetUserIdSuspendPost
     */
    readonly targetUserId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersApiApiV1UsersTargetUserIdSuspendPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UserSuspendDto}
     * @memberof UsersApiApiV1UsersTargetUserIdSuspendPost
     */
    readonly userSuspendDto?: UserSuspendDto
}

/**
 * Request parameters for apiV1UsersTargetUserIdUnsuspendPost operation in UsersApi.
 * @export
 * @interface UsersApiApiV1UsersTargetUserIdUnsuspendPostRequest
 */
export interface UsersApiApiV1UsersTargetUserIdUnsuspendPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersApiApiV1UsersTargetUserIdUnsuspendPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersTargetUserIdUnsuspendPost
     */
    readonly targetUserId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersApiApiV1UsersTargetUserIdUnsuspendPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UserUnsuspendDto}
     * @memberof UsersApiApiV1UsersTargetUserIdUnsuspendPost
     */
    readonly userUnsuspendDto?: UserUnsuspendDto
}

/**
 * Request parameters for apiV1UsersUserIdDelete operation in UsersApi.
 * @export
 * @interface UsersApiApiV1UsersUserIdDeleteRequest
 */
export interface UsersApiApiV1UsersUserIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdDelete
     */
    readonly userId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1UsersUserIdDepartmentsDepartmentIdDelete operation in UsersApi.
 * @export
 * @interface UsersApiApiV1UsersUserIdDepartmentsDepartmentIdDeleteRequest
 */
export interface UsersApiApiV1UsersUserIdDepartmentsDepartmentIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdDepartmentsDepartmentIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdDepartmentsDepartmentIdDelete
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdDepartmentsDepartmentIdDelete
     */
    readonly departmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdDepartmentsDepartmentIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1UsersUserIdDepartmentsDepartmentIdPost operation in UsersApi.
 * @export
 * @interface UsersApiApiV1UsersUserIdDepartmentsDepartmentIdPostRequest
 */
export interface UsersApiApiV1UsersUserIdDepartmentsDepartmentIdPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdDepartmentsDepartmentIdPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdDepartmentsDepartmentIdPost
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdDepartmentsDepartmentIdPost
     */
    readonly departmentId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdDepartmentsDepartmentIdPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1UsersUserIdDepartmentsGet operation in UsersApi.
 * @export
 * @interface UsersApiApiV1UsersUserIdDepartmentsGetRequest
 */
export interface UsersApiApiV1UsersUserIdDepartmentsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdDepartmentsGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdDepartmentsGet
     */
    readonly userId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdDepartmentsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1UsersUserIdGet operation in UsersApi.
 * @export
 * @interface UsersApiApiV1UsersUserIdGetRequest
 */
export interface UsersApiApiV1UsersUserIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdGet
     */
    readonly userId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1UsersUserIdLocationsGet operation in UsersApi.
 * @export
 * @interface UsersApiApiV1UsersUserIdLocationsGetRequest
 */
export interface UsersApiApiV1UsersUserIdLocationsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdLocationsGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdLocationsGet
     */
    readonly userId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdLocationsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1UsersUserIdLocationsLocationIdDelete operation in UsersApi.
 * @export
 * @interface UsersApiApiV1UsersUserIdLocationsLocationIdDeleteRequest
 */
export interface UsersApiApiV1UsersUserIdLocationsLocationIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdLocationsLocationIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdLocationsLocationIdDelete
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdLocationsLocationIdDelete
     */
    readonly locationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdLocationsLocationIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1UsersUserIdLocationsLocationIdPost operation in UsersApi.
 * @export
 * @interface UsersApiApiV1UsersUserIdLocationsLocationIdPostRequest
 */
export interface UsersApiApiV1UsersUserIdLocationsLocationIdPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdLocationsLocationIdPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdLocationsLocationIdPost
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdLocationsLocationIdPost
     */
    readonly locationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdLocationsLocationIdPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1UsersUserIdPut operation in UsersApi.
 * @export
 * @interface UsersApiApiV1UsersUserIdPutRequest
 */
export interface UsersApiApiV1UsersUserIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdPut
     */
    readonly userId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersApiApiV1UsersUserIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateTenantUserDto}
     * @memberof UsersApiApiV1UsersUserIdPut
     */
    readonly updateTenantUserDto?: UpdateTenantUserDto
}

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {UsersApiApiV1UsersByIdsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersByIdsGetPost(requestParameters: UsersApiApiV1UsersByIdsGetPostRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiV1UsersByIdsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiV1UsersGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersGetPost(requestParameters: UsersApiApiV1UsersGetPostRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiV1UsersGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.userGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiV1UsersTargetUserIdSuspendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersTargetUserIdSuspendPost(requestParameters: UsersApiApiV1UsersTargetUserIdSuspendPostRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiV1UsersTargetUserIdSuspendPost(requestParameters.nexusOpsTenant, requestParameters.targetUserId, requestParameters.nexusOpsAppVersion, requestParameters.userSuspendDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiV1UsersTargetUserIdUnsuspendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersTargetUserIdUnsuspendPost(requestParameters: UsersApiApiV1UsersTargetUserIdUnsuspendPostRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiV1UsersTargetUserIdUnsuspendPost(requestParameters.nexusOpsTenant, requestParameters.targetUserId, requestParameters.nexusOpsAppVersion, requestParameters.userUnsuspendDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiV1UsersUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersUserIdDelete(requestParameters: UsersApiApiV1UsersUserIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiV1UsersUserIdDelete(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiV1UsersUserIdDepartmentsDepartmentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersUserIdDepartmentsDepartmentIdDelete(requestParameters: UsersApiApiV1UsersUserIdDepartmentsDepartmentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiV1UsersUserIdDepartmentsDepartmentIdDelete(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiV1UsersUserIdDepartmentsDepartmentIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersUserIdDepartmentsDepartmentIdPost(requestParameters: UsersApiApiV1UsersUserIdDepartmentsDepartmentIdPostRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiV1UsersUserIdDepartmentsDepartmentIdPost(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.departmentId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiV1UsersUserIdDepartmentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersUserIdDepartmentsGet(requestParameters: UsersApiApiV1UsersUserIdDepartmentsGetRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiV1UsersUserIdDepartmentsGet(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiV1UsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersUserIdGet(requestParameters: UsersApiApiV1UsersUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiV1UsersUserIdGet(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiV1UsersUserIdLocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersUserIdLocationsGet(requestParameters: UsersApiApiV1UsersUserIdLocationsGetRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiV1UsersUserIdLocationsGet(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiV1UsersUserIdLocationsLocationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersUserIdLocationsLocationIdDelete(requestParameters: UsersApiApiV1UsersUserIdLocationsLocationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiV1UsersUserIdLocationsLocationIdDelete(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.locationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiV1UsersUserIdLocationsLocationIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersUserIdLocationsLocationIdPost(requestParameters: UsersApiApiV1UsersUserIdLocationsLocationIdPostRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiV1UsersUserIdLocationsLocationIdPost(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.locationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiApiV1UsersUserIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersUserIdPut(requestParameters: UsersApiApiV1UsersUserIdPutRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiV1UsersUserIdPut(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, requestParameters.updateTenantUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersAdminApi - axios parameter creator
 * @export
 */
export const UsersAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUserGetPaginatedDto} [adminUserGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, adminUserGetPaginatedDto?: AdminUserGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AdminUsersGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/admin/users/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUserGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} targetUserId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUserActivateDto} [adminUserActivateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersTargetUserIdActivatePost: async (nexusOpsTenant: string, targetUserId: string, nexusOpsAppVersion?: string, adminUserActivateDto?: AdminUserActivateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AdminUsersTargetUserIdActivatePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'targetUserId' is not null or undefined
            assertParamExists('apiV1AdminUsersTargetUserIdActivatePost', 'targetUserId', targetUserId)
            const localVarPath = `/api/v1/admin/users/{targetUserId}/activate`
                .replace(`{${"targetUserId"}}`, encodeURIComponent(String(targetUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUserActivateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} targetUserId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersTargetUserIdIdentityCacheDelete: async (nexusOpsTenant: string, targetUserId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AdminUsersTargetUserIdIdentityCacheDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'targetUserId' is not null or undefined
            assertParamExists('apiV1AdminUsersTargetUserIdIdentityCacheDelete', 'targetUserId', targetUserId)
            const localVarPath = `/api/v1/admin/users/{targetUserId}/identity/cache`
                .replace(`{${"targetUserId"}}`, encodeURIComponent(String(targetUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} targetUserId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUserSuspendDto} [adminUserSuspendDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersTargetUserIdSuspendPost: async (nexusOpsTenant: string, targetUserId: string, nexusOpsAppVersion?: string, adminUserSuspendDto?: AdminUserSuspendDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AdminUsersTargetUserIdSuspendPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'targetUserId' is not null or undefined
            assertParamExists('apiV1AdminUsersTargetUserIdSuspendPost', 'targetUserId', targetUserId)
            const localVarPath = `/api/v1/admin/users/{targetUserId}/suspend`
                .replace(`{${"targetUserId"}}`, encodeURIComponent(String(targetUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUserSuspendDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} targetUserId 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersTargetUserIdTenantTenantIdDelete: async (nexusOpsTenant: string, targetUserId: string, tenantId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AdminUsersTargetUserIdTenantTenantIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'targetUserId' is not null or undefined
            assertParamExists('apiV1AdminUsersTargetUserIdTenantTenantIdDelete', 'targetUserId', targetUserId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiV1AdminUsersTargetUserIdTenantTenantIdDelete', 'tenantId', tenantId)
            const localVarPath = `/api/v1/admin/users/{targetUserId}/tenant/{tenantId}`
                .replace(`{${"targetUserId"}}`, encodeURIComponent(String(targetUserId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} targetUserId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUserUnsuspendDto} [adminUserUnsuspendDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersTargetUserIdUnsuspendPost: async (nexusOpsTenant: string, targetUserId: string, nexusOpsAppVersion?: string, adminUserUnsuspendDto?: AdminUserUnsuspendDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AdminUsersTargetUserIdUnsuspendPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'targetUserId' is not null or undefined
            assertParamExists('apiV1AdminUsersTargetUserIdUnsuspendPost', 'targetUserId', targetUserId)
            const localVarPath = `/api/v1/admin/users/{targetUserId}/unsuspend`
                .replace(`{${"targetUserId"}}`, encodeURIComponent(String(targetUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUserUnsuspendDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminAddUserToTenantDto} [adminAddUserToTenantDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersTenantPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, adminAddUserToTenantDto?: AdminAddUserToTenantDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AdminUsersTenantPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/admin/users/tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminAddUserToTenantDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersUserIdGet: async (nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AdminUsersUserIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1AdminUsersUserIdGet', 'userId', userId)
            const localVarPath = `/api/v1/admin/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateAdminUserDto} [updateAdminUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersUserIdPut: async (nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, updateAdminUserDto?: UpdateAdminUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AdminUsersUserIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1AdminUsersUserIdPut', 'userId', userId)
            const localVarPath = `/api/v1/admin/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAdminUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersUserIdTenantTenantIdDepartmentsGet: async (nexusOpsTenant: string, userId: string, tenantId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AdminUsersUserIdTenantTenantIdDepartmentsGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1AdminUsersUserIdTenantTenantIdDepartmentsGet', 'userId', userId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiV1AdminUsersUserIdTenantTenantIdDepartmentsGet', 'tenantId', tenantId)
            const localVarPath = `/api/v1/admin/users/{userId}/tenant/{tenantId}/departments`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersUserIdTenantTenantIdLocationsGet: async (nexusOpsTenant: string, userId: string, tenantId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1AdminUsersUserIdTenantTenantIdLocationsGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiV1AdminUsersUserIdTenantTenantIdLocationsGet', 'userId', userId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiV1AdminUsersUserIdTenantTenantIdLocationsGet', 'tenantId', tenantId)
            const localVarPath = `/api/v1/admin/users/{userId}/tenant/{tenantId}/locations`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersAdminApi - functional programming interface
 * @export
 */
export const UsersAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUserGetPaginatedDto} [adminUserGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminUsersGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, adminUserGetPaginatedDto?: AdminUserGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersGetPost(nexusOpsTenant, nexusOpsAppVersion, adminUserGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersAdminApi.apiV1AdminUsersGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} targetUserId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUserActivateDto} [adminUserActivateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminUsersTargetUserIdActivatePost(nexusOpsTenant: string, targetUserId: string, nexusOpsAppVersion?: string, adminUserActivateDto?: AdminUserActivateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersTargetUserIdActivatePost(nexusOpsTenant, targetUserId, nexusOpsAppVersion, adminUserActivateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersAdminApi.apiV1AdminUsersTargetUserIdActivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} targetUserId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminUsersTargetUserIdIdentityCacheDelete(nexusOpsTenant: string, targetUserId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersTargetUserIdIdentityCacheDelete(nexusOpsTenant, targetUserId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersAdminApi.apiV1AdminUsersTargetUserIdIdentityCacheDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} targetUserId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUserSuspendDto} [adminUserSuspendDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminUsersTargetUserIdSuspendPost(nexusOpsTenant: string, targetUserId: string, nexusOpsAppVersion?: string, adminUserSuspendDto?: AdminUserSuspendDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersTargetUserIdSuspendPost(nexusOpsTenant, targetUserId, nexusOpsAppVersion, adminUserSuspendDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersAdminApi.apiV1AdminUsersTargetUserIdSuspendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} targetUserId 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminUsersTargetUserIdTenantTenantIdDelete(nexusOpsTenant: string, targetUserId: string, tenantId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersTargetUserIdTenantTenantIdDelete(nexusOpsTenant, targetUserId, tenantId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersAdminApi.apiV1AdminUsersTargetUserIdTenantTenantIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} targetUserId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUserUnsuspendDto} [adminUserUnsuspendDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminUsersTargetUserIdUnsuspendPost(nexusOpsTenant: string, targetUserId: string, nexusOpsAppVersion?: string, adminUserUnsuspendDto?: AdminUserUnsuspendDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersTargetUserIdUnsuspendPost(nexusOpsTenant, targetUserId, nexusOpsAppVersion, adminUserUnsuspendDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersAdminApi.apiV1AdminUsersTargetUserIdUnsuspendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminAddUserToTenantDto} [adminAddUserToTenantDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminUsersTenantPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, adminAddUserToTenantDto?: AdminAddUserToTenantDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersTenantPost(nexusOpsTenant, nexusOpsAppVersion, adminAddUserToTenantDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersAdminApi.apiV1AdminUsersTenantPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminUsersUserIdGet(nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersUserIdGet(nexusOpsTenant, userId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersAdminApi.apiV1AdminUsersUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateAdminUserDto} [updateAdminUserDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminUsersUserIdPut(nexusOpsTenant: string, userId: string, nexusOpsAppVersion?: string, updateAdminUserDto?: UpdateAdminUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersUserIdPut(nexusOpsTenant, userId, nexusOpsAppVersion, updateAdminUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersAdminApi.apiV1AdminUsersUserIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminUsersUserIdTenantTenantIdDepartmentsGet(nexusOpsTenant: string, userId: string, tenantId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DepartmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersUserIdTenantTenantIdDepartmentsGet(nexusOpsTenant, userId, tenantId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersAdminApi.apiV1AdminUsersUserIdTenantTenantIdDepartmentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} userId 
         * @param {string} tenantId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminUsersUserIdTenantTenantIdLocationsGet(nexusOpsTenant: string, userId: string, tenantId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersUserIdTenantTenantIdLocationsGet(nexusOpsTenant, userId, tenantId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersAdminApi.apiV1AdminUsersUserIdTenantTenantIdLocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersAdminApi - factory interface
 * @export
 */
export const UsersAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {UsersAdminApiApiV1AdminUsersGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersGetPost(requestParameters: UsersAdminApiApiV1AdminUsersGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminUserDto> {
            return localVarFp.apiV1AdminUsersGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.adminUserGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersAdminApiApiV1AdminUsersTargetUserIdActivatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersTargetUserIdActivatePost(requestParameters: UsersAdminApiApiV1AdminUsersTargetUserIdActivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserDto> {
            return localVarFp.apiV1AdminUsersTargetUserIdActivatePost(requestParameters.nexusOpsTenant, requestParameters.targetUserId, requestParameters.nexusOpsAppVersion, requestParameters.adminUserActivateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersAdminApiApiV1AdminUsersTargetUserIdIdentityCacheDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersTargetUserIdIdentityCacheDelete(requestParameters: UsersAdminApiApiV1AdminUsersTargetUserIdIdentityCacheDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminUsersTargetUserIdIdentityCacheDelete(requestParameters.nexusOpsTenant, requestParameters.targetUserId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersAdminApiApiV1AdminUsersTargetUserIdSuspendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersTargetUserIdSuspendPost(requestParameters: UsersAdminApiApiV1AdminUsersTargetUserIdSuspendPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserDto> {
            return localVarFp.apiV1AdminUsersTargetUserIdSuspendPost(requestParameters.nexusOpsTenant, requestParameters.targetUserId, requestParameters.nexusOpsAppVersion, requestParameters.adminUserSuspendDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersAdminApiApiV1AdminUsersTargetUserIdTenantTenantIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersTargetUserIdTenantTenantIdDelete(requestParameters: UsersAdminApiApiV1AdminUsersTargetUserIdTenantTenantIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminUsersTargetUserIdTenantTenantIdDelete(requestParameters.nexusOpsTenant, requestParameters.targetUserId, requestParameters.tenantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersAdminApiApiV1AdminUsersTargetUserIdUnsuspendPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersTargetUserIdUnsuspendPost(requestParameters: UsersAdminApiApiV1AdminUsersTargetUserIdUnsuspendPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserDto> {
            return localVarFp.apiV1AdminUsersTargetUserIdUnsuspendPost(requestParameters.nexusOpsTenant, requestParameters.targetUserId, requestParameters.nexusOpsAppVersion, requestParameters.adminUserUnsuspendDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersAdminApiApiV1AdminUsersTenantPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersTenantPost(requestParameters: UsersAdminApiApiV1AdminUsersTenantPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserDto> {
            return localVarFp.apiV1AdminUsersTenantPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.adminAddUserToTenantDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersAdminApiApiV1AdminUsersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersUserIdGet(requestParameters: UsersAdminApiApiV1AdminUsersUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserDto> {
            return localVarFp.apiV1AdminUsersUserIdGet(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersAdminApiApiV1AdminUsersUserIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersUserIdPut(requestParameters: UsersAdminApiApiV1AdminUsersUserIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserDto> {
            return localVarFp.apiV1AdminUsersUserIdPut(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, requestParameters.updateAdminUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdDepartmentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersUserIdTenantTenantIdDepartmentsGet(requestParameters: UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdDepartmentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DepartmentDto>> {
            return localVarFp.apiV1AdminUsersUserIdTenantTenantIdDepartmentsGet(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.tenantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdLocationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUsersUserIdTenantTenantIdLocationsGet(requestParameters: UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdLocationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<LocationDto>> {
            return localVarFp.apiV1AdminUsersUserIdTenantTenantIdLocationsGet(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.tenantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminUsersGetPost operation in UsersAdminApi.
 * @export
 * @interface UsersAdminApiApiV1AdminUsersGetPostRequest
 */
export interface UsersAdminApiApiV1AdminUsersGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUserGetPaginatedDto}
     * @memberof UsersAdminApiApiV1AdminUsersGetPost
     */
    readonly adminUserGetPaginatedDto?: AdminUserGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminUsersTargetUserIdActivatePost operation in UsersAdminApi.
 * @export
 * @interface UsersAdminApiApiV1AdminUsersTargetUserIdActivatePostRequest
 */
export interface UsersAdminApiApiV1AdminUsersTargetUserIdActivatePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdActivatePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdActivatePost
     */
    readonly targetUserId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdActivatePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUserActivateDto}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdActivatePost
     */
    readonly adminUserActivateDto?: AdminUserActivateDto
}

/**
 * Request parameters for apiV1AdminUsersTargetUserIdIdentityCacheDelete operation in UsersAdminApi.
 * @export
 * @interface UsersAdminApiApiV1AdminUsersTargetUserIdIdentityCacheDeleteRequest
 */
export interface UsersAdminApiApiV1AdminUsersTargetUserIdIdentityCacheDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdIdentityCacheDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdIdentityCacheDelete
     */
    readonly targetUserId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdIdentityCacheDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminUsersTargetUserIdSuspendPost operation in UsersAdminApi.
 * @export
 * @interface UsersAdminApiApiV1AdminUsersTargetUserIdSuspendPostRequest
 */
export interface UsersAdminApiApiV1AdminUsersTargetUserIdSuspendPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdSuspendPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdSuspendPost
     */
    readonly targetUserId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdSuspendPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUserSuspendDto}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdSuspendPost
     */
    readonly adminUserSuspendDto?: AdminUserSuspendDto
}

/**
 * Request parameters for apiV1AdminUsersTargetUserIdTenantTenantIdDelete operation in UsersAdminApi.
 * @export
 * @interface UsersAdminApiApiV1AdminUsersTargetUserIdTenantTenantIdDeleteRequest
 */
export interface UsersAdminApiApiV1AdminUsersTargetUserIdTenantTenantIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdTenantTenantIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdTenantTenantIdDelete
     */
    readonly targetUserId: string

    /**
     * 
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdTenantTenantIdDelete
     */
    readonly tenantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdTenantTenantIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminUsersTargetUserIdUnsuspendPost operation in UsersAdminApi.
 * @export
 * @interface UsersAdminApiApiV1AdminUsersTargetUserIdUnsuspendPostRequest
 */
export interface UsersAdminApiApiV1AdminUsersTargetUserIdUnsuspendPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdUnsuspendPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdUnsuspendPost
     */
    readonly targetUserId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdUnsuspendPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUserUnsuspendDto}
     * @memberof UsersAdminApiApiV1AdminUsersTargetUserIdUnsuspendPost
     */
    readonly adminUserUnsuspendDto?: AdminUserUnsuspendDto
}

/**
 * Request parameters for apiV1AdminUsersTenantPost operation in UsersAdminApi.
 * @export
 * @interface UsersAdminApiApiV1AdminUsersTenantPostRequest
 */
export interface UsersAdminApiApiV1AdminUsersTenantPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTenantPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersTenantPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminAddUserToTenantDto}
     * @memberof UsersAdminApiApiV1AdminUsersTenantPost
     */
    readonly adminAddUserToTenantDto?: AdminAddUserToTenantDto
}

/**
 * Request parameters for apiV1AdminUsersUserIdGet operation in UsersAdminApi.
 * @export
 * @interface UsersAdminApiApiV1AdminUsersUserIdGetRequest
 */
export interface UsersAdminApiApiV1AdminUsersUserIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdGet
     */
    readonly userId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminUsersUserIdPut operation in UsersAdminApi.
 * @export
 * @interface UsersAdminApiApiV1AdminUsersUserIdPutRequest
 */
export interface UsersAdminApiApiV1AdminUsersUserIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdPut
     */
    readonly userId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateAdminUserDto}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdPut
     */
    readonly updateAdminUserDto?: UpdateAdminUserDto
}

/**
 * Request parameters for apiV1AdminUsersUserIdTenantTenantIdDepartmentsGet operation in UsersAdminApi.
 * @export
 * @interface UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdDepartmentsGetRequest
 */
export interface UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdDepartmentsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdDepartmentsGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdDepartmentsGet
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdDepartmentsGet
     */
    readonly tenantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdDepartmentsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminUsersUserIdTenantTenantIdLocationsGet operation in UsersAdminApi.
 * @export
 * @interface UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdLocationsGetRequest
 */
export interface UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdLocationsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdLocationsGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdLocationsGet
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdLocationsGet
     */
    readonly tenantId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdLocationsGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * UsersAdminApi - object-oriented interface
 * @export
 * @class UsersAdminApi
 * @extends {BaseAPI}
 */
export class UsersAdminApi extends BaseAPI {
    /**
     * 
     * @param {UsersAdminApiApiV1AdminUsersGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public apiV1AdminUsersGetPost(requestParameters: UsersAdminApiApiV1AdminUsersGetPostRequest, options?: RawAxiosRequestConfig) {
        return UsersAdminApiFp(this.configuration).apiV1AdminUsersGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.adminUserGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersAdminApiApiV1AdminUsersTargetUserIdActivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public apiV1AdminUsersTargetUserIdActivatePost(requestParameters: UsersAdminApiApiV1AdminUsersTargetUserIdActivatePostRequest, options?: RawAxiosRequestConfig) {
        return UsersAdminApiFp(this.configuration).apiV1AdminUsersTargetUserIdActivatePost(requestParameters.nexusOpsTenant, requestParameters.targetUserId, requestParameters.nexusOpsAppVersion, requestParameters.adminUserActivateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersAdminApiApiV1AdminUsersTargetUserIdIdentityCacheDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public apiV1AdminUsersTargetUserIdIdentityCacheDelete(requestParameters: UsersAdminApiApiV1AdminUsersTargetUserIdIdentityCacheDeleteRequest, options?: RawAxiosRequestConfig) {
        return UsersAdminApiFp(this.configuration).apiV1AdminUsersTargetUserIdIdentityCacheDelete(requestParameters.nexusOpsTenant, requestParameters.targetUserId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersAdminApiApiV1AdminUsersTargetUserIdSuspendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public apiV1AdminUsersTargetUserIdSuspendPost(requestParameters: UsersAdminApiApiV1AdminUsersTargetUserIdSuspendPostRequest, options?: RawAxiosRequestConfig) {
        return UsersAdminApiFp(this.configuration).apiV1AdminUsersTargetUserIdSuspendPost(requestParameters.nexusOpsTenant, requestParameters.targetUserId, requestParameters.nexusOpsAppVersion, requestParameters.adminUserSuspendDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersAdminApiApiV1AdminUsersTargetUserIdTenantTenantIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public apiV1AdminUsersTargetUserIdTenantTenantIdDelete(requestParameters: UsersAdminApiApiV1AdminUsersTargetUserIdTenantTenantIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return UsersAdminApiFp(this.configuration).apiV1AdminUsersTargetUserIdTenantTenantIdDelete(requestParameters.nexusOpsTenant, requestParameters.targetUserId, requestParameters.tenantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersAdminApiApiV1AdminUsersTargetUserIdUnsuspendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public apiV1AdminUsersTargetUserIdUnsuspendPost(requestParameters: UsersAdminApiApiV1AdminUsersTargetUserIdUnsuspendPostRequest, options?: RawAxiosRequestConfig) {
        return UsersAdminApiFp(this.configuration).apiV1AdminUsersTargetUserIdUnsuspendPost(requestParameters.nexusOpsTenant, requestParameters.targetUserId, requestParameters.nexusOpsAppVersion, requestParameters.adminUserUnsuspendDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersAdminApiApiV1AdminUsersTenantPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public apiV1AdminUsersTenantPost(requestParameters: UsersAdminApiApiV1AdminUsersTenantPostRequest, options?: RawAxiosRequestConfig) {
        return UsersAdminApiFp(this.configuration).apiV1AdminUsersTenantPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.adminAddUserToTenantDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersAdminApiApiV1AdminUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public apiV1AdminUsersUserIdGet(requestParameters: UsersAdminApiApiV1AdminUsersUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return UsersAdminApiFp(this.configuration).apiV1AdminUsersUserIdGet(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersAdminApiApiV1AdminUsersUserIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public apiV1AdminUsersUserIdPut(requestParameters: UsersAdminApiApiV1AdminUsersUserIdPutRequest, options?: RawAxiosRequestConfig) {
        return UsersAdminApiFp(this.configuration).apiV1AdminUsersUserIdPut(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.nexusOpsAppVersion, requestParameters.updateAdminUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdDepartmentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public apiV1AdminUsersUserIdTenantTenantIdDepartmentsGet(requestParameters: UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdDepartmentsGetRequest, options?: RawAxiosRequestConfig) {
        return UsersAdminApiFp(this.configuration).apiV1AdminUsersUserIdTenantTenantIdDepartmentsGet(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.tenantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdLocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public apiV1AdminUsersUserIdTenantTenantIdLocationsGet(requestParameters: UsersAdminApiApiV1AdminUsersUserIdTenantTenantIdLocationsGetRequest, options?: RawAxiosRequestConfig) {
        return UsersAdminApiFp(this.configuration).apiV1AdminUsersUserIdTenantTenantIdLocationsGet(requestParameters.nexusOpsTenant, requestParameters.userId, requestParameters.tenantId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleBodyTypesApi - axios parameter creator
 * @export
 */
export const VehicleBodyTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleBodyTypeGetPaginatedDto} [vehicleBodyTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesBodyTypesGetPost: async (nexusOpsAppVersion?: string, vehicleBodyTypeGetPaginatedDto?: VehicleBodyTypeGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/vehicles/body-types/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleBodyTypeGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} vehicleBodyTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGet: async (vehicleBodyTypeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleBodyTypeId' is not null or undefined
            assertParamExists('apiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGet', 'vehicleBodyTypeId', vehicleBodyTypeId)
            const localVarPath = `/api/v1/reference-data/vehicles/body-types/{vehicleBodyTypeId}`
                .replace(`{${"vehicleBodyTypeId"}}`, encodeURIComponent(String(vehicleBodyTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleBodyTypesApi - functional programming interface
 * @export
 */
export const VehicleBodyTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleBodyTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleBodyTypeGetPaginatedDto} [vehicleBodyTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesBodyTypesGetPost(nexusOpsAppVersion?: string, vehicleBodyTypeGetPaginatedDto?: VehicleBodyTypeGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfVehicleBodyTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesBodyTypesGetPost(nexusOpsAppVersion, vehicleBodyTypeGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleBodyTypesApi.apiV1ReferenceDataVehiclesBodyTypesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} vehicleBodyTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGet(vehicleBodyTypeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleBodyTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGet(vehicleBodyTypeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleBodyTypesApi.apiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleBodyTypesApi - factory interface
 * @export
 */
export const VehicleBodyTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleBodyTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesBodyTypesGetPost(requestParameters: VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfVehicleBodyTypeDto> {
            return localVarFp.apiV1ReferenceDataVehiclesBodyTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleBodyTypeGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGet(requestParameters: VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleBodyTypeDto> {
            return localVarFp.apiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGet(requestParameters.vehicleBodyTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ReferenceDataVehiclesBodyTypesGetPost operation in VehicleBodyTypesApi.
 * @export
 * @interface VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesGetPostRequest
 */
export interface VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleBodyTypeGetPaginatedDto}
     * @memberof VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesGetPost
     */
    readonly vehicleBodyTypeGetPaginatedDto?: VehicleBodyTypeGetPaginatedDto
}

/**
 * Request parameters for apiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGet operation in VehicleBodyTypesApi.
 * @export
 * @interface VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGetRequest
 */
export interface VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGet
     */
    readonly vehicleBodyTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * VehicleBodyTypesApi - object-oriented interface
 * @export
 * @class VehicleBodyTypesApi
 * @extends {BaseAPI}
 */
export class VehicleBodyTypesApi extends BaseAPI {
    /**
     * 
     * @param {VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleBodyTypesApi
     */
    public apiV1ReferenceDataVehiclesBodyTypesGetPost(requestParameters: VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleBodyTypesApiFp(this.configuration).apiV1ReferenceDataVehiclesBodyTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleBodyTypeGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleBodyTypesApi
     */
    public apiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGet(requestParameters: VehicleBodyTypesApiApiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleBodyTypesApiFp(this.configuration).apiV1ReferenceDataVehiclesBodyTypesVehicleBodyTypeIdGet(requestParameters.vehicleBodyTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleBodyTypesAdminApi - axios parameter creator
 * @export
 */
export const VehicleBodyTypesAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} bodyTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDelete: async (bodyTypeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bodyTypeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDelete', 'bodyTypeId', bodyTypeId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/body-types/{bodyTypeId}`
                .replace(`{${"bodyTypeId"}}`, encodeURIComponent(String(bodyTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bodyTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGet: async (bodyTypeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bodyTypeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGet', 'bodyTypeId', bodyTypeId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/body-types/{bodyTypeId}`
                .replace(`{${"bodyTypeId"}}`, encodeURIComponent(String(bodyTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bodyTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleBodyTypeDto} [adminUpdateVehicleBodyTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPut: async (bodyTypeId: string, nexusOpsAppVersion?: string, adminUpdateVehicleBodyTypeDto?: AdminUpdateVehicleBodyTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bodyTypeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPut', 'bodyTypeId', bodyTypeId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/body-types/{bodyTypeId}`
                .replace(`{${"bodyTypeId"}}`, encodeURIComponent(String(bodyTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateVehicleBodyTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleBodyTypeGetPaginatedDto} [adminVehicleBodyTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesBodyTypesGetPost: async (nexusOpsAppVersion?: string, adminVehicleBodyTypeGetPaginatedDto?: AdminVehicleBodyTypeGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/body-types/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminVehicleBodyTypeGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleBodyTypeDto} [adminCreateVehicleBodyTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesBodyTypesPost: async (nexusOpsAppVersion?: string, adminCreateVehicleBodyTypeDto?: AdminCreateVehicleBodyTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/body-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateVehicleBodyTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleBodyTypesAdminApi - functional programming interface
 * @export
 */
export const VehicleBodyTypesAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleBodyTypesAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} bodyTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDelete(bodyTypeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDelete(bodyTypeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleBodyTypesAdminApi.apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bodyTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGet(bodyTypeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleBodyTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGet(bodyTypeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleBodyTypesAdminApi.apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bodyTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleBodyTypeDto} [adminUpdateVehicleBodyTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPut(bodyTypeId: string, nexusOpsAppVersion?: string, adminUpdateVehicleBodyTypeDto?: AdminUpdateVehicleBodyTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleBodyTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPut(bodyTypeId, nexusOpsAppVersion, adminUpdateVehicleBodyTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleBodyTypesAdminApi.apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleBodyTypeGetPaginatedDto} [adminVehicleBodyTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesBodyTypesGetPost(nexusOpsAppVersion?: string, adminVehicleBodyTypeGetPaginatedDto?: AdminVehicleBodyTypeGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminVehicleBodyTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesBodyTypesGetPost(nexusOpsAppVersion, adminVehicleBodyTypeGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleBodyTypesAdminApi.apiV1AdminReferenceDataVehiclesBodyTypesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleBodyTypeDto} [adminCreateVehicleBodyTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesBodyTypesPost(nexusOpsAppVersion?: string, adminCreateVehicleBodyTypeDto?: AdminCreateVehicleBodyTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleBodyTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesBodyTypesPost(nexusOpsAppVersion, adminCreateVehicleBodyTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleBodyTypesAdminApi.apiV1AdminReferenceDataVehiclesBodyTypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleBodyTypesAdminApi - factory interface
 * @export
 */
export const VehicleBodyTypesAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleBodyTypesAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDelete(requestParameters: VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDelete(requestParameters.bodyTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGet(requestParameters: VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleBodyTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGet(requestParameters.bodyTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPut(requestParameters: VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleBodyTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPut(requestParameters.bodyTypeId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleBodyTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesBodyTypesGetPost(requestParameters: VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminVehicleBodyTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesBodyTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleBodyTypeGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesBodyTypesPost(requestParameters: VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleBodyTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesBodyTypesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleBodyTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDelete operation in VehicleBodyTypesAdminApi.
 * @export
 * @interface VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDeleteRequest
 */
export interface VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDelete
     */
    readonly bodyTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGet operation in VehicleBodyTypesAdminApi.
 * @export
 * @interface VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGetRequest
 */
export interface VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGet
     */
    readonly bodyTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPut operation in VehicleBodyTypesAdminApi.
 * @export
 * @interface VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPutRequest
 */
export interface VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPut
     */
    readonly bodyTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUpdateVehicleBodyTypeDto}
     * @memberof VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPut
     */
    readonly adminUpdateVehicleBodyTypeDto?: AdminUpdateVehicleBodyTypeDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesBodyTypesGetPost operation in VehicleBodyTypesAdminApi.
 * @export
 * @interface VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesGetPostRequest
 */
export interface VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminVehicleBodyTypeGetPaginatedDto}
     * @memberof VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesGetPost
     */
    readonly adminVehicleBodyTypeGetPaginatedDto?: AdminVehicleBodyTypeGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesBodyTypesPost operation in VehicleBodyTypesAdminApi.
 * @export
 * @interface VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesPostRequest
 */
export interface VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateVehicleBodyTypeDto}
     * @memberof VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesPost
     */
    readonly adminCreateVehicleBodyTypeDto?: AdminCreateVehicleBodyTypeDto
}

/**
 * VehicleBodyTypesAdminApi - object-oriented interface
 * @export
 * @class VehicleBodyTypesAdminApi
 * @extends {BaseAPI}
 */
export class VehicleBodyTypesAdminApi extends BaseAPI {
    /**
     * 
     * @param {VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleBodyTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDelete(requestParameters: VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return VehicleBodyTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdDelete(requestParameters.bodyTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleBodyTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGet(requestParameters: VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleBodyTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdGet(requestParameters.bodyTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleBodyTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPut(requestParameters: VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPutRequest, options?: RawAxiosRequestConfig) {
        return VehicleBodyTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesBodyTypesBodyTypeIdPut(requestParameters.bodyTypeId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleBodyTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleBodyTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesBodyTypesGetPost(requestParameters: VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleBodyTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesBodyTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleBodyTypeGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleBodyTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesBodyTypesPost(requestParameters: VehicleBodyTypesAdminApiApiV1AdminReferenceDataVehiclesBodyTypesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleBodyTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesBodyTypesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleBodyTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleDamagesApi - axios parameter creator
 * @export
 */
export const VehicleDamagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleDamageGetPaginatedDto} [vehicleDamageGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehicleDamagesGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, vehicleDamageGetPaginatedDto?: VehicleDamageGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehicleDamagesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/vehicle-damages/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleDamageGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleDamageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehicleDamagesVehicleDamageIdGet: async (nexusOpsTenant: string, vehicleDamageId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehicleDamagesVehicleDamageIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleDamageId' is not null or undefined
            assertParamExists('apiV1VehicleDamagesVehicleDamageIdGet', 'vehicleDamageId', vehicleDamageId)
            const localVarPath = `/api/v1/vehicle-damages/{vehicleDamageId}`
                .replace(`{${"vehicleDamageId"}}`, encodeURIComponent(String(vehicleDamageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [contractId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesByContractGet: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, contractId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesByContractGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesByContractGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/damages/by-contract`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (contractId !== undefined) {
                localVarQueryParameter['contractId'] = contractId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [contractIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesByContractsGet: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, contractIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesByContractsGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesByContractsGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/damages/by-contracts`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (contractIds) {
                localVarQueryParameter['contractIds'] = contractIds;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [vehicleDamageIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesByIdsGet: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, vehicleDamageIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesByIdsGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesByIdsGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/damages/by-ids`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (vehicleDamageIds) {
                localVarQueryParameter['vehicleDamageIds'] = vehicleDamageIds;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleDamageGetCountersDto} [vehicleDamageGetCountersDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesCountersGetPost: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, vehicleDamageGetCountersDto?: VehicleDamageGetCountersDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesCountersGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesCountersGetPost', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/damages/counters/get`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleDamageGetCountersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [damageDetectionId] 
         * @param {string} [itemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, damageDetectionId?: string, itemId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/damages/get/by-damage-detection-item`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (damageDetectionId !== undefined) {
                localVarQueryParameter['damageDetectionId'] = damageDetectionId;
            }

            if (itemId !== undefined) {
                localVarQueryParameter['itemId'] = itemId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleDamageGetPaginatedDto} [vehicleDamageGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesGetPost: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, vehicleDamageGetPaginatedDto?: VehicleDamageGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesGetPost', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/damages/get`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleDamageGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} vehicleDamageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete: async (nexusOpsTenant: string, vehicleId: string, vehicleDamageId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete', 'vehicleId', vehicleId)
            // verify required parameter 'vehicleDamageId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete', 'vehicleDamageId', vehicleDamageId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/damages/{vehicleDamageId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)))
                .replace(`{${"vehicleDamageId"}}`, encodeURIComponent(String(vehicleDamageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} vehicleDamageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesVehicleDamageIdGet: async (nexusOpsTenant: string, vehicleId: string, vehicleDamageId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesVehicleDamageIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesVehicleDamageIdGet', 'vehicleId', vehicleId)
            // verify required parameter 'vehicleDamageId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesVehicleDamageIdGet', 'vehicleDamageId', vehicleDamageId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/damages/{vehicleDamageId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)))
                .replace(`{${"vehicleDamageId"}}`, encodeURIComponent(String(vehicleDamageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} vehicleDamageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleDamageMigrateToNewVisualModelDto} [vehicleDamageMigrateToNewVisualModelDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost: async (nexusOpsTenant: string, vehicleId: string, vehicleDamageId: string, nexusOpsAppVersion?: string, vehicleDamageMigrateToNewVisualModelDto?: VehicleDamageMigrateToNewVisualModelDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost', 'vehicleId', vehicleId)
            // verify required parameter 'vehicleDamageId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost', 'vehicleDamageId', vehicleDamageId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/damages/{vehicleDamageId}/migrate-to-new-visual-model`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)))
                .replace(`{${"vehicleDamageId"}}`, encodeURIComponent(String(vehicleDamageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleDamageMigrateToNewVisualModelDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleDamagesApi - functional programming interface
 * @export
 */
export const VehicleDamagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleDamagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleDamageGetPaginatedDto} [vehicleDamageGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehicleDamagesGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, vehicleDamageGetPaginatedDto?: VehicleDamageGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfVehicleDamageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehicleDamagesGetPost(nexusOpsTenant, nexusOpsAppVersion, vehicleDamageGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleDamagesApi.apiV1VehicleDamagesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleDamageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehicleDamagesVehicleDamageIdGet(nexusOpsTenant: string, vehicleDamageId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDamageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehicleDamagesVehicleDamageIdGet(nexusOpsTenant, vehicleDamageId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleDamagesApi.apiV1VehicleDamagesVehicleDamageIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [contractId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdDamagesByContractGet(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, contractId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleDamageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdDamagesByContractGet(nexusOpsTenant, vehicleId, nexusOpsAppVersion, contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleDamagesApi.apiV1VehiclesVehicleIdDamagesByContractGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [contractIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdDamagesByContractsGet(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, contractIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleDamageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdDamagesByContractsGet(nexusOpsTenant, vehicleId, nexusOpsAppVersion, contractIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleDamagesApi.apiV1VehiclesVehicleIdDamagesByContractsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [vehicleDamageIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdDamagesByIdsGet(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, vehicleDamageIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleDamageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdDamagesByIdsGet(nexusOpsTenant, vehicleId, nexusOpsAppVersion, vehicleDamageIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleDamagesApi.apiV1VehiclesVehicleIdDamagesByIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleDamageGetCountersDto} [vehicleDamageGetCountersDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdDamagesCountersGetPost(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, vehicleDamageGetCountersDto?: VehicleDamageGetCountersDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDamageCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdDamagesCountersGetPost(nexusOpsTenant, vehicleId, nexusOpsAppVersion, vehicleDamageGetCountersDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleDamagesApi.apiV1VehiclesVehicleIdDamagesCountersGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [damageDetectionId] 
         * @param {string} [itemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, damageDetectionId?: string, itemId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDamageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet(nexusOpsTenant, vehicleId, nexusOpsAppVersion, damageDetectionId, itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleDamagesApi.apiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleDamageGetPaginatedDto} [vehicleDamageGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdDamagesGetPost(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, vehicleDamageGetPaginatedDto?: VehicleDamageGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfVehicleDamageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdDamagesGetPost(nexusOpsTenant, vehicleId, nexusOpsAppVersion, vehicleDamageGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleDamagesApi.apiV1VehiclesVehicleIdDamagesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} vehicleDamageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete(nexusOpsTenant: string, vehicleId: string, vehicleDamageId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete(nexusOpsTenant, vehicleId, vehicleDamageId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleDamagesApi.apiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} vehicleDamageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdDamagesVehicleDamageIdGet(nexusOpsTenant: string, vehicleId: string, vehicleDamageId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDamageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdDamagesVehicleDamageIdGet(nexusOpsTenant, vehicleId, vehicleDamageId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleDamagesApi.apiV1VehiclesVehicleIdDamagesVehicleDamageIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} vehicleDamageId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleDamageMigrateToNewVisualModelDto} [vehicleDamageMigrateToNewVisualModelDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost(nexusOpsTenant: string, vehicleId: string, vehicleDamageId: string, nexusOpsAppVersion?: string, vehicleDamageMigrateToNewVisualModelDto?: VehicleDamageMigrateToNewVisualModelDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDamageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost(nexusOpsTenant, vehicleId, vehicleDamageId, nexusOpsAppVersion, vehicleDamageMigrateToNewVisualModelDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleDamagesApi.apiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleDamagesApi - factory interface
 * @export
 */
export const VehicleDamagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleDamagesApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleDamagesApiApiV1VehicleDamagesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehicleDamagesGetPost(requestParameters: VehicleDamagesApiApiV1VehicleDamagesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfVehicleDamageDto> {
            return localVarFp.apiV1VehicleDamagesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.vehicleDamageGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleDamagesApiApiV1VehicleDamagesVehicleDamageIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehicleDamagesVehicleDamageIdGet(requestParameters: VehicleDamagesApiApiV1VehicleDamagesVehicleDamageIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleDamageDto> {
            return localVarFp.apiV1VehicleDamagesVehicleDamageIdGet(requestParameters.nexusOpsTenant, requestParameters.vehicleDamageId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesByContractGet(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<VehicleDamageDto>> {
            return localVarFp.apiV1VehiclesVehicleIdDamagesByContractGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesByContractsGet(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<VehicleDamageDto>> {
            return localVarFp.apiV1VehiclesVehicleIdDamagesByContractsGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.contractIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesByIdsGet(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<VehicleDamageDto>> {
            return localVarFp.apiV1VehiclesVehicleIdDamagesByIdsGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.vehicleDamageIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesCountersGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesCountersGetPost(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesCountersGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleDamageCountersDto> {
            return localVarFp.apiV1VehiclesVehicleIdDamagesCountersGetPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.vehicleDamageGetCountersDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleDamageDto> {
            return localVarFp.apiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.damageDetectionId, requestParameters.itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesGetPost(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfVehicleDamageDto> {
            return localVarFp.apiV1VehiclesVehicleIdDamagesGetPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.vehicleDamageGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.vehicleDamageId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesVehicleDamageIdGet(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleDamageDto> {
            return localVarFp.apiV1VehiclesVehicleIdDamagesVehicleDamageIdGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.vehicleDamageId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleDamageDto> {
            return localVarFp.apiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.vehicleDamageId, requestParameters.nexusOpsAppVersion, requestParameters.vehicleDamageMigrateToNewVisualModelDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1VehicleDamagesGetPost operation in VehicleDamagesApi.
 * @export
 * @interface VehicleDamagesApiApiV1VehicleDamagesGetPostRequest
 */
export interface VehicleDamagesApiApiV1VehicleDamagesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehicleDamagesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehicleDamagesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleDamageGetPaginatedDto}
     * @memberof VehicleDamagesApiApiV1VehicleDamagesGetPost
     */
    readonly vehicleDamageGetPaginatedDto?: VehicleDamageGetPaginatedDto
}

/**
 * Request parameters for apiV1VehicleDamagesVehicleDamageIdGet operation in VehicleDamagesApi.
 * @export
 * @interface VehicleDamagesApiApiV1VehicleDamagesVehicleDamageIdGetRequest
 */
export interface VehicleDamagesApiApiV1VehicleDamagesVehicleDamageIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehicleDamagesVehicleDamageIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehicleDamagesVehicleDamageIdGet
     */
    readonly vehicleDamageId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehicleDamagesVehicleDamageIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1VehiclesVehicleIdDamagesByContractGet operation in VehicleDamagesApi.
 * @export
 * @interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractGetRequest
 */
export interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractGet
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractGet
     */
    readonly contractId?: string
}

/**
 * Request parameters for apiV1VehiclesVehicleIdDamagesByContractsGet operation in VehicleDamagesApi.
 * @export
 * @interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractsGetRequest
 */
export interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractsGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractsGet
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractsGet
     */
    readonly contractIds?: Array<string>
}

/**
 * Request parameters for apiV1VehiclesVehicleIdDamagesByIdsGet operation in VehicleDamagesApi.
 * @export
 * @interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByIdsGetRequest
 */
export interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByIdsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByIdsGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByIdsGet
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByIdsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByIdsGet
     */
    readonly vehicleDamageIds?: Array<string>
}

/**
 * Request parameters for apiV1VehiclesVehicleIdDamagesCountersGetPost operation in VehicleDamagesApi.
 * @export
 * @interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesCountersGetPostRequest
 */
export interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesCountersGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesCountersGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesCountersGetPost
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesCountersGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleDamageGetCountersDto}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesCountersGetPost
     */
    readonly vehicleDamageGetCountersDto?: VehicleDamageGetCountersDto
}

/**
 * Request parameters for apiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet operation in VehicleDamagesApi.
 * @export
 * @interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGetRequest
 */
export interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet
     */
    readonly damageDetectionId?: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet
     */
    readonly itemId?: string
}

/**
 * Request parameters for apiV1VehiclesVehicleIdDamagesGetPost operation in VehicleDamagesApi.
 * @export
 * @interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetPostRequest
 */
export interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetPost
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleDamageGetPaginatedDto}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetPost
     */
    readonly vehicleDamageGetPaginatedDto?: VehicleDamageGetPaginatedDto
}

/**
 * Request parameters for apiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete operation in VehicleDamagesApi.
 * @export
 * @interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdDeleteRequest
 */
export interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete
     */
    readonly vehicleId: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete
     */
    readonly vehicleDamageId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1VehiclesVehicleIdDamagesVehicleDamageIdGet operation in VehicleDamagesApi.
 * @export
 * @interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdGetRequest
 */
export interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdGet
     */
    readonly vehicleId: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdGet
     */
    readonly vehicleDamageId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost operation in VehicleDamagesApi.
 * @export
 * @interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPostRequest
 */
export interface VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost
     */
    readonly vehicleId: string

    /**
     * 
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost
     */
    readonly vehicleDamageId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleDamageMigrateToNewVisualModelDto}
     * @memberof VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost
     */
    readonly vehicleDamageMigrateToNewVisualModelDto?: VehicleDamageMigrateToNewVisualModelDto
}

/**
 * VehicleDamagesApi - object-oriented interface
 * @export
 * @class VehicleDamagesApi
 * @extends {BaseAPI}
 */
export class VehicleDamagesApi extends BaseAPI {
    /**
     * 
     * @param {VehicleDamagesApiApiV1VehicleDamagesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDamagesApi
     */
    public apiV1VehicleDamagesGetPost(requestParameters: VehicleDamagesApiApiV1VehicleDamagesGetPostRequest, options?: RawAxiosRequestConfig) {
        return VehicleDamagesApiFp(this.configuration).apiV1VehicleDamagesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.vehicleDamageGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleDamagesApiApiV1VehicleDamagesVehicleDamageIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDamagesApi
     */
    public apiV1VehicleDamagesVehicleDamageIdGet(requestParameters: VehicleDamagesApiApiV1VehicleDamagesVehicleDamageIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleDamagesApiFp(this.configuration).apiV1VehicleDamagesVehicleDamageIdGet(requestParameters.nexusOpsTenant, requestParameters.vehicleDamageId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDamagesApi
     */
    public apiV1VehiclesVehicleIdDamagesByContractGet(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleDamagesApiFp(this.configuration).apiV1VehiclesVehicleIdDamagesByContractGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDamagesApi
     */
    public apiV1VehiclesVehicleIdDamagesByContractsGet(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByContractsGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleDamagesApiFp(this.configuration).apiV1VehiclesVehicleIdDamagesByContractsGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.contractIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDamagesApi
     */
    public apiV1VehiclesVehicleIdDamagesByIdsGet(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesByIdsGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleDamagesApiFp(this.configuration).apiV1VehiclesVehicleIdDamagesByIdsGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.vehicleDamageIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesCountersGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDamagesApi
     */
    public apiV1VehiclesVehicleIdDamagesCountersGetPost(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesCountersGetPostRequest, options?: RawAxiosRequestConfig) {
        return VehicleDamagesApiFp(this.configuration).apiV1VehiclesVehicleIdDamagesCountersGetPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.vehicleDamageGetCountersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDamagesApi
     */
    public apiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleDamagesApiFp(this.configuration).apiV1VehiclesVehicleIdDamagesGetByDamageDetectionItemGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.damageDetectionId, requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDamagesApi
     */
    public apiV1VehiclesVehicleIdDamagesGetPost(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesGetPostRequest, options?: RawAxiosRequestConfig) {
        return VehicleDamagesApiFp(this.configuration).apiV1VehiclesVehicleIdDamagesGetPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.vehicleDamageGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDamagesApi
     */
    public apiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return VehicleDamagesApiFp(this.configuration).apiV1VehiclesVehicleIdDamagesVehicleDamageIdDelete(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.vehicleDamageId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDamagesApi
     */
    public apiV1VehiclesVehicleIdDamagesVehicleDamageIdGet(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleDamagesApiFp(this.configuration).apiV1VehiclesVehicleIdDamagesVehicleDamageIdGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.vehicleDamageId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDamagesApi
     */
    public apiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost(requestParameters: VehicleDamagesApiApiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPostRequest, options?: RawAxiosRequestConfig) {
        return VehicleDamagesApiFp(this.configuration).apiV1VehiclesVehicleIdDamagesVehicleDamageIdMigrateToNewVisualModelPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.vehicleDamageId, requestParameters.nexusOpsAppVersion, requestParameters.vehicleDamageMigrateToNewVisualModelDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleFuelTypesApi - axios parameter creator
 * @export
 */
export const VehicleFuelTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleFuelTypeGetPaginatedDto} [vehicleFuelTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesFuelTypesGetPost: async (nexusOpsAppVersion?: string, vehicleFuelTypeGetPaginatedDto?: VehicleFuelTypeGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/vehicles/fuel-types/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleFuelTypeGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} vehicleFuelTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGet: async (vehicleFuelTypeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleFuelTypeId' is not null or undefined
            assertParamExists('apiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGet', 'vehicleFuelTypeId', vehicleFuelTypeId)
            const localVarPath = `/api/v1/reference-data/vehicles/fuel-types/{vehicleFuelTypeId}`
                .replace(`{${"vehicleFuelTypeId"}}`, encodeURIComponent(String(vehicleFuelTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleFuelTypesApi - functional programming interface
 * @export
 */
export const VehicleFuelTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleFuelTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleFuelTypeGetPaginatedDto} [vehicleFuelTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesFuelTypesGetPost(nexusOpsAppVersion?: string, vehicleFuelTypeGetPaginatedDto?: VehicleFuelTypeGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfVehicleFuelTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesFuelTypesGetPost(nexusOpsAppVersion, vehicleFuelTypeGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleFuelTypesApi.apiV1ReferenceDataVehiclesFuelTypesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} vehicleFuelTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGet(vehicleFuelTypeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleFuelTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGet(vehicleFuelTypeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleFuelTypesApi.apiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleFuelTypesApi - factory interface
 * @export
 */
export const VehicleFuelTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleFuelTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesFuelTypesGetPost(requestParameters: VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfVehicleFuelTypeDto> {
            return localVarFp.apiV1ReferenceDataVehiclesFuelTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleFuelTypeGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGet(requestParameters: VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleFuelTypeDto> {
            return localVarFp.apiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGet(requestParameters.vehicleFuelTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ReferenceDataVehiclesFuelTypesGetPost operation in VehicleFuelTypesApi.
 * @export
 * @interface VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesGetPostRequest
 */
export interface VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleFuelTypeGetPaginatedDto}
     * @memberof VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesGetPost
     */
    readonly vehicleFuelTypeGetPaginatedDto?: VehicleFuelTypeGetPaginatedDto
}

/**
 * Request parameters for apiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGet operation in VehicleFuelTypesApi.
 * @export
 * @interface VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGetRequest
 */
export interface VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGet
     */
    readonly vehicleFuelTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * VehicleFuelTypesApi - object-oriented interface
 * @export
 * @class VehicleFuelTypesApi
 * @extends {BaseAPI}
 */
export class VehicleFuelTypesApi extends BaseAPI {
    /**
     * 
     * @param {VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleFuelTypesApi
     */
    public apiV1ReferenceDataVehiclesFuelTypesGetPost(requestParameters: VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleFuelTypesApiFp(this.configuration).apiV1ReferenceDataVehiclesFuelTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleFuelTypeGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleFuelTypesApi
     */
    public apiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGet(requestParameters: VehicleFuelTypesApiApiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleFuelTypesApiFp(this.configuration).apiV1ReferenceDataVehiclesFuelTypesVehicleFuelTypeIdGet(requestParameters.vehicleFuelTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleFuelTypesAdminApi - axios parameter creator
 * @export
 */
export const VehicleFuelTypesAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fuelTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDelete: async (fuelTypeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fuelTypeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDelete', 'fuelTypeId', fuelTypeId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/fuel-types/{fuelTypeId}`
                .replace(`{${"fuelTypeId"}}`, encodeURIComponent(String(fuelTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fuelTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGet: async (fuelTypeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fuelTypeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGet', 'fuelTypeId', fuelTypeId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/fuel-types/{fuelTypeId}`
                .replace(`{${"fuelTypeId"}}`, encodeURIComponent(String(fuelTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fuelTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleFuelTypeDto} [adminUpdateVehicleFuelTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPut: async (fuelTypeId: string, nexusOpsAppVersion?: string, adminUpdateVehicleFuelTypeDto?: AdminUpdateVehicleFuelTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fuelTypeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPut', 'fuelTypeId', fuelTypeId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/fuel-types/{fuelTypeId}`
                .replace(`{${"fuelTypeId"}}`, encodeURIComponent(String(fuelTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateVehicleFuelTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleFuelTypeGetPaginatedDto} [adminVehicleFuelTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesFuelTypesGetPost: async (nexusOpsAppVersion?: string, adminVehicleFuelTypeGetPaginatedDto?: AdminVehicleFuelTypeGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/fuel-types/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminVehicleFuelTypeGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleFuelTypeDto} [adminCreateVehicleFuelTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesFuelTypesPost: async (nexusOpsAppVersion?: string, adminCreateVehicleFuelTypeDto?: AdminCreateVehicleFuelTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/fuel-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateVehicleFuelTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleFuelTypesAdminApi - functional programming interface
 * @export
 */
export const VehicleFuelTypesAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleFuelTypesAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} fuelTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDelete(fuelTypeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDelete(fuelTypeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleFuelTypesAdminApi.apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fuelTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGet(fuelTypeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleFuelTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGet(fuelTypeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleFuelTypesAdminApi.apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fuelTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleFuelTypeDto} [adminUpdateVehicleFuelTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPut(fuelTypeId: string, nexusOpsAppVersion?: string, adminUpdateVehicleFuelTypeDto?: AdminUpdateVehicleFuelTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleFuelTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPut(fuelTypeId, nexusOpsAppVersion, adminUpdateVehicleFuelTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleFuelTypesAdminApi.apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleFuelTypeGetPaginatedDto} [adminVehicleFuelTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesFuelTypesGetPost(nexusOpsAppVersion?: string, adminVehicleFuelTypeGetPaginatedDto?: AdminVehicleFuelTypeGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminVehicleFuelTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesFuelTypesGetPost(nexusOpsAppVersion, adminVehicleFuelTypeGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleFuelTypesAdminApi.apiV1AdminReferenceDataVehiclesFuelTypesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleFuelTypeDto} [adminCreateVehicleFuelTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesFuelTypesPost(nexusOpsAppVersion?: string, adminCreateVehicleFuelTypeDto?: AdminCreateVehicleFuelTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleFuelTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesFuelTypesPost(nexusOpsAppVersion, adminCreateVehicleFuelTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleFuelTypesAdminApi.apiV1AdminReferenceDataVehiclesFuelTypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleFuelTypesAdminApi - factory interface
 * @export
 */
export const VehicleFuelTypesAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleFuelTypesAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDelete(requestParameters: VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDelete(requestParameters.fuelTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGet(requestParameters: VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleFuelTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGet(requestParameters.fuelTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPut(requestParameters: VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleFuelTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPut(requestParameters.fuelTypeId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleFuelTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesFuelTypesGetPost(requestParameters: VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminVehicleFuelTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesFuelTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleFuelTypeGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesFuelTypesPost(requestParameters: VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleFuelTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesFuelTypesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleFuelTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDelete operation in VehicleFuelTypesAdminApi.
 * @export
 * @interface VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDeleteRequest
 */
export interface VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDelete
     */
    readonly fuelTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGet operation in VehicleFuelTypesAdminApi.
 * @export
 * @interface VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGetRequest
 */
export interface VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGet
     */
    readonly fuelTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPut operation in VehicleFuelTypesAdminApi.
 * @export
 * @interface VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPutRequest
 */
export interface VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPut
     */
    readonly fuelTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUpdateVehicleFuelTypeDto}
     * @memberof VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPut
     */
    readonly adminUpdateVehicleFuelTypeDto?: AdminUpdateVehicleFuelTypeDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesFuelTypesGetPost operation in VehicleFuelTypesAdminApi.
 * @export
 * @interface VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesGetPostRequest
 */
export interface VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminVehicleFuelTypeGetPaginatedDto}
     * @memberof VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesGetPost
     */
    readonly adminVehicleFuelTypeGetPaginatedDto?: AdminVehicleFuelTypeGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesFuelTypesPost operation in VehicleFuelTypesAdminApi.
 * @export
 * @interface VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesPostRequest
 */
export interface VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateVehicleFuelTypeDto}
     * @memberof VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesPost
     */
    readonly adminCreateVehicleFuelTypeDto?: AdminCreateVehicleFuelTypeDto
}

/**
 * VehicleFuelTypesAdminApi - object-oriented interface
 * @export
 * @class VehicleFuelTypesAdminApi
 * @extends {BaseAPI}
 */
export class VehicleFuelTypesAdminApi extends BaseAPI {
    /**
     * 
     * @param {VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleFuelTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDelete(requestParameters: VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return VehicleFuelTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdDelete(requestParameters.fuelTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleFuelTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGet(requestParameters: VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleFuelTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdGet(requestParameters.fuelTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleFuelTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPut(requestParameters: VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPutRequest, options?: RawAxiosRequestConfig) {
        return VehicleFuelTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesFuelTypesFuelTypeIdPut(requestParameters.fuelTypeId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleFuelTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleFuelTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesFuelTypesGetPost(requestParameters: VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleFuelTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesFuelTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleFuelTypeGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleFuelTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesFuelTypesPost(requestParameters: VehicleFuelTypesAdminApiApiV1AdminReferenceDataVehiclesFuelTypesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleFuelTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesFuelTypesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleFuelTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleGenerationsApi - axios parameter creator
 * @export
 */
export const VehicleGenerationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} generationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesGenerationsGenerationIdGet: async (generationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generationId' is not null or undefined
            assertParamExists('apiV1ReferenceDataVehiclesGenerationsGenerationIdGet', 'generationId', generationId)
            const localVarPath = `/api/v1/reference-data/vehicles/generations/{generationId}`
                .replace(`{${"generationId"}}`, encodeURIComponent(String(generationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleGenerationGetPaginatedDto} [vehicleGenerationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesGenerationsGetPost: async (nexusOpsAppVersion?: string, vehicleGenerationGetPaginatedDto?: VehicleGenerationGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/vehicles/generations/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleGenerationGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleGenerationsApi - functional programming interface
 * @export
 */
export const VehicleGenerationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleGenerationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} generationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesGenerationsGenerationIdGet(generationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleGenerationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesGenerationsGenerationIdGet(generationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleGenerationsApi.apiV1ReferenceDataVehiclesGenerationsGenerationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleGenerationGetPaginatedDto} [vehicleGenerationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesGenerationsGetPost(nexusOpsAppVersion?: string, vehicleGenerationGetPaginatedDto?: VehicleGenerationGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfVehicleGenerationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesGenerationsGetPost(nexusOpsAppVersion, vehicleGenerationGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleGenerationsApi.apiV1ReferenceDataVehiclesGenerationsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleGenerationsApi - factory interface
 * @export
 */
export const VehicleGenerationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleGenerationsApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGenerationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesGenerationsGenerationIdGet(requestParameters: VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGenerationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleGenerationDto> {
            return localVarFp.apiV1ReferenceDataVehiclesGenerationsGenerationIdGet(requestParameters.generationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesGenerationsGetPost(requestParameters: VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfVehicleGenerationDto> {
            return localVarFp.apiV1ReferenceDataVehiclesGenerationsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleGenerationGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ReferenceDataVehiclesGenerationsGenerationIdGet operation in VehicleGenerationsApi.
 * @export
 * @interface VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGenerationIdGetRequest
 */
export interface VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGenerationIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGenerationIdGet
     */
    readonly generationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGenerationIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1ReferenceDataVehiclesGenerationsGetPost operation in VehicleGenerationsApi.
 * @export
 * @interface VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGetPostRequest
 */
export interface VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleGenerationGetPaginatedDto}
     * @memberof VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGetPost
     */
    readonly vehicleGenerationGetPaginatedDto?: VehicleGenerationGetPaginatedDto
}

/**
 * VehicleGenerationsApi - object-oriented interface
 * @export
 * @class VehicleGenerationsApi
 * @extends {BaseAPI}
 */
export class VehicleGenerationsApi extends BaseAPI {
    /**
     * 
     * @param {VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGenerationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGenerationsApi
     */
    public apiV1ReferenceDataVehiclesGenerationsGenerationIdGet(requestParameters: VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGenerationIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleGenerationsApiFp(this.configuration).apiV1ReferenceDataVehiclesGenerationsGenerationIdGet(requestParameters.generationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGenerationsApi
     */
    public apiV1ReferenceDataVehiclesGenerationsGetPost(requestParameters: VehicleGenerationsApiApiV1ReferenceDataVehiclesGenerationsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleGenerationsApiFp(this.configuration).apiV1ReferenceDataVehiclesGenerationsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleGenerationGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleGenerationsAdminApi - axios parameter creator
 * @export
 */
export const VehicleGenerationsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} generationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesGenerationsGenerationIdDelete: async (generationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generationId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesGenerationsGenerationIdDelete', 'generationId', generationId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/generations/{generationId}`
                .replace(`{${"generationId"}}`, encodeURIComponent(String(generationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} generationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesGenerationsGenerationIdGet: async (generationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generationId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesGenerationsGenerationIdGet', 'generationId', generationId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/generations/{generationId}`
                .replace(`{${"generationId"}}`, encodeURIComponent(String(generationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} generationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleGenerationDto} [adminUpdateVehicleGenerationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesGenerationsGenerationIdPut: async (generationId: string, nexusOpsAppVersion?: string, adminUpdateVehicleGenerationDto?: AdminUpdateVehicleGenerationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generationId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesGenerationsGenerationIdPut', 'generationId', generationId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/generations/{generationId}`
                .replace(`{${"generationId"}}`, encodeURIComponent(String(generationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateVehicleGenerationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleGenerationGetPaginatedDto} [adminVehicleGenerationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesGenerationsGetPost: async (nexusOpsAppVersion?: string, adminVehicleGenerationGetPaginatedDto?: AdminVehicleGenerationGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/generations/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminVehicleGenerationGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleGenerationDto} [adminCreateVehicleGenerationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesGenerationsPost: async (nexusOpsAppVersion?: string, adminCreateVehicleGenerationDto?: AdminCreateVehicleGenerationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/generations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateVehicleGenerationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleGenerationsAdminApi - functional programming interface
 * @export
 */
export const VehicleGenerationsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleGenerationsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} generationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesGenerationsGenerationIdDelete(generationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesGenerationsGenerationIdDelete(generationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleGenerationsAdminApi.apiV1AdminReferenceDataVehiclesGenerationsGenerationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} generationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesGenerationsGenerationIdGet(generationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleGenerationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesGenerationsGenerationIdGet(generationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleGenerationsAdminApi.apiV1AdminReferenceDataVehiclesGenerationsGenerationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} generationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleGenerationDto} [adminUpdateVehicleGenerationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesGenerationsGenerationIdPut(generationId: string, nexusOpsAppVersion?: string, adminUpdateVehicleGenerationDto?: AdminUpdateVehicleGenerationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleGenerationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesGenerationsGenerationIdPut(generationId, nexusOpsAppVersion, adminUpdateVehicleGenerationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleGenerationsAdminApi.apiV1AdminReferenceDataVehiclesGenerationsGenerationIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleGenerationGetPaginatedDto} [adminVehicleGenerationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesGenerationsGetPost(nexusOpsAppVersion?: string, adminVehicleGenerationGetPaginatedDto?: AdminVehicleGenerationGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminVehicleGenerationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesGenerationsGetPost(nexusOpsAppVersion, adminVehicleGenerationGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleGenerationsAdminApi.apiV1AdminReferenceDataVehiclesGenerationsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleGenerationDto} [adminCreateVehicleGenerationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesGenerationsPost(nexusOpsAppVersion?: string, adminCreateVehicleGenerationDto?: AdminCreateVehicleGenerationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleGenerationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesGenerationsPost(nexusOpsAppVersion, adminCreateVehicleGenerationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleGenerationsAdminApi.apiV1AdminReferenceDataVehiclesGenerationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleGenerationsAdminApi - factory interface
 * @export
 */
export const VehicleGenerationsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleGenerationsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesGenerationsGenerationIdDelete(requestParameters: VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminReferenceDataVehiclesGenerationsGenerationIdDelete(requestParameters.generationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesGenerationsGenerationIdGet(requestParameters: VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleGenerationDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesGenerationsGenerationIdGet(requestParameters.generationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesGenerationsGenerationIdPut(requestParameters: VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleGenerationDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesGenerationsGenerationIdPut(requestParameters.generationId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleGenerationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesGenerationsGetPost(requestParameters: VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminVehicleGenerationDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesGenerationsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleGenerationGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesGenerationsPost(requestParameters: VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleGenerationDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesGenerationsPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleGenerationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesGenerationsGenerationIdDelete operation in VehicleGenerationsAdminApi.
 * @export
 * @interface VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdDeleteRequest
 */
export interface VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdDelete
     */
    readonly generationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesGenerationsGenerationIdGet operation in VehicleGenerationsAdminApi.
 * @export
 * @interface VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdGetRequest
 */
export interface VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdGet
     */
    readonly generationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesGenerationsGenerationIdPut operation in VehicleGenerationsAdminApi.
 * @export
 * @interface VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdPutRequest
 */
export interface VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdPut
     */
    readonly generationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUpdateVehicleGenerationDto}
     * @memberof VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdPut
     */
    readonly adminUpdateVehicleGenerationDto?: AdminUpdateVehicleGenerationDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesGenerationsGetPost operation in VehicleGenerationsAdminApi.
 * @export
 * @interface VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGetPostRequest
 */
export interface VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminVehicleGenerationGetPaginatedDto}
     * @memberof VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGetPost
     */
    readonly adminVehicleGenerationGetPaginatedDto?: AdminVehicleGenerationGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesGenerationsPost operation in VehicleGenerationsAdminApi.
 * @export
 * @interface VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsPostRequest
 */
export interface VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateVehicleGenerationDto}
     * @memberof VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsPost
     */
    readonly adminCreateVehicleGenerationDto?: AdminCreateVehicleGenerationDto
}

/**
 * VehicleGenerationsAdminApi - object-oriented interface
 * @export
 * @class VehicleGenerationsAdminApi
 * @extends {BaseAPI}
 */
export class VehicleGenerationsAdminApi extends BaseAPI {
    /**
     * 
     * @param {VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGenerationsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesGenerationsGenerationIdDelete(requestParameters: VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return VehicleGenerationsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesGenerationsGenerationIdDelete(requestParameters.generationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGenerationsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesGenerationsGenerationIdGet(requestParameters: VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleGenerationsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesGenerationsGenerationIdGet(requestParameters.generationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGenerationsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesGenerationsGenerationIdPut(requestParameters: VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGenerationIdPutRequest, options?: RawAxiosRequestConfig) {
        return VehicleGenerationsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesGenerationsGenerationIdPut(requestParameters.generationId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleGenerationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGenerationsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesGenerationsGetPost(requestParameters: VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleGenerationsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesGenerationsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleGenerationGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGenerationsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesGenerationsPost(requestParameters: VehicleGenerationsAdminApiApiV1AdminReferenceDataVehiclesGenerationsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleGenerationsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesGenerationsPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleGenerationDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleHistoryApi - axios parameter creator
 * @export
 */
export const VehicleHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleHistoryGetPaginatedDto} [vehicleHistoryGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdHistoryGetPost: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, vehicleHistoryGetPaginatedDto?: VehicleHistoryGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdHistoryGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdHistoryGetPost', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/history/get`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleHistoryGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} id 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdHistoryIdGet: async (nexusOpsTenant: string, vehicleId: string, id: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdHistoryIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdHistoryIdGet', 'vehicleId', vehicleId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdHistoryIdGet', 'id', id)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/history/{id}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleHistoryApi - functional programming interface
 * @export
 */
export const VehicleHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleHistoryGetPaginatedDto} [vehicleHistoryGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdHistoryGetPost(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, vehicleHistoryGetPaginatedDto?: VehicleHistoryGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfVehicleHistoryItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdHistoryGetPost(nexusOpsTenant, vehicleId, nexusOpsAppVersion, vehicleHistoryGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleHistoryApi.apiV1VehiclesVehicleIdHistoryGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} id 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdHistoryIdGet(nexusOpsTenant: string, vehicleId: string, id: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleHistoryItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdHistoryIdGet(nexusOpsTenant, vehicleId, id, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleHistoryApi.apiV1VehiclesVehicleIdHistoryIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleHistoryApi - factory interface
 * @export
 */
export const VehicleHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleHistoryApiApiV1VehiclesVehicleIdHistoryGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdHistoryGetPost(requestParameters: VehicleHistoryApiApiV1VehiclesVehicleIdHistoryGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfVehicleHistoryItemDto> {
            return localVarFp.apiV1VehiclesVehicleIdHistoryGetPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.vehicleHistoryGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleHistoryApiApiV1VehiclesVehicleIdHistoryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdHistoryIdGet(requestParameters: VehicleHistoryApiApiV1VehiclesVehicleIdHistoryIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleHistoryItemDto> {
            return localVarFp.apiV1VehiclesVehicleIdHistoryIdGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.id, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1VehiclesVehicleIdHistoryGetPost operation in VehicleHistoryApi.
 * @export
 * @interface VehicleHistoryApiApiV1VehiclesVehicleIdHistoryGetPostRequest
 */
export interface VehicleHistoryApiApiV1VehiclesVehicleIdHistoryGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleHistoryApiApiV1VehiclesVehicleIdHistoryGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehicleHistoryApiApiV1VehiclesVehicleIdHistoryGetPost
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleHistoryApiApiV1VehiclesVehicleIdHistoryGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleHistoryGetPaginatedDto}
     * @memberof VehicleHistoryApiApiV1VehiclesVehicleIdHistoryGetPost
     */
    readonly vehicleHistoryGetPaginatedDto?: VehicleHistoryGetPaginatedDto
}

/**
 * Request parameters for apiV1VehiclesVehicleIdHistoryIdGet operation in VehicleHistoryApi.
 * @export
 * @interface VehicleHistoryApiApiV1VehiclesVehicleIdHistoryIdGetRequest
 */
export interface VehicleHistoryApiApiV1VehiclesVehicleIdHistoryIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleHistoryApiApiV1VehiclesVehicleIdHistoryIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehicleHistoryApiApiV1VehiclesVehicleIdHistoryIdGet
     */
    readonly vehicleId: string

    /**
     * 
     * @type {string}
     * @memberof VehicleHistoryApiApiV1VehiclesVehicleIdHistoryIdGet
     */
    readonly id: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleHistoryApiApiV1VehiclesVehicleIdHistoryIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * VehicleHistoryApi - object-oriented interface
 * @export
 * @class VehicleHistoryApi
 * @extends {BaseAPI}
 */
export class VehicleHistoryApi extends BaseAPI {
    /**
     * 
     * @param {VehicleHistoryApiApiV1VehiclesVehicleIdHistoryGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleHistoryApi
     */
    public apiV1VehiclesVehicleIdHistoryGetPost(requestParameters: VehicleHistoryApiApiV1VehiclesVehicleIdHistoryGetPostRequest, options?: RawAxiosRequestConfig) {
        return VehicleHistoryApiFp(this.configuration).apiV1VehiclesVehicleIdHistoryGetPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.vehicleHistoryGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleHistoryApiApiV1VehiclesVehicleIdHistoryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleHistoryApi
     */
    public apiV1VehiclesVehicleIdHistoryIdGet(requestParameters: VehicleHistoryApiApiV1VehiclesVehicleIdHistoryIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleHistoryApiFp(this.configuration).apiV1VehiclesVehicleIdHistoryIdGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.id, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleMakesApi - axios parameter creator
 * @export
 */
export const VehicleMakesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleMakeGetPaginatedDto} [vehicleMakeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesMakesGetPost: async (nexusOpsAppVersion?: string, vehicleMakeGetPaginatedDto?: VehicleMakeGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/vehicles/makes/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleMakeGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} makeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesMakesMakeIdGet: async (makeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'makeId' is not null or undefined
            assertParamExists('apiV1ReferenceDataVehiclesMakesMakeIdGet', 'makeId', makeId)
            const localVarPath = `/api/v1/reference-data/vehicles/makes/{makeId}`
                .replace(`{${"makeId"}}`, encodeURIComponent(String(makeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleMakesApi - functional programming interface
 * @export
 */
export const VehicleMakesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleMakesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleMakeGetPaginatedDto} [vehicleMakeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesMakesGetPost(nexusOpsAppVersion?: string, vehicleMakeGetPaginatedDto?: VehicleMakeGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfVehicleMakeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesMakesGetPost(nexusOpsAppVersion, vehicleMakeGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleMakesApi.apiV1ReferenceDataVehiclesMakesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} makeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesMakesMakeIdGet(makeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMakeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesMakesMakeIdGet(makeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleMakesApi.apiV1ReferenceDataVehiclesMakesMakeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleMakesApi - factory interface
 * @export
 */
export const VehicleMakesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleMakesApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleMakesApiApiV1ReferenceDataVehiclesMakesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesMakesGetPost(requestParameters: VehicleMakesApiApiV1ReferenceDataVehiclesMakesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfVehicleMakeDto> {
            return localVarFp.apiV1ReferenceDataVehiclesMakesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleMakeGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleMakesApiApiV1ReferenceDataVehiclesMakesMakeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesMakesMakeIdGet(requestParameters: VehicleMakesApiApiV1ReferenceDataVehiclesMakesMakeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleMakeDto> {
            return localVarFp.apiV1ReferenceDataVehiclesMakesMakeIdGet(requestParameters.makeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ReferenceDataVehiclesMakesGetPost operation in VehicleMakesApi.
 * @export
 * @interface VehicleMakesApiApiV1ReferenceDataVehiclesMakesGetPostRequest
 */
export interface VehicleMakesApiApiV1ReferenceDataVehiclesMakesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleMakesApiApiV1ReferenceDataVehiclesMakesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleMakeGetPaginatedDto}
     * @memberof VehicleMakesApiApiV1ReferenceDataVehiclesMakesGetPost
     */
    readonly vehicleMakeGetPaginatedDto?: VehicleMakeGetPaginatedDto
}

/**
 * Request parameters for apiV1ReferenceDataVehiclesMakesMakeIdGet operation in VehicleMakesApi.
 * @export
 * @interface VehicleMakesApiApiV1ReferenceDataVehiclesMakesMakeIdGetRequest
 */
export interface VehicleMakesApiApiV1ReferenceDataVehiclesMakesMakeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleMakesApiApiV1ReferenceDataVehiclesMakesMakeIdGet
     */
    readonly makeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleMakesApiApiV1ReferenceDataVehiclesMakesMakeIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * VehicleMakesApi - object-oriented interface
 * @export
 * @class VehicleMakesApi
 * @extends {BaseAPI}
 */
export class VehicleMakesApi extends BaseAPI {
    /**
     * 
     * @param {VehicleMakesApiApiV1ReferenceDataVehiclesMakesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMakesApi
     */
    public apiV1ReferenceDataVehiclesMakesGetPost(requestParameters: VehicleMakesApiApiV1ReferenceDataVehiclesMakesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleMakesApiFp(this.configuration).apiV1ReferenceDataVehiclesMakesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleMakeGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleMakesApiApiV1ReferenceDataVehiclesMakesMakeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMakesApi
     */
    public apiV1ReferenceDataVehiclesMakesMakeIdGet(requestParameters: VehicleMakesApiApiV1ReferenceDataVehiclesMakesMakeIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleMakesApiFp(this.configuration).apiV1ReferenceDataVehiclesMakesMakeIdGet(requestParameters.makeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleMakesAdminApi - axios parameter creator
 * @export
 */
export const VehicleMakesAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleMakeGetPaginatedDto} [adminVehicleMakeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesMakesGetPost: async (nexusOpsAppVersion?: string, adminVehicleMakeGetPaginatedDto?: AdminVehicleMakeGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/makes/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminVehicleMakeGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} makeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesMakesMakeIdDelete: async (makeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'makeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesMakesMakeIdDelete', 'makeId', makeId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/makes/{makeId}`
                .replace(`{${"makeId"}}`, encodeURIComponent(String(makeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} makeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesMakesMakeIdGet: async (makeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'makeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesMakesMakeIdGet', 'makeId', makeId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/makes/{makeId}`
                .replace(`{${"makeId"}}`, encodeURIComponent(String(makeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} makeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleMakeDto} [adminUpdateVehicleMakeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesMakesMakeIdPut: async (makeId: string, nexusOpsAppVersion?: string, adminUpdateVehicleMakeDto?: AdminUpdateVehicleMakeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'makeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesMakesMakeIdPut', 'makeId', makeId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/makes/{makeId}`
                .replace(`{${"makeId"}}`, encodeURIComponent(String(makeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateVehicleMakeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleMakeDto} [adminCreateVehicleMakeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesMakesPost: async (nexusOpsAppVersion?: string, adminCreateVehicleMakeDto?: AdminCreateVehicleMakeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/makes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateVehicleMakeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleMakesAdminApi - functional programming interface
 * @export
 */
export const VehicleMakesAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleMakesAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleMakeGetPaginatedDto} [adminVehicleMakeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesMakesGetPost(nexusOpsAppVersion?: string, adminVehicleMakeGetPaginatedDto?: AdminVehicleMakeGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminVehicleMakeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesMakesGetPost(nexusOpsAppVersion, adminVehicleMakeGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleMakesAdminApi.apiV1AdminReferenceDataVehiclesMakesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} makeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesMakesMakeIdDelete(makeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesMakesMakeIdDelete(makeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleMakesAdminApi.apiV1AdminReferenceDataVehiclesMakesMakeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} makeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesMakesMakeIdGet(makeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleMakeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesMakesMakeIdGet(makeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleMakesAdminApi.apiV1AdminReferenceDataVehiclesMakesMakeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} makeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleMakeDto} [adminUpdateVehicleMakeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesMakesMakeIdPut(makeId: string, nexusOpsAppVersion?: string, adminUpdateVehicleMakeDto?: AdminUpdateVehicleMakeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleMakeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesMakesMakeIdPut(makeId, nexusOpsAppVersion, adminUpdateVehicleMakeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleMakesAdminApi.apiV1AdminReferenceDataVehiclesMakesMakeIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleMakeDto} [adminCreateVehicleMakeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesMakesPost(nexusOpsAppVersion?: string, adminCreateVehicleMakeDto?: AdminCreateVehicleMakeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleMakeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesMakesPost(nexusOpsAppVersion, adminCreateVehicleMakeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleMakesAdminApi.apiV1AdminReferenceDataVehiclesMakesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleMakesAdminApi - factory interface
 * @export
 */
export const VehicleMakesAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleMakesAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesMakesGetPost(requestParameters: VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminVehicleMakeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesMakesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleMakeGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesMakesMakeIdDelete(requestParameters: VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminReferenceDataVehiclesMakesMakeIdDelete(requestParameters.makeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesMakesMakeIdGet(requestParameters: VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleMakeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesMakesMakeIdGet(requestParameters.makeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesMakesMakeIdPut(requestParameters: VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleMakeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesMakesMakeIdPut(requestParameters.makeId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleMakeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesMakesPost(requestParameters: VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleMakeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesMakesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleMakeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesMakesGetPost operation in VehicleMakesAdminApi.
 * @export
 * @interface VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesGetPostRequest
 */
export interface VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminVehicleMakeGetPaginatedDto}
     * @memberof VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesGetPost
     */
    readonly adminVehicleMakeGetPaginatedDto?: AdminVehicleMakeGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesMakesMakeIdDelete operation in VehicleMakesAdminApi.
 * @export
 * @interface VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdDeleteRequest
 */
export interface VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdDelete
     */
    readonly makeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesMakesMakeIdGet operation in VehicleMakesAdminApi.
 * @export
 * @interface VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdGetRequest
 */
export interface VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdGet
     */
    readonly makeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesMakesMakeIdPut operation in VehicleMakesAdminApi.
 * @export
 * @interface VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdPutRequest
 */
export interface VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdPut
     */
    readonly makeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUpdateVehicleMakeDto}
     * @memberof VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdPut
     */
    readonly adminUpdateVehicleMakeDto?: AdminUpdateVehicleMakeDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesMakesPost operation in VehicleMakesAdminApi.
 * @export
 * @interface VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesPostRequest
 */
export interface VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateVehicleMakeDto}
     * @memberof VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesPost
     */
    readonly adminCreateVehicleMakeDto?: AdminCreateVehicleMakeDto
}

/**
 * VehicleMakesAdminApi - object-oriented interface
 * @export
 * @class VehicleMakesAdminApi
 * @extends {BaseAPI}
 */
export class VehicleMakesAdminApi extends BaseAPI {
    /**
     * 
     * @param {VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMakesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesMakesGetPost(requestParameters: VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleMakesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesMakesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleMakeGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMakesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesMakesMakeIdDelete(requestParameters: VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return VehicleMakesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesMakesMakeIdDelete(requestParameters.makeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMakesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesMakesMakeIdGet(requestParameters: VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleMakesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesMakesMakeIdGet(requestParameters.makeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMakesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesMakesMakeIdPut(requestParameters: VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesMakeIdPutRequest, options?: RawAxiosRequestConfig) {
        return VehicleMakesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesMakesMakeIdPut(requestParameters.makeId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleMakeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMakesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesMakesPost(requestParameters: VehicleMakesAdminApiApiV1AdminReferenceDataVehiclesMakesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleMakesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesMakesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleMakeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleModelsApi - axios parameter creator
 * @export
 */
export const VehicleModelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleModelGetPaginatedDto} [vehicleModelGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesModelsGetPost: async (nexusOpsAppVersion?: string, vehicleModelGetPaginatedDto?: VehicleModelGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/vehicles/models/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleModelGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} modelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesModelsModelIdGet: async (modelId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiV1ReferenceDataVehiclesModelsModelIdGet', 'modelId', modelId)
            const localVarPath = `/api/v1/reference-data/vehicles/models/{modelId}`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleModelsApi - functional programming interface
 * @export
 */
export const VehicleModelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleModelsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleModelGetPaginatedDto} [vehicleModelGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesModelsGetPost(nexusOpsAppVersion?: string, vehicleModelGetPaginatedDto?: VehicleModelGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfVehicleModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesModelsGetPost(nexusOpsAppVersion, vehicleModelGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleModelsApi.apiV1ReferenceDataVehiclesModelsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} modelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesModelsModelIdGet(modelId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesModelsModelIdGet(modelId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleModelsApi.apiV1ReferenceDataVehiclesModelsModelIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleModelsApi - factory interface
 * @export
 */
export const VehicleModelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleModelsApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleModelsApiApiV1ReferenceDataVehiclesModelsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesModelsGetPost(requestParameters: VehicleModelsApiApiV1ReferenceDataVehiclesModelsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfVehicleModelDto> {
            return localVarFp.apiV1ReferenceDataVehiclesModelsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleModelGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleModelsApiApiV1ReferenceDataVehiclesModelsModelIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesModelsModelIdGet(requestParameters: VehicleModelsApiApiV1ReferenceDataVehiclesModelsModelIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleModelDto> {
            return localVarFp.apiV1ReferenceDataVehiclesModelsModelIdGet(requestParameters.modelId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ReferenceDataVehiclesModelsGetPost operation in VehicleModelsApi.
 * @export
 * @interface VehicleModelsApiApiV1ReferenceDataVehiclesModelsGetPostRequest
 */
export interface VehicleModelsApiApiV1ReferenceDataVehiclesModelsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleModelsApiApiV1ReferenceDataVehiclesModelsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleModelGetPaginatedDto}
     * @memberof VehicleModelsApiApiV1ReferenceDataVehiclesModelsGetPost
     */
    readonly vehicleModelGetPaginatedDto?: VehicleModelGetPaginatedDto
}

/**
 * Request parameters for apiV1ReferenceDataVehiclesModelsModelIdGet operation in VehicleModelsApi.
 * @export
 * @interface VehicleModelsApiApiV1ReferenceDataVehiclesModelsModelIdGetRequest
 */
export interface VehicleModelsApiApiV1ReferenceDataVehiclesModelsModelIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleModelsApiApiV1ReferenceDataVehiclesModelsModelIdGet
     */
    readonly modelId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleModelsApiApiV1ReferenceDataVehiclesModelsModelIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * VehicleModelsApi - object-oriented interface
 * @export
 * @class VehicleModelsApi
 * @extends {BaseAPI}
 */
export class VehicleModelsApi extends BaseAPI {
    /**
     * 
     * @param {VehicleModelsApiApiV1ReferenceDataVehiclesModelsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleModelsApi
     */
    public apiV1ReferenceDataVehiclesModelsGetPost(requestParameters: VehicleModelsApiApiV1ReferenceDataVehiclesModelsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleModelsApiFp(this.configuration).apiV1ReferenceDataVehiclesModelsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleModelGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleModelsApiApiV1ReferenceDataVehiclesModelsModelIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleModelsApi
     */
    public apiV1ReferenceDataVehiclesModelsModelIdGet(requestParameters: VehicleModelsApiApiV1ReferenceDataVehiclesModelsModelIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleModelsApiFp(this.configuration).apiV1ReferenceDataVehiclesModelsModelIdGet(requestParameters.modelId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleModelsAdminApi - axios parameter creator
 * @export
 */
export const VehicleModelsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleModelGetPaginatedDto} [adminVehicleModelGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModelsGetPost: async (nexusOpsAppVersion?: string, adminVehicleModelGetPaginatedDto?: AdminVehicleModelGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/models/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminVehicleModelGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} modelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModelsModelIdDelete: async (modelId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesModelsModelIdDelete', 'modelId', modelId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/models/{modelId}`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} modelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModelsModelIdGet: async (modelId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesModelsModelIdGet', 'modelId', modelId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/models/{modelId}`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} modelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleModelDto} [adminUpdateVehicleModelDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModelsModelIdPut: async (modelId: string, nexusOpsAppVersion?: string, adminUpdateVehicleModelDto?: AdminUpdateVehicleModelDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesModelsModelIdPut', 'modelId', modelId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/models/{modelId}`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateVehicleModelDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleModelDto} [adminCreateVehicleModelDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModelsPost: async (nexusOpsAppVersion?: string, adminCreateVehicleModelDto?: AdminCreateVehicleModelDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateVehicleModelDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleModelsAdminApi - functional programming interface
 * @export
 */
export const VehicleModelsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleModelsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleModelGetPaginatedDto} [adminVehicleModelGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesModelsGetPost(nexusOpsAppVersion?: string, adminVehicleModelGetPaginatedDto?: AdminVehicleModelGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminVehicleModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesModelsGetPost(nexusOpsAppVersion, adminVehicleModelGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleModelsAdminApi.apiV1AdminReferenceDataVehiclesModelsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} modelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesModelsModelIdDelete(modelId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesModelsModelIdDelete(modelId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleModelsAdminApi.apiV1AdminReferenceDataVehiclesModelsModelIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} modelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesModelsModelIdGet(modelId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesModelsModelIdGet(modelId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleModelsAdminApi.apiV1AdminReferenceDataVehiclesModelsModelIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} modelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleModelDto} [adminUpdateVehicleModelDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesModelsModelIdPut(modelId: string, nexusOpsAppVersion?: string, adminUpdateVehicleModelDto?: AdminUpdateVehicleModelDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesModelsModelIdPut(modelId, nexusOpsAppVersion, adminUpdateVehicleModelDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleModelsAdminApi.apiV1AdminReferenceDataVehiclesModelsModelIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleModelDto} [adminCreateVehicleModelDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesModelsPost(nexusOpsAppVersion?: string, adminCreateVehicleModelDto?: AdminCreateVehicleModelDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesModelsPost(nexusOpsAppVersion, adminCreateVehicleModelDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleModelsAdminApi.apiV1AdminReferenceDataVehiclesModelsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleModelsAdminApi - factory interface
 * @export
 */
export const VehicleModelsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleModelsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModelsGetPost(requestParameters: VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminVehicleModelDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesModelsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleModelGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModelsModelIdDelete(requestParameters: VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminReferenceDataVehiclesModelsModelIdDelete(requestParameters.modelId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModelsModelIdGet(requestParameters: VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleModelDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesModelsModelIdGet(requestParameters.modelId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModelsModelIdPut(requestParameters: VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleModelDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesModelsModelIdPut(requestParameters.modelId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleModelDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModelsPost(requestParameters: VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleModelDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesModelsPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleModelDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesModelsGetPost operation in VehicleModelsAdminApi.
 * @export
 * @interface VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsGetPostRequest
 */
export interface VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminVehicleModelGetPaginatedDto}
     * @memberof VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsGetPost
     */
    readonly adminVehicleModelGetPaginatedDto?: AdminVehicleModelGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesModelsModelIdDelete operation in VehicleModelsAdminApi.
 * @export
 * @interface VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdDeleteRequest
 */
export interface VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdDelete
     */
    readonly modelId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesModelsModelIdGet operation in VehicleModelsAdminApi.
 * @export
 * @interface VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdGetRequest
 */
export interface VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdGet
     */
    readonly modelId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesModelsModelIdPut operation in VehicleModelsAdminApi.
 * @export
 * @interface VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdPutRequest
 */
export interface VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdPut
     */
    readonly modelId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUpdateVehicleModelDto}
     * @memberof VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdPut
     */
    readonly adminUpdateVehicleModelDto?: AdminUpdateVehicleModelDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesModelsPost operation in VehicleModelsAdminApi.
 * @export
 * @interface VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsPostRequest
 */
export interface VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateVehicleModelDto}
     * @memberof VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsPost
     */
    readonly adminCreateVehicleModelDto?: AdminCreateVehicleModelDto
}

/**
 * VehicleModelsAdminApi - object-oriented interface
 * @export
 * @class VehicleModelsAdminApi
 * @extends {BaseAPI}
 */
export class VehicleModelsAdminApi extends BaseAPI {
    /**
     * 
     * @param {VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleModelsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesModelsGetPost(requestParameters: VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleModelsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesModelsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleModelGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleModelsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesModelsModelIdDelete(requestParameters: VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return VehicleModelsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesModelsModelIdDelete(requestParameters.modelId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleModelsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesModelsModelIdGet(requestParameters: VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleModelsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesModelsModelIdGet(requestParameters.modelId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleModelsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesModelsModelIdPut(requestParameters: VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsModelIdPutRequest, options?: RawAxiosRequestConfig) {
        return VehicleModelsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesModelsModelIdPut(requestParameters.modelId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleModelDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleModelsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesModelsPost(requestParameters: VehicleModelsAdminApiApiV1AdminReferenceDataVehiclesModelsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleModelsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesModelsPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleModelDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleModificationsApi - axios parameter creator
 * @export
 */
export const VehicleModificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleModificationGetPaginatedDto} [vehicleModificationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesModificationsGetPost: async (nexusOpsAppVersion?: string, vehicleModificationGetPaginatedDto?: VehicleModificationGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/vehicles/modifications/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleModificationGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} modificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesModificationsModificationIdGet: async (modificationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modificationId' is not null or undefined
            assertParamExists('apiV1ReferenceDataVehiclesModificationsModificationIdGet', 'modificationId', modificationId)
            const localVarPath = `/api/v1/reference-data/vehicles/modifications/{modificationId}`
                .replace(`{${"modificationId"}}`, encodeURIComponent(String(modificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleModificationsApi - functional programming interface
 * @export
 */
export const VehicleModificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleModificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleModificationGetPaginatedDto} [vehicleModificationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesModificationsGetPost(nexusOpsAppVersion?: string, vehicleModificationGetPaginatedDto?: VehicleModificationGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfVehicleModificationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesModificationsGetPost(nexusOpsAppVersion, vehicleModificationGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleModificationsApi.apiV1ReferenceDataVehiclesModificationsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} modificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesModificationsModificationIdGet(modificationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleModificationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesModificationsModificationIdGet(modificationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleModificationsApi.apiV1ReferenceDataVehiclesModificationsModificationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleModificationsApi - factory interface
 * @export
 */
export const VehicleModificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleModificationsApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesModificationsGetPost(requestParameters: VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfVehicleModificationDto> {
            return localVarFp.apiV1ReferenceDataVehiclesModificationsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleModificationGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsModificationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesModificationsModificationIdGet(requestParameters: VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsModificationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleModificationDto> {
            return localVarFp.apiV1ReferenceDataVehiclesModificationsModificationIdGet(requestParameters.modificationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ReferenceDataVehiclesModificationsGetPost operation in VehicleModificationsApi.
 * @export
 * @interface VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsGetPostRequest
 */
export interface VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleModificationGetPaginatedDto}
     * @memberof VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsGetPost
     */
    readonly vehicleModificationGetPaginatedDto?: VehicleModificationGetPaginatedDto
}

/**
 * Request parameters for apiV1ReferenceDataVehiclesModificationsModificationIdGet operation in VehicleModificationsApi.
 * @export
 * @interface VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsModificationIdGetRequest
 */
export interface VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsModificationIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsModificationIdGet
     */
    readonly modificationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsModificationIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * VehicleModificationsApi - object-oriented interface
 * @export
 * @class VehicleModificationsApi
 * @extends {BaseAPI}
 */
export class VehicleModificationsApi extends BaseAPI {
    /**
     * 
     * @param {VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleModificationsApi
     */
    public apiV1ReferenceDataVehiclesModificationsGetPost(requestParameters: VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleModificationsApiFp(this.configuration).apiV1ReferenceDataVehiclesModificationsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleModificationGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsModificationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleModificationsApi
     */
    public apiV1ReferenceDataVehiclesModificationsModificationIdGet(requestParameters: VehicleModificationsApiApiV1ReferenceDataVehiclesModificationsModificationIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleModificationsApiFp(this.configuration).apiV1ReferenceDataVehiclesModificationsModificationIdGet(requestParameters.modificationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleModificationsAdminApi - axios parameter creator
 * @export
 */
export const VehicleModificationsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleModificationGetPaginatedDto} [adminVehicleModificationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModificationsGetPost: async (nexusOpsAppVersion?: string, adminVehicleModificationGetPaginatedDto?: AdminVehicleModificationGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/modifications/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminVehicleModificationGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} modificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModificationsModificationIdDelete: async (modificationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modificationId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesModificationsModificationIdDelete', 'modificationId', modificationId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/modifications/{modificationId}`
                .replace(`{${"modificationId"}}`, encodeURIComponent(String(modificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} modificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModificationsModificationIdGet: async (modificationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modificationId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesModificationsModificationIdGet', 'modificationId', modificationId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/modifications/{modificationId}`
                .replace(`{${"modificationId"}}`, encodeURIComponent(String(modificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} modificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleModificationDto} [adminUpdateVehicleModificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModificationsModificationIdPut: async (modificationId: string, nexusOpsAppVersion?: string, adminUpdateVehicleModificationDto?: AdminUpdateVehicleModificationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modificationId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesModificationsModificationIdPut', 'modificationId', modificationId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/modifications/{modificationId}`
                .replace(`{${"modificationId"}}`, encodeURIComponent(String(modificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateVehicleModificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleModificationDto} [adminCreateVehicleModificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModificationsPost: async (nexusOpsAppVersion?: string, adminCreateVehicleModificationDto?: AdminCreateVehicleModificationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/modifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateVehicleModificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleModificationsAdminApi - functional programming interface
 * @export
 */
export const VehicleModificationsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleModificationsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleModificationGetPaginatedDto} [adminVehicleModificationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesModificationsGetPost(nexusOpsAppVersion?: string, adminVehicleModificationGetPaginatedDto?: AdminVehicleModificationGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminVehicleModificationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesModificationsGetPost(nexusOpsAppVersion, adminVehicleModificationGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleModificationsAdminApi.apiV1AdminReferenceDataVehiclesModificationsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} modificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesModificationsModificationIdDelete(modificationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesModificationsModificationIdDelete(modificationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleModificationsAdminApi.apiV1AdminReferenceDataVehiclesModificationsModificationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} modificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesModificationsModificationIdGet(modificationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleModificationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesModificationsModificationIdGet(modificationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleModificationsAdminApi.apiV1AdminReferenceDataVehiclesModificationsModificationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} modificationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleModificationDto} [adminUpdateVehicleModificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesModificationsModificationIdPut(modificationId: string, nexusOpsAppVersion?: string, adminUpdateVehicleModificationDto?: AdminUpdateVehicleModificationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleModificationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesModificationsModificationIdPut(modificationId, nexusOpsAppVersion, adminUpdateVehicleModificationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleModificationsAdminApi.apiV1AdminReferenceDataVehiclesModificationsModificationIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleModificationDto} [adminCreateVehicleModificationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesModificationsPost(nexusOpsAppVersion?: string, adminCreateVehicleModificationDto?: AdminCreateVehicleModificationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleModificationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesModificationsPost(nexusOpsAppVersion, adminCreateVehicleModificationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleModificationsAdminApi.apiV1AdminReferenceDataVehiclesModificationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleModificationsAdminApi - factory interface
 * @export
 */
export const VehicleModificationsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleModificationsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModificationsGetPost(requestParameters: VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminVehicleModificationDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesModificationsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleModificationGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModificationsModificationIdDelete(requestParameters: VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminReferenceDataVehiclesModificationsModificationIdDelete(requestParameters.modificationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModificationsModificationIdGet(requestParameters: VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleModificationDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesModificationsModificationIdGet(requestParameters.modificationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModificationsModificationIdPut(requestParameters: VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleModificationDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesModificationsModificationIdPut(requestParameters.modificationId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleModificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesModificationsPost(requestParameters: VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleModificationDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesModificationsPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleModificationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesModificationsGetPost operation in VehicleModificationsAdminApi.
 * @export
 * @interface VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsGetPostRequest
 */
export interface VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminVehicleModificationGetPaginatedDto}
     * @memberof VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsGetPost
     */
    readonly adminVehicleModificationGetPaginatedDto?: AdminVehicleModificationGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesModificationsModificationIdDelete operation in VehicleModificationsAdminApi.
 * @export
 * @interface VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdDeleteRequest
 */
export interface VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdDelete
     */
    readonly modificationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesModificationsModificationIdGet operation in VehicleModificationsAdminApi.
 * @export
 * @interface VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdGetRequest
 */
export interface VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdGet
     */
    readonly modificationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesModificationsModificationIdPut operation in VehicleModificationsAdminApi.
 * @export
 * @interface VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdPutRequest
 */
export interface VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdPut
     */
    readonly modificationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUpdateVehicleModificationDto}
     * @memberof VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdPut
     */
    readonly adminUpdateVehicleModificationDto?: AdminUpdateVehicleModificationDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesModificationsPost operation in VehicleModificationsAdminApi.
 * @export
 * @interface VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsPostRequest
 */
export interface VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateVehicleModificationDto}
     * @memberof VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsPost
     */
    readonly adminCreateVehicleModificationDto?: AdminCreateVehicleModificationDto
}

/**
 * VehicleModificationsAdminApi - object-oriented interface
 * @export
 * @class VehicleModificationsAdminApi
 * @extends {BaseAPI}
 */
export class VehicleModificationsAdminApi extends BaseAPI {
    /**
     * 
     * @param {VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleModificationsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesModificationsGetPost(requestParameters: VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleModificationsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesModificationsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleModificationGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleModificationsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesModificationsModificationIdDelete(requestParameters: VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return VehicleModificationsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesModificationsModificationIdDelete(requestParameters.modificationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleModificationsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesModificationsModificationIdGet(requestParameters: VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleModificationsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesModificationsModificationIdGet(requestParameters.modificationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleModificationsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesModificationsModificationIdPut(requestParameters: VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsModificationIdPutRequest, options?: RawAxiosRequestConfig) {
        return VehicleModificationsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesModificationsModificationIdPut(requestParameters.modificationId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleModificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleModificationsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesModificationsPost(requestParameters: VehicleModificationsAdminApiApiV1AdminReferenceDataVehiclesModificationsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleModificationsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesModificationsPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleModificationDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehiclePartTypesApi - axios parameter creator
 * @export
 */
export const VehiclePartTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehiclePartTypeGetPaginatedDto} [vehiclePartTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesPartTypesGetPost: async (nexusOpsAppVersion?: string, vehiclePartTypeGetPaginatedDto?: VehiclePartTypeGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/vehicles/part-types/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehiclePartTypeGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} partTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesPartTypesPartTypeIdGet: async (partTypeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partTypeId' is not null or undefined
            assertParamExists('apiV1ReferenceDataVehiclesPartTypesPartTypeIdGet', 'partTypeId', partTypeId)
            const localVarPath = `/api/v1/reference-data/vehicles/part-types/{partTypeId}`
                .replace(`{${"partTypeId"}}`, encodeURIComponent(String(partTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehiclePartTypesApi - functional programming interface
 * @export
 */
export const VehiclePartTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehiclePartTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehiclePartTypeGetPaginatedDto} [vehiclePartTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesPartTypesGetPost(nexusOpsAppVersion?: string, vehiclePartTypeGetPaginatedDto?: VehiclePartTypeGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfVehiclePartTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesPartTypesGetPost(nexusOpsAppVersion, vehiclePartTypeGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclePartTypesApi.apiV1ReferenceDataVehiclesPartTypesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} partTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesPartTypesPartTypeIdGet(partTypeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehiclePartTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesPartTypesPartTypeIdGet(partTypeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclePartTypesApi.apiV1ReferenceDataVehiclesPartTypesPartTypeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehiclePartTypesApi - factory interface
 * @export
 */
export const VehiclePartTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehiclePartTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesPartTypesGetPost(requestParameters: VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfVehiclePartTypeDto> {
            return localVarFp.apiV1ReferenceDataVehiclesPartTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehiclePartTypeGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesPartTypeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesPartTypesPartTypeIdGet(requestParameters: VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesPartTypeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehiclePartTypeDto> {
            return localVarFp.apiV1ReferenceDataVehiclesPartTypesPartTypeIdGet(requestParameters.partTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ReferenceDataVehiclesPartTypesGetPost operation in VehiclePartTypesApi.
 * @export
 * @interface VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesGetPostRequest
 */
export interface VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehiclePartTypeGetPaginatedDto}
     * @memberof VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesGetPost
     */
    readonly vehiclePartTypeGetPaginatedDto?: VehiclePartTypeGetPaginatedDto
}

/**
 * Request parameters for apiV1ReferenceDataVehiclesPartTypesPartTypeIdGet operation in VehiclePartTypesApi.
 * @export
 * @interface VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesPartTypeIdGetRequest
 */
export interface VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesPartTypeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesPartTypeIdGet
     */
    readonly partTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesPartTypeIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * VehiclePartTypesApi - object-oriented interface
 * @export
 * @class VehiclePartTypesApi
 * @extends {BaseAPI}
 */
export class VehiclePartTypesApi extends BaseAPI {
    /**
     * 
     * @param {VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePartTypesApi
     */
    public apiV1ReferenceDataVehiclesPartTypesGetPost(requestParameters: VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehiclePartTypesApiFp(this.configuration).apiV1ReferenceDataVehiclesPartTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehiclePartTypeGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesPartTypeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePartTypesApi
     */
    public apiV1ReferenceDataVehiclesPartTypesPartTypeIdGet(requestParameters: VehiclePartTypesApiApiV1ReferenceDataVehiclesPartTypesPartTypeIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehiclePartTypesApiFp(this.configuration).apiV1ReferenceDataVehiclesPartTypesPartTypeIdGet(requestParameters.partTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehiclePartTypesAdminApi - axios parameter creator
 * @export
 */
export const VehiclePartTypesAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehiclePartTypeGetPaginatedDto} [adminVehiclePartTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesPartTypesGetPost: async (nexusOpsAppVersion?: string, adminVehiclePartTypeGetPaginatedDto?: AdminVehiclePartTypeGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/part-types/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminVehiclePartTypeGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} partTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDelete: async (partTypeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partTypeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDelete', 'partTypeId', partTypeId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/part-types/{partTypeId}`
                .replace(`{${"partTypeId"}}`, encodeURIComponent(String(partTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} partTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGet: async (partTypeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partTypeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGet', 'partTypeId', partTypeId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/part-types/{partTypeId}`
                .replace(`{${"partTypeId"}}`, encodeURIComponent(String(partTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} partTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehiclePartTypeDto} [adminUpdateVehiclePartTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPut: async (partTypeId: string, nexusOpsAppVersion?: string, adminUpdateVehiclePartTypeDto?: AdminUpdateVehiclePartTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partTypeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPut', 'partTypeId', partTypeId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/part-types/{partTypeId}`
                .replace(`{${"partTypeId"}}`, encodeURIComponent(String(partTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateVehiclePartTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehiclePartTypeDto} [adminCreateVehiclePartTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesPartTypesPost: async (nexusOpsAppVersion?: string, adminCreateVehiclePartTypeDto?: AdminCreateVehiclePartTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/part-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateVehiclePartTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehiclePartTypesAdminApi - functional programming interface
 * @export
 */
export const VehiclePartTypesAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehiclePartTypesAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehiclePartTypeGetPaginatedDto} [adminVehiclePartTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesPartTypesGetPost(nexusOpsAppVersion?: string, adminVehiclePartTypeGetPaginatedDto?: AdminVehiclePartTypeGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminVehiclePartTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesPartTypesGetPost(nexusOpsAppVersion, adminVehiclePartTypeGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclePartTypesAdminApi.apiV1AdminReferenceDataVehiclesPartTypesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} partTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDelete(partTypeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDelete(partTypeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclePartTypesAdminApi.apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} partTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGet(partTypeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehiclePartTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGet(partTypeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclePartTypesAdminApi.apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} partTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehiclePartTypeDto} [adminUpdateVehiclePartTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPut(partTypeId: string, nexusOpsAppVersion?: string, adminUpdateVehiclePartTypeDto?: AdminUpdateVehiclePartTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehiclePartTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPut(partTypeId, nexusOpsAppVersion, adminUpdateVehiclePartTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclePartTypesAdminApi.apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehiclePartTypeDto} [adminCreateVehiclePartTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesPartTypesPost(nexusOpsAppVersion?: string, adminCreateVehiclePartTypeDto?: AdminCreateVehiclePartTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehiclePartTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesPartTypesPost(nexusOpsAppVersion, adminCreateVehiclePartTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclePartTypesAdminApi.apiV1AdminReferenceDataVehiclesPartTypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehiclePartTypesAdminApi - factory interface
 * @export
 */
export const VehiclePartTypesAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehiclePartTypesAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesPartTypesGetPost(requestParameters: VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminVehiclePartTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesPartTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehiclePartTypeGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDelete(requestParameters: VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDelete(requestParameters.partTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGet(requestParameters: VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehiclePartTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGet(requestParameters.partTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPut(requestParameters: VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehiclePartTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPut(requestParameters.partTypeId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehiclePartTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesPartTypesPost(requestParameters: VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehiclePartTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesPartTypesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehiclePartTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesPartTypesGetPost operation in VehiclePartTypesAdminApi.
 * @export
 * @interface VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesGetPostRequest
 */
export interface VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminVehiclePartTypeGetPaginatedDto}
     * @memberof VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesGetPost
     */
    readonly adminVehiclePartTypeGetPaginatedDto?: AdminVehiclePartTypeGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDelete operation in VehiclePartTypesAdminApi.
 * @export
 * @interface VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDeleteRequest
 */
export interface VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDelete
     */
    readonly partTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGet operation in VehiclePartTypesAdminApi.
 * @export
 * @interface VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGetRequest
 */
export interface VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGet
     */
    readonly partTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPut operation in VehiclePartTypesAdminApi.
 * @export
 * @interface VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPutRequest
 */
export interface VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPut
     */
    readonly partTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUpdateVehiclePartTypeDto}
     * @memberof VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPut
     */
    readonly adminUpdateVehiclePartTypeDto?: AdminUpdateVehiclePartTypeDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesPartTypesPost operation in VehiclePartTypesAdminApi.
 * @export
 * @interface VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPostRequest
 */
export interface VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateVehiclePartTypeDto}
     * @memberof VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPost
     */
    readonly adminCreateVehiclePartTypeDto?: AdminCreateVehiclePartTypeDto
}

/**
 * VehiclePartTypesAdminApi - object-oriented interface
 * @export
 * @class VehiclePartTypesAdminApi
 * @extends {BaseAPI}
 */
export class VehiclePartTypesAdminApi extends BaseAPI {
    /**
     * 
     * @param {VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePartTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesPartTypesGetPost(requestParameters: VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehiclePartTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesPartTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehiclePartTypeGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePartTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDelete(requestParameters: VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return VehiclePartTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdDelete(requestParameters.partTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePartTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGet(requestParameters: VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehiclePartTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdGet(requestParameters.partTypeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePartTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPut(requestParameters: VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPutRequest, options?: RawAxiosRequestConfig) {
        return VehiclePartTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesPartTypesPartTypeIdPut(requestParameters.partTypeId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehiclePartTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePartTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesPartTypesPost(requestParameters: VehiclePartTypesAdminApiApiV1AdminReferenceDataVehiclesPartTypesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehiclePartTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesPartTypesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehiclePartTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleScheduleApi - axios parameter creator
 * @export
 */
export const VehicleScheduleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ScheduleEntriesGetDto} [scheduleEntriesGetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdScheduleEntriesGetPost: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, scheduleEntriesGetDto?: ScheduleEntriesGetDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdScheduleEntriesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdScheduleEntriesGetPost', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/schedule/entries/get`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleEntriesGetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ScheduleStatusEntriesGetDto} [scheduleStatusEntriesGetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdScheduleEntriesStatusGetPost: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, scheduleStatusEntriesGetDto?: ScheduleStatusEntriesGetDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdScheduleEntriesStatusGetPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdScheduleEntriesStatusGetPost', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/schedule/entries/status/get`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleStatusEntriesGetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleScheduleApi - functional programming interface
 * @export
 */
export const VehicleScheduleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleScheduleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ScheduleEntriesGetDto} [scheduleEntriesGetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdScheduleEntriesGetPost(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, scheduleEntriesGetDto?: ScheduleEntriesGetDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleEntriesResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdScheduleEntriesGetPost(nexusOpsTenant, vehicleId, nexusOpsAppVersion, scheduleEntriesGetDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleScheduleApi.apiV1VehiclesVehicleIdScheduleEntriesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {ScheduleStatusEntriesGetDto} [scheduleStatusEntriesGetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdScheduleEntriesStatusGetPost(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, scheduleStatusEntriesGetDto?: ScheduleStatusEntriesGetDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleEntriesResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdScheduleEntriesStatusGetPost(nexusOpsTenant, vehicleId, nexusOpsAppVersion, scheduleStatusEntriesGetDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleScheduleApi.apiV1VehiclesVehicleIdScheduleEntriesStatusGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleScheduleApi - factory interface
 * @export
 */
export const VehicleScheduleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleScheduleApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdScheduleEntriesGetPost(requestParameters: VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScheduleEntriesResultDto> {
            return localVarFp.apiV1VehiclesVehicleIdScheduleEntriesGetPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.scheduleEntriesGetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesStatusGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdScheduleEntriesStatusGetPost(requestParameters: VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesStatusGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScheduleEntriesResultDto> {
            return localVarFp.apiV1VehiclesVehicleIdScheduleEntriesStatusGetPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.scheduleStatusEntriesGetDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1VehiclesVehicleIdScheduleEntriesGetPost operation in VehicleScheduleApi.
 * @export
 * @interface VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesGetPostRequest
 */
export interface VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesGetPost
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ScheduleEntriesGetDto}
     * @memberof VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesGetPost
     */
    readonly scheduleEntriesGetDto?: ScheduleEntriesGetDto
}

/**
 * Request parameters for apiV1VehiclesVehicleIdScheduleEntriesStatusGetPost operation in VehicleScheduleApi.
 * @export
 * @interface VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesStatusGetPostRequest
 */
export interface VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesStatusGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesStatusGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesStatusGetPost
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesStatusGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {ScheduleStatusEntriesGetDto}
     * @memberof VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesStatusGetPost
     */
    readonly scheduleStatusEntriesGetDto?: ScheduleStatusEntriesGetDto
}

/**
 * VehicleScheduleApi - object-oriented interface
 * @export
 * @class VehicleScheduleApi
 * @extends {BaseAPI}
 */
export class VehicleScheduleApi extends BaseAPI {
    /**
     * 
     * @param {VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleScheduleApi
     */
    public apiV1VehiclesVehicleIdScheduleEntriesGetPost(requestParameters: VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesGetPostRequest, options?: RawAxiosRequestConfig) {
        return VehicleScheduleApiFp(this.configuration).apiV1VehiclesVehicleIdScheduleEntriesGetPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.scheduleEntriesGetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesStatusGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleScheduleApi
     */
    public apiV1VehiclesVehicleIdScheduleEntriesStatusGetPost(requestParameters: VehicleScheduleApiApiV1VehiclesVehicleIdScheduleEntriesStatusGetPostRequest, options?: RawAxiosRequestConfig) {
        return VehicleScheduleApiFp(this.configuration).apiV1VehiclesVehicleIdScheduleEntriesStatusGetPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.scheduleStatusEntriesGetDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleTypesApi - axios parameter creator
 * @export
 */
export const VehicleTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleTypeGetPaginatedDto} [vehicleTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesTypesGetPost: async (nexusOpsAppVersion?: string, vehicleTypeGetPaginatedDto?: VehicleTypeGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/vehicles/types/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleTypeGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} typeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesTypesTypeIdGet: async (typeId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('apiV1ReferenceDataVehiclesTypesTypeIdGet', 'typeId', typeId)
            const localVarPath = `/api/v1/reference-data/vehicles/types/{typeId}`
                .replace(`{${"typeId"}}`, encodeURIComponent(String(typeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleTypesApi - functional programming interface
 * @export
 */
export const VehicleTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleTypeGetPaginatedDto} [vehicleTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesTypesGetPost(nexusOpsAppVersion?: string, vehicleTypeGetPaginatedDto?: VehicleTypeGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfVehicleTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesTypesGetPost(nexusOpsAppVersion, vehicleTypeGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleTypesApi.apiV1ReferenceDataVehiclesTypesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} typeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesTypesTypeIdGet(typeId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesTypesTypeIdGet(typeId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleTypesApi.apiV1ReferenceDataVehiclesTypesTypeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleTypesApi - factory interface
 * @export
 */
export const VehicleTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleTypesApiApiV1ReferenceDataVehiclesTypesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesTypesGetPost(requestParameters: VehicleTypesApiApiV1ReferenceDataVehiclesTypesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfVehicleTypeDto> {
            return localVarFp.apiV1ReferenceDataVehiclesTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleTypeGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleTypesApiApiV1ReferenceDataVehiclesTypesTypeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesTypesTypeIdGet(requestParameters: VehicleTypesApiApiV1ReferenceDataVehiclesTypesTypeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleTypeDto> {
            return localVarFp.apiV1ReferenceDataVehiclesTypesTypeIdGet(requestParameters.typeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ReferenceDataVehiclesTypesGetPost operation in VehicleTypesApi.
 * @export
 * @interface VehicleTypesApiApiV1ReferenceDataVehiclesTypesGetPostRequest
 */
export interface VehicleTypesApiApiV1ReferenceDataVehiclesTypesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleTypesApiApiV1ReferenceDataVehiclesTypesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleTypeGetPaginatedDto}
     * @memberof VehicleTypesApiApiV1ReferenceDataVehiclesTypesGetPost
     */
    readonly vehicleTypeGetPaginatedDto?: VehicleTypeGetPaginatedDto
}

/**
 * Request parameters for apiV1ReferenceDataVehiclesTypesTypeIdGet operation in VehicleTypesApi.
 * @export
 * @interface VehicleTypesApiApiV1ReferenceDataVehiclesTypesTypeIdGetRequest
 */
export interface VehicleTypesApiApiV1ReferenceDataVehiclesTypesTypeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleTypesApiApiV1ReferenceDataVehiclesTypesTypeIdGet
     */
    readonly typeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleTypesApiApiV1ReferenceDataVehiclesTypesTypeIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * VehicleTypesApi - object-oriented interface
 * @export
 * @class VehicleTypesApi
 * @extends {BaseAPI}
 */
export class VehicleTypesApi extends BaseAPI {
    /**
     * 
     * @param {VehicleTypesApiApiV1ReferenceDataVehiclesTypesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTypesApi
     */
    public apiV1ReferenceDataVehiclesTypesGetPost(requestParameters: VehicleTypesApiApiV1ReferenceDataVehiclesTypesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleTypesApiFp(this.configuration).apiV1ReferenceDataVehiclesTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleTypeGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleTypesApiApiV1ReferenceDataVehiclesTypesTypeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTypesApi
     */
    public apiV1ReferenceDataVehiclesTypesTypeIdGet(requestParameters: VehicleTypesApiApiV1ReferenceDataVehiclesTypesTypeIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleTypesApiFp(this.configuration).apiV1ReferenceDataVehiclesTypesTypeIdGet(requestParameters.typeId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleTypesAdminApi - axios parameter creator
 * @export
 */
export const VehicleTypesAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleTypeGetPaginatedDto} [adminVehicleTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesTypesGetPost: async (nexusOpsAppVersion?: string, adminVehicleTypeGetPaginatedDto?: AdminVehicleTypeGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/types/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminVehicleTypeGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleTypeDto} [adminCreateVehicleTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesTypesPost: async (nexusOpsAppVersion?: string, adminCreateVehicleTypeDto?: AdminCreateVehicleTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateVehicleTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} vehicleTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleTypeDto} [adminUpdateVehicleTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPut: async (vehicleTypeId: string, nexusOpsAppVersion?: string, adminUpdateVehicleTypeDto?: AdminUpdateVehicleTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleTypeId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPut', 'vehicleTypeId', vehicleTypeId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/types/{vehicleTypeId}`
                .replace(`{${"vehicleTypeId"}}`, encodeURIComponent(String(vehicleTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateVehicleTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleTypesAdminApi - functional programming interface
 * @export
 */
export const VehicleTypesAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleTypesAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleTypeGetPaginatedDto} [adminVehicleTypeGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesTypesGetPost(nexusOpsAppVersion?: string, adminVehicleTypeGetPaginatedDto?: AdminVehicleTypeGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminVehicleTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesTypesGetPost(nexusOpsAppVersion, adminVehicleTypeGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleTypesAdminApi.apiV1AdminReferenceDataVehiclesTypesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleTypeDto} [adminCreateVehicleTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesTypesPost(nexusOpsAppVersion?: string, adminCreateVehicleTypeDto?: AdminCreateVehicleTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesTypesPost(nexusOpsAppVersion, adminCreateVehicleTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleTypesAdminApi.apiV1AdminReferenceDataVehiclesTypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} vehicleTypeId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleTypeDto} [adminUpdateVehicleTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPut(vehicleTypeId: string, nexusOpsAppVersion?: string, adminUpdateVehicleTypeDto?: AdminUpdateVehicleTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPut(vehicleTypeId, nexusOpsAppVersion, adminUpdateVehicleTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleTypesAdminApi.apiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleTypesAdminApi - factory interface
 * @export
 */
export const VehicleTypesAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleTypesAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesTypesGetPost(requestParameters: VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminVehicleTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleTypeGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesTypesPost(requestParameters: VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesTypesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPut(requestParameters: VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleTypeDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPut(requestParameters.vehicleTypeId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesTypesGetPost operation in VehicleTypesAdminApi.
 * @export
 * @interface VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesGetPostRequest
 */
export interface VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminVehicleTypeGetPaginatedDto}
     * @memberof VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesGetPost
     */
    readonly adminVehicleTypeGetPaginatedDto?: AdminVehicleTypeGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesTypesPost operation in VehicleTypesAdminApi.
 * @export
 * @interface VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesPostRequest
 */
export interface VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateVehicleTypeDto}
     * @memberof VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesPost
     */
    readonly adminCreateVehicleTypeDto?: AdminCreateVehicleTypeDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPut operation in VehicleTypesAdminApi.
 * @export
 * @interface VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPutRequest
 */
export interface VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPut
     */
    readonly vehicleTypeId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUpdateVehicleTypeDto}
     * @memberof VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPut
     */
    readonly adminUpdateVehicleTypeDto?: AdminUpdateVehicleTypeDto
}

/**
 * VehicleTypesAdminApi - object-oriented interface
 * @export
 * @class VehicleTypesAdminApi
 * @extends {BaseAPI}
 */
export class VehicleTypesAdminApi extends BaseAPI {
    /**
     * 
     * @param {VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesTypesGetPost(requestParameters: VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesTypesGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleTypeGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesTypesPost(requestParameters: VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesTypesPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleTypesAdminApi
     */
    public apiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPut(requestParameters: VehicleTypesAdminApiApiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPutRequest, options?: RawAxiosRequestConfig) {
        return VehicleTypesAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesTypesVehicleTypeIdPut(requestParameters.vehicleTypeId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleVisualModelsApi - axios parameter creator
 * @export
 */
export const VehicleVisualModelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleVisualModelGetPaginatedDto} [vehicleVisualModelGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesVisualModelsGetPost: async (nexusOpsAppVersion?: string, vehicleVisualModelGetPaginatedDto?: VehicleVisualModelGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/vehicles/visual-models/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleVisualModelGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleVisualModelType} [type] 
         * @param {VehicleType} [vehicleType] 
         * @param {VehicleBodyType} [bodyType] 
         * @param {string} [makeId] 
         * @param {string} [modelId] 
         * @param {string} [generationId] 
         * @param {string} [modificationId] 
         * @param {string} [vehicleId] 
         * @param {boolean} [isIgnoreDefaultForVehicle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet: async (nexusOpsAppVersion?: string, type?: VehicleVisualModelType, vehicleType?: VehicleType, bodyType?: VehicleBodyType, makeId?: string, modelId?: string, generationId?: string, modificationId?: string, vehicleId?: string, isIgnoreDefaultForVehicle?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/reference-data/vehicles/visual-models/latest-or-default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (vehicleType !== undefined) {
                localVarQueryParameter['vehicleType'] = vehicleType;
            }

            if (bodyType !== undefined) {
                localVarQueryParameter['bodyType'] = bodyType;
            }

            if (makeId !== undefined) {
                localVarQueryParameter['makeId'] = makeId;
            }

            if (modelId !== undefined) {
                localVarQueryParameter['modelId'] = modelId;
            }

            if (generationId !== undefined) {
                localVarQueryParameter['generationId'] = generationId;
            }

            if (modificationId !== undefined) {
                localVarQueryParameter['modificationId'] = modificationId;
            }

            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }

            if (isIgnoreDefaultForVehicle !== undefined) {
                localVarQueryParameter['isIgnoreDefaultForVehicle'] = isIgnoreDefaultForVehicle;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} modelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesVisualModelsModelIdGet: async (modelId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('apiV1ReferenceDataVehiclesVisualModelsModelIdGet', 'modelId', modelId)
            const localVarPath = `/api/v1/reference-data/vehicles/visual-models/{modelId}`
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleVisualModelsApi - functional programming interface
 * @export
 */
export const VehicleVisualModelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleVisualModelsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleVisualModelGetPaginatedDto} [vehicleVisualModelGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesVisualModelsGetPost(nexusOpsAppVersion?: string, vehicleVisualModelGetPaginatedDto?: VehicleVisualModelGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfVehicleVisualModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesVisualModelsGetPost(nexusOpsAppVersion, vehicleVisualModelGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleVisualModelsApi.apiV1ReferenceDataVehiclesVisualModelsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleVisualModelType} [type] 
         * @param {VehicleType} [vehicleType] 
         * @param {VehicleBodyType} [bodyType] 
         * @param {string} [makeId] 
         * @param {string} [modelId] 
         * @param {string} [generationId] 
         * @param {string} [modificationId] 
         * @param {string} [vehicleId] 
         * @param {boolean} [isIgnoreDefaultForVehicle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet(nexusOpsAppVersion?: string, type?: VehicleVisualModelType, vehicleType?: VehicleType, bodyType?: VehicleBodyType, makeId?: string, modelId?: string, generationId?: string, modificationId?: string, vehicleId?: string, isIgnoreDefaultForVehicle?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleVisualModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet(nexusOpsAppVersion, type, vehicleType, bodyType, makeId, modelId, generationId, modificationId, vehicleId, isIgnoreDefaultForVehicle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleVisualModelsApi.apiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} modelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReferenceDataVehiclesVisualModelsModelIdGet(modelId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleVisualModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReferenceDataVehiclesVisualModelsModelIdGet(modelId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleVisualModelsApi.apiV1ReferenceDataVehiclesVisualModelsModelIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleVisualModelsApi - factory interface
 * @export
 */
export const VehicleVisualModelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleVisualModelsApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesVisualModelsGetPost(requestParameters: VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfVehicleVisualModelDto> {
            return localVarFp.apiV1ReferenceDataVehiclesVisualModelsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleVisualModelGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet(requestParameters: VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<VehicleVisualModelDto> {
            return localVarFp.apiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet(requestParameters.nexusOpsAppVersion, requestParameters.type, requestParameters.vehicleType, requestParameters.bodyType, requestParameters.makeId, requestParameters.modelId, requestParameters.generationId, requestParameters.modificationId, requestParameters.vehicleId, requestParameters.isIgnoreDefaultForVehicle, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsModelIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReferenceDataVehiclesVisualModelsModelIdGet(requestParameters: VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsModelIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleVisualModelDto> {
            return localVarFp.apiV1ReferenceDataVehiclesVisualModelsModelIdGet(requestParameters.modelId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1ReferenceDataVehiclesVisualModelsGetPost operation in VehicleVisualModelsApi.
 * @export
 * @interface VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsGetPostRequest
 */
export interface VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleVisualModelGetPaginatedDto}
     * @memberof VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsGetPost
     */
    readonly vehicleVisualModelGetPaginatedDto?: VehicleVisualModelGetPaginatedDto
}

/**
 * Request parameters for apiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet operation in VehicleVisualModelsApi.
 * @export
 * @interface VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGetRequest
 */
export interface VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleVisualModelType}
     * @memberof VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet
     */
    readonly type?: VehicleVisualModelType

    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet
     */
    readonly vehicleType?: VehicleType

    /**
     * 
     * @type {VehicleBodyType}
     * @memberof VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet
     */
    readonly bodyType?: VehicleBodyType

    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet
     */
    readonly makeId?: string

    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet
     */
    readonly modelId?: string

    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet
     */
    readonly generationId?: string

    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet
     */
    readonly modificationId?: string

    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet
     */
    readonly vehicleId?: string

    /**
     * 
     * @type {boolean}
     * @memberof VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet
     */
    readonly isIgnoreDefaultForVehicle?: boolean
}

/**
 * Request parameters for apiV1ReferenceDataVehiclesVisualModelsModelIdGet operation in VehicleVisualModelsApi.
 * @export
 * @interface VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsModelIdGetRequest
 */
export interface VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsModelIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsModelIdGet
     */
    readonly modelId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsModelIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * VehicleVisualModelsApi - object-oriented interface
 * @export
 * @class VehicleVisualModelsApi
 * @extends {BaseAPI}
 */
export class VehicleVisualModelsApi extends BaseAPI {
    /**
     * 
     * @param {VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleVisualModelsApi
     */
    public apiV1ReferenceDataVehiclesVisualModelsGetPost(requestParameters: VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleVisualModelsApiFp(this.configuration).apiV1ReferenceDataVehiclesVisualModelsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.vehicleVisualModelGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleVisualModelsApi
     */
    public apiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet(requestParameters: VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGetRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleVisualModelsApiFp(this.configuration).apiV1ReferenceDataVehiclesVisualModelsLatestOrDefaultGet(requestParameters.nexusOpsAppVersion, requestParameters.type, requestParameters.vehicleType, requestParameters.bodyType, requestParameters.makeId, requestParameters.modelId, requestParameters.generationId, requestParameters.modificationId, requestParameters.vehicleId, requestParameters.isIgnoreDefaultForVehicle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsModelIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleVisualModelsApi
     */
    public apiV1ReferenceDataVehiclesVisualModelsModelIdGet(requestParameters: VehicleVisualModelsApiApiV1ReferenceDataVehiclesVisualModelsModelIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleVisualModelsApiFp(this.configuration).apiV1ReferenceDataVehiclesVisualModelsModelIdGet(requestParameters.modelId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleVisualModelsAdminApi - axios parameter creator
 * @export
 */
export const VehicleVisualModelsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleVisualModelGetPaginatedDto} [adminVehicleVisualModelGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesVisualModelsGetPost: async (nexusOpsAppVersion?: string, adminVehicleVisualModelGetPaginatedDto?: AdminVehicleVisualModelGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/visual-models/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminVehicleVisualModelGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleVisualModelType} [type] 
         * @param {VehicleType} [vehicleType] 
         * @param {VehicleBodyType} [bodyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGet: async (nexusOpsAppVersion?: string, type?: VehicleVisualModelType, vehicleType?: VehicleType, bodyType?: VehicleBodyType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/visual-models/latest-or-default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (vehicleType !== undefined) {
                localVarQueryParameter['vehicleType'] = vehicleType;
            }

            if (bodyType !== undefined) {
                localVarQueryParameter['bodyType'] = bodyType;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleVisualModelDto} [adminCreateVehicleVisualModelDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesVisualModelsPost: async (nexusOpsAppVersion?: string, adminCreateVehicleVisualModelDto?: AdminCreateVehicleVisualModelDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/reference-data/vehicles/visual-models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateVehicleVisualModelDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} visualModelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDelete: async (visualModelId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visualModelId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDelete', 'visualModelId', visualModelId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/visual-models/{visualModelId}`
                .replace(`{${"visualModelId"}}`, encodeURIComponent(String(visualModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} visualModelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGet: async (visualModelId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visualModelId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGet', 'visualModelId', visualModelId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/visual-models/{visualModelId}`
                .replace(`{${"visualModelId"}}`, encodeURIComponent(String(visualModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} visualModelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleVisualModelDto} [adminUpdateVehicleVisualModelDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPut: async (visualModelId: string, nexusOpsAppVersion?: string, adminUpdateVehicleVisualModelDto?: AdminUpdateVehicleVisualModelDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visualModelId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPut', 'visualModelId', visualModelId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/visual-models/{visualModelId}`
                .replace(`{${"visualModelId"}}`, encodeURIComponent(String(visualModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateVehicleVisualModelDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a version of entity after update (next version).
         * @param {string} visualModelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleVisualModelDto} [adminUpdateVehicleVisualModelDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPost: async (visualModelId: string, nexusOpsAppVersion?: string, adminUpdateVehicleVisualModelDto?: AdminUpdateVehicleVisualModelDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visualModelId' is not null or undefined
            assertParamExists('apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPost', 'visualModelId', visualModelId)
            const localVarPath = `/api/v1/admin/reference-data/vehicles/visual-models/{visualModelId}/update/next-version`
                .replace(`{${"visualModelId"}}`, encodeURIComponent(String(visualModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateVehicleVisualModelDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleVisualModelsAdminApi - functional programming interface
 * @export
 */
export const VehicleVisualModelsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleVisualModelsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminVehicleVisualModelGetPaginatedDto} [adminVehicleVisualModelGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesVisualModelsGetPost(nexusOpsAppVersion?: string, adminVehicleVisualModelGetPaginatedDto?: AdminVehicleVisualModelGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfAdminVehicleVisualModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesVisualModelsGetPost(nexusOpsAppVersion, adminVehicleVisualModelGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleVisualModelsAdminApi.apiV1AdminReferenceDataVehiclesVisualModelsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleVisualModelType} [type] 
         * @param {VehicleType} [vehicleType] 
         * @param {VehicleBodyType} [bodyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGet(nexusOpsAppVersion?: string, type?: VehicleVisualModelType, vehicleType?: VehicleType, bodyType?: VehicleBodyType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleVisualModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGet(nexusOpsAppVersion, type, vehicleType, bodyType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleVisualModelsAdminApi.apiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminCreateVehicleVisualModelDto} [adminCreateVehicleVisualModelDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesVisualModelsPost(nexusOpsAppVersion?: string, adminCreateVehicleVisualModelDto?: AdminCreateVehicleVisualModelDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleVisualModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesVisualModelsPost(nexusOpsAppVersion, adminCreateVehicleVisualModelDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleVisualModelsAdminApi.apiV1AdminReferenceDataVehiclesVisualModelsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} visualModelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDelete(visualModelId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDelete(visualModelId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleVisualModelsAdminApi.apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} visualModelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGet(visualModelId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleVisualModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGet(visualModelId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleVisualModelsAdminApi.apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} visualModelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleVisualModelDto} [adminUpdateVehicleVisualModelDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPut(visualModelId: string, nexusOpsAppVersion?: string, adminUpdateVehicleVisualModelDto?: AdminUpdateVehicleVisualModelDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVehicleVisualModelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPut(visualModelId, nexusOpsAppVersion, adminUpdateVehicleVisualModelDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleVisualModelsAdminApi.apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a version of entity after update (next version).
         * @param {string} visualModelId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AdminUpdateVehicleVisualModelDto} [adminUpdateVehicleVisualModelDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPost(visualModelId: string, nexusOpsAppVersion?: string, adminUpdateVehicleVisualModelDto?: AdminUpdateVehicleVisualModelDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPost(visualModelId, nexusOpsAppVersion, adminUpdateVehicleVisualModelDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleVisualModelsAdminApi.apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleVisualModelsAdminApi - factory interface
 * @export
 */
export const VehicleVisualModelsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleVisualModelsAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesVisualModelsGetPost(requestParameters: VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfAdminVehicleVisualModelDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesVisualModelsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleVisualModelGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGet(requestParameters: VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleVisualModelDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGet(requestParameters.nexusOpsAppVersion, requestParameters.type, requestParameters.vehicleType, requestParameters.bodyType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesVisualModelsPost(requestParameters: VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleVisualModelDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesVisualModelsPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleVisualModelDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDelete(requestParameters: VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDelete(requestParameters.visualModelId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGet(requestParameters: VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleVisualModelDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGet(requestParameters.visualModelId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPut(requestParameters: VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVehicleVisualModelDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPut(requestParameters.visualModelId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleVisualModelDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a version of entity after update (next version).
         * @param {VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPost(requestParameters: VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<VersionDto> {
            return localVarFp.apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPost(requestParameters.visualModelId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleVisualModelDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesVisualModelsGetPost operation in VehicleVisualModelsAdminApi.
 * @export
 * @interface VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsGetPostRequest
 */
export interface VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminVehicleVisualModelGetPaginatedDto}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsGetPost
     */
    readonly adminVehicleVisualModelGetPaginatedDto?: AdminVehicleVisualModelGetPaginatedDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGet operation in VehicleVisualModelsAdminApi.
 * @export
 * @interface VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGetRequest
 */
export interface VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGetRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleVisualModelType}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGet
     */
    readonly type?: VehicleVisualModelType

    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGet
     */
    readonly vehicleType?: VehicleType

    /**
     * 
     * @type {VehicleBodyType}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGet
     */
    readonly bodyType?: VehicleBodyType
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesVisualModelsPost operation in VehicleVisualModelsAdminApi.
 * @export
 * @interface VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsPostRequest
 */
export interface VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminCreateVehicleVisualModelDto}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsPost
     */
    readonly adminCreateVehicleVisualModelDto?: AdminCreateVehicleVisualModelDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDelete operation in VehicleVisualModelsAdminApi.
 * @export
 * @interface VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDeleteRequest
 */
export interface VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDelete
     */
    readonly visualModelId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGet operation in VehicleVisualModelsAdminApi.
 * @export
 * @interface VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGetRequest
 */
export interface VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGet
     */
    readonly visualModelId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPut operation in VehicleVisualModelsAdminApi.
 * @export
 * @interface VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPutRequest
 */
export interface VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPut
     */
    readonly visualModelId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUpdateVehicleVisualModelDto}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPut
     */
    readonly adminUpdateVehicleVisualModelDto?: AdminUpdateVehicleVisualModelDto
}

/**
 * Request parameters for apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPost operation in VehicleVisualModelsAdminApi.
 * @export
 * @interface VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPostRequest
 */
export interface VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPostRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPost
     */
    readonly visualModelId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AdminUpdateVehicleVisualModelDto}
     * @memberof VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPost
     */
    readonly adminUpdateVehicleVisualModelDto?: AdminUpdateVehicleVisualModelDto
}

/**
 * VehicleVisualModelsAdminApi - object-oriented interface
 * @export
 * @class VehicleVisualModelsAdminApi
 * @extends {BaseAPI}
 */
export class VehicleVisualModelsAdminApi extends BaseAPI {
    /**
     * 
     * @param {VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleVisualModelsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesVisualModelsGetPost(requestParameters: VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleVisualModelsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesVisualModelsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.adminVehicleVisualModelGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleVisualModelsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGet(requestParameters: VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGetRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleVisualModelsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesVisualModelsLatestOrDefaultGet(requestParameters.nexusOpsAppVersion, requestParameters.type, requestParameters.vehicleType, requestParameters.bodyType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleVisualModelsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesVisualModelsPost(requestParameters: VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return VehicleVisualModelsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesVisualModelsPost(requestParameters.nexusOpsAppVersion, requestParameters.adminCreateVehicleVisualModelDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleVisualModelsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDelete(requestParameters: VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return VehicleVisualModelsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdDelete(requestParameters.visualModelId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleVisualModelsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGet(requestParameters: VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehicleVisualModelsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdGet(requestParameters.visualModelId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleVisualModelsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPut(requestParameters: VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPutRequest, options?: RawAxiosRequestConfig) {
        return VehicleVisualModelsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdPut(requestParameters.visualModelId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleVisualModelDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a version of entity after update (next version).
     * @param {VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleVisualModelsAdminApi
     */
    public apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPost(requestParameters: VehicleVisualModelsAdminApiApiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPostRequest, options?: RawAxiosRequestConfig) {
        return VehicleVisualModelsAdminApiFp(this.configuration).apiV1AdminReferenceDataVehiclesVisualModelsVisualModelIdUpdateNextVersionPost(requestParameters.visualModelId, requestParameters.nexusOpsAppVersion, requestParameters.adminUpdateVehicleVisualModelDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehiclesApi - axios parameter creator
 * @export
 */
export const VehiclesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleStatusBulkUpdateDto} [vehicleStatusBulkUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesBulkStatusPut: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, vehicleStatusBulkUpdateDto?: VehicleStatusBulkUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesBulkStatusPut', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/vehicles/bulk/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleStatusBulkUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleCreateManySimilarDto} [vehicleCreateManySimilarDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesCreateManySimilarPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, vehicleCreateManySimilarDto?: VehicleCreateManySimilarDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesCreateManySimilarPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/vehicles/create-many-similar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleCreateManySimilarDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleGetPaginatedDto} [vehicleGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, vehicleGetPaginatedDto?: VehicleGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/vehicles/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateVehicleDto} [createVehicleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createVehicleDto?: CreateVehicleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/vehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVehicleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleTaxCalcRequestDto} [vehicleTaxCalcRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesTaxCalcPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, vehicleTaxCalcRequestDto?: VehicleTaxCalcRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesTaxCalcPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/vehicles/tax/calc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleTaxCalcRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [plateNo] 
         * @param {string} [identificationNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleDataPrefillGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, plateNo?: string, identificationNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleDataPrefillGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/vehicles/vehicle-data-prefill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (plateNo !== undefined) {
                localVarQueryParameter['plateNo'] = plateNo;
            }

            if (identificationNumber !== undefined) {
                localVarQueryParameter['identificationNumber'] = identificationNumber;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [contractId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdAccessoriesGet: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, contractId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdAccessoriesGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdAccessoriesGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/accessories`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (contractId !== undefined) {
                localVarQueryParameter['contractId'] = contractId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdActualStateGet: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdActualStateGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdActualStateGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/actual-state`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdActualStatePdfGet: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdActualStatePdfGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdActualStatePdfGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/actual-state/pdf`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AttachmentsUpdateDto} [attachmentsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdAttachmentsPut: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, attachmentsUpdateDto?: AttachmentsUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdAttachmentsPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdAttachmentsPut', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/attachments`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attachmentsUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Checks vehicle availability based on existing contracts.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} rangeFrom Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {string} rangeTo Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdAvailabilityGet: async (nexusOpsTenant: string, vehicleId: string, rangeFrom: string, rangeTo: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdAvailabilityGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdAvailabilityGet', 'vehicleId', vehicleId)
            // verify required parameter 'rangeFrom' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdAvailabilityGet', 'rangeFrom', rangeFrom)
            // verify required parameter 'rangeTo' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdAvailabilityGet', 'rangeTo', rangeTo)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/availability`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (rangeFrom !== undefined) {
                localVarQueryParameter['range.from'] = rangeFrom;
            }

            if (rangeTo !== undefined) {
                localVarQueryParameter['range.to'] = rangeTo;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralGeolocationOfEntityUpdateDto} [generalGeolocationOfEntityUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdGeolocationPut: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, generalGeolocationOfEntityUpdateDto?: GeneralGeolocationOfEntityUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdGeolocationPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdGeolocationPut', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/geolocation`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalGeolocationOfEntityUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdGet: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleMileageDto} [updateVehicleMileageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdMileagePut: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, updateVehicleMileageDto?: UpdateVehicleMileageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdMileagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdMileagePut', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/mileage`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVehicleMileageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdNotesPut: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdNotesPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdNotesPut', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/notes`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalNotesInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralProductProfileOfEntityUpdateDto} [generalProductProfileOfEntityUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdProductProfilePut: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, generalProductProfileOfEntityUpdateDto?: GeneralProductProfileOfEntityUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdProductProfilePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdProductProfilePut', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/product/profile`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalProductProfileOfEntityUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleDto} [updateVehicleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdPut: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, updateVehicleDto?: UpdateVehicleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdPut', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVehicleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStatusInputTypedDtoOfVehicleStatus} [generalStatusInputTypedDtoOfVehicleStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdStatusPut: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, generalStatusInputTypedDtoOfVehicleStatus?: GeneralStatusInputTypedDtoOfVehicleStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdStatusPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV1VehiclesVehicleIdStatusPut', 'vehicleId', vehicleId)
            const localVarPath = `/api/v1/vehicles/{vehicleId}/status`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalStatusInputTypedDtoOfVehicleStatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehiclesApi - functional programming interface
 * @export
 */
export const VehiclesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehiclesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleStatusBulkUpdateDto} [vehicleStatusBulkUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesBulkStatusPut(nexusOpsTenant: string, nexusOpsAppVersion?: string, vehicleStatusBulkUpdateDto?: VehicleStatusBulkUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleStatusBulkUpdateResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesBulkStatusPut(nexusOpsTenant, nexusOpsAppVersion, vehicleStatusBulkUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesBulkStatusPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleCreateManySimilarDto} [vehicleCreateManySimilarDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesCreateManySimilarPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, vehicleCreateManySimilarDto?: VehicleCreateManySimilarDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesCreateManySimilarPost(nexusOpsTenant, nexusOpsAppVersion, vehicleCreateManySimilarDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesCreateManySimilarPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleGetPaginatedDto} [vehicleGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, vehicleGetPaginatedDto?: VehicleGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfVehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesGetPost(nexusOpsTenant, nexusOpsAppVersion, vehicleGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateVehicleDto} [createVehicleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createVehicleDto?: CreateVehicleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesPost(nexusOpsTenant, nexusOpsAppVersion, createVehicleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VehicleTaxCalcRequestDto} [vehicleTaxCalcRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesTaxCalcPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, vehicleTaxCalcRequestDto?: VehicleTaxCalcRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleTaxCalcResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesTaxCalcPost(nexusOpsTenant, nexusOpsAppVersion, vehicleTaxCalcRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesTaxCalcPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [plateNo] 
         * @param {string} [identificationNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleDataPrefillGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, plateNo?: string, identificationNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDataPrefillDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleDataPrefillGet(nexusOpsTenant, nexusOpsAppVersion, plateNo, identificationNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesVehicleDataPrefillGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [contractId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdAccessoriesGet(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, contractId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleAccessoriesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdAccessoriesGet(nexusOpsTenant, vehicleId, nexusOpsAppVersion, contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesVehicleIdAccessoriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdActualStateGet(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleActualStateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdActualStateGet(nexusOpsTenant, vehicleId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesVehicleIdActualStateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdActualStatePdfGet(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdActualStatePdfGet(nexusOpsTenant, vehicleId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesVehicleIdActualStatePdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AttachmentsUpdateDto} [attachmentsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdAttachmentsPut(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, attachmentsUpdateDto?: AttachmentsUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdAttachmentsPut(nexusOpsTenant, vehicleId, nexusOpsAppVersion, attachmentsUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesVehicleIdAttachmentsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Checks vehicle availability based on existing contracts.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} rangeFrom Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {string} rangeTo Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdAvailabilityGet(nexusOpsTenant: string, vehicleId: string, rangeFrom: string, rangeTo: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleAvailabilityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdAvailabilityGet(nexusOpsTenant, vehicleId, rangeFrom, rangeTo, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesVehicleIdAvailabilityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralGeolocationOfEntityUpdateDto} [generalGeolocationOfEntityUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdGeolocationPut(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, generalGeolocationOfEntityUpdateDto?: GeneralGeolocationOfEntityUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralGeolocationOfEntityUpdateResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdGeolocationPut(nexusOpsTenant, vehicleId, nexusOpsAppVersion, generalGeolocationOfEntityUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesVehicleIdGeolocationPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdGet(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdGet(nexusOpsTenant, vehicleId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesVehicleIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleMileageDto} [updateVehicleMileageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdMileagePut(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, updateVehicleMileageDto?: UpdateVehicleMileageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdMileagePut(nexusOpsTenant, vehicleId, nexusOpsAppVersion, updateVehicleMileageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesVehicleIdMileagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdNotesPut(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdNotesPut(nexusOpsTenant, vehicleId, nexusOpsAppVersion, generalNotesInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesVehicleIdNotesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralProductProfileOfEntityUpdateDto} [generalProductProfileOfEntityUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdProductProfilePut(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, generalProductProfileOfEntityUpdateDto?: GeneralProductProfileOfEntityUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralProductProfileOfEntityUpdateResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdProductProfilePut(nexusOpsTenant, vehicleId, nexusOpsAppVersion, generalProductProfileOfEntityUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesVehicleIdProductProfilePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleDto} [updateVehicleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdPut(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, updateVehicleDto?: UpdateVehicleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdPut(nexusOpsTenant, vehicleId, nexusOpsAppVersion, updateVehicleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesVehicleIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStatusInputTypedDtoOfVehicleStatus} [generalStatusInputTypedDtoOfVehicleStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesVehicleIdStatusPut(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, generalStatusInputTypedDtoOfVehicleStatus?: GeneralStatusInputTypedDtoOfVehicleStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesVehicleIdStatusPut(nexusOpsTenant, vehicleId, nexusOpsAppVersion, generalStatusInputTypedDtoOfVehicleStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.apiV1VehiclesVehicleIdStatusPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehiclesApi - factory interface
 * @export
 */
export const VehiclesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehiclesApiFp(configuration)
    return {
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesBulkStatusPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesBulkStatusPut(requestParameters: VehiclesApiApiV1VehiclesBulkStatusPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleStatusBulkUpdateResultDto> {
            return localVarFp.apiV1VehiclesBulkStatusPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.vehicleStatusBulkUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesCreateManySimilarPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesCreateManySimilarPost(requestParameters: VehiclesApiApiV1VehiclesCreateManySimilarPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<VehicleDto>> {
            return localVarFp.apiV1VehiclesCreateManySimilarPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.vehicleCreateManySimilarDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesGetPost(requestParameters: VehiclesApiApiV1VehiclesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfVehicleDto> {
            return localVarFp.apiV1VehiclesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.vehicleGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesPost(requestParameters: VehiclesApiApiV1VehiclesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleDto> {
            return localVarFp.apiV1VehiclesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createVehicleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesTaxCalcPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesTaxCalcPost(requestParameters: VehiclesApiApiV1VehiclesTaxCalcPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleTaxCalcResponseDto> {
            return localVarFp.apiV1VehiclesTaxCalcPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.vehicleTaxCalcRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesVehicleDataPrefillGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleDataPrefillGet(requestParameters: VehiclesApiApiV1VehiclesVehicleDataPrefillGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleDataPrefillDto> {
            return localVarFp.apiV1VehiclesVehicleDataPrefillGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.plateNo, requestParameters.identificationNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesVehicleIdAccessoriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdAccessoriesGet(requestParameters: VehiclesApiApiV1VehiclesVehicleIdAccessoriesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleAccessoriesDto> {
            return localVarFp.apiV1VehiclesVehicleIdAccessoriesGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesVehicleIdActualStateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdActualStateGet(requestParameters: VehiclesApiApiV1VehiclesVehicleIdActualStateGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleActualStateDto> {
            return localVarFp.apiV1VehiclesVehicleIdActualStateGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesVehicleIdActualStatePdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdActualStatePdfGet(requestParameters: VehiclesApiApiV1VehiclesVehicleIdActualStatePdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1VehiclesVehicleIdActualStatePdfGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesVehicleIdAttachmentsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdAttachmentsPut(requestParameters: VehiclesApiApiV1VehiclesVehicleIdAttachmentsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleDto> {
            return localVarFp.apiV1VehiclesVehicleIdAttachmentsPut(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.attachmentsUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Checks vehicle availability based on existing contracts.
         * @param {VehiclesApiApiV1VehiclesVehicleIdAvailabilityGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdAvailabilityGet(requestParameters: VehiclesApiApiV1VehiclesVehicleIdAvailabilityGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleAvailabilityDto> {
            return localVarFp.apiV1VehiclesVehicleIdAvailabilityGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.rangeFrom, requestParameters.rangeTo, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesVehicleIdGeolocationPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdGeolocationPut(requestParameters: VehiclesApiApiV1VehiclesVehicleIdGeolocationPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralGeolocationOfEntityUpdateResultDto> {
            return localVarFp.apiV1VehiclesVehicleIdGeolocationPut(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.generalGeolocationOfEntityUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesVehicleIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdGet(requestParameters: VehiclesApiApiV1VehiclesVehicleIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleDto> {
            return localVarFp.apiV1VehiclesVehicleIdGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesVehicleIdMileagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdMileagePut(requestParameters: VehiclesApiApiV1VehiclesVehicleIdMileagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleDto> {
            return localVarFp.apiV1VehiclesVehicleIdMileagePut(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleMileageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesVehicleIdNotesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdNotesPut(requestParameters: VehiclesApiApiV1VehiclesVehicleIdNotesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleDto> {
            return localVarFp.apiV1VehiclesVehicleIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesVehicleIdProductProfilePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdProductProfilePut(requestParameters: VehiclesApiApiV1VehiclesVehicleIdProductProfilePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralProductProfileOfEntityUpdateResultDto> {
            return localVarFp.apiV1VehiclesVehicleIdProductProfilePut(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.generalProductProfileOfEntityUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesVehicleIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdPut(requestParameters: VehiclesApiApiV1VehiclesVehicleIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleDto> {
            return localVarFp.apiV1VehiclesVehicleIdPut(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VehiclesApiApiV1VehiclesVehicleIdStatusPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesVehicleIdStatusPut(requestParameters: VehiclesApiApiV1VehiclesVehicleIdStatusPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<VehicleDto> {
            return localVarFp.apiV1VehiclesVehicleIdStatusPut(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.generalStatusInputTypedDtoOfVehicleStatus, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1VehiclesBulkStatusPut operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesBulkStatusPutRequest
 */
export interface VehiclesApiApiV1VehiclesBulkStatusPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesBulkStatusPut
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesBulkStatusPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleStatusBulkUpdateDto}
     * @memberof VehiclesApiApiV1VehiclesBulkStatusPut
     */
    readonly vehicleStatusBulkUpdateDto?: VehicleStatusBulkUpdateDto
}

/**
 * Request parameters for apiV1VehiclesCreateManySimilarPost operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesCreateManySimilarPostRequest
 */
export interface VehiclesApiApiV1VehiclesCreateManySimilarPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesCreateManySimilarPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesCreateManySimilarPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleCreateManySimilarDto}
     * @memberof VehiclesApiApiV1VehiclesCreateManySimilarPost
     */
    readonly vehicleCreateManySimilarDto?: VehicleCreateManySimilarDto
}

/**
 * Request parameters for apiV1VehiclesGetPost operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesGetPostRequest
 */
export interface VehiclesApiApiV1VehiclesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleGetPaginatedDto}
     * @memberof VehiclesApiApiV1VehiclesGetPost
     */
    readonly vehicleGetPaginatedDto?: VehicleGetPaginatedDto
}

/**
 * Request parameters for apiV1VehiclesPost operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesPostRequest
 */
export interface VehiclesApiApiV1VehiclesPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateVehicleDto}
     * @memberof VehiclesApiApiV1VehiclesPost
     */
    readonly createVehicleDto?: CreateVehicleDto
}

/**
 * Request parameters for apiV1VehiclesTaxCalcPost operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesTaxCalcPostRequest
 */
export interface VehiclesApiApiV1VehiclesTaxCalcPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesTaxCalcPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesTaxCalcPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VehicleTaxCalcRequestDto}
     * @memberof VehiclesApiApiV1VehiclesTaxCalcPost
     */
    readonly vehicleTaxCalcRequestDto?: VehicleTaxCalcRequestDto
}

/**
 * Request parameters for apiV1VehiclesVehicleDataPrefillGet operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesVehicleDataPrefillGetRequest
 */
export interface VehiclesApiApiV1VehiclesVehicleDataPrefillGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleDataPrefillGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleDataPrefillGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleDataPrefillGet
     */
    readonly plateNo?: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleDataPrefillGet
     */
    readonly identificationNumber?: string
}

/**
 * Request parameters for apiV1VehiclesVehicleIdAccessoriesGet operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesVehicleIdAccessoriesGetRequest
 */
export interface VehiclesApiApiV1VehiclesVehicleIdAccessoriesGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdAccessoriesGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdAccessoriesGet
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdAccessoriesGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdAccessoriesGet
     */
    readonly contractId?: string
}

/**
 * Request parameters for apiV1VehiclesVehicleIdActualStateGet operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesVehicleIdActualStateGetRequest
 */
export interface VehiclesApiApiV1VehiclesVehicleIdActualStateGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdActualStateGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdActualStateGet
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdActualStateGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1VehiclesVehicleIdActualStatePdfGet operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesVehicleIdActualStatePdfGetRequest
 */
export interface VehiclesApiApiV1VehiclesVehicleIdActualStatePdfGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdActualStatePdfGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdActualStatePdfGet
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdActualStatePdfGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1VehiclesVehicleIdAttachmentsPut operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesVehicleIdAttachmentsPutRequest
 */
export interface VehiclesApiApiV1VehiclesVehicleIdAttachmentsPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdAttachmentsPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdAttachmentsPut
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdAttachmentsPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AttachmentsUpdateDto}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdAttachmentsPut
     */
    readonly attachmentsUpdateDto?: AttachmentsUpdateDto
}

/**
 * Request parameters for apiV1VehiclesVehicleIdAvailabilityGet operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesVehicleIdAvailabilityGetRequest
 */
export interface VehiclesApiApiV1VehiclesVehicleIdAvailabilityGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdAvailabilityGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdAvailabilityGet
     */
    readonly vehicleId: string

    /**
     * Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdAvailabilityGet
     */
    readonly rangeFrom: string

    /**
     * Date-time string in &lt;a href&#x3D;\&quot;https://en.wikipedia.org/wiki/ISO_8601#UTC\\\&quot;&gt;ISO 8601 format&lt;/a&gt;.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdAvailabilityGet
     */
    readonly rangeTo: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdAvailabilityGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1VehiclesVehicleIdGeolocationPut operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesVehicleIdGeolocationPutRequest
 */
export interface VehiclesApiApiV1VehiclesVehicleIdGeolocationPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdGeolocationPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdGeolocationPut
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdGeolocationPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralGeolocationOfEntityUpdateDto}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdGeolocationPut
     */
    readonly generalGeolocationOfEntityUpdateDto?: GeneralGeolocationOfEntityUpdateDto
}

/**
 * Request parameters for apiV1VehiclesVehicleIdGet operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesVehicleIdGetRequest
 */
export interface VehiclesApiApiV1VehiclesVehicleIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdGet
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1VehiclesVehicleIdMileagePut operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesVehicleIdMileagePutRequest
 */
export interface VehiclesApiApiV1VehiclesVehicleIdMileagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdMileagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdMileagePut
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdMileagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateVehicleMileageDto}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdMileagePut
     */
    readonly updateVehicleMileageDto?: UpdateVehicleMileageDto
}

/**
 * Request parameters for apiV1VehiclesVehicleIdNotesPut operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesVehicleIdNotesPutRequest
 */
export interface VehiclesApiApiV1VehiclesVehicleIdNotesPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdNotesPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdNotesPut
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdNotesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralNotesInputDto}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdNotesPut
     */
    readonly generalNotesInputDto?: GeneralNotesInputDto
}

/**
 * Request parameters for apiV1VehiclesVehicleIdProductProfilePut operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesVehicleIdProductProfilePutRequest
 */
export interface VehiclesApiApiV1VehiclesVehicleIdProductProfilePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdProductProfilePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdProductProfilePut
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdProductProfilePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralProductProfileOfEntityUpdateDto}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdProductProfilePut
     */
    readonly generalProductProfileOfEntityUpdateDto?: GeneralProductProfileOfEntityUpdateDto
}

/**
 * Request parameters for apiV1VehiclesVehicleIdPut operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesVehicleIdPutRequest
 */
export interface VehiclesApiApiV1VehiclesVehicleIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdPut
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateVehicleDto}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdPut
     */
    readonly updateVehicleDto?: UpdateVehicleDto
}

/**
 * Request parameters for apiV1VehiclesVehicleIdStatusPut operation in VehiclesApi.
 * @export
 * @interface VehiclesApiApiV1VehiclesVehicleIdStatusPutRequest
 */
export interface VehiclesApiApiV1VehiclesVehicleIdStatusPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdStatusPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdStatusPut
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdStatusPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralStatusInputTypedDtoOfVehicleStatus}
     * @memberof VehiclesApiApiV1VehiclesVehicleIdStatusPut
     */
    readonly generalStatusInputTypedDtoOfVehicleStatus?: GeneralStatusInputTypedDtoOfVehicleStatus
}

/**
 * VehiclesApi - object-oriented interface
 * @export
 * @class VehiclesApi
 * @extends {BaseAPI}
 */
export class VehiclesApi extends BaseAPI {
    /**
     * 
     * @param {VehiclesApiApiV1VehiclesBulkStatusPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesBulkStatusPut(requestParameters: VehiclesApiApiV1VehiclesBulkStatusPutRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesBulkStatusPut(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.vehicleStatusBulkUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesCreateManySimilarPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesCreateManySimilarPost(requestParameters: VehiclesApiApiV1VehiclesCreateManySimilarPostRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesCreateManySimilarPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.vehicleCreateManySimilarDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesGetPost(requestParameters: VehiclesApiApiV1VehiclesGetPostRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.vehicleGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesPost(requestParameters: VehiclesApiApiV1VehiclesPostRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createVehicleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesTaxCalcPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesTaxCalcPost(requestParameters: VehiclesApiApiV1VehiclesTaxCalcPostRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesTaxCalcPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.vehicleTaxCalcRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesVehicleDataPrefillGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesVehicleDataPrefillGet(requestParameters: VehiclesApiApiV1VehiclesVehicleDataPrefillGetRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesVehicleDataPrefillGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.plateNo, requestParameters.identificationNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesVehicleIdAccessoriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesVehicleIdAccessoriesGet(requestParameters: VehiclesApiApiV1VehiclesVehicleIdAccessoriesGetRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesVehicleIdAccessoriesGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesVehicleIdActualStateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesVehicleIdActualStateGet(requestParameters: VehiclesApiApiV1VehiclesVehicleIdActualStateGetRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesVehicleIdActualStateGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesVehicleIdActualStatePdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesVehicleIdActualStatePdfGet(requestParameters: VehiclesApiApiV1VehiclesVehicleIdActualStatePdfGetRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesVehicleIdActualStatePdfGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesVehicleIdAttachmentsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesVehicleIdAttachmentsPut(requestParameters: VehiclesApiApiV1VehiclesVehicleIdAttachmentsPutRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesVehicleIdAttachmentsPut(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.attachmentsUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Checks vehicle availability based on existing contracts.
     * @param {VehiclesApiApiV1VehiclesVehicleIdAvailabilityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesVehicleIdAvailabilityGet(requestParameters: VehiclesApiApiV1VehiclesVehicleIdAvailabilityGetRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesVehicleIdAvailabilityGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.rangeFrom, requestParameters.rangeTo, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesVehicleIdGeolocationPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesVehicleIdGeolocationPut(requestParameters: VehiclesApiApiV1VehiclesVehicleIdGeolocationPutRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesVehicleIdGeolocationPut(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.generalGeolocationOfEntityUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesVehicleIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesVehicleIdGet(requestParameters: VehiclesApiApiV1VehiclesVehicleIdGetRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesVehicleIdGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesVehicleIdMileagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesVehicleIdMileagePut(requestParameters: VehiclesApiApiV1VehiclesVehicleIdMileagePutRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesVehicleIdMileagePut(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleMileageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesVehicleIdNotesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesVehicleIdNotesPut(requestParameters: VehiclesApiApiV1VehiclesVehicleIdNotesPutRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesVehicleIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesVehicleIdProductProfilePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesVehicleIdProductProfilePut(requestParameters: VehiclesApiApiV1VehiclesVehicleIdProductProfilePutRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesVehicleIdProductProfilePut(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.generalProductProfileOfEntityUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesVehicleIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesVehicleIdPut(requestParameters: VehiclesApiApiV1VehiclesVehicleIdPutRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesVehicleIdPut(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VehiclesApiApiV1VehiclesVehicleIdStatusPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesVehicleIdStatusPut(requestParameters: VehiclesApiApiV1VehiclesVehicleIdStatusPutRequest, options?: RawAxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesVehicleIdStatusPut(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.generalStatusInputTypedDtoOfVehicleStatus, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VisualInspectionsApi - axios parameter creator
 * @export
 */
export const VisualInspectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/visual-inspections/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsByIdsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsByIdsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/visual-inspections/by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/visual-inspections/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsCreateMetaGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsCreateMetaGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/visual-inspections/create/meta`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VisualInspectionGetPaginatedDto} [visualInspectionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, visualInspectionGetPaginatedDto?: VisualInspectionGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/visual-inspections/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(visualInspectionGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VisualInspectionCreateDto} [visualInspectionCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, visualInspectionCreateDto?: VisualInspectionCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/visual-inspections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(visualInspectionCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdAddAssignmentPost: async (nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdAddAssignmentPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'visualInspectionId' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdAddAssignmentPost', 'visualInspectionId', visualInspectionId)
            const localVarPath = `/api/v1/visual-inspections/{visualInspectionId}/add-assignment`
                .replace(`{${"visualInspectionId"}}`, encodeURIComponent(String(visualInspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentAddEntityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VisualInspectionAddToContractDto} [visualInspectionAddToContractDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdAddToContractPost: async (nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, visualInspectionAddToContractDto?: VisualInspectionAddToContractDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdAddToContractPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'visualInspectionId' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdAddToContractPost', 'visualInspectionId', visualInspectionId)
            const localVarPath = `/api/v1/visual-inspections/{visualInspectionId}/add-to-contract`
                .replace(`{${"visualInspectionId"}}`, encodeURIComponent(String(visualInspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(visualInspectionAddToContractDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdAutoInspectPut: async (nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdAutoInspectPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'visualInspectionId' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdAutoInspectPut', 'visualInspectionId', visualInspectionId)
            const localVarPath = `/api/v1/visual-inspections/{visualInspectionId}/auto-inspect`
                .replace(`{${"visualInspectionId"}}`, encodeURIComponent(String(visualInspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdDelete: async (nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'visualInspectionId' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdDelete', 'visualInspectionId', visualInspectionId)
            const localVarPath = `/api/v1/visual-inspections/{visualInspectionId}`
                .replace(`{${"visualInspectionId"}}`, encodeURIComponent(String(visualInspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdDownloadPdfGet: async (nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdDownloadPdfGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'visualInspectionId' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdDownloadPdfGet', 'visualInspectionId', visualInspectionId)
            const localVarPath = `/api/v1/visual-inspections/{visualInspectionId}/download/pdf`
                .replace(`{${"visualInspectionId"}}`, encodeURIComponent(String(visualInspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdExternalNumberPut: async (nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdExternalNumberPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'visualInspectionId' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdExternalNumberPut', 'visualInspectionId', visualInspectionId)
            const localVarPath = `/api/v1/visual-inspections/{visualInspectionId}/external-number`
                .replace(`{${"visualInspectionId"}}`, encodeURIComponent(String(visualInspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalExternalNumberInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdGet: async (nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'visualInspectionId' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdGet', 'visualInspectionId', visualInspectionId)
            const localVarPath = `/api/v1/visual-inspections/{visualInspectionId}`
                .replace(`{${"visualInspectionId"}}`, encodeURIComponent(String(visualInspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleMileageDto} [updateVehicleMileageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdMileagePut: async (nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, updateVehicleMileageDto?: UpdateVehicleMileageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdMileagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'visualInspectionId' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdMileagePut', 'visualInspectionId', visualInspectionId)
            const localVarPath = `/api/v1/visual-inspections/{visualInspectionId}/mileage`
                .replace(`{${"visualInspectionId"}}`, encodeURIComponent(String(visualInspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVehicleMileageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdNotesPut: async (nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdNotesPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'visualInspectionId' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdNotesPut', 'visualInspectionId', visualInspectionId)
            const localVarPath = `/api/v1/visual-inspections/{visualInspectionId}/notes`
                .replace(`{${"visualInspectionId"}}`, encodeURIComponent(String(visualInspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalNotesInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VisualInspectionUpdateDto} [visualInspectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdPut: async (nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, visualInspectionUpdateDto?: VisualInspectionUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'visualInspectionId' is not null or undefined
            assertParamExists('apiV1VisualInspectionsVisualInspectionIdPut', 'visualInspectionId', visualInspectionId)
            const localVarPath = `/api/v1/visual-inspections/{visualInspectionId}`
                .replace(`{${"visualInspectionId"}}`, encodeURIComponent(String(visualInspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(visualInspectionUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VisualInspectionsApi - functional programming interface
 * @export
 */
export const VisualInspectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VisualInspectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsByIdsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VisualInspectionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsByIdsGet(nexusOpsTenant, nexusOpsAppVersion, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsByIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisualInspectionCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsCreateMetaGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisualInspectionGetCreateMetaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsCreateMetaGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsCreateMetaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VisualInspectionGetPaginatedDto} [visualInspectionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, visualInspectionGetPaginatedDto?: VisualInspectionGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfVisualInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsGetPost(nexusOpsTenant, nexusOpsAppVersion, visualInspectionGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VisualInspectionCreateDto} [visualInspectionCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, visualInspectionCreateDto?: VisualInspectionCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisualInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsPost(nexusOpsTenant, nexusOpsAppVersion, visualInspectionCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsVisualInspectionIdAddAssignmentPost(nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisualInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsVisualInspectionIdAddAssignmentPost(nexusOpsTenant, visualInspectionId, nexusOpsAppVersion, assignmentAddEntityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsVisualInspectionIdAddAssignmentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VisualInspectionAddToContractDto} [visualInspectionAddToContractDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsVisualInspectionIdAddToContractPost(nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, visualInspectionAddToContractDto?: VisualInspectionAddToContractDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisualInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsVisualInspectionIdAddToContractPost(nexusOpsTenant, visualInspectionId, nexusOpsAppVersion, visualInspectionAddToContractDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsVisualInspectionIdAddToContractPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsVisualInspectionIdAutoInspectPut(nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisualInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsVisualInspectionIdAutoInspectPut(nexusOpsTenant, visualInspectionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsVisualInspectionIdAutoInspectPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsVisualInspectionIdDelete(nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsVisualInspectionIdDelete(nexusOpsTenant, visualInspectionId, nexusOpsAppVersion, isDeleteCascade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsVisualInspectionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsVisualInspectionIdDownloadPdfGet(nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsVisualInspectionIdDownloadPdfGet(nexusOpsTenant, visualInspectionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsVisualInspectionIdDownloadPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsVisualInspectionIdExternalNumberPut(nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisualInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsVisualInspectionIdExternalNumberPut(nexusOpsTenant, visualInspectionId, nexusOpsAppVersion, generalExternalNumberInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsVisualInspectionIdExternalNumberPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsVisualInspectionIdGet(nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisualInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsVisualInspectionIdGet(nexusOpsTenant, visualInspectionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsVisualInspectionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleMileageDto} [updateVehicleMileageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsVisualInspectionIdMileagePut(nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, updateVehicleMileageDto?: UpdateVehicleMileageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisualInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsVisualInspectionIdMileagePut(nexusOpsTenant, visualInspectionId, nexusOpsAppVersion, updateVehicleMileageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsVisualInspectionIdMileagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsVisualInspectionIdNotesPut(nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisualInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsVisualInspectionIdNotesPut(nexusOpsTenant, visualInspectionId, nexusOpsAppVersion, generalNotesInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsVisualInspectionIdNotesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} visualInspectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {VisualInspectionUpdateDto} [visualInspectionUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VisualInspectionsVisualInspectionIdPut(nexusOpsTenant: string, visualInspectionId: string, nexusOpsAppVersion?: string, visualInspectionUpdateDto?: VisualInspectionUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisualInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VisualInspectionsVisualInspectionIdPut(nexusOpsTenant, visualInspectionId, nexusOpsAppVersion, visualInspectionUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VisualInspectionsApi.apiV1VisualInspectionsVisualInspectionIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VisualInspectionsApi - factory interface
 * @export
 */
export const VisualInspectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VisualInspectionsApiFp(configuration)
    return {
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsBulkDeleteDelete(requestParameters: VisualInspectionsApiApiV1VisualInspectionsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1VisualInspectionsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsByIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsByIdsGet(requestParameters: VisualInspectionsApiApiV1VisualInspectionsByIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<VisualInspectionDto>> {
            return localVarFp.apiV1VisualInspectionsByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsCountersGet(requestParameters: VisualInspectionsApiApiV1VisualInspectionsCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VisualInspectionCountersDto> {
            return localVarFp.apiV1VisualInspectionsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsCreateMetaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsCreateMetaGet(requestParameters: VisualInspectionsApiApiV1VisualInspectionsCreateMetaGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VisualInspectionGetCreateMetaDto> {
            return localVarFp.apiV1VisualInspectionsCreateMetaGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsGetPost(requestParameters: VisualInspectionsApiApiV1VisualInspectionsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfVisualInspectionDto> {
            return localVarFp.apiV1VisualInspectionsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.visualInspectionGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsPost(requestParameters: VisualInspectionsApiApiV1VisualInspectionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<VisualInspectionDto> {
            return localVarFp.apiV1VisualInspectionsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.visualInspectionCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddAssignmentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdAddAssignmentPost(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddAssignmentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<VisualInspectionDto> {
            return localVarFp.apiV1VisualInspectionsVisualInspectionIdAddAssignmentPost(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddToContractPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdAddToContractPost(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddToContractPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<VisualInspectionDto> {
            return localVarFp.apiV1VisualInspectionsVisualInspectionIdAddToContractPost(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, requestParameters.visualInspectionAddToContractDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAutoInspectPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdAutoInspectPut(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAutoInspectPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<VisualInspectionDto> {
            return localVarFp.apiV1VisualInspectionsVisualInspectionIdAutoInspectPut(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdDelete(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1VisualInspectionsVisualInspectionIdDelete(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDownloadPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdDownloadPdfGet(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1VisualInspectionsVisualInspectionIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdExternalNumberPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdExternalNumberPut(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdExternalNumberPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<VisualInspectionDto> {
            return localVarFp.apiV1VisualInspectionsVisualInspectionIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdGet(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VisualInspectionDto> {
            return localVarFp.apiV1VisualInspectionsVisualInspectionIdGet(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdMileagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdMileagePut(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdMileagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<VisualInspectionDto> {
            return localVarFp.apiV1VisualInspectionsVisualInspectionIdMileagePut(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleMileageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdNotesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdNotesPut(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdNotesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<VisualInspectionDto> {
            return localVarFp.apiV1VisualInspectionsVisualInspectionIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VisualInspectionsVisualInspectionIdPut(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<VisualInspectionDto> {
            return localVarFp.apiV1VisualInspectionsVisualInspectionIdPut(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, requestParameters.visualInspectionUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1VisualInspectionsBulkDeleteDelete operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsBulkDeleteDeleteRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1VisualInspectionsByIdsGet operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsByIdsGetRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsByIdsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsByIdsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsByIdsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsByIdsGet
     */
    readonly ids?: Array<string>
}

/**
 * Request parameters for apiV1VisualInspectionsCountersGet operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsCountersGetRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1VisualInspectionsCreateMetaGet operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsCreateMetaGetRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsCreateMetaGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsCreateMetaGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsCreateMetaGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1VisualInspectionsGetPost operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsGetPostRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VisualInspectionGetPaginatedDto}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsGetPost
     */
    readonly visualInspectionGetPaginatedDto?: VisualInspectionGetPaginatedDto
}

/**
 * Request parameters for apiV1VisualInspectionsPost operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsPostRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VisualInspectionCreateDto}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsPost
     */
    readonly visualInspectionCreateDto?: VisualInspectionCreateDto
}

/**
 * Request parameters for apiV1VisualInspectionsVisualInspectionIdAddAssignmentPost operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddAssignmentPostRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddAssignmentPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddAssignmentPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddAssignmentPost
     */
    readonly visualInspectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddAssignmentPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentAddEntityDto}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddAssignmentPost
     */
    readonly assignmentAddEntityDto?: AssignmentAddEntityDto
}

/**
 * Request parameters for apiV1VisualInspectionsVisualInspectionIdAddToContractPost operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddToContractPostRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddToContractPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddToContractPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddToContractPost
     */
    readonly visualInspectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddToContractPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VisualInspectionAddToContractDto}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddToContractPost
     */
    readonly visualInspectionAddToContractDto?: VisualInspectionAddToContractDto
}

/**
 * Request parameters for apiV1VisualInspectionsVisualInspectionIdAutoInspectPut operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAutoInspectPutRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAutoInspectPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAutoInspectPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAutoInspectPut
     */
    readonly visualInspectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAutoInspectPut
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1VisualInspectionsVisualInspectionIdDelete operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDeleteRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDelete
     */
    readonly visualInspectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDelete
     */
    readonly isDeleteCascade?: boolean
}

/**
 * Request parameters for apiV1VisualInspectionsVisualInspectionIdDownloadPdfGet operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDownloadPdfGetRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDownloadPdfGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDownloadPdfGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDownloadPdfGet
     */
    readonly visualInspectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDownloadPdfGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1VisualInspectionsVisualInspectionIdExternalNumberPut operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdExternalNumberPutRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdExternalNumberPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdExternalNumberPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdExternalNumberPut
     */
    readonly visualInspectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdExternalNumberPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralExternalNumberInputDto}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdExternalNumberPut
     */
    readonly generalExternalNumberInputDto?: GeneralExternalNumberInputDto
}

/**
 * Request parameters for apiV1VisualInspectionsVisualInspectionIdGet operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdGetRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdGet
     */
    readonly visualInspectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1VisualInspectionsVisualInspectionIdMileagePut operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdMileagePutRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdMileagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdMileagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdMileagePut
     */
    readonly visualInspectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdMileagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateVehicleMileageDto}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdMileagePut
     */
    readonly updateVehicleMileageDto?: UpdateVehicleMileageDto
}

/**
 * Request parameters for apiV1VisualInspectionsVisualInspectionIdNotesPut operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdNotesPutRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdNotesPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdNotesPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdNotesPut
     */
    readonly visualInspectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdNotesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralNotesInputDto}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdNotesPut
     */
    readonly generalNotesInputDto?: GeneralNotesInputDto
}

/**
 * Request parameters for apiV1VisualInspectionsVisualInspectionIdPut operation in VisualInspectionsApi.
 * @export
 * @interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdPutRequest
 */
export interface VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdPut
     */
    readonly visualInspectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {VisualInspectionUpdateDto}
     * @memberof VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdPut
     */
    readonly visualInspectionUpdateDto?: VisualInspectionUpdateDto
}

/**
 * VisualInspectionsApi - object-oriented interface
 * @export
 * @class VisualInspectionsApi
 * @extends {BaseAPI}
 */
export class VisualInspectionsApi extends BaseAPI {
    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsBulkDeleteDelete(requestParameters: VisualInspectionsApiApiV1VisualInspectionsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsByIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsByIdsGet(requestParameters: VisualInspectionsApiApiV1VisualInspectionsByIdsGetRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsCountersGet(requestParameters: VisualInspectionsApiApiV1VisualInspectionsCountersGetRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsCreateMetaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsCreateMetaGet(requestParameters: VisualInspectionsApiApiV1VisualInspectionsCreateMetaGetRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsCreateMetaGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsGetPost(requestParameters: VisualInspectionsApiApiV1VisualInspectionsGetPostRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.visualInspectionGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsPost(requestParameters: VisualInspectionsApiApiV1VisualInspectionsPostRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.visualInspectionCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddAssignmentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsVisualInspectionIdAddAssignmentPost(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddAssignmentPostRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsVisualInspectionIdAddAssignmentPost(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddToContractPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsVisualInspectionIdAddToContractPost(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAddToContractPostRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsVisualInspectionIdAddToContractPost(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, requestParameters.visualInspectionAddToContractDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAutoInspectPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsVisualInspectionIdAutoInspectPut(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdAutoInspectPutRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsVisualInspectionIdAutoInspectPut(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsVisualInspectionIdDelete(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsVisualInspectionIdDelete(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDownloadPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsVisualInspectionIdDownloadPdfGet(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdDownloadPdfGetRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsVisualInspectionIdDownloadPdfGet(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdExternalNumberPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsVisualInspectionIdExternalNumberPut(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdExternalNumberPutRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsVisualInspectionIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsVisualInspectionIdGet(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdGetRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsVisualInspectionIdGet(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdMileagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsVisualInspectionIdMileagePut(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdMileagePutRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsVisualInspectionIdMileagePut(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleMileageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdNotesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsVisualInspectionIdNotesPut(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdNotesPutRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsVisualInspectionIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisualInspectionsApi
     */
    public apiV1VisualInspectionsVisualInspectionIdPut(requestParameters: VisualInspectionsApiApiV1VisualInspectionsVisualInspectionIdPutRequest, options?: RawAxiosRequestConfig) {
        return VisualInspectionsApiFp(this.configuration).apiV1VisualInspectionsVisualInspectionIdPut(requestParameters.nexusOpsTenant, requestParameters.visualInspectionId, requestParameters.nexusOpsAppVersion, requestParameters.visualInspectionUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WashesApi - axios parameter creator
 * @export
 */
export const WashesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WashesBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/washes/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesByIdsGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WashesByIdsGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/washes/by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WashesCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/washes/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WashGetPaginatedDto} [washGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, washGetPaginatedDto?: WashGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WashesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/washes/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(washGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateWashDto} [createWashDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createWashDto?: CreateWashDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WashesPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/washes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWashDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdAddAssignmentPost: async (nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WashesWashIdAddAssignmentPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'washId' is not null or undefined
            assertParamExists('apiV1WashesWashIdAddAssignmentPost', 'washId', washId)
            const localVarPath = `/api/v1/washes/{washId}/add-assignment`
                .replace(`{${"washId"}}`, encodeURIComponent(String(washId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentAddEntityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdDelete: async (nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WashesWashIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'washId' is not null or undefined
            assertParamExists('apiV1WashesWashIdDelete', 'washId', washId)
            const localVarPath = `/api/v1/washes/{washId}`
                .replace(`{${"washId"}}`, encodeURIComponent(String(washId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdExternalNumberPut: async (nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WashesWashIdExternalNumberPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'washId' is not null or undefined
            assertParamExists('apiV1WashesWashIdExternalNumberPut', 'washId', washId)
            const localVarPath = `/api/v1/washes/{washId}/external-number`
                .replace(`{${"washId"}}`, encodeURIComponent(String(washId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalExternalNumberInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdGet: async (nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WashesWashIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'washId' is not null or undefined
            assertParamExists('apiV1WashesWashIdGet', 'washId', washId)
            const localVarPath = `/api/v1/washes/{washId}`
                .replace(`{${"washId"}}`, encodeURIComponent(String(washId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleMileageDto} [updateVehicleMileageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdMileagePut: async (nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, updateVehicleMileageDto?: UpdateVehicleMileageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WashesWashIdMileagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'washId' is not null or undefined
            assertParamExists('apiV1WashesWashIdMileagePut', 'washId', washId)
            const localVarPath = `/api/v1/washes/{washId}/mileage`
                .replace(`{${"washId"}}`, encodeURIComponent(String(washId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVehicleMileageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdNotesPut: async (nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WashesWashIdNotesPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'washId' is not null or undefined
            assertParamExists('apiV1WashesWashIdNotesPut', 'washId', washId)
            const localVarPath = `/api/v1/washes/{washId}/notes`
                .replace(`{${"washId"}}`, encodeURIComponent(String(washId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalNotesInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateWashDto} [updateWashDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdPut: async (nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, updateWashDto?: UpdateWashDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WashesWashIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'washId' is not null or undefined
            assertParamExists('apiV1WashesWashIdPut', 'washId', washId)
            const localVarPath = `/api/v1/washes/{washId}`
                .replace(`{${"washId"}}`, encodeURIComponent(String(washId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWashDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStageUpdateDtoOfWashStage} [generalStageUpdateDtoOfWashStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdStagePut: async (nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, generalStageUpdateDtoOfWashStage?: GeneralStageUpdateDtoOfWashStage, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WashesWashIdStagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'washId' is not null or undefined
            assertParamExists('apiV1WashesWashIdStagePut', 'washId', washId)
            const localVarPath = `/api/v1/washes/{washId}/stage`
                .replace(`{${"washId"}}`, encodeURIComponent(String(washId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalStageUpdateDtoOfWashStage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WashesApi - functional programming interface
 * @export
 */
export const WashesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WashesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WashesBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WashesBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WashesApi.apiV1WashesBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WashesByIdsGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WashDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WashesByIdsGet(nexusOpsTenant, nexusOpsAppVersion, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WashesApi.apiV1WashesByIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WashesCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WashCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WashesCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WashesApi.apiV1WashesCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WashGetPaginatedDto} [washGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WashesGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, washGetPaginatedDto?: WashGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfWashDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WashesGetPost(nexusOpsTenant, nexusOpsAppVersion, washGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WashesApi.apiV1WashesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateWashDto} [createWashDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WashesPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createWashDto?: CreateWashDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WashDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WashesPost(nexusOpsTenant, nexusOpsAppVersion, createWashDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WashesApi.apiV1WashesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WashesWashIdAddAssignmentPost(nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WashDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WashesWashIdAddAssignmentPost(nexusOpsTenant, washId, nexusOpsAppVersion, assignmentAddEntityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WashesApi.apiV1WashesWashIdAddAssignmentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WashesWashIdDelete(nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WashesWashIdDelete(nexusOpsTenant, washId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WashesApi.apiV1WashesWashIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WashesWashIdExternalNumberPut(nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WashDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WashesWashIdExternalNumberPut(nexusOpsTenant, washId, nexusOpsAppVersion, generalExternalNumberInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WashesApi.apiV1WashesWashIdExternalNumberPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WashesWashIdGet(nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WashDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WashesWashIdGet(nexusOpsTenant, washId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WashesApi.apiV1WashesWashIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleMileageDto} [updateVehicleMileageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WashesWashIdMileagePut(nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, updateVehicleMileageDto?: UpdateVehicleMileageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WashDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WashesWashIdMileagePut(nexusOpsTenant, washId, nexusOpsAppVersion, updateVehicleMileageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WashesApi.apiV1WashesWashIdMileagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WashesWashIdNotesPut(nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WashDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WashesWashIdNotesPut(nexusOpsTenant, washId, nexusOpsAppVersion, generalNotesInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WashesApi.apiV1WashesWashIdNotesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateWashDto} [updateWashDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WashesWashIdPut(nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, updateWashDto?: UpdateWashDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WashDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WashesWashIdPut(nexusOpsTenant, washId, nexusOpsAppVersion, updateWashDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WashesApi.apiV1WashesWashIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} washId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStageUpdateDtoOfWashStage} [generalStageUpdateDtoOfWashStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WashesWashIdStagePut(nexusOpsTenant: string, washId: string, nexusOpsAppVersion?: string, generalStageUpdateDtoOfWashStage?: GeneralStageUpdateDtoOfWashStage, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WashDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WashesWashIdStagePut(nexusOpsTenant, washId, nexusOpsAppVersion, generalStageUpdateDtoOfWashStage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WashesApi.apiV1WashesWashIdStagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WashesApi - factory interface
 * @export
 */
export const WashesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WashesApiFp(configuration)
    return {
        /**
         * 
         * @param {WashesApiApiV1WashesBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesBulkDeleteDelete(requestParameters: WashesApiApiV1WashesBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1WashesBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WashesApiApiV1WashesByIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesByIdsGet(requestParameters: WashesApiApiV1WashesByIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WashDto>> {
            return localVarFp.apiV1WashesByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WashesApiApiV1WashesCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesCountersGet(requestParameters: WashesApiApiV1WashesCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WashCountersDto> {
            return localVarFp.apiV1WashesCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WashesApiApiV1WashesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesGetPost(requestParameters: WashesApiApiV1WashesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfWashDto> {
            return localVarFp.apiV1WashesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.washGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WashesApiApiV1WashesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesPost(requestParameters: WashesApiApiV1WashesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WashDto> {
            return localVarFp.apiV1WashesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createWashDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WashesApiApiV1WashesWashIdAddAssignmentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdAddAssignmentPost(requestParameters: WashesApiApiV1WashesWashIdAddAssignmentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WashDto> {
            return localVarFp.apiV1WashesWashIdAddAssignmentPost(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WashesApiApiV1WashesWashIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdDelete(requestParameters: WashesApiApiV1WashesWashIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1WashesWashIdDelete(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WashesApiApiV1WashesWashIdExternalNumberPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdExternalNumberPut(requestParameters: WashesApiApiV1WashesWashIdExternalNumberPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WashDto> {
            return localVarFp.apiV1WashesWashIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WashesApiApiV1WashesWashIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdGet(requestParameters: WashesApiApiV1WashesWashIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WashDto> {
            return localVarFp.apiV1WashesWashIdGet(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WashesApiApiV1WashesWashIdMileagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdMileagePut(requestParameters: WashesApiApiV1WashesWashIdMileagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WashDto> {
            return localVarFp.apiV1WashesWashIdMileagePut(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleMileageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WashesApiApiV1WashesWashIdNotesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdNotesPut(requestParameters: WashesApiApiV1WashesWashIdNotesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WashDto> {
            return localVarFp.apiV1WashesWashIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WashesApiApiV1WashesWashIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdPut(requestParameters: WashesApiApiV1WashesWashIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WashDto> {
            return localVarFp.apiV1WashesWashIdPut(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, requestParameters.updateWashDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WashesApiApiV1WashesWashIdStagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WashesWashIdStagePut(requestParameters: WashesApiApiV1WashesWashIdStagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WashDto> {
            return localVarFp.apiV1WashesWashIdStagePut(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, requestParameters.generalStageUpdateDtoOfWashStage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1WashesBulkDeleteDelete operation in WashesApi.
 * @export
 * @interface WashesApiApiV1WashesBulkDeleteDeleteRequest
 */
export interface WashesApiApiV1WashesBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WashesApiApiV1WashesBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WashesApiApiV1WashesBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof WashesApiApiV1WashesBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1WashesByIdsGet operation in WashesApi.
 * @export
 * @interface WashesApiApiV1WashesByIdsGetRequest
 */
export interface WashesApiApiV1WashesByIdsGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WashesApiApiV1WashesByIdsGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WashesApiApiV1WashesByIdsGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof WashesApiApiV1WashesByIdsGet
     */
    readonly ids?: Array<string>
}

/**
 * Request parameters for apiV1WashesCountersGet operation in WashesApi.
 * @export
 * @interface WashesApiApiV1WashesCountersGetRequest
 */
export interface WashesApiApiV1WashesCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WashesApiApiV1WashesCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WashesApiApiV1WashesCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1WashesGetPost operation in WashesApi.
 * @export
 * @interface WashesApiApiV1WashesGetPostRequest
 */
export interface WashesApiApiV1WashesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WashesApiApiV1WashesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WashesApiApiV1WashesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {WashGetPaginatedDto}
     * @memberof WashesApiApiV1WashesGetPost
     */
    readonly washGetPaginatedDto?: WashGetPaginatedDto
}

/**
 * Request parameters for apiV1WashesPost operation in WashesApi.
 * @export
 * @interface WashesApiApiV1WashesPostRequest
 */
export interface WashesApiApiV1WashesPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WashesApiApiV1WashesPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WashesApiApiV1WashesPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateWashDto}
     * @memberof WashesApiApiV1WashesPost
     */
    readonly createWashDto?: CreateWashDto
}

/**
 * Request parameters for apiV1WashesWashIdAddAssignmentPost operation in WashesApi.
 * @export
 * @interface WashesApiApiV1WashesWashIdAddAssignmentPostRequest
 */
export interface WashesApiApiV1WashesWashIdAddAssignmentPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdAddAssignmentPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdAddAssignmentPost
     */
    readonly washId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdAddAssignmentPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentAddEntityDto}
     * @memberof WashesApiApiV1WashesWashIdAddAssignmentPost
     */
    readonly assignmentAddEntityDto?: AssignmentAddEntityDto
}

/**
 * Request parameters for apiV1WashesWashIdDelete operation in WashesApi.
 * @export
 * @interface WashesApiApiV1WashesWashIdDeleteRequest
 */
export interface WashesApiApiV1WashesWashIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdDelete
     */
    readonly washId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1WashesWashIdExternalNumberPut operation in WashesApi.
 * @export
 * @interface WashesApiApiV1WashesWashIdExternalNumberPutRequest
 */
export interface WashesApiApiV1WashesWashIdExternalNumberPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdExternalNumberPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdExternalNumberPut
     */
    readonly washId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdExternalNumberPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralExternalNumberInputDto}
     * @memberof WashesApiApiV1WashesWashIdExternalNumberPut
     */
    readonly generalExternalNumberInputDto?: GeneralExternalNumberInputDto
}

/**
 * Request parameters for apiV1WashesWashIdGet operation in WashesApi.
 * @export
 * @interface WashesApiApiV1WashesWashIdGetRequest
 */
export interface WashesApiApiV1WashesWashIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdGet
     */
    readonly washId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1WashesWashIdMileagePut operation in WashesApi.
 * @export
 * @interface WashesApiApiV1WashesWashIdMileagePutRequest
 */
export interface WashesApiApiV1WashesWashIdMileagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdMileagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdMileagePut
     */
    readonly washId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdMileagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateVehicleMileageDto}
     * @memberof WashesApiApiV1WashesWashIdMileagePut
     */
    readonly updateVehicleMileageDto?: UpdateVehicleMileageDto
}

/**
 * Request parameters for apiV1WashesWashIdNotesPut operation in WashesApi.
 * @export
 * @interface WashesApiApiV1WashesWashIdNotesPutRequest
 */
export interface WashesApiApiV1WashesWashIdNotesPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdNotesPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdNotesPut
     */
    readonly washId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdNotesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralNotesInputDto}
     * @memberof WashesApiApiV1WashesWashIdNotesPut
     */
    readonly generalNotesInputDto?: GeneralNotesInputDto
}

/**
 * Request parameters for apiV1WashesWashIdPut operation in WashesApi.
 * @export
 * @interface WashesApiApiV1WashesWashIdPutRequest
 */
export interface WashesApiApiV1WashesWashIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdPut
     */
    readonly washId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateWashDto}
     * @memberof WashesApiApiV1WashesWashIdPut
     */
    readonly updateWashDto?: UpdateWashDto
}

/**
 * Request parameters for apiV1WashesWashIdStagePut operation in WashesApi.
 * @export
 * @interface WashesApiApiV1WashesWashIdStagePutRequest
 */
export interface WashesApiApiV1WashesWashIdStagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdStagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdStagePut
     */
    readonly washId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WashesApiApiV1WashesWashIdStagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralStageUpdateDtoOfWashStage}
     * @memberof WashesApiApiV1WashesWashIdStagePut
     */
    readonly generalStageUpdateDtoOfWashStage?: GeneralStageUpdateDtoOfWashStage
}

/**
 * WashesApi - object-oriented interface
 * @export
 * @class WashesApi
 * @extends {BaseAPI}
 */
export class WashesApi extends BaseAPI {
    /**
     * 
     * @param {WashesApiApiV1WashesBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WashesApi
     */
    public apiV1WashesBulkDeleteDelete(requestParameters: WashesApiApiV1WashesBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return WashesApiFp(this.configuration).apiV1WashesBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WashesApiApiV1WashesByIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WashesApi
     */
    public apiV1WashesByIdsGet(requestParameters: WashesApiApiV1WashesByIdsGetRequest, options?: RawAxiosRequestConfig) {
        return WashesApiFp(this.configuration).apiV1WashesByIdsGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WashesApiApiV1WashesCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WashesApi
     */
    public apiV1WashesCountersGet(requestParameters: WashesApiApiV1WashesCountersGetRequest, options?: RawAxiosRequestConfig) {
        return WashesApiFp(this.configuration).apiV1WashesCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WashesApiApiV1WashesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WashesApi
     */
    public apiV1WashesGetPost(requestParameters: WashesApiApiV1WashesGetPostRequest, options?: RawAxiosRequestConfig) {
        return WashesApiFp(this.configuration).apiV1WashesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.washGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WashesApiApiV1WashesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WashesApi
     */
    public apiV1WashesPost(requestParameters: WashesApiApiV1WashesPostRequest, options?: RawAxiosRequestConfig) {
        return WashesApiFp(this.configuration).apiV1WashesPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createWashDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WashesApiApiV1WashesWashIdAddAssignmentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WashesApi
     */
    public apiV1WashesWashIdAddAssignmentPost(requestParameters: WashesApiApiV1WashesWashIdAddAssignmentPostRequest, options?: RawAxiosRequestConfig) {
        return WashesApiFp(this.configuration).apiV1WashesWashIdAddAssignmentPost(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WashesApiApiV1WashesWashIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WashesApi
     */
    public apiV1WashesWashIdDelete(requestParameters: WashesApiApiV1WashesWashIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return WashesApiFp(this.configuration).apiV1WashesWashIdDelete(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WashesApiApiV1WashesWashIdExternalNumberPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WashesApi
     */
    public apiV1WashesWashIdExternalNumberPut(requestParameters: WashesApiApiV1WashesWashIdExternalNumberPutRequest, options?: RawAxiosRequestConfig) {
        return WashesApiFp(this.configuration).apiV1WashesWashIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WashesApiApiV1WashesWashIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WashesApi
     */
    public apiV1WashesWashIdGet(requestParameters: WashesApiApiV1WashesWashIdGetRequest, options?: RawAxiosRequestConfig) {
        return WashesApiFp(this.configuration).apiV1WashesWashIdGet(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WashesApiApiV1WashesWashIdMileagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WashesApi
     */
    public apiV1WashesWashIdMileagePut(requestParameters: WashesApiApiV1WashesWashIdMileagePutRequest, options?: RawAxiosRequestConfig) {
        return WashesApiFp(this.configuration).apiV1WashesWashIdMileagePut(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleMileageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WashesApiApiV1WashesWashIdNotesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WashesApi
     */
    public apiV1WashesWashIdNotesPut(requestParameters: WashesApiApiV1WashesWashIdNotesPutRequest, options?: RawAxiosRequestConfig) {
        return WashesApiFp(this.configuration).apiV1WashesWashIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WashesApiApiV1WashesWashIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WashesApi
     */
    public apiV1WashesWashIdPut(requestParameters: WashesApiApiV1WashesWashIdPutRequest, options?: RawAxiosRequestConfig) {
        return WashesApiFp(this.configuration).apiV1WashesWashIdPut(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, requestParameters.updateWashDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WashesApiApiV1WashesWashIdStagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WashesApi
     */
    public apiV1WashesWashIdStagePut(requestParameters: WashesApiApiV1WashesWashIdStagePutRequest, options?: RawAxiosRequestConfig) {
        return WashesApiFp(this.configuration).apiV1WashesWashIdStagePut(requestParameters.nexusOpsTenant, requestParameters.washId, requestParameters.nexusOpsAppVersion, requestParameters.generalStageUpdateDtoOfWashStage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebPushWebhookApi - axios parameter creator
 * @export
 */
export const WebPushWebhookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WebPushWebhookDto} [webPushWebhookDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebHookWebPushPost: async (nexusOpsAppVersion?: string, webPushWebhookDto?: WebPushWebhookDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/web-hook/web-push`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webPushWebhookDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebPushWebhookApi - functional programming interface
 * @export
 */
export const WebPushWebhookApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebPushWebhookApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WebPushWebhookDto} [webPushWebhookDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebHookWebPushPost(nexusOpsAppVersion?: string, webPushWebhookDto?: WebPushWebhookDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebHookWebPushPost(nexusOpsAppVersion, webPushWebhookDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebPushWebhookApi.apiV1WebHookWebPushPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebPushWebhookApi - factory interface
 * @export
 */
export const WebPushWebhookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebPushWebhookApiFp(configuration)
    return {
        /**
         * 
         * @param {WebPushWebhookApiApiV1WebHookWebPushPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebHookWebPushPost(requestParameters: WebPushWebhookApiApiV1WebHookWebPushPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1WebHookWebPushPost(requestParameters.nexusOpsAppVersion, requestParameters.webPushWebhookDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1WebHookWebPushPost operation in WebPushWebhookApi.
 * @export
 * @interface WebPushWebhookApiApiV1WebHookWebPushPostRequest
 */
export interface WebPushWebhookApiApiV1WebHookWebPushPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WebPushWebhookApiApiV1WebHookWebPushPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {WebPushWebhookDto}
     * @memberof WebPushWebhookApiApiV1WebHookWebPushPost
     */
    readonly webPushWebhookDto?: WebPushWebhookDto
}

/**
 * WebPushWebhookApi - object-oriented interface
 * @export
 * @class WebPushWebhookApi
 * @extends {BaseAPI}
 */
export class WebPushWebhookApi extends BaseAPI {
    /**
     * 
     * @param {WebPushWebhookApiApiV1WebHookWebPushPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebPushWebhookApi
     */
    public apiV1WebHookWebPushPost(requestParameters: WebPushWebhookApiApiV1WebHookWebPushPostRequest = {}, options?: RawAxiosRequestConfig) {
        return WebPushWebhookApiFp(this.configuration).apiV1WebHookWebPushPost(requestParameters.nexusOpsAppVersion, requestParameters.webPushWebhookDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebhooksApi - axios parameter creator
 * @export
 */
export const WebhooksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WebhookActivationGetPaginatedDto} [webhookActivationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksActivationsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, webhookActivationGetPaginatedDto?: WebhookActivationGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WebhooksActivationsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/webhooks/activations/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webhookActivationGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WebhookGetPaginatedDto} [webhookGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, webhookGetPaginatedDto?: WebhookGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WebhooksGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/webhooks/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webhookGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateWebhookDto} [createWebhookDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createWebhookDto?: CreateWebhookDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WebhooksPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/webhooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWebhookDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksTriggerTestPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WebhooksTriggerTestPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/webhooks/trigger/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} webhookId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksWebhookIdDelete: async (nexusOpsTenant: string, webhookId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WebhooksWebhookIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('apiV1WebhooksWebhookIdDelete', 'webhookId', webhookId)
            const localVarPath = `/api/v1/webhooks/{webhookId}`
                .replace(`{${"webhookId"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} webhookId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksWebhookIdDisablePut: async (nexusOpsTenant: string, webhookId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WebhooksWebhookIdDisablePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('apiV1WebhooksWebhookIdDisablePut', 'webhookId', webhookId)
            const localVarPath = `/api/v1/webhooks/{webhookId}/disable`
                .replace(`{${"webhookId"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} webhookId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksWebhookIdEnablePut: async (nexusOpsTenant: string, webhookId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WebhooksWebhookIdEnablePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('apiV1WebhooksWebhookIdEnablePut', 'webhookId', webhookId)
            const localVarPath = `/api/v1/webhooks/{webhookId}/enable`
                .replace(`{${"webhookId"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} webhookId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksWebhookIdGet: async (nexusOpsTenant: string, webhookId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WebhooksWebhookIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('apiV1WebhooksWebhookIdGet', 'webhookId', webhookId)
            const localVarPath = `/api/v1/webhooks/{webhookId}`
                .replace(`{${"webhookId"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} webhookId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateWebhookDto} [updateWebhookDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksWebhookIdPut: async (nexusOpsTenant: string, webhookId: string, nexusOpsAppVersion?: string, updateWebhookDto?: UpdateWebhookDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WebhooksWebhookIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('apiV1WebhooksWebhookIdPut', 'webhookId', webhookId)
            const localVarPath = `/api/v1/webhooks/{webhookId}`
                .replace(`{${"webhookId"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWebhookDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhooksApi - functional programming interface
 * @export
 */
export const WebhooksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhooksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WebhookActivationGetPaginatedDto} [webhookActivationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebhooksActivationsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, webhookActivationGetPaginatedDto?: WebhookActivationGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfWebhookActivationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebhooksActivationsGetPost(nexusOpsTenant, nexusOpsAppVersion, webhookActivationGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.apiV1WebhooksActivationsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WebhookGetPaginatedDto} [webhookGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebhooksGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, webhookGetPaginatedDto?: WebhookGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfWebhookDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebhooksGetPost(nexusOpsTenant, nexusOpsAppVersion, webhookGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.apiV1WebhooksGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateWebhookDto} [createWebhookDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebhooksPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createWebhookDto?: CreateWebhookDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebhooksPost(nexusOpsTenant, nexusOpsAppVersion, createWebhookDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.apiV1WebhooksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebhooksTriggerTestPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebhooksTriggerTestPost(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.apiV1WebhooksTriggerTestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} webhookId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebhooksWebhookIdDelete(nexusOpsTenant: string, webhookId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebhooksWebhookIdDelete(nexusOpsTenant, webhookId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.apiV1WebhooksWebhookIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} webhookId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebhooksWebhookIdDisablePut(nexusOpsTenant: string, webhookId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebhooksWebhookIdDisablePut(nexusOpsTenant, webhookId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.apiV1WebhooksWebhookIdDisablePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} webhookId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebhooksWebhookIdEnablePut(nexusOpsTenant: string, webhookId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebhooksWebhookIdEnablePut(nexusOpsTenant, webhookId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.apiV1WebhooksWebhookIdEnablePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} webhookId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebhooksWebhookIdGet(nexusOpsTenant: string, webhookId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebhooksWebhookIdGet(nexusOpsTenant, webhookId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.apiV1WebhooksWebhookIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} webhookId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateWebhookDto} [updateWebhookDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebhooksWebhookIdPut(nexusOpsTenant: string, webhookId: string, nexusOpsAppVersion?: string, updateWebhookDto?: UpdateWebhookDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebhooksWebhookIdPut(nexusOpsTenant, webhookId, nexusOpsAppVersion, updateWebhookDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.apiV1WebhooksWebhookIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebhooksApi - factory interface
 * @export
 */
export const WebhooksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhooksApiFp(configuration)
    return {
        /**
         * 
         * @param {WebhooksApiApiV1WebhooksActivationsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksActivationsGetPost(requestParameters: WebhooksApiApiV1WebhooksActivationsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfWebhookActivationDto> {
            return localVarFp.apiV1WebhooksActivationsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.webhookActivationGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebhooksApiApiV1WebhooksGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksGetPost(requestParameters: WebhooksApiApiV1WebhooksGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfWebhookDto> {
            return localVarFp.apiV1WebhooksGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.webhookGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebhooksApiApiV1WebhooksPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksPost(requestParameters: WebhooksApiApiV1WebhooksPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebhookDto> {
            return localVarFp.apiV1WebhooksPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createWebhookDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebhooksApiApiV1WebhooksTriggerTestPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksTriggerTestPost(requestParameters: WebhooksApiApiV1WebhooksTriggerTestPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1WebhooksTriggerTestPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebhooksApiApiV1WebhooksWebhookIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksWebhookIdDelete(requestParameters: WebhooksApiApiV1WebhooksWebhookIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1WebhooksWebhookIdDelete(requestParameters.nexusOpsTenant, requestParameters.webhookId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebhooksApiApiV1WebhooksWebhookIdDisablePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksWebhookIdDisablePut(requestParameters: WebhooksApiApiV1WebhooksWebhookIdDisablePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebhookDto> {
            return localVarFp.apiV1WebhooksWebhookIdDisablePut(requestParameters.nexusOpsTenant, requestParameters.webhookId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebhooksApiApiV1WebhooksWebhookIdEnablePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksWebhookIdEnablePut(requestParameters: WebhooksApiApiV1WebhooksWebhookIdEnablePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebhookDto> {
            return localVarFp.apiV1WebhooksWebhookIdEnablePut(requestParameters.nexusOpsTenant, requestParameters.webhookId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebhooksApiApiV1WebhooksWebhookIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksWebhookIdGet(requestParameters: WebhooksApiApiV1WebhooksWebhookIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebhookDto> {
            return localVarFp.apiV1WebhooksWebhookIdGet(requestParameters.nexusOpsTenant, requestParameters.webhookId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WebhooksApiApiV1WebhooksWebhookIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebhooksWebhookIdPut(requestParameters: WebhooksApiApiV1WebhooksWebhookIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebhookDto> {
            return localVarFp.apiV1WebhooksWebhookIdPut(requestParameters.nexusOpsTenant, requestParameters.webhookId, requestParameters.nexusOpsAppVersion, requestParameters.updateWebhookDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1WebhooksActivationsGetPost operation in WebhooksApi.
 * @export
 * @interface WebhooksApiApiV1WebhooksActivationsGetPostRequest
 */
export interface WebhooksApiApiV1WebhooksActivationsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksActivationsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksActivationsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {WebhookActivationGetPaginatedDto}
     * @memberof WebhooksApiApiV1WebhooksActivationsGetPost
     */
    readonly webhookActivationGetPaginatedDto?: WebhookActivationGetPaginatedDto
}

/**
 * Request parameters for apiV1WebhooksGetPost operation in WebhooksApi.
 * @export
 * @interface WebhooksApiApiV1WebhooksGetPostRequest
 */
export interface WebhooksApiApiV1WebhooksGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {WebhookGetPaginatedDto}
     * @memberof WebhooksApiApiV1WebhooksGetPost
     */
    readonly webhookGetPaginatedDto?: WebhookGetPaginatedDto
}

/**
 * Request parameters for apiV1WebhooksPost operation in WebhooksApi.
 * @export
 * @interface WebhooksApiApiV1WebhooksPostRequest
 */
export interface WebhooksApiApiV1WebhooksPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateWebhookDto}
     * @memberof WebhooksApiApiV1WebhooksPost
     */
    readonly createWebhookDto?: CreateWebhookDto
}

/**
 * Request parameters for apiV1WebhooksTriggerTestPost operation in WebhooksApi.
 * @export
 * @interface WebhooksApiApiV1WebhooksTriggerTestPostRequest
 */
export interface WebhooksApiApiV1WebhooksTriggerTestPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksTriggerTestPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksTriggerTestPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1WebhooksWebhookIdDelete operation in WebhooksApi.
 * @export
 * @interface WebhooksApiApiV1WebhooksWebhookIdDeleteRequest
 */
export interface WebhooksApiApiV1WebhooksWebhookIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdDelete
     */
    readonly webhookId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1WebhooksWebhookIdDisablePut operation in WebhooksApi.
 * @export
 * @interface WebhooksApiApiV1WebhooksWebhookIdDisablePutRequest
 */
export interface WebhooksApiApiV1WebhooksWebhookIdDisablePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdDisablePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdDisablePut
     */
    readonly webhookId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdDisablePut
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1WebhooksWebhookIdEnablePut operation in WebhooksApi.
 * @export
 * @interface WebhooksApiApiV1WebhooksWebhookIdEnablePutRequest
 */
export interface WebhooksApiApiV1WebhooksWebhookIdEnablePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdEnablePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdEnablePut
     */
    readonly webhookId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdEnablePut
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1WebhooksWebhookIdGet operation in WebhooksApi.
 * @export
 * @interface WebhooksApiApiV1WebhooksWebhookIdGetRequest
 */
export interface WebhooksApiApiV1WebhooksWebhookIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdGet
     */
    readonly webhookId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1WebhooksWebhookIdPut operation in WebhooksApi.
 * @export
 * @interface WebhooksApiApiV1WebhooksWebhookIdPutRequest
 */
export interface WebhooksApiApiV1WebhooksWebhookIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdPut
     */
    readonly webhookId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateWebhookDto}
     * @memberof WebhooksApiApiV1WebhooksWebhookIdPut
     */
    readonly updateWebhookDto?: UpdateWebhookDto
}

/**
 * WebhooksApi - object-oriented interface
 * @export
 * @class WebhooksApi
 * @extends {BaseAPI}
 */
export class WebhooksApi extends BaseAPI {
    /**
     * 
     * @param {WebhooksApiApiV1WebhooksActivationsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public apiV1WebhooksActivationsGetPost(requestParameters: WebhooksApiApiV1WebhooksActivationsGetPostRequest, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).apiV1WebhooksActivationsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.webhookActivationGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebhooksApiApiV1WebhooksGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public apiV1WebhooksGetPost(requestParameters: WebhooksApiApiV1WebhooksGetPostRequest, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).apiV1WebhooksGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.webhookGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebhooksApiApiV1WebhooksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public apiV1WebhooksPost(requestParameters: WebhooksApiApiV1WebhooksPostRequest, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).apiV1WebhooksPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createWebhookDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebhooksApiApiV1WebhooksTriggerTestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public apiV1WebhooksTriggerTestPost(requestParameters: WebhooksApiApiV1WebhooksTriggerTestPostRequest, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).apiV1WebhooksTriggerTestPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebhooksApiApiV1WebhooksWebhookIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public apiV1WebhooksWebhookIdDelete(requestParameters: WebhooksApiApiV1WebhooksWebhookIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).apiV1WebhooksWebhookIdDelete(requestParameters.nexusOpsTenant, requestParameters.webhookId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebhooksApiApiV1WebhooksWebhookIdDisablePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public apiV1WebhooksWebhookIdDisablePut(requestParameters: WebhooksApiApiV1WebhooksWebhookIdDisablePutRequest, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).apiV1WebhooksWebhookIdDisablePut(requestParameters.nexusOpsTenant, requestParameters.webhookId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebhooksApiApiV1WebhooksWebhookIdEnablePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public apiV1WebhooksWebhookIdEnablePut(requestParameters: WebhooksApiApiV1WebhooksWebhookIdEnablePutRequest, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).apiV1WebhooksWebhookIdEnablePut(requestParameters.nexusOpsTenant, requestParameters.webhookId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebhooksApiApiV1WebhooksWebhookIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public apiV1WebhooksWebhookIdGet(requestParameters: WebhooksApiApiV1WebhooksWebhookIdGetRequest, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).apiV1WebhooksWebhookIdGet(requestParameters.nexusOpsTenant, requestParameters.webhookId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WebhooksApiApiV1WebhooksWebhookIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public apiV1WebhooksWebhookIdPut(requestParameters: WebhooksApiApiV1WebhooksWebhookIdPutRequest, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).apiV1WebhooksWebhookIdPut(requestParameters.nexusOpsTenant, requestParameters.webhookId, requestParameters.nexusOpsAppVersion, requestParameters.updateWebhookDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WheelOperationsApi - axios parameter creator
 * @export
 */
export const WheelOperationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsBulkDeleteDelete: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WheelOperationsBulkDeleteDelete', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/wheel-operations/bulk/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsCountersGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WheelOperationsCountersGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/wheel-operations/counters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WheelOperationGetPaginatedDto} [wheelOperationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, wheelOperationGetPaginatedDto?: WheelOperationGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WheelOperationsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/wheel-operations/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wheelOperationGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateWheelOperationDto} [createWheelOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, createWheelOperationDto?: CreateWheelOperationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WheelOperationsPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/wheel-operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWheelOperationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdAddAssignmentPost: async (nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdAddAssignmentPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'wheelOperationId' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdAddAssignmentPost', 'wheelOperationId', wheelOperationId)
            const localVarPath = `/api/v1/wheel-operations/{wheelOperationId}/add-assignment`
                .replace(`{${"wheelOperationId"}}`, encodeURIComponent(String(wheelOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentAddEntityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdDelete: async (nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'wheelOperationId' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdDelete', 'wheelOperationId', wheelOperationId)
            const localVarPath = `/api/v1/wheel-operations/{wheelOperationId}`
                .replace(`{${"wheelOperationId"}}`, encodeURIComponent(String(wheelOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDeleteCascade !== undefined) {
                localVarQueryParameter['isDeleteCascade'] = isDeleteCascade;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdExternalNumberPut: async (nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdExternalNumberPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'wheelOperationId' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdExternalNumberPut', 'wheelOperationId', wheelOperationId)
            const localVarPath = `/api/v1/wheel-operations/{wheelOperationId}/external-number`
                .replace(`{${"wheelOperationId"}}`, encodeURIComponent(String(wheelOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalExternalNumberInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdGet: async (nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'wheelOperationId' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdGet', 'wheelOperationId', wheelOperationId)
            const localVarPath = `/api/v1/wheel-operations/{wheelOperationId}`
                .replace(`{${"wheelOperationId"}}`, encodeURIComponent(String(wheelOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleMileageDto} [updateVehicleMileageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdMileagePut: async (nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, updateVehicleMileageDto?: UpdateVehicleMileageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdMileagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'wheelOperationId' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdMileagePut', 'wheelOperationId', wheelOperationId)
            const localVarPath = `/api/v1/wheel-operations/{wheelOperationId}/mileage`
                .replace(`{${"wheelOperationId"}}`, encodeURIComponent(String(wheelOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVehicleMileageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdNotesPut: async (nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdNotesPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'wheelOperationId' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdNotesPut', 'wheelOperationId', wheelOperationId)
            const localVarPath = `/api/v1/wheel-operations/{wheelOperationId}/notes`
                .replace(`{${"wheelOperationId"}}`, encodeURIComponent(String(wheelOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalNotesInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateWheelOperationDto} [updateWheelOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdPut: async (nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, updateWheelOperationDto?: UpdateWheelOperationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdPut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'wheelOperationId' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdPut', 'wheelOperationId', wheelOperationId)
            const localVarPath = `/api/v1/wheel-operations/{wheelOperationId}`
                .replace(`{${"wheelOperationId"}}`, encodeURIComponent(String(wheelOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWheelOperationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStageUpdateDtoOfWheelOperationStage} [generalStageUpdateDtoOfWheelOperationStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdStagePut: async (nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, generalStageUpdateDtoOfWheelOperationStage?: GeneralStageUpdateDtoOfWheelOperationStage, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdStagePut', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'wheelOperationId' is not null or undefined
            assertParamExists('apiV1WheelOperationsWheelOperationIdStagePut', 'wheelOperationId', wheelOperationId)
            const localVarPath = `/api/v1/wheel-operations/{wheelOperationId}/stage`
                .replace(`{${"wheelOperationId"}}`, encodeURIComponent(String(wheelOperationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalStageUpdateDtoOfWheelOperationStage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WheelOperationsApi - functional programming interface
 * @export
 */
export const WheelOperationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WheelOperationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {EntityBulkDeleteDto} [entityBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WheelOperationsBulkDeleteDelete(nexusOpsTenant: string, nexusOpsAppVersion?: string, entityBulkDeleteDto?: EntityBulkDeleteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WheelOperationsBulkDeleteDelete(nexusOpsTenant, nexusOpsAppVersion, entityBulkDeleteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelOperationsApi.apiV1WheelOperationsBulkDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WheelOperationsCountersGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelOperationCountersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WheelOperationsCountersGet(nexusOpsTenant, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelOperationsApi.apiV1WheelOperationsCountersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WheelOperationGetPaginatedDto} [wheelOperationGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WheelOperationsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, wheelOperationGetPaginatedDto?: WheelOperationGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfWheelOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WheelOperationsGetPost(nexusOpsTenant, nexusOpsAppVersion, wheelOperationGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelOperationsApi.apiV1WheelOperationsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {CreateWheelOperationDto} [createWheelOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WheelOperationsPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, createWheelOperationDto?: CreateWheelOperationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WheelOperationsPost(nexusOpsTenant, nexusOpsAppVersion, createWheelOperationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelOperationsApi.apiV1WheelOperationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {AssignmentAddEntityDto} [assignmentAddEntityDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WheelOperationsWheelOperationIdAddAssignmentPost(nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, assignmentAddEntityDto?: AssignmentAddEntityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WheelOperationsWheelOperationIdAddAssignmentPost(nexusOpsTenant, wheelOperationId, nexusOpsAppVersion, assignmentAddEntityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelOperationsApi.apiV1WheelOperationsWheelOperationIdAddAssignmentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isDeleteCascade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WheelOperationsWheelOperationIdDelete(nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, isDeleteCascade?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WheelOperationsWheelOperationIdDelete(nexusOpsTenant, wheelOperationId, nexusOpsAppVersion, isDeleteCascade, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelOperationsApi.apiV1WheelOperationsWheelOperationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralExternalNumberInputDto} [generalExternalNumberInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WheelOperationsWheelOperationIdExternalNumberPut(nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, generalExternalNumberInputDto?: GeneralExternalNumberInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WheelOperationsWheelOperationIdExternalNumberPut(nexusOpsTenant, wheelOperationId, nexusOpsAppVersion, generalExternalNumberInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelOperationsApi.apiV1WheelOperationsWheelOperationIdExternalNumberPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WheelOperationsWheelOperationIdGet(nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WheelOperationsWheelOperationIdGet(nexusOpsTenant, wheelOperationId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelOperationsApi.apiV1WheelOperationsWheelOperationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateVehicleMileageDto} [updateVehicleMileageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WheelOperationsWheelOperationIdMileagePut(nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, updateVehicleMileageDto?: UpdateVehicleMileageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WheelOperationsWheelOperationIdMileagePut(nexusOpsTenant, wheelOperationId, nexusOpsAppVersion, updateVehicleMileageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelOperationsApi.apiV1WheelOperationsWheelOperationIdMileagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralNotesInputDto} [generalNotesInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WheelOperationsWheelOperationIdNotesPut(nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, generalNotesInputDto?: GeneralNotesInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WheelOperationsWheelOperationIdNotesPut(nexusOpsTenant, wheelOperationId, nexusOpsAppVersion, generalNotesInputDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelOperationsApi.apiV1WheelOperationsWheelOperationIdNotesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {UpdateWheelOperationDto} [updateWheelOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WheelOperationsWheelOperationIdPut(nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, updateWheelOperationDto?: UpdateWheelOperationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WheelOperationsWheelOperationIdPut(nexusOpsTenant, wheelOperationId, nexusOpsAppVersion, updateWheelOperationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelOperationsApi.apiV1WheelOperationsWheelOperationIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} wheelOperationId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {GeneralStageUpdateDtoOfWheelOperationStage} [generalStageUpdateDtoOfWheelOperationStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WheelOperationsWheelOperationIdStagePut(nexusOpsTenant: string, wheelOperationId: string, nexusOpsAppVersion?: string, generalStageUpdateDtoOfWheelOperationStage?: GeneralStageUpdateDtoOfWheelOperationStage, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WheelOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WheelOperationsWheelOperationIdStagePut(nexusOpsTenant, wheelOperationId, nexusOpsAppVersion, generalStageUpdateDtoOfWheelOperationStage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WheelOperationsApi.apiV1WheelOperationsWheelOperationIdStagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WheelOperationsApi - factory interface
 * @export
 */
export const WheelOperationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WheelOperationsApiFp(configuration)
    return {
        /**
         * 
         * @param {WheelOperationsApiApiV1WheelOperationsBulkDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsBulkDeleteDelete(requestParameters: WheelOperationsApiApiV1WheelOperationsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1WheelOperationsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WheelOperationsApiApiV1WheelOperationsCountersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsCountersGet(requestParameters: WheelOperationsApiApiV1WheelOperationsCountersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WheelOperationCountersDto> {
            return localVarFp.apiV1WheelOperationsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WheelOperationsApiApiV1WheelOperationsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsGetPost(requestParameters: WheelOperationsApiApiV1WheelOperationsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfWheelOperationDto> {
            return localVarFp.apiV1WheelOperationsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.wheelOperationGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WheelOperationsApiApiV1WheelOperationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsPost(requestParameters: WheelOperationsApiApiV1WheelOperationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WheelOperationDto> {
            return localVarFp.apiV1WheelOperationsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createWheelOperationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdAddAssignmentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdAddAssignmentPost(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdAddAssignmentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WheelOperationDto> {
            return localVarFp.apiV1WheelOperationsWheelOperationIdAddAssignmentPost(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdDelete(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1WheelOperationsWheelOperationIdDelete(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdExternalNumberPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdExternalNumberPut(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdExternalNumberPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WheelOperationDto> {
            return localVarFp.apiV1WheelOperationsWheelOperationIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdGet(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WheelOperationDto> {
            return localVarFp.apiV1WheelOperationsWheelOperationIdGet(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdMileagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdMileagePut(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdMileagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WheelOperationDto> {
            return localVarFp.apiV1WheelOperationsWheelOperationIdMileagePut(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleMileageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdNotesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdNotesPut(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdNotesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WheelOperationDto> {
            return localVarFp.apiV1WheelOperationsWheelOperationIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdPut(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WheelOperationDto> {
            return localVarFp.apiV1WheelOperationsWheelOperationIdPut(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, requestParameters.updateWheelOperationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdStagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WheelOperationsWheelOperationIdStagePut(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdStagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<WheelOperationDto> {
            return localVarFp.apiV1WheelOperationsWheelOperationIdStagePut(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, requestParameters.generalStageUpdateDtoOfWheelOperationStage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1WheelOperationsBulkDeleteDelete operation in WheelOperationsApi.
 * @export
 * @interface WheelOperationsApiApiV1WheelOperationsBulkDeleteDeleteRequest
 */
export interface WheelOperationsApiApiV1WheelOperationsBulkDeleteDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsBulkDeleteDelete
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsBulkDeleteDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {EntityBulkDeleteDto}
     * @memberof WheelOperationsApiApiV1WheelOperationsBulkDeleteDelete
     */
    readonly entityBulkDeleteDto?: EntityBulkDeleteDto
}

/**
 * Request parameters for apiV1WheelOperationsCountersGet operation in WheelOperationsApi.
 * @export
 * @interface WheelOperationsApiApiV1WheelOperationsCountersGetRequest
 */
export interface WheelOperationsApiApiV1WheelOperationsCountersGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsCountersGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsCountersGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1WheelOperationsGetPost operation in WheelOperationsApi.
 * @export
 * @interface WheelOperationsApiApiV1WheelOperationsGetPostRequest
 */
export interface WheelOperationsApiApiV1WheelOperationsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {WheelOperationGetPaginatedDto}
     * @memberof WheelOperationsApiApiV1WheelOperationsGetPost
     */
    readonly wheelOperationGetPaginatedDto?: WheelOperationGetPaginatedDto
}

/**
 * Request parameters for apiV1WheelOperationsPost operation in WheelOperationsApi.
 * @export
 * @interface WheelOperationsApiApiV1WheelOperationsPostRequest
 */
export interface WheelOperationsApiApiV1WheelOperationsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {CreateWheelOperationDto}
     * @memberof WheelOperationsApiApiV1WheelOperationsPost
     */
    readonly createWheelOperationDto?: CreateWheelOperationDto
}

/**
 * Request parameters for apiV1WheelOperationsWheelOperationIdAddAssignmentPost operation in WheelOperationsApi.
 * @export
 * @interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdAddAssignmentPostRequest
 */
export interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdAddAssignmentPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdAddAssignmentPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdAddAssignmentPost
     */
    readonly wheelOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdAddAssignmentPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {AssignmentAddEntityDto}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdAddAssignmentPost
     */
    readonly assignmentAddEntityDto?: AssignmentAddEntityDto
}

/**
 * Request parameters for apiV1WheelOperationsWheelOperationIdDelete operation in WheelOperationsApi.
 * @export
 * @interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdDeleteRequest
 */
export interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdDelete
     */
    readonly wheelOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdDelete
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdDelete
     */
    readonly isDeleteCascade?: boolean
}

/**
 * Request parameters for apiV1WheelOperationsWheelOperationIdExternalNumberPut operation in WheelOperationsApi.
 * @export
 * @interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdExternalNumberPutRequest
 */
export interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdExternalNumberPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdExternalNumberPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdExternalNumberPut
     */
    readonly wheelOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdExternalNumberPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralExternalNumberInputDto}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdExternalNumberPut
     */
    readonly generalExternalNumberInputDto?: GeneralExternalNumberInputDto
}

/**
 * Request parameters for apiV1WheelOperationsWheelOperationIdGet operation in WheelOperationsApi.
 * @export
 * @interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdGetRequest
 */
export interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdGet
     */
    readonly wheelOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV1WheelOperationsWheelOperationIdMileagePut operation in WheelOperationsApi.
 * @export
 * @interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdMileagePutRequest
 */
export interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdMileagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdMileagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdMileagePut
     */
    readonly wheelOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdMileagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateVehicleMileageDto}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdMileagePut
     */
    readonly updateVehicleMileageDto?: UpdateVehicleMileageDto
}

/**
 * Request parameters for apiV1WheelOperationsWheelOperationIdNotesPut operation in WheelOperationsApi.
 * @export
 * @interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdNotesPutRequest
 */
export interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdNotesPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdNotesPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdNotesPut
     */
    readonly wheelOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdNotesPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralNotesInputDto}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdNotesPut
     */
    readonly generalNotesInputDto?: GeneralNotesInputDto
}

/**
 * Request parameters for apiV1WheelOperationsWheelOperationIdPut operation in WheelOperationsApi.
 * @export
 * @interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdPutRequest
 */
export interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdPutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdPut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdPut
     */
    readonly wheelOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdPut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {UpdateWheelOperationDto}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdPut
     */
    readonly updateWheelOperationDto?: UpdateWheelOperationDto
}

/**
 * Request parameters for apiV1WheelOperationsWheelOperationIdStagePut operation in WheelOperationsApi.
 * @export
 * @interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdStagePutRequest
 */
export interface WheelOperationsApiApiV1WheelOperationsWheelOperationIdStagePutRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdStagePut
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdStagePut
     */
    readonly wheelOperationId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdStagePut
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {GeneralStageUpdateDtoOfWheelOperationStage}
     * @memberof WheelOperationsApiApiV1WheelOperationsWheelOperationIdStagePut
     */
    readonly generalStageUpdateDtoOfWheelOperationStage?: GeneralStageUpdateDtoOfWheelOperationStage
}

/**
 * WheelOperationsApi - object-oriented interface
 * @export
 * @class WheelOperationsApi
 * @extends {BaseAPI}
 */
export class WheelOperationsApi extends BaseAPI {
    /**
     * 
     * @param {WheelOperationsApiApiV1WheelOperationsBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelOperationsApi
     */
    public apiV1WheelOperationsBulkDeleteDelete(requestParameters: WheelOperationsApiApiV1WheelOperationsBulkDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return WheelOperationsApiFp(this.configuration).apiV1WheelOperationsBulkDeleteDelete(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.entityBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WheelOperationsApiApiV1WheelOperationsCountersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelOperationsApi
     */
    public apiV1WheelOperationsCountersGet(requestParameters: WheelOperationsApiApiV1WheelOperationsCountersGetRequest, options?: RawAxiosRequestConfig) {
        return WheelOperationsApiFp(this.configuration).apiV1WheelOperationsCountersGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WheelOperationsApiApiV1WheelOperationsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelOperationsApi
     */
    public apiV1WheelOperationsGetPost(requestParameters: WheelOperationsApiApiV1WheelOperationsGetPostRequest, options?: RawAxiosRequestConfig) {
        return WheelOperationsApiFp(this.configuration).apiV1WheelOperationsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.wheelOperationGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WheelOperationsApiApiV1WheelOperationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelOperationsApi
     */
    public apiV1WheelOperationsPost(requestParameters: WheelOperationsApiApiV1WheelOperationsPostRequest, options?: RawAxiosRequestConfig) {
        return WheelOperationsApiFp(this.configuration).apiV1WheelOperationsPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.createWheelOperationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdAddAssignmentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelOperationsApi
     */
    public apiV1WheelOperationsWheelOperationIdAddAssignmentPost(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdAddAssignmentPostRequest, options?: RawAxiosRequestConfig) {
        return WheelOperationsApiFp(this.configuration).apiV1WheelOperationsWheelOperationIdAddAssignmentPost(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, requestParameters.assignmentAddEntityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelOperationsApi
     */
    public apiV1WheelOperationsWheelOperationIdDelete(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return WheelOperationsApiFp(this.configuration).apiV1WheelOperationsWheelOperationIdDelete(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, requestParameters.isDeleteCascade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdExternalNumberPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelOperationsApi
     */
    public apiV1WheelOperationsWheelOperationIdExternalNumberPut(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdExternalNumberPutRequest, options?: RawAxiosRequestConfig) {
        return WheelOperationsApiFp(this.configuration).apiV1WheelOperationsWheelOperationIdExternalNumberPut(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, requestParameters.generalExternalNumberInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelOperationsApi
     */
    public apiV1WheelOperationsWheelOperationIdGet(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdGetRequest, options?: RawAxiosRequestConfig) {
        return WheelOperationsApiFp(this.configuration).apiV1WheelOperationsWheelOperationIdGet(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdMileagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelOperationsApi
     */
    public apiV1WheelOperationsWheelOperationIdMileagePut(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdMileagePutRequest, options?: RawAxiosRequestConfig) {
        return WheelOperationsApiFp(this.configuration).apiV1WheelOperationsWheelOperationIdMileagePut(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, requestParameters.updateVehicleMileageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdNotesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelOperationsApi
     */
    public apiV1WheelOperationsWheelOperationIdNotesPut(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdNotesPutRequest, options?: RawAxiosRequestConfig) {
        return WheelOperationsApiFp(this.configuration).apiV1WheelOperationsWheelOperationIdNotesPut(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, requestParameters.generalNotesInputDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelOperationsApi
     */
    public apiV1WheelOperationsWheelOperationIdPut(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdPutRequest, options?: RawAxiosRequestConfig) {
        return WheelOperationsApiFp(this.configuration).apiV1WheelOperationsWheelOperationIdPut(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, requestParameters.updateWheelOperationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WheelOperationsApiApiV1WheelOperationsWheelOperationIdStagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WheelOperationsApi
     */
    public apiV1WheelOperationsWheelOperationIdStagePut(requestParameters: WheelOperationsApiApiV1WheelOperationsWheelOperationIdStagePutRequest, options?: RawAxiosRequestConfig) {
        return WheelOperationsApiFp(this.configuration).apiV1WheelOperationsWheelOperationIdStagePut(requestParameters.nexusOpsTenant, requestParameters.wheelOperationId, requestParameters.nexusOpsAppVersion, requestParameters.generalStageUpdateDtoOfWheelOperationStage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WidgetDataApi - axios parameter creator
 * @export
 */
export const WidgetDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WidgetDataGetBaseDto} [widgetDataGetBaseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WidgetDataActiveOperationSummaryGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, widgetDataGetBaseDto?: WidgetDataGetBaseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WidgetDataActiveOperationSummaryGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/widget-data/active-operation-summary/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetDataGetBaseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WidgetDataOfCostPerMonthSummaryGetDto} [widgetDataOfCostPerMonthSummaryGetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WidgetDataCostPerMonthSummaryGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, widgetDataOfCostPerMonthSummaryGetDto?: WidgetDataOfCostPerMonthSummaryGetDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WidgetDataCostPerMonthSummaryGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/widget-data/cost-per-month-summary/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetDataOfCostPerMonthSummaryGetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WidgetDataGetBaseDto} [widgetDataGetBaseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WidgetDataDamageAndIssueSummaryGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, widgetDataGetBaseDto?: WidgetDataGetBaseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WidgetDataDamageAndIssueSummaryGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/widget-data/damage-and-issue-summary/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetDataGetBaseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WidgetDataGetBaseDto} [widgetDataGetBaseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WidgetDataVehicleInFlowSummaryGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, widgetDataGetBaseDto?: WidgetDataGetBaseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WidgetDataVehicleInFlowSummaryGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/widget-data/vehicle-in-flow-summary/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetDataGetBaseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WidgetDataGetBaseDto} [widgetDataGetBaseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WidgetDataVehicleStatusSummaryGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, widgetDataGetBaseDto?: WidgetDataGetBaseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV1WidgetDataVehicleStatusSummaryGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v1/widget-data/vehicle-status-summary/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetDataGetBaseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WidgetDataApi - functional programming interface
 * @export
 */
export const WidgetDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WidgetDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WidgetDataGetBaseDto} [widgetDataGetBaseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WidgetDataActiveOperationSummaryGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, widgetDataGetBaseDto?: WidgetDataGetBaseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetDataOfActiveOperationSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WidgetDataActiveOperationSummaryGetPost(nexusOpsTenant, nexusOpsAppVersion, widgetDataGetBaseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetDataApi.apiV1WidgetDataActiveOperationSummaryGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WidgetDataOfCostPerMonthSummaryGetDto} [widgetDataOfCostPerMonthSummaryGetDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WidgetDataCostPerMonthSummaryGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, widgetDataOfCostPerMonthSummaryGetDto?: WidgetDataOfCostPerMonthSummaryGetDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetDataOfCostPerMonthSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WidgetDataCostPerMonthSummaryGetPost(nexusOpsTenant, nexusOpsAppVersion, widgetDataOfCostPerMonthSummaryGetDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetDataApi.apiV1WidgetDataCostPerMonthSummaryGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WidgetDataGetBaseDto} [widgetDataGetBaseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WidgetDataDamageAndIssueSummaryGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, widgetDataGetBaseDto?: WidgetDataGetBaseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetDataOfDamageAndIssueSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WidgetDataDamageAndIssueSummaryGetPost(nexusOpsTenant, nexusOpsAppVersion, widgetDataGetBaseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetDataApi.apiV1WidgetDataDamageAndIssueSummaryGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WidgetDataGetBaseDto} [widgetDataGetBaseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WidgetDataVehicleInFlowSummaryGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, widgetDataGetBaseDto?: WidgetDataGetBaseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetDataOfVehicleInFlowSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WidgetDataVehicleInFlowSummaryGetPost(nexusOpsTenant, nexusOpsAppVersion, widgetDataGetBaseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetDataApi.apiV1WidgetDataVehicleInFlowSummaryGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WidgetDataGetBaseDto} [widgetDataGetBaseDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WidgetDataVehicleStatusSummaryGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, widgetDataGetBaseDto?: WidgetDataGetBaseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetDataOfVehicleStatusSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WidgetDataVehicleStatusSummaryGetPost(nexusOpsTenant, nexusOpsAppVersion, widgetDataGetBaseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetDataApi.apiV1WidgetDataVehicleStatusSummaryGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WidgetDataApi - factory interface
 * @export
 */
export const WidgetDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WidgetDataApiFp(configuration)
    return {
        /**
         * 
         * @param {WidgetDataApiApiV1WidgetDataActiveOperationSummaryGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WidgetDataActiveOperationSummaryGetPost(requestParameters: WidgetDataApiApiV1WidgetDataActiveOperationSummaryGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WidgetDataOfActiveOperationSummaryDto> {
            return localVarFp.apiV1WidgetDataActiveOperationSummaryGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.widgetDataGetBaseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WidgetDataApiApiV1WidgetDataCostPerMonthSummaryGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WidgetDataCostPerMonthSummaryGetPost(requestParameters: WidgetDataApiApiV1WidgetDataCostPerMonthSummaryGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WidgetDataOfCostPerMonthSummaryDto> {
            return localVarFp.apiV1WidgetDataCostPerMonthSummaryGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.widgetDataOfCostPerMonthSummaryGetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WidgetDataApiApiV1WidgetDataDamageAndIssueSummaryGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WidgetDataDamageAndIssueSummaryGetPost(requestParameters: WidgetDataApiApiV1WidgetDataDamageAndIssueSummaryGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WidgetDataOfDamageAndIssueSummaryDto> {
            return localVarFp.apiV1WidgetDataDamageAndIssueSummaryGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.widgetDataGetBaseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WidgetDataApiApiV1WidgetDataVehicleInFlowSummaryGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WidgetDataVehicleInFlowSummaryGetPost(requestParameters: WidgetDataApiApiV1WidgetDataVehicleInFlowSummaryGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WidgetDataOfVehicleInFlowSummaryDto> {
            return localVarFp.apiV1WidgetDataVehicleInFlowSummaryGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.widgetDataGetBaseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WidgetDataApiApiV1WidgetDataVehicleStatusSummaryGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WidgetDataVehicleStatusSummaryGetPost(requestParameters: WidgetDataApiApiV1WidgetDataVehicleStatusSummaryGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WidgetDataOfVehicleStatusSummaryDto> {
            return localVarFp.apiV1WidgetDataVehicleStatusSummaryGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.widgetDataGetBaseDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1WidgetDataActiveOperationSummaryGetPost operation in WidgetDataApi.
 * @export
 * @interface WidgetDataApiApiV1WidgetDataActiveOperationSummaryGetPostRequest
 */
export interface WidgetDataApiApiV1WidgetDataActiveOperationSummaryGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WidgetDataApiApiV1WidgetDataActiveOperationSummaryGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WidgetDataApiApiV1WidgetDataActiveOperationSummaryGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {WidgetDataGetBaseDto}
     * @memberof WidgetDataApiApiV1WidgetDataActiveOperationSummaryGetPost
     */
    readonly widgetDataGetBaseDto?: WidgetDataGetBaseDto
}

/**
 * Request parameters for apiV1WidgetDataCostPerMonthSummaryGetPost operation in WidgetDataApi.
 * @export
 * @interface WidgetDataApiApiV1WidgetDataCostPerMonthSummaryGetPostRequest
 */
export interface WidgetDataApiApiV1WidgetDataCostPerMonthSummaryGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WidgetDataApiApiV1WidgetDataCostPerMonthSummaryGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WidgetDataApiApiV1WidgetDataCostPerMonthSummaryGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {WidgetDataOfCostPerMonthSummaryGetDto}
     * @memberof WidgetDataApiApiV1WidgetDataCostPerMonthSummaryGetPost
     */
    readonly widgetDataOfCostPerMonthSummaryGetDto?: WidgetDataOfCostPerMonthSummaryGetDto
}

/**
 * Request parameters for apiV1WidgetDataDamageAndIssueSummaryGetPost operation in WidgetDataApi.
 * @export
 * @interface WidgetDataApiApiV1WidgetDataDamageAndIssueSummaryGetPostRequest
 */
export interface WidgetDataApiApiV1WidgetDataDamageAndIssueSummaryGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WidgetDataApiApiV1WidgetDataDamageAndIssueSummaryGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WidgetDataApiApiV1WidgetDataDamageAndIssueSummaryGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {WidgetDataGetBaseDto}
     * @memberof WidgetDataApiApiV1WidgetDataDamageAndIssueSummaryGetPost
     */
    readonly widgetDataGetBaseDto?: WidgetDataGetBaseDto
}

/**
 * Request parameters for apiV1WidgetDataVehicleInFlowSummaryGetPost operation in WidgetDataApi.
 * @export
 * @interface WidgetDataApiApiV1WidgetDataVehicleInFlowSummaryGetPostRequest
 */
export interface WidgetDataApiApiV1WidgetDataVehicleInFlowSummaryGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WidgetDataApiApiV1WidgetDataVehicleInFlowSummaryGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WidgetDataApiApiV1WidgetDataVehicleInFlowSummaryGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {WidgetDataGetBaseDto}
     * @memberof WidgetDataApiApiV1WidgetDataVehicleInFlowSummaryGetPost
     */
    readonly widgetDataGetBaseDto?: WidgetDataGetBaseDto
}

/**
 * Request parameters for apiV1WidgetDataVehicleStatusSummaryGetPost operation in WidgetDataApi.
 * @export
 * @interface WidgetDataApiApiV1WidgetDataVehicleStatusSummaryGetPostRequest
 */
export interface WidgetDataApiApiV1WidgetDataVehicleStatusSummaryGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof WidgetDataApiApiV1WidgetDataVehicleStatusSummaryGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WidgetDataApiApiV1WidgetDataVehicleStatusSummaryGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {WidgetDataGetBaseDto}
     * @memberof WidgetDataApiApiV1WidgetDataVehicleStatusSummaryGetPost
     */
    readonly widgetDataGetBaseDto?: WidgetDataGetBaseDto
}

/**
 * WidgetDataApi - object-oriented interface
 * @export
 * @class WidgetDataApi
 * @extends {BaseAPI}
 */
export class WidgetDataApi extends BaseAPI {
    /**
     * 
     * @param {WidgetDataApiApiV1WidgetDataActiveOperationSummaryGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetDataApi
     */
    public apiV1WidgetDataActiveOperationSummaryGetPost(requestParameters: WidgetDataApiApiV1WidgetDataActiveOperationSummaryGetPostRequest, options?: RawAxiosRequestConfig) {
        return WidgetDataApiFp(this.configuration).apiV1WidgetDataActiveOperationSummaryGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.widgetDataGetBaseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WidgetDataApiApiV1WidgetDataCostPerMonthSummaryGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetDataApi
     */
    public apiV1WidgetDataCostPerMonthSummaryGetPost(requestParameters: WidgetDataApiApiV1WidgetDataCostPerMonthSummaryGetPostRequest, options?: RawAxiosRequestConfig) {
        return WidgetDataApiFp(this.configuration).apiV1WidgetDataCostPerMonthSummaryGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.widgetDataOfCostPerMonthSummaryGetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WidgetDataApiApiV1WidgetDataDamageAndIssueSummaryGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetDataApi
     */
    public apiV1WidgetDataDamageAndIssueSummaryGetPost(requestParameters: WidgetDataApiApiV1WidgetDataDamageAndIssueSummaryGetPostRequest, options?: RawAxiosRequestConfig) {
        return WidgetDataApiFp(this.configuration).apiV1WidgetDataDamageAndIssueSummaryGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.widgetDataGetBaseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WidgetDataApiApiV1WidgetDataVehicleInFlowSummaryGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetDataApi
     */
    public apiV1WidgetDataVehicleInFlowSummaryGetPost(requestParameters: WidgetDataApiApiV1WidgetDataVehicleInFlowSummaryGetPostRequest, options?: RawAxiosRequestConfig) {
        return WidgetDataApiFp(this.configuration).apiV1WidgetDataVehicleInFlowSummaryGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.widgetDataGetBaseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WidgetDataApiApiV1WidgetDataVehicleStatusSummaryGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetDataApi
     */
    public apiV1WidgetDataVehicleStatusSummaryGetPost(requestParameters: WidgetDataApiApiV1WidgetDataVehicleStatusSummaryGetPostRequest, options?: RawAxiosRequestConfig) {
        return WidgetDataApiFp(this.configuration).apiV1WidgetDataVehicleStatusSummaryGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.widgetDataGetBaseDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WidgetDataAdminApi - axios parameter creator
 * @export
 */
export const WidgetDataAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WidgetDataOfTenantStatsGetAdminDto} [widgetDataOfTenantStatsGetAdminDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminWidgetDataTenantStatsGetPost: async (nexusOpsAppVersion?: string, widgetDataOfTenantStatsGetAdminDto?: WidgetDataOfTenantStatsGetAdminDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/widget-data/tenant-stats/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetDataOfTenantStatsGetAdminDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WidgetDataOfTenantStatsTabularGetAdminDto} [widgetDataOfTenantStatsTabularGetAdminDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminWidgetDataTenantStatsTabularGetPost: async (nexusOpsAppVersion?: string, widgetDataOfTenantStatsTabularGetAdminDto?: WidgetDataOfTenantStatsTabularGetAdminDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/widget-data/tenant-stats-tabular/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetDataOfTenantStatsTabularGetAdminDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WidgetDataAdminApi - functional programming interface
 * @export
 */
export const WidgetDataAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WidgetDataAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WidgetDataOfTenantStatsGetAdminDto} [widgetDataOfTenantStatsGetAdminDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminWidgetDataTenantStatsGetPost(nexusOpsAppVersion?: string, widgetDataOfTenantStatsGetAdminDto?: WidgetDataOfTenantStatsGetAdminDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetDataOfTenantStatsAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminWidgetDataTenantStatsGetPost(nexusOpsAppVersion, widgetDataOfTenantStatsGetAdminDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetDataAdminApi.apiV1AdminWidgetDataTenantStatsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {WidgetDataOfTenantStatsTabularGetAdminDto} [widgetDataOfTenantStatsTabularGetAdminDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminWidgetDataTenantStatsTabularGetPost(nexusOpsAppVersion?: string, widgetDataOfTenantStatsTabularGetAdminDto?: WidgetDataOfTenantStatsTabularGetAdminDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetDataOfTenantStatsTabularAdminDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminWidgetDataTenantStatsTabularGetPost(nexusOpsAppVersion, widgetDataOfTenantStatsTabularGetAdminDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WidgetDataAdminApi.apiV1AdminWidgetDataTenantStatsTabularGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WidgetDataAdminApi - factory interface
 * @export
 */
export const WidgetDataAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WidgetDataAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminWidgetDataTenantStatsGetPost(requestParameters: WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<WidgetDataOfTenantStatsAdminDto> {
            return localVarFp.apiV1AdminWidgetDataTenantStatsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.widgetDataOfTenantStatsGetAdminDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsTabularGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminWidgetDataTenantStatsTabularGetPost(requestParameters: WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsTabularGetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<WidgetDataOfTenantStatsTabularAdminDto> {
            return localVarFp.apiV1AdminWidgetDataTenantStatsTabularGetPost(requestParameters.nexusOpsAppVersion, requestParameters.widgetDataOfTenantStatsTabularGetAdminDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV1AdminWidgetDataTenantStatsGetPost operation in WidgetDataAdminApi.
 * @export
 * @interface WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsGetPostRequest
 */
export interface WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {WidgetDataOfTenantStatsGetAdminDto}
     * @memberof WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsGetPost
     */
    readonly widgetDataOfTenantStatsGetAdminDto?: WidgetDataOfTenantStatsGetAdminDto
}

/**
 * Request parameters for apiV1AdminWidgetDataTenantStatsTabularGetPost operation in WidgetDataAdminApi.
 * @export
 * @interface WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsTabularGetPostRequest
 */
export interface WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsTabularGetPostRequest {
    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsTabularGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {WidgetDataOfTenantStatsTabularGetAdminDto}
     * @memberof WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsTabularGetPost
     */
    readonly widgetDataOfTenantStatsTabularGetAdminDto?: WidgetDataOfTenantStatsTabularGetAdminDto
}

/**
 * WidgetDataAdminApi - object-oriented interface
 * @export
 * @class WidgetDataAdminApi
 * @extends {BaseAPI}
 */
export class WidgetDataAdminApi extends BaseAPI {
    /**
     * 
     * @param {WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetDataAdminApi
     */
    public apiV1AdminWidgetDataTenantStatsGetPost(requestParameters: WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return WidgetDataAdminApiFp(this.configuration).apiV1AdminWidgetDataTenantStatsGetPost(requestParameters.nexusOpsAppVersion, requestParameters.widgetDataOfTenantStatsGetAdminDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsTabularGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetDataAdminApi
     */
    public apiV1AdminWidgetDataTenantStatsTabularGetPost(requestParameters: WidgetDataAdminApiApiV1AdminWidgetDataTenantStatsTabularGetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return WidgetDataAdminApiFp(this.configuration).apiV1AdminWidgetDataTenantStatsTabularGetPost(requestParameters.nexusOpsAppVersion, requestParameters.widgetDataOfTenantStatsTabularGetAdminDto, options).then((request) => request(this.axios, this.basePath));
    }
}



